import React, { useState, useMemo, useEffect, useCallback, useRef, useContext, createContext } from "react";
const WrapCtx = createContext(false);
// Roles that must never see contract value — they get the QS budget instead.
const BUDGET_ONLY=["Design","Operations","ProjectMover"];
import {deductionFromSb,supabase,isSupabaseReady,sbList,sbInsert,sbUpdate,sbUpsert,sbUpsertDetailed,sbInsertIfMissing,sbDelete,sbDeleteWhere,sbLoadAll,sbSubscribe,sbClear,sbUploadFile,sbDeleteFile,sbGetPublicUrl,sbListFiles,setSbErrorHandler,setSbDropHandler,sbFlushQueue,sbQueueSize,sbPendingIds,sbOnQueueChange,appLogin,appLogout,restoreAppToken,hasAppToken,appTokenExpired,setSessionExpiredHandler,logClientError} from './supabaseClient';
import{idbGetMany,idbSetMany}from'./idb.js';
import {useSharePdf} from "./views/SharePdf";
import {fmt,addPrintClose,today,uid,KEYS,BANKS,emptyBankRow,emptyDayPosition,dropPhantomCashDays,Inp,Sel,Fld,Card,Modal,KPI,toastEmit,toastUpdate,Toaster,uiConfirm,uiPrompt,uiAlert,DialogHost,Skeleton,PageSkeleton,useIsMobile,LifecycleStrip,clickable,HIDDEN_NAV_IDS,AP_HIDDEN,WAREHOUSE_HIDDEN,isHiddenView,HIDDEN_FIN_TABS,HIDDEN_PIPE_TABS,pageOn} from './shared';
import {T} from './theme';
import {DEFAULT_DEPT_TASKS,GMD_CHECKLIST_TEMPLATE,GMD_CLIENTS,mkDesign,SEED_DEALS,SEED_PROJECTS,SEED_EXP,SEED_INF,SEED_SWATCHES,SEED_CHECKLIST,SEED_INVENTORY,SEED_DRF} from './data/seed';
import {drfToSb,drfFromSb,invToSb,invFromSb,moveToSb,moveFromSb,supToSb,payableToSb,loanToSb,subconToSb,cvToSb,swoToSb,swoFromSb,payableFromSb,payablePaymentToSb,payablePaymentFromSb,ceReqFromSb,commissionPayoutToSb,commissionPayoutFromSb,toolToSb,toolFromSb,drToSb,drFromSb} from './data/mappers';
import {DEAL_STAGES, STAGE_ALIASES, normalizeStage, clientKey, clientMatchKey, titleSimilar, WON_STAGES, ACTIVE_STAGES, LOST_STAGES, isLostStage, isActivePipeline, canSetDealStage, PM_SETTABLE_STAGES, DEAL_TEMPS, TEMP_META, HOT_AGE_DAYS, COLD_STALE_DAYS, deriveTemp, PAULO_GATE, CE_TYPES, STAGE_OWNER, STAGE_DURATION, PROD_STAGES, DESIGN_STATUSES, DESIGN_ACTIVE_STATUSES, DESIGN_CLOSED_STATUSES, isDesignClosed, DESIGN_DELIVERABLES, ARTWORK_DELIVERABLES, designNeedsArtwork, openBlockers, designPromisedDate, isProductionBriefed, designUrgency, PRODUCT_TYPES, SALES_TEAM, COST_CONTROL_TEAM, OPS_TEAM, DESIGN_MEMBERS, HEAD_DESIGNER, isHeadDesigner, ALL_MEMBERS, PROD_MEMBERS, MAT_UNITS, PO_UNITS, PO_TERMS, PO_TERMS_DEFAULT, EXP_CATS, SWATCH_CATS, SWATCH_STATUS, PAY_STATUS, LEAD_ORIGINS, DEFAULT_LEAD_ORIGIN, COMMISSION_RATE, leadOriginOf, leadOriginPending, effectiveLeadOrigin, collectedBase, milestoneBalance, milestoneBalanceParts, isBillingOverdue, isBillingUnsentLate, milestoneReceivable, arSummary, costNet, costSummary, poTotals, commissionRate, commissionEarned, ownsDealCommission, salesOwnerLocked, commissionProjected, PAYOUT_STATUS, isPayoutApproved, isPayoutPending, payoutsPaid, payoutsPending, commissionPayable, MONTHS, PRIORITIES, STAGE_CLR, PROD_CLR, PAY_CLR, PRI_CLR, DS_CLR, SW_CLR, DRF_TYPES, DRF_CATEGORIES, DRF_STATUSES, DRF_CLR, emptyDRF, ROLE_CLR, roleLabel, CL_TYPES, CL_STATUS, CL_DEPT, TYPE_ICON, TYPE_CLR, CS_CLR, fmtK, fmtPHP, BUSINESS_DAYS_SLA, bizDaysElapsed, bizDaysRemaining, calcTax, dealFinancials, calcInputTax, EWT_RATES, todayL, mergeLocalOnly, mergeLocalOnlyObj, addDaysISO, dueDateFromTerms, ADDENDUM_STATUSES, ADDENDUM_STATUS_CLR, CO_KINDS, coSignedValue, findCrossMechanismCO, findAddendumDoubleBilling, MILESTONE_TYPES, defaultBillDate, buildMilestoneSchedule, termsFromSchedule, scheduleSummary, billingIntegrityIssues, isMotherPO, dealDpClear, findDuplicatePayments, NET_DAY_OPTIONS, RETENTION_RELEASE_OPTIONS, coMilestoneMatches, isApprovedAddendumDeal, CO_MILESTONE_PREFIX, TAT_REFERENCE, DEPT_ORDER, HAS_ADDENDA_PAGE, DEPT_CLR, ACT_SCORE, emptyProjectCard, nextItemCode, BILLING_STATUSES, BILLING_STATUS_CLR, emptyMilestone, MR_STATUSES, BR_STATUSES, BR_PURPOSES, PR_STATUSES, PROC_STATUSES, PR_CATS, BUDGET_CATS, BUDGET_CAT_CLR, projectCostBreakdown, emptyPR, canApprovePO, isProcurementRole, canonRole, woRetentionAmt, AP_RULES, isSubconPayable, subconNeedsWo, subconNoWoBlock, payableRetentionPct, payableClaimed, recomputePayableFromPayments, SWO_STATUSES, SWO_STATUS_CLR, emptySWO, emptyDelivery, projDisplayName, projOptions, emptyBudget, ACCT_CLR, emptyDeal, emptyProject, dealCompleteness, calcStreak, PM_UPDATE_TYPES, PM_TYPE_COLOR, PM_TYPE_ICON, WEATHER_OPTS, PAYMENT_METHODS, OFFSET_METHOD, isOffsetPayment, isCashPayment, paymentClearDate, isPaymentCleared, VAT_TREATMENTS, REPORT_KINDS, REPORT_STATUSES, REPORT_STATUS_CLR, emptyProjectReport, latestReport, progressReportOnFile, installationReportOnFile, dealOnboardingGate, dealJo, dropStaleJos, moveNeedsWitness, SCRAP_MOVE_TYPE, AUDIT_AREAS, AUDIT_SEVERITY, AUDIT_SEVERITY_CLR, AUDIT_STATUSES, AUDIT_STATUS_CLR, AUDIT_REPLY_DAYS, emptyFinding, findingOverdue, RECURRING_AUDITS, PERMISSIONS, PERM_ROLES, PERM_NOTES, PERM_ACTIONS, roleCan, rolesAllowedLabel} from './core';

// Returns a component whose function IDENTITY is stable across renders while its
// implementation closure stays fresh (always the latest `impl` passed in). React
// keys reconciliation off a component's type identity: a component defined inline
// in a render body is a brand-new function every render, so React tears down and
// remounts its entire subtree on every parent re-render — replaying mount
// animations (the "blinking screen") and wiping descendants' local state (e.g. a
// half-typed modal form). App re-renders constantly here from Supabase realtime
// pushes, so every inline shell component (Wrap, Nav, headers) hit this. Wrapping
// them in a stable identity lets React reconcile in place instead. (An explicit
// useCallback dep list was tried and rejected — it silently went stale; see #112.)
const useStableComponent=(impl)=>{
  const ref=useRef(impl); ref.current=impl;
  return useRef((props)=>ref.current(props)).current;
};

// ─── CODE-SPLIT VIEWS ────────────────────────────────────────────────────────
// Each of these pages ships as its own chunk, downloaded the first time the
// page is opened instead of being part of the initial bundle. _lazyView bakes
// the Suspense boundary into the binding itself, so every existing render
// site keeps working unchanged.
const PageLoading=()=><div style={{padding:"24px 20px",maxWidth:1100,margin:"0 auto"}}><PageSkeleton/></div>;
// After a deploy, a tab still running the old bundle asks for chunk hashes that
// no longer exist ("Loading chunk 608 failed" in client_errors). Reload once to
// pick up the new build; the sessionStorage stamp stops a reload loop if the
// chunk is genuinely unreachable (offline), letting the error surface instead.
const _loadChunk=(load)=>()=>load().catch(err=>{
  const isChunk=err?.name==="ChunkLoadError"||/Loading (CSS )?chunk .* failed/i.test(err?.message||"");
  let last=0;try{last=Number(sessionStorage.getItem("fabhub:chunkReload"))||0;}catch{}
  if(isChunk&&Date.now()-last>60000){try{sessionStorage.setItem("fabhub:chunkReload",String(Date.now()));}catch{}window.location.reload();return new Promise(()=>{});}
  throw err;
});
const _lazyView=(load)=>{const L=React.lazy(_loadChunk(load));return function LazyView(props){return <React.Suspense fallback={<PageLoading/>}><L {...props}/></React.Suspense>;};};
const ConstructionCalendar=_lazyView(()=>import('./views/ConstructionCalendar'));
const PermissionsMatrix=_lazyView(()=>import('./views/PermissionsMatrix'));
const BOQBuilder=_lazyView(()=>import('./views/BOQBuilder'));
const LiquidationView=_lazyView(()=>import('./views/LiquidationView'));
const DailyCashPosition=_lazyView(()=>import('./views/DailyCashPosition'));
const CashPositionPayables=_lazyView(()=>import('./views/CashPositionPayables'));
const CERequestTracker=_lazyView(()=>import('./views/CERequestTracker'));
const POApprovals=_lazyView(()=>import('./views/POApprovals'));
const PrfView=_lazyView(()=>import('./views/PrfView'));
const SubconCertView=_lazyView(()=>import('./views/SubconCertView'));
const ARDrill=_lazyView(()=>import('./views/ARDrill'));
const AttentionPanel=_lazyView(()=>import('./views/AttentionPanel'));
const WeeklyCashFlow=_lazyView(()=>import('./views/WeeklyCashFlow'));
const FinanceWeeklyDues=_lazyView(()=>import('./views/FinanceWeeklyDues'));
const InventoryView=_lazyView(()=>import('./views/Warehouse').then(m=>({default:m.InventoryView})));
const StockMovementView=_lazyView(()=>import('./views/Warehouse').then(m=>({default:m.StockMovementView})));

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
// GMD Real 13-Stage Workflow

// Normalize any stage string to canonical format
// GMD Real Team — 4 departments




// ─── TAX CALCULATIONS ─────────────────────────────────────────────────────────
// VAT-exclusive: contract value is the base, VAT added on top
// Purchase-side tax breakdown for a supplier cost (input VAT + EWT withheld).
// gross = VAT-inclusive amount on the supplier invoice. If vatable, 12% is
// embedded: net = gross/1.12, inputVat = gross − net (creditable against output
// VAT). EWT is withheld from the supplier on the net (VAT-exclusive) amount.
// Common BIR EWT rates for supplier payments.
// A full sbLoadAll() reload must never blindly overwrite records that were
// just added locally but haven't reached the server yet — e.g. a write still
// in flight, or one that hung on a bad connection (see supabaseClient.js's
// _withTimeout). Without this, refreshing right after "Add Deal" wipes the
// new deal the instant the reload's (still deal-less) server response comes
// back, since it replaces local state outright instead of merging into it.
// Reported live 2026-07-03. Callers pass the CURRENT React state (via the
// functional setState form) as `localList` so this only re-adds records the
// server fetch doesn't already know about.
// Same idea as mergeLocalOnly but for the dict-shaped tables (pcards/budgets/
// projs/cashPositions, keyed by dealId or date, not a list of {id,...}) — the
// server's value for a key always wins (it's the synced truth for anything
// that DID make it), but a key that only exists locally (not yet synced)
// is kept instead of vanishing.


// ─── SUPABASE FIELD MAPPERS ───────────────────────────────────────────────────
// Compute a payment due date from a supplier's free-text terms (e.g. "Net 30", "30 days", "COD").
// A number → that many days from `fromISO`; COD/cash/none → due immediately (the from date).

// ─── PROCUREMENT CONSTANTS ────────────────────────────────────────────────────
// ─── PROJECT CARD ─────────────────────────────────────────────────────────────
// ─── TURNAROUND TIME REFERENCE ────────────────────────────────────────────────
// Based on GMD Project Library benchmarks. Used as reference only — QS or
// Operations Director sets the actual target per project.




// ─── INVENTORY CONSTANTS ──────────────────────────────────────────────────────


// Split a project's costs into Committed (open POs not yet delivered — money
// ordered but not yet spent, i.e. ongoing exposure) and Actual (delivered POs +
// logged expenses — money actually gone out). Delivered POs already turned into
// an expense (matched by PO ref) are not double-counted. Shared by BudgetView
// and the Project Card finance snapshot so both agree on the same numbers.



// Reload-merge that only preserves genuinely-unsynced local rows (those with a
// pending offline-queue write) and drops local-only rows the server deleted, so
// a deleted deal/record can't resurrect itself on the next reload — including on
// another user's device, which never issued the delete. See mergeLocalOnly in
// core.js and sbPendingIds in supabaseClient.js.
const mlo=(list,prev)=>mergeLocalOnly(list,prev,sbPendingIds());

const WO_NO_RE=/^WO-(\d+)$/;
const computeNextWoNo=swos=>{
  const nums=(swos||[]).map(w=>{const m=WO_NO_RE.exec(w.woNumber||"");return m?Number(m[1]):0;});
  return `WO-${String((nums.length?Math.max(...nums):0)+1).padStart(4,"0")}`;
};
const claimWoNumber=async({typed,suggested,swos})=>{
  const taken=new Set((swos||[]).map(w=>w.woNumber).filter(Boolean));
  const t=(typed||"").trim();
  if(t&&t!==suggested&&!taken.has(t)) return t;
  if(isSupabaseReady()){
    try{
      const {data,error}=await _rpcWithTimeout(supabase.rpc('next_wo_number'));
      if(!error&&typeof data==="string"&&WO_NO_RE.test(data)) return data;
    }catch(e){ /* fall back to local allocation */ }
  }
  let nn=Number(WO_NO_RE.exec(computeNextWoNo(swos))[1]);
  while(taken.has(`WO-${String(nn).padStart(4,"0")}`)) nn++;
  return `WO-${String(nn).padStart(4,"0")}`;
};
// A hung Supabase request (no error, no success — seen on some flaky/
// restrictive networks) must not block forever: without a timeout, callers
// that `await` this RPC (saveDeal via claimCENo, JO/PO/CV numbering via
// claimDocNumber) hang indefinitely with no toast and no console output —
// the form just sits there looking broken. Same fix as the offline retry
// queue's _withTimeout in supabaseClient.js, applied here too.
const _rpcWithTimeout=(promise,ms=12000)=>Promise.race([
  promise,
  new Promise(resolve=>setTimeout(()=>resolve({data:null,error:{message:'next_doc_number timed out'}}),ms)),
]);
// Collision-free document numbers (PO / CV / INV / JO). Asks the server for the
// next number via the next_doc_number RPC (atomic across devices), passing the
// current local max as a floor; falls back to local count if the RPC is
// unavailable (e.g. before supabase_doc_numbers.sql is applied, or offline).
const claimDocNumber=async(prefix,existingNumbers,digits=4,dbAssigns=false)=>{
  const re=new RegExp(`^${prefix}-(\\d+)$`);
  const localMax=(existingNumbers||[]).reduce((m,s)=>{const mt=re.exec(String(s||""));return mt?Math.max(m,Number(mt[1])):m;},0);
  if(isSupabaseReady()){
    try{
      const {data,error}=await _rpcWithTimeout(supabase.rpc('next_doc_number',{p_prefix:prefix,p_min:localMax}));
      if(!error&&Number.isFinite(Number(data))&&Number(data)>0) return `${prefix}-${String(Number(data)).padStart(digits,"0")}`;
    }catch(e){ /* fall back below */ }
  }
  // RPC unreachable (offline / timeout). For DB-assigned series (migration 022:
  // JO/CV/DRF) leave the number blank so the server's BEFORE INSERT trigger
  // stamps a collision-free value on sync — don't guess "localMax + 1" from a
  // possibly-stale local list, the same trap that duplicated CE numbers.
  if(dbAssigns) return "";
  return `${prefix}-${String(localMax+1).padStart(digits,"0")}`;
};
// Year-scoped document numbers (FOO-YYYY-NNN, e.g. CE-2026-005, EV-2026-003) —
// a distinct shape from the flat PREFIX-NNNN docs above, but reuses the same
// atomic next_doc_number RPC keyed by a year-scoped prefix (e.g. "CE-2026").
// Two offline devices previously each computed "next" from their own stale
// local list and could both save the same number — same collision class
// already fixed for PO/CV/JO. Only re-claims when the number looks like this
// year's auto-format; a manually customized or prior-year number (e.g. an
// addendum suffix) is left untouched.
const claimYearScopedNo=async(base,digits,currentNo,existingNos,dbAssigns=false)=>{
  const yr=new Date().getFullYear();
  const re=new RegExp(`^${base}-(\\d{4})-(\\d+)$`);
  const m=re.exec((currentNo||"").trim());
  if(!m||Number(m[1])!==yr) return (currentNo||"").trim();
  const localMax=(existingNos||[]).reduce((mx,s)=>{const mt=re.exec(String(s||""));return(mt&&Number(mt[1])===yr)?Math.max(mx,Number(mt[2])):mx;},0);
  if(isSupabaseReady()){
    try{
      const{data,error}=await _rpcWithTimeout(supabase.rpc('next_doc_number',{p_prefix:`${base}-${yr}`,p_min:localMax}));
      if(!error&&Number.isFinite(Number(data))&&Number(data)>0) return `${base}-${yr}-${String(Number(data)).padStart(digits,"0")}`;
    }catch(e){ /* fall back below */ }
  }
  // RPC unreachable (offline, or the timeout fired on a flaky connection). For a
  // DB-assigned series, DO NOT guess "localMax + 1" from this device's possibly
  // stale list — that is exactly what let two offline devices both save the same
  // CE number. Leave it blank so the server's BEFORE INSERT trigger stamps a
  // guaranteed-unique value when the deal actually syncs (migration 020); the
  // realtime feed then delivers the assigned number back into local state.
  if(dbAssigns) return "";
  return `${base}-${yr}-${String(localMax+1).padStart(digits,"0")}`;
};
// CE numbers are server-assigned on insert (see supabase_migration_020.sql), so
// an offline claim that can't reach the RPC resolves to blank ("CE pending")
// rather than a collision-prone local guess.
const claimCENo=(dealCeNo,existingCeNos)=>claimYearScopedNo("CE",3,dealCeNo,existingCeNos,true);
const claimEvNo=(evNo,existingEvNos)=>claimYearScopedNo("EV",3,evNo,existingEvNos);


// ─── GMD BANKS & CASH POSITION ───────────────────────────────────────────────

// ─── GMD CLIENT DIRECTORY ────────────────────────────────────────────────────

// ─── DEFAULT ACCOUNTS ─────────────────────────────────────────────────────────
// Password hashing — SHA-256 via Web Crypto API (async)
// Legacy btoa hashes (pre-migration) are detected by the absence of the "sha256:" prefix
// and auto-upgraded to SHA-256 on first successful login.
const legacyHashPw = pw => btoa(pw + ":gmd-salt-2026").split("").reverse().join("");
const TG_CHANNEL_ALIAS={finance:"financialcontrol",operations:"ops"};
const sha256Hash = async (pw, username="") => {
  const raw = pw + username.toLowerCase() + ":gmd-fabhub-2026";
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(raw));
  return "sha256:" + Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,'0')).join('');
};
// hashPw is async — use await everywhere it's called
const hashPw = (pw, username="") => sha256Hash(pw, username);
// checkPw handles both new SHA-256 and legacy btoa hashes transparently
const checkPw = async (pw, hash, username="") => {
  if(!hash) return false;
  if(hash.startsWith("sha256:")) return (await sha256Hash(pw, username)) === hash;
  return legacyHashPw(pw) === hash; // legacy path for migration
};

const DEFAULT_USERS = [
  // ── Owners / Management ──────────────────────────────────────────────────
  { id:"u01", name:"Paulo Garcia", title:"CEO",       username:"paulo",    passwordHash:"",   role:"Manager",      status:"active", createdAt:today },
  { id:"u02", name:"Mar Mungcal", title:"COO",        username:"mar",      passwordHash:"",   role:"Manager",      status:"active", createdAt:today },
  // ── Operations ───────────────────────────────────────────────────────────
  { id:"u03", name:"Arrius Catubay", title:"Operations Director",     username:"arrius",   passwordHash:"",   role:"Manager",      status:"active", createdAt:today },
  { id:"u04", name:"Ryon Santiago",      username:"ryon",     passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u05", name:"David Melendez",     username:"david",    passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u06", name:"Jay Bernardo",       username:"jay",      passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u07", name:"Angelo Nogra",       username:"angelo",   passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u08", name:"Arvin Jaca",         username:"arvin",    passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u09", name:"Jessie Singun",      username:"jessie",   passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u10", name:"Anthony Nogra",      username:"thony",  passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  { id:"u11", name:"Steve Jazmin",       username:"steve",    passwordHash:"",   role:"ProjectMover",   status:"active", createdAt:today },
  // ── Sales ─────────────────────────────────────────────────────────────────
  { id:"u12", name:"Paolo Gomez", title:"Sales Manager",        username:"paolo",    passwordHash:"",   role:"Manager",      status:"active", createdAt:today },
  { id:"u13", name:"Jena De Asis",       username:"jena",     passwordHash:"", role:"Sales",        status:"active", createdAt:today },
  { id:"u14", name:"Don Wyn Celmar",     username:"wyn",      passwordHash:"", role:"Sales",        status:"active", createdAt:today },
  { id:"u15", name:"April Gail De Ello", username:"gail",     passwordHash:"", role:"Sales",        status:"active", createdAt:today },
  // ── Cost Control ──────────────────────────────────────────────────────────
  { id:"u16", name:"Aerwin Del Rosario", username:"aerwin",   passwordHash:"",   role:"Finance",      status:"inactive", createdAt:today },
  { id:"u25", name:"Accounting",         username:"accounting",passwordHash:"",  role:"Accounting",   status:"active", createdAt:today },
  { id:"u17", name:"Marian Prile",       username:"marian",   passwordHash:"",   role:"ProcurementManager", title:"Procurement Manager", status:"active", createdAt:today },
  { id:"u27", name:"Mark Acejo",         username:"mark",     passwordHash:"",   role:"FinanceAssistant", title:"Finance Assistant",          status:"active", createdAt:today },
  { id:"u29", name:"Jerwin Limon",       username:"jerwin",   passwordHash:"",   role:"FinanceAssistant", title:"Finance Assistant",          status:"active", createdAt:today },
  // ── Sales & Ops Admin ─────────────────────────────────────────────────────
  { id:"u26", name:"Jessica Castro",     username:"jessica",  passwordHash:"",   role:"SalesOpsAdmin",    title:"Operations & Sales Admin",   status:"active", createdAt:today },
  // ── QS / Cost Estimator ───────────────────────────────────────────────────
  { id:"u23", name:"Rodney",             username:"rodney",   passwordHash:"",   role:"QS",           status:"active", createdAt:today },
  // ── Warehouse ─────────────────────────────────────────────────────────────
  { id:"u24", name:"Warehouse",          username:"warehouse",passwordHash:"",   role:"Warehouse",    status:"active", createdAt:today },
  // ── Design ────────────────────────────────────────────────────────────────
  { id:"u18", name:"Gab Florita",        username:"gab",      passwordHash:"",   role:"Design",       status:"active", createdAt:today },
  { id:"u19", name:"Miaa Villoria",      username:"miaa",     passwordHash:"",   role:"Design",       status:"active", createdAt:today },
  { id:"u20", name:"Miel Vidallo",       username:"miel",     passwordHash:"",   role:"Design",       status:"active", createdAt:today },
  { id:"u21", name:"Adrian Adriano",     username:"adrian",   passwordHash:"",   role:"Design",       status:"active", createdAt:today },
  { id:"u22", name:"Tisha Leyva",        username:"tisha",    passwordHash:"",   role:"Design",       status:"active", createdAt:today },
  // ── Office wall display (65" touchscreen) ────────────────────────────────
  // A dedicated read-only kiosk account. Logging in as this user drops straight
  // into the fullscreen OfficeTVDashboard (no nav, no write actions). Role
  // "Display" is granted SELECT-only RLS in migration 054; it can never write.
  { id:"u28", name:"Office Display",     username:"tv",       passwordHash:"", role:"Display",   title:"Office Wall Display", status:"active", createdAt:today },
];

// ─── SEED DATA ────────────────────────────────────────────────────────────────










// ─── UI ATOMS ─────────────────────────────────────────────────────────────────
const Badge=({label,color})=>(
  <span style={{display:"inline-block",padding:"3px 10px",borderRadius:20,background:color+"18",color,fontSize:".72rem",fontWeight:700,border:`1px solid ${color}33`,whiteSpace:"nowrap"}}>{label}</span>
);
const Btn=({children,onClick,variant="primary",small,full,disabled,type="button"})=>{
  const styles={
    primary:{bg:T.navy,color:"#fff",border:"none"},
    ghost:{bg:"transparent",color:T.inkMuted,border:"1.5px solid #cbd5e1"},
    danger:{bg:T.dangerBg,color:"#ef4444",border:`1.5px solid ${T.dangerLine}`},
    green:{bg:T.successBg,color:T.successAlt,border:`1.5px solid ${T.successLine}`},
    accent:{bg:T.infoBg,color:"#3b82f6",border:`1.5px solid ${T.infoLine}`},
  }[variant]||{bg:T.navy,color:"#fff",border:"none"};
  return(
    <button type={type} onClick={onClick} disabled={disabled} style={{background:disabled?T.surface3:styles.bg,color:disabled?T.inkFaint:styles.color,border:styles.border,borderRadius:T.radius.md,padding:small?"5px 12px":"9px 18px",fontFamily:"inherit",fontWeight:600,fontSize:small?".76rem":".84rem",cursor:disabled?"not-allowed":"pointer",width:full?"100%":"auto",transition:"opacity .15s,box-shadow .15s",whiteSpace:"nowrap"}}
      onMouseEnter={e=>{if(!disabled)e.currentTarget.style.opacity=".85";}}
      onMouseLeave={e=>{e.currentTarget.style.opacity="1";}}>
      {children}
    </button>
  );
};
function SearchSelect({value,onChange,options,placeholder="Search…",noneLabel="— None —",noneValue=null}){
  const [query,setQuery]=useState("");
  const [open,setOpen]=useState(false);
  const ref=useRef(null);
  const selected=options.find(o=>o.value===value);
  const filtered=query.trim()===""?options:options.filter(o=>o.label.toLowerCase().includes(query.toLowerCase()));
  useEffect(()=>{
    const handler=e=>{if(ref.current&&!ref.current.contains(e.target)) setOpen(false);};
    document.addEventListener("mousedown",handler);
    return()=>document.removeEventListener("mousedown",handler);
  },[]);
  const choose=v=>{onChange(v);setOpen(false);setQuery("");};
  return(
    <div ref={ref} style={{position:"relative"}}>
      <div style={{display:"flex",alignItems:"center",border:"1.5px solid "+(open?"#6366f1":"#e2e8f0"),borderRadius:8,background:"#fff",cursor:"pointer",transition:"border-color .15s"}} onClick={()=>{setOpen(o=>!o);setQuery("");}}>
        {open?(
          <input autoFocus value={query} onChange={e=>setQuery(e.target.value)} onKeyDown={e=>{if(e.key==="Escape"){setOpen(false);setQuery("");}if(e.key==="Enter"&&filtered.length>0) choose(filtered[0].value);}} placeholder={placeholder} style={{flex:1,border:"none",outline:"none",padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"transparent",borderRadius:8}} onClick={e=>e.stopPropagation()}/>
        ):(
          <div style={{flex:1,padding:"10px 13px",fontSize:".87rem",color:selected?"#1e293b":"#94a3b8",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{selected?selected.label:noneLabel}</div>
        )}
        <span style={{padding:"0 10px",color:"#94a3b8",fontSize:".75rem",flexShrink:0}}>{open?"▲":"▼"}</span>
      </div>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,.12)",zIndex:999,maxHeight:240,overflowY:"auto"}}>
          <div onClick={()=>choose(noneValue)} style={{padding:"10px 13px",fontSize:".85rem",color:"#94a3b8",cursor:"pointer",borderBottom:"1px solid #f1f5f9",fontStyle:"italic"}} onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>{noneLabel}</div>
          {filtered.length===0?(
            <div style={{padding:"10px 13px",fontSize:".82rem",color:"#94a3b8",textAlign:"center"}}>No projects match "{query}"</div>
          ):filtered.map(o=>(
            <div key={o.value} onClick={()=>choose(o.value)} style={{padding:"9px 13px",fontSize:".85rem",color:o.value===value?"#6366f1":"#1e293b",fontWeight:o.value===value?700:400,cursor:"pointer",background:o.value===value?"#f0f0ff":"transparent",borderBottom:"1px solid #f8fafc"}} onMouseEnter={e=>{if(o.value!==value)e.currentTarget.style.background="#f8fafc";}} onMouseLeave={e=>{e.currentTarget.style.background=o.value===value?"#f0f0ff":"transparent";}}>{o.label}</div>
          ))}
        </div>
      )}
    </div>
  );
}
// Focus-safe raw input — use this instead of bare <input> inside forms
const FInp=({value,onChange,type="text",placeholder,style:sx={},className,onKeyDown,min,max,rows})=>{
  const base={...sx};
  if(rows) return <textarea value={value||""} onChange={onChange} placeholder={placeholder} rows={rows} className={className} style={base}/>;
  return <input type={type} value={value||""} onChange={onChange} onKeyDown={onKeyDown} placeholder={placeholder} min={min} max={max} className={className} style={base}/>;
};
const FileAttachments=({folder,label="Attachments"})=>{
  const [files,setFiles]=React.useState([]);
  const [loading,setLoading]=React.useState(false);
  const [uploading,setUploading]=React.useState(false);
  const [open,setOpen]=React.useState(false);
  const fileRef=React.useRef();

  const load=React.useCallback(async()=>{
    if(!folder||!isSupabaseReady()) return;
    setLoading(true);
    const list=await sbListFiles(folder);
    setFiles(list);
    setLoading(false);
  },[folder]);

  React.useEffect(()=>{ if(open) load(); },[open,load]);

  const upload=async(e)=>{
    const file=e.target.files?.[0]; if(!file) return;
    setUploading(true);
    const path=await sbUploadFile(folder,file);
    if(path) await load();
    setUploading(false);
    e.target.value="";
  };

  const del=async(fileName)=>{
    if(!(await uiConfirm(`Delete "${fileName}"?`))) return;
    await sbDeleteFile(`${folder}/${fileName}`);
    await load();
  };

  const fileIcon=(name)=>{
    const ext=name.split('.').pop().toLowerCase();
    if(['jpg','jpeg','png','gif','webp'].includes(ext)) return '🖼';
    if(['pdf'].includes(ext)) return '📄';
    if(['xlsx','xls','csv'].includes(ext)) return '📊';
    if(['docx','doc'].includes(ext)) return '📝';
    return '📎';
  };

  if(!isSupabaseReady()) return null;

  return(
    <div style={{borderTop:"1px solid #f1f5f9",marginTop:12,paddingTop:10}}>
      <div style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}} onClick={()=>setOpen(o=>!o)}>
        <span style={{fontSize:".78rem",fontWeight:700,color:"#475569"}}>📎 {label}</span>
        {files.length>0&&<span style={{background:"#eff6ff",color:"#3b82f6",borderRadius:99,padding:"0 7px",fontSize:".68rem",fontWeight:700}}>{files.length}</span>}
        <span style={{fontSize:".72rem",color:"#94a3b8",marginLeft:"auto"}}>{open?"▲":"▼"}</span>
      </div>
      {open&&(
        <div style={{marginTop:8}}>
          {loading&&<div style={{fontSize:".75rem",color:"#94a3b8"}}>Loading…</div>}
          {!loading&&files.length===0&&<div style={{fontSize:".75rem",color:"#94a3b8",fontStyle:"italic"}}>No files yet.</div>}
          {files.map(f=>{
            const displayName=f.name.replace(/^\d+_/,"");
            const url=sbGetPublicUrl(`${folder}/${f.name}`);
            return(
              <div key={f.name} style={{display:"flex",alignItems:"center",gap:6,padding:"4px 0",borderBottom:"1px solid #f8fafc"}}>
                <span>{fileIcon(f.name)}</span>
                <a href={url} target="_blank" rel="noreferrer" style={{flex:1,fontSize:".75rem",color:"#3b82f6",textDecoration:"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={displayName}>{displayName}</a>
                <span style={{fontSize:".68rem",color:"#94a3b8",whiteSpace:"nowrap"}}>{f.metadata?.size?`${(f.metadata.size/1024).toFixed(0)}KB`:""}</span>
                <button onClick={()=>del(f.name)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".75rem",padding:"0 2px"}} title="Delete">✕</button>
              </div>
            );
          })}
          <div style={{marginTop:8}}>
            <input ref={fileRef} type="file" style={{display:"none"}} onChange={upload} />
            <button onClick={()=>fileRef.current?.click()} disabled={uploading}
              style={{fontSize:".73rem",background:"#f8fafc",border:"1.5px dashed #cbd5e1",borderRadius:6,padding:"5px 12px",color:"#64748b",cursor:"pointer",width:"100%"}}>
              {uploading?"Uploading…":"+ Upload File"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Render free-text that may contain http(s) URLs, turning each URL into a
// clickable link while leaving the rest as plain text. Used for DRF
// notes/descriptions where the team pastes a Google Drive / reference link
// inline. whiteSpace:"pre-wrap" on the parent preserves line breaks.
const Linkify=({text,color="#2563eb"})=>{
  if(text==null||text==="") return null;
  const parts=String(text).split(/(https?:\/\/[^\s]+)/g);
  return parts.map((p,i)=>/^https?:\/\//.test(p)
    ? <a key={i} href={p} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{color,fontWeight:600,wordBreak:"break-all",textDecoration:"underline"}}>{p}</a>
    : <React.Fragment key={i}>{p}</React.Fragment>
  );
};

// Best-effort thumbnail source for a reference link. Google Drive share links
// become a Drive thumbnail endpoint; direct image URLs are used as-is; anything
// else returns null (the tile falls back to an icon).
const refThumbSrc=(url)=>{
  const m=/(?:\/d\/|[?&]id=|\/file\/d\/)([A-Za-z0-9_-]{20,})/.exec(url||"");
  if(m) return `https://drive.google.com/thumbnail?id=${m[1]}&sz=w400`;
  if(/\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(url||"")) return url;
  return null;
};
// A reference link rendered as a clickable thumbnail tile. Falls back to an
// icon tile when the URL can't be previewed or the image fails to load.
const RefThumb=({url,label,icon="🖼"})=>{
  const[err,setErr]=React.useState(false);
  const thumb=refThumbSrc(url);
  return(
    <a href={url} target="_blank" rel="noreferrer" title={label} style={{display:"block",width:92,textDecoration:"none",flexShrink:0}}>
      <div style={{width:92,height:70,borderRadius:8,overflow:"hidden",border:"1px solid #e2e8f0",background:"#f8fafc",display:"flex",alignItems:"center",justifyContent:"center"}}>
        {thumb&&!err
          ? <img src={thumb} alt={label} loading="lazy" onError={()=>setErr(true)} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
          : <span style={{fontSize:"1.4rem"}}>{icon}</span>}
      </div>
      <div style={{fontSize:".66rem",color:"#6366f1",fontWeight:600,marginTop:3,textAlign:"center",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{label}</div>
    </a>
  );
};

// Single source of truth for a design status change — used by the modal, the
// home cards, and the Kanban board's drag-drop so the "Done → Fabrication"
// handoff + notifications never drift between call sites.
function applyDesignStatus(upProj,id,proj,deal,s,session,today,sendTelegramNotification){
  const cur=proj?.design||{};
  if(s===cur.status) return;
  const next={...cur,status:s,statusHistory:[...(cur.statusHistory||[]),{status:s,date:today,by:session?.name||"Design"}]};
  upProj(id,x=>({...x,design:{...x.design,...next}}));
  if(s==="Done"&&proj?.currentStage==="Design"){
    upProj(id,x=>({...x,currentStage:"Fabrication",progress:{...x.progress,Design:100},stageDates:{...x.stageDates,Design:{...x.stageDates?.Design,e:today},Fabrication:{...x.stageDates?.Fabrication,s:x.stageDates?.Fabrication?.s||today}}}));
    const msg=`🎨 <b>Design Complete — Ready for Fabrication</b>\nProject: <b>${deal?.client||"?"}</b>${deal?.ceNo?`\nCE: ${deal.ceNo}`:""}\nDesigner: ${next.designer||"—"}${next.revisionNo?`\nRevision: ${next.revisionNo}`:""}\n${next.link?`<a href="${next.link}">View Drawings</a>`:"No file link yet"}\nBy: ${session?.name||"Design"}`;
    sendTelegramNotification?.("ops",msg);sendTelegramNotification?.("management",msg);
  }
}

// ─── DESIGN KANBAN BOARD ──────────────────────────────────────────────────────
// One triage board reused on the Design home and the Manager side panel. Columns
// are the live design statuses; Done/Cancelled collapse into a "Closed" lane.
// Filter tiles double as the "most-due / what's urgent" widgets. Desktop supports
// drag-drop between columns; mobile falls back to a per-card status dropdown.
function DesignBoard({projList,projs,drfs,upProj,session,role,today,setSelProj,setOpsTab,sendTelegramNotification,toastEmit}){
  const mob=window.innerWidth<768;
  const[filter,setFilter]=React.useState(null);
  const[showClosed,setShowClosed]=React.useState(false);
  const[dragId,setDragId]=React.useState(null);
  const[mobStatus,setMobStatus]=React.useState(""); // mobile-only status filter (no columns on phones)

  const items=(projList||[]).map(dl=>{
    const p=projs[dl.id];if(!p)return null;
    const design=p.design||{};
    const drf=(drfs||[]).find(r=>r.dealId===dl.id);
    return {id:dl.id,deal:dl,design,drf,u:designUrgency(design,drf,today),promised:designPromisedDate(design,drf)};
  }).filter(Boolean);

  // Filter-tile widgets. Each is {key,label,color,test,count}.
  const tiles=[
    {key:"overdue", label:"Overdue",           color:"#dc2626", test:it=>it.u.tier==="overdue"},
    {key:"soon",    label:"Due ≤ 7 days",      color:"#f59e0b", test:it=>it.u.tier==="due-soon"||it.u.tier==="at-risk"},
    {key:"blocked", label:"Blocked",           color:"#dc2626", test:it=>it.u.tier==="blocked"},
    {key:"ack",     label:"Awaiting prod ack", color:"#3b82f6", test:it=>(it.design.status==="Production Plans"||it.design.status==="Done")&&!isProductionBriefed(it.design)},
    {key:"undated", label:"No committed date", color:"#a855f7", test:it=>!isDesignClosed(it.design.status)&&!it.design.committedDate},
    {key:"art",     label:"Artwork / Signage", color:"#7c3aed", test:it=>designNeedsArtwork(it.design)},
  ].map(t=>({...t,count:items.filter(t.test).length}));

  const activeTile=tiles.find(t=>t.key===filter);
  const visible=activeTile?items.filter(activeTile.test):items;
  // Rank inside each column by urgency (most urgent on top).
  const byStatus=(st)=>visible.filter(it=>it.design.status===st).sort((a,b)=>b.u.rank-a.u.rank||(a.promised||"9999").localeCompare(b.promised||"9999"));

  const openCard=(id)=>{setSelProj(id);setOpsTab&&setOpsTab("design");};
  const dropTo=(st)=>{
    if(!dragId)return;const it=items.find(x=>x.id===dragId);setDragId(null);
    if(!it||it.design.status===st)return;
    if(st==="Done"&&!it.design.link){toastEmit&&toastEmit("⚠ Add a file / link before marking Done — opening the card.","warning");openCard(it.id);return;}
    applyDesignStatus(upProj,it.id,projs[it.id],it.deal,st,session,today,sendTelegramNotification);
  };

  const cols=[...DESIGN_ACTIVE_STATUSES,...(showClosed?DESIGN_CLOSED_STATUSES:[])];

  const Cardlet=(it)=>{
    const c=DS_CLR[it.design.status]||"#94a3b8";
    const openB=openBlockers(it.design).length;
    return(
      <div key={it.id}
        draggable={!mob}
        onDragStart={()=>setDragId(it.id)}
        onDragEnd={()=>setDragId(null)}
        onClick={()=>openCard(it.id)}
        style={{background:"#fff",border:`1.5px solid ${it.u.rank>=3?"#fecaca":"#e2e8f0"}`,borderLeft:`4px solid ${it.u.color}`,borderRadius:10,padding:"9px 11px",marginBottom:8,cursor:"pointer",boxShadow:dragId===it.id?"0 8px 20px rgba(0,0,0,.15)":"none",opacity:dragId===it.id?.5:1}}>
        <div style={{fontWeight:700,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{it.deal.client}</div>
        <div style={{fontSize:".7rem",color:"#94a3b8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginTop:1}}>{it.design.projectTitle||it.deal.product||"—"}</div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",alignItems:"center",marginTop:6}}>
          <span style={{fontSize:".64rem",fontWeight:700,color:it.u.color,background:it.u.color+"18",border:`1px solid ${it.u.color}44`,borderRadius:12,padding:"1px 7px"}}>{it.u.label}</span>
          {openB>0&&<span style={{fontSize:".64rem",fontWeight:700,color:"#dc2626"}}>🚧 {openB}</span>}
          {designNeedsArtwork(it.design)&&<span style={{fontSize:".62rem",fontWeight:700,color:"#7c3aed",background:"#f5f3ff",borderRadius:12,padding:"1px 6px"}}>🎨</span>}
          {isProductionBriefed(it.design)&&<span style={{fontSize:".62rem"}} title="Briefed to Production">📦</span>}
        </div>
        <div style={{fontSize:".66rem",color:"#94a3b8",marginTop:5}}>{it.design.designer||"Unassigned"}{it.promised?` · ${it.promised}`:""}</div>
        {mob&&(
          <select value={it.design.status} onClick={e=>e.stopPropagation()} onChange={e=>{e.stopPropagation();const s=e.target.value;if(s==="Done"&&!it.design.link){toastEmit&&toastEmit("⚠ Add a file / link first.","warning");openCard(it.id);return;}applyDesignStatus(upProj,it.id,projs[it.id],it.deal,s,session,today,sendTelegramNotification);}}
            style={{marginTop:7,width:"100%",boxSizing:"border-box",border:`1.5px solid ${c}`,borderRadius:7,padding:"5px 8px",fontFamily:"inherit",fontSize:".72rem",color:c,background:c+"12",fontWeight:700}}>
            {DESIGN_STATUSES.map(s=><option key={s} value={s} style={{color:"#0f172a",background:"#fff"}}>{s}</option>)}
          </select>
        )}
      </div>
    );
  };

  return(
    <div>
      {/* Filter-tile widgets */}
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr 1fr":"repeat(6,1fr)",gap:8,marginBottom:14}}>
        {tiles.map(t=>(
          <div key={t.key} onClick={()=>setFilter(filter===t.key?null:t.key)}
            style={{background:filter===t.key?t.color+"14":"#fff",border:`1.5px solid ${filter===t.key?t.color:t.color+"33"}`,borderRadius:11,padding:"9px 11px",cursor:"pointer"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:t.count?t.color:"#cbd5e1"}}>{t.count}</div>
            <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:".5px",color:"#94a3b8",marginTop:2,fontWeight:700}}>{t.label}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,flexWrap:"wrap",gap:8}}>
        <div style={{fontSize:".72rem",color:"#94a3b8"}}>{activeTile?`Filtered: ${activeTile.label} · ${visible.length} project${visible.length!==1?"s":""}`:`${items.length} project${items.length!==1?"s":""}`}{!mob&&" · drag cards between columns to change status"}</div>
        <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          {mob&&(
            <select value={mobStatus} onChange={e=>setMobStatus(e.target.value)}
              style={{border:"1.5px solid #e2e8f0",borderRadius:9,padding:"6px 10px",fontFamily:"inherit",fontSize:".76rem",color:"#0f172a",background:"#fff",fontWeight:700}}>
              <option value="">All statuses</option>
              {DESIGN_STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          )}
          <label style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:".72rem",color:"#64748b",cursor:"pointer"}}>
            <input type="checkbox" checked={showClosed} onChange={e=>setShowClosed(e.target.checked)} style={{cursor:"pointer"}}/>Show closed
          </label>
        </div>
      </div>
      {mob
        ? (/* Mobile: no Kanban columns — a single most-due-first list driven by the tiles + status filter */
          (()=>{
            const list=visible
              .filter(it=>showClosed||!isDesignClosed(it.design.status))
              .filter(it=>!mobStatus||it.design.status===mobStatus)
              .sort((a,b)=>b.u.rank-a.u.rank||(a.promised||"9999").localeCompare(b.promised||"9999"));
            return list.length===0
              ? <div style={{fontSize:".8rem",color:"#94a3b8",textAlign:"center",padding:"24px 0"}}>Nothing matches this filter.</div>
              : <div>{list.map(Cardlet)}</div>;
          })()
        )
        : (/* Desktop: Kanban columns with drag-drop */
          <div style={{display:"flex",gap:12,overflowX:"auto",paddingBottom:8}}>
            {cols.map(st=>{
              const list=byStatus(st);const c=DS_CLR[st]||"#94a3b8";
              return(
                <div key={st}
                  onDragOver={e=>{e.preventDefault();}}
                  onDrop={()=>dropTo(st)}
                  style={{flex:"1",minWidth:180,background:"#f8fafc",border:`1.5px solid ${dragId?c+"66":"#eef2f7"}`,borderRadius:12,padding:"10px 10px 6px"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                    <span style={{fontSize:".72rem",fontWeight:800,color:c}}>{st}</span>
                    <span style={{fontSize:".66rem",fontWeight:700,color:"#94a3b8",background:"#fff",borderRadius:10,padding:"1px 7px"}}>{list.length}</span>
                  </div>
                  {list.length===0?<div style={{fontSize:".68rem",color:"#cbd5e1",textAlign:"center",padding:"14px 0"}}>—</div>:list.map(Cardlet)}
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}

// ─── DESIGN DETAILS MODAL ─────────────────────────────────────────────────────
// The designer's working modal for one project: Sales brief, design output,
// status, revisions, approvals (internal + client), a handoff-readiness gate,
// and a comment thread. Extracted to a component so it can hold local UI state.
function DesignDetailModal({selProj,proj,deal,linkedDrf,drfs,projList,projs,upProj,session,role,sendTelegramNotification,toastEmit,today,setSelProj,setOpsTab}){
  const mob=window.innerWidth<768;
  const d=proj.design||{};
  // ── Draft / Save ────────────────────────────────────────────────────────────
  // Typed fields buffer into a local draft and commit on Save (one write instead
  // of one-per-keystroke). Discrete actions — status, blockers, deliverables,
  // comments, approvals-as-stamps — still commit immediately via setD. `v` is the
  // effective view: committed design with unsaved edits layered on top.
  const[draft,setDraft]=React.useState({});
  const v={...d,...draft};
  const setF=(patch)=>setDraft(prev=>({...prev,...patch}));
  const dirty=Object.keys(draft).length>0;
  const saveDraft=()=>{ if(!dirty) return; upProj(selProj,p=>({...p,design:{...p.design,...draft}})); setDraft({}); toastEmit("✔ Design details saved","success"); };
  const discardDraft=()=>setDraft({});
  const closeModal=async()=>{ if(dirty&&!(await uiConfirm("You have unsaved changes. Discard them?"))) return; setDraft({}); setSelProj(null); };

  const status=d.status||"Briefing";
  const hasApproval=v.approvedBy&&v.approvedOn;
  const notify=!!d.notifyStatus;
  const[commentText,setCommentText]=React.useState("");
  const[briefOpen,setBriefOpen]=React.useState(status==="Briefing");
  const setD=(patch)=>upProj(selProj,p=>({...p,design:{...p.design,...patch}}));

  // Designer workload — count each member's still-open projects + DRFs so the
  // lead can distribute evenly. "Open" excludes finished states.
  const workload={};
  DESIGN_MEMBERS.forEach(m=>{workload[m]=0;});
  (projList||[]).forEach(x=>{const dz=projs[x.id]?.design?.designer;if(dz&&workload[dz]!=null&&projs[x.id]?.design?.status!=="Done")workload[dz]++;});
  (drfs||[]).forEach(x=>{if(x.designer&&workload[x.designer]!=null&&!["Approved","Production","Done"].includes(x.status))workload[x.designer]++;});

  const changeStatus=async(s)=>{
    if(s===status) return;
    if(s==="Done"&&!d.link){toastEmit("⚠ Please add a file / link before marking Done.","warning");return;}
    if(s==="Done"&&!hasApproval){ if(!(await uiConfirm("Mark Done without an internal approval on file? Ops handoff usually needs a locked, approved revision."))) return; }
    const next={...d,status:s,statusHistory:[...(d.statusHistory||[]),{status:s,date:today,by:session?.name||"Design"}]};
    upProj(selProj,x=>({...x,design:next}));
    if(s==="Done"&&proj.currentStage==="Design"){
      upProj(selProj,x=>({...x,currentStage:"Fabrication",progress:{...x.progress,Design:100},stageDates:{...x.stageDates,Design:{...x.stageDates?.Design,e:today},Fabrication:{...x.stageDates?.Fabrication,s:x.stageDates?.Fabrication?.s||today}}}));
      const msg=`🎨 <b>Design Complete — Ready for Fabrication</b>\nProject: <b>${deal?.client||"?"}</b>${deal?.ceNo?`\nCE: ${deal.ceNo}`:""}\nDesigner: ${next.designer||"—"}${next.revisionNo?`\nRevision: ${next.revisionNo}`:""}\n${next.link?`<a href="${next.link}">View Drawings</a>`:"No file link yet"}\nBy: ${session?.name||"Design"}`;
      sendTelegramNotification("ops",msg);sendTelegramNotification("management",msg);
    }else if(notify){
      const msg=`🎨 <b>Design Status → ${s}</b>\nProject: <b>${deal?.client||"?"}</b>${deal?.ceNo?`\nCE: ${deal.ceNo}`:""}\nDesigner: ${next.designer||"—"}\nBy: ${session?.name||"Design"}`;
      sendTelegramNotification("design",msg);
      if(s==="For Review"||s==="Production Plans") sendTelegramNotification("management",msg);
    }
  };

  const postComment=()=>{
    const t=commentText.trim(); if(!t) return;
    setD({comments:[...(d.comments||[]),{text:t,by:session?.name||"Design",at:new Date().toISOString()}]});
    setCommentText("");
  };

  const copyBrief=async()=>{
    const L=linkedDrf||{};
    const lines=[
      `PROJECT: ${d.projectTitle||deal?.product||deal?.client||""}`,
      `CLIENT: ${deal?.client||L.client||""}`,
      `CATEGORY: ${L.category||"—"}`,
      `LOCATION: ${deal?.location||L.location||"—"}`,
      `SIZE: ${deal?.drfSize||L.size||"—"}`,
      L.maxHeight?`MAX HEIGHT: ${L.maxHeight}`:"",
      L.platform?`PLATFORM: ${L.platform}`:"",
      L.finishes?`FINISHES: ${L.finishes}`:"",
      L.budget?`BUDGET: ${L.budget}`:"",
      (deal?.drfDescription||L.description)?`\nBRIEF:\n${deal?.drfDescription||L.description}`:"",
      L.brandGuideLink?`\nBrand guideline: ${L.brandGuideLink}`:"",
    ].filter(Boolean).join("\n");
    try{ await navigator.clipboard.writeText(lines); toastEmit("📋 Brief copied to clipboard","success"); }
    catch{ toastEmit("Couldn't copy automatically — select the brief text manually.","warning"); }
  };

  // Handoff-readiness checklist (reflects unsaved edits via v).
  const checks=[
    {label:"File / drawings link",ok:!!v.link},
    {label:"Revision no. locked",ok:!!v.revisionNo},
    {label:"Internal approval",ok:!!hasApproval},
    {label:"Client approval",ok:v.clientStatus==="Client Approved"},
  ];
  const readyCount=checks.filter(c=>c.ok).length;
  const allReady=readyCount===checks.length;

  // Days in current status (from the last status-history entry).
  const lastHist=(d.statusHistory||[]).slice(-1)[0];
  const daysInStatus=lastHist?.date?Math.max(0,Math.floor((new Date(today)-new Date(lastHist.date))/86400000)):null;
  const dueOverdue=v.dueDate&&!hasApproval&&new Date(v.dueDate)<new Date(today);

  const refs=(linkedDrf?.refLinks||[]).filter(Boolean);
  const CS_CLR={"Not Sent":"#94a3b8","Sent for Review":"#3b82f6","Client Approved":"#059669","Client Revisions":"#ef4444"};
  const cs=v.clientStatus||"Not Sent";

  // Committed (promised) date is owned by the design manager only; everyone else
  // sees it read-only. Blockers can be raised by any designer. Urgency/promised
  // reflect unsaved edits (v) so the badge updates live as Gab types a date.
  const canSetCommitted=role==="Manager";
  const promised=designPromisedDate(v,linkedDrf);
  const urgency=designUrgency(v,linkedDrf,today);
  const openBlks=openBlockers(d);
  const briefed=isProductionBriefed(d);
  const[blkText,setBlkText]=React.useState("");
  const addBlocker=()=>{
    const t=blkText.trim(); if(!t) return;
    setD({blockers:[...(d.blockers||[]),{text:t,by:session?.name||"Design",at:new Date().toISOString(),resolved:false}]});
    setBlkText("");
    if(notify) sendTelegramNotification("design",`🚧 <b>Design Blocker — ${deal?.client||"?"}</b>\n${t}\nBy: ${session?.name||"Design"}`);
  };
  const toggleBlocker=(idx)=>setD({blockers:(d.blockers||[]).map((b,j)=>j===idx?{...b,resolved:!b.resolved,resolvedBy:session?.name,resolvedAt:new Date().toISOString()}:b)});
  const toggleDeliverable=(t)=>{const cur=d.deliverables||[];setD({deliverables:cur.includes(t)?cur.filter(x=>x!==t):[...cur,t]});};
  const markBriefed=()=>setD({productionBriefed:{by:session?.name||"—",at:new Date().toISOString()}});

  return(
    <Modal open title={`Design Details — ${deal?.client}`} onClose={closeModal} wide>
      {/* ── Handoff readiness gate ─────────────────────── */}
      <div style={{background:allReady?"#f0fdf4":"#fff7ed",border:`1.5px solid ${allReady?"#bbf7d0":"#fed7aa"}`,borderRadius:12,padding:"10px 14px",marginBottom:14}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,flexWrap:"wrap",marginBottom:7}}>
          <span style={{fontSize:".72rem",fontWeight:800,color:allReady?"#15803d":"#9a3412"}}>{allReady?"✅ Ready for handoff":`🚧 Handoff readiness — ${readyCount}/${checks.length}`}</span>
          {daysInStatus!=null&&<span style={{fontSize:".68rem",fontWeight:600,color:daysInStatus>=7?"#dc2626":"#94a3b8"}}>⏱ {daysInStatus}d in “{status}”</span>}
        </div>
        <div style={{display:"flex",gap:"6px 14px",flexWrap:"wrap"}}>
          {checks.map(c=>(
            <span key={c.label} style={{fontSize:".72rem",fontWeight:600,color:c.ok?"#15803d":"#b45309"}}>{c.ok?"✅":"⬜"} {c.label}</span>
          ))}
        </div>
      </div>

      {/* ── Timeline · Blockers · Production handoff ────── */}
      <div style={{background:"#fff",border:`1.5px solid ${urgency.color}44`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:12}}>
          {/* Committed / promised date — manager-owned */}
          <div>
            <div style={{fontSize:".64rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:4}}>Committed Date {canSetCommitted?"":" (set by Design Mgr)"}</div>
            {canSetCommitted
              ? <Inp type="date" value={v.committedDate||""} onChange={e=>setF({committedDate:e.target.value})}/>
              : <div style={{fontSize:".9rem",fontWeight:800,color:v.committedDate?"#0f172a":"#cbd5e1"}}>{v.committedDate||"— not committed —"}</div>}
            <div style={{marginTop:5,fontSize:".72rem",fontWeight:700,color:urgency.color}}>{urgency.label}</div>
            {linkedDrf?.designDeadline&&<div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>Sales requested: {linkedDrf.designDeadline}</div>}
          </div>
          {/* Production handoff acknowledgement */}
          <div>
            <div style={{fontSize:".64rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:4}}>Production Briefed</div>
            {briefed
              ? <div style={{background:"#f0fdf4",border:"1.5px solid #bbf7d0",borderRadius:9,padding:"8px 12px",fontSize:".76rem",color:"#166534",fontWeight:700}}>✅ Briefed by {d.productionBriefed.by} · {new Date(d.productionBriefed.at).toLocaleDateString()}
                  {canSetCommitted&&<button onClick={()=>setD({productionBriefed:null})} style={{marginLeft:8,background:"none",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:".7rem"}}>undo</button>}</div>
              : <button onClick={markBriefed} style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:9,padding:"8px 12px",fontFamily:"inherit",fontSize:".76rem",color:"#1d4ed8",fontWeight:700,cursor:"pointer"}}>📦 Mark briefed to Production</button>}
            {/* Deliverable tags */}
            <div style={{marginTop:8}}>
              <div style={{fontSize:".62rem",color:"#94a3b8",fontWeight:700,marginBottom:4}}>DELIVERABLES</div>
              <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                {DESIGN_DELIVERABLES.map(t=>{const on=(d.deliverables||[]).includes(t);return(
                  <button key={t} onClick={()=>toggleDeliverable(t)} style={{padding:"3px 10px",borderRadius:16,border:`1.5px solid ${on?"#7c3aed":"#e2e8f0"}`,background:on?"#f5f3ff":"#fff",color:on?"#6d28d9":"#94a3b8",fontWeight:on?700:400,cursor:"pointer",fontSize:".7rem",fontFamily:"inherit"}}>{on?"✓ ":""}{t}</button>
                );})}
              </div>
            </div>
          </div>
        </div>
        {/* Blockers — raised by any designer */}
        <div style={{marginTop:12,borderTop:"1px solid #f1f5f9",paddingTop:10}}>
          <div style={{fontSize:".64rem",color:openBlks.length?"#dc2626":"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>🚧 Blockers — what we need to move {openBlks.length>0&&`(${openBlks.length} open)`}</div>
          <div style={{display:"flex",gap:8,marginBottom:(d.blockers||[]).length?8:0}}>
            <Inp value={blkText} onChange={e=>setBlkText(e.target.value)} placeholder="e.g. Waiting on client artwork / final dimensions from Sales…" onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();addBlocker();}}}/>
            <button onClick={addBlocker} disabled={!blkText.trim()} style={{flexShrink:0,background:blkText.trim()?"#dc2626":"#e2e8f0",border:"none",borderRadius:8,padding:"0 14px",color:blkText.trim()?"#fff":"#94a3b8",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:blkText.trim()?"pointer":"not-allowed"}}>Raise</button>
          </div>
          {(d.blockers||[]).map((b,idx)=>(
            <div key={idx} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",borderRadius:8,background:b.resolved?"#f8fafc":"#fef2f2",border:`1px solid ${b.resolved?"#eef2f7":"#fecaca"}`,marginBottom:5}}>
              <button onClick={()=>toggleBlocker(idx)} title={b.resolved?"Reopen":"Resolve"} style={{background:"none",border:"none",cursor:"pointer",fontSize:".85rem"}}>{b.resolved?"✅":"⬜"}</button>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:".78rem",color:b.resolved?"#94a3b8":"#7f1d1d",fontWeight:600,textDecoration:b.resolved?"line-through":"none"}}>{b.text}</div>
                <div style={{fontSize:".66rem",color:"#94a3b8"}}>{b.by}{b.at?` · ${new Date(b.at).toLocaleDateString()}`:""}{b.resolved&&b.resolvedBy?` · resolved by ${b.resolvedBy}`:""}</div>
              </div>
            </div>
          ))}
          {(d.blockers||[]).length===0&&<div style={{fontSize:".72rem",color:"#94a3b8",fontStyle:"italic"}}>No blockers — designer can flag anything they're waiting on here.</div>}
        </div>
      </div>

      {/* ── Brief from Sales (collapsible) ─────────────── */}
      <div style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
          <div style={{fontSize:".68rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",cursor:"pointer",flex:1}} onClick={()=>setBriefOpen(o=>!o)}>📋 Brief from Sales <span style={{color:"#cbd5e1"}}>{briefOpen?"▲":"▼"}</span></div>
          <button onClick={copyBrief} style={{background:"#eef2ff",border:"1.5px solid #c7d2fe",borderRadius:8,padding:"4px 10px",fontFamily:"inherit",fontSize:".7rem",color:"#4338ca",cursor:"pointer",fontWeight:700}}>📋 Copy brief</button>
        </div>
        {briefOpen&&(<div style={{marginTop:10}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px 16px",fontSize:".8rem",color:"#1e293b",marginBottom:8}}>
            <div><span style={{color:"#94a3b8",fontSize:".72rem"}}>Product / Item</span><div style={{fontWeight:600}}>{deal?.product||"—"}</div></div>
            <div><span style={{color:"#94a3b8",fontSize:".72rem"}}>Location</span><div style={{fontWeight:600}}>{deal?.location||"—"}</div></div>
            {deal?.drfSize&&<div><span style={{color:"#94a3b8",fontSize:".72rem"}}>Size / Dimensions</span><div style={{fontWeight:600}}>{deal.drfSize}</div></div>}
            {deal?.contact&&<div><span style={{color:"#94a3b8",fontSize:".72rem"}}>Contact Person</span><div style={{fontWeight:600}}>{deal.contact}</div></div>}
          </div>
          {(deal?.drfDescription||deal?.notes)&&(
            <div style={{fontSize:".78rem",color:"#475569",marginBottom:6,whiteSpace:"pre-wrap",borderTop:"1px solid #e2e8f0",paddingTop:8}}><Linkify text={deal?.drfDescription||deal?.notes}/></div>
          )}
          {deal?.drfAccessories?.filter(a=>a).length>0&&(
            <div style={{marginTop:6}}>
              <div style={{fontSize:".68rem",color:"#94a3b8",fontWeight:700,marginBottom:4}}>ACCESSORIES / COMPONENTS</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {deal.drfAccessories.filter(a=>a).map((a,i)=>(<span key={i} style={{background:"#e0e7ff",color:"#4338ca",fontSize:".72rem",padding:"2px 9px",borderRadius:20,fontWeight:600}}>{a}</span>))}
              </div>
            </div>
          )}
          {linkedDrf&&(
            <div style={{marginTop:8,paddingTop:8,borderTop:"1px solid #e2e8f0"}}>
              <div style={{fontSize:".75rem",color:"#6366f1",fontWeight:700}}>📄 DRF on file: {linkedDrf.drfNo||"DRF"} · {linkedDrf.type||""} · {linkedDrf.designDeadline||"no deadline"}</div>
              {(linkedDrf.category||linkedDrf.platform||linkedDrf.finishes||linkedDrf.maxHeight||linkedDrf.budget||linkedDrf.size)&&(
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"5px 16px",fontSize:".78rem",color:"#1e293b",marginTop:8}}>
                  {linkedDrf.category&&<div><span style={{color:"#94a3b8",fontSize:".7rem"}}>Project Type</span><div style={{fontWeight:600}}>{linkedDrf.category}</div></div>}
                  {linkedDrf.size&&<div><span style={{color:"#94a3b8",fontSize:".7rem"}}>Size / Dimensions</span><div style={{fontWeight:600}}>{linkedDrf.size}</div></div>}
                  {linkedDrf.maxHeight&&<div><span style={{color:"#94a3b8",fontSize:".7rem"}}>Maximum Height</span><div style={{fontWeight:600}}>{linkedDrf.maxHeight}</div></div>}
                  {linkedDrf.platform&&<div><span style={{color:"#94a3b8",fontSize:".7rem"}}>Platform</span><div style={{fontWeight:600}}>{linkedDrf.platform}</div></div>}
                  {linkedDrf.finishes&&<div><span style={{color:"#94a3b8",fontSize:".7rem"}}>Ideal Finishes</span><div style={{fontWeight:600}}>{linkedDrf.finishes}</div></div>}
                  {linkedDrf.budget&&<div><span style={{color:"#94a3b8",fontSize:".7rem"}}>Budget</span><div style={{fontWeight:600}}>{linkedDrf.budget}</div></div>}
                </div>
              )}
              {linkedDrf.description&&<div style={{color:"#475569",fontSize:".78rem",marginTop:8,whiteSpace:"pre-wrap"}}><Linkify text={linkedDrf.description}/></div>}
              {/* Reference images + brand guideline as thumbnails */}
              {(linkedDrf.brandGuideLink||refs.length>0)&&(
                <div style={{display:"flex",gap:10,flexWrap:"wrap",marginTop:10}}>
                  {linkedDrf.brandGuideLink&&<RefThumb url={linkedDrf.brandGuideLink} label="Brand guide" icon="📘"/>}
                  {refs.map((r,i)=><RefThumb key={i} url={r} label={`Ref ${i+1}`}/>)}
                </div>
              )}
            </div>
          )}
        </div>)}
      </div>

      {/* ── Design Output ──────────────────────────────── */}
      <div style={{fontSize:".68rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",marginBottom:10}}>🎨 Design Output</div>
      <Fld label="Project Status">
        <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
          {DESIGN_STATUSES.map(s=>(
            <button key={s} onClick={()=>changeStatus(s)} style={{padding:"5px 12px",border:`1.5px solid ${status===s?DS_CLR[s]:"#e2e8f0"}`,borderRadius:16,background:status===s?DS_CLR[s]+"18":"#fff",color:status===s?DS_CLR[s]:"#94a3b8",fontWeight:status===s?700:400,cursor:"pointer",fontSize:".74rem",fontFamily:"inherit"}}>{s}</button>
          ))}
        </div>
        <label style={{display:"inline-flex",alignItems:"center",gap:6,marginTop:8,fontSize:".72rem",color:"#64748b",cursor:"pointer"}}>
          <input type="checkbox" checked={notify} onChange={e=>setD({notifyStatus:e.target.checked})} style={{cursor:"pointer",accentColor:"#7c3aed"}}/>
          🔔 Notify team on status change
        </label>
      </Fld>
      {(d.statusHistory||[]).length>0&&(
        <div style={{background:"#f8fafc",border:"1px solid #eef2f7",borderRadius:10,padding:"8px 12px",marginBottom:12}}>
          <div style={{fontSize:".64rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Status History</div>
          <div style={{display:"flex",flexDirection:"column",gap:3}}>
            {[...d.statusHistory].slice(-6).reverse().map((h,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,fontSize:".74rem"}}>
                <span style={{width:8,height:8,borderRadius:99,background:DS_CLR[h.status]||"#94a3b8",flexShrink:0}}/>
                <span style={{fontWeight:600,color:"#334155"}}>{h.status}</span>
                <span style={{color:"#94a3b8",marginLeft:"auto"}}>{h.date}{h.by?` · ${h.by}`:""}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <Fld label="Designer">
        <Sel value={v.designer||""} onChange={e=>setF({designer:e.target.value})}><option value="">— Select —</option>{DESIGN_MEMBERS.map(m=><option key={m}>{m}{workload[m]!=null?`  (${workload[m]} open)`:""}</option>)}</Sel>
        {v.designer&&workload[v.designer]!=null&&<div style={{fontSize:".7rem",color:"#94a3b8",marginTop:4}}>{v.designer} currently has {workload[v.designer]} open item{workload[v.designer]!==1?"s":""}.</div>}
      </Fld>
      <Fld label="Working Due Date" hint="Internal target; the committed date above is the promise to Sales.">
        <Inp type="date" value={v.dueDate||""} onChange={e=>setF({dueDate:e.target.value})}/>
        {v.dueDate&&!hasApproval&&(()=>{
          const diff=Math.ceil((new Date(v.dueDate)-new Date(today))/86400000);
          const over=diff<0,soon=diff>=0&&diff<=2;const c=over?"#dc2626":soon?"#f59e0b":"#059669";
          return <div style={{marginTop:5,fontSize:".72rem",fontWeight:700,color:c}}>{over?`⚠ Overdue by ${Math.abs(diff)} day${Math.abs(diff)!==1?"s":""}`:diff===0?"⏰ Due today":`⏳ ${diff} day${diff!==1?"s":""} left`}</div>;
        })()}
      </Fld>
      <Fld label="Revision No." hint="e.g. Rev 3 — lock this before handoff to Ops"><Inp value={v.revisionNo||""} onChange={e=>setF({revisionNo:e.target.value})} placeholder="e.g. Rev 3"/></Fld>
      <Fld label="File / Link (Google Drive, Figma, etc.)"><Inp type="url" value={v.link||""} onChange={e=>setF({link:e.target.value})} placeholder="https://drive.google.com/…"/></Fld>
      {/* ── Revision Log ─────────────────────────────── */}
      <div style={{gridColumn:"1/-1"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
          <div style={{fontSize:".68rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px"}}>📑 Revision Log</div>
          <button onClick={()=>{
            if(!v.revisionNo&&!v.link){toastEmit("⚠ Set a Revision No. and file link before logging a revision.","warning");return;}
            const rev={no:v.revisionNo||`Rev ${(d.revisions||[]).length+1}`,link:v.link||"",date:today,by:session?.name||"Design",status:d.status||""};
            // Commit any unsaved edits (revisionNo/link) alongside the new log entry.
            upProj(selProj,p=>({...p,design:{...p.design,...draft,revisions:[...(p.design?.revisions||[]),rev]}}));setDraft({});
            toastEmit(`📑 Logged ${rev.no}`,"success");
          }} style={{background:"#f5f3ff",border:"1.5px solid #ddd6fe",borderRadius:8,padding:"5px 12px",fontFamily:"inherit",fontSize:".73rem",color:"#6d28d9",cursor:"pointer",fontWeight:700}}>+ Log current revision</button>
        </div>
        {(d.revisions||[]).length===0
          ? <div style={{fontSize:".74rem",color:"#94a3b8",fontStyle:"italic",padding:"4px 0"}}>No revisions logged yet — set the Revision No. + file link above, then log it to keep an iteration history.</div>
          : <div style={{border:"1px solid #eef2f7",borderRadius:10,overflow:"hidden"}}>
              {[...d.revisions].reverse().map((r,i,arr)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",borderBottom:i<arr.length-1?"1px solid #f8fafc":"none",background:i===0?"#faf5ff":"#fff"}}>
                  <span style={{fontWeight:700,color:"#6d28d9",fontSize:".78rem",minWidth:60}}>{r.no}</span>
                  <span style={{fontSize:".72rem",color:"#94a3b8"}}>{r.date}{r.by?` · ${r.by}`:""}{r.status?` · ${r.status}`:""}</span>
                  {r.link&&<a href={r.link} target="_blank" rel="noreferrer" style={{marginLeft:"auto",fontSize:".73rem",color:"#3b82f6",fontWeight:600,textDecoration:"none"}}>📂 View</a>}
                  <button onClick={async()=>{if(await uiConfirm(`Remove ${r.no} from the log?`)){const idx=d.revisions.length-1-i;setD({revisions:d.revisions.filter((_,j)=>j!==idx)});}}} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".75rem",marginLeft:r.link?8:"auto"}} title="Remove">✕</button>
                </div>
              ))}
            </div>
        }
      </div>
      <Fld label="Notes"><Inp rows={2} value={v.notes||""} onChange={e=>setF({notes:e.target.value})}/></Fld>
      {/* ── Approval Stamp ───────────────────────────── */}
      <div style={{marginTop:16,background:hasApproval?"#f0fdf4":"#fffbeb",border:`1.5px solid ${hasApproval?"#bbf7d0":"#fde68a"}`,borderRadius:12,padding:"14px 16px"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,flexWrap:"wrap",marginBottom:10}}>
          <div style={{fontSize:".68rem",fontWeight:700,color:hasApproval?"#15803d":"#92400e",textTransform:"uppercase",letterSpacing:".8px"}}>{hasApproval?"✅ Approved — Locked for Handoff":"⏳ Pending Approval"}</div>
          {dueOverdue&&<span style={{fontSize:".68rem",fontWeight:700,color:"#dc2626"}}>⚠ Past due — not yet approved</span>}
        </div>
        {hasApproval&&(
          <div style={{display:"flex",gap:16,alignItems:"center",marginBottom:10,flexWrap:"wrap"}}>
            <div style={{background:"#dcfce7",border:"1.5px solid #86efac",borderRadius:10,padding:"8px 14px",display:"inline-flex",gap:10,alignItems:"center"}}>
              <span style={{fontSize:"1.2rem"}}>🔏</span>
              <div><div style={{fontWeight:800,color:"#15803d",fontSize:".85rem"}}>{v.revisionNo||"Rev —"}</div><div style={{fontSize:".72rem",color:"#166534"}}>Approved by {v.approvedBy} · {v.approvedOn}</div></div>
            </div>
            {v.link&&<a href={v.link} target="_blank" rel="noreferrer" style={{fontSize:".78rem",color:"#15803d",fontWeight:600}}>📂 View Drawings</a>}
          </div>
        )}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <Fld label="Approved by"><Sel value={v.approvedBy||""} onChange={e=>setF({approvedBy:e.target.value})}><option value="">— Select approver —</option>{[...DESIGN_MEMBERS,...SALES_TEAM,...OPS_TEAM].filter((val,i,a)=>a.indexOf(val)===i).map(m=><option key={m}>{m}</option>)}</Sel></Fld>
          <Fld label="Approved on"><Inp type="date" value={v.approvedOn||""} onChange={e=>setF({approvedOn:e.target.value})}/></Fld>
        </div>
        {!hasApproval&&<div style={{fontSize:".72rem",color:"#92400e",marginTop:6}}>Fill in both fields above to lock this revision for handoff to Operations.</div>}
      </div>
      {/* ── Client-facing Approval ───────────────────── */}
      <div style={{marginTop:16,background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap",marginBottom:10}}>
          <div style={{fontSize:".68rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px"}}>🤝 Client Approval</div>
          <span style={{fontSize:".7rem",fontWeight:700,color:CS_CLR[cs],background:CS_CLR[cs]+"18",border:`1px solid ${CS_CLR[cs]}44`,borderRadius:20,padding:"2px 10px"}}>{cs}</span>
        </div>
        <Fld label="Client Review Link" hint="Shareable drawings / presentation link to send the client for sign-off">
          <div style={{display:"flex",gap:8}}>
            <Inp type="url" value={v.clientReviewLink||""} onChange={e=>setF({clientReviewLink:e.target.value})} placeholder="https://drive.google.com/…"/>
            {v.clientReviewLink&&<a href={v.clientReviewLink} target="_blank" rel="noreferrer" style={{flexShrink:0,background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:8,padding:"8px 12px",fontSize:".75rem",color:"#1d4ed8",fontWeight:700,textDecoration:"none",alignSelf:"center"}}>Open ↗</a>}
          </div>
        </Fld>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:10}}>
          <Fld label="Review Status"><Sel value={cs} onChange={e=>{const val=e.target.value;const patch={clientStatus:val};if(val==="Client Approved"&&!v.clientSignoffDate)patch.clientSignoffDate=today;setF(patch);}}>{["Not Sent","Sent for Review","Client Approved","Client Revisions"].map(s=><option key={s}>{s}</option>)}</Sel></Fld>
          <Fld label="Client Sign-off (name)"><Inp value={v.clientSignoffName||""} onChange={e=>setF({clientSignoffName:e.target.value})} placeholder="Client contact who approved"/></Fld>
          <Fld label="Sign-off Date"><Inp type="date" value={v.clientSignoffDate||""} onChange={e=>setF({clientSignoffDate:e.target.value})}/></Fld>
          <Fld label="Client Feedback"><Inp value={v.clientFeedback||""} onChange={e=>setF({clientFeedback:e.target.value})} placeholder="Revisions requested, comments…"/></Fld>
        </div>
        {cs==="Client Approved"&&v.clientSignoffName&&(
          <div style={{marginTop:10,background:"#dcfce7",border:"1.5px solid #86efac",borderRadius:10,padding:"8px 14px",display:"inline-flex",gap:10,alignItems:"center"}}>
            <span style={{fontSize:"1.1rem"}}>✅</span>
            <div style={{fontSize:".76rem",color:"#166534",fontWeight:600}}>Client approved by {v.clientSignoffName}{v.clientSignoffDate?` · ${v.clientSignoffDate}`:""}</div>
          </div>
        )}
      </div>
      {/* ── Activity / Comments ──────────────────────── */}
      <div style={{marginTop:16}}>
        <div style={{fontSize:".68rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>💬 Activity</div>
        <div style={{display:"flex",gap:8,marginBottom:10}}>
          <Inp value={commentText} onChange={e=>setCommentText(e.target.value)} placeholder="Add a note or update for the team…" onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();postComment();}}}/>
          <button onClick={postComment} disabled={!commentText.trim()} style={{flexShrink:0,background:commentText.trim()?"#7c3aed":"#e2e8f0",border:"none",borderRadius:8,padding:"0 16px",color:commentText.trim()?"#fff":"#94a3b8",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:commentText.trim()?"pointer":"not-allowed"}}>Post</button>
        </div>
        {(d.comments||[]).length===0
          ? <div style={{fontSize:".74rem",color:"#94a3b8",fontStyle:"italic"}}>No activity yet — post the first note.</div>
          : <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {[...d.comments].reverse().map((cm,i,arr)=>{
                const idx=d.comments.length-1-i;
                return(
                  <div key={idx} style={{background:"#f8fafc",border:"1px solid #eef2f7",borderRadius:10,padding:"8px 12px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                      <span style={{fontWeight:700,color:"#334155",fontSize:".76rem"}}>{cm.by}</span>
                      <span style={{fontSize:".68rem",color:"#94a3b8"}}>{cm.at?new Date(cm.at).toLocaleString():""}</span>
                      {cm.by===session?.name&&<button onClick={()=>setD({comments:d.comments.filter((_,j)=>j!==idx)})} style={{marginLeft:"auto",background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".72rem"}} title="Remove">✕</button>}
                    </div>
                    <div style={{fontSize:".8rem",color:"#475569",whiteSpace:"pre-wrap"}}><Linkify text={cm.text}/></div>
                  </div>
                );
              })}
            </div>
        }
      </div>
      {/* ── Save bar ─────────────────────────────────────
          Typed fields (dates, links, notes, approvals) buffer locally and commit
          here. Status changes, blockers, deliverables and comments still save on
          click, so the bar only lights up for the fields it owns. */}
      <div style={{position:"sticky",bottom:0,marginTop:16,paddingTop:12,background:"#fff",borderTop:"1px solid #eef2f7",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
        <div style={{flex:1,minWidth:120,fontSize:".74rem",fontWeight:700,color:dirty?"#b45309":"#94a3b8"}}>{dirty?"● Unsaved changes":"✓ All changes saved"}</div>
        {dirty&&<button onClick={discardDraft} style={{background:"#f1f5f9",border:"none",borderRadius:9,padding:"9px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#475569",cursor:"pointer"}}>Discard</button>}
        <button onClick={saveDraft} disabled={!dirty} style={{background:dirty?"#7c3aed":"#e2e8f0",border:"none",borderRadius:9,padding:"9px 24px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:dirty?"#fff":"#94a3b8",cursor:dirty?"pointer":"not-allowed"}}>💾 Save</button>
        <button onClick={closeModal} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#475569",cursor:"pointer"}}>Close</button>
      </div>
    </Modal>
  );
}

function SetPriceModal({deal,today,onClose,onSave}){
  const[val,setVal]=React.useState(deal?.value||"");
  const[note,setNote]=React.useState("");
  const ok=Number(val)>0;
  const mob=window.innerWidth<768;
  return(
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(15,23,42,.65)",zIndex:900,display:"flex",alignItems:mob?"flex-end":"center",justifyContent:"center",padding:mob?0:20}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:mob?"18px 18px 0 0":16,width:"100%",maxWidth:mob?undefined:420,padding:"24px 24px 28px",boxShadow:"0 24px 64px rgba(0,0,0,.25)",maxHeight:"92vh",overflowY:"auto"}}>
        <div style={{fontWeight:800,color:"#4f46e5",fontSize:"1.05rem",marginBottom:4}}>₱ Set Client Submission Price</div>
        <div style={{fontSize:".78rem",color:"#64748b",marginBottom:18}}>
          <span style={{fontWeight:700,color:"#0f172a"}}>{deal?.client}</span>{deal?.ceNo?" · "+deal.ceNo:""}
          <div style={{marginTop:3}}>This is the amount being quoted to the client.</div>
        </div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:".72rem",fontWeight:700,color:"#475569",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>Contract / Proposal Amount (₱) *</div>
          <input type="number" value={val} onChange={e=>setVal(e.target.value)} placeholder="e.g. 1250000"
            style={{width:"100%",border:"1.5px solid #6366f1",borderRadius:9,padding:"10px 14px",fontFamily:"inherit",fontSize:"1rem",fontWeight:700,color:"#0f172a",outline:"none",boxSizing:"border-box"}}
            autoFocus/>
          {val&&Number(val)>0&&<div style={{fontSize:".78rem",color:"#6366f1",fontWeight:700,marginTop:4}}>₱{Number(val).toLocaleString("en-PH",{maximumFractionDigits:0})}</div>}
        </div>
        <div style={{marginBottom:18}}>
          <div style={{fontSize:".72rem",fontWeight:700,color:"#475569",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>Costing Notes (optional)</div>
          <textarea value={note} onChange={e=>setNote(e.target.value)} placeholder="e.g. Based on cost study dated today. Includes 30% markup." rows={3}
            style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 14px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>
        </div>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{background:"#f1f5f9",border:"none",borderRadius:9,padding:"9px 20px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#475569",cursor:"pointer"}}>Cancel</button>
          <button disabled={!ok} onClick={()=>onSave(Number(val),note)} style={{background:ok?"#4f46e5":"#e2e8f0",border:"none",borderRadius:9,padding:"9px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:ok?"#fff":"#94a3b8",cursor:ok?"pointer":"default"}}>Save Price →</button>
        </div>
      </div>
    </div>
  );
}

function AwardReqModal({deal,session,today,onClose,onSubmit}){
  const[form,setForm]=React.useState({
    awardTrigger:deal?.awardRequestData?.awardTrigger||"CE Signed by Client",
    triggerDate:deal?.awardRequestData?.triggerDate||today,
    triggerNote:deal?.awardRequestData?.triggerNote||"",
    aeAssigned:deal?.awardRequestData?.aeAssigned||deal?.salesOwner||"",
    pm1Suggestion:deal?.awardRequestData?.pm1Suggestion||"",
    scopeNotes:deal?.awardRequestData?.scopeNotes||"",
    specialInstructions:deal?.awardRequestData?.specialInstructions||"",
  });
  const[step,setStep]=React.useState(1);
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const mob=window.innerWidth<768;
  if(!deal) return null;
  return(
    <Modal open title={`🏆 Request Award — ${deal.client}`} onClose={onClose} wide>
      <div style={{display:"flex",gap:0,marginBottom:22,borderRadius:10,overflow:"hidden",border:"1.5px solid #e2e8f0"}}>
        {[["1","Award Details","#f59e0b"],["2","Scope & Team","#10b981"]].map(([num,label,clr],i)=>{
          const active=step===i+1; const done=step>i+1;
          return(<div key={num} onClick={()=>done&&setStep(i+1)} style={{flex:1,padding:"12px 8px",textAlign:"center",background:active?clr:done?"#f8fafc":"#fff",cursor:done?"pointer":"default",borderRight:i<1?"1px solid #e2e8f0":"none"}}>
            <div style={{fontSize:".82rem",fontWeight:700,color:active?"#fff":done?"#374151":"#cbd5e1"}}>{num}. {label}</div>
            <div style={{fontSize:".68rem",color:active?"rgba(255,255,255,.75)":done?"#10b981":"#e2e8f0",marginTop:2}}>{done?"✓ Done":active?"In progress":"—"}</div>
          </div>);
        })}
      </div>
      <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"10px 16px",marginBottom:18,display:"flex",gap:20,flexWrap:"wrap",fontSize:".82rem"}}>
        <span><span style={{color:"#92400e"}}>Client: </span><strong>{deal.client}</strong></span>
        {deal.contact&&<span><span style={{color:"#92400e"}}>Project: </span><strong>{deal.contact}</strong></span>}
        {deal.ceNo&&<span><span style={{color:"#92400e"}}>CE No: </span><strong>{deal.ceNo}</strong></span>}
        {deal.value&&<span><span style={{color:"#92400e"}}>Value: </span><strong>₱{Number(deal.value).toLocaleString("en-PH")}</strong></span>}
      </div>
      {step===1&&(<div>
        <div style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:10,padding:"10px 14px",marginBottom:18,fontSize:".8rem",color:"#1d4ed8"}}>
          📋 Fill in what confirmed this award. Your information will be pre-loaded for Paulo when he approves.
        </div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
          <Fld label="Award Trigger" required hint="What officially confirmed this project?">
            <Sel value={form.awardTrigger} onChange={e=>f("awardTrigger",e.target.value)}>
              {["CE Signed by Client","Purchase Order Received","Downpayment Received","Verbal Confirmation (to be followed by written)","Letter of Intent Received"].map(t=><option key={t}>{t}</option>)}
            </Sel>
          </Fld>
          <Fld label="Date Confirmed"><Inp type="date" value={form.triggerDate} onChange={e=>f("triggerDate",e.target.value)}/></Fld>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Reference / Notes" hint="PO number, email thread, verbal confirmation details, etc.">
              <Inp rows={2} value={form.triggerNote} onChange={e=>f("triggerNote",e.target.value)} placeholder="e.g. PO No. 2026-0187 received via email from Karen Santos on May 25…"/>
            </Fld>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:18}}>
          <button onClick={()=>setStep(2)} style={{background:"#f59e0b",border:"none",borderRadius:10,padding:"11px 28px",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>Next: Scope & Team →</button>
        </div>
      </div>)}
      {step===2&&(<div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
          <Fld label="AE (Account Executive)" hint="Client relationship owner — usually you">
            <Sel value={form.aeAssigned} onChange={e=>f("aeAssigned",e.target.value)}>
              <option value="">— Select AE —</option>
              {SALES_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <Fld label="Suggested PM" hint="Optional — Paulo will assign the PM but your input helps">
            <Sel value={form.pm1Suggestion} onChange={e=>f("pm1Suggestion",e.target.value)}>
              <option value="">— Optional suggestion —</option>
              {OPS_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Scope of Work" required hint="What exactly is being built? Be as specific as possible.">
              <Inp rows={4} value={form.scopeNotes} onChange={e=>f("scopeNotes",e.target.value)} placeholder="e.g. Full retail fit-out Unit 3B SM Megamall — custom shelving, signage (2 lightboxes + letters), 4 display gondolas, 8 downlights…"/>
            </Fld>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Special Instructions / Venue Requirements" hint="Delivery restrictions, permit requirements, client contacts on site">
              <Inp rows={3} value={form.specialInstructions} onChange={e=>f("specialInstructions",e.target.value)} placeholder="e.g. SM Megamall: night delivery only 10PM–6AM, GS permit required. Client contact on site: Kat Santos +63917…"/>
            </Fld>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:18}}>
          <button onClick={()=>setStep(1)} style={{background:"#f1f5f9",border:"none",borderRadius:10,padding:"10px 20px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#475569",cursor:"pointer"}}>← Back</button>
          <button disabled={!form.scopeNotes} onClick={()=>onSubmit(form)}
            style={{background:form.scopeNotes?"#059669":"#e2e8f0",border:"none",borderRadius:10,padding:"12px 28px",fontFamily:"inherit",fontWeight:800,fontSize:".9rem",color:form.scopeNotes?"#fff":"#94a3b8",cursor:form.scopeNotes?"pointer":"not-allowed",letterSpacing:".3px"}}>
            🏆 Submit for Manager Approval
          </button>
        </div>
      </div>)}
    </Modal>
  );
}
// Milestone Builder (replaces the Payment Terms modal + "Set Up Billing
// Milestones"). One screen, nothing pre-filled: staff type each milestone as a
// name and a % of the contract. Saving is blocked until the rows total exactly
// 100%, every row has a name, each retention row has a release condition and
// the payment due period is chosen. The amounts come from
// buildMilestoneSchedule (centavo rounding, last row takes the remainder).
function MilestoneBuilder({deal,contractVal,schedCtx,onClose,onCreate}){
  const val=Number(contractVal)||0;
  const blank=()=>({key:uid(),name:"",pct:"",type:"",retention:false,release:"",plannedDate:"",dateTouched:false});
  const[rows,setRows]=useState(()=>[blank(),blank()]);
  const[netDays,setNetDays]=useState("");
  const[notes,setNotes]=useState("");
  const[saving,setSaving]=useState(false);
  const sch=buildMilestoneSchedule(val,rows);
  const problems=[...sch.problems,...(netDays===""?[{kind:"net",msg:"Choose when payment is due after each invoice."}]:[])];
  const ok=problems.length===0&&val>0;
  // Type or release changes re-derive the default "Bill on" date from the
  // project schedule, unless staff typed their own date for that row.
  const withDefaults=rs=>{const seen={};return rs.map(r=>{const nth=seen[r.type]||0;seen[r.type]=nth+1;if(r.dateTouched||!r.type)return r;return{...r,plannedDate:defaultBillDate(r.type,nth,schedCtx,r.release).date};});};
  const upd=(key,ch)=>setRows(rs=>withDefaults(rs.map(r=>r.key===key?{...r,...ch}:r)));
  const hintFor=(r,i)=>{if(!r.type)return"";const nth=rows.slice(0,i).filter(x=>x.type===r.type).length;const d=defaultBillDate(r.type,nth,schedCtx,r.release);return r.dateTouched?"set by hand":d.source;};
  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
  const first=problems[0];
  const tone=!first?{bg:"#ecfdf5",bd:"#a7f3d0",tx:"#047857"}:first.kind==="over"?{bg:"#fef2f2",bd:"#fecaca",tx:"#b91c1c"}:first.kind==="empty"?{bg:"#eff6ff",bd:"#bfdbfe",tx:"#1d4ed8"}:{bg:"#fffbeb",bd:"#fde68a",tx:"#92400e"};
  const pctTotal=sch.pctTotal;
  const meterClr=pctTotal===100?"#059669":pctTotal>100?"#ef4444":"#f59e0b";
  const inp={border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",background:"#fff",width:"100%",boxSizing:"border-box"};
  const cols="minmax(150px,1.4fr) 124px 76px minmax(112px,1fr) 136px 30px";
  const save=async()=>{
    if(!ok||saving) return;
    setSaving(true);
    try{ await onCreate(sch.active,Number(netDays),notes.trim()); }
    finally{ setSaving(false); }
  };
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div role="dialog" aria-modal="true" aria-label="Set up billing milestones" style={{background:"#fff",borderRadius:18,padding:24,width:"100%",maxWidth:720,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 24px 64px rgba(0,0,0,.25)"}}>
        <div style={{display:"flex",justifyContent:"space-between",gap:10,alignItems:"flex-start",marginBottom:4}}>
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.35rem",color:"#0f172a"}}>Set Up Billing Milestones</div>
            <div style={{fontSize:".76rem",color:"#64748b"}}>{deal?.client||""}{deal?.contact?` · ${deal.contact}`:""}{deal?.ceNo?` · ${deal.ceNo}`:""}{deal?.parentDealId?" · Addendum":""}</div>
          </div>
          <button onClick={onClose} aria-label="Close" style={{background:"#f8fafc",border:"none",borderRadius:8,width:30,height:30,cursor:"pointer",color:"#94a3b8"}}>✕</button>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",margin:"12px 0 16px"}}>
          {[["Contract (VAT-ex)",peso(val)],["Receipt",deal?.receiptType||"OR"],["Withholding",deal?.withholding?"2% EWT":"None"]].map(([l,v])=>(
            <div key={l} style={{background:"#f8fafc",borderRadius:9,padding:"6px 11px"}}>
              <div style={{fontSize:".56rem",textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",fontWeight:700}}>{l}</div>
              <div style={{fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,fontSize:".86rem",color:"#0f172a"}}>{v}</div>
            </div>
          ))}
        </div>
        <div style={{overflowX:"auto"}}>
          <div style={{minWidth:700,display:"grid",gap:8}}>
            <div style={{display:"grid",gridTemplateColumns:cols,gap:8,fontSize:".6rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".08em"}}>
              <div>Milestone name</div><div>Type</div><div style={{textAlign:"right"}}>%</div><div style={{textAlign:"right"}}>Amount (VAT-ex)</div><div>Bill on</div><div/>
            </div>
            {rows.map((r,i)=>{
              const p=Number(r.pct)||0;
              const missName=p>0&&!String(r.name).trim();
              return(
                <React.Fragment key={r.key}>
                  <div style={{display:"grid",gridTemplateColumns:cols,gap:8,alignItems:"center"}}>
                    <input id={`msb-name-${r.key}`} aria-label="Milestone name" value={r.name} placeholder="e.g. Down Payment" onChange={e=>upd(r.key,{name:e.target.value})} style={{...inp,borderColor:missName?"#fecaca":"#e2e8f0",background:missName?"#fef2f2":"#fff"}}/>
                    <select aria-label="Milestone type" value={r.type} onChange={e=>upd(r.key,{type:e.target.value,retention:e.target.value==="Retention",release:e.target.value==="Retention"?r.release:""})} style={{...inp,padding:"8px 6px",borderColor:p>0&&!r.type?"#fecaca":"#e2e8f0",background:p>0&&!r.type?"#fef2f2":"#fff"}}>
                      <option value="">Type…</option>
                      {MILESTONE_TYPES.map(t=><option key={t}>{t}</option>)}
                    </select>
                    <input id={`msb-pct-${r.key}`} aria-label="Percent of contract" type="number" min={0} max={100} step="0.01" value={r.pct} placeholder="%" onChange={e=>upd(r.key,{pct:e.target.value})} style={{...inp,textAlign:"right",fontFamily:"'IBM Plex Mono',monospace"}}/>
                    <div style={{textAlign:"right",fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,fontSize:".84rem",color:p>0?"#0f172a":"#cbd5e1"}}>
                      {p>0?peso(sch.amounts[i]):"—"}
                      {sch.adjusted===i&&<div style={{fontSize:".6rem",fontWeight:500,color:"#94a3b8"}}>+ leftover centavo</div>}
                    </div>
                    <div>
                      <input aria-label="Bill on" type="date" value={r.plannedDate||""} onChange={e=>upd(r.key,{plannedDate:e.target.value,dateTouched:!!e.target.value})} style={{...inp,padding:"7px 6px",fontSize:".78rem"}}/>
                      {r.type&&<div style={{fontSize:".58rem",color:r.plannedDate?"#94a3b8":"#d97706",marginTop:2,lineHeight:1.2}}>{hintFor(r,i)}</div>}
                    </div>
                    <button type="button" aria-label="Remove row" onClick={()=>setRows(rs=>rs.length>1?rs.filter(x=>x.key!==r.key):[blank()])} style={{width:30,height:30,borderRadius:7,border:"1px solid #e2e8f0",background:"#fff",color:"#94a3b8",cursor:"pointer"}}>✕</button>
                  </div>
                  {r.type==="Retention"&&(
                    <div style={{display:"flex",gap:8,alignItems:"center",background:"#f5f3ff",border:"1px solid #ddd6fe",borderRadius:8,padding:"6px 10px",fontSize:".74rem",color:"#6d28d9"}}>
                      <span>Released when</span>
                      <select aria-label="Retention release condition" value={r.release} onChange={e=>upd(r.key,{release:e.target.value})} style={{...inp,width:"auto",padding:"5px 8px",fontSize:".76rem"}}>
                        <option value="">Choose…</option>
                        {RETENTION_RELEASE_OPTIONS.map(o=><option key={o}>{o}</option>)}
                      </select>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
            <div style={{display:"grid",gridTemplateColumns:cols,gap:8,alignItems:"center",borderTop:"1.5px solid #e2e8f0",paddingTop:10}}>
              <div style={{fontWeight:800,fontSize:".8rem"}}>Total</div>
              <div/>
              <div style={{textAlign:"right",fontFamily:"'IBM Plex Mono',monospace",fontWeight:800}}>{pctTotal}%</div>
              <div style={{textAlign:"right",fontFamily:"'IBM Plex Mono',monospace",fontWeight:800}}>{peso(sch.amountTotal)}</div>
              <div style={{gridColumn:"5 / 7",height:8,borderRadius:99,background:"#f1f5f9",overflow:"hidden"}}><div style={{height:"100%",width:`${Math.min(100,Math.max(0,pctTotal))}%`,background:meterClr,borderRadius:99}}/></div>
            </div>
          </div>
        </div>
        <button type="button" onClick={()=>setRows(rs=>[...rs,blank()])} style={{marginTop:10,background:"none",border:"1.5px dashed #e2e8f0",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",fontWeight:600,color:"#475569",cursor:"pointer"}}>+ Add milestone</button>
        <div role="status" style={{marginTop:14,background:tone.bg,border:`1.5px solid ${tone.bd}`,color:tone.tx,borderRadius:10,padding:"9px 12px",fontSize:".78rem",fontWeight:600}}>
          {val<=0?"This project has no contract value. Set it before building the schedule.":first?first.msg:`Schedule adds up to 100% — ${peso(sch.amountTotal)}, exactly the contract value.`}
        </div>
        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<600?"1fr":"220px 1fr",gap:12,marginTop:14}}>
          <div>
            <div style={{fontSize:".7rem",fontWeight:700,color:"#475569",marginBottom:4}}>Payment due after invoice</div>
            <select aria-label="Payment due after invoice" value={netDays} onChange={e=>setNetDays(e.target.value)} style={inp}>
              <option value="">Choose…</option>
              {NET_DAY_OPTIONS.map(o=><option key={o.days} value={o.days}>{o.label}</option>)}
            </select>
          </div>
          <div>
            <div style={{fontSize:".7rem",fontWeight:700,color:"#475569",marginBottom:4}}>Notes / special conditions (optional)</div>
            <input aria-label="Notes" value={notes} onChange={e=>setNotes(e.target.value)} placeholder="e.g. PDC on DP, retention waived per client" style={inp}/>
          </div>
        </div>
        <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:10}}>Milestones are created as Drafts with the next free invoice numbers. "Bill on" is when the invoice should go out — a Draft still unsent 3 days after it shows in Billing Check. The payment due date is set when the invoice is marked sent.</div>
        {(()=>{const missing=sch.active.filter(r=>!r.plannedDate).length;return missing>0&&<div style={{fontSize:".72rem",color:"#b45309",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"6px 10px",marginTop:8}}>{missing} milestone{missing===1?" has":"s have"} no "Bill on" date. You can still save; fill the project schedule dates (or type a date) so nobody forgets to bill {missing===1?"it":"them"}.</div>;})()}
        <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
          <button onClick={onClose} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"10px 20px",fontFamily:"inherit",fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          <button onClick={save} disabled={!ok||saving} style={{background:ok&&!saving?"#0f172a":"#e2e8f0",border:"none",borderRadius:10,padding:"10px 24px",fontFamily:"inherit",fontSize:".84rem",fontWeight:700,color:ok&&!saving?"#fff":"#94a3b8",cursor:ok&&!saving?"pointer":"not-allowed"}}>{saving?"Creating…":"Create milestones"}</button>
        </div>
      </div>
    </div>
  );
}
function AwardModal({deal,session,today,onClose,onConfirm,drfs}){
  const req=deal?.awardRequestData||{};
  const drf=(drfs||[]).filter(d=>d.dealId===deal?.id||(d.client&&d.client===deal?.client)).sort((a,b)=>new Date(b.createdAt||0)-new Date(a.createdAt||0))[0]||{};
  const[form,setForm]=React.useState({
    // Must match one of the <Sel> options below exactly — this previously
    // defaulted to "CE Signed" (no "by Client"), which matches none of them.
    // React then shows the first option in the dropdown while form.awardTrigger
    // silently holds the mismatched string, so any Manager who awards a deal
    // directly (no prior award request) without touching this field saves a
    // bogus, non-standard trigger value onto the Job Order.
    awardTrigger:req.awardTrigger||"CE Signed by Client",
    triggerDate:req.triggerDate||today,
    triggerNote:req.triggerNote||"",
    pm1:req.pm1Suggestion||"",pm2:"",pm3:"",coordinator:"",
    aeAssigned:req.aeAssigned||deal?.salesOwner||"",
    startDate:today,commsLink:deal?.commsGroup||"",
    scopeNotes:req.scopeNotes||"",
    specialInstructions:req.specialInstructions||"",
    designer:req.designer||drf.designer||"",
    location:deal?.location||"",
    // Payment terms are no longer captured here — they are set in Billing via
    // the Milestone Builder ("Set Up Billing Milestones"). Awarding always
    // defers the schedule to Finance.
  });
  const[step,setStep]=React.useState(1);
  const[submitting,setSubmitting]=React.useState(false);
  // confirmAward is async (awaits claimDocNumber for the JO, project card and
  // budget creation) — an unguarded double-click on either final button below
  // could fire it twice and create duplicate JOs/project cards/billing.
  const confirmOnce=(payload)=>{ if(submitting) return; setSubmitting(true); onConfirm(payload); };
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const mob=window.innerWidth<768;
  if(!deal) return null;
  return(
    <Modal open title={`🏆 Award — ${deal.client}`} onClose={onClose} wide>
      <div style={{display:"flex",gap:0,marginBottom:22,borderRadius:10,overflow:"hidden",border:"1.5px solid #e2e8f0"}}>
        {[["1","Confirm Award","#10b981",step>=1],["2","Job Order","#3b82f6",step>=2]].map(([num,label,clr,active],i)=>(
          <div key={num} onClick={()=>step>i+1&&setStep(i+1)} style={{flex:1,padding:"12px 8px",textAlign:"center",background:step===i+1?clr:active?"#f8fafc":"#fff",cursor:step>i+1?"pointer":"default",borderRight:i<1?"1px solid #e2e8f0":"none"}}>
            <div style={{fontSize:".82rem",fontWeight:700,color:step===i+1?"#fff":active?"#374151":"#cbd5e1"}}>{num}. {label}</div>
            <div style={{fontSize:".68rem",color:step===i+1?"rgba(255,255,255,.75)":step>i+1?"#10b981":"#e2e8f0",marginTop:2}}>{step>i+1?"✓ Done":step===i+1?"In progress":"—"}</div>
          </div>
        ))}
      </div>
      {step===1&&(<div>
        <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:12,padding:"14px 18px",marginBottom:20}}>
          <div style={{fontWeight:700,color:"#059669",marginBottom:8,fontSize:".9rem"}}>Confirming this award will:</div>
          <div style={{fontSize:".82rem",color:"#065f46",lineHeight:2}}>
            ✓ Move to <strong>Stage 06 · Kickoff</strong><br/>
            ✓ Issue a <strong>Job Order</strong> to all departments<br/>
            ✓ Create a <strong>Project Card</strong> — all depts start their task checklists<br/>
            ✓ Notify <strong>Finance</strong> to set up billing milestones<br/>
            ✓ Flag <strong>QS</strong> to set the budget target in Cost Analysis
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
          <Fld label="Award Trigger" required hint="What officially confirmed this project?">
            <Sel value={form.awardTrigger} onChange={e=>f("awardTrigger",e.target.value)}>
              {["CE Signed by Client","Purchase Order Received","Downpayment Received","Verbal Confirmation (to be followed by written)","Letter of Intent Received"].map(t=><option key={t}>{t}</option>)}
            </Sel>
          </Fld>
          <Fld label="Date Confirmed"><Inp type="date" value={form.triggerDate} onChange={e=>f("triggerDate",e.target.value)}/></Fld>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Notes" hint="PO number, email confirmation details, etc. (optional)">
              <Inp rows={2} value={form.triggerNote} onChange={e=>f("triggerNote",e.target.value)} placeholder="e.g. PO No. 2026-0187 received via email from client@email.com on May 18…"/>
            </Fld>
          </div>
        </div>
        <div style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:10,padding:"10px 14px",marginTop:14,fontSize:".8rem",color:"#1d4ed8"}}>
          💳 <strong>Payment status will be set to Unpaid.</strong> Finance will receive a notification to set up billing milestones and track collections.
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:18}}>
          <button onClick={()=>setStep(2)} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"11px 28px",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>Next: Job Order →</button>
        </div>
      </div>)}
      {step===2&&(<div>
        <div style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:12,padding:"12px 16px",marginBottom:18,fontSize:".82rem",color:"#1d4ed8"}}>
          📋 This Job Order is the official start signal. Once issued, every department sees a new project in their queue. <strong> QS (Rodney) will set the budget target separately in Cost Analysis.</strong>
        </div>
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
          <Fld label="Project Manager 1" hint="Optional — OM/GM assigns PM in Project Cards after award">
            <Sel value={form.pm1} onChange={e=>f("pm1",e.target.value)}>
              <option value="">— Assign later in Project Cards —</option>
              {OPS_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <Fld label="Project Manager 2" hint="For large scope — second PM">
            <Sel value={form.pm2} onChange={e=>f("pm2",e.target.value)}>
              <option value="">— Optional —</option>
              {OPS_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <Fld label="Coordinator" hint="Handles logistics, permits, site coordination">
            <Sel value={form.coordinator} onChange={e=>f("coordinator",e.target.value)}>
              <option value="">— Optional —</option>
              {OPS_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <Fld label="PM 3 / Support" hint="Additional PM for complex multi-site projects">
            <Sel value={form.pm3} onChange={e=>f("pm3",e.target.value)}>
              <option value="">— Optional —</option>
              {OPS_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <Fld label="Account Executive (AE)" hint="Client relationship owner — pre-filled from deal, change if needed">
            <Sel value={form.aeAssigned} onChange={e=>f("aeAssigned",e.target.value)}>
              <option value="">— Assign AE —</option>
              {SALES_TEAM.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
          <Fld label="Target Turnover Date" hint="When do we hand over the project to the client?">
            <Inp type="date" value={form.startDate} onChange={e=>f("startDate",e.target.value)}/>
            {form.startDate&&form.startDate<today&&<div style={{fontSize:".7rem",color:"#f59e0b",marginTop:3,fontWeight:600}}>⚠ Date is in the past — please confirm this is correct.</div>}
          </Fld>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Comms Group Link" hint="WhatsApp or Viber group — add all stakeholders">
              <Inp value={form.commsLink} onChange={e=>f("commsLink",e.target.value)} placeholder="https://chat.whatsapp.com/…"/>
            </Fld>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Scope of Work" required hint="Sales + PM align on this together — what exactly is being built?">
              <Inp rows={4} value={form.scopeNotes} onChange={e=>f("scopeNotes",e.target.value)} placeholder="e.g. Full retail fit-out Unit 3B SM Megamall — custom shelving, signage (2 lightboxes + letters), 4 display gondolas, electrical (8 downlights, 2 track lights)"/>
            </Fld>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Special Instructions / Venue Requirements" hint="Delivery restrictions, permit requirements, mall rules, client preferences">
              <Inp rows={3} value={form.specialInstructions} onChange={e=>f("specialInstructions",e.target.value)} placeholder="e.g. SM Megamall: night delivery only 10PM-6AM, GS permit required 2 weeks before. Client contact on site: Kat Santos +63917-xxx-xxxx"/>
            </Fld>
            <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:4,fontStyle:"italic"}}>💡 Venue Memory (SM, Ayala, Robinsons requirements) — coming in a future update</div>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Project Location" hint="Full venue / address — will appear in JO and notifications">
              <Inp value={form.location||""} onChange={e=>f("location",e.target.value)} placeholder="e.g. SM North EDSA – 3F Activity Area, Quezon City"/>
            </Fld>
          </div>
          <Fld label="Assigned Designer" hint="Design team member handling this project">
            <Sel value={form.designer||""} onChange={e=>f("designer",e.target.value)}>
              <option value="">— Assign later —</option>
              {DESIGN_MEMBERS.map(m=><option key={m}>{m}</option>)}
            </Sel>
          </Fld>
        </div>
        {form.pm1&&(
          <div style={{background:"#f8fafc",borderRadius:10,border:"1.5px solid #e2e8f0",padding:"12px 16px",marginTop:14}}>
            <div style={{fontSize:".7rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>JO Preview</div>
            <div style={{display:"flex",gap:20,flexWrap:"wrap",fontSize:".8rem"}}>
              <div><span style={{color:"#94a3b8"}}>Client: </span><strong>{deal.client}</strong></div>
              <div><span style={{color:"#94a3b8"}}>CE: </span><strong>{deal.ceNo||"CE pending"}</strong></div>
              <div><span style={{color:"#94a3b8"}}>PM: </span><strong>{[form.pm1,form.pm2,form.pm3].filter(Boolean).join(", ")}</strong></div>
              {form.coordinator&&<div><span style={{color:"#94a3b8"}}>Coordinator: </span><strong>{form.coordinator}</strong></div>}
              <div><span style={{color:"#94a3b8"}}>AE: </span><strong>{form.aeAssigned||"—"}</strong></div>
              <div><span style={{color:"#f59e0b",fontWeight:700}}>⏳ QS Budget: Pending</span></div>
            </div>
          </div>
        )}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:18}}>
          <button onClick={()=>setStep(1)} style={{background:"#f1f5f9",border:"none",borderRadius:10,padding:"10px 20px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#475569",cursor:"pointer"}}>← Back</button>
          <button onClick={()=>confirmOnce({...form,paymentTerms:null})}
            disabled={submitting||!form.scopeNotes}
            title={!form.scopeNotes?"Scope of Work is required before awarding":"Payment terms are set later in Billing"}
            style={{background:(submitting||!form.scopeNotes)?"#94a3b8":"#059669",border:"none",borderRadius:10,padding:"12px 28px",fontFamily:"inherit",fontWeight:800,fontSize:".9rem",color:"#fff",cursor:(submitting||!form.scopeNotes)?"not-allowed":"pointer",letterSpacing:".3px"}}>
            {submitting?"⏳ Awarding…":"🏆 Confirm Award Deal"}
          </button>
        </div>
        <div style={{textAlign:"right",fontSize:".72rem",color:"#94a3b8",marginTop:8}}>💡 Payment terms &amp; billing milestones are set in <strong>Billing</strong> after award.</div>
      </div>)}
    </Modal>
  );
}
const ProgBar=({pct,color,h=6})=>(
  <div style={{height:h,background:"#f1f5f9",borderRadius:h/2,overflow:"hidden"}}>
    <div style={{height:"100%",width:Math.min(pct||0,100)+"%",background:color,borderRadius:h/2,transition:"width .5s"}}/>
  </div>
);
// ─── TOAST NOTIFICATION SYSTEM ────────────────────────────────────────────────
const SecHead=({title,action,sub})=>(
  <div style={{marginBottom:16}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <h2 style={{margin:0,fontSize:"1.1rem",fontWeight:800,color:"#0f172a"}}>{title}</h2>
      {action}
    </div>
    {sub&&<div style={{fontSize:".78rem",color:"#64748b",marginTop:3}}>{sub}</div>}
  </div>
);
const EmptyState=({icon,msg})=>(
  <div style={{textAlign:"center",padding:"36px 24px",color:"#94a3b8"}}>
    <div style={{fontSize:"2rem",marginBottom:8}}>{icon}</div>
    <div style={{fontSize:".88rem"}}>{msg}</div>
  </div>
);

// ─── COLLECTIONS COMPONENT (shared by Sales & Finance) ────────────────────────
function CollectionsPanel({wonDeals,infs,onUpdatePayment,onLogPayment,readonly=false}){
  const[logModal,setLogModal]=useState(false);
  const[logForm,setLogForm]=useState({dealId:"",amount:"",note:"",date:today});

  // All money runs through dealFinancials so every figure is on one consistent
  // basis: contract/VAT/EWT are derived from the net base, and Outstanding is
  // billed receivable (cash the client owes, VAT in / EWT out) minus collections.
  const fins=wonDeals.map(d=>dealFinancials(d));
  const totalContract =fins.reduce((s,f)=>s+f.contract,0);
  const totalVat      =fins.reduce((s,f)=>s+f.vat,0);
  const totalEwt      =fins.reduce((s,f)=>s+f.ewt,0);
  const totalCollected=fins.reduce((s,f)=>s+f.collected,0);
  const totalOut      =fins.reduce((s,f)=>s+f.outstanding,0);
  const overdue=wonDeals.filter(d=>d.dueDate&&d.dueDate<today&&d.paymentStatus!=="Paid"&&d.paymentStatus!=="Deposited"&&d.invoiced>0);

  return(
    <div>
      {/* Summary KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"repeat(2,1fr)":"repeat(5,1fr)",gap:12,marginBottom:20}}>
        <KPI label="Total Contract Price" value={fmtK(totalContract)} color="#3b82f6"/>
        <KPI label="VAT (12%)"            value={fmtK(totalVat)}      color="#6366f1"/>
        <KPI label="EWT Withheld"         value={fmtK(totalEwt)}      color="#a855f7"/>
        <KPI label="Total Collected"      value={fmtK(totalCollected)} color="#059669"/>
        <KPI label="Outstanding"          value={fmtK(totalOut)}       color={totalOut>0?"#ef4444":"#059669"}/>
      </div>

      {/* Overdue alert */}
      {overdue.length>0&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fca5a5",borderRadius:12,padding:"14px 18px",marginBottom:16,display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:"1.2rem"}}>⚠️</span>
          <div>
            <div style={{fontWeight:700,color:"#dc2626",fontSize:".9rem"}}>{overdue.length} overdue account{overdue.length>1?"s":""}</div>
            <div style={{fontSize:".78rem",color:"#ef4444",marginTop:2}}>{overdue.map(d=>d.client).join(", ")}</div>
          </div>
        </div>
      )}

      <SecHead title="Client Collections" action={!readonly&&<Btn onClick={()=>setLogModal(true)}>+ Log Payment</Btn>}/>

      {wonDeals.filter(d=>d.invoiced>0).map(d=>{
        const f=dealFinancials(d);
        const bal=f.outstanding;
        const od=d.dueDate&&d.dueDate<today&&d.paymentStatus!=="Paid";
        const pct=f.billedReceivable>0?Math.round(f.collected/f.billedReceivable*100):0;
        return(
          <Card key={d.id} accent={od?"#fca5a5":bal===0?"#6ee7b7":undefined}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:180}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".98rem"}}>{d.client}</div>
                <div style={{fontSize:".76rem",color:"#64748b",marginTop:3}}>{d.product}</div>
                <div style={{marginTop:10,marginBottom:4}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:".7rem",color:"#94a3b8",marginBottom:4}}>
                    <span>{fmt(f.collected)} collected of {fmt(f.billedReceivable)}</span>
                    <span style={{fontWeight:700,color:pct===100?"#059669":"#64748b"}}>{pct}%</span>
                  </div>
                  <ProgBar pct={pct} color={pct===100?"#059669":pct>0?"#10b981":"#e2e8f0"} h={8}/>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:5}}>Contract {fmt(f.contract)} · VAT {fmt(f.vat)}{f.ewt>0?` · EWT −${fmt(f.ewt)}`:""} · Receivable {fmt(f.billedReceivable)}</div>
                </div>
                {d.dueDate&&<div style={{fontSize:".72rem",color:od?"#ef4444":"#94a3b8",marginTop:6}}>{od?"⚠ Overdue since":"Due:"} {d.dueDate}</div>}
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{fontWeight:800,fontSize:"1.1rem",color:bal===0?"#059669":"#ef4444"}}>{bal===0?"PAID":fmt(bal)+" due"}</div>
                <div style={{marginTop:8}}><Badge label={d.paymentStatus} color={PAY_CLR[d.paymentStatus]}/></div>
                {!readonly&&(
                  <div style={{marginTop:10}}>
                    <Sel value={d.paymentStatus} onChange={e=>onUpdatePayment(d.id,"paymentStatus",e.target.value)}>
                      {PAY_STATUS.map(s=><option key={s}>{s}</option>)}
                    </Sel>
                  </div>
                )}
              </div>
            </div>
          </Card>
        );
      })}

      {wonDeals.filter(d=>d.invoiced>0).length===0&&(
        <EmptyState icon="💳" msg="No invoiced projects yet. Invoice amounts are set when marking a deal as Won."/>
      )}

      {/* Log Payment Modal */}
      <Modal open={logModal} onClose={()=>setLogModal(false)} title="Log Payment Received">
        <Fld label="Client / Project" required>
          <Sel value={logForm.dealId} onChange={e=>setLogForm(p=>({...p,dealId:e.target.value}))}>
            <option value="">— Select client —</option>
            {wonDeals.filter(d=>d.invoiced>0).map(d=>(
              <option key={d.id} value={d.id}>{d.client} — {fmt(dealFinancials(d).outstanding)} remaining</option>
            ))}
          </Sel>
        </Fld>
        <Fld label="Amount Received (₱)" required>
          <Inp type="number" value={logForm.amount} onChange={e=>setLogForm(p=>({...p,amount:e.target.value}))} placeholder="e.g. 25000"/>
        </Fld>
        <Fld label="Date Received">
          <Inp type="date" value={logForm.date} onChange={e=>setLogForm(p=>({...p,date:e.target.value}))}/>
        </Fld>
        <Fld label="Note" hint="e.g. Full payment, 50% deposit, partial">
          <Inp value={logForm.note} onChange={e=>setLogForm(p=>({...p,note:e.target.value}))} placeholder="Payment note"/>
        </Fld>
        <div style={{display:"flex",gap:10,marginTop:20}}>
          <Btn full onClick={()=>{
            if(!logForm.dealId||!logForm.amount) return;
            onLogPayment(logForm);
            setLogModal(false);
            setLogForm({dealId:"",amount:"",note:"",date:today});
          }}>✓ Confirm Payment</Btn>
          <Btn variant="ghost" onClick={()=>setLogModal(false)}>Cancel</Btn>
        </div>
      </Modal>
    </div>
  );
}

// ─── DEAL FORM MODAL ──────────────────────────────────────────────────────────
function ClientAutocomplete({value:initVal, onChange, existingNames=[]}){
  const[localVal,setLocalVal]= useState(initVal||"");
  const[show,    setShow]    = useState(false);
  // Sync if parent resets (e.g. new deal)
  useEffect(()=>{ setLocalVal(initVal||""); },[initVal]);

  // Known client universe = seed directory + names already used on deals, so
  // the box suggests (and dedupe-checks against) clients that really exist —
  // not just the hardcoded GMD list. De-duplicated by normalized key.
  const known = useMemo(()=>{
    const map=new Map();
    GMD_CLIENTS.forEach(c=>{const k=clientKey(c.name);if(!map.has(k))map.set(k,{name:c.name,city:c.city,phone:c.phone,balance:c.balance});});
    (existingNames||[]).forEach(n=>{const k=clientKey(n);if(k&&!map.has(k))map.set(k,{name:n});});
    return [...map.values()];
  },[existingNames]);

  const suggestions = useMemo(()=>{
    if(!localVal||localVal.length<2) return [];
    const q = localVal.toLowerCase();
    return known.filter(c=>c.name.toLowerCase().includes(q)).slice(0,8);
  },[localVal,known]);

  // Duplicate guard: typed name normalizes to an existing client but isn't an
  // exact match (e.g. "collecticons inc" vs stored "Collecticons Inc.").
  const dup = useMemo(()=>{
    if(!localVal||localVal.trim().length<2) return null;
    const k=clientKey(localVal);
    const hit=known.find(c=>clientKey(c.name)===k);
    return hit&&hit.name!==localVal ? hit : null;
  },[localVal,known]);

  const exactKnown = known.some(c=>c.name.toLowerCase()===localVal.toLowerCase());
  const pick = (name) => { setLocalVal(name); onChange(name); setShow(false); };

  return(
    <div style={{position:"relative"}}>
      <input
        value={localVal}
        onChange={e=>{setLocalVal(e.target.value);onChange(e.target.value);setShow(true);}}
        onFocus={()=>setShow(true)}
        onBlur={()=>setTimeout(()=>setShow(false),150)}
        placeholder="Start typing client name…"
        style={{width:"100%",border:`1.5px solid ${dup?"#f59e0b":"#e2e8f0"}`,borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",outline:"none"}}
      />
      {/* Possible-duplicate nudge — visible even when the dropdown is closed */}
      {dup&&(
        <div style={{marginTop:5,background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:8,padding:"7px 10px",fontSize:".76rem",color:"#92400e",display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          <span>⚠ Looks like an existing client:</span>
          <button type="button" onMouseDown={()=>pick(dup.name)} style={{background:"#f59e0b",border:"none",borderRadius:6,padding:"3px 9px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".74rem",cursor:"pointer"}}>Use “{dup.name}”</button>
          <span style={{color:"#b45309"}}>— avoids a duplicate client.</span>
        </div>
      )}
      {show && (localVal.length>=1) && (suggestions.length>0 || (localVal.length>=2 && !exactKnown)) && (
        <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,boxShadow:"0 8px 24px rgba(0,0,0,.12)",zIndex:200,maxHeight:280,overflowY:"auto",marginTop:4}}>
          {suggestions.map((c,i)=>(
            <div key={i} onMouseDown={()=>pick(c.name)}
              style={{padding:"10px 14px",cursor:"pointer",borderBottom:"1px solid #f1f5f9",transition:"background .1s"}}
              onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
              onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
              <div style={{fontWeight:600,color:"#0f172a",fontSize:".86rem"}}>{c.name}</div>
              <div style={{display:"flex",gap:12,marginTop:2,flexWrap:"wrap"}}>
                {c.city&&<span style={{fontSize:".7rem",color:"#94a3b8"}}>📍 {c.city}</span>}
                {c.phone&&<span style={{fontSize:".7rem",color:"#94a3b8"}}>📞 {c.phone}</span>}
                {c.balance>0&&<span style={{fontSize:".7rem",color:"#ef4444",fontWeight:700}}>⚠ ₱{c.balance.toLocaleString()} open balance</span>}
              </div>
            </div>
          ))}
          {localVal&&!exactKnown&&(
            <div onMouseDown={()=>pick(localVal)}
              style={{padding:"10px 14px",cursor:"pointer",background:"#fafafa",borderTop:"1px solid #e2e8f0",fontSize:".82rem",color:dup?"#b45309":"#3b82f6",fontWeight:600}}>
              {dup?`+ Add "${localVal}" anyway as a new client`:`+ Add "${localVal}" as new client`}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── CLIENT DIRECTORY ────────────────────────────────────────────────────────
function DealModal({open,onClose,form:initialForm,setForm:_setForm,onSave,editId,deals=[],addenda=[],role}){
  // Local state — prevents App re-render on every keystroke (fixes focus bug)
  const[form,setForm]=useState(initialForm||emptyDeal);
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const isWon=WON_STAGES.includes(form.stage);
  const setDrfAcc=(i,v)=>f("drfAccessories",(form.drfAccessories||[]).map((a,ai)=>ai===i?v:a));
  const addDrfAcc=()=>f("drfAccessories",[...(form.drfAccessories||[]),""])
  const remDrfAcc=(i)=>f("drfAccessories",(form.drfAccessories||[]).filter((_,ai)=>ai!==i));
  const setDrfRef=(i,v)=>f("drfRefLinks",(form.drfRefLinks||["","",""]).map((r,ri)=>ri===i?v:r));
  const mob=window.innerWidth<768;
  const[saving,setSaving]=useState(false);
  // Gross-entry helper. Staff type the VAT-INCLUSIVE (gross) contract amount for
  // OR deals — the number off the client PO — but the deal's `value` is stored
  // VAT-EXCLUSIVE (net) as everywhere else in the system, so nothing downstream
  // (saveDeal, reports, tax engine, existing data) changes. This local string
  // holds what the user typed in the gross box; `value` = gross / 1.12.
  const netToGross=(v)=>{const n=Number(v)||0;return n?String(Math.round(n*1.12*100)/100):"";};
  const[grossStr,setGrossStr]=useState(()=>initialForm?.receiptType==="OR"?netToGross(initialForm?.value):"");
  // The BOQ is the VAT authority: once a linked BOQ has decided VAT, the receipt
  // type follows it (VAT 12% → OR, No VAT → AR) and is locked here.
  // Sales Owner is Manager-only once the deal has collections (commission follows it).
  const ownerLocked=salesOwnerLocked(editId?deals.find(d=>d.id===editId):null,role);
  const boqLockedRt=(()=>{const src=editId?deals.find(d=>d.id===editId):null;const v=(src?.boqData||src?.boq_data||form?.boqData)?.vatEnabled;return typeof v==="boolean"?(v?"OR":"AR"):null;})();
  useEffect(()=>{if(open&&boqLockedRt&&form.receiptType!==boqLockedRt){setForm(p=>({...p,receiptType:boqLockedRt,withholding:boqLockedRt==="AR"?false:p.withholding}));}},[open,boqLockedRt,form.receiptType]);

  // Sync when modal opens or editId changes
  const formKey=`${open}-${editId||"new"}`;
  useEffect(()=>{
    if(open){setForm(initialForm||emptyDeal);setSaving(false);
      setGrossStr(initialForm?.receiptType==="OR"?netToGross(initialForm?.value):"");}
  },[open,editId]);

  const handleSave=async()=>{
    // saveDeal is async (claims a CE number, awaits the Supabase write) — a
    // fast double-click before it resolves could re-run the whole save and
    // risk a second deal record. Guard with a local submitting lock.
    if(saving) return;
    // Receipt type is NOT chosen here: the BOQ's VAT choice sets it (VAT 12% →
    // OR, No VAT → AR — see onBoqVat). A sales-side pick defaulted to OR and
    // silently overrode "No VAT" costings, so a new deal saves with it blank and
    // billing refuses to invoice until the BOQ decides.
    setSaving(true);
    // Pass local form data directly to saveDeal — bypasses async state sync
    _setForm(()=>form);
    try{ await onSave(form); } finally { setSaving(false); }
  };
  return(
    <Modal open={open} onClose={onClose} title={editId?"Edit Deal":"Add New Deal"} wide key={formKey}>

      {/* Contract breakdown (original + addenda) — shown when this deal has change orders */}
      {editId&&((addenda||[]).some(a=>a.dealId===editId&&a.status!=="Rejected")||(deals||[]).some(d=>d.parentDealId===editId&&!isLostStage(d.stage)))&&(
        <div style={{marginBottom:16}}><ContractBreakdown deal={deals.find(d=>d.id===editId)} addenda={addenda} deals={deals}/></div>
      )}

      {/* ── SECTION 1: DEAL ESSENTIALS ─────────────────────────────────── */}
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
        <div style={{gridColumn:"1/-1"}}>
          <Fld label="Client Name" required hint="Start typing to search from your GMD clients">
            <ClientAutocomplete value={form.client} onChange={v=>f("client",v)} existingNames={[...new Set((deals||[]).map(d=>d.client).filter(Boolean))]}/>
          </Fld>
        </div>
        <Fld label="Project Name" hint="e.g. SM Megamall Fit-Out Phase 1"><Inp value={form.contact} onChange={e=>f("contact",e.target.value)} placeholder="e.g. SM Megamall Fit-Out Phase 1"/></Fld>
        <Fld label={form.standbyPO?"Deal Value (₱) — held at 0 for standby PO":"Contract Value (₱, Net / VAT-exclusive)"} hint={form.standbyPO?"Standby POs earn nothing on the umbrella itself — value lives on the drawdown jobs":"Net (ex-VAT). For VAT (OR) deals you can instead type the gross total in Tax Settings below — this fills automatically."}><Inp type="number" min={0} value={form.standbyPO?0:form.value} disabled={form.standbyPO} onChange={e=>{const v=e.target.value;const nv=v===""?"":Math.max(0,Number(v)||0);f("value",nv);setGrossStr(nv===""?"":netToGross(nv));}} placeholder="To be confirmed" style={form.standbyPO?{background:"#f1f5f9",color:"#94a3b8",cursor:"not-allowed"}:undefined}/></Fld>
        <Fld label="CE Number"><Inp value={form.ceNo||""} onChange={e=>f("ceNo",e.target.value)} placeholder="CE-2026-005"/></Fld>
        <Fld label="CE Type">
          <Sel value={form.ceType||"Fabrication / General"} onChange={e=>f("ceType",e.target.value)}>
            {CE_TYPES.map(t=><option key={t}>{t}</option>)}
          </Sel>
          {form.ceType==="Other"&&<Inp value={form.customProductType||""} onChange={e=>f("customProductType",e.target.value)} placeholder="Describe the project type..." style={{marginTop:6}}/>}
        </Fld>
        <Fld label="Sales Owner / AE" hint={ownerLocked?"Locked: this deal has collections, so only a Manager can change its Sales Owner.":undefined}>
          <Sel value={form.salesOwner||""} onChange={e=>f("salesOwner",e.target.value)} disabled={ownerLocked}>
            <option value="">— Assign AE —</option>
            {SALES_TEAM.map(m=><option key={m}>{m}</option>)}
          </Sel>
        </Fld>
        <Fld label="Lead Origin" hint="Sets the sales commission on collected payments: Self-sourced = 1.5%, Given to the team = 0.5%">
          <Sel value={form.leadOrigin||DEFAULT_LEAD_ORIGIN} onChange={e=>f("leadOrigin",e.target.value)}>
            {LEAD_ORIGINS.map(o=><option key={o} value={o}>{o==="Self-sourced"?"Self-sourced (AE brought the client) · 1.5%":"Given to the sales team · 0.5%"}</option>)}
          </Sel>
          {form.leadOrigin==="Self-sourced"&&(()=>{
            const orig=editId?deals.find(d=>d.id===editId):null;
            const approved=orig&&leadOriginOf(orig)==="Self-sourced"&&!leadOriginPending(orig);
            const txt=approved?`✅ Approved${orig.leadOriginApprovedBy?` by ${orig.leadOriginApprovedBy}`:""} — earns 1.5%`
              :role==="Manager"?"Saving as Manager approves the 1.5% rate."
              :"⏳ Needs Manager approval — earns 0.5% until approved.";
            return <div style={{fontSize:".7rem",marginTop:4,fontWeight:600,color:approved?"#047857":role==="Manager"?"#475569":"#b45309"}}>{txt}</div>;
          })()}
        </Fld>
        <Fld label="Date Acquired"><Inp type="date" value={form.dateAcquired||today} onChange={e=>f("dateAcquired",e.target.value)}/></Fld>
        <div style={{gridColumn:"1/-1"}}>
          <Fld label="Project Location" hint="e.g. SM North EDSA 3F Activity Area, BGC Taguig, Makati CBD">
            <Inp value={form.location||""} onChange={e=>f("location",e.target.value)} placeholder="e.g. SM North EDSA – 3F Activity Area"/>
          </Fld>
        </div>
        <div style={{gridColumn:"1/-1"}}>
          <Fld label="🔗 Link to Parent Deal" hint="Set this if the deal is an addendum or extension of an existing project">
            <SearchSelect
              value={form.parentDealId||null}
              onChange={v=>f("parentDealId",v)}
              options={deals.filter(d=>!d.parentDealId&&d.id!==editId).map(d=>({value:d.id,label:(d.contact||d.client)+(d.ceNo?` (${d.ceNo})`:"")})) }
              placeholder="Type to search deals…"
              noneLabel="— Standalone deal —"
              noneValue={null}
            />
          </Fld>
        </div>
        {/* Addendum approval — shown only when this deal is linked to a parent.
            The flag (not the workflow stage) drives the contract roll-up:
            Pending sits in "If pending approved" and never inflates the parent's
            Total Contract; Approved rolls in and the addendum then follows the
            parent project's stage (see saveDeal + ContractBreakdown). */}
        {form.parentDealId&&(
          <div style={{gridColumn:"1/-1"}}>
            <div style={{background:form.addendumStatus==="Approved"?"#ecfdf5":"#fffbeb",borderRadius:12,padding:"12px 14px",border:`1.5px solid ${form.addendumStatus==="Approved"?"#a7f3d0":"#fde68a"}`}}>
              <div style={{fontSize:".82rem",fontWeight:700,color:form.addendumStatus==="Approved"?"#047857":"#92400e",marginBottom:4}}>
                {form.addendumStatus==="Approved"?"✅ Addendum approved by client":"⏳ Addendum — awaiting client approval"}
              </div>
              <div style={{fontSize:".72rem",color:"#94a3b8",marginBottom:9}}>While Pending it's invisible to Billing & Design and stays out of Total Contract (shown under “If pending approved”). Approve once the client signs off — it rolls into Total Contract, follows the parent project's stage, and unlocks billing & design.</div>
              <div style={{display:"flex",gap:8}}>
                {["Pending","Approved"].map(st=>{
                  const on=(form.addendumStatus||"Pending")===st;
                  const clr=st==="Approved"?"#059669":"#d97706";
                  return(
                    <button type="button" key={st} onClick={()=>f("addendumStatus",st)}
                      style={{flex:1,padding:"7px 12px",borderRadius:8,cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",
                        border:`1.5px solid ${on?clr:"#e2e8f0"}`,background:on?clr:"#fff",color:on?"#fff":"#64748b"}}>
                      {st==="Approved"?"✅ Approved":"⏳ Pending"}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        {/* Standby PO / Adhoc umbrella — only for parent (non-linked) deals. Marks
            this deal as a client PO / standby fund: the umbrella carries no
            contract revenue of its own (value pinned to 0), and its child jobs
            draw down against poBudget. Prevents the PO from being double-counted
            on top of the jobs charged against it. */}
        {!form.parentDealId&&(
          <div style={{gridColumn:"1/-1"}}>
            <div style={{background:form.standbyPO?"#eff6ff":"#f8fafc",borderRadius:12,padding:"12px 14px",border:`1.5px solid ${form.standbyPO?"#bfdbfe":"#e2e8f0"}`}}>
              <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:".82rem",fontWeight:700,color:form.standbyPO?"#1d4ed8":"#475569"}}>
                <input type="checkbox" checked={!!form.standbyPO} onChange={e=>{const on=e.target.checked;f("standbyPO",on);if(on)f("value",0);}} style={{width:18,height:18,cursor:"pointer",accentColor:"#2563eb"}}/>
                💳 Standby PO / Adhoc umbrella
              </label>
              <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:4}}>Tick when this is a client PO / standby fund drawn down by individual jobs. The umbrella stays at ₱0 revenue; each linked job counts as it's charged, drawing the PO ceiling down toward ₱0.</div>
              {form.standbyPO&&(
                <div style={{marginTop:10}}>
                  <Fld label="PO Ceiling / Budget (₱)" hint="Total the client committed — drawdown jobs count down against this">
                    <Inp type="number" min={0} value={form.poBudget} onChange={e=>{const v=e.target.value;f("poBudget",v===""?"":Math.max(0,Number(v)||0));}} placeholder="e.g. 854000"/>
                  </Fld>
                </div>
              )}
            </div>
          </div>
        )}
        {isWon&&(
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="🏁 Client Turnover Date" hint="Date promised to client — notifies Ops & Management when changed">
              <Inp type="date" value={form.turnoverDate||""} onChange={e=>f("turnoverDate",e.target.value)}/>
            </Fld>
          </div>
        )}
        {editId&&form.addedBy&&(
          <div style={{gridColumn:"1/-1"}}>
            <div style={{background:"#eef2ff",border:"1.5px solid #c7d2fe",borderRadius:8,padding:"8px 12px",fontSize:".75rem",color:"#4338ca",display:"flex",gap:8,alignItems:"center"}}>
              <span style={{fontWeight:700}}>✏ Added by:</span> {form.addedBy}
              {form.addedAt&&<span style={{color:"#6366f1",marginLeft:4}}>· {form.addedAt}</span>}
            </div>
          </div>
        )}
      </div>

      {/* Design Request Form (DRF) — tickbox like the CE/QS request below: the
          requester flags that design work is needed, the Design lead picks who
          on the team handles it (see DRFView "Assign" action) instead of the
          requester naming a specific designer up front. */}
      {/* Hidden for a pending addendum — Design can't be requested on scope the
          client hasn't approved yet (it unlocks once the addendum is approved). */}
      {!editId&&!(form.parentDealId&&form.addendumStatus!=="Approved")&&(
      <div style={{background:"#faf5ff",borderRadius:12,padding:"14px 16px",marginTop:8,border:"1.5px solid #ddd6fe"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
          <div>
            <div style={{fontWeight:700,color:"#6d28d9",fontSize:".85rem"}}>🎨 Request Design</div>
            <div style={{fontSize:".72rem",color:"#a78bfa",marginTop:2}}>Tick to create a Design Request when the deal is saved — the Design lead will assign who works on it.</div>
          </div>
          <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:".8rem",fontWeight:700,color:"#6d28d9"}}>
            <input type="checkbox" checked={!!form.drfReqCreate} onChange={e=>f("drfReqCreate",e.target.checked)} style={{width:18,height:18,cursor:"pointer",accentColor:"#7c3aed"}}/>
            {form.drfReqCreate?"Will create Design Request":"Create Design Request"}
          </label>
        </div>
        {form.drfReqCreate&&(
        <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:12,marginTop:12}}>
          <Fld label="Project Type" hint="Kiosk / In-line / Event / Other"><Sel value={form.drfCategory||""} onChange={e=>f("drfCategory",e.target.value)}><option value="">— Select —</option>{DRF_CATEGORIES.map(t=><option key={t}>{t}</option>)}</Sel></Fld>
          <Fld label="Design Deadline"><Inp type="date" value={form.drfDeadline||""} onChange={e=>f("drfDeadline",e.target.value)}/></Fld>
          <Fld label="Size / Dimensions"><Inp value={form.drfSize||""} onChange={e=>f("drfSize",e.target.value)} placeholder="e.g. W1200 x H1800 x D600mm"/></Fld>
          <Fld label="Maximum Height"><Inp value={form.drfMaxHeight||""} onChange={e=>f("drfMaxHeight",e.target.value)} placeholder="e.g. 2400mm"/></Fld>
          <Fld label="Platform"><Sel value={form.drfPlatform||""} onChange={e=>f("drfPlatform",e.target.value)}><option value="">— Select —</option><option>With Platform</option><option>Without Platform</option></Sel></Fld>
          <Fld label="Ideal Finishes"><Inp value={form.drfFinishes||""} onChange={e=>f("drfFinishes",e.target.value)} placeholder="e.g. Matte laminate, powder-coated steel"/></Fld>
          <Fld label="Brand Guideline Link"><Inp type="url" value={form.drfBrandGuideLink||""} onChange={e=>f("drfBrandGuideLink",e.target.value)} placeholder="https://…"/></Fld>
          <Fld label="Budget (optional)"><Inp value={form.drfBudget||""} onChange={e=>f("drfBudget",e.target.value)} placeholder="e.g. ₱150,000"/></Fld>
          <div style={{gridColumn:"1/-1"}}><Fld label="Description / Details" hint="What needs to be designed? Include dimensions, function, and key specs."><Inp rows={4} value={form.drfDescription||""} onChange={e=>f("drfDescription",e.target.value)} placeholder={"RE-CREATE: Golf bag organizer rack\nSIZE: Must fit two large golf bags\nFUNCTION: Store bags + shoe shelf"}/></Fld></div>
          <div style={{gridColumn:"1/-1"}}>
            <div style={{fontSize:".8rem",fontWeight:700,color:"#64748b",marginBottom:6}}>Accessories / Components</div>
            {(form.drfAccessories||[]).map((a,i)=>(
              <div key={i} style={{display:"flex",gap:8,marginBottom:6}}>
                <Inp value={a} onChange={e=>setDrfAcc(i,e.target.value)} placeholder="e.g. Shelving for shoes (3-4 pairs)"/>
                <button onClick={()=>remDrfAcc(i)} style={{background:"#fef2f2",border:"none",borderRadius:7,padding:"6px 10px",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,flexShrink:0}}>✕</button>
              </div>
            ))}
            <button onClick={addDrfAcc} style={{background:"#f8fafc",border:"1.5px dashed #e2e8f0",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>+ Add Component</button>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <div style={{fontSize:".8rem",fontWeight:700,color:"#64748b",marginBottom:6}}>Reference Images (links)</div>
            <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr 1fr",gap:10}}>
              {(form.drfRefLinks||["","",""]).map((r,i)=>(
                <Fld key={i} label={`Ref ${i+1}`}><Inp type="url" value={r} onChange={e=>setDrfRef(i,e.target.value)} placeholder="https://…"/></Fld>
              ))}
            </div>
          </div>
          <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={form.drfNotes||""} onChange={e=>f("drfNotes",e.target.value)} placeholder="Brand guidelines, restrictions, additional references…"/></Fld></div>
        </div>
        )}
      </div>
      )}

      {/* CE/QS Request — auto-creates a cost-estimation request for Rodney's queue */}
      {!editId&&(
      <div style={{background:"#f5f3ff",borderRadius:12,padding:"14px 16px",marginTop:8,border:"1.5px solid #c4b5fd"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
          <div>
            <div style={{fontWeight:700,color:"#6d28d9",fontSize:".85rem"}}>📐 Send to CE/QS for Costing</div>
            <div style={{fontSize:".72rem",color:"#a78bfa",marginTop:2}}>Tick to send this project to Rodney's cost-estimation queue when the deal is saved.</div>
          </div>
          <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:".8rem",fontWeight:700,color:"#6d28d9"}}>
            <input type="checkbox" checked={!!form.ceReqCreate} onChange={e=>f("ceReqCreate",e.target.checked)} style={{width:18,height:18,cursor:"pointer",accentColor:"#7c3aed"}}/>
            {form.ceReqCreate?"Will create CE request":"Create CE request"}
          </label>
        </div>
        {form.ceReqCreate&&(
          <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:12,marginTop:12}}>
            <Fld label="Project Type">
              <Sel value={form.ceReqType||"retail"} onChange={e=>f("ceReqType",e.target.value)}>
                <option value="kiosk">Kiosk</option><option value="retail">Retail Fit-out</option><option value="office">Office</option><option value="fnb">F&B / Restaurant</option><option value="signage">Signage</option><option value="event">Event / Activation</option><option value="repair">Repair / Refurb</option><option value="other">Other</option>
              </Sel>
            </Fld>
            <Fld label="Priority"><Sel value={form.ceReqPriority||"Normal"} onChange={e=>f("ceReqPriority",e.target.value)}><option>High</option><option>Normal</option><option>Low</option></Sel></Fld>
            <Fld label="CE Deadline" hint="When does CE/QS need to finish costing?"><Inp type="date" value={form.ceReqDeadline||""} onChange={e=>f("ceReqDeadline",e.target.value)}/></Fld>
            <Fld label="Proposal Submission Deadline"><Inp type="date" value={form.ceReqSubmitDeadline||""} onChange={e=>f("ceReqSubmitDeadline",e.target.value)}/></Fld>
            <Fld label="Target Budget (₱)"><Inp type="number" min={0} value={form.ceReqBudget||""} onChange={e=>f("ceReqBudget",e.target.value)} placeholder="If applicable"/></Fld>
            <Fld label="Target Margin (%)"><Inp type="number" min={0} max={100} value={form.ceReqMargin||""} onChange={e=>f("ceReqMargin",e.target.value)} placeholder="e.g. 25"/></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Plans Link" hint="Google Drive folder with the complete set of plans"><Inp type="url" value={form.ceReqPlansLink||""} onChange={e=>f("ceReqPlansLink",e.target.value)} placeholder="https://drive.google.com/…"/></Fld></div>
            <Fld label="SKP File Link"><Inp type="url" value={form.ceReqSkpLink||""} onChange={e=>f("ceReqSkpLink",e.target.value)} placeholder="https://…"/></Fld>
            <Fld label="Schedule of Finish"><Inp value={form.ceReqSchedule||""} onChange={e=>f("ceReqSchedule",e.target.value)} placeholder="e.g. Standard finish, no special cladding"/></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Notes for CE/QS" hint="Scope clarifications, special requirements, client preferences"><Inp rows={2} value={form.ceReqNotes||""} onChange={e=>f("ceReqNotes",e.target.value)} placeholder="Anything that helps Rodney cost this accurately…"/></Fld></div>
          </div>
        )}
      </div>
      )}
      {PAULO_GATE.includes(form.stage)&&(
        <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"12px 16px",marginTop:8,fontSize:".82rem",color:"#92400e"}}>
          ⚠️ <strong>Paulo Gate:</strong> Stage {form.stage} requires Paulo Garcia's review and sign-off before proceeding to the next stage.
        </div>
      )}
      {Number(form.value)>=3000000&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"12px 16px",marginTop:8,fontSize:".82rem",color:"#991b1b"}}>
          🚨 <strong>₱3M Rule:</strong> This project exceeds ₱3,000,000. Paulo Garcia must be involved. Paolo can quote a range but <strong>cannot commit pricing</strong> without Paulo.
        </div>
      )}
      {form.ceType==="Construction"&&(
        <div style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:10,padding:"12px 16px",marginTop:8,fontSize:".82rem",color:"#1d4ed8"}}>
          🏗 <strong>Construction CE:</strong> Rodney (QS/CE) prepares the cost estimate using the Construction template. Jerome Mendoza is on-call backup. Paulo sets the final % adjustment.
        </div>
      )}


      {/* ── SECTION 6: TAX SETTINGS ─────────────────────────────────────── */}
      {/* Shown from the start (except standby POs) so staff can pick OR and enter
          the gross figure up front, rather than being gated behind a net value. */}
      {!form.standbyPO&&(
        <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"16px 18px",marginTop:10}}>
          <div style={{fontWeight:700,color:"#92400e",fontSize:".88rem",marginBottom:12}}>🧾 Tax Settings</div>
          <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14,marginBottom:14}}>
            <div>
              <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"#92400e",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>Receipt Type</label>
              <div style={{padding:"8px 12px",border:"2px solid #e2e8f0",borderRadius:8,background:"#f8fafc",fontSize:".82rem",fontWeight:700,color:form.receiptType?"#92400e":"#64748b"}}>
                {form.receiptType==="OR"?"🧾 OR (with VAT)":form.receiptType==="AR"?"📄 AR (no VAT)":"⏳ Pending BOQ"}
              </div>
              <div style={{fontSize:".7rem",color:"#92400e",marginTop:5,opacity:.85}}>
                {boqLockedRt!==null
                  ?<span style={{fontWeight:700}}>🔒 Set by the BOQ ({boqLockedRt==="OR"?"VAT 12%":"No VAT"}) — change VAT in the BOQ.</span>
                  :form.receiptType
                    ?"Will follow the BOQ once its VAT treatment is chosen."
                    :"Set automatically when the BOQ's VAT treatment (VAT 12% / No VAT) is chosen. With no BOQ, Finance sets it in Billing. Billing can't be generated until then."}
              </div>
            </div>
            {form.receiptType==="OR"?(
              <div>
                <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"#92400e",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>Withholding Tax (EWT 2%)</label>
                <div style={{display:"flex",gap:8}}>
                  {[["Yes — client withholds",true],["No withholding",false]].map(([label,val])=>(
                    <button key={String(val)} type="button" onClick={()=>setForm(p=>({...p,withholding:val}))}
                      style={{flex:1,padding:"8px",border:`2px solid ${form.withholding===val?"#d97706":"#e2e8f0"}`,borderRadius:8,background:form.withholding===val?"#fef3c7":"#fff",color:form.withholding===val?"#92400e":"#64748b",fontWeight:form.withholding===val?700:400,cursor:"pointer",fontFamily:"inherit",fontSize:".75rem"}}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            ):(
              <div style={{display:"flex",alignItems:"center"}}>
                <div style={{background:"#f1f5f9",borderRadius:8,padding:"12px 16px",fontSize:".78rem",color:"#94a3b8",width:"100%",textAlign:"center"}}>
                  {form.receiptType==="AR"?"📄 AR — No EWT applicable":"Set receipt type to see EWT options"}
                </div>
              </div>
            )}
          </div>
          {/* Gross entry — staff type the VAT-inclusive total off the client PO;
              the net Contract Value above fills automatically (value stays net). */}
          {form.receiptType==="OR"&&!form.standbyPO&&(
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"#92400e",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>Or enter Gross (VAT-inclusive) — from client PO</label>
              <Inp type="number" min={0} value={grossStr} onChange={e=>{const g=e.target.value;setGrossStr(g);f("value",g===""?"":Math.round(Math.max(0,Number(g)||0)/1.12*100)/100);}} placeholder="e.g. 1,120,000 total incl. VAT"/>
              <div style={{fontSize:".68rem",color:"#92400e",opacity:.8,marginTop:5}}>Type the gross here and the net Contract Value fills for you — or type net above and this shows the gross.</div>
            </div>
          )}
          {["OR","AR"].includes(form.receiptType)&&(()=>{
            const tx=calcTax(form.value,form.receiptType,form.withholding||false);
            // Invoice-style breakdown, read top-to-bottom the way an OR reads:
            // net sale → +VAT → =gross billed → −EWT withheld → =cash you collect.
            const rows=form.receiptType==="OR"
              ?[["Net Sale (VAT-exclusive)", tx.base, "#0f172a"],
                ["VAT 12%",                  tx.vat,  "#f59e0b"],
                ["Gross (billed to client)", tx.gross,"#2563eb"],
                ...(tx.ewt>0?[["EWT 2% (client withholds)", -tx.ewt, "#ef4444"]]:[]),
                ["Net Collectible (cash in)",tx.netReceivable, "#059669"]]
              :[["Contract (AR — no VAT)",   tx.base, "#0f172a"],
                ["Net Collectible (cash in)",tx.netReceivable, "#059669"]];
            return(
              <div style={{background:"rgba(255,255,255,.9)",borderRadius:8,padding:"6px 14px",borderTop:"1px solid #fde68a"}}>
                {rows.map(([l,v,c],i)=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderTop:i===0?"none":"1px dashed #fde68a"}}>
                    <span style={{fontSize:".74rem",color:"#78716c",fontWeight:i===rows.length-1?700:500}}>{l}</span>
                    <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.05rem",color:c}}>
                      {v<0?"−":""}₱{Math.abs(Number(v)).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2})}
                    </span>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      )}

      <div style={{display:"flex",gap:10,marginTop:20}}>
        <Btn full onClick={handleSave} disabled={saving}>{saving?"Saving…":editId?"Save Changes":"Add Deal"}</Btn>
        <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
      </div>
    </Modal>
  );
}

// ─── EXPENSE FORM MODAL (with confirmation step) ──────────────────────────────
function ExpenseModal({open,onClose,form:initialExpForm,setForm:_setExpForm,onSave,onSaveAll,editId,projList,clientName,chartOfAccounts=[],suppliers=[],exps=[]}){
  const todayStr=new Date().toISOString().slice(0,10);
  const emptyRow=()=>({expDate:todayStr,supplier:"",payee:"",projectId:null,note:"",qty:"1",pricePerQty:"",tin:"",category:"Materials",accountCode:"",remarks:"",bankAccount:"",receipt:"",month:new Date().getMonth(),year:new Date().getFullYear(),_exp:false});
  const expenseAccounts=(chartOfAccounts||[]).filter(a=>a.type==="COGS"||a.type==="Expense").sort((x,y)=>String(x.code).localeCompare(String(y.code)));
  const[rows,setRows]=useState([emptyRow()]);
  const[errors,setErrors]=useState({});
  useEffect(()=>{
    if(open){
      if(editId&&initialExpForm){setRows([{...initialExpForm,_exp:false}]);}
      else{setRows([initialExpForm?{...initialExpForm,_exp:false}:emptyRow()]);}
      setErrors({});
    }
  },[open,editId]);
  const upRow=(i,k,v)=>setRows(rs=>rs.map((r,idx)=>idx===i?{...r,[k]:v}:r));
  const addRow=()=>setRows(rs=>[...rs,{...emptyRow(),expDate:rs[rs.length-1]?.expDate||todayStr,bankAccount:rs[rs.length-1]?.bankAccount||"",projectId:rs[rs.length-1]?.projectId||null}]);
  const removeRow=i=>setRows(rs=>rs.filter((_,idx)=>idx!==i));
  const rowAmt=r=>{const q=Number(String(r.qty||1).replace(/,/g,""))||1;const p=Number(String(r.pricePerQty||0).replace(/,/g,""))||0;return q*p;};
  const grandTotal=rows.reduce((s,r)=>s+rowAmt(r),0);
  const fmt=v=>Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
  const inp={width:"100%",padding:"6px 9px",border:"1.5px solid #e2e8f0",borderRadius:7,fontSize:".8rem",fontFamily:"inherit",boxSizing:"border-box",outline:"none"};
  const errInp={...inp,borderColor:"#ef4444"};
  const lbl=t=><div style={{fontSize:".65rem",fontWeight:700,color:"#64748b",marginBottom:2,textTransform:"uppercase",letterSpacing:".3px"}}>{t}</div>;
  const handleSave=async ()=>{
    const errs={};
    rows.forEach((r,i)=>{
      if(!r.note?.trim()) errs[`${i}_note`]=true;
      if(!(Number(String(r.pricePerQty||0).replace(/,/g,""))||0)) errs[`${i}_price`]=true;
    });
    if(Object.keys(errs).length){setErrors(errs);return;}
    // Duplicate guard — a freshly logged expense doesn't surface in Daily Payables
    // until it's routed, so users sometimes re-enter it thinking the first save failed.
    // Warn before persisting a row that matches an existing expense (same date, amount,
    // and particulars/supplier). Skipped in edit mode (editing an expense IS itself).
    if(!editId){
      const norm=s=>String(s||"").trim().toLowerCase().replace(/\s+/g," ");
      const dupes=rows.map((r,i)=>{
        const q=Number(String(r.qty||1).replace(/,/g,""))||1;
        const p=Number(String(r.pricePerQty||0).replace(/,/g,""))||0;
        const amt=Math.round((q*p)*100)/100;
        if(!amt) return null;
        const match=exps.find(e=>Math.round((Number(e.amount||0))*100)/100===amt
          && (e.expDate||"")===(r.expDate||"")
          && norm(e.note)===norm(r.note)
          && norm(e.supplier||e.payee)===norm(r.supplier||r.payee));
        return match?{i,row:r,amt,match}:null;
      }).filter(Boolean);
      if(dupes.length){
        const lines=dupes.map(d=>`  • #${d.i+1}  ${d.row.expDate||"—"}  ${d.row.supplier||d.row.payee||d.row.note||"—"}  ₱${fmt(d.amt)}`).join("\n");
        const msg=`⚠️ Possible duplicate${dupes.length>1?"s":""} — the following already exist in your expenses:\n\n${lines}\n\nA logged expense won't show in Daily Payables until it's routed for payment, so it may already be saved. Save ${dupes.length>1?"these anyway":"it anyway"}?`;
        if(!(await uiConfirm(msg))) return;
      }
    }
    if(editId){
      const r=rows[0];const q=Number(String(r.qty||1).replace(/,/g,""))||1;const p=Number(String(r.pricePerQty||0).replace(/,/g,""))||0;
      _setExpForm(()=>({...r,amount:q*p,qty:q,pricePerQty:p}));onSave({...r,amount:q*p,qty:q,pricePerQty:p});
    } else {
      onSaveAll(rows);
    }
  };
  const printExpLog=()=>{
    const printRows=rows.filter(r=>r.note?.trim());
    const total=printRows.reduce((s,r)=>s+rowAmt(r),0);
    const dateNow=new Date().toLocaleDateString("en-PH",{year:"numeric",month:"long",day:"numeric"});
    const projName=r=>projList.find(d=>d.id===r.projectId)?((p=>((p.contact||p.client||"")+(p.ceNo?" · "+p.ceNo:"")))(projList.find(d=>d.id===r.projectId))):"Company-wide";
    const rows_html=printRows.map((r,i)=>`
      <tr>
        <td style="text-align:center">${i+1}</td>
        <td>${r.expDate||""}</td>
        <td>${r.supplier||r.payee||"—"}</td>
        <td>${projName(r)}</td>
        <td>${r.note||""}</td>
        <td style="text-align:center">${r.qty||1}</td>
        <td style="text-align:right">₱${fmt(r.pricePerQty||0)}</td>
        <td>${r.tin||""}</td>
        <td style="text-align:right;font-weight:700">₱${fmt(rowAmt(r))}</td>
        <td>${r.remarks||""}</td>
      </tr>`).join("");
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Expense Log</title>
    <style>
      @page{size:A4 landscape;margin:15mm}
      body{font-family:Arial,sans-serif;font-size:10pt;color:#0f172a;margin:0}
      h1{font-size:16pt;margin:0 0 2px}
      .meta{font-size:9pt;color:#475569;margin-bottom:12px}
      table{width:100%;border-collapse:collapse;font-size:9pt}
      th{background:#1e293b;color:#fff;padding:7px 8px;text-align:left;font-size:8pt;text-transform:uppercase;letter-spacing:.4px}
      td{padding:6px 8px;border-bottom:1px solid #e2e8f0;vertical-align:top}
      tr:nth-child(even) td{background:#f8fafc}
      .total-row td{background:#f1f5f9;font-weight:700;border-top:2px solid #1e293b}
      .footer{margin-top:20px;font-size:8pt;color:#94a3b8;text-align:right}
    </style></head><body>
    <h1>📝 EXPENSE LOG</h1>
    <div class="meta">Printed: ${dateNow} &nbsp;|&nbsp; ${printRows.length} expense${printRows.length!==1?"s":""} &nbsp;|&nbsp; GMD PRO</div>
    <table>
      <thead><tr>
        <th style="width:30px">#</th>
        <th>Date</th><th>Supplier / Payee</th><th>Project</th>
        <th>Particulars</th><th style="text-align:center">QTY</th>
        <th style="text-align:right">Price/QTY</th><th>TIN</th>
        <th style="text-align:right">Total</th><th>Remarks</th>
      </tr></thead>
      <tbody>${rows_html}</tbody>
      <tfoot><tr class="total-row">
        <td colspan="8" style="text-align:right">GRAND TOTAL</td>
        <td style="text-align:right">₱${fmt(total)}</td>
        <td></td>
      </tr></tfoot>
    </table>
    <div class="footer">Generated by FabHub · GMD PRO</div>
    </body></html>`;
    const w=window.open("","_blank","width=1000,height=700");
    w.document.write(html);w.document.close();addPrintClose(w);w.focus();setTimeout(()=>w.print(),400);
  };
  return(
    <Modal open={open} onClose={onClose} title={editId?"Edit Expense":`Log Expenses`} maxWidth={820}>
      {rows.map((r,i)=>(
        <div key={i} style={{border:`1.5px solid ${Object.keys(errors).some(k=>k.startsWith(i+"_"))?"#ef4444":"#e2e8f0"}`,borderRadius:12,marginBottom:10,overflow:"hidden"}}>
          <div style={{background:"#f8fafc",padding:"7px 12px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid #e2e8f0"}}>
            <span style={{fontWeight:700,color:"#475569",fontSize:".78rem"}}>#{i+1}</span>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              {rowAmt(r)>0&&<span style={{fontWeight:800,color:"#059669",fontSize:".82rem"}}>₱{fmt(rowAmt(r))}</span>}
              {rows.length>1&&<button onClick={()=>removeRow(i)} style={{background:"#fee2e2",border:"none",borderRadius:5,width:22,height:22,cursor:"pointer",color:"#dc2626",fontSize:".85rem",lineHeight:1,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>}
            </div>
          </div>
          <div style={{padding:"10px 12px"}}>
            <div style={{display:"grid",gridTemplateColumns:"130px 1fr 1fr",gap:7,marginBottom:7}}>
              <div>{lbl("Date")}<input type="date" value={r.expDate||""} onChange={e=>upRow(i,"expDate",e.target.value)} style={inp}/></div>
              <div>{lbl("Supplier / Payee")}<input list="expSupplierOptions" value={r.supplier||r.payee||""} onChange={e=>{upRow(i,"supplier",e.target.value);upRow(i,"payee",e.target.value);}} placeholder="e.g. Wilcon Home Depot — new names are added to Suppliers" style={inp}/></div>
              <div>{lbl("Project")}<SearchSelect value={r.projectId||null} onChange={v=>upRow(i,"projectId",v)} options={projList.map(d=>({value:d.id,label:(d.contact||d.client||"")+(d.ceNo?` · ${d.ceNo}`:"")}))} placeholder="Type to search projects…" noneLabel="— Company-wide —" noneValue={null}/></div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 72px 120px 110px",gap:7,marginBottom:7}}>
              <div>{lbl("Particulars *")}<input value={r.note||""} onChange={e=>{upRow(i,"note",e.target.value);setErrors(p=>({...p,[`${i}_note`]:false}));}} placeholder="Description of expense" style={errors[`${i}_note`]?errInp:inp}/></div>
              <div>{lbl("QTY")}<input type="number" value={r.qty||"1"} onChange={e=>upRow(i,"qty",e.target.value)} min="0" style={inp}/></div>
              <div>{lbl("Price / QTY (₱) *")}<input type="number" value={r.pricePerQty||""} onChange={e=>{upRow(i,"pricePerQty",e.target.value);setErrors(p=>({...p,[`${i}_price`]:false}));}} placeholder="0.00" style={errors[`${i}_price`]?errInp:inp}/></div>
              <div>{lbl("Total")}<div style={{padding:"6px 9px",background:"#f0fdf4",borderRadius:7,fontWeight:800,color:"#059669",fontSize:".82rem",border:"1.5px solid #bbf7d0",height:30,display:"flex",alignItems:"center"}}>{rowAmt(r)>0?"₱"+fmt(rowAmt(r)):"—"}</div></div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:expenseAccounts.length?"1fr 1fr 1fr auto":"1fr 1fr auto",gap:7,alignItems:"end"}}>
              <div>{lbl("Category")}<select value={r.category||"Materials"} onChange={e=>upRow(i,"category",e.target.value)} style={{...inp,background:"#fff"}}>{EXP_CATS.map(c=><option key={c}>{c}</option>)}</select></div>
              {expenseAccounts.length>0&&<div>{lbl("Account")}<select value={r.accountCode||""} onChange={e=>upRow(i,"accountCode",e.target.value)} style={{...inp,background:"#fff"}}><option value="">— None —</option>{expenseAccounts.map(a=><option key={a.id} value={a.code}>{a.code} · {a.name}</option>)}</select></div>}
              <div>{lbl("Bank Account")}<select value={r.bankAccount||""} onChange={e=>upRow(i,"bankAccount",e.target.value||null)} style={{...inp,background:"#fff"}}><option value="">— Cash / untagged —</option>{BANKS.map(b=><option key={b.id} value={b.id}>{b.short}</option>)}</select></div>
              <button onClick={()=>upRow(i,"_exp",!r._exp)} style={{background:r._exp?"#eff6ff":"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 11px",cursor:"pointer",fontSize:".7rem",fontWeight:700,color:"#64748b",fontFamily:"inherit",whiteSpace:"nowrap",marginTop:14}}>{r._exp?"▲ less":"▼ more"}</button>
            </div>
            {r._exp&&(
              <>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7,marginTop:7,paddingTop:7,borderTop:"1px dashed #e2e8f0"}}>
                <div>{lbl("TIN (optional)")}<input value={r.tin||""} onChange={e=>upRow(i,"tin",e.target.value)} placeholder="Supplier TIN" style={inp}/></div>
                <div>{lbl("Remarks (optional)")}<input value={r.remarks||""} onChange={e=>upRow(i,"remarks",e.target.value)} placeholder="Additional notes" style={inp}/></div>
                <div>{lbl("Receipt Link (optional)")}<input type="url" value={r.receipt||""} onChange={e=>upRow(i,"receipt",e.target.value)} placeholder="Google Drive link…" style={inp}/></div>
              </div>
              {/* BIR tax capture — input VAT (creditable) + EWT withheld */}
              <div style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:10,marginTop:7,alignItems:"end"}}>
                <label style={{display:"flex",alignItems:"center",gap:6,fontSize:".75rem",fontWeight:700,color:"#475569",cursor:"pointer",whiteSpace:"nowrap",paddingBottom:6}}>
                  <input type="checkbox" checked={!!r.vatable} onChange={e=>upRow(i,"vatable",e.target.checked)} style={{width:16,height:16}}/>
                  VAT-inclusive (12%)
                </label>
                <div>{lbl("EWT (withholding)")}<select value={r.ewtRate||0} onChange={e=>upRow(i,"ewtRate",Number(e.target.value))} style={{...inp,background:"#fff"}}>{EWT_RATES.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}</select></div>
              </div>
              {(r.vatable||Number(r.ewtRate)>0)&&rowAmt(r)>0&&(()=>{
                const tx=calcInputTax(rowAmt(r),r.vatable,r.ewtRate);
                return(
                  <div style={{display:"flex",flexWrap:"wrap",gap:12,marginTop:7,padding:"8px 11px",background:"#f8fafc",borderRadius:8,fontSize:".72rem",color:"#475569"}}>
                    <span>Net of VAT: <strong>₱{fmt(tx.net)}</strong></span>
                    {tx.inputVat>0&&<span>Input VAT: <strong style={{color:"#2563eb"}}>₱{fmt(tx.inputVat)}</strong></span>}
                    {tx.ewtAmount>0&&<span>EWT withheld: <strong style={{color:"#b45309"}}>−₱{fmt(tx.ewtAmount)}</strong></span>}
                    <span>Net payable to supplier: <strong style={{color:"#059669"}}>₱{fmt(tx.netPayable)}</strong></span>
                  </div>
                );
              })()}
              </>
            )}
          </div>
        </div>
      ))}
      <button onClick={addRow} style={{width:"100%",padding:"9px",border:"2px dashed #cbd5e1",borderRadius:10,background:"#f8fafc",cursor:"pointer",color:"#475569",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",marginBottom:14}}>＋ Add Another Expense</button>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",borderTop:"2px solid #e2e8f0",paddingTop:12}}>
        <div>
          <div style={{fontSize:".65rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase"}}>Grand Total</div>
          <div style={{fontWeight:900,fontSize:"1.1rem",color:"#059669"}}>₱{fmt(grandTotal)}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={onClose} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 16px",fontFamily:"inherit",fontWeight:600,fontSize:".82rem",cursor:"pointer",color:"#475569"}}>Cancel</button>
          <button onClick={printExpLog} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer",color:"#475569"}}>🖨 Print</button>
          <button onClick={handleSave} style={{background:"#0f172a",border:"none",borderRadius:8,padding:"8px 20px",color:"#facc15",fontFamily:"inherit",fontWeight:800,fontSize:".84rem",cursor:"pointer"}}>
            {editId?"Save Changes":`Save ${rows.length} Expense${rows.length!==1?"s":""}`}
          </button>
        </div>
      </div>
      <datalist id="expSupplierOptions">{suppliers.map(s=><option key={s.id} value={s.companyName}/>)}</datalist>
    </Modal>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────

// Deal completeness — checks which key fields are filled

// ── ERROR BOUNDARY ──────────────────────────────────────────────────────────
class ErrorBoundary extends React.Component{
  constructor(p){super(p);this.state={err:null};}
  static getDerivedStateFromError(e){return{err:e};}
  componentDidCatch(e,info){console.error("FabHub render error:",e,info);try{logClientError(e,info,"app-root");}catch(_){}}
  render(){
    if(this.state.err) return(
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#f8fafc",fontFamily:"'Segoe UI',sans-serif"}}>
        <div style={{background:"#fff",borderRadius:16,padding:32,maxWidth:480,textAlign:"center",border:"1.5px solid #fecaca",boxShadow:"0 8px 32px rgba(0,0,0,.1)"}}>
          <div style={{fontSize:"2.5rem",marginBottom:12}}>⚠️</div>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.1rem",marginBottom:8}}>Something went wrong</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginBottom:20,lineHeight:1.6}}>
            {this.state.err?.message||"Unknown error"}
          </div>
          <button onClick={()=>{this.setState({err:null});window.location.reload();}}
            style={{background:"#1e293b",border:"none",borderRadius:8,padding:"10px 24px",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:".9rem"}}>
            🔄 Reload FabHub
          </button>
          <div style={{marginTop:12,fontSize:".75rem",color:"#94a3b8"}}>
            If this keeps happening, send a screenshot to your system admin.
          </div>
        </div>
      </div>
    );
    return this.props.children;
  }
}

// ── PER-VIEW ERROR BOUNDARY ───────────────────────────────────────────────
// The top-level ErrorBoundary (index.js / above) is a last resort: any throw
// inside it blanks the ENTIRE app. This lighter boundary wraps only the active
// view's content (inside Wrap), so a render error in one page (e.g. BOQ)
// degrades to a small inline card while the sidebar/nav stay usable and every
// OTHER page keeps working. Render it with key={page} so navigating away
// mounts a fresh instance and clears the error automatically.
class ViewErrorBoundary extends React.Component{
  constructor(p){super(p);this.state={err:null};}
  static getDerivedStateFromError(e){return{err:e};}
  componentDidCatch(e,info){
    console.error("FabHub view error:",e,info);
    // Best-effort crash telemetry — logClientError is itself fail-safe.
    try{ logClientError(e,info,this.props.view); }catch(_){}
  }
  render(){
    if(this.state.err) return(
      <div style={{background:"#fff",borderRadius:14,padding:"28px 24px",maxWidth:520,margin:"32px auto",textAlign:"center",border:"1.5px solid #fecaca",boxShadow:"0 4px 20px rgba(0,0,0,.06)"}}>
        <div style={{fontSize:"2rem",marginBottom:10}}>⚠️</div>
        <div style={{fontWeight:800,color:"#0f172a",fontSize:"1rem",marginBottom:8}}>This page hit an error</div>
        <div style={{color:"#64748b",fontSize:".82rem",marginBottom:18,lineHeight:1.6}}>
          The rest of FabHub is still working — your other pages and unsaved changes are unaffected. You can go back to the dashboard and try again.
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
          {this.props.onHome&&<button onClick={()=>{this.setState({err:null});this.props.onHome();}}
            style={{background:"#1e293b",border:"none",borderRadius:8,padding:"9px 20px",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:".85rem"}}>← Back to Dashboard</button>}
          <button onClick={()=>window.location.reload()}
            style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 20px",color:"#334155",cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:".85rem"}}>🔄 Reload</button>
        </div>
        <div style={{marginTop:16,fontSize:".72rem",color:"#94a3b8",wordBreak:"break-word"}}>{this.state.err?.message||"Unknown error"}</div>
      </div>
    );
    return this.props.children;
  }
}

// ── SYSTEM HEALTH ────────────────────────────────────────────────────────────
// Manager-only view over the `client_errors` crash-telemetry table. The app's
// error boundaries and the global window handlers already CAPTURE crashes; this
// surfaces them in-app so they're read instead of sitting unseen in Supabase.
// Read-only, fail-safe: if the table is absent or the read fails, it shows an
// empty/So-far-so-good state rather than erroring.
function SystemHealthView({session}){
  const[rows,setRows]=React.useState(null);   // null = loading, [] = loaded empty
  const[failed,setFailed]=React.useState(false);
  const[copied,setCopied]=React.useState(false);
  const load=React.useCallback(async()=>{
    setFailed(false);
    if(!isSupabaseReady()){setRows([]);return;}
    try{
      const data=await sbList('client_errors',{order:'created_at',asc:false,limit:100});
      setRows(Array.isArray(data)?data:[]);
    }catch(_){setRows([]);setFailed(true);}
  },[]);
  React.useEffect(()=>{load();},[load]);

  const fmtWhen=(ts)=>{try{return new Date(ts).toLocaleString("en-PH",{month:"short",day:"numeric",hour:"numeric",minute:"2-digit"});}catch{return ts||"—";}};
  const shortUA=(ua)=>{if(!ua)return"";const m=ua.match(/(Chrome|Firefox|Safari|Edg|Samsung|Mobile)[\/ ]?([\d.]*)/g);return m?m.slice(0,2).join(" · "):ua.slice(0,40);};

  // 24-hour and 7-day counts for the header tiles.
  const now=Date.now();
  const within=(ts,ms)=>{const t=new Date(ts).getTime();return !isNaN(t)&&(now-t)<=ms;};
  const c24=(rows||[]).filter(r=>within(r.created_at,864e5)).length;
  const c7d=(rows||[]).filter(r=>within(r.created_at,7*864e5)).length;

  // One-tap copy of the whole recent log, formatted so it can be pasted straight
  // into a chat with Claude / a dev to diagnose.
  const copyAll=async()=>{
    const text=(rows||[]).map(r=>`[${fmtWhen(r.created_at)}] (${r.view||"?"}) ${r.message||""}\n  url: ${r.url||""}\n  ${(r.stack||"").split("\n").slice(0,4).join("\n  ")}`).join("\n\n");
    try{await navigator.clipboard.writeText(text||"No crashes logged.");setCopied(true);setTimeout(()=>setCopied(false),2000);}catch{}
  };

  const card={background:"#fff",border:"1px solid #e2e8f0",borderRadius:10,padding:"12px 14px"};
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,marginBottom:14}}>
        <div>
          <div style={{fontWeight:900,fontSize:"1.15rem",color:"#0f172a"}}>🩺 System Health</div>
          <div style={{fontSize:".78rem",color:"#64748b",marginTop:2}}>Crashes caught across the app. If a page ever misbehaves, check here and copy the log.</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={load} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#334155",cursor:"pointer"}}>🔄 Refresh</button>
          <button onClick={copyAll} disabled={!rows||rows.length===0} style={{background:!rows||rows.length===0?"#e2e8f0":"#1e293b",border:"none",borderRadius:8,padding:"8px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:!rows||rows.length===0?"#94a3b8":"#fff",cursor:!rows||rows.length===0?"default":"pointer"}}>{copied?"✓ Copied":"📋 Copy log"}</button>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:10,marginBottom:14}}>
        {[
          {l:"Crashes · last 24h",v:c24,c:c24>0?"#dc2626":"#16a34a"},
          {l:"Crashes · last 7 days",v:c7d,c:c7d>0?"#d97706":"#16a34a"},
          {l:"Shown (most recent)",v:(rows||[]).length,c:"#475569"},
        ].map(t=>(
          <div key={t.l} style={card}>
            <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:".5px",color:"#94a3b8",fontWeight:700}}>{t.l}</div>
            <div style={{fontWeight:900,fontSize:"1.5rem",color:t.c,marginTop:2}}>{rows===null?"…":t.v}</div>
          </div>
        ))}
      </div>

      {failed&&<div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:9,padding:"10px 13px",marginBottom:12,fontSize:".78rem",color:"#92400e"}}>Couldn't reach the crash log just now. Tap Refresh to retry.</div>}

      {rows===null?(
        <div style={{...card,textAlign:"center",color:"#94a3b8"}}>Loading…</div>
      ):rows.length===0?(
        <div style={{...card,textAlign:"center",padding:"32px 16px"}}>
          <div style={{fontSize:"2rem",marginBottom:8}}>✅</div>
          <div style={{fontWeight:800,color:"#0f172a"}}>No crashes logged</div>
          <div style={{fontSize:".8rem",color:"#64748b",marginTop:4}}>Nothing has crashed that the app captured. That's the good state.</div>
        </div>
      ):(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {rows.map((r,i)=>(
            <div key={r.id||i} style={{...card,borderLeft:"3px solid #dc2626"}}>
              <div style={{display:"flex",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
                <span style={{fontWeight:800,color:"#0f172a",fontSize:".85rem",wordBreak:"break-word",flex:1,minWidth:200}}>{r.message||"Unknown error"}</span>
                <span style={{fontSize:".72rem",color:"#94a3b8",whiteSpace:"nowrap"}}>{fmtWhen(r.created_at)}</span>
              </div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:5}}>
                {r.view&&<span style={{fontSize:".64rem",fontWeight:700,color:"#6366f1",background:"#eef2ff",borderRadius:5,padding:"2px 7px"}}>{r.view}</span>}
                {r.url&&<span style={{fontSize:".64rem",color:"#94a3b8"}}>{String(r.url).replace(/^https?:\/\/[^/]+/,"")||"/"}</span>}
                {r.user_agent&&<span style={{fontSize:".64rem",color:"#cbd5e1"}}>{shortUA(r.user_agent)}</span>}
              </div>
              {r.stack&&<details style={{marginTop:6}}><summary style={{fontSize:".7rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>Stack trace</summary><pre style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:6,padding:"8px 10px",fontSize:".68rem",color:"#475569",overflowX:"auto",whiteSpace:"pre-wrap",wordBreak:"break-word",marginTop:5}}>{r.stack}</pre></details>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


// ── PM UPDATE MODAL (proper component — fixes focus loss from IIFE hooks) ──

// ── ACTIVITY HELPERS ──────────────────────────────────────────────────────

// ── ACTIVITY DASHBOARD ────────────────────────────────────────────────────
function ActivityDashboard({actLog,users,session,isMobile}){
  const[period,setPeriod]=React.useState("month");
  const[selRole,setSelRole]=React.useState("all");
  const now=new Date();
  let startDate;
  if(period==="month") startDate=new Date(now.getFullYear(),now.getMonth(),1);
  else if(period==="quarter"){const q=Math.floor(now.getMonth()/3);startDate=new Date(now.getFullYear(),q*3,1);}
  else startDate=new Date(now.getFullYear(),0,1);
  const startStr=startDate.toISOString().slice(0,10);
  const periodLog=(actLog||[]).filter(e=>e.date>=startStr);
  const scoreMap=periodLog.reduce((acc,e)=>{if(!e.by||e.by==="System")return acc;acc[e.by]=(acc[e.by]||0)+Math.max(0,ACT_SCORE[e.action]||1);return acc;},{});
  const countMap=periodLog.reduce((acc,e)=>{if(!e.by||e.by==="System")return acc;acc[e.by]=(acc[e.by]||0)+1;return acc;},{});
  const breakMap=periodLog.reduce((acc,e)=>{if(!e.by||e.by==="System")return acc;if(!acc[e.by])acc[e.by]={};acc[e.by][e.action]=(acc[e.by][e.action]||0)+1;return acc;},{});
  const lboard=(users||[]).filter(u=>u.status==="active").map(u=>({id:u.id,name:u.name,role:u.role,title:u.title||u.role,score:scoreMap[u.name]||0,count:countMap[u.name]||0,breakdown:breakMap[u.name]||{}})).sort((a,b)=>b.score-a.score);
  const roleGroups=[...new Set(lboard.map(u=>u.role))];
  const filtered=selRole==="all"?lboard:lboard.filter(u=>u.role===selRole);
  const top3=lboard.filter(u=>u.score>0).slice(0,3);
  const periodLabel={month:"This Month",quarter:"This Quarter",year:"This Year"}[period];
  const MEDALS=["🥇","🥈","🥉"];
  const podiumOrder=top3.length===3?[top3[1],top3[0],top3[2]]:top3;
  return(
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:isMobile?"1.5rem":"1.8rem",color:"#0f172a"}}>📈 Team Activity</div>
          <div style={{fontSize:".78rem",color:"#94a3b8",marginTop:2}}>{periodLabel} · {lboard.filter(u=>u.score>0).length} active contributors</div>
        </div>
        <div style={{display:"flex",gap:4,background:"#f1f5f9",borderRadius:10,padding:3}}>
          {[["month","Month"],["quarter","Quarter"],["year","Year"]].map(([k,l])=>(
            <button key={k} onClick={()=>setPeriod(k)} style={{padding:"6px 14px",border:"none",borderRadius:8,fontFamily:"inherit",fontSize:".78rem",fontWeight:period===k?700:500,background:period===k?"#0f172a":"transparent",color:period===k?"#fff":"#64748b",cursor:"pointer"}}>{l}</button>
          ))}
        </div>
      </div>
      {top3.length>0&&(
        <div style={{background:"linear-gradient(135deg,#1e293b 0%,#0f172a 100%)",borderRadius:16,padding:"20px 24px",marginBottom:20}}>
          <div style={{fontSize:".7rem",fontWeight:800,color:"#475569",textTransform:"uppercase",letterSpacing:".1em",marginBottom:16}}>🏆 Top Performers · {periodLabel}</div>
          <div style={{display:"flex",gap:isMobile?8:20,justifyContent:"center",alignItems:"flex-end"}}>
            {podiumOrder.filter(Boolean).map(u=>{
              const rank=lboard.indexOf(u)+1;const clr=ROLE_CLR[u.role]||"#64748b";const isFirst=rank===1;
              return(
                <div key={u.id} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:6,maxWidth:isMobile?90:120}}>
                  <div style={{fontSize:isFirst?"1.8rem":"1.2rem"}}>{MEDALS[rank-1]}</div>
                  <div style={{width:isFirst?52:40,height:isFirst?52:40,borderRadius:"50%",background:clr+"33",border:`2.5px solid ${clr}`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:isFirst?"1.1rem":".85rem",color:clr}}>
                    {u.name.split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase()}
                  </div>
                  <div style={{textAlign:"center"}}>
                    <div style={{color:"#f8fafc",fontWeight:700,fontSize:isFirst?".9rem":".78rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:90}}>{u.name.split(" ")[0]}</div>
                    <div style={{color:clr,fontWeight:800,fontSize:isFirst?"1.15rem":".9rem"}}>{u.score}pts</div>
                    <div style={{color:"#475569",fontSize:".62rem"}}>{u.role}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:6,marginBottom:16,overflowX:"auto",paddingBottom:4}}>
        <button onClick={()=>setSelRole("all")} style={{whiteSpace:"nowrap",padding:"5px 12px",border:"none",borderRadius:20,fontFamily:"inherit",fontSize:".75rem",fontWeight:selRole==="all"?700:500,background:selRole==="all"?"#0f172a":"#f1f5f9",color:selRole==="all"?"#fff":"#64748b",cursor:"pointer"}}>All Roles</button>
        {roleGroups.map(r=>{const clr=ROLE_CLR[r]||"#64748b";return(
          <button key={r} onClick={()=>setSelRole(r===selRole?"all":r)} style={{whiteSpace:"nowrap",padding:"5px 12px",border:"none",borderRadius:20,fontFamily:"inherit",fontSize:".75rem",fontWeight:selRole===r?700:500,background:selRole===r?clr:clr+"22",color:selRole===r?"#fff":clr,cursor:"pointer"}}>{r}</button>
        );})}
      </div>
      <div style={{background:"#fff",borderRadius:16,border:"1.5px solid #e2e8f0",overflow:"hidden",marginBottom:20}}>
        <div style={{padding:"12px 16px",borderBottom:"1px solid #f1f5f9",background:"#f8fafc"}}>
          <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".9rem",color:"#0f172a"}}>Leaderboard · {selRole==="all"?"All Roles":selRole}</span>
        </div>
        {filtered.length===0&&<div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".85rem"}}>No activity data for this period.</div>}
        {filtered.map((u,idx)=>{
          const rank=lboard.indexOf(u)+1;const clr=ROLE_CLR[u.role]||"#64748b";
          const topAct=Object.entries(u.breakdown).sort((a,b)=>b[1]-a[1])[0];
          const isSelf=u.name===session?.name;
          return(
            <div key={u.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",borderBottom:"1px solid #f8fafc",background:isSelf?"rgba(245,158,11,.07)":idx===0?"rgba(16,185,129,.04)":"transparent"}}>
              <div style={{width:28,textAlign:"center",fontWeight:800,fontSize:rank<=3?"1rem":".82rem",color:rank<=3?"#f59e0b":"#94a3b8"}}>{rank<=3?MEDALS[rank-1]:rank}</div>
              <div style={{width:36,height:36,borderRadius:"50%",background:clr+"22",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".82rem",color:clr,flexShrink:0,border:isSelf?`2px solid ${clr}`:"2px solid transparent"}}>
                {u.name.split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase()}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:isSelf?800:700,fontSize:".85rem",color:"#0f172a",display:"flex",alignItems:"center",gap:5}}>
                  {u.name}
                  {isSelf&&<span style={{fontSize:".62rem",color:clr,background:clr+"22",borderRadius:10,padding:"1px 6px",fontWeight:700}}>You</span>}
                </div>
                <div style={{fontSize:".7rem",color:"#94a3b8"}}>{u.role}{topAct?` · ${topAct[0]} ×${topAct[1]}`:""}</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{fontWeight:800,color:u.score>0?clr:"#94a3b8",fontSize:".9rem"}}>{u.score} pts</div>
                <div style={{fontSize:".68rem",color:"#94a3b8"}}>{u.count} actions</div>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{background:"#fff",borderRadius:16,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{padding:"12px 16px",borderBottom:"1px solid #f1f5f9",background:"#f8fafc"}}>
          <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".9rem",color:"#0f172a"}}>Recent Activity</span>
        </div>
        {periodLog.length===0&&<div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".85rem"}}>No activity this {period}.</div>}
        {periodLog.slice(0,25).map((e,i)=>{
          const u=(users||[]).find(x=>x.name===e.by);const clr=ROLE_CLR[u?.role]||"#64748b";
          return(
            <div key={e.id||i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"8px 16px",borderBottom:"1px solid #f8fafc"}}>
              <div style={{width:28,height:28,borderRadius:"50%",background:clr+"22",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".68rem",color:clr,flexShrink:0,marginTop:1}}>
                {(e.by||"?").split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase()}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:".8rem",color:"#0f172a"}}><strong>{e.by}</strong> · <span style={{color:"#0ea5e9"}}>{e.action}</span></div>
                {e.detail&&<div style={{fontSize:".72rem",color:"#64748b",marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.detail}</div>}
              </div>
              <div style={{fontSize:".65rem",color:"#94a3b8",flexShrink:0,textAlign:"right",lineHeight:1.4}}>{e.date}<br/>{e.time}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── MY ACCOUNT PAGE (proper component — fixes focus loss) ─────────────────
function MyAccountPage({session,users,setUsers,upUsers:upUsersExt,setSession:setSessionExt,logActivity:logActivityExt,checkPw,hashPw,actLog,verifyCurrentPassword,onSetServerPw}){
          const[tab,setTab]=useState("password");
          const[curPw,setCurPw]=useState("");
          const[newPw,setNewPw]=useState("");
          const[confPw,setConfPw]=useState("");
          const[newName,setNewName]=useState(session?.name||"");
          const[newUsername,setNewUsername]=useState(session?.username||"");
          const[msg,setMsg]=useState(null); // {type:"success"|"error", text}
          const[showCur,setShowCur]=useState(false);
          const[showNew,setShowNew]=useState(false);

          const savePassword=async()=>{
            const u=users.find(x=>x.id===session?.userId);
            if(!u){setMsg({type:"error",text:"Session error. Please log out and log back in."});return;}
            if(!(await verifyCurrentPassword(u.username,curPw))){setMsg({type:"error",text:"Current password is incorrect."});return;}
            if(newPw.length<6){setMsg({type:"error",text:"New password must be at least 6 characters."});return;}
            if(newPw!==confPw){setMsg({type:"error",text:"New passwords do not match."});return;}
            if(newPw===curPw){setMsg({type:"error",text:"New password must be different from current password."});return;}
            // Write the authoritative bcrypt hash server-side; keep a local
            // SHA-256 only for offline login continuity.
            if(onSetServerPw){
              const ok=await onSetServerPw(u.id,newPw);
              if(!ok){setMsg({type:"error",text:"Couldn't reach the server to save your new password. Try again."});return;}
            }
            const newHash=await sha256Hash(newPw,u.username);
            (upUsersExt||setUsers)(us=>us.map(x=>x.id===u.id?{...x,passwordHash:newHash}:x));
            setCurPw(""); setNewPw(""); setConfPw("");
            setMsg({type:"success",text:"✅ Password changed successfully! Use your new password next time you log in."});
            logActivityExt&&logActivityExt(null,"Password Changed","User changed their password");
          };

          const saveProfile=()=>{
            if(!newName.trim()){setMsg({type:"error",text:"Name cannot be empty."});return;}
            if(!newUsername.trim()){setMsg({type:"error",text:"Username cannot be empty."});return;}
            const taken=users.find(x=>x.username.toLowerCase()===newUsername.toLowerCase().trim()&&x.id!==session?.userId);
            if(taken){setMsg({type:"error",text:"That username is already taken by another user."});return;}
            (upUsersExt||setUsers)(us=>us.map(x=>x.id===session?.userId?{...x,name:newName.trim(),username:newUsername.toLowerCase().trim()}:x));
            // Update session
            const newSess={...session,name:newName.trim(),username:newUsername.toLowerCase().trim()};
            setSessionExt&&setSessionExt(newSess);
            localStorage.setItem(KEYS.session,JSON.stringify(newSess));
            setMsg({type:"success",text:"✅ Profile updated successfully!"});
            logActivityExt&&logActivityExt(null,"Profile Updated","User updated their name/username");
          };

          // ── Personal stats computation ─────────────────────────────────
          const myRole=session?.role||"";
          const myName=session?.name||"";          const nowD=new Date();const mStart=new Date(nowD.getFullYear(),nowD.getMonth(),1).toISOString().slice(0,10);
          const myMonthLog=(actLog||[]).filter(e=>e.by===myName&&e.date>=mStart);
          const myScore=myMonthLog.reduce((s,e)=>s+Math.max(0,ACT_SCORE[e.action]||1),0);
          const myStreak=calcStreak(actLog,myName);
          const activeUsers=(users||[]).filter(u=>u.status==="active");
          const sameRole=activeUsers.filter(u=>u.role===myRole);
          const roleScores=sameRole.map(u=>({name:u.name,score:(actLog||[]).filter(e=>e.by===u.name&&e.date>=mStart).reduce((s,e)=>s+Math.max(0,ACT_SCORE[e.action]||1),0)})).sort((a,b)=>b.score-a.score);
          const myRoleRank=(roleScores.findIndex(u=>u.name===myName))+1||roleScores.length;
          const roleClr=ROLE_CLR[myRole]||"#64748b";

          return(
            <div style={{background:"#fff",borderRadius:16,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              {/* Profile banner */}
              <div style={{background:"#1e293b",padding:"20px 24px",display:"flex",alignItems:"center",gap:14}}>
                <div style={{width:52,height:52,borderRadius:"50%",background:"#0ea5e9",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:"#fff",flexShrink:0}}>
                  {(session?.name||"?").split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase()}
                </div>
                <div>
                  <div style={{fontWeight:700,color:"#fff",fontSize:"1rem"}}>{session?.name}</div>
                  <div style={{fontSize:".78rem",color:"#94a3b8",marginTop:2}}>@{session?.username}</div>
                  <div style={{display:"inline-block",marginTop:4,background:"rgba(255,255,255,.1)",borderRadius:20,padding:"2px 10px",fontSize:".7rem",fontWeight:700,color:"#f59e0b"}}>{session?.title||myRole}</div>
                </div>
              </div>
              {/* Stats strip */}
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",borderBottom:"1.5px solid #e2e8f0"}}>
                {[{icon:"⭐",val:myScore+" pts",lbl:"This Month"},{icon:"🏅",val:`#${myRoleRank} of ${sameRole.length}`,lbl:myRole},{icon:"🔥",val:myStreak+(myStreak===1?" day":" days"),lbl:"Streak"}].map(({icon,val,lbl})=>(
                  <div key={lbl} style={{padding:"12px 10px",textAlign:"center",borderRight:"1px solid #f1f5f9"}}>
                    <div style={{fontSize:"1.1rem",marginBottom:2}}>{icon}</div>
                    <div style={{fontWeight:800,fontSize:".88rem",color:roleClr}}>{val}</div>
                    <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>{lbl}</div>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div style={{display:"flex",borderBottom:"1.5px solid #e2e8f0"}}>
                {[["password","🔑 Change Password"],["profile","👤 Edit Profile"]].map(([t,l])=>(
                  <button key={t} onClick={()=>{setTab(t);setMsg(null);}}
                    style={{flex:1,padding:"12px",background:"transparent",border:"none",borderBottom:tab===t?"2.5px solid #0ea5e9":"2.5px solid transparent",fontFamily:"inherit",fontSize:".85rem",fontWeight:tab===t?700:400,color:tab===t?"#0ea5e9":"#64748b",cursor:"pointer"}}>
                    {l}
                  </button>
                ))}
              </div>

              <div style={{padding:"24px"}}>
                {msg&&(
                  <div style={{background:msg.type==="success"?"#f0fdf4":"#fef2f2",border:`1px solid ${msg.type==="success"?"#6ee7b7":"#fecaca"}`,borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:".85rem",color:msg.type==="success"?"#059669":"#dc2626",fontWeight:600}}>
                    {msg.text}
                  </div>
                )}

                {tab==="password"&&(
                  <div style={{display:"flex",flexDirection:"column",gap:16}}>
                    <div>
                      <label style={{display:"block",fontSize:".8rem",fontWeight:700,color:"#374151",marginBottom:6}}>Current Password <span style={{color:"#ef4444"}}>*</span></label>
                      <div style={{position:"relative"}}>
                        <input type={showCur?"text":"password"} value={curPw} onChange={e=>setCurPw(e.target.value)}
                          placeholder="Enter your current password"
                          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 40px 10px 14px",fontFamily:"inherit",fontSize:".88rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}
                          onFocus={e=>e.target.style.borderColor="#0ea5e9"}
                          onBlur={e=>e.target.style.borderColor="#e2e8f0"}/>
                        <button type="button" onClick={()=>setShowCur(v=>!v)}
                          style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:".85rem"}}>
                          {showCur?"🙈":"👁"}
                        </button>
                      </div>
                    </div>
                    <div>
                      <label style={{display:"block",fontSize:".8rem",fontWeight:700,color:"#374151",marginBottom:6}}>New Password <span style={{color:"#ef4444"}}>*</span></label>
                      <div style={{position:"relative"}}>
                        <input type={showNew?"text":"password"} value={newPw} onChange={e=>setNewPw(e.target.value)}
                          placeholder="At least 6 characters"
                          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 40px 10px 14px",fontFamily:"inherit",fontSize:".88rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}
                          onFocus={e=>e.target.style.borderColor="#0ea5e9"}
                          onBlur={e=>e.target.style.borderColor="#e2e8f0"}/>
                        <button type="button" onClick={()=>setShowNew(v=>!v)}
                          style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:".85rem"}}>
                          {showNew?"🙈":"👁"}
                        </button>
                      </div>
                      {/* Password strength indicator */}
                      {newPw&&(()=>{
                        const strength=newPw.length>=12&&/[A-Z]/.test(newPw)&&/[0-9]/.test(newPw)?"Strong":newPw.length>=8?"Good":newPw.length>=6?"Weak":"Too short";
                        const clr={"Strong":"#059669","Good":"#0ea5e9","Weak":"#f59e0b","Too short":"#ef4444"};
                        return <div style={{fontSize:".75rem",color:clr[strength],marginTop:4,fontWeight:600}}>Password strength: {strength}</div>;
                      })()}
                    </div>
                    <div>
                      <label style={{display:"block",fontSize:".8rem",fontWeight:700,color:"#374151",marginBottom:6}}>Confirm New Password <span style={{color:"#ef4444"}}>*</span></label>
                      <input type="password" value={confPw} onChange={e=>setConfPw(e.target.value)}
                        placeholder="Re-enter new password"
                        style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 14px",fontFamily:"inherit",fontSize:".88rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}
                        onFocus={e=>e.target.style.borderColor="#0ea5e9"}
                        onBlur={e=>e.target.style.borderColor="#e2e8f0"}/>
                      {confPw&&newPw&&(
                        <div style={{fontSize:".75rem",marginTop:4,fontWeight:600,color:confPw===newPw?"#059669":"#ef4444"}}>
                          {confPw===newPw?"✅ Passwords match":"❌ Passwords do not match"}
                        </div>
                      )}
                    </div>
                    <button onClick={savePassword}
                      style={{background:"#0ea5e9",border:"none",borderRadius:9,padding:"12px",fontFamily:"inherit",fontWeight:700,fontSize:".9rem",color:"#fff",cursor:"pointer",marginTop:4}}>
                      🔑 Change Password
                    </button>
                    <div style={{fontSize:".78rem",color:"#94a3b8",textAlign:"center"}}>
                      Forgot your password? Ask a Manager to reset it in the Manager → Accounts panel.
                    </div>
                  </div>
                )}

                {tab==="profile"&&(
                  <div style={{display:"flex",flexDirection:"column",gap:16}}>
                    <div>
                      <label style={{display:"block",fontSize:".8rem",fontWeight:700,color:"#374151",marginBottom:6}}>Display Name</label>
                      <input value={newName} onChange={e=>setNewName(e.target.value)}
                        placeholder="Your full name"
                        style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 14px",fontFamily:"inherit",fontSize:".88rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}
                        onFocus={e=>e.target.style.borderColor="#0ea5e9"}
                        onBlur={e=>e.target.style.borderColor="#e2e8f0"}/>
                      <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:4}}>This name appears on Job Orders, checklists, and activity logs.</div>
                    </div>
                    <div>
                      <label style={{display:"block",fontSize:".8rem",fontWeight:700,color:"#374151",marginBottom:6}}>Username</label>
                      <input value={newUsername} onChange={e=>setNewUsername(e.target.value.toLowerCase())}
                        placeholder="Your login username"
                        style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 14px",fontFamily:"inherit",fontSize:".88rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}
                        onFocus={e=>e.target.style.borderColor="#0ea5e9"}
                        onBlur={e=>e.target.style.borderColor="#e2e8f0"}/>
                      <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:4}}>Lowercase letters and numbers only. You will use this to log in.</div>
                    </div>
                    <div style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:8,padding:"10px 14px",fontSize:".8rem",color:"#64748b"}}>
                      🔒 Your <strong>role</strong> ({myRole}) can only be changed by a Manager.
                    </div>
                    <button onClick={saveProfile}
                      style={{background:"#0f172a",border:"none",borderRadius:9,padding:"12px",fontFamily:"inherit",fontWeight:700,fontSize:".9rem",color:"#fff",cursor:"pointer"}}>
                      💾 Save Profile
                    </button>
                  </div>
                )}
              </div>
            </div>
          );

}


// Stage / % Complete here are the project's real status: a changed stage goes
// through changeDealStage (set_deal_stage) and % Complete sets the project
// card's progress. They used to be stored only as text inside the update, so
// a PM could report "Installation" while the project still read Fabrication.
function PmUpdateModal({pmUpdateModal,setPmUpdateModal,session,logActivity:logActivityProp,addPmUpdate,updateProjectTurnover,sendTelegramNotification,deals=[],role,changeDealStage,setProjectProgress}){
  const deal=pmUpdateModal?.dealId?deals.find(d=>d.id===pmUpdateModal.dealId):null;
  const curStage=deal?.stage||"";
  // Awarded projects only: a pre-award deal enters Kickoff through the Award
  // flow (JO, award date), never from here.
  const canStage=!!(deal&&changeDealStage&&WON_STAGES.includes(curStage)&&canSetDealStage(role,curStage));
  const canPct=!!(deal&&setProjectProgress&&["Manager","ProjectMover","Operations","SalesOpsAdmin"].includes(role));
  const[saving,setSaving]=useState(false);
  const[updateType,setUpdateType]=useState(pmUpdateModal?.initialType||"General Progress");
  const[note,setNote]=useState("");
  const[nextSteps,setNextSteps]=useState("");
  const[stage,setStage]=useState("");
  const[pct,setPct]=useState("");
  const[revisedDate,setRevisedDate]=useState("");
  const[blockerDesc,setBlockerDesc]=useState("");
  const[decisionMaker,setDecisionMaker]=useState("");
  const[actionPlan,setActionPlan]=useState("");
  React.useEffect(()=>{
    if(pmUpdateModal){setUpdateType(pmUpdateModal.initialType||"General Progress");setNote("");setNextSteps("");setStage(curStage);setPct("");setSaving(false);setRevisedDate("");setBlockerDesc("");setDecisionMaker("");setActionPlan("");}
  },[pmUpdateModal?.dealId]);
  if(!pmUpdateModal) return null;
  const typeColor=PM_TYPE_COLOR[updateType]||"#0ea5e9";
  const isBlocker=updateType==="Blocker";
  return(
    <Modal open title={`📝 Log Update — ${pmUpdateModal.dealName}`} onClose={()=>setPmUpdateModal(null)}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        {/* Update type selector */}
        <div>
          <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:6}}>Update Type <span style={{color:"#ef4444"}}>*</span></label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {PM_UPDATE_TYPES.map(t=>(
              <button key={t} onClick={()=>setUpdateType(t)} style={{border:`2px solid ${PM_TYPE_COLOR[t]}`,borderRadius:20,padding:"5px 14px",fontSize:".78rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",background:updateType===t?PM_TYPE_COLOR[t]:"#fff",color:updateType===t?"#fff":PM_TYPE_COLOR[t],transition:"all .15s"}}>
                {PM_TYPE_ICON[t]} {t}
              </button>
            ))}
          </div>
        </div>
        {deal&&(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Project Stage</label>
            {canStage?(
              <select value={stage} onChange={e=>setStage(e.target.value)} style={{width:"100%",border:`1.5px solid ${stage!==curStage?"#f97316":"#e2e8f0"}`,borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem"}}>
                {!PM_SETTABLE_STAGES.includes(curStage)&&<option value={curStage}>{curStage||"—"}</option>}
                {PM_SETTABLE_STAGES.map(s=><option key={s} value={s}>{s.replace(/^\d+ · /,"")}{s===curStage?" (current)":""}</option>)}
              </select>
            ):(
              <div style={{padding:"8px 12px",borderRadius:8,background:"#f8fafc",fontSize:".85rem",color:"#475569"}}>{curStage.replace(/^\d+ · /,"")||"—"}</div>
            )}
            {canStage&&stage!==curStage&&<div style={{fontSize:".72rem",color:"#f97316",marginTop:3,fontWeight:600}}>⚠ Moves the project to {stage.replace(/^\d+ · /,"")}.</div>}
          </div>
          {canPct&&<div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>% Complete <span style={{fontWeight:400,color:"#94a3b8"}}>(optional)</span></label>
            <input type="number" min="0" max="100" value={pct} onChange={e=>setPct(e.target.value)} placeholder="e.g. 45" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
          </div>}
        </div>
        )}
        <div>
          <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>What happened? <span style={{color:"#ef4444"}}>*</span></label>
          <textarea value={note} onChange={e=>setNote(e.target.value)} rows={3} placeholder="Deliveries, installations, issues, decisions, site status..." style={{width:"100%",border:`1.5px solid ${typeColor}`,borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem",resize:"vertical",boxSizing:"border-box"}}/>
        </div>
        {isBlocker&&(
          <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"12px 14px",display:"flex",flexDirection:"column",gap:10}}>
            <div style={{fontWeight:700,color:"#dc2626",fontSize:".82rem"}}>🚨 Blocker Details</div>
            <div>
              <label style={{fontSize:".78rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Describe the blocker</label>
              <textarea value={blockerDesc} onChange={e=>setBlockerDesc(e.target.value)} rows={2} placeholder="What exactly is blocked and why?" style={{width:"100%",border:"1.5px solid #fecaca",borderRadius:8,padding:"7px 10px",fontFamily:"inherit",fontSize:".82rem",resize:"vertical",boxSizing:"border-box"}}/>
            </div>
            <div>
              <label style={{fontSize:".78rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Who needs to decide?</label>
              <input value={decisionMaker} onChange={e=>setDecisionMaker(e.target.value)} placeholder="e.g. Paulo Garcia, Client, Architect..." style={{width:"100%",border:"1.5px solid #fecaca",borderRadius:8,padding:"7px 10px",fontFamily:"inherit",fontSize:".82rem",boxSizing:"border-box"}}/>
            </div>
            <div>
              <label style={{fontSize:".78rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Proposed action / solution</label>
              <textarea value={actionPlan} onChange={e=>setActionPlan(e.target.value)} rows={2} placeholder="What do we need to do to unblock?" style={{width:"100%",border:"1.5px solid #fecaca",borderRadius:8,padding:"7px 10px",fontFamily:"inherit",fontSize:".82rem",resize:"vertical",boxSizing:"border-box"}}/>
            </div>
          </div>
        )}
        <div>
          <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Next Steps / Action Items</label>
          <textarea value={nextSteps} onChange={e=>setNextSteps(e.target.value)} rows={2} placeholder="What needs to happen next? Who is responsible?" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem",resize:"vertical",boxSizing:"border-box"}}/>
        </div>
        <div>
          <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Revised Target Completion <span style={{fontWeight:400,color:"#94a3b8"}}>(optional)</span></label>
          <input type="date" value={revisedDate} onChange={e=>setRevisedDate(e.target.value)} style={{width:"100%",border:`1.5px solid ${revisedDate?"#f97316":"#e2e8f0"}`,borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
          {revisedDate&&<div style={{fontSize:".72rem",color:"#f97316",marginTop:3,fontWeight:600}}>⚠ This will update the project's target end date visible to Management.</div>}
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button onClick={()=>setPmUpdateModal(null)} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"9px 18px",fontFamily:"inherit",fontSize:".85rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>Cancel</button>
          <button disabled={saving} onClick={async()=>{
            if(saving) return;
            if(!note.trim()){toastEmit("Please enter what happened.","warning");return;}
            if(isBlocker&&!blockerDesc.trim()){toastEmit("Please describe the blocker.","warning");return;}
            const pctNum=String(pct).trim()===""?null:Math.round(Number(pct));
            if(pctNum!=null&&(!Number.isFinite(pctNum)||pctNum<0||pctNum>100)){toastEmit("% Complete must be between 0 and 100.","warning");return;}
            const dealId=pmUpdateModal.dealId;
            const stageChanged=canStage&&!!stage&&stage!==curStage;
            // Stage first: if the server refuses it (or a gate is cancelled),
            // nothing is logged and the modal stays open to adjust.
            if(stageChanged){
              setSaving(true);
              const ok=await changeDealStage(dealId,stage,{note:`[${updateType}] ${note.trim()}`});
              setSaving(false);
              if(!ok) return;
            }
            if(pctNum!=null&&canPct) setProjectProgress(dealId,pctNum);
            const entry={id:uid(),type:updateType,date:today,time:new Date().toLocaleTimeString("en-PH",{hour:"2-digit",minute:"2-digit"}),by:session?.name||"Team",stage:deal?(stage||curStage):"",pct:pctNum!=null?String(pctNum):"",note:note.trim(),nextSteps:nextSteps.trim(),revisedDate,...(isBlocker?{blockerDesc:blockerDesc.trim(),decisionMaker:decisionMaker.trim(),actionPlan:actionPlan.trim(),blockerStatus:"Open"}:{})};
            // One Telegram per update: skip the generic ops ping when a more
            // specific message (stage change, blocker, materials) goes to ops.
            const silent=stageChanged||isBlocker||updateType==="Materials Needed";
            logActivityProp&&logActivityProp(dealId,"PM Update",`[${updateType}] ${note.trim()}`,undefined,{silent});
            addPmUpdate&&addPmUpdate(dealId,entry);
            if(revisedDate&&updateProjectTurnover) updateProjectTurnover(dealId,revisedDate);
            if(isBlocker&&sendTelegramNotification){
              const msg=`🚨 <b>BLOCKER — ${pmUpdateModal.dealName}</b>\n${blockerDesc||note}\nDecision needed from: <b>${decisionMaker||"TBD"}</b>\nAction plan: ${actionPlan||"—"}\nLogged by: ${session?.name||"Team"}`;
              sendTelegramNotification("ops",msg);
              sendTelegramNotification("management",msg);
            }
            if(updateType==="Design Request"&&sendTelegramNotification) sendTelegramNotification("design",`🎨 <b>Design Request — ${pmUpdateModal.dealName}</b>\n${note}\nBy: ${session?.name||"Team"}`);
            if(updateType==="Materials Needed"&&sendTelegramNotification) sendTelegramNotification("ops",`📦 <b>Materials Needed — ${pmUpdateModal.dealName}</b>\n${note}\nBy: ${session?.name||"Team"}`);
            setPmUpdateModal(null);
            toastEmit(stageChanged?`Update logged — stage → ${stage.replace(/^\d+ · /,"")}`:"Update logged!");
          }} style={{opacity:saving?.6:1,background:typeColor,border:"none",borderRadius:8,padding:"9px 18px",fontFamily:"inherit",fontSize:".85rem",color:"#fff",cursor:"pointer",fontWeight:700}}>
            ✅ Submit Update
          </button>
        </div>
      </div>
    </Modal>
  );
}

// ─── ADDENDA PAGE CONTENT ─────────────────────────────────────────────────────
// Extracted from App IIFE to fix React hooks #310 — hooks must be at top level
function AddendaPageContent({role,wonDeals,deals,jos,session,addenda,upAddenda,updateAddendum,logActivity,onOpenCoBoq}){
  const canCreate=!["Sales","Finance"].includes(role);
  // Who may advance a change order's status (Discovered → … → Approved) from this
  // page. Sales, Ops and Management all speak to clients directly, so all three
  // can approve. (Server-side RLS must allow the same set — see migration 054.)
  const canApprove=["Manager","Sales","Operations","ProjectMover","SalesOpsAdmin"].includes(role)&&typeof updateAddendum==="function";
  const myName=session?.name||"";
  const myProjects=wonDeals.filter(d=>{
    const jo=dealJo(jos,d.id);
    return jo&&[jo.pm1,jo.pm2,jo.pm3,jo.coordinator].filter(Boolean).some(p=>
      p===myName||p.toLowerCase().includes((myName||"").split(" ")[0]?.toLowerCase()||""));
  });
  const[selDealId,setSelDealId]=React.useState(myProjects[0]?.id||wonDeals[0]?.id||"");
  const[title,setTitle]=React.useState("");
  const[desc,setDesc]=React.useState("");
  const[value,setValue]=React.useState("");
  const[kind,setKind]=React.useState("Additive");
  const[scopeItems,setScopeItems]=React.useState([]); // optional BOQ line items
  const[addSearch,setAddSearch]=React.useState("");
  const isDeduct=kind==="Deductive";
  const scopeTotal=scopeItems.reduce((s,it)=>s+(Number(it.qty)||0)*(Number(it.rate)||0),0);
  const addScopeRow=()=>setScopeItems(r=>[...r,{description:"",qty:1,unit:"lot",rate:""}]);
  const setScopeRow=(i,ch)=>setScopeItems(r=>r.map((it,j)=>j===i?{...it,...ch}:it));
  const delScopeRow=(i)=>setScopeItems(r=>r.filter((_,j)=>j!==i));

  // Linked child deals ARE the addendums (parentDealId set). They stay their own
  // live deals — created by Sales via "+ Add New Deal → Link to Parent Deal",
  // awarded and billed on their own — and roll into the parent's Total Contract
  // as a display line. Surface them here alongside legacy CO records so the log
  // is a complete ledger of every change order. A child in a won stage is an
  // approved addendum; otherwise it reflects its pipeline stage. They're
  // read-only in this log (managed from the Pipeline), flagged _linkedDeal.
  const childEntries=(deals||[]).filter(d=>d.parentDealId&&!isLostStage(d.stage)).map(d=>{
    const par=(deals||[]).find(p=>p.id===d.parentDealId);
    const won=WON_STAGES.includes(d.stage);
    return{
      id:d.id,dealId:d.parentDealId,
      title:d.contact||d.client||"Addendum",
      description:d.notes||"Addendum — linked deal with its own billing.",
      kind:"Additive",value:Math.abs(Number(d.value)||0),
      status:won?"Approved":(d.stage||"In pipeline"),
      discoveredBy:d.salesOwner||"",salesOwner:d.salesOwner||"",
      subAccount:(d.client&&par&&d.client!==par.client)?d.client:"",
      ceNo:d.ceNo||"",_linkedDeal:true,_won:won,
    };
  });
  const allEntries=[...addenda,...childEntries];
  const visibleAddenda=canCreate
    ?(["Manager","QS"].includes(role)?allEntries:allEntries.filter(a=>myProjects.find(d=>d.id===a.dealId)))
    :allEntries;
  const filteredAddenda=addSearch
    ?visibleAddenda.filter(a=>{const d=(deals||[]).find(x=>x.id===a.dealId);return[a.title,a.status,d?.client,d?.ceNo].join(" ").toLowerCase().includes(addSearch.toLowerCase());})
    :visibleAddenda;

  const statusClr={Discovered:"#f59e0b","Sales Notified":"#3b82f6","Client Coordinating":"#8b5cf6",Approved:"#059669",Billed:"#06b6d4",Collected:"#10b981",Rejected:"#ef4444","Linked — not converted":"#94a3b8"};
  const totalValue=filteredAddenda.reduce((s,a)=>s+coSignedValue(a),0);
  const fmtSigned=(v)=>`${v<0?"−":"+"}₱${Number(Math.abs(v)).toLocaleString("en-PH")}`;

  const AddendaList=()=>(
    <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
      <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontWeight:700,color:"#f59e0b",fontSize:".9rem"}}>📋 Change Order Log ({filteredAddenda.length}){totalValue!==0&&<span style={{fontSize:".72rem",color:"#94a3b8",marginLeft:8,fontWeight:400}}>{fmtSigned(totalValue)} net value adjustment</span>}</span>
      </div>
      <div style={{padding:"10px 14px",borderBottom:"1px solid #f1f5f9"}}>
        <input value={addSearch} onChange={e=>setAddSearch(e.target.value)} placeholder="Search by project, client, status…"
          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontSize:".82rem",boxSizing:"border-box"}}/>
      </div>
      {filteredAddenda.length===0
        ? <div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No scope changes found.</div>
        : (()=>{
            // Group scope changes by project (deal) so all addendum CEs for the same
            // project sit together instead of being scattered across a flat list.
            const groups=[];const byDeal={};
            filteredAddenda.forEach(a=>{
              if(!byDeal[a.dealId]){byDeal[a.dealId]={dealId:a.dealId,items:[]};groups.push(byDeal[a.dealId]);}
              byDeal[a.dealId].items.push(a);
            });
            return groups.map(g=>{
              const d=(deals||[]).find(x=>x.id===g.dealId)||wonDeals.find(x=>x.id===g.dealId);
              const grpTotal=g.items.reduce((s,a)=>s+coSignedValue(a),0);
              return(
                <div key={g.dealId||"unassigned"}>
                  <div style={{padding:"8px 16px",background:"#f8fafc",borderBottom:"1px solid #eef2f7",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".8rem",minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d?.client||"Unassigned"}{d?.ceNo?` · ${d.ceNo}`:""} <span style={{color:"#94a3b8",fontWeight:500}}>({g.items.length})</span></span>
                    {grpTotal!==0&&<span style={{fontSize:".72rem",color:grpTotal<0?"#dc2626":"#059669",fontWeight:700,whiteSpace:"nowrap",flexShrink:0}}>{fmtSigned(grpTotal)}</span>}
                  </div>
                  {g.items.map((a,i)=>(
                    <div key={a.id} style={{padding:"11px 16px 11px 24px",borderBottom:i<g.items.length-1?"1px solid #f8fafc":"1px solid #eef2f7"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>
                            <span style={{fontSize:".58rem",fontWeight:800,letterSpacing:".4px",color:a.kind==="Deductive"?"#dc2626":"#059669",background:(a.kind==="Deductive"?"#dc2626":"#059669")+"18",borderRadius:5,padding:"1px 6px",marginRight:6,verticalAlign:"middle"}}>{a.kind==="Deductive"?"− DEDUCT":"+ ADD"}</span>
                            {a.subAccount&&<span style={{fontSize:".58rem",fontWeight:800,letterSpacing:".3px",color:"#7c3aed",background:"#f5f3ff",border:"1px solid #ddd6fe",borderRadius:5,padding:"1px 6px",marginRight:6,verticalAlign:"middle"}}>↳ {a.subAccount}</span>}
                            {a.title}
                          </div>
                          <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:1}}>By {a.discoveredBy||"—"}{a.salesOwner?` · AE: ${a.salesOwner}`:""}{a.awardedDate?` · awarded ${a.awardedDate}`:""}</div>
                          {a.description&&<div style={{fontSize:".75rem",color:"#64748b",marginTop:2,lineHeight:1.4}}>{a.description}</div>}
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:6,marginLeft:8,flexShrink:0}}>
                          {!a._linkedDeal&&canCreate&&onOpenCoBoq&&<button onClick={()=>onOpenCoBoq(a.id)} title="Build this change order's BOQ (sections, rate card, markup)" style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:6,padding:"3px 9px",fontSize:".66rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>🧮 BOQ{(a.coBoqData?.items?.length)?` (${a.coBoqData.items.length})`:""}</button>}
                          {!a._linkedDeal&&!canCreate&&onOpenCoBoq&&(a.coBoqData?.items?.length)>0&&<button onClick={()=>onOpenCoBoq(a.id,true)} title="View & print this change order's BOQ to send to the client" style={{background:"#f5f3ff",border:"1.5px solid #ddd6fe",borderRadius:6,padding:"3px 9px",fontSize:".66rem",fontWeight:700,color:"#7c3aed",cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>📄 Print BOQ</button>}
                          {a._linkedDeal&&<span title="This addendum is a linked deal, managed from the Sales Pipeline. It has its own billing and rolls into the parent's Total Contract when awarded." style={{fontSize:".62rem",fontWeight:700,color:"#0369a1",background:"#f0f9ff",border:"1px solid #bae6fd",borderRadius:6,padding:"2px 7px",whiteSpace:"nowrap"}}>🔗 linked deal</span>}
                          {canApprove&&!a._linkedDeal
                            ? <select value={a.status} title="Advance this change order's status. Set to Approved once the client agrees — it rolls into the contract and creates its billing claim."
                                onChange={e=>{const v=e.target.value;updateAddendum(a.id,v==="Approved"?{status:v,clientApproved:true}:{status:v});}}
                                style={{fontSize:".68rem",fontWeight:700,color:statusClr[a.status]||"#64748b",background:(statusClr[a.status]||"#64748b")+"18",border:`1px solid ${(statusClr[a.status]||"#64748b")}55`,borderRadius:20,padding:"2px 8px",fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>
                                {ADDENDUM_STATUSES.map(s=><option key={s} value={s}>{s}</option>)}
                              </select>
                            : <span style={{fontSize:".68rem",fontWeight:700,color:statusClr[a.status]||"#64748b",background:(statusClr[a.status]||"#64748b")+"18",borderRadius:20,padding:"2px 8px",whiteSpace:"nowrap"}}>{a.status}</span>}
                        </div>
                      </div>
                      {Number(a.value)>0&&<div style={{fontSize:".75rem",color:a.kind==="Deductive"?"#dc2626":"#059669",marginTop:3,fontWeight:600}}>{fmtSigned(coSignedValue(a))} {a._linkedDeal?(a._won?"additional (own billing)":"additional — pending award"):a.kind==="Deductive"?"deducted":"additional"}{Array.isArray(a.scopeItems)&&a.scopeItems.length?` · ${a.scopeItems.length} BOQ item${a.scopeItems.length>1?"s":""}`:""}</div>}
                    </div>
                  ))}
                </div>
              );
            });
          })()
      }
    </div>
  );

  if(!canCreate) return <AddendaList/>;

  return(
    <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:20}}>
      <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{background:isDeduct?"#b91c1c":"#dc2626",padding:"12px 16px"}}>
          <span style={{fontWeight:700,color:"#fff",fontSize:".9rem"}}>⚠️ Flag New Change Order</span>
        </div>
        <div style={{padding:"16px",display:"flex",flexDirection:"column",gap:12}}>
          <div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Project <span style={{color:"#ef4444"}}>*</span></label>
            <select value={selDealId} onChange={e=>setSelDealId(e.target.value)}
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem"}}>
              {(["Manager","QS"].includes(role)?wonDeals:myProjects).map(d=><option key={d.id} value={d.id}>{d.client} — {d.ceNo}</option>)}
            </select>
          </div>
          <div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Change Type <span style={{color:"#ef4444"}}>*</span></label>
            <div style={{display:"flex",gap:8}}>
              {CO_KINDS.map(k=>{const on=kind===k;const ded=k==="Deductive";return(
                <button key={k} type="button" onClick={()=>setKind(k)}
                  style={{flex:1,border:`1.5px solid ${on?(ded?"#dc2626":"#059669"):"#e2e8f0"}`,background:on?(ded?"#fef2f2":"#ecfdf5"):"#fff",color:on?(ded?"#b91c1c":"#047857"):"#64748b",borderRadius:8,padding:"9px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>
                  {ded?"− Deductive (credit / descope)":"+ Additive (added scope)"}
                </button>);})}
            </div>
          </div>
          <div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Change Order Title <span style={{color:"#ef4444"}}>*</span></label>
            <input value={title} onChange={e=>setTitle(e.target.value)} placeholder="e.g. Additional wall cladding — Unit B"
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem"}}/>
          </div>
          <div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Description <span style={{color:"#ef4444"}}>*</span></label>
            <textarea value={desc} onChange={e=>setDesc(e.target.value)} rows={3} placeholder="What changed? Where? Who requested it? Client verbal approval received?"
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem",resize:"vertical"}}/>
          </div>
          <div>
            <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>{isDeduct?"Estimated Deducted Value (₱)":"Estimated Additional Value (₱)"}</label>
            <input type="number" value={scopeItems.length?scopeTotal:value} onChange={e=>setValue(e.target.value)} disabled={scopeItems.length>0}
              placeholder="0 if unknown" title={scopeItems.length?"Auto-summed from scope line items below":""}
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".85rem",background:scopeItems.length?"#f8fafc":"#fff",color:scopeItems.length?"#64748b":"inherit"}}/>
          </div>
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
              <label style={{fontSize:".8rem",fontWeight:700,color:"#64748b"}}>Scope Line Items <span style={{fontWeight:400,color:"#94a3b8"}}>(optional — {isDeduct?"removed from":"added to"} BOQ on approval)</span></label>
              <button type="button" onClick={addScopeRow} style={{background:"#eef2ff",border:"none",borderRadius:6,padding:"3px 10px",fontSize:".72rem",color:"#4f46e5",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>+ Add line</button>
            </div>
            {scopeItems.map((it,i)=>(
              <div key={i} style={{display:"flex",gap:6,marginBottom:6,alignItems:"center"}}>
                <input value={it.description} onChange={e=>setScopeRow(i,{description:e.target.value})} placeholder="Description"
                  style={{flex:3,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"6px 8px",fontFamily:"inherit",fontSize:".78rem",minWidth:0}}/>
                <input type="number" value={it.qty} onChange={e=>setScopeRow(i,{qty:e.target.value})} placeholder="Qty"
                  style={{width:52,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"6px 6px",fontFamily:"inherit",fontSize:".78rem"}}/>
                <input value={it.unit} onChange={e=>setScopeRow(i,{unit:e.target.value})} placeholder="unit"
                  style={{width:52,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"6px 6px",fontFamily:"inherit",fontSize:".78rem"}}/>
                <input type="number" value={it.rate} onChange={e=>setScopeRow(i,{rate:e.target.value})} placeholder="Rate"
                  style={{width:74,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"6px 6px",fontFamily:"inherit",fontSize:".78rem"}}/>
                <button type="button" onClick={()=>delScopeRow(i)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".95rem",padding:"0 2px"}}>✕</button>
              </div>
            ))}
            {scopeItems.length>0&&<div style={{fontSize:".74rem",color:isDeduct?"#dc2626":"#059669",fontWeight:700,textAlign:"right"}}>Line total: {isDeduct?"−":"+"}₱{Number(scopeTotal).toLocaleString("en-PH")}</div>}
          </div>
          <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"10px 12px",fontSize:".8rem",color:"#92400e"}}>
            📣 Submitting this will notify: <strong>{wonDeals.find(d=>d.id===selDealId)?.salesOwner||"AE"}</strong> (AE) and <strong>Paolo Gomez</strong> for coordination. Once <strong>Approved</strong> it {isDeduct?"deducts from":"adds to"} the contract value{scopeItems.length?" and BOQ":""}; once <strong>Billed</strong> a milestone is generated automatically.
          </div>
          <button
            onClick={()=>{
              if(!title.trim()||!desc.trim()||!selDealId){toastEmit("Please fill in all required fields.","warning");return;}
              const deal=wonDeals.find(d=>d.id===selDealId);
              const cleanItems=scopeItems.filter(it=>(it.description||"").trim()).map(it=>({description:(it.description||"").trim(),qty:Number(it.qty)||0,unit:it.unit||"lot",rate:Number(it.rate)||0}));
              const magnitude=cleanItems.length?cleanItems.reduce((s,it)=>s+it.qty*it.rate,0):Math.abs(Number(value)||0);
              const coDup=findCrossMechanismCO({parentId:selDealId,value:magnitude,deals,addenda});
              if(coDup && !window.confirm(coDup+"\n\nLog this change order anyway?")) return;
              const newAdd={
                id:"add"+Date.now(),dealId:selDealId,
                title:title.trim(),description:desc.trim(),
                kind, value:magnitude, scopeItems:cleanItems,
                ceNo:deal?.ceNo||"",
                receiptType:deal?.receiptType||"OR",
                withholding:deal?.withholding||false,
                salesOwner:deal?.salesOwner||"",
                status:"Discovered",salesNotified:true,
                discoveredBy:session?.name||role,
              };
              upAddenda(as=>[...as,newAdd]);
              const ae=deal?.salesOwner||"AE";
              logActivity(selDealId,"Change Order Flagged",`${session?.name} flagged a ${kind.toLowerCase()} change order on ${deal?.client||"?"} (${deal?.ceNo||"?"}): "${title}" — Notifying ${ae} and Paolo Gomez.`);
              setTitle(""); setDesc(""); setValue(""); setKind("Additive"); setScopeItems([]);
              toastEmit("Change order logged! Notified Sales.","success");
            }}
            style={{background:isDeduct?"#b91c1c":"#dc2626",border:"none",borderRadius:8,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:"#fff",cursor:"pointer"}}>
            ⚠️ Submit Change Order
          </button>
        </div>
      </div>
      <AddendaList/>
    </div>
  );
}

// ─── ACCOUNTING HOME ─────────────────────────────────────────────────────────
function AcctHome({exps,vouchers,fmt,today,greeting,todayL,session,setPage,setFinTab,wonDeals,Wrap}){
  const[tab,setTab]=useState("cash");
  const cashItems=exps.filter(e=>e.acctStatus==="For Payment"&&e.paymentMethod!=="Check");
  const checkItems=vouchers.filter(v=>v.status==="For Release"||v.status==="Draft");
  const paidToday=exps.filter(e=>e.acctStatus==="Paid"&&e.expDate===today);
  const thisMonthExp=exps.filter(e=>{const d=new Date(e.expDate||`${e.year}-${String((e.month||0)+1).padStart(2,"0")}-01`);return d.getMonth()===new Date().getMonth()&&d.getFullYear()===new Date().getFullYear();}).reduce((s,e)=>s+Number(e.amount||0),0);
  const fmtAmt=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:0});
  return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"there"} 👋</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Accounting Dashboard · {todayL}</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <button onClick={()=>{setFinTab&&setFinTab("payables");setPage("finance");}} style={{background:"#6366f1",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📤 Accounts Payable</button>
          <button onClick={()=>setPage("checkvouchers")} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📄 Check Vouchers</button>
        </div>
      </div>
      {/* KPI strip */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
        {[
          {l:"Cash/BizLink For Payment", v:cashItems.length,        c:"#6366f1", icon:"💳"},
          {l:"Checks For Release",       v:checkItems.filter(v=>v.status==="For Release").length, c:"#f59e0b", icon:"📄"},
          {l:"Paid Today",               v:paidToday.length,        c:"#059669", icon:"✅"},
          {l:"Expenses This Month",      v:fmtAmt(thisMonthExp),    c:"#94a3b8", icon:"📊"},
        ].map(({l,v,c,icon})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px",border:`1.5px solid ${c}22`,textAlign:"center"}}>
            <div style={{fontSize:"1.1rem"}}>{icon}</div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:c,marginTop:4}}>{v}</div>
            <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
          </div>
        ))}
      </div>
      {/* Unified payables tabs */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{display:"flex",borderBottom:"1.5px solid #e2e8f0"}}>
          {[["cash",`💳 Cash / BizLink (${cashItems.length})`],["check",`📄 Check Vouchers (${checkItems.length})`],["paid",`✅ Paid Today (${paidToday.length})`]].map(([t,l])=>(
            <button key={t} onClick={()=>setTab(t)} style={{flex:1,padding:"12px",border:"none",borderBottom:tab===t?"2.5px solid #6366f1":"2.5px solid transparent",background:tab===t?"#f8fafc":"#fff",fontFamily:"inherit",fontSize:".78rem",fontWeight:tab===t?700:500,color:tab===t?"#6366f1":"#64748b",cursor:"pointer",transition:"all .12s"}}>{l}</button>
          ))}
        </div>
        <div style={{maxHeight:340,overflowY:"auto"}}>
          {tab==="cash"&&(cashItems.length===0
            ?<div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No cash/BizLink items pending payment.</div>
            :[...cashItems].sort((a,b)=>(a.expDate||"").localeCompare(b.expDate||"")).map((e,i)=>{
              const d=wonDeals.find(x=>x.id===e.dealId);
              const isOld=e.expDate&&e.expDate<today;
              return(
                <div key={e.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",borderBottom:i<cashItems.length-1?"1px solid #f1f5f9":"",background:isOld?"#fffbeb":"#fff"}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:600,fontSize:".83rem",color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.note||e.category||"Expense"}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:1}}>{e.expDate||"No date"} · {d?.client||e.dealId||"General"} · {e.paymentMethod||"Cash"}{isOld&&<span style={{color:"#d97706",fontWeight:700,marginLeft:6}}>⚠ Overdue</span>}</div>
                  </div>
                  <div style={{fontWeight:700,color:"#dc2626",fontSize:".85rem",flexShrink:0,marginLeft:12}}>{fmtAmt(e.amount)}</div>
                </div>
              );
            })
          )}
          {tab==="check"&&(checkItems.length===0
            ?<div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No check vouchers pending.</div>
            :checkItems.sort((a,b)=>(a.date||"").localeCompare(b.date||"")).map((v,i)=>(
              <div key={v.id} onClick={()=>setPage("checkvouchers")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",borderBottom:i<checkItems.length-1?"1px solid #f1f5f9":"",cursor:"pointer",background:"#fff"}}
                onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:600,fontSize:".83rem",color:"#0f172a"}}>{v.cvNo||"Draft"} · {v.payee||"—"}</div>
                  <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:1}}>{v.date||"No date"} · {v.bankAccount||"—"}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
                  <span style={{fontSize:".65rem",fontWeight:700,padding:"2px 7px",borderRadius:20,background:v.status==="For Release"?"#fffbeb":"#f1f5f9",color:v.status==="For Release"?"#d97706":"#64748b",border:`1px solid ${v.status==="For Release"?"#fde68a":"#e2e8f0"}`}}>{v.status}</span>
                  <div style={{fontWeight:700,color:"#dc2626",fontSize:".85rem"}}>{fmtAmt(v.amount)}</div>
                </div>
              </div>
            ))
          )}
          {tab==="paid"&&(paidToday.length===0
            ?<div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>Nothing marked as paid today yet.</div>
            :paidToday.map((e,i)=>{
              const d=wonDeals.find(x=>x.id===e.dealId);
              return(
                <div key={e.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",borderBottom:i<paidToday.length-1?"1px solid #f1f5f9":""}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:600,fontSize:".83rem",color:"#0f172a"}}>{e.note||e.category||"Expense"}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:1}}>{d?.client||"General"} · {e.paymentMethod||"Cash"}</div>
                  </div>
                  <div style={{fontWeight:700,color:"#059669",fontSize:".85rem",flexShrink:0,marginLeft:12}}>{fmtAmt(e.amount)}</div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </Wrap>
  );
}

// Read-only Audit Trail for soft-deleted financial records. Lazy-loads
// audit_log (so it doesn't slow app startup) and lets Finance restore a row.
function AuditTrailView({isMobile,fmt,setPage,restoreFinancial,labelFor,Wrap}){
  const[rows,setRows]=useState(null);
  const[busy,setBusy]=useState("");
  const load=useCallback(async()=>{
    if(!isSupabaseReady()){setRows([]);return;}
    setRows(null);
    const data=await sbList("audit_log",{order:"performed_at",limit:500});
    setRows(data||[]);
  },[]);
  useEffect(()=>{load();},[load]);
  const onRestore=async(r)=>{
    const amt=r.snapshot?.amount!=null?fmt(Number(r.snapshot.amount)):null;
    if(!(await uiConfirm(`Restore this ${labelFor(r.table_name)}${amt?` (${amt})`:""}, deleted ${r.performed_at?new Date(r.performed_at).toLocaleDateString("en-PH"):"previously"}${r.performed_by?` by ${r.performed_by}`:""}?\n\nReason given for deletion: ${r.reason||"—"}`))) return;
    setBusy(r.id);
    const ok=await restoreFinancial(r);
    setBusy("");
    if(ok) load();
  };
  return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>🕵️ Audit Trail</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Billing edits &amp; deletions — who, when, what changed. Deleted rows can be restored.</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={load} style={{background:"#475569",border:"none",borderRadius:9,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>↻ Refresh</button>
          <button onClick={()=>setPage("acctdash")} style={{background:"#0f172a",border:"none",borderRadius:9,padding:"8px 16px",color:"#facc15",fontFamily:"inherit",fontWeight:800,fontSize:".8rem",cursor:"pointer"}}>← Accounting</button>
        </div>
      </div>
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"auto"}}>
        {rows===null?(
          <div style={{padding:30,textAlign:"center",color:"#94a3b8"}}>Loading…</div>
        ):rows.length===0?(
          <div style={{padding:30,textAlign:"center",color:"#94a3b8"}}>Nothing recorded yet. Billing edits and deletions — and deletions of expenses, check vouchers, payables, loans, collections and inflows — will appear here.</div>
        ):(
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:isMobile?".72rem":".82rem"}}>
            <thead>
              <tr style={{background:"#f8fafc",textAlign:"left",color:"#64748b"}}>
                <th style={{padding:"9px 12px"}}>When</th>
                <th style={{padding:"9px 12px"}}>Type</th>
                <th style={{padding:"9px 12px"}}>Action</th>
                <th style={{padding:"9px 12px"}}>Amount</th>
                <th style={{padding:"9px 12px"}}>Reason / change</th>
                <th style={{padding:"9px 12px"}}>By</th>
                <th style={{padding:"9px 12px"}}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r=>{
                // action → badge label + colors. Older rows have no `action`
                // set for a delete, so default to Deleted.
                const badge=({
                  insert:{t:"Created",bg:"#eff6ff",c:"#2563eb"},
                  update:{t:"Edited", bg:"#fffbeb",c:"#b45309"},
                  restore:{t:"Restored",bg:"#f0fdf4",c:"#059669"},
                  delete:{t:"Deleted", bg:"#fef2f2",c:"#dc2626"},
                }[r.action])||{t:"Deleted",bg:"#fef2f2",c:"#dc2626"};
                const newAmt=Number(r.snapshot?.amount);
                const oldAmt=Number(r.old_snapshot?.amount);
                const amtChanged=r.action==="update"&&Number.isFinite(oldAmt)&&Number.isFinite(newAmt)&&oldAmt!==newAmt;
                const when=(r.performed_at||"").replace("T"," ").slice(0,16);
                // For edits, show which fields changed (amount rendered separately).
                const changed=(r.changed_fields||[]).filter(f=>!["updated_at","created_at"].includes(f));
                return(
                  <tr key={r.id} style={{borderTop:"1px solid #f1f5f9"}}>
                    <td style={{padding:"8px 12px",whiteSpace:"nowrap",color:"#475569"}}>{when}</td>
                    <td style={{padding:"8px 12px"}}>{labelFor(r.table_name)}</td>
                    <td style={{padding:"8px 12px"}}>
                      <span style={{padding:"2px 8px",borderRadius:20,fontSize:".68rem",fontWeight:700,background:badge.bg,color:badge.c}}>{badge.t}</span>
                    </td>
                    <td style={{padding:"8px 12px",fontWeight:700,color:"#0f172a",whiteSpace:"nowrap"}}>
                      {amtChanged?(
                        <span><span style={{color:"#94a3b8",textDecoration:"line-through",fontWeight:500}}>{fmt(oldAmt)}</span> → <span style={{color:"#b45309"}}>{fmt(newAmt)}</span></span>
                      ):Number.isFinite(newAmt)?fmt(newAmt):"—"}
                    </td>
                    <td style={{padding:"8px 12px",color:"#475569",maxWidth:260}}>
                      {r.action==="update"
                        ? (changed.length?<span>Changed: {changed.join(", ")}</span>:(r.reason||"—"))
                        : (r.reason||"—")}
                    </td>
                    <td style={{padding:"8px 12px",color:"#64748b"}}>{r.performed_by||"—"}</td>
                    <td style={{padding:"8px 12px"}}>
                      {r.action==="delete"&&(
                        <button disabled={busy===r.id} onClick={()=>onRestore(r)} style={{background:busy===r.id?"#cbd5e1":"#059669",border:"none",borderRadius:7,padding:"5px 12px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:busy===r.id?"default":"pointer"}}>{busy===r.id?"…":"Restore"}</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </Wrap>
  );
}

// ─── WORK-IN-PROGRESS (WIP) SCHEDULE ─────────────────────────────────────────
// The headline construction-finance report: per active project, compares
// earned revenue (contract × % complete) against what's actually been billed,
// surfacing over-billing (billed ahead of work — a liability) and under-billing
// (work done but not yet billed — revenue/cash to catch up).
// React.memo — this recomputes a full earned-vs-billed pass over every active
// project on every render; without memo it re-ran on any unrelated App
// re-render (e.g. typing in a search box elsewhere) even though its own
// inputs hadn't changed.
const WIPView=React.memo(function WIPView({wonDeals,projs,billings,exps,prs,overallProg,setPage,Wrap,isMobile}){
  const money=v=>"₱"+Math.round(Number(v)||0).toLocaleString("en-PH");
  const actualCostOf=(dealId)=>{
    const projExps=exps.filter(e=>e.projectId===dealId);
    const expensedPORefs=new Set(projExps.map(e=>e.poRef).filter(Boolean));
    let cost=projExps.reduce((s,e)=>s+(Number(e.amount)||0),0);
    prs.filter(p=>p.projectId===dealId&&p.status==="Delivered").forEach(p=>{
      if(!(p.poNumber&&expensedPORefs.has(p.poNumber))) cost+=(Number(p.actUnitCost)||Number(p.estUnitCost)||0)*(Number(p.qty)||0);
    });
    return cost;
  };
  const rows=wonDeals
    .filter(d=>d.stage!=="14 · Completed")
    .map(d=>{
      const p=projs[d.id];
      const pct=p?Math.max(0,Math.min(100,overallProg(p))):0;
      const contract=Number(d.value)||0;
      const billed=Number(d.invoiced)||0;
      const collected=Number(d.amountPaid)||0;
      const earned=Math.round(contract*pct/100);
      const overUnder=earned-billed;            // + = under-billed, − = over-billed
      const cost=actualCostOf(d.id);
      const uncollected=billed-collected;
      return {d,pct,contract,billed,collected,earned,overUnder,cost,uncollected};
    })
    .filter(r=>r.contract>0||r.billed>0)
    .sort((a,b)=>Math.abs(b.overUnder)-Math.abs(a.overUnder));

  const T=k=>rows.reduce((s,r)=>s+r[k],0);
  const totContract=T("contract"),totEarned=T("earned"),totBilled=T("billed"),totOverUnder=totEarned-totBilled,totUncollected=T("uncollected");

  const kpi=(l,v,c)=>(
    <div style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
      <div style={{fontWeight:800,fontSize:"1rem",color:c,lineHeight:1.3,wordBreak:"break-all"}}>{v}</div>
      <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
    </div>
  );
  const cell={padding:"9px 10px",fontSize:isMobile?".72rem":".8rem",textAlign:"right",whiteSpace:"nowrap"};
  const head={...cell,fontSize:".64rem",fontWeight:700,color:"rgba(255,255,255,.65)",textTransform:"uppercase",letterSpacing:".5px"};

  return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>📐 Work-in-Progress (WIP)</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Earned revenue vs billed — over/under-billing across active projects. % complete comes from each project's production progress.</div>
        </div>
        <button onClick={()=>setPage("acctdash")} style={{background:"#0f172a",border:"none",borderRadius:9,padding:"8px 16px",color:"#facc15",fontFamily:"inherit",fontWeight:800,fontSize:".8rem",cursor:"pointer"}}>← Accounting</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:18}}>
        {kpi("Contract Value (active)",money(totContract),"#0f172a")}
        {kpi("Earned to Date",money(totEarned),"#3b82f6")}
        {kpi("Billed to Date",money(totBilled),"#8b5cf6")}
        {kpi(totOverUnder>=0?"Net Under-billed (to bill)":"Net Over-billed (liability)",money(Math.abs(totOverUnder)),totOverUnder>=0?"#059669":"#ef4444")}
      </div>
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:760}}>
          <thead>
            <tr style={{background:"#1e293b"}}>
              <th style={{...head,textAlign:"left"}}>Project</th>
              <th style={head}>% Comp</th>
              <th style={head}>Contract</th>
              <th style={head}>Earned</th>
              <th style={head}>Billed</th>
              <th style={head}>Over / (Under)</th>
              <th style={head}>Cost to Date</th>
              <th style={head}>Uncollected</th>
            </tr>
          </thead>
          <tbody>
            {rows.length===0?(
              <tr><td colSpan={8} style={{padding:24,textAlign:"center",color:"#94a3b8"}}>No active projects with a contract value yet.</td></tr>
            ):rows.map(({d,pct,contract,billed,earned,overUnder,cost,uncollected})=>{
              const ouClr=overUnder>0?"#059669":overUnder<0?"#ef4444":"#64748b";
              return(
                <tr key={d.id} style={{borderTop:"1px solid #f1f5f9"}}>
                  <td style={{padding:"9px 10px",fontSize:isMobile?".72rem":".8rem"}}>
                    <div style={{fontWeight:700,color:"#0f172a"}}>{d.contact||d.client}</div>
                    <div style={{fontSize:".68rem",color:"#94a3b8"}}>{d.ceNo||"No CE"}</div>
                  </td>
                  <td style={cell}>{pct}%</td>
                  <td style={cell}>{money(contract)}</td>
                  <td style={cell}>{money(earned)}</td>
                  <td style={cell}>{money(billed)}</td>
                  <td style={{...cell,fontWeight:700,color:ouClr}}>{overUnder<0?"("+money(-overUnder)+")":money(overUnder)}</td>
                  <td style={cell}>{money(cost)}</td>
                  <td style={{...cell,color:uncollected>0?"#b45309":"#64748b"}}>{money(uncollected)}</td>
                </tr>
              );
            })}
          </tbody>
          {rows.length>0&&(
            <tfoot>
              <tr style={{background:"#0f172a"}}>
                <td style={{...cell,textAlign:"left",fontWeight:800,color:"#f59e0b"}}>TOTAL</td>
                <td style={cell}></td>
                <td style={{...cell,fontWeight:800,color:"#fff"}}>{money(totContract)}</td>
                <td style={{...cell,fontWeight:800,color:"#93c5fd"}}>{money(totEarned)}</td>
                <td style={{...cell,fontWeight:800,color:"#c4b5fd"}}>{money(totBilled)}</td>
                <td style={{...cell,fontWeight:800,color:totOverUnder>=0?"#4ade80":"#f87171"}}>{totOverUnder<0?"("+money(-totOverUnder)+")":money(totOverUnder)}</td>
                <td style={cell}></td>
                <td style={{...cell,fontWeight:800,color:"#fbbf24"}}>{money(totUncollected)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      <div style={{marginTop:12,fontSize:".74rem",color:"#64748b",lineHeight:1.6,background:"#f8fafc",borderRadius:10,padding:"11px 14px"}}>
        <strong>How to read this:</strong> <span style={{color:"#059669",fontWeight:700}}>Under-billed</span> (positive) = work earned but not yet invoiced — revenue/cash to catch up on. <span style={{color:"#ef4444",fontWeight:700}}>Over-billed</span> (in parentheses) = billed ahead of work done — a liability you still owe in production. Earned = Contract × % Complete (production progress).
      </div>
    </Wrap>
  );
});

// ─── DUE-DATE BACKFILL DIALOG ────────────────────────────────────────────────
// The Cash-Flow Forecast buckets each outstanding billing / payable by its due
// date. Anything with no due date has nowhere to land and gets treated as
// "now / overdue", quietly distorting the projection. This dialog lists every
// unpaid billing and payable that is MISSING a due date so Finance can fill them
// in one place. Openable from the forecast banner, Billing and Payables.
function DueDateBackfillModal({open,onClose,billings,payables,deals,updateMilestone,setPayableDueDate,toastEmit}){
  const peso=v=>"₱"+Math.round(Number(v)||0).toLocaleString("en-PH");
  const missBill=useMemo(()=>(billings||[]).filter(b=>{
    if(b.status==="Cancelled"||b.status==="Fully Paid") return false;
    return milestoneBalance(b,(deals||[]).find(d=>d.id===b.dealId))>0.5 && !b.dueDate;
  }),[billings,deals]);
  const missPay=useMemo(()=>(payables||[]).filter(p=>p.status!=="Paid"&&p.status!=="Cancelled"&&Number(p.amount)>0&&!p.dueDate),[payables]);
  const[edits,setEdits]=useState({});
  useEffect(()=>{ if(open) setEdits({}); },[open]);
  const dealName=id=>{const d=(deals||[]).find(x=>x.id===id);return d?(d.client||d.contact||""):"";};
  const setE=(k,v)=>setEdits(e=>({...e,[k]:v}));
  const filled=Object.values(edits).filter(Boolean).length;
  const save=()=>{
    let n=0;
    missBill.forEach(b=>{const v=edits["b:"+b.id];if(v){updateMilestone(b.id,{dueDate:v});n++;}});
    missPay.forEach(p=>{const v=edits["p:"+p.id];if(v){setPayableDueDate(p.id,v);n++;}});
    toastEmit&&toastEmit(n?`✅ Set due dates on ${n} item${n>1?"s":""} — forecast updated.`:"No due dates entered yet.",n?"success":"info");
    if(n) onClose();
  };
  const rowStyle={display:"grid",gridTemplateColumns:"1fr auto 150px",gap:10,alignItems:"center",padding:"8px 0",borderBottom:"1px solid #f1f5f9"};
  const sect=(title,color,rows,render)=>(
    <div style={{marginBottom:18}}>
      <div style={{fontWeight:800,fontSize:".78rem",color,textTransform:"uppercase",letterSpacing:".6px",marginBottom:6}}>{title} ({rows.length})</div>
      {rows.length===0
        ?<div style={{fontSize:".8rem",color:"#94a3b8",fontStyle:"italic",padding:"4px 0"}}>All caught up — none missing a due date.</div>
        :rows.map(render)}
    </div>
  );
  return(
    <Modal open={open} onClose={onClose} title="📅 Set Missing Due Dates" wide>
      <div style={{fontSize:".82rem",color:"#64748b",marginBottom:16,lineHeight:1.5}}>
        These unpaid items have <b>no due date</b>, so the Cash-Flow Forecast can't place them in the right week and treats them as due now. Set a date to fix the projection.
      </div>
      {sect("Expected Collections — Billings","#047857",missBill,b=>{
        const out=milestoneBalance(b,(deals||[]).find(d=>d.id===b.dealId));
        return(
          <div key={b.id} style={rowStyle}>
            <div style={{minWidth:0}}>
              <div style={{fontWeight:700,fontSize:".84rem",color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{dealName(b.dealId)||b.name||"Billing"}</div>
              <div style={{fontSize:".7rem",color:"#94a3b8"}}>{b.name||b.invoiceNo||""}{b.invoiceNo&&b.name?` · ${b.invoiceNo}`:""}</div>
            </div>
            <div style={{fontWeight:800,fontSize:".84rem",color:"#047857",fontVariantNumeric:"tabular-nums"}}>{peso(out)}</div>
            <Inp type="date" value={edits["b:"+b.id]||""} onChange={e=>setE("b:"+b.id,e.target.value)}/>
          </div>
        );
      })}
      {sect("Expected Payments — Payables","#b45309",missPay,p=>(
        <div key={p.id} style={rowStyle}>
          <div style={{minWidth:0}}>
            <div style={{fontWeight:700,fontSize:".84rem",color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.vendor||"Payable"}</div>
            <div style={{fontSize:".7rem",color:"#94a3b8"}}>{p.apNumber||p.poNumber||p.invoiceNumber||p.category||""}</div>
          </div>
          <div style={{fontWeight:800,fontSize:".84rem",color:"#b45309",fontVariantNumeric:"tabular-nums"}}>{peso(p.amount)}</div>
          <Inp type="date" value={edits["p:"+p.id]||""} onChange={e=>setE("p:"+p.id,e.target.value)}/>
        </div>
      ))}
      <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:8}}>
        <button onClick={onClose} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"9px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:"#475569",cursor:"pointer"}}>Close</button>
        <button onClick={save} disabled={!filled} style={{background:filled?"#1f3864":"#cbd5e1",border:"none",borderRadius:8,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:"#fff",cursor:filled?"pointer":"not-allowed"}}>Save {filled||""} due date{filled===1?"":"s"}</button>
      </div>
    </Modal>
  );
}

// ─── CASH-FLOW FORECAST ──────────────────────────────────────────────────────
// Forward view of working cash: projects expected collections (outstanding
// billings) against expected payments (payables, uncleared checks, loan
// amortizations) week by week, flagging when the projected balance runs short.
function CashFlowView({billings,payables,vouchers,loans,cashPositions,setPage,Wrap,isMobile,onFixDueDates,deals=[]}){
  const money=v=>(v<0?"−₱":"₱")+Math.round(Math.abs(Number(v)||0)).toLocaleString("en-PH");
  const DAY=86400000, WEEKS=8;
  const start=new Date(); start.setHours(0,0,0,0);
  const today=start.getTime();
  const parse=d=>{ if(!d) return null; const t=new Date(d); return isNaN(t.getTime())?null:(t.setHours(0,0,0,0),t.getTime()); };

  // Opening working cash = latest reconciled position across operating banks
  const opening=(()=>{
    const days=Object.values(cashPositions||{}).filter(p=>p&&p.banks&&(p.date||"")<=today).sort((a,b)=>(b.date||"").localeCompare(a.date||""));
    if(!days[0]) return 0;
    return BANKS.filter(b=>b.type==="Operating").reduce((s,b)=>{const r=days[0].banks?.[b.id]||{};return s+(Number(r.book)||Number(r.end)||Number(r.beg)||0);},0);
  })();

  const flows=[];
  billings.filter(m=>m.status!=="Cancelled").forEach(m=>{
    // Expected CASH in: the milestone's receivable (VAT in, EWT out) less good payments.
    const out=Math.round(milestoneBalance(m,deals.find(d=>d.id===m.dealId))*100)/100;
    if(out>0.5) flows.push({date:parse(m.dueDate),amt:out,dir:"in",label:m.name||"Billing",ref:m.invoiceNo||""});
  });
  (payables||[]).filter(p=>p.status!=="Paid"&&Number(p.amount)>0).forEach(p=>{
    flows.push({date:parse(p.dueDate),amt:Number(p.amount),dir:"out",label:p.vendor||"Payable",ref:p.poNumber||p.invoiceRef||""});
  });
  (vouchers||[]).filter(v=>v.status==="Released"&&!v.isCleared&&Number(v.amount)>0).forEach(v=>{
    const exp=parse(v.clearedDate)||(parse(v.releasedDate)?parse(v.releasedDate)+3*DAY:today+3*DAY);
    flows.push({date:exp,amt:Number(v.amount),dir:"out",label:v.payee||"Check",ref:v.cvNo||""});
  });
  const horizonEnd=today+(WEEKS+4)*7*DAY;
  (loans||[]).forEach(l=>{
    const mp=Number(l.monthlyPayment)||0; if(mp<=0) return;
    let bal=(Number(l.principal)||0)-(l.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);
    if(bal<=0.5) return;
    const dd=l.disbursedDate?new Date(l.disbursedDate):start; const day=dd.getDate();
    let d=new Date(start.getFullYear(),start.getMonth(),day); d.setHours(0,0,0,0);
    if(d.getTime()<today) d=new Date(start.getFullYear(),start.getMonth()+1,day);
    let guard=0;
    while(d.getTime()<=horizonEnd&&bal>0.5&&guard++<24){
      const amt=Math.min(mp,bal);
      flows.push({date:d.getTime(),amt,dir:"out",label:l.lender||"Loan",ref:"Amortization"});
      bal-=amt; d=new Date(d.getFullYear(),d.getMonth()+1,day);
    }
  });

  // Flows with no due date can't be placed in a week — they fall into bucket 0
  // ("now/overdue") and skew the projection. Surface them so Finance can fix.
  const noDateIn =flows.filter(f=>f.dir==="in" &&f.date==null).reduce((s,f)=>s+f.amt,0);
  const noDateOut=flows.filter(f=>f.dir==="out"&&f.date==null).reduce((s,f)=>s+f.amt,0);
  const noDateCount=flows.filter(f=>f.date==null&&f.amt>0.5).length;

  const bucketOf=ms=>{ if(ms==null||ms<today) return 0; const w=Math.floor((ms-today)/(7*DAY))+1; return w>WEEKS?WEEKS+1:w; };
  const buckets=Array.from({length:WEEKS+2},(_,i)=>({i,in:0,out:0}));
  flows.forEach(f=>{ const b=buckets[bucketOf(f.date)]; if(f.dir==="in") b.in+=f.amt; else b.out+=f.amt; });
  let run=opening; let lowest=opening, crunchWk=null;
  buckets.forEach(b=>{ b.net=b.in-b.out; run+=b.net; b.close=run; if(run<lowest) lowest=run; if(b.close<0&&crunchWk==null&&b.i>0) crunchWk=b.i; });
  const bLabel=i=>{ if(i===0) return "Overdue / now"; if(i===WEEKS+1) return `Beyond ${WEEKS} wks`; const s=new Date(today+(i-1)*7*DAY),e=new Date(today+(i*7*DAY-DAY)); const f=dt=>dt.toLocaleDateString("en-PH",{month:"short",day:"numeric"}); return `Wk ${i} · ${f(s)}–${f(e)}`; };

  const horizon30=today+30*DAY;
  const in30=flows.filter(f=>f.dir==="in"&&(f.date==null||f.date<=horizon30)).reduce((s,f)=>s+f.amt,0);
  const out30=flows.filter(f=>f.dir==="out"&&f.date!=null&&f.date<=horizon30).reduce((s,f)=>s+f.amt,0);
  const bal30=opening+in30-out30;
  const upcoming=[...flows].filter(f=>f.amt>0).sort((a,b)=>((a.date??today)-(b.date??today))).slice(0,14);

  const kpi=(l,v,c,sub)=>(
    <div style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
      <div style={{fontWeight:800,fontSize:"1.05rem",color:c,lineHeight:1.3,wordBreak:"break-all"}}>{v}</div>
      <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
      {sub&&<div style={{fontSize:".7rem",color:"#94a3b8",marginTop:3}}>{sub}</div>}
    </div>
  );
  const cell={padding:"9px 12px",fontSize:isMobile?".74rem":".82rem",textAlign:"right",whiteSpace:"nowrap",fontVariantNumeric:"tabular-nums"};
  const head={...cell,fontSize:".64rem",fontWeight:700,color:"rgba(255,255,255,.65)",textTransform:"uppercase",letterSpacing:".5px"};
  const fdate=ms=>ms==null?"—":new Date(ms).toLocaleDateString("en-PH",{month:"short",day:"numeric"});

  return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>💵 Cash-Flow Forecast</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Projected working cash — collections in vs payments out, week by week.</div>
        </div>
        <button onClick={()=>setPage("acctdash")} style={{background:"#0f172a",border:"none",borderRadius:9,padding:"8px 16px",color:"#facc15",fontFamily:"inherit",fontWeight:800,fontSize:".8rem",cursor:"pointer"}}>← Accounting</button>
      </div>

      {crunchWk!=null&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,padding:"12px 16px",marginBottom:16,fontSize:".86rem",color:"#b91c1c",fontWeight:600}}>
          ⚠️ Projected cash goes negative around <strong>{bLabel(crunchWk)}</strong> (low point {money(lowest)}). Pull collections forward or defer payments.
        </div>
      )}

      {noDateCount>0&&(
        <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"12px 16px",marginBottom:16,display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:220,fontSize:".84rem",color:"#92400e",lineHeight:1.5}}>
            ⚠️ <strong>{noDateCount} item{noDateCount===1?"":"s"}</strong> ha{noDateCount===1?"s":"ve"} no due date
            {noDateIn>0.5&&<> — {money(noDateIn)} in collections</>}
            {noDateIn>0.5&&noDateOut>0.5?" and":""}
            {noDateOut>0.5&&<> {money(noDateOut)} in payments</>}
            {" "}counted as due now. Set due dates to sharpen the projection.
          </div>
          {onFixDueDates&&<button onClick={onFixDueDates} style={{background:"#b45309",border:"none",borderRadius:9,padding:"9px 16px",color:"#fff",fontFamily:"inherit",fontWeight:800,fontSize:".8rem",cursor:"pointer",whiteSpace:"nowrap"}}>📅 Set due dates</button>}
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:18}}>
        {kpi("Working cash now",money(opening),"#0f172a",opening===0?"Set cash position for accuracy":null)}
        {kpi("Collections (30d)",money(in30),"#059669")}
        {kpi("Payments due (30d)",money(out30),"#b45309")}
        {kpi("Projected balance (30d)",money(bal30),bal30<0?"#ef4444":"#059669")}
      </div>

      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflowX:"auto",marginBottom:18}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:560}}>
          <thead><tr style={{background:"#1e293b"}}>
            <th style={{...head,textAlign:"left"}}>Period</th>
            <th style={head}>In</th><th style={head}>Out</th><th style={head}>Net</th><th style={head}>Projected balance</th>
          </tr></thead>
          <tbody>
            {buckets.map(b=>(
              <tr key={b.i} style={{borderTop:"1px solid #f1f5f9",background:b.close<0?"#fff5f5":"#fff"}}>
                <td style={{padding:"9px 12px",fontSize:isMobile?".74rem":".82rem",fontWeight:b.i===0?700:500,color:"#0f172a"}}>{bLabel(b.i)}</td>
                <td style={{...cell,color:b.in?"#059669":"#cbd5e1"}}>{b.in?money(b.in):"—"}</td>
                <td style={{...cell,color:b.out?"#b45309":"#cbd5e1"}}>{b.out?money(b.out):"—"}</td>
                <td style={{...cell,fontWeight:600,color:b.net>0?"#059669":b.net<0?"#ef4444":"#64748b"}}>{b.net?money(b.net):"—"}</td>
                <td style={{...cell,fontWeight:800,color:b.close<0?"#ef4444":"#0f172a"}}>{money(b.close)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflowX:"auto"}}>
        <div style={{padding:"11px 16px",borderBottom:"1px solid #f1f5f9",fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>Next movements</div>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:520}}>
          <tbody>
            {upcoming.length===0?(
              <tr><td style={{padding:24,textAlign:"center",color:"#94a3b8"}}>No upcoming collections or payments on record.</td></tr>
            ):upcoming.map((f,idx)=>(
              <tr key={idx} style={{borderTop:"1px solid #f8fafc"}}>
                <td style={{padding:"8px 14px",width:64,color:"#64748b",fontSize:".76rem",whiteSpace:"nowrap"}}>{fdate(f.date)}</td>
                <td style={{padding:"8px 6px",width:30}}>{f.dir==="in"?"🟢":"🟠"}</td>
                <td style={{padding:"8px 10px",fontSize:isMobile?".76rem":".84rem"}}>
                  <div style={{fontWeight:600,color:"#0f172a"}}>{f.label}</div>
                  {f.ref&&<div style={{fontSize:".7rem",color:"#94a3b8"}}>{f.ref}</div>}
                </td>
                <td style={{padding:"8px 14px",textAlign:"right",fontWeight:700,fontVariantNumeric:"tabular-nums",color:f.dir==="in"?"#059669":"#b45309",whiteSpace:"nowrap"}}>{f.dir==="in"?"+":"−"}{money(f.amt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{marginTop:12,fontSize:".74rem",color:"#64748b",lineHeight:1.6,background:"#f8fafc",borderRadius:10,padding:"11px 14px"}}>
        <strong>Sources:</strong> collections = outstanding billings (by due date); payments = unpaid payables, released-but-uncleared checks (≈3 days to clear), and loan amortizations. Items with no due date show under “Overdue / now.” Opening cash uses your latest cash position (operating banks only).
      </div>
    </Wrap>
  );
}

// ─── DAILY SITE LOG ──────────────────────────────────────────────────────────
// A per-project site diary: manpower, work done, weather, delays, materials &
// equipment on site. The daily record that feeds progress, supports progress
// claims, and becomes the delay/dispute trail.
function DailySiteLogView({dailyLogs,wonDeals,addDailyLog,delDailyLog,session,role,Wrap,isMobile,setPage}){
  const todayStr=new Date().toISOString().slice(0,10);
  const canLog=["Manager","ProjectMover","Operations","Admin"].includes(role);
  const [projF,setProjF]=useState("all");
  const [show,setShow]=useState(false);
  const blank={dealId:wonDeals[0]?.id||"",date:todayStr,weather:WEATHER_OPTS[0],manpower:"",workDone:"",issues:"",materials:"",equipment:"",progressNote:""};
  const [f,setF]=useState(blank);
  const up=(k,v)=>setF(p=>({...p,[k]:v}));
  const dealName=id=>{const d=wonDeals.find(x=>x.id===id);return d?(d.contact||d.client||"—"):"—";};
  const logs=(dailyLogs||[]).filter(l=>projF==="all"||l.dealId===projF)
    .slice().sort((a,b)=>(b.date||"").localeCompare(a.date||"")||(b.createdAt||"").localeCompare(a.createdAt||""));
  const submit=()=>{
    if(!f.dealId){alert("Pick a project first.");return;}
    if(!f.workDone.trim()){alert("Describe the work done.");return;}
    addDailyLog({...f,manpower:Number(f.manpower)||0,loggedBy:session?.name||role||""});
    setF({...blank,dealId:f.dealId,date:f.date});
    setShow(false);
  };
  const inp={width:"100%",padding:"8px 10px",border:"1.5px solid #e2e8f0",borderRadius:8,fontSize:".85rem",fontFamily:"inherit",boxSizing:"border-box",outline:"none"};
  const lbl=t=><div style={{fontSize:".66rem",fontWeight:700,color:"#64748b",marginBottom:3,textTransform:"uppercase",letterSpacing:".3px"}}>{t}</div>;
  return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>📓 Daily Site Log</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Per-project site diary — manpower, work done, weather, delays. The daily record behind progress & claims.</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <select value={projF} onChange={e=>setProjF(e.target.value)} style={{...inp,width:"auto",background:"#fff"}}>
            <option value="all">All projects</option>
            {wonDeals.map(d=><option key={d.id} value={d.id}>{d.contact||d.client}</option>)}
          </select>
          {canLog&&<button onClick={()=>{setF({...blank,dealId:projF!=="all"?projF:(wonDeals[0]?.id||"")});setShow(s=>!s);}} style={{background:"#0f172a",border:"none",borderRadius:9,padding:"8px 16px",color:"#facc15",fontFamily:"inherit",fontWeight:800,fontSize:".8rem",cursor:"pointer",whiteSpace:"nowrap"}}>{show?"✕ Close":"+ New Log"}</button>}
        </div>
      </div>

      {show&&canLog&&(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:18,marginBottom:16}}>
          <div style={{fontWeight:800,color:"#0f172a",marginBottom:12}}>New Site Log Entry</div>
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"2fr 1fr 1fr 1fr",gap:10,marginBottom:10}}>
            <div>{lbl("Project *")}<select value={f.dealId} onChange={e=>up("dealId",e.target.value)} style={{...inp,background:"#fff"}}><option value="">— Select —</option>{wonDeals.map(d=><option key={d.id} value={d.id}>{d.contact||d.client} · {d.ceNo||""}</option>)}</select></div>
            <div>{lbl("Date")}<input type="date" value={f.date} onChange={e=>up("date",e.target.value)} style={inp}/></div>
            <div>{lbl("Weather")}<select value={f.weather} onChange={e=>up("weather",e.target.value)} style={{...inp,background:"#fff"}}>{WEATHER_OPTS.map(w=><option key={w}>{w}</option>)}</select></div>
            <div>{lbl("Manpower")}<input type="number" min="0" value={f.manpower} onChange={e=>up("manpower",e.target.value)} placeholder="0" style={inp}/></div>
          </div>
          <div style={{marginBottom:10}}>{lbl("Work accomplished today *")}<textarea rows={3} value={f.workDone} onChange={e=>up("workDone",e.target.value)} placeholder="What was completed on site today…" style={{...inp,resize:"vertical"}}/></div>
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10,marginBottom:10}}>
            <div>{lbl("Delays / issues")}<textarea rows={2} value={f.issues} onChange={e=>up("issues",e.target.value)} placeholder="Blockers, delays, safety, rework…" style={{...inp,resize:"vertical"}}/></div>
            <div>{lbl("Materials received")}<textarea rows={2} value={f.materials} onChange={e=>up("materials",e.target.value)} placeholder="Deliveries to site…" style={{...inp,resize:"vertical"}}/></div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10,marginBottom:12}}>
            <div>{lbl("Equipment on site")}<input value={f.equipment} onChange={e=>up("equipment",e.target.value)} placeholder="e.g. scaffold, welding set" style={inp}/></div>
            <div>{lbl("Progress note")}<input value={f.progressNote} onChange={e=>up("progressNote",e.target.value)} placeholder="e.g. ~60% fabrication done" style={inp}/></div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={submit} style={{background:"#059669",border:"none",borderRadius:9,padding:"9px 20px",color:"#fff",fontFamily:"inherit",fontWeight:800,fontSize:".85rem",cursor:"pointer"}}>Save Log</button>
            <button onClick={()=>setShow(false)} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 18px",color:"#475569",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {logs.length===0?(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:30,textAlign:"center",color:"#94a3b8"}}>No site logs yet{projF!=="all"?" for this project":""}. {canLog?"Tap “+ New Log” to record today’s site activity.":""}</div>
        ):logs.map(l=>{
          const canDel=role==="Manager"||l.loggedBy===session?.name;
          return(
            <div key={l.id} style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                <div style={{minWidth:0}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".92rem"}}>{dealName(l.dealId)}</div>
                  <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:1}}>{l.date} · {l.weather||""} · 👷 {l.manpower||0} on site · by {l.loggedBy||"—"}</div>
                </div>
                {canDel&&<button onClick={async ()=>{if((await uiConfirm("Delete this site log?")))delDailyLog(l.id);}} style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:7,padding:"3px 9px",color:"#dc2626",fontSize:".72rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>Delete</button>}
              </div>
              {l.workDone&&<div style={{fontSize:".85rem",color:"#334155",marginTop:8,lineHeight:1.5,whiteSpace:"pre-wrap"}}>{l.workDone}</div>}
              <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:8}}>
                {l.issues&&<span style={{fontSize:".76rem",background:"#fef2f2",color:"#b91c1c",border:"1px solid #fecaca",borderRadius:8,padding:"4px 9px"}}>⚠️ {l.issues}</span>}
                {l.materials&&<span style={{fontSize:".76rem",background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe",borderRadius:8,padding:"4px 9px"}}>📦 {l.materials}</span>}
                {l.equipment&&<span style={{fontSize:".76rem",background:"#f5f3ff",color:"#6d28d9",border:"1px solid #ddd6fe",borderRadius:8,padding:"4px 9px"}}>🔧 {l.equipment}</span>}
                {l.progressNote&&<span style={{fontSize:".76rem",background:"#f0fdf4",color:"#047857",border:"1px solid #bbf7d0",borderRadius:8,padding:"4px 9px"}}>📈 {l.progressNote}</span>}
              </div>
            </div>
          );
        })}
      </div>
    </Wrap>
  );
}

// ─── OFFICE TV WALL DISPLAY ───────────────────────────────────────────────────
// Fullscreen, touch-navigable dashboard built for the 65" office touchscreen.
// Rendered ONLY for the read-only "Display" kiosk account (see the render gate in
// App). Three panels — the construction/site calendar, awarded (won) projects,
// and announcements — laid out to fill the whole wall. No nav, no write actions:
// every piece of data it shows is already loaded into App state and kept live by
// the Supabase realtime subscriptions, so the board self-refreshes.
const TV_EVENT_COLORS={Installation:"#17998a",Repair:"#3b82f6",Punchlist:"#f59e0b",Construction:"#c0392b",Others:"#64748b",Turnover:"#3b82f6","PO Delivery":"#f97316","Billing Due":"#10b981","DRF Deadline":"#ec4899",Backjob:"#dc2626",Maintenance:"#f59e0b","Site Visit":"#0ea5e9",Inspection:"#8b5cf6","Site Meeting":"#059669"};
const TV_EVENT_ICONS={Installation:"🏗",Repair:"🔧",Punchlist:"📋",Construction:"🧱",Others:"📌",Turnover:"🏗","PO Delivery":"📦","Billing Due":"💵","DRF Deadline":"📝",Backjob:"🔄",Maintenance:"⚙️","Site Visit":"🏗","Inspection":"🔍","Site Meeting":"👥"};
const TV_OPS_TYPES=Object.keys(TV_EVENT_COLORS);
const TV_PRI_CLR={High:"#ef4444",Urgent:"#dc2626",Normal:"#0ea5e9",Low:"#64748b",Info:"#0ea5e9"};
const tvPeso=n=>{const v=Number(n||0);try{return "₱"+v.toLocaleString("en-PH",{maximumFractionDigits:0});}catch{return "₱"+Math.round(v);}};
const tvDayLabel=dateStr=>{if(!dateStr)return "";try{const d=new Date(dateStr+"T00:00:00");return d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});}catch{return dateStr;}};

const TV_JOB_TYPES=[{label:"Installation",code:"I"},{label:"Repair",code:"R"},{label:"Punchlist",code:"P"},{label:"Construction",code:"C"},{label:"Site Visit",code:"P"},{label:"Inspection",code:"P"},{label:"Site Meeting",code:"P"},{label:"Backjob",code:"R"},{label:"Others",code:"O"}];
// Weekly Field Board — mirrors ConstructionCalendar's field board. Every field
// job carries a top-level work code (I/R/P/C/O); auto-derived event types map
// onto a code via TV_CAT_FROM_TYPE.
const TV_WORK_CATEGORIES=[{code:"I",label:"Installation",color:"#17998a"},{code:"R",label:"Repair",color:"#3b82f6"},{code:"P",label:"Punchlist",color:"#f59e0b"},{code:"C",label:"Construction",color:"#c0392b"},{code:"O",label:"Others",color:"#64748b"}];
const TV_CAT_COLOR=Object.fromEntries(TV_WORK_CATEGORIES.map(c=>[c.code,c.color]));
const TV_CODE_FROM_LABEL=Object.fromEntries(TV_WORK_CATEGORIES.map(c=>[c.label,c.code]));
const TV_CAT_FROM_TYPE=t=>TV_CODE_FROM_LABEL[t]||({Turnover:"I","Site Visit":"P",Inspection:"P","Site Meeting":"P",Backjob:"R",Maintenance:"R"}[t])||"R";
const TV_DOW=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
const tvIsoDate=d=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
function OfficeTVDashboard({deals=[],wonDeals=[],checklists=[],announcements=[],today,todayL,onLogout,onAddJob}){
  const[tab,setTab]=React.useState("overview");
  const[now,setNow]=React.useState(()=>new Date());
  const[jobModal,setJobModal]=React.useState(false);
  const emptyJob={type:"Installation",dueDate:today,projectId:"",title:"",location:"",assignedTo:"",notes:""};
  const[jobForm,setJobForm]=React.useState(emptyJob);
  const openJob=()=>{setJobForm({...emptyJob,dueDate:today});setJobModal(true);};
  const saveJob=()=>{
    const hasProject=!!jobForm.projectId;
    const title=(jobForm.title||"").trim();
    if(!jobForm.dueDate){toastEmit("Pick a date for the job.","warning");return;}
    if(!hasProject&&!title){toastEmit("Choose a project or type a job title.","warning");return;}
    const meta=TV_JOB_TYPES.find(t=>t.label===jobForm.type)||TV_JOB_TYPES[0];
    onAddJob&&onAddJob({type:jobForm.type,category:meta.code,dueDate:jobForm.dueDate,projectId:jobForm.projectId||"",title:hasProject?"":title,workDetail:jobForm.notes||"",location:jobForm.location||"",assignedTo:jobForm.assignedTo||"",notes:jobForm.notes||"",status:"Scheduled"});
    toastEmit("Job added to the calendar.","success");
    setJobModal(false);
  };
  // ── Weekly Field Board ────────────────────────────────────────────────────
  const[boardMonday,setBoardMonday]=React.useState(()=>{const d=new Date(today+"T00:00:00");d.setDate(d.getDate()-((d.getDay()+6)%7));d.setHours(0,0,0,0);return d;});
  const boardDays=React.useMemo(()=>Array.from({length:6},(_,i)=>{const d=new Date(boardMonday);d.setDate(d.getDate()+i);return{date:tvIsoDate(d),dow:TV_DOW[d.getDay()],dd:`${String(d.getMonth()+1).padStart(2,"0")}.${String(d.getDate()).padStart(2,"0")}`};}),[boardMonday]);
  const boardJobs=React.useMemo(()=>{
    const start=boardDays[0]?.date,end=boardDays[5]?.date;const map={};boardDays.forEach(d=>map[d.date]=[]);
    if(!start||!end) return map;
    (checklists||[]).filter(c=>c.dept==="Operations"&&TV_OPS_TYPES.includes(c.type)&&c.dueDate&&c.dueDate>=start&&c.dueDate<=end).forEach(c=>{const cat=c.category||TV_CAT_FROM_TYPE(c.type);const proj=wonDeals.find(d=>d.id===c.projectId);(map[c.dueDate]=map[c.dueDate]||[]).push({...c,cat,projName:proj?.contact||proj?.client||c.title||"Untitled",client:proj?.client||""});});
    Object.values(map).forEach(a=>a.sort((x,y)=>(x.cat||"").localeCompare(y.cat||"")));
    return map;
  },[checklists,boardDays,wonDeals]);
  const boardCoordLoad=React.useMemo(()=>{const m={};Object.values(boardJobs).flat().forEach(j=>{const who=(j.assignedTo||"").trim();if(who)m[who]=(m[who]||0)+1;});return Object.entries(m).map(([name,count])=>({name,count})).sort((a,b)=>b.count-a.count);},[boardJobs]);
  const boardTotal=React.useMemo(()=>Object.values(boardJobs).reduce((s,a)=>s+a.length,0),[boardJobs]);
  const boardMaxLoad=boardCoordLoad.length?boardCoordLoad[0].count:0;
  const shiftWeek=n=>setBoardMonday(m=>{const d=new Date(m);d.setDate(d.getDate()+n*7);return d;});
  const thisMonday=()=>{const d=new Date(today+"T00:00:00");d.setDate(d.getDate()-((d.getDay()+6)%7));d.setHours(0,0,0,0);setBoardMonday(d);};
  const addJobOn=dateIso=>{setJobForm({...emptyJob,dueDate:dateIso});setJobModal(true);};

  // Live clock — ticks every second. Guarded new Date() is fine at runtime.
  React.useEffect(()=>{const t=setInterval(()=>setNow(new Date()),1000);return()=>clearInterval(t);},[]);

  // ── Upcoming site/ops calendar (from the checklists table) ────────────────
  const upcoming=React.useMemo(()=>{
    const rows=(checklists||[]).filter(c=>c.dept==="Operations"&&TV_OPS_TYPES.includes(c.type)&&c.dueDate&&c.status!=="Done"&&c.dueDate>=today);
    rows.sort((a,b)=>(a.dueDate||"").localeCompare(b.dueDate||""));
    const byDay={};
    rows.forEach(c=>{const proj=wonDeals.find(d=>d.id===c.projectId);(byDay[c.dueDate]=byDay[c.dueDate]||[]).push({...c,projName:proj?.contact||proj?.client||c.title||"Site work",client:proj?.client||""});});
    return Object.entries(byDay).slice(0,10).map(([date,items])=>({date,items}));
  },[checklists,wonDeals,today]);

  // ── Awarded / won projects ────────────────────────────────────────────────
  const awarded=React.useMemo(()=>{
    // Award date is the real awarded date only (project_cards.award_date) — no fallback to
    // dateAcquired. A won deal with no award date set shows blank and is excluded from the
    // "awarded this month" tally, rather than silently borrowing the lead-acquisition date.
    const rows=(wonDeals||[]).map(d=>({id:d.id,client:d.client||"—",name:d.contact||d.product||d.client||"Project",value:Number(d.value||0),stage:d.stage||"",date:d.awardDate||d.awardedDate||"",owner:d.salesOwner||"",location:d.location||""}));
    rows.sort((a,b)=>(b.date||"").localeCompare(a.date||""));
    return rows;
  },[wonDeals]);
  const awardTotal=React.useMemo(()=>awarded.reduce((s,d)=>s+d.value,0),[awarded]);
  const monthKey=today?.slice(0,7)||"";
  const awardedThisMonth=React.useMemo(()=>awarded.filter(d=>(d.date||"").slice(0,7)===monthKey),[awarded,monthKey]);

  // ── Announcements ─────────────────────────────────────────────────────────
  const notices=React.useMemo(()=>{
    const rows=[...(announcements||[])].filter(a=>a&&(a.title||a.body));
    rows.sort((a,b)=>((b.pinned?1:0)-(a.pinned?1:0))||((b.date||"").localeCompare(a.date||"")));
    return rows;
  },[announcements]);

  const C={bg:"#0b1220",panel:"#111c31",panel2:"#0f1830",border:"#1e2c48",text:"#f1f5f9",dim:"#94a3b8",amber:"#f59e0b",teal:"#17998a"};
  const shell={position:"fixed",inset:0,background:C.bg,color:C.text,fontFamily:"'Segoe UI',system-ui,sans-serif",display:"flex",flexDirection:"column",overflow:"hidden",zIndex:9999};
  const panel={background:C.panel,border:`1px solid ${C.border}`,borderRadius:18,display:"flex",flexDirection:"column",overflow:"hidden",minHeight:0};
  const panelHead={display:"flex",alignItems:"center",gap:12,padding:"18px 22px",borderBottom:`1px solid ${C.border}`,flexShrink:0};
  const panelTitle={fontFamily:"'Barlow Condensed','Segoe UI',sans-serif",fontWeight:800,fontSize:"1.7rem",letterSpacing:.3,textTransform:"uppercase"};
  const scroll={flex:1,overflowY:"auto",padding:"14px 20px",WebkitOverflowScrolling:"touch"};
  const clock=now.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"});
  const bigDate=now.toLocaleDateString("en-US",{weekday:"long",year:"numeric",month:"long",day:"numeric"});

  // ── Panel renderers ───────────────────────────────────────────────────────
  const CalendarPanel=({compact})=>(
    <div style={panel}>
      <div style={panelHead}><span style={{fontSize:"1.7rem"}}>📅</span><span style={panelTitle}>Site Calendar</span>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:14}}>
          <span style={{color:C.dim,fontSize:"1rem"}}>{upcoming.reduce((s,d)=>s+d.items.length,0)} upcoming</span>
          {onAddJob&&<button onClick={openJob} style={{background:C.teal,color:"#fff",border:"none",borderRadius:12,padding:"10px 18px",fontSize:"1.05rem",fontWeight:800,cursor:"pointer"}}>+ Add Job</button>}
        </div>
      </div>
      <div style={scroll}>
        {upcoming.length===0&&<div style={{color:C.dim,textAlign:"center",padding:"40px 0",fontSize:"1.2rem"}}>No scheduled site work.</div>}
        {upcoming.map(({date,items})=>(
          <div key={date} style={{marginBottom:18}}>
            <div style={{fontWeight:800,fontSize:"1.15rem",color:date===today?C.amber:C.text,marginBottom:8,display:"flex",alignItems:"center",gap:10}}>
              {tvDayLabel(date)} {date===today&&<span style={{fontSize:".8rem",background:C.amber,color:"#0b1220",padding:"2px 10px",borderRadius:20,fontWeight:800}}>TODAY</span>}
            </div>
            {items.slice(0,compact?3:20).map(it=>{const t=it.type;const clr=TV_EVENT_COLORS[t]||"#64748b";return(
              <div key={it.id} style={{display:"flex",alignItems:"center",gap:14,background:C.panel2,border:`1px solid ${C.border}`,borderLeft:`5px solid ${clr}`,borderRadius:12,padding:"12px 16px",marginBottom:8}}>
                <span style={{fontSize:"1.5rem"}}>{TV_EVENT_ICONS[t]||"📌"}</span>
                <div style={{minWidth:0,flex:1}}>
                  <div style={{fontWeight:700,fontSize:"1.15rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{it.projName}</div>
                  <div style={{color:C.dim,fontSize:".95rem"}}>{[it.location,it.assignedTo].filter(Boolean).join(" · ")||it.client}</div>
                </div>
                <span style={{fontSize:".85rem",fontWeight:700,color:clr,textTransform:"uppercase",whiteSpace:"nowrap"}}>{t}</span>
              </div>
            );})}
            {compact&&items.length>3&&<div style={{color:C.dim,fontSize:".9rem",paddingLeft:4}}>+{items.length-3} more…</div>}
          </div>
        ))}
      </div>
    </div>
  );

  const AwardedPanel=({compact})=>(
    <div style={panel}>
      <div style={panelHead}><span style={{fontSize:"1.7rem"}}>🏆</span><span style={panelTitle}>Awarded Projects</span></div>
      <div style={{display:"flex",gap:12,padding:"14px 20px 4px",flexShrink:0}}>
        <div style={{flex:1,background:C.panel2,border:`1px solid ${C.border}`,borderRadius:12,padding:"10px 14px"}}><div style={{color:C.dim,fontSize:".8rem",textTransform:"uppercase",letterSpacing:.5}}>Total Awarded</div><div style={{fontWeight:800,fontSize:"1.5rem",color:C.teal}}>{tvPeso(awardTotal)}</div></div>
        <div style={{flex:1,background:C.panel2,border:`1px solid ${C.border}`,borderRadius:12,padding:"10px 14px"}}><div style={{color:C.dim,fontSize:".8rem",textTransform:"uppercase",letterSpacing:.5}}>This Month</div><div style={{fontWeight:800,fontSize:"1.5rem",color:C.amber}}>{awardedThisMonth.length} · {tvPeso(awardedThisMonth.reduce((s,d)=>s+d.value,0))}</div></div>
      </div>
      <div style={scroll}>
        {awarded.length===0&&<div style={{color:C.dim,textAlign:"center",padding:"40px 0",fontSize:"1.2rem"}}>No awarded projects yet.</div>}
        {awarded.slice(0,compact?8:100).map((d,i)=>{const clr=(typeof STAGE_CLR!=="undefined"&&STAGE_CLR[d.stage])||C.teal;return(
          <div key={d.id} style={{display:"flex",alignItems:"center",gap:14,background:C.panel2,border:`1px solid ${C.border}`,borderRadius:12,padding:"12px 16px",marginBottom:8}}>
            <span style={{fontWeight:800,color:C.dim,fontSize:"1.1rem",width:28,textAlign:"right"}}>{i+1}</span>
            <div style={{minWidth:0,flex:1}}>
              <div style={{fontWeight:700,fontSize:"1.2rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{d.name}</div>
              <div style={{color:C.dim,fontSize:".95rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{d.client}{d.owner?` · ${d.owner}`:""}</div>
            </div>
            <div style={{textAlign:"right",whiteSpace:"nowrap"}}>
              <div style={{fontWeight:800,fontSize:"1.2rem",color:C.teal}}>{tvPeso(d.value)}</div>
              <div style={{fontSize:".8rem",fontWeight:700,color:clr,textTransform:"uppercase"}}>{(d.stage||"").replace(/^\d+\s·\s/,"")}</div>
            </div>
          </div>
        );})}
      </div>
    </div>
  );

  const NoticesPanel=()=>(
    <div style={panel}>
      <div style={panelHead}><span style={{fontSize:"1.7rem"}}>📢</span><span style={panelTitle}>Announcements</span></div>
      <div style={scroll}>
        {notices.length===0&&<div style={{color:C.dim,textAlign:"center",padding:"40px 0",fontSize:"1.2rem"}}>No announcements right now.</div>}
        {notices.map(a=>{const clr=TV_PRI_CLR[a.priority]||C.amber;return(
          <div key={a.id||a.title} style={{background:C.panel2,border:`1px solid ${C.border}`,borderLeft:`5px solid ${clr}`,borderRadius:12,padding:"14px 18px",marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
              {a.pinned&&<span title="Pinned" style={{fontSize:"1.1rem"}}>📌</span>}
              <span style={{fontWeight:800,fontSize:"1.25rem"}}>{a.title||"Notice"}</span>
              {a.priority&&<span style={{marginLeft:"auto",fontSize:".75rem",fontWeight:800,color:clr,textTransform:"uppercase",letterSpacing:.5}}>{a.priority}</span>}
            </div>
            {a.body&&<div style={{color:"#dbe4f0",fontSize:"1.1rem",lineHeight:1.5,whiteSpace:"pre-wrap"}}>{a.body}</div>}
            {(a.date||a.author)&&<div style={{color:C.dim,fontSize:".85rem",marginTop:6}}>{[a.author,a.date&&tvDayLabel(a.date)].filter(Boolean).join(" · ")}</div>}
          </div>
        );})}
      </div>
    </div>
  );

  const FieldBoardPanel=()=>{
    const wkNo=(()=>{const d=new Date(boardMonday);const oneJan=new Date(d.getFullYear(),0,1);return Math.ceil((((d-oneJan)/86400000)+oneJan.getDay()+1)/7);})();
    const rangeLbl=`${boardMonday.toLocaleDateString("en-PH",{month:"short",day:"numeric"})} – ${new Date(boardMonday.getTime()+5*86400000).toLocaleDateString("en-PH",{day:"numeric"})}`;
    const navBtn={background:C.panel2,color:C.text,border:`1px solid ${C.border}`,borderRadius:10,padding:"8px 16px",fontSize:"1rem",fontWeight:700,cursor:"pointer"};
    return(
      <div style={{...panel,height:"100%"}}>
        {/* Board header */}
        <div style={{display:"flex",flexWrap:"wrap",gap:12,alignItems:"flex-end",justifyContent:"space-between",padding:"16px 22px",borderBottom:`4px solid ${C.amber}`,flexShrink:0}}>
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,letterSpacing:".14em",fontSize:".8rem",color:C.amber,textTransform:"uppercase"}}>GMD Productions · Operations</div>
            <div style={{...panelTitle,fontSize:"2rem"}}>Weekly Field Board</div>
          </div>
          <div style={{textAlign:"right",lineHeight:1.3}}>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginBottom:6}}>
              <button onClick={()=>shiftWeek(-1)} style={navBtn}>‹</button>
              <button onClick={thisMonday} style={navBtn}>This week</button>
              <button onClick={()=>shiftWeek(1)} style={navBtn}>›</button>
            </div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:600,fontSize:"1.4rem"}}>WK {wkNo} · {rangeLbl}</div>
            <div style={{fontSize:".9rem",color:C.dim}}>{boardTotal} job{boardTotal!==1?"s":""} · {boardCoordLoad.length} coordinator{boardCoordLoad.length!==1?"s":""}</div>
          </div>
        </div>
        {/* Legend + coordinator load */}
        <div style={{display:"flex",flexWrap:"wrap",gap:16,justifyContent:"space-between",alignItems:"center",padding:"10px 22px",background:C.panel2,borderBottom:`1px solid ${C.border}`,flexShrink:0}}>
          <div style={{display:"flex",flexWrap:"wrap",gap:14}}>
            {TV_WORK_CATEGORIES.map(c=><span key={c.code} style={{display:"flex",alignItems:"center",gap:6,fontSize:".9rem",color:"#d7dee8",fontWeight:600}}><span style={{width:12,height:12,borderRadius:3,background:c.color}}/>{c.label}</span>)}
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,alignItems:"center"}}>
            <span style={{fontSize:".72rem",letterSpacing:".12em",textTransform:"uppercase",color:C.dim,fontWeight:700}}>Load</span>
            {boardCoordLoad.length===0&&<span style={{fontSize:".85rem",color:C.dim}}>— none assigned</span>}
            {boardCoordLoad.map(c=>{const hot=c.count>=Math.max(3,boardMaxLoad);return(<span key={c.name} style={{display:"flex",alignItems:"center",gap:6,background:hot?"rgba(245,158,11,.18)":"rgba(255,255,255,.06)",border:`1px solid ${hot?C.amber:C.border}`,padding:"3px 10px",borderRadius:20,fontSize:".9rem",fontWeight:600,color:hot?"#ffd9b8":C.text}}>{c.name} <b style={{color:hot?C.amber:C.text}}>{c.count}</b></span>);})}
          </div>
        </div>
        {/* Week grid */}
        <div style={{flex:1,minHeight:0,overflowY:"auto",padding:14}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:10,minHeight:"100%"}}>
            {boardDays.map(day=>{
              const jobs=boardJobs[day.date]||[];const isToday=day.date===today;const slack=jobs.length<=1;
              return(
                <div key={day.date} style={{background:C.panel2,border:`1px solid ${isToday?C.amber:C.border}`,borderRadius:12,display:"flex",flexDirection:"column",minHeight:220,overflow:"hidden"}}>
                  <div style={{padding:"10px 12px",background:isToday?"rgba(245,158,11,.14)":"rgba(255,255,255,.03)",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"baseline"}}>
                    <div>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",fontSize:"1.1rem",color:isToday?C.amber:C.text}}>{day.dow}</div>
                      <div style={{fontSize:".75rem",color:C.dim,fontFamily:"monospace"}}>{day.dd}</div>
                    </div>
                    <span style={{fontFamily:"monospace",fontSize:".8rem",color:"#0b1220",background:slack?C.amber:C.teal,borderRadius:10,padding:"2px 9px",fontWeight:800}}>{jobs.length}</span>
                  </div>
                  <div style={{padding:8,display:"flex",flexDirection:"column",gap:8,flex:1}}>
                    {jobs.length===0&&<div style={{fontSize:".85rem",color:C.dim,textAlign:"center",padding:"16px 0"}}>—</div>}
                    {jobs.map(j=>{const clr=TV_CAT_COLOR[j.cat]||"#64748b";const done=j.status==="Done";return(
                      <div key={j.id} style={{background:C.panel,border:`1px solid ${C.border}`,borderLeft:`5px solid ${clr}`,borderRadius:8,padding:"9px 10px",position:"relative",opacity:done?.55:1}}>
                        <span style={{position:"absolute",top:8,right:8,width:22,height:22,borderRadius:6,fontFamily:"monospace",fontWeight:800,fontSize:".8rem",color:"#fff",background:clr,display:"flex",alignItems:"center",justifyContent:"center"}}>{j.cat}</span>
                        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,fontSize:"1.1rem",lineHeight:1.1,paddingRight:26,textDecoration:done?"line-through":"none"}}>{j.projName}</div>
                        {j.workDetail&&<div style={{fontSize:".8rem",color:clr,marginTop:2,fontWeight:700}}>{j.workDetail}</div>}
                        {j.location&&<div style={{fontSize:".82rem",color:C.dim,marginTop:2}}>{j.location}</div>}
                        {j.assignedTo&&<div style={{display:"inline-flex",alignItems:"center",gap:5,marginTop:5,fontSize:".8rem",fontWeight:600}}><span style={{width:6,height:6,borderRadius:"50%",background:C.dim}}/>{j.assignedTo}</div>}
                      </div>
                    );})}
                    {onAddJob&&<button onClick={()=>addJobOn(day.date)} style={{marginTop:"auto",background:"transparent",border:`1px dashed ${C.border}`,borderRadius:8,padding:"8px",fontSize:".85rem",color:C.dim,cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>+ Add job</button>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{fontSize:".8rem",color:C.dim,padding:"8px 22px",borderTop:`1px solid ${C.border}`,flexShrink:0,fontFamily:"monospace"}}>I · Installation&nbsp;&nbsp; R · Repair&nbsp;&nbsp; P · Punchlist&nbsp;&nbsp; C · Construction&nbsp;&nbsp; O · Others&nbsp;&nbsp;·&nbsp;&nbsp;Sunday is a rest day and is hidden.</div>
      </div>
    );
  };

  const TABS=[{id:"overview",l:"Overview",icon:"🖥️"},{id:"field",l:"Field Board",icon:"🗂"},{id:"calendar",l:"Calendar",icon:"📅"},{id:"awarded",l:"Awarded",icon:"🏆"},{id:"notices",l:"Notices",icon:"📢"}];

  return(
    <div style={shell}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:20,padding:"16px 26px",borderBottom:`1px solid ${C.border}`,flexShrink:0}}>
        <div style={{fontFamily:"'Barlow Condensed','Segoe UI',sans-serif",fontWeight:800,fontSize:"2.1rem",letterSpacing:-.5}}>GMD <span style={{color:C.amber}}>PRODUCTIONS</span></div>
        <div style={{marginLeft:"auto",textAlign:"right"}}>
          <div style={{fontWeight:800,fontSize:"2.4rem",lineHeight:1,fontVariantNumeric:"tabular-nums"}}>{clock}</div>
          <div style={{color:C.dim,fontSize:"1rem"}}>{bigDate}</div>
        </div>
        <button onClick={onLogout} title="Exit display" style={{background:"transparent",border:`1px solid ${C.border}`,color:C.dim,borderRadius:10,padding:"8px 12px",fontSize:".85rem",cursor:"pointer"}}>Exit</button>
      </div>
      {/* Tabs */}
      <div style={{display:"flex",gap:12,padding:"14px 26px 4px",flexShrink:0,flexWrap:"wrap"}}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{display:"flex",alignItems:"center",gap:10,background:tab===t.id?C.amber:C.panel,color:tab===t.id?"#0b1220":C.text,border:`1px solid ${tab===t.id?C.amber:C.border}`,borderRadius:14,padding:"12px 24px",fontSize:"1.15rem",fontWeight:800,cursor:"pointer",transition:"all .15s"}}>
            <span style={{fontSize:"1.3rem"}}>{t.icon}</span>{t.l}
          </button>
        ))}
      </div>
      {/* Body */}
      <div style={{flex:1,minHeight:0,padding:"14px 26px 26px"}}>
        {tab==="overview"&&(
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:16,height:"100%"}}>
            <CalendarPanel compact/><AwardedPanel compact/><NoticesPanel/>
          </div>
        )}
        {tab==="field"&&<div style={{height:"100%"}}><FieldBoardPanel/></div>}
        {tab==="calendar"&&<div style={{height:"100%"}}><CalendarPanel/></div>}
        {tab==="awarded"&&<div style={{height:"100%"}}><AwardedPanel/></div>}
        {tab==="notices"&&<div style={{height:"100%"}}><NoticesPanel/></div>}
      </div>
      {/* Add-job modal — touch-optimized, dark theme */}
      {jobModal&&(()=>{
        const lbl={display:"block",color:C.dim,fontSize:".85rem",fontWeight:700,textTransform:"uppercase",letterSpacing:.5,margin:"14px 0 6px"};
        const inp={width:"100%",background:C.panel2,color:C.text,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 16px",fontSize:"1.15rem",fontFamily:"inherit",boxSizing:"border-box"};
        return(
        <div onClick={()=>setJobModal(false)} style={{position:"fixed",inset:0,background:"rgba(2,6,18,.72)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:10000,padding:24}}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:20,width:"min(640px,94vw)",maxHeight:"90vh",overflowY:"auto",padding:"26px 30px",boxShadow:"0 20px 60px rgba(0,0,0,.5)"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.9rem",marginBottom:4}}>📅 Add Site Job</div>
            <div style={{color:C.dim,fontSize:"1rem",marginBottom:8}}>Schedules a job on the operations calendar.</div>
            <label style={lbl}>Work Type</label>
            <select value={jobForm.type} onChange={e=>setJobForm(f=>({...f,type:e.target.value}))} style={inp}>{TV_JOB_TYPES.map(t=><option key={t.label} value={t.label}>{TV_EVENT_ICONS[t.label]||"📌"} {t.label}</option>)}</select>
            <label style={lbl}>Date</label>
            <input type="date" value={jobForm.dueDate} onChange={e=>setJobForm(f=>({...f,dueDate:e.target.value}))} style={inp}/>
            <label style={lbl}>Project (optional)</label>
            <select value={jobForm.projectId} onChange={e=>setJobForm(f=>({...f,projectId:e.target.value}))} style={inp}>
              <option value="">— No project / other —</option>
              {wonDeals.map(d=><option key={d.id} value={d.id}>{(d.contact||d.product||d.client)}{d.client?` — ${d.client}`:""}</option>)}
            </select>
            {!jobForm.projectId&&(<><label style={lbl}>Job Title</label><input value={jobForm.title} onChange={e=>setJobForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Punchlist — SM North kiosk" style={inp}/></>)}
            <label style={lbl}>Location</label>
            <input value={jobForm.location} onChange={e=>setJobForm(f=>({...f,location:e.target.value}))} placeholder="Site / address" style={inp}/>
            <label style={lbl}>Assigned To</label>
            <input value={jobForm.assignedTo} onChange={e=>setJobForm(f=>({...f,assignedTo:e.target.value}))} placeholder="Coordinator / team" style={inp}/>
            <label style={lbl}>Notes</label>
            <textarea value={jobForm.notes} onChange={e=>setJobForm(f=>({...f,notes:e.target.value}))} rows={3} placeholder="What's the job?" style={{...inp,resize:"vertical"}}/>
            <div style={{display:"flex",gap:12,justifyContent:"flex-end",marginTop:22}}>
              <button onClick={()=>setJobModal(false)} style={{background:"transparent",color:C.dim,border:`1px solid ${C.border}`,borderRadius:12,padding:"14px 24px",fontSize:"1.1rem",fontWeight:700,cursor:"pointer"}}>Cancel</button>
              <button onClick={saveJob} style={{background:C.teal,color:"#fff",border:"none",borderRadius:12,padding:"14px 32px",fontSize:"1.1rem",fontWeight:800,cursor:"pointer"}}>Add Job</button>
            </div>
          </div>
        </div>
        );
      })()}
    </div>
  );
}

// ─── OFFICE TV BOARD — ANNOUNCEMENTS EDITOR (Manager only) ─────────────────────
// Managers curate the notices shown on the office wall display here. Writes go
// through upAnnouncements → app_settings (key='announcements'), gated to Manager
// by RLS migration 054. The Display kiosk account only ever reads these.
const TVB_PRIORITIES=["Normal","High","Info"];
function TVBoardAdmin({announcements=[],upAnnouncements,session,today}){
  const[modal,setModal]=React.useState(false);
  const[form,setForm]=React.useState(null); // {id?,title,body,priority,pinned}
  const open=(a=null)=>{setForm(a?{...a}:{id:null,title:"",body:"",priority:"Normal",pinned:false});setModal(true);};
  const close=()=>{setModal(false);setForm(null);};
  const save=()=>{
    const title=(form.title||"").trim();
    if(!title){toastEmit("A title is required.","warning");return;}
    if(form.id){
      upAnnouncements(list=>list.map(a=>a.id===form.id?{...a,title,body:form.body||"",priority:form.priority||"Normal",pinned:!!form.pinned}:a));
    }else{
      const rec={id:uid(),title,body:form.body||"",priority:form.priority||"Normal",pinned:!!form.pinned,author:session?.name||"",date:today};
      upAnnouncements(list=>[rec,...(list||[])]);
    }
    toastEmit("Announcement saved.","success");
    close();
  };
  const remove=async(a)=>{
    if(!await uiConfirm(`Delete announcement "${a.title}"?`)) return;
    upAnnouncements(list=>list.filter(x=>x.id!==a.id));
    toastEmit("Announcement removed.","info");
  };
  const togglePin=(a)=>upAnnouncements(list=>list.map(x=>x.id===a.id?{...x,pinned:!x.pinned}:x));
  const sorted=[...(announcements||[])].sort((a,b)=>((b.pinned?1:0)-(a.pinned?1:0))||((b.date||"").localeCompare(a.date||"")));
  const PRI_CLR={High:"#ef4444",Info:"#0ea5e9",Normal:"#64748b"};
  return(
    <div style={{padding:"24px 20px",maxWidth:900,margin:"0 auto"}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:6}}>
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.8rem"}}>📺 Office TV Board</div>
        <div style={{marginLeft:"auto"}}><Btn onClick={()=>open()}>+ New Announcement</Btn></div>
      </div>
      <div style={{color:"#64748b",fontSize:".9rem",marginBottom:18}}>
        These notices appear on the 65" wall display. Log the wall screen in as user <strong>tv</strong> to show the dashboard. Pinned items rise to the top.
      </div>
      {sorted.length===0&&<Card><div style={{padding:"30px 0",textAlign:"center",color:"#94a3b8"}}>No announcements yet. Add one to show it on the wall.</div></Card>}
      {sorted.map(a=>(
        <Card key={a.id} style={{marginBottom:12}}>
          <div style={{display:"flex",alignItems:"flex-start",gap:12,padding:"4px 2px"}}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                {a.pinned&&<span title="Pinned">📌</span>}
                <span style={{fontWeight:800,fontSize:"1.1rem"}}>{a.title}</span>
                <span style={{fontSize:".7rem",fontWeight:800,color:PRI_CLR[a.priority]||"#64748b",textTransform:"uppercase",letterSpacing:.5}}>{a.priority}</span>
              </div>
              {a.body&&<div style={{color:"#334155",fontSize:".95rem",whiteSpace:"pre-wrap",lineHeight:1.5}}>{a.body}</div>}
              <div style={{color:"#94a3b8",fontSize:".78rem",marginTop:6}}>{[a.author,a.date].filter(Boolean).join(" · ")}</div>
            </div>
            <div style={{display:"flex",gap:6,flexShrink:0}}>
              <Btn small variant="ghost" onClick={()=>togglePin(a)}>{a.pinned?"Unpin":"Pin"}</Btn>
              <Btn small variant="ghost" onClick={()=>open(a)}>Edit</Btn>
              <Btn small variant="danger" onClick={()=>remove(a)}>Delete</Btn>
            </div>
          </div>
        </Card>
      ))}
      {modal&&form&&(
        <Modal open onClose={close} title={form.id?"Edit Announcement":"New Announcement"}>
          <Fld label="Title" required><Inp value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="e.g. All-hands Friday 4 PM"/></Fld>
          <Fld label="Message"><Inp rows={4} value={form.body} onChange={e=>setForm(f=>({...f,body:e.target.value}))} placeholder="Details to show on the wall…"/></Fld>
          <Fld label="Priority"><Sel value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))}>{TVB_PRIORITIES.map(p=><option key={p} value={p}>{p}</option>)}</Sel></Fld>
          <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:16,cursor:"pointer",fontSize:".9rem",fontWeight:600,color:"#334155"}}>
            <input type="checkbox" checked={!!form.pinned} onChange={e=>setForm(f=>({...f,pinned:e.target.checked}))}/> Pin to top of the board
          </label>
          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <Btn variant="ghost" onClick={close}>Cancel</Btn>
            <Btn onClick={save}>Save</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── BANK CASH SUMMARY ───────────────────────────────────────────────────────
// Single source of truth for "money in the bank." The in-memory cashPositions
// object stores nested banks[b.id].{beg,book,end} (see convertSbCashPos /
// emptyDayPosition) — NOT the flat metrobank_end / secbank_end keys the old
// owner-dashboard KPIs read, which silently resolved to 0. Mirrors CashFlowView's
// book||end||beg convention.
function bankCashSummary(cashPositions, today){
  // Never let a future-dated sheet (a pre-fill for the next banking day) pose as "latest".
  const days=Object.values(cashPositions||{}).filter(p=>p&&p.date&&String(p.date)<=today).sort((a,b)=>String(b.date).localeCompare(String(a.date)));
  const latest=days[0]||null;
  // `total` = money actually in the banks at end of day — the Cash Position
  // sheet's "Total Cash – All Accounts (End of Day)". `bookTotal` = the same
  // after uncleared floating checks (Ending − Float), and `floatTotal` the gap.
  // Previously `total` was the book figure summed over all 6 banks, a number
  // that appears on no line of the sheet (dashboard ₱10.1M vs sheet ₱12.9M).
  const num=(v)=>(v===undefined||v===null||v==="")?null:(Number(String(v).replace(/,/g,""))||0);
  const endOf =(r)=>num(r.end)??num(r.beg)??0;
  const bookOf=(r)=>num(r.book)??endOf(r);
  const perBank=latest?BANKS.map(b=>{const r=latest.banks?.[b.id]||{};return {id:b.id,short:b.short,name:b.name,type:b.type,val:endOf(r),book:bookOf(r)};}):[];
  const total=perBank.reduce((s,b)=>s+b.val,0);
  const bookTotal=perBank.reduce((s,b)=>s+b.book,0);
  const floatTotal=Math.max(0,total-bookTotal);
  const stale=!latest||latest.date!==today;
  const daysOld=latest?Math.round((new Date(today)-new Date(latest.date))/86400000):null;
  return {latest,total,bookTotal,floatTotal,perBank,stale,daysOld};
}

// ─── FINANCIAL OVERVIEW ──────────────────────────────────────────────────────
// Owner-only ("paulo"/"mar") consolidated finance snapshot: project count,
// per-project margin, bank cash (with a hard staleness flag), total payables,
// total loans outstanding. Rendered on both the CEO (generic Manager) and COO
// dashboards. Margin here is contract value less EXPENSES BOOKED TO DATE — an
// as-of number, not final profitability; early-stage jobs read optimistically
// high because their costs haven't been incurred yet. The "% billed" column is
// shown alongside so the reader can gauge how far along each job actually is.
// Per-project margin rows — all won deals, contract value less expenses booked
// to date. Shared by the dashboard panel (preview) and the full Project Margins
// page so both compute identically. Sorted worst-margin-first so problems lead.
function projectMarginRows(wonDeals=[],exps=[],billings=[],payables=[],prs=[],swos=[]){
  // Cost committed to date on the PO basis, VAT-ex (issued POs + Work Orders +
  // other payables + unrouted expenses; see costSummary).
  const costByDeal=costSummary(exps,payables,prs,swos).byProject;
  const billedByDeal={};(billings||[]).forEach(b=>{if(b.dealId)billedByDeal[b.dealId]=(billedByDeal[b.dealId]||0)+Number(b.amount||0);});
  return (wonDeals||[]).map(d=>{
    const contract=Number(d.value||0);
    const spent=costByDeal.get(d.id)||0;
    const profit=contract-spent;
    const margin=contract>0?Math.round(profit/contract*100):null;
    const billedPct=contract>0?Math.round((billedByDeal[d.id]||0)/contract*100):0;
    return {id:d.id,name:d.contact||d.client||d.projName||"Untitled",ceNo:d.ceNo||"",contract,spent,profit,margin,billedPct};
  }).sort((a,b)=>(a.margin==null?999:a.margin)-(b.margin==null?999:b.margin));
}
const _fmtM=v=>{const a=Math.abs(v);const s=v<0?"−":"";return a>=1000000?s+"₱"+(Math.round(a/100000)/10)+"M":a>=1000?s+"₱"+Math.round(a/1000)+"K":s+"₱"+Math.round(a||0);};
const _money=v=>(v<0?"−₱":"₱")+Math.round(Math.abs(Number(v)||0)).toLocaleString("en-PH");
const _marginClr=m=>m==null?"#94a3b8":m>=25?"#059669":m>=10?"#f59e0b":"#ef4444";

function FinancialOverview({deals=[],wonDeals=[],exps=[],payables=[],prs=[],swos=[],loans=[],cashPositions={},billings=[],today,setPage,setFinTab,onOpenProject,onViewAllMargins,isMobile}){
  const cash=bankCashSummary(cashPositions,today);
  const payTotal=(payables||[]).filter(p=>p.status!=="Paid"&&p.status!=="Cancelled"&&Number(p.amount)>0).reduce((s,p)=>s+Number(p.amount||0),0);
  const payCount=(payables||[]).filter(p=>p.status!=="Paid"&&p.status!=="Cancelled"&&Number(p.amount)>0).length;
  const loanPrincipal=(loans||[]).reduce((s,l)=>s+(Number(l.principal)||0),0);
  const loanPaid=(loans||[]).reduce((s,l)=>s+(l.payments||[]).reduce((a,p)=>a+Number(p.amount||0),0),0);
  const loanOutstanding=Math.max(0,loanPrincipal-loanPaid);
  const loanMonthly=(loans||[]).reduce((s,l)=>s+(Number(l.monthlyPayment)||0),0);

  const allRows=projectMarginRows(wonDeals,exps,billings,payables,prs,swos);
  const preview=allRows.slice(0,5); // just the 5 worst — full list lives on its own page
  const openProj=(id)=>onOpenProject&&onOpenProject(id);
  const card=(bg="#fff")=>({background:bg,borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 16px"});

  return(
    <div style={{background:"linear-gradient(135deg,#0f172a,#1e293b)",borderRadius:16,padding:isMobile?14:18,marginBottom:18}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.15rem",color:"#fff"}}>💼 Financial Overview</span>
          <span style={{fontSize:".6rem",fontWeight:800,color:"#fbbf24",background:"rgba(251,191,36,.15)",borderRadius:5,padding:"2px 7px",letterSpacing:".5px"}}>OWNERS ONLY</span>
        </div>
        <span style={{fontSize:".7rem",color:"rgba(255,255,255,.5)"}}>Paulo & Mar · live</span>
      </div>

      {/* KPI row */}
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:12}}>
        {/* Projects */}
        <div onClick={()=>onViewAllMargins&&onViewAllMargins()} style={{...card(),cursor:"pointer",textAlign:"center"}}>
          <div style={{fontSize:"1.2rem"}}>🏗</div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:"#0f172a"}}>{wonDeals.length}</div>
          <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>Awarded Projects</div>
        </div>
        {/* Bank cash */}
        <div onClick={()=>{setFinTab&&setFinTab("cash");setPage&&setPage("finance");}} style={{...card(cash.stale?"#fffbeb":"#fff"),cursor:"pointer",textAlign:"center",borderColor:cash.stale?"#fcd34d":"#e2e8f0"}}>
          <div style={{fontSize:"1.2rem"}}>🏦</div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:cash.total>0?"#059669":"#94a3b8"}}>{_fmtM(cash.total)}</div>
          <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>Cash in Bank · End of Day</div>
          {cash.latest&&cash.floatTotal>0.005&&<div style={{fontSize:".64rem",color:"#64748b",marginTop:2}}>{_fmtM(cash.bookTotal)} after {_fmtM(cash.floatTotal)} uncleared checks</div>}
          {cash.stale
            ?<div style={{fontSize:".62rem",color:"#b45309",fontWeight:700,marginTop:3}}>⚠ {cash.latest?`As of ${cash.latest.date} · ${cash.daysOld}d old`:"No entry yet"}</div>
            :<div style={{fontSize:".62rem",color:"#059669",fontWeight:700,marginTop:3}}>✓ Updated today</div>}
        </div>
        {/* Payables */}
        <div onClick={()=>{setFinTab&&setFinTab("payables");setPage&&setPage("finance");}} style={{...card(),cursor:"pointer",textAlign:"center"}}>
          <div style={{fontSize:"1.2rem"}}>📤</div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:payTotal>0?"#ef4444":"#94a3b8"}}>{_fmtM(payTotal)}</div>
          <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>Total Payables</div>
          <div style={{fontSize:".62rem",color:"#64748b",fontWeight:600,marginTop:3}}>{payCount} unpaid</div>
        </div>
        {/* Loans */}
        <div onClick={()=>{setFinTab&&setFinTab("loans");setPage&&setPage("finance");}} style={{...card(),cursor:"pointer",textAlign:"center"}}>
          <div style={{fontSize:"1.2rem"}}>💳</div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:loanOutstanding>0?"#7c3aed":"#94a3b8"}}>{_fmtM(loanOutstanding)}</div>
          <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>Loans Outstanding</div>
          <div style={{fontSize:".62rem",color:"#64748b",fontWeight:600,marginTop:3}}>{_fmtM(loanMonthly)}/mo</div>
        </div>
      </div>

      {/* Margin preview — only the 5 that need attention; full list on its own page */}
      <div style={{background:"#fff",borderRadius:12,overflow:"hidden"}}>
        <div style={{padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid #f1f5f9"}}>
          <span style={{fontWeight:800,fontSize:".84rem",color:"#0f172a"}}>⚠ Lowest-Margin Projects</span>
          <span style={{fontSize:".62rem",color:"#94a3b8"}}>Contract − expenses booked</span>
        </div>
        {allRows.length===0
          ?<div style={{padding:"22px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No awarded projects yet.</div>
          :preview.map((r,i)=>(
            <div key={r.id} onClick={()=>openProj(r.id)} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderTop:i>0?"1px solid #f8fafc":"",cursor:"pointer"}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name}{r.ceNo?<span style={{color:"#94a3b8",fontWeight:400}}> · {r.ceNo}</span>:null}</div>
                <div style={{fontSize:".68rem",color:"#94a3b8"}}>{_money(r.contract)} contract · {r.billedPct}% billed</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.05rem",color:_marginClr(r.margin)}}>{r.margin==null?"—":r.margin+"%"}</div>
                <div style={{fontSize:".66rem",fontWeight:600,color:r.profit>=0?"#059669":"#ef4444"}}>{_money(r.profit)}</div>
              </div>
              <span style={{fontSize:".8rem",color:"#cbd5e1",flexShrink:0}}>→</span>
            </div>
          ))}
        {allRows.length>0&&(
          <button onClick={()=>onViewAllMargins&&onViewAllMargins()} style={{width:"100%",border:"none",borderTop:"1px solid #f1f5f9",background:"#f8fafc",padding:"11px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#1e293b",cursor:"pointer"}}>
            View all {allRows.length} projects →
          </button>
        )}
      </div>
    </div>
  );
}

// Full owner-only page: every awarded project's margin, click a row to open its
// project card. Reached from the Financial Overview panel's "View all" button.
function ProjectMarginsView({wonDeals=[],exps=[],billings=[],payables=[],prs=[],swos=[],today,setPage,onOpenProject,Wrap,isMobile}){
  const [sortKey,setSortKey]=useState("margin"); // margin | contract | profit | billed | name
  const [sortDir,setSortDir]=useState("desc");    // desc = highest first
  const [q,setQ]=useState("");
  let rows=projectMarginRows(wonDeals,exps,billings,payables,prs,swos);
  if(q.trim()){const t=q.trim().toLowerCase();rows=rows.filter(r=>r.name.toLowerCase().includes(t)||r.ceNo.toLowerCase().includes(t));}
  // Base comparators are ascending (small→large / A→Z); direction flips them.
  // Null margins always sink to the bottom regardless of direction.
  const base={
    margin:(a,b)=>{if(a.margin==null&&b.margin==null)return 0;if(a.margin==null)return 1;if(b.margin==null)return -1;return a.margin-b.margin;},
    contract:(a,b)=>a.contract-b.contract,
    profit:(a,b)=>a.profit-b.profit,
    billed:(a,b)=>a.billedPct-b.billedPct,
    name:(a,b)=>a.name.localeCompare(b.name),
  };
  const cmp=base[sortKey]||base.margin;
  rows=[...rows].sort((a,b)=>{const r=cmp(a,b);if(r!==0)return sortDir==="asc"?r:-r;return 0;});
  // Default direction when switching to a new column: text asc, numbers desc.
  const setSort=(key)=>{
    if(key===sortKey){setSortDir(d=>d==="asc"?"desc":"asc");}
    else{setSortKey(key);setSortDir(key==="name"?"asc":"desc");}
  };
  const totContract=rows.reduce((s,r)=>s+r.contract,0);
  const totSpent=rows.reduce((s,r)=>s+r.spent,0);
  const totProfit=totContract-totSpent;
  const totMargin=totContract>0?Math.round(totProfit/totContract*100):null;

  const th=(key,label,align="left")=>(
    <th onClick={()=>setSort(key)} style={{padding:"9px 12px",fontWeight:700,textAlign:align,cursor:"pointer",whiteSpace:"nowrap",userSelect:"none",color:sortKey===key?"#1e293b":"#64748b"}}>
      {label}{sortKey===key?(sortDir==="asc"?" ↑":" ↓"):""}
    </th>
  );

  return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.5rem",color:"#0f172a"}}>Profit Margin by Project</div>
          <div style={{fontSize:".8rem",color:"#64748b",marginTop:2}}>All awarded projects · contract value less expenses booked to date</div>
        </div>
        <button onClick={()=>setPage&&setPage("home")} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>← Back to Dashboard</button>
      </div>

      {/* totals strip */}
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12,marginBottom:14}}>
        {[
          {l:"Projects",v:rows.length,c:"#0f172a"},
          {l:"Total Contract",v:_fmtM(totContract),c:"#6366f1"},
          {l:"Profit (to date)",v:_money(totProfit),c:totProfit>=0?"#059669":"#ef4444"},
          {l:"Blended Margin",v:totMargin==null?"—":totMargin+"%",c:_marginClr(totMargin)},
        ].map(k=>(
          <div key={k.l} style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 16px",textAlign:"center"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:k.c}}>{k.v}</div>
            <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700,marginTop:2}}>{k.l}</div>
          </div>
        ))}
      </div>

      <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search project or CE no…" style={{width:"100%",boxSizing:"border-box",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 12px",fontFamily:"inherit",fontSize:".84rem",marginBottom:12}}/>

      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:".8rem",minWidth:620}}>
            <thead><tr style={{background:"#f8fafc"}}>
              {th("name","Project")}
              {th("contract","Contract","right")}
              <th style={{padding:"9px 12px",fontWeight:700,textAlign:"right",color:"#64748b"}}>Expenses</th>
              {th("profit","Profit","right")}
              {th("margin","Margin","right")}
              {th("billed","% Billed","right")}
              <th style={{width:24}}></th>
            </tr></thead>
            <tbody>
              {rows.length===0
                ?<tr><td colSpan={7} style={{padding:"24px",textAlign:"center",color:"#94a3b8"}}>No matching projects.</td></tr>
                :rows.map((r,i)=>(
                  <tr key={r.id} onClick={()=>onOpenProject&&onOpenProject(r.id)} style={{borderTop:"1px solid #f1f5f9",cursor:"pointer"}}>
                    <td style={{padding:"9px 12px",fontWeight:600,color:"#0f172a",maxWidth:240,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name}{r.ceNo?<span style={{color:"#94a3b8",fontWeight:400}}> · {r.ceNo}</span>:null}</td>
                    <td style={{padding:"9px 12px",textAlign:"right",fontVariantNumeric:"tabular-nums",color:"#475569"}}>{_money(r.contract)}</td>
                    <td style={{padding:"9px 12px",textAlign:"right",fontVariantNumeric:"tabular-nums",color:"#475569"}}>{_money(r.spent)}</td>
                    <td style={{padding:"9px 12px",textAlign:"right",fontVariantNumeric:"tabular-nums",fontWeight:700,color:r.profit>=0?"#059669":"#ef4444"}}>{_money(r.profit)}</td>
                    <td style={{padding:"9px 12px",textAlign:"right",fontWeight:800,color:_marginClr(r.margin)}}>{r.margin==null?"—":r.margin+"%"}</td>
                    <td style={{padding:"9px 12px",textAlign:"right",fontVariantNumeric:"tabular-nums",color:"#94a3b8"}}>{r.billedPct}%</td>
                    <td style={{padding:"9px 8px",textAlign:"right",color:"#cbd5e1"}}>→</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div style={{padding:"9px 14px",fontSize:".64rem",color:"#94a3b8",background:"#fafafa",borderTop:"1px solid #f1f5f9"}}>
          ⚠ Margin uses expenses booked so far, not final cost. Early-stage jobs (low % billed) will read high — cross-check against progress before treating as final profit. Tap any column header to sort; tap it again to reverse (highest ↔ lowest). Tap a row to open its project card.
        </div>
      </div>
    </Wrap>
  );
}

// Check register: every check number recorded in payable_payments, per bank,
// with the gaps and problems a manual check log hides — a skipped number, a
// number used for two different payments, or a transfer reference that sits
// inside the check series (check 87862 was logged as an online payment).
function CheckRegister({pays,payables}){
  const[bankF,setBankF]=useState("");
  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
  const bankName=id=>{const b=(BANKS||[]).find(x=>x.id===id||x.short===id||x.name===id);return b?(b.short||b.name):(id||"—");};
  const vendorOf=id=>(payables.find(p=>p.id===id)||{}).vendor||"—";
  const digits=s=>/^\d+$/.test(String(s||"").trim())?Number(String(s).trim()):null;
  // one entry per bank + check no.
  const map=new Map();
  (pays||[]).filter(r=>r.method==="Check"&&String(r.refNo||"").trim()).forEach(r=>{
    const k=`${r.bank}|${String(r.refNo).trim().replace(/^0+(?=\d)/,"")}`;
    const e=map.get(k)||{bank:r.bank,no:String(r.refNo).trim(),rows:[]};
    e.rows.push(r);map.set(k,e);
  });
  const entries=[...map.values()].map(e=>{
    const active=e.rows.filter(r=>r.status!=="Cancelled");
    const payees=[...new Set(e.rows.map(r=>vendorOf(r.payableId)))];
    const batches=new Set(active.map(r=>r.batchId||r.id));
    const dates=[...new Set(active.map(r=>r.payDate))];
    const flags=[];
    if(active.length&&batches.size>1&&(payees.length>1||dates.length>1)) flags.push("Number used for two payments");
    return {...e,n:digits(e.no),payees,bills:active.length||e.rows.length,total:(active.length?active:e.rows).reduce((s,r)=>s+(Number(r.amount)||0),0),
      date:(active[0]||e.rows[0]).payDate,status:active.length?"Issued":"Cancelled",flags};
  });
  const banks=[...new Set(entries.map(e=>e.bank))].sort();
  const bank=bankF||banks[0]||"";
  const list=entries.filter(e=>e.bank===bank).sort((a,b)=>(a.n??Infinity)-(b.n??Infinity)||String(a.no).localeCompare(String(b.no)));
  const nums=list.map(e=>e.n).filter(n=>n!=null);
  const gaps=[];
  for(let i=1;i<nums.length;i++){const d=nums[i]-nums[i-1];if(d>1&&d<=50) for(let g=nums[i-1]+1;g<nums[i];g++) gaps.push(g);}
  const lo=nums.length?Math.min(...nums):null,hi=nums.length?Math.max(...nums):null;
  const inSeries=(pays||[]).filter(r=>r.method!=="Check"&&r.bank===bank&&r.status!=="Cancelled"&&lo!=null&&(()=>{const n=digits(r.refNo);return n!=null&&n>lo&&n<hi;})());
  const cancelled=list.filter(e=>e.status==="Cancelled").length;
  const clash=list.filter(e=>e.flags.length).length;
  if(!entries.length) return null;
  const th={textAlign:"left",padding:"7px 10px",fontSize:11,color:"#64748b",textTransform:"uppercase",letterSpacing:".4px",borderBottom:"1px solid #e2e8f0",whiteSpace:"nowrap"};
  const td={padding:"7px 10px",borderBottom:"1px solid #f1f5f9",fontSize:12.5,verticalAlign:"top"};
  return(
    <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",marginBottom:20}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:10}}>
        <div style={{fontWeight:800,color:"#1e293b",fontSize:14}}>Check register</div>
        <span style={{fontSize:12,color:"#64748b"}}>{nums.length?`${bankName(bank)} · ${lo} – ${hi}`:bankName(bank)}</span>
        <div style={{marginLeft:"auto",display:"flex",gap:6,flexWrap:"wrap"}}>
          {banks.map(b=><button key={b} onClick={()=>setBankF(b)} style={{background:b===bank?"#1e293b":"#fff",color:b===bank?"#fff":"#475569",border:`1px solid ${b===bank?"#1e293b":"#e2e8f0"}`,borderRadius:7,padding:"4px 10px",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>{bankName(b)}</button>)}
        </div>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
        <span style={{fontSize:11.5,fontWeight:700,padding:"2px 9px",borderRadius:20,background:gaps.length?"#fffbeb":"#f0fdf4",color:gaps.length?"#a16207":"#15803d",border:`1px solid ${gaps.length?"#fde68a":"#86efac"}`}}>{gaps.length?`${gaps.length} gap${gaps.length>1?"s":""}: ${gaps.slice(0,8).join(", ")}${gaps.length>8?"…":""}`:"No gaps"}</span>
        {cancelled>0&&<span style={{fontSize:11.5,fontWeight:700,padding:"2px 9px",borderRadius:20,background:"#fef2f2",color:"#b91c1c",border:"1px solid #fca5a5"}}>{cancelled} cancelled</span>}
        {clash>0&&<span style={{fontSize:11.5,fontWeight:700,padding:"2px 9px",borderRadius:20,background:"#fef2f2",color:"#b91c1c",border:"1px solid #fca5a5"}}>{clash} number{clash>1?"s":""} used twice</span>}
        {inSeries.length>0&&<span title={inSeries.map(r=>`${r.refNo} (${r.method})`).join(", ")} style={{fontSize:11.5,fontWeight:700,padding:"2px 9px",borderRadius:20,background:"#fffbeb",color:"#a16207",border:"1px solid #fde68a"}}>{inSeries.length} non-check payment{inSeries.length>1?"s":""} with a reference inside this check series</span>}
      </div>
      <div style={{overflowX:"auto",maxHeight:360,overflowY:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:620}}>
          <thead><tr><th style={th}>Check no.</th><th style={th}>Payee</th><th style={{...th,textAlign:"right"}}>Bills</th><th style={{...th,textAlign:"right"}}>Amount</th><th style={th}>Date</th><th style={th}>Status</th></tr></thead>
          <tbody>
            {list.map(e=>{const off=e.status==="Cancelled";return(
              <tr key={e.bank+e.no}>
                <td style={{...td,fontFamily:"monospace",fontWeight:700,color:off?"#94a3b8":"#1e293b"}}>{e.no}</td>
                <td style={{...td,color:off?"#94a3b8":"#334155"}}>{e.payees.join(", ")}</td>
                <td style={{...td,textAlign:"right",fontVariantNumeric:"tabular-nums"}}>{e.bills}</td>
                <td style={{...td,textAlign:"right",fontVariantNumeric:"tabular-nums",textDecoration:off?"line-through":"none",color:off?"#94a3b8":"#0f172a"}}>{peso(e.total)}</td>
                <td style={{...td,whiteSpace:"nowrap",color:"#64748b"}}>{e.date||"—"}</td>
                <td style={td}><span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:20,background:off?"#fef2f2":"#f0fdf4",color:off?"#b91c1c":"#15803d"}}>{e.status}</span>{e.flags.map(f=><div key={f} style={{fontSize:11,color:"#b91c1c",fontWeight:700,marginTop:3}}>{f}</div>)}</td>
              </tr>);})}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// Payment history rows for one bill (payable_payments). Cancelled rows stay on
// screen, struck through, with who cancelled and why.
function PayHistoryList({rows,onCancel,canCancel}){
  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
  const bankName=id=>{const b=(BANKS||[]).find(x=>x.id===id||x.short===id||x.name===id);return b?(b.short||b.name):(id||"");};
  return(
    <div style={{display:"grid",gap:6}}>
      {rows.map(r=>{const off=r.status==="Cancelled";return(
        <div key={r.id} style={{border:"1px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontSize:".78rem",background:off?"#f8fafc":"#fff"}}>
          <div style={{display:"flex",justifyContent:"space-between",gap:8,flexWrap:"wrap"}}>
            <span style={{color:off?"#94a3b8":"#0f172a",fontWeight:700,textDecoration:off?"line-through":"none"}}>{peso(r.amount)}{r.kind==="Retention release"?" · retention release":""}</span>
            <span style={{color:"#64748b"}}>{r.payDate||"—"}</span>
          </div>
          <div style={{color:"#64748b",marginTop:2}}>{[r.method,bankName(r.bank),r.refNo?`#${r.refNo}`:"",r.batchId?"part of a multi-bill payment":""].filter(Boolean).join(" · ")}</div>
          {r.retentionAmount>0&&<div style={{color:"#b45309",marginTop:2}}>Retention held from this claim: {peso(r.retentionAmount)}</div>}
          {r.note&&<div style={{color:"#64748b",marginTop:2}}>{r.note}</div>}
          {off
            ? <div style={{color:"#b91c1c",marginTop:2,fontWeight:600}}>Cancelled{r.cancelledBy?` by ${r.cancelledBy}`:""}: {r.cancelReason}</div>
            : canCancel&&<button onClick={()=>onCancel(r.id)} style={{marginTop:6,background:"#fff",border:"1px solid #fca5a5",color:"#b91c1c",borderRadius:6,padding:"3px 10px",fontSize:".72rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>Cancel payment</button>}
        </div>);})}
    </div>
  );
}

export default function App(){
  const[users,      setUsers]     = useState(DEFAULT_USERS);
  const[cashPositions,setCashPos]  = useState({});
  // True when the last Supabase refresh of cash_positions FAILED (network/timeout),
  // so what's on screen is the stale local cache — not the server's source of truth.
  // Drives the stale banner and, crucially, blocks the Daily Cash Position sheet's
  // silent auto-save so a stale Manager session can't overwrite good server rows.
  const[cashStale,  setCashStale]  = useState(false);
  const[vvipClients, setVvip]      = useState(new Set());
  const[actLog,      setActLog]    = useState([]);
  const[pcards,      setPcards]    = useState({});
  const[inventory,   setInventory] = useState([]);  // Inventory items
  const[stocklog,    setStocklog]  = useState([]);  // Stock movement log // Set of client names marked VVIP
  const[tools,       setTools]     = useState([]);  // Tools / equipment borrow-return register
  const[drs,         setDrs]       = useState([]);  // Standalone delivery receipts (goods received notes)
  const[receivingPr, setReceivingPr]=useState(null);  // PR being received (partial receiving modal)
  const[rxQty,       setRxQty]     =useState("");
  const[rxDrNo,      setRxDrNo]    =useState("");
  const[issueModal,  setIssueModal]=useState(false);  // Issue to Site modal
  const[issueForm,   setIssueForm] =useState({itemId:"",qty:"",projectId:"",requestedBy:"",deliveryLink:"",date:""});
  const[fabModal,    setFabModal]  =useState(false);  // Release for Fabrication modal
  const[fabForm,     setFabForm]   =useState({itemId:"",qty:"",projectId:"",requestedBy:"",notes:"",date:""});
  const[prs,         setPrs]       = useState([]);   // Purchase Requests
  const[addenda,     setAddenda]   = useState([]);   // Project Addenda
  const[billings,    setBillings]  = useState([]);   // Billing milestones
  const[mreqs,       setMreqs]     = useState([]);   // Material Requests
  const[breqs,       setBreqs]     = useState([]);   // Budget Requests
  const[drfs,        setDrfs]      = useState([]);   // Design Request Forms
  const[suppliers,  setSuppliers] = useState([]);  // Supplier master list
  const[subcons,    setSubcons]   = useState([]);  // Subcontractor master list
  const[swos,       setSwos]      = useState([]);  // Subcon work orders
  const[ceReqs,     setCeReqs]    = useState([]);  // CE/QS cost estimation requests
  const[botSettings, setBotSettings]= useState(()=>{
    try{
      const local=JSON.parse(localStorage.getItem(KEYS.botsettings)||"{}");
      // The bot token lives only on the server (app_secrets, migration
      // 20261026103448); clear the copy older versions kept in this tab.
      sessionStorage.removeItem('fabhub:bottoken');
      return{chatIds:{...{general:"",ops:"",design:"",procurement:"",warehouse:"",sales:"",management:"",financialcontrol:""},...(local.chatIds||{})},hideValueInBots:local.hideValueInBots||false};
    }catch{return{chatIds:{general:"",ops:"",design:"",procurement:"",warehouse:"",sales:"",management:"",financialcontrol:""},hideValueInBots:false};}
  });
  const[customClients,setCustomClients]= useState([]);
  const[customMembers,setCustomMembers]= useState(()=>{try{return JSON.parse(localStorage.getItem("gmdv5:customMembers")||"[]");}catch{return[];}});  // extra team members typed in (beyond the built-in roster)
  const[clientProfiles,setClientProfiles]= useState({});  // keyed by client name
  // Saves ONE client's profile through set_client_profile (migration
  // 20261026053903), which merges it server-side. The old whole-object upsert
  // was rejected for Sales under RLS (error swallowed, edit lost on reload) and
  // let a stale copy wipe other clients' edits. Same roles as the RPC.
  const saveClientProfileRemote=async(name,profile)=>{
    let prev;
    setClientProfiles(cp=>{prev=cp?.[name];return{...cp,[name]:profile};});
    if(!isSupabaseReady()){toastEmit("⚠ Offline: client profile not saved.","error",9000);return false;}
    const{error}=await _rpcWithTimeout(supabase.rpc('set_client_profile',{p_name:name,p_profile:profile}));
    if(error){
      setClientProfiles(cp=>{const n={...cp};if(prev===undefined)delete n[name];else n[name]=prev;return n;});
      toastEmit("⚠ Client profile not saved: "+error.message,"error",9000);
      return false;
    }
    toastEmit(`Client profile saved: ${name}`,"success");
    return true;
  };
  const[budgets,     setBudgets]   = useState({});   // keyed by dealId
  const[session,  setSession] = useState(null);   // {userId, username, name, role}
  const[authView, setAuthView]= useState("login"); // login | register
  const[role,     setRole]    = useState(null);
  // Sales users explicitly granted deal-delete rights (for clearing duplicate /
  // double-entered deals). Kept to named individuals rather than the whole Sales
  // role; the server-side RLS in migration 033 mirrors this exact allow-list.
  // Must stay in sync with the deals_del RLS policy (migrations 033/034/071).
  const DEAL_DELETE_USERS=["jena","wyn","paolo","jessica"];
  const canDeleteDeal=role==="Manager"||DEAL_DELETE_USERS.includes(session?.username);
  const[deals,    setDeals]   = useState([]);
  const[projs,    setProjs]   = useState({});
  const[exps,     setExps]    = useState([]);
  const[evouchers,setEvouchers]= useState([]);
  const[announcements,setAnnouncements]= useState([]); // office TV board notices
  const[dailyLogs,setDailyLogs]= useState([]);
  const[infs,     setInfs]    = useState([]);
  const[jos,      setJos]     = useState([]);
  const[swatches, setSwatches]= useState([]);
  const[checklist,setChecklist]= useState([]);
  const[ready,    setReady]   = useState(false);
  const[sbReady,  setSbReady] = useState(false); // true once Supabase load completes
  const[syncRetry,setSyncRetry]=useState(false); // manual sync in progress
  const[sync,     setSync]    = useState("saved");

  // Load SheetJS once for Excel import
  useEffect(()=>{
    if(!window.XLSX){
      const s=document.createElement("script");
      s.src="https://cdn.sheetjs.com/xlsx-0.20.2/package/dist/xlsx.full.min.js";
      document.head.appendChild(s);
    }
  },[]);

  // ── SUPABASE: Initialize auth + load all data ──────────────────────────────
  useEffect(()=>{
    // Temporary load-timing instrumentation — prints to the browser console so
    // we can see where cold-load time actually goes (bundle boot vs IndexedDB
    // cache read vs the Supabase refresh) before optimizing the startup path.
    const _perf=(typeof performance!=="undefined"&&performance.now)?()=>performance.now():()=>Date.now();
    const _t0=_perf();
    const _log=(label,since)=>{try{console.info(`[FabHub timing] ${label}: ${Math.round(_perf()-since)}ms`);}catch{}};
    const init = async () => {
      // _t0 is measured from navigation start, so this first number is the cost
      // of downloading + parsing the JS bundle and booting React up to here.
      try{console.info(`[FabHub timing] bundle download + parse + React boot: ${Math.round(_t0)}ms`);}catch{}
      // Step 1: Session/role from localStorage (sync, tiny)
      try {
        const s=localStorage.getItem(KEYS.session);
        // Only restore a session if we still hold a valid role token (RLS needs it).
        // Offline (no Supabase) we allow the cached session so the app still opens.
        const hasToken = isSupabaseReady() ? restoreAppToken() : true;
        if(s && hasToken){ const sess=JSON.parse(s); setSession(sess); setRole(sess.role||"Sales"); const lp=sessionStorage.getItem("gmd:lastPage"); if(lp)setPage(lp); }
        else if(s){ localStorage.removeItem(KEYS.session); localStorage.removeItem(KEYS.role); }
        // Session (KEYS.session) is the single source of truth for role — don't
        // let a stale KEYS.role value (e.g. left over from a previous user/role on
        // this browser, never updated by the Supabase-auth SIGNED_IN path) silently
        // override it and strip role-gated UI like the Sales "Award" button.
      } catch {}
      // Step 1b: Data from IndexedDB — async, no 5 MB limit
      let idb={};
      try {
        idb=await idbGetMany([
          KEYS.deals,KEYS.projects,KEYS.expenses,KEYS.inflows,KEYS.jos,
          KEYS.swatches,KEYS.checklist,KEYS.users,KEYS.cashPos,KEYS.prs,
          KEYS.mreqs,KEYS.breqs,KEYS.drfs,KEYS.suppliers,KEYS.subcons,
          KEYS.botsettings,KEYS.customclients,KEYS.addenda,KEYS.budgets,
          KEYS.billings,KEYS.vvip,KEYS.actlog,KEYS.pcards,KEYS.inventory,
          KEYS.stocklog,KEYS.swos,"gmdv5:payables","gmdv5:loans","gmdv5:clientprofiles",
          "gmdv5:aeUpdates","gmdv5:auditFindings",KEYS.vouchers,"gmdv5:standaloneBoqs","gmdv5:chartOfAccounts",KEYS.dailylogs,KEYS.ceReqs,KEYS.payouts,KEYS.tools,KEYS.drs,KEYS.payPays
        ]);
        if(idb[KEYS.deals]){setDeals(idb[KEYS.deals].map(x=>({...x,stage:normalizeStage(x.stage)})));}
        if(idb[KEYS.projects])    setProjs(idb[KEYS.projects]);
        if(idb[KEYS.expenses])    setExps(idb[KEYS.expenses]);
        if(idb[KEYS.inflows])     setInfs(idb[KEYS.inflows]);
        if(idb[KEYS.jos])         setJos(idb[KEYS.jos]);
        if(idb[KEYS.swatches])    setSwatches(idb[KEYS.swatches]);
        if(idb[KEYS.checklist])   setChecklist(idb[KEYS.checklist]);
        if(idb[KEYS.users])       setUsers(idb[KEYS.users]);
        if(idb[KEYS.cashPos])     setCashPos(dropPhantomCashDays(idb[KEYS.cashPos]));
        if(idb[KEYS.prs])         setPrs(idb[KEYS.prs]);
        if(idb[KEYS.mreqs])       setMreqs(idb[KEYS.mreqs]);
        if(idb[KEYS.breqs])       setBreqs(idb[KEYS.breqs]);
        if(idb[KEYS.drfs])        setDrfs(idb[KEYS.drfs]);
        if(idb[KEYS.suppliers])   setSuppliers(idb[KEYS.suppliers]);
        if(idb[KEYS.subcons])     setSubcons(idb[KEYS.subcons]);
        if(idb[KEYS.swos])        setSwos(idb[KEYS.swos]);
        if(idb[KEYS.botsettings]){const{token:_t,...bs}=idb[KEYS.botsettings];setBotSettings(bs);if(_t!==undefined) idbSetMany([[KEYS.botsettings,bs]]).catch(()=>{});}
        if(idb[KEYS.customclients]){const cc=idb[KEYS.customclients];setCustomClients(cc);cc.forEach(c=>{if(!GMD_CLIENTS.find(x=>x.name.toLowerCase()===c.name.toLowerCase())) GMD_CLIENTS.push(c);});}
        if(idb["gmdv5:clientprofiles"]) setClientProfiles(idb["gmdv5:clientprofiles"]);
        if(idb["gmdv5:standaloneBoqs"]) setStandaloneBoqs(idb["gmdv5:standaloneBoqs"]);
        if(idb["gmdv5:chartOfAccounts"]) setChartOfAccounts(idb["gmdv5:chartOfAccounts"]);
        if(idb[KEYS.addenda])     setAddenda(idb[KEYS.addenda]);
        if(idb[KEYS.budgets])     setBudgets(idb[KEYS.budgets]);
        if(idb[KEYS.billings])    setBillings(idb[KEYS.billings]);
        if(idb[KEYS.vvip]){const sv=new Set(idb[KEYS.vvip]);setVvip(sv);}
        if(idb[KEYS.actlog])      setActLog(idb[KEYS.actlog]);
        if(idb[KEYS.pcards])      setPcards(idb[KEYS.pcards]);
        if(idb[KEYS.inventory])   setInventory(idb[KEYS.inventory]);
        if(idb[KEYS.stocklog])    setStocklog(idb[KEYS.stocklog]);
        if(idb[KEYS.tools])       setTools(idb[KEYS.tools]);
        if(idb[KEYS.drs])         setDrs(idb[KEYS.drs]);
        if(idb["gmdv5:payables"]) setPayables(idb["gmdv5:payables"]);
        if(idb[KEYS.payPays])     setPayPays(idb[KEYS.payPays]);
        if(idb["gmdv5:loans"])    setLoans(idb["gmdv5:loans"]);
        if(idb["gmdv5:aeUpdates"]) setAeUpdates(idb["gmdv5:aeUpdates"]);
        if(idb["gmdv5:auditFindings"]) setAuditFindings(idb["gmdv5:auditFindings"]);
        if(idb[KEYS.vouchers])    setVouchers(idb[KEYS.vouchers]);
        if(idb[KEYS.evouchers])   setEvouchers(idb[KEYS.evouchers]);
        if(idb[KEYS.announcements]) setAnnouncements(idb[KEYS.announcements]);
        if(idb[KEYS.dailylogs])   setDailyLogs(idb[KEYS.dailylogs]);
        if(idb[KEYS.ceReqs])      setCeReqs(idb[KEYS.ceReqs]);
        if(idb[KEYS.payouts])     setPayouts(idb[KEYS.payouts]);
      } catch(err){ console.error("IDB load error:", err); }
      _log("IndexedDB cache read → app interactive",_t0);
      setReady(true);

      // Step 2: Pull from Supabase (PRIMARY source of truth) — overrides localStorage
      if(!isSupabaseReady()){ setSbReady(true); return; }
      // Data access now requires the role-bearing token minted at login (RLS,
      // migration 024). restoreAppToken() in Step 1 already re-loaded it if still
      // valid, and the client's accessToken option attaches it to every request —
      // no anonymous session needed.
      setSbReady(true);
      // Signed out (no session, or the role token expired): the server returns
      // empty lists to anon, and the reconciliation below would then treat every
      // cached row as "local-only" and push it back up as anon — all rejected by
      // RLS, surfacing as "N changes to standalone_boqs could not be saved" on the
      // login screen. Load nothing now; login runs loadAllFromSupabase().
      if(!hasAppToken()) return;
      if(isSupabaseReady()){
        try{
          const _tLoad=_perf();
          const data = await sbLoadAll();
          _log("sbLoadAll (server refresh of all tables)",_tLoad);
          if(!data) toastEmit&&toastEmit("⚠️ Couldn't load from the server. Check your connection, then tap the 🔄 sync button.","error",12000);
          else if(data._failed?.length) toastEmit&&toastEmit(`⚠️ Some data couldn't refresh (${data._failed.join(", ")}) — you may be seeing a last-synced copy. Tap the 🔄 sync button to retry.`,"warning",12000);
          // Diagnostic — visible in browser console AND stored for the sync banner
          console.info("[FabHub] sbLoadAll result — deals:",data?.deals?.length||0,"jos:",data?.jos?.length||0,"users:",data?.users?.length||0);
          if(data){
            const idbE=[];
            const _deals=data.deals?.length?data.deals.map(d=>({...d,ceNo:d.ce_no,ceType:d.ce_type,salesOwner:d.sales_owner,bizDevSource:d.biz_dev_source,dateAcquired:d.date_acquired,dueDate:d.due_date,followUp:d.follow_up||"",amountPaid:Number(d.amount_paid)||0,paymentStatus:d.payment_status,billingGenerated:d.billing_generated||false,receiptType:d.receipt_type,commsGroup:d.comms_group,salesRepoLink:d.sales_repo_link,proposalFolderLink:d.proposal_folder_link,salesRepoNote:d.sales_repo_note||"",location:d.location||"",addedBy:d.added_by||"",addedAt:d.added_at||"",stage:normalizeStage(d.stage),awardRequestData:d.award_request_data||null,parentDealId:d.parent_deal_id||null,addendumStatus:d.addendum_status||null,leadOrigin:d.lead_origin||DEFAULT_LEAD_ORIGIN,leadOriginStatus:d.lead_origin_status||"Approved",leadOriginApprovedBy:d.lead_origin_approved_by||"",leadOriginApprovedAt:d.lead_origin_approved_at||null,standbyPO:d.standby_po||false,dpWaivedBy:d.dp_waived_by||"",dpWaivedAt:d.dp_waived_at||null,dpWaivedReason:d.dp_waived_reason||"",poBudget:d.standby_po?(Number(d.po_budget)||0):"",bir2303Url:d.bir_2303_url||"",bir2303OnFile:d.bir_2303_on_file||false,signedCeUrl:d.signed_ce_url||"",signedCeOnFile:d.signed_ce_on_file||false,clientPoNo:d.client_po_no||"",isCostCenter:!!d.is_cost_center,vatTreatment:d.vat_treatment||"",downpaymentPct:d.downpayment_pct??null,paymentTermsText:d.payment_terms_text||"",clientSatisfied:d.client_satisfied||false,satisfactionNote:d.satisfaction_note||"",boqData:d.boq_data||null,paymentTerms:d.payment_terms_json?(()=>{try{return JSON.parse(d.payment_terms_json);}catch(e){return null;}})():null})):null;
            if(_deals){
              // Reconcile legacy non-UUID "ghost" deals against the server.
              // Before the deals.id → UUID migration, deals were keyed by local
              // text ids (e.g. "d"+Date.now()). Those old rows still live in some
              // users' IndexedDB/localStorage caches, and the local-only merge keeps
              // any local id the server doesn't have — so a device carries BOTH the
              // real UUID row AND its stale text-id twin. Every write then targets
              // the ghost: sbUpdate('deals',<textId>) matches 0 server rows (edit
              // "doesn't update", queues forever) and delDeal skips sbDelete
              // entirely for non-UUID ids (isUUID gate at delDeal), so a "deleted"
              // old project reappears from the server on the next hard reset.
              // ce_no is unique and 100% populated on the server, so drop any local
              // non-UUID deal whose ce_no already exists on the server: it's the
              // same project, and the UUID row is the synced truth. Genuinely
              // local-only deals (offline-created, no server ce_no twin) are still
              // preserved. Reported live: Pao's account — old project edits don't
              // update; deleted old projects come back.
              // mlo() (from #297) is the keepIds-aware merge: it only retains
              // local-only rows that are still pending sync, so cross-user deletes
              // don't resurrect. Both fixes compose — pre-filter the legacy twins,
              // then let mlo apply the pending-only rule to what remains.
              const _serverCeNos=new Set(_deals.map(d=>d.ceNo).filter(Boolean));
              setDeals(prev=>mlo(_deals,(prev||[]).filter(d=>isUUID(d.id)||!(d.ceNo&&_serverCeNos.has(d.ceNo)))));
              idbE.push([KEYS.deals,_deals]);
            }
            const _jos=data.jos?.length?data.jos.map(j=>({...j,dealId:j.deal_id,joNo:j.jo_no,projectName:j.project_name,awardTrigger:j.award_trigger,triggerDate:j.trigger_date,startDate:j.start_date,commsLink:j.comms_link,scopeNotes:j.scope_notes,specialInstructions:j.special_instructions,designer:j.designer||"",location:j.location||"",budgetStatus:j.budget_status,issuedDate:j.issued_date,aeAssigned:j.ae_assigned})):null;
            if(_jos){setJos(prev=>mlo(_jos,dropStaleJos(_jos,prev)));idbE.push([KEYS.jos,_jos]);}
            if(Object.keys(data.pcards||{}).length){setPcards(prev=>mergeLocalOnlyObj(data.pcards,prev));idbE.push([KEYS.pcards,data.pcards]);}
            const mapSbPayment=p=>({...p,milestoneId:p.milestone_id??p.milestoneId,refNo:p.ref_no??p.refNo,recordedBy:p.recorded_by??p.recordedBy,valueDate:p.value_date??p.valueDate,method:p.payment_method??p.method,bounced:!!(p.bounced??false)});
            const _billings=data.billings?.length?data.billings.map(m=>({...m,dealId:m.deal_id,invoiceNo:m.invoice_no,invoiceDate:m.invoice_date,dueDate:m.due_date,createdBy:m.created_by,receiptType:m.receipt_type||null,withholding:m.withholding??null,retentionHeld:m.retention_held!=null?Number(m.retention_held):undefined,isRetentionRelease:m.is_retention_release||undefined,plannedDate:m.planned_bill_date||undefined,msType:m.ms_type||undefined,payments:(m.payments||[]).map(mapSbPayment)})):null;
            if(_billings){
              // Merge: preserve any locally-recorded payments that didn't sync to Supabase yet
              const idbBilMap=Object.fromEntries((idb[KEYS.billings]||[]).map(b=>[b.id,b]));
              const mergedBillings=_billings.map(sb=>{
                const local=idbBilMap[sb.id];
                if(!local?.payments?.length) return sb;
                const sbPayIds=new Set((sb.payments||[]).map(p=>p.id));
                const localOnly=local.payments.filter(p=>!sbPayIds.has(p.id));
                return localOnly.length?{...sb,payments:[...(sb.payments||[]),...localOnly]}:sb;
              });
              setBillings(mergedBillings);
              idbE.push([KEYS.billings,mergedBillings]);
            }
            const _exps=data.exps!=null?data.exps.map(e=>{const dt=e.date?new Date(e.date):null;return{...e,dealId:e.deal_id,projectId:e.deal_id||null,receiptNo:e.receipt_no,bankAccount:e.bank_account||"",expDate:e.date||null,poRef:e.po_ref||"",note:e.note||e.description||"",accountCode:e.account_code||"",month:e.month!=null?e.month:(dt?dt.getMonth():new Date().getMonth()),year:e.year||(dt?dt.getFullYear():new Date().getFullYear())};}) : null;
            if(_exps!=null){setExps(prev=>mlo(_exps,prev));idbE.push([KEYS.expenses,_exps]);}
            const _prs=data.prs?.length?data.prs.map(p=>({...p,dealId:p.deal_id,projectId:p.deal_id,itemName:p.item||"",estimatedCost:Number(p.estimated_cost)||0,estUnitCost:Number(p.estimated_cost)||0,actualCost:Number(p.actual_cost)||0,actUnitCost:Number(p.actual_cost)||0,budgetCategory:p.budget_category,qtyDelivered:Number(p.qty_delivered)||0,deliveryDate:p.delivery_date,deliveryNote:p.delivery_note||"",drNo:p.dr_no,createdBy:p.created_by,poNumber:p.po_number||"",poDate:p.po_date||"",paymentTerms:p.payment_terms||"",termsText:p.terms_text||"",requestedBy:p.requested_by||p.created_by||"",approvedBy:p.approved_by||"",projectName:p.project_name||"",fromMrId:p.from_mr_id||null,urgency:p.urgency||"Normal",approvedAt:p.approved_at||null,deliveryHistory:p.delivery_history?(() => { try { return JSON.parse(p.delivery_history); } catch(e) { return []; } })():undefined,acctStatus:p.acct_status||"",acctNotes:p.acct_notes||"",acctCheckedBy:p.acct_checked_by||"",acctCheckedAt:p.acct_checked_at||"",paymentBank:p.payment_bank||"",paymentRef:p.payment_ref||"",paymentOrderedBy:p.payment_ordered_by||"",paymentOrderedAt:p.payment_ordered_at||"",paidRef:p.paid_ref||"",paidDate:p.paid_date||"",paidAmt:p.paid_amt!=null?Number(p.paid_amt):null,paidBy:p.paid_by||"",discType:p.disc_type||"none",discValue:Number(p.disc_value)||0,poDiscType:p.po_discount_type||"none",poDiscValue:Number(p.po_discount_value)||0,withVat:p.with_vat||false,accountCode:p.account_code||""})):null;
            if(_prs){setPrs(prev=>{const sbIds=new Set(_prs.map(p=>p.id));const localOnly=prev.filter(p=>!sbIds.has(p.id));return localOnly.length?[..._prs,...localOnly]:_prs;});idbE.push([KEYS.prs,_prs]);}
            const _mreqs=data.mreqs?.length?data.mreqs.map(m=>({...m,dealId:m.deal_id,projectId:m.deal_id,itemName:m.item||"",estimatedCost:Number(m.estimated_cost)||0,estUnitCost:Number(m.estimated_cost)||0,submittedBy:m.submitted_by,requestedBy:m.submitted_by||"",statusChangedAt:m.status_changed_at,urgency:m.urgency||"Normal"})):null;
            if(_mreqs){setMreqs(prev=>mlo(_mreqs,prev));idbE.push([KEYS.mreqs,_mreqs]);}
            const _breqs=data.breqs?.length?data.breqs.map(b=>({...b,dealId:b.deal_id,projectId:b.deal_id,dateNeeded:b.date_needed,approvedBy:b.approved_by,submittedBy:b.submitted_by,requestedBy:b.submitted_by||"",releasedBy:b.released_by||"",releasedAt:b.released_at,statusChangedAt:b.status_changed_at})):null;
            if(_breqs){setBreqs(prev=>mlo(_breqs,prev));idbE.push([KEYS.breqs,_breqs]);}
            const _addenda=data.addenda?.length?data.addenda.map(a=>({...a,dealId:a.deal_id,receiptType:a.receipt_type,salesNotified:a.sales_notified,discoveredBy:a.discovered_by,kind:a.kind||"Additive",scopeItems:Array.isArray(a.scope_items)?a.scope_items:[],coBoqData:a.co_boq_data||null,salesOwner:a.sales_owner||"",awardedDate:a.awarded_date||null,subAccount:a.sub_account||null})):null;
            if(_addenda){setAddenda(prev=>mlo(_addenda,prev));idbE.push([KEYS.addenda,_addenda]);}
            const _checklist=data.checklist?.length?data.checklist.map(c=>({...c,projectId:c.deal_id,dealId:c.deal_id,assignedTo:c.assigned_to,dueDate:c.due_date,riskNote:c.risk_note,workDetail:c.work_detail||c.description||c.workDetail||""})):null;
            if(_checklist){setChecklist(prev=>mlo(_checklist,prev));idbE.push([KEYS.checklist,_checklist]);}
            const _swatches=data.swatches?.length?data.swatches.map(s=>({...s,dealId:s.deal_id,refLink:s.ref_link})):null;
            if(_swatches){setSwatches(prev=>mlo(_swatches,prev));idbE.push([KEYS.swatches,_swatches]);}
            if(data.actLog?.length) setActLog(prev=>mlo(data.actLog.map(a=>({...a,dealId:a.deal_id})),prev));
            // Cash positions are the source of truth for the whole finance report,
            // so treat the SERVER as authoritative whenever the read actually
            // succeeded — even if it came back empty (that genuinely means no rows).
            // Only when the read FAILED (recorded in data._failed) do we keep the
            // local cache; in that case flag it stale so the UI can warn and the
            // Daily Cash Position sheet won't silently save over the server.
            {
              const cashReadFailed=Array.isArray(data._failed)&&data._failed.includes("cash_positions");
              setCashStale(cashReadFailed);
              if(!cashReadFailed) setCashPos(prev=>{const merged=dropPhantomCashDays(mergeLocalOnlyObj(convertSbCashPos(data.cashPositions),prev));idbSetMany([[KEYS.cashPos,merged]]).catch(()=>{});return merged;});
            }
            const _budgets=Object.keys(data.budgets||{}).length?Object.fromEntries(Object.entries(data.budgets).map(([k,b])=>[k,{Materials:b.materials,Labor:b.labor,Overhead:b.overhead,Subcon:b.subcon,notes:b.notes}])):null;
            if(_budgets){setBudgets(prev=>mergeLocalOnlyObj(_budgets,prev));idbE.push([KEYS.budgets,_budgets]);}
            if(data.inflows!=null){setInfs(data.inflows);idbE.push([KEYS.inflows,data.inflows]);}
            const _payables=data.payables!=null?data.payables.map(payableFromSb):null;
            if(_payables!=null){setPayables(prev=>mlo(_payables,prev));idbE.push(["gmdv5:payables",_payables]);}
            if(data.payablePayments!=null&&!(Array.isArray(data._failed)&&data._failed.includes("payable_payments"))){const _pp=data.payablePayments.map(payablePaymentFromSb);setPayPays(prev=>mlo(_pp,prev));idbE.push([KEYS.payPays,_pp]);}
            const _loans=data.loans!=null?data.loans.map(l=>({...l,disbursedDate:l.disbursed_date,termMonths:l.term_months,interestRate:l.interest_rate,monthlyPayment:l.monthly_payment,createdAt:l.created_at,payments:l.payments||[]})):null;
            if(_loans!=null){setLoans(prev=>mlo(_loans,prev));idbE.push(["gmdv5:loans",_loans]);}
            const _vouchers=data.checkVouchers?.length?data.checkVouchers.map(v=>({...v,cvNo:v.cv_no,projectId:v.project_id,releasedBy:v.released_by||"",releasedDate:v.released_date||null,createdBy:v.created_by||"",createdAt:v.created_at||null,poRef:v.po_ref||"",apRef:v.ap_ref||"",payableId:v.payable_id||null,checkNo:v.check_no||"",clearedDate:v.cleared_date||null,isCleared:v.is_cleared||false})):null;
            if(_vouchers){setVouchers(prev=>mlo(_vouchers,prev));idbE.push([KEYS.vouchers,_vouchers]);}
            const _dl=data.dailyLogs?.length?data.dailyLogs.map(l=>({...l,dealId:l.deal_id,date:l.log_date,workDone:l.work_done,progressNote:l.progress_note,loggedBy:l.logged_by,createdAt:l.created_at})):null;
            if(_dl){setDailyLogs(prev=>mlo(_dl,prev));idbE.push([KEYS.dailylogs,_dl]);}
            const _ceReqs=data.ceReqs?.length?data.ceReqs.map(ceReqFromSb):null;
            if(_ceReqs){setCeReqs(prev=>mlo(_ceReqs,prev));idbE.push([KEYS.ceReqs,_ceReqs]);}
            if(data.blockers?.length){const bl=data.blockers.map(b=>({id:b.id,dealId:b.deal_id,title:b.title,dept:b.dept||"Operations",detail:b.detail||"",flaggedBy:b.flagged_by||"",status:b.status||"Open",createdAt:b.created_at||"",resolvedBy:b.resolved_by||null,resolvedAt:b.resolved_at||null}));setBlockers(prev=>mlo(bl,prev));idbE.push([KEYS.blockers,bl]);localStorage.setItem(KEYS.blockers,JSON.stringify(bl));}
            if(data.settings?.botsettings){const{token:_t,...bs}=data.settings.botsettings;setBotSettings(bs);idbE.push([KEYS.botsettings,bs]);}
            const _drfs=data.drfs?.length?data.drfs.map(drfFromSb):null;
            if(_drfs){setDrfs(prev=>mlo(_drfs,prev));idbE.push([KEYS.drfs,_drfs]);}
            const _inv=data.inventory?.length?data.inventory.map(invFromSb):null;
            if(_inv){setInventory(prev=>{const sbIds=new Set(_inv.map(i=>i.id));const localOnly=prev.filter(i=>!sbIds.has(i.id));return localOnly.length?[..._inv,...localOnly]:_inv;});idbE.push([KEYS.inventory,_inv]);}
            const _stock=data.stocklog?.length?data.stocklog.map(moveFromSb):null;
            if(_stock){setStocklog(_stock);idbE.push([KEYS.stocklog,_stock]);}
            const _tools=data.tools?.length?data.tools.map(toolFromSb):null;
            if(_tools){setTools(prev=>mlo(_tools,prev));idbE.push([KEYS.tools,_tools]);}
            const _drs=data.drs?.length?data.drs.map(drFromSb):null;
            if(_drs){setDrs(prev=>mlo(_drs,prev));idbE.push([KEYS.drs,_drs]);}
            const _suppliers=data.suppliers?.length?data.suppliers.map(s=>({...s,companyName:s.company_name,contactNos:s.contact_nos,contactPerson:s.contact_person,paymentTerms:s.payment_terms,tinNo:s.tin_no,createdBy:s.created_by})):null;
            if(_suppliers){setSuppliers(prev=>mlo(_suppliers,prev));idbE.push([KEYS.suppliers,_suppliers]);}
            const _subcons=data.subcontractors?.length?data.subcontractors.map(s=>({...s,companyName:s.company_name,strengthsWeaknesses:s.strengths_weaknesses,contactNo:s.contact_no,paymentTerms:s.payment_terms,rateStructure:s.rate_structure,paymentStructure:s.payment_structure,locationNote:s.location_note,createdBy:s.created_by})):null;
            if(_subcons){setSubcons(prev=>mlo(_subcons,prev));idbE.push([KEYS.subcons,_subcons]);}
            const _boqLib=data.boqLibrary?.length?data.boqLibrary.map(it=>({id:it.id,name:it.name,description:it.description||"",section:it.category||"",unit:it.unit||"lot",unitCost:Number(it.unit_cost)||0,tags:it.tags||[],createdBy:it.created_by||"",createdAt:it.created_at||"",updatedAt:it.updated_at||""})):null;
            if(_boqLib){setBoqLibrary(prev=>mlo(_boqLib,prev));idbE.push([KEYS.boqLibrary,_boqLib]);}
            const _users=data.users?.length?data.users.map(u=>{
              // If Supabase row has no password_hash, fall back to the DEFAULT_USERS hash
              // so existing users can still log in while hashes are being migrated
              const fallbackHash=DEFAULT_USERS.find(d=>d.username===(u.username||""))?.passwordHash||"";
              return{id:u.id,username:u.username||"",name:u.name||u.full_name||"",role:u.role||"Sales",title:u.title||u.role||"",status:u.status||"active",passwordHash:u.password_hash||fallbackHash,createdAt:u.created_at||""};
            }):null;
            if(_users){setUsers(prev=>mlo(_users,prev));idbE.push([KEYS.users,_users]);}
            if(data.settings?.vvip){const sv=new Set(data.settings.vvip);setVvip(sv);idbE.push([KEYS.vvip,[...sv]]);}
            if(data.settings?.customclients){const cc=data.settings.customclients;setCustomClients(cc);idbE.push([KEYS.customclients,cc]);cc.forEach(c=>{if(!GMD_CLIENTS.find(x=>x.name.toLowerCase()===c.name.toLowerCase())) GMD_CLIENTS.push(c);}); }
            if(data.settings?.custom_members){const cm=data.settings.custom_members;setCustomMembers(cm);localStorage.setItem("gmdv5:customMembers",JSON.stringify(cm));idbE.push(["gmdv5:customMembers",cm]);}
            if(data.settings?.evouchers){const ev=data.settings.evouchers;setEvouchers(ev);idbE.push([KEYS.evouchers,ev]);}
            if(data.settings?.announcements){const an=data.settings.announcements;setAnnouncements(an);idbE.push([KEYS.announcements,an]);}
            if(data.settings?.clientprofiles){const cp=data.settings.clientprofiles;setClientProfiles(cp);idbE.push(["gmdv5:clientprofiles",cp]);}
            if(data.standaloneBoqs){
              // Standalone BOQs now come from their own table, one row per BOQ
              // (migration 051). Server is authoritative; keep any local-only
              // BOQ that hasn't reached the server yet (offline draft) and push
              // it up, so an in-flight save is never lost on refresh.
              const serverBoqs=data.standaloneBoqs;
              setStandaloneBoqs(prev=>{
                const serverIds=new Set(serverBoqs.map(b=>b.id));
                const localOnly=prev.filter(b=>!serverIds.has(b.id));
                const merged=[...serverBoqs,...localOnly];
                localStorage.setItem("gmdv5:standaloneBoqs",JSON.stringify(merged));
                idbSetMany([["gmdv5:standaloneBoqs",merged]]).catch(()=>{});
                if(localOnly.length&&isSupabaseReady())
                  localOnly.forEach(b=>sbUpsert('standalone_boqs',_boqToRow(b),'id').catch(()=>{}));
                return merged;
              });
            }
            if(data.settings?.chart_of_accounts){const coa=data.settings.chart_of_accounts;setChartOfAccounts(coa);localStorage.setItem("gmdv5:chartOfAccounts",JSON.stringify(coa));idbE.push(["gmdv5:chartOfAccounts",coa]);}
            if(data.projs&&Object.keys(data.projs).length){setProjs(prev=>mergeLocalOnlyObj(data.projs,prev));idbE.push([KEYS.projects,data.projs]);}
            console.log("\u2705 FabHub: Loaded from Supabase \u2014 "+(data.deals?.length||0)+" deals");
            // Auto-sync: push any local records that Supabase is missing.
            // This covers saves made while offline or before Supabase was ready.
            setTimeout(()=>{
              const uuidRe=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
              const sbDealIds=new Set((data.deals||[]).map(d=>d.id));
              const sbPrIds=new Set((data.prs||[]).map(r=>r.id));
              const sbJoIds=new Set((data.jos||[]).map(j=>j.id));
              const sbJos=(data.jos||[]).map(j=>({id:j.id,joNo:j.jo_no}));
              const sbSwoIds=new Set((data.swos||[]).map(s=>s.id));
              const sbMrIds=new Set((data.mreqs||[]).map(r=>r.id));
              const sbBrIds=new Set((data.breqs||[]).map(r=>r.id));
              // Read current local state via functional updater pattern (read-only)
              setDeals(localDeals=>{
                const missing=localDeals.filter(d=>uuidRe.test(d.id||"")&&!sbDealIds.has(d.id));
                if(missing.length){console.info("[FabHub] Auto-syncing",missing.length,"local-only deals to Supabase");missing.forEach(d=>sbSyncOne("deals",d,toSbDeal));}
                return localDeals;
              });
              setPrs(localPrs=>{
                const missing=localPrs.filter(r=>uuidRe.test(r.id||"")&&!sbPrIds.has(r.id));
                if(missing.length){console.info("[FabHub] Auto-syncing",missing.length,"local-only POs to Supabase");missing.forEach(r=>sbSyncOne("purchase_requests",r,toSbPR));}
                return localPrs;
              });
              setJos(localJos=>{
                const missing=dropStaleJos(sbJos,localJos).filter(j=>uuidRe.test(j.id||"")&&!sbJoIds.has(j.id));
                if(missing.length){console.info("[FabHub] Auto-syncing",missing.length,"local-only JOs to Supabase");missing.forEach(j=>sbSyncOne("job_orders",j,toSbJO));}
                return localJos;
              });
              setSwos(localSwos=>{
                const missing=localSwos.filter(s=>uuidRe.test(s.id||"")&&!sbSwoIds.has(s.id));
                if(missing.length){console.info("[FabHub] Auto-syncing",missing.length,"local-only WOs to Supabase");missing.forEach(s=>sbSyncOne("subcon_work_orders",s,swoToSb));}
                return localSwos;
              });
              setMreqs(localMreqs=>{
                const missing=localMreqs.filter(r=>uuidRe.test(r.id||"")&&!sbMrIds.has(r.id));
                if(missing.length){console.info("[FabHub] Auto-syncing",missing.length,"local-only MRs to Supabase");missing.forEach(r=>sbSyncOne("material_requests",r,toSbMR));}
                return localMreqs;
              });
              setBreqs(localBreqs=>{
                const missing=localBreqs.filter(r=>uuidRe.test(r.id||"")&&!sbBrIds.has(r.id));
                if(missing.length){console.info("[FabHub] Auto-syncing",missing.length,"local-only BRs to Supabase");missing.forEach(r=>sbSyncOne("budget_requests",r,toSbBR));}
                return localBreqs;
              });
            },2000); // 2s delay \u2014 let all state settle before comparing
            try{
              // Load via sbList (the same helper every other table uses) — the previous
              // raw supabase.from('ae_updates').select('*') call wasn't populating the
              // feed, so recently-posted updates stayed invisible behind the stale local
              // cache. Merge with any local-only rows so nothing is lost, and push those
              // local-only rows up so Supabase becomes the complete source of truth.
              const aeRows=await sbList('ae_updates',{order:'created_at',limit:300});
              if(aeRows){
                const mapped=aeRows.map(r=>({id:r.id,by:r.by,role:r.role,date:r.date,time:r.time,text:r.text,dealId:r.deal_id||null}));
                const remoteIds=new Set(mapped.map(u=>u.id));
                const localCache=((await idbGetMany(["gmdv5:aeUpdates"]))||{})["gmdv5:aeUpdates"]||[];
                // Server is the source of truth for the shared feed. Only keep local-only
                // rows posted TODAY (in-flight posts still syncing) — stale browser-only
                // rows that were never synced are dropped so old updates don't linger.
                const localOnly=localCache.filter(u=>u&&u.id&&!remoteIds.has(u.id)&&u.date===today);
                const merged=[...mapped,...localOnly]
                  .sort((a,b)=>String((b.date||"")+(b.time||"")).localeCompare(String((a.date||"")+(a.time||""))))
                  .slice(0,300);
                setAeUpdates(merged);idbE.push(["gmdv5:aeUpdates",merged]);
                localOnly.forEach(u=>sbInsert('ae_updates',{id:u.id,by:u.by,role:u.role,date:u.date,time:u.time,text:u.text,deal_id:u.dealId||null}).catch(()=>{}));
              }
            }catch(e){console.error('ae_updates load failed:',e);}
            try{
              sbList('audit_findings',{order:'created_at',limit:500}).then(rows=>{if(rows)setAuditFindings(rows.map(findingFromSb));}).catch(()=>{});
            }catch(e){console.error('audit_findings load failed:',e);}
            try{
              sbList('ce_requests',{order:'created_at',limit:500}).then(rows=>{if(rows?.length)setCeReqs(rows.map(r=>({id:r.id,clientName:r.client_name,projectName:r.project_name,location:r.location,projectType:r.project_type,priority:r.priority,status:r.status,submittedBy:r.submitted_by,targetDeadline:r.target_deadline,submissionDeadline:r.submission_deadline,targetBudget:r.target_budget,targetMargin:r.target_margin,plansLink:r.plans_link,skpLink:r.skp_link,scheduleOfFinish:r.schedule_of_finish,notes:r.notes,ceNotes:r.ce_notes,bidAmount:r.bid_amount,bidMarginPct:r.bid_margin_pct,awarded:r.awarded,awardDate:r.award_date,dealId:r.deal_id,createdAt:r.created_at})));}).catch(()=>{});
            }catch{}
            if(idbE.length) idbSetMany(idbE).catch(()=>{});
          }
        }catch(sbErr){
          console.warn("Supabase load failed — using IDB cache:", sbErr.message);
        }finally{
          setSbReady(true);
        }
      }
    };
    init();

    // (Supabase auth-state listener removed — FabHub now uses its own token-based
    // login: appLogin mints the role token, restoreAppToken rehydrates it on boot.)
  },[]);

  // Tables whose dropped writes are derived/log/rollup state, not something a person
  // typed as a form — they get a dedicated, non-alarming drop toast (below) and must NOT
  // also trip the scary red "redo it or contact support" banner. Defined here (module-ish
  // scope for this component) so BOTH the error handler and the drop handler can read it.
  const LOW_STAKES_DROP_TABLES=useRef(new Set(["activity_log","project_card_dept_tasks","project_card_dept_status"])).current;
  // App-wide sync-failure warning: when ANY Supabase write fails (offline, RLS,
  // network), warn the user once (throttled) that changes are local-only — instead
  // of the 160+ silent .catch() sites that hid sync failures from the user.
  useEffect(()=>{
    let last=0;
    setSbErrorHandler((op,table,msg,kind)=>{
      // Low-stakes tables own their own gentle drop toast (setSbDropHandler below).
      // Firing the red "bad data — redo it or contact support" banner for them too
      // produced two contradictory toasts for one event ("redo it" vs "nothing lost").
      if(LOW_STAKES_DROP_TABLES.has(table)) return;
      // Expired login: the write is held in the queue, and the session-expired
      // banner (below) tells the user what to do. No scary "rejected" toast.
      if(kind==="expired") return;
      const n=Date.now();
      if(n-last>30000){
        last=n;
        const text=kind==="auth"
          ?"⚠️ The server rejected a change — your account may not have permission to save this, or your session expired. Nothing is being saved to the server. If logging out and back in doesn't fix it, contact your administrator about your access."
          :kind==="data"
          ?"⚠️ The server rejected a change (bad data) — it won't be retried automatically. Please redo it or contact support."
          :"⚠️ Some changes aren't reaching the server — you may be offline. Working locally; they'll sync when the connection returns.";
        toastEmit(text,"error",8000);
      }
    });
    return ()=>setSbErrorHandler(null);
  },[]);

  // A queued write that's non-retryable (bad data/permission) or has failed 8
  // retry cycles is dropped from the queue for good — until now that drop was
  // a console.error only, so the pending-sync badge count would quietly go
  // down as if it synced, while the change never reached the server at all.
  // This must never be throttled like the generic warning above: it's the
  // one remaining path where something the user believes saved is gone.
  // Tables that are derived/audit records, not something a person typed in —
  // losing one means the history feed is missing an entry, not that someone's
  // work vanished. A dropped write here should read as low-stakes, not as a
  // wall of identical "NOT SAVED, please redo it" errors (which is exactly
  // what a burst of same-cause drops used to produce, one toast per item).
  // (LOW_STAKES_DROP_TABLES is defined above so the red-banner handler shares it.)
  const dropBufferRef=useRef([]);
  const dropTimerRef=useRef(null);
  useEffect(()=>{
    setSbDropHandler((op,kind,msg)=>{
      dropBufferRef.current.push({table:op?.table||"the server",msg});
      if(dropTimerRef.current) return;
      // Collect drops for a short window instead of firing one toast per
      // item — a single doomed batch (e.g. 20 activity_log entries pointing
      // at a deal that never synced) used to paint 20 identical red toasts.
      dropTimerRef.current=setTimeout(()=>{
        const batch=dropBufferRef.current; dropBufferRef.current=[]; dropTimerRef.current=null;
        const byTable={};
        batch.forEach(({table,msg})=>{ (byTable[table]=byTable[table]||{count:0,msg}).count++; });
        Object.entries(byTable).forEach(([table,{count,msg}])=>{
          const low=LOW_STAKES_DROP_TABLES.has(table);
          // "No row matched … it may not exist on the server yet" means the edit
          // was fine — its PARENT record just never reached the server, so the
          // update had nothing to attach to. "Please redo it" is the wrong advice
          // here (redoing the edit hits the same missing row); the fix is to push
          // the local record up first via the Data Backup → "Push All Data to
          // Cloud" button, which recreates the parent so the queued edit lands.
          const orphan=!low && /no row matched/i.test(msg||"");
          // Department task/status rows are real completion state a person toggled — not a
          // log — but they're a rollup that lives on the device and re-derives from the
          // checklist, so the honest message is "saved here, not on the server yet," not the
          // "nothing you did is lost" line that's true only for the activity_log feed.
          const deptTable=table==="project_card_dept_tasks"||table==="project_card_dept_status";
          const text=low
            ? deptTable
              ? `⚠️ ${count} department progress update${count===1?"":"s"} couldn't reach the server yet — ${count===1?"it's":"they're"} saved on this device. This usually means the project card isn't on the server yet: open 💾 Data Backup and tap "☁ Push All Data to Cloud", then retry sync.`
              : `ℹ️ ${count} history/audit ${count===1?"entry":"entries"} for ${table} couldn't be saved — this is internal log data, not something you entered, so nothing you did is lost.`
            : orphan
            ? `❌ ${count} change${count===1?"":"s"} to ${table} couldn't sync — the record ${count===1?"it belongs":"they belong"} to isn't on the server yet. Your change is still saved on this device. Open 💾 Data Backup and tap "☁ Push All Data to Cloud" to fix it, then retry sync.`
            : `❌ ${count} change${count===1?"":"s"} to ${table} could not be saved after several attempts — ${count===1?"it":"they"} were NOT saved. Please redo ${count===1?"it":"them"}. ${msg?`(${msg})`:""}`;
          toastEmit(text,low?"warning":"error",low?8000:15000);
        });
      },500);
    });
    return ()=>{ setSbDropHandler(null); if(dropTimerRef.current){clearTimeout(dropTimerRef.current);dropTimerRef.current=null;} };
  },[]);

  // Offline write queue: track how many writes are still pending and keep
  // retrying them on mount / focus / reconnect until they reach the server.
  const[accountsPermOpen,setAccountsPermOpen]=useState(false); // Role Permissions panel on the Accounts page
  const[pendingSync,setPendingSync]=useState(sbQueueSize());
  // The role token lives 12h and was only checked at boot, so a tab left open
  // past that kept "saving" into a wall of JWT-expired rejections. Now the
  // server's "JWT expired" (or the local clock) flips this on, writes are held
  // in the queue, and a banner asks the user to log in again.
  const[sessionExpired,setSessionExpired]=useState(false);
  useEffect(()=>{
    setSessionExpiredHandler(()=>setSessionExpired(true));
    const t=setInterval(()=>{ if(appTokenExpired()) setSessionExpired(true); },60000);
    return ()=>{ setSessionExpiredHandler(null); clearInterval(t); };
  },[]);
  useEffect(()=>{
    const off=sbOnQueueChange(n=>setPendingSync(n));
    const tryFlush=()=>{ if(isSupabaseReady()) sbFlushQueue(); };
    tryFlush();
    window.addEventListener("focus",tryFlush);
    window.addEventListener("online",tryFlush);
    return ()=>{ off(); window.removeEventListener("focus",tryFlush); window.removeEventListener("online",tryFlush); };
  },[]);

  // Auto-refresh when user switches back to FabHub tab/app
  useEffect(()=>{
    let lastRefresh=0;
    const refresh=async()=>{
      if(!isSupabaseReady()||!session) return;
      const now=Date.now();
      if(now-lastRefresh<30000) return; // max once per 30s
      lastRefresh=now;
      try{
        const data=await sbLoadAll();
        // mergeLocalOnly: this fires on every tab-focus/reconnect (throttled to
        // once/30s) — far more often than a manual page refresh — so a blind
        // overwrite here was the single biggest way to lose a just-added record
        // that hadn't synced yet (e.g. still in flight when the user tabbed away).
        if(data?.deals?.length) setDeals(prev=>mlo(data.deals.map(d=>({...d,ceNo:d.ce_no,ceType:d.ce_type,salesOwner:d.sales_owner,bizDevSource:d.biz_dev_source,dateAcquired:d.date_acquired,dueDate:d.due_date,followUp:d.follow_up||"",amountPaid:Number(d.amount_paid)||0,paymentStatus:d.payment_status,billingGenerated:d.billing_generated||false,receiptType:d.receipt_type,commsGroup:d.comms_group,salesRepoLink:d.sales_repo_link,proposalFolderLink:d.proposal_folder_link,salesRepoNote:d.sales_repo_note||"",location:d.location||"",addedBy:d.added_by||"",addedAt:d.added_at||"",stage:normalizeStage(d.stage),awardRequestData:d.award_request_data||null,parentDealId:d.parent_deal_id||null,addendumStatus:d.addendum_status||null,leadOrigin:d.lead_origin||DEFAULT_LEAD_ORIGIN,leadOriginStatus:d.lead_origin_status||"Approved",leadOriginApprovedBy:d.lead_origin_approved_by||"",leadOriginApprovedAt:d.lead_origin_approved_at||null,standbyPO:d.standby_po||false,dpWaivedBy:d.dp_waived_by||"",dpWaivedAt:d.dp_waived_at||null,dpWaivedReason:d.dp_waived_reason||"",poBudget:d.standby_po?(Number(d.po_budget)||0):"",bir2303Url:d.bir_2303_url||"",bir2303OnFile:d.bir_2303_on_file||false,signedCeUrl:d.signed_ce_url||"",signedCeOnFile:d.signed_ce_on_file||false,clientPoNo:d.client_po_no||"",isCostCenter:!!d.is_cost_center,vatTreatment:d.vat_treatment||"",downpaymentPct:d.downpayment_pct??null,paymentTermsText:d.payment_terms_text||"",clientSatisfied:d.client_satisfied||false,satisfactionNote:d.satisfaction_note||"",paymentTerms:d.payment_terms_json?(()=>{try{return JSON.parse(d.payment_terms_json);}catch(e){return null;}})():null})),prev));
        if(data?.jos?.length){const js=data.jos.map(j=>({...j,dealId:j.deal_id,joNo:j.jo_no}));setJos(prev=>mlo(js,dropStaleJos(js,prev)));}
        if(Object.keys(data?.pcards||{}).length) setPcards(prev=>mergeLocalOnlyObj(data.pcards,prev));
        // Map the same camelCase fields the initial load does. Omitting dueDate
        // (leaving only the raw due_date) made the Field Board — which filters on
        // c.dueDate — drop every event on each focus/visibility refresh, so a
        // calendar item showed on first load then vanished the moment the app
        // regained focus (constant on mobile). Keep this in sync with the full
        // checklist mapping in the initial load / loadAllFromSupabase.
        if(data?.checklist?.length) setChecklist(prev=>mlo(data.checklist.map(c=>({...c,projectId:c.deal_id,dealId:c.deal_id,assignedTo:c.assigned_to,dueDate:c.due_date,riskNote:c.risk_note,sortOrder:c.sort_order,workDetail:c.work_detail||c.description||c.workDetail||""})),prev));
      }catch(e){console.warn("Focus refresh:",e.message);}
    };
    const onVisibility=()=>{ if(document.visibilityState==="visible") refresh(); };
    window.addEventListener("focus",refresh);
    window.addEventListener("online",refresh); // network reconnect (mobile/PWA)
    document.addEventListener("visibilitychange",onVisibility);
    return()=>{
      window.removeEventListener("focus",refresh);
      window.removeEventListener("online",refresh);
      document.removeEventListener("visibilitychange",onVisibility);
    };
  },[session]);

  // ── SUPABASE: Load all data ───────────────────────────────────────────────
  const loadAllFromSupabase = async () => {
    if(!isSupabaseReady()) return;
    const data = await sbLoadAll();
    if(!data) return;
    const idbE=[];
    // mergeLocalOnly on every one of these: this is the "Retry Sync" button's
    // handler (and runs on login too) — the exact moment a user most likely
    // clicks it is right after a save looked stuck, which is also the exact
    // moment a blind overwrite would erase the very record they're trying to
    // recover.
    if(data.deals?.length){const ds=data.deals.map(d=>({...d,stage:normalizeStage(d.stage||d.stage),ceNo:d.ce_no,ceType:d.ce_type,product:d.product,salesOwner:d.sales_owner,bizDevSource:d.biz_dev_source,dateAcquired:d.date_acquired,dueDate:d.due_date,followUp:d.follow_up||"",amountPaid:d.amount_paid||0,paymentStatus:d.payment_status,billingGenerated:d.billing_generated||false,receiptType:d.receipt_type,commsGroup:d.comms_group,salesRepoLink:d.sales_repo_link,proposalFolderLink:d.proposal_folder_link,salesRepoNote:d.sales_repo_note||"",location:d.location||"",addedBy:d.added_by||"",addedAt:d.added_at||"",awardRequestData:d.award_request_data||null,parentDealId:d.parent_deal_id||null,addendumStatus:d.addendum_status||null,standbyPO:d.standby_po||false,dpWaivedBy:d.dp_waived_by||"",dpWaivedAt:d.dp_waived_at||null,dpWaivedReason:d.dp_waived_reason||"",poBudget:d.standby_po?(Number(d.po_budget)||0):"",leadOrigin:d.lead_origin||DEFAULT_LEAD_ORIGIN,leadOriginStatus:d.lead_origin_status||"Approved",leadOriginApprovedBy:d.lead_origin_approved_by||"",leadOriginApprovedAt:d.lead_origin_approved_at||null,boqData:d.boq_data||null,bir2303Url:d.bir_2303_url||"",bir2303OnFile:d.bir_2303_on_file||false,signedCeUrl:d.signed_ce_url||"",signedCeOnFile:d.signed_ce_on_file||false,clientPoNo:d.client_po_no||"",isCostCenter:!!d.is_cost_center,vatTreatment:d.vat_treatment||"",downpaymentPct:d.downpayment_pct??null,paymentTermsText:d.payment_terms_text||"",clientSatisfied:d.client_satisfied||false,satisfactionNote:d.satisfaction_note||"",paymentTerms:d.payment_terms_json?(()=>{try{return JSON.parse(d.payment_terms_json);}catch(e){return null;}})():null}));setDeals(prev=>mlo(ds,prev));idbE.push([KEYS.deals,ds]);}
    if(data.jos?.length){const js=data.jos.map(j=>({...j,dealId:j.deal_id,joNo:j.jo_no,projectName:j.project_name,awardTrigger:j.award_trigger,triggerDate:j.trigger_date,startDate:j.start_date,commsLink:j.comms_link,scopeNotes:j.scope_notes,specialInstructions:j.special_instructions,designer:j.designer||"",location:j.location||"",budgetStatus:j.budget_status,issuedBy:j.issued_by,issuedDate:j.issued_date,aeAssigned:j.ae_assigned}));setJos(prev=>mlo(js,dropStaleJos(js,prev)));idbE.push([KEYS.jos,js]);}
    if(Object.keys(data.pcards||{}).length){setPcards(data.pcards);idbE.push([KEYS.pcards,data.pcards]);}
    if(data.billings?.length){const bs=data.billings.map(m=>({...m,dealId:m.deal_id,invoiceNo:m.invoice_no,invoiceDate:m.invoice_date,dueDate:m.due_date,createdBy:m.created_by,retentionHeld:m.retention_held!=null?Number(m.retention_held):undefined,isRetentionRelease:m.is_retention_release||undefined,plannedDate:m.planned_bill_date||undefined,msType:m.ms_type||undefined,payments:(m.payments||[]).map(p=>({...p,milestoneId:p.milestone_id??p.milestoneId,refNo:p.ref_no??p.refNo,recordedBy:p.recorded_by??p.recordedBy,valueDate:p.value_date??p.valueDate,method:p.payment_method??p.method,bounced:!!(p.bounced??false)}))}));setBillings(prev=>mlo(bs,prev));idbE.push([KEYS.billings,bs]);}
    if(data.exps?.length){const mappedExps=data.exps.map(e=>{const dt=e.date?new Date(e.date):null;return{...e,dealId:e.deal_id,receiptNo:e.receipt_no,createdBy:e.created_by,bankAccount:e.bank_account||"",expDate:e.date||null,poRef:e.po_ref||"",payee:e.supplier||"",vatable:e.vatable??undefined,inputVat:e.input_vat!=null?Number(e.input_vat):undefined,ewtRate:e.ewt_rate!=null?Number(e.ewt_rate):undefined,ewtAmount:e.ewt_amount!=null?Number(e.ewt_amount):undefined,netAmount:e.net_amount!=null?Number(e.net_amount):undefined,month:e.month!=null?e.month:(dt?dt.getMonth():new Date().getMonth()),year:e.year||(dt?dt.getFullYear():new Date().getFullYear())};});setExps(prev=>mlo(mappedExps,prev));idbE.push([KEYS.expenses,mappedExps]);}
    if(data.swos?.length){const ws=data.swos.map(swoFromSb);setSwos(prev=>mlo(ws,prev));idbE.push([KEYS.swos,ws]);}
    if(data.inflows?.length){const infs=data.inflows.map(i=>({...i,dealId:i.deal_id,refNo:i.ref_no}));setInfs(prev=>mlo(infs,prev));idbE.push([KEYS.inflows,infs]);}
    if(data.prs?.length){const ps=data.prs.map(p=>({...p,dealId:p.deal_id,projectId:p.deal_id,itemName:p.item||"",estimatedCost:Number(p.estimated_cost)||0,estUnitCost:Number(p.estimated_cost)||0,actualCost:Number(p.actual_cost)||0,actUnitCost:Number(p.actual_cost)||0,budgetCategory:p.budget_category,qtyDelivered:Number(p.qty_delivered)||0,deliveryDate:p.delivery_date,deliveryNote:p.delivery_note||"",drNo:p.dr_no,createdBy:p.created_by,poNumber:p.po_number||"",poDate:p.po_date||"",paymentTerms:p.payment_terms||"",termsText:p.terms_text||"",requestedBy:p.requested_by||p.created_by||"",approvedBy:p.approved_by||"",projectName:p.project_name||"",acctStatus:p.acct_status||"",acctNotes:p.acct_notes||"",acctCheckedBy:p.acct_checked_by||"",acctCheckedAt:p.acct_checked_at||"",paymentBank:p.payment_bank||"",paymentRef:p.payment_ref||"",paymentOrderedBy:p.payment_ordered_by||"",paymentOrderedAt:p.payment_ordered_at||"",paidRef:p.paid_ref||"",paidDate:p.paid_date||"",paidAmt:p.paid_amt!=null?Number(p.paid_amt):null,paidBy:p.paid_by||"",discType:p.disc_type||"none",discValue:Number(p.disc_value)||0,poDiscType:p.po_discount_type||"none",poDiscValue:Number(p.po_discount_value)||0,withVat:p.with_vat||false,accountCode:p.account_code||""}));setPrs(prev=>mlo(ps,prev));idbE.push([KEYS.prs,ps]);}
    if(data.mreqs?.length){const ms=data.mreqs.map(m=>({...m,dealId:m.deal_id,projectId:m.deal_id,itemName:m.item||"",estimatedCost:Number(m.estimated_cost)||0,estUnitCost:Number(m.estimated_cost)||0,submittedBy:m.submitted_by,requestedBy:m.submitted_by||"",statusChangedAt:m.status_changed_at}));setMreqs(prev=>mlo(ms,prev));idbE.push([KEYS.mreqs,ms]);}
    if(data.breqs?.length){const bs2=data.breqs.map(b=>({...b,dealId:b.deal_id,projectId:b.deal_id,dateNeeded:b.date_needed,approvedBy:b.approved_by,submittedBy:b.submitted_by,requestedBy:b.submitted_by||"",releasedBy:b.released_by||"",releasedAt:b.released_at,statusChangedAt:b.status_changed_at}));setBreqs(prev=>mlo(bs2,prev));idbE.push([KEYS.breqs,bs2]);}
    if(data.addenda?.length){const as=data.addenda.map(a=>({...a,dealId:a.deal_id,receiptType:a.receipt_type,salesNotified:a.sales_notified,discoveredBy:a.discovered_by,kind:a.kind||"Additive",scopeItems:Array.isArray(a.scope_items)?a.scope_items:[],coBoqData:a.co_boq_data||null,salesOwner:a.sales_owner||"",awardedDate:a.awarded_date||null,subAccount:a.sub_account||null}));setAddenda(prev=>mlo(as,prev));idbE.push([KEYS.addenda,as]);}
    if(data.checklist?.length){const cs=data.checklist.map(c=>({...c,projectId:c.deal_id,dealId:c.deal_id,assignedTo:c.assigned_to,dueDate:c.due_date,riskNote:c.risk_note,sortOrder:c.sort_order,workDetail:c.work_detail||c.description||c.workDetail||""}));setChecklist(prev=>mlo(cs,prev));idbE.push([KEYS.checklist,cs]);}
    if(data.swatches?.length){const ss=data.swatches.map(s=>({...s,dealId:s.deal_id,refLink:s.ref_link}));setSwatches(prev=>mlo(ss,prev));idbE.push([KEYS.swatches,ss]);}
    if(data.actLog?.length)      setActLog(prev=>mlo(data.actLog.map(a=>({...a,dealId:a.deal_id})),prev));
    // Server is authoritative for cash positions on a successful read (even an
    // empty one); only a FAILED read keeps the stale local cache — flag it so the
    // UI warns and the Daily Cash Position sheet won't save over the server.
    {
      const cashReadFailed=Array.isArray(data._failed)&&data._failed.includes("cash_positions");
      setCashStale(cashReadFailed);
      if(!cashReadFailed) setCashPos(prev=>{const merged=dropPhantomCashDays(mergeLocalOnlyObj(convertSbCashPos(data.cashPositions),prev));idbE.push([KEYS.cashPos,merged]);return merged;});
    }
    if(Object.keys(data.budgets||{}).length){const bg=Object.fromEntries(Object.entries(data.budgets).map(([k,b])=>[k,{Materials:b.materials,Labor:b.labor,Overhead:b.overhead,Subcon:b.subcon,notes:b.notes}]));setBudgets(prev=>mergeLocalOnlyObj(bg,prev));idbE.push([KEYS.budgets,bg]);}
    if(data.users?.length){const us=data.users.map(u=>{const fallbackHash=DEFAULT_USERS.find(d=>d.username===(u.username||""))?.passwordHash||"";return{id:u.id,username:u.username||"",name:u.name||u.full_name||"",role:u.role||"Sales",title:u.title||u.role||"",status:u.status||"active",passwordHash:u.password_hash||fallbackHash,createdAt:u.created_at||""};});setUsers(prev=>mlo(us,prev));idbE.push([KEYS.users,us]);}
    if(data.payables?.length){const ps=data.payables.map(payableFromSb);setPayables(prev=>mlo(ps,prev));idbE.push(["gmdv5:payables",ps]);}
    if(data.loans?.length){const ls=data.loans.map(l=>({...l,disbursedDate:l.disbursed_date,termMonths:l.term_months,interestRate:l.interest_rate,monthlyPayment:l.monthly_payment,createdAt:l.created_at,payments:l.payments||[]}));setLoans(prev=>mlo(ls,prev));idbE.push(["gmdv5:loans",ls]);}
    if(data.dailyLogs?.length){const dl=data.dailyLogs.map(l=>({...l,dealId:l.deal_id,date:l.log_date,workDone:l.work_done,progressNote:l.progress_note,loggedBy:l.logged_by,createdAt:l.created_at}));setDailyLogs(prev=>mlo(dl,prev));idbE.push([KEYS.dailylogs,dl]);}
    if(data.ceReqs?.length){const cr=data.ceReqs.map(ceReqFromSb);setCeReqs(prev=>mlo(cr,prev));idbE.push([KEYS.ceReqs,cr]);}
    if(data.commissionPayouts?.length){const po=data.commissionPayouts.map(commissionPayoutFromSb);setPayouts(prev=>mlo(po,prev));idbE.push([KEYS.payouts,po]);}
    if(data.payablePayments?.length){const pp=data.payablePayments.map(payablePaymentFromSb);setPayPays(prev=>mlo(pp,prev));idbE.push([KEYS.payPays,pp]);}
    // These tables were previously set only by the boot-time load, never here.
    // Because this function is the LOGIN / Retry-Sync / focus-refresh path, a
    // freshly-provisioned account (e.g. a designer who just got a user_profiles
    // row) that logs in and never hard-reloads would see empty Design Requests,
    // Project Cards, inventory, suppliers, etc. until a full page reload — the
    // "designers see no DRFs" bug. Mirror the boot handler so login populates them.
    if(data.drfs?.length){const _drfs=data.drfs.map(drfFromSb);setDrfs(prev=>mlo(_drfs,prev));idbE.push([KEYS.drfs,_drfs]);}
    if(data.projs&&Object.keys(data.projs).length){setProjs(prev=>mergeLocalOnlyObj(data.projs,prev));idbE.push([KEYS.projects,data.projs]);}
    if(data.inventory?.length){const _inv=data.inventory.map(invFromSb);setInventory(prev=>{const sbIds=new Set(_inv.map(i=>i.id));const localOnly=prev.filter(i=>!sbIds.has(i.id));return localOnly.length?[..._inv,...localOnly]:_inv;});idbE.push([KEYS.inventory,_inv]);}
    if(data.stocklog?.length){const _stock=data.stocklog.map(moveFromSb);setStocklog(_stock);idbE.push([KEYS.stocklog,_stock]);}
    if(data.tools?.length){const _tools=data.tools.map(toolFromSb);setTools(prev=>mlo(_tools,prev));idbE.push([KEYS.tools,_tools]);}
    if(data.drs?.length){const _drs=data.drs.map(drFromSb);setDrs(prev=>mlo(_drs,prev));idbE.push([KEYS.drs,_drs]);}
    if(data.suppliers?.length){const _sup=data.suppliers.map(s=>({...s,companyName:s.company_name,contactNos:s.contact_nos,contactPerson:s.contact_person,paymentTerms:s.payment_terms,tinNo:s.tin_no,createdBy:s.created_by}));setSuppliers(prev=>mlo(_sup,prev));idbE.push([KEYS.suppliers,_sup]);}
    if(data.subcontractors?.length){const _sc=data.subcontractors.map(s=>({...s,companyName:s.company_name,strengthsWeaknesses:s.strengths_weaknesses,contactNo:s.contact_no,paymentTerms:s.payment_terms,rateStructure:s.rate_structure,paymentStructure:s.payment_structure,locationNote:s.location_note,createdBy:s.created_by}));setSubcons(prev=>mlo(_sc,prev));idbE.push([KEYS.subcons,_sc]);}
    if(data.boqLibrary?.length){const _bl=data.boqLibrary.map(it=>({id:it.id,name:it.name,description:it.description||"",section:it.category||"",unit:it.unit||"lot",unitCost:Number(it.unit_cost)||0,tags:it.tags||[],createdBy:it.created_by||"",createdAt:it.created_at||"",updatedAt:it.updated_at||""}));setBoqLibrary(prev=>mlo(_bl,prev));idbE.push([KEYS.boqLibrary,_bl]);}
    if(data.checkVouchers?.length){const _cv=data.checkVouchers.map(v=>({...v,cvNo:v.cv_no,projectId:v.project_id,releasedBy:v.released_by||"",releasedDate:v.released_date||null,createdBy:v.created_by||"",createdAt:v.created_at||null,poRef:v.po_ref||"",payableId:v.payable_id||null,checkNo:v.check_no||"",clearedDate:v.cleared_date||null,isCleared:v.is_cleared||false}));setVouchers(prev=>mlo(_cv,prev));idbE.push([KEYS.vouchers,_cv]);}
    if(data.blockers?.length){const bl=data.blockers.map(b=>({id:b.id,dealId:b.deal_id,title:b.title,dept:b.dept||"Operations",detail:b.detail||"",flaggedBy:b.flagged_by||"",status:b.status||"Open",createdAt:b.created_at||"",resolvedBy:b.resolved_by||null,resolvedAt:b.resolved_at||null}));setBlockers(prev=>mlo(bl,prev));idbE.push([KEYS.blockers,bl]);}
    if(idbE.length) idbSetMany(idbE).catch(()=>{});
  };


  // Converts flat Supabase cash_positions rows back to the rich banks-object format
  const convertSbCashPos=(raw)=>{
    const out={};
    Object.entries(raw).forEach(([date,c])=>{
      out[date]=c.banks?c:{
        ...emptyDayPosition(date),
        banks:{
          bpi:      {beg:String(c.bpi_beg||0),      book:String(c.bpi_book||0),      end:String(c.bpi_end||0)},
          metro:    {beg:String(c.metrobank_beg||0), book:String(c.metrobank_book||0),end:String(c.metrobank_end||0)},
          china:    {beg:String(c.chinabank_beg||0), book:String(c.chinabank_book||0),end:String(c.chinabank_end||0)},
          bdo:      {beg:String(c.bdo_beg||0),       book:String(c.bdo_book||0),      end:String(c.bdo_end||0)},
          security: {beg:String(c.secbank_beg||0),   book:String(c.secbank_book||0),  end:String(c.secbank_end||0)},
          union:    {beg:String(c.unionbank_beg||0),  book:String(c.unionbank_book||0), end:String(c.unionbank_end||0)},
        },
        collections:{
          fabhubAmt:0,
          approvedPayments: typeof c.approved_payments==="string"?(()=>{try{return JSON.parse(c.approved_payments||"[]");}catch(e){return[];}})():(c.approved_payments||[]),
          manualCollections: typeof c.manual_collections==="string"?(()=>{try{return JSON.parse(c.manual_collections||"[]");}catch(e){return[];}})():(c.manual_collections||[]),
        },
        disbursements:{
          manual: typeof c.manual_disbursements==="string"?(()=>{try{return JSON.parse(c.manual_disbursements||"[]");}catch(e){return[];}})():(c.manual_disbursements||[]),
        },
        floatingChecks: typeof c.floating_checks==="string"?(()=>{try{return JSON.parse(c.floating_checks||"[]");}catch(e){return[];}})():(c.floating_checks||[]),
        audit: typeof c.audit==="string"?(()=>{try{return JSON.parse(c.audit||"[]");}catch(e){return[];}})():(c.audit||[]),
        transactions:typeof c.transactions==='string'?(()=>{try{return JSON.parse(c.transactions||'[]');}catch(e){return[];}})():(c.transactions||[]),
        ytd:{
          supplierPayable:c.ytd_supplier_payable>0?String(c.ytd_supplier_payable):"",
          loansPayable:   c.ytd_loans_payable>0?String(c.ytd_loans_payable):"",
          accountsReceivable:"",
          expectedCollection:"",
        },
        notes:c.notes||"",
        savedAt:c.updated_at||null,
      };
    });
    return out;
  };

  // ── SUPABASE FIELD MAPPERS (camelCase → snake_case) ─────────────────────────
  const toSbDeal = r=>({
    id:r.id, ce_no:r.ceNo, client:r.client, contact:r.contact,
    ce_type:r.ceType, product:r.product, stage:r.stage,
    priority:r.priority||"Normal", sales_owner:r.salesOwner||"",
    biz_dev_source:r.bizDevSource||"", lead_origin:leadOriginOf(r), date_acquired:r.dateAcquired||null,
    lead_origin_status:leadOriginPending(r)?"Pending":"Approved", lead_origin_approved_by:r.leadOriginApprovedBy||"", lead_origin_approved_at:r.leadOriginApprovedAt||null,
    temperature:r.temperature||null,
    due_date:r.dueDate||null, follow_up:r.followUp||null,
    value:Number(r.value)||0,
    invoiced:Number(r.invoiced)||0, amount_paid:Number(r.amountPaid)||0,
    payment_status:r.paymentStatus||"Unpaid", receipt_type:r.receiptType||null,
    withholding:r.withholding||false, comms_group:r.commsGroup||"",
    sales_repo_link:r.salesRepoLink||"", proposal_folder_link:r.proposalFolderLink||"",
    notes:r.notes||"", probability:Number(r.probability)||0,
    location:r.location||"",
    added_by:r.addedBy||"", added_at:r.addedAt||null,
    award_request_data:r.awardRequestData||null,
    parent_deal_id:r.parentDealId||null,
    addendum_status:r.parentDealId?(r.addendumStatus||"Pending"):null,
    standby_po:!!r.standbyPO, po_budget:r.standbyPO?(Number(r.poBudget)||0):0,
    billing_generated:r.billingGenerated||false,
    // Receivables policy §2.1 onboarding facts + §2.3/§3 satisfaction
    bir_2303_url:r.bir2303Url||null, bir_2303_on_file:!!r.bir2303OnFile,
    vat_treatment:r.vatTreatment||null,
    downpayment_pct:r.downpaymentPct!=null&&r.downpaymentPct!==""?Number(r.downpaymentPct):null,
    payment_terms_text:r.paymentTermsText||null,
    client_satisfied:!!r.clientSatisfied, satisfaction_note:r.satisfactionNote||null,
    updated_at:new Date().toISOString(),
  });
  const toSbJO = r=>({
    id:r.id, deal_id:r.dealId, jo_no:r.joNo||r.joNum||"",
    client:r.client||"", ce_no:r.ceNo||"", project_name:r.projectName||r.contact||"",
    value:Number(r.value)||0, award_trigger:r.awardTrigger||"",
    trigger_date:r.triggerDate||null, trigger_note:r.triggerNote||"",
    pm1:r.pm1||"", pm2:r.pm2||"", pm3:r.pm3||"", coordinator:r.coordinator||"",
    ae_assigned:r.aeAssigned||"", start_date:r.startDate||null,
    comms_link:r.commsLink||"", scope_notes:r.scopeNotes||"",
    special_instructions:r.specialInstructions||"",
    designer:r.designer||"",
    location:r.location||"",
    budget_status:r.budgetStatus||"QS Budget Pending",
    status:r.status||"Active", issued_date:r.issuedDate||r.dateIssued||null,
  });
  const toSbBilling = r=>{
    // A milestone with no receipt type of its own inherits its deal's — so the
    // persisted vat/ewt/net_receivable follow the deal form (e.g. an AR / VAT-
    // exempt addendum) instead of silently defaulting to OR and baking in 12% VAT.
    const od=deals.find(d=>d.id===r.dealId);
    const tx=calcTax(Number(r.amount)||0,r.receiptType??od?.receiptType??"OR",r.withholding??od?.withholding??false);
    const base={
      id:r.id, deal_id:r.dealId, name:r.name||"", description:r.description||"",
      amount:Number(r.amount)||0, invoice_no:r.invoiceNo||"",
      invoice_date:r.invoiceDate||null, due_date:r.dueDate||null,
      sent_date:r.sentDate||null,
      status:r.status||"Draft", created_by:r.createdBy||"",
      receipt_type:r.receiptType||null, withholding:r.withholding??null,
      vat:tx.vat, ewt:tx.ewt, net_receivable:tx.netReceivable,
    };
    // Retention columns only when set, so writes work before supabase_retention.sql
    // runs (the retry queue syncs them once the columns exist).
    if(r.retentionHeld!=null) base.retention_held=Number(r.retentionHeld)||0;
    if(r.isRetentionRelease) base.is_retention_release=true;
    // Builder fields (migration 070) — only when set, like retention above.
    if(r.plannedDate!==undefined) base.planned_bill_date=r.plannedDate||null;
    if(r.msType) base.ms_type=r.msType;
    return base;
  };
  const toSbPayment = r=>({
    id:r.id, milestone_id:r.milestoneId, amount:Number(r.amount)||0,
    date:r.date||null, ref_no:r.refNo||"", note:r.note||"",
    recorded_by:r.recordedBy||"", bank:r.bank||"",
    value_date:r.valueDate||null,
    payment_method:r.method||"", bounced:!!r.bounced,
  });
  const toSbExpense = r=>{
    let date=r.expDate||null;
    if(!date){const yr=r.year||new Date().getFullYear();const mo=r.month!=null?Number(r.month):new Date().getMonth();date=`${yr}-${String(mo+1).padStart(2,'0')}-01`;}
    const desc=r.note||r.description||"";
    const base={id:r.id,deal_id:r.dealId||r.projectId||null,date,
      category:r.category||"",description:desc,note:desc,
      amount:Number(r.amount)||0,supplier:r.payee||r.supplier||"",receipt_no:r.receiptNo||"",
      bank_account:r.bankAccount||null,cleared_date:r.clearedDate||null,
      acct_status:r.acctStatus||"Logged",payment_method:r.paymentMethod||"",
      payable_id:r.payableId||null,cv_id:r.cvId||null,
      routed_by:r.routedBy||"",routed_at:r.routedAt||null,
      qty:Number(r.qty)||1,price_per_qty:Number(r.pricePerQty)||0,
      tin:r.tin||"",remarks:r.remarks||"",account_code:r.accountCode||null};
    // Tax columns only included when the expense is tax-tagged, so writes keep
    // working before supabase_input_tax.sql is applied (the retry queue syncs
    // any tax-tagged expense once the columns exist).
    if(r.vatable!=null){
      base.vatable=!!r.vatable;
      base.input_vat=Number(r.inputVat)||0;
      base.ewt_rate=Number(r.ewtRate)||0;
      base.ewt_amount=Number(r.ewtAmount)||0;
      base.net_amount=Number(r.netAmount)||0;
    }
    return base;
  };
  const toSbPR = r=>{
    const uuidRe=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const rawId=r.projectId||r.dealId||null;
    const dealId=(rawId==="__gmd_stocks__")?null:(rawId&&uuidRe.test(rawId)?rawId:null);
    return({
    id:r.id, deal_id:dealId, item:r.itemName||r.item||"",
    supplier:r.supplier||"", qty:Number(r.qty)||0, unit:r.unit||"",
    estimated_cost:Number(r.estUnitCost||r.estimatedCost)||0,
    actual_cost:Number(r.actUnitCost||r.actualCost)||0,
    budget_category:r.budgetCategory||"", status:r.status||"Pending Approval",
    qty_delivered:Number(r.qtyDelivered)||0, delivery_date:r.deliveryDate||null,
    dr_no:r.drNo||"", notes:r.notes||"", created_by:r.createdBy||r.requestedBy||"",
    po_number:r.poNumber||"", po_date:r.poDate||null,
    payment_terms:r.paymentTerms||"", terms_text:r.termsText||"",
    delivery_note:r.deliveryNote||"", requested_by:r.requestedBy||"",
    approved_by:r.approvedBy||"", project_name:r.projectName||"",
    with_vat:r.withVat||false,
    from_mr_id:r.fromMrId||null,
    urgency:r.urgency||"Normal",
    approved_at:r.approvedAt||null,
    delivery_history:r.deliveryHistory?JSON.stringify(r.deliveryHistory):null,
    acct_status:r.acctStatus||"", acct_notes:r.acctNotes||"",
    acct_checked_by:r.acctCheckedBy||"", acct_checked_at:r.acctCheckedAt||null,
    payment_bank:r.paymentBank||"", payment_ref:r.paymentRef||"",
    payment_ordered_by:r.paymentOrderedBy||"", payment_ordered_at:r.paymentOrderedAt||null,
    paid_ref:r.paidRef||"", paid_date:r.paidDate||null,
    paid_amt:r.paidAmt!=null?Number(r.paidAmt):null, paid_by:r.paidBy||"",
    disc_type:r.discType||"none", disc_value:Number(r.discValue)||0,
    po_discount_type:r.poDiscType||"none", po_discount_value:Number(r.poDiscValue)||0,
    account_code:r.accountCode||"",
  });};
  const toSbMR = r=>{const uuidRe=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;const rawId=r.projectId||r.dealId||null;const dealId=rawId&&uuidRe.test(rawId)?rawId:null;return({
    id:r.id, deal_id:dealId,
    item:r.itemName||r.item||"", category:r.category||"",
    qty:Number(r.qty)||0, unit:r.unit||"",
    estimated_cost:Number(r.estUnitCost||r.estimatedCost)||0,
    urgency:r.urgency||"Normal", purpose:r.purpose||"", notes:r.notes||"",
    status:r.status||"Submitted", submitted_by:r.requestedBy||r.submittedBy||"",
    created_by:r.createdBy||r.requestedBy||r.submittedBy||"",
    status_changed_at:r.statusChangedAt||null,
  });};
  const toSbBR = r=>{const uuidRe=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;const rawId=r.projectId||r.dealId||null;const dealId=rawId&&uuidRe.test(rawId)?rawId:null;return({
    id:r.id, deal_id:dealId, purpose:r.purpose||"",
    title:r.title||r.purpose||"",
    amount:Number(r.amount)||0, urgency:r.urgency||"Normal",
    date_needed:r.dateNeeded||null, status:r.status||"Pending",
    approved_by:r.approvedBy||"", submitted_by:r.requestedBy||r.submittedBy||"",
    category:r.category||"", notes:r.notes||"",
    released_by:r.releasedBy||"", released_at:r.releasedAt||null,
    status_changed_at:r.statusChangedAt||null,
  });};
  const toSbAddendum = r=>({
    id:r.id, deal_id:r.dealId||r.projectId, title:r.title||"", description:r.description||r.desc||"",
    value:Number(r.value)||0, ce_no:r.ceNo||"",
    kind:r.kind||"Additive", scope_items:Array.isArray(r.scopeItems)?r.scopeItems:[],
    receipt_type:r.receiptType||"OR", withholding:r.withholding||false,
    // NOTE: cost_impact (duplicated `value`) and client_approved (redundant with
    // status "Approved") were written here but never existed as columns on the
    // addenda table and are never read back — so every addendum upsert failed on
    // the unknown column and change orders stopped syncing. Dropped both; `value`
    // and `status` already carry this information and are persisted.
    status:r.status||"Discovered", sales_notified:r.salesNotified||false,
    discovered_by:r.discoveredBy||"",
    co_boq_data:r.coBoqData||null,
    sales_owner:r.salesOwner||null, awarded_date:r.awardedDate||null, sub_account:r.subAccount||null,
  });
  const toSbSwatch = r=>({
    id:r.id, deal_id:r.dealId||r.projectId||null, name:r.name||"", category:r.category||"",
    qty:Number(r.qty)||0, unit:r.unit||"", supplier:r.supplier||"",
    ref_link:r.refLink||r.swatchLink||"", status:r.status||"To Buy", notes:r.notes||"",
    est_cost:Number(r.estCost)||0, swatch_link:r.swatchLink||r.refLink||"",
    added_by:r.addedBy||"",
    client_approved_by:r.clientApprovedBy||null,
    client_approved_at:r.clientApprovedAt||null,
  });
  const toSbChecklist = r=>({
    id:r.id, deal_id:r.dealId||r.projectId||null, type:r.type||"Task", title:r.title||"",
    description:r.workDetail||r.description||"", status:r.status||"Pending",
    assigned_to:r.assignedTo||"", due_date:r.dueDate||null,
    risk_note:r.riskNote||"", sort_order:r.sortOrder||0,
    dept:r.dept||"", priority:r.priority||"Normal",
    notes:r.notes||"", supplier:r.supplier||"",
    created_by:r.createdBy||"", what_could_go_wrong:r.whatCouldGoWrong||"",
    qty:Number(r.qty)||0, unit:r.unit||"pcs",
    category:r.category||null, location:r.location||null,
  });
  // NOTE: password_hash is deliberately NOT written here. The hash column is
  // owned by the server: it is set only via the set_password() RPC (bcrypt) and
  // upgraded in place by verify_login() on login. Syncing it from local state
  // used to clobber the server's bcrypt hash with a stale client-side SHA-256
  // one on every ordinary user-row sync (approve / deactivate / profile edit),
  // which could even revert a changed password to an older value. Omitting the
  // field means an upsert leaves the existing hash untouched.
  const toSbUser = u=>({
    id:u.id, name:u.name||"", username:u.username||"", role:u.role||"Sales",
    title:u.title||"", status:u.status||"active",
    email:u.email||"", created_at:u.createdAt||null,
  });
  // Set a user's password server-side (bcrypt, in Postgres). Authorization is
  // enforced inside the RPC against the caller's JWT (Manager, or self).
  const setPasswordServer = async(id,pw)=>{
    if(!isSupabaseReady()) return false;
    try{ const{error}=await supabase.rpc('set_password',{p_user_id:id,p_new_password:pw}); if(error){console.error('set_password:',error.message);return false;} return true; }
    catch(e){ console.error('set_password:',e); return false; }
  };
  const toSbBudget = (dealId,b)=>({
    deal_id:dealId, materials:Number(b.Materials)||0, labor:Number(b.Labor)||0,
    overhead:Number(b.Overhead)||0, subcon:Number(b.Subcon)||0, notes:b.notes||"",
    set_by:b.setBy||"",
  });
  const toSbActivity = r=>({
    // deal_id is a UUID column: a legacy/ghost deal id (non-UUID local id) would
    // fail the insert, dropping the whole audit entry. Keep the entry (deal_id is
    // nullable) by nulling a non-UUID reference instead of losing the log line.
    // id likewise must be a UUID — fall back to a fresh one, never a text id.
    id:(r.id&&isUUID(r.id))?r.id:uid(), deal_id:(r.dealId&&isUUID(r.dealId))?r.dealId:null,
    action:r.action||"", detail:r.detail||"",
    by:r.by||"", date:r.date||today, time:r.time||"",
  });

  // ── SUPABASE SYNC HELPERS ─────────────────────────────────────────────────
  // Fire-and-forget — never blocks the UI. Errors logged to console only.
  const isUUID=s=>/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(s||''));
  // Reject payloads where any UUID-typed column holds a non-UUID value (old numeric IDs).
  const hasValidUUIDs=p=>(!p.id||isUUID(p.id))&&(!p.deal_id||isUUID(p.deal_id))&&(!p.milestone_id||isUUID(p.milestone_id))&&(!p.card_id||isUUID(p.card_id));
  const sbSync=(table,records,mapper)=>{
    if(!isSupabaseReady()||!records?.length) return;
    Promise.all(records.map(r=>{
      const payload=mapper?mapper(r):r;
      if(!hasValidUUIDs(payload)) return Promise.resolve();
      return sbUpsert(table,payload,'id');
    })).catch(e=>console.error("FabHub sbSync "+table+":",e.message));
  };
  // Returns the sbUpsert outcome (true/false) so a caller that's about to write
  // a DEPENDENT row (one referencing this record by foreign key) can await
  // confirmation first — see createProjectCard for why this matters.
  // Client-side mirror of the server INSERT policies (supabase_migration_037_
  // rls_rollout_v2.sql). Its ONLY job is to keep the bulk/auto re-push paths
  // (migrateToCloud + the load-time auto-sync) from re-uploading records the
  // current role can't write. Those pushes replay the whole local cache — most
  // of which was synced DOWN from the server — so for a role not in a table's
  // insert list, RLS rejects every row with "new row violates row-level
  // security policy". The drop handler then paints that as "N changes NOT saved
  // — please redo them", which is both alarming and wrong: the rows already
  // exist on the server and nothing was lost (observed live: 53 job_orders =
  // the entire table). Skipping the doomed writes removes the false alarm
  // without weakening RLS — the server stays the source of truth, and any
  // genuine single-record write still goes through its own guarded path.
  // Aliases match the mint-session ROLE_MAP so raw profile roles map to the
  // canonical RLS roles before the check. Tables absent from the map are left
  // unrestricted so no legitimate push path changes behavior.
  const INSERT_ROLES={
    deals:["Manager","Sales","SalesOpsAdmin"],
    job_orders:["Manager","ProjectMover"],
    purchase_requests:["Manager","Finance","FinanceAssistant","Procurement"],
    material_requests:["Manager","Sales","Procurement","SalesOpsAdmin"],
    budget_requests:["Manager","Sales","Procurement","SalesOpsAdmin"],
    subcon_work_orders:["Manager","Finance","FinanceAssistant","Procurement"],
    addenda:["Manager","ProjectMover","Procurement","Design"],
    swatches:["Manager","Procurement","Design"],
    // checklists: intentionally UNMAPPED. Migration 049 opened checklists
    // INSERT/UPDATE to any logged-in user (AUTH); leaving it out of this map
    // means roleCanInsert returns true, matching the server. (Previously listed
    // Manager/ProjectMover only, which wrongly blocked the bulk-sync push for
    // Sales/Design/Finance even though RLS now allows them.)
    // Finance cost-entry tables: derive straight from the canonical PERMISSIONS
    // map (core.js) so this push-gate can't drift out of sync with RLS the way it
    // did before — expenses was missing SalesOpsAdmin/Procurement (migration 062),
    // silently dropping their rows on bulk sync, and payables was absent entirely
    // (unmapped → push attempted for every role → server-rejected "changes NOT
    // saved" false alarm). PERMISSIONS is transcribed in lock-step with the
    // migrations, so referencing it keeps one source of truth.
    expenses:PERMISSIONS.expenses.insert,
    payables:PERMISSIONS.payables.insert,
    payable_payments:PERMISSIONS.payable_payments.insert,
    billing_milestones:["Manager","Finance","FinanceAssistant","SalesOpsAdmin"],
    billing_payments:["Manager","Finance","FinanceAssistant","SalesOpsAdmin"],
    commission_payouts:["Manager","Finance","FinanceAssistant"],
    project_budgets:["Manager","QS","Sales","SalesOpsAdmin"], // award (🏆) auto-writes a starting budget; must match migration 068 INSERT policy
    // activity_log is INSERT=AUTH server-side — any logged-in user may write it.
  };
  const ROLE_ALIASES={Operations:"ProjectMover",Ops:"ProjectMover","Cost Control":"Finance",Admin:"Manager",ProcurementManager:"Procurement"};
  const roleCanInsert=(table)=>{
    const allowed=INSERT_ROLES[table];
    if(!allowed) return true; // unmapped table → don't change push behavior
    const canon=ROLE_ALIASES[role]||role;
    return allowed.includes(canon);
  };
  // ── Permission guard for user-initiated writes ──────────────────────────────
  // Checks the PERMISSIONS map (client mirror of RLS) BEFORE a role-gated write
  // and, if the current role isn't allowed, shows a clear dialog and returns
  // false so the caller can abort — instead of optimistically changing local
  // state that the next server resync silently reverts. Used at the write sites
  // where RLS is stricter than the UI (addendum status, daily-log/calendar
  // deletes). Unmapped tables/actions are allowed, so this never over-blocks.
  const roleCanDo=(action,table)=>roleCan(ROLE_ALIASES[role]||role,action,table);
  const guardWrite=async(action,table,label)=>{
    if(roleCanDo(action,table)) return true;
    const verb={select:"view",insert:"add",update:"edit",delete:"delete"}[action]||action;
    await uiAlert({
      title:"Not allowed for your role",
      message:`Your role (${roleLabel(role)}) can't ${verb} ${label||table}.\n\nThis is limited to: ${rolesAllowedLabel(action,table)}.\n\nNothing was changed. Ask a manager if you need access.`,
      tone:"warning",
    });
    return false;
  };
  // opts.ignoreDuplicates → INSERT ... ON CONFLICT DO NOTHING: only materialise a
  // MISSING row, never overwrite an existing one. Use it for parent-before-child
  // FK-safety writes so they can't clobber a server row that's newer than this
  // device's local copy (the stale-`deals`-snapshot clobber that silently
  // reverted an awarded deal's stage and produced a duplicate Job Order).
  const sbSyncOne=(table,record,mapper,opts={})=>{
    if(!isSupabaseReady()||!record) return Promise.resolve(false);
    // Don't re-push what RLS will reject — see roleCanInsert / INSERT_ROLES above.
    if(!roleCanInsert(table)) return Promise.resolve(false);
    const payload=mapper?mapper(record):record;
    if(!hasValidUUIDs(payload)) return Promise.resolve(false);
    return sbUpsert(table,payload,'id',opts)
      .catch(e=>{console.error("FabHub sbSyncOne "+table+":",e.message);return false;});
  };
  const sbSyncDelete=(table,id)=>{
    if(!isSupabaseReady()||!id) return;
    sbDelete(table,id).catch(e=>console.error("FabHub sbDelete "+table+":",e.message));
  };
  // Persist a partial project_cards change keyed on deal_id — but ALWAYS make
  // sure the parent deal exists on the server first. A project_cards row
  // references deals(id) by foreign key (project_cards_deal_id_fkey). Upserting
  // a card for a deal that hasn't reached the server yet — its own insert still
  // sitting in the offline queue, dropped, or never synced from this device —
  // turns the upsert into an INSERT that violates that FK. That's a
  // non-retryable "data" error, so the sync queue drops it for good and the user
  // gets the alarming red "1 change to project_cards could not be saved … it
  // were NOT saved" toast (the recurring failure reported from the pipeline).
  // The Award flow already prevents this by upserting the whole deal before its
  // child writes; this helper applies the SAME parent-before-child ordering to
  // every other project-card write (award date, TAT/turnover, PM/AE assignment,
  // manual progress) so none of them can strand a card against a missing deal.
  // sbSyncOne is an idempotent full-record deal upsert: for a role that can't
  // insert deals it no-ops (that role never created the deal, so whoever did has
  // already synced it), and for the deal's owner it re-materialises the parent
  // if it somehow went missing — exactly the self-heal we want.
  const syncProjectCard=async(dealId,patch)=>{
    if(!isSupabaseReady()||!dealId) return false;
    // Insert-if-missing only: this write exists solely to guarantee the parent
    // deal row is present for the card's FK. `deal` here is this device's local
    // (possibly-stale) copy, so a full upsert would overwrite whatever is on the
    // server — reverting another user's newer stage/value edit. ignoreDuplicates
    // makes it a no-op whenever the row already exists.
    const deal=deals.find(d=>d.id===dealId);
    if(deal) await sbSyncOne("deals",deal,toSbDeal,{ignoreDuplicates:true});
    // Adopt the local card id on the server row. project_card_dept_status/_tasks
    // reference the card by card_id; if the parent row is created here without an
    // id, the server assigns its own UUID and every child write orphans (the
    // "department progress update couldn't reach the server — project card isn't
    // on the server yet" toast). Sending the local UUID makes an INSERT adopt it
    // so children match. On an UPDATE (row already exists for this unique
    // deal_id) the id equals what a prior load set, so this is a no-op — never a
    // PK change. createProjectCard already does exactly this on first creation.
    const cardId=pcards[dealId]?.id;
    const base=(cardId&&isUUID(cardId))?{id:cardId}:{};
    return sbUpsert('project_cards',{...base,deal_id:dealId,...patch},'deal_id').catch(()=>false);
  };

  // ── PERSIST — updates the save indicator; Supabase is the write target ──
  // ── PERSIST — updates save indicator; Supabase is the write target ──
  const persist=useCallback((_key,_val)=>{
    setSync("saving");
    idbSetMany([[_key,_val]]).then(()=>setSync("saved")).catch(()=>setSync("saved"));
  },[]);

  const upUsers    =useCallback(fn=>setUsers(p=>{const n=fn(p);persist(KEYS.users,n);return n;}),[persist]);
  const upCashPos  =useCallback(fn=>setCashPos(p=>{const n=fn(p);persist(KEYS.cashPos,n);return n;}),[persist]);
  const upEvouchers=useCallback(fn=>setEvouchers(p=>{const n=fn(p);persist(KEYS.evouchers,n);if(isSupabaseReady())sbUpsert('app_settings',{key:'evouchers',value:n,updated_at:new Date().toISOString()},'key').catch(()=>{});return n;}),[persist]);
  // Office TV board announcements — stored as one JSON blob in app_settings
  // (key='announcements'), same pattern as evouchers. Manager-write only (RLS
  // migration 054); the Display kiosk account reads them but can't touch them.
  const upAnnouncements=useCallback(fn=>setAnnouncements(p=>{const n=fn(p);persist(KEYS.announcements,n);if(isSupabaseReady())sbUpsert('app_settings',{key:'announcements',value:n,updated_at:new Date().toISOString()},'key').catch(e=>{toastEmit("Announcement sync failed — check connection.","warning");console.error("upAnnouncements:",e);});return n;}),[persist]);
  // EV/LQ numbers used local max+1 with no server-side atomicity — the same
  // cross-device collision risk already fixed for PO/CV/JO/CE.
  const addEV=async(ev)=>{
    const evNo=await claimEvNo(`EV-${new Date().getFullYear()}-000`,evouchers.map(e=>e.evNo));
    const lqNo=await claimDocNumber("LQ",evouchers.map(e=>e.lqNo),6);
    const ne={...ev,id:uid(),evNo,lqNo,status:ev.status||"Draft",createdBy:session?.name||"",createdAt:new Date().toISOString(),items:ev.items||[]};
    upEvouchers(es=>[...es,ne]);
  };
  const updateEV=(id,ch)=>upEvouchers(es=>es.map(e=>e.id===id?{...e,...ch}:e));
  const deleteEV=(id)=>upEvouchers(es=>es.filter(e=>e.id!==id));
  const addEVItem=(evId,item)=>upEvouchers(es=>es.map(e=>e.id===evId?{...e,items:[...(e.items||[]),{...item,id:uid()}]}:e));
  const updateEVItem=(evId,itemId,ch)=>upEvouchers(es=>es.map(e=>e.id===evId?{...e,items:(e.items||[]).map(i=>i.id===itemId?{...i,...ch}:i)}:e));
  // Liquidation line items are the one financial delete in the app that had no
  // confirmation and no trace afterward (evouchers is outside FIN_AUDIT, whose
  // archive/restore is built for whole table rows, not items nested inside a
  // record) — at minimum, gate it and leave a trail in the activity log.
  const deleteEVItem=async (evId,itemId)=>{
    const ev=evouchers.find(e=>e.id===evId);
    const item=ev?.items?.find(i=>i.id===itemId);
    if(item&&!(await uiConfirm(`Delete this liquidation item?\n\n${item.description||"Item"} — ₱${Number(item.amount||0).toLocaleString("en-PH")}\n\nThis cannot be undone.`))) return;
    upEvouchers(es=>es.map(e=>e.id===evId?{...e,items:(e.items||[]).filter(i=>i.id!==itemId)}:e));
    if(item) logActivity(ev?.dealId||null,"EV Item Deleted",`Liquidation item removed from ${ev?.evNo||evId}: ${item.description||"item"} (₱${Number(item.amount||0).toLocaleString("en-PH")})`,session?.name);
  };
  const submitEV=(id)=>upEvouchers(es=>es.map(e=>e.id===id?{...e,status:"For Payment",submittedAt:new Date().toISOString()}:e));
  const markEVPaid=(id,bank,ref)=>upEvouchers(es=>es.map(e=>e.id===id?{...e,status:"Paid",paidBank:bank,paidRef:ref,paidAt:new Date().toISOString(),paidBy:session?.name||"Finance"}:e));
  // Activity log helper — called whenever something meaningful happens
  // opts.silent: the caller already sent a more specific Telegram for this
  // PM Update (blocker, materials, stage change), so skip the generic ops ping.
  const logActivity=(dealId,action,detail,by,opts)=>{
    const entry={id:uid(),dealId,action,detail,by:by||session?.name||"System",date:today,time:new Date().toLocaleTimeString("en-PH",{hour:"2-digit",minute:"2-digit"})};
    setActLog(prev=>{const next=[entry,...prev].slice(0,500);return next;});
    if(isSupabaseReady()) sbInsert('activity_log',toSbActivity(entry)).catch(()=>{});
    if(action==="PM Update"&&!opts?.silent){
      const deal=deals.find(d=>d.id===dealId);
      sendTelegramNotification("ops",`📝 <b>PM Update</b>\n${deal?.client||dealId}\nBy: ${entry.by} · ${today}\n${detail||""}`);
    }
  };
  const upPcards    =useCallback(fn=>setPcards(p=>{const n=fn(p);persist(KEYS.pcards,n);return n;}),[persist]);

  // ── FINANCIAL AUDIT TRAIL (soft-delete) ───────────────────────────────────
  // Money records are never silently lost: before an expense, check voucher,
  // payable, loan, loan payment, cash inflow or billing collection is deleted
  // we snapshot the row (in its Supabase shape) into audit_log with who / when
  // / why, so it appears in Finance ▸ Audit Trail and can be restored.
  const inflowToSb=r=>({id:r.id,deal_id:r.dealId||r.projectId||null,date:r.date||r.month||null,amount:Number(r.amount)||0,source:r.source||"",ref_no:r.refNo||"",note:r.note||""});
  const FIN_AUDIT={
    expenses:       {label:"expense",          toSb:toSbExpense},
    check_vouchers: {label:"check voucher",    toSb:cvToSb},
    payables:       {label:"payable",          toSb:payableToSb},
    loans:          {label:"loan",             toSb:loanToSb},
    loan_payments:  {label:"loan payment",     toSb:r=>({id:r.id,loan_id:r.loanId||r.loan_id||null,amount:Number(r.amount)||0,date:r.date||null})},
    inflows:        {label:"cash inflow",      toSb:inflowToSb},
    billing_payments:{label:"collection",     toSb:r=>toSbPayment(r)},
    billing_milestones:{label:"billing milestone", toSb:toSbBilling},
    // Restore a deleted deal BEFORE its milestones (milestones FK to deals).
    deals:          {label:"deal",             toSb:toSbDeal},
  };
  // Write to audit_log via the raw client (not sbInsert) so a missing-table /
  // audit-only failure doesn't trip the app-wide "you're offline" warning.
  const writeAudit=async(entry)=>{
    if(!supabase) return;
    try{ const {error}=await supabase.from("audit_log").insert(entry); if(error) console.error("audit_log:",error.message); }
    catch(e){ console.error("audit_log:",e.message); }
  };
  const archiveFinancial=async(table,sbSnapshot,recordId,reason)=>{
    const entry={id:uid(),table_name:table,record_id:String(recordId??""),action:"delete",snapshot:sbSnapshot||null,reason:reason||"",performed_by:session?.name||role||"System",performed_at:new Date().toISOString()};
    await writeAudit(entry);
    return entry;
  };
  // Prompt for a reason, archive the record, then return true to proceed with the delete.
  const confirmFinancialDelete=async(table,record)=>{
    const cfg=FIN_AUDIT[table]||{};
    if(!record) return true; // nothing to snapshot — shouldn't happen, don't block
    const reason=(await uiPrompt(`Delete this ${cfg.label||"financial record"}?\n\nIt will be archived in Finance ▸ Audit Trail and can be restored.\nReason (required):`,""));
    if(reason===null) return false;                 // cancelled
    if(!reason.trim()){ toastEmit("A reason is required to delete a financial record.","error",5000); return false; }
    const snap=cfg.toSb?cfg.toSb(record):record;
    await archiveFinancial(table,snap,record.id,reason.trim());
    logActivity(record.dealId||record.projectId||null,"Financial Record Deleted",`${cfg.label||table} deleted — ${reason.trim()}`);
    return true;
  };
  // Restore a previously-deleted record from its audit snapshot.
  const restoreFinancial=async(audit)=>{
    if(!audit?.snapshot||!audit?.table_name){ toastEmit("Nothing to restore.","error"); return false; }
    if(!isSupabaseReady()){ toastEmit("Restore needs a server connection.","error"); return false; }
    try{
      await sbUpsert(audit.table_name,audit.snapshot,"id");
      await writeAudit({id:uid(),table_name:audit.table_name,record_id:audit.record_id,action:"restore",snapshot:audit.snapshot,reason:"Restored from audit trail",performed_by:session?.name||role||"System",performed_at:new Date().toISOString()});
      logActivity(null,"Financial Record Restored",`${(FIN_AUDIT[audit.table_name]||{}).label||audit.table_name} restored`);
      await loadAllFromSupabase();
      toastEmit("✅ Record restored. (Loan payments & collections may need a refresh to re-link.)","success",6000);
      return true;
    }catch(e){ console.error("restore:",e); toastEmit("Restore failed — see console.","error",6000); return false; }
  };

  // One-time migration: push all IDB-cached data to Supabase on new devices
  const migrateToCloud=useCallback(async()=>{
    if(!isSupabaseReady()){toastEmit("Supabase is not connected — check environment variables","error",5000);return;}
    toastEmit("Pushing all data to cloud…","info",2500);
    // Skip tables the current role can't INSERT (see roleCanInsert): re-pushing
    // them only produces false "NOT saved — please redo" toasts for rows RLS
    // rejects, which already exist on the server.
    const syncAll=(table,arr,mapper)=>(arr?.length&&roleCanInsert(table))?Promise.all(arr.map(r=>{const p=mapper?mapper(r):r;return hasValidUUIDs(p)?sbUpsert(table,p,'id'):Promise.resolve();})).catch(e=>console.error("migrate "+table+":",e.message)):Promise.resolve();
    await syncAll("deals",deals,toSbDeal);
    await syncAll("job_orders",jos,toSbJO);
    await syncAll("expenses",exps,toSbExpense);
    await syncAll("purchase_requests",prs,toSbPR);
    await syncAll("subcon_work_orders",swos,swoToSb);
    await syncAll("material_requests",mreqs,toSbMR);
    await syncAll("budget_requests",breqs,toSbBR);
    await syncAll("addenda",addenda,toSbAddendum);
    await syncAll("swatches",swatches,toSbSwatch);
    await syncAll("checklists",checklist,toSbChecklist);
    await syncAll("activity_log",actLog,toSbActivity);
    if(billings?.length){
      await Promise.all(billings.map(m=>{if(!isUUID(m.id))return Promise.resolve();sbSyncOne("billing_milestones",m,toSbBilling);return Promise.all((m.payments||[]).map(p=>isUUID(p.id)?sbSyncOne("billing_payments",{...p,milestoneId:m.id},toSbPayment):Promise.resolve()));})).catch(()=>{});
    }
    // A role that may create but not edit budgets (Sales/SalesOpsAdmin) can only
    // fill in budgets missing on the server — an upsert is refused for it outright.
    if(budgets&&roleCanInsert("project_budgets")){const canEdit=roleCan(role,"update","project_budgets");Object.entries(budgets).forEach(([dealId,b])=>{if(!isUUID(dealId)) return;(canEdit?sbUpsert("project_budgets",toSbBudget(dealId,b),"deal_id"):sbInsertIfMissing("project_budgets",toSbBudget(dealId,b))).catch(()=>{});});}
    setTimeout(()=>toastEmit("Done! All data pushed to Supabase. Refresh Safari to see it.","success",6000),1200);
  },[hasValidUUIDs,deals,jos,exps,prs,mreqs,breqs,addenda,swatches,checklist,actLog,billings,budgets,cashPositions,infs]);
  const upInventory =useCallback(fn=>setInventory(p=>{const n=fn(p);persist(KEYS.inventory,n);return n;}),[persist]);
  const upStocklog  =useCallback(fn=>setStocklog(p=>{const n=fn(p);persist(KEYS.stocklog,n);return n;}),[persist]);
  const upTools     =useCallback(fn=>setTools(p=>{const n=fn(p);persist(KEYS.tools,n);return n;}),[persist]);
  const upDrs       =useCallback(fn=>setDrs(p=>{const n=fn(p);persist(KEYS.drs,n);return n;}),[persist]);
  const upSuppliers =useCallback(fn=>setSuppliers(p=>{const n=fn(p);persist(KEYS.suppliers,n);return n;}),[persist]);
  const upSubcons   =useCallback(fn=>setSubcons(p=>{const n=fn(p);persist(KEYS.subcons,n);return n;}),[persist]);
  const upSwos      =useCallback(fn=>setSwos(p=>{const n=fn(p);persist(KEYS.swos,n);return n;}),[persist]);

  const addInventoryItem=(item)=>upInventory(iv=>{
    const rec={...item,id:item.id||uid(),code:item.code||nextItemCode(iv),createdAt:today,createdBy:session?.name||role};
    if(isSupabaseReady()) sbUpsert('inventory_items',invToSb(rec),'id').catch(e=>console.warn("inv insert:",e.message));
    return[...iv,rec];
  });
  const updateInventoryItem=(id,ch)=>{
    upInventory(iv=>iv.map(i=>i.id===id?{...i,...ch,lastUpdated:today}:i));
    if(isSupabaseReady()) sbUpdate('inventory_items',id,invToSb({...ch,lastUpdated:today})).catch(()=>{});
  };
  const deleteInventoryItem=(id)=>{
    upInventory(iv=>iv.filter(i=>i.id!==id));
    if(isSupabaseReady()) sbDelete('inventory_items',id).catch(()=>{});
  };
  // Wipe ALL inventory items and stock movements — local + Supabase. Used to start fresh.
  const clearAllInventory=async()=>{
    upInventory(()=>[]);
    upStocklog(()=>[]);
    if(isSupabaseReady()){
      try{ await sbClear('stock_movements'); await sbClear('inventory_items'); }
      catch(e){ toastEmit&&toastEmit("Cleared locally but server wipe failed: "+(e?.message||e),"error"); return false; }
    }
    return true;
  };

  // Merge duplicate inventory items into one survivor: reassign every stock
  // movement from the duplicates to the survivor, fold their on-hand qty and
  // value into the survivor (weighted avg cost), then delete the duplicates.
  // Local + Supabase. Returns the number of duplicates merged.
  const mergeInventoryItems=(survivorId,dupeIds=[])=>{
    const ids=dupeIds.filter(d=>d&&d!==survivorId);
    if(!survivorId||!ids.length) return 0;
    const idSet=new Set(ids);
    // 1) reassign movements
    upStocklog(sl=>sl.map(m=>{
      if(!idSet.has(m.itemId)) return m;
      if(isSupabaseReady()&&isUUID(m.id)) sbUpdate('stock_movements',m.id,{item_id:survivorId}).catch(()=>{});
      return {...m,itemId:survivorId};
    }));
    // 2) fold qty + value into survivor, 3) drop duplicates
    upInventory(iv=>{
      const survivor=iv.find(i=>i.id===survivorId); if(!survivor) return iv;
      const dupes=iv.filter(i=>idSet.has(i.id));
      let totQty=Number(survivor.qtyOnHand)||0, totVal=(Number(survivor.qtyOnHand)||0)*(Number(survivor.avgCost)||0);
      dupes.forEach(d=>{const q=Number(d.qtyOnHand)||0;totQty+=q;totVal+=q*(Number(d.avgCost)||Number(d.lastPurchasePrice)||0);});
      const merged={...survivor,qtyOnHand:Math.round(totQty*100)/100,avgCost:totQty>0?Math.round((totVal/totQty)*100)/100:survivor.avgCost,lastUpdated:today};
      if(isSupabaseReady()){
        sbUpdate('inventory_items',survivorId,invToSb(merged)).catch(()=>{});
        ids.forEach(id=>sbDelete('inventory_items',id).catch(()=>{}));
      }
      return iv.filter(i=>!idSet.has(i.id)).map(i=>i.id===survivorId?merged:i);
    });
    return ids.length;
  };

  // Tools / equipment register CRUD (local + Supabase)
  const saveTool=(rec)=>{
    const r={...rec,id:rec.id||uid()};
    upTools(ts=>ts.some(t=>t.id===r.id)?ts.map(t=>t.id===r.id?r:t):[r,...ts]);
    if(isSupabaseReady()) sbUpsert('tools',toolToSb(r),'id').catch(()=>{});
    return r;
  };
  const deleteTool=(id)=>{
    upTools(ts=>ts.filter(t=>t.id!==id));
    if(isSupabaseReady()) sbDelete('tools',id).catch(()=>{});
  };
  // Standalone delivery-receipt CRUD (local + Supabase)
  const saveDr=(rec)=>{
    const r={...rec,id:rec.id||uid(),createdBy:rec.createdBy||session?.name||role,createdAt:rec.createdAt||today};
    upDrs(ds=>ds.some(d=>d.id===r.id)?ds.map(d=>d.id===r.id?r:d):[r,...ds]);
    if(isSupabaseReady()) sbUpsert('delivery_receipts',drToSb(r),'id').catch(()=>{});
    return r;
  };
  const deleteDr=(id)=>{
    upDrs(ds=>ds.filter(d=>d.id!==id));
    if(isSupabaseReady()) sbDelete('delivery_receipts',id).catch(()=>{});
  };

  // Supplier CRUD
  const addSupplier=(item)=>upSuppliers(ss=>{
    const rec={...item,id:uid(),createdAt:today,createdBy:session?.name||role};
    if(isSupabaseReady()) sbInsert('suppliers',supToSb(rec)).catch(()=>{});
    return[...ss,rec];
  });
  // Typing a not-yet-known supplier/payee name while logging an expense adds it
  // to the Supplier Master so it shows up as a pick next time (mirrors how a
  // typed-in team member name gets remembered for the Project Team roster).
  const rememberSupplierNames=(names)=>{
    const known=new Set(suppliers.map(s=>(s.companyName||"").trim().toLowerCase()).filter(Boolean));
    const fresh=[...new Set(names.map(n=>(n||"").trim()).filter(n=>n&&!known.has(n.toLowerCase())))];
    fresh.forEach(name=>addSupplier({companyName:name,status:"Active"}));
  };
  const updateSupplier=(id,ch)=>{
    upSuppliers(ss=>ss.map(s=>s.id===id?{...s,...ch}:s));
    if(isSupabaseReady()) sbUpdate('suppliers',id,supToSb(ch)).catch(()=>{});
  };
  const deleteSupplier=(id)=>{
    upSuppliers(ss=>ss.filter(s=>s.id!==id));
    if(isSupabaseReady()) sbDelete('suppliers',id).catch(()=>{});
  };
  // Subcontractor CRUD
  const addSubcon=(item)=>upSubcons(ss=>{
    const rec={...item,id:uid(),createdAt:today,createdBy:session?.name||role};
    if(isSupabaseReady()) sbInsert('subcontractors',subconToSb(rec)).catch(()=>{});
    return[...ss,rec];
  });
  const updateSubcon=(id,ch)=>{
    upSubcons(ss=>ss.map(s=>s.id===id?{...s,...ch}:s));
    if(isSupabaseReady()) sbUpdate('subcontractors',id,subconToSb(ch)).catch(()=>{});
  };
  const deleteSubcon=(id)=>{
    upSubcons(ss=>ss.filter(s=>s.id!==id));
    if(isSupabaseReady()) sbDelete('subcontractors',id).catch(()=>{});
  };

  const addSWO=(wo)=>{
    const rec={...wo,id:uid(),createdDate:today};
    upSwos(ws=>[rec,...ws]);
    if(isSupabaseReady()) sbSyncOne("subcon_work_orders",rec,swoToSb);
    syncWoPayable(rec); // WO issued → subcontractor payable in the AP ledger
    const msg=`🛠 <b>${rec.status==="Pending Approval"?"Work Order Awaiting Approval":"Subcon Work Order Issued"} ${rec.woNumber||""}</b>\n${rec.subcontractor||"?"}${rec.specialty?` · ${rec.specialty}`:""}\nProject: ${rec.projectName||"?"}\nAmount: ₱${(Number(rec.contractAmount)||0).toLocaleString("en-PH")}\nBy: ${rec.requestedBy||session?.name||"?"}`;
    sendTelegramNotification("procurement",msg);
    sendTelegramNotification("management",msg);
  };
  // Bulk-create Work Orders from a batch upload. Records arrive fully shaped by
  // the view (status/requestedBy/approvedBy already decided by role), so here we
  // only allocate collision-free WO numbers, persist in ONE state update, mirror
  // each to Supabase + the AP ledger, and fire a single summary notification.
  const addSWOBatch=(list)=>{
    const items=(list||[]).filter(Boolean);
    if(!items.length) return 0;
    const taken=new Set(swos.map(w=>w.woNumber).filter(Boolean));
    let nn=Number(WO_NO_RE.exec(computeNextWoNo(swos))[1]);
    const recs=items.map(wo=>{
      let woNo=(wo.woNumber||"").trim();
      if(!woNo||taken.has(woNo)){
        while(taken.has(`WO-${String(nn).padStart(4,"0")}`)) nn++;
        woNo=`WO-${String(nn).padStart(4,"0")}`; nn++;
      }
      taken.add(woNo);
      return {...wo,woNumber:woNo,id:uid(),createdDate:today};
    });
    upSwos(ws=>[...recs,...ws]);
    if(isSupabaseReady()) recs.forEach(rec=>sbSyncOne("subcon_work_orders",rec,swoToSb));
    recs.forEach(rec=>syncWoPayable(rec));
    const total=recs.reduce((s,r)=>s+(Number(r.contractAmount)||0),0);
    const anyPending=recs.some(r=>r.status==="Pending Approval");
    const msg=`🛠 <b>${recs.length} Subcon Work Order${recs.length>1?"s":""} uploaded${anyPending?" — some awaiting approval":""}</b>\nRange: ${recs[recs.length-1].woNumber} → ${recs[0].woNumber}\nTotal: ₱${total.toLocaleString("en-PH")}\nBy: ${session?.name||"?"}`;
    sendTelegramNotification("procurement",msg);
    sendTelegramNotification("management",msg);
    return recs.length;
  };
  const updateSWO=(id,changes)=>{
    let updated=null;
    upSwos(ws=>ws.map(w=>{
      if(w.id!==id) return w;
      const nw={...w,...changes};
      updated=nw;
      if(isSupabaseReady()) sbSyncOne("subcon_work_orders",nw,swoToSb);
      return nw;
    }));
    if(updated) syncWoPayable(updated); // keep the WO's AP payable in sync (created once it's Issued)
  };
  const deleteSWO=(id)=>{
    const wo=swos.find(w=>w.id===id);
    if(wo&&role!=="Manager"&&!isProcurementRole(role)&&wo.requestedBy!==session?.name) return toastEmit&&toastEmit("Only Managers, Procurement, or the creator can delete work orders.","error");
    upSwos(ws=>ws.filter(w=>w.id!==id));if(isSupabaseReady()) sbDelete('subcon_work_orders',id).catch(()=>{});
  };

  // addCEReq/updateCEReq used to await the server round-trip before touching
  // local state, while the CEQSView caller showed a hardcoded "Saved" toast
  // regardless of the outcome — on any transient failure (flaky connection,
  // stale session) the CE Request a Sales rep just submitted vanished with no
  // trace: never shown locally, never queued for retry, no error surfaced.
  // Rewritten to the optimistic local-update + background-sync pattern used
  // everywhere else in the app (see addSWO/addDRF) so the record always shows
  // up immediately and failed writes are queued/retried instead of dropped.
  const addCEReq=(rec)=>{
    const nr={...rec,id:rec.id||uid(),created_at:rec.created_at||new Date().toISOString()};
    setCeReqs(p=>[...p,ceReqFromSb(nr)]);
    // Plain insert, not upsert: Sales may CREATE a CE request but not edit one
    // (migration 20261006020000), and an upsert needs edit rights too.
    return isSupabaseReady()?sbInsertIfMissing('ce_requests',nr).catch(()=>false):Promise.resolve(true);
  };
  const updateCEReq=(id,updates)=>{
    setCeReqs(p=>p.map(r=>{if(r.id!==id)return r;return{...r,...(updates.status!==undefined?{status:updates.status}:{}),clientName:updates.client_name??r.clientName,projectName:updates.project_name??r.projectName,location:updates.location??r.location,projectType:updates.project_type??r.projectType,priority:updates.priority??r.priority,submittedBy:updates.submitted_by??r.submittedBy,targetDeadline:updates.target_deadline??r.targetDeadline,submissionDeadline:updates.submission_deadline??r.submissionDeadline,targetBudget:updates.target_budget??r.targetBudget,targetMargin:updates.target_margin??r.targetMargin,plansLink:updates.plans_link??r.plansLink,skpLink:updates.skp_link??r.skpLink,scheduleOfFinish:updates.schedule_of_finish??r.scheduleOfFinish,notes:updates.notes??r.notes,ceNotes:updates.ce_notes??r.ceNotes,bidAmount:updates.bid_amount??r.bidAmount,bidMarginPct:updates.bid_margin_pct??r.bidMarginPct,awarded:updates.awarded??r.awarded,awardDate:updates.award_date??r.awardDate};}));
    return isSupabaseReady()?sbUpdate('ce_requests',id,updates).catch(()=>{}):Promise.resolve();
  };
  const deleteCEReq=async(id)=>{
    setCeReqs(p=>p.filter(r=>r.id!==id));
    if(isSupabaseReady()) sbDelete('ce_requests',id).catch(()=>{});
  };

  // One-time seed from spreadsheet data
  const SEED_SUPPLIERS = [
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Durawood Construction and Lumber Supply Inc.",email:"durawoodcons@yahoo.com.ph",materials:"Assorted Construction Supply",contactNos:"645-39-77 / 09228104751",contactPerson:"Mr. Wilson",paymentTerms:"60 Days",address:"#177 Sumulong High-way cor. B Soliven Ave. Mayamot, Antipolo City",tinNo:"000-096-499-000",notes:""},
    {rating:"4 - GOOD",companyName:"Miles Merchandising",email:"",materials:"Assorted Construction Supply",contactNos:"941-38-36",contactPerson:"",paymentTerms:"Cash Basis",address:"41 Bayan-Bayanan Avenue, Concepcion, Marikina, 1807 Metro Manila",tinNo:"209-086-074-000",notes:""},
    {rating:"4 - GOOD",companyName:"MLC Hardware",email:"mlchardware@yahoo.com",materials:"Assorted Construction Supply",contactNos:"941-06-92 / 941-4055",contactPerson:"Ms. Ayen/Mr. Johnson",paymentTerms:"30-45 Days",address:"No. 36 D, Bayanbayanan Avenue, Concepcion, Marikina, 1807 Metro Manila",tinNo:"235-528-886-000",notes:""},
    {rating:"2 - MODERATE",companyName:"Peng-Yong Hardware & Construction Supply",email:"",materials:"Assorted Construction Supply",contactNos:"682-1201 / 0906-565-8607",contactPerson:"Ms. Marjorie/ Ms. Maria Lorraine",paymentTerms:"30 Days",address:"Sumulong Antipolo City",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Trima Industrial Sales",email:"",materials:"Paint and Screws",contactNos:"475-2125 / 475-2224",contactPerson:"",paymentTerms:"Cash Basis",address:"No. 21 Bayan Bayanan Ave., Concepcion, Marikina City",tinNo:"190-582-296-000",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"Auto-Ad Trading",email:"auto.ad_trading@yahoo.com",materials:"Acrylic",contactNos:"261-24-70/71",contactPerson:"Ms. Tina/Allen",paymentTerms:"90 Days",address:"Casa Corazon Bldg. Earnshaw St. Sampaloc Barangay 457",tinNo:"912-382-767-000",notes:""},
    {rating:"4 - GOOD",companyName:"Signmate",email:"signmatemarketing01@gmail.com",materials:"MDF and Acrylic",contactNos:"439-3346",contactPerson:"Ms. Dianne / Paul Samonte",paymentTerms:"30 Days",address:"916 Aurora Blvd. Quezon City",tinNo:"",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"CWC Prime Industries Corporation",email:"sales_corian@primegroup.ph",materials:"Quartz Countertop",contactNos:"8010-986 / 843-9760 / 844-4320 / 0917-688-8646",contactPerson:"Mr. Miguel",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"Euro Asia (Veneer Laminate)",email:"angcedric@aim.com",materials:"Stone/Quartz Countertop",contactNos:"705-1408 Loc. 103/09228002470",contactPerson:"Mr. Cedric Ang",paymentTerms:"30 Days",address:"206-B M. Paterno St. San Juan City, Metro Manila",tinNo:"004-541-794-000",notes:""},
    {rating:"4 - GOOD",companyName:"FOURTH DIMENSION",email:"lina_iligan@ymail.com",materials:"Vasari",contactNos:"570-3380 / 0977-802-8614",contactPerson:"Ms. Lina",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"World Class Laminate Inc.",email:"info@worldclasslaminate.com",materials:"Laminated Board/Quartz Countertop",contactNos:"374-8738 / 245-3767",contactPerson:"Ms. Alyana / Cherma / Ms. Ven",paymentTerms:"Cash Basis",address:"88 Jenny's Avenue, Maybunga Pasig City",tinNo:"230-792-490-001",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Al Metal Master Inc.",email:"",materials:"Assorted Metal",contactNos:"941-3336",contactPerson:"M. Jaja",paymentTerms:"Cash Basis",address:"532 J.P Rizal St. Marikina City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"Metalbase",email:"",materials:"Assorted Metal",contactNos:"",contactPerson:"",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:"Payment Method: No Bank/Terms (Cash Only)"},
    {rating:"2 - MODERATE",companyName:"Takezo Industrial Supply",email:"takezo.industrialsupply@yahoo.com",materials:"Polycarbonate and Accessories",contactNos:"0925-897-6706 / 748-4311 / 370-9091 / 796-0980 / 642-0659",contactPerson:"Mr. Joey",paymentTerms:"Cash Basis",address:"1416 B. Velasquez St. Tondo Manila",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"JTCI Carpet Gallery Corporation",email:"jovetcarpets_05@yahoo.com",materials:"Carpet",contactNos:"401-85-37/401-86-77/ 0920-282-4187 / 655-1643",contactPerson:"Ms. Rosana Babes",paymentTerms:"7 Days",address:"Unit 304 - 3rd Floor Jeb Arcade Realty & Builders #101 Amang Rodriguez Ave. Rosario, Pasig City",tinNo:"008-605-986-000",notes:""},
    {rating:"2 - MODERATE",companyName:"Fortress Glass Supply",email:"gcrystalglass@yahoo.com / fortressquency@gmail.com",materials:"Mirror/Tempered/Ordinary Glass",contactNos:"647-8888 / 470-0704",contactPerson:"Ms. Anna / Mae",paymentTerms:"Cash Basis",address:"71, Gertrudes Street, Antipolo, 1870 Rizal",tinNo:"151-555-637-003",notes:""},
    {rating:"4 - GOOD",companyName:"MRDH Glass & Aluminum Enterprises",email:"",materials:"Mirror/Tempered/Ordinary Glass",contactNos:"948-9087",contactPerson:"Ms. Riza",paymentTerms:"Cash Basis",address:"128-A B. G. Molina Street, Marikina, Metro Manila",tinNo:"174-990-316-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Authentic Wood Products International Inc.",email:"authentic_wood@yahoo.com",materials:"Cut Out Materials/Laser Cutting",contactNos:"942-3735 / 940-4519",contactPerson:"Ms. Anabelle Calalo / Mr. Mark",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:"Wood Cutting & Engraving"},
    {rating:"4 - GOOD",companyName:"FULL CREATIVE INNOVATION (FCI)",email:"sales.fcienterprises@gmail.com",materials:"Print/Signages",contactNos:"0915-410-5134 / 754-9259",contactPerson:"Sir Fritz",paymentTerms:"Cash Basis",address:"#179 Market Ave. Pasig City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"KENT FLOORS",email:"",materials:"Vinyl Tiles",contactNos:"0917-861-2316",contactPerson:"Ms. Jhoza",paymentTerms:"Cash Basis",address:"Evangelista Cor. Marcos Highway (Near SM Marikina, Green Gate)",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"Hilongos Industrial Supply",email:"",materials:"Assorted Tools",contactNos:"682-1255",contactPerson:"Mr. Jm",paymentTerms:"30 Days",address:"#2 Saenz Arcade, Sumulong Hi-way Mayamot, Antipolo City",tinNo:"",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"DMI Metal Industries",email:"dmimetalindustries@gmail.com",materials:"Accordion Door Installation/Metal",contactNos:"570-3114 / 710-3570",contactPerson:"Ms. Arra",paymentTerms:"Cash Basis",address:"#11 Cattleya St. Vista Hermosa Village San Mateo Rizal",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Mega Packaging Corporation",email:"",materials:"Stretch Film/Bubble Wrap/Office Supply",contactNos:"0923-953-8218",contactPerson:"Ms. Jane",paymentTerms:"Cash Basis",address:"Canlubang Calamba Laguna",tinNo:"003-057-431-000",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"Hafele Philippines, Inc.",email:"",materials:"Accessories",contactNos:"842-3353",contactPerson:"",paymentTerms:"Cash Basis",address:"Levi Mariano Ave., Brgy. Ususan Taguig city",tinNo:"001-707-726-000",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"Joaquin Shoe Supply",email:"",materials:"Rugby",contactNos:"646-1881",contactPerson:"",paymentTerms:"Cash Basis",address:"450 E. DELA PAZ STREET, MARIKINA METRO MANILA",tinNo:"100-145-045-000",notes:""},
    {rating:"4 - GOOD",companyName:"Olympus Marketing Inc.",email:"mjebelia@olympus.com.ph",materials:"Lighting Fixtures",contactNos:"941-7978 / 0922-5310-757",contactPerson:"Ms. Mary Jane Belia",paymentTerms:"Cash Basis",address:"#17 A 1st Avenue., Sta. Maria Industrial Subd. Bagumbayan, Taguig City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"Pingping Shoe Supply Corporation",email:"",materials:"Rugby/Triple 8/Leather",contactNos:"997-5199",contactPerson:"Ms. Yolie/Ms. Pat",paymentTerms:"Cash Basis",address:"83 E. Manalo Sto. Niño Marikina City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"Shell Canvas",email:"",materials:"Fabric",contactNos:"921-8546 / 922-7797 / 922-8708",contactPerson:"Mr. Bobby / Ms. Lilibeth / Ms. Jenny",paymentTerms:"Cash Basis",address:"816 EDSA Cor. Kamias Road, Quezon City",tinNo:"",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"LEGOBUILDERS INC.",email:"www.legobuildersinc.com",materials:"Bricks",contactNos:"09278587110 /09062987574",contactPerson:"Mr. JC Delosreyes / Ms. Irene",paymentTerms:"Cash Basis",address:"U/1-2, Casa Royale Building, 558 Cabildo St. Intramuros, Manila.",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"FORMICA LAMINATES",email:"",materials:"Laminates",contactNos:"+639652371702",contactPerson:"Mr. Jeorge",paymentTerms:"Cash Basis",address:"8009, 1709 West Service Rd., Merville, Parañaque City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"GRAND JADE HARDWARE",email:"",materials:"Assorted Construction Supply",contactNos:"+639230856115",contactPerson:"Ms. Rhea",paymentTerms:"15 Days",address:"JP Rizal St. Malanday, Marikina City",tinNo:"009-324-876-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"LEXTON MARKETING CORPORATION",email:"",materials:"Plumbing Fixtures, Accessories, and Laminates",contactNos:"63 2 5318-5215",contactPerson:"Ms. Je-Anne/Ria",paymentTerms:"30 Days",address:"280 9th St. Cor. 8th Avenue, Grace Park, Caloocan City",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Modern Art / Artmart Signage Materials Trading",email:"",materials:"Acrylic/Sticker/MDF",contactNos:"+639175081777",contactPerson:"Ms. Addie",paymentTerms:"Cash Basis",address:"12 Broadway Avenue Brgy. Mariana New Manila, QC",tinNo:"235-579-712-0001",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Contractors Home",email:"chte_corp@yahoo.com",materials:"Assorted Tools",contactNos:"+639396065367",contactPerson:"Mr. Jai-Jai",paymentTerms:"7 Days",address:"116 Lilac St. Concepcion Dos Marikina City",tinNo:"010-551-650-000",notes:""},
    {rating:"4 - GOOD",companyName:"RGB/VR CONCEPT",email:"rrlk@ymail.com",materials:"Print/Signages",contactNos:"+639568395213",contactPerson:"Ms. Alyssandra",paymentTerms:"30 Days",address:"90 West Riverside St. Brgy. San Antonio, Quezon City",tinNo:"010-119-786-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"CPRO Home Hardware",email:"",materials:"Drawer Guide/Accessories",contactNos:"8981-1598",contactPerson:"Mr. Gerald Shi",paymentTerms:"Cash Basis",address:"321-A Fernando Poe Jr Ave, San Antonio, QC",tinNo:"454-659-870-000",notes:""},
    {rating:"4 - GOOD",companyName:"Seato Trading Company Inc.",email:"",materials:"MDF/Plywood/Plyboard",contactNos:"+639566088309",contactPerson:"Ms. Jasmin Sultan",paymentTerms:"Cash Basis",address:"110 20th Ave., Cor. P. Tuazon, Cubao, QC",tinNo:"000-389-723-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"Vertiflute",email:"info@vertiflute.com",materials:"Fluted/Tile Trim/Accessories",contactNos:"+639457821888",contactPerson:"Ms. Meg/Sir. Kyle",paymentTerms:"Terms",address:"G/F Midway Court Bldg. EDSA, Wack-wack, Mandaluyong",tinNo:"010-063-229",notes:""},
    {rating:"4 - GOOD",companyName:"PHILUX",email:"south@philux.ph",materials:"Furnitures",contactNos:"+639773259506",contactPerson:"",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"Kuysen",email:"",materials:"Furnitures",contactNos:"",contactPerson:"Mr. Angelo Irabon",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"8GADS PRINTING SUPPLY",email:"",materials:"Lighting Fixtures/Power Supply",contactNos:"+639661424177",contactPerson:"Mr. Vladimir",paymentTerms:"Terms",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"PANDA CONSTRUCTION SUPPLY",email:"",materials:"Assorted Construction Supply",contactNos:"",contactPerson:"Ms. Mary Ann",paymentTerms:"Terms",address:"",tinNo:"000-326-384-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"STAR LIGHTING",email:"",materials:"Lighting Fixtures",contactNos:"+639288750509",contactPerson:"Ms. Kristina Casela",paymentTerms:"Cash Basis",address:"1322 CM RECTO AVENUE TONDO MANILA",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"NEW SQ LUMBER AND HARDWARE CORP",email:"",materials:"Plywood/Plyboard",contactNos:"",contactPerson:"Ms. Linda, Ms. Geraldine",paymentTerms:"Terms",address:"210 LOPEZ JAENA ST. COR. BARASOAIN LITTLE BAGUIO SAN JUAN",tinNo:"007-069-204-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"MAKATI FINEST LUMBER & HARDWARE",email:"",materials:"Plywood/Plyboard",contactNos:"",contactPerson:"Ms. Shaina Lim/Mr. Jaime Lim",paymentTerms:"Terms",address:"431 J. P. Rizal St, Makati City, Metro Manila",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"TEXTURIA ARCHITECTURAL FINISHES",email:"",materials:"Sticker",contactNos:"+639178153392",contactPerson:"Mr. Julian Ong, Mr. Billy Bautista",paymentTerms:"Cash Basis",address:"No. 8 A. De Leon St., Concepcion Uno, Marikina City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"ALUMINUM POWER MARKETING CORPORATION",email:"",materials:"Assorted Metal/ACP/Accessories",contactNos:"",contactPerson:"Ms. Arlyn",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"DIZON MEDIA ADVERTISING",email:"",materials:"Wires/Cyno Glue",contactNos:"+639061041657",contactPerson:"Ms. Ann Barcia",paymentTerms:"Terms",address:"Trading OPC East Los Angeles, Novaliches, Quezon City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"BMMC MULTI SALES CORPORATION",email:"",materials:"Electrical Materials",contactNos:"",contactPerson:"",paymentTerms:"Cash Basis",address:"F. Torres St, Binondo, Manila, 1008 Metro Manila",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"GERMIKE PACKAGING SUPPLIES",email:"",materials:"Stretch Film/Bubble Wrap/Office Supply",contactNos:"",contactPerson:"",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"SPECTRUM BY LARRY'S",email:"",materials:"Fabric",contactNos:"",contactPerson:"",paymentTerms:"Cash Basis",address:"5608 South Super Highway Palanan, Makati City",tinNo:"008-792-225-000",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"QUEENSWAY REBO BAMBOO OPC",email:"",materials:"Fluted/Laminate",contactNos:"+639177082159",contactPerson:"Ms. Jaja",paymentTerms:"Cash Basis",address:"Unit 49 CW Home Depot, Dona Julia Vargas Pasig City",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"PHILBOARDS",email:"",materials:"Laminated Board",contactNos:"",contactPerson:"Ms. Mj",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"HIGH-TOP MERCHANDISING INC",email:"",materials:"Stone/Metal Laser Cutting",contactNos:"+639190792827",contactPerson:"Ms. Jen",paymentTerms:"Cash Basis",address:"227 Biak na bato, Brgy. Manresa, Quezon City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"PRIMARK",email:"",materials:"Stone/Wood/Metal Laser Cutting",contactNos:"+639177053894",contactPerson:"Ms. Leady",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"BW GLASS VENTURES",email:"",materials:"Glass Supply/Installation",contactNos:"",contactPerson:"Ms. Lyra/ Mr. Jaime",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"AGC LED",email:"",materials:"Electrical Materials",contactNos:"+639068770391",contactPerson:"Mr. Sergio Labauanan",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"AMPERE LIGHTS TRADING",email:"",materials:"Lighting Fixtures",contactNos:"+639913349137",contactPerson:"Ms. Ghene",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"COB/ YANNY",email:"",materials:"Electrical Materials",contactNos:"+639563520972",contactPerson:"Ms. Yanny",paymentTerms:"Cash Basis",address:"",tinNo:""},
    {rating:"4 - GOOD",companyName:"PACIFIC GLASS CORPORATION",email:"",materials:"Glass Supply/Installation",contactNos:"9544168035/ 9175660785",contactPerson:"Ms. NJ Calmerin/ Mr. Herminigildo",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"5 - EXCELLENT AND RELIABLE",companyName:"JUAN LUKAS ELECTRICAL SUPPLY",email:"",materials:"Panel Board/Electrical",contactNos:"+639176530430",contactPerson:"Mr. Michael",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"AC BOX ALL IN ONE CORP",email:"",materials:"Panel Board/Electrical",contactNos:"+6319029147",contactPerson:"Ms. Diana",paymentTerms:"Cash Basis",address:"38 2nd Street Brgy. Sto Nino, Marikina City",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"DELTATEK ELECTRICAL SUPPLIES TRADING",email:"",materials:"Panel Board/Electrical",contactNos:"+639985493623",contactPerson:"Ms. Aira",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"EUROBEL MARKETING",email:"www.eurobel.com.ph",materials:"Carpet",contactNos:"+639171528131",contactPerson:"Ms. Gillian",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"AIRJELLE ENTERPRISES CO INC",email:"airjelle.enterprises2024@gmail.com",materials:"Office Supplies",contactNos:"+639300801526",contactPerson:"Mr. Francis",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"3 - ACCEPTABLE",companyName:"STYO BOLT",email:"",materials:"Styro",contactNos:"+639353307270",contactPerson:"Mr. Macalanda",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"MKM MERCHANDISE",email:"",materials:"Electrical Materials",contactNos:"+639167312997",contactPerson:"Mr. Fernando",paymentTerms:"Cash Basis",address:"",tinNo:"331-383-897-000",notes:""},
    {rating:"4 - GOOD",companyName:"ACE HARDWARE SM MASINAG",email:"",materials:"Tools",contactNos:"+639992210941",contactPerson:"Ms. Ronaliza Tarala",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
    {rating:"4 - GOOD",companyName:"LND SIGN CORP",email:"",materials:"Print/Signages",contactNos:"+639564996605",contactPerson:"Ms. Cha",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:""},
  ];

  const SEED_SUBCONS = [
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material request details  S: Scope of Work",contactNo:"0915-017-0014",companyName:"Benedick Jamito",paymentTerms:"60 Days",address:"#177 Sumulong Hi-way cor. B Soliven Ave. Mayamot, Antipolo City",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material request details/Scope of Work",contactNo:"0915-827-5419",companyName:"Benedicto Pantriore",paymentTerms:"Cash Basis",address:"41 Bayan-Bayanan Avenue, Concepcion, Marikina, 1807 Metro Manila",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"Stone Works (Supply & Install)",strengthsWeaknesses:"W: Communication  S: Product and Samples",contactNo:"0999-158-5829",companyName:"John Piang Ometer",paymentTerms:"30-45 Days",address:"No. 36 D, Bayanbayanan Avenue, Concepcion, Marikina, 1807 Metro Manila",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material request details  S: Contract Amount",contactNo:"0995-147-0400",companyName:"Rising/Jovic Susim",paymentTerms:"30 Days",address:"Sumulong Antipolo City",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material request details  S: Communication",contactNo:"0917-871-3284",companyName:"Racem/Jhun Alzona",paymentTerms:"Cash Basis",address:"No. 21 Bayan Bayanan Ave., Concepcion, Marikina City",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material Request Details  S: Progress Report",contactNo:"0915-361-3286",companyName:"Imelda Orale",paymentTerms:"90 Days",address:"Casa Corazon Bldg. Earnshaw St. Sampaloc Barangay 457",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Hard to communicate/Request Details",contactNo:"0947-755-3557",companyName:"Jerome Mendoza",paymentTerms:"30 Days",address:"916 Aurora Blvd. Quezon City",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"Electrical (Install only)",strengthsWeaknesses:"W: Communication  S: Scope of Work",contactNo:"0945-311-1571",companyName:"Michael Labrador",paymentTerms:"Cash Basis",address:"",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material request details/Communication  S: Scope of Work",contactNo:"0917-719-8415",companyName:"Ronald Quirong",paymentTerms:"30 Days",address:"206-B M. Paterno St. San Juan City, Metro Manila",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"Davao",remarks:"",notes:""},
    {rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"W: Material request details/Communication  S: Scope of Work",contactNo:"0933-626-2399",companyName:"Miguel Kwan",paymentTerms:"Cash Basis",address:"",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"Cebu",remarks:"",notes:""},
    {rating:"NO",specialty:"Metal Works (Supply & Install)",strengthsWeaknesses:"W: Work errors/Design concerns about metal works/Billing",contactNo:"0917-802-6014",companyName:"Alba Motors/Elijah Mojares",paymentTerms:"Cash Basis",address:"88 Jenny's Avenue, Maybunga Pasig City",rateStructure:"Material/Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",remarks:"",notes:""},
  ];

  // NOTE: this used to auto-seed SEED_SUPPLIERS/SEED_SUBCONS into Supabase on
  // mount whenever `suppliers.length===0`/`subcons.length===0`. That check ran
  // against local React state, which starts empty on every fresh mount BEFORE
  // sbLoadAll() has hydrated it from the server — so it looked "empty" (and
  // re-seeded the full list with brand-new random IDs, so nothing deduped)
  // essentially every time the app mounted, not just once ever. Removed —
  // suppliers/subcontractors are already fully seeded; use the Supplier/Subcon
  // Master "+ Add" UI for anything new instead of an automatic effect.

  const logStockMove=(move)=>{
    const moveItem=inventory.find(i=>i.id===move.itemId);
    if(move.moveType?.startsWith("OUT")){
      if(!moveItem){toastEmit("Stock OUT failed — inventory item not found. Check that the item still exists.","error");return false;}
      if(Number(moveItem.qtyOnHand)<Number(move.qty||0)){toastEmit(`Insufficient stock — only ${moveItem.qtyOnHand} ${moveItem.unit||""} on hand.`,"error");return false;}
    }
    // Policy §5.3 — Finance must witness release/return of high-value materials
    // and all scrap. Enforced here so no UI path can bypass it.
    const needsWitness=moveNeedsWitness(move.moveType,moveItem);
    if(needsWitness&&!String(move.financeWitness||"").trim()){
      toastEmit("This release requires a Finance witness (§5.3). Enter the Finance representative before recording.","error",7000);
      return false;
    }
    const entry={...move,highValue:needsWitness||!!move.highValue,id:uid(),date:move.date||today,recordedBy:session?.name||role};
    upStocklog(sl=>[entry,...sl]);
    if(isSupabaseReady()) sbInsert('stock_movements',moveToSb(entry)).catch(()=>{});
    const qty=Number(move.qty)||0;
    upInventory(iv=>iv.map(i=>{
      if(i.id!==move.itemId) return i;
      const type=move.moveType||"";
      let newQty=Number(i.qtyOnHand)||0;
      if(type.startsWith("IN"))    newQty+=qty;
      if(type.startsWith("OUT"))   newQty=Math.max(0,newQty-qty);
      if(type.startsWith("ADJUST"))newQty=qty;
      if(type.startsWith("RETURN"))newQty=Math.max(0,newQty-qty);
      let avgCost=Number(i.avgCost)||0;
      if(type.startsWith("IN")&&Number(move.unitCost)>0){
        const prevTotal=(Number(i.qtyOnHand)||0)*avgCost;
        const newTotal=qty*Number(move.unitCost);
        avgCost=newQty>0?(prevTotal+newTotal)/newQty:Number(move.unitCost);
      }
      const updated={...i,qtyOnHand:Math.round(newQty*100)/100,avgCost:Math.round(avgCost*100)/100,
        lastPurchasePrice:type.startsWith("IN")&&move.unitCost?Number(move.unitCost):i.lastPurchasePrice,
        lastUpdated:today};
      if(isSupabaseReady()) sbUpdate('inventory_items',i.id,invToSb(updated)).catch(()=>{});
      // Auto-create project expense when stock is issued to a project
      if((move.moveType||"").startsWith("OUT")&&(move.dealId||move.projectId)){
        const costPerUnit=Number(move.unitCost)||Number(i.avgCost)||0;
        const costAmt=Math.round(qty*costPerUnit*100)/100;
        if(costAmt>0){
          const dealId=move.dealId||move.projectId;
          const expEntry={
            id:uid(),dealId,projectId:dealId,
            expDate:move.date||today,
            category:"Materials",
            note:`${i.name} × ${qty} ${i.unit||""} — from GMD Stocks`,
            description:`${i.name} × ${qty} ${i.unit||""} — from GMD Stocks`,
            amount:costAmt,payee:"GMD Stocks",
            bankAccount:null, // non-cash stock transfer — excluded from bank flows
            year:new Date(move.date||today).getFullYear(),
            month:new Date(move.date||today).getMonth(),
            receiptNo:"",createdBy:session?.name||role,
          };
          upExps(es=>[expEntry,...es]);
          if(isSupabaseReady()) sbUpsert("expenses",toSbExpense(expEntry),"id").catch(()=>{});
          toastEmit&&toastEmit(`Expense of ₱${costAmt.toLocaleString("en-PH",{maximumFractionDigits:0})} auto-tagged to project for ${i.name}×${qty}${i.unit||""}`,  "info");
        }
      }
      return updated;
    }));
    return true;
  };

  const printDR=(pr,qty,drNo,deal)=>{
    const recvDate=today;
    const projName=pr.projectId==="__gmd_stocks__"||pr.projectName==="GMD Stocks"?"GMD Stocks":(deal?projDisplayName(deal):(pr.projectName||"—"));
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8">
<title>Delivery Receipt — ${drNo||"GRN"}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Arial',sans-serif;font-size:12px;color:#1a1a2e;background:#fff;padding:20px}
  .logo-area{display:flex;align-items:center;gap:14px;margin-bottom:4px}
  .co-name{font-size:20px;font-weight:900;color:#0f172a;letter-spacing:-0.5px}
  .co-sub{font-size:10px;color:#64748b;margin-top:2px}
  .doc-title{font-size:22px;font-weight:900;color:#0f172a;margin-top:16px;border-bottom:3px solid #0f172a;padding-bottom:8px;letter-spacing:1px}
  .meta-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 24px;margin:14px 0;font-size:11px}
  .meta-row{display:flex;gap:6px;align-items:flex-start}
  .meta-label{font-weight:700;color:#475569;min-width:80px;flex-shrink:0}
  .meta-val{color:#0f172a}
  .section-head{font-weight:800;font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#475569;margin:16px 0 8px;border-bottom:1px solid #e2e8f0;padding-bottom:4px}
  table{width:100%;border-collapse:collapse;font-size:11px;margin-bottom:16px}
  th{background:#1e293b;color:#fff;padding:8px 10px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.8px;font-weight:700}
  td{padding:8px 10px;border-bottom:1px solid #f1f5f9;vertical-align:top}
  tr:last-child td{border-bottom:none}
  .sig-row{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:30px}
  .sig-box{text-align:center;font-size:10px;color:#475569}
  .sig-line{border-top:1px solid #94a3b8;padding-top:6px;margin-top:36px}
  .sig-name{font-weight:700;font-size:11px;color:#0f172a}
  .status-badge{display:inline-block;background:#dcfce7;color:#15803d;border:1px solid #bbf7d0;border-radius:12px;padding:2px 10px;font-weight:700;font-size:10px}
  .notes-box{background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:10px;font-size:11px;color:#475569;margin-top:8px}
  @media print{body{padding:10px}}
</style></head><body>
<div class="logo-area"><div><div class="co-name">GMD PRODUCTIONS INC</div><div class="co-sub">Interior Design & Fabrication · info@gmdpro.com.ph</div></div></div>
<div class="doc-title">GOODS RECEIVING NOTE</div>
<div class="meta-grid">
  <div class="meta-row"><span class="meta-label">GRN / DR No.:</span><span class="meta-val"><strong>${drNo||"— (none)"}</strong></span></div>
  <div class="meta-row"><span class="meta-label">Date Received:</span><span class="meta-val">${recvDate}</span></div>
  <div class="meta-row"><span class="meta-label">PO Reference:</span><span class="meta-val">${pr.poNumber||pr.id?.slice(-8)||"—"}</span></div>
  <div class="meta-row"><span class="meta-label">Supplier:</span><span class="meta-val">${pr.supplier||"—"}</span></div>
  <div class="meta-row"><span class="meta-label">Project:</span><span class="meta-val">${projName}</span></div>
  <div class="meta-row"><span class="meta-label">Received By:</span><span class="meta-val">${session?.name||"Warehouse"}</span></div>
</div>
<div class="section-head">Items Received</div>
<table>
  <thead><tr><th>Description</th><th style="width:90px">PO Qty</th><th style="width:90px">Qty Received</th><th style="width:80px">Unit</th><th>Condition</th></tr></thead>
  <tbody>
    <tr>
      <td>${pr.itemName||"—"}</td>
      <td>${pr.qty||"—"}</td>
      <td><strong>${qty}</strong></td>
      <td>${pr.unit||"pcs"}</td>
      <td><span class="status-badge">✓ Good</span></td>
    </tr>
  </tbody>
</table>
${Number(qty)<Number(pr.qty)?`<div class="notes-box">⚠️ <strong>Partial Delivery:</strong> ${qty} of ${pr.qty} ${pr.unit||""} received. Balance of ${Number(pr.qty)-Number(qty)} ${pr.unit||""} pending.</div>`:""}
<div class="notes-box" style="margin-top:8px">Notes: ${pr.deliveryNote||"No additional notes."}</div>
<div class="sig-row">
  <div class="sig-box"><div class="sig-line"><span class="sig-name">${session?.name||"Warehouse Staff"}</span></div>Received By / Warehouse</div>
  <div class="sig-box"><div class="sig-line"><span class="sig-name">&nbsp;</span></div>Checked By / QC</div>
  <div class="sig-box"><div class="sig-line"><span class="sig-name">&nbsp;</span></div>Supplier Representative</div>
</div>
<div style="margin-top:20px;font-size:9px;color:#94a3b8;text-align:center;border-top:1px solid #f1f5f9;padding-top:8px">
  This document serves as official receiving record. Any discrepancies must be reported within 24 hours. · GMD PRODUCTIONS INC · ${recvDate}
</div>
</body></html>`;
    const w=window.open("","_blank","width=800,height=600");
    if(!w){toastEmit("Popup blocked — allow popups to print.","error");return;}
    w.document.write(html);w.document.close();addPrintClose(w);
    setTimeout(()=>w.print(),400);
  };

  const createProjectCard=async(dealId,dealData)=>{
    const card=emptyProjectCard(dealId,dealData);
    // Never reassign the primary key of a card that already exists for this deal.
    // emptyProjectCard mints a fresh uid() (and ~39 fresh task uids) on every call.
    // The write below upserts on the UNIQUE deal_id, so on a re-award (or a second
    // "create card" pass) the ON CONFLICT(deal_id) DO UPDATE would rewrite
    // project_cards.id with the new uid — orphaning every existing
    // project_card_dept_tasks.card_id, since that FK is ON DELETE CASCADE with no
    // ON UPDATE CASCADE. Postgres rejects it as
    // project_card_dept_tasks_card_id_fkey, a non-retryable "data" error that sync
    // drops and surfaces as the red "bad data — redo it" toast on award.
    // Reuse the existing card's id AND its existing department/task ids so the
    // deal_id upsert stays a same-PK update and the task upserts (keyed on task id)
    // don't insert a duplicate checklist. Same id-adoption guard as syncProjectCard.
    const existing=pcards[dealId];
    if(existing&&isUUID(existing.id)){
      card.id=existing.id;
      if(existing.departments) card.departments=existing.departments;
    }
    upPcards(ps=>({...ps,[dealId]:card}));
    logActivity(dealId,"Project Card Created",`${dealData?.client} — project card created for all departments`,session?.name);
    if(isSupabaseReady()){
      // Await the parent card write before firing the ~39 department-task
      // inserts that reference it by foreign key — firing them in parallel
      // let a task occasionally reach the server before the card committed,
      // failing an FK check that sync retry then permanently drops (a
      // constraint violation is a "data" error, never retried, only dropped —
      // this silently lost individual checklist tasks in production).
      // Guarantee the parent deal exists on the server before the card's own FK
      // to deals(id) is evaluated — createProjectCard is reachable from the
      // manual "create card" path too, where the deal may still be local-only.
      // Merge the caller-supplied dealData over the `deals` snapshot before
      // re-syncing the parent. During Award the optimistic stage/probability
      // update (upDeals → "06 · Kickoff") has only been scheduled, so the
      // `deals` closure here still holds the PRE-award stage. Syncing that raw
      // snapshot would land after confirmAward's own Kickoff write and silently
      // revert the deal to its old stage (e.g. "01 · BizDev") — the deal then
      // looks un-awarded in the pipeline and gets awarded again, issuing a
      // duplicate Job Order. dealData carries the authoritative just-changed
      // fields, so let it win over the stale snapshot.
      // Insert-if-missing only (ignoreDuplicates): if the deal already exists on
      // the server — the normal case, since confirmAward upserts the awarded deal
      // just before this — leave that row untouched so this write can't revert the
      // "06 · Kickoff" stage back to the pre-award value. The merged payload only
      // matters for the self-heal case where the parent was never synced, and even
      // then carries the caller's authoritative (awarded) fields, not the stale
      // `deals` snapshot.
      const parentDeal=deals.find(d=>d.id===dealId);
      const parentToSync=parentDeal?{...parentDeal,...(dealData||{})}:(dealData||null);
      if(parentToSync&&parentToSync.id) await sbSyncOne("deals",parentToSync,toSbDeal,{ignoreDuplicates:true});
      const cardSynced=await sbUpsert('project_cards',{id:card.id,deal_id:dealId,client:dealData?.client||"",ce_no:dealData?.ceNo||"",value:Number(dealData?.value)||0,award_date:dealData?.awardDate||today,created_at:card.createdAt,ae_assigned:card.aeAssigned||"",pm1:card.pm1||"",pm2:card.pm2||"",pm3:card.pm3||"",designer:card.designer||"",coordinator:card.coordinator||"",...(card.targetEndDate?{target_end_date:card.targetEndDate}:{}),...(card.targetDays!=null?{target_days:card.targetDays}:{})},'deal_id');
      if(cardSynced){
        DEPT_ORDER.forEach(dept=>{
          (card.departments?.[dept]?.tasks||[]).forEach((t,i)=>{
            sbUpsert('project_card_dept_tasks',{id:t.id,card_id:card.id,department:dept,task_text:t.text,done:false,sort_order:i},'id').catch(()=>{});
          });
        });
      }
      // If the parent write itself failed, it's already queued for retry —
      // the tasks stay local-only until the next createProjectCard-style
      // flow or a manual resync; queuing them now would just fail the FK too.
      return cardSynced;
    }
    return true;
  };
  const toggleDeptTask=(dealId,dept,taskId)=>{
    // Compute the new card OUTSIDE the setState updater. React runs updaters
    // asynchronously, so the card wouldn't be available to the server writes
    // below if they lived inside the updater — which is also why the writes used
    // to sit inside it. Deriving from the current pcards (same closure the
    // done/nowDone flags already read) lets us fire the writes parent-first.
    const baseCard=pcards[dealId]||emptyProjectCard(dealId,{});
    const existingTask=baseCard?.departments?.[dept]?.tasks?.find(t=>t.id===taskId);
    const nowDone=!(existingTask?.done||false);
    const wasAlreadyDeptDone=baseCard?.departments?.[dept]?.done||false;
    const ts=new Date().toISOString();
    const depts=baseCard.departments||{};
    const deptData={...(depts[dept]||{tasks:[]})};
    deptData.tasks=(deptData.tasks||[]).map(t=>t.id===taskId?{...t,done:nowDone,doneAt:nowDone?ts:null,doneBy:nowDone?session?.name:null}:t);
    deptData.done=deptData.tasks.length>0&&deptData.tasks.every(t=>t.done);
    const deptJustCompleted=deptData.done&&!wasAlreadyDeptDone;
    if(deptJustCompleted){deptData.doneAt=ts;deptData.doneBy=session?.name;}
    const newCard={...baseCard,departments:{...depts,[dept]:deptData}};
    upPcards(ps=>({...ps,[dealId]:{...(ps[dealId]||newCard),departments:{...((ps[dealId]||newCard).departments||{}),[dept]:deptData}}}));
    if(isSupabaseReady()&&isUUID(taskId)){
      sbUpdate('project_card_dept_tasks',taskId,{done:nowDone,done_at:nowDone?ts:null,done_by:nowDone?session?.name:null}).catch(()=>{});
    }
    // Parent-first: ensure the project_cards row (with this card's id) exists on
    // the server before the dept_status child that references it, so it can't
    // orphan ("progress update couldn't reach the server — card isn't there yet").
    if(isSupabaseReady()&&deptData.done&&newCard.id&&isUUID(newCard.id)){
      (async()=>{
        await syncProjectCard(dealId,{});
        sbUpsert('project_card_dept_status',{card_id:newCard.id,department:dept,done:deptData.done,done_at:deptData.doneAt,done_by:deptData.doneBy},'card_id,department').catch(()=>{});
      })();
    }
    if(deptJustCompleted) logActivity(dealId,"Department Done",`${dept} completed all tasks for ${baseCard?.client}`,session?.name);
  };
  const setProjectTAT=(dealId,dateStr,category)=>{
    if(!dateStr) return;
    const card=pcards[dealId];
    if(!card) return;
    const award=card.awardDate||today;
    const targetDays=Math.max(1,Math.ceil((new Date(dateStr)-new Date(award))/86400000));
    upPcards(ps=>({...ps,[dealId]:{...ps[dealId],
      targetDays,
      targetEndDate:dateStr,
      tatCategory:category||"",
      tatSetBy:session?.name,
      tatSetAt:new Date().toISOString(),
    }}));
    if(isSupabaseReady()){
      syncProjectCard(dealId,{target_days:targetDays,target_end_date:dateStr,tat_category:category||"",tat_set_by:session?.name,tat_set_at:new Date().toISOString()});
    }
    toastEmit("Turnover date set — Due "+dateStr,"success");
    logActivity(dealId,"TAT Set",`Target: ${targetDays} days → Due ${dateStr}`,session?.name);
    const deal=deals.find(d=>d.id===dealId);
    const tgMsg=`📅 <b>Turnover Date Set</b>\nProject: <b>${deal?.client||card.client||"?"}</b> — ${deal?.ceNo||card.ceNo||"(no CE)"}\nTarget: ${targetDays} days from award (${award})\n🏁 Turnover Date: <b>${dateStr}</b>${category?`\nCategory: ${category}`:""}\nSet by: ${session?.name||"?"}`;
    sendTelegramNotification("ops",tgMsg);
    sendTelegramNotification("management",tgMsg);
    toastEmit("Turnover date set — Due "+dateStr,"success");
  };

  const markDeptDone=(dealId,dept,done)=>{
    // Same pattern as toggleDeptTask: compute outside the updater so the server
    // write can run parent-first and can't orphan the dept_status child.
    const baseCard=pcards[dealId]||emptyProjectCard(dealId,{});
    const depts=baseCard.departments||{};
    const ts=new Date().toISOString();
    const deptData={...(depts[dept]||{tasks:[]}),done,doneAt:done?ts:null,doneBy:done?session?.name:null};
    const newCard={...baseCard,departments:{...depts,[dept]:deptData}};
    upPcards(ps=>({...ps,[dealId]:{...(ps[dealId]||newCard),departments:{...((ps[dealId]||newCard).departments||{}),[dept]:deptData}}}));
    if(done) logActivity(dealId,"Department Done",`${dept} marked complete for ${baseCard.client}`,session?.name);
    if(isSupabaseReady()&&newCard.id&&isUUID(newCard.id)){
      (async()=>{
        await syncProjectCard(dealId,{});
        sbUpsert('project_card_dept_status',{card_id:newCard.id,department:dept,done,done_at:deptData.doneAt,done_by:deptData.doneBy},'card_id,department').catch(()=>{});
      })();
    }
  };

  // ── Supabase real-time subscriptions ─────────────────────────────────────────
  // When any user makes a change, ALL other logged-in users see it instantly
  useEffect(()=>{
    if(!session||!isSupabaseReady()) return;

    // Role gating: skip live-update channels for tables this role's UI never
    // reads (audited per-role via navMap reachability + each page's actual
    // props, including indirect paths like Accounting's dashboard buttons into
    // WIP/Cash Flow and the role-unguarded calendar route). This only skips the
    // realtime push — initial load and the tab-focus auto-refresh still fetch
    // everything, so a wrong entry here degrades to "updates on next refresh"
    // rather than missing data. Rules that must hold when editing this map:
    // - null = every role subscribes; unknown/missing role = subscribe to all.
    // - project_cards / project_card_dept_status / project_card_dept_tasks all
    //   write into the same pcards state — keep their lists identical.
    // - billing_milestones / billing_payments share the billings state (payments
    //   nest inside milestones) — keep their lists identical.
    // - inflows' only consumer is the username-gated (paulo) Data Management
    //   screen; its modal is dead UI, so Manager-only.
    const RT_SUB_ROLES={
      deals:null,
      purchase_requests:null,
      project_cards:["Manager","Sales","Finance","Procurement","Operations","Design","ProjectMover","Warehouse"],
      project_card_dept_status:["Manager","Sales","Finance","Procurement","Operations","Design","ProjectMover","Warehouse"],
      project_card_dept_tasks:["Manager","Sales","Finance","Procurement","Operations","Design","ProjectMover","Warehouse"],
      billing_milestones:["Manager","Sales","Finance","Accounting","Procurement","Operations","Design","ProjectMover"],
      billing_payments:["Manager","Sales","Finance","Accounting","Procurement","Operations","Design","ProjectMover"],
      addenda:["Manager","Sales","Finance","QS","Procurement","Operations","Design","ProjectMover"],
      activity_log:["Manager","Sales","Finance","QS","Procurement","Operations","Design","ProjectMover"],
      job_orders:["Manager","Sales","Finance","QS","Procurement","Operations","Design","ProjectMover","Warehouse"],
      material_requests:["Manager","Sales","Finance","Procurement","Operations","Design","ProjectMover"],
      budget_requests:["Manager","Sales","Finance","Procurement","Operations","Design","ProjectMover"],
      expenses:["Manager","Sales","Finance","Accounting","QS","Procurement","Operations","Design","ProjectMover"],
      subcon_work_orders:["Manager","Sales","Finance","Accounting","Procurement","Operations","Design","ProjectMover"],
      inflows:["Manager"],
      // Calendar/field-board events live in `checklists`. Every audited role must
      // receive these live — a role left off this list only sees items it created
      // locally and won't pick up events added on another device until a manual
      // reload, which reads as the event "disappearing" from the calendar.
      checklists:["Manager","Sales","Finance","Accounting","QS","Procurement","Operations","Design","ProjectMover","Warehouse"],
      swatches:["Manager","Finance","Procurement","Operations","Design"],
      ae_updates:["Manager","Sales","Finance","QS","Operations","ProjectMover","Design"],
      audit_findings:["Manager","Finance","Accounting","Audit","HRAdmin","Warehouse","Procurement"],
      project_blockers:["Manager","Sales","Finance","QS","Procurement","Operations","Design","ProjectMover"],
      inventory_items:["Manager","Finance","Procurement","Warehouse"],
      stock_movements:["Manager","Finance","Procurement","Warehouse"],
      design_requests:["Manager","Sales","Finance","Design","Operations","ProjectMover"],
    };
    // Only trim subscriptions for roles the audit actually covered — a role
    // string we don't recognize (new role added later, legacy value in the DB)
    // subscribes to everything rather than silently losing live updates.
    const RT_AUDITED_ROLES=new Set(["Manager","Sales","Finance","Accounting","Procurement","QS","Operations","Design","ProjectMover","Warehouse"]);
    const rtRole=session?.role||role||"";
    const wantsRT=t=>{const allow=RT_SUB_ROLES[t];return !allow||!RT_AUDITED_ROLES.has(rtRole)||allow.includes(rtRole);};

    // Deals — Paulo awards, Paolo sees it; Aerwin updates billing, everyone sees it
    const dealsSub = sbSubscribe('deals-rt', 'deals', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped={...rec,ceNo:rec.ce_no,ceType:rec.ce_type,salesOwner:rec.sales_owner,
          bizDevSource:rec.biz_dev_source,leadOrigin:rec.lead_origin||DEFAULT_LEAD_ORIGIN,leadOriginStatus:rec.lead_origin_status||"Approved",leadOriginApprovedBy:rec.lead_origin_approved_by||"",leadOriginApprovedAt:rec.lead_origin_approved_at||null,
          parentDealId:rec.parent_deal_id||null,addendumStatus:rec.addendum_status||null,dateAcquired:rec.date_acquired,
          dueDate:rec.due_date,amountPaid:Number(rec.amount_paid)||0,
          paymentStatus:rec.payment_status,receiptType:rec.receipt_type,
          commsGroup:rec.comms_group,salesRepoLink:rec.sales_repo_link,
          proposalFolderLink:rec.proposal_folder_link,stage:normalizeStage(rec.stage),
          location:rec.location||"",addedBy:rec.added_by||"",addedAt:rec.added_at||"",
          awardRequestData:rec.award_request_data||null,boqData:rec.boq_data||null,
          standbyPO:rec.standby_po||false,dpWaivedBy:rec.dp_waived_by||"",dpWaivedAt:rec.dp_waived_at||null,dpWaivedReason:rec.dp_waived_reason||"",poBudget:rec.standby_po?(Number(rec.po_budget)||0):"",
          billingGenerated:rec.billing_generated||false,
          bir2303Url:rec.bir_2303_url||"",bir2303OnFile:rec.bir_2303_on_file||false,
          signedCeUrl:rec.signed_ce_url||"",signedCeOnFile:rec.signed_ce_on_file||false,clientPoNo:rec.client_po_no||"",isCostCenter:!!rec.is_cost_center,
          vatTreatment:rec.vat_treatment||"",downpaymentPct:rec.downpayment_pct??null,
          paymentTermsText:rec.payment_terms_text||"",clientSatisfied:rec.client_satisfied||false,
          satisfactionNote:rec.satisfaction_note||"",
          paymentTerms:rec.payment_terms_json?(()=>{try{return JSON.parse(rec.payment_terms_json);}catch(e){return null;}})():null};
        setDeals(ds=>{const ex=ds.find(d=>d.id===rec.id);
          return ex?ds.map(d=>d.id===rec.id?{...d,...mapped}:d):[mapped,...ds];});
      }
      if(eventType==='DELETE') setDeals(ds=>ds.filter(d=>d.id!==oldRow.id));
    });

    // Project card dept status — Ryon checks a task, Arrius sees it live
    const pcardSub = !wantsRT('project_card_dept_status')?null:sbSubscribe('pcards-rt', 'project_card_dept_status', payload=>{
      if(payload.eventType==='INSERT'||payload.eventType==='UPDATE'){
        const{card_id,department,done,done_at,done_by}=payload.new;
        setPcards(pc=>{
          if(!pc) return pc;
          const card=Object.values(pc).find(c=>c.id===card_id);
          if(!card) return pc;
          return{...pc,[card.dealId||card.deal_id]:{...card,departments:{
            ...card.departments,
            [department]:{...card.departments?.[department],done,doneAt:done_at,doneBy:done_by}
          }}};
        });
      }
    });

    // Billing — Aerwin logs a payment, Mar's dashboard updates
    const billSub = !wantsRT('billing_milestones')?null:sbSubscribe('bill-rt', 'billing_milestones', payload=>{
      if(payload.eventType==='INSERT'||payload.eventType==='UPDATE'){
        const rec=payload.new;
        const mapped={...rec,dealId:rec.deal_id,invoiceNo:rec.invoice_no,
          invoiceDate:rec.invoice_date,dueDate:rec.due_date,createdBy:rec.created_by,
          plannedDate:rec.planned_bill_date||undefined,msType:rec.ms_type||undefined};
        setBillings(bs=>{const ex=bs.find(b=>b.id===rec.id);
          // Preserve existing payments array — billing_milestones RT event doesn't carry payments
          return ex?bs.map(b=>b.id===rec.id?{...b,...mapped,payments:b.payments||[]}:b):[...bs,{...mapped,payments:[]}];});
      }
      if(payload.eventType==='DELETE') setBillings(bs=>bs.filter(b=>b.id!==payload.old.id));
    });

    // Addenda — PM flags scope, AE + Paolo see it on their dashboard immediately
    const addSub = !wantsRT('addenda')?null:sbSubscribe('add-rt', 'addenda', payload=>{
      if(payload.eventType==='INSERT'||payload.eventType==='UPDATE'){
        const rec=payload.new;
        const mapped={...rec,dealId:rec.deal_id,receiptType:rec.receipt_type,
          salesNotified:rec.sales_notified,discoveredBy:rec.discovered_by,
          kind:rec.kind||"Additive",scopeItems:Array.isArray(rec.scope_items)?rec.scope_items:[],coBoqData:rec.co_boq_data||null,salesOwner:rec.sales_owner||"",awardedDate:rec.awarded_date||null,subAccount:rec.sub_account||null};
        setAddenda(as=>{const ex=as.find(a=>a.id===rec.id);
          return ex?as.map(a=>a.id===rec.id?{...a,...mapped}:a):[...as,mapped];});
      }
    });

    // Activity log — PM update shows on Arrius's dashboard live
    const actSub = !wantsRT('activity_log')?null:sbSubscribe('actlog-rt', 'activity_log', payload=>{
      if(payload.eventType==='INSERT')
        setActLog(al=>[{...payload.new,dealId:payload.new.deal_id},...al].slice(0,200));
    });

    // Job Orders — PM assigned, everyone sees it live
    const joSub = !wantsRT('job_orders')?null:sbSubscribe('jos-rt', 'job_orders', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped={...rec,dealId:rec.deal_id,joNo:rec.jo_no,projectName:rec.project_name,
          awardTrigger:rec.award_trigger,triggerDate:rec.trigger_date,startDate:rec.start_date,
          commsLink:rec.comms_link,scopeNotes:rec.scope_notes,
          specialInstructions:rec.special_instructions,designer:rec.designer||"",
          location:rec.location||"",budgetStatus:rec.budget_status,
          issuedDate:rec.issued_date,aeAssigned:rec.ae_assigned};
        setJos(prev=>{const js=dropStaleJos([mapped],prev);const ex=js.find(j=>j.id===rec.id);
          return ex?js.map(j=>j.id===rec.id?{...j,...mapped}:j):[...js,mapped];});
      }
      if(eventType==='DELETE') setJos(js=>js.filter(j=>j.id!==oldRow.id));
    });

    // Purchase Requests — Procurement approves, Ops sees it immediately
    const prSub = sbSubscribe('prs-rt', 'purchase_requests', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        // Mirror the initial-load mapping (snake_case → camelCase) in full. A
        // partial mapping here meant a teammate's new PO arrived without
        // poNumber / est-act unit costs / itemName, so it failed to group as a
        // PO and showed a blank amount until a full reload ("need to logout for
        // other POs to appear").
        const mapped={...rec,dealId:rec.deal_id,projectId:rec.deal_id,itemName:rec.item||"",
          estimatedCost:Number(rec.estimated_cost)||0,estUnitCost:Number(rec.estimated_cost)||0,
          actualCost:Number(rec.actual_cost)||0,actUnitCost:Number(rec.actual_cost)||0,
          budgetCategory:rec.budget_category,qtyDelivered:Number(rec.qty_delivered)||0,
          deliveryDate:rec.delivery_date,deliveryNote:rec.delivery_note||"",drNo:rec.dr_no,
          createdBy:rec.created_by,poNumber:rec.po_number||"",poDate:rec.po_date||"",paymentTerms:rec.payment_terms||"",termsText:rec.terms_text||"",
          requestedBy:rec.requested_by||rec.created_by||"",approvedBy:rec.approved_by||"",
          projectName:rec.project_name||"",fromMrId:rec.from_mr_id||null,urgency:rec.urgency||"Normal",
          approvedAt:rec.approved_at||null,
          deliveryHistory:rec.delivery_history?(()=>{try{return JSON.parse(rec.delivery_history);}catch(e){return [];}})():undefined,
          acctStatus:rec.acct_status||"",acctNotes:rec.acct_notes||"",acctCheckedBy:rec.acct_checked_by||"",
          acctCheckedAt:rec.acct_checked_at||"",paymentBank:rec.payment_bank||"",paymentRef:rec.payment_ref||"",
          paymentOrderedBy:rec.payment_ordered_by||"",paymentOrderedAt:rec.payment_ordered_at||"",
          paidRef:rec.paid_ref||"",paidDate:rec.paid_date||"",paidAmt:rec.paid_amt!=null?Number(rec.paid_amt):null,
          paidBy:rec.paid_by||"",discType:rec.disc_type||"none",discValue:Number(rec.disc_value)||0,
          poDiscType:rec.po_discount_type||"none",poDiscValue:Number(rec.po_discount_value)||0,withVat:rec.with_vat||false,accountCode:rec.account_code||""};
        setPrs(ps=>{const ex=ps.find(p=>p.id===rec.id);
          return ex?ps.map(p=>p.id===rec.id?{...p,...mapped}:p):[...ps,mapped];});
      }
      if(eventType==='DELETE') setPrs(ps=>ps.filter(p=>p.id!==oldRow.id));
    });

    // CE/QS cost-estimation requests — Sales submits, Rodney's queue updates live.
    // Previously ce_requests had NO realtime subscription, so a submitted CE
    // request only reached other users' queues after a logout/refresh.
    const ceReqSub = sbSubscribe('ce-rt', 'ce_requests', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped=ceReqFromSb(rec);
        setCeReqs(cs=>{const ex=cs.find(c=>c.id===rec.id);return ex?cs.map(c=>c.id===rec.id?{...c,...mapped}:c):[mapped,...cs];});
      }
      if(eventType==='DELETE') setCeReqs(cs=>cs.filter(c=>c.id!==oldRow.id));
    });

    // Material Requests — submitted on site, office sees it live
    const mreqSub = !wantsRT('material_requests')?null:sbSubscribe('mreqs-rt', 'material_requests', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped={...rec,dealId:rec.deal_id,estimatedCost:rec.estimated_cost,
          submittedBy:rec.submitted_by};
        setMreqs(ms=>{const ex=ms.find(m=>m.id===rec.id);
          return ex?ms.map(m=>m.id===rec.id?{...m,...mapped}:m):[...ms,mapped];});
      }
      if(eventType==='DELETE') setMreqs(ms=>ms.filter(m=>m.id!==oldRow.id));
    });

    // Budget Requests — Finance approves, PM notified instantly
    const breqSub = !wantsRT('budget_requests')?null:sbSubscribe('breqs-rt', 'budget_requests', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped={...rec,dealId:rec.deal_id,dateNeeded:rec.date_needed,
          approvedBy:rec.approved_by,submittedBy:rec.submitted_by};
        setBreqs(bs=>{const ex=bs.find(b=>b.id===rec.id);
          return ex?bs.map(b=>b.id===rec.id?{...b,...mapped}:b):[...bs,mapped];});
      }
      if(eventType==='DELETE') setBreqs(bs=>bs.filter(b=>b.id!==oldRow.id));
    });

    // Billing payments — payment logged, Finance dashboard updates immediately
    const paymentSub = !wantsRT('billing_payments')?null:sbSubscribe('payments-rt', 'billing_payments', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped={...rec,milestoneId:rec.milestone_id,refNo:rec.ref_no,
          recordedBy:rec.recorded_by,valueDate:rec.value_date,method:rec.payment_method,bounced:!!rec.bounced};
        setBillings(bs=>bs.map(b=>{
          if(b.id!==rec.milestone_id) return b;
          const payments=b.payments||[];
          const ex=payments.find(p=>p.id===rec.id);
          return{...b,payments:ex?payments.map(p=>p.id===rec.id?{...p,...mapped}:p):[...payments,mapped]};
        }));
      }
      if(eventType==='DELETE')
        setBillings(bs=>bs.map(b=>({...b,payments:(b.payments||[]).filter(p=>p.id!==oldRow.id)})));
    });

    // Expenses — anyone logs cost, Finance sees it live
    const expSub = !wantsRT('expenses')?null:sbSubscribe('exps-rt', 'expenses', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const dt=rec.date?new Date(rec.date):null;
        const mapped={...rec,dealId:rec.deal_id,receiptNo:rec.receipt_no,payee:rec.supplier||"",
          month:dt?dt.getMonth():new Date().getMonth(),
          year:dt?dt.getFullYear():new Date().getFullYear()};
        setExps(es=>{const ex=es.find(e=>e.id===rec.id);
          return ex?es.map(e=>e.id===rec.id?{...e,...mapped}:e):[...es,mapped];});
      }
      if(eventType==='DELETE') setExps(es=>es.filter(e=>e.id!==oldRow.id));
    });

    const swoSub = !wantsRT('subcon_work_orders')?null:sbSubscribe('swos-rt','subcon_work_orders',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped=swoFromSb(rec);
        setSwos(ws=>{const ex=ws.find(w=>w.id===rec.id);return ex?ws.map(w=>w.id===rec.id?{...w,...mapped}:w):[mapped,...ws];});
      }
      if(eventType==='DELETE') setSwos(ws=>ws.filter(w=>w.id!==oldRow.id));
    });

    // Inflows — payment received, cash position updates across all devices
    const inflowSub = !wantsRT('inflows')?null:sbSubscribe('inflows-rt', 'inflows', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const mapped={...rec,dealId:rec.deal_id,refNo:rec.ref_no};
        setInfs(is=>{const ex=is.find(i=>i.id===rec.id);
          return ex?is.map(i=>i.id===rec.id?{...i,...mapped}:i):[...is,mapped];});
      }
      if(eventType==='DELETE') setInfs(is=>is.filter(i=>i.id!==oldRow.id));
    });

    // Project card tasks — Ryon checks off a task, Arrius sees it live
    const taskSub = !wantsRT('project_card_dept_tasks')?null:sbSubscribe('tasks-rt', 'project_card_dept_tasks', payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='INSERT'||eventType==='UPDATE'){
        const task={id:rec.id,text:rec.task_text,done:rec.done,doneAt:rec.done_at,doneBy:rec.done_by};
        setPcards(pc=>{
          if(!pc) return pc;
          const card=Object.values(pc).find(c=>c.id===rec.card_id);
          if(!card||!card.departments?.[rec.department]) return pc;
          const dept=card.departments[rec.department];
          const tasks=dept.tasks||[];
          const ex=tasks.find(t=>t.id===rec.id);
          const newTasks=ex?tasks.map(t=>t.id===rec.id?{...t,...task}:t):[...tasks,task];
          return{...pc,[card.dealId||card.deal_id]:{...card,departments:{
            ...card.departments,[rec.department]:{...dept,tasks:newTasks}
          }}};
        });
      }
      if(eventType==='DELETE'){
        setPcards(pc=>{
          if(!pc) return pc;
          const next={...pc};
          Object.keys(next).forEach(k=>{
            const card=next[k];
            Object.keys(card.departments||{}).forEach(dept=>{
              if(card.departments[dept]?.tasks?.find(t=>t.id===oldRow.id)){
                next[k]={...card,departments:{...card.departments,
                  [dept]:{...card.departments[dept],tasks:card.departments[dept].tasks.filter(t=>t.id!==oldRow.id)}
                }};
              }
            });
          });
          return next;
        });
      }
    });

    const checkSub = !wantsRT('checklists')?null:sbSubscribe('checklist-rt','checklists',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setChecklist(cs=>cs.filter(c=>c.id!==oldRow.id));return;}
      if(rec){
        const item={...rec,projectId:rec.deal_id,dealId:rec.deal_id,assignedTo:rec.assigned_to,dueDate:rec.due_date,riskNote:rec.risk_note,sortOrder:rec.sort_order,workDetail:rec.work_detail||rec.description||rec.workDetail||""};
        setChecklist(cs=>eventType==='UPDATE'?cs.map(c=>c.id===rec.id?{...c,...item}:c):cs.find(c=>c.id===rec.id)?cs:[...cs,item]);
      }
    });
    const swatchSub = !wantsRT('swatches')?null:sbSubscribe('swatches-rt','swatches',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setSwatches(ss=>ss.filter(s=>s.id!==oldRow.id));return;}
      if(rec){
        const item={...rec,dealId:rec.deal_id,refLink:rec.ref_link,swatchLink:rec.swatch_link,estCost:Number(rec.est_cost)||0,addedBy:rec.added_by,clientApprovedBy:rec.client_approved_by,clientApprovedAt:rec.client_approved_at};
        setSwatches(ss=>eventType==='UPDATE'?ss.map(s=>s.id===rec.id?{...s,...item}:s):ss.find(s=>s.id===rec.id)?ss:[...ss,item]);
      }
    });
    const aeUpdateSub = !wantsRT('ae_updates')?null:sbSubscribe('ae-updates-rt','ae_updates',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setAeUpdates(us=>us.filter(u=>u.id!==oldRow.id));return;}
      if(rec){
        const item={id:rec.id,by:rec.by,role:rec.role,date:rec.date,time:rec.time,text:rec.text,dealId:rec.deal_id||null};
        setAeUpdates(us=>{
          if(eventType==='UPDATE') return us.map(u=>u.id===rec.id?item:u);
          if(us.find(u=>u.id===rec.id)) return us; // already have it (own post)
          return [item,...us].slice(0,300);
        });
      }
    });
    const auditSub = !wantsRT('audit_findings')?null:sbSubscribe('audit-findings-rt','audit_findings',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setAuditFindings(fs=>fs.filter(f=>f.id!==oldRow.id));return;}
      if(rec){
        const item=findingFromSb(rec);
        setAuditFindings(fs=>{
          if(eventType==='UPDATE') return fs.map(f=>f.id===rec.id?item:f);
          if(fs.find(f=>f.id===rec.id)) return fs;
          return [item,...fs];
        });
      }
    });
    const blockerSub = !wantsRT('project_blockers')?null:sbSubscribe('blockers-rt','project_blockers',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setBlockers(bs=>bs.filter(b=>b.id!==oldRow.id));return;}
      if(rec){
        const item={id:rec.id,dealId:rec.deal_id,title:rec.title,dept:rec.dept||"Operations",detail:rec.detail||"",flaggedBy:rec.flagged_by||"",status:rec.status||"Open",createdAt:rec.created_at||"",resolvedBy:rec.resolved_by||null,resolvedAt:rec.resolved_at||null};
        setBlockers(bs=>eventType==='UPDATE'?bs.map(b=>b.id===rec.id?{...b,...item}:b):bs.find(b=>b.id===rec.id)?bs:[item,...bs]);
      }
    });
    const invSub = !wantsRT('inventory_items')?null:sbSubscribe('inv-rt','inventory_items',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setInventory(iv=>iv.filter(i=>i.id!==oldRow.id));return;}
      if(rec){
        const item=invFromSb(rec);
        setInventory(iv=>eventType==='UPDATE'?iv.map(i=>i.id===rec.id?{...i,...item}:i):iv.find(i=>i.id===rec.id)?iv:[...iv,item]);
      }
    });
    const stockSub = !wantsRT('stock_movements')?null:sbSubscribe('stock-rt','stock_movements',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setStocklog(sl=>sl.filter(m=>m.id!==oldRow.id));return;}
      if(rec){
        const item=moveFromSb(rec);
        setStocklog(sl=>sl.find(m=>m.id===rec.id)?sl:[...sl,item]);
      }
    });
    const drfSub = !wantsRT('design_requests')?null:sbSubscribe('drfs-rt','design_requests',payload=>{
      const{eventType,new:rec,old:oldRow}=payload;
      if(eventType==='DELETE'){setDrfs(ds=>ds.filter(d=>d.id!==oldRow.id));return;}
      if(rec){
        const item=drfFromSb(rec);
        setDrfs(ds=>eventType==='UPDATE'?ds.map(d=>d.id===rec.id?{...d,...item}:d):ds.find(d=>d.id===rec.id)?ds:[item,...ds]);
      }
    });
    const pcardsTableSub = !wantsRT('project_cards')?null:sbSubscribe('pcards-table-rt','project_cards',payload=>{
      const{eventType,new:rec}=payload;
      if(eventType==='DELETE'||!rec) return;
      const dealId=rec.deal_id;
      if(!dealId) return;
      setPcards(ps=>{
        const existing=ps[dealId]||{};
        const m=(v,e)=>v!==undefined?v:e;
        return {...ps,[dealId]:{...existing,aeAssigned:m(rec.ae_assigned,existing.aeAssigned),pm1:m(rec.pm1,existing.pm1),pm2:m(rec.pm2,existing.pm2),pm3:m(rec.pm3,existing.pm3),designer:m(rec.designer,existing.designer),coordinator:m(rec.coordinator,existing.coordinator),commsLink:m(rec.comms_link,existing.commsLink),scopeNotes:m(rec.scope_notes,existing.scopeNotes),specialInstructions:m(rec.special_instructions,existing.specialInstructions)}};
      });
    });

    // Standalone BOQs had NO realtime subscription — they were fetched once at
    // boot only, so a BOQ created or edited by anyone else (or by you on another
    // device) never appeared until a hard refresh re-ran the boot fetch. Subscribe
    // and merge per id (server is authoritative for BOQs) so they stream in live.
    const rowToBoq=r=>({id:r.id,title:r.title||"",location:r.location||"",quotationNo:r.quotation_no||"",boqDate:r.boq_date||"",items:Array.isArray(r.items)?r.items:[],sections:Array.isArray(r.sections)?r.sections:[],vatEnabled:r.vat_enabled!==false,discount:r.discount||"",markupPct:r.markup_pct||"",createdBy:r.created_by||"",createdAt:r.created_at||"",updatedAt:r.updated_at||""});
    const boqSub = !wantsRT('standalone_boqs')?null:sbSubscribe('standalone-boqs-rt','standalone_boqs',payload=>{
      const{eventType,new:rec,old}=payload;
      setStandaloneBoqs(prev=>{
        let next;
        if(eventType==='DELETE'){const id=old?.id;if(!id)return prev;next=prev.filter(b=>b.id!==id);}
        else{ if(!rec||!rec.id) return prev; const rb=rowToBoq(rec); next=prev.some(b=>b.id===rb.id)?prev.map(b=>b.id===rb.id?rb:b):[...prev,rb]; }
        localStorage.setItem("gmdv5:standaloneBoqs",JSON.stringify(next));
        idbSetMany([["gmdv5:standaloneBoqs",next]]).catch(()=>{});
        return next;
      });
    });

    return ()=>{
      dealsSub?.unsubscribe?.();
      boqSub?.unsubscribe?.();
      pcardSub?.unsubscribe?.();
      billSub?.unsubscribe?.();
      addSub?.unsubscribe?.();
      actSub?.unsubscribe?.();
      joSub?.unsubscribe?.();
      prSub?.unsubscribe?.();
      ceReqSub?.unsubscribe?.();
      mreqSub?.unsubscribe?.();
      breqSub?.unsubscribe?.();
      paymentSub?.unsubscribe?.();
      expSub?.unsubscribe?.();
      swoSub?.unsubscribe?.();
      inflowSub?.unsubscribe?.();
      taskSub?.unsubscribe?.();
      checkSub?.unsubscribe?.();
      swatchSub?.unsubscribe?.();
      aeUpdateSub?.unsubscribe?.();
      auditSub?.unsubscribe?.();
      blockerSub?.unsubscribe?.();
      invSub?.unsubscribe?.();
      stockSub?.unsubscribe?.();
      drfSub?.unsubscribe?.();
      pcardsTableSub?.unsubscribe?.();
    };
  },[session?.userId,session?.role]);


  const toggleVvip=(name)=>{
    setVvip(prev=>{
      const next=new Set(prev);
      next.has(name)?next.delete(name):next.add(name);
      persist(KEYS.vvip,[...next]);
      if(isSupabaseReady()) sbUpsert('app_settings',{key:'vvip',value:[...next],updated_at:new Date().toISOString()},'key').catch(()=>{});
      return next;
    });
  };
  const upPrs      =useCallback(fn=>setPrs(p=>{const n=fn(p);persist(KEYS.prs,n);return n;}),[persist]);
  const upAddenda  =useCallback(fn=>setAddenda(p=>{const n=fn(p);persist(KEYS.addenda,n);return n;}),[persist]);
  const upBillings =useCallback(fn=>setBillings(p=>{const n=fn(p);persist(KEYS.billings,n);return n;}),[persist]);
  // Net receivable actually collectible for a deal — the sum of each non-cancelled
  // milestone's netReceivable (after output VAT and any EWT withheld). Collections
  // are recorded net, so a deal only reaches 'Paid' when amountPaid meets this, NOT
  // the gross `invoiced` (which under 2% EWT is never reachable → stuck 'Deposited').
  const dealNetDue=(dealId,msList,dealObj)=>(msList||[])
    .filter(b=>b.dealId===dealId&&b.status!=='Cancelled')
    .reduce((s,b)=>s+calcTax(Number(b.amount)||0,b.receiptType??b.receipt_type??dealObj?.receiptType??"OR",b.withholding??dealObj?.withholding??false).netReceivable,0);
  // Invoices are issued in centavos — a % split like 50% of ₱804,720.07 gives
  // ₱402,360.035, which no BIR invoice can carry and never foots back to the
  // contract. Round every entered amount to 2 decimals at the write boundary.
  const toCentavos=v=>v===""||v==null||isNaN(Number(v))?v:Math.round(Number(v)*100)/100;
  const addMilestone=(ms)=>{
    const rec={...ms,id:uid(),createdDate:today};
    if(rec.amount!==undefined) rec.amount=toCentavos(rec.amount);
    upBillings(bs=>[...bs,rec]);
    if(!isSupabaseReady()) toastEmit("⚠️ Billing saved on this device only — no server connection. It won't appear on other devices until reconnected.","warning",9000);
    else if(rec.dealId&&!isUUID(rec.dealId)) toastEmit("⚠️ This billing can't sync — the project has an invalid ID. Saved on this device only.","warning",9000);
    else sbSyncOne("billing_milestones",rec,toSbBilling);
    // Fix 4: sync deal.invoiced = sum of all non-cancelled milestones
    if(rec.dealId){
      const allMs=[...billings,rec].filter(b=>b.dealId===rec.dealId&&b.status!=='Cancelled');
      const totalInvoiced=allMs.reduce((s,b)=>s+Number(b.amount||0),0);
      upDeals(ds=>ds.map(d=>{
        if(d.id!==rec.dealId) return d;
        // Totals (invoiced / amount_paid / payment_status) are kept by the database
        // (trg_billing_totals_sync, migration 20261012010000); this only updates the screen.
        return {...d,invoiced:totalInvoiced};
      }));
    }
  };
  // Create a project's billing schedule from the Milestone Builder rows. The base
  // schedule bills the ORIGINAL contract only (originalValue when a legacy CO has
  // been rolled into deal.value — each CO bills as its own line). Idempotent: the
  // persistent billingGenerated flag and the in-memory check both refuse a second
  // schedule (the 3–5× duplicate-set bug). Invoice numbers come from the server
  // counter one by one, so two people setting up billing at the same time can't
  // both get INV-1535. The rows are also saved as the project's payment terms in
  // the legacy {dp,progress,final,retention} shape that progress claims, retention
  // release and the onboarding gate read.
  const createMilestoneSchedule=async(dealId,active,netDays,notes)=>{
    const _deal=deals.find(d=>d.id===dealId);
    if(!_deal) return false;
    const val=Number(_deal.originalValue!=null?_deal.originalValue:_deal.value)||0;
    if(val<=0){toastEmit("Set a contract value for this project first.","error");return false;}
    // VAT is decided by the BOQ (it sets receipt type). Never bill an undecided
    // project: its invoices would silently default to OR and re-tax later.
    if(!_deal.standbyPO&&!["OR","AR"].includes(_deal.receiptType)){toastEmit("VAT isn't decided yet — choose VAT 12% or No VAT in this project's BOQ (or, with no BOQ, Finance sets Project VAT in Billing) before generating billing.","error",9000);return false;}
    if(_deal.billingGenerated||billings.some(b=>b.dealId===dealId)){toastEmit("This project already has billing milestones. Edit those instead.","warning",7000);return false;}
    const sch=buildMilestoneSchedule(val,active);
    if(!sch.ok){toastEmit(sch.problems[0]?.msg||"The schedule doesn't add up to 100%.","error");return false;}
    const known=billings.map(b=>b.invoiceNo||"");
    const recs=[];
    for(const m of sch.active){
      const invoiceNo=await claimDocNumber("INV",[...known,...recs.map(r=>r.invoiceNo)]);
      recs.push({
        id:uid(),dealId,name:String(m.name).trim(),amount:m.amount,
        description:m.type==="Retention"||m.retention?`Retention (${m.pct}% of contract). Release condition: ${m.release}`:`${m.type} — ${m.pct}% of contract`,
        msType:m.type||undefined,plannedDate:m.plannedDate||"",
        invoiceNo,invoiceDate:today,dueDate:"",status:"Draft",
        receiptType:_deal.receiptType||null,withholding:_deal.withholding??null,
        createdBy:session?.name||role,deductions:[],createdDate:today,
      });
    }
    upBillings(bs=>[...bs,...recs]);
    recs.forEach(rec=>{
      if(!isSupabaseReady()) toastEmit("⚠️ Billing schedule saved on this device only — no server connection. It won't appear on other devices until reconnected.","warning",9000);
      else if(!isUUID(rec.dealId)) toastEmit("⚠️ This billing can't sync — the project has an invalid ID. Saved on this device only.","warning",9000);
      else sbSyncOne("billing_milestones",rec,toSbBilling);
    });
    const terms={...termsFromSchedule(sch.active,netDays),notes:notes||""};
    const totalInvoiced=recs.reduce((s,r)=>s+Number(r.amount||0),0);
    const firstMain=sch.active.find(r=>!r.retention);
    upDeals(ds=>ds.map(d=>{
      if(d.id!==dealId) return d;
      const nd={...d,invoiced:Math.round(totalInvoiced*100)/100,billingGenerated:true,paymentTerms:terms,
        paymentTermsText:d.paymentTermsText||scheduleSummary(terms),
        downpaymentPct:(d.downpaymentPct!=null&&d.downpaymentPct!=="")?d.downpaymentPct:(firstMain?firstMain.pct:d.downpaymentPct)};
      if(isSupabaseReady()){
        sbSyncOne("deals",nd,toSbDeal);
        sbUpdate('deals',dealId,{payment_terms_json:JSON.stringify(terms),updated_at:new Date().toISOString()}).catch(()=>{});
      }
      return nd;
    }));
    logActivity(dealId,"Billing Schedule Created",`${recs.length} milestones (${scheduleSummary(terms)}) — ${recs.map(r=>r.invoiceNo).join(", ")}`);
    toastEmit(`${recs.length} billing milestones created (${recs.map(r=>r.invoiceNo).join(", ")}).`,"success",7000);
    return true;
  };
  // Notify Jessica (Operations & Sales Admin) that a project was awarded and needs
  // its billing milestones set up. Billing schedules are no longer auto-generated —
  // this is the hand-off that prompts her to open Billing and use the
  // "Set Up Billing Milestones" dialogue for the project.
  const notifyBillingSetup=(dealId,client,contractVal,terms)=>{
    const termLine=terms
      ?`\n📄 Schedule on file: ${scheduleSummary(terms)}`
      :`\n📋 Enter the milestones from the signed C.E. in Billing ▸ Set Up Billing Milestones.`;
    const msg=
      `💳 <b>Billing Milestones Needed</b>\n`+
      `Jessica — a project was just awarded and needs its billing milestones set up.\n\n`+
      `Client: <b>${client||dealId}</b>\n`+
      (botSettings.hideValueInBots?"":`Contract Value: ₱${Number(contractVal||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\n`)+
      termLine+
      `\n\n👉 Open <b>Billing</b> and use “Set Up Billing Milestones” to create the schedule.`;
    // Finance is where billing setup lives; sales and management are copied for visibility.
    sendTelegramNotification("finance",msg);
    sendTelegramNotification("sales",msg);
    sendTelegramNotification("management",msg);
    logActivity(dealId,"Billing Setup Requested",`Jessica notified to set up billing milestones for ${client||"the awarded project"}.`,session?.name||role);
  };
  // Screen-only update after record/reverse_billing_deduction: the database has
  // already changed the amount and written the deduction row, so mirror that
  // locally without re-saving the milestone.
  const applyDeduction=(msId,row)=>{
    const ded=deductionFromSb(row);
    upBillings(bs=>bs.map(b=>{
      if(b.id!==msId) return b;
      const others=(b.deductions||[]).filter(x=>x.id!==ded.id);
      const amount=ded.reversedAt?Math.round((Number(b.amount||0)+ded.amount)*100)/100:ded.amountAfter;
      const d=deals.find(x=>x.id===b.dealId);
      const paid=(b.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+Number(p.amount||0),0);
      const net=calcTax(amount,b.receiptType??d?.receiptType??"OR",b.withholding??d?.withholding??false).netReceivable;
      const status=ded.reversedAt?(b.status==="Fully Paid"?"Partially Paid":b.status):(paid>0&&paid>=net-0.01?"Fully Paid":b.status);
      return{...b,amount,status,deductions:[...others,ded]};
    }));
  };
  const updateMilestone=(id,ch,audit)=>{
    if(ch.status==='Fully Paid'){
      const ms=billings.find(b=>b.id===id);
      const msDeal=ms?.dealId?deals.find(d=>d.id===ms.dealId):null;
      const msg=`✅ <b>Milestone Fully Paid</b>\nProject: <b>${msDeal?.contact||ms?.name||ms?.title||"—"}</b>\nClient: ${msDeal?.client||"—"}\nMilestone: ${ms?.name||ms?.title||"—"}\nAmount: ₱${Number(ms?.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\nUpdated by: ${session?.name||"Finance"}`;
      sendTelegramNotification("sales",msg);
      sendTelegramNotification("management",msg);
    }
    // A change that touches the payments array (inline edit, bounce, clear,
    // un-bounce) must ripple exactly like logBillingPayment/deleteBillingPayment:
    // recompute the milestone status, persist the payment rows to billing_payments
    // (the milestone row alone never carried them), and re-derive deal.amountPaid
    // from non-bounced payments. Previously these paths only rewrote the milestone
    // row, so edits/bounces silently reverted on reload and left deal collections
    // and status stale.
    const touchesPayments=Object.prototype.hasOwnProperty.call(ch,"payments");
    let savedMs=null;
    upBillings(bs=>bs.map(b=>{
      if(b.id!==id) return b;
      const n={...b,...ch};
      if(Object.prototype.hasOwnProperty.call(ch,"amount")) n.amount=toCentavos(n.amount);
      // auto-set invoiceDate and sentDate when status changes to "Sent to Client"
      if(ch.status==='Sent to Client'){
        if(!n.invoiceDate)n.invoiceDate=today;if(!n.sentDate)n.sentDate=today;
        // Due date follows the project's payment period, counted from the day
        // the invoice actually goes out (not the day the schedule was set up).
        const nd=deals.find(d=>d.id===n.dealId)?.paymentTerms?.netDays;
        if(!n.dueDate&&nd!=null&&nd!==""&&Number.isFinite(Number(nd))){const dt=new Date(String(n.sentDate).slice(0,10)+"T00:00:00Z");dt.setUTCDate(dt.getUTCDate()+Number(nd));n.dueDate=dt.toISOString().slice(0,10);}
      }
      // Recompute status from the non-bounced paid total unless the caller set it explicitly.
      if(touchesPayments&&ch.status===undefined){
        const od=deals.find(d=>d.id===n.dealId);
        const net=calcTax(Number(n.amount)||0,n.receiptType??od?.receiptType??"OR",n.withholding??od?.withholding??false).netReceivable;
        const paid=(n.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+Number(p.amount||0),0);
        // When payments drop to 0 (bounce/clear/edit-to-zero), revert a paid-derived
        // status to a neutral one instead of leaving a stale 'Partially/Fully Paid'.
        n.status=(paid>=net&&net>0)?'Fully Paid':paid>0?'Partially Paid':(['Fully Paid','Partially Paid'].includes(b.status)?'Sent to Client':b.status);
      }
      savedMs=n;
      if(isSupabaseReady()) sbSyncOne("billing_milestones",n,toSbBilling);
      return n;
    }));
    // Persist the (possibly edited/bounced) payment rows to their own table.
    if(touchesPayments&&isSupabaseReady()&&savedMs){
      (savedMs.payments||[]).forEach(p=>{if(isUUID(p.id)) sbSyncOne("billing_payments",{...p,milestoneId:id},toSbPayment);});
    }
    // Fix 4: sync deal.invoiced = sum of all non-cancelled milestones (+ amountPaid when payments changed)
    const ms=billings.find(b=>b.id===id);
    const dealId=ms?.dealId;
    if(dealId){
      const updatedBillings=billings.map(b=>b.id===id?(savedMs||{...b,...ch}):b);
      const dealMs=updatedBillings.filter(b=>b.dealId===dealId&&b.status!=='Cancelled');
      const invoiced=dealMs.reduce((s,b)=>s+Number(b.amount||0),0);
      const paid=touchesPayments?dealMs.reduce((s,b)=>s+(b.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+Number(p.amount||0),0),0):null;
      upDeals(ds=>ds.map(d=>{
        if(d.id!==dealId) return d;
        const nd={...d,invoiced};
        if(touchesPayments){const refVal=dealNetDue(dealId,updatedBillings,d)||Number(d.value||0);nd.amountPaid=paid;nd.paymentStatus=paid>=refVal&&refVal>0?'Paid':paid>0?'Deposited':'Unpaid';}
        // Screen only — the database recomputes and stores the totals (trg_billing_totals_sync).
        return nd;
      }));
    }
    // Payment-mutation audit trail (edit / bounce / clear / restore). Deletes are
    // already archived via confirmFinancialDelete; edits previously left no trace.
    if(audit&&audit.action){
      const aMs=billings.find(b=>b.id===id);
      logActivity(aMs?.dealId||dealId,audit.action,audit.detail||"",session?.name||role);
    }
  };
  const deleteMilestone=async(id)=>{
    const ms=billings.find(b=>b.id===id);
    if(!ms) return;
    const dealId=ms.dealId;
    const deal=dealId?deals.find(d=>d.id===dealId):null;
    const pays=ms.payments||[];
    const paidTotal=pays.filter(p=>!p.bounced).reduce((s,p)=>s+Number(p.amount||0),0);
    // billing_payments cascade-delete when the milestone is removed, so ALWAYS
    // archive the milestone AND its payments first (restorable) and require a
    // reason — otherwise recorded collections vanish with no trail.
    const reason=(await uiPrompt(`Delete milestone "${ms.name||ms.title||"—"}"${paidTotal>0?`\n\n⚠️ This milestone has ${pays.length} recorded payment${pays.length!==1?"s":""} totalling ₱${paidTotal.toLocaleString("en-PH")} — they will be archived and removed too.`:""}\n\nIt will be archived in Finance ▸ Audit Trail and can be restored.\nReason (required):`,""));
    if(reason===null) return;                                                    // cancelled
    if(!reason.trim()){ toastEmit("A reason is required to delete a milestone.","error",5000); return; }
    const why=reason.trim();
    // Archive milestone + each of its payments before removal.
    await archiveFinancial("billing_milestones",toSbBilling(ms),ms.id,why);
    for(const p of pays) await archiveFinancial("billing_payments",toSbPayment({...p,milestoneId:ms.id}),p.id,why);
    upBillings(bs=>bs.filter(b=>b.id!==id));
    if(dealId){
      const remaining=billings.filter(b=>b.dealId===dealId&&b.id!==id&&b.status!=='Cancelled');
      const total=remaining.reduce((s,b)=>s+Number(b.amount||0),0);
      // Recompute deal.amountPaid from surviving payments — the old code left it
      // stale, overstating "Collected" after a paid milestone was deleted.
      const newPaid=remaining.reduce((s,b)=>(b.payments||[]).filter(p=>!p.bounced).reduce((ss,p)=>ss+Number(p.amount||0),s),0);
      const refVal=dealNetDue(dealId,remaining,deal)||Number(total||deal?.value||0);
      const newStatus=newPaid>=refVal&&refVal>0?'Paid':newPaid>0?'Deposited':'Unpaid';
      upDeals(ds=>ds.map(d=>{
        if(d.id!==dealId) return d;
        // Screen only — the database recomputes and stores the totals (trg_billing_totals_sync).
        return {...d,invoiced:total,amountPaid:newPaid,paymentStatus:newStatus};
      }));
    }
    if(isSupabaseReady()){
      sbDeleteWhere('billing_payments','milestone_id',id);
      sbDelete('billing_milestones',id).catch(()=>{});
    }
    logActivity(dealId,"Milestone Deleted",`${ms.name||ms.title||"Milestone"} removed — ${why}`,session?.name||role);
    toastEmit("🗑 Milestone deleted and archived to Audit Trail.","success",5000);
  };
  // Delete an entire project's billing schedule — every milestone and its
  // payments — in one shot, then zero out the deal's billed/collected totals.
  // Prompts once for a required reason; each milestone and payment is archived
  // to Finance ▸ Audit Trail (restorable) before removal.
  const deleteProjectBilling=async(dealId)=>{
    const ms=billings.filter(b=>b.dealId===dealId);
    if(!ms.length) return;
    const deal=deals.find(d=>d.id===dealId);
    const reason=(await uiPrompt(`Delete the ENTIRE billing schedule for ${deal?.client||"this project"} — all ${ms.length} milestone${ms.length!==1?"s":""} and their recorded payments?\n\nEverything will be archived in Finance ▸ Audit Trail and can be restored.\nReason (required):`,""));
    if(reason===null) return;                                                    // cancelled
    if(!reason.trim()){ toastEmit("A reason is required to delete billing.","error",5000); return; }
    const why=reason.trim();
    // Archive every milestone + its payments before removing them.
    for(const m of ms){
      await archiveFinancial("billing_milestones",toSbBilling(m),m.id,why);
      for(const p of (m.payments||[])) await archiveFinancial("billing_payments",toSbPayment({...p,milestoneId:m.id}),p.id,why);
    }
    upBillings(bs=>bs.filter(b=>b.dealId!==dealId));
    upDeals(ds=>ds.map(d=>{
      if(d.id!==dealId) return d;
      // Screen only — the database zeroes the totals once the milestones are gone (trg_billing_totals_sync).
      return {...d,invoiced:0,amountPaid:0};
    }));
    if(isSupabaseReady()){
      ms.forEach(m=>{
        if(!isUUID(m.id)) return;
        sbDeleteWhere('billing_payments','milestone_id',m.id);
        sbDelete('billing_milestones',m.id).catch(()=>{});
      });
    }
    logActivity(dealId,"Billing Deleted",`All ${ms.length} milestone${ms.length!==1?"s":""} removed — ${why}`,session?.name||role);
    toastEmit("🗑 Billing deleted and archived to Audit Trail.","success",5000);
  };
  const logBillingPayment=(msId,payment)=>{
    const payId=uid();
    const milestone=billings.find(b=>b.id===msId);
    const dealId=milestone?.dealId;
    const payDeal=dealId?deals.find(d=>d.id===dealId):null;
    if(!isSupabaseReady()) toastEmit("⚠️ Collection saved on this device only — no server connection. It won't appear on other devices until reconnected.","warning",9000);
    const msTx=calcTax(milestone?.amount||0,milestone?.receiptType??milestone?.receipt_type??payDeal?.receiptType??"OR",milestone?.withholding??payDeal?.withholding??false);
    const totalPaidAfter=(milestone?.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0)+Number(payment.amount||0);
    const isFullyPaid=totalPaidAfter>=msTx.netReceivable;
    // Where the money landed: resolve the stored bank code (e.g. "bpi") to its
    // short name, then append the method (Bank Transfer / Cheque / Cash…).
    const payBankCode=payment.bank??payment.bank_id;
    const payBankRow=(BANKS||[]).find(x=>x.id===payBankCode||x.short===payBankCode||x.name===payBankCode);
    const payBankLabel=payBankCode==="cash"?"Cash":payBankRow?payBankRow.short:(payBankCode||"—");
    const payMethod=payment.method||payment.payment_method||"";
    const depositedTo=`${payBankLabel}${payMethod?` · ${payMethod}`:""}`;
    // "Credited" = value date (when funds were actually available); fall back to
    // the date received, then today.
    const creditedOn=payment.valueDate||payment.value_date||payment.date||today;
    const payMsg=`💵 <b>Payment Received</b>\nProject: <b>${payDeal?.contact||milestone?.name||milestone?.title||"—"}</b>\nClient: ${payDeal?.client||"—"}\nDeposited to: ${depositedTo}\nAmount: ₱${Number(payment.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\nCredited: ${creditedOn}\nRef: ${payment.refNo||payment.ref_no||"—"}\nRecorded by: ${payment.recordedBy||session?.name||"Finance"}${isFullyPaid?"\n✅ Milestone fully paid!":""}`;
    if(isOffsetPayment(payment)){
      // No money moved — say so, and tell Financial Control as well.
      const offMsg=`🔁 <b>Invoice Settled by Offset / Credit Note — no cash</b>\nProject: <b>${payDeal?.contact||milestone?.name||"—"}</b>\nClient: ${payDeal?.client||"—"}\nInvoice: ${milestone?.invoiceNo||milestone?.name||"—"}\nAmount: ₱${Number(payment.amount||0).toLocaleString("en-PH",{maximumFractionDigits:2})}\nCredit note / agreement: ${payment.refNo||"—"}\nWhat was offset: ${payment.note||"—"}\nRecorded by: ${payment.recordedBy||session?.name||"Manager"}${isFullyPaid?"\n✅ Milestone settled in full":""}`;
      sendTelegramNotification("management",offMsg);
      sendTelegramNotification("financialcontrol",offMsg);
      if(dealId) logActivity(dealId,"Settled by Offset",`₱${Number(payment.amount||0).toLocaleString("en-PH",{maximumFractionDigits:2})} on ${milestone?.name||"milestone"} · ${payment.refNo||""} · ${payment.note||""}`,payment.recordedBy||session?.name);
    }else{
      sendTelegramNotification("sales",payMsg);
      sendTelegramNotification("management",payMsg);
      if(dealId) logActivity(dealId,"Payment Received",`₱${Number(payment.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})} on ${milestone?.name||"milestone"}${payment.refNo?` · Ref: ${payment.refNo}`:""}`,payment.recordedBy||session?.name);
    }
    upBillings(bs=>bs.map(b=>{
      if(b.id!==msId) return b;
      const payments=[...(b.payments||[]),{...payment,id:payId,date:payment.date||today}];
      const totalPaid=payments.reduce((s,p)=>s+Number(p.amount||0),0);
      const bTx=calcTax(b.amount||0,b.receiptType??b.receipt_type??payDeal?.receiptType??"OR",b.withholding??payDeal?.withholding??false);
      const status=totalPaid>=bTx.netReceivable?'Fully Paid':totalPaid>0?'Partially Paid':b.status;
      if(isSupabaseReady()){
        sbUpsert("billing_payments",toSbPayment({...payment,id:payId,milestoneId:msId}),"id")
          .catch(e=>{console.error("billing_payments sync:",e.message);toastEmit("⚠️ Payment saved locally but NOT synced to server — do not close this tab!","warning",9000);});
        sbUpdate('billing_milestones',msId,{status,updated_at:new Date().toISOString()}).catch(e=>{toastEmit("⚠️ Payment status not synced — do not close this tab!","warning",9000);console.error("billing sync:",e);});
      }
      return{...b,payments,status};
    }));
    // Sync deal.amountPaid so Finance KPIs reflect billing collections.
    // Recompute from ALL surviving non-bounced payments (mirroring
    // deleteBillingPayment) rather than incrementing a possibly-stale base —
    // incrementing drifts after bounces, edits, or duplicate-milestone cleanup.
    if(dealId){
      const d0=deals.find(d=>d.id===dealId);
      const newPaid=billings
        .filter(b=>b.dealId===dealId&&b.status!=='Cancelled')
        .reduce((s,b)=>{
          const ps=b.id===msId?[...(b.payments||[]),{...payment,id:payId}]:(b.payments||[]);
          return ps.filter(p=>!p.bounced).reduce((ss,p)=>ss+Number(p.amount||0),s);
        },0);
      const refVal=dealNetDue(dealId,billings,d0)||Number(d0?.value||0);
      const newStatus=(newPaid>=refVal&&refVal>0)?'Paid':newPaid>0?'Deposited':'Unpaid';
      // Screen only — the database recomputes and stores the totals (trg_billing_totals_sync).
      upDeals(ds=>ds.map(d=>d.id===dealId?{...d,amountPaid:newPaid,paymentStatus:newStatus}:d));
    }
    // NOTE: we deliberately do NOT inject this collection into the daily cash
    // position here. The Daily Cash Position derives collections directly from
    // billing payments (counting each on its clearance date), so the payment
    // record is the single source of truth — no hidden bank-balance write to
    // keep in sync, and deleting a payment reverses automatically.
  };
  const deleteBillingPayment=async(msId,payId)=>{
    const milestone=billings.find(b=>b.id===msId);
    const payment=milestone?.payments?.find(p=>p.id===payId);
    if(!payment) return;
    if(!await confirmFinancialDelete("billing_payments",{...payment,milestoneId:msId,dealId:milestone.dealId}))return;
    const dealId=milestone.dealId;
    const delDeal=dealId?deals.find(d=>d.id===dealId):null;
    upBillings(bs=>bs.map(b=>{
      if(b.id!==msId) return b;
      const payments=(b.payments||[]).filter(p=>p.id!==payId);
      const totalPaid=payments.reduce((s,p)=>s+Number(p.amount||0),0);
      const bTx=calcTax(b.amount||0,b.receiptType??b.receipt_type??delDeal?.receiptType??"OR",b.withholding??delDeal?.withholding??false);
      // 'Sent to Client' (a valid BILLING_STATUS) when payments drop to zero —
      // 'Unpaid' is not a valid status (no badge, not selectable in the dropdown).
      const status=totalPaid>=bTx.netReceivable?'Fully Paid':totalPaid>0?'Partially Paid':'Sent to Client';
      if(isSupabaseReady()){
        sbDelete('billing_payments',payId).catch(()=>{});
        sbUpdate('billing_milestones',msId,{status,updated_at:new Date().toISOString()}).catch(()=>{});
      }
      return{...b,payments,status};
    }));
    // Recompute deal.amountPaid from all remaining payments across all milestones
    if(dealId){
      const updatedBillings=billings.map(b=>{
        if(b.id!==msId) return b;
        return{...b,payments:(b.payments||[]).filter(p=>p.id!==payId)};
      });
      const newPaid=updatedBillings
        .filter(b=>b.dealId===dealId&&b.status!=='Cancelled')
        .reduce((s,b)=>(b.payments||[]).filter(p=>!p.bounced).reduce((ss,p)=>ss+Number(p.amount||0),s),0);
      const d0=deals.find(d=>d.id===dealId);
      const refVal=dealNetDue(dealId,updatedBillings,d0)||Number(d0?.value||0);
      const newStatus=(newPaid>=refVal&&refVal>0)?'Paid':newPaid>0?'Deposited':'Unpaid';
      // Screen only — the database recomputes and stores the totals (trg_billing_totals_sync).
      upDeals(ds=>ds.map(d=>d.id===dealId?{...d,amountPaid:newPaid,paymentStatus:newStatus}:d));
    }
    // No cash-position reversal needed: collections are no longer injected into
    // the daily position (see logBillingPayment). The Daily Cash Position reads
    // billing payments directly, so removing the payment here is the reversal.
  };
  // Auto invoice number generator
  const nextCENo=()=>{
    const nums=(deals||[]).map(d=>d.ceNo).filter(Boolean)
      .map(n=>{const m=n.match(/(\d+)$/);return m?parseInt(m[1]):0;});
    const next=(nums.length?Math.max(...nums):0)+1;
    const yr=new Date().getFullYear();
    return`CE-${yr}-${String(next).padStart(3,"0")}`;
  };
  const addAddendum2=(adm)=>{
    // Guard: warn if a same-value change order already exists on this parent as a
    // linked child deal or another addendum (prevents double-counting).
    const coDup=findCrossMechanismCO({parentId:adm.dealId,value:adm.value,deals,addenda,excludeAddendumId:adm.id});
    if(coDup && !window.confirm(coDup+"\n\nLog this addendum anyway?")) return;
    const rec={...adm,id:uid(),createdDate:today,status:"Discovered"};
    upAddenda(as=>[rec,...as]);
    if(isSupabaseReady()) sbSyncOne("addenda",rec,toSbAddendum);
    const deal=deals.find(d=>d.id===adm.dealId);
    const msg=`⚠️ <b>Scope Change Discovered</b>\n${adm.title||"?"}\nProject: ${deal?.client||adm.dealId||"?"}${botSettings.hideValueInBots?"":"\nValue: ₱"+Number(adm.value||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\nBy: ${adm.discoveredBy||"?"}\n\n📌 Sales must quote this to client before proceeding.`;
    sendTelegramNotification("sales",msg);
    sendTelegramNotification("management",msg);
  };
  // Once a change order is client-approved (or further along), its value is part
  // of the contract — keep the parent deal's contract value in step automatically.
  const ADDENDUM_ROLLED=s=>["Approved","Billed","Collected"].includes(s);
  // Apply a delta to a deal's contract value (and remember the pre-addenda base
  // for transparency). Derives nothing from flags, so it can't double-count.
  const rollDealContract=(dealId,delta,addendum)=>{
    if(!dealId||!delta) return;
    upDeals(ds=>ds.map(d=>{
      if(d.id!==dealId) return d;
      const base=d.originalValue!=null?d.originalValue:Number(d.value)||0;
      const nd={...d,originalValue:base,value:Math.round((Number(d.value||0)+delta)*100)/100};
      if(isSupabaseReady()) sbSyncOne("deals",nd,toSbDeal);
      return nd;
    }));
    logActivity(dealId,"Contract Value Updated",`${delta>0?"+":"−"}₱${Number(Math.abs(delta)).toLocaleString("en-PH",{maximumFractionDigits:2})} from change order "${addendum?.title||""}" → revised contract value`);
  };
  // Once a change order is APPROVED it carries its own billing milestone so
  // Finance can raise the claim for the delta directly — as a SEPARATE line from
  // the original contract's schedule, never blended into it (the base schedule
  // bills the original contract only; see createMilestoneSchedule). Deductive
  // change orders create a negative (credit) milestone. The milestone's tax basis
  // is INHERITED from the parent contract (receipt type + withholding) so a CO is
  // never taxed on a different basis than its project.
  const syncCoBilling=(co,shouldExist)=>{
    const dealId=co.dealId||co.projectId;
    // coId is never persisted (billing_milestones has no co_id column), so after
    // any reload the link is gone. Fall back to the parent + milestone name the
    // CO created — otherwise un-approving/deleting the CO left its milestone
    // behind (orphan), and re-approving created a second one (double billing).
    const existing=billings.find(b=>b.coId===co.id)||billings.find(b=>b.dealId===dealId&&!b.coId&&coMilestoneMatches(b,co));
    if(shouldExist&&!existing&&dealId){
      // Never bill the same scope twice: if this change order is already an
      // approved linked addendum deal, it bills on its own project.
      const childDup=deals.find(d=>d.parentDealId===dealId&&isApprovedAddendumDeal(d)&&Math.abs(Math.abs(Number(d.value)||0)-Math.abs(coSignedValue(co)))<0.5);
      if(childDup){toastEmit(`Change order not added to billing — it's already billed on addendum project ${childDup.ceNo||childDup.contact||""}.`,"warning",9000);return;}
      const parentDeal=deals.find(d=>d.id===dealId);
      claimDocNumber("INV",billings.map(b=>b.invoiceNo||"")).then(invoiceNo=>addMilestone({name:`${CO_MILESTONE_PREFIX}${co.title||"Scope Change"}`,description:co.description||co.desc||"",amount:coSignedValue(co),dealId,coId:co.id,invoiceNo,invoiceDate:today,dueDate:"",status:"Draft",receiptType:parentDeal?.receiptType||co.receiptType||null,withholding:parentDeal?.withholding??co.withholding??null,createdBy:session?.name||role,deductions:[]}));
    }else if(!shouldExist&&existing){
      // Only a Draft is removed automatically — once it has been sent or paid,
      // silently deleting it would hide a real invoice. Flag it for Finance.
      if(existing.status!=="Draft"||(existing.payments||[]).length){toastEmit(`Change order milestone ${existing.invoiceNo||""} was already ${existing.status} — cancel or credit it in Billing.`,"warning",9000);return;}
      upBillings(bs=>bs.filter(b=>b.id!==existing.id));
      if(isSupabaseReady()) sbDelete('billing_milestones',existing.id).catch(()=>{});
    }
  };
  // Once a change order is client-approved, its scope line items (if any) flow
  // into the project BOQ as a tagged Change Order block — additive items add,
  // deductive items subtract — and are stripped back out if it's reversed.
  const syncCoBoq=(co,shouldExist)=>{
    const items=Array.isArray(co.scopeItems)?co.scopeItems:[];
    const dealId=co.dealId||co.projectId;
    if(!dealId||(!items.length&&shouldExist)) return;
    const sign=co.kind==="Deductive"?-1:1;
    upDeals(ds=>ds.map(d=>{
      if(d.id!==dealId) return d;
      const bd=d.boqData?{...d.boqData}:{items:[],sections:[]};
      const base=(bd.items||[]).filter(it=>it.coId!==co.id);
      if((bd.items||[]).length===base.length&&!shouldExist) return d; // nothing to strip
      let next=base;
      if(shouldExist&&items.length){
        const coItems=items.map(it=>{
          const qty=Number(it.qty)||0, rate=Number(it.rate!=null?it.rate:it.unitCost)||0;
          const total=Math.round(sign*Math.abs(qty*rate)*100)/100;
          return {_id:uid(),coId:co.id,section:it.section||"CO",subsection:`CO: ${co.title||""}`,description:it.description||it.desc||"",unit:it.unit||"lot",qty,baseCost:rate,unitCost:rate,total,remarks:it.remarks||(co.kind==="Deductive"?"Deductive change order":"Additive change order"),markup:0};
        });
        next=[...base,...coItems];
      }
      const nbd={...bd,items:next};
      if(isSupabaseReady()) sbUpdate('deals',dealId,{boq_data:nbd}).catch(()=>{});
      return {...d,boqData:nbd};
    }));
  };
  const updateAddendum=(id,ch)=>{
    upAddenda(as=>as.map(a=>{
      if(a.id!==id) return a;
      const n={...a,...ch};
      // Roll the change-order value in/out of the parent contract based on the
      // status transition (and any value/kind edit). Uses persisted status only.
      // Values are signed by kind so a deductive CO subtracts from the contract.
      const oldVal=coSignedValue(a), newVal=coSignedValue(n);
      const wasIn=ADDENDUM_ROLLED(a.status), nowIn=ADDENDUM_ROLLED(n.status);
      // Stamp the awarded date the first time a CO becomes Approved — this is the
      // month its value is credited to the AE on the Sales Value report. Cleared
      // if it ever rolls back out (unapproved), so it re-stamps on re-approval.
      if(nowIn&&!n.awardedDate) n.awardedDate=today;
      else if(!nowIn&&n.awardedDate&&!ch.awardedDate) n.awardedDate=null;
      const delta=(nowIn?newVal:0)-(wasIn?oldVal:0);
      if(delta) rollDealContract(n.dealId||n.projectId,delta,n);
      // Scope items flow into the BOQ on approval; the CO's own billing milestone
      // is created on approval too (ADDENDUM_ROLLED = Approved/Billed/Collected) so
      // Finance can raise the claim immediately — not left until someone marks it
      // "Billed", which used to leave the delta unbilled and the contract short.
      if(wasIn!==nowIn||(nowIn&&oldVal!==newVal)) syncCoBoq(n,nowIn);
      syncCoBilling(n,ADDENDUM_ROLLED(n.status));
      if(isSupabaseReady()) sbSyncOne("addenda",n,toSbAddendum);
      if(ch.status==="Approved"||ch.clientApproved){
        const deal=deals.find(d=>d.id===(a.dealId||a.projectId));
        const costMsg=`⚠️ <b>Scope Change Approved</b>\nProject: <b>${deal?.client||"?"}</b>${deal?.ceNo?`\nCE: ${deal.ceNo}`:""}\nScope: ${a.title||"?"}\nCost Impact: ₱${Number(a.value||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\nApproved by: ${session?.name||"Ops"}\nRevised contract value updated automatically.\n\n💰 Finance team: please review cost impact and update billing milestones if applicable.`;
        sendTelegramNotification("finance",costMsg);
        sendTelegramNotification("management",costMsg);
        // Ops owns the added scope: tell them there's extra work and an updated
        // budget/BOQ to draw against, so an approved change order isn't only a
        // finance event.
        const opsMsg=`🛠️ <b>Additional Scope Approved</b>\nProject: <b>${deal?.client||"?"}</b>${deal?.ceNo?`\nCE: ${deal.ceNo}`:""}\nScope: ${a.title||"?"}${a.kind==="Deductive"?"\n(Deductive — scope removed)":""}\nBudget Impact: ₱${Number(a.value||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\nContract value & BOQ updated automatically.\n\n🔧 Ops: additional work is in scope — plan/procure against the revised project budget.`;
        sendTelegramNotification("ops",opsMsg);
      }
      return n;
    }));
  };
  const deleteAddendum=(id)=>{
    const adm=addenda.find(a=>a.id===id);
    if(adm&&role!=="Manager"&&adm.discoveredBy!==session?.name) return toastEmit("Only Managers or the creator can delete scope changes.","error");
    // If this change order was already rolled into the contract, take it back
    // out (signed by kind), and strip any BOQ items / billing milestone it added.
    if(adm&&ADDENDUM_ROLLED(adm.status)&&coSignedValue(adm)) rollDealContract(adm.dealId||adm.projectId,-coSignedValue(adm),adm);
    if(adm){syncCoBoq(adm,false);syncCoBilling(adm,false);}
    upAddenda(as=>as.filter(a=>a.id!==id));
    if(isSupabaseReady()) sbDelete('addenda',id).catch(()=>{});
  };
  const updateJO     =(id,changes)=>{upJos(js=>js.map(j=>{if(j.id!==id)return j;const u={...j,...changes};if(isSupabaseReady())sbSyncOne("job_orders",u,toSbJO);return u;}));}
  const delMR        =(id)=>{
    const mr=mreqs.find(m=>m.id===id);
    if(!mr) return;
    const isOwner=mr.requestedBy&&session?.name&&mr.requestedBy===session.name;
    if(role!=="Manager"&&!isProcurementRole(role)&&!isOwner) return toastEmit("Only Managers, Procurement, or the submitter can delete material requests.","error");
    upMreqs(ms=>ms.filter(m=>m.id!==id));if(isSupabaseReady()) sbDelete('material_requests',id).catch(()=>{});
  };
  const delBR        =(id)=>{
    const br=breqs.find(b=>b.id===id);
    if(br&&role!=="Manager"&&br.requestedBy!==session?.name) return toastEmit("Only Managers or the submitter can delete budget requests.","error");
    upBreqs(bs=>bs.filter(b=>b.id!==id));if(isSupabaseReady()) sbDelete('budget_requests',id).catch(()=>{});
  };
  const delPcard     =(id)=>{upPcards(ps=>{const n={...ps};delete n[id];return n;});if(isSupabaseReady()) sbDeleteWhere('project_cards','deal_id',id);};
  const delBudget    =(id)=>{upBudgets(bs=>{const n={...bs};delete n[id];return n;});if(isSupabaseReady()) sbDeleteWhere('project_budgets','deal_id',id);};
  const delChecklist =async(id)=>{if(!await guardWrite('delete','checklists','a checklist item')) return;upChecklist(cs=>cs.filter(c=>c.id!==id));if(isSupabaseReady()) sbDelete('checklists',id).catch(()=>{});};
  const upMreqs    =useCallback(fn=>setMreqs(p=>{const n=fn(p);persist(KEYS.mreqs,n);return n;}),[persist]);
  const upBreqs    =useCallback(fn=>setBreqs(p=>{const n=fn(p);persist(KEYS.breqs,n);return n;}),[persist]);
  const addMR=(mr)=>{
    const rec={...mr,id:uid(),createdDate:today};
    upMreqs(ms=>[rec,...ms]);
    if(isSupabaseReady()) sbSyncOne("material_requests",rec,toSbMR);
    const deal=deals.find(d=>d.id===mr.projectId);
    sendTelegramNotification("procurement",`🔧 <b>New Material Request</b>\n${mr.itemName||"?"}\nProject: ${deal?.client||mr.projectId||"?"}\nQty: ${mr.qty||"?"} ${mr.unit||""}\nUrgency: ${mr.urgency||"Normal"}\nBy: ${mr.requestedBy||"?"}`);
  };
  const updateMR=(id,ch)=>{
    upMreqs(ms=>ms.map(m=>{
      if(m.id!==id) return m;
      const n={...m,...ch};
      if(isSupabaseReady()) sbSyncOne("material_requests",n,toSbMR);
      if(ch.status==="Approved"){
        const deal=deals.find(d=>d.id===(m.projectId||m.dealId));
        sendTelegramNotification("procurement",`✅ <b>MR Approved</b>\n${m.itemName||"?"}\nProject: ${deal?.client||m.projectId||"?"}\nApproved by: ${session?.name||"Manager"}\n\n🛒 Proceed to create a PO for this item in Procurement.`);
        sendTelegramNotification("ops",`✅ <b>MR Approved</b>\n${m.itemName||"?"}\nProject: ${deal?.client||m.projectId||"?"}\nApproved by: ${session?.name||"Manager"}`);
        // P6: log MR approval to project activity
        if(m.projectId||m.dealId) logActivity(m.projectId||m.dealId,"MR Approved",`Material Request approved: ${m.itemName||"?"} × ${m.qty||"?"} ${m.unit||""} (${m.urgency||"Normal"})`,session?.name);
        // P12: guard against race condition — only create draft PO if one doesn't already exist for this MR
        const alreadyHasPO=prs.some(p=>p.fromMrId===m.id);
        if(!alreadyHasPO){
          const draftPR={id:uid(),itemName:m.itemName||"",item:m.itemName||"",qty:Number(m.qty)||1,unit:m.unit||"pcs",estUnitCost:Number(m.estUnitCost||m.estimatedCost)||0,actUnitCost:0,category:"Materials",budgetCategory:m.budgetCategory||"Materials",projectId:m.projectId||m.dealId||null,dealId:m.dealId||m.projectId||null,supplier:"",status:"Draft",urgency:m.urgency||"Normal",requestedBy:m.requestedBy||m.submittedBy||"",approvedBy:"",createdDate:today,createdBy:session?.name||"",poNumber:"",fromMrId:m.id,notes:`Auto-created from approved MR: ${m.itemName||"?"}`};
          upPrs(ps=>[draftPR,...ps]);
          if(isSupabaseReady()) sbSyncOne("purchase_requests",draftPR,toSbPR);
        }
      }
      return n;
    }));
  };
  const addBR=(br)=>{
    const rec={...br,id:uid(),createdDate:today};
    upBreqs(bs=>[rec,...bs]);
    if(isSupabaseReady()) sbSyncOne("budget_requests",rec,toSbBR);
    const deal=deals.find(d=>d.id===br.projectId);
    sendTelegramNotification("management",`💰 <b>Budget Request Submitted</b>\n${br.title||br.purpose||"?"}\nProject: ${deal?.client||br.projectId||"?"}${botSettings.hideValueInBots?"":"\nAmount: ₱"+Number(br.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})}\nCategory: ${br.category||"—"}\nBy: ${br.requestedBy||"?"}`);
  };
  const updateBR=(id,ch)=>{
    if(ch.status==="Approved"){
      const br=breqs.find(b=>b.id===id);
      if(br){
        const b=budgets[br.projectId];
        const budgetCeiling=b?((Number(b.Materials)||0)+(Number(b.Labor)||0)+(Number(b.Overhead)||0)+(Number(b.Subcon)||0)):0;
        if(budgetCeiling>0){
          const totalApproved=breqs.filter(x=>x.id!==id&&x.projectId===br.projectId&&x.status==="Approved").reduce((s,x)=>s+Number(x.amount||0),0)+Number(br.amount||0);
          if(totalApproved>budgetCeiling){
            toastEmit&&toastEmit(`⚠️ Approved BRs (₱${totalApproved.toLocaleString("en-PH",{maximumFractionDigits:0})}) exceed project budget ceiling of ₱${budgetCeiling.toLocaleString("en-PH",{maximumFractionDigits:0})}.`,"warn");
          }
        }
      }
    }
    if(ch.status==="Approved"){
      const br=breqs.find(b=>b.id===id);
      if(br?.projectId) logActivity(br.projectId,"BR Approved",`Budget Request approved: ${br.title||br.purpose||"?"} — ₱${Number(br.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})}`,session?.name);
    }
    upBreqs(bs=>bs.map(b=>{
      if(b.id!==id) return b;
      const n={...b,...ch};
      if(isSupabaseReady()) sbSyncOne("budget_requests",n,toSbBR);
      return n;
    }));
  };
  const upBudgets  =useCallback(fn=>setBudgets(p=>{const n=fn(p);persist(KEYS.budgets,n);return n;}),[persist]);
  // onlyIfMissing: the 🏆 award's auto "starting budget". It must never replace
  // a budget QS already built (re-award, or QS got there first), and Sales —
  // who award deals — may create a budget row but not edit one, so it is a
  // plain create-if-absent, not an upsert (which RLS refused for Sales).
  const saveBudget=async(dealId,budget,{onlyIfMissing=false}={})=>{
    const saved={...budget,savedAt:new Date().toISOString()};
    upBudgets(bs=>(onlyIfMissing&&bs[dealId])?bs:({...bs,[dealId]:saved}));
    if(!isSupabaseReady()) return true;
    if(onlyIfMissing) return await sbInsertIfMissing("project_budgets",toSbBudget(dealId,saved));
    return await sbUpsert("project_budgets",toSbBudget(dealId,saved),"deal_id");
  };
  const addPR=(pr,{silent=false}={})=>{
    const rec={...pr,id:uid(),createdDate:today};
    upPrs(ps=>[rec,...ps]);
    if(isSupabaseReady()) sbSyncOne("purchase_requests",rec,toSbPR);
    if(!silent){
      const deal=deals.find(d=>d.id===(pr.projectId||pr.dealId));
      const msg=`🛒 <b>New Purchase Request</b>\n${pr.itemName||pr.item||"?"}\nProject: ${deal?.client||pr.dealId||"?"}\nQty: ${pr.qty||"?"} ${pr.unit||""}\nCategory: ${pr.category||"—"}\nUrgency: ${pr.urgency||"Normal"}\nBy: ${pr.requestedBy||session?.name||"?"}`;
      sendTelegramNotification("procurement",msg);
      sendTelegramNotification("management",msg);
    }
  };
  // Bulk PO approval (PO Approvals panel). Issues every Pending Approval line of
  // the given POs in one write, raises each PO's payable, and sends ONE Telegram
  // summary instead of one message per line (updatePR's per-line notice).
  // Authority is re-checked per PO with canApprovePO.
  const approvePOs=async(poNos)=>{
    const want=new Set(poNos||[]);
    const me=session?.name||"";
    const pending=prs.filter(p=>want.has(p.poNumber)&&p.status==="Pending Approval"&&canApprovePO(role,me,p.requestedBy));
    // Down payment gate: a PO with any line on a deal that has no payment (and
    // no Manager waiver) is skipped whole. The database rejects those writes,
    // and one bad row would fail its entire 200-row batch below.
    const dpBlockedNos=new Map();
    pending.forEach(p=>{const d=deals.find(x=>x.id===(p.projectId||p.dealId));if(d&&!dealDpClear(d,deals))dpBlockedNos.set(p.poNumber,d.ceNo||d.client||"?");});
    if(dpBlockedNos.size) toastEmit(`Not approved — no down payment yet: ${[...dpBlockedNos].map(([no,ce])=>`${no} (${ce})`).join(", ")}. A Manager must waive it on the deal first.`,"error",10000);
    const lines=pending.filter(p=>!dpBlockedNos.has(p.poNumber));
    if(!lines.length){if(!dpBlockedNos.size)toastEmit("Nothing to approve — those POs are no longer pending or need another approver.","error");return false;}
    const ids=new Set(lines.map(p=>p.id));
    const next=prs.map(p=>ids.has(p.id)?{...p,status:"PO Issued",approvedBy:me,approvedAt:today}:p);
    upPrs(()=>next);
    let ok=true;
    if(isSupabaseReady()){
      // Chunked so a large catch-up batch can't hit the request timeout.
      const rows=next.filter(p=>ids.has(p.id)&&hasValidUUIDs({id:p.id})).map(toSbPR);
      for(let i=0;i<rows.length;i+=200){
        if(!(await sbUpsert("purchase_requests",rows.slice(i,i+200),"id").catch(()=>false))) ok=false;
      }
      // A refused save (e.g. the server's approver check) must not leave the
      // POs shown as issued, raise supplier bills or announce an approval.
      if(!ok){
        upPrs(cur=>cur.map(p=>ids.has(p.id)?(prs.find(o=>o.id===p.id)||p):p));
        toastEmit("Not approved: the server refused it. Only a Manager or the Procurement Manager can approve POs.","error",9000);
        return false;
      }
    }
    const approvedNos=[...new Set(lines.map(p=>p.poNumber))];
    approvedNos.forEach(no=>{
      syncPoPayable(no,next);
      const first=lines.find(p=>p.poNumber===no);
      if(first&&(first.projectId||first.dealId)) logActivity(first.projectId||first.dealId,"PO Issued",`PO ${no} approved by ${me} (${first.supplier||"no supplier"})`);
    });
    sendTelegramNotification("procurement",`✅ <b>${approvedNos.length} PO${approvedNos.length>1?"s":""} approved</b> by ${me}\n${approvedNos.slice(0,15).join(", ")}${approvedNos.length>15?` … +${approvedNos.length-15} more`:""}`);
    toastEmit(`✅ ${approvedNos.length} PO${approvedNos.length>1?"s":""} approved (${lines.length} lines) — supplier bills raised.`,"success");
    return ok!==false;
  };
  const updatePR=(id,changes)=>{
    const pr=prs.find(p=>p.id===id);
    const deal=deals.find(d=>d.id===(pr?.projectId||pr?.dealId));
    if(changes.status==="PO Issued"&&changes.approvedBy){
      sendTelegramNotification("procurement",`✅ <b>PO Approved</b>\n${pr?.itemName||"?"}\nProject: ${deal?.client||"GMD Stock"}\nQty: ${pr?.qty||"?"} ${pr?.unit||""}\nSupplier: ${pr?.supplier||"—"}\nApproved by: ${changes.approvedBy} · ${today}`);
      // P7: log PO issued to project activity
      if(pr?.projectId||pr?.dealId) logActivity(pr.projectId||pr.dealId,"PO Issued",`PO issued for ${pr.itemName||"?"} × ${pr.qty||"?"} ${pr.unit||""} from ${pr.supplier||"(no supplier)"} — PO# ${changes.poNumber||pr?.poNumber||"—"}`,changes.approvedBy||session?.name);
    }
    // P9: stamp approvedAt when PO is issued
    if(changes.status==="PO Issued"&&!changes.approvedAt) changes={...changes,approvedAt:today};
    upPrs(ps=>ps.map(p=>{
      if(p.id!==id) return p;
      // P11: append delivery history entry when delivery status is set
      let extraChanges={};
      if((changes.status==="Partially Delivered"||changes.status==="Delivered")&&changes.qtyDelivered){
        const shipment={date:changes.deliveryDate||today,qty:Number(changes.qtyDelivered)||0,drNo:changes.drNo||changes.deliveryNote||"",recordedBy:session?.name||""};
        extraChanges={deliveryHistory:[...(p.deliveryHistory||[]),shipment]};
        // P8: log delivery to project activity
        if(p.projectId||p.dealId) logActivity(p.projectId||p.dealId,"Delivery Received",`${changes.status==="Delivered"?"Full":"Partial"} delivery: ${p.itemName||"?"} × ${changes.qtyDelivered} ${p.unit||""} from ${p.supplier||"(no supplier)"}${shipment.drNo?` · DR# ${shipment.drNo}`:""}`,session?.name);
      }
      const n={...p,...changes,...extraChanges};
      if(isSupabaseReady()&&hasValidUUIDs({id:n.id}))
        sbUpsert("purchase_requests",toSbPR(n),"id")
          .catch(e=>toastEmit(`PR sync failed: ${e?.message||"unknown error"} — saved locally, retry when online.`,"warn"));
      return n;
    }));
  };
  const deletePR   =(id)=>{
    const pr=prs.find(p=>p.id===id);
    if(pr&&role!=="Manager"&&!isProcurementRole(role)&&pr.createdBy!==session?.name) return toastEmit("Only Managers, Procurement, or the creator can delete purchase requests.","error");
    upPrs(ps=>ps.filter(p=>p.id!==id));
    if(isSupabaseReady()&&isUUID(id)){
      sbDelete('purchase_requests',id).catch(()=>{
        // Re-add if Supabase delete failed so the record is not lost
        if(pr) upPrs(ps=>[pr,...ps]);
        toastEmit("Delete failed — check your connection and try again.","error");
      });
    } else if(!isUUID(id)){
      // Non-UUID id was never in Supabase — local-only record, just remove from localStorage (already done via upPrs)
    }
  };
  const saveDayPos=(date,pos)=>{
    // One timestamp for the local copy AND the server row, so the sheet's
    // "updated elsewhere" check compares like with like after a refresh.
    const savedAt=pos.savedAt||new Date().toISOString();
    // A Manager changed a day that had already locked — tell management.
    const _last=Array.isArray(pos.audit)?pos.audit[pos.audit.length-1]:null;
    if(_last?.pastEdit&&_last.at===savedAt){
      sendTelegramNotification("management",`🔓 <b>Cash position edited after lock</b>\nDay: ${date}\nBy: ${_last.by||"—"}\nReason: ${_last.pastEdit.reason||"—"}`);
    }
    upCashPos(cp=>({...cp,[date]:{...pos,savedAt}}));
    if(isSupabaseReady()){
      const nb=(bank,key)=>Number(pos.banks?.[bank]?.[key])||0;
      const payload={
        date,
        bpi_beg:      nb("bpi","beg"),      bpi_book:      nb("bpi","book"),      bpi_end:      nb("bpi","end"),
        metrobank_beg:nb("metro","beg"),     metrobank_book:nb("metro","book"),    metrobank_end:nb("metro","end"),
        chinabank_beg:nb("china","beg"),     chinabank_book:nb("china","book"),    chinabank_end:nb("china","end"),
        bdo_beg:      nb("bdo","beg"),       bdo_book:      nb("bdo","book"),      bdo_end:      nb("bdo","end"),
        secbank_beg:  nb("security","beg"),  secbank_book:  nb("security","book"), secbank_end:  nb("security","end"),
        unionbank_beg:nb("union","beg"),     unionbank_book:nb("union","book"),    unionbank_end:nb("union","end"),
        manual_collections:  JSON.stringify(pos.collections?.manualCollections||[]),
        approved_payments:   JSON.stringify(pos.collections?.approvedPayments||[]),
        manual_disbursements:JSON.stringify(pos.disbursements?.manual||[]),
        floating_checks:     JSON.stringify(pos.floatingChecks||[]),
        audit:               JSON.stringify(pos.audit||[]),
        ytd_supplier_payable:Number(pos.ytd?.supplierPayable)||0,
        ytd_loans_payable:   Number(pos.ytd?.loansPayable)  ||0,
        notes:pos.notes||"",
        // No DB trigger bumps updated_at on UPDATE, so without this every row kept
        // its creation time forever and the server copy looked older than it was.
        updated_at:savedAt,
      };
      // Surface a rejected write — the sheet already shows "✓ Saved" from the local
      // copy, so a silent console.error here meant the day never reached the server.
      sbUpsert("cash_positions",payload,"date").catch(e=>{console.error("cash sync:",e.message);toastEmit(`Cash position ${date} did NOT save to the server: ${e?.message||"unknown error"} — it's only on this device. Tap 🔄 sync and save again.`,"error",12000);});
    }
  };
  const upDeals    =useCallback(fn=>setDeals(p=>{const n=fn(p);persist(KEYS.deals,n);return n;}),[persist]);
  // A Manager waives (reason given) or restores the down payment on a deal, so
  // POs and subcon work orders can be issued before the client pays (credit-term
  // clients). The database allows only Managers, requires the reason and writes
  // every change to audit_log (migration 20261020110000). reason=null restores.
  const waiveDp=async(dealId,reason)=>{
    const d=deals.find(x=>x.id===dealId);
    if(!d) return false;
    if(canonRole(role)!=="Manager"){toastEmit("Only a Manager can waive the down payment.","error");return false;}
    const r=(reason||"").trim();
    if(reason!==null&&r.length<5){toastEmit("Give a reason for the waiver (at least 5 characters).","error");return false;}
    if(!isSupabaseReady()){toastEmit("No server connection. Try again when you're back online.","error");return false;}
    const patch=reason===null
      ?{dp_waived_by:null,dp_waived_at:null,dp_waived_reason:null}
      :{dp_waived_by:session?.name||"",dp_waived_at:new Date().toISOString(),dp_waived_reason:r};
    if(!(await sbUpdate('deals',dealId,patch))) return false;
    upDeals(ds=>ds.map(x=>x.id===dealId?{...x,dpWaivedBy:patch.dp_waived_by||"",dpWaivedAt:patch.dp_waived_at,dpWaivedReason:patch.dp_waived_reason||""}:x));
    const label=`${d.client||""}${d.ceNo?" ("+d.ceNo+")":""}`;
    logActivity(dealId,reason===null?"DP waiver removed":"DP waived",reason===null?"Down payment required again before POs":`POs allowed before down payment: ${r}`);
    sendTelegramNotification("management",reason===null
      ?`↩️ <b>DP waiver removed</b>\n${label}\nBy: ${session?.name||"?"}`
      :`⚠️ <b>Down payment waived</b>\n${label}\nPaid so far: ₱${(Number(d.amountPaid)||0).toLocaleString("en-PH")}\nReason: ${r}\nBy: ${session?.name||"?"}`);
    toastEmit(reason===null?"Waiver removed — POs need a down payment again":"Down payment waived — POs can be issued","success");
    return true;
  };
  // Manager adds an internal cost center (create_cost_center RPC, migration
  // 20261026090000): a GMD-internal deal flagged is_cost_center that POs,
  // payables, expenses and vouchers can be booked to.
  const createCostCenter=async(name)=>{
    if(canonRole(role)!=="Manager"){toastEmit("Only a Manager can add a cost center.","error");return false;}
    const n=(name||"").trim();
    if(!n){toastEmit("Give the cost center a name.","error");return false;}
    if(!isSupabaseReady()){toastEmit("No server connection. Try again when you're back online.","error");return false;}
    const{data:id,error}=await _rpcWithTimeout(supabase.rpc('create_cost_center',{p_name:n}));
    if(error){toastEmit("Cost center not added: "+error.message,"error",9000);return false;}
    const{data:row}=await supabase.from('deals').select('id,ce_no,client,contact,product,stage,added_by,created_at').eq('id',id).maybeSingle();
    upDeals(ds=>ds.some(x=>x.id===id)?ds.map(x=>x.id===id?{...x,isCostCenter:true}:x):[...ds,{
      id,client:row?.client||"GMD Productions Inc.",contact:row?.contact||n,product:row?.product||"Internal cost center",
      stage:row?.stage||"06 · Kickoff",ceNo:row?.ce_no||"",value:0,amountPaid:0,isCostCenter:true,
      addedBy:row?.added_by||session?.name||"",addedAt:row?.created_at||new Date().toISOString(),
    }]);
    logActivity(id,"Cost center added",`Internal cost center: ${n}`);
    toastEmit(`Cost center added: ${n}`,"success");
    return true;
  };
  const upProjs    =useCallback(fn=>setProjs(p=>{const n=fn(p);persist(KEYS.projects,n);return n;}),[persist]);
  const upExps     =useCallback(fn=>setExps(p=>{const n=fn(p);persist(KEYS.expenses,n);return n;}),[persist]);
  const upVouchers =useCallback(fn=>setVouchers(p=>{const n=fn(p);persist(KEYS.vouchers,n);return n;}),[persist]);
  const upInfs     =useCallback(fn=>setInfs(p=>{const n=fn(p);persist(KEYS.inflows,n);return n;}),[persist]);
  const upInflows  =upInfs; // alias for DataManagement
  const upJos      =useCallback(fn=>setJos(p=>{const n=fn(p);persist(KEYS.jos,n);return n;}),[persist]);
  const upSwatches =useCallback(fn=>setSwatches(p=>{const n=fn(p);persist(KEYS.swatches,n);return n;}),[persist]);
  const delSwatch  =(id)=>{
    const sw=swatches.find(s=>s.id===id);
    if(sw&&role!=="Manager"&&!isProcurementRole(role)&&sw.addedBy!==session?.name) return toastEmit("Only Managers, Procurement, or the creator can delete swatch items.","error");
    upSwatches(ss=>ss.filter(s=>s.id!==id));if(isSupabaseReady()) sbDelete('swatches',id).catch(()=>{});
  };
  const upChecklist=useCallback(fn=>setChecklist(p=>{const n=fn(p);persist(KEYS.checklist,n);return n;}),[persist]);
  // Create an Operations calendar job (checklists row). Shared by the normal
  // Construction Calendar and the office TV wall board. Mirrors the inline
  // addOpsEvent handlers used by ConstructionCalendar so a job entered on the
  // wall behaves identically to one entered in the app.
  const addOpsEvent=useCallback(data=>{
    const rec={...data,id:uid(),dept:"Operations",createdDate:today,createdBy:session?.name||role};
    upChecklist(cs=>[...cs,rec]);
    if(isSupabaseReady()) sbInsert('checklists',toSbChecklist(rec)).catch(err=>{console.error("Calendar item sync:",err);toastEmit&&toastEmit("Job saved locally only — tap 🔄 sync to push it to the server.","warning",8000);});
    return rec;
  },[upChecklist,session,role]);

  // ── DRF CRUD ─────────────────────────────────────────────────────────────
  const upDrfs   =useCallback(fn=>setDrfs(p=>{const n=fn(p);persist(KEYS.drfs,n);return n;}),[persist]);

  // ── BOT SETTINGS CRUD ────────────────────────────────────────────────────
  const saveBotSettings=async(data)=>{
    // The token never touches this device's storage or app_settings: a new one
    // goes straight to app_secrets through set_telegram_token (Manager only).
    const{token,...n}=data;
    if(token&&isSupabaseReady()){
      const{error}=await supabase.rpc('set_telegram_token',{p_token:token.trim()});
      if(error){toastEmit("Bot token not saved: "+(error.message||error),"error");return false;}
    }
    setBotSettings(n);
    idbSetMany([[KEYS.botsettings,n]]).catch(()=>{});
    localStorage.setItem(KEYS.botsettings,JSON.stringify({chatIds:n.chatIds,hideValueInBots:n.hideValueInBots}));
    if(isSupabaseReady()){
      try{
        const{data:existing}=await supabase.from('app_settings').select('key').eq('key','botsettings').maybeSingle();
        if(existing){
          const{error}=await supabase.from('app_settings').update({value:n,updated_at:new Date().toISOString()}).eq('key','botsettings');
          if(error) throw error;
        } else {
          const{error}=await supabase.from('app_settings').insert({key:'botsettings',value:n,updated_at:new Date().toISOString()});
          if(error) throw error;
        }
      }catch(e){
        toastEmit("Bot settings saved locally but failed to sync to server: "+(e?.message||e),"error");
        return false;
      }
    }
    return true;
  };

  // ── TELEGRAM NOTIFICATION UTILITY ────────────────────────────────────────
  // Sent by the server (send_telegram RPC), which holds the bot token and
  // picks the department's chat (falling back to management).
  // "finance" and "operations" are not chats in Bot Settings, so those messages
  // (Final Billing Ready, billing set-up, budget requests…) silently fell back to
  // management. Final billing and payment releases belong to the Cost Control
  // chat (financialcontrol, decided 2026-10-27); budget requests to Operations.
  const sendTelegramNotification=useCallback(async(dept,message)=>{
    if(!isSupabaseReady()) return;
    const chat=TG_CHANNEL_ALIAS[dept]||dept;
    try{
      const{error}=await supabase.rpc('send_telegram',{p_dept:chat,p_message:String(message||"").slice(0,4096)});
      if(error) console.warn("Telegram notify failed:",error.message||error);
    }catch(e){console.warn("Telegram notify failed:",e);}
  },[]);

  const sendToAllChannels=(message)=>{
    ["general","ops","design","procurement","sales","management"].forEach(dept=>sendTelegramNotification(dept,message));
  };

  const addBlocker=useCallback((dealId,title,dept,detail)=>{
    const entry={id:uid(),dealId,title,dept:dept||"Operations",detail:detail||"",flaggedBy:session?.name||"PM",status:"Open",createdAt:new Date().toISOString(),resolvedBy:null,resolvedAt:null};
    setBlockers(prev=>{const n=[entry,...prev];localStorage.setItem(KEYS.blockers,JSON.stringify(n));idbSetMany([[KEYS.blockers,n]]).catch(()=>{});return n;});
    if(isSupabaseReady()) sbInsert('project_blockers',{id:entry.id,deal_id:dealId,title,dept:dept||"Operations",detail:detail||"",flagged_by:session?.name||"PM",status:"Open",created_at:entry.createdAt}).catch(()=>{});
    logActivity(dealId,"Blocker Flagged",`${title} — needs ${dept}`,session?.name);
    const d=deals.find(x=>x.id===dealId);
    const msg=`⛔ <b>Blocker Flagged</b>\n${d?.client||dealId}\n<b>${title}</b>${detail?"\n"+detail:""}\nFlagged by: ${session?.name} · Dept: ${dept}`;
    const DEPT_CHANNEL={Operations:"ops",Design:"design",Procurement:"procurement","Cost Control":"finance",QS:"management",Sales:"sales",Finance:"finance"};
    const deptKey=DEPT_CHANNEL[dept]||(dept||"").toLowerCase().replace(/[^a-z]/g,"");
    sendTelegramNotification(deptKey,msg);
    sendTelegramNotification("management",msg);
  },[session,deals,logActivity,sendTelegramNotification]);

  const resolveBlocker=useCallback((blockerId)=>{
    setBlockers(prev=>{
      const n=prev.map(b=>b.id===blockerId?{...b,status:"Resolved",resolvedBy:session?.name,resolvedAt:new Date().toISOString()}:b);
      localStorage.setItem(KEYS.blockers,JSON.stringify(n));idbSetMany([[KEYS.blockers,n]]).catch(()=>{});
      const resolved=n.find(b=>b.id===blockerId);
      if(resolved&&isSupabaseReady()) sbUpdate('project_blockers',blockerId,{status:"Resolved",resolved_by:resolved.resolvedBy,resolved_at:resolved.resolvedAt}).catch(()=>{});
      if(resolved){
        const d=deals.find(x=>x.id===resolved.dealId);
        const msg=`✅ <b>Blocker Resolved</b>\n${d?.client||resolved.dealId}\n<b>${resolved.title}</b>\nResolved by: ${session?.name}`;
        sendTelegramNotification("management",msg);
        const DEPT_CHANNEL={Operations:"ops",Design:"design",Procurement:"procurement","Cost Control":"finance",QS:"management",Sales:"sales",Finance:"finance"};
        const dk=DEPT_CHANNEL[resolved.dept]||(resolved.dept||"").toLowerCase().replace(/[^a-z]/g,"");
        sendTelegramNotification(dk,msg);
      }
      return n;
    });
  },[session,deals,sendTelegramNotification]);

  const addDRF=async(drf)=>{
    // Was `DRF-${ds.length+1}` — generated from array LENGTH, so deleting any
    // DRF made the next one reuse a number, on top of the same cross-device
    // collision risk the other doc numbers already had. Atomic counter fixes both.
    const no=await claimDocNumber("DRF",drfs.map(d=>d.drfNo),4,true);
    const rec={...drf,id:uid(),drfNo:no,createdAt:today,status:"New",createdBy:drf.createdBy||session?.name||role};
    upDrfs(ds=>[...ds,rec]);
    sendTelegramNotification("design",`📝 <b>New Design Request</b>\n${no} · ${drf.client||"?"}\nProject: ${drf.projectTitle||"—"}\nDeadline: ${drf.designDeadline||"TBD"}\nBy: ${drf.createdBy||"?"}`);
    if(!isSupabaseReady()) return true;
    const result=await sbInsert('design_requests',drfToSb(rec));
    return !!result;
  };
  const updateDRF=(id,data)=>{
    // Merge the partial `data` onto the existing record BEFORE mapping to
    // Supabase. drfToSb fills every unset column with empty defaults, so
    // passing the raw partial (e.g. just {designer,status} from the assign
    // dropdown) wiped drf_no/client/project_title/design_deadline in the DB —
    // the DRF "got lost" on the next sync. Map the full merged row instead.
    upDrfs(ds=>{
      const next=ds.map(d=>d.id===id?{...d,...data}:d);
      if(isSupabaseReady()){
        const merged=next.find(d=>d.id===id);
        if(merged) sbUpdate('design_requests',id,drfToSb(merged)).catch(()=>{});
      }
      return next;
    });
  };
  const deleteDRF=(id)=>{
    upDrfs(ds=>ds.filter(d=>d.id!==id));
    if(isSupabaseReady()) sbDelete('design_requests',id).catch(()=>{});
  };

  // ── PM Update + Addendum helpers ─────────────────────────────────────────
  // ── Proactive Checklist Template Auto-Load ──────────────────────────────────
  const loadChecklistTemplate=(dealId,clientName)=>{
    // Only load if no checklist items exist for this project yet
    const existing=checklist.filter(c=>(c.projectId||c.dealId)===dealId);
    if(existing.length>0) return; // already has items — don't overwrite
    const items=GMD_CHECKLIST_TEMPLATE.map(t=>({
      ...t,
      id:uid(),
      projectId:dealId,
      title:t.title,
      status:"To Do",
      customType:"",
      assignedTo:"",
      dueDate:"",
      supplier:"",
      qty:"",
      unit:"pcs",
      createdDate:today,
      createdBy:"System (Template)",
    }));
    upChecklist(cs=>[...cs,...items]);
    if(isSupabaseReady()) items.forEach(item=>sbInsert('checklists',toSbChecklist(item)).catch(()=>{}));
  };

  const addPmUpdate=(projId,entryOrText,by)=>{
    const entry=typeof entryOrText==="object"&&entryOrText!==null
      ? entryOrText
      : {id:uid(),type:"General Progress",note:String(entryOrText||""),text:String(entryOrText||""),by:by||session?.name||"Team",date:today,time:new Date().toLocaleTimeString("en-PH",{hour:"2-digit",minute:"2-digit"})};
    if(!(entry.note||entry.text||"").trim()) return;
    // No Telegram here: logActivity("PM Update") already pings ops, and this
    // used to send a second copy of every update. Coordinators can't write
    // projects under RLS; their update lives in activity_log (logActivity),
    // which is what the project feed reads.
    if(roleCanDo("update","projects")) upProj(projId,p=>({...p,pmUpdates:[entry,...(p.pmUpdates||[])]}));
  };
  // The one place a project's stage changes (Projects stage chips and the Log
  // Update modal). Saves through set_deal_stage — PMs can't update deals under
  // RLS, so a plain sbUpdate from them changed 0 rows yet still announced the
  // change on Telegram. The server answers first; only then the screen, the
  // activity log and Telegram follow. Returns true when the stage changed.
  // opts.note: the PM's update text, added to the stage message so ops gets one
  // message instead of two.
  const changeDealStage=async(dealId,st,opts={})=>{
    const deal=deals.find(d=>d.id===dealId);
    if(!deal||!st||deal.stage===st) return false;
    if(!canSetDealStage(role,deal.stage,st)){
      toastEmit(st==="14 · Completed"?"Only a Manager or Sales can mark a project Completed.":"You can't change this project's stage.","error",7000);
      return false;
    }
    const curIdx=WON_STAGES.indexOf(deal.stage||"");
    const newIdx=WON_STAGES.indexOf(st);
    // M8: warn if active CE/QS requests exist for this deal
    const activeCE=(ceReqs||[]).filter(r=>r.dealId===dealId&&!["Done","Cancelled"].includes(r.status));
    if(activeCE.length>0&&newIdx>curIdx){
      if(!(await uiConfirm(`⚠️ This project has ${activeCE.length} active CE/QS request${activeCE.length!==1?"s":""} not yet completed.\n\nAdvance stage anyway?`))) return false;
    }
    // M1: warn if jumping more than 1 stage ahead (only when current stage is recognized)
    if(curIdx!==-1&&newIdx>curIdx+1){
      if(!(await uiConfirm(`⚠️ You're skipping ${newIdx-curIdx-1} stage${newIdx-curIdx-1!==1?"s":""} (${deal.stage||"?"} → ${st}).\n\nContinue?`))) return false;
    }
    // FINANCIAL GATE — a project cannot be marked Completed without a contract value
    // and billing on record; if collections are short, require an explicit confirm.
    // Standby PO umbrellas carry no contract value or billing of
    // their own (their jobs do), so skip the financial gate for them.
    if(st==="14 · Completed"&&!deal.standbyPO){
      const miss=[];
      if(!Number(deal.value)) miss.push("Contract Value");
      if(!Number(deal.invoiced)) miss.push("Billing (invoiced amount)");
      if(miss.length){ toastEmit(`Can't mark Completed — ${miss.join(" & ")} must be recorded in Finance first.`,"error",9000); return false; }
      const outstanding=Math.round((Number(deal.invoiced||0)-Number(deal.amountPaid||0))*100)/100;
      if(outstanding>0.5 && !(await uiConfirm(`⚠️ This project still has ₱${outstanding.toLocaleString("en-PH",{minimumFractionDigits:2})} outstanding (collected is below billed).\n\nMark Completed anyway? Do this only if the balance is retention or a written-off amount.`))) return false;
    }
    if(isSupabaseReady()){
      const{error}=await supabase.rpc('set_deal_stage',{p_deal_id:dealId,p_stage:st});
      if(error){ console.error('set_deal_stage:',error.message); toastEmit("⚠ Stage not changed: "+error.message,"error",9000); return false; }
    }
    // Approved addendums follow their parent's stage (the RPC cascades them
    // server-side too); pending children stay parked.
    const kids=deals.filter(d=>d.parentDealId===dealId&&d.addendumStatus==="Approved"&&!isLostStage(d.stage)).map(d=>d.id);
    upDeals(ds=>ds.map(d=>(d.id===dealId||kids.includes(d.id))?{...d,stage:st}:d));
    logActivity(dealId,"Stage Change",`Stage → ${st}`,session?.name);
    // Auto-stamp the award date the first time a deal enters a WON stage so the
    // awarded / sales-value reports never silently miss it. Only stamps when the
    // project card has no award date yet — an existing (possibly hand-corrected)
    // date is never overwritten, and non-won stages don't touch it.
    if(WON_STAGES.includes(st)&&!pcards[dealId]?.awardDate){
      const awDate=today;
      upPcards(ps=>({...ps,[dealId]:{...(ps[dealId]||emptyProjectCard(dealId,deal)),awardDate:awDate}}));
      if(isSupabaseReady()) syncProjectCard(dealId,{award_date:awDate});
      logActivity(dealId,"Award date set",`${deal.contact||deal.client} — award date auto-set to ${awDate} on entering ${st}`,session?.name);
    }
    const note=(opts.note||"").trim();
    const msg=`📌 <b>Project Stage Updated</b>\nClient: <b>${deal.client}</b>${deal.ceNo?`\nCE: ${deal.ceNo}`:""}${deal.contact?`\nProject: ${deal.contact}`:""}\nStage: ${st}\nBy: ${session?.name}${note?`\n\n${note}`:""}`;
    ["sales","ops","management"].forEach(ch=>sendTelegramNotification(ch,msg));
    if(st==="12 · Close-Out"){
      const finMsg=`💰 <b>Final Billing Ready</b>\nProject: <b>${deal.contact||deal.client}</b>${deal.ceNo?`\nCE: ${deal.ceNo}`:""}\nClient: ${deal.client}\nContract Value: ₱${Number(deal.value||0).toLocaleString("en-PH")}\n\nThis project has moved to Close-Out. Please issue the final invoice.\n\n— ${session?.name}`;
      ["sales","finance"].forEach(ch=>sendTelegramNotification(ch,finMsg));
    }
    return true;
  };
  // PM-reported % complete → the project card's manual progress (the same
  // override the Projects page sets). Only for a project that has a card.
  const setProjectProgress=(dealId,val)=>{
    if(!pcards[dealId]) return false;
    upPcards(ps=>({...ps,[dealId]:{...ps[dealId],manualProgress:val}}));
    if(isSupabaseReady()) syncProjectCard(dealId,{manual_progress:val});
    return true;
  };
  // Everything the Log Update modal needs to move the real project status.
  const pmModalExtra={deals,role,changeDealStage,setProjectProgress,sendTelegramNotification};
  const addAddendum=(dealId,title,desc,requestedBy)=>{
    const entry={id:uid(),dealId,title,desc,requestedBy,date:today,status:"Pending",notifiedSales:false,notifiedOps:false};
    upDeals(ds=>ds.map(d=>d.id===dealId?{...d,addenda:[entry,...(d.addenda||[])]}:d));
    upProj(dealId,p=>({...p,addenda:[entry,...(p.addenda||[])]}));
    if(isSupabaseReady()) sbSyncOne("addenda",entry,toSbAddendum);
    const deal=deals.find(d=>d.id===dealId);
    const msg=`⚠️ <b>Scope Change Logged</b>\n${title||"?"}\nProject: ${deal?.client||dealId||"?"}\nBy: ${requestedBy||"?"}\n\n📌 Sales must quote this to client before proceeding.`;
    sendTelegramNotification("sales",msg);
    sendTelegramNotification("ops",msg);
    sendTelegramNotification("procurement",msg);
    sendTelegramNotification("management",msg);
  };
  const updateAddendumStatus=async(dealId,addId,status)=>{
    // Advancing an addendum's status is a Manager-only UPDATE server-side (RLS).
    // Guard first so a PM/Ops user gets a clear dialog instead of a change that
    // reverts on the next resync.
    if(!await guardWrite('update','addenda','a scope change status')) return;
    upDeals(ds=>ds.map(d=>d.id===dealId?{...d,addenda:(d.addenda||[]).map(a=>a.id===addId?{...a,status}:a)}:d));
    if(isSupabaseReady()) sbUpdate('addenda',addId,{status,updated_at:new Date().toISOString()}).catch(()=>{});
  };

  // ── Checklist state ──────────────────────────────────────────────────────────
  const[clModal,   setClModal]  = useState(false);
  const[clForm,    setClForm]   = useState({projectId:null,type:"Task",customType:"",title:"",dept:"Operations",assignedTo:"",status:"To Do",priority:"Normal",dueDate:"",supplier:"",notes:"",whatCouldGoWrong:"",qty:"",unit:"pcs"});
  const[editCl,    setEditCl]   = useState(null);
  const[clProjF,   setClProjF]  = useState("all");
  const[clTypeF,   setClTypeF]  = useState("All");
  const[clStatF,   setClStatF]  = useState("All");
  const[clDeptF,   setClDeptF]  = useState("All");

  const openAddCl=(projId=null,dept="Operations",type="Task")=>{setClForm({projectId:projId,type,customType:"",title:"",dept:dept,assignedTo:"",status:"To Do",priority:"Normal",dueDate:"",supplier:"",notes:"",whatCouldGoWrong:"",qty:"",unit:"pcs"});setEditCl(null);setClModal(true);};
  const openEditCl=item=>{setClForm({...item,customType:CL_TYPES.includes(item.type)?"":item.type,whatCouldGoWrong:item.whatCouldGoWrong||"",qty:item.qty||"",unit:item.unit||"pcs"});setEditCl(item.id);setClModal(true);};
  const saveCl=()=>{
    if(!clForm.title||!clForm.title.trim()){toastEmit("Task title is required.","error");return;}
    if(!clForm.dept){toastEmit("Department is required.","error");return;}
    if(clForm.type==="Custom"&&!clForm.customType?.trim()){toastEmit("Please describe the custom task type.","error");return;}
    const finalType=clForm.type==="Custom"&&clForm.customType?clForm.customType.trim():clForm.type;
    if(!finalType){toastEmit("Task type is required.","error");return;}
    const rec={...clForm,type:finalType,id:editCl||uid(),createdDate:today,createdBy:role};
    upChecklist(cs=>editCl?cs.map(c=>c.id===editCl?rec:c):[...cs,rec]);
    if(isSupabaseReady()) sbSyncOne("checklists",rec,toSbChecklist);
    setClModal(false);setEditCl(null);
  };
  const delCl=delChecklist;
  const clStatusQ=(id,st)=>{
    upChecklist(cs=>cs.map(c=>c.id===id?{...c,status:st}:c));
    if(isSupabaseReady()) sbUpdate('checklists',id,{status:st}).catch(e=>{toastEmit("Task status sync failed — check connection.","warning");console.error("clStatusQ:",e);});
    if(st==="Done") toastEmit("Task marked done!","success");
  };

  // ── Auth helpers ───────────────────────────────────────────────────────────
  const login=async(username,password)=>{
    const unameLower=username.toLowerCase().trim();
    const defUser=DEFAULT_USERS.find(x=>x.username===unameLower);
    let u=null, viaServer=false, needsUpgrade=false;
    // Verify the password server-side via the verify_login RPC — the hash
    // comparison happens in Postgres, so the actual password_hash never has to
    // be read into the browser (previously fetched via select('*') and
    // compared client-side, which — combined with RLS being open to `anon` —
    // let anyone with the public anon key bulk-read every user's hash with no
    // login at all). Falls back to the old local/DEFAULT_USERS check only if
    // Supabase is unreachable (offline / pre-load / RPC not yet applied).
    if(isSupabaseReady()){
      try{
        // mint-session verifies the password in Postgres and returns a signed,
        // role-bearing token (stored by appLogin) that RLS uses for every request.
        const{user,error}=await appLogin(unameLower,password);
        if(user){
          viaServer=true;
          u={id:user.id,username:user.username,name:user.name,role:user.role,title:user.title||user.role,status:user.status};
          needsUpgrade=!!user.needs_upgrade;
        } else if(error){
          // Server was REACHABLE and rejected the credentials. Never fall back
          // to a local/default hash here — doing so let the seeded default
          // password authenticate even after a user changed their real
          // (server-side) password. Only a genuinely unreachable server (the
          // catch below) may fall through to the offline local check.
          return error;
        }
      }catch(e){ /* network/offline → fall back to local check below */ }
    }
    if(!viaServer){
      let localU=users.find(x=>x.username.toLowerCase()===unameLower);
      if(!localU&&defUser) localU={...defUser,status:"active"};
      if(!localU) return "Username not found.";
      if(localU.status==="pending") return "Your account is pending approval by a Manager.";
      if(localU.status==="inactive") return "Your account has been deactivated. Contact Paulo.";
      // Offline only. Check the user's own stored hash — no default-password
      // fallback (the seeded DEFAULT_USERS carry no password now).
      const hashToCheck=localU.passwordHash||"";
      const valid=hashToCheck?await checkPw(password,hashToCheck,localU.username):false;
      if(!valid) return "Incorrect password.";
      needsUpgrade=!hashToCheck.startsWith("sha256:");
      u=localU;
    }
    if(!u) return "Username not found.";
    if(u.status==="pending") return "Your account is pending approval by a Manager.";
    if(u.status==="inactive") return "Your account has been deactivated. Contact Paulo.";
    // Hash upgrade: on the SERVER path this is already done — verify_login()
    // re-hashes to bcrypt in place on any successful non-bcrypt login. Doing it
    // again here would overwrite that bcrypt with a client-side SHA-256 hash and
    // the migration would never stick. So only upgrade locally when we fell back
    // to the offline/local check (no server involved).
    if(needsUpgrade && !viaServer){
      const newHash=await sha256Hash(password,u.username);
      upUsers(us=>us.map(x=>x.id===u.id?{...x,passwordHash:newHash}:x));
    }
    const sess={userId:u.id,username:u.username,name:u.name,role:u.role,title:u.title||u.role};
    setSession(sess); setRole(u.role);
    logActivity(null,"Login",u.role,sess.name);
    const defaultPages={Manager:"home",Sales:"pipeline",Finance:"home",Procurement:"home",QS:"home",Operations:"home",Design:"home",ProjectMover:"home",SalesOpsAdmin:"home",FinanceAssistant:"home",Display:"tv"};
    setPage(defaultPages[u.role]||"home");
    localStorage.setItem(KEYS.session,JSON.stringify(sess));
    localStorage.setItem(KEYS.role,u.role);
    setSessionExpired(false);
    // Send changes held while the previous login was expired BEFORE reloading,
    // so the fresh server read already includes them.
    (isSupabaseReady()?sbFlushQueue(true).catch(()=>{}):Promise.resolve()).finally(()=>loadAllFromSupabase());
    return null;
  };
  // Verify a password against the CURRENT logged-in user's own stored hash
  // (used by the "change my password" flow) via the same server-side RPC as
  // login — u.passwordHash is no longer readable from the client, so this is
  // the only way to check the current password without knowing it in advance.
  const verifyCurrentPassword=async(username,password)=>{
    if(isSupabaseReady()){
      try{
        const{data,error}=await _rpcWithTimeout(supabase.rpc('verify_login',{p_username:username,p_password:password}));
        const row=Array.isArray(data)?data[0]:data;
        if(!error&&row?.found) return !!row.password_ok;
      }catch(e){ /* fall back to local check below */ }
    }
    const u=users.find(x=>x.username.toLowerCase()===username.toLowerCase());
    return u?checkPw(password,u.passwordHash,u.username):false;
  };
  const logout=async()=>{
    appLogout();
    setSession(null);
    setRole(null);
    setAuthView("login");
    setPage("home");
    sessionStorage.removeItem("gmd:lastPage");
    localStorage.removeItem(KEYS.session);
    localStorage.removeItem(KEYS.role);
  };
  const register=async(name,username,password,requestedRole)=>{
    if(!name||!username||!password) return "All fields are required.";
    if(users.find(u=>u.username.toLowerCase()===username.toLowerCase())) return "Username already taken.";
    if(password.length<6) return "Password must be at least 6 characters.";
    const uname=username.toLowerCase();
    const newUser={id:"u"+Date.now(),name,username:uname,passwordHash:await sha256Hash(password,uname),role:requestedRole,status:"pending",createdAt:today};
    upUsers(us=>[...us,newUser]);
    return null;
  };
  const approveUser =(id,role)=>upUsers(us=>us.map(u=>{if(u.id!==id)return u;const n={...u,status:"active",role};if(isSupabaseReady())sbUpsert('user_profiles',toSbUser(n),'id').catch(()=>{});return n;}));
  const rejectUser  =(id)    =>upUsers(us=>us.map(u=>{if(u.id!==id)return u;const n={...u,status:"rejected"};if(isSupabaseReady())sbUpsert('user_profiles',toSbUser(n),'id').catch(()=>{});return n;}));
  const deactivateUser=(id)  =>upUsers(us=>us.map(u=>{if(u.id!==id)return u;const n={...u,status:"inactive"};if(isSupabaseReady())sbUpsert('user_profiles',toSbUser(n),'id').catch(()=>{});return n;}));
  const deleteUser  =(id)    =>{upUsers(us=>us.filter(u=>u.id!==id));if(isSupabaseReady())sbDelete('user_profiles',id).catch(()=>{});};
  const resetPw     =async(id,pw)=>{
    const u=users.find(x=>x.id===id);if(!u)return false;
    // Keep a local SHA-256 for offline login continuity; the authoritative
    // (bcrypt) hash is written server-side via the RPC.
    const n={...u,passwordHash:await sha256Hash(pw,u.username)};
    upUsers(us=>us.map(x=>x.id===id?n:x));
    // Only report failure when the server was reachable but the RPC failed —
    // offline we intentionally keep just the local hash and still succeed.
    if(isSupabaseReady() && !(await setPasswordServer(id,pw))) return false;
    return true;
  };
  const createUser  =async(name,username,password,role,title)=>{
    const uname=username.toLowerCase().trim();
    const newUser={id:uid(),name:name.trim(),username:uname,passwordHash:await sha256Hash(password,uname),role,title:title.trim()||role,status:"active",createdAt:today};
    if(isSupabaseReady()){
      // Insert the row first (toSbUser omits the hash), then set the bcrypt
      // password server-side. If that RPC fails, roll the row back rather than
      // leave a passwordless account nobody can ever log into.
      await sbUpsert('user_profiles',toSbUser(newUser),'id');
      if(!(await setPasswordServer(newUser.id,password))){
        sbDelete('user_profiles',newUser.id).catch(()=>{});
        return {ok:false,error:"Couldn't set the password on the server — account not created. Try again."};
      }
    }
    upUsers(us=>[...us,newUser]);
    return {ok:true};
  };
  // ── Derived ───────────────────────────────────────────────────────────────
  // Internal cost centers (deals.is_cost_center: GMD OPEX, Tools, HR…) are
  // buckets for GMD's own spending, not projects. They stay out of wonDeals so
  // no project view, KPI, billing list or commission counts them, and are
  // offered in the purchase / expense / payable / voucher pickers through
  // costCenterDeals instead. Migration 20261026090000_deals_cost_centers.sql.
  const wonDeals    =useMemo(()=>deals.filter(d=>WON_STAGES.includes(d.stage)&&!d.isCostCenter),[deals]);
  const completedDeals=useMemo(()=>deals.filter(d=>d.stage==="14 · Completed"&&!d.isCostCenter),[deals]);
  const costCenterDeals=useMemo(()=>deals.filter(d=>d.isCostCenter&&!isLostStage(d.stage)).sort((a,b)=>(a.contact||"").localeCompare(b.contact||"")),[deals]);
  const closedDeals=useMemo(()=>deals.filter(d=>d.stage==="12 · Close-Out"),[deals]);
  // Auto-create project entries for any won deal that doesn't have one yet
  // Depends on both wonDeals.length AND projs key count so it re-runs after Supabase loads projs
  const projsKeyCount=Object.keys(projs).length;
  useEffect(()=>{
    // Standby PO umbrellas have no production of their own (their jobs do),
    // so don't spin up an empty ₱0 project shell for them. Child/addendum deals
    // (parentDealId) never get their own project card either — Ops maintains the
    // single parent card even when the project has addendums.
    const missing=wonDeals.filter(d=>!projs[d.id]&&!d.standbyPO&&!d.parentDealId);
    if(missing.length>0){
      const patch={};
      missing.forEach(d=>{patch[d.id]=emptyProject();});
      upProjs(ps=>({...ps,...patch}));
    }
  // eslint-disable-next-line
  },[wonDeals.length,projsKeyCount]);

  // Auto-mark Finance DONE when project is fully paid
  useEffect(()=>{
    wonDeals.forEach(d=>{
      const ms=billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled");
      if(ms.length===0) return;
      const allPaid=ms.every(m=>m.status==="Fully Paid");
      const card=pcards[d.id];
      if(allPaid&&card&&!card.departments?.Finance?.done){
        markDeptDone(d.id,"Finance",true);
      }
    });
  // eslint-disable-next-line
  },[billings.length]);
  const projList  =useMemo(()=>wonDeals.filter(d=>projs[d.id]),[wonDeals,projs]);
  // Where money can be booked: projects plus internal cost centers.
  const spendProjList=useMemo(()=>[...projList,...costCenterDeals],[projList,costCenterDeals]);
  const spendWonDeals=useMemo(()=>[...wonDeals,...costCenterDeals],[wonDeals,costCenterDeals]);
  const isPauloGate = stage => PAULO_GATE.includes(stage);
  const clientName=useCallback(id=>deals.find(d=>d.id===id)?.client||`Project #${id}`,[deals]);
  // useCallback so this stays referentially stable across renders — otherwise
  // a plain inline function is a NEW reference every render, which defeats
  // React.memo on anything it's passed to (e.g. WIPView below) since one of
  // its props would always look "changed" even when nothing did.
  const overallProg=useCallback(p=>{const si=PROD_STAGES.indexOf(p.currentStage);return Math.round(si*25+(p.progress[p.currentStage]||0)*0.25);},[]);
  const costOf    =p=>(p.materials||[]).reduce((s,m)=>s+m.cost,0)+(p.laborCost||0)+(p.overhead||0);
  const marginOf  =(p,d)=>d&&costOf(p)<d.value?Math.round((d.value-costOf(p))/d.value*100):0;
  const totRev    =useMemo(()=>wonDeals.reduce((s,d)=>s+d.value,0),[wonDeals]);
  const escalations = useMemo(()=>{
    const list = [];
    const todayD = today;
    const in7days = new Date(); in7days.setDate(in7days.getDate()+7);
    const in7str = in7days.toISOString().slice(0,10);
    // O(1) Map lookups instead of O(n) find() on every iteration
    const wonMap  = new Map(wonDeals.map(d=>[d.id,d]));
    const dealMap = new Map(deals.map(d=>[d.id,d]));
    const billedDealIds = new Set(billings.filter(b=>b.status!=='Cancelled').map(b=>b.dealId));
    // E-1: billing milestones overdue
    billings.forEach(b=>{
      if(b.dueDate && b.dueDate < todayD && b.status !== 'Fully Paid' && b.status !== 'Cancelled'){
        const deal = wonMap.get(b.dealId);
        if(deal) list.push({type:'E-1',dealId:b.dealId,client:deal.client,label:`Overdue: ${b.name||b.label||'Invoice'} (due ${b.dueDate})`,severity:'high'});
      }
    });
    // E-2: addenda in Discovered status
    addenda.forEach(a=>{
      if(a.status==='Discovered'){
        const deal = wonMap.get(a.dealId);
        if(deal) list.push({type:'E-2',dealId:a.dealId,client:deal.client,label:`Unresolved scope change: ${a.title||'Addendum'}`,severity:'medium'});
      }
    });
    // E-3: punchlist SLA breach
    wonDeals.forEach(d=>{
      if(d.stage==='11 · Punchlist'){
        const proj = projs[d.id];
        const startDate = proj?.stageDates?.Punchlist?.s;
        if(startDate && bizDaysElapsed(startDate) > BUSINESS_DAYS_SLA){
          list.push({type:'E-3',dealId:d.id,client:d.client,label:`Punchlist SLA breached (${bizDaysElapsed(startDate)} biz days)`,severity:'high'});
        }
      }
    });
    // E-4: DRF deadline within 7 days
    drfs.forEach(drf=>{
      if(drf.designDeadline && drf.status!=='Done' && drf.status!=='Cancelled' && drf.designDeadline>=todayD && drf.designDeadline<=in7str){
        const deal = wonMap.get(drf.dealId)||dealMap.get(drf.dealId);
        const daysLeft = Math.ceil((new Date(drf.designDeadline)-new Date(todayD))/(1000*60*60*24));
        list.push({type:'E-4',dealId:drf.dealId,client:deal?.client||drf.client||'?',label:`DRF ${drf.drfNo||''} deadline in ${daysLeft}d (${drf.designDeadline})`,severity:'medium'});
      }
    });
    // E-5: PO delivery overdue
    prs.forEach(pr=>{
      if(pr.deliveryDate && pr.deliveryDate < todayD && !['Delivered','Cancelled'].includes(pr.status)){
        const deal = wonMap.get(pr.dealId||pr.projectId);
        list.push({type:'E-5',dealId:pr.dealId||pr.projectId,client:deal?.client||'?',label:`PO overdue: ${pr.item||'Item'} (due ${pr.deliveryDate})`,severity:'high'});
      }
    });
    // E-6: Budget requests pending >3 days
    breqs.forEach(br=>{
      if(br.status==='Pending' && br.createdAt){
        const created = new Date(br.createdAt); const diff = Math.floor((new Date()-created)/(1000*60*60*24));
        if(diff>3){
          const deal = wonMap.get(br.dealId);
          list.push({type:'E-6',dealId:br.dealId,client:deal?.client||br.title||'?',label:`Budget request pending ${diff}d: ${br.title||'Request'}`,severity:'low'});
        }
      }
    });
    // E-7: Won projects with no billing milestones — only flag from Fabrication stage onwards
    // Kickoff & Briefing are too early to require milestones
    const BILLING_REQUIRED_STAGES=["08 · Fabrication","09 · Site & Billing","10 · Installation","11 · Punchlist","12 · Close-Out"];
    wonDeals.forEach(d=>{
      if(!billedDealIds.has(d.id)&&BILLING_REQUIRED_STAGES.includes(d.stage)) list.push({type:'E-7',dealId:d.id,client:d.client,label:`No billing milestone set for active project`,severity:'medium'});
    });
    return list;
  },[billings,addenda,wonDeals,projs,drfs,prs,breqs,deals,today]);
  // Billing milestones are the source of truth for "collected" once a deal has a schedule —
  // deal.amountPaid can drift (legacy imports, manual edits) with nothing to catch it, which is
  // exactly how Sales Pipeline and Billing ended up showing different numbers for the same deal.
  // Falls back to deal.amountPaid only for deals that never got a billing schedule.
  const dealCollected=(d)=>{
    const allMs=billings.filter(b=>b.dealId===d.id);
    if(!allMs.length) return Number(d.amountPaid||0); // no schedule → legacy fallback
    // Has a schedule: sum payments on non-cancelled milestones only, so collected
    // stays consistent with deal.invoiced (which also excludes Cancelled).
    // Bounced payments never landed, so they don't count as collected.
    return allMs.filter(b=>b.status!=='Cancelled').reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+Number(p.amount||0),0),0);
  };
  // Billed-but-unpaid for one deal, like-for-like in CASH terms: what the client
  // was invoiced (VAT-ex `invoiced` grossed up for VAT, less EWT) minus what the
  // billing ledger shows collected. Never `invoiced − collected` (net − cash).
  const dealOutstanding=(d)=>{
    const ms=billings.filter(b=>b.dealId===d.id);
    if(ms.length) return ms.reduce((s,b)=>s+milestoneBalance(b,d),0);
    return Math.max(0,calcTax(Number(d.invoiced)||0,d.receiptType||"OR",!!d.withholding).netReceivable-dealCollected(d));
  };
  const totColl   =useMemo(()=>wonDeals.reduce((s,d)=>s+dealCollected(d),0),[wonDeals,billings]);
  // Company-wide AR, same basis everywhere (see arSummary in core.js).
  const dealById  =useMemo(()=>{const m=new Map();deals.forEach(d=>m.set(d.id,d));return m;},[deals]);
  const arTot     =useMemo(()=>arSummary(billings,id=>dealById.get(id)),[billings,dealById]);
  const totOut    =arTot.outstanding;

  // Auto-mark overdue billing milestones — runs once when billings load, then daily
  useEffect(()=>{
    if(!billings.length) return;
    // Skip milestones already paid in full even if their status tag is stale —
    // otherwise a paid "Partially Paid" milestone gets flipped to Overdue.
    // Drafts haven't been sent to the client, so they can't be overdue.
    const toMark=billings.filter(b=>b.dueDate&&b.dueDate<today&&!['Draft','Fully Paid','Cancelled','Overdue'].includes(b.status)&&milestoneBalance(b,dealById.get(b.dealId))>0.5);
    if(!toMark.length) return;
    upBillings(bs=>bs.map(b=>toMark.find(m=>m.id===b.id)?{...b,status:'Overdue'}:b));
    if(isSupabaseReady()){
      toMark.forEach(b=>sbUpdate('billing_milestones',b.id,{status:'Overdue',updated_at:new Date().toISOString()}).catch(()=>{}));
    }
  },[billings.length,today]); // eslint-disable-line

  // Daily bot alerts: overdue payables + low inventory
  useEffect(()=>{
    if(!isSupabaseReady()||!botSettings?.chatIds?.management) return;
    const overdueP=payables.filter(p=>p.status==="Unpaid"&&p.dueDate&&p.dueDate<today);
    if(overdueP.length>0){
      const total=overdueP.reduce((s,p)=>s+Number(p.amount||0),0);
      const lines=overdueP.slice(0,5).map(p=>`• ${p.payee||p.description||"?"} — ₱${Number(p.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})} (due ${p.dueDate})`).join("\n");
      const msg=`⚠️ <b>Overdue Payables Alert</b>\n${overdueP.length} payable${overdueP.length!==1?"s":""} overdue — ₱${total.toLocaleString("en-PH",{maximumFractionDigits:0})} total\n\n${lines}${overdueP.length>5?`\n…and ${overdueP.length-5} more`:""}`;
      sendTelegramNotification("financialcontrol",msg);
      sendTelegramNotification("management",msg);
    }
    const lowStock=inventory.filter(i=>i.status!=="Inactive"&&i.reorderPoint>0&&i.qtyOnHand<=i.reorderPoint);
    if(lowStock.length>0){
      const lines=lowStock.slice(0,5).map(i=>`• ${i.name} — ${i.qtyOnHand} ${i.unit} (reorder at ${i.reorderPoint})`).join("\n");
      const msg=`📦 <b>Low Inventory Alert</b>\n${lowStock.length} item${lowStock.length!==1?"s":""} at or below reorder point\n\n${lines}${lowStock.length>5?`\n…and ${lowStock.length-5} more`:""}`;
      sendTelegramNotification("warehouse",msg);
      sendTelegramNotification("procurement",msg);
    }
  },[today]); // eslint-disable-line

  // ── Dashboard KPI memos — pre-computed so render is instant ──────────────
  const pipeDeals      =useMemo(()=>deals.filter(d=>isActivePipeline(d.stage)),[deals]);
  const pipeVal        =useMemo(()=>pipeDeals.reduce((s,d)=>s+Number(d.value||0),0),[pipeDeals]);
  const awardReqCnt    =useMemo(()=>deals.filter(d=>d.notes&&d.notes.includes("[AWARD REQUEST")).length,[deals]);
  const overdueInvCnt  =useMemo(()=>billings.filter(b=>isBillingOverdue(b,today)).length,[billings]);
  const overdueTATCnt  =useMemo(()=>wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed"&&pcards[d.id]?.targetEndDate&&pcards[d.id].targetEndDate<today&&!DEPT_ORDER.every(dept=>pcards[d.id]?.departments?.[dept]?.done)).length,[wonDeals,pcards]);
  const qsPendingCnt   =useMemo(()=>jos.filter(j=>j.budgetStatus==="QS Budget Pending"&&!Object.values(budgets[j.dealId]||{}).some(v=>Number(v)>0)).length,[jos,budgets]);
  const mrPendingCnt   =useMemo(()=>mreqs.filter(m=>m.status==="Submitted").length,[mreqs]);
  const addendaAlertCnt=useMemo(()=>addenda.filter(a=>!a.salesNotified&&a.status!=="Rejected").length,[addenda]);
  const activeJOCnt    =useMemo(()=>jos.filter(j=>j.status==="Active").length,[jos]);
  const pendingPRCnt   =useMemo(()=>prs.filter(p=>p.status==="Pending Approval").length,[prs]);
  const overdueInvMs   =useMemo(()=>billings.filter(m=>isBillingOverdue(m,today)).length,[billings]);
  const breqPendingCnt =useMemo(()=>breqs.filter(b=>b.status==="Pending").length,[breqs]);
  const openPOCnt      =useMemo(()=>prs.filter(p=>["Pending Approval","Approved","PO Issued"].includes(p.status)).length,[prs]);
  const toBuyCnt       =useMemo(()=>swatches.filter(s=>s.status==="To Buy").length,[swatches]);
  const overdueProjectCnt=useMemo(()=>wonDeals.filter(d=>pcards[d.id]?.targetEndDate&&pcards[d.id].targetEndDate<today&&!DEPT_ORDER.every(dept=>pcards[d.id]?.departments?.[dept]?.done)).length,[wonDeals,pcards]);

  // ── Modals ────────────────────────────────────────────────────────────────
  const[dealModal,  setDealModal] =useState(false);
  const[awardModal, setAwardModal]=useState(null);
  const[awardReqModal, setAwardReqModal]=useState(null);
  const[payTermsModal,setPayTermsModal]=useState(null); // dealId — Milestone Builder open for this project
  const[dueDateFixOpen,setDueDateFixOpen]=useState(false); // backfill dialog for missing billing/payable due dates
  const[clientSugg, setClientSugg]=useState([]); // autocomplete suggestions
  const[dealForm,  setDealForm] =useState(emptyDeal);
  const[editDeal,  setEditDeal] =useState(null);
  const[expModal,  setExpModal] =useState(false);
  const[routeModal,setRouteModal]=useState(null);
  const[routeMethod,setRouteMethod]=useState("BizLink");
  const[routeBank,setRouteBank]=useState("");
  const[expForm,   setExpForm]  =useState({expDate:today,month:new Date().getMonth(),year:new Date().getFullYear(),category:"Materials",amount:"",note:"",payee:"",projectId:null,bankAccount:"",receipt:""});
  const[editExpId, setEditExpId]=useState(null);
  const[infModal,  setInfModal] =useState(false);
  const[infForm,   setInfForm]  =useState({month:new Date().getMonth(),source:"",amount:"",note:"",projectId:null});
  const[selProj,   setSelProj]  =useState(null);
  const[jumpDeal,  setJumpDeal] =useState(null);
  const[jumpFilter,setJumpFilter]=useState(null);
  const[widgetDrill,setWidgetDrill]=useState(null); // which home widget's detail panel is open
  const[attnDrill,setAttnDrill]=useState(null);     // which "Needs Attention" card's detail panel is open
  const[opsTab,    setOpsTab]   =useState("progress");
  const[finTab,    setFinTab]   =useState("overview");
  const[cashSub,   setCashSub]  =useState("daily");   // Cash Position sub-tab: daily | weekly | monthly
  const[payables,  setPayables] =useState([]);
  const[payPays,   setPayPays]  =useState([]); // payable_payments: one row per payment / retention release
  // Company costs on the PO basis (issued POs + Work Orders + other payables +
  // unrouted legacy expenses), VAT-exclusive — the one cost figure every margin
  // uses (see costSummary).
  const costTot   =useMemo(()=>costSummary(exps,payables,prs,swos),[exps,payables,prs,swos]);
  const totExp    =costTot.net;
  const[payouts,   setPayouts]  =useState([]);
  const[payModal,  setPayModal] =useState(false);
  const emptyPayForm=()=>({vendor:"",amount:"",paidAmount:"",dueDate:"",invoiceNumber:"",invoiceDate:"",projectId:null,category:"Supplier",accountCode:"",notes:"",invoiceRef:""});
  const[payForm,   setPayForm]  =useState(emptyPayForm());
  const[payFilter, setPayFilter]=useState("All");
  const[poViewFilter,setPoViewFilter]=useState("all"); // unified PO view: all | po | wo
  const[poViewSearch,setPoViewSearch]=useState("");
  const[apLogSearch,setApLogSearch]=useState("");   // Accounts Payable Log search
  const[supPaySearch,setSupPaySearch]=useState(""); // Supplier Payables (Open POs) search
  const[payPayId,  setPayPayId] =useState(null); // payable id being settled in the Record-Payment modal
  const[payPayAmt, setPayPayAmt]=useState("");
  const[payPayMode,setPayPayMode]=useState("amount"); // "amount" | "pct" (progress payment to a subcontractor/supplier)
  const[payPayPct, setPayPayPct]=useState("");
  const[payPayBank,  setPayPayBank]  =useState("");            // which bank/account the payable is paid from
  const[payPayMethod,setPayPayMethod]=useState("Online Transfer"); // Online Transfer | Cash | Check
  const[payPayRef,   setPayPayRef]   =useState("");
  const[payPayDate,  setPayPayDate]  =useState("");   // date the payment actually went out (required)
  const[payPayDP,    setPayPayDP]    =useState(false); // subcontractor downpayment: no retention withheld
  const[payPayKind,  setPayPayKind]  =useState("Payment"); // "Payment" | "Retention release"
  const[multiPay,    setMultiPay]    =useState(null);  // one check / transfer paying several bills: {vendor, sel:{id:amount}, date, method, bank, ref}
  const[payHistId,   setPayHistId]   =useState(null);  // payable whose payment history is open
  const[editPayId, setEditPayId]=useState(null);
  const[loans,     setLoans]    =useState([]);
  const[loanModal, setLoanModal]=useState(false);
  const[editLoanId,setEditLoanId]=useState(null);
  const[loanPay,   setLoanPay]  =useState({});
  const[loanForm,  setLoanForm] =useState({lender:"",type:"Bank Loan",principal:"",disbursedDate:"",termMonths:"",interestRate:"",monthlyPayment:"",notes:""});
  const[acctSearch,setAcctSearch]=useState("");
  const[acctCat,   setAcctCat]  =useState("All");
  const[acctProj,  setAcctProj] =useState("all");
  const[acctMonth, setAcctMonth]=useState(today.slice(0,7));
  const[vouchers,  setVouchers] =useState([]);
  const[cvModal,   setCvModal]  =useState(false);
  const[editCvId,  setEditCvId] =useState(null);
  const[cvForm,    setCvForm]   =useState({date:today,cvNo:"",payee:"",amount:"",description:"",projectId:null,bank:"",notes:"",status:"Draft",poRef:"",payableId:null,checkNo:"",clearedDate:"",isCleared:false});
  const[cvSearch,  setCvSearch] =useState("");
  const[cvStatus,  setCvStatus] =useState("All");
  const[cvView,    setCvView]   =useState(null); // voucher id shown in the Aerwin-style document view
  const[dpCollapsed,setDpCollapsed]=useState(new Set());
  const[cvCollapsed,setCvCollapsed]=useState(new Set());
  const[isOnline,   setIsOnline]   =useState(()=>navigator.onLine);
  const[poPayModal, setPoPayModal]=useState(false);
  const[poPayPr,    setPoPayPr]   =useState(null);
  const[poPayStep,  setPoPayStep] =useState(1);
  const[poPayType,  setPoPayType] =useState(null);
  const[actCollapsed,setActCollapsed]=useState(()=>{try{return JSON.parse(localStorage.getItem("gmdv5:actCollapsed")||"false");}catch{return false;}});
  const[dashEditMode,setDashEditMode]=useState(false);
  const[dashOrder,setDashOrder]=useState(()=>{
    try{const k="gmdv5:dashOrder";const v=localStorage.getItem(k);return v?JSON.parse(v):["active","collections","activity","dept"];}catch{return["active","collections","activity","dept"];}
  });
  const saveDashOrder=o=>{setDashOrder(o);try{localStorage.setItem("gmdv5:dashOrder",JSON.stringify(o));}catch{}};
  const[repPeriod, setRepPeriod]=useState("monthly");
  const[repYear,   setRepYear]  =useState(new Date().getFullYear());
  const[repMonth,  setRepMonth] =useState(new Date().getMonth());
  const[repAESort,  setRepAESort]  =useState("gross");   // "gross"|"won"|"clients"
  const[repAEFilter,setRepAEFilter]=useState("");
  const[repTab,    setRepTab]   =useState("sales");
  const[matModal,  setMatModal] =useState(false);
  const[matForm,   setMatForm]  =useState({projectId:"",name:"",category:"Materials",qty:1,unit:"pcs",cost:0,supplier:"",note:""});
  const[editMat,   setEditMat]  =useState(null);
  const saveMat=(mat)=>{
    if(!mat.name?.trim()){toastEmit("Material name is required.","warning");return;}
    if(!mat.qty||Number(mat.qty)<=0){toastEmit("Quantity must be greater than 0.","warning");return;}
    if(!mat.cost||Number(mat.cost)<=0){toastEmit("Unit cost must be greater than 0.","warning");return;}
    const isEdit=editMat!=null;
    const rec={...mat,name:mat.name.trim(),qty:Number(mat.qty),cost:Number(mat.cost),id:isEdit?editMat:uid(),createdAt:today,by:session?.name||""};
    upProjs(ps=>{
      const p=ps[mat.projectId]||emptyProject();
      const mats=isEdit?p.materials.map(m=>m.id===editMat?rec:m):[...(p.materials||[]),rec];
      return{...ps,[mat.projectId]:{...p,materials:mats}};
    });
    setMatModal(false);setEditMat(null);
    setMatForm({projectId:"",name:"",category:"Materials",qty:1,unit:"pcs",cost:0,supplier:"",note:""});
  };
  const[swModal,   setSwModal]  =useState(false);
  const[swForm,    setSwForm]   =useState({projectId:null,name:"",category:"Fabric",qty:"",unit:"pcs",supplier:"",estCost:"",swatchLink:"",addedBy:"Design",status:"To Buy",notes:""});
  const[editSw,    setEditSw]   =useState(null);
  const openAddSwatch=(pid,by)=>{setSwForm({projectId:pid,name:"",category:"Furniture/Fixture",spec:"",qty:1,unit:"pcs",status:"To Buy",addedBy:session?.name||by||"",refLink:""});setEditSw(null);setSwModal(true);};
  const openEditSwatch=(sw)=>{setSwForm({...sw});setEditSw(sw.id);setSwModal(true);};
  const[designModal,setDesignModal]=useState(false);
  const[designForm, setDesignForm] =useState({});
  const[confirmDel, setConfirmDel] =useState(null);
  const[delAck,     setDelAck]     =useState(false);  // forces an explicit tick before deleting a deal that has financial records
  const[stageFilter,  setStageFilter]  = useState(false);  // pipeline stage click filter
  const[pipeSearch,   setPipeSearch]   = useState("");     // pipeline search query
  const[pipeTab,      setPipeTab]      = useState("pipeline"); // "pipeline" | "awarded" | "updates"
  const[homePeriod,   setHomePeriod]   = useState("year");     // Sales home performance window: "month" | "year" | "all"
  const[awardScope,   setAwardScope]   = useState("mine");     // Awarded tab: "mine" | "team" (team is manager-only)
  const[payoutDraft,  setPayoutDraft]  = useState(null);       // Commissions tab: open record-payout form (null = closed)
  const[aeUpdates,    setAeUpdates]    = useState([]);
  const[auditFindings,setAuditFindings]= useState([]);
  const[aeUpdateText, setAeUpdateText] = useState("");
  const[aeUpdateDealId, setAeUpdateDealId] = useState("");
  const[aeUpdateDealType, setAeUpdateDealType] = useState("active");
  const[aeFeedFilter, setAeFeedFilter] = useState("all");
  const[aeShowClosed, setAeShowClosed] = useState(false);
  const[doneExpanded, setDoneExpanded] = useState(false);  // closed-out projects accordion
  const[dnwExpanded,  setDnwExpanded]  = useState(false);  // did-not-win accordion (under closed-out)
  const[pipeType,     setPipeType]     = useState("all");  // awarded-project type filter
  const[pipeAE,       setPipeAE]       = useState("all");  // AE/salesperson filter
  const[pipeNoAward,  setPipeNoAward]  = useState(false);  // awarded tab: show only won projects with no award date set
  const[showActChat,  setShowActChat]  = useState(false); // pipeline activity pop-up
  const[rowMenu,      setRowMenu]      = useState(null);   // {deal,x,y} — pipeline row overflow menu
  const[coldSweepDismissed,setColdSweepDismissed]=useState(false); // hide stale-cold review banner for this session
  const[priceModal,   setPriceModal]   = useState(null);   // {deal} — QS set price modal
  const[quickAddClientOpen,setQuickAddClientOpen]=useState(false);
  const[quickAddClientForm,setQuickAddClientForm]=useState({name:"",contactPerson:"",email:"",phone:"",mobile:"",website:"",billingAddress:"",city:"",province:"",zipCode:"",country:"Philippines",tin:"",paymentTerms:"Due on receipt",notes:""});
  const fqac=(k,v)=>setQuickAddClientForm(p=>({...p,[k]:v}));
  const resetQAC=()=>setQuickAddClientForm({name:"",contactPerson:"",email:"",phone:"",mobile:"",website:"",billingAddress:"",city:"",province:"",zipCode:"",country:"Philippines",tin:"",paymentTerms:"Due on receipt",notes:""});
  const[pmUpdateModal,setPmUpdateModal]= useState(null);   // {dealId, dealName} — PM update entry
  const[billingJumpDeal,setBillingJumpDeal]=useState(null); // pre-select a deal when opening billing page
  const[billingJumpPay,setBillingJumpPay]=useState(null);   // …and open Log Payment on this milestone
  const[arDrill,setArDrill]=useState(null);                 // AR Aging card clicked: bucket key
  const[smartImport,  setSmartImport]  = useState(null);   // {rows, summary, rawData} — AI import preview
  const[importLoading,setImportLoading]= useState(false);  // AI analyzing flag
  const[importReview, setImportReview] = useState(null);   // [{...mapped deal fields}] for review step
  const[navCollapsed, setNavCollapsed] = useState(()=>{try{return localStorage.getItem("gmdv5:navCollapsed")==="1";}catch{return false;}});  // sidebar collapsed (persisted)
  useEffect(()=>{try{localStorage.setItem("gmdv5:navCollapsed",navCollapsed?"1":"0");}catch{}},[navCollapsed]);
  // Sidebar favorites: pinned nav items (by id) surface in a ⭐ FAVORITES group at the
  // top of the sidebar, so the pages a user works with most are reachable without scrolling.
  const[favNav, setFavNav] = useState(()=>{try{return JSON.parse(localStorage.getItem("gmdv5:favNav")||"[]");}catch{return[];}});
  useEffect(()=>{try{localStorage.setItem("gmdv5:favNav",JSON.stringify(favNav));}catch{}},[favNav]);
  // "Favorites only" hides every non-favorited page for a clean sidebar; a Show-all toggle
  // brings them back so other pages stay reachable and favorites remain editable.
  const[favOnly, setFavOnly] = useState(()=>{try{return localStorage.getItem("gmdv5:favOnly")==="1";}catch{return false;}});
  useEffect(()=>{try{localStorage.setItem("gmdv5:favOnly",favOnly?"1":"0");}catch{}},[favOnly]);
  // Collapsed nav department groups (accordion). Set holds the group NAMES a user
  // has collapsed; persisted so the sidebar reopens the way they left it. Kept at
  // this level (not inside the memoized Nav) so toggling never resets on re-render.
  const[navGroupsCollapsed, setNavGroupsCollapsed] = useState(()=>{try{return new Set(JSON.parse(localStorage.getItem("gmdv5:navGroupsCollapsed")||"[]"));}catch{return new Set();}});
  const toggleNavGroup = (g)=>setNavGroupsCollapsed(prev=>{const nx=new Set(prev);nx.has(g)?nx.delete(g):nx.add(g);try{localStorage.setItem("gmdv5:navGroupsCollapsed",JSON.stringify([...nx]));}catch{}return nx;});
  const toggleFav=(id)=>setFavNav(f=>f.includes(id)?f.filter(x=>x!==id):[...f,id]);
  const isMobile = useIsMobile();
  const[moreNavOpen,  setMoreNavOpen]  = useState(false);
  const mobileNavRef = React.useRef(null);
  const[blockers,     setBlockers]     = useState(()=>{try{return JSON.parse(localStorage.getItem(KEYS.blockers)||"[]");}catch{return [];}});
  const[boqLibrary,  setBoqLibrary]   = useState(()=>{try{return JSON.parse(localStorage.getItem(KEYS.boqLibrary)||"[]");}catch{return [];}});
  const[boqDealId,   setBoqDealId]    = useState(null);
  const[standaloneBoqs,setStandaloneBoqs]=useState(()=>{try{return JSON.parse(localStorage.getItem("gmdv5:standaloneBoqs")||"[]");}catch{return [];}});
  const[boqStandaloneId,setBoqStandaloneId]=useState(null);
  const[boqCoId,      setBoqCoId]     = useState(null);
  const[boqCoReadOnly,setBoqCoReadOnly]=useState(false);
  // Standalone BOQs now live ONE ROW PER BOQ in their own `standalone_boqs`
  // table (migration 051) — Supabase is the source of truth. Each save/delete
  // touches only that BOQ's row, so concurrent authors can never clobber each
  // other (the old single app_settings blob could). localStorage/IndexedDB is
  // kept purely as an offline cache, reconciled per id on the next load.
  const _boqToRow=(b)=>({
    id:b.id,
    title:b.title||"",
    location:b.location||"",
    quotation_no:b.quotationNo||"",
    boq_date:b.boqDate||null,
    items:b.items||[],
    sections:b.sections||[],
    vat_enabled:b.vatEnabled!==false,
    discount:b.discount||"",
    markup_pct:b.markupPct||"",
    created_by:b.createdBy||"",
    created_at:b.createdAt||new Date().toISOString(),
    updated_at:b.updatedAt||new Date().toISOString(),
  });
  const saveStandaloneBoq=useCallback((boq)=>{
    setStandaloneBoqs(prev=>{
      const next=prev.some(b=>b.id===boq.id)?prev.map(b=>b.id===boq.id?{...b,...boq}:b):[...prev,boq];
      localStorage.setItem("gmdv5:standaloneBoqs",JSON.stringify(next));
      idbSetMany([["gmdv5:standaloneBoqs",next]]).catch(()=>{});
      // Upsert just this BOQ's row. A failed write is surfaced (and queued for
      // retry) by sbUpsert's central error handling — no longer swallowed.
      const merged=next.find(b=>b.id===boq.id)||boq;
      if(isSupabaseReady()) sbUpsert('standalone_boqs',_boqToRow(merged),'id').catch(()=>{});
      return next;
    });
  },[]);
  const deleteStandaloneBoq=useCallback((id)=>{
    setStandaloneBoqs(prev=>{
      const next=prev.filter(b=>b.id!==id);
      localStorage.setItem("gmdv5:standaloneBoqs",JSON.stringify(next));
      idbSetMany([["gmdv5:standaloneBoqs",next]]).catch(()=>{});
      if(isSupabaseReady()) sbDelete('standalone_boqs',id);
      return next;
    });
  },[]);
  // ── Chart of Accounts (synced via app_settings, like standalone BOQs) ──
  const[chartOfAccounts,setChartOfAccounts]=useState(()=>{try{return JSON.parse(localStorage.getItem("gmdv5:chartOfAccounts")||"[]");}catch{return [];}});
  const saveChartOfAccounts=useCallback((next)=>{
    setChartOfAccounts(next);
    localStorage.setItem("gmdv5:chartOfAccounts",JSON.stringify(next));
    idbSetMany([["gmdv5:chartOfAccounts",next]]).catch(()=>{});
    if(isSupabaseReady()) sbUpsert('app_settings',{key:'chart_of_accounts',value:next,updated_at:new Date().toISOString()},'key').catch(()=>{});
  },[]);
  // (viewport tracking now handled by the reactive useIsMobile() hook above)
  useEffect(()=>{const on=()=>setIsOnline(true);const off=()=>setIsOnline(false);window.addEventListener('online',on);window.addEventListener('offline',off);return()=>{window.removeEventListener('online',on);window.removeEventListener('offline',off);};},[]);
  const[dragDeal,    setDragDeal]    = useState(null);   // deal id being dragged
  const[dragOver,    setDragOver]    = useState(null);   // stage column being hovered
  const[dupPrompt,   setDupPrompt]   = useState(null);   // {newData, matches[]} — duplicate deal detection
  const[dupScopeTarget,setDupScopeTarget]=useState(null); // {dealId,dealName} — inline scope form inside dup prompt
  const[dupScopeForm,setDupScopeForm]=useState({title:"",desc:"",value:""});
  const[costTab,     setCostTab]     = useState("budget"); // cost analysis sub-tab
  const[page,       setPage]       =useState("home");
  const[fromHome,   setFromHome]   =useState(false);
  const[showExport, setShowExport] =useState(false);
  const showExportRef=useRef(false);
  useEffect(()=>{if(session&&page)sessionStorage.setItem("gmd:lastPage",page);},[page,session]);
  // Hidden modules (see HIDDEN_PAGES in shared.jsx): any link, favorite or
  // restored last page that still points at one lands on Home instead.
  useEffect(()=>{if(isHiddenView(page,finTab))setPage("home");},[page,finTab]);
  useEffect(()=>{if(HIDDEN_PIPE_TABS.has(pipeTab))setPipeTab("pipeline");},[pipeTab]);
  const smartImportInputRef=useRef(null);
  showExportRef.current=showExport;

  // ── Helpers ───────────────────────────────────────────────────────────────
  const openAddDeal=()=>{setDealForm({...emptyDeal,ceNo:nextCENo()});setEditDeal(null);setDealModal(true);};
  const openEditDeal=d=>{setDealForm({...d,value:String(d.value),invoiced:String(d.invoiced||0),amountPaid:String(d.amountPaid||0),dateAcquired:d.dateAcquired||today,turnoverDate:pcards[d.id]?.targetEndDate||""});setEditDeal(d.id);setDealModal(true);};
  // ── Supabase deal writers ───────────────────────────────────────────────────
  const sbSaveDeal=async(rec)=>{
    try {
      const payload={
        ce_no:rec.ceNo, client:rec.client, contact:rec.contact,
        ce_type:rec.ceType, product:rec.product||rec.ceType||"", stage:rec.stage,
        priority:rec.priority, sales_owner:rec.salesOwner,
        biz_dev_source:rec.bizDevSource, lead_origin:leadOriginOf(rec), date_acquired:rec.dateAcquired||null,
        lead_origin_status:leadOriginPending(rec)?"Pending":"Approved", lead_origin_approved_by:rec.leadOriginApprovedBy||"", lead_origin_approved_at:rec.leadOriginApprovedAt||null,
        due_date:rec.dueDate||null, value:Number(rec.value)||0,
        invoiced:Number(rec.invoiced)||0, amount_paid:Number(rec.amountPaid)||0,
        payment_status:rec.paymentStatus, receipt_type:rec.receiptType,
        withholding:rec.withholding||false, comms_group:rec.commsGroup,
        sales_repo_link:rec.salesRepoLink, proposal_folder_link:rec.proposalFolderLink,
        notes:rec.notes, probability:rec.probability||0,
        standby_po:!!rec.standbyPO, po_budget:rec.standbyPO?(Number(rec.poBudget)||0):0,
        updated_at:new Date().toISOString(),
      };
      // Check if UUID (Supabase) or old ID
      const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-/.test(rec.id);
      if(isUUID){
        await sbUpdate('deals', rec.id, payload);
      } else {
        const data = await sbInsert('deals', payload);
        if(data?.id) return data.id; // return new Supabase UUID
      }
    } catch(err){ console.warn("Supabase deal save failed, localStorage only:", err.message); }
    return rec.id;
  };

  const saveDeal=async(overrideData,skipDupCheck=false)=>{
    const data = overrideData||dealForm;
    if(!data.client||!data.client.trim()){toastEmit("Client name is required.","error");return;}
    if(!data.stage){toastEmit("Stage is required.","error");return;}
    // Standby PO umbrellas are intentionally ₱0 (their value lives on the
    // drawdown jobs), so exempt them from the awarded-value requirement.
    if(WON_STAGES.includes(data.stage)&&!data.standbyPO&&(!data.value||Number(data.value)<=0)){toastEmit("Contract value is required for awarded projects.","error");return;}
    // Awarding a project is exclusively the Award modal's job (it creates the Job
    // Order, project card and starting budget). The deal edit form must never move
    // a deal INTO a won stage — doing so marked it "awarded" with none of that
    // scaffolding. Allowed: editing a deal that is ALREADY in a won stage (Ops
    // pipeline progress). Blocked: a new deal saved directly at a won stage, or an
    // edit lifting a pre-award deal into one — use the 🏆 Award button instead.
    if(WON_STAGES.includes(data.stage)){
      const prevStage=editDeal?deals.find(d=>d.id===editDeal)?.stage:null;
      if(!editDeal||!WON_STAGES.includes(prevStage)){
        toastEmit("🏆 To award a project, use the Award button (🏆) so its Job Order, project card and budget are created. Set the stage back to a pipeline stage to save this edit.","warning",7000);
        return;
      }
    }
    // Placeholder / import-artifact guard. A real contract is never ₱1, and a
    // deal can't carry invoiced/paid amounts with no contract value. Both are the
    // signature of a re-import where the value column didn't map (deals came in at
    // ₱1 while invoiced/paid copied over from the source row). Standby PO
    // umbrellas are legitimately ₱0 — their value lives on the drawdown jobs — so
    // exempt them. Applies on edit too, so fixing a bad row means entering the
    // real value, not re-saving the placeholder.
    if(!data.standbyPO){
      const v=Number(data.value)||0, inv=Number(data.invoiced)||0, paid=Number(data.amountPaid)||0;
      if(v===1){toastEmit("Contract value of ₱1 looks like an import placeholder. Enter the real contract value before saving.","error");return;}
      if(v<=0&&(inv>0||paid>0)){toastEmit("This deal has amounts invoiced/paid but no contract value — check the value field before saving.","error");return;}
    }
    // Duplicate detection — only on new deals, not edits or forced saves
    if(!editDeal&&!skipDupCheck){
      // Match clients with the fuzzy key so "Adm Indicia" vs "Adm-Indicia" and
      // "Matchanese" vs "Matchanese Inc" are treated as the same client, then
      // flag when the CE number matches OR the project titles are similar (loose
      // token overlap, so "Event 1" vs "Leg 1" of the same job is caught).
      const clientK=clientMatchKey(data.client);
      const newTitle=data.product||data.contact||"";
      const dupes=deals.filter(d=>{
        if(isLostStage(d.stage)) return false;
        if(clientMatchKey(d.client)!==clientK) return false;
        const ceMatch=data.ceNo&&d.ceNo&&data.ceNo.trim()===d.ceNo.trim();
        return ceMatch||titleSimilar(newTitle,d.product||d.contact||"");
      });
      if(dupes.length>0){setDupPrompt({newData:data,matches:dupes});return;}
    }
    // Re-claim the CE number atomically for new deals — the value sitting in
    // the form is only ever a local suggestion (set when the Add Deal form
    // opened), which can be stale/colliding if another device saved a deal
    // since then.
    // An edit never blanks the CE number (trg_deals_keep_ce_no enforces the same).
    const claimedCeNo=editDeal?(String(data.ceNo||"").trim()?data.ceNo:(deals.find(d=>d.id===editDeal)?.ceNo||data.ceNo)):await claimCENo(data.ceNo,deals.map(d=>d.ceNo));
    const prob=WON_STAGES.includes(data.stage)?100:isLostStage(data.stage)?0:Number(data.probability);
    const rec={...data,ceNo:claimedCeNo,product:data.product||data.ceType||"",id:editDeal||uid(),value:data.standbyPO?0:Number(data.value),poBudget:data.standbyPO?(Number(data.poBudget)||0):"",invoiced:Number(data.invoiced||0),amountPaid:Number(data.amountPaid||0),probability:prob,
      addedBy:editDeal?(data.addedBy||""):(session?.name||""),
      addedAt:editDeal?(data.addedAt||today):today,
    };
    // ── Addendum approval normalization ──────────────────────────────────────
    // A child deal (parentDealId set) carries an explicit approval flag that
    // drives the contract roll-up, independent of the workflow stage:
    //   • Pending (default): park it at "05 · For Approval" so it reads as
    //     awaiting client sign-off — never left in raw "01 · BizDev" — and
    //     default its board temperature to "Almost Awarded". It stays OUT of
    //     the parent's Total Contract until approved.
    //   • Approved: it now follows the parent project — inherit the parent's
    //     current (non-lost) stage so the two track together, and it rolls into
    //     Total Contract via ContractBreakdown (which keys off the flag).
    // Standalone deals keep addendumStatus null.
    if(rec.parentDealId){
      const _parent=deals.find(d=>d.id===rec.parentDealId);
      if(rec.addendumStatus==="Approved"){
        if(_parent&&!isLostStage(_parent.stage)) rec.stage=_parent.stage;
        rec.probability=WON_STAGES.includes(rec.stage)?100:rec.probability;
      }else{
        rec.addendumStatus="Pending";
        if(!WON_STAGES.includes(rec.stage)) rec.stage="05 · For Approval";
        if(!DEAL_TEMPS.includes(rec.temperature)) rec.temperature="Almost Awarded";
      }
    }else{
      rec.addendumStatus=null;
    }
    // ── Lead-origin approval (migration 072) ─────────────────────────────────
    // Self-sourced pays 1.5% instead of 0.5%, so it needs a Manager's approval.
    // A Manager's own save approves it; anyone else's new claim (new deal, or a
    // switch from Given) goes to Pending. An already-approved claim stays approved
    // when other fields are edited. The DB trigger enforces the same rule.
    const _prevDeal=editDeal?deals.find(d=>d.id===editDeal):null;
    const _prevLead=_prevDeal?leadOriginOf(_prevDeal):DEFAULT_LEAD_ORIGIN;
    let _leadClaimSubmitted=false;
    if(leadOriginOf(rec)!=="Self-sourced"){
      Object.assign(rec,{leadOriginStatus:"Approved",leadOriginApprovedBy:"",leadOriginApprovedAt:null});
    }else if(role==="Manager"){
      if(_prevLead!=="Self-sourced"||leadOriginPending(_prevDeal||{}))
        Object.assign(rec,{leadOriginStatus:"Approved",leadOriginApprovedBy:session?.name||"Manager",leadOriginApprovedAt:new Date().toISOString()});
    }else if(_prevLead!=="Self-sourced"){
      Object.assign(rec,{leadOriginStatus:"Pending",leadOriginApprovedBy:"",leadOriginApprovedAt:null});
      _leadClaimSubmitted=true;
    }else{
      Object.assign(rec,{leadOriginStatus:_prevDeal.leadOriginStatus||"Pending",leadOriginApprovedBy:_prevDeal.leadOriginApprovedBy||"",leadOriginApprovedAt:_prevDeal.leadOriginApprovedAt||null});
    }
    // Guard: block the same change order being recorded as BOTH a linked child
    // deal AND an addendum on the same parent (double-counts awarded value).
    if(!editDeal && !skipDupCheck && rec.parentDealId){
      const coDup=findCrossMechanismCO({parentId:rec.parentDealId,value:rec.value,deals,addenda,excludeDealId:rec.id});
      if(coDup && !window.confirm(coDup+"\n\nSave this change-order deal anyway?")) return;
    }
    // Only trigger award logic for NEW deals entering won stages — never on edit
    const wasAlreadyAwarded = editDeal && WON_STAGES.includes(deals.find(d=>d.id===editDeal)?.stage);
    // Child/addendum deals (parentDealId set) never get their own project card —
    // Ops keeps the single parent project card. Only parent deals do.
    if(WON_STAGES.includes(data.stage) && !editDeal && !rec.parentDealId) upProjs(ps=>ps[rec.id]?ps:{...ps,[rec.id]:emptyProject()});
    upDeals(ds=>editDeal?ds.map(d=>d.id===editDeal?rec:d):[...ds,rec]);
    // Keep approved addendums in step with their parent's stage: if this edit
    // is a PARENT deal whose stage changed, cascade the new stage to any of its
    // approved children (pending children stay parked at "For Approval").
    if(editDeal && !rec.parentDealId){
      const _prevStage=deals.find(d=>d.id===editDeal)?.stage;
      if(_prevStage!==rec.stage){
        const _kids=deals.filter(d=>d.parentDealId===editDeal&&d.addendumStatus==="Approved"&&!isLostStage(d.stage)).map(d=>d.id);
        if(_kids.length){
          upDeals(ds=>ds.map(d=>_kids.includes(d.id)?{...d,stage:rec.stage}:d));
          if(isSupabaseReady()) _kids.forEach(cid=>sbUpdate('deals',cid,{stage:rec.stage}).catch(()=>{}));
        }
      }
    }
    // Await the deal's own write before firing the DRF auto-create below, which
    // references rec.id by foreign key — firing it unawaited let the design
    // request occasionally reach the server before the deal committed, failing
    // an FK check that sync retry then permanently drops (same bug class fixed
    // in createProjectCard for department tasks).
    // The deal itself is already saved above (upDeals + optimistic UI update) —
    // everything below is a secondary side-effect (client-list registration,
    // DRF/CE auto-create, Telegram notifications, turnover-date sync). None of
    // it may ever leave the form stuck open on top of an already-saved deal, so
    // any failure here is swallowed and the modal still closes in the finally.
    try{
      // The write to Supabase is always awaited before the form closes — a
      // deal that only ever reached local state and never got confirmed on
      // the server is exactly how a sales rep's deal went missing (confirmed
      // via direct DB query: it never landed, no error the rep could see).
      // sbUpsert already bounds this to ~12s via its own internal timeout, so
      // this can't hang indefinitely the way an earlier, unrelated RPC bug did.
      const syncP=isSupabaseReady()?sbSyncOne("deals",rec,toSbDeal):Promise.resolve(true);
      // New deals get a visible "saving…" prompt while that wait is happening,
      // so it's clear something is in flight rather than the form just sitting
      // there — updates in place to saved/failed once syncP resolves.
      const savingToastId=(!editDeal&&isSupabaseReady())?toastEmit(`⏳ Saving ${rec.client} to server…`,"pending",15000):null;
      const dealSynced=await syncP;
      if(savingToastId){
        if(dealSynced) toastUpdate(savingToastId,`✅ ${rec.client} saved to server`,"success",3000);
        else toastUpdate(savingToastId,`⚠️ ${rec.client} didn't reach the server yet — saved on this device only for now. Keep this browser/tab around so it can sync.`,"warning",12000);
      }
      // Each optional/secondary step below tracks its own pass/fail instead of
      // one generic "something failed" — collected into stepResults and
      // reported as a single, specific summary toast at the end, so you know
      // exactly which step needs a retry instead of guessing from a vague
      // warning + the console.
      const stepResults=[];
      // Save new client to master list if not already present
      if(rec.client && !GMD_CLIENTS.find(c=>c.name.toLowerCase()===rec.client.toLowerCase())){
        const safeName=rec.client.replace(/</g,"&lt;").replace(/>/g,"&gt;");
        const newClient={name:safeName,id:"c"+Date.now(),addedBy:session?.name||"",addedAt:today};
        GMD_CLIENTS.push(newClient);
        // Compute the new list up front. Reading it out of the setState updater
        // (which React 18 runs asynchronously, after this line) left it null when
        // the upsert fired, sending value:null and hitting app_settings' NOT NULL
        // constraint — the "server rejected a change (bad data)" drop.
        const newClientList=[...customClients,newClient];
        setCustomClients(newClientList);
        try{localStorage.setItem(KEYS.customclients,JSON.stringify(newClientList));}catch{}
        const clientOk=isSupabaseReady()?await sbUpsert('app_settings',{key:'customclients',value:newClientList,updated_at:new Date().toISOString()},'key'):true;
        stepResults.push({label:"Client directory",ok:clientOk});
      }
      // Auto-create DRF when the Sales rep ticked "Request Design" — designer is
      // left unset here; the Design lead assigns who handles it (DRFView "Assign").
      // Gated on dealSynced: firing this before the deal committed would fail
      // design_requests' foreign key to deals.id. If the deal write itself failed,
      // it's already queued for retry — the DRF stays local-only rather than
      // risk an unwinnable, permanently-dropped FK violation.
      // Never auto-create a Design Request for a PENDING addendum — Design must
      // not start on scope the client hasn't approved. Once approved, design is
      // requested through the normal project flow.
      if(!editDeal && data.drfReqCreate && dealSynced && !(rec.parentDealId&&rec.addendumStatus!=="Approved")){
        const drfOk=await addDRF({
          dealId:rec.id, client:rec.client, location:"",
          designer:"", designDeadline:data.drfDeadline||"",
          projectTitle:data.drfProjectTitle||rec.contact||rec.client||"",
          type:data.ceType||DRF_TYPES[0], category:data.drfCategory||"",
          size:data.drfSize||"", maxHeight:data.drfMaxHeight||"",
          platform:data.drfPlatform||"", finishes:data.drfFinishes||"",
          brandGuideLink:data.drfBrandGuideLink||"", budget:data.drfBudget||"",
          description:data.drfDescription||"",
          accessories:data.drfAccessories||[], refLinks:data.drfRefLinks||["","",""],
          notes:data.drfNotes||"", approvedLink:"", status:"New",
          createdBy:session?.name||""
        });
        stepResults.push({label:"Design Request",ok:drfOk});
      }
      // Auto-create CE/QS request if the Sales rep ticked "Send to CE/QS for Costing"
      if(!editDeal && data.ceReqCreate){
        const num=v=>Number(String(v||0).replace(/,/g,""))||0;
        const ceOk=await addCEReq({
          client_name:rec.client, project_name:rec.contact||"", location:rec.location||"",
          project_type:data.ceReqType||"retail", priority:data.ceReqPriority||"Normal", status:"Pending",
          submitted_by:session?.name||"", target_deadline:data.ceReqDeadline||null,
          submission_deadline:data.ceReqSubmitDeadline||null,
          target_budget:num(data.ceReqBudget)||null, target_margin:num(data.ceReqMargin)||null,
          plans_link:data.ceReqPlansLink||rec.salesRepoLink||"", skp_link:data.ceReqSkpLink||"",
          schedule_of_finish:data.ceReqSchedule||"", notes:data.ceReqNotes||"",
          deal_id:String(rec.id), updated_at:new Date().toISOString(),
        });
        stepResults.push({label:"CE/QS Request",ok:ceOk});
        sendTelegramNotification("management",`📐 <b>New CE Request</b>\nClient: <b>${rec.client}</b>${rec.contact?`\nProject: ${rec.contact}`:""}\nType: ${data.ceReqType||"retail"} · ${data.ceReqPriority||"Normal"} priority${data.ceReqDeadline?`\nCE Deadline: ${data.ceReqDeadline}`:""}\nFor: Rodney (CE/QS)\nFrom: ${session?.name||"Sales"}`);
      }
      if(!editDeal){
        logActivity(rec.id,"New Deal",`${rec.client} added at ${rec.stage}`,session?.name);
        sendTelegramNotification("sales",`🆕 <b>New Deal Added</b>\nClient: <b>${rec.client}</b>\n${rec.contact?`Project: ${rec.contact}\n`:""}${rec.ceNo?`CE: ${rec.ceNo}\n`:""}${(!botSettings.hideValueInBots&&rec.value)?`₱${Number(rec.value).toLocaleString("en-PH")}\n`:""}Added by: ${session?.name||"Sales"}`);
      } else {
        logActivity(rec.id,"Deal Updated",`${rec.client} — ${rec.stage}`,session?.name);
        // Fire award notification when stage is changed to an awarded stage via edit
        const prevStage=deals.find(d=>d.id===editDeal)?.stage||"";
        if(WON_STAGES.includes(rec.stage)&&!WON_STAGES.includes(prevStage)){
          sendToAllChannels(
            `🏆 <b>PROJECT AWARDED!</b>\n\n`+
            `Client: <b>${rec.client}</b>\n`+
            (rec.contact?`Project: <b>${rec.contact}</b>\n`:"")+
            (rec.ceNo?`CE No: ${rec.ceNo}\n`:"")+
            (rec.ceType?`${rec.ceType}\n`:"")+
            (rec.location?`📍 ${rec.location}\n`:"")+
            (!botSettings.hideValueInBots&&rec.value?`Value: ₱${Number(rec.value).toLocaleString("en-PH",{maximumFractionDigits:0})}\n`:"")+
            `\nAwarded by: ${session?.name||"Manager"}`
          );
          logActivity(rec.id,"Project Awarded",`${rec.client} moved to awarded stage by ${session?.name}`,session?.name);
          // A linked child deal (addendum) stays its own deal — it is awarded and
          // billed on its own, and rolls into the parent's Total Contract as a
          // display-only addendum line (see ContractBreakdown). It is never
          // converted or retired, and never spawns a second project card.
        }
        // Fire notification when stage moves back out of awarded (e.g. cancelled)
        if(!WON_STAGES.includes(rec.stage)&&WON_STAGES.includes(prevStage)&&rec.stage==="Cancelled"){
          sendTelegramNotification("management",`❌ <b>Project Cancelled</b>\nClient: <b>${rec.client}</b>\n${rec.contact?`Project: ${rec.contact}\n`:""}By: ${session?.name||"Manager"}`);
          sendTelegramNotification("sales",`❌ <b>Project Cancelled</b>\nClient: <b>${rec.client}</b>\n${rec.contact?`Project: ${rec.contact}\n`:""}By: ${session?.name||"Manager"}`);
        }
      }
      // Save turnover date to project card if provided and deal is a won project
      if(rec.turnoverDate&&WON_STAGES.includes(rec.stage)){
        const card=pcards[rec.id];
        if(card){
          upPcards(ps=>({...ps,[rec.id]:{...ps[rec.id],targetEndDate:rec.turnoverDate}}));
          let turnoverOk=true;
          if(isSupabaseReady()&&card.id&&isUUID(card.id)){
            turnoverOk=await sbUpdate('project_cards',card.id,{target_end_date:rec.turnoverDate});
          }
          if(rec.turnoverDate!==(card.targetEndDate||"")){
            const tgMsg=`📅 <b>Turnover Date Updated</b>\nProject: <b>${rec.contact||rec.client}</b>${rec.ceNo?` — ${rec.ceNo}`:""}\n🏁 Turnover Date: <b>${rec.turnoverDate}</b>\nUpdated by: ${session?.name||"Sales"}`;
            sendTelegramNotification("ops",tgMsg);
            sendTelegramNotification("management",tgMsg);
            const existingTov=checklist.find(c=>c.type==="Turnover"&&(c.projectId===rec.id||c.dealId===rec.id));
            if(existingTov){
              upChecklist(cs=>cs.map(c=>c.id===existingTov.id?{...c,dueDate:rec.turnoverDate}:c));
              if(isSupabaseReady()){const ok=await sbUpdate('checklists',existingTov.id,{due_date:rec.turnoverDate});turnoverOk=turnoverOk&&ok;}
            }else{
              const tov={id:uid(),type:"Turnover",title:"Client Turnover",dueDate:rec.turnoverDate,projectId:rec.id,dealId:rec.id,dept:"Operations",status:"Scheduled",priority:"Normal",createdDate:today,createdBy:session?.name||role,notes:""};
              upChecklist(cs=>[...cs,tov]);
              if(isSupabaseReady()){const result=await sbInsert('checklists',toSbChecklist(tov));turnoverOk=turnoverOk&&!!result;}
            }
          }
          stepResults.push({label:"Turnover checklist",ok:turnoverOk});
        }
      }
      const failedSteps=stepResults.filter(s=>!s.ok);
      if(failedSteps.length) toastEmit(`⚠️ ${rec.client} saved, but needs attention: ${failedSteps.map(f=>f.label).join(", ")} — saved on this device only, check console.`,"warning",10000);
      if(_leadClaimSubmitted){
        toastEmit("Self-sourced claim sent to a Manager for approval — commission stays at 0.5% until approved.","info",8000);
        logActivity(rec.id,"Lead Origin","Claimed Self-sourced (1.5%) — awaiting Manager approval");
        sendTelegramNotification("management",`🧭 <b>Self-sourced claim needs approval</b>\n${rec.contact||rec.client}${rec.ceNo?` (${rec.ceNo})`:""}\nAE: ${rec.salesOwner||"—"} · by ${session?.name||"—"}\nApprove in Sales Pipeline → top panel.`);
      }
    }catch(err){
      console.error("saveDeal side-effect failed:",err);
      toastEmit("Deal saved, but a follow-up step failed — check console.","warning");
    }
    setEditDeal(null);
    setDealModal(false);
  };
  const delDeal=id=>{
    if(!canDeleteDeal){toastEmit("You don't have permission to delete deals.","error");return;}
    // Close the confirmation modal immediately and unconditionally — closing
    // it is a pure UI action and must never depend on the cascade below
    // succeeding. Previously setConfirmDel(null) sat after ~10 local state
    // updates with no try/catch: if any one of them threw, the modal was
    // left stuck open even though earlier updates (e.g. the deal itself
    // disappearing from Pipeline) had already gone through — reported live
    // as "delete didn't close but the deal was deleted".
    setConfirmDel(null);
    const deal=deals.find(d=>d.id===id);
    // Snapshot the deal and its billing (milestones cascade at the DB, taking
    // invoice numbers and recorded payments with them) to Finance ▸ Audit Trail
    // so a wrong delete can be restored. Fire-and-forget: the snapshots are
    // taken from state now, before any of it is cleared below.
    if(isSupabaseReady()&&deal){
      const why=`Deal deleted by ${session?.name||role}`;
      archiveFinancial("deals",toSbDeal(deal),deal.id,why);
      billings.filter(b=>b.dealId===id).forEach(ms=>{
        archiveFinancial("billing_milestones",toSbBilling(ms),ms.id,why);
        (ms.payments||[]).forEach(p=>archiveFinancial("billing_payments",toSbPayment({...p,milestoneId:ms.id}),p.id,why));
      });
    }
    try{
      // Cascade-clear all related local state
      const dealMsIds=billings.filter(b=>b.dealId===id).map(b=>b.id);
      upDeals(ds=>ds.filter(d=>d.id!==id));
      upProjs(ps=>{const n={...ps};delete n[id];return n;});
      upBillings(bs=>bs.filter(b=>b.dealId!==id));
      upPrs(ps=>ps.filter(p=>(p.dealId||p.projectId)!==id));
      upMreqs(ms=>ms.filter(m=>m.dealId!==id));
      upBreqs(bs=>bs.filter(b=>b.dealId!==id));
      upAddenda(as=>as.filter(a=>a.dealId!==id));
      upDrfs(ds=>ds.filter(d=>d.dealId!==id));
      upChecklist(cs=>cs.filter(c=>(c.projectId||c.dealId)!==id));
      upSwatches(ss=>ss.filter(s=>(s.projectId||s.dealId)!==id));
      upExps(es=>es.filter(e=>(e.projectId||e.dealId)!==id));
      logActivity(id,"Deal Deleted",`${deal?.client||id} permanently deleted`,session?.name||role);
      if(isSupabaseReady()&&isUUID(id)){
        sbDelete('deals',id)
          .then(()=>{ toastEmit("Deal deleted","success"); })
          .catch(e=>{ toastEmit("Supabase delete failed — check console","error"); console.error("delDeal:",e); });
        // Cascade deletes (DB has ON DELETE CASCADE but clean up explicitly too)
        dealMsIds.forEach(msId=>sbDeleteWhere('billing_payments','milestone_id',msId));
        const tables=['projects','billing_milestones','job_orders','purchase_requests',
          'material_requests','budget_requests','addenda','design_requests',
          'checklists','project_cards','project_budgets','swatches'];
        tables.forEach(t=>sbDeleteWhere(t,'deal_id',id));
        sbDeleteWhere('expenses','deal_id',id);
        const cardIds=pcards[id]?.id?[pcards[id].id]:[];
        if(cardIds.length){
          sbDeleteWhere('project_card_dept_tasks','card_id',cardIds,'in');
          sbDeleteWhere('project_card_dept_status','card_id',cardIds,'in');
        }
      } else if(isSupabaseReady()&&!isUUID(id)){
        toastEmit("Deal removed locally — not synced (legacy ID)","warning");
      }
    }catch(err){
      console.error("delDeal cascade failed:",err);
      toastEmit(`⚠️ ${deal?.client||"Deal"} removed, but cleaning up related records failed — check console.`,"warning",9000);
    }
  };

  // NOTE: Change orders are modeled as linked child deals (parentDealId set) that
  // stay their own live deals — created by Sales via "+ Add New Deal → Link to
  // Parent Deal", awarded and billed on their own. They are NEVER converted into
  // a CO record or retired, and never spawn a second project card; they roll into
  // the parent's Total Contract as a display-only line (see ContractBreakdown).
  // The old convertChildToCO / convertAllChildrenToCO helpers were removed with
  // that model change.

  const updatePayment=(id,key,val)=>upDeals(ds=>ds.map(d=>d.id===id?{...d,[key]:val}:d));

  const stageQ=(id,st)=>{
    // A linked child deal (addendum) stays its own live deal — it is NEVER
    // converted or retired. It counts as sales/billing on its own, but it must
    // NOT spawn a second project card: Operations maintains the ONE parent
    // project card even when the project has addendums, so only parent deals
    // (no parentDealId) get a projs entry on award.
    const staging=deals.find(x=>x.id===id);
    // Awarding is exclusively the Award modal's job — it issues the Job Order,
    // project card and starting budget and sends the award notification. Dragging
    // a deal from a pre-award stage straight into a won stage did NONE of that,
    // leaving an "awarded" deal Operations never received. Block that one
    // transition (non-won → won) and point to the 🏆 Award button. Moving BETWEEN
    // won stages (already-awarded pipeline progress) stays free.
    if(WON_STAGES.includes(st)&&staging&&!WON_STAGES.includes(staging.stage)){
      toastEmit("🏆 Use the Award button (🏆) to award a project — it sets up the Job Order, project card and budget. Drag-to-award is disabled.","warning",6000);
      return;
    }
    if(WON_STAGES.includes(st)&&!staging?.parentDealId) upProjs(ps=>ps[id]?ps:{...ps,[id]:emptyProject()});
    if(st==="14 · Completed"){
      const d=deals.find(x=>x.id===id);
      // Standby PO umbrellas have no contract value/payments of their own.
      if(!d?.standbyPO){
        const missing=[];
        if(!d?.value||Number(d.value)===0) missing.push("Contract Value");
        if(!d?.amountPaid||Number(d?.amountPaid)===0) missing.push("Payments Received");
        if(missing.length>0) toastEmit(`⚠ Before closing: please ensure ${missing.join(" and ")} are recorded in Finance.`,"warning");
      }
    }
    upDeals(ds=>ds.map(d=>{
      if(d.id!==id) return d;
      const prob=WON_STAGES.includes(st)?100:st==="Cancelled"?0:st==="14 · Completed"?100:d.probability;
      logActivity(id,"Stage Change",`${d.client}: ${d.stage} → ${st}`,session?.name);
      if(isSupabaseReady()) sbUpdate('deals',id,{stage:st,probability:prob,updated_at:new Date().toISOString()}).catch(()=>{});
      return{...d,stage:st,probability:prob};
    }));
  };
  const payQ=(id,ps)=>{
    upDeals(ds=>ds.map(d=>d.id===id?{...d,paymentStatus:ps}:d));
    if(isSupabaseReady()) sbUpdate('deals',id,{payment_status:ps,updated_at:new Date().toISOString()}).catch(()=>{});
  };

  const addAeUpdate=(text,dealId)=>{
    if(!text.trim()) return;
    const now=new Date();
    const entry={id:uid(),by:session?.name||"",role:session?.role||"Sales",date:today,time:now.toTimeString().slice(0,5),text:text.trim(),dealId:dealId||null};
    const next=[entry,...aeUpdates].slice(0,300);
    setAeUpdates(next);
    setAeUpdateText("");
    setAeUpdateDealId("");
    
    if(isSupabaseReady()) sbInsert('ae_updates',{id:entry.id,by:entry.by,role:entry.role,date:entry.date,time:entry.time,text:entry.text,deal_id:entry.dealId||null}).catch(()=>{});
    logActivity(dealId||null,"AE Update",text.trim(),session?.name);
    const taggedDeal=dealId?[...wonDeals,...deals].find(d=>d.id===dealId):null;
    const projectLine=taggedDeal?`\n📌 Project: <b>${taggedDeal.contact||taggedDeal.client}</b> — ${taggedDeal.client}${taggedDeal.ceNo||taggedDeal.ceno?" · "+(taggedDeal.ceNo||taggedDeal.ceno):""} | ${taggedDeal.stage}`:"";
    const tgMsg=`📋 <b>AE Update</b>${projectLine}\nBy: ${session?.name||"?"} · ${now.toTimeString().slice(0,5)}\n${text.trim()}`;
    sendTelegramNotification("sales",tgMsg);
    sendTelegramNotification("ops",tgMsg);
    toastEmit("Update posted!","success");
  };
  const delAeUpdate=(id)=>{
    const next=aeUpdates.filter(u=>u.id!==id);
    setAeUpdates(next);

    if(isSupabaseReady()) sbDelete('ae_updates',id).catch(()=>{});
  };

  // ── Audit findings (Policy §5) ─────────────────────────────────────────────
  const findingToSb=f=>({id:f.id,area:f.area||"",finding:f.finding||"",respondent:f.respondent||"",severity:f.severity||"Medium",status:f.status||"Open",issued_by:f.issuedBy||"",issued_at:f.issuedAt||null,reply_due:f.replyDue||null,response:f.response||"",responded_at:f.respondedAt||null,hr_referral:!!f.hrReferral,kpi_impact:f.kpiImpact||"",resolved_at:f.resolvedAt||null});
  const findingFromSb=r=>({...r,issuedBy:r.issued_by,issuedAt:r.issued_at,replyDue:r.reply_due,respondedAt:r.responded_at,hrReferral:r.hr_referral||false,kpiImpact:r.kpi_impact||"",resolvedAt:r.resolved_at});
  const upAudit=fn=>setAuditFindings(p=>{const n=fn(p);persist("gmdv5:auditFindings",n);return n;});
  const addFinding=(data)=>{
    const issued=data.issuedAt||today;
    const entry={...emptyFinding(),...data,id:uid(),issuedBy:session?.name||role,issuedAt:issued,replyDue:addDaysISO(issued,AUDIT_REPLY_DAYS),status:"Open"};
    upAudit(fs=>[entry,...fs]);
    if(isSupabaseReady()) sbInsert('audit_findings',findingToSb(entry)).catch(()=>{});
    logActivity(null,"Audit Finding",`${entry.area}: ${entry.finding}`.slice(0,140),session?.name);
    const amsg=`🔎 <b>Audit Finding Issued</b>\nArea: ${entry.area}\nRespondent: ${entry.respondent||"—"}\nReply due: ${entry.replyDue} (3 days)\n\n${entry.finding}`;
    sendTelegramNotification("management",amsg);
    toastEmit("Audit finding issued — respondent has 3 days to reply","success");
  };
  const updateFinding=(id,ch)=>{
    // Build the persisted payload from the freshly-updated record inside the
    // functional updater, not from the render-closure `auditFindings` snapshot,
    // so back-to-back updates don't overwrite each other in the DB.
    let merged=null;
    upAudit(fs=>fs.map(f=>{if(f.id!==id)return f;merged={...f,...ch};return merged;}));
    if(isSupabaseReady()&&merged) sbUpdate('audit_findings',id,findingToSb(merged)).catch(()=>{});
  };

  const openAward=(deal)=>setAwardModal(deal);
  const confirmAward=async(form)=>{
    if(!awardModal) return;
    const id=awardModal.id;
    // Everything below is wrapped so a failure anywhere in this long chain
    // (JO numbering, project card, budget, notifications, billing schedule)
    // can never leave the Award modal stuck open with the button appearing to
    // do nothing — see the identical issue fixed in saveDeal.
    try{
    // Update deal — payment is Unpaid (Finance will bill separately)
    const awardedDate=form.triggerDate||today;
    const savingToastId=isSupabaseReady()?toastEmit(`⏳ Awarding ${awardModal.client} — saving to server…`,"pending",15000):null;
    // The JO number is the project code and the database issues it: a blank
    // number lets trg_job_orders_adopt_auto keep the JO the deal got when it
    // reached Kickoff (or give a child deal its parent's JO + -01), and
    // trg_job_orders_assign_no number anything else. Read back after sync.
    const joNo="";
    upDeals(ds=>ds.map(d=>d.id===id?{...d,
      stage:"06 · Kickoff",
      probability:100,
      paymentStatus:"Unpaid",
      notes:form.scopeNotes||d.notes,
      dateAcquired:d.dateAcquired||awardedDate,
    }:d));
    // Persist stage change to Supabase before anything else — awaited, not
    // fire-and-forget: this is the write that actually marks the deal as
    // awarded server-side, and a Telegram "PROJECT AWARDED!" notification
    // firing regardless of whether this succeeded is exactly how an award
    // could look confirmed in chat while never actually landing in FabHub.
    // The write bounds itself to ~12s via its own timeout, so this can't hang.
    // Full-record UPSERT, not a partial UPDATE. Awarding is often the first time
    // a deal is written to the server under real network conditions, and if the
    // deal's original save is still sitting in the offline queue (or was dropped),
    // an UPDATE matches zero rows — the deal silently stays absent AND every child
    // write below (job_orders, project_cards, project_budgets) then fails its
    // deal_id foreign key. Those FK violations are "data" errors the sync queue
    // never retries, so the project card and starting budget were lost for good
    // (exactly the cascade of "could not be saved" toasts reported on award).
    // Upserting the whole deal guarantees the parent row exists before any child
    // references it — the same parent-before-child ordering createProjectCard
    // already enforces for its own dept-task children.
    const awardedDeal={...awardModal,
      stage:"06 · Kickoff",
      probability:100,
      paymentStatus:"Unpaid",
      notes:form.scopeNotes||awardModal.notes||"",
      dateAcquired:awardModal.dateAcquired||awardedDate,
    };
    const awardSynced=isSupabaseReady()?await sbSyncOne("deals",awardedDeal,toSbDeal):true;
    if(savingToastId){
      if(awardSynced) toastUpdate(savingToastId,`✅ ${awardModal.client} awarded and saved to server`,"success",3000);
      else toastUpdate(savingToastId,`⚠️ ${awardModal.client} awarded on this device only — didn't reach the server yet. Keep this browser/tab around so it can sync.`,"warning",12000);
    }
    // Create project record — but never for a child/addendum deal, which shares
    // its parent's single project card.
    if(!projs[id]&&!awardedDeal.parentDealId) upProjs(ps=>ps[id]?ps:{...ps,[id]:emptyProject()});
    // Build PM list
    const pms=[form.pm1,form.pm2,form.pm3].filter(Boolean);
    const pmDisplay=pms.join(", ")||"TBA";
    // Create Job Order
    const jo={
      id:uid(), dealId:id,
      joNo,
      client:awardModal.client,
      ceNo:awardModal.ceNo,
      projectName:awardModal.contact||awardModal.client,
      ceType:awardModal.ceType,
      product:awardModal.product,
      value:awardModal.value||0,
      awardTrigger:form.awardTrigger,
      triggerDate:form.triggerDate,
      triggerNote:form.triggerNote,
      pm1:form.pm1, pm2:form.pm2, pm3:form.pm3,
      coordinator:form.coordinator,
      aeAssigned:form.aeAssigned||awardModal.salesOwner,
      startDate:form.startDate,
      commsLink:form.commsLink,
      scopeNotes:form.scopeNotes,
      specialInstructions:form.specialInstructions,
      designer:form.designer||"",
      location:form.location||awardModal.location||"",
      budgetStatus:"QS Budget Pending",
      issuedBy:session?.name||"Manager",
      issuedDate:today,
      status:"Active",
    };
    upJos(js=>[jo,...js]);
    // Each step below tracks its own pass/fail instead of one generic
    // "something failed" — reported as a single, specific summary toast at
    // the end so it's clear exactly which step needs a retry.
    const stepResults=[];
    if(isSupabaseReady()){
      const joOk=await sbSyncOne("job_orders",jo,toSbJO);
      stepResults.push({label:"Job Order",ok:joOk});
      if(joOk){
        try{
          const{data:joRow}=await supabase.from('job_orders').select('jo_no').eq('id',jo.id).maybeSingle();
          if(joRow?.jo_no){jo.joNo=joRow.jo_no;upJos(js=>dropStaleJos([jo],js).map(j=>j.id===jo.id?{...j,joNo:joRow.jo_no}:j));}
        }catch(e){ /* the number still arrives over realtime */ }
      }
    }
    // Create project card with PM/AE pre-populated — awaited so Ops/Sales
    // don't see "awarded" without the department task checklists existing yet.
    // Carry the "Target Turnover Date" entered on the award notice into the
    // project card so Ops sees the turnover date without re-entering it. The
    // award-notice field is stored on the JO as startDate; targetDays is the
    // day count from award → turnover (mirrors setProjectTAT's derivation).
    const awardDateForCard=form.triggerDate||today;
    const turnoverDate=form.startDate||"";
    const turnoverDays=turnoverDate?Math.max(1,Math.ceil((new Date(turnoverDate)-new Date(awardDateForCard))/86400000)):null;
    const cardOk=await createProjectCard(id,{...awardModal,
      // Carry the awarded stage/probability/payment so createProjectCard's
      // parent-deal re-sync writes the AWARDED deal, not awardModal's stale
      // pre-award snapshot (which would revert stage back and orphan the award).
      stage:"06 · Kickoff",
      probability:100,
      paymentStatus:"Unpaid",
      notes:form.scopeNotes||awardModal.notes||"",
      dateAcquired:awardModal.dateAcquired||awardedDate,
      aeAssigned:jo.aeAssigned,
      pm1:jo.pm1||"",
      pm2:jo.pm2||"",
      pm3:jo.pm3||"",
      designer:jo.designer||"",
      coordinator:jo.coordinator||"",
      awardDate:awardDateForCard,
      ...(turnoverDate?{targetEndDate:turnoverDate,targetDays:turnoverDays}:{}),
    });
    stepResults.push({label:"Project Card & Checklists",ok:cardOk});
    // Auto-set QS budget at 30% margin target (70% cost of contract value)
    const contractVal=Number(awardModal.value||0);
    if(contractVal>0){
      const costTarget=contractVal*0.70;
      const budgetOk=await saveBudget(id,{
        Materials: Math.round(costTarget*0.50),
        Labor:     Math.round(costTarget*0.25),
        Overhead:  Math.round(costTarget*0.15),
        Subcon:    Math.round(costTarget*0.10),
        marginTarget:30,
        autoGenerated:true,
        autoGeneratedAt:today,
      },{onlyIfMissing:true});
      stepResults.push({label:"Starting Budget",ok:budgetOk});
    }
    // Log
    logActivity(id,"Project Awarded",`${awardModal.client} — JO ${jo.joNo||"(number pending sync)"} issued. PM: ${pmDisplay}. AE: ${jo.aeAssigned||"—"}. Awarded by: ${session?.name}.`,session?.name);
    // Notify ALL departments
    sendToAllChannels(
      `🏆 <b>PROJECT AWARDED!</b>\n\n` +
      `Client: <b>${awardModal.client}</b>\n` +
      (awardModal.contact?`Project: <b>${awardModal.contact}</b>\n`:"")+
      `${awardModal.ceNo?`CE No: ${awardModal.ceNo} · `:``}${awardModal.ceType||""}\n` +
      (jo.location?`📍 Location: ${jo.location}\n`:"")+
      (botSettings.hideValueInBots?"":(`Value: ₱${contractVal.toLocaleString("en-PH",{maximumFractionDigits:0})}\n`)) +
      `\n👷 PM: ${pmDisplay}\n` +
      `🤝 AE: ${jo.aeAssigned||"—"}\n` +
      (jo.designer?`🎨 Designer: ${jo.designer}\n`:"")+
      `📋 JO: ${jo.joNo||"(number pending sync)"}\n` +
      (jo.startDate?`🗓 Target Turnover: ${jo.startDate}\n`:"")+
      `Awarded by: ${session?.name||"Manager"}\n` +
      (form.scopeNotes?`\n📝 Scope:\n${form.scopeNotes}\n`:"")+
      (form.specialInstructions?`\n⚠️ Special Instructions:\n${form.specialInstructions}\n`:"")+
      `\n🚀 All departments — please mobilize!`
    );
    // Save payment terms if set in Step 3. Billing milestones are NOT generated
    // automatically anymore — instead Jessica (Operations & Sales Admin) is
    // notified that a project was awarded and sets up the billing milestones
    // deliberately through the Set Up Billing Milestones dialogue in Billing.
    if(form.paymentTerms){
      upDeals(ds=>ds.map(d=>d.id===id?{...d,paymentTerms:form.paymentTerms}:d));
      const termsOk=isSupabaseReady()?await sbUpdate('deals',id,{payment_terms_json:JSON.stringify(form.paymentTerms),updated_at:new Date().toISOString()}):true;
      stepResults.push({label:"Payment Terms",ok:termsOk});
    }
    // Notify Jessica to set up the billing milestones for the newly awarded project.
    notifyBillingSetup(id,awardModal.client,contractVal,form.paymentTerms);
    const failedSteps=stepResults.filter(s=>!s.ok);
    if(failedSteps.length) toastEmit(`⚠️ ${awardModal.client} awarded, but needs attention: ${failedSteps.map(f=>f.label).join(", ")} — check console.`,"warning",10000);
    }catch(err){
      console.error("confirmAward failed:",err);
      toastEmit("Award may be incomplete — a follow-up step failed. Check the project card and console.","warning",9000);
    }
    setAwardModal(null);
  };
  const logPayment=({dealId,amount,note,date})=>{
    const amt=Number(amount);
    const d0=deals.find(d=>d.id===dealId);
    const newPaid=Number(d0?.amountPaid||0)+amt;
    const newStatus=newPaid>=Number(d0?.invoiced||0)?"Paid":newPaid>0?"Deposited":"Unpaid";
    upDeals(ds=>ds.map(d=>d.id===dealId?{...d,amountPaid:newPaid,paymentStatus:newStatus}:d));
    // Persist the collection to the server so Finance/Billing reflect it on every device.
    if(isSupabaseReady()) sbUpdate('deals',dealId,{amount_paid:newPaid,payment_status:newStatus}).catch(()=>{});
    const mo=new Date(date).getMonth();
    const inf={id:uid(),month:mo,date:date||today,source:deals.find(d=>d.id===dealId)?.client||"",amount:amt,note,projectId:dealId,dealId};
    upInfs(is=>[...is,inf]);
    if(isSupabaseReady()) sbUpsert("inflows",{id:inf.id,deal_id:dealId,date:inf.date,amount:amt,source:inf.source,note:note||""},"id").catch(()=>{});
  };

  const upProj=(id,fn)=>{
    setProjs(ps=>{
      const proj=fn(ps[id]||emptyProject());
      const updated={...ps,[id]:proj};
      persist(KEYS.projects,updated);
      if(isSupabaseReady()) sbUpsert('projects',{deal_id:id,data:proj,updated_at:new Date().toISOString()},'deal_id').catch(()=>{});
      return updated;
    });
  };
  const proj=selProj?{...emptyProject(),...(projs[selProj]||{})}:null;
  const projDeal=selProj?deals.find(d=>d.id===selProj):null;

  const openAddExp=(projId=null,date=null)=>{
    // Standalone "Log Expense" is retired (Aerwin-model restructure): every new
    // cost now enters as an Other Payable in the AP ledger — a PO/WO covers
    // procurement, this covers non-PO bills (utilities, permits, petty cash).
    // The signature is kept so existing "+ Log Expense" call sites just open the
    // Other Payable form instead. Editing legacy expenses (openEditExp) is
    // unaffected. Guard against being wired directly as an event handler.
    const pid=(projId&&typeof projId==="object")?null:projId;
    setPayForm({...emptyPayForm(),projectId:(pid&&isUUID(pid))?pid:null});
    setEditPayId(null);
    setFinTab("payables");
    setPage("finance");
    setPayModal(true);
  };
  const openEditExp=e=>{setExpForm({...e});setEditExpId(e.id);setExpModal(true);};
  const saveExp=(overrideData)=>{
    const data=overrideData||expForm;
    if(!data.note) return;
    const qty=Number(String(data.qty||1).replace(/,/g,""))||1;
    const price=Number(String(data.pricePerQty||0).replace(/,/g,""))||0;
    const computedAmt=qty*price||Number(String(data.amount||0).replace(/,/g,""))||0;
    if(qty<0||price<0){toastEmit("Quantity and price cannot be negative.","error");return;}
    if(!computedAmt||computedAmt<0){toastEmit(computedAmt<0?"Amount cannot be negative.":"Enter a valid amount.","error");return;}
    const tx=calcInputTax(computedAmt,data.vatable,data.ewtRate);
    const rec={...data,qty,pricePerQty:price,amount:computedAmt,id:editExpId||uid(),vatable:!!data.vatable,ewtRate:tx.ewtRate,inputVat:tx.inputVat,ewtAmount:tx.ewtAmount,netAmount:tx.net};
    upExps(es=>editExpId?es.map(e=>e.id===editExpId?rec:e):[...es,rec]);
    rememberSupplierNames([rec.supplier||rec.payee]);
    if(isSupabaseReady()){
      sbUpsert("expenses",toSbExpense(rec),"id").catch(e=>{
        console.error("FabHub expense save:",e.message);
        toastEmit("⚠️ Expense saved locally but NOT synced to server — do not close this tab!","warning",9000);
      });
    } else {
      toastEmit("⚠️ Expense saved locally only — no server connection. Do not close this tab!","warning",9000);
    }
    setEditExpId(null);
    setExpModal(false);
  };
  const batchSaveExps=(rows)=>{
    const valid=rows.map(data=>{
      if(!data.note?.trim()) return null;
      const qty=Number(String(data.qty||1).replace(/,/g,""))||1;
      const price=Number(String(data.pricePerQty||0).replace(/,/g,""))||0;
      const amt=qty*price;
      if(!amt||amt<0||qty<0||price<0) return null;
      const tx=calcInputTax(amt,data.vatable,data.ewtRate);
      return {...data,qty,pricePerQty:price,amount:amt,id:uid(),acctStatus:"Logged",vatable:!!data.vatable,ewtRate:tx.ewtRate,inputVat:tx.inputVat,ewtAmount:tx.ewtAmount,netAmount:tx.net};
    }).filter(Boolean);
    if(!valid.length) return;
    upExps(es=>[...es,...valid]);
    rememberSupplierNames(valid.map(rec=>rec.supplier||rec.payee));
    if(isSupabaseReady()){valid.forEach(rec=>sbUpsert("expenses",toSbExpense(rec),"id").catch(e=>{console.error("FabHub batch expense:",e.message);toastEmit("⚠️ Some expenses saved locally only — no server sync","warning",9000);}));}
    else{toastEmit("⚠️ Expenses saved locally only — no server connection. Do not close this tab!","warning",9000);}
    setEditExpId(null);
    setExpModal(false);
    toastEmit(`✅ ${valid.length} expense${valid.length!==1?"s":""} logged`,"success");
  };
  const delExp=async id=>{const rec=exps.find(e=>e.id===id);if(!await confirmFinancialDelete("expenses",rec))return;upExps(es=>es.filter(e=>e.id!==id));if(isSupabaseReady()) sbDelete('expenses',id).catch(()=>{});};

  const openAddCv=async()=>{
    const nextNo=await claimDocNumber("CV",vouchers.map(v=>v.cvNo),4,true);
    setCvForm({date:today,cvNo:nextNo,payee:"",amount:"",description:"",projectId:null,bank:"",notes:"",status:"Draft",poRef:"",payableId:null,checkNo:"",clearedDate:"",isCleared:false});
    setEditCvId(null);setCvModal(true);
  };
  const openEditCv=cv=>{setCvForm({...cv});setEditCvId(cv.id);setCvModal(true);};
  const saveCv=()=>{
    if(!cvForm.payee||!cvForm.amount) return;
    const cvAmt=Number(cvForm.amount);
    if(!(cvAmt>0)){toastEmit("Amount must be a positive number.","error");return;}
    const rec={...cvForm,amount:cvAmt,id:editCvId||uid(),createdBy:session?.name||role,createdAt:editCvId?(cvForm.createdAt||today):today};
    upVouchers(vs=>editCvId?vs.map(v=>v.id===editCvId?rec:v):[rec,...vs]);
    if(isSupabaseReady()){
      sbUpsert("check_vouchers",cvToSb(rec),"id").catch(e=>{
        console.error("CV save:",e);
        toastEmit("⚠️ Check Voucher saved locally but NOT synced to server — do not close this tab!","warning",9000);
      });
    } else {
      toastEmit("⚠️ Check Voucher saved locally only — no server connection. Do not close this tab!","warning",9000);
    }
    setEditCvId(null);setCvModal(false);
  };
  const delCv=async id=>{const rec=vouchers.find(v=>v.id===id);if(!await confirmFinancialDelete("check_vouchers",rec))return;upVouchers(vs=>vs.filter(v=>v.id!==id));if(isSupabaseReady()) sbDelete("check_vouchers",id).catch(()=>{});};
  const releaseCv=id=>{
    const releasedBy=session?.name||role;
    const cv=vouchers.find(v=>v.id===id);
    upVouchers(vs=>vs.map(v=>v.id===id?{...v,status:"Released",releasedBy,releasedDate:today}:v));
    if(isSupabaseReady()) sbUpsert("check_vouchers",{id,status:"Released",released_by:releasedBy,released_date:today},"id").catch(()=>{});
    if(cv?.payableId){
      // Releasing the check pays the linked bill's open balance — recorded as a
      // payment row (method Check) so it shows in the bill's history and the
      // check register, and can be cancelled with a reason if the check bounces.
      const linked=payables.find(p=>p.id===cv.payableId);
      const bal=linked?Math.round(((Number(linked.amount)||0)-(Number(linked.paidAmount)||0))*100)/100:0;
      if(linked&&bal>0) recordPayablePayment(linked.id,bal,{date:today,method:"Check",bank:cv.bank||"",ref:cv.checkNo||cv.cvNo||"",cvId:cv.id,note:`Released via ${cv.cvNo||"check voucher"}`});
    }
    // Reflect payment on the originating expense so the log shows "Paid" rather than "Logged".
    const paidExpId=cv?.sourceExpenseId||(payables.find(p=>p.id===cv?.payableId)||{}).expenseId;
    if(paidExpId) markExpensePaid(paidExpId);
  };
  const clearCv=async id=>{
    const cv=vouchers.find(v=>v.id===id);
    let checkNo=cv?.checkNo||"";
    if(!checkNo){
      const input=(await uiPrompt("Enter check number for bank clearance:"));
      if(input===null) return;
      checkNo=input.trim();
    }
    const patch={is_cleared:true,cleared_date:today,...(checkNo?{check_no:checkNo}:{})};
    upVouchers(vs=>vs.map(v=>v.id===id?{...v,isCleared:true,clearedDate:today,...(checkNo?{checkNo}:{})}:v));
    if(isSupabaseReady()) sbUpsert("check_vouchers",{id,...patch},"id").catch(()=>{});
  };
  const submitCvForRelease=id=>{
    upVouchers(vs=>vs.map(v=>v.id===id?{...v,status:"For Release"}:v));
    if(isSupabaseReady()) sbUpsert("check_vouchers",{id,status:"For Release"},"id").catch(()=>{});
  };
  const voidCv=id=>{
    upVouchers(vs=>vs.map(v=>v.id===id?{...v,status:"Void"}:v));
    if(isSupabaseReady()) sbUpsert("check_vouchers",{id,status:"Void"},"id").catch(()=>{});
  };

  const upPayables=fn=>{const next=fn(payables);setPayables(next);persist(KEYS.payables,next);};
  // Set just the due date on a payable (used by the due-date backfill dialog) and sync it.
  const setPayableDueDate=(id,dueDate)=>{
    let updated=null;
    upPayables(ps=>ps.map(p=>{if(p.id!==id)return p;updated={...p,dueDate};return updated;}));
    if(updated&&isSupabaseReady()) sbUpsert("payables",payableToSb(updated),"id").catch(()=>{});
  };

  // ── Commission payouts (what Finance has disbursed to each rep) ─────────────
  const upPayouts=fn=>{const next=fn(payouts);setPayouts(next);persist(KEYS.payouts,next);};
  // Finance records a lump payout for a rep/period. It starts "Recorded" and
  // only counts as paid once a Manager approves it.
  const recordPayout=async(rec)=>{
    if(!await guardWrite("insert","commission_payouts","record a commission payout")) return;
    const row={id:uid(),payee:rec.payee||"",periodLabel:rec.periodLabel||"",periodStart:rec.periodStart||null,periodEnd:rec.periodEnd||null,
      amount:Number(rec.amount)||0,status:"Recorded",payBank:rec.payBank||"",payMethod:rec.payMethod||"",payRef:rec.payRef||"",notes:rec.notes||"",
      recordedBy:session?.name||"",recordedAt:new Date().toISOString(),approvedBy:"",approvedAt:null,createdAt:new Date().toISOString()};
    upPayouts(ps=>[row,...ps]);
    if(isSupabaseReady()) sbUpsert("commission_payouts",commissionPayoutToSb(row),"id")
      .catch(e=>{console.error("commission_payouts sync:",e.message);toastEmit("⚠️ Payout saved locally but NOT synced to server.","warning",8000);});
    toastEmit("Commission payout recorded — pending Manager approval.","success");
  };
  // Manager approves a recorded payout, which makes it count as paid.
  const approvePayout=async(id)=>{
    if(role!=="Manager"){toastEmit("Only a Manager can approve payouts.","warning");return;}
    const patch={status:"Approved",approvedBy:session?.name||"",approvedAt:new Date().toISOString()};
    upPayouts(ps=>ps.map(p=>p.id===id?{...p,...patch}:p));
    if(isSupabaseReady()) sbUpsert("commission_payouts",{id,...commissionPayoutToSb({...patch})},"id").catch(()=>{});
    toastEmit("Payout approved.","success");
  };
  const voidPayout=async(id)=>{
    if(!await guardWrite("update","commission_payouts","void a commission payout")) return;
    if(!await uiConfirm("Void this commission payout? It will no longer count as paid.")) return;
    upPayouts(ps=>ps.map(p=>p.id===id?{...p,status:"Void"}:p));
    if(isSupabaseReady()) sbUpsert("commission_payouts",{id,status:"Void"},"id").catch(()=>{});
  };
  // AP / PRV numbers (AP-YYYY-NNNN, PRV-YYYY-NNNN) are assigned by the server
  // when a payable is first inserted (trigger payables_assign_number, migration
  // 20260930140000). Numbering on each device produced 102 duplicate AP numbers.
  // The Accounts Payable Voucher (APV) is the approval/support document raised
  // when a payable is logged — BEFORE payment (vs. the Check Voucher, raised AT
  // payment). FabHub derives its number 1:1 from the payable's AP number, so the
  // payable itself is the APV — no separate record or numbering series needed.
  const apvNoFor=p=>{const n=String(p?.apNumber||"");return n?n.replace(/^AP-/,"APV-"):("APV-"+String(p?.id||"").slice(0,6));};
  const printAPV=(p)=>{
    if(!p) return;
    const esc=s=>String(s==null?"":s).replace(/[&<>]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;"}[c]));
    const pesos=n=>"PHP "+Number(n||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
    const acct=chartOfAccounts.find(a=>String(a.code)===String(p.accountCode));
    const acctLabel=acct?`${acct.code} — ${acct.name}`:(p.accountCode||"—");
    const proj=(wonDeals.find(d=>d.id===p.projectId)||completedDeals.find(d=>d.id===p.projectId));
    const bal=Math.max(0,(Number(p.amount)||0)-(Number(p.paidAmount)||0));
    const payStatus=p.status==="Paid"?"Paid":`${p.status||"Unpaid"}${bal>0?" (Balance "+pesos(bal)+")":""}`;
    const row=(l,val)=>`<tr><td class="lbl">${esc(l)}</td><td class="val">${esc(val)||"—"}</td></tr>`;
    const html=`<!doctype html><html><head><meta charset="utf-8"><title>${esc(apvNoFor(p))}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Inter',-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#1B2430;padding:40px;background:#fff}
  .doc{max-width:660px;margin:0 auto;border:1.5px solid #0B2545;border-radius:8px;padding:32px 34px;position:relative;overflow:hidden}
  .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #C9A24B;padding-bottom:14px;margin-bottom:18px;position:relative}
  .co{font-size:1.2rem;font-weight:800;color:#0B2545}
  .co small{display:block;font-size:.7rem;font-weight:400;color:#5B6472;margin-top:3px}
  .cvlbl{font-size:.62rem;letter-spacing:.05em;color:#5B6472;text-transform:uppercase;text-align:right}
  .cvno{font-size:1.15rem;font-weight:800;color:#A8822F;text-align:right}
  table{width:100%;border-collapse:collapse;position:relative}
  td{padding:6px 0;font-size:.86rem;vertical-align:top}
  td.lbl{color:#5B6472;width:170px;font-weight:600}
  td.val{font-weight:600;color:#1B2430}
  .amt{margin:16px 0;border:1px solid #DCE2EC;border-radius:8px;padding:14px 16px;display:flex;justify-content:space-between;align-items:center;background:#EEF2F8;position:relative}
  .amt .k{font-size:.78rem;color:#5B6472;font-weight:600}
  .amt .v{font-size:1.4rem;font-weight:800;color:#0B2545}
  .je{background:#fff;border:1px solid #DCE2EC;border-radius:8px;padding:10px 14px;margin-bottom:14px;font-size:.78rem;position:relative}
  .je .t{font-weight:700;color:#0B2545;font-size:.68rem;text-transform:uppercase;letter-spacing:.04em;margin-bottom:5px}
  .je .l{display:flex;justify-content:space-between;padding:2px 0}
  .je .l.cr span:first-child{padding-left:18px;color:#5B6472}
  .je .l.cr span:last-child{color:#5B6472}
  .sig{display:grid;grid-template-columns:1fr 1fr 1fr;gap:18px;margin-top:26px;position:relative}
  .sig .b{text-align:center;border-top:1px solid #1B2430;padding-top:5px;font-size:.68rem;color:#5B6472}
  .wm{position:absolute;top:44%;left:50%;transform:translate(-50%,-50%) rotate(-18deg);font-size:38px;font-weight:800;color:rgba(11,37,69,0.05);white-space:nowrap;pointer-events:none}
  @media print{body{padding:0}}
</style></head><body>
<div class="doc">
  <div class="wm">GMD PRODUCTION INC.</div>
  <div class="top">
    <div class="co">GMD PRODUCTION INC.<small>Marikina City, Metro Manila, Philippines · TIN 010-063-229-00000</small></div>
    <div><div class="cvlbl">Accounts Payable Voucher No.</div><div class="cvno">${esc(apvNoFor(p))}</div></div>
  </div>
  <table>
    ${row("Date",p.invoiceDate||p.createdAt)}
    ${row("Payee / Vendor",p.vendor)}
    ${row("Particulars",p.notes||p.invoiceNumber||p.invoiceRef)}
    ${p.poNumber?row("PO Reference",p.poNumber):""}
    ${row("AP Reference",p.apNumber)}
    ${proj?row("Project",projDisplayName(proj)):""}
    ${row("Account to be Charged",acctLabel)}
    ${row("Due Date",p.dueDate)}
    ${row("Payment Status",payStatus)}
  </table>
  <div class="amt"><span class="k">Amount</span><span class="v">${pesos(p.amount)}</span></div>
  <div class="je">
    <div class="t">Accounting Entry</div>
    <div class="l"><span>Dr &nbsp;${esc(acctLabel)}</span><span>${pesos(p.amount)}</span></div>
    <div class="l cr"><span>Cr &nbsp;2000 — Accounts Payable - Trade</span><span>${pesos(p.amount)}</span></div>
  </div>
  <div class="sig">
    <div class="b">Prepared by — Finance</div>
    <div class="b">Checked by — Accounting</div>
    <div class="b">Approved by — Management</div>
  </div>
</div>
</body></html>`;
    const w=window.open("","_blank","width=760,height=800");
    if(w){w.document.write(html);w.document.close();addPrintClose(w);setTimeout(()=>w.print(),500);}
  };
  // Days-based aging for the AP log. Negative days = overdue; positive = remaining.
  // Mirrors the finance team's "30d left" / overdue read-out.
  const payableAging=(p)=>{
    if(!p.dueDate) return {label:"—",clr:"#94a3b8",overdue:false,days:null};
    const d=Math.round((new Date(p.dueDate)-new Date(today))/86400000);
    if(d<0)  return {label:`${Math.abs(d)}d overdue`,clr:"#ef4444",overdue:true,days:d};
    if(d===0)return {label:"Due today",clr:"#f97316",overdue:false,days:0};
    return {label:`${d}d left`,clr:d<=7?"#f59e0b":"#64748b",overdue:false,days:d};
  };
  // Printable Check Voucher document — the finance team's CV format, showing both
  // the PO Reference and AP Reference so a signed voucher ties back to procurement.
  const printCheckVoucher=(v)=>{
    if(!v) return;
    const esc=s=>String(s==null?"":s).replace(/[&<>]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;"}[c]));
    const pesos=n=>"PHP "+Number(n||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
    const bankName=(()=>{const b=(BANKS||[]).find(x=>x.id===v.bank||x.short===v.bank||x.name===v.bank);return b?b.name:(v.bank||"—");})();
    const linkedPay=payables.find(p=>p.id===v.payableId);
    const apRef=v.apRef||linkedPay?.apNumber||"—";
    const row=(l,val)=>`<tr><td class="lbl">${esc(l)}</td><td class="val">${esc(val)||"—"}</td></tr>`;
    const html=`<!doctype html><html><head><meta charset="utf-8"><title>${esc(v.cvNo||"Check Voucher")}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Inter',-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#1B2430;padding:40px;background:#fff}
  .doc{max-width:660px;margin:0 auto;border:1.5px solid #0B2545;border-radius:8px;padding:32px 34px;position:relative;overflow:hidden}
  .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #C9A24B;padding-bottom:14px;margin-bottom:18px;position:relative}
  .co{font-size:1.2rem;font-weight:800;color:#0B2545}
  .co small{display:block;font-size:.7rem;font-weight:400;color:#5B6472;margin-top:3px}
  .cvlbl{font-size:.62rem;letter-spacing:.05em;color:#5B6472;text-transform:uppercase;text-align:right}
  .cvno{font-size:1.15rem;font-weight:800;color:#A8822F;text-align:right}
  table{width:100%;border-collapse:collapse;position:relative}
  td{padding:6px 0;font-size:.86rem;vertical-align:top}
  td.lbl{color:#5B6472;width:150px;font-weight:600}
  td.val{font-weight:600;color:#1B2430}
  .amt{margin:16px 0;border:1px solid #DCE2EC;border-radius:8px;padding:14px 16px;display:flex;justify-content:space-between;align-items:center;background:#EEF2F8;position:relative}
  .amt .k{font-size:.78rem;color:#5B6472;font-weight:600}
  .amt .v{font-size:1.4rem;font-weight:800;color:#0B2545}
  .je{background:#fff;border:1px solid #DCE2EC;border-radius:8px;padding:10px 14px;margin-bottom:14px;font-size:.78rem;position:relative}
  .je .t{font-weight:700;color:#0B2545;font-size:.68rem;text-transform:uppercase;letter-spacing:.04em;margin-bottom:5px}
  .je .l{display:flex;justify-content:space-between;padding:2px 0}
  .je .l.cr span:first-child{padding-left:18px;color:#5B6472}
  .je .l.cr span:last-child{color:#5B6472}
  .sig{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-top:26px;position:relative}
  .sig .b{text-align:center;border-top:1px solid #1B2430;padding-top:5px;font-size:.7rem;color:#5B6472}
  .wm{position:absolute;top:44%;left:50%;transform:translate(-50%,-50%) rotate(-18deg);font-size:38px;font-weight:800;color:rgba(11,37,69,0.05);white-space:nowrap;pointer-events:none}
  @media print{body{padding:0}}
</style></head><body>
<div class="doc">
  <div class="wm">GMD PRODUCTION INC.</div>
  <div class="top">
    <div class="co">GMD PRODUCTION INC.<small>Marikina City, Metro Manila, Philippines · TIN 010-063-229-00000</small></div>
    <div><div class="cvlbl">Check Voucher No.</div><div class="cvno">${esc(v.cvNo||"—")}</div></div>
  </div>
  <table>
    ${row("Date",v.date)}
    ${row("Payee",v.payee)}
    ${row("Particulars",v.description)}
    ${row("PO Reference",v.poRef)}
    ${row("AP Reference",apRef)}
    ${row("Bank",bankName)}
    ${row("Check Number",v.checkNo)}
  </table>
  <div class="amt"><span class="k">Amount</span><span class="v">${pesos(v.amount)}</span></div>
  <div class="je">
    <div class="t">Accounting Entry</div>
    <div class="l"><span>Dr &nbsp;2000 — Accounts Payable - Trade</span><span>${pesos(v.amount)}</span></div>
    <div class="l cr"><span>Cr &nbsp;${esc(bankName)}</span><span>${pesos(v.amount)}</span></div>
  </div>
  <div class="sig">
    <div class="b">Prepared by — Finance</div>
    <div class="b">Approved by — Management</div>
  </div>
</div>
</body></html>`;
    const w=window.open("","_blank","width=760,height=800");
    if(w){w.document.write(html);w.document.close();addPrintClose(w);setTimeout(()=>w.print(),500);}
  };
  // One payable per issued PO (keyed by poId = PO number). Created when a PO is
  // issued and kept in sync when it's edited; the delivery/receive flow reconciles
  // the SAME payable (stamps a due date, links the receipt expense) rather than
  // creating a duplicate. `lines` is the PO's current line items (PR-shaped).
  const syncPoPayable=(poNo,lines)=>{
    if(!poNo) return null;
    const active=(lines||[]).filter(p=>p.poNumber===poNo&&p.status!=="Cancelled");
    const existing=payables.find(p=>p.poId===poNo);
    const issued=active.some(p=>["PO Issued","Partially Delivered","Delivered"].includes(p.status));
    if(!issued) return existing||null; // still Draft/Pending — no payable yet
    // True amount owed: gross − PO-level discount (+ VAT), the shared poTotals
    // formula the printed PO, the PO list and project cost use. Actual unit cost
    // wins over the estimate once it's known.
    const amount=poTotals(active).total;
    if(!(amount>0)) return existing||null;
    // Only link a real deal UUID — a free-typed project name would be written to
    // the payable's uuid project_id column and silently fail to sync.
    const linkedProjectId=active.find(x=>x.projectId&&x.projectId!=="__gmd_stocks__"&&isUUID(x.projectId))?.projectId||null;
    const supplier=active[0]?.supplier||"";
    if(existing){
      if(existing.status==="Paid") return existing; // never disturb a settled payable
      const upd={...existing,amount,vendor:supplier||existing.vendor,projectId:linkedProjectId||existing.projectId};
      upPayables(ps=>ps.map(p=>p.id===existing.id?upd:p));
      if(isSupabaseReady()&&isUUID(existing.id)) sbUpsert("payables",payableToSb(upd),"id").catch(()=>{});
      return upd;
    }
    const rec={id:uid(),apNumber:"",vendor:supplier, /* AP no. assigned by the server on insert (migration 20260930140000) */amount,paidAmount:0,dueDate:"",category:"Supplier",
      accountCode:active[0]?.accountCode||"5020", // default: 5020 Production Supplies (5000 is Warehouse Rental in the chart)
      invoiceRef:poNo,invoiceNumber:"",invoiceDate:"",notes:`Auto-created from PO ${poNo}`,projectId:linkedProjectId,
      poNumber:poNo,poId:poNo,status:"Unpaid",verified:false,verificationPct:0,createdAt:today,createdBy:session?.name||""};
    upPayables(ps=>[rec,...ps]);
    if(isSupabaseReady()) sbUpsert("payables",payableToSb(rec),"id").catch(()=>{});
    return rec;
  };
  // Work Order → Accounts Payable. Mirrors syncPoPayable for subcontractor Work
  // Orders so both procurement doors (PO to suppliers, WO to subcontractors) land
  // in the one AP ledger. Keyed by woNumber; account code defaults to 5070
  // (Production - Subcon). The full contract is the liability — retention (the
  // WO's rate, else AP_RULES.subconRetentionPct) is held back at payment time.
  const syncWoPayable=(wo)=>{
    if(!wo||!wo.woNumber) return null;
    const amount=Math.round((Number(wo.contractAmount)||0)*100)/100;
    const committed=["Issued","Partially Delivered","Delivered","Completed","For Accounting"].includes(wo.status);
    const existing=payables.find(p=>p.poId===wo.woNumber);
    if(!committed||!(amount>0)) return existing||null;
    const linkedProjectId=(wo.projectId&&isUUID(wo.projectId))?wo.projectId:(wo.dealId&&isUUID(wo.dealId)?wo.dealId:null);
    const vendor=wo.subcontractor||"Subcontractor";
    if(existing){
      if(existing.status==="Paid") return existing;
      const upd={...existing,amount,vendor,projectId:linkedProjectId||existing.projectId,retentionPct:Number(wo.retentionPct)||0};
      upPayables(ps=>ps.map(p=>p.id===existing.id?upd:p));
      if(isSupabaseReady()&&isUUID(existing.id)) sbUpsert("payables",payableToSb(upd),"id").catch(()=>{});
      return upd;
    }
    const rec={id:uid(),apNumber:"",vendor,amount,paidAmount:0,dueDate:"",category:"Subcontractor",
      accountCode:wo.accountCode||"5070", // 5070 Production - Subcon (5200 is Load Allowance in the chart)
      retentionPct:Number(wo.retentionPct)||0,
      invoiceRef:wo.woNumber,invoiceNumber:"",invoiceDate:"",notes:`Auto-created from Work Order ${wo.woNumber}`,projectId:linkedProjectId,
      poNumber:wo.woNumber,poId:wo.woNumber,status:"Unpaid",verified:false,verificationPct:0,createdAt:today,createdBy:session?.name||""};
    upPayables(ps=>[rec,...ps]);
    if(isSupabaseReady()) sbUpsert("payables",payableToSb(rec),"id").catch(()=>{});
    return rec;
  };
  // The database refuses a likely duplicate bill or payment (AP safety net,
  // migration 20261102113419): DUPLICATE_BLOCK always, DUPLICATE_REVIEW unless a
  // Manager gives a reason. Returns the Manager's reason, or null after
  // explaining the refusal.
  const dupText=m=>String(m||"").replace(/^[\s\S]*?DUPLICATE_(BLOCK|REVIEW):\s*/,"");
  const askDupOverride=async(res)=>{
    const text=dupText(res.message);
    if(res.duplicate==="review"&&role==="Manager"){
      const r=await uiPrompt(`${text}\n\nIf this is not a duplicate, give the reason. It is kept in the audit log.`,"");
      return String(r||"").trim()||null;
    }
    await uiAlert({title:res.duplicate==="block"?"Not saved: duplicate":"Not saved: needs a Manager",message:text});
    return null;
  };
  const savePayable=async(data)=>{
    if(!data.vendor||!data.amount) return;
    if(!String(data.accountCode||"").trim()){toastEmit("Select a Chart-of-Accounts code before saving — it drives the financial statements.","error");return;}
    // Payment request (PRV) for subcontractor work. The Excel log paid ₱492K of
    // subcontractor PRVs with no Work Order, so Operations never confirmed the
    // work. A PRV linked to a WO that already has its own bill would pay the same
    // work twice — pay that bill instead.
    if(data.docType==="PRV"&&isSubconPayable(data)){
      const wo=String(data.poNumber||"").trim();
      if(wo){
        const woBill=payables.find(p=>p.poId===wo&&p.id!==editPayId);
        if(woBill){toastEmit(`${wo} already has its own bill${woBill.apNumber?` (${woBill.apNumber})`:""}. Record the payment on that bill instead of a new payment request, so the work isn't paid twice.`,"error",9000);return;}
      }
    }
    // D3: subcontractor work of ₱50,000+ must go through a Work Order (either
    // document type, so switching PRV to AP doesn't get around it). The limit is
    // cumulative per subcontractor over AP_RULES.subconNoWoWindowDays, so it
    // can't be split into smaller requests.
    const woBlock=subconNoWoBlock(data,editPayId?payables.find(p=>p.id===editPayId):null,payables);
    if(woBlock){
      const lim="₱"+AP_RULES.subconNoWoLimit.toLocaleString("en-PH");
      toastEmit(woBlock.others>0
        ?`${data.vendor} already has ${fmt(woBlock.others)} of subcontractor payables with no Work Order in the last ${AP_RULES.subconNoWoWindowDays} days. With this one it's ${fmt(woBlock.total)}, over the ${lim} limit. Create a Work Order for this work: its bill is created automatically.`
        :`Subcontractor payables of ${lim} or more need a Work Order, so Operations can confirm the work before it's paid. Create the Work Order first: its bill is created automatically.`,"error",12000);
      return;
    }
    // Duplicate guard (new payables only) — the AP ledger has no unique key, so the
    // same supplier invoice can be entered twice and double-paid. Warn before saving
    // a likely repeat: same vendor + same amount, matched on invoice number when both
    // sides have one (strong signal) or on invoice date when neither does (soft).
    // Bypassable, because genuine identical recurring bills do occur.
    if(!editPayId){
      const norm=s=>String(s||"").trim().toLowerCase().replace(/\s+/g," ");
      const dupAmt=Math.round((Number(data.amount)||0)*100)/100;
      const inv=norm(data.invoiceNumber);
      const dup=payables.find(p=>{
        if(norm(p.vendor)!==norm(data.vendor)) return false;
        if(Math.round((Number(p.amount)||0)*100)/100!==dupAmt) return false;
        const pInv=norm(p.invoiceNumber);
        if(inv&&pInv) return pInv===inv;                                  // both have invoice # → match on it
        if(!inv&&!pInv) return (p.invoiceDate||"")===(data.invoiceDate||""); // neither → match on invoice date
        return false;                                                     // one has #, the other doesn't → not a match
      });
      if(dup){
        const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
        const ok=await uiConfirm({title:"Possible duplicate payable",tone:"warning",confirmLabel:"Save anyway",cancelLabel:"Go back",
          message:`A payable for ${data.vendor||"this vendor"} of ${peso(dupAmt)} already exists`+
            (dup.invoiceNumber?` (Invoice ${dup.invoiceNumber})`:"")+
            (dup.apNumber?` · ${dup.apNumber}`:"")+
            (dup.createdAt?` · entered ${dup.createdAt}`:"")+
            `.\n\nThis looks like the same bill entered twice — entering it again would double the amount owed. Save it anyway?`});
        if(!ok) return;
      }
    }
    // Due date drives the cash-flow forecast — nudge (don't hard-block) if missing.
    if(!String(data.dueDate||"").trim()){
      const ok=await uiConfirm({title:"No due date set",tone:"warning",confirmLabel:"Save without due date",cancelLabel:"Go back & set it",
        message:"This payable has no due date, so the Cash-Flow Forecast will treat it as due now instead of scheduling it. Set a due date for an accurate projection.\n\nSave anyway?"});
      if(!ok) return;
    }
    const amount=Number(data.amount);
    const paidAmount=Number(data.paidAmount)||0;
    // Derive status from what's actually been paid so a manually entered payable
    // with a partial prior payment shows correctly, just like the finance ERP.
    const derived=paidAmount<=0?"Unpaid":paidAmount>=amount?"Paid":"Partial";
    // BIR: derive VAT (amount is VAT-inclusive when vatable) + EWT on the net.
    const vatable=!!data.vatable;
    const netAmount=vatable?Math.round(amount/1.12*100)/100:amount;
    const inputVat=vatable?Math.round((amount-netAmount)*100)/100:0;
    const ewtRate=Number(data.ewtRate)||0;
    const ewtAmount=ewtRate>0?Math.round(netAmount*ewtRate/100*100)/100:0;
    // Approval gate: a new payable enters as Pending and cannot be paid until a
    // Manager or Finance Manager approves it. Editing preserves the existing
    // decision — UNLESS the amount changed after approval, which resets it to
    // Pending so a larger amount can't ride an old approval.
    let approvalStatus="Pending",approvedBy="",approvedAt=null;
    if(editPayId){
      const prev=payables.find(p=>p.id===editPayId);
      const amtChanged=prev&&Math.round((Number(prev.amount)||0)*100)/100!==Math.round(amount*100)/100;
      if(prev&&prev.approvalStatus==="Approved"&&amtChanged){approvalStatus="Pending";approvedBy="";approvedAt=null;}
      else{approvalStatus=prev?.approvalStatus||"Pending";approvedBy=prev?.approvedBy||"";approvedAt=prev?.approvedAt||null;}
    }
    const rec={...data,amount,paidAmount,vatable,netAmount,inputVat,ewtRate,ewtAmount,tin:data.tin||"",approvalStatus,approvedBy,approvedAt,
      apNumber:data.apNumber||"", // blank → the server assigns AP-YYYY-NNNN / PRV-YYYY-NNNN on insert
      docType:data.docType==="PRV"?"PRV":"AP",
      id:editPayId||uid(),status:editPayId?derived:(paidAmount>0?derived:"Unpaid"),
      paidDate:derived==="Paid"?(data.paidDate||today):(data.paidDate||""),
      createdAt:editPayId?data.createdAt:today,createdBy:editPayId?(data.createdBy||session?.name||""):session?.name||""};
    if(isSupabaseReady()){
      let res=await sbUpsertDetailed("payables",payableToSb(rec),"id");
      if(res.duplicate){
        const reason=await askDupOverride(res);
        if(!reason) return;
        rec.dupOverrideReason=reason;
        res=await sbUpsertDetailed("payables",payableToSb(rec),"id");
        if(res.duplicate){await uiAlert({title:"Not saved",message:dupText(res.message)});return;}
      }
      if(!res.ok) toastEmit("⚠️ Payable saved locally but NOT synced to server — do not close this tab!","warning",9000);
    } else {
      toastEmit("⚠️ Payable saved locally only — no server connection. Do not close this tab!","warning",9000);
    }
    upPayables(ps=>editPayId?ps.map(p=>p.id===editPayId?rec:p):[rec,...ps]);
    setPayModal(false);setEditPayId(null);setPayForm(emptyPayForm());
  };
  // Verification gate: a PO/WO-sourced payable is locked from payment until the
  // receiving side signs off — Warehouse for Materials, Operations (% complete)
  // for Subcontractor. Manual Other Payables are verified by default.
  const payIsSubcon=isSubconPayable; // category Subcontractor, or account 5070 / 5100 (or the old 5200 default)
  const payNeedsVerify=p=>p&&!!(p.poId||p.poNumber); // only PO/WO-sourced payables are gated
  const subconCertified=p=>!!(p&&p.verified&&String(p.verifiedBy||"").trim()&&(Number(p.verificationPct)||0)>0);
  const verifyPayable=async (id)=>{
    const p=payables.find(x=>x.id===id); if(!p) return;
    // Subcon work is certified by the project PM / Operations on the Subcon
    // Billing page (certify_subcon_billing); the database ignores any other
    // change to these fields (migration 20261027160000).
    if(payIsSubcon(p)){toastEmit("Subcontractor work is certified by the project PM or Operations on the Subcon Billing page — no payment until they do.","info",8000);return;}
    const pct=100;
    if(!(await uiConfirm(`Confirm Warehouse received the items for ${p.vendor||"this vendor"}${p.apNumber?` (${p.apNumber})`:""}? This unlocks it for payment.`))) return;
    const upd={...p,verified:true,verificationPct:pct,verifiedBy:session?.name||"",verifiedAt:today};
    upPayables(ps=>ps.map(x=>x.id===id?upd:x));
    if(isSupabaseReady()&&isUUID(id)) sbUpsert("payables",payableToSb(upd),"id").catch(()=>{});
    toastEmit("Warehouse receipt verified — now payable.","success");
  };
  // ── Expense/payable approval gate ────────────────────────────────────────
  // Only a Manager or the Finance Manager (Finance role) may approve a payable
  // for payment. Approval is separate from receiving-verification: verification
  // confirms goods/work arrived; approval authorizes the spend. A payable must
  // be Approved before it can be paid or routed to a check voucher.
  // Named individuals granted payable-approval WITHOUT holding the Finance role,
  // mirroring the by-username deal-delete grantees (migrations 033/034). Keeps a
  // FinanceAssistant's role intact while lending them Finance-Manager approval
  // authority — used for Mark Acejo during Aerwin's turnover. Must stay in sync
  // with the DB gate in supabase_migration_065 (enforce_payable_approval).
  const PAYABLE_APPROVAL_GRANTEES=["mark"];
  const canApprovePayables=["Manager","Finance"].includes(role)
    || PAYABLE_APPROVAL_GRANTEES.includes((session?.username||"").toLowerCase());
  const payApproved=p=>((p?.approvalStatus)||"Approved")==="Approved"; // legacy rows (no field) treated as approved
  const approvePayable=async(id)=>{
    const p=payables.find(x=>x.id===id); if(!p) return;
    if(!canApprovePayables){toastEmit("Only a Manager or the Finance Manager can approve a payable.","error");return;}
    // Block self-approval — the person who entered it can't clear it (Manager may override).
    const nm=s=>String(s||"").trim().toLowerCase();
    if(role!=="Manager"&&nm(p.createdBy)===nm(session?.name)&&nm(p.createdBy)!==""){
      toastEmit("You entered this payable — another Manager or Finance approver must review it.","error",7000);return;
    }
    if(payIsSubcon(p)&&!subconCertified(p)){toastEmit(`${p.vendor||"This subcontractor"}${p.apNumber?` (${p.apNumber})`:""} isn't certified by the project PM or Operations yet — no approval until they certify the work done.`,"error",8000);return;}
    if(!(await uiConfirm(`Approve ${p.vendor||"this payable"}${p.apNumber?` (${p.apNumber})`:""} for ₱${Number(p.amount||0).toLocaleString("en-PH",{minimumFractionDigits:2})}? This clears it for payment.`))) return;
    const upd={...p,approvalStatus:"Approved",approvedBy:session?.name||role,approvedAt:today};
    upPayables(ps=>ps.map(x=>x.id===id?upd:x));
    if(isSupabaseReady()&&isUUID(id)) sbUpsert("payables",payableToSb(upd),"id").catch(()=>{toastEmit("⚠️ Approval saved locally but NOT synced — do not close this tab!","warning",9000);});
    toastEmit(`✅ Approved — ${p.vendor||"payable"} is now cleared for payment.`,"success");
  };
  const rejectPayable=async(id)=>{
    const p=payables.find(x=>x.id===id); if(!p) return;
    if(!canApprovePayables){toastEmit("Only a Manager or the Finance Manager can reject a payable.","error");return;}
    const reason=await uiPrompt("Reason for rejecting this payable (kept on record):","");
    if(reason==null) return;
    const upd={...p,approvalStatus:"Rejected",approvedBy:session?.name||role,approvedAt:today,notes:(p.notes?p.notes+" · ":"")+"REJECTED: "+(reason||"(no reason given)")};
    upPayables(ps=>ps.map(x=>x.id===id?upd:x));
    if(isSupabaseReady()&&isUUID(id)) sbUpsert("payables",payableToSb(upd),"id").catch(()=>{toastEmit("⚠️ Rejection saved locally but NOT synced — do not close this tab!","warning",9000);});
    toastEmit("Payable rejected — it can be edited and re-submitted.","info");
  };
  // ── Payment history (payable_payments) ─────────────────────────────────────
  // Every payment is its own row: one check paying 15 bills is 15 rows sharing a
  // batchId; a second payment on the same bill is another row, not a new invoice
  // number; a mistake is Cancelled with a reason and stays on record. The payable's
  // paid / retention / status figures are recomputed from its Active rows, here
  // for the screen and by the database trigger for the record (migration
  // 20260930140000), so a cancelled check can never count as paid.
  const r2=v=>Math.round((Number(v)||0)*100)/100;
  const pesoFmt=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
  const paysOf=id=>payPays.filter(x=>x.payableId===id);
  // entries: [{payableId, amount (cash), retentionAmount?, kind?}]
  // common:  {date, method, bank, ref, note?, cvId?}
  const recordPayments=async(entries,common={})=>{
    if(!roleCanInsert("payable_payments")){toastEmit("Only Finance, Accounting or a Manager can record payments.","error",7000);return false;}
    const list=(entries||[]).filter(e=>r2(e.amount)+r2(e.retentionAmount)>0);
    if(!list.length) return false;
    for(const e of list){
      const p=payables.find(x=>x.id===e.payableId);
      if(!p){toastEmit("That payable no longer exists — refresh and try again.","error");return false;}
      // Approval gate — enforced here for every pay surface, and again by the DB guard.
      // Subcon: paid only up to the PM-certified % (payable_payments_subcon_gate).
      if(payIsSubcon(p)&&e.kind!=="Retention release"){
        if(!subconCertified(p)){toastEmit(`${p.vendor||"This subcontractor"}${p.apNumber?` (${p.apNumber})`:""} isn't certified by the project PM or Operations — no payment.`,"error",8000);return false;}
        const wo=(swos||[]).find(w=>w.woNumber&&w.woNumber===p.poNumber);
        const base=Number(wo?.contractAmount)>0?Number(wo.contractAmount):Number(p.amount)||0;
        const cap=Math.round((Number(p.verificationPct)||0)/100*base*100)/100;
        const claimed=paysOf(p.id).filter(x=>x.status!=="Cancelled"&&x.kind!=="Retention release").reduce((s,x)=>s+r2(x.amount)+r2(x.retentionAmount),0)+r2(e.amount)+r2(e.retentionAmount);
        if(claimed>cap+1){toastEmit(`No payment: that brings ${p.apNumber||p.vendor||"this bill"} to ₱${claimed.toLocaleString("en-PH")} but the PM certified only ${Number(p.verificationPct)||0}% (₱${cap.toLocaleString("en-PH")}). Ask the PM to certify more work first.`,"error",10000);return false;}
      }
      if(payIsSubcon(p)&&e.kind==="Retention release"&&(Number(p.verificationPct)||0)<100){toastEmit("Retention is released only when the PM certifies 100%.","error",8000);return false;}
      if(!payApproved(p)){toastEmit(`${p.vendor||"This payable"}${p.apNumber?` (${p.apNumber})`:""} isn't approved yet — a Manager or Finance Manager must approve it before payment.`,"error",7000);return false;}
    }
    if(!common.date){toastEmit("Enter the payment date.","error");return false;}
    const ref=String(common.ref||"").trim();
    if(common.method==="Check"&&!ref){toastEmit("Enter the check number.","error");return false;}
    const batchId=list.length>1?uid():null;
    const now=new Date().toISOString();
    const rows=list.map(e=>({id:uid(),payableId:e.payableId,batchId,kind:e.kind==="Retention release"?"Retention release":"Payment",payDate:common.date,
      amount:r2(e.amount),retentionAmount:e.kind==="Retention release"?0:r2(e.retentionAmount),method:common.method||"",bank:common.bank||"",refNo:ref,
      cvId:common.cvId||null,note:common.note||"",status:"Active",recordedBy:session?.name||"",createdAt:now,dupOverrideReason:common.overrideReason||null}));
    const nextPays=[...rows,...payPays];
    const touched=new Set(rows.map(r=>r.payableId));
    const nextPayables=payables.map(p=>touched.has(p.id)?recomputePayableFromPayments(p,nextPays):p);
    setPayPays(nextPays);persist(KEYS.payPays,nextPays);
    setPayables(nextPayables);persist(KEYS.payables,nextPayables);
    if(isSupabaseReady()){
      // One statement for the whole batch, so a check is recorded against all its bills or none.
      const res=await sbUpsertDetailed("payable_payments",rows.map(payablePaymentToSb),"id");
      if(res.duplicate){
        // Refused as a likely double payment: undo the screen, explain, and let a
        // Manager record it with a reason.
        setPayPays(payPays);persist(KEYS.payPays,payPays);
        setPayables(payables);persist(KEYS.payables,payables);
        const reason=await askDupOverride(res);
        return reason?recordPayments(entries,{...common,overrideReason:reason}):false;
      }
      if(!res.ok) toastEmit("⚠️ Payment saved on this device but NOT confirmed by the server — do not close this tab.","warning",9000);
    } else toastEmit("⚠️ Payment saved on this device only — no server connection. Do not close this tab.","warning",9000);
    nextPayables.filter(p=>touched.has(p.id)&&p.status==="Paid"&&p.expenseId).forEach(p=>markExpensePaid(p.expenseId));
    const cash=rows.reduce((s,r)=>s+r.amount,0),held=rows.reduce((s,r)=>s+r.retentionAmount,0);
    const bankLbl=(BANKS||[]).find(b=>b.id===common.bank||b.short===common.bank||b.name===common.bank);
    toastEmit(`✅ ${rows.length>1?`${rows.length} bills paid under one ${common.method==="Check"?"check":"payment"}`:(rows[0].kind==="Retention release"?"Retention released":"Payment recorded")} — ${pesoFmt(cash)}${held>0?` · retention held ${pesoFmt(held)}`:""}${bankLbl?` · ${bankLbl.short||bankLbl.name}`:""}`,"success",6000);
    return true;
  };
  // Single-bill wrapper kept for existing callers.
  const recordPayablePayment=(id,payAmt,opts={})=>recordPayments(
    [{payableId:id,amount:payAmt,retentionAmount:opts.retention||0,kind:opts.kind}],
    {date:opts.date||today,method:opts.method||"",bank:opts.bank||"",ref:opts.ref||"",note:opts.note||"",cvId:opts.cvId||null});
  // Cancel a payment (with a reason). A cancelled check usually covered several
  // bills, so every row of its batch is cancelled together.
  const cancelPayablePayment=async(payId)=>{
    const r=payPays.find(x=>x.id===payId);
    if(!r||r.status==="Cancelled") return;
    if(!roleCanInsert("payable_payments")){toastEmit("Only Finance, Accounting or a Manager can cancel a payment.","error",7000);return;}
    const group=r.batchId?payPays.filter(x=>x.batchId===r.batchId&&x.status!=="Cancelled"):[r];
    const total=group.reduce((s,x)=>s+(Number(x.amount)||0),0);
    const what=r.method==="Check"&&r.refNo?`check ${r.refNo}`:(r.kind==="Retention release"?"retention release":"payment");
    const reason=await uiPrompt(`Cancel ${what} of ${pesoFmt(total)}${group.length>1?` (it paid ${group.length} bills — all of them will be reopened)`:""}.\n\nReason (kept on record):`,"");
    if(reason==null) return;
    if(!reason.trim()){toastEmit("A reason is required to cancel a payment.","error");return;}
    const ids=new Set(group.map(x=>x.id));
    const at=new Date().toISOString();
    const nextPays=payPays.map(x=>ids.has(x.id)?{...x,status:"Cancelled",cancelReason:reason.trim(),cancelledBy:session?.name||"",cancelledAt:at}:x);
    const touched=new Set(group.map(x=>x.payableId));
    const nextPayables=payables.map(p=>touched.has(p.id)?recomputePayableFromPayments(p,nextPays):p);
    setPayPays(nextPays);persist(KEYS.payPays,nextPays);
    setPayables(nextPayables);persist(KEYS.payables,nextPayables);
    if(isSupabaseReady()){
      const res=await Promise.all(group.map(x=>sbUpdate("payable_payments",x.id,{status:"Cancelled",cancel_reason:reason.trim(),cancelled_by:session?.name||""})));
      if(res.some(ok=>!ok)) toastEmit("⚠️ Cancellation saved on this device but NOT confirmed by the server — do not close this tab.","warning",9000);
    }
    toastEmit(`Payment cancelled — ${group.length>1?`${group.length} bills`:"the bill"} reopened.`,"info");
  };
  // Mark a logged expense as Paid (so the expense log reflects payment instead of staying "Logged").
  const markExpensePaid=(expId)=>{
    if(!expId) return;
    upExps(es=>{const next=es.map(e=>e.id===expId?{...e,acctStatus:"Paid"}:e);const ex=next.find(e=>e.id===expId);if(ex&&isSupabaseReady())sbUpsert("expenses",toSbExpense(ex),"id").catch(()=>{});return next;});
  };
  const markPayablePaid=(id)=>{
    const p=payables.find(x=>x.id===id); if(!p) return;
    const balance=r2((Number(p.amount)||0)-(Number(p.paidAmount)||0));
    if(balance>0) recordPayablePayment(id,balance,{date:today,method:p.payMethod||"",bank:p.payBank||"",ref:p.payRef||""});
  };
  // Open the Record-Payment modal for a payable, pre-filled with its open balance.
  // Navigation + badge counts for the Aerwin-styled Finance module tab bar.
  const financeErpCounts=()=>({
    po:new Set(prs.filter(p=>["PO Issued","Partially Delivered"].includes(p.status)&&p.poNumber).map(p=>p.poNumber)).size,
    ap:payables.filter(p=>p.status!=="Paid").length,
    cv:vouchers.filter(v=>["Draft","For Release"].includes(v.status)).length,
  });
  const financeErpGo=(k)=>{
    if(k==="dashboard") setPage("acctdash");
    else if(k==="po") setPage(["Finance","Manager","FinanceAssistant","Accounting"].includes(role)?"purchaseorders":"procurement");
    else if(k==="ap"){setPage("finance");setFinTab("payables");}
    else if(k==="payments"){setPage("finance");setFinTab("payments");}
    else if(k==="cv") setPage("checkvouchers");
  };
  const openPayModal=(p)=>{
    if(!p) return;
    const balance=Math.max(0,(Number(p.amount)||0)-(Number(p.paidAmount)||0));
    setPayPayId(p.id);
    setPayPayMode("amount");setPayPayPct("");
    setPayPayAmt(String(balance||""));
    setPayPayBank(p.payBank||"");setPayPayMethod(p.payMethod||"Online Transfer");setPayPayRef("");
    setPayPayDate(today);setPayPayDP(false);setPayPayKind("Payment");
    // Subcontractor bills pay by gross progress claim; start from what's left to claim.
    if(payIsSubcon(p)) setPayPayAmt(String(Math.max(0,Math.round(((Number(p.amount)||0)-payableClaimed(p))*100)/100)||""));
  };
  const openRetentionRelease=(p)=>{
    if(!p) return;
    setPayPayId(p.id);setPayPayKind("Retention release");setPayPayMode("amount");setPayPayPct("");
    setPayPayAmt(String(Number(p.retentionHeld)||0));setPayPayDate(today);setPayPayDP(false);
    setPayPayBank(p.payBank||"");setPayPayMethod(p.payMethod||"Online Transfer");setPayPayRef("");
  };
  // Route a floated payable into Check Payables: create a linked Draft check voucher.
  // The CV carries the vendor/amount/PO; on Release it marks this payable Paid (see releaseCv).
  const payableToCheck=async(id)=>{
    const p=payables.find(x=>x.id===id);
    if(!p) return;
    if(p.cvId||p.status==="Check Issued"){toastEmit("This payable already has a check voucher.","info");setPage("checkvouchers");return;}
    if(!payApproved(p)){toastEmit("This payable isn't approved yet — it must be approved before routing to a check voucher.","error",7000);return;}
    const cvId=uid();
    const nextNo=await claimDocNumber("CV",vouchers.map(v=>v.cvNo),4,true);
    const particulars=`Payment for Invoice ${p.invoiceNumber||p.invoiceRef||"—"}${p.poNumber?` (PO ${p.poNumber})`:""}`;
    const cvRec={id:cvId,date:today,cvNo:nextNo,payee:p.vendor||"",amount:Number(p.amount||0),description:particulars,projectId:p.projectId||null,bank:"",notes:p.notes||"",status:"Draft",poRef:p.poNumber||"",apRef:p.apNumber||"",payableId:p.id,checkNo:"",clearedDate:"",isCleared:false,sourceExpenseId:p.expenseId||null,createdBy:session?.name||"",createdAt:today};
    upVouchers(vs=>[cvRec,...vs]);
    if(isSupabaseReady()) sbUpsert("check_vouchers",cvToSb(cvRec),"id").catch(()=>{});
    upPayables(ps=>ps.map(x=>x.id===id?{...x,status:"Check Issued",cvId}:x));
    if(isSupabaseReady()) sbUpsert("payables",{id,status:"Check Issued"},"id").catch(()=>{});
    toastEmit(`✅ Routed to Check Payables — ${nextNo} (Draft). Set the bank, then Submit → Release.`,"success");
    setPage("checkvouchers");
  };
  const delPayable=async(id)=>{
    const rec=payables.find(p=>p.id===id);
    if(!await confirmFinancialDelete("payables",rec))return;
    upPayables(ps=>ps.filter(p=>p.id!==id));
    if(isSupabaseReady()) sbDelete("payables",id).catch(()=>{});
  };

  const upLoans=fn=>{const next=fn(loans);setLoans(next);persist(KEYS.loans,next);};
  const saveLoan=(data)=>{
    if(!data.lender||!data.principal) return;
    const rec={...data,principal:Number(data.principal),monthlyPayment:Number(data.monthlyPayment||0),termMonths:Number(data.termMonths||0),interestRate:Number(data.interestRate||0),id:editLoanId||uid(),createdAt:editLoanId?data.createdAt:today,payments:editLoanId?(data.payments||[]):[]};
    upLoans(ls=>editLoanId?ls.map(l=>l.id===editLoanId?rec:l):[rec,...ls]);
    if(isSupabaseReady()) sbUpsert("loans",loanToSb(rec),"id").catch(()=>{});
    setLoanModal(false);setEditLoanId(null);setLoanForm({lender:"",type:"Bank Loan",principal:"",disbursedDate:"",termMonths:"",interestRate:"",monthlyPayment:"",notes:""});
  };
  const delLoan=async(id)=>{
    const rec=loans.find(l=>l.id===id);
    if(!await confirmFinancialDelete("loans",rec))return;
    upLoans(ls=>ls.filter(l=>l.id!==id));
    if(isSupabaseReady()) sbDelete("loans",id).catch(()=>{});
  };
  const addLoanPayment=(loanId,amount,date)=>{
    if(!amount||Number(amount)<=0) return;
    const loan=loans.find(l=>l.id===loanId);
    if(!loan) return;
    const totalPaid=(loan.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);
    const remaining=Math.max(0,Number(loan.principal||0)-totalPaid);
    if(remaining>0&&Number(amount)>remaining+0.01){
      toastEmit(`Payment ₱${Number(amount).toLocaleString("en-PH",{maximumFractionDigits:0})} exceeds outstanding balance of ₱${remaining.toLocaleString("en-PH",{maximumFractionDigits:0})}.`,"error");
      return;
    }
    const pm={id:uid(),amount:Number(amount),date:date||today};
    upLoans(ls=>ls.map(l=>l.id===loanId?{...l,payments:[...(l.payments||[]),pm]}:l));
    if(isSupabaseReady()) sbUpsert("loan_payments",{id:pm.id,loan_id:loanId,amount:pm.amount,date:pm.date},"id").catch(()=>{});
    setLoanPay(p=>({...p,[loanId]:{amount:"",date:today}}));
  };
  const delLoanPayment=async(loanId,payId)=>{
    const loan=loans.find(l=>l.id===loanId);
    const pay=(loan?.payments||[]).find(p=>p.id===payId);
    if(!await confirmFinancialDelete("loan_payments",pay?{...pay,loanId}:null))return;
    upLoans(ls=>ls.map(l=>l.id===loanId?{...l,payments:(l.payments||[]).filter(p=>p.id!==payId)}:l));
    if(isSupabaseReady()) sbDelete("loan_payments",payId).catch(()=>{});
  };

  const saveInf=()=>{
    if(!infForm.source||!infForm.amount) return;
    const rec={...infForm,amount:Number(infForm.amount),id:uid()};
    upInfs(is=>[...is,rec]);
    if(isSupabaseReady()) sbUpsert("inflows",{id:rec.id,deal_id:rec.dealId||rec.projectId||null,date:rec.date||rec.month||null,amount:Number(rec.amount)||0,source:rec.source||"",ref_no:rec.refNo||"",note:rec.note||""},"id").catch(()=>{});
    setInfModal(false);
    setInfForm({month:new Date().getMonth(),source:"",amount:"",note:"",projectId:null});
  };
  const delInf=async id=>{const rec=infs.find(i=>i.id===id);if(!await confirmFinancialDelete("inflows",rec))return;upInfs(is=>is.filter(i=>i.id!==id));if(isSupabaseReady()) sbDelete('inflows',id).catch(()=>{});};

  // ── DAILY SITE LOG ─────────────────────────────────────────────────────────
  const upDailyLogs=fn=>{const next=fn(dailyLogs);setDailyLogs(next);persist(KEYS.dailylogs,next);};
  const dailyLogToSb=r=>({id:r.id,deal_id:r.dealId||null,log_date:r.date||null,weather:r.weather||"",manpower:Number(r.manpower)||0,work_done:r.workDone||"",issues:r.issues||"",materials:r.materials||"",equipment:r.equipment||"",progress_note:r.progressNote||"",logged_by:r.loggedBy||""});
  const addDailyLog=(rec)=>{
    const r={...rec,id:uid(),createdAt:today};
    upDailyLogs(ls=>[r,...ls]);
    if(isSupabaseReady()) sbUpsert("daily_logs",dailyLogToSb(r),"id").catch(()=>{});
    logActivity(r.dealId||null,"Daily Log",`Site log${r.workDone?`: ${r.workDone.slice(0,80)}`:""}`,r.loggedBy);
    return r;
  };
  const delDailyLog=async(id)=>{
    // RLS (migration 052) allows a delete by a Manager OR the log's author
    // (matched on the logged-by name). Mirror that ownership check here so the
    // author isn't wrongly blocked and a non-author gets a clear message.
    const log=dailyLogs.find(l=>l.id===id);
    const isMgr=(ROLE_ALIASES[role]||role)==="Manager";
    const isAuthor=log&&log.loggedBy&&log.loggedBy===session?.name;
    if(!isMgr&&!isAuthor){
      await uiAlert({title:"Not allowed for your role",message:"Only a manager or the person who wrote a site log can delete it.\n\nNothing was changed.",tone:"warning"});
      return;
    }
    upDailyLogs(ls=>ls.filter(l=>l.id!==id));
    if(isSupabaseReady()) sbDelete("daily_logs",id).catch(()=>{});
  };
  // Deleting a calendar item (checklists table) is Manager-only server-side —
  // migration 049 opened create/edit to everyone but left delete to Managers.
  const delOpsEvent=async(id)=>{
    if(!await guardWrite('delete','checklists','a calendar item')) return;
    upChecklist(cs=>cs.filter(c=>c.id!==id));
    if(isSupabaseReady()) sbDelete('checklists',id).catch(()=>{});
  };

  const saveSwatch=()=>{
    if(!swForm.name) return;
    const rec={...swForm,estCost:Number(swForm.estCost||0),id:editSw||uid(),date:today};
    upSwatches(ss=>editSw?ss.map(s=>s.id===editSw?rec:s):[...ss,rec]);
    if(isSupabaseReady()) sbSyncOne("swatches",rec,toSbSwatch);
    setSwModal(false);setEditSw(null);
  };
  const swQ=(id,st)=>upSwatches(ss=>ss.map(s=>{
    if(s.id!==id) return s;
    const extra=st==="Client Approved"?{clientApprovedBy:session?.name||"",clientApprovedAt:today}:{};
    if(st==="Client Approved"){
      const msg=`✅ <b>Swatch Client Approved</b>\n${s.name} (${s.category})\nProject: ${deals.find(d=>d.id===s.projectId)?.client||s.projectId}\nApproved by: ${session?.name||"?"} · ${today}`;
      sendTelegramNotification("procurement",msg);
      sendTelegramNotification("sales",msg);
    }
    const updated={...s,status:st,...extra};
    if(isSupabaseReady()) sbSyncOne("swatches",updated,toSbSwatch);
    return updated;
  }));

  const openDesignEdit=()=>{setDesignForm({...(proj?.design||mkDesign())});setDesignModal(true);};
  const saveDesign=()=>{
    const next={...designForm};
    if(next.status==="Done"&&!next.link){toastEmit("⚠ Please add a file link before marking design Done.","warning");return;}
    if(proj?.design?.status!==next.status) next.statusHistory=[...(proj?.design?.statusHistory||[]),{status:next.status,date:today,by:role}];
    upProj(selProj,p=>({...p,design:next}));
    if(next.status==="Done"&&proj?.currentStage==="Design"){
      upProj(selProj,p=>({...p,currentStage:"Fabrication",progress:{...p.progress,Design:100},stageDates:{...p.stageDates,Design:{...p.stageDates?.Design,e:today},Fabrication:{...p.stageDates?.Fabrication,s:p.stageDates?.Fabrication?.s||today}}}));
      const d=projDeal;
      const msg=`🎨 <b>Design Complete — Ready for Fabrication</b>\nProject: <b>${d?.client||"?"}</b>${d?.ceNo?`\nCE: ${d.ceNo}`:""}\nDesigner: ${next.designer||"—"}${next.revisionNo?`\nRevision: ${next.revisionNo}`:""}\n${next.link?`<a href="${next.link}">View Drawings</a>`:"No file link yet"}\nBy: ${session?.name||"Design"}`;
      sendTelegramNotification("ops",msg);
      sendTelegramNotification("management",msg);
    }
    setDesignModal(false);
  };

  // ── SHARED NAV ────────────────────────────────────────────────────────────
  const roleColor=ROLE_CLR[role]||"#64748b";
  const hr=new Date().getHours();
  const greeting=hr<12?"morning":hr<17?"afternoon":"evening";
  const navMap={
    Manager:[
      {group:"Overview",    items:[{id:"home",l:"Dashboard"},{id:"calendar",l:"Calendar"}]},
      {group:"Sales",       items:[{id:"pipeline",l:"Sales Pipeline"},{id:"boq",l:"BOQ"},{id:"clients",l:"Clients"},{id:"sales-reports",l:"Reports"}]},
      {group:"QS / Cost",   items:[{id:"ceqs",l:"CE/QS Queue"},{id:"costanalysis",l:"Cost Analysis"}]},
      {group:"Finance",     items:[{id:"finance",l:"Finance"},{id:"executive",l:"Executive"},...((session?.username==="paulo"||session?.username==="mar")?[{id:"projectmargins",l:"Project Margins"}]:[]),{id:"billing",l:"Billing"},{id:"cashposition",l:"Cash Position"},...(AP_HIDDEN?[{id:"supplierbills",l:"Supplier Bills"}]:[]),{id:"cashflow",l:"Cash Flow"},{id:"finance-reports",l:"Reports"}]},
      {group:"Accounting",  items:[{id:"coa",l:"Chart of Accounts"}]},
      {group:"Operations",  items:[{id:"projects",l:"Projects"},{id:"addenda",l:"Scope Changes"},{id:"subconcert",l:"Subcon Billing"}]},
      {group:"Design",      items:[{id:"designboard",l:"Design Board"},{id:"drf",l:"Design Requests"}]},
      {group:"Procurement", items:[{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"procurement",l:"Purchase Orders"},{id:"inventory",l:"Inventory"},{id:"deliveries",l:"Deliveries"},{id:"stockmove",l:"Stock Movements"},{id:"subconwo",l:"Subcon Work Orders"},{id:"masters",l:"Master Lists"}]},
      {group:"Admin",       items:[{id:"accounts",l:"Accounts"},{id:"audit",l:"Audit"},{id:"syshealth",l:"System Health"},{id:"botsettings",l:"Bot Settings"},{id:"tvboard",l:"Office TV Board"},{id:"activity",l:"Team Activity"}]},
    ],
    Sales:[
      {group:"Pipeline",     items:[{id:"pipeline",l:"Sales Pipeline"},{id:"boq",l:"BOQ"},{id:"calendar",l:"Calendar"},{id:"clients",l:"Clients"},{id:"sales-reports",l:"Reports"}]},
      {group:"Projects",     items:[{id:"projects",l:"Projects"},{id:"addenda",l:"Scope Changes"}]},
      {group:"Billing",      items:[{id:"billing",l:"Billing"}]},
      {group:"Deliverables", items:[{id:"designstatus",l:"Design Status"},{id:"drf",l:"Design Requests"}]},
      {group:"QS",           items:[{id:"ceqs",l:"CE Requests"}]},
    ],
    Finance:[
      {group:"Overview",    items:[{id:"home",l:"Cash Position"},{id:"calendar",l:"Calendar"}]},
      {group:"Sales",       items:[{id:"pipeline",l:"Sales Pipeline"},{id:"boq",l:"BOQ"},{id:"clients",l:"Clients"}]},
      {group:"Finance",     items:[{id:"finance",l:"Finance"},{id:"executive",l:"Executive"},{id:"billing",l:"Billing"},{id:"cashposition",l:"Cash Position"},...(AP_HIDDEN?[{id:"supplierbills",l:"Supplier Bills"}]:[]),{id:"cashflow",l:"Cash Flow"},{id:"finance-reports",l:"Reports"}]},
      {group:"Accounting",  items:[{id:"coa",l:"Chart of Accounts"}]},
      {group:"Operations",  items:[{id:"projects",l:"Projects"},{id:"addenda",l:"Scope Changes"},{id:"subconcert",l:"Subcon Billing"}]},
      {group:"Design",      items:[{id:"drf",l:"Design Requests"}]},
      {group:"Procurement", items:[{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"procurement",l:"Purchase Orders"},{id:"inventory",l:"Inventory"},{id:"deliveries",l:"Deliveries"},{id:"stockmove",l:"Stock Movements"},{id:"subconwo",l:"Subcon Work Orders"},{id:"masters",l:"Master Lists"}]},
      {group:"QS / Cost",   items:[{id:"ceqs",l:"CE/QS Queue"},{id:"costanalysis",l:"Cost Analysis"}]},
      {group:"Admin",       items:[{id:"audit",l:"Audit"},{id:"botsettings",l:"Bot Settings"},{id:"activity",l:"Team Activity"}]},
    ],
    Audit:[
      {group:"Overview", items:[{id:"home",l:"Dashboard"},{id:"calendar",l:"Calendar"}]},
      {group:"Audit",    items:[{id:"audit",l:"Audit"}]},
      {group:"Reference",items:[{id:"inventory",l:"Inventory"},{id:"stockmove",l:"Stock Movements"},{id:"billing",l:"Billing"}]},
    ],
    HRAdmin:[
      {group:"Overview", items:[{id:"home",l:"Dashboard"},{id:"calendar",l:"Calendar"}]},
      {group:"Audit",    items:[{id:"audit",l:"Audit"}]},
      {group:"Admin",    items:[{id:"activity",l:"Team Activity"}]},
    ],
    Accounting:[
      {group:"Overview",    items:[{id:"home",l:"Dashboard"},{id:"acctdash",l:"Accounting"}]},
      {group:"Accounting",  items:[{id:"coa",l:"Chart of Accounts"}]},
      {group:"Procurement", items:[{id:"subconwo",l:"SWO For Accounting"}]},
    ],
    Procurement:[
      {group:"Overview",   items:[{id:"home",l:"Overview"}]},
      {group:"Orders",     items:[{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"procurement",l:"Purchase Orders"},{id:"inventory",l:"Inventory"},{id:"deliveries",l:"Deliveries"},{id:"stockmove",l:"Stock Movements"},{id:"subconwo",l:"Subcon Work Orders"},{id:"masters",l:"Master Lists"}]},
      {group:"Projects",   items:[{id:"projects",l:"Projects"},{id:"clients",l:"Clients"}]},
    ],
    QS:[
      {group:"Overview", items:[{id:"home",l:"Dashboard"}]},
      {group:"Sales",    items:[{id:"pipeline",l:"Sales Pipeline"},{id:"boq",l:"BOQ"}]},
      {group:"CE / QS",  items:[{id:"ceqs",l:"CE/QS Queue"},{id:"costanalysis",l:"Cost Analysis"},{id:"materialreq",l:"Purchase Requests (PRF)"}]},
      {group:"Operations", items:[{id:"projects",l:"Projects"},{id:"addenda",l:"Scope Changes"}]},
    ],
    Operations:[
      {group:"Overview",  items:[{id:"home",l:"Dashboard"},{id:"calendar",l:"Calendar"}]},
      {group:"Sales",     items:[{id:"pipeline",l:"Sales Pipeline"}]},
      {group:"On-Site",   items:[{id:"projects",l:"Project Cards"}]},
      {group:"Design",    items:[{id:"drf",l:"Design Requests"}]},
      {group:"Requests",  items:[{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"subconcert",l:"Subcon Billing"},{id:"costanalysis",l:"Cost Analysis"}]},
    ],
    Design:[
      {group:"Overview",    items:[{id:"home",l:"Projects"},{id:"designboard",l:"Design Board"},{id:"myfolder",l:"My Projects"}]},
      // Sales Pipeline is limited to the Head Designer — the rest of the design
      // team only sees their design work, not the sales funnel.
      ...(isHeadDesigner(session?.name)?[{group:"Sales", items:[{id:"pipeline",l:"Sales Pipeline"}]}]:[]),
      {group:"Design Work", items:[{id:"drf",l:"Design Requests"},{id:"projects",l:"Project Cards"}]},
    ],
    ProjectMover:[
      {group:"Overview", items:[{id:"home",l:"My Projects"},{id:"calendar",l:"Calendar"}]},
      // Scope changes are Sales-owned (a linked deal). A PM who spots one reports
      // it via PM Updates; Sales picks it up and logs the linked addendum.
      {group:"Updates",  items:[{id:"pmupdates",l:"PM Updates"}]},
      {group:"Work",     items:[{id:"projects",l:"Project Cards"},{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"subconcert",l:"Subcon Billing"}]},
    ],
    // Coordinators post updates and request materials on the projects they are
    // assigned to (project_cards.coordinator) — nothing else. The database scopes
    // what they can read and write (migration 20261027150000_coordinator_role.sql).
    Coordinator:[
      {group:"Overview", items:[{id:"home",l:"My Projects"}]},
      {group:"Work",     items:[{id:"projects",l:"Project Cards"},{id:"materialreq",l:"Purchase Requests (PRF)"}]},
    ],
    Warehouse:[
      {group:"Overview", items:[{id:"home",l:"Dashboard"}]},
      {group:"Stock",    items:[{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"deliveries",l:"Deliveries"},{id:"inventory",l:"Inventory"},{id:"stockmove",l:"Stock Movements"}]},
    ],
    SalesOpsAdmin:[
      {group:"Overview",   items:[{id:"home",l:"Dashboard"},{id:"calendar",l:"Calendar"}]},
      {group:"Sales",      items:[{id:"pipeline",l:"Sales Pipeline"},{id:"boq",l:"BOQ"},{id:"clients",l:"Clients"},{id:"sales-reports",l:"Reports"},{id:"ceqs",l:"CE Requests"}]},
      {group:"Billing",    items:[{id:"billing",l:"Billing"}]},
      {group:"Finance",    items:[{id:"financecal",l:"Finance Calendar"}]},
      {group:"Operations", items:[{id:"projects",l:"Projects"},{id:"addenda",l:"Scope Changes"}]},
      {group:"Design",     items:[{id:"drf",l:"Design Requests"}]},
    ],
    FinanceAssistant:[
      {group:"Overview",   items:[{id:"home",l:"Dashboard"},{id:"calendar",l:"Calendar"}]},
      {group:"Finance",    items:[{id:"finance",l:"Finance"},{id:"executive",l:"Executive"},{id:"billing",l:"Billing"},{id:"cashposition",l:"Cash Position"},...(AP_HIDDEN?[{id:"supplierbills",l:"Supplier Bills"}]:[]),{id:"cashflow",l:"Cash Flow"},{id:"finance-reports",l:"Reports"}]},
      {group:"Accounting", items:[{id:"coa",l:"Chart of Accounts"}]},
    ],
    // Procurement Manager sees the same workspace as Procurement — the only
    // difference is authority (they approve POs), not navigation.
    ProcurementManager:[
      {group:"Overview",   items:[{id:"home",l:"Overview"}]},
      {group:"Orders",     items:[{id:"materialreq",l:"Purchase Requests (PRF)"},{id:"procurement",l:"Purchase Orders"},{id:"inventory",l:"Inventory"},{id:"deliveries",l:"Deliveries"},{id:"stockmove",l:"Stock Movements"},{id:"subconwo",l:"Subcon Work Orders"},{id:"masters",l:"Master Lists"}]},
      {group:"Projects",   items:[{id:"projects",l:"Projects"},{id:"clients",l:"Clients"}]},
    ],
  };
  // Hidden modules drop out of every role's nav; a group left empty goes too.
  const visibleNav=r=>(navMap[r]||[]).map(g=>({...g,items:(g.items||[]).filter(it=>!HIDDEN_NAV_IDS.has(it.id))})).filter(g=>g.items.length);
  const Nav=useStableComponent(()=>{
    const NAV_ICONS={
      home:"🏠",    pipeline:"📊",   projects:"📋",   finance:"💰",   cashposition:"🏦",   supplierbills:"📦",   cashflow:"📈",   payables:"📤",   billing:"🧾",
      reports:"📈", "sales-reports":"📈", "finance-reports":"📈", projectmargins:"🪙", acctdash:"📒", executive:"🎯", accounting:"💸", checkvouchers:"✅", evouchers:"🧾", coa:"📚", acctreport:"📊", dailylog:"📓",
      ceqs:"📐",    costanalysis:"💹",boq:"🧮",       inventory:"🗃️", calendar:"📅", financecal:"📅",
      drf:"🖌️",    procurement:"📦", subconwo:"🔨",   requests:"📋",   swatchboard:"🎨",
      masters:"🗂️",clients:"🏢",    accounts:"👥",   botsettings:"🤖",activity:"🏆", audit:"🔎", syshealth:"🩺", tvboard:"📺",
      deliveries:"🚚",stockmove:"🔄",addenda:"⚠️",   pmupdates:"📝",  pmfeed:"📋",  suppliers:"🏭",
      subcontractors:"👷",materialreq:"🔧",subconcert:"🔨",budgetreq:"💳",collections:"💵",
      checklist:"✅",joborders:"📄", ops:"⚙️",        datamanagement:"⚙️", myfolder:"📁",
    };
    const groups=visibleNav(role);
    const allItems=groups.flatMap(g=>g.items||[]);
    const pauloExtra=session?.username==="paulo"?[{id:"datamanagement",l:"Data"}]:[];
    const NavBtn=({id,l,collapsed})=>{
      // "payables" is a virtual nav entry: it opens the Finance page pinned to the
      // Accounts Payable tab, so the AP Ledger reads as its own top-level item.
      const active=id==="payables"?(page==="finance"&&finTab==="payables")
        :id==="cashposition"?(page==="finance"&&finTab==="cash")
        :id==="supplierbills"?(page==="finance"&&finTab==="bills")
        :id==="executive"?(page==="finance"&&["overview","pl","loans"].includes(finTab))
        :id==="finance"?(page==="acctdash")
        :page===id;
      const icon=NAV_ICONS[id]||NAV_ICONS[l]||"•";
      const fav=favNav.includes(id);
      return(
        <button key={id} onClick={()=>{if(id==="payables"){setPage("finance");setFinTab("payables");}else if(id==="cashposition"){setPage("finance");setFinTab("cash");}else if(id==="supplierbills"){setPage("finance");setFinTab("bills");}else if(id==="executive"){setPage("finance");setFinTab("overview");}else if(id==="finance"){setPage("acctdash");}else{setPage(id);}setSelProj(null);setDealModal(false);setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(null);}}
          title={collapsed?l:""}
          style={{display:"flex",alignItems:"center",gap:10,width:"100%",border:"none",borderRadius:0,padding:collapsed?"10px 0":"8px 16px",justifyContent:collapsed?"center":"flex-start",background:active?"rgba(245,158,11,.15)":"transparent",color:active?"#f59e0b":"#94a3b8",fontFamily:"inherit",fontSize:".82rem",fontWeight:active?700:400,cursor:"pointer",borderLeft:active?"3px solid #f59e0b":"3px solid transparent",transition:"all .12s"}}>
          <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
          {!collapsed&&<span style={{flex:1,textAlign:"left",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l}</span>}
          {!collapsed&&<span role="button" tabIndex={-1} onClick={(e)=>{e.stopPropagation();toggleFav(id);}} title={fav?"Remove from favorites":"Pin to favorites"} style={{flexShrink:0,fontSize:".82rem",lineHeight:1,color:fav?"#f59e0b":"#475569",cursor:"pointer",padding:"0 2px"}}>{fav?"★":"☆"}</span>}
        </button>
      );
    };
    // Resolve favorited ids to {id,l} for the pinned group (drop any no longer in this role's nav).
    const itemLookup={};[...allItems,...pauloExtra].forEach(it=>{itemLookup[it.id]=it;});
    const favItems=favNav.map(id=>itemLookup[id]).filter(Boolean);
    const W = navCollapsed ? 64 : 220;
    return(
      <aside style={{position:"fixed",left:0,top:0,height:"100vh",width:W,background:"#1e293b",display:"flex",flexDirection:"column",zIndex:200,transition:"width .2s",overflow:"hidden",boxShadow:"2px 0 12px rgba(0,0,0,.15)"}} className="noprint">
        {/* Logo + collapse toggle */}
        <div style={{display:"flex",alignItems:"center",justifyContent:navCollapsed?"center":"space-between",padding:navCollapsed?"16px 0":"14px 16px",borderBottom:"1px solid rgba(255,255,255,.08)",minHeight:56,flexShrink:0}}>
          {!navCollapsed&&<img src="/gmd-logo.png" alt="GMD" style={{height:28,objectFit:"contain",filter:"brightness(0) invert(1)"}}/>}
          <button onClick={()=>setNavCollapsed(c=>!c)} style={{background:"rgba(255,255,255,.08)",border:"none",borderRadius:6,width:28,height:28,cursor:"pointer",color:"#94a3b8",fontSize:"1rem",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            {navCollapsed?"→":"←"}
          </button>
        </div>
        {/* Nav items */}
        <div style={{flex:1,overflowY:"auto",padding:"8px 0"}}>
          {navCollapsed ? (
            [...allItems,...pauloExtra].map(({id,l})=><NavBtn key={id} id={id} l={l} collapsed={true}/>)
          ) : (
            <>
              {favItems.length>0&&(
                <div style={{marginBottom:4}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 16px 3px"}}>
                    <span style={{fontSize:".58rem",fontWeight:800,color:"#f59e0b",textTransform:"uppercase",letterSpacing:"0.08em"}}>★ Favorites</span>
                    <span role="button" tabIndex={-1} onClick={()=>setFavOnly(v=>!v)} title={favOnly?"Show all pages":"Hide the pages you haven't favorited"} style={{fontSize:".58rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:"0.04em",cursor:"pointer"}}>{favOnly?"Show all":"Hide rest"}</span>
                  </div>
                  {favItems.map(({id,l})=><NavBtn key={"fav-"+id} id={id} l={l} collapsed={false}/>)}
                </div>
              )}
              {!(favOnly&&favItems.length>0)&&groups.map((section,si)=>{
                // A group stays open if it holds the current page, so collapsing
                // never hides where you are. Otherwise honor the saved collapse.
                const hasActive=(section.items||[]).some(it=>it.id===page);
                const open=hasActive||!navGroupsCollapsed.has(section.group);
                return(
                <div key={si} style={{marginBottom:4}}>
                  <div role="button" tabIndex={-1} onClick={()=>toggleNavGroup(section.group)}
                    title={open?"Collapse":"Expand"}
                    style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 16px 3px",fontSize:".58rem",fontWeight:800,color:"#475569",textTransform:"uppercase",letterSpacing:"0.08em",cursor:"pointer",userSelect:"none"}}>
                    <span>{section.group}</span>
                    <span style={{fontSize:".7rem",color:"#334155",transform:open?"rotate(90deg)":"rotate(0deg)",transition:"transform .15s",lineHeight:1}}>›</span>
                  </div>
                  {open&&(section.items||[]).map(({id,l})=><NavBtn key={id} id={id} l={l} collapsed={false}/>)}
                </div>
              );})}
              {!(favOnly&&favItems.length>0)&&pauloExtra.map(({id,l})=><NavBtn key={id} id={id} l={l} collapsed={false}/>)}
            </>
          )}
        </div>
        {/* Bottom: user info + actions */}
        <div style={{borderTop:"1px solid rgba(255,255,255,.08)",padding:navCollapsed?"12px 0":"12px 14px",flexShrink:0}}>
          {!navCollapsed&&(
            <>
              <div style={{background:roleColor+"22",borderRadius:20,padding:"4px 10px",fontSize:".7rem",fontWeight:700,color:roleColor,marginBottom:8,textAlign:"center"}}>
                {session?.name?.split(" ")[0]} · {roleLabel(session?.title||role)}
              </div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap",justifyContent:"center",marginBottom:8}}>
                <span onClick={async()=>{
                  if(!isSupabaseReady()) return;
                  setSync("saving");
                  // Heal the session (fixes a device that's showing no data due to a stale/expired
                  // token blocked by RLS), then do a full reload so EVERYTHING re-fetches cleanly.
                  // If the role token has expired, reloading lands on the login
                  // screen (boot clears the session when no valid token remains).
                  if(!restoreAppToken()){ appLogout(); }
                  window.location.reload();
                }}
                title="Re-sync: reconnect to the server and reload all data"
                style={{fontSize:".62rem",cursor:"pointer",userSelect:"none"}}>
                {sync==="saving"?<span style={{color:"#f59e0b"}}>saving…</span>:sync!=="saved"?<span style={{color:"#ef4444"}}>⚠ error</span>:<span style={{color:"#10b981"}}>🔄</span>}
              </span>
                {role==="Manager"&&users.filter(u=>u.status==="pending").length>0&&(
                  <button onClick={()=>setPage("accounts")} style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:6,padding:"3px 8px",fontSize:".65rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>
                    {users.filter(u=>u.status==="pending").length} pending
                  </button>
                )}
              </div>
              <div style={{display:"flex",gap:5,justifyContent:"center",flexWrap:"wrap"}}>
                <button onClick={()=>setShowExport(s=>!s)} title="Backup" style={{background:"rgba(255,255,255,.08)",border:"none",borderRadius:6,padding:"5px 8px",color:"#94a3b8",cursor:"pointer",fontSize:".72rem",fontFamily:"inherit"}}>💾</button>
                <a href="/handbook.html" target="_blank" rel="noopener noreferrer" style={{background:"rgba(245,158,11,.15)",border:"1px solid rgba(245,158,11,.3)",borderRadius:6,padding:"5px 8px",color:"#f59e0b",fontSize:".72rem",fontWeight:700,textDecoration:"none"}}>📘</a>
                <button onClick={()=>setPage("myaccount")} title="My Account & Settings" style={{background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.1)",borderRadius:6,padding:"5px 8px",color:"#94a3b8",cursor:"pointer",fontSize:".72rem",fontFamily:"inherit"}}>⚙️</button>
                <button onClick={logout} style={{background:"rgba(239,68,68,.15)",border:"1px solid rgba(239,68,68,.2)",borderRadius:6,padding:"5px 8px",color:"#ef4444",cursor:"pointer",fontSize:".72rem",fontFamily:"inherit"}}>↩ Out</button>
              </div>
            </>
          )}
          {navCollapsed&&(
            <div style={{display:"flex",flexDirection:"column",gap:6,alignItems:"center"}}>
              <button onClick={()=>setShowExport(s=>!s)} title="Backup" style={{background:"rgba(255,255,255,.08)",border:"none",borderRadius:6,padding:"6px",color:"#94a3b8",cursor:"pointer",fontSize:".85rem"}}>💾</button>
              <a href="/handbook.html" target="_blank" rel="noopener noreferrer" title="Handbook" style={{background:"rgba(245,158,11,.15)",border:"1px solid rgba(245,158,11,.3)",borderRadius:6,padding:"6px",color:"#f59e0b",fontSize:".85rem",textDecoration:"none"}}>📘</a>
              <button onClick={logout} title="Log out" style={{background:"rgba(239,68,68,.12)",border:"none",borderRadius:6,padding:"6px",color:"#ef4444",cursor:"pointer",fontSize:".75rem",fontFamily:"inherit"}}>↩</button>
              <button onClick={()=>setPage("myaccount")} title="My Account" style={{background:"rgba(255,255,255,.06)",border:"none",borderRadius:6,padding:"6px",color:"#94a3b8",cursor:"pointer",fontSize:".85rem",fontFamily:"inherit"}}>⚙️</button>
            </div>
          )}
        </div>
      </aside>
    );
  });
  // ── MOBILE HEADER (top bar) ───────────────────────────────────────────────
  const MobileHeader=useStableComponent(()=>{
    if(!isMobile) return null;
    return(
      <div style={{position:"fixed",top:0,left:0,right:0,height:48,background:"#1e293b",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 14px",zIndex:300,boxShadow:"0 2px 8px rgba(0,0,0,.25)"}} className="noprint">
        <img src="/gmd-logo.png" alt="GMD" style={{height:30,objectFit:"contain",filter:"brightness(0) invert(1)"}}/>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:".65rem",fontWeight:700,color:roleColor,background:roleColor+"22",borderRadius:20,padding:"2px 8px"}}>
            {session?.name?.split(" ")[0]} · {roleLabel(session?.title||role)}
          </span>
          <a href="/handbook.html" target="_blank" rel="noopener noreferrer" style={{background:"rgba(245,158,11,.2)",border:"none",borderRadius:6,padding:"9px 12px",color:"#f59e0b",fontSize:".72rem",fontWeight:700,textDecoration:"none",display:"inline-flex",alignItems:"center",minHeight:36}}>📘</a>
          <button onClick={logout} style={{background:"rgba(239,68,68,.2)",border:"none",borderRadius:6,padding:"9px 12px",color:"#ef4444",cursor:"pointer",fontSize:".72rem",fontFamily:"inherit",minHeight:36,minWidth:36,display:"inline-flex",alignItems:"center",justifyContent:"center"}}>↩</button>
        </div>
      </div>
    );
  });

  // ── MOBILE BOTTOM NAV ─────────────────────────────────────────────────────
  const MobileBottomNav=useStableComponent(()=>{
    if(!isMobile) return null;
    const groups=visibleNav(role);
    const allItems=groups.flatMap(g=>g.items||[]);
    const NAV_ICONS={
      home:"🏠",    pipeline:"📊",   projects:"📋",   finance:"💰",   cashposition:"🏦",   supplierbills:"📦",   cashflow:"📈",   payables:"📤",   billing:"🧾",
      reports:"📈", "sales-reports":"📈", "finance-reports":"📈", projectmargins:"🪙", acctdash:"📒", executive:"🎯", accounting:"💸", checkvouchers:"✅", evouchers:"🧾", coa:"📚", acctreport:"📊", dailylog:"📓",
      ceqs:"📐",    costanalysis:"💹",boq:"🧮",       inventory:"🗃️", calendar:"📅", financecal:"📅",
      drf:"🖌️",    procurement:"📦", subconwo:"🔨",   requests:"📋",   swatchboard:"🎨",
      masters:"🗂️",clients:"🏢",    accounts:"👥",   botsettings:"🤖",activity:"🏆", audit:"🔎", syshealth:"🩺", tvboard:"📺",
      deliveries:"🚚",stockmove:"🔄",addenda:"⚠️",   pmupdates:"📝",  pmfeed:"📋",  suppliers:"🏭",
      subcontractors:"👷",materialreq:"🔧",subconcert:"🔨",budgetreq:"💳",collections:"💵",
      checklist:"✅",joborders:"📄", ops:"⚙️",        datamanagement:"⚙️", myfolder:"📁",
    };
    const NAV_LABELS={
      home:"Home",pipeline:"Pipeline",projects:"Projects",finance:"Finance",executive:"Executive",
      billing:"Billing",checklist:"Checklist",joborders:"JOs",
      costanalysis:"Costs",accounting:"Daily Payables",procurement:"Orders",
      clients:"Clients",materialreq:"PRF",budgetreq:"Budget",
      swatchboard:"Swatches",drf:"Design",deliveries:"Delivery",
      stockmove:"Stock",reports:"Reports",suppliers:"Suppliers",
      subcontractors:"Subcon",calendar:"Calendar",inventory:"Inventory",
      pmupdates:"Updates",addenda:"Scope",botsettings:"Bot",activity:"Activity",
      requests:"Requests",masters:"Masters",tvboard:"TV Board",
    };
    // Notification badge counts per tab
    const openBlockersAll=(blockers||[]).filter(b=>b.status==="Open").length;
    const pendingMRs=(mreqs||[]).filter(m=>m.status==="Submitted"||m.status==="Reviewed").length;
    const pendingBRs=(breqs||[]).filter(b=>b.status==="Submitted"||b.status==="Under Review").length;
    const pendingDRFs=(drfs||[]).filter(d=>d.status==="New"||d.status==="In Progress").length;
    const BADGE_MAP={
      projects:openBlockersAll||0,
      materialreq:pendingMRs||0,
      budgetreq:pendingBRs||0,
      requests:(pendingMRs||0)+(pendingBRs||0),
      drf:pendingDRFs||0,
    };
    const BadgeDot=({count})=>count>0?(
      <span style={{position:"absolute",top:6,right:"50%",transform:"translateX(18px)",background:"#ef4444",color:"#fff",borderRadius:10,padding:"1px 5px",fontSize:".6rem",fontWeight:800,lineHeight:1.2,minWidth:14,textAlign:"center"}}>{count>9?"9+":count}</span>
    ):null;
    const navigate=(id)=>{
      // Virtual nav items open the Finance page pinned to a tab (same as the
      // desktop sidebar) — they are not standalone pages, so route them here or
      // they hit the "No view" fallback on mobile.
      let pg=id;
      if(id==="cashposition"){setFinTab("cash");pg="finance";}
      else if(id==="supplierbills"){setFinTab("bills");pg="finance";}
      else if(id==="payables"){setFinTab("payables");pg="finance";}
      else if(id==="executive"){setFinTab("overview");pg="finance";}
      else if(id==="finance"){pg="acctdash";} // Finance home = ERP operational dashboard
      setPage(pg);setSelProj(null);setDealModal(false);setMoreNavOpen(false);setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(null);if(id==="home")setFromHome(false);
    };
    // Favorites (if the user set any) drive the mobile bottom bar and lead the More sheet,
    // matching the desktop sidebar. Only ids present in this role's nav are kept.
    const favItemsM=favNav.map(id=>allItems.find(x=>x.id===id)).filter(Boolean);
    // For Manager show fixed key tabs + More; others show first 4 + Me.
    // When favorites exist, the first 4 favorites take the primary slots instead.
    const primaryIds=favItemsM.length>0
      ? favItemsM.slice(0,4).map(x=>x.id)
      : role==="Manager"
        ? ["home","pipeline","projects",AP_HIDDEN?"cashposition":"finance"]
        : allItems.slice(0,4).map(x=>x.id);
    const moreBadge=Object.entries(BADGE_MAP).filter(([id])=>!primaryIds.includes(id)).reduce((s,[,v])=>s+v,0);
    const tabs=[
      ...primaryIds.map(id=>({id,l:allItems.find(x=>x.id===id)?.l||id})),
      {id:"__more__",l:"More"},
    ];
    return(
      <>
        {/* More drawer backdrop */}
        {moreNavOpen&&(
          <div onClick={()=>setMoreNavOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:298}}/>
        )}
        {/* More drawer sheet */}
        {moreNavOpen&&(
          <div style={{position:"fixed",bottom:62,left:0,right:0,maxHeight:"70vh",overflowY:"auto",background:"#1e293b",zIndex:299,borderRadius:"18px 18px 0 0",borderTop:"1px solid rgba(255,255,255,.12)",boxShadow:"0 -4px 24px rgba(0,0,0,.35)",paddingBottom:8}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px 8px",borderBottom:"1px solid rgba(255,255,255,.08)"}}>
              <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".95rem",color:"#f8fafc",letterSpacing:.5}}>All Sections</span>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                {favItemsM.length>0&&(
                  <button onClick={()=>setFavOnly(v=>!v)} style={{background:"transparent",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:".62rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".04em",fontFamily:"inherit"}}>{favOnly?"Show all":"Hide rest"}</button>
                )}
                <button onClick={()=>setMoreNavOpen(false)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:6,width:28,height:28,color:"#94a3b8",cursor:"pointer",fontSize:".9rem"}}>✕</button>
              </div>
            </div>
            {favItemsM.length>0&&(
              <div style={{padding:"6px 0"}}>
                <div style={{padding:"4px 16px 2px",fontSize:".58rem",fontWeight:800,color:"#f59e0b",textTransform:"uppercase",letterSpacing:".08em"}}>★ Favorites</div>
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:0}}>
                  {favItemsM.map(({id,l})=>{
                    const active=page===id;
                    const icon=NAV_ICONS[id]||"•";
                    const label=NAV_LABELS[id]||l?.replace(/📅|📋|📝|⚠️|📊|📦/g,"").trim()||l;
                    return(
                      <button key={"favm-"+id} onClick={()=>navigate(id)}
                        style={{display:"flex",alignItems:"center",gap:10,border:"none",padding:"10px 16px",background:active?"rgba(245,158,11,.15)":"transparent",color:active?"#f59e0b":"#cbd5e1",fontFamily:"inherit",fontSize:".82rem",fontWeight:active?700:400,cursor:"pointer",borderLeft:active?"3px solid #f59e0b":"3px solid transparent",textAlign:"left"}}>
                        <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
                        <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            {!(favOnly&&favItemsM.length>0)&&groups.map((sec,si)=>(
              <div key={si} style={{padding:"6px 0"}}>
                <div style={{padding:"4px 16px 2px",fontSize:".58rem",fontWeight:800,color:"#475569",textTransform:"uppercase",letterSpacing:".08em"}}>{sec.group}</div>
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:0}}>
                  {(sec.items||[]).map(({id,l})=>{
                    const active=page===id;
                    const icon=NAV_ICONS[id]||"•";
                    const label=NAV_LABELS[id]||l?.replace(/📅|📋|📝|⚠️|📊|📦/g,"").trim()||l;
                    const fav=favNav.includes(id);
                    return(
                      <button key={id} onClick={()=>navigate(id)}
                        style={{display:"flex",alignItems:"center",gap:10,border:"none",padding:"10px 16px",background:active?"rgba(245,158,11,.15)":"transparent",color:active?"#f59e0b":"#cbd5e1",fontFamily:"inherit",fontSize:".82rem",fontWeight:active?700:400,cursor:"pointer",borderLeft:active?"3px solid #f59e0b":"3px solid transparent",textAlign:"left"}}>
                        <span style={{fontSize:"1rem",flexShrink:0}}>{icon}</span>
                        <span style={{flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{label}</span>
                        <span role="button" tabIndex={-1} onClick={(e)=>{e.stopPropagation();toggleFav(id);}} title={fav?"Remove from favorites":"Pin to favorites"} style={{flexShrink:0,fontSize:"1rem",lineHeight:1,color:fav?"#f59e0b":"#475569",padding:"0 4px"}}>{fav?"★":"☆"}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
            <div style={{padding:"6px 0 0",borderTop:"1px solid rgba(255,255,255,.08)",marginTop:4}}>
              <button onClick={()=>navigate("myaccount")}
                style={{display:"flex",alignItems:"center",gap:10,width:"100%",border:"none",padding:"10px 16px",background:page==="myaccount"?"rgba(245,158,11,.15)":"transparent",color:page==="myaccount"?"#f59e0b":"#cbd5e1",fontFamily:"inherit",fontSize:".82rem",cursor:"pointer",borderLeft:page==="myaccount"?"3px solid #f59e0b":"3px solid transparent"}}>
                <span style={{fontSize:"1rem"}}>⚙️</span>
                <span>My Account</span>
              </button>
            </div>
          </div>
        )}
        {/* Bottom tab bar */}
        <div style={{position:"fixed",bottom:0,left:0,right:0,height:62,background:"#1e293b",display:"flex",alignItems:"stretch",zIndex:300,borderTop:"1px solid rgba(255,255,255,.08)",boxShadow:"0 -2px 12px rgba(0,0,0,.2)"}} className="noprint">
          {tabs.map(({id,l})=>{
            if(id==="__more__"){
              return(
                <button key="__more__" onClick={()=>setMoreNavOpen(o=>!o)}
                  style={{flex:1,position:"relative",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:2,border:"none",background:moreNavOpen?"rgba(245,158,11,.15)":"transparent",color:moreNavOpen?"#f59e0b":"#64748b",fontFamily:"inherit",cursor:"pointer",padding:"6px 0",borderTop:moreNavOpen?"2px solid #f59e0b":"2px solid transparent",transition:"all .12s"}}>
                  <span style={{fontSize:"1.1rem",lineHeight:1}}>☰</span>
                  <span style={{fontSize:".55rem",fontWeight:moreNavOpen?700:400,letterSpacing:".2px"}}>More</span>
                  <BadgeDot count={moreBadge}/>
                </button>
              );
            }
            if(id==="myaccount"){
              const active=page==="myaccount";
              return(
                <button key="myaccount" onClick={()=>navigate("myaccount")}
                  style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:2,border:"none",background:active?"rgba(245,158,11,.15)":"transparent",color:active?"#f59e0b":"#64748b",fontFamily:"inherit",cursor:"pointer",padding:"6px 0",borderTop:active?"2px solid #f59e0b":"2px solid transparent",transition:"all .12s"}}>
                  <span style={{fontSize:"1.1rem",lineHeight:1}}>👤</span>
                  <span style={{fontSize:".55rem",fontWeight:active?700:400,letterSpacing:".2px"}}>Me</span>
                </button>
              );
            }
            const active=page===id;
            const icon=NAV_ICONS[id]||"•";
            const label=NAV_LABELS[id]||l?.replace(/📅|📋|📝|⚠️|📊|📦/g,"").trim()||l;
            const bc=BADGE_MAP[id]||0;
            return(
              <button key={id} onClick={()=>navigate(id)}
                style={{flex:1,position:"relative",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:2,border:"none",background:active?"rgba(245,158,11,.15)":"transparent",color:active?"#f59e0b":"#64748b",fontFamily:"inherit",cursor:"pointer",padding:"6px 0",borderTop:active?"2px solid #f59e0b":"2px solid transparent",transition:"all .12s"}}>
                <span style={{fontSize:"1.1rem",lineHeight:1}}>{icon}</span>
                <span style={{fontSize:".55rem",fontWeight:active?700:400,letterSpacing:".2px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:54}}>{label}</span>
                <BadgeDot count={bc}/>
              </button>
            );
          })}
        </div>
      </>
    );
  });
  // Rebuild the element each render so it reflects the latest page/badge state;
  // MobileBottomNav's stable identity keeps React from remounting it on the way.
  mobileNavRef.current = isMobile ? <MobileBottomNav/> : null;

  // ── SYNC FAILURE BANNER — must be declared BEFORE Wrap so the closure captures it initialized ─
  const SyncBanner=sbReady&&deals.length===0&&isSupabaseReady()?(
    <div style={{position:"fixed",top:0,left:0,right:0,zIndex:9999,background:"#fef2f2",borderBottom:"2px solid #fca5a5",padding:"10px 20px",display:"flex",alignItems:"center",gap:12,justifyContent:"center",fontSize:".82rem",fontFamily:"'Segoe UI',sans-serif"}}>
      <span style={{color:"#991b1b",fontWeight:700}}>⚠ Data not loaded from server.</span>
      <span style={{color:"#b91c1c"}}>Couldn't read your data — usually a sign-in/session issue. If you're on a phone, open in <strong>Chrome/Safari</strong> (not an in-app browser), then Retry.</span>
      <button disabled={syncRetry} onClick={async()=>{
        setSyncRetry(true);
        // Re-establish the session BEFORE reloading — a missing/stale anonymous session under RLS
        // is the usual reason reads come back empty on one device but not others.
        try{
          if(!restoreAppToken()){ toastEmit("⚠️ Your session expired — please log in again.","error",8000); appLogout(); setSession(null); }
        }catch(e){console.warn("retry auth:",e?.message);}
        await loadAllFromSupabase();
        setSyncRetry(false);
      }} style={{background:"#dc2626",color:"#fff",border:"none",borderRadius:6,padding:"5px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:syncRetry?"not-allowed":"pointer",whiteSpace:"nowrap"}}>
        {syncRetry?"Syncing…":"↺ Retry Sync"}
      </button>
    </div>
  ):null;

  // Wrap is the shared page shell (side nav + global modals + fade-in content).
  // It closes over ~15 modal-open states (confirmDel, dealModal, expModal,
  // swModal, infModal, …) that live in the Global Modals block below and must be
  // read fresh every render — an earlier useCallback dep array omitted them, so
  // Wrap kept a STALE closure (clicking delete on Pipeline set confirmDel, but the
  // memoized Wrap still had the old value until an in-deps state like `page`
  // changed — the "modal only appears after visiting Dashboard" bug in #112).
  // #112 fixed that by inlining Wrap, but an inline component gets a NEW identity
  // every render, so React then remounted the whole page on each re-render
  // (constant, from Supabase realtime pushes): the `.fi` fade-in replayed (the
  // "blinking screen" on Project Cards) and every descendant's local state reset,
  // wiping a half-typed DealModal form. useStableComponent resolves both — the
  // closure stays fresh (no stale reads) while the identity stays stable (no
  // remount), so React reconciles the page in place.
  const Wrap=useStableComponent(({children})=>{
    const W=navCollapsed?64:220;
    const alreadyWrapped=useContext(WrapCtx);
    return(
      <WrapCtx.Provider value={true}>
      <div style={{minHeight:"100vh",background:"#f8fafc",fontFamily:"'Segoe UI',sans-serif",marginLeft:isMobile?0:W,transition:isMobile?"none":"margin-left .2s",overflowX:"hidden",width:isMobile?"100%":undefined}}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800&display=swap');
          .fi{animation:fadeIn .2s ease}
          @keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
          @media print{.noprint{display:none}}
          body{overflow-x:hidden}
          /* Keyboard focus — visible ring for every interactive element. Uses
             :focus-visible so it shows on Tab but not on mouse click. Previously
             only <input> had any focus style, leaving keyboard users lost. */
          button:focus-visible,a:focus-visible,select:focus-visible,textarea:focus-visible,
          [role="button"]:focus-visible,[tabindex]:focus-visible{
            outline:2px solid #f59e0b!important;outline-offset:2px!important;
            border-radius:6px;
          }
          input:focus-visible{outline:none}
          @media(prefers-reduced-motion:reduce){*{animation-duration:.001ms!important;transition-duration:.001ms!important}}
          /* Loading skeleton shimmer */
          @keyframes fhshimmer{0%{background-position:-360px 0}100%{background-position:360px 0}}
          .fh-skel{background:#e9edf2;background-image:linear-gradient(90deg,#e9edf2 0px,#f4f6f9 160px,#e9edf2 320px);background-size:720px 100%;border-radius:8px;animation:fhshimmer 1.3s linear infinite}
          @media(max-width:767px){
            input,select,textarea{font-size:16px!important}
            select{max-width:100%}
            .grid2{grid-template-columns:1fr!important}
            .grid3{grid-template-columns:1fr!important}
            .grid4{grid-template-columns:1fr 1fr!important}
            .tbl-scroll{overflow-x:auto;-webkit-overflow-scrolling:touch}
            .hide-mobile{display:none!important}
            .card-stack{flex-direction:column!important}
          }
          @keyframes fhspin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
        `}</style>
        {!isMobile&&<Nav/>}
        <MobileHeader/>
        <Toaster/>
        <DialogHost/>
        <DueDateBackfillModal open={dueDateFixOpen} onClose={()=>setDueDateFixOpen(false)} billings={billings} payables={payables} deals={deals} updateMilestone={updateMilestone} setPayableDueDate={setPayableDueDate} toastEmit={toastEmit}/>
        {!isOnline&&<div style={{position:"fixed",top:0,left:0,right:0,zIndex:2000,background:"#1e293b",color:"#fcd34d",padding:"8px 16px",textAlign:"center",fontSize:".78rem",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>⚠️ You're offline — changes are saved locally and will sync when you reconnect.</div>}
        {pendingSync>0&&(
          <div onClick={async()=>{
            const toastId=toastEmit("⏳ Retrying sync…","pending",20000);
            // "busy" just means another flush (the auto-retry heartbeat, or a
            // focus/online trigger) was already mid-flight when this was
            // tapped — that's transient, not a failure. Wait it out and
            // re-check ourselves a few times instead of making the user
            // keep tapping into the same "busy" message.
            let result={synced:0,remaining:sbQueueSize(),lastError:null};
            for(let attempt=0;attempt<4;attempt++){
              result=await sbFlushQueue(true); // force — bypass the unreliable navigator.onLine check
              if(result.lastError?.kind!=="busy") break;
              await new Promise(r=>setTimeout(r,3000));
            }
            const{synced,remaining,lastError}=result;
            if(remaining===0) toastUpdate(toastId,"✅ Synced — all changes reached the server.","success",5000);
            else if(synced>0) toastUpdate(toastId,`Synced ${synced}, ${remaining} still pending — ${lastError?.message||"retrying…"}`,"warning",6000);
            else{
              const reason=lastError?.kind==="other-user"?lastError.message:
                lastError?.kind==="expired"?"Your login expired — log in again and they'll be sent.":
                lastError?.kind==="offline"?"This device appears to be offline.":
                lastError?.kind==="auth"?"Your session can't reach the server — try logging out and back in.":
                lastError?.kind==="network"?"Network request failed — check your connection or try a different network.":
                lastError?.kind==="busy"?"A sync keeps running in the background without finishing — try reloading the page, then tap retry again.":
                lastError?.message?`Server said: "${lastError.message}"`:"Unknown error — check your connection.";
              toastUpdate(toastId,`Still can't sync. ${reason}`,"error",9000);
            }
          }} title="Some changes haven't reached the server yet. Tap to retry now."
            style={{position:"fixed",bottom:isMobile?80:18,right:18,zIndex:2100,background:"#b45309",color:"#fff",padding:"8px 14px",borderRadius:24,fontSize:".76rem",fontWeight:800,cursor:"pointer",boxShadow:"0 4px 14px rgba(180,83,9,.35)",display:"flex",alignItems:"center",gap:7}}>
            <span style={{display:"inline-block",animation:"fhspin 1.1s linear infinite"}}>⟳</span>
            {pendingSync} change{pendingSync!==1?"s":""} pending sync — tap to retry
          </div>
        )}
        {sessionExpired&&session&&(
          <div role="alert" style={{position:"fixed",top:0,left:0,right:0,zIndex:10000,background:"#fffbeb",borderBottom:"2px solid #f59e0b",padding:"10px 16px",display:"flex",alignItems:"center",gap:12,justifyContent:"center",flexWrap:"wrap",fontSize:".82rem",fontFamily:"'Segoe UI',sans-serif"}}>
            <span style={{color:"#92400e",fontWeight:700}}>⏱ Your login expired.</span>
            <span style={{color:"#78350f"}}>Changes you make now are held on this device{pendingSync>0?` (${pendingSync} waiting)`:""} and sent after you log in again. Finish what you're typing, then log in.</span>
            <button onClick={logout} style={{background:"#d97706",color:"#fff",border:"none",borderRadius:6,padding:"5px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:"pointer",whiteSpace:"nowrap"}}>Log in again</button>
          </div>
        )}
        {SyncBanner}
        <div style={{maxWidth:isMobile?undefined:1140,margin:"0 auto",padding:isMobile?"10px 12px":"22px 24px",paddingTop:isMobile?56:undefined,paddingBottom:isMobile?72:undefined}} className="fi">
          {!isMobile&&!alreadyWrapped&&(
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:20,paddingBottom:16,borderBottom:"1.5px solid #e2e8f0"}}>
              <img src="/gmd-logo.png" alt="GMD Productions" style={{height:56,objectFit:"contain",display:"block"}}/>
            </div>
          )}
          {fromHome&&page!=="home"&&(
            <button onClick={()=>{setPage("home");setFromHome(false);}}
              style={{display:"inline-flex",alignItems:"center",gap:6,background:"#1e293b",color:"#fff",border:"none",borderRadius:20,padding:"7px 16px",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,cursor:"pointer",marginBottom:14,boxShadow:"0 2px 8px rgba(0,0,0,.18)"}}>
              ← Dashboard
            </button>
          )}
          <ViewErrorBoundary key={page} view={page} onHome={()=>{setPage("home");setFromHome(false);}}>
            {children}
          </ViewErrorBoundary>
        </div>
      {showExportRef.current&&(
        <div style={{position:"fixed",top:58,right:16,zIndex:800,background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",boxShadow:"0 8px 32px rgba(0,0,0,.15)",padding:24,width:340,animation:"fi .2s ease"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem"}}>💾 Data Backup</div>
            <button onClick={()=>setShowExport(false)} style={{background:"#f1f5f9",border:"none",borderRadius:6,width:28,height:28,cursor:"pointer",color:"#64748b",fontSize:".9rem"}}>✕</button>
          </div>
          <div style={{fontSize:".78rem",color:"#64748b",marginBottom:16,lineHeight:1.6}}>
            Your data lives in this browser. Export a backup before any update so you never lose your real financials, deals, or expenses.
          </div>
          {isSupabaseReady()&&(
            <button onClick={migrateToCloud} style={{width:"100%",background:"#0ea5e9",border:"none",borderRadius:10,padding:"11px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:"#fff",cursor:"pointer",marginBottom:14,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              ☁ Push All Data to Cloud
            </button>
          )}
          <ExportImportPanel KEYS={KEYS} onClose={()=>setShowExport(false)}/>
        </div>
      )}
      {/* Global Modals */}
      <DealModal open={dealModal} onClose={()=>setDealModal(false)} form={dealForm} setForm={setDealForm} onSave={saveDeal} editId={editDeal} deals={deals} addenda={addenda} role={role}/>
      <ExpenseModal open={expModal} onClose={()=>setExpModal(false)} form={expForm} setForm={setExpForm} onSave={saveExp} onSaveAll={batchSaveExps} editId={editExpId} projList={spendProjList} clientName={clientName} chartOfAccounts={chartOfAccounts} suppliers={suppliers} exps={exps} poRefOptions={[...new Set([...prs.map(p=>p.poNumber),...swos.map(w=>w.woNumber)].filter(Boolean))]}/>
      <Modal open={confirmDel!==null} onClose={()=>{setConfirmDel(null);setDelAck(false);}} title="Delete this deal?">
        {(()=>{
          const d=deals.find(x=>x.id===confirmDel);
          // Compute what's ACTUALLY attached to this deal so the warning reflects
          // reality instead of a generic list. Deleting a deal with delivered POs,
          // logged expenses, or received payments erases real financial history
          // and skews the linked project's margin — so those gate the button.
          const dMs   =billings.filter(b=>b.dealId===confirmDel);
          const dPrs  =prs.filter(p=>(p.dealId||p.projectId)===confirmDel);
          const dExps =exps.filter(e=>(e.projectId||e.dealId)===confirmDel);
          const dJos  =jos.filter(j=>j.dealId===confirmDel);
          // Issued invoice numbers disappear from the sequence with the deal, and
          // payables link by project_id with NO foreign key, so they would be left
          // in AP pointing at a deal that no longer exists.
          const dInv  =dMs.filter(m=>m.invoiceNo);
          const dAps  =payables.filter(p=>p.projectId===confirmDel&&p.status!=="Paid"&&p.status!=="Cancelled");
          const apTotal=dAps.reduce((s,p)=>s+Math.max(0,Number(p.amount||0)-Number(p.paidAmount||0)),0);
          const payments=dMs.reduce((a,m)=>a.concat(m.payments||[]),[]);
          const paidTotal=payments.filter(p=>!p.bounced).reduce((s,p)=>s+Number(p.amount||0),0);
          const poCost=dPrs.reduce((s,p)=>s+(Number(p.actUnitCost)||Number(p.estUnitCost)||0)*(Number(p.qty)||0),0);
          const expTotal=dExps.reduce((s,e)=>s+Number(e.amount||e.cost||0),0);
          // "Financial" records are the ones whose loss actually matters on the books.
          const hasFinancial=dPrs.length>0||dExps.length>0||payments.length>0||dInv.length>0||dAps.length>0;
          const attached=[
            dMs.length  &&`${dMs.length} billing milestone${dMs.length!==1?"s":""}`,
            payments.length&&`${payments.length} payment${payments.length!==1?"s":""} (₱${paidTotal.toLocaleString("en-PH",{maximumFractionDigits:0})} received)`,
            dPrs.length &&`${dPrs.length} purchase order${dPrs.length!==1?"s":""} (₱${poCost.toLocaleString("en-PH",{maximumFractionDigits:0})})`,
            dExps.length&&`${dExps.length} logged expense${dExps.length!==1?"s":""} (₱${expTotal.toLocaleString("en-PH",{maximumFractionDigits:0})})`,
            dJos.length &&`${dJos.length} job order${dJos.length!==1?"s":""}`,
          ].filter(Boolean);
          const invNos=dInv.map(m=>m.invoiceNo).join(", ");
          const canDelete=!hasFinancial||delAck;
          return(
          <>
            <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"12px 16px",marginBottom:14}}>
              <div style={{fontWeight:700,color:"#dc2626",marginBottom:6,fontSize:".88rem"}}>⚠ Permanently delete <strong>{d?.client}{d?.ceNo?" · "+d.ceNo:""}</strong> and everything linked to it:</div>
              {attached.length>0?(
                <ul style={{margin:"6px 0 0",paddingLeft:18,fontSize:".82rem",color:"#7f1d1d",lineHeight:1.9}}>
                  {attached.map((t,i)=><li key={i}>{t}</li>)}
                  <li>Project card, checklists, DRFs, addenda &amp; swatches (if any)</li>
                </ul>
              ):(
                <div style={{fontSize:".82rem",color:"#7f1d1d",marginTop:4}}>No billing, POs, expenses or job orders are attached — safe to remove.</div>
              )}
            </div>
            {hasFinancial&&(
              <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"12px 16px",marginBottom:14}}>
                <div style={{fontWeight:700,color:"#b45309",fontSize:".82rem",marginBottom:6}}>💰 This deal has financial records.</div>
                <div style={{fontSize:".78rem",color:"#92400e",marginBottom:10,lineHeight:1.5}}>
                  If this is a duplicate, the POs / expenses / payments above may belong to the real project. Deleting erases them and can inflate the other project's margin. Consider moving them first (Procurement ▸ reassign PO) before deleting.
                </div>
                {dInv.length>0&&(
                  <div style={{fontSize:".78rem",color:"#92400e",marginBottom:8,lineHeight:1.5}}>
                    🧾 <strong>Issued invoice{dInv.length!==1?"s":""}: {invNos}.</strong> If {dInv.length!==1?"these were":"this was"} sent to the client, void {dInv.length!==1?"them":"it"} instead of deleting, or the invoice sequence gets a gap with no record of why. Milestones are archived to Finance ▸ Audit Trail either way.
                  </div>
                )}
                {dAps.length>0&&(
                  <div style={{fontSize:".78rem",color:"#b91c1c",marginBottom:8,lineHeight:1.5,fontWeight:600}}>
                    📤 {dAps.length} open payable{dAps.length!==1?"s":""} ({dAps.map(p=>p.apNumber||p.invoiceRef||p.vendor).join(", ")}, ₱{apTotal.toLocaleString("en-PH",{maximumFractionDigits:2})}) will NOT be deleted — {dAps.length!==1?"they stay":"it stays"} in Accounts Payable unlinked. Cancel {dAps.length!==1?"them":"it"} in Payables and tell the supplier if the PO is void.
                  </div>
                )}
                <label style={{display:"flex",gap:8,alignItems:"flex-start",cursor:"pointer",fontSize:".8rem",color:"#7f1d1d",fontWeight:600}}>
                  <input type="checkbox" checked={delAck} onChange={e=>setDelAck(e.target.checked)} style={{marginTop:2,cursor:"pointer"}}/>
                  <span>I understand these financial records will be permanently deleted along with the deal.</span>
                </label>
              </div>
            )}
            <p style={{color:"#64748b",marginBottom:20,fontSize:".85rem"}}>This cannot be undone. Make sure you have a data backup first.</p>
            <div style={{display:"flex",gap:10}}>
              <Btn variant="danger" onClick={()=>{if(!canDelete)return;delDeal(confirmDel);setDelAck(false);}} disabled={!canDelete}>Yes, Delete Everything</Btn>
              <Btn variant="ghost" onClick={()=>{setConfirmDel(null);setDelAck(false);}}>Cancel</Btn>
            </div>
          </>
          );
        })()}
      </Modal>
      <Modal open={swModal} onClose={()=>setSwModal(false)} title={editSw?"Edit Swatch Item":"Add to Swatchboard"} wide>
        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
          <div style={{gridColumn:"1/-1"}}><Fld label="Item Name" required><Inp value={swForm.name} onChange={e=>setSwForm(p=>({...p,name:e.target.value}))} placeholder="e.g. Walnut veneer, Brass pulls 96mm"/></Fld></div>
          <Fld label="Category"><Sel value={swForm.category} onChange={e=>setSwForm(p=>({...p,category:e.target.value}))}>{SWATCH_CATS.map(c=><option key={c}>{c}</option>)}</Sel></Fld>
          <Fld label="Added By" hint="Auto-set to your name">
            <div style={{padding:"8px 12px",borderRadius:8,background:"#f8fafc",fontSize:".85rem",color:"#475569",border:"1.5px solid #e2e8f0"}}>{swForm.addedBy||session?.name||"—"}</div>
          </Fld>
          <Fld label="Quantity"><Inp type="number" value={swForm.qty} onChange={e=>setSwForm(p=>({...p,qty:e.target.value}))}/></Fld>
          <Fld label="Unit"><Sel value={swForm.unit} onChange={e=>setSwForm(p=>({...p,unit:e.target.value}))}>{MAT_UNITS.map(u=><option key={u}>{u}</option>)}</Sel></Fld>
          <Fld label="Supplier"><Inp value={swForm.supplier} onChange={e=>setSwForm(p=>({...p,supplier:e.target.value}))} placeholder="e.g. Casa Hardware"/></Fld>
          <Fld label="Est. Cost (₱)"><Inp type="number" value={swForm.estCost} onChange={e=>setSwForm(p=>({...p,estCost:e.target.value}))}/></Fld>
          <Fld label="Status"><Sel value={swForm.status} onChange={e=>setSwForm(p=>({...p,status:e.target.value}))}>{SWATCH_STATUS.map(s=><option key={s}>{s}</option>)}</Sel></Fld>
          <div style={{gridColumn:"1/-1"}}><Fld label="Project"><Sel value={swForm.projectId||"none"} onChange={e=>setSwForm(p=>({...p,projectId:e.target.value==="none"?null:e.target.value}))}><option value="none">— Not linked —</option>{projList.map(d=><option key={d.id} value={d.id}>{d.client}</option>)}</Sel></Fld></div>
          <div style={{gridColumn:"1/-1"}}><Fld label="Swatch / Reference Link"><Inp type="url" value={swForm.swatchLink||""} onChange={e=>setSwForm(p=>({...p,swatchLink:e.target.value}))} placeholder="https://… (optional)"/></Fld></div>
          <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={swForm.notes||""} onChange={e=>setSwForm(p=>({...p,notes:e.target.value}))}/></Fld></div>
        </div>
        <div style={{display:"flex",gap:10,marginTop:16}}><Btn full onClick={saveSwatch}>{editSw?"Save Changes":"Add Item"}</Btn><Btn variant="ghost" onClick={()=>setSwModal(false)}>Cancel</Btn></div>
      </Modal>
      <Modal open={designModal&&!!proj} onClose={()=>setDesignModal(false)} title="Edit Design Details" wide>
        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Design Status">
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {DESIGN_STATUSES.map(s=>(
                  <button key={s} onClick={()=>setDesignForm(p=>({...p,status:s}))} style={{padding:"7px 14px",border:`2px solid ${designForm.status===s?DS_CLR[s]:"#e2e8f0"}`,borderRadius:20,background:designForm.status===s?DS_CLR[s]+"18":"#fff",color:designForm.status===s?DS_CLR[s]:"#64748b",fontWeight:designForm.status===s?700:400,cursor:"pointer",fontSize:".8rem",fontFamily:"inherit"}}>
                    {s}
                  </button>
                ))}
              </div>
            </Fld>
          </div>
          <Fld label="Designer">
            <Sel value={designForm.designer||""} onChange={e=>setDesignForm(p=>({...p,designer:e.target.value}))}><option value="">— Select —</option>{DESIGN_MEMBERS.map(m=><option key={m}>{m}</option>)}</Sel>
            {!designForm.designer&&designForm.status&&designForm.status!=="Briefing"&&<div style={{fontSize:".72rem",color:"#f59e0b",marginTop:3,fontWeight:600}}>⚠ No designer assigned — who owns this design?</div>}
          </Fld>
          <Fld label="Type"><Sel value={designForm.designerType||"in-house"} onChange={e=>setDesignForm(p=>({...p,designerType:e.target.value}))}><option value="in-house">In-house</option><option value="outsourced">Outsourced</option></Sel></Fld>
          <Fld label="Due Date">
            <Inp type="date" value={designForm.dueDate||""} onChange={e=>setDesignForm(p=>({...p,dueDate:e.target.value}))}/>
            {!designForm.dueDate&&designForm.status&&designForm.status!=="Briefing"&&designForm.status!=="Done"&&<div style={{fontSize:".72rem",color:"#94a3b8",marginTop:3}}>No due date set — consider adding one to track progress.</div>}
          </Fld>
          <div style={{gridColumn:"1/-1"}}><Fld label="File / Link (Google Drive, Figma, etc.)"><Inp type="url" value={designForm.link||""} onChange={e=>setDesignForm(p=>({...p,link:e.target.value}))} placeholder="https://…"/></Fld></div>
          <div style={{gridColumn:"1/-1"}}><Fld label="Revision No." hint="e.g. Rev 3 — lock before handing off to Ops"><Inp value={designForm.revisionNo||""} onChange={e=>setDesignForm(p=>({...p,revisionNo:e.target.value}))} placeholder="e.g. Rev 3"/></Fld></div>
          <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={designForm.notes||""} onChange={e=>setDesignForm(p=>({...p,notes:e.target.value}))}/></Fld></div>
        </div>
        {/* Approval stamp */}
        <div style={{marginTop:14,background:designForm.approvedBy&&designForm.approvedOn?"#f0fdf4":"#fffbeb",border:`1.5px solid ${designForm.approvedBy&&designForm.approvedOn?"#bbf7d0":"#fde68a"}`,borderRadius:12,padding:"14px 16px"}}>
          <div style={{fontSize:".68rem",fontWeight:700,color:designForm.approvedBy&&designForm.approvedOn?"#15803d":"#92400e",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>
            {designForm.approvedBy&&designForm.approvedOn?"✅ Approval Stamp":"⏳ Approval Sign-off"}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <Fld label="Approved by"><Sel value={designForm.approvedBy||""} onChange={e=>setDesignForm(p=>({...p,approvedBy:e.target.value}))}><option value="">— Select approver —</option>{[...DESIGN_MEMBERS,...SALES_TEAM,...OPS_TEAM].filter((v,i,a)=>a.indexOf(v)===i).map(m=><option key={m}>{m}</option>)}</Sel></Fld>
            <Fld label="Approved on"><Inp type="date" value={designForm.approvedOn||""} onChange={e=>setDesignForm(p=>({...p,approvedOn:e.target.value}))}/></Fld>
          </div>
          {!(designForm.approvedBy&&designForm.approvedOn)&&<div style={{fontSize:".72rem",color:"#92400e",marginTop:6}}>Fill both fields to stamp this revision as approved. Operations will see the stamp on their view.</div>}
        </div>
        {designForm.status==="Done"&&proj?.currentStage==="Design"&&(
          <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:10,padding:"10px 14px",margin:"12px 0",fontSize:".82rem",color:"#059669"}}>✓ Marking as Done will advance this project to Fabrication automatically.</div>
        )}
        <div style={{display:"flex",gap:10,marginTop:16}}><Btn full onClick={saveDesign}>Save Design Details</Btn><Btn variant="ghost" onClick={()=>setDesignModal(false)}>Cancel</Btn></div>
      </Modal>
      <Modal open={infModal} onClose={()=>setInfModal(false)} title="Log Inflow / Payment">
        <Fld label="Month">
          <Sel value={infForm?.month??new Date().getMonth()} onChange={e=>setInfForm(p=>({...p,month:Number(e.target.value)}))}>
            {MONTHS.map((m,i)=><option key={m} value={i}>{m}</option>)}
          </Sel>
        </Fld>
        <Fld label="Amount (₱)" required>
          <Inp type="number" value={infForm?.amount||""} onChange={e=>setInfForm(p=>({...p,amount:e.target.value}))} placeholder="e.g. 25000"/>
        </Fld>
        <Fld label="Source / Client" required>
          <Inp value={infForm?.source||""} onChange={e=>setInfForm(p=>({...p,source:e.target.value}))} placeholder="e.g. Metro Retail Co."/>
        </Fld>
        <Fld label="Link to Project">
          <Sel value={infForm?.projectId||"none"} onChange={e=>setInfForm(p=>({...p,projectId:e.target.value==="none"?null:e.target.value}))}>
            <option value="none">— Not linked to a project —</option>
            {projList.map(d=><option key={d.id} value={d.id}>{d.client}</option>)}
          </Sel>
        </Fld>
        <Fld label="Note" hint="e.g. Full payment, 50% deposit, partial">
          <Inp value={infForm?.note||""} onChange={e=>setInfForm(p=>({...p,note:e.target.value}))} placeholder="Payment note"/>
        </Fld>
        <div style={{display:"flex",gap:10,marginTop:20}}>
          <Btn full onClick={saveInf}>✓ Save Payment</Btn>
          <Btn variant="ghost" onClick={()=>setInfModal(false)}>Cancel</Btn>
        </div>
      </Modal>
      {mobileNavRef.current}
    </div>
    </WrapCtx.Provider>
  );
  });
  // ── AUTH SCREENS ─────────────────────────────────────────────────────────────
  if(!ready) return(
    <div style={{minHeight:"100vh",background:"#f8fafc",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Segoe UI',sans-serif"}}>
      <div style={{textAlign:"center"}}>
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"2rem",color:"#0f172a",letterSpacing:-1}}>GMD <span style={{color:"#f59e0b"}}>PRODUCTIONS</span></div>
        <div style={{color:"#94a3b8",marginTop:8,fontSize:".88rem"}}>Loading your workspace…</div>
      </div>
    </div>
  );

  // ── AUTH GATE ─────────────────────────────────────────────────────────────
  if(!session) return <><AuthScreen authView={authView} setAuthView={setAuthView} onLogin={login} onRegister={register} sbReady={sbReady}/><Toaster/><DialogHost/></>;

  // ── OFFICE TV WALL DISPLAY ─────────────────────────────────────────────────
  // The dedicated read-only kiosk account (role "Display") never sees the normal
  // app shell — it lands straight on the fullscreen, touch-navigable dashboard
  // built to fill the 65" office touchscreen. No nav, no write actions.
  if(role==="Display") return <><OfficeTVDashboard deals={deals} wonDeals={wonDeals} checklists={checklist} announcements={announcements} today={today} todayL={todayL} onLogout={logout} onAddJob={addOpsEvent}/><Toaster/><DialogHost/></>;



  if(page==="home"){

  // ── SALES HOME ───────────────────────────────────────────────────────────
  if(role==="Sales") return(
    <Wrap>
      <DeptHeader
        name={session?.name?.split(" ")[0]}
        subtitle={`Sales · ${todayL}`}
        buttons={[
          {label:"+ New Deal",    icon:"🤝", bg:"#6366f1", action:()=>openAddDeal()},
          {label:"Pipeline",      icon:"📊", bg:"#1e293b", action:()=>setPage("pipeline")},
          {label:"My Projects",   icon:"📋", bg:"#1e293b", action:()=>setPage("projects")},
          {label:"Flag for Award",icon:"🏆", bg:"#059669", action:()=>setPage("pipeline")},
          {label:"Addenda",       icon:"📝", bg:"#8b5cf6", action:()=>setPage("addenda")},
        ]}
      />
      {(()=>{
        const me=session?.name;
        const myDeals=deals.filter(d=>d.salesOwner===me);
        const myWon=myDeals.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage));
        const myPipe=myDeals.filter(d=>isActivePipeline(d.stage));
        const myUnpriced=myPipe.filter(d=>!d.standbyPO&&(!Number(d.value)||Number(d.value)===0));
        const pendingAddenda=addenda.filter(a=>!a.salesNotified&&a.status!=="Rejected"&&myWon.some(d=>d.id===a.dealId));
        const fmtK=v=>v>=1000000?"₱"+Math.round(v/1000000*10)/10+"M":"₱"+Math.round(v/1000)+"K";
        // ── Performance window (deals created / closing rate) ────────────────
        // Cohort = deals this AE owns that were acquired in the window. Addendums
        // (child deals) are left out so an approved scope change doesn't inflate
        // the closing rate. Closing rate = Won ÷ (Won + Did Not Win); cancelled
        // and still-open deals aren't decided yet so they sit outside the ratio.
        const nowD=new Date(today);
        const inWin=d=>{
          if(homePeriod==="all") return true;
          const dt=d.dateAcquired?new Date(d.dateAcquired):null;
          if(!dt||isNaN(dt)) return false;
          return dt.getFullYear()===nowD.getFullYear()&&(homePeriod==="year"||dt.getMonth()===nowD.getMonth());
        };
        const cohort=myDeals.filter(d=>!d.parentDealId&&inWin(d));
        const cWon=cohort.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage));
        const cLost=cohort.filter(d=>d.stage==="Did Not Win");
        const cOpen=cohort.filter(d=>isActivePipeline(d.stage));
        const decided=cWon.length+cLost.length;
        const closeRate=decided?Math.round(cWon.length/decided*100):null;
        const winLabel=homePeriod==="month"?MONTHS[nowD.getMonth()]+" "+nowD.getFullYear():homePeriod==="year"?String(nowD.getFullYear()):"All time";
        // ── Collections & commission (every awarded project, incl. addendums) ─
        // One basis: VAT-exclusive, from the billing ledger (dealCollected).
        const myAwarded=myWon.filter(d=>!d.standbyPO);
        const aContract=myAwarded.reduce((s,d)=>s+(Number(d.value)||0),0);
        const aColl=myAwarded.reduce((s,d)=>s+collectedBase(d,dealCollected(d)),0);
        const collPct=aContract>0?Math.min(100,Math.round(aColl/aContract*100)):0;
        const billedUnpaid=myAwarded.reduce((s,d)=>s+dealOutstanding(d),0);
        const cEarned=myAwarded.reduce((s,d)=>s+commissionEarned(d,dealCollected(d)),0);
        const cProj=myAwarded.reduce((s,d)=>s+commissionProjected(d),0);
        const cPaid=payoutsPaid((payouts||[]).filter(p=>p.payee===me));
        const cPayable=commissionPayable(cEarned,cPaid);
        const myLeadPending=myDeals.filter(d=>leadOriginPending(d)&&!isLostStage(d.stage)).length;
        const tile=(l,v,sub,c,action,extra)=>(
          <div key={l} onClick={action} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:`1.5px solid ${c}33`,cursor:action?"pointer":"default"}}>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#64748b",fontWeight:700}}>{l}</div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:c,marginTop:4,fontVariantNumeric:"tabular-nums"}}>{v}</div>
            {extra}
            {sub&&<div style={{fontSize:".7rem",color:"#64748b",marginTop:3}}>{sub}</div>}
          </div>
        );
        const cols=window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)";
        return(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* ── My performance ───────────────────────────────────────── */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
              <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem"}}>📈 My performance <span style={{fontWeight:600,color:"#64748b",fontSize:".75rem"}}>· {winLabel}</span></div>
              <div style={{display:"flex",background:"#f1f5f9",borderRadius:9,padding:3}}>
                {[["month","This month"],["year","This year"],["all","All time"]].map(([v,l])=>(
                  <button key={v} onClick={()=>setHomePeriod(v)} style={{border:"none",background:homePeriod===v?"#6366f1":"transparent",color:homePeriod===v?"#fff":"#475569",fontFamily:"inherit",fontWeight:700,fontSize:".74rem",padding:"5px 12px",borderRadius:6,cursor:"pointer"}}>{l}</button>
                ))}
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:cols,gap:12}}>
              {tile("Deals created",cohort.length,`acquired · ${cOpen.length} still open`,"#6366f1",()=>setPage("pipeline"))}
              {tile("Closing rate",closeRate===null?"—":closeRate+"%",decided?`${cWon.length} won · ${cLost.length} did not win`:"no decided deals yet",closeRate===null?"#94a3b8":closeRate>=50?"#059669":closeRate>=25?"#d97706":"#dc2626")}
              {tile("Collected",collPct+"%",`${fmtK(aColl)} of ${fmtK(aContract)} · VAT-ex`,"#059669",()=>setPage("billing"),
                <div style={{height:5,borderRadius:20,background:"#e2e8f0",overflow:"hidden",marginTop:4}}><div style={{height:"100%",width:collPct+"%",background:"#059669"}}/></div>)}
              {tile("Commission earned",fmtK(cEarned),`payable ${fmtK(cPayable)} · of ${fmtK(cProj)} at full collection`,"#047857",()=>{setPipeTab("awarded");setPage("pipeline");})}
            </div>
            <div style={{fontSize:".7rem",color:"#64748b",marginTop:-4}}>
              {myAwarded.length} awarded project{myAwarded.length!==1?"s":""} · billed but unpaid {fmtK(billedUnpaid)} (incl. VAT) · paid out {fmtK(cPaid)}
              {myLeadPending>0&&<span style={{color:"#b45309",fontWeight:700}}> · ⏳ {myLeadPending} self-sourced claim{myLeadPending!==1?"s":""} awaiting Manager approval</span>}
            </div>
            {/* Scope changes needing Sales action */}
            {pendingAddenda.length>0&&(
              <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,overflow:"hidden"}}>
                <div style={{background:"#d97706",padding:"10px 16px"}}><span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⚠️ {pendingAddenda.length} Scope Change{pendingAddenda.length!==1?"s":""} Need Your Action</span></div>
                {pendingAddenda.slice(0,4).map((a,i)=>{
                  const d=myWon.find(x=>x.id===a.dealId);
                  return(
                    <div key={a.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 16px",borderBottom:i<Math.min(pendingAddenda.length,4)-1?"1px solid #fef3c7":"",background:"#fff"}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".83rem"}}>{a.title||"Untitled Scope Change"}</div>
                        <div style={{fontSize:".7rem",color:"#94a3b8"}}>{d?.client||"?"} · {a.status}</div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                        <button onClick={()=>{setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(a.id);setPage("boq");}} title="Open this change order's BOQ (sections, rate card, markup)" style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:7,padding:"5px 10px",color:"#1d4ed8",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer",whiteSpace:"nowrap"}}>🧮 BOQ{(a.coBoqData?.items?.length)?` (${a.coBoqData.items.length})`:""}</button>
                        <button onClick={()=>{setJumpDeal(a.dealId);setPage("projects");}} style={{background:"#f59e0b",border:"none",borderRadius:7,padding:"5px 12px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer"}}>Review →</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* Unpriced deals */}
            {myUnpriced.length>0&&(
              <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                <div>
                  <div style={{fontWeight:700,color:"#dc2626",fontSize:".85rem"}}>⏳ {myUnpriced.length} deal{myUnpriced.length!==1?"s":""} awaiting QS pricing</div>
                  <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:2}}>{myUnpriced.slice(0,3).map(d=>d.client).join(", ")}{myUnpriced.length>3&&` +${myUnpriced.length-3} more`}</div>
                </div>
                <button onClick={()=>setPage("pipeline")} style={{background:"#ef4444",border:"none",borderRadius:7,padding:"6px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",cursor:"pointer",whiteSpace:"nowrap"}}>View Pipeline →</button>
              </div>
            )}
            {/* My awarded projects */}
            {myWon.length>0&&(
              <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>🏆 My Awarded Projects ({myWon.length})</span>
                  <span style={{fontSize:".72rem",color:"rgba(255,255,255,.5)",cursor:"pointer",textDecoration:"underline"}} onClick={()=>setPage("pipeline")}>See all →</span>
                </div>
                {myWon.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed").slice(0,6).map((d,i,arr)=>{
                  const cv=Number(d.value||0);const pct=cv>0?Math.min(100,Math.round(collectedBase(d,dealCollected(d))/cv*100)):0;
                  const sc={"06 · Kickoff":"#8b5cf6","07 · Briefing":"#6366f1","08 · Fabrication":"#f59e0b","09 · Site & Billing":"#f97316","10 · Installation":"#3b82f6","11 · Punchlist":"#ef4444"}[d.stage]||"#94a3b8";
                  return(
                    <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<arr.length-1?"1px solid #f8fafc":""}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:700,color:"#0f172a",fontSize:".83rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                        <div style={{display:"flex",gap:6,marginTop:3,alignItems:"center"}}>
                          <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".54rem",fontWeight:600,padding:"1px 6px",borderRadius:3,background:sc+"18",color:sc,border:`1px solid ${sc}44`}}>{d.stage?.replace(/^\d+ · /,"")||"—"}</span>
                          <span style={{fontSize:".68rem",color:"#10b981",fontWeight:700}}>₱{Number(d.value||0).toLocaleString("en-PH")}</span>
                          <span style={{fontSize:".66rem",color:pct===100?"#059669":"#94a3b8",fontWeight:600}}>{pct}% collected</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })()}
    </Wrap>
  );

  // ── SALES & OPS ADMIN HOME ────────────────────────────────────────────────
  if(role==="SalesOpsAdmin") return(
    <Wrap>
      <DeptHeader
        name={session?.name?.split(" ")[0]}
        subtitle={`Sales & Ops Admin · ${todayL}`}
        buttons={[
          {label:"+ New Deal",     icon:"🤝", bg:"#6366f1", action:()=>openAddDeal()},
          {label:"+ Add Client",   icon:"🏢", bg:"#059669", action:()=>{setPage("pipeline");setQuickAddClientOpen(true);}},
          {label:"Submit CE",      icon:"📐", bg:"#7c3aed", action:()=>setPage("ceqs")},
          {label:"Billing",        icon:"🧾", bg:"#1e293b", action:()=>setPage("billing")},
          {label:"Projects",       icon:"📋", bg:"#f97316", action:()=>setPage("projects")},
        ]}
      />
      {(()=>{
        const activePipe=deals.filter(d=>isActivePipeline(d.stage));
        const pendingCE=ceReqs.filter(r=>r.status!=="Done");
        const allMs=billings.filter(b=>b.dealId);
        const outstanding=arSummary(allMs,id=>dealById.get(id)).outstanding;
        const activeProjects=wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed");
        const fmtK2=v=>v>=1000000?"₱"+Math.round(v/1000000*10)/10+"M":"₱"+Math.round(v/1000)+"K";
        return(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* KPI strip */}
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
              {[
                {l:"Active Pipeline",    v:activePipe.length,        c:"#6366f1", icon:"📊", action:()=>setPage("pipeline")},
                {l:"CE Requests Open",   v:pendingCE.length,         c:"#7c3aed", icon:"📐", action:()=>setPage("ceqs")},
                {l:"Outstanding Billing",v:fmtK2(outstanding),       c:outstanding>0?"#ef4444":"#94a3b8", icon:"🧾", action:()=>setPage("billing")},
                {l:"Active Projects",    v:activeProjects.length,    c:"#f97316", icon:"📋", action:()=>setPage("projects")},
              ].map(({l,v,c,icon,action})=>(
                <div key={l} onClick={action} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:`1.5px solid ${c}22`,cursor:"pointer",transition:"all .15s"}}>
                  <div style={{fontSize:"1.1rem"}}>{icon}</div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.25rem",color:c,marginTop:4}}>{v}</div>
                  <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
                </div>
              ))}
            </div>
            {/* Active projects — operations progress at a glance */}
            {activeProjects.length>0&&(
              <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontWeight:700,color:"#f97316",fontSize:".88rem"}}>📋 Projects In Progress ({activeProjects.length})</span>
                  <span style={{fontSize:".72rem",color:"rgba(255,255,255,.5)",cursor:"pointer",textDecoration:"underline"}} onClick={()=>setPage("projects")}>See all →</span>
                </div>
                {activeProjects.slice(0,6).map((d,i,arr)=>{
                  const cv=Number(d.value||0);const pct=cv>0?Math.min(100,Math.round(collectedBase(d,dealCollected(d))/cv*100)):0;
                  const sc={"06 · Kickoff":"#8b5cf6","07 · Briefing":"#6366f1","08 · Fabrication":"#f59e0b","09 · Site & Billing":"#f97316","10 · Installation":"#3b82f6","11 · Punchlist":"#ef4444"}[d.stage]||"#94a3b8";
                  return(
                    <div key={d.id} onClick={()=>{setJumpDeal(d.id);setPage("projects");}} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<arr.length-1?"1px solid #f8fafc":"",cursor:"pointer"}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:700,color:"#0f172a",fontSize:".83rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                        <div style={{display:"flex",gap:6,marginTop:3,alignItems:"center",flexWrap:"wrap"}}>
                          <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".54rem",fontWeight:600,padding:"1px 6px",borderRadius:3,background:sc+"18",color:sc,border:`1px solid ${sc}44`}}>{d.stage?.replace(/^\d+ · /,"")||"—"}</span>
                          <span style={{fontSize:".68rem",color:"#10b981",fontWeight:700}}>₱{Number(d.value||0).toLocaleString("en-PH")}</span>
                          <span style={{fontSize:".66rem",color:pct===100?"#059669":"#94a3b8",fontWeight:600}}>{pct}% collected</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })()}
    </Wrap>
  );

  // ── FINANCE HOME ──────────────────────────────────────────────────────────
  // Finance Assistant (accounting + finance modals) shares the Finance dashboard.
  if(role==="Finance"||role==="FinanceAssistant") return(
    <Wrap>
      <DeptHeader
        name={session?.name?.split(" ")[0]}
        subtitle={`${roleLabel(role)} · ${todayL}`}
        buttons={[
          {label:"Log Payment",   icon:"💵", bg:"#8b5cf6", action:()=>{setFromHome(true);setPage("billing");}},
          {label:"Other Payable",   icon:"💸", bg:"#3b82f6", action:()=>openAddExp()},
          {label:"Open Billing",  icon:"📋", bg:"#1e293b", action:()=>setPage("billing")},
          {label:"Cash Position", icon:"💰", bg:"#059669", action:()=>setPage("finance")},
        ]}
      />
      {/* What needs a person today, each with a button to fix it */}
      <AttentionPanel billings={billings} deals={deals} prs={prs} payables={payables} today={today}
        pages={role==="FinanceAssistant"?["billing","bills"]:["billing","procurement","bills"]}
        go={to=>{if(to==="bills"){setFinTab("bills");setPage("finance");}else setPage(to);}}/>

      {/* KPI row */}
      {(()=>{
        const allMs=billings.filter(b=>b.dealId);
        const _ar=arSummary(allMs,id=>dealById.get(id));
        const totalBilled=_ar.billed;
        const totalPaid=_ar.collected;
        const totalOutstanding=_ar.outstanding;
        const overdue30=allMs.filter(m=>isBillingOverdue(m,today));
        const todayCash=Object.values(cashPositions).find(c=>c.date===today)||null;
        return(
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12,marginBottom:24}}>
            {[
              {l:"Total Billed",       v:"₱"+Math.round(totalBilled/1000)+"K",              c:"#3b82f6", icon:"🧾", action:()=>setPage("billing")},
              {l:"Collected",          v:"₱"+Math.round(totalPaid/1000)+"K",                c:"#059669", icon:"✅", action:()=>setPage("billing")},
              {l:"Outstanding",        v:"₱"+Math.round(totalOutstanding/1000)+"K",         c:"#ef4444", icon:"⏰", action:()=>setPage("billing")},
              {l:"Overdue Invoices",   v:overdue30.length+" invoices",                      c:"#f59e0b", icon:"🚨", action:()=>setPage("billing")},
            ].map(({l,v,c,icon,action})=>(
              <div key={l} onClick={action} style={{background:"#fff",borderRadius:12,padding:"16px",border:"1.5px solid #e2e8f0",textAlign:"center",cursor:"pointer"}}>
                <div style={{fontSize:"1.4rem",marginBottom:4}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
                <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
              </div>
            ))}
          </div>
        );
      })()}

      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:16}}>
        {/* Cash position shortcut */}
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
          <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>💰 Daily Cash Position</span>
            <button onClick={()=>setPage("finance")} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:6,padding:"4px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>Open →</button>
          </div>
          <div style={{padding:"14px 16px"}}>
            {Object.keys(cashPositions).length===0
              ? <div style={{color:"#94a3b8",fontSize:".82rem",textAlign:"center",padding:"16px"}}>No cash position entries yet. Click Open to start today's entry.</div>
              : (()=>{
                  const _cs=bankCashSummary(cashPositions,today);
                  const latest=_cs.latest;
                  if(!latest) return <div style={{color:"#94a3b8",fontSize:".82rem",textAlign:"center",padding:"16px"}}>No valid entries found.</div>;
                  const total=_cs.total;
                  return(
                    <div>
                      <div style={{fontSize:".72rem",color:"#94a3b8",marginBottom:8}}>Last entry: {latest.date}</div>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.8rem",color:"#059669"}}>₱{total.toLocaleString("en-PH",{minimumFractionDigits:0})}</div>
                      <div style={{fontSize:".72rem",color:"#64748b"}}>Total ending balance across 6 banks</div>
                      {_cs.floatTotal>0.005&&<div style={{fontSize:".72rem",color:"#64748b",marginTop:2}}>₱{_cs.bookTotal.toLocaleString("en-PH",{minimumFractionDigits:0})} after ₱{_cs.floatTotal.toLocaleString("en-PH",{minimumFractionDigits:0})} uncleared checks</div>}
                    </div>
                  );
                })()
            }
          </div>
        </div>

        {/* Overdue invoices */}
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
          <div style={{background:"#dc2626",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🚨 Overdue Invoices</span>
            <button onClick={()=>setPage("billing")} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:6,padding:"4px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>View All →</button>
          </div>
          <div style={{padding:"0"}}>
            {(()=>{
              const today2=new Date();
              const od=billings.filter(m=>isBillingOverdue(m,today))
                .sort((a,b)=>new Date(a.dueDate)-new Date(b.dueDate)).slice(0,5);
              if(!od.length) return <div style={{padding:"16px",color:"#94a3b8",fontSize:".82rem",textAlign:"center"}}>✅ No overdue invoices</div>;
              return od.map((m,i)=>{
                const d=wonDeals.find(x=>x.id===m.dealId);
                const days=Math.floor((today2-new Date(m.dueDate))/(1000*60*60*24));
                const bal=milestoneBalance(m,d);
                return(
                  <div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 14px",borderBottom:i<4?"1px solid #f8fafc":"",flexWrap:"wrap",gap:4}}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{d?.client||"?"}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8"}}>{m.invoiceNo||"No invoice #"}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontWeight:700,color:"#dc2626",fontSize:".82rem"}}>₱{Math.round(bal).toLocaleString()}</div>
                      <div style={{fontSize:".68rem",color:"#f59e0b"}}>{days}d overdue</div>
                    </div>
                  </div>
                );
              });
            })()}
          </div>
        </div>
      </div>

      {/* Projects needing billing setup */}
      {(()=>{
        const noBilling=wonDeals.filter(d=>!billings.find(b=>b.dealId===d.id));
        if(!noBilling.length) return null;
        return(
          <div style={{marginTop:16,background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"14px 18px"}}>
            <div style={{fontWeight:700,color:"#92400e",marginBottom:10,fontSize:".88rem"}}>⚠️ {noBilling.length} awarded projects have no billing milestones set up</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {noBilling.slice(0,6).map(d=>(
                <button key={d.id} onClick={()=>{setBillingJumpDeal(d.id);setPage("billing");}} style={{background:"#fff",border:"1px solid #fde68a",borderRadius:20,padding:"4px 12px",fontSize:".75rem",color:"#92400e",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>{d.client} — {d.ceNo}</button>
              ))}
              {noBilling.length>6&&<span style={{fontSize:".75rem",color:"#92400e",padding:"4px 8px"}}>+{noBilling.length-6} more</span>}
            </div>
          </div>
        );
      })()}
    </Wrap>
  );

  // ── ACCOUNTING HOME ───────────────────────────────────────────────────────
  if(role==="Accounting") return(
    <AcctHome exps={exps} vouchers={vouchers} fmt={fmt} today={today} greeting={greeting} todayL={todayL} session={session} setPage={setPage} setFinTab={setFinTab} wonDeals={wonDeals} Wrap={Wrap}/>
  );

  // ── QS HOME ──────────────────────────────────────────────────────────────
  if(role==="QS") return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"there"} 👋</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>QS Dashboard · {todayL}</div>
        </div>
        <button onClick={()=>setPage("costanalysis")} style={{background:"#8b5cf6",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📈 Cost Analysis</button>
      </div>

      {(()=>{
        const noBudget=wonDeals.filter(d=>!budgets[d.id]||(!budgets[d.id].Materials&&!budgets[d.id].Labor&&!budgets[d.id].Overhead&&!budgets[d.id].Subcon));
        const autoBudgets=wonDeals.filter(d=>budgets[d.id]?.autoGenerated);
        // Unpriced pipeline deals — Sales created but QS has not set value yet
        const wonIds=new Set(wonDeals.map(d=>d.id));
        const unpricedDeals=deals.filter(d=>!wonIds.has(d.id)&&!d.standbyPO&&(!Number(d.value)||Number(d.value)===0)&&d.stage&&!isLostStage(d.stage)&&!["12 · Close-Out","14 · Completed"].includes(d.stage));
        const withBudget=wonDeals.filter(d=>budgets[d.id]);
        const overBudget=withBudget.filter(d=>{
          const b=budgets[d.id];const total=(b.Materials||0)+(b.Labor||0)+(b.Overhead||0)+(b.Subcon||0);
          const spent=exps.filter(e=>e.dealId===d.id).reduce((s,e)=>s+Number(e.amount||0),0);
          return spent>total&&total>0;
        });

        // Margin health per project
        const marginHealth=wonDeals.map(d=>{
          const b=budgets[d.id];
          const budgetTotal=b?(b.Materials||0)+(b.Labor||0)+(b.Overhead||0)+(b.Subcon||0):0;
          const spent=exps.filter(e=>e.dealId===d.id).reduce((s,e)=>s+Number(e.amount||0),0);
          const contractVal=Number(d.value||0);
          const projectedCost=budgetTotal>0?Math.max(spent,budgetTotal):spent;
          const margin=contractVal>0?Math.round((contractVal-projectedCost)/contractVal*100):null;
          const jo=dealJo(jos,d.id);
          return{d,margin,spent,budgetTotal,contractVal,jo,isAuto:b?.autoGenerated,needsReview:b?.autoGenerated};
        }).filter(x=>x.contractVal>0);

        const healthGreen=marginHealth.filter(x=>x.margin!==null&&x.margin>=30);
        const healthYellow=marginHealth.filter(x=>x.margin!==null&&x.margin>=20&&x.margin<30);
        const healthRed=marginHealth.filter(x=>x.margin!==null&&x.margin<20);

        return(<div style={{display:"flex",flexDirection:"column",gap:16}}>
          {/* Unpriced pipeline deals alert */}
          {unpricedDeals.length>0&&(
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fecaca",overflow:"hidden"}}>
              <div style={{background:"#dc2626",padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⚠️ {unpricedDeals.length} Unpriced Pipeline Deal{unpricedDeals.length!==1?"s":""} — Action Needed</span>
                <span style={{fontSize:".72rem",color:"rgba(255,255,255,.7)"}}>Sales created · awaiting QS price</span>
              </div>
              {unpricedDeals.slice(0,5).map((d,i)=>{
                const age=d.createdAt?Math.ceil((new Date()-new Date(d.createdAt))/86400000):null;
                return(
                  <div key={d.id} onClick={()=>setPage("pipeline")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 16px",borderBottom:i<Math.min(unpricedDeals.length,5)-1?"1px solid #fee2e2":"",cursor:"pointer",background:"#fff"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#fef2f2"}
                    onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".84rem"}}>{d.client}</div>
                      <div style={{fontSize:".7rem",color:"#94a3b8"}}>{d.ceNo||"No CE"} · {d.stage?.replace(/^\d+ · /,"")||"Pipeline"} · AE: {d.salesOwner||"—"}</div>
                    </div>
                    {age!==null&&<span style={{fontSize:".68rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:20,padding:"2px 8px",fontWeight:700,whiteSpace:"nowrap"}}>{age}d old</span>}
                  </div>
                );
              })}
              {unpricedDeals.length>5&&<div style={{padding:"8px 16px",fontSize:".72rem",color:"#94a3b8",textAlign:"center"}}>+{unpricedDeals.length-5} more · go to Pipeline to set prices</div>}
            </div>
          )}

          {/* KPI Row */}
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
            {[
              {l:"Active Projects",    v:wonDeals.length,         c:"#8b5cf6", icon:"📋"},
              {l:"Auto-Budget Set",    v:autoBudgets.length,      c:"#06b6d4", icon:"🤖", sub:"needs QS review"},
              {l:"Needs Budget",       v:noBudget.length,         c:"#f59e0b", icon:"⏳", click:()=>setPage("costanalysis")},
              {l:"Over Budget",        v:overBudget.length,       c:"#ef4444", icon:"🚨", click:()=>setPage("costanalysis")},
            ].map(({l,v,c,icon,sub,click})=>(
              <div key={l} onClick={click} style={{background:"#fff",borderRadius:12,padding:"16px",border:`1.5px solid ${c}33`,textAlign:"center",cursor:click?"pointer":"default"}}>
                <div style={{fontSize:"1.4rem",marginBottom:4}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:c}}>{v}</div>
                <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
                {sub&&<div style={{fontSize:".62rem",color:"#94a3b8",marginTop:2}}>{sub}</div>}
              </div>
            ))}
          </div>

          {/* Margin health summary row */}
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:10}}>
            {[
              {l:"On Target (≥30%)",  v:healthGreen.length,  c:"#059669", bg:"#f0fdf4", border:"#6ee7b7", icon:"🟢"},
              {l:"At Risk (20–29%)",  v:healthYellow.length, c:"#d97706", bg:"#fffbeb", border:"#fde68a", icon:"🟡"},
              {l:"Below Target (<20%)",v:healthRed.length,   c:"#dc2626", bg:"#fef2f2", border:"#fecaca", icon:"🔴"},
            ].map(({l,v,c,bg,border,icon})=>(
              <div key={l} style={{background:bg,borderRadius:12,padding:"14px",border:`1.5px solid ${border}`,textAlign:"center"}}>
                <div style={{fontSize:"1.2rem",marginBottom:3}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                <div style={{fontSize:".65rem",color:c,fontWeight:600,marginTop:2}}>{l}</div>
              </div>
            ))}
          </div>

          {/* Auto-budgets needing review */}
          {autoBudgets.length>0&&(
            <div style={{background:"#eff6ff",borderRadius:12,border:"1.5px solid #93c5fd",overflow:"hidden"}}>
              <div style={{background:"#1d4ed8",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🤖 {autoBudgets.length} Auto-Budgets Pending Your Review</span>
                <span style={{fontSize:".7rem",color:"rgba(255,255,255,.7)"}}>System set 30% margin target — please verify splits</span>
              </div>
              {autoBudgets.slice(0,6).map((d,i)=>{
                const b=budgets[d.id];
                const total=(b.Materials||0)+(b.Labor||0)+(b.Overhead||0)+(b.Subcon||0);
                const margin=Number(d.value||0)>0?Math.round((Number(d.value||0)-total)/Number(d.value||0)*100):0;
                const jo=dealJo(jos,d.id);
                return(
                  <div key={d.id} onClick={()=>setPage("costanalysis")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<autoBudgets.length-1?"1px solid #dbeafe":"",cursor:"pointer",background:"#fff"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#eff6ff"}
                    onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{d.client}</div>
                      <div style={{fontSize:".72rem",color:"#64748b",marginTop:1}}>{d.ceNo} · PM: {pcards[d.id]?.pm1||jo?.pm1||"—"} · Budget: ₱{Math.round(total).toLocaleString("en-PH",{maximumFractionDigits:0})}</div>
                    </div>
                    <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
                      <span style={{fontSize:".72rem",fontWeight:700,color:margin>=30?"#059669":"#f59e0b",background:margin>=30?"#f0fdf4":"#fffbeb",border:`1px solid ${margin>=30?"#6ee7b7":"#fde68a"}`,borderRadius:20,padding:"2px 8px"}}>{margin}% margin</span>
                      <span style={{fontSize:".68rem",background:"#dbeafe",color:"#1d4ed8",border:"1px solid #93c5fd",borderRadius:20,padding:"2px 7px",fontWeight:600}}>Auto</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Margin health per project */}
          {marginHealth.length>0&&(
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#1e293b",padding:"11px 16px"}}>
                <span style={{fontWeight:700,color:"#a78bfa",fontSize:".88rem"}}>📊 Margin Health — All Projects</span>
              </div>
              {marginHealth.sort((a,b)=>(a.margin??999)-(b.margin??999)).map((x,i)=>{
                const {d,margin,spent,budgetTotal,contractVal,isAuto}=x;
                const clr=margin===null?"#94a3b8":margin>=30?"#059669":margin>=20?"#d97706":"#dc2626";
                const bgClr=margin===null?"#f8fafc":margin>=30?"#f0fdf4":margin>=20?"#fffbeb":"#fef2f2";
                const pct=contractVal>0?Math.min(100,Math.round(spent/contractVal*100)):0;
                return(
                  <div key={d.id} style={{padding:"10px 16px",borderBottom:i<marginHealth.length-1?"1px solid #f8fafc":"",background:bgClr+"80"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:5}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".84rem"}}>{d.client}</div>
                        <div style={{fontSize:".68rem",color:"#94a3b8"}}>{d.ceNo} · Contract: ₱{Math.round(contractVal).toLocaleString("en-PH",{maximumFractionDigits:0})}{isAuto?<span style={{marginLeft:5,background:"#dbeafe",color:"#1d4ed8",borderRadius:20,padding:"1px 6px",fontWeight:600}}>Auto</span>:null}</div>
                      </div>
                      <span style={{fontWeight:800,color:clr,fontSize:".9rem",flexShrink:0}}>
                        {margin===null?"No data":margin+"%"}
                      </span>
                    </div>
                    {budgetTotal>0&&(
                      <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden"}}>
                        <div style={{height:"100%",width:pct+"%",background:clr,borderRadius:3,transition:"width .5s"}}/>
                      </div>
                    )}
                    {budgetTotal>0&&<div style={{fontSize:".62rem",color:"#94a3b8",marginTop:3}}>Spent ₱{Math.round(spent).toLocaleString("en-PH",{maximumFractionDigits:0})} of ₱{Math.round(budgetTotal).toLocaleString("en-PH",{maximumFractionDigits:0})} budget ({pct}%)</div>}
                  </div>
                );
              })}
            </div>
          )}

          {/* Scope changes needing QS pricing */}
          {(()=>{
            const unpricedScope=addenda.filter(a=>!a.value&&(a.status==="Discovered"||a.status==="Sales Notified"));
            if(!unpricedScope.length) return null;
            return(
              <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fed7aa",overflow:"hidden"}}>
                <div style={{background:"#f59e0b",padding:"11px 16px"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⚠️ {unpricedScope.length} Scope Changes Need QS Pricing</span>
                </div>
                {unpricedScope.slice(0,5).map((a,i)=>{
                  const d=wonDeals.find(x=>x.id===a.dealId);
                  return(
                    <div key={a.id} onClick={()=>{setJumpDeal(a.dealId);setPage("projects");}} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 16px",borderBottom:i<unpricedScope.length-1?"1px solid #f8fafc":"",cursor:"pointer"}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".83rem"}}>{a.title}</div>
                        <div style={{fontSize:".7rem",color:"#94a3b8"}}>{d?.client||"?"} · {a.discoveredBy||"?"}</div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                        <button onClick={e=>{e.stopPropagation();setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(a.id);setPage("boq");}} title="Build this change order's BOQ (sections, rate card, markup)" style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:6,padding:"3px 9px",fontSize:".68rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>🧮 Build BOQ</button>
                        <span style={{fontSize:".7rem",background:"#fef9c3",color:"#92400e",border:"1px solid #fde047",borderRadius:20,padding:"2px 8px",fontWeight:600}}>Needs price</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>);
      })()}
    </Wrap>
  );

  // ── PROCUREMENT HOME ──────────────────────────────────────────────────────
  if(isProcurementRole(role)) return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"there"} 👋</div>
          <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Procurement Overview · {todayL}</div>
        </div>
        <button onClick={()=>setPage("procurement")} style={{background:"#06b6d4",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📦 Purchase Orders</button>
      </div>

      {/* KPIs */}
      {(()=>{
        const pendingPRs=prs.filter(p=>["Pending Approval","Approved","PO Issued"].includes(p.status));
        const needsApproval=prs.filter(p=>p.status==="Pending Approval");
        const pendingMRs=mreqs.filter(m=>m.status==="Submitted"||m.status==="Approved");
        const pendingBRs=breqs.filter(b=>b.status==="Pending"||b.status==="Approved");
        const deliveredToday=prs.filter(p=>p.deliveryDate===today&&p.status==="Delivered");
        return(
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:12,marginBottom:24}}>
            {[
              {l:"Open Purchase Orders",      v:pendingPRs.length,     c:"#06b6d4", icon:"📦", click:()=>setPage("procurement")},
              {l:"Awaiting Mgr Approval",     v:needsApproval.length,  c:needsApproval.length>0?"#ef4444":"#94a3b8", icon:"⏳", click:()=>setPage("procurement")},
              ...(pageOn("requests")?[{l:"Material Requests",         v:pendingMRs.length,     c:"#f97316", icon:"🔧", click:()=>setPage("requests")},
              {l:"Budget Requests",           v:pendingBRs.length,     c:"#8b5cf6", icon:"💳", click:()=>setPage("requests")}]:[]),
              {l:"Arriving Today",            v:deliveredToday.length, c:"#059669", icon:"🚚", click:()=>setPage("procurement")},
            ].map(({l,v,c,icon,click})=>(
              <div key={l} onClick={click} style={{background:"#fff",borderRadius:12,padding:"16px",border:`1.5px solid ${c}33`,textAlign:"center",cursor:click?"pointer":"default"}}>
                <div style={{fontSize:"1.4rem",marginBottom:4}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:c}}>{v}</div>
                <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
              </div>
            ))}
          </div>
        );
      })()}

      {/* Pending MRs needing action */}
      {(()=>{
        const pending=mreqs.filter(m=>m.status==="Submitted").slice(0,6);
        if(!pending.length) return null;
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",marginBottom:16}}>
            <div style={{background:"#f97316",padding:"12px 16px"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🔧 Material Requests Waiting for Your Action ({pending.length})</span>
            </div>
            {pending.map((m,i)=>{
              const d=wonDeals.find(x=>x.id===m.dealId);
              return(
                <div key={m.id} onClick={()=>setPage("requests")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<pending.length-1?"1px solid #f8fafc":"",cursor:"pointer"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{m.item}</div>
                    <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · Qty: {m.qty} {m.unit} · {m.urgency||"Normal"}</div>
                  </div>
                  <span style={{fontSize:".72rem",background:"#fff7ed",color:"#c2410c",border:"1px solid #fed7aa",borderRadius:20,padding:"2px 8px",fontWeight:600}}>Waiting</span>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* Swatchboard items to source */}
      {(()=>{
        const toBuy=swatches.filter(s=>s.status==="To Buy").slice(0,5);
        if(!toBuy.length) return null;
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",marginBottom:16}}>
            <div style={{background:"#06b6d4",padding:"12px 16px"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🎨 Swatchboard — Items To Source ({toBuy.length})</span>
            </div>
            {toBuy.map((s,i)=>{
              const d=wonDeals.find(x=>x.id===s.dealId);
              return(
                <div key={s.id} onClick={()=>setPage("swatchboard")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<toBuy.length-1?"1px solid #f8fafc":"",cursor:"pointer"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{s.name}</div>
                    <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"}{d?.ceNo?` · ${d.ceNo}`:""} · {s.qty} {s.unit} · {s.category}</div>
                  </div>
                  <span style={{fontSize:".72rem",background:"#ecfeff",color:"#0891b2",border:"1px solid #a5f3fc",borderRadius:20,padding:"2px 8px",fontWeight:600}}>To Buy</span>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* Swatches received but not yet client-approved */}
      {(()=>{
        const pendingApproval=swatches.filter(s=>s.status==="Received").slice(0,5);
        if(!pendingApproval.length) return null;
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fde68a",overflow:"hidden",marginBottom:16}}>
            <div style={{background:"#d97706",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⚠️ Swatches Received — Awaiting Client Approval ({pendingApproval.length})</span>
              <button onClick={()=>setPage("swatchboard")} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>Open Swatchboard →</button>
            </div>
            {pendingApproval.map((s,i)=>{
              const d=wonDeals.find(x=>x.id===s.projectId||x.id===s.dealId);
              return(
                <div key={s.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<pendingApproval.length-1?"1px solid #fef3c7":"",background:"#fff"}}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{s.name}</div>
                    <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · {s.category} · {s.qty} {s.unit}</div>
                  </div>
                  <span style={{fontSize:".72rem",background:"#fffbeb",color:"#d97706",border:"1px solid #fde68a",borderRadius:20,padding:"2px 8px",fontWeight:600}}>Needs sign-off</span>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* Overdue deliveries */}
      {(()=>{
        const nowD=new Date();
        const overdue=prs.filter(p=>p.deliveryDate&&new Date(p.deliveryDate)<nowD&&!["Delivered","Cancelled"].includes(p.status)).slice(0,5);
        if(!overdue.length) return null;
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fecaca",overflow:"hidden",marginBottom:16}}>
            <div style={{background:"#dc2626",padding:"12px 16px"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🚨 Overdue Deliveries — Follow Up Now ({overdue.length})</span>
            </div>
            {overdue.map((pr,i)=>{
              const d=wonDeals.find(x=>x.id===pr.projectId);
              const daysLate=Math.ceil((nowD-new Date(pr.deliveryDate))/(1000*60*60*24));
              return(
                <div key={pr.id} onClick={()=>setPage("procurement")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<overdue.length-1?"1px solid #fee2e2":"",cursor:"pointer",background:"#fff"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#fef2f2"}
                  onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{pr.itemName}</div>
                    <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · {pr.supplier||"No supplier"} · Expected {pr.deliveryDate}</div>
                  </div>
                  <span style={{fontSize:".72rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:20,padding:"2px 9px",fontWeight:700,whiteSpace:"nowrap"}}>{daysLate}d late</span>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* Expected deliveries this week */}
      {(()=>{
        const nowD=new Date();
        const weekEnd=new Date(nowD); weekEnd.setDate(nowD.getDate()+7);
        const thisWeek=prs.filter(p=>p.deliveryDate&&new Date(p.deliveryDate)>=nowD&&new Date(p.deliveryDate)<=weekEnd&&!["Delivered","Cancelled"].includes(p.status)).slice(0,5);
        if(!thisWeek.length) return null;
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
            <div style={{background:"#059669",padding:"12px 16px"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🚚 Expected Deliveries This Week ({thisWeek.length})</span>
            </div>
            {thisWeek.map((pr,i)=>{
              const d=wonDeals.find(x=>x.id===pr.projectId);
              const daysUntil=Math.ceil((new Date(pr.deliveryDate)-nowD)/(1000*60*60*24));
              return(
                <div key={pr.id} onClick={()=>setPage("procurement")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<thisWeek.length-1?"1px solid #f8fafc":"",cursor:"pointer"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{pr.itemName}</div>
                    <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · {pr.supplier||"No supplier"} · {pr.deliveryDate}</div>
                  </div>
                  <span style={{fontSize:".72rem",background:"#f0fdf4",color:"#059669",border:"1px solid #6ee7b7",borderRadius:20,padding:"2px 9px",fontWeight:700,whiteSpace:"nowrap"}}>
                    {daysUntil===0?"Today":daysUntil===1?"Tomorrow":`in ${daysUntil}d`}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })()}
    </Wrap>
  );

  // ── OPERATIONS HOME ───────────────────────────────────────────────────────
  if(role==="Operations") return(
    <Wrap>
      <DeptHeader
        name={session?.name?.split(" ")[0]||"Team"}
        subtitle={`Operations · ${todayL}`}
        buttons={[
          {label:"Log Update",      icon:"📝", bg:"#f97316", action:()=>setPmUpdateModal&&setPmUpdateModal({dealId:null,dealName:"General"})},
          {label:"Report Blocker",  icon:"🚨", bg:"#dc2626", action:()=>setPmUpdateModal&&setPmUpdateModal({dealId:null,dealName:"General",initialType:"Blocker"})},
          {label:"PRF",icon:"📦", bg:"#f59e0b", action:()=>setPage("materialreq")},
          {label:"My Projects",     icon:"📋", bg:"#1e293b", action:()=>setPage("projects")},
        ]}
      />

      {(()=>{
        const myName=session?.name||"";
        const firstWord=(myName||"").split(" ")[0]?.toLowerCase()||"";
        const myProjects=wonDeals.filter(d=>{
          const jo=dealJo(jos,d.id);
          return jo&&[jo.pm1,jo.pm2,jo.pm3,jo.coordinator].filter(Boolean).some(p=>p===myName||p.toLowerCase().includes(firstWord));
        });
        const display=myProjects.length>0?myProjects:wonDeals;
        const now=new Date();

        // At-risk & needs-update flags
        const needsUpdate=display.filter(d=>{
          const last=actLog.filter(e=>e.dealId===d.id&&e.action==="PM Update")[0];
          const daysSince=last?Math.ceil((now-new Date(last.date))/(1000*60*60*24)):999;
          return daysSince>=3;
        });
        const atRisk=display.filter(d=>{
          const pc=pcards[d.id];
          if(!pc?.targetEndDate) return false;
          const daysLeft=Math.ceil((new Date(pc.targetEndDate)-now)/(1000*60*60*24));
          return daysLeft<=7;
        });
        const myOpenTasks=checklist.filter(c2=>c2.status!=="Done"&&display.some(d=>d.id===c2.projectId));

        const openBlockers=(blockers||[]).filter(b=>b.status==="Open"&&display.some(d=>d.id===b.dealId)).length;
        return(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>

            {/* ── AT A GLANCE (summary promoted to the top) ─────────────── */}
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"repeat(2,1fr)":"repeat(5,1fr)",gap:10}}>
              {[
                {l:"My Projects",   v:display.length,     icon:"🏗", c:"#6366f1", pg:"projects"},
                {l:"Needs Update",  v:needsUpdate.length, icon:"🚨", c:needsUpdate.length>0?"#dc2626":"#94a3b8", pg:"projects"},
                {l:"At Risk",       v:atRisk.length,      icon:"⏰", c:atRisk.length>0?"#d97706":"#94a3b8", pg:"projects"},
                {l:"Open Tasks",    v:myOpenTasks.length, icon:"✅", c:"#3b82f6", pg:"checklist"},
                {l:"Open Blockers", v:openBlockers,       icon:"⛔", c:openBlockers>0?"#ef4444":"#94a3b8", pg:"projects"},
              ].map(({l,v,icon,c,pg})=>(
                <div key={l} onClick={()=>setPage(pg)} style={{background:"#fff",borderRadius:10,padding:"12px 14px",border:`1.5px solid ${c}22`,textAlign:"center",cursor:"pointer"}}>
                  <div style={{fontSize:"1.15rem"}}>{icon}</div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.35rem",color:c,marginTop:3}}>{v}</div>
                  <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:2}}>{l}</div>
                </div>
              ))}
            </div>

            {/* 🚨 Needs Update Now */}
            {needsUpdate.length>0&&(
              <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,overflow:"hidden"}}>
                <div style={{background:"#dc2626",padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🚨 Needs Update Now — {needsUpdate.length} project{needsUpdate.length!==1?"s":""} silent for 3+ days</span>
                  <span style={{fontSize:".72rem",color:"rgba(255,255,255,.7)"}}>Log an update before your client asks</span>
                </div>
                {needsUpdate.map((d,i)=>{
                  const last=actLog.filter(e=>e.dealId===d.id&&e.action==="PM Update")[0];
                  const daysSince=last?Math.ceil((now-new Date(last.date))/(1000*60*60*24)):null;
                  return(
                    <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<needsUpdate.length-1?"1px solid #fee2e2":"",background:"#fff"}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8"}}>{daysSince===null?"Never updated":daysSince+"d since last update"} · {d.product}</div>
                      </div>
                      <button onClick={()=>setPmUpdateModal({dealId:d.id,dealName:d.client})}
                        style={{background:"#dc2626",border:"none",borderRadius:8,padding:"7px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                        📝 Log Now
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            {/* ⏰ At Risk This Week */}
            {atRisk.length>0&&(
              <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,overflow:"hidden"}}>
                <div style={{background:"#d97706",padding:"10px 16px"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⏰ At Risk — {atRisk.length} project{atRisk.length!==1?"s":""} finishing within 7 days or overdue</span>
                </div>
                {atRisk.map((d,i)=>{
                  const pc=pcards[d.id];
                  const daysLeft=pc?.targetEndDate?Math.ceil((new Date(pc.targetEndDate)-now)/(1000*60*60*24)):null;
                  return(
                    <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<atRisk.length-1?"1px solid #fef3c7":"",background:"#fff"}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8"}}>Target: {pc?.targetEndDate||"—"}</div>
                      </div>
                      <span style={{fontSize:".78rem",fontWeight:700,color:daysLeft!==null&&daysLeft<0?"#dc2626":"#d97706",background:daysLeft!==null&&daysLeft<0?"#fef2f2":"#fffbeb",border:"1px solid currentColor",borderRadius:20,padding:"3px 10px",whiteSpace:"nowrap"}}>
                        {daysLeft===null?"No TAT set":daysLeft<0?`${Math.abs(daysLeft)}d OVERDUE`:`${daysLeft}d left`}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* My Active Projects */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between"}}>
                <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>🏗 My Active Projects</span>
                <span style={{fontSize:".72rem",color:"rgba(255,255,255,.5)"}}>{display.length} projects · <span style={{cursor:"pointer",textDecoration:"underline",color:"rgba(255,255,255,.6)"}} onClick={()=>setPage("projects")}>See all →</span></span>
              </div>
              {display.length===0&&<div style={{padding:"20px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No active projects assigned to you.</div>}
              {display.slice(0,8).map((d,i)=>{
                const pc=pcards[d.id];
                const jo=dealJo(jos,d.id);
                const depsTotal=Object.values(pc?.departments||{}).length||6;
                const depsDone=Object.values(pc?.departments||{}).filter(dept=>dept.done).length;
                const pct=Math.round(depsDone/depsTotal*100);
                const daysLeft=pc?.targetEndDate?Math.ceil((new Date(pc.targetEndDate)-now)/(1000*60*60*24)):null;
                const isOver=daysLeft!==null&&daysLeft<0;
                const lastUpd=actLog.filter(e=>e.dealId===d.id&&e.action==="PM Update")[0];
                const daysSince=lastUpd?Math.ceil((now-new Date(lastUpd.date))/(1000*60*60*24)):null;
                return(
                  <div key={d.id} style={{padding:"12px 16px",borderBottom:i<display.length-1?"1px solid #f8fafc":""}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:700,color:"#0f172a",fontSize:".9rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:1}}>
                          PM: {pc?.pm1||jo?.pm1||"—"} · {pct}% complete
                          {daysSince!==null&&<span style={{marginLeft:8,color:daysSince>=3?"#dc2626":"#94a3b8"}}>{daysSince===0?"Updated today":daysSince===1?"Updated yesterday":`Last update ${daysSince}d ago`}</span>}
                        </div>
                        <div style={{height:3,background:"#f1f5f9",borderRadius:2,marginTop:6,width:"100%",maxWidth:200}}>
                          <div style={{height:"100%",width:pct+"%",background:pct===100?"#059669":isOver?"#dc2626":"#3b82f6",borderRadius:2}}/>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                        {daysLeft!==null&&(
                          <span style={{fontSize:".7rem",fontWeight:700,color:isOver?"#dc2626":daysLeft<=7?"#d97706":"#059669",background:isOver?"#fef2f2":daysLeft<=7?"#fffbeb":"#f0fdf4",border:`1px solid ${isOver?"#fecaca":daysLeft<=7?"#fde68a":"#6ee7b7"}`,borderRadius:20,padding:"2px 8px",whiteSpace:"nowrap"}}>
                            {isOver?`${Math.abs(daysLeft)}d over`:`${daysLeft}d left`}
                          </span>
                        )}
                        <button onClick={e=>{e.stopPropagation();setPmUpdateModal({dealId:d.id,dealName:d.client});}}
                          style={{background:"#0ea5e9",border:"none",borderRadius:7,padding:"5px 12px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                          📝 Update
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Pending requests — kept as a slim reachable strip (MRs/BRs) */}
            {(mreqs.filter(m=>m.status==="Submitted").length>0||breqs.filter(b=>b.status==="Pending").length>0)&&(
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <div onClick={()=>setPage("requests")} style={{background:"#fff",borderRadius:10,padding:"12px 14px",border:"1.5px solid #f9731622",cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:"1.2rem"}}>🔧</span>
                  <div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:"#f97316"}}>{mreqs.filter(m=>m.status==="Submitted").length}</div><div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8"}}>Pending Material Requests</div></div>
                </div>
                <div onClick={()=>setPage("requests")} style={{background:"#fff",borderRadius:10,padding:"12px 14px",border:"1.5px solid #8b5cf622",cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:"1.2rem"}}>💳</span>
                  <div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:"#8b5cf6"}}>{breqs.filter(b=>b.status==="Pending").length}</div><div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8"}}>Pending Budget Requests</div></div>
                </div>
              </div>
            )}

            {/* My open checklist tasks */}
            {myOpenTasks.length>0&&(
              <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{background:"#3b82f6",padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>✅ My Open Tasks ({myOpenTasks.length})</span>
                  <button onClick={()=>setPage("checklist")} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>See all →</button>
                </div>
                {myOpenTasks.slice(0,5).map((t,i)=>{
                  const d=wonDeals.find(x=>x.id===t.projectId);
                  return(
                    <div key={t.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 16px",borderBottom:i<Math.min(myOpenTasks.length,5)-1?"1px solid #f8fafc":""}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{t.title}</div>
                        <div style={{fontSize:".7rem",color:"#94a3b8"}}>{d?.client||"General"} · {t.dept}</div>
                      </div>
                      <span style={{fontSize:".68rem",background:PRI_CLR[t.priority]+"18",color:PRI_CLR[t.priority],border:`1px solid ${PRI_CLR[t.priority]}44`,borderRadius:20,padding:"1px 8px",fontWeight:600}}>{t.priority||"Normal"}</span>
                    </div>
                  );
                })}
              </div>
            )}

            {myProjects.length>0&&(
              <div style={{background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:8,padding:"8px 14px",fontSize:".8rem",color:"#c2410c",fontWeight:600}}>
                📍 Showing your {myProjects.length} assigned project{myProjects.length!==1?"s":""} · <span style={{cursor:"pointer",textDecoration:"underline"}} onClick={()=>setPage("projects")}>See all projects →</span>
              </div>
            )}

          </div>
        );
      })()}
      {/* Recent Activity */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",marginTop:14}}>
        <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>📋 Recent Activity</span>
          <span style={{fontSize:".72rem",color:"rgba(255,255,255,.5)"}}>Latest updates from all projects</span>
        </div>
        <RecentActivityFeed projs={projs} wonDeals={wonDeals} limit={12}/>
      </div>
    </Wrap>
  );

  // ── DESIGN HOME ───────────────────────────────────────────────────────────
  if(role==="Design") return(
    <Wrap>
      <DeptHeader
        name={session?.name?.split(" ")[0]||"Team"}
        subtitle={`Design · ${todayL}`}
        buttons={[
          {label:"+ New DRF",    icon:"🎨", bg:"#ec4899", action:()=>setPage("drf")},
          {label:"My Requests",  icon:"📋", bg:"#1e293b", action:()=>setPage("drf")},
          ...(pageOn("swatchboard")?[{label:"Swatchboard",  icon:"🎨", bg:"#8b5cf6", action:()=>setPage("swatchboard")}]:[]),
        ]}
      />

      {(()=>{
        const now=new Date();
        const inQueue=wonDeals.filter(d=>pcards[d.id]&&!pcards[d.id]?.departments?.Design?.done)
          .sort((a,b)=>new Date(pcards[a.id]?.awardDate||0)-new Date(pcards[b.id]?.awardDate||0));
        const done=wonDeals.filter(d=>pcards[d.id]?.departments?.Design?.done);

        // Stuck in Revision: design status === "Revision" for 5+ days
        const stuckInRevision=inQueue.filter(d=>{
          const p=projs[d.id];
          if(p?.design?.status!=="Revision") return false;
          const hist=p.design?.statusHistory||[];
          const revEntry=[...hist].reverse().find(h=>h.status==="Revision");
          if(!revEntry) return true;
          return Math.floor((now-new Date(revEntry.date))/(1000*60*60*24))>=5;
        });

        // Missing handoff: Production Plans status but no file link
        const needsHandoff=inQueue.filter(d=>{
          const p=projs[d.id];
          return p?.design?.status==="Production Plans"&&!p?.design?.link;
        });

        return(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>

            {/* Trial pointer — surfaces the new Design Board during the evaluation
                window. Remove this block once the team has picked a default view. */}
            <div onClick={()=>setPage("designboard")} style={{background:"linear-gradient(90deg,#faf5ff,#eef2ff)",border:"1.5px solid #ddd6fe",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,cursor:"pointer",flexWrap:"wrap"}}>
              <div>
                <div style={{fontWeight:700,color:"#6d28d9",fontSize:".9rem"}}>🆕 Try the new Design Board</div>
                <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:2}}>Kanban + most-due view with committed dates and blockers. Tell us if it should replace this page.</div>
              </div>
              <span style={{background:"#7c3aed",border:"none",borderRadius:8,padding:"8px 16px",color:"#fff",fontWeight:700,fontSize:".78rem",whiteSpace:"nowrap"}}>Open board →</span>
            </div>

            {/* KPI strip */}
            {drfs.filter(d=>d.status==="New").length>0&&(
              <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontWeight:700,color:"#dc2626",fontSize:".9rem"}}>🔔 {drfs.filter(d=>d.status==="New").length} new Design Request Form{drfs.filter(d=>d.status==="New").length!==1?"s":""} waiting</div>
                  <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:2}}>Acknowledge to accept the brief</div>
                </div>
                <button onClick={()=>setPage("drf")} style={{background:"#ec4899",border:"none",borderRadius:8,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:"pointer"}}>View DRFs →</button>
              </div>
            )}
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:12}}>
              {[
                {l:"New DRFs",          v:drfs.filter(d=>d.status==="New").length, c:"#dc2626", icon:"🔔", pg:"drf"},
                {l:"In Your Queue",     v:inQueue.length,            c:"#ec4899", icon:"📐"},
                {l:"Stuck in Revision", v:stuckInRevision.length,    c:"#dc2626", icon:"🔴"},
                {l:"Needs Handoff",     v:needsHandoff.length,       c:"#d97706", icon:"📤"},
                {l:"Design Done",       v:done.length,               c:"#059669", icon:"✅"},
              ].map(({l,v,c,icon,pg})=>(
                <div key={l} onClick={pg?()=>setPage(pg):undefined} style={{background:"#fff",borderRadius:12,padding:"14px",border:`1.5px solid ${c}33`,textAlign:"center",cursor:pg?"pointer":"default"}}>
                  <div style={{fontSize:"1.2rem",marginBottom:4}}>{icon}</div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                  <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
                </div>
              ))}
            </div>

            {/* Stuck in Revision alert */}
            {stuckInRevision.length>0&&(
              <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,overflow:"hidden"}}>
                <div style={{background:"#dc2626",padding:"10px 16px"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🔴 Stuck in Revision — {stuckInRevision.length} project{stuckInRevision.length!==1?"s":""} waiting 5+ days for client feedback</span>
                </div>
                {stuckInRevision.map((d,i)=>{
                  const p=projs[d.id];
                  const hist=p?.design?.statusHistory||[];
                  const revEntry=[...hist].reverse().find(h=>h.status==="Revision");
                  const days=revEntry?Math.floor((now-new Date(revEntry.date))/(1000*60*60*24)):null;
                  const jo=dealJo(jos,d.id);
                  return(
                    <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<stuckInRevision.length-1?"1px solid #fee2e2":"",background:"#fff"}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8"}}>AE: {jo?.ae_assigned||d.contact||"—"} · {days!==null?days+"d in revision":"In revision"}</div>
                      </div>
                      <span style={{fontSize:".72rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:20,padding:"2px 9px",fontWeight:700,whiteSpace:"nowrap"}}>Chase AE</span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Missing file handoff */}
            {needsHandoff.length>0&&(
              <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,overflow:"hidden"}}>
                <div style={{background:"#d97706",padding:"10px 16px"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>📤 Ready to Hand Off — Add file link before marking Done ({needsHandoff.length})</span>
                </div>
                {needsHandoff.map((d,i)=>{
                  const p=projs[d.id];
                  return(
                    <div key={d.id} onClick={()=>setPage("projects")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<needsHandoff.length-1?"1px solid #fef3c7":"",background:"#fff",cursor:"pointer"}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8"}}>Status: {p?.design?.status} · No file link yet · Rev: {p?.design?.revisionNo||"not set"}</div>
                      </div>
                      <span style={{fontSize:".72rem",background:"#fffbeb",color:"#d97706",border:"1px solid #fde68a",borderRadius:20,padding:"2px 9px",fontWeight:700,whiteSpace:"nowrap"}}>Add link →</span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Full queue */}
            {inQueue.length===0
              ? <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:12,padding:"24px",textAlign:"center"}}>
                  <div style={{fontSize:"2rem",marginBottom:8}}>🎉</div>
                  <div style={{fontWeight:700,color:"#059669",fontSize:"1rem"}}>All caught up! No projects in your design queue.</div>
                </div>
              : <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  <div style={{background:"#be185d",padding:"12px 16px",display:"flex",justifyContent:"space-between"}}>
                    <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>📐 Full Design Queue — {inQueue.length} projects</span>
                    <span style={{fontSize:".72rem",color:"rgba(255,255,255,.6)"}}>Oldest first</span>
                  </div>
                  {inQueue.slice(0,8).map((d,i)=>{
                    const pc=pcards[d.id];
                    const p=projs[d.id];
                    const tasks=pc?.departments?.Design?.tasks||[];
                    const doneTasks=tasks.filter(t=>t.done).length;
                    const totalTasks=tasks.length||10;
                    const pct=Math.round(doneTasks/totalTasks*100);
                    const waitDays=pc?.awardDate?Math.floor((now-new Date(pc.awardDate))/(1000*60*60*24)):null;
                    const ds=p?.design?.status||"Briefing";
                    const isStuck=stuckInRevision.some(x=>x.id===d.id);
                    const isHandoff=needsHandoff.some(x=>x.id===d.id);
                    return(
                      <div key={d.id} onClick={()=>setPage("projects")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",borderBottom:i<inQueue.length-1?"1px solid #f8fafc":"",cursor:"pointer",background:isStuck?"#fef2f2":isHandoff?"#fffbeb":"#fff"}}
                        onMouseEnter={e=>e.currentTarget.style.opacity="0.85"}
                        onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.client}</div>
                          <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:1,display:"flex",gap:8,alignItems:"center"}}>
                            <span style={{background:DS_CLR[ds]+"18",color:DS_CLR[ds],fontWeight:700,padding:"1px 7px",borderRadius:20,fontSize:".68rem"}}>{ds}</span>
                            <span>{doneTasks}/{totalTasks} tasks</span>
                            {p?.design?.revisionNo&&<span style={{color:"#8b5cf6"}}>Rev: {p.design.revisionNo}</span>}
                          </div>
                          <div style={{height:3,background:"#f1f5f9",borderRadius:2,marginTop:5,width:120}}>
                            <div style={{height:"100%",width:pct+"%",background:"#ec4899",borderRadius:2}}/>
                          </div>
                        </div>
                        {waitDays!==null&&(
                          <span style={{marginLeft:12,fontSize:".72rem",fontWeight:700,color:waitDays>14?"#dc2626":waitDays>7?"#f59e0b":"#64748b",background:waitDays>14?"#fef2f2":waitDays>7?"#fffbeb":"#f8fafc",border:"1px solid #e2e8f0",borderRadius:20,padding:"3px 9px",whiteSpace:"nowrap"}}>
                            {waitDays===0?"Today":waitDays+"d waiting"}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
            }
          </div>
        );
      })()}
    </Wrap>
  );


  // ── PROJECT MOVER ────────────────────────────────────────────────────────
  if(role==="ProjectMover"&&page==="calendar") return(
    <ConstructionCalendar
      wonDeals={wonDeals} completedDeals={completedDeals} deals={deals} pcards={pcards} jos={jos}
      prs={prs} billings={billings} drfs={drfs} ceReqs={ceReqs} payables={payables}
      setPage={setPage} setJumpDeal={setJumpDeal} today={today} Wrap={Wrap}
      checklists={checklist} session={session}
      addOpsEvent={data=>{const rec={...data,id:uid(),dept:"Operations",createdDate:today,createdBy:session?.name||role};upChecklist(cs=>[...cs,rec]);if(isSupabaseReady())sbInsert('checklists',toSbChecklist(rec)).catch(err=>{console.error("Calendar item sync:",err);toastEmit&&toastEmit("Calendar item saved locally only — tap 🔄 sync to push it to the server.","warning",8000);});const proj=wonDeals.find(d=>d.id===rec.projectId);const msg=`📅 <b>Calendar Item Added</b>\n<b>${rec.type||"Event"}</b>: ${rec.title||""}\nDate: ${rec.dueDate||"—"}${proj?`\nProject: ${proj.client}${proj.ceNo?" ("+proj.ceNo+")":""}`:""}\nBy: ${rec.createdBy||"—"}`;const _t=(rec.type||"").toLowerCase();if(_t==="turnover"){sendTelegramNotification("ops",msg);sendTelegramNotification("sales",msg);sendTelegramNotification("management",msg);}else if(_t==="po delivery"){sendTelegramNotification("procurement",msg);sendTelegramNotification("warehouse",msg);}else if(_t.includes("billing")){sendTelegramNotification("financialcontrol",msg);sendTelegramNotification("management",msg);}else if(_t.includes("drf")||_t.includes("design")){sendTelegramNotification("design",msg);}else if(_t==="inspection"){sendTelegramNotification("ops",msg);sendTelegramNotification("management",msg);}else if(_t==="maintenance"){sendTelegramNotification("ops",msg);}else{sendTelegramNotification("ops",msg);sendTelegramNotification("sales",msg);}}}
      updateOpsEvent={(id,ch)=>{upChecklist(cs=>cs.map(c=>c.id===id?{...c,...ch}:c));if(isSupabaseReady())sbUpdate('checklists',id,toSbChecklist({...checklist.find(c=>c.id===id),...ch})).catch(()=>{});}}
      deleteOpsEvent={delOpsEvent}
      updateProjectTurnover={(dealId,date)=>{upPcards(ps=>({...ps,[dealId]:{...ps[dealId],targetEndDate:date}}));if(isSupabaseReady())syncProjectCard(dealId,{target_end_date:date});}}
    />
  );

  // ── PROJECT MOVER HOME ───────────────────────────────────────────────────
  if(role==="ProjectMover"||role==="Coordinator") return(
    <Wrap>
      <DeptHeader
        name={session?.name?.split(" ")[0]||"Team"}
        subtitle={`${role==="Coordinator"?"Project Coordinator":"Project Mover"} · ${todayL}`}
        buttons={[
          {label:"Log Update",   icon:"📝", bg:"#f97316", action:()=>setPmUpdateModal&&setPmUpdateModal({dealId:null,dealName:"General"})},
          {label:"My Projects",  icon:"📋", bg:"#1e293b", action:()=>setPage("projects")},
          {label:"Calendar",     icon:"📅", bg:"#0ea5e9", action:()=>setPage("calendar")},
          {label:"PRF",          icon:"📦", bg:"#f59e0b", action:()=>setPage("materialreq")},
        ]}
      />

      {(()=>{
        const myName=session?.name||"";
        const myProjects=wonDeals.filter(d=>{
          const jo=dealJo(jos,d.id);
          return jo&&[jo.pm1,jo.pm2,jo.pm3,jo.coordinator].filter(Boolean).some(p=>
            p===myName||p.toLowerCase().includes((myName||"").split(" ")[0]?.toLowerCase()||""));
        });
        const otherProjects=wonDeals.filter(d=>!myProjects.find(m=>m.id===d.id));
        const today2=new Date();

        return(
          <div style={{display:"flex",flexDirection:"column",gap:20}}>
            {/* KPIs */}
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
              {[
                {l:"My Projects",    v:myProjects.length,  c:"#0ea5e9", icon:"🏗"},
                {l:"All Active",     v:wonDeals.length,    c:"#0f172a", icon:"📋"},
                {l:"My Updates Today",v:actLog.filter(a=>a.action==="PM Update"&&a.date===today&&myProjects.find(d=>d.id===a.dealId)).length, c:"#059669", icon:"✅"},
                {l:"Scope Changes",  v:addenda.filter(a=>a.discoveredBy===myName).length, c:"#ef4444", icon:"⚠️"},
              ].map(({l,v,c,icon})=>(
                <div key={l} style={{background:"#fff",borderRadius:12,padding:"16px",border:`1.5px solid ${c==="0f172a"?"#e2e8f0":c+"33"}`,textAlign:"center"}}>
                  <div style={{fontSize:"1.3rem",marginBottom:4}}>{icon}</div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:"#"+c.replace("#","")}}>{v}</div>
                  <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
                </div>
              ))}
            </div>

            {/* My assigned projects */}
            <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#0ea5e9",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".9rem"}}>🏗 My Assigned Projects ({myProjects.length})</span>
                <span style={{fontSize:".72rem",color:"rgba(255,255,255,.6)"}}>Sorted by urgency</span>
              </div>
              {myProjects.length===0
                ? <div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>
                    No projects assigned to you yet.<br/>Contact Arrius or Paulo to get added as PM on a Job Order.
                  </div>
                : myProjects
                    .sort((a,b)=>{
                      const da=pcards[a.id]?.targetEndDate?Math.ceil((new Date(pcards[a.id].targetEndDate)-today2)/(1000*60*60*24)):999;
                      const db=pcards[b.id]?.targetEndDate?Math.ceil((new Date(pcards[b.id].targetEndDate)-today2)/(1000*60*60*24)):999;
                      return da-db;
                    })
                    .map((d,i)=>{
                      const jo=dealJo(jos,d.id);
                      const pc=pcards[d.id];
                      const pct=pc?Math.round(Object.values(pc.departments||{}).filter(dept=>dept.done).length/6*100):0;
                      const daysLeft=pc?.targetEndDate?Math.ceil((new Date(pc.targetEndDate)-today2)/(1000*60*60*24)):null;
                      const isOver=daysLeft!==null&&daysLeft<0;
                      const myUpdates=actLog.filter(a=>a.dealId===d.id&&a.action==="PM Update");
                      const lastUpdate=myUpdates[0];
                      return(
                        <div key={d.id} style={{padding:"12px 16px",borderBottom:i<myProjects.length-1?"1px solid #f8fafc":""}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{fontWeight:700,color:"#0f172a",fontSize:".9rem"}}>{d.client}</div>
                              <div style={{fontSize:".72rem",color:"#64748b",marginTop:1}}>{d.ceNo} · {d.contact||""}</div>
                              <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:1}}>
                                PM: {[pc?.pm1||jo?.pm1,pc?.pm2||jo?.pm2,pc?.pm3||jo?.pm3].filter(Boolean).join(", ")||"—"} · Coord: {pc?.coordinator||jo?.coordinator||"—"}
                              </div>
                              {lastUpdate&&(
                                <div style={{fontSize:".72rem",color:"#0ea5e9",marginTop:3,fontStyle:"italic"}}>
                                  Last update ({lastUpdate.date}): {lastUpdate.detail?.slice(0,60)}{lastUpdate.detail?.length>60?"…":""}
                                </div>
                              )}
                            </div>
                            <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4}}>
                              <div style={{display:"flex",gap:6,alignItems:"center"}}>
                                <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.1rem",color:pct===100?"#059669":"#3b82f6"}}>{pct}%</span>
                                {daysLeft!==null&&(
                                  <span style={{fontSize:".7rem",fontWeight:700,color:isOver?"#dc2626":daysLeft<=7?"#f59e0b":"#059669",background:isOver?"#fef2f2":daysLeft<=7?"#fffbeb":"#f0fdf4",border:"1px solid",borderColor:isOver?"#fecaca":daysLeft<=7?"#fde68a":"#6ee7b7",borderRadius:20,padding:"2px 8px",whiteSpace:"nowrap"}}>
                                    {isOver?`${Math.abs(daysLeft)}d OVER`:`${daysLeft}d left`}
                                  </span>
                                )}
                              </div>
                              <button onClick={()=>setPmUpdateModal({dealId:d.id,dealName:d.client,ceNo:d.ceNo,ae:jo?.aeAssigned||d.salesOwner})}
                                style={{background:"#0ea5e9",border:"none",borderRadius:7,padding:"5px 12px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",cursor:"pointer"}}>
                                + Update
                              </button>
                            </div>
                          </div>
                          <div style={{height:4,background:"#f1f5f9",borderRadius:2,marginTop:8}}>
                            <div style={{height:"100%",width:pct+"%",background:pct===100?"#059669":"#0ea5e9",borderRadius:2,transition:"width .4s"}}/>
                          </div>
                        </div>
                      );
                    })
              }
            </div>

            {/* Other projects — read-only */}
            {otherProjects.length>0&&(
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{background:"#475569",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontWeight:700,color:"#fff",fontSize:".9rem"}}>📋 All Other Active Projects ({otherProjects.length})</span>
                  <span style={{fontSize:".72rem",color:"rgba(255,255,255,.5)"}}>Read-only</span>
                </div>
                {otherProjects.slice(0,5).map((d,i)=>{
                  const jo=dealJo(jos,d.id);
                  const pc=pcards[d.id];
                  const pct=pc?Math.round(Object.values(pc.departments||{}).filter(dept=>dept.done).length/6*100):0;
                  return(
                    <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<4?"1px solid #f8fafc":""}}>
                      <div>
                        <div style={{fontWeight:600,color:"#475569",fontSize:".85rem"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d.ceNo} · PM: {pc?.pm1||jo?.pm1||"—"}</div>
                      </div>
                      <span style={{fontSize:".8rem",fontWeight:700,color:"#94a3b8"}}>{pct}%</span>
                    </div>
                  );
                })}
                {otherProjects.length>5&&<div style={{padding:"8px 16px",fontSize:".75rem",color:"#94a3b8",borderTop:"1px solid #f8fafc"}}>+{otherProjects.length-5} more projects</div>}
              </div>
            )}
          </div>
        );
      })()}

      {/* PM Update Modal (also accessible from home) */}
      {pmUpdateModal&&<PmUpdateModal {...pmModalExtra} pmUpdateModal={pmUpdateModal} setPmUpdateModal={setPmUpdateModal} session={session} logActivity={logActivity} addPmUpdate={addPmUpdate} updateProjectTurnover={(dealId,date)=>{upPcards(ps=>({...ps,[dealId]:{...ps[dealId],targetEndDate:date}}));if(isSupabaseReady())syncProjectCard(dealId,{target_end_date:date});}}/>}
    </Wrap>
  );

  // ── OWNER DASHBOARDS — customized by title ─────────────────────────────────
  const ownerTitle = session?.title || role;

  // ─── MAR MUNGCAL — COO ──────────────────────────────────────────────────────
  if(ownerTitle === "COO") return(
    <Wrap>
      <AttentionPanel billings={billings} deals={deals} prs={prs} payables={payables} today={today}
        pages={role==="FinanceAssistant"?["billing","bills"]:["billing","procurement","bills"]}
        go={to=>{if(to==="bills"){setFinTab("bills");setPage("finance");}else setPage(to);}}/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"there"} 👋</div>
          <div style={{fontSize:".82rem",color:"#64748b",marginTop:2}}>COO Dashboard · {todayL}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setPage("finance")} style={{background:"#3b82f6",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",cursor:"pointer"}}>💰 Cash Position</button>
          <button onClick={()=>setPage("billing")} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",cursor:"pointer"}}>🧾 Billing</button>
        </div>
      </div>

      {/* ── FINANCIAL OVERVIEW (owners only) ─────────────────────────── */}
      {(session?.username==="paulo"||session?.username==="mar")&&(
        <FinancialOverview deals={deals} wonDeals={wonDeals} exps={exps} payables={payables} prs={prs} swos={swos} loans={loans} cashPositions={cashPositions} billings={billings} today={today} setPage={setPage} setFinTab={setFinTab} onOpenProject={id=>{setJumpDeal(id);setPage("projects");}} onViewAllMargins={()=>setPage("projectmargins")} isMobile={isMobile}/>
      )}

      {(()=>{
        const allMs = billings;
        const totalBilled   = arTot.billed;
        const totalPaid     = arTot.collected;
        const outstanding   = arTot.outstanding;
        const today2        = new Date();
        const overdue       = allMs.filter(m=>isBillingOverdue(m,today));
        const overdueValue  = overdue.reduce((s,m)=>s+milestoneBalance(m,dealById.get(m.dealId)),0);
        const _cash         = bankCashSummary(cashPositions,today);
        const latestCash    = _cash.latest;
        const totalCash     = _cash.total;
        const noBilling     = wonDeals.filter(d=>!billings.find(b=>b.dealId===d.id));
        const collRate      = Math.round(arTot.collectionRate*100);
        const totalPipeVal  = deals.filter(d=>isActivePipeline(d.stage)).reduce((s,d)=>s+Number(d.value||0),0);

        return(<div style={{display:"flex",flexDirection:"column",gap:16}}>
          {/* KPI Row 1 — Financial health */}
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
            {[
              {l:"Total Cash (6 banks)",   v:"₱"+Math.round(totalCash/1000)+"K",        c:"#059669",  icon:"🏦", sub:!latestCash?"⚠ No entry yet":_cash.stale?`⚠ As of ${latestCash.date} · ${_cash.daysOld}d old`:(_cash.floatTotal>0.005?`✓ Today · ₱${Math.round(_cash.bookTotal/1000)}K after uncleared checks`:"✓ Updated today")},
              {l:"Total Collected YTD",    v:"₱"+Math.round(totalPaid/1000)+"K",         c:"#3b82f6",  icon:"✅", sub:"Collection rate: "+collRate+"%"},
              {l:"Outstanding",            v:"₱"+Math.round(outstanding/1000)+"K",       c:"#f59e0b",  icon:"⏰", sub:overdue.length+" invoices overdue"},
              {l:"Overdue Value",          v:"₱"+Math.round(overdueValue/1000)+"K",      c:"#ef4444",  icon:"🚨", sub:"Needs immediate follow-up", click:()=>setPage("billing")},
            ].map(({l,v,c,icon,sub,click})=>(
              <div key={l} onClick={click} style={{background:"#fff",borderRadius:12,padding:"16px",border:`1.5px solid ${c}33`,cursor:click?"pointer":"default",textAlign:"center"}}>
                <div style={{fontSize:"1.3rem",marginBottom:4}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:2}}>{l}</div>
                {sub&&<div style={{fontSize:".7rem",color:"#64748b",marginTop:3}}>{sub}</div>}
              </div>
            ))}
          </div>

          {/* KPI Row 2 — Pipeline */}
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
            {[
              {l:"Pipeline Value",      v:"₱"+Math.round(totalPipeVal/1000000)+"M", c:"#8b5cf6", icon:"📊"},
              {l:"Awarded Projects",    v:wonDeals.length,                           c:"#0f172a",  icon:"🏆"},
              {l:"No Billing Setup",    v:noBilling.length,                          c:"#f59e0b",  icon:"⚠️", click:()=>setPage("billing")},
              {l:"Projects Complete",   v:wonDeals.filter(d=>Object.values(pcards[d.id]?.departments||{}).every(dept=>dept.done)).length, c:"#059669", icon:"🎉"},
            ].map(({l,v,c,icon,click})=>(
              <div key={l} onClick={click} style={{background:"#fff",borderRadius:12,padding:"14px",border:`1.5px solid ${c==="0f172a"?"#e2e8f0":c+"33"}`,cursor:click?"pointer":"default",textAlign:"center"}}>
                <div style={{fontSize:"1.2rem",marginBottom:3}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:"#"+c.replace("#","")}}>{v}</div>
                <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:2}}>{l}</div>
              </div>
            ))}
          </div>

          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16}}>
            {/* Overdue invoices */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#dc2626",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🚨 Overdue Invoices ({overdue.length})</span>
                <button onClick={()=>setPage("billing")} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>View all →</button>
              </div>
              {overdue.length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>✅ No overdue invoices</div>
                :overdue.sort((a,b)=>new Date(a.dueDate)-new Date(b.dueDate)).slice(0,5).map((m,i)=>{
                  const d=wonDeals.find(x=>x.id===m.dealId);
                  const bal=milestoneBalance(m,d);
                  const days=Math.floor((today2-new Date(m.dueDate))/(1000*60*60*24));
                  return(<div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 14px",borderBottom:i<4?"1px solid #f8fafc":"",flexWrap:"wrap",gap:4}}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{d?.client||"?"}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8"}}>{m.invoiceNo} · {days}d overdue</div>
                    </div>
                    <div style={{fontWeight:700,color:"#dc2626",fontSize:".82rem"}}>₱{Math.round(bal).toLocaleString()}</div>
                  </div>);
                })
              }
            </div>

            {/* Cash position by bank */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#1e293b",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>🏦 Cash Position {latestCash?"("+latestCash.date+")":""}</span>
                <button onClick={()=>setPage("finance")} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>Update →</button>
              </div>
              {!latestCash
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No cash position entered yet. Finance needs to update daily.</div>
                :_cash.perBank.map((b,i)=>{
                  const val=b.val;
                  return(<div key={b.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 14px",borderBottom:i<_cash.perBank.length-1?"1px solid #f8fafc":""}}>
                    <span style={{fontSize:".82rem",color:"#475569",fontWeight:500}}>{b.short}</span>
                    <span style={{fontWeight:700,color:val>0?"#059669":"#94a3b8",fontSize:".82rem"}}>₱{val.toLocaleString("en-PH",{minimumFractionDigits:0})}</span>
                  </div>);
                })
              }
            </div>
          </div>

          {/* Recent activity */}
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
            <div style={{background:"#475569",padding:"11px 16px"}}><span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>📋 Recent Activity</span></div>
            {actLog.slice(0,6).map((a,i)=>{
              const d=wonDeals.find(x=>x.id===a.dealId);
              return(<div key={i} style={{display:"flex",gap:12,alignItems:"flex-start",padding:"9px 14px",borderBottom:i<5?"1px solid #f8fafc":""}}>
                <span style={{fontSize:".72rem",color:"#94a3b8",whiteSpace:"nowrap",marginTop:1}}>{a.date}</span>
                <div style={{fontSize:".82rem",color:"#475569"}}><strong style={{color:"#0f172a"}}>{a.action}</strong>{a.detail?" — "+a.detail:""}{d?" ("+d.client+")":""}</div>
              </div>);
            })}
            {actLog.length===0&&<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No activity yet.</div>}
          </div>
        </div>);
      })()}
    </Wrap>
  );

  // ─── ARRIUS CATUBAY — Operations Director ─────────────────────────────────
  if(ownerTitle === "Operations Director") return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"there"} 👋</div>
          <div style={{fontSize:".82rem",color:"#64748b",marginTop:2}}>Operations Director · {todayL}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setPage("projects")} style={{background:"#f97316",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",cursor:"pointer"}}>📋 Project Cards</button>
        </div>
      </div>

      {(()=>{
        const today2=new Date();
        const noBudget=wonDeals.filter(d=>!budgets[d.id]||(!budgets[d.id].Materials&&!budgets[d.id].Labor&&!budgets[d.id].Overhead&&!budgets[d.id].Subcon));
        const overBudget=wonDeals.filter(d=>{
          const b=budgets[d.id]; if(!b) return false;
          const total=(b.Materials||0)+(b.Labor||0)+(b.Overhead||0)+(b.Subcon||0);
          const spent=exps.filter(e=>e.dealId===d.id).reduce((s,e)=>s+Number(e.amount||0),0);
          return spent>total&&total>0;
        });
        const overdueProjects=wonDeals.filter(d=>pcards[d.id]?.targetEndDate&&new Date(pcards[d.id].targetEndDate)<today2);
        const newScope=addenda.filter(a=>a.status==="Discovered");
        const pendingMRs=mreqs.filter(m=>m.status==="Submitted");
        const todayPMUpdates=actLog.filter(a=>a.action==="PM Update"&&a.date===today);

        return(<div style={{display:"flex",flexDirection:"column",gap:16}}>
          {/* KPI Row */}
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
            {[
              {l:"Active Projects",    v:wonDeals.length,          c:"#f97316", icon:"🏗",  click:()=>setPage("projects")},
              {l:"TAT Overdue",        v:overdueProjects.length,   c:"#ef4444", icon:"⏰",  click:()=>setPage("projects")},
              {l:"New Scope Changes",  v:newScope.length,          c:"#f59e0b", icon:"⚠️"},
              {l:"PM Updates Today",   v:todayPMUpdates.length,    c:"#059669", icon:"📝"},
            ].map(({l,v,c,icon,click})=>(
              <div key={l} onClick={click} style={{background:"#fff",borderRadius:12,padding:"16px",border:`1.5px solid ${c}33`,cursor:click?"pointer":"default",textAlign:"center"}}>
                <div style={{fontSize:"1.3rem",marginBottom:4}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:c}}>{v}</div>
                <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:2}}>{l}</div>
              </div>
            ))}
          </div>

          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16}}>
            {/* TAT overdue projects */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#dc2626",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⏰ TAT Overdue ({overdueProjects.length})</span>
                <button onClick={()=>setPage("projects")} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>View all →</button>
              </div>
              {overdueProjects.length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>✅ No overdue projects</div>
                :overdueProjects.sort((a,b)=>new Date(pcards[a.id]?.targetEndDate||0)-new Date(pcards[b.id]?.targetEndDate||0)).slice(0,6).map((d,i)=>{
                  const pc=pcards[d.id];
                  const jo=dealJo(jos,d.id);
                  const daysOver=Math.ceil((today2-new Date(pc.targetEndDate))/(1000*60*60*24));
                  return(<div key={d.id} onClick={()=>setPage("projects")} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 14px",borderBottom:i<5?"1px solid #f8fafc":"",cursor:"pointer"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{d.client}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8"}}>PM: {pc?.pm1||jo?.pm1||"—"} · {d.ceNo}</div>
                    </div>
                    <span style={{fontSize:".72rem",fontWeight:700,color:"#dc2626",background:"#fef2f2",border:"1px solid #fecaca",borderRadius:20,padding:"2px 8px"}}>{daysOver}d over</span>
                  </div>);
                })
              }
            </div>

            {/* PM Updates feed */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#0ea5e9",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>📝 Latest PM Updates</span>
              </div>
              {actLog.filter(a=>a.action==="PM Update").length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No PM updates logged yet.</div>
                :actLog.filter(a=>a.action==="PM Update").slice(0,6).map((a,i)=>{
                  const d=wonDeals.find(x=>x.id===a.dealId);
                  return(<div key={i} style={{padding:"9px 14px",borderBottom:i<5?"1px solid #f8fafc":""}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".8rem"}}>{d?.client||"?"}</div>
                        <div style={{fontSize:".75rem",color:"#475569",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.detail}</div>
                      </div>
                      <span style={{fontSize:".68rem",color:"#94a3b8",whiteSpace:"nowrap"}}>{a.date}</span>
                    </div>
                  </div>);
                })
              }
            </div>
          </div>

          {/* Scope changes + MRs row */}
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16}}>
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#f59e0b",padding:"11px 16px"}}><span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⚠️ Scope Changes Needing Action ({newScope.length})</span></div>
              {newScope.length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>✅ No open scope changes</div>
                :newScope.slice(0,5).map((a,i)=>{
                  const d=wonDeals.find(x=>x.id===a.dealId);
                  return(<div key={a.id} onClick={()=>{setJumpDeal(a.dealId);setPage("projects");}} style={{padding:"9px 14px",borderBottom:i<4?"1px solid #f8fafc":"",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                    <div style={{minWidth:0}}>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{a.title}</div>
                      <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · {a.discoveredBy} · ₱{Number(a.value||0).toLocaleString()}</div>
                    </div>
                    <button onClick={e=>{e.stopPropagation();setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(a.id);setPage("boq");}} title="Build this change order's BOQ (sections, rate card, markup)" style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:6,padding:"3px 9px",fontSize:".68rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap",flexShrink:0}}>🧮 BOQ{(a.coBoqData?.items?.length)?` (${a.coBoqData.items.length})`:""}</button>
                  </div>);
                })
              }
            </div>
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#f97316",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🔧 Pending Material Requests ({pendingMRs.length})</span>
                {pageOn("requests")&&<button onClick={()=>setPage("requests")} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>View →</button>}
              </div>
              {pendingMRs.length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>✅ No pending MRs</div>
                :pendingMRs.slice(0,5).map((m,i)=>{
                  const d=wonDeals.find(x=>x.id===m.dealId);
                  return(<div key={m.id} style={{display:"flex",justifyContent:"space-between",padding:"9px 14px",borderBottom:i<4?"1px solid #f8fafc":"",alignItems:"center"}}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{m.item}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8"}}>{d?.client||"?"} · {m.urgency||"Normal"}</div>
                    </div>
                    <span style={{fontSize:".7rem",fontWeight:700,color:"#c2410c",background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:20,padding:"2px 8px"}}>Waiting</span>
                  </div>);
                })
              }
            </div>
          </div>
        </div>);
      })()}
    </Wrap>
  );

  // ─── PAOLO GOMEZ — Sales Manager ──────────────────────────────────────────
  if(ownerTitle === "Sales Manager") return(
    <Wrap>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"there"} 👋</div>
          <div style={{fontSize:".82rem",color:"#64748b",marginTop:2}}>Sales Manager · {todayL}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setPage("pipeline")} style={{background:"#10b981",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",cursor:"pointer"}}>📊 Pipeline</button>
          <button onClick={()=>setPage("billing")} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",cursor:"pointer"}}>💵 Billing</button>
        </div>
      </div>

      {/* ── AWARD REQUESTS ── */}
      {(()=>{
        const reqs=deals.filter(d=>d.notes&&d.notes.includes("[AWARD REQUEST"));
        if(!reqs.length) return null;
        return(
          <div style={{background:"#fffbeb",borderRadius:12,border:"2px solid #f59e0b",padding:"12px 16px",marginBottom:16}}>
            <div style={{fontWeight:800,color:"#92400e",fontSize:".9rem",marginBottom:8}}>
              🏆 {reqs.length} Deal{reqs.length>1?"s":""} Awaiting Award Approval
            </div>
            {reqs.map(d=>{
              const reqLine=d.notes.split("\n").filter(l=>l.includes("[AWARD REQUEST")).pop()||"";
              const reqBy=reqLine.match(/]: (.+?) flagged/)?.[1]||"Sales";
              return(
                <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#fff",borderRadius:7,padding:"8px 12px",marginBottom:4,border:"1px solid #fde68a"}}>
                  <div>
                    <span style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{d.client}</span>
                    <span style={{fontSize:".72rem",color:"#92400e",marginLeft:8}}>by {reqBy} · ₱{Number(d.value||0).toLocaleString()}</span>
                  </div>
                  <button onClick={()=>setPage("pipeline")} style={{background:"#f59e0b",border:"none",borderRadius:6,padding:"5px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",color:"#fff",cursor:"pointer"}}>
                    Review
                  </button>
                </div>
              );
            })}
          </div>
        );
      })()}

      {(()=>{
        const today2=new Date();
        const activePipe=deals.filter(d=>isActivePipeline(d.stage));
        const totalPipeVal=activePipe.reduce((s,d)=>s+Number(d.value||0),0);
        const awardedVal=wonDeals.reduce((s,d)=>s+Number(d.value||0),0);
        const thisMonth=new Date().toISOString().slice(0,7);
        const newThisMonth=deals.filter(d=>d.dateAcquired?.slice(0,7)===thisMonth);
        const allMs=billings;
        const totalPaid=arTot.collected;
        const outstanding=arTot.outstanding;
        const newScope=addenda.filter(a=>a.status==="Discovered"||a.status==="Sales Notified");
        const overdue=allMs.filter(m=>isBillingOverdue(m,today));

        // AE performance — derive from actual deal data instead of a hardcoded
        // roster, so a new AE (or one who was simply missing from a stale list,
        // like Paolo Gomez) always shows up without a code change.
        const aeNames=[...new Set(deals.map(d=>d.salesOwner).filter(Boolean))];
        const aeStats=aeNames.map(ae=>({
          name:ae.split(" ")[0]+(ae.includes("Gail")?" (Gail)":""),
          deals:deals.filter(d=>d.salesOwner===ae).length,
          awarded:wonDeals.filter(d=>d.salesOwner===ae).length,
        })).filter(a=>a.deals>0);

        return(<div style={{display:"flex",flexDirection:"column",gap:16}}>
          {/* KPI Row */}
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:12}}>
            {[
              {l:"Total Pipeline",     v:"₱"+Math.round(totalPipeVal/1000000)+"M",  c:"#10b981", icon:"📊", click:()=>setPage("pipeline")},
              {l:"Awarded Value",      v:"₱"+Math.round(awardedVal/1000000)+"M",    c:"#3b82f6", icon:"🏆"},
              {l:"New This Month",     v:newThisMonth.length+" deals",               c:"#8b5cf6", icon:"✨"},
              {l:"Outstanding AR",     v:"₱"+Math.round(outstanding/1000)+"K",      c:"#f59e0b", icon:"💵", click:()=>setPage("billing")},
            ].map(({l,v,c,icon,click})=>(
              <div key={l} onClick={click} style={{background:"#fff",borderRadius:12,padding:"16px",border:`1.5px solid ${c}33`,cursor:click?"pointer":"default",textAlign:"center"}}>
                <div style={{fontSize:"1.3rem",marginBottom:4}}>{icon}</div>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:2}}>{l}</div>
              </div>
            ))}
          </div>

          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16}}>
            {/* Scope changes needing AE action */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#dc2626",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⚠️ Scope Changes Needing AE Action ({newScope.length})</span>
              </div>
              {newScope.length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>✅ No open scope changes</div>
                :newScope.slice(0,5).map((a,i)=>{
                  const d=wonDeals.find(x=>x.id===a.dealId);
                  return(<div key={a.id} onClick={()=>{setJumpDeal(a.dealId);setPage("projects");}} style={{padding:"9px 14px",borderBottom:i<newScope.length-1?"1px solid #f8fafc":"",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                    <div style={{minWidth:0}}>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{a.title}</div>
                      <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · AE: {d?.salesOwner||"—"} · {a.status}</div>
                      {a.value>0&&<div style={{fontSize:".72rem",color:"#059669",marginTop:1}}>Est. ₱{Number(a.value).toLocaleString()} additional</div>}
                    </div>
                    <button onClick={e=>{e.stopPropagation();setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(a.id);setPage("boq");}} title="Open this change order's BOQ (sections, rate card, markup)" style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:6,padding:"3px 9px",fontSize:".68rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap",flexShrink:0}}>🧮 BOQ{(a.coBoqData?.items?.length)?` (${a.coBoqData.items.length})`:""}</button>
                  </div>);
                })
              }
            </div>

            {/* Collections call list */}
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#1e293b",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>📞 Priority Collections ({overdue.length})</span>
                <button onClick={()=>setPage("billing")} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",fontSize:".72rem",cursor:"pointer",fontFamily:"inherit"}}>Full list →</button>
              </div>
              {overdue.length===0
                ?<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>✅ No overdue collections</div>
                :overdue.sort((a,b)=>new Date(a.dueDate)-new Date(b.dueDate)).slice(0,5).map((m,i)=>{
                  const d=wonDeals.find(x=>x.id===m.dealId);
                  const bal=milestoneBalance(m,d);
                  const days=Math.floor((today2-new Date(m.dueDate))/(1000*60*60*24));
                  return(<div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 14px",borderBottom:i<4?"1px solid #f8fafc":"",flexWrap:"wrap",gap:4}}>
                    <div>
                      <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{d?.client||"?"}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8"}}>AE: {d?.salesOwner||"—"} · {days}d overdue</div>
                    </div>
                    <div style={{fontWeight:700,color:"#dc2626",fontSize:".82rem"}}>₱{Math.round(bal).toLocaleString()}</div>
                  </div>);
                })
              }
            </div>
          </div>

          {/* AE performance */}
          {aeStats.length>0&&(
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{background:"#059669",padding:"11px 16px"}}><span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>👥 AE Performance — {new Date().toLocaleString("en-PH",{month:"long",year:"numeric"})}</span></div>
              <div style={{display:"grid",gridTemplateColumns:`repeat(${aeStats.length},1fr)`,gap:0}}>
                {aeStats.map((ae,i)=>(
                  <div key={ae.name} style={{padding:"14px 16px",textAlign:"center",borderRight:i<aeStats.length-1?"1px solid #f8fafc":""}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",marginBottom:6}}>{ae.name}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:"#10b981"}}>{ae.deals}</div>
                    <div style={{fontSize:".65rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:"1px"}}>Total Deals</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.1rem",color:"#3b82f6",marginTop:6}}>{ae.awarded}</div>
                    <div style={{fontSize:".65rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:"1px"}}>Awarded</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>);
      })()}
    </Wrap>
  );

  // ── PAULO GARCIA — CEO (full system overview) ──────────────────────────────
  // Gross margin = work billed (VAT-ex) − AP-ledger costs (VAT-ex). Was contract
  // value − legacy expenses only, which ignored the ₱9M+ sitting in payables.
  const grossMar=arTot.billed>0?Math.round((arTot.billed-totExp)/arTot.billed*100):0;
  const ceoMob=window.innerWidth<768;
  return(
    <Wrap>
      <AttentionPanel billings={billings} deals={deals} prs={prs} payables={payables} today={today}
        pages={role==="FinanceAssistant"?["billing","bills"]:["billing","procurement","bills"]}
        go={to=>{if(to==="bills"){setFinTab("bills");setPage("finance");}else setPage(to);}}/>
      {/* ── COMMAND BAR ─────────────────────────────────────────────── */}
      <div style={{background:"#0f172a",borderRadius:14,padding:ceoMob?"11px 16px":"16px 20px",marginBottom:ceoMob?10:14,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.4rem",color:"#fff",letterSpacing:"-.5px"}}>
            Good {new Date().getHours()<12?"morning":new Date().getHours()<17?"afternoon":"evening"}, {session?.name?.split(" ")[0]}
          </div>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:1}}>{todayL} · FabHub GMD</div>
        </div>
        </div>

      {/* ── FINANCIAL OVERVIEW (owners only) ─────────────────────────── */}
      {(session?.username==="paulo"||session?.username==="mar")&&(
        <FinancialOverview deals={deals} wonDeals={wonDeals} exps={exps} payables={payables} prs={prs} swos={swos} loans={loans} cashPositions={cashPositions} billings={billings} today={today} setPage={setPage} setFinTab={setFinTab} onOpenProject={id=>{setJumpDeal(id);setPage("projects");}} onViewAllMargins={()=>setPage("projectmargins")} isMobile={ceoMob}/>
      )}

      {/* ── ACTION CENTER (what needs attention, promoted to the top) ── */}
      {(()=>{
        const items=[];
        const attnWonMap=new Map(wonDeals.map(d=>[d.id,d]));
        // Each card carries a `rows` list (shown in a drill-down modal, like the
        // Collections widget) plus a `fullPage` navigation used by the modal's
        // "Open full page →" button. Clicking a card opens the modal; only the
        // modal navigates away.
        if(escalations.length){
          const hi=escalations.filter(e=>e.severity==="high").length;
          const rows=escalations.map(e=>({name:e.client||"—",sub:e.label,id:e.dealId,sev:e.severity}));
          items.push({icon:"⚠️",n:escalations.length,l:"Escalations",sub:hi?`${hi} high severity`:"needs review",tone:"crit",rows,unit:"escalation",fullPage:()=>setPage("projects"),fullPageLabel:"Open Projects →"});
        }
        if(overdueInvCnt){
          const ov=billings.filter(b=>isBillingOverdue(b,today));
          const rows=ov.map(b=>{const d=attnWonMap.get(b.dealId);return{name:d?.contact||d?.client||b.client||"Invoice",sub:`${b.name||b.label||"Invoice"} · due ${b.dueDate}`,amt:milestoneBalance(b,d),id:b.dealId};});
          items.push({icon:"🚨",n:overdueInvCnt,l:"Overdue Invoices",sub:"past due date",tone:"crit",rows,unit:"invoice",fullPage:()=>setPage("billing"),fullPageLabel:"Open Billing →"});
        }
        {
          const ul=billings.filter(b=>isBillingUnsentLate(b,today));
          if(ul.length){
            const rows=ul.map(b=>{const d=attnWonMap.get(b.dealId);return{name:d?.contact||d?.client||b.client||"Invoice",sub:`${b.name||b.label||"Invoice"} · was due ${b.dueDate}`,amt:milestoneBalance(b,d),id:b.dealId};});
            items.push({icon:"📤",n:ul.length,l:"Not Yet Sent",sub:"drafts past due date",tone:"warn",rows,unit:"invoice",fullPage:()=>setPage("billing"),fullPageLabel:"Open Billing →"});
          }
        }
        if(overdueTATCnt){
          const od=wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed"&&pcards[d.id]?.targetEndDate&&pcards[d.id].targetEndDate<today&&!DEPT_ORDER.every(dept=>pcards[d.id]?.departments?.[dept]?.done));
          const rows=od.map(d=>({name:d.contact||d.client||"Project",sub:`${d.ceNo||"No CE"} · due ${pcards[d.id]?.targetEndDate}`,id:d.id}));
          items.push({icon:"⏰",n:overdueTATCnt,l:"Past Deadline",sub:"projects overdue",tone:"warn",rows,unit:"project",fullPage:()=>{setJumpFilter("overdue");setPage("projects");},fullPageLabel:"Open Projects →"});
        }
        if(awardReqCnt){
          const ar=deals.filter(d=>d.notes&&d.notes.includes("[AWARD REQUEST"));
          const rows=ar.map(d=>({name:d.contact||d.client||"Deal",sub:d.ceNo||"Awaiting sign-off",id:d.id}));
          items.push({icon:"🏆",n:awardReqCnt,l:"Award Approvals",sub:"awaiting sign-off",tone:"warn",rows,unit:"request",fullPage:()=>setPage("pipeline"),fullPageLabel:"Open Pipeline →"});
        }
        if(mrPendingCnt){
          const mr=mreqs.filter(m=>m.status==="Submitted");
          const rows=mr.map(m=>{const d=attnWonMap.get(m.dealId||m.projectId);return{name:d?.contact||d?.client||m.title||"Material Request",sub:m.item||m.note||m.title||"Pending",id:m.dealId||m.projectId};});
          items.push({icon:"📋",n:mrPendingCnt,l:"Material Requests",sub:"pending",tone:"info",rows,unit:"request",fullPage:()=>setPage("requests"),fullPageLabel:"Open Requests →"});
        }
        if(addendaAlertCnt){
          const sc=addenda.filter(a=>!a.salesNotified&&a.status!=="Rejected");
          const rows=sc.map(a=>{const d=attnWonMap.get(a.dealId);return{name:d?.contact||d?.client||"Scope Change",sub:a.title||"Addendum",id:a.dealId};});
          items.push({icon:"📝",n:addendaAlertCnt,l:"Scope Changes",sub:"need Sales action",tone:"info",rows,unit:"change",fullPage:()=>setPage("addenda"),fullPageLabel:"Open Addenda →"});
        }
        const TONE={crit:{bg:"#fef2f2",bd:"#fecaca",fg:"#dc2626"},warn:{bg:"#fff7ed",bd:"#fed7aa",fg:"#c2410c"},info:{bg:"#eff6ff",bd:"#bfdbfe",fg:"#1d4ed8"}};
        if(!items.length)return(
          <div style={{background:"#f0fdf4",border:"1.5px solid #bbf7d0",borderRadius:12,padding:"14px 16px",marginBottom:14,display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:"1.1rem"}}>✅</span><span style={{fontWeight:700,color:"#15803d",fontSize:".85rem"}}>All clear — nothing needs your attention right now.</span>
          </div>
        );
        return(
          <div style={{marginBottom:ceoMob?10:14}}>
            <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1.2px",color:"#94a3b8",fontWeight:700,marginBottom:6}}>⚡ Needs Attention</div>
            <div style={{display:"grid",gridTemplateColumns:ceoMob?"repeat(3,1fr)":`repeat(auto-fit,minmax(168px,1fr))`,gap:ceoMob?7:10}}>
              {items.map((a,i)=>{const t=TONE[a.tone];return(
                <div key={i} {...clickable(()=>setAttnDrill({...a,fg:t.fg}))} aria-label="Open attention item details" style={{background:t.bg,border:`1.5px solid ${t.bd}`,borderRadius:12,padding:ceoMob?"9px 10px":"12px 14px",cursor:"pointer",display:"flex",flexDirection:"column",gap:1}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:ceoMob?".95rem":"1.05rem"}}>{a.icon}</span>
                    <span style={{fontSize:".7rem",color:t.fg,fontWeight:700}}>→</span>
                  </div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:ceoMob?"1.35rem":"1.6rem",color:t.fg,lineHeight:1.05}}>{a.n}</div>
                  <div style={{fontSize:ceoMob?".68rem":".74rem",fontWeight:700,color:"#0f172a",lineHeight:1.1}}>{a.l}</div>
                  <div style={{fontSize:".6rem",color:"#94a3b8",lineHeight:1.1}}>{a.sub}</div>
                </div>
              );})}
            </div>
          </div>
        );
      })()}

      {/* ── CHARTS 2×2 ──────────────────────────────────────────────── */}
      {(()=>{
        const now=new Date();
        const months=[];
        for(let i=5;i>=0;i--){const d=new Date(now.getFullYear(),now.getMonth()-i,1);months.push({yr:d.getFullYear(),mo:d.getMonth(),label:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()]});}
        // Awarded month is driven ONLY by the real award date (project_cards.award_date).
        // No fallback to dateAcquired: a won deal with no award date set is undated and drops
        // out of the monthly awarded buckets until a real date is entered, instead of landing
        // in the wrong month on the lead-acquisition date.
        const awardedMonth=d=>{const aw=pcards[d.id]?.awardDate;return aw?new Date(aw):null;};
        const salesData=months.map(({yr,mo})=>deals.filter(d=>{if(!WON_STAGES.includes(d.stage))return false;const dt=awardedMonth(d);return dt&&dt.getFullYear()===yr&&dt.getMonth()===mo;}).reduce((s,d)=>s+Number(d.value||0),0));
        const expData=months.map(({yr,mo})=>exps.filter(e=>{const ds=e.date||(e.year!=null&&e.month!=null?`${e.year}-${String(e.month+1).padStart(2,"0")}-01`:null);if(!ds)return false;const d=new Date(ds);return d.getFullYear()===yr&&d.getMonth()===mo;}).reduce((s,e)=>s+Number(e.amount||0),0));
        const collData=months.map(({yr,mo})=>{let sum=0;billings.forEach(b=>{(b.payments||[]).forEach(p=>{if(!p.date||!isCashPayment(p))return;const d=new Date(p.date);if(d.getFullYear()===yr&&d.getMonth()===mo)sum+=Number(p.amount||0);});});return sum;});
        const awardData=months.map(({yr,mo})=>deals.filter(d=>{if(!WON_STAGES.includes(d.stage))return false;const dt=awardedMonth(d);return dt&&dt.getFullYear()===yr&&dt.getMonth()===mo;}).length);
        const fmtM=v=>v>=1000000?"₱"+Math.round(v/100000)/10+"M":v>=1000?"₱"+Math.round(v/1000)+"K":v>0?"₱"+v:"₱0";
        const BarChart=({data,color,labels})=>{
          const max=Math.max(...data,1);
          const n=data.length;
          const gap=3;
          const barW=(100-gap*(n-1))/n;
          const H=ceoMob?46:64;
          return(
            <svg viewBox={`0 0 100 ${H+10}`} style={{width:"100%",height:H+10,display:"block"}}>
              {data.map((v,i)=>{
                const bh=Math.max((v/max)*H,v>0?2:0);
                const x=i*(barW+gap);
                const y=H-bh;
                const isLast=i===n-1;
                return(
                  <g key={i}>
                    <rect x={x} y={y} width={barW} height={bh} rx={2} fill={isLast?color:color+"44"}/>
                    <text x={x+barW/2} y={H+8} textAnchor="middle" fontSize={6} fill="#94a3b8">{labels[i]}</text>
                  </g>
                );
              })}
            </svg>
          );
        };
        // Pace-adjusted comparison: this month-to-date vs the SAME number of days
        // into last month (not vs. all of last month — that made the 4th of a month
        // always read as a ~95% "crash").
        const D=now.getDate();
        const cyr=now.getFullYear(),cmo=now.getMonth();
        const pm=new Date(cyr,cmo-1,1),pyr=pm.getFullYear(),pmo=pm.getMonth();
        const salesRec=deals.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage)).map(d=>({dt:awardedMonth(d),v:Number(d.value||0)}));
        const expRec=exps.map(e=>{const ds=e.date||(e.year!=null&&e.month!=null?`${e.year}-${String(e.month+1).padStart(2,"0")}-01`:null);return{dt:ds?new Date(ds):null,v:Number(e.amount||0)};});
        const collRec=[];billings.forEach(b=>(b.payments||[]).forEach(p=>{if(p.date&&isCashPayment(p))collRec.push({dt:new Date(p.date),v:Number(p.amount||0)});}));
        const pace=(rec,yr,mo,maxDay,count)=>rec.filter(x=>x.dt&&x.dt.getFullYear()===yr&&x.dt.getMonth()===mo&&x.dt.getDate()<=maxDay).reduce((s,x)=>s+(count?1:x.v),0);
        const charts=[
          {key:"sales",      title:"Sales Value",     data:salesData,  color:"#6366f1", fmt:fmtM, icon:"📊", action:()=>setPage("pipeline"), cur:pace(salesRec,cyr,cmo,D),      prev:pace(salesRec,pyr,pmo,D)},
          {key:"expenses",   title:"Expenses",        data:expData,    color:"#ef4444", fmt:fmtM, icon:"💸", action:()=>setPage("finance"),  cur:pace(expRec,cyr,cmo,D),        prev:pace(expRec,pyr,pmo,D), invert:true},
          {key:"collections",title:"Collections",     data:collData,   color:"#10b981", fmt:fmtM, icon:"💰", action:()=>setPage("billing"),  cur:pace(collRec,cyr,cmo,D),       prev:pace(collRec,pyr,pmo,D)},
          {key:"awarded",    title:"Projects Awarded",data:awardData,  color:"#f59e0b", fmt:v=>v+(v===1?" project":" projects"), icon:"🏆", action:()=>setPage("projects"), cur:pace(salesRec,cyr,cmo,D,true), prev:pace(salesRec,pyr,pmo,D,true)},
        ];
        return(
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:ceoMob?7:10,marginBottom:ceoMob?10:14}}>
            {charts.map(({key,title,data,color,fmt,icon,action,cur,prev,invert})=>{
              const chg=prev>0?Math.round((cur-prev)/prev*100):null;
              const good=chg!=null&&(invert?chg<=0:chg>=0);
              const prevFull=data[data.length-2]||0;
              return(
                <div key={title} {...clickable(()=>setWidgetDrill({key,title,color,icon,fmt,action,cur,cyr,cmo}))} aria-label={`Open ${title} details`} style={{background:T.surface,borderRadius:T.radius.lg,border:`1.5px solid ${T.line}`,padding:ceoMob?"9px 11px":"12px 14px",cursor:"pointer"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:2}}>
                    <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>{icon} {title}</div>
                    {chg!==null?<span title={`vs. first ${D} days of last month`} style={{fontSize:".58rem",fontWeight:700,color:good?"#059669":"#ef4444",background:good?"#f0fdf4":"#fef2f2",borderRadius:5,padding:"1px 5px"}}>{chg>=0?"↑":"↓"}{Math.abs(chg)}% MTD</span>:<span style={{fontSize:".55rem",color:"#cbd5e1",fontWeight:600}}>—</span>}
                  </div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:ceoMob?"1.05rem":"1.15rem",color:color,lineHeight:1.1}}>{fmt(cur)}</div>
                  <div style={{fontSize:".55rem",color:"#94a3b8",marginBottom:ceoMob?4:6,lineHeight:1.15}}>month-to-date · {fmt(prevFull)} last mo total</div>
                  <BarChart data={data} color={color} labels={months.map(m=>m.label)}/>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* ── WIDGET DRILL-DOWN DETAIL ────────────────────────────────── */}
      {widgetDrill&&(()=>{
        const{key,title,color,icon,fmt,action,cur,cyr,cmo}=widgetDrill;
        const mob=window.innerWidth<768;
        const money=v=>"₱"+Math.round(Number(v)||0).toLocaleString("en-PH");
        const MON=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const monLabel=`${MON[cmo]} ${cyr}`;
        const inThisMonth=dt=>dt&&dt.getFullYear()===cyr&&dt.getMonth()===cmo;
        // Awarded month is driven ONLY by the real award date (project_cards.award_date).
        // No fallback to dateAcquired: a won deal with no award date set is undated and drops
        // out of the monthly awarded buckets until a real date is entered, instead of landing
        // in the wrong month on the lead-acquisition date.
        const awardedMonth=d=>{const aw=pcards[d.id]?.awardDate;return aw?new Date(aw):null;};
        // Build the row list for the clicked widget
        let rows=[];
        if(key==="sales"||key==="awarded"){
          rows=deals.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage)&&inThisMonth(awardedMonth(d)))
            .map(d=>({name:d.contact||d.client||"Untitled deal",sub:d.ceNo||"No CE",amt:Number(d.value||0),dt:awardedMonth(d),id:d.id}))
            .sort((a,b)=>b.dt-a.dt);
        }else if(key==="expenses"){
          rows=exps.map(e=>{const ds=e.date||(e.year!=null&&e.month!=null?`${e.year}-${String(e.month+1).padStart(2,"0")}-01`:null);return{...e,_dt:ds?new Date(ds):null};})
            .filter(e=>inThisMonth(e._dt))
            .map(e=>{const pj=e.projectId&&wonDeals.find(x=>x.id===e.projectId);return{name:e.note||e.category||"Expense",sub:(e.payee||e.supplier||e.category||"—")+(pj?` · ${pj.contact||pj.client}`:""),amt:Number(e.amount||0),dt:e._dt};})
            .sort((a,b)=>b.dt-a.dt);
        }else if(key==="collections"){
          billings.forEach(b=>{const dl=wonDeals.find(x=>x.id===b.dealId);(b.payments||[]).forEach(p=>{if(!p.date||!isCashPayment(p))return;const dt=new Date(p.date);if(inThisMonth(dt))rows.push({name:dl?.contact||dl?.client||b.client||"Payment",sub:(dl?.ceNo||b.invoiceNumber||"Client payment"),amt:Number(p.amount||0),dt});});});
          rows.sort((a,b)=>b.dt-a.dt);
        }
        const total=rows.reduce((s,r)=>s+(r.amt||0),0);
        const isCount=key==="awarded";
        return(
          <div onClick={()=>setWidgetDrill(null)} style={{position:"fixed",inset:0,background:"rgba(15,23,42,.65)",zIndex:900,display:"flex",alignItems:mob?"flex-end":"center",justifyContent:"center",padding:mob?0:20}}>
            <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:mob?"18px 18px 0 0":16,width:"100%",maxWidth:mob?undefined:520,boxShadow:"0 24px 64px rgba(0,0,0,.25)",maxHeight:"88vh",display:"flex",flexDirection:"column",overflow:"hidden"}}>
              {/* header */}
              <div style={{padding:"18px 20px 14px",borderBottom:"1px solid #f1f5f9"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>{icon} {title} · {monLabel}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.7rem",color,lineHeight:1.1,marginTop:2}}>{fmt(cur)}</div>
                    <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:1}}>{rows.length} {isCount?(rows.length===1?"project":"projects"):"item"+(rows.length===1?"":"s")} this month</div>
                  </div>
                  <button onClick={()=>setWidgetDrill(null)} style={{background:"#f1f5f9",border:"none",borderRadius:9,width:30,height:30,fontSize:"1rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit",lineHeight:1}}>✕</button>
                </div>
              </div>
              {/* list */}
              <div style={{overflowY:"auto",flex:1}}>
                {rows.length===0?(
                  <div style={{padding:"34px 20px",textAlign:"center",color:"#94a3b8",fontSize:".84rem"}}>Nothing recorded for {monLabel} yet.</div>
                ):rows.map((r,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 20px",borderBottom:i<rows.length-1?"1px solid #f8fafc":""}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:".84rem",fontWeight:600,color:"#0f172a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.name}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.sub}{r.dt?` · ${MON[r.dt.getMonth()]} ${r.dt.getDate()}`:""}</div>
                    </div>
                    {!isCount&&<div style={{fontSize:".84rem",fontWeight:700,color,flexShrink:0}}>{money(r.amt)}</div>}
                  </div>
                ))}
              </div>
              {/* footer */}
              <div style={{borderTop:"1px solid #f1f5f9",padding:"12px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
                {!isCount?(
                  <div style={{fontSize:".72rem",color:"#64748b"}}>Total <span style={{fontWeight:800,color:"#0f172a",fontSize:".92rem",marginLeft:4}}>{money(total)}</span></div>
                ):<div/>}
                <button onClick={()=>{setWidgetDrill(null);action&&action();}} style={{background:color,border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer",whiteSpace:"nowrap"}}>Open full page →</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── NEEDS-ATTENTION DRILL-DOWN DETAIL ───────────────────────── */}
      {attnDrill&&(()=>{
        const{icon,l,n,rows,unit,fg,fullPage,fullPageLabel}=attnDrill;
        const mob=window.innerWidth<768;
        const money=v=>"₱"+Math.round(Number(v)||0).toLocaleString("en-PH");
        const hasAmt=rows.some(r=>r.amt!=null);
        const total=rows.reduce((s,r)=>s+(Number(r.amt)||0),0);
        const SEV={high:{bg:"#fef2f2",fg:"#dc2626",t:"HIGH"},medium:{bg:"#fff7ed",fg:"#c2410c",t:"MED"},low:{bg:"#f8fafc",fg:"#64748b",t:"LOW"}};
        const jump=id=>{if(!id)return;setAttnDrill(null);setJumpDeal(id);setPage("projects");};
        return(
          <div onClick={()=>setAttnDrill(null)} style={{position:"fixed",inset:0,background:"rgba(15,23,42,.65)",zIndex:900,display:"flex",alignItems:mob?"flex-end":"center",justifyContent:"center",padding:mob?0:20}}>
            <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:mob?"18px 18px 0 0":16,width:"100%",maxWidth:mob?undefined:520,boxShadow:"0 24px 64px rgba(0,0,0,.25)",maxHeight:"88vh",display:"flex",flexDirection:"column",overflow:"hidden"}}>
              {/* header */}
              <div style={{padding:"18px 20px 14px",borderBottom:"1px solid #f1f5f9"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700}}>{icon} {l}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.7rem",color:fg,lineHeight:1.1,marginTop:2}}>{n}</div>
                    <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:1}}>{rows.length} {unit}{rows.length===1?"":"s"}</div>
                  </div>
                  <button onClick={()=>setAttnDrill(null)} style={{background:"#f1f5f9",border:"none",borderRadius:9,width:30,height:30,fontSize:"1rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit",lineHeight:1}}>✕</button>
                </div>
              </div>
              {/* list */}
              <div style={{overflowY:"auto",flex:1}}>
                {rows.length===0?(
                  <div style={{padding:"34px 20px",textAlign:"center",color:"#94a3b8",fontSize:".84rem"}}>Nothing to show.</div>
                ):rows.map((r,i)=>{const sv=r.sev&&SEV[r.sev];return(
                  <div key={i} onClick={()=>jump(r.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 20px",borderBottom:i<rows.length-1?"1px solid #f8fafc":"",cursor:r.id?"pointer":"default"}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:".84rem",fontWeight:600,color:"#0f172a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.name}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.sub}</div>
                    </div>
                    {sv&&<span style={{fontSize:".55rem",fontWeight:700,color:sv.fg,background:sv.bg,borderRadius:5,padding:"2px 6px",flexShrink:0}}>{sv.t}</span>}
                    {r.amt!=null&&<div style={{fontSize:".84rem",fontWeight:700,color:fg,flexShrink:0}}>{money(r.amt)}</div>}
                    {r.id&&<span style={{fontSize:".7rem",color:"#cbd5e1",flexShrink:0}}>→</span>}
                  </div>
                );})}
              </div>
              {/* footer */}
              <div style={{borderTop:"1px solid #f1f5f9",padding:"12px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
                {hasAmt?(
                  <div style={{fontSize:".72rem",color:"#64748b"}}>Total <span style={{fontWeight:800,color:"#0f172a",fontSize:".92rem",marginLeft:4}}>{money(total)}</span></div>
                ):<div/>}
                <button onClick={()=>{setAttnDrill(null);fullPage&&fullPage();}} style={{background:fg,border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer",whiteSpace:"nowrap"}}>{fullPageLabel||"Open full page →"}</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── FINANCIAL SNAPSHOT ──────────────────────────────────────── */}
      {(()=>{
        // Billed-but-unpaid on one basis (cash receivable − good payments); was
        // contract value (ex-VAT) − every payment incl. bounced, which is neither AR
        // nor like-for-like.
        const totColl=arTot.collected;
        const fmtM=v=>v>=1000000?"₱"+Math.round(v/100000)/10+"M":v>=1000?"₱"+Math.round(v/1000)+"K":"₱"+Math.round(v||0);
        const cells=[
          {l:"Revenue (won)", v:fmtM(totRev), c:"#6366f1", action:()=>setPage("pipeline")},
          {l:"Collected",     v:fmtM(totColl),c:"#10b981", action:()=>setPage("billing")},
          {l:"Outstanding AR",v:fmtM(totOut), c:totOut>0?"#ef4444":"#94a3b8", action:()=>setPage("billing")},
          {l:"Costs (VAT-ex)",v:fmtM(totExp), c:"#f59e0b", action:()=>setPage("finance")},
          {l:"Gross Margin",  v:grossMar+"%", c:grossMar>=0?"#059669":"#ef4444", action:()=>setPage("finance")},
        ];
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"6px 4px",marginBottom:14,display:"grid",gridTemplateColumns:window.innerWidth<768?"repeat(2,1fr)":"repeat(5,1fr)",gap:0}}>
            {cells.map((c,i)=>(
              <div key={c.l} onClick={c.action} style={{padding:"10px 14px",cursor:"pointer",borderRight:window.innerWidth>=768&&i<cells.length-1?"1px solid #f1f5f9":"",textAlign:"center"}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.25rem",color:c.c}}>{c.v}</div>
                <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700,marginTop:2}}>{c.l}</div>
              </div>
            ))}
          </div>
        );
      })()}

      {/* ── RECENT ACTIVITY ─────────────────────────────────────────── */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{background:"#1e293b",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#f59e0b",fontSize:".86rem"}}>📋 Recent Activity</span>
          <span style={{fontSize:".7rem",color:"rgba(255,255,255,.4)"}}>Latest updates from all projects</span>
        </div>
        <RecentActivityFeed projs={projs} wonDeals={wonDeals} limit={12}/>
      </div>

      {/* ── UPCOMING AGENDA (replaces the empty month grid) ─────────── */}
      {(()=>{
        const now=new Date();
        const start=new Date(now.getFullYear(),now.getMonth(),now.getDate());
        const horizon=new Date(start);horizon.setDate(horizon.getDate()+21);
        const evts=[];
        checklist.forEach(c=>{if(!c.dueDate)return;const d=new Date(c.dueDate);if(d>=start&&d<=horizon)evts.push({d,type:c.type||"Operations",title:c.title||"Operations item",color:"#f97316",kind:"ops"});});
        billings.forEach(b=>{if(!b.dueDate||b.status==="Paid"||b.status==="Fully Paid"||b.status==="Cancelled")return;const d=new Date(b.dueDate);if(d>=start&&d<=horizon){const dl=wonDeals.find(x=>x.id===b.dealId);evts.push({d,type:"Billing Due",title:dl?.client||b.client||"Invoice",color:"#3b82f6",kind:"bill",amt:Number(b.amount||0)});}});
        evts.sort((a,b)=>a.d-b.d);
        const MON=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const DOW=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        const dayLbl=d=>{const diff=Math.round((new Date(d.getFullYear(),d.getMonth(),d.getDate())-start)/86400000);return diff===0?"Today":diff===1?"Tomorrow":`${DOW[d.getDay()]} ${MON[d.getMonth()]} ${d.getDate()}`;};
        const fmtM=v=>v>=1000000?"₱"+Math.round(v/100000)/10+"M":v>=1000?"₱"+Math.round(v/1000)+"K":"₱"+Math.round(v||0);
        const shown=evts.slice(0,10);
        return(
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",marginTop:14}}>
            <div style={{background:"#1e293b",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".86rem"}}>📅 Upcoming — next 21 days</span>
              <button onClick={()=>setPage("calendar")} style={{background:"rgba(255,255,255,.12)",border:"none",borderRadius:6,padding:"3px 10px",fontSize:".7rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>Full Calendar →</button>
            </div>
            {evts.length===0?(
              <div style={{padding:"22px 16px",textAlign:"center",color:"#94a3b8",fontSize:".8rem"}}>Nothing scheduled in the next 21 days.</div>
            ):(
              <div>
                {shown.map((e,i)=>(
                  <div key={i} onClick={()=>setPage("calendar")} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",borderBottom:i<shown.length-1?"1px solid #f1f5f9":"",cursor:"pointer"}}>
                    <span style={{width:8,height:8,borderRadius:"50%",background:e.color,flexShrink:0}}/>
                    <div style={{width:100,flexShrink:0,fontSize:".72rem",fontWeight:700,color:dayLbl(e.d)==="Today"?"#0f172a":"#64748b"}}>{dayLbl(e.d)}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:".8rem",fontWeight:600,color:"#0f172a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{e.title}</div>
                      <div style={{fontSize:".66rem",color:"#94a3b8"}}>{e.type}</div>
                    </div>
                    {e.kind==="bill"&&e.amt>0&&<div style={{fontSize:".76rem",fontWeight:700,color:"#3b82f6",flexShrink:0}}>{fmtM(e.amt)}</div>}
                  </div>
                ))}
                {evts.length>shown.length&&<div onClick={()=>setPage("calendar")} style={{padding:"9px 16px",textAlign:"center",fontSize:".72rem",color:"#6366f1",fontWeight:600,cursor:"pointer"}}>+{evts.length-shown.length} more →</div>}
              </div>
            )}
            <div style={{display:"flex",gap:14,padding:"9px 16px",borderTop:"1px solid #f1f5f9"}}>
              <span style={{fontSize:".64rem",color:"#64748b",display:"flex",alignItems:"center",gap:4}}><span style={{width:6,height:6,borderRadius:"50%",background:"#f97316",display:"inline-block"}}/>Operations</span>
              <span style={{fontSize:".64rem",color:"#64748b",display:"flex",alignItems:"center",gap:4}}><span style={{width:6,height:6,borderRadius:"50%",background:"#3b82f6",display:"inline-block"}}/>Billing Due</span>
            </div>
          </div>
        );
      })()}
    </Wrap>
  );
  }
  // ── PRF (Purchase Request Form) — one route for every role in the chain.
  // The page id stays "materialreq" so the existing dashboard buttons land here.
  if(page==="materialreq") return(
    <Wrap>
      <PrfView session={session} role={role} deals={deals} pcards={pcards} prs={prs}
        sendTelegramNotification={sendTelegramNotification} isMobile={isMobile}
        initialDeal={jumpDeal} clearJump={()=>setJumpDeal(null)}/>
    </Wrap>
  );
  // ── SUBCON BILLING — PM / Operations certify work done (no cert, no payment).
  if(page==="subconcert") return(
    <Wrap>
      <SubconCertView session={session} deals={deals} sendTelegramNotification={sendTelegramNotification} isMobile={isMobile}/>
    </Wrap>
  );
  // ── CALENDAR ────────────────────────────────────────────────────────────────
  if(page==="calendar") return(
    <ConstructionCalendar
      wonDeals={wonDeals} completedDeals={completedDeals} deals={deals} pcards={pcards} jos={jos}
      prs={prs} billings={billings} drfs={drfs} ceReqs={ceReqs} payables={payables}
      setPage={setPage} setJumpDeal={setJumpDeal} today={today} Wrap={Wrap}
      checklists={checklist} session={session}
      addOpsEvent={data=>{const rec={...data,id:uid(),dept:"Operations",createdDate:today,createdBy:session?.name||role};upChecklist(cs=>[...cs,rec]);if(isSupabaseReady())sbInsert('checklists',toSbChecklist(rec)).catch(err=>{console.error("Calendar item sync:",err);toastEmit&&toastEmit("Calendar item saved locally only — tap 🔄 sync to push it to the server.","warning",8000);});const proj=wonDeals.find(d=>d.id===rec.projectId);const msg=`📅 <b>Calendar Item Added</b>\n<b>${rec.type||"Event"}</b>: ${rec.title||""}\nDate: ${rec.dueDate||"—"}${proj?`\nProject: ${proj.client}${proj.ceNo?" ("+proj.ceNo+")":""}`:""}\nBy: ${rec.createdBy||"—"}`;const _t=(rec.type||"").toLowerCase();if(_t==="turnover"){sendTelegramNotification("ops",msg);sendTelegramNotification("sales",msg);sendTelegramNotification("management",msg);}else if(_t==="po delivery"){sendTelegramNotification("procurement",msg);sendTelegramNotification("warehouse",msg);}else if(_t.includes("billing")){sendTelegramNotification("financialcontrol",msg);sendTelegramNotification("management",msg);}else if(_t.includes("drf")||_t.includes("design")){sendTelegramNotification("design",msg);}else if(_t==="inspection"){sendTelegramNotification("ops",msg);sendTelegramNotification("management",msg);}else if(_t==="maintenance"){sendTelegramNotification("ops",msg);}else{sendTelegramNotification("ops",msg);sendTelegramNotification("sales",msg);}}}
      updateOpsEvent={(id,ch)=>{upChecklist(cs=>cs.map(c=>c.id===id?{...c,...ch}:c));if(isSupabaseReady())sbUpdate('checklists',id,toSbChecklist({...checklist.find(c=>c.id===id),...ch})).catch(()=>{});}}
      deleteOpsEvent={delOpsEvent}
      updateProjectTurnover={(dealId,date)=>{upPcards(ps=>({...ps,[dealId]:{...ps[dealId],targetEndDate:date}}));if(isSupabaseReady())syncProjectCard(dealId,{target_end_date:date});}}
    />
  );

  // ── BOT SETTINGS (Manager / Finance) ─────────────────────────────────────
  if(page==="botsettings"&&(role==="Manager"||role==="Finance")) return(
    <BotSettingsView botSettings={botSettings} saveBotSettings={saveBotSettings} role={role} Wrap={Wrap}/>
  );

  // ── REPORTS CENTER (Manager / Sales / Finance) ───────────────────────────
  if(page==="reports"||page==="sales-reports"||page==="finance-reports"){
    const CY=repYear;
    const CM=repMonth;
    const REPORT_YEARS=Array.from({length:5},(_,i)=>new Date().getFullYear()-i);
    const svcType=(ct)=>{if(!ct)return"Other";if(ct==="Construction")return"Construction";if(["Fabrication / General","Kiosk","Retail Fit-Out"].includes(ct))return"Fabrication";return"Special Services";};
    const aeCode=(name)=>{if(!name)return"—";const skip=new Set(["de","del","ng","la","the"]);return name.split(" ").filter(w=>w&&!skip.has(w.toLowerCase())).map(w=>w[0].toUpperCase()).join("");};
    const getPCount=()=>repPeriod==="monthly"?12:repPeriod==="quarterly"?4:1;
    const getPLabel=(i)=>repPeriod==="monthly"?MONTHS[i]:repPeriod==="quarterly"?`Q${i+1}`:`${CY}`;
    // acqDate: the acquisition/win-RATE anchor. For WON deals it prefers the award date,
    // falling back to the lead-intake date so a won-but-undated deal STILL counts in its
    // acquisition cohort (dropping it would silently understate the win-rate denominator).
    // Use this ONLY for period/win-rate bucketing, never for "awarded this month" value.
    const acqDate=(d)=>(WON_STAGES.includes(d.stage)?pcards[d.id]?.awardDate:null)||d.dateAcquired||null;
    // awardOnly: the true awarded date with NO fallback — matches the TV and Sales Value
    // reports. An undated won deal is excluded from the awarded-value/count metrics rather
    // than being credited to the wrong (lead-intake) month.
    const awardOnly=(d)=>pcards[d.id]?.awardDate||null;
    const getDealPeriod=(d)=>{const ds=acqDate(d);if(!ds)return -1;const dt=new Date(ds);if(dt.getFullYear()!==CY)return -1;return repPeriod==="monthly"?dt.getMonth():repPeriod==="quarterly"?Math.floor(dt.getMonth()/3):0;};
    const getFinPeriod=(dateStr)=>{if(!dateStr)return -1;const d=new Date(dateStr);if(d.getFullYear()!==CY)return -1;return repPeriod==="monthly"?d.getMonth():repPeriod==="quarterly"?Math.floor(d.getMonth()/3):0;};
    const n=getPCount();
    // Count a won deal at its BASE contract value (before change orders). Approved
    // change orders are counted separately below, in their own awarded month and
    // under their own AE — so using the base here prevents double-counting a CO
    // that rollDealContract already folded into the parent's `value`.
    const dealBase=(d)=>d.originalValue!=null?Number(d.originalValue)||0:Number(d.value||0);
    const dealTax=(d)=>calcTax(dealBase(d),d.receiptType||"OR",d.withholding||false);
    // The BOQ is the VAT authority; flag a deal whose receipt type disagrees with
    // its BOQ's decided VAT choice (e.g. set before the BOQ became authoritative).
    const boqVat=(d)=>{const v=(d.boqData||d.boq_data)?.vatEnabled;return typeof v==="boolean"?v:null;};
    const boqVatMismatch=(d)=>boqVat(d)!==null&&d.receiptType!==(boqVat(d)?"OR":"AR");
    // Approved change orders are sales in their own right. They land in the month
    // they were Approved (awardedDate) and are credited to the CO's salesOwner.
    // coTax is signed so a deductive CO reduces the month's sales value.
    const CO_APPROVED=a=>["Approved","Billed","Collected"].includes(a.status);
    const coTax=a=>{const t=calcTax(Math.abs(Number(a.value||0)),a.receiptType||"OR",a.withholding||false);const sign=a.kind==="Deductive"?-1:1;return {gross:sign*t.gross,base:sign*t.base,vat:sign*t.vat};};
    const coInPeriod=(a,i)=>{const ds=a.awardedDate;if(!ds)return false;const dt=new Date(ds);if(dt.getFullYear()!==CY)return false;const p=repPeriod==="monthly"?dt.getMonth():repPeriod==="quarterly"?Math.floor(dt.getMonth()/3):0;return p===i;};
    // "Won this month" credits by the true award date (awardOnly) so AE credit and sales
    // value land in the month the deal was actually awarded — consistent with the TV and
    // Sales Value reports. Undated won deals are surfaced in dataFlags below, not mis-dated.
    const monthWon=deals.filter(d=>{if(!WON_STAGES.includes(d.stage))return false;const dt=awardOnly(d);return dt&&new Date(dt).getFullYear()===CY&&new Date(dt).getMonth()===CM;});
    const monthCancelled=deals.filter(d=>{if(d.stage!=="Cancelled")return false;const dt=acqDate(d);return dt&&new Date(dt).getFullYear()===CY&&new Date(dt).getMonth()===CM;});
    // Change orders approved in the selected month (CM) — credited as sales value.
    const monthCO=addenda.filter(a=>{if(!CO_APPROVED(a)||!a.awardedDate)return false;const dt=new Date(a.awardedDate);return dt.getFullYear()===CY&&dt.getMonth()===CM;});
    const openPipeline=deals.filter(d=>isActivePipeline(d.stage));
    const totalWonGross=monthWon.reduce((s,d)=>s+dealTax(d).gross,0)+monthCO.reduce((s,a)=>s+coTax(a).gross,0);
    const totalWonBase=monthWon.reduce((s,d)=>s+dealTax(d).base,0)+monthCO.reduce((s,a)=>s+coTax(a).base,0);
    const totalWonVat=monthWon.reduce((s,d)=>s+dealTax(d).vat,0)+monthCO.reduce((s,a)=>s+coTax(a).vat,0);
    const aeMap={};
    monthWon.forEach(d=>{const ae=d.salesOwner||"Unassigned";if(!aeMap[ae])aeMap[ae]={name:ae,code:aeCode(ae),won:0,co:0,gross:0,clients:new Set()};aeMap[ae].won++;aeMap[ae].gross+=dealTax(d).gross;if(d.client)aeMap[ae].clients.add(d.client);});
    // Value only: add the CO's value to its AE's gross and track a separate CO
    // count (does NOT increment "won" deals). Sub-account brand counts as a client.
    monthCO.forEach(a=>{const ae=a.salesOwner||"Unassigned";if(!aeMap[ae])aeMap[ae]={name:ae,code:aeCode(ae),won:0,co:0,gross:0,clients:new Set()};aeMap[ae].co++;aeMap[ae].gross+=coTax(a).gross;if(a.subAccount)aeMap[ae].clients.add(a.subAccount);});
    const aeRowsRaw=Object.values(aeMap).map(r=>({...r,clients:r.clients.size}));
    const aeRows=[...aeRowsRaw].sort((a,b)=>repAESort==="won"?b.won-a.won:repAESort==="clients"?b.clients-a.clients:b.gross-a.gross);
    const aeTotal=aeRows.reduce((s,r)=>s+r.gross,0);
    // AE-filtered deal lists
    const filteredWon=repAEFilter?monthWon.filter(d=>(d.salesOwner||"Unassigned")===repAEFilter):monthWon;
    const filteredPipeline=repAEFilter?openPipeline.filter(d=>(d.salesOwner||"Unassigned")===repAEFilter):openPipeline;
    const allAEs=[...new Set([...monthWon,...openPipeline].map(d=>d.salesOwner||"Unassigned"))].sort();
    const dataFlags=[];
    const zeroWon=monthWon.filter(d=>!Number(d.value)&&!d.standbyPO);
    if(zeroWon.length)dataFlags.push({n:dataFlags.length+1,issue:"Won deal with no value",detail:zeroWon.map(d=>`${d.client} — ${d.product||"(no project)"}`).join("; "),stake:"unknown"});
    const noCE=monthWon.filter(d=>!d.ceNo);
    if(noCE.length)dataFlags.push({n:dataFlags.length+1,issue:"Missing CE# on won deal",detail:noCE.map(d=>d.client).join(", "),stake:"—"});
    // Won deals with no award date drop out of every awarded-value/count report (they can't
    // be bucketed to a month). Surface them here so the award date gets set and the numbers
    // reconcile, instead of the deal silently vanishing from the awarded totals.
    const noAward=deals.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage)&&!d.parentDealId&&!awardOnly(d));
    if(noAward.length)dataFlags.push({n:dataFlags.length+1,issue:"Won project — no award date (excluded from awarded reports)",detail:noAward.map(d=>d.client+(d.ceNo?` (${d.ceNo})`:"")).join(", "),stake:fmt(noAward.reduce((s,d)=>s+Number(d.value||0),0))});
    const ceCounts={};deals.filter(d=>d.ceNo).forEach(d=>{ceCounts[d.ceNo]=(ceCounts[d.ceNo]||0)+1;});
    const dupCE=Object.entries(ceCounts).filter(([,c])=>c>1);
    if(dupCE.length)dataFlags.push({n:dataFlags.length+1,issue:"Duplicate CE numbers",detail:dupCE.map(([ce,c])=>`${ce} (${c}x)`).join(", "),stake:"—"});
    const noBilling=monthWon.filter(d=>!d.standbyPO&&!billings.some(b=>b.dealId===d.id));
    if(noBilling.length)dataFlags.push({n:dataFlags.length+1,issue:"Won project — no billing milestones",detail:noBilling.map(d=>d.client).join(", "),stake:fmt(noBilling.reduce((s,d)=>s+Number(d.value||0),0))});
    const noClient=openPipeline.filter(d=>!d.client);
    if(noClient.length)dataFlags.push({n:dataFlags.length+1,issue:"Pipeline deals missing client name",detail:`${noClient.length} deal(s) with no client`,stake:"—"});
    const noVal=openPipeline.filter(d=>!Number(d.value)&&!d.standbyPO);
    if(noVal.length)dataFlags.push({n:dataFlags.length+1,issue:"Pipeline deals with no value",detail:`${noVal.length} deal(s) have ₱0 value — pipeline understated`,stake:"unknown"});
    const yearDeals=deals.filter(d=>{const dt=acqDate(d);return dt&&new Date(dt).getFullYear()===CY;});
    const yearWon=yearDeals.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage));
    // Approved change orders awarded this year, for the yearly period / AE rollups.
    // Counted at their raw signed value (deductive subtracts) to match the deal
    // value sums, and attributed to the period of their awardedDate.
    const yearCO=addenda.filter(a=>CO_APPROVED(a)&&a.awardedDate&&new Date(a.awardedDate).getFullYear()===CY);
    const coRawSigned=a=>(a.kind==="Deductive"?-1:1)*Math.abs(Number(a.value||0));
    const salesPeriods=Array.from({length:n},(_,i)=>{const pd=yearDeals.filter(d=>getDealPeriod(d)===i);const pw=pd.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage));const pco=yearCO.filter(a=>coInPeriod(a,i));return{label:getPLabel(i),acquired:pd.length,won:pw.length,winRate:pd.length>0?Math.round(pw.length/pd.length*100):0,pipelineValue:pd.reduce((s,d)=>s+Number(d.value||0),0),wonValue:pw.reduce((s,d)=>s+dealBase(d),0)+pco.reduce((s,a)=>s+coRawSigned(a),0)};});
    const ownerMap={};yearDeals.forEach(d=>{const o=d.salesOwner||"Unassigned";if(!ownerMap[o])ownerMap[o]={owner:o,acquired:0,won:0,value:0};ownerMap[o].acquired++;if(WON_STAGES.includes(d.stage)){ownerMap[o].won++;ownerMap[o].value+=dealBase(d);}});
    yearCO.forEach(a=>{const o=a.salesOwner||"Unassigned";if(!ownerMap[o])ownerMap[o]={owner:o,acquired:0,won:0,value:0};ownerMap[o].value+=coRawSigned(a);});
    const ownerRows=Object.values(ownerMap).sort((a,b)=>b.value-a.value);
    const ceMap={};yearDeals.forEach(d=>{const t=d.ceType||"Other";if(!ceMap[t])ceMap[t]={type:t,acquired:0,won:0,value:0};ceMap[t].acquired++;if(WON_STAGES.includes(d.stage)){ceMap[t].won++;ceMap[t].value+=dealBase(d);}});
    const ceRows=Object.values(ceMap).sort((a,b)=>b.value-a.value);
    const revArr=Array(n).fill(0);billings.forEach(b=>{if(b.status==="Cancelled")return;const p=getFinPeriod(b.invoiceDate||b.dueDate);if(p>=0)revArr[p]+=Number(b.amount||0);});
    // Collections restated VAT-ex (cash × base/receivable) so Revenue, Collections and
    // Outstanding share one basis; bounced payments and offsets (no cash) excluded.
    const collArr=Array(n).fill(0);billings.forEach(b=>{if(b.status==="Cancelled")return;const rcv=milestoneReceivable(b,deals.find(x=>x.id===b.dealId));const k=rcv>0?Number(b.amount||0)/rcv:1;(b.payments||[]).forEach(pay=>{if(!isCashPayment(pay))return;const p=getFinPeriod(pay.date);if(p>=0)collArr[p]+=Number(pay.amount||0)*k;});});
    // AP-ledger accrual basis (matches the account-code Income Statement below):
    // payables + legacy expenses not routed to a payable (no double count).
    const expArr=Array(n).fill(0);
    exps.forEach(e=>{if(e.payableId||e.cvId)return;const ds=e.date||(e.year!=null&&e.month!=null?`${e.year}-${String(e.month+1).padStart(2,"0")}-01`:null);const p=getFinPeriod(ds);if(p>=0)expArr[p]+=costNet(e);});
    payables.forEach(pp=>{if(["Cancelled","Void"].includes(pp.status))return;const p=getFinPeriod(pp.invoiceDate||pp.createdAt||null);if(p>=0)expArr[p]+=costNet(pp);});
    const finPeriods=Array.from({length:n},(_,i)=>({label:getPLabel(i),revenue:revArr[i],collections:collArr[i],outstanding:Math.max(0,revArr[i]-collArr[i]),expenses:expArr[i],net:revArr[i]-expArr[i]}));
    const finTot={revenue:revArr.reduce((s,v)=>s+v,0),collections:collArr.reduce((s,v)=>s+v,0),expenses:expArr.reduce((s,v)=>s+v,0)};
    finTot.outstanding=Math.max(0,finTot.revenue-finTot.collections);finTot.net=finTot.revenue-finTot.expenses;
    const expCatMap={};exps.forEach(e=>{const ds=e.date||(e.year!=null&&e.month!=null?`${e.year}-${String(e.month+1).padStart(2,"0")}-01`:null);if(!ds||new Date(ds).getFullYear()!==CY)return;const cat=e.category||"Other";expCatMap[cat]=(expCatMap[cat]||0)+Number(e.amount||0);});
    const expCatRows=Object.entries(expCatMap).sort((a,b)=>b[1]-a[1]);
    const totalExpCat=expCatRows.reduce((s,[,v])=>s+v,0);
    const agingMs=billings.filter(b=>b.status!=="Paid"&&b.status!=="Cancelled"&&Number(b.amount||0)>0).map(b=>{const deal=deals.find(d=>d.id===b.dealId);const daysOver=b.dueDate?Math.max(0,Math.floor((new Date()-new Date(b.dueDate))/(864e5))):null;return{...b,clientName:deal?.client||"Unknown",daysOver};}).sort((a,b)=>(b.daysOver||0)-(a.daysOver||0)).slice(0,15);
    // Reports are split into a Sales Reports page (Sales section) and a Finance
    // Reports page (Finance section). The Sales role, and anyone landing on the
    // "sales-reports" page, get a sales-only experience: only the Sales Report tab
    // is shown, and exports/prints omit the finance & receivables sections. The
    // "finance-reports" page shows the finance/receivables tabs only. The legacy
    // "reports" id keeps the combined view for any role not yet split.
    const salesOnly=role==="Sales"||page==="sales-reports";
    const finView=page==="finance-reports";
    const repTabs=salesOnly?[["sales","📊 Sales Report"]]
      :finView?[["finance","💰 Finance Report"],["ar-aging","📋 AR Aging"],["ap-aging","📑 AP Aging"]]
      :[["sales","📊 Sales Report"],["finance","💰 Finance Report"],["ar-aging","📋 AR Aging"],["ap-aging","📑 AP Aging"]];
    const curTab=repTabs.some(([t])=>t===repTab)?repTab:repTabs[0][0];
    const exportReports=()=>{
      if(!window.XLSX){toastEmit("Excel library not loaded — please refresh","error");return;}
      const wb=window.XLSX.utils.book_new();
      if(repPeriod==="monthly"){
        const ml=`${MONTHS[CM]} ${CY}`;
        const summData=[["GMD PRODUCTIONS INC."],[`Sales Month-End Report — ${ml}`],[`Prepared by FabHub • Values are ex-VAT base + 12% VAT (OR) • Review Data Flags before circulating`],[],["DEALS WON","DEALS CANCELLED","OPEN PIPELINE (count)"],[monthWon.length,monthCancelled.length,openPipeline.length],[],[`CLOSED REVENUE — ${ml.toUpperCase()} (incl. VAT)`],["Total closed (all WON rows, as recorded)",totalWonGross],["  Memo: ex-VAT base",totalWonBase],["  Memo: total VAT collected",totalWonVat],[],["CLOSED REVENUE BY SALES OWNER"],["AE","AE Code","Deals Won","Closed (incl. VAT)","% of total"],...aeRows.map(r=>[r.name,r.code,r.won,r.gross,aeTotal>0?(r.gross/aeTotal).toFixed(4):0]),["TOTAL","",aeRows.reduce((s,r)=>s+r.won,0),aeTotal,1]];
        window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(summData),"Summary");
        const closedData=[["Service Type","Project Type","AE","Client","Project Name","Status","Estimate (ex-VAT)","VAT","Total (incl. VAT)","Flag / Note"],...monthWon.map(d=>{const t=dealTax(d);const f=[];if(!Number(d.value))f.push("No value");if(!d.ceNo)f.push("Missing CE#");if(t.vat===0&&Number(d.value)>50000)f.push("VAT=0 — confirm exempt");if(!["OR","AR"].includes(d.receiptType))f.push("VAT pending BOQ — shown as OR");if(boqVatMismatch(d))f.push(`BOQ says ${boqVat(d)?"VAT":"No VAT"} — receipt is ${d.receiptType||"unset"}`);return[svcType(d.ceType),d.ceType||"—",aeCode(d.salesOwner||""),d.client||"—",d.contact||d.product||"—","WON",t.base,t.vat,t.gross,f.join("; ")||null];}),[],...monthCancelled.map(d=>{const t=dealTax(d);return[svcType(d.ceType),d.ceType||"—",aeCode(d.salesOwner||""),d.client||"—",d.contact||d.product||"—","CANCELLED",t.base,t.vat,t.gross,"Cancelled"];}),["","","","","TOTAL — WON only",monthWon.length,totalWonBase,totalWonVat,totalWonGross,""]];
        window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(closedData),"Closed Deals");
        const pipeData=[["Client","Project Name","Service Type","Stage","CE#","Note"],...openPipeline.map(d=>{const f=[];if(!d.client)f.push("Client missing");if(!Number(d.value))f.push("No value");if(!d.ceNo)f.push("No CE#");return[d.client||"(blank)",d.contact||d.product||"—",svcType(d.ceType),d.stage||"—",d.ceNo||"—",f.join("; ")||null];})];
        window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(pipeData),"Open Pipeline");
        const flagData=[[null,"DATA FLAGS — RESOLVE BEFORE THIS REPORT IS FINAL"],["#","Issue","Detail","₱ at Stake"],...dataFlags.map(f=>[f.n,f.issue,f.detail,f.stake]),...(dataFlags.length===0?[[null,"✅ No issues detected","",""]]:[] )];
        window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(flagData),"Data Flags");
        window.XLSX.writeFile(wb,`GMD-Sales-MonthEnd-${MONTHS[CM]}${CY}.xlsx`);
      } else {
        const sh1=[["Period","Acquired","Won","Win Rate %","Pipeline ₱","Won Value ₱ (incl. approved COs)"],...salesPeriods.map(p=>[p.label,p.acquired,p.won,p.winRate,Math.round(p.pipelineValue),Math.round(p.wonValue)]),["TOTAL",yearDeals.length,yearWon.length,yearDeals.length>0?Math.round(yearWon.length/yearDeals.length*100):0,Math.round(salesPeriods.reduce((s,p)=>s+p.pipelineValue,0)),Math.round(salesPeriods.reduce((s,p)=>s+p.wonValue,0))]];
        window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(sh1),"Sales");
        if(!salesOnly){
          const sh2=[["Period","Revenue ₱ (VAT-ex)","Collections ₱ (VAT-ex)","Outstanding ₱","Costs ₱ (VAT-ex)","Net Profit ₱"],...finPeriods.map(p=>[p.label,p.revenue,p.collections,p.outstanding,p.expenses,p.net]),["TOTAL",finTot.revenue,finTot.collections,finTot.outstanding,finTot.expenses,finTot.net]];
          window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(sh2),"Finance");
          const sh3=[["Category","Amount ₱","% of Total"],...expCatRows.map(([cat,amt])=>[cat,amt,totalExpCat>0?Math.round(amt/totalExpCat*100):0])];
          window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet(sh3),"Expenses by Category");
        }
        window.XLSX.writeFile(wb,`FabHub-Report-${CY}-${repPeriod}.xlsx`);
      }
    };
    // Proper printable report — letterhead + KPI strip + sectioned tables,
    // instead of just window.print()-ing whatever screen tab happens to be
    // open (which prints filter dropdowns, tab buttons, etc. with no letterhead).
    const printReports=()=>{
      const esc=(s)=>String(s??"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
      const periodLabel=repPeriod==="monthly"?monthLabel:repPeriod==="quarterly"?`${CY} — Quarterly`:`${CY} — Full Year`;
      const dateStr=new Date().toLocaleDateString("en-PH",{year:"numeric",month:"long",day:"numeric"});
      const closedRowsHtml=(repPeriod==="monthly"?monthWon:yearWon).map((d,i)=>{
        const t=dealTax(d);
        return`<tr>
          <td style="text-align:center;color:#64748b">${i+1}</td>
          <td>${esc(d.client||"—")}</td>
          <td>${esc(d.ceNo||"—")}</td>
          <td>${esc(aeCode(d.salesOwner||""))}</td>
          <td style="text-align:right">${fmt(t.base)}</td>
          <td style="text-align:right">${fmt(t.vat)}</td>
          <td style="text-align:right;font-weight:700">${fmt(t.gross)}</td>
        </tr>`;
      }).join("")||`<tr><td colspan="7" style="text-align:center;color:#94a3b8;padding:14px">No won deals in this period</td></tr>`;
      const aeRowsHtml=aeRows.map(r=>`<tr>
        <td>${esc(r.name)}</td><td style="text-align:center">${r.code}</td>
        <td style="text-align:center">${r.won}</td><td style="text-align:center">${r.clients}</td>
        <td style="text-align:right;font-weight:700">${fmt(r.gross)}</td>
        <td style="text-align:right">${aeTotal>0?Math.round(r.gross/aeTotal*100):0}%</td>
      </tr>`).join("")||`<tr><td colspan="6" style="text-align:center;color:#94a3b8;padding:14px">No closed deals to attribute</td></tr>`;
      const finRowsHtml=finPeriods.map(p=>`<tr>
        <td>${esc(p.label)}</td>
        <td style="text-align:right">${fmt(p.revenue)}</td>
        <td style="text-align:right">${fmt(p.collections)}</td>
        <td style="text-align:right">${fmt(p.outstanding)}</td>
        <td style="text-align:right">${fmt(p.expenses)}</td>
        <td style="text-align:right;font-weight:700;color:${p.net>=0?"#059669":"#dc2626"}">${fmt(p.net)}</td>
      </tr>`).join("");
      const agingRowsHtml=agingMs.slice(0,10).map(b=>`<tr>
        <td>${esc(b.clientName)}</td>
        <td>${esc(b.name||b.label||"Invoice")}</td>
        <td style="text-align:right">${fmt(b.amount)}</td>
        <td style="text-align:center;font-weight:700;color:${(b.daysOver||0)>30?"#dc2626":"#92400e"}">${b.daysOver||0}d</td>
      </tr>`).join("")||`<tr><td colspan="4" style="text-align:center;color:#94a3b8;padding:14px">No outstanding receivables</td></tr>`;
      const flagsHtml=dataFlags.length?dataFlags.map(f=>`<tr>
        <td style="text-align:center">${f.n}</td><td>${esc(f.issue)}</td><td>${esc(f.detail)}</td><td style="text-align:right">${typeof f.stake==="string"?esc(f.stake):fmt(f.stake)}</td>
      </tr>`).join(""):`<tr><td colspan="4" style="text-align:center;color:#059669;padding:10px">✅ No data-quality issues detected</td></tr>`;
      const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>FabHub Report — ${esc(periodLabel)}</title><style>
        @page{size:A4 portrait;margin:14mm 15mm}
        *{box-sizing:border-box;margin:0;padding:0}
        body{font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#0f172a;background:#fff}
        .print-btn{text-align:center;padding:12px;background:#f8fafc;border-bottom:1px solid #e2e8f0}
        .print-btn button{background:#1e293b;color:#fff;border:none;border-radius:6px;padding:8px 24px;font-size:13px;cursor:pointer;font-family:inherit}
        @media print{.print-btn{display:none}}
        .header{background:#1e293b;padding:14px 22px;display:flex;justify-content:space-between;align-items:center}
        .co-name{font-size:20px;font-weight:900;color:#fff;letter-spacing:-.5px}
        .sub-bar{background:#1e293b;padding:2px 22px 10px;display:flex;justify-content:space-between;border-bottom:3px solid #ea580c}
        .tagline{color:rgba(255,255,255,.45);font-size:9px}
        .wrap{padding:14px 22px 8px}
        .title{font-size:15px;font-weight:900;letter-spacing:1px;text-transform:uppercase;margin-bottom:2px}
        .subtitle{font-size:10px;color:#64748b;margin-bottom:14px}
        .kpis{display:grid;grid-template-columns:repeat(4,1fr);border:1.5px solid #e2e8f0;margin-bottom:18px}
        .kb{padding:10px 12px;background:#f8fafc;border-right:1px solid #e2e8f0;text-align:center}
        .kb:last-child{border-right:none;background:#fff7ed}
        .kl{font-size:7.5px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px}
        .kv{font-size:14px;font-weight:800;color:#0f172a}
        .sec{margin-bottom:20px}
        .sec-title{font-size:10.5px;font-weight:900;text-transform:uppercase;letter-spacing:.8px;color:#ea580c;border-bottom:1.5px solid #ea580c;padding-bottom:4px;margin-bottom:8px}
        table{width:100%;border-collapse:collapse;font-size:10px}
        thead tr{background:#1e293b}
        thead th{color:rgba(255,255,255,.85);font-size:8px;font-weight:700;text-transform:uppercase;letter-spacing:.4px;padding:7px 9px;text-align:left}
        tbody tr:nth-child(even){background:#f9fafb}
        tbody td{padding:6px 9px;border-bottom:1px solid #f1f5f9}
        .sig{display:grid;grid-template-columns:1fr 1fr;gap:40px;padding:14px 0 0;margin-top:8px;border-top:1px solid #e2e8f0}
        .sl2{font-size:9px;color:#64748b;margin-bottom:18px}
        .sn{font-size:11px;font-weight:700}
        .sc{font-size:9px;color:#64748b}
        .footer{margin-top:10px;font-size:8.5px;color:#94a3b8;text-align:right}
      </style></head><body>
      <div class="print-btn"><button onclick="window.print()">🖨 Print / Save as PDF</button></div>
      <div class="header">
        <div class="co-name">GMD PRODUCTIONS INC.</div>
        <div style="text-align:right">
          <span style="color:rgba(255,255,255,.6);font-size:10px">DATE: </span>
          <span style="color:#f97316;font-weight:700;font-size:12px">${dateStr}</span>
        </div>
      </div>
      <div class="sub-bar">
        <span class="tagline">Retail Design &amp; Build | Construction | Modular Fit-outs | Signage | POP Displays</span>
        <span class="tagline">PREPARED BY: ${esc(session?.name||"FabHub")}</span>
      </div>
      <div class="wrap">
        <div class="title">${salesOnly?(repPeriod==="monthly"?"Sales Report":"Sales Summary"):(repPeriod==="monthly"?"Sales &amp; Finance Report":"Sales &amp; Finance Summary")}</div>
        <div class="subtitle">${esc(periodLabel)} · Values include 12% VAT where applicable (OR)${dataFlags.length?" · Review Data Flags before circulating":""}</div>
        <div class="kpis">
          <div class="kb"><div class="kl">Deals Won</div><div class="kv">${repPeriod==="monthly"?monthWon.length:yearWon.length}</div></div>
          <div class="kb"><div class="kl">Closed Revenue</div><div class="kv">${fmt(repPeriod==="monthly"?totalWonGross:yearWon.reduce((s,d)=>s+dealTax(d).gross,0))}</div></div>
          ${salesOnly?"":`<div class="kb"><div class="kl">Collections</div><div class="kv">${fmt(finTot.collections)}</div></div>
          <div class="kb"><div class="kl">Net Profit</div><div class="kv" style="color:${finTot.net>=0?"#059669":"#dc2626"}">${fmt(finTot.net)}</div></div>`}
        </div>

        <div class="sec">
          <div class="sec-title">Closed Deals</div>
          <table>
            <thead><tr><th style="width:26px;text-align:center">#</th><th>Client</th><th>CE #</th><th>AE</th><th style="text-align:right">Ex-VAT</th><th style="text-align:right">VAT</th><th style="text-align:right">Total</th></tr></thead>
            <tbody>${closedRowsHtml}</tbody>
          </table>
        </div>

        <div class="sec">
          <div class="sec-title">Revenue by Sales Owner</div>
          <table>
            <thead><tr><th>AE</th><th style="text-align:center">Code</th><th style="text-align:center">Won</th><th style="text-align:center">Clients</th><th style="text-align:right">Closed (incl. VAT)</th><th style="text-align:right">% of Total</th></tr></thead>
            <tbody>${aeRowsHtml}</tbody>
          </table>
        </div>

        ${salesOnly?"":`<div class="sec">
          <div class="sec-title">Finance by Period</div>
          <table>
            <thead><tr><th>Period</th><th style="text-align:right">Revenue</th><th style="text-align:right">Collections</th><th style="text-align:right">Outstanding</th><th style="text-align:right">Expenses</th><th style="text-align:right">Net Profit</th></tr></thead>
            <tbody>${finRowsHtml}</tbody>
          </table>
        </div>

        <div class="sec">
          <div class="sec-title">AR Aging — Top Outstanding</div>
          <table>
            <thead><tr><th>Client</th><th>Invoice</th><th style="text-align:right">Amount</th><th style="text-align:center">Days Overdue</th></tr></thead>
            <tbody>${agingRowsHtml}</tbody>
          </table>
        </div>`}

        <div class="sec">
          <div class="sec-title">Data Flags</div>
          <table>
            <thead><tr><th style="width:26px;text-align:center">#</th><th>Issue</th><th>Detail</th><th style="text-align:right">₱ at Stake</th></tr></thead>
            <tbody>${flagsHtml}</tbody>
          </table>
        </div>

        <div class="sig">
          <div><div class="sl2">Prepared by:</div><div class="sn">${esc(session?.name||"—")}</div><div class="sc">GMD Productions Inc.</div></div>
          <div><div class="sl2">Reviewed by:</div><div class="sn">&nbsp;</div><div class="sc">GMD Productions Inc.</div></div>
        </div>
        <div class="footer">Generated by FabHub · ${esc(periodLabel)}</div>
      </div>
      </body></html>`;
      const w=window.open("","_blank","width=1000,height=800");
      if(!w){toastEmit&&toastEmit("Popup blocked — please allow popups for this site","warning");return;}
      w.document.write(html);
      w.document.close();addPrintClose(w);
      setTimeout(()=>w.print(),500);
    };
    const TH=(l,right)=><th style={{padding:"9px 12px",fontWeight:700,fontSize:".72rem",color:"#64748b",textTransform:"uppercase",letterSpacing:".04em",textAlign:right?"right":"left",background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>{l}</th>;
    const TD=(v,opts={})=><td style={{padding:"8px 12px",fontSize:".82rem",textAlign:opts.right?"right":"left",borderBottom:"1px solid #f1f5f9",fontWeight:opts.bold?700:400,color:opts.color||"#374151",...(opts.style||{})}}>{v}</td>;
    const monthLabel=`${MONTHS[CM]} ${CY}`;
    return(
      <Wrap>
        <SecHead title={salesOnly?"📊 Sales Reports":finView?"💰 Finance Reports":"📊 Reports Center"} sub={salesOnly?(repPeriod==="monthly"?`Sales Month-End Report — ${monthLabel}`:`Sales — ${CY}`):finView?(repPeriod==="monthly"?`Finance Report — ${monthLabel}`:`Finance — ${CY}`):(repPeriod==="monthly"?`Sales Month-End Report — ${monthLabel}`:`Sales & Finance — ${CY}`)}/>
        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",marginBottom:20}}>
          <select value={repPeriod} onChange={e=>setRepPeriod(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".84rem",color:"#374151",background:"#fff",cursor:"pointer"}}>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="yearly">Full Year</option>
          </select>
          {repPeriod==="monthly"&&(
            <select value={repMonth} onChange={e=>setRepMonth(Number(e.target.value))} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".84rem",color:"#374151",background:"#fff",cursor:"pointer"}}>
              {MONTHS.map((m,i)=><option key={m} value={i}>{m}</option>)}
            </select>
          )}
          <select value={repYear} onChange={e=>setRepYear(Number(e.target.value))} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".84rem",color:"#374151",background:"#fff",cursor:"pointer"}}>
            {REPORT_YEARS.map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          <div style={{flex:1}}/>
          <button onClick={exportReports} style={{background:"#10b981",border:"none",borderRadius:8,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,cursor:"pointer"}}>📥 Export Excel</button>
          <button onClick={printReports} style={{background:"#64748b",border:"none",borderRadius:8,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,cursor:"pointer"}}>🖨 Print</button>
        </div>
        <div style={{display:"flex",gap:0,borderBottom:"2px solid #e2e8f0",marginBottom:24,flexWrap:"wrap"}}>
          {repTabs.map(([t,l])=>(
            <button key={t} onClick={()=>setRepTab(t)} style={{padding:"10px 22px",border:"none",background:"none",cursor:"pointer",fontSize:".88rem",fontWeight:curTab===t?700:500,color:curTab===t?"#3b82f6":"#64748b",borderBottom:curTab===t?"2px solid #3b82f6":"2px solid transparent",marginBottom:-2,fontFamily:"inherit",transition:"all .15s"}}>{l}</button>
          ))}
        </div>

        {curTab==="sales"&&(
          repPeriod==="monthly"?(
            <div>
              <div style={{background:"#1e293b",borderRadius:12,padding:"20px 24px",marginBottom:20,color:"#fff"}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.4rem",letterSpacing:-.5}}>GMD PRODUCTIONS INC.</div>
                <div style={{fontSize:"1rem",fontWeight:700,color:"#f59e0b",marginTop:2}}>Sales Month-End Report — {monthLabel.toUpperCase()}</div>
                <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:6}}>Prepared by FabHub · Values include 12% VAT where applicable (OR) · Review Data Flags before circulating</div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:12,marginBottom:20}}>
                <KPI label="Deals Won"     value={monthWon.length}       color="#059669"/>
                <KPI label="Cancelled"     value={monthCancelled.length} color="#94a3b8"/>
                <KPI label="Open Pipeline" value={openPipeline.length}   color="#3b82f6"/>
              </div>
              <Card>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:"1rem",marginBottom:14}}>CLOSED REVENUE — {monthLabel.toUpperCase()} (incl. VAT)</div>
                <div style={{maxWidth:500}}>
                  {[["Total closed (all WON rows, as recorded)",fmt(totalWonGross),"#059669",true],["  ↳ Memo: ex-VAT base",fmt(totalWonBase),"#64748b",false],["  ↳ Memo: total VAT collected",fmt(totalWonVat),"#64748b",false]].map(([label,val,color,bold],i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #f1f5f9"}}>
                      <span style={{fontSize:".88rem",color:"#64748b"}}>{label}</span>
                      <span style={{fontWeight:bold?700:400,color,fontSize:".88rem"}}>{val}</span>
                    </div>
                  ))}
                </div>
              </Card>
              <Card style={{marginTop:16}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8,marginBottom:12}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".95rem"}}>CLOSED REVENUE BY SALES OWNER</div>
                  <div style={{display:"flex",gap:4}}>
                    {[["gross","By Revenue"],["won","By Deals"],["clients","By Clients"]].map(([k,l])=>(
                      <button key={k} onClick={()=>setRepAESort(k)} style={{padding:"4px 10px",border:"1.5px solid",borderColor:repAESort===k?"#3b82f6":"#e2e8f0",borderRadius:6,background:repAESort===k?"#eff6ff":"#fff",color:repAESort===k?"#1d4ed8":"#64748b",fontFamily:"inherit",fontSize:".72rem",fontWeight:repAESort===k?700:400,cursor:"pointer"}}>{l}</button>
                    ))}
                  </div>
                </div>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr>{["Sales Owner","AE Code","Deals Won","Unique Clients","Closed (incl. VAT)","% of Total"].map((h,i)=>TH(h,i>1))}</tr></thead>
                  <tbody>
                    {aeRows.map((r,i)=>(
                      <tr key={i} style={{background:repAEFilter===r.name?"#eff6ff":i%2===0?"#fff":"#f9fafb",cursor:"pointer"}} onClick={()=>setRepAEFilter(repAEFilter===r.name?"":r.name)} title={repAEFilter===r.name?"Click to clear filter":"Click to filter deals by this AE"}>
                        {TD(<span style={{display:"flex",alignItems:"center",gap:6}}>{repAEFilter===r.name&&<span style={{fontSize:".65rem",background:"#3b82f6",color:"#fff",borderRadius:4,padding:"1px 5px"}}>filtered</span>}<strong>{r.name}</strong></span>)}
                        {TD(<span style={{fontFamily:"monospace",fontWeight:700,color:"#6366f1"}}>{r.code}</span>)}
                        {TD(r.won,{right:true,bold:repAESort==="won",color:repAESort==="won"?"#059669":"#374151"})}
                        {TD(r.clients,{right:true,bold:repAESort==="clients",color:repAESort==="clients"?"#6366f1":"#374151"})}
                        {TD(fmt(r.gross),{right:true,bold:repAESort==="gross",color:"#059669"})}
                        {TD((aeTotal>0?Math.round(r.gross/aeTotal*100):0)+"%",{right:true,color:"#64748b"})}
                      </tr>
                    ))}
                    {aeRows.length===0&&<tr><td colSpan={6} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>No won deals for {monthLabel}</td></tr>}
                    <tr style={{background:"#eff6ff"}}>{TD(<strong style={{color:"#1e40af"}}>TOTAL</strong>)}{TD("")}{TD(aeRows.reduce((s,r)=>s+r.won,0),{right:true,bold:true,color:"#1e40af"})}{TD([...new Set(monthWon.map(d=>d.client).filter(Boolean))].length,{right:true,bold:true,color:"#6366f1"})}{TD(fmt(aeTotal),{right:true,bold:true,color:"#059669"})}{TD("100%",{right:true,color:"#64748b"})}</tr>
                  </tbody>
                </table>
                {aeRows.length>0&&<div style={{fontSize:".72rem",color:"#94a3b8",marginTop:8}}>💡 Click an AE row to filter the Closed Deals and Open Pipeline tables below</div>}
              </Card>
              <Card style={{marginTop:16}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8,marginBottom:12}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".95rem"}}>CLOSED DEALS — {monthLabel.toUpperCase()}</div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    {repAEFilter&&<span style={{fontSize:".78rem",background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:6,padding:"3px 10px",color:"#1d4ed8",fontWeight:600}}>AE: {repAEFilter} <button onClick={()=>setRepAEFilter("")} style={{marginLeft:4,background:"none",border:"none",color:"#3b82f6",cursor:"pointer",fontSize:".8rem",padding:0}}>✕</button></span>}
                    <select value={repAEFilter} onChange={e=>setRepAEFilter(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 10px",fontFamily:"inherit",fontSize:".78rem",color:"#374151",background:"#fff",cursor:"pointer"}}>
                      <option value="">All AEs</option>
                      {allAEs.map(ae=><option key={ae} value={ae}>{ae}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",minWidth:820}}>
                    <thead><tr>{["Service","Project Type","AE","Client","Project Name","Ex-VAT","VAT","Total (incl VAT)","Flags"].map((h,i)=>TH(h,i>=5))}</tr></thead>
                    <tbody>
                      {filteredWon.map((d,i)=>{
                        const t=dealTax(d);const flags=[];
                        if(!Number(d.value))flags.push("No value");
                        if(!d.ceNo)flags.push("Missing CE#");
                        if(t.vat===0&&Number(d.value)>50000)flags.push("VAT=0 — confirm exempt");
                        if(!["OR","AR"].includes(d.receiptType))flags.push("VAT pending BOQ — shown as OR");
                        if(boqVatMismatch(d))flags.push(`BOQ says ${boqVat(d)?"VAT":"No VAT"} — receipt is ${d.receiptType||"unset"}`);
                        return(
                          <tr key={d.id} style={{background:i%2===0?"#fff":"#f9fafb"}}>
                            {TD(<span style={{fontSize:".74rem",background:"#e0e7ff",color:"#3730a3",padding:"2px 7px",borderRadius:5,fontWeight:600}}>{svcType(d.ceType)}</span>)}
                            {TD(d.ceType||"—")}{TD(<span style={{fontFamily:"monospace",fontWeight:700,color:"#6366f1",fontSize:".8rem"}}>{aeCode(d.salesOwner||"")}</span>)}
                            {TD(<strong>{d.client||"—"}</strong>)}{TD(d.contact||d.product||"—")}
                            {TD(t.base>0?fmt(t.base):"—",{right:true})}{TD(t.vat>0?fmt(t.vat):"—",{right:true,color:"#94a3b8"})}{TD(fmt(t.gross),{right:true,bold:true,color:"#059669"})}
                            {TD(flags.length>0?<span style={{fontSize:".72rem",color:"#f59e0b"}}>⚠ {flags.join("; ")}</span>:"")}
                          </tr>
                        );
                      })}
                      {filteredWon.length===0&&<tr><td colSpan={9} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>{repAEFilter?`No won deals for ${repAEFilter} in ${monthLabel}`:`No won deals for ${monthLabel}`}</td></tr>}
                      <tr style={{background:"#f0fdf4",borderTop:"2px solid #6ee7b7"}}>
                        <td colSpan={5} style={{padding:"8px 12px",fontWeight:700,color:"#065f46",fontSize:".82rem"}}>TOTAL — {repAEFilter?`${repAEFilter} · `:""}WON only ({filteredWon.length} deals)</td>
                        {TD(fmt(filteredWon.reduce((s,d)=>s+dealTax(d).base,0)),{right:true,bold:true,color:"#065f46"})}{TD(fmt(filteredWon.reduce((s,d)=>s+dealTax(d).vat,0)),{right:true,color:"#94a3b8"})}{TD(fmt(filteredWon.reduce((s,d)=>s+dealTax(d).gross,0)),{right:true,bold:true,color:"#059669"})}{TD("")}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Card>
              <Card style={{marginTop:16}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12,flexWrap:"wrap",gap:8}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".95rem"}}>OPEN PIPELINE{repAEFilter?` — ${repAEFilter}`:""}</div>
                  <div style={{fontSize:".78rem",color:"#64748b"}}>{filteredPipeline.length} active opportunities</div>
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",minWidth:600}}>
                    <thead><tr>{["Client","Project Name","Service","Stage","CE#","Note"].map(h=>TH(h,false))}</tr></thead>
                    <tbody>
                      {filteredPipeline.slice(0,30).map((d,i)=>{
                        const flags=[];
                        if(!d.client)flags.push("Client missing");if(!Number(d.value))flags.push("No value");if(!d.ceNo)flags.push("No CE#");
                        return(<tr key={d.id} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(d.client||<span style={{color:"#ef4444",fontStyle:"italic"}}>(blank)</span>)}{TD(d.contact||d.product||"—")}{TD(<span style={{fontSize:".74rem",background:"#f1f5f9",color:"#475569",padding:"2px 6px",borderRadius:4}}>{svcType(d.ceType)}</span>)}{TD(<span style={{fontSize:".74rem",color:"#6366f1",fontWeight:600}}>{d.stage}</span>)}{TD(d.ceNo||"—")}{TD(flags.length>0?<span style={{fontSize:".72rem",color:"#f59e0b"}}>⚠ {flags.join("; ")}</span>:"")}</tr>);
                      })}
                      {filteredPipeline.length===0&&<tr><td colSpan={6} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>{repAEFilter?`No pipeline deals for ${repAEFilter}`:"No open pipeline deals"}</td></tr>}
                      {filteredPipeline.length>30&&<tr><td colSpan={6} style={{textAlign:"center",padding:10,color:"#94a3b8",fontSize:".78rem"}}>...and {filteredPipeline.length-30} more — export to Excel for full list</td></tr>}
                    </tbody>
                  </table>
                </div>
              </Card>
              <Card style={{marginTop:16,border:"1.5px solid #fde68a",background:"#fffbeb"}}>
                <div style={{fontWeight:700,color:"#92400e",fontSize:".95rem",marginBottom:4}}>⚠ DATA FLAGS — RESOLVE BEFORE THIS REPORT IS FINAL</div>
                <div style={{fontSize:".75rem",color:"#b45309",marginBottom:12}}>Devil's-advocate read on the data. None of this is fatal — but a number you can't defend is worse than a smaller number you can.</div>
                {dataFlags.length===0?(
                  <div style={{textAlign:"center",padding:16,color:"#059669",fontWeight:600,fontSize:".88rem"}}>✅ No data quality issues detected for {monthLabel}</div>
                ):(
                  <table style={{width:"100%",borderCollapse:"collapse"}}>
                    <thead><tr>{["#","Issue","Detail","₱ at Stake"].map(h=>TH(h,false))}</tr></thead>
                    <tbody>
                      {dataFlags.map((f,i)=>(<tr key={i} style={{background:i%2===0?"#fffbeb":"#fef9c3"}}>{TD(f.n,{bold:true,color:"#92400e"})}{TD(f.issue,{bold:true,color:"#92400e"})}{TD(f.detail,{style:{maxWidth:340,fontSize:".78rem"}})}{TD(f.stake,{bold:true,color:"#ef4444"})}</tr>))}
                    </tbody>
                  </table>
                )}
              </Card>
            </div>
          ):(
            <div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:12,marginBottom:24}}>
                <KPI label="Deals Acquired" value={yearDeals.length} color="#3b82f6"/>
                <KPI label="Deals Won"      value={yearWon.length}  color="#10b981"/>
                <KPI label="Win Rate"       value={(yearDeals.length>0?Math.round(yearWon.length/yearDeals.length*100):0)+"%"} color="#f59e0b"/>
                <KPI label="Pipeline Value" value={fmtK(yearDeals.reduce((s,d)=>s+Number(d.value||0),0))} color="#6366f1"/>
                <KPI label="Won Value"      value={fmtK(salesPeriods.reduce((s,p)=>s+p.wonValue,0))} color="#059669"/>
              </div>
              <Card>
                <div style={{fontWeight:700,color:"#0f172a",marginBottom:2,fontSize:".95rem"}}>{repPeriod==="quarterly"?"Quarterly":"Yearly"} Breakdown — {CY}</div>
                <div style={{fontSize:".72rem",color:"#64748b",marginBottom:12}}>Won Value = base contract + approved change orders, for deals acquired in {CY}. The all-time "Awarded Value" tile on Sales Pipeline uses a wider scope, so the two will differ.</div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse"}}>
                    <thead><tr>{[repPeriod==="quarterly"?"Quarter":"Year","Acquired","Won","Win Rate","Pipeline","Won Value"].map((h,i)=>TH(h,i>0))}</tr></thead>
                    <tbody>
                      {salesPeriods.map((p,i)=>(<tr key={i} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(<strong>{p.label}</strong>)}{TD(p.acquired,{right:true})}{TD(p.won,{right:true,color:p.won>0?"#059669":"#94a3b8"})}{TD(p.winRate+"%",{right:true,color:p.winRate>=50?"#059669":p.winRate>=25?"#f59e0b":"#ef4444"})}{TD(p.pipelineValue>0?fmt(Math.round(p.pipelineValue)):"—",{right:true})}{TD(p.wonValue>0?fmt(Math.round(p.wonValue)):"—",{right:true,bold:true,color:"#059669"})}</tr>))}
                      <tr style={{background:"#eff6ff"}}>{TD(<strong style={{color:"#1e40af"}}>TOTAL</strong>)}{TD(yearDeals.length,{right:true,bold:true,color:"#1e40af"})}{TD(yearWon.length,{right:true,bold:true,color:"#059669"})}{TD((yearDeals.length>0?Math.round(yearWon.length/yearDeals.length*100):0)+"%",{right:true,bold:true,color:"#1e40af"})}{TD(fmt(Math.round(salesPeriods.reduce((s,p)=>s+p.pipelineValue,0))),{right:true,bold:true,color:"#1e40af"})}{TD(fmt(Math.round(salesPeriods.reduce((s,p)=>s+p.wonValue,0))),{right:true,bold:true,color:"#059669"})}</tr>
                    </tbody>
                  </table>
                </div>
              </Card>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16,marginTop:16}}>
                <Card>
                  <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".9rem"}}>By Sales Owner</div>
                  <table style={{width:"100%",borderCollapse:"collapse"}}>
                    <thead><tr>{["Sales Owner","Acq.","Won","Won Value"].map((h,i)=>TH(h,i>0))}</tr></thead>
                    <tbody>
                      {ownerRows.map((o,i)=>(<tr key={i} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(o.owner)}{TD(o.acquired,{right:true})}{TD(o.won,{right:true,color:o.won>0?"#059669":"#94a3b8"})}{TD(fmtK(o.value),{right:true,bold:true,color:"#059669"})}</tr>))}
                      {ownerRows.length===0&&<tr><td colSpan={4} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>No data for {CY}</td></tr>}
                    </tbody>
                  </table>
                </Card>
                <Card>
                  <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".9rem"}}>By Project Type</div>
                  <table style={{width:"100%",borderCollapse:"collapse"}}>
                    <thead><tr>{["CE Type","Acq.","Won","Won Value"].map((h,i)=>TH(h,i>0))}</tr></thead>
                    <tbody>
                      {ceRows.map((r,i)=>(<tr key={i} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(r.type)}{TD(r.acquired,{right:true})}{TD(r.won,{right:true,color:r.won>0?"#059669":"#94a3b8"})}{TD(fmtK(r.value),{right:true,bold:true,color:"#059669"})}</tr>))}
                      {ceRows.length===0&&<tr><td colSpan={4} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>No data for {CY}</td></tr>}
                    </tbody>
                  </table>
                </Card>
              </div>
            </div>
          )
        )}

        {curTab==="finance"&&(
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:12,marginBottom:24}}>
              <KPI label="Revenue"     value={fmtK(finTot.revenue)}     color="#3b82f6"/>
              <KPI label="Collections (VAT-ex)" value={fmtK(finTot.collections)} color="#10b981"/>
              <KPI label="Outstanding" value={fmtK(finTot.outstanding)} color="#f59e0b"/>
              <KPI label="Costs (VAT-ex)" value={fmtK(finTot.expenses)}    color="#ef4444"/>
              <KPI label="Net Profit"  value={fmtK(finTot.net)}         color={finTot.net>=0?"#059669":"#ef4444"}/>
            </div>
            {/* BIR tax this month — input VAT (creditable) + EWT to remit (moved here from the ERP dashboard) */}
            {(()=>{
              const ym=today.slice(0,7);
              const monthExps=exps.filter(e=>(e.expDate||"").slice(0,7)===ym);
              // Payables now carry VAT/EWT too — include both sources, and avoid
              // double-counting exps already routed to a payable.
              const monthPays=payables.filter(p=>((p.invoiceDate||p.createdAt||"").slice(0,7)===ym));
              const inputVatMonth=monthExps.filter(e=>!e.payableId&&!e.cvId).reduce((s,e)=>s+(Number(e.inputVat)||0),0)+monthPays.reduce((s,p)=>s+(Number(p.inputVat)||0),0);
              const ewtPayableMonth=monthExps.filter(e=>!e.payableId&&!e.cvId).reduce((s,e)=>s+(Number(e.ewtAmount)||0),0)+monthPays.reduce((s,p)=>s+(Number(p.ewtAmount)||0),0);
              if(!(inputVatMonth>0||ewtPayableMonth>0)) return null;
              return(
                <div style={{display:"flex",flexWrap:"wrap",gap:12,marginBottom:20,padding:"12px 16px",background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:12}}>
                  <span style={{fontWeight:800,color:"#1e3a8a",fontSize:".82rem"}}>🧾 BIR Tax · {new Date().toLocaleDateString("en-PH",{month:"long",year:"numeric"})}</span>
                  <span style={{fontSize:".82rem",color:"#1e40af"}}>Input VAT (creditable): <strong>{fmt(inputVatMonth)}</strong></span>
                  <span style={{fontSize:".82rem",color:"#1e40af"}}>EWT withheld (to remit): <strong>{fmt(ewtPayableMonth)}</strong></span>
                  <span style={{fontSize:".72rem",color:"#64748b"}}>from supplier costs tagged this month</span>
                </div>
              );
            })()}
            <Card>
              <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".95rem"}}>Income Statement — {CY}</div>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr>{[repPeriod==="monthly"?"Month":repPeriod==="quarterly"?"Quarter":"Year","Revenue","Collections","Outstanding","Expenses","Net Profit"].map((h,i)=>TH(h,i>0))}</tr></thead>
                  <tbody>
                    {finPeriods.map((p,i)=>(<tr key={i} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(<strong>{p.label}</strong>)}{TD(p.revenue>0?fmt(p.revenue):"—",{right:true,color:"#3b82f6"})}{TD(p.collections>0?fmt(p.collections):"—",{right:true,color:"#10b981"})}{TD(p.outstanding>0?fmt(p.outstanding):"—",{right:true,color:"#f59e0b"})}{TD(p.expenses>0?fmt(p.expenses):"—",{right:true,color:"#ef4444"})}{TD(p.revenue>0||p.expenses>0?fmt(p.net):"—",{right:true,bold:true,color:p.net>=0?"#059669":"#ef4444"})}</tr>))}
                    <tr style={{background:"#eff6ff"}}>{TD(<strong style={{color:"#1e40af"}}>TOTAL</strong>)}{TD(fmt(finTot.revenue),{right:true,bold:true,color:"#3b82f6"})}{TD(fmt(finTot.collections),{right:true,bold:true,color:"#10b981"})}{TD(fmt(finTot.outstanding),{right:true,bold:true,color:"#f59e0b"})}{TD(fmt(finTot.expenses),{right:true,bold:true,color:"#ef4444"})}{TD(fmt(finTot.net),{right:true,bold:true,color:finTot.net>=0?"#059669":"#ef4444"})}</tr>
                  </tbody>
                </table>
              </div>
            </Card>
            {/* Aerwin-style statements — account-code driven (Income Statement + Cash Flow) */}
            {(()=>{
              const N=v=>Number(v)||0;
              const yr=String(CY);
              const inYear=d=>String(d||"").slice(0,4)===yr;
              const revenue=billings.filter(b=>b.status!=="Cancelled"&&inYear(b.invoiceDate||b.dueDate)).reduce((s,b)=>s+N(b.amount),0);
              // Costs by CoA code: payables are the source of truth; add legacy expenses not already in a payable/CV to avoid double-count.
              const costRecs=[
                ...payables.map(p=>({code:String(p.accountCode||""),amt:N(p.amount),date:p.invoiceDate||p.createdAt})),
                ...exps.filter(e=>!e.payableId&&!e.cvId).map(e=>({code:String(e.accountCode||""),amt:N(e.amount),date:e.expDate})),
              ].filter(r=>r.amt>0&&inYear(r.date));
              const cos=costRecs.filter(r=>/^5/.test(r.code)).reduce((s,r)=>s+r.amt,0);
              const opex=costRecs.filter(r=>/^6/.test(r.code)).reduce((s,r)=>s+r.amt,0);
              const uncoded=costRecs.filter(r=>!/^[56]/.test(r.code)).reduce((s,r)=>s+r.amt,0);
              const grossProfit=revenue-cos;
              const gpMargin=revenue>0?Math.round(grossProfit/revenue*100):0;
              const netIncome=grossProfit-opex-uncoded;
              const cashIn=billings.reduce((s,b)=>s+(b.payments||[]).filter(p=>inYear(p.date)&&isCashPayment(p)).reduce((ss,p)=>ss+N(p.amount),0),0);
              const cashOut=payables.filter(p=>inYear(p.paidDate)).reduce((s,p)=>s+N(p.paidAmount),0);
              const netCash=cashIn-cashOut;
              const SLine=({label,value,color,bold,indent,top})=>(
                <div style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderTop:top?"2px solid #e2e8f0":"1px solid #f1f5f9"}}>
                  <span style={{fontSize:".84rem",color:bold?"#0f172a":"#475569",fontWeight:bold?800:500,paddingLeft:indent?14:0}}>{label}</span>
                  <span style={{fontSize:".86rem",fontWeight:bold?800:600,fontFamily:"monospace",color:color||"#0f172a"}}>{value}</span>
                </div>
              );
              return(
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16,marginTop:16}}>
                  <Card>
                    <div style={{fontWeight:700,color:"#0f172a",marginBottom:8,fontSize:".95rem"}}>📈 Income Statement — {CY}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginBottom:6}}>By Chart-of-Accounts code · 5000s = Cost of Sales · 6000s = Operating Expenses</div>
                    <SLine label="Revenue" value={fmt(revenue)} color="#3b82f6" bold/>
                    <SLine label="Less: Cost of Sales (5000s)" value={"("+fmt(cos)+")"} color="#ef4444" indent/>
                    <SLine label="Gross Profit" value={`${fmt(grossProfit)}  ·  ${gpMargin}%`} color={grossProfit>=0?"#059669":"#ef4444"} bold top/>
                    <SLine label="Less: Operating Expenses (6000s)" value={"("+fmt(opex)+")"} color="#ef4444" indent/>
                    {uncoded>0&&<SLine label="Less: Uncoded costs" value={"("+fmt(uncoded)+")"} color="#f59e0b" indent/>}
                    <SLine label="Net Income" value={fmt(netIncome)} color={netIncome>=0?"#059669":"#ef4444"} bold top/>
                    {uncoded>0&&<div style={{fontSize:".68rem",color:"#b45309",marginTop:8}}>⚠ {fmt(uncoded)} of costs have no account code — tag them on the PO/WO/Other Payable to classify correctly.</div>}
                  </Card>
                  <Card>
                    <div style={{fontWeight:700,color:"#0f172a",marginBottom:8,fontSize:".95rem"}}>💵 Cash Flow — {CY}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginBottom:6}}>Operating cash · collections in, supplier/subcontractor payments out</div>
                    <SLine label="Cash In — Collections" value={fmt(cashIn)} color="#10b981" bold/>
                    <SLine label="Cash Out — AP Payments" value={"("+fmt(cashOut)+")"} color="#ef4444" bold/>
                    <SLine label="Net Cash from Operations" value={fmt(netCash)} color={netCash>=0?"#059669":"#ef4444"} bold top/>
                    <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:8}}>Collections = client payments logged in Billing. AP Payments = amounts paid against payables (POs, Work Orders &amp; Other Payables).</div>
                  </Card>
                </div>
              );
            })()}
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:16,marginTop:16}}>
              <Card>
                <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".9rem"}}>Expenses by Category — {CY}</div>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr>{["Category","Amount","% of Total"].map((h,i)=>TH(h,i>0))}</tr></thead>
                  <tbody>
                    {expCatRows.map(([cat,amt],i)=>(<tr key={i} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(cat)}{TD(fmt(amt),{right:true,color:"#ef4444"})}{TD((totalExpCat>0?Math.round(amt/totalExpCat*100):0)+"%",{right:true,color:"#94a3b8"})}</tr>))}
                    {expCatRows.length===0&&<tr><td colSpan={3} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>No expenses for {CY}</td></tr>}
                  </tbody>
                </table>
              </Card>
              <Card>
                <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".9rem"}}>Outstanding Invoices Aging</div>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr>{["Client","Milestone","Amount","Days"].map((h,i)=>TH(h,i>1))}</tr></thead>
                  <tbody>
                    {agingMs.map((b,i)=>(<tr key={b.id} style={{background:i%2===0?"#fff":"#f9fafb"}}>{TD(<span style={{maxWidth:90,display:"block",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.clientName}</span>)}{TD(b.name||b.label||"Milestone")}{TD(fmt(b.amount),{right:true,bold:true,color:"#f59e0b"})}{TD(b.daysOver!=null?b.daysOver+"d":"—",{right:true,color:b.daysOver>30?"#ef4444":b.daysOver>0?"#f59e0b":"#94a3b8"})}</tr>))}
                    {agingMs.length===0&&<tr><td colSpan={4} style={{textAlign:"center",padding:20,color:"#94a3b8",fontSize:".82rem"}}>No outstanding invoices</td></tr>}
                  </tbody>
                </table>
              </Card>
            </div>
          </div>
        )}

        {curTab==="ar-aging"&&(()=>{
          const fmtM=v=>"₱"+Number(v||0).toLocaleString("en-PH",{maximumFractionDigits:0});
          const msWithBalance=billings.filter(b=>!['Fully Paid','Cancelled'].includes(b.status)&&Number(b.amount||0)>0).map(b=>{
            const deal=deals.find(d=>d.id===b.dealId);
            const tx=calcTax(Number(b.amount||0),b.receiptType??b.receipt_type??deal?.receiptType??"OR",b.withholding??deal?.withholding??false);
            const totalPaid=(b.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);
            const balance=Math.max(0,tx.netReceivable-totalPaid);
            if(balance<=0) return null;
            const days=b.dueDate?Math.floor((new Date()-new Date(b.dueDate))/(864e5)):null;
            return{...b,clientName:deal?.client||"Unknown",balance,days};
          }).filter(Boolean).sort((a,b)=>(b.days||0)-(a.days||0));
          const buckets=[
            {label:"Current",color:"#10b981",bg:"#f0fdf4",filter:r=>r.days===null||r.days<=0},
            {label:"1–30 days",color:"#f59e0b",bg:"#fffbeb",filter:r=>r.days>0&&r.days<=30},
            {label:"31–60 days",color:"#f97316",bg:"#fff7ed",filter:r=>r.days>30&&r.days<=60},
            {label:"61–90 days",color:"#ef4444",bg:"#fef2f2",filter:r=>r.days>60&&r.days<=90},
            {label:"90+ days",color:"#dc2626",bg:"#fef2f2",filter:r=>r.days>90},
          ];
          const total=msWithBalance.reduce((s,r)=>s+r.balance,0);
          return(
            <div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:20}}>
                {buckets.map(bk=>{const amt=msWithBalance.filter(bk.filter).reduce((s,r)=>s+r.balance,0);const pct=total>0?Math.round(amt/total*100):0;return(
                  <div key={bk.label} style={{background:bk.bg,border:`1.5px solid ${bk.color}33`,borderTop:`3px solid ${bk.color}`,borderRadius:10,padding:"12px 14px"}}>
                    <div style={{fontSize:".6rem",color:"#64748b",textTransform:"uppercase",letterSpacing:".6px",marginBottom:4}}>{bk.label}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.15rem",color:bk.color}}>{fmtM(amt)}</div>
                    <div style={{fontSize:".7rem",color:bk.color,fontWeight:600}}>{pct}% of total</div>
                  </div>);
                })}
              </div>
              <Card>
                <div style={{fontWeight:700,fontSize:".9rem",marginBottom:12,color:"#0f172a"}}>Outstanding Invoices — {fmtM(total)} total</div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",minWidth:520}}>
                    <thead><tr style={{background:"#1e293b"}}>{["Client","Milestone","Due Date","Balance","Age","Status"].map((h,i)=><th key={h} style={{padding:"8px 12px",color:"rgba(255,255,255,.7)",fontSize:".65rem",fontWeight:700,textTransform:"uppercase",textAlign:i>=3?"right":"left"}}>{h}</th>)}</tr></thead>
                    <tbody>
                      {msWithBalance.map((r,i)=>{
                        const bk=buckets.find(bk=>bk.filter(r))||buckets[0];
                        return(<tr key={r.id} style={{background:i%2?"#fafafa":"#fff"}}>
                          <td style={{padding:"9px 12px",fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{r.clientName}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",color:"#475569"}}>{r.name||"Invoice"}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",color:"#64748b"}}>{r.dueDate||"—"}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",fontWeight:700,color:bk.color,textAlign:"right"}}>{fmtM(r.balance)}</td>
                          <td style={{padding:"9px 12px",textAlign:"right"}}><span style={{background:bk.bg,color:bk.color,border:`1px solid ${bk.color}44`,borderRadius:20,padding:"2px 8px",fontSize:".72rem",fontWeight:700}}>{r.days!=null&&r.days>0?r.days+"d overdue":r.days===null?"No due date":"Current"}</span></td>
                          <td style={{padding:"9px 12px",textAlign:"right"}}><span style={{background:"#f1f5f9",color:"#475569",borderRadius:20,padding:"2px 8px",fontSize:".7rem"}}>{r.status}</span></td>
                        </tr>);
                      })}
                      {msWithBalance.length===0&&<tr><td colSpan={6} style={{textAlign:"center",padding:24,color:"#94a3b8",fontSize:".82rem"}}>No outstanding AR — all invoices current!</td></tr>}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          );
        })()}

        {curTab==="ap-aging"&&(()=>{
          const fmtM=v=>"₱"+Number(v||0).toLocaleString("en-PH",{maximumFractionDigits:0});
          const unpaid=payables.filter(p=>p.status!=="Paid"&&Number(p.amount||0)>0).map(p=>{
            const deal=deals.find(d=>d.id===p.projectId);
            const days=p.dueDate?Math.floor((new Date()-new Date(p.dueDate))/(864e5)):null;
            return{...p,projectName:deal?.client||p.projectName||"—",days};
          }).sort((a,b)=>(b.days||0)-(a.days||0));
          const buckets=[
            {label:"Current",color:"#10b981",bg:"#f0fdf4",filter:r=>r.days===null||r.days<=0},
            {label:"1–30 days",color:"#f59e0b",bg:"#fffbeb",filter:r=>r.days>0&&r.days<=30},
            {label:"31–60 days",color:"#f97316",bg:"#fff7ed",filter:r=>r.days>30&&r.days<=60},
            {label:"61–90 days",color:"#ef4444",bg:"#fef2f2",filter:r=>r.days>60&&r.days<=90},
            {label:"90+ days",color:"#dc2626",bg:"#fef2f2",filter:r=>r.days>90},
          ];
          const total=unpaid.reduce((s,r)=>s+Number(r.amount||0),0);
          return(
            <div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:20}}>
                {buckets.map(bk=>{const amt=unpaid.filter(bk.filter).reduce((s,r)=>s+Number(r.amount||0),0);const pct=total>0?Math.round(amt/total*100):0;return(
                  <div key={bk.label} style={{background:bk.bg,border:`1.5px solid ${bk.color}33`,borderTop:`3px solid ${bk.color}`,borderRadius:10,padding:"12px 14px"}}>
                    <div style={{fontSize:".6rem",color:"#64748b",textTransform:"uppercase",letterSpacing:".6px",marginBottom:4}}>{bk.label}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.15rem",color:bk.color}}>{fmtM(amt)}</div>
                    <div style={{fontSize:".7rem",color:bk.color,fontWeight:600}}>{pct}% of total</div>
                  </div>);
                })}
              </div>
              <Card>
                <div style={{fontWeight:700,fontSize:".9rem",marginBottom:12,color:"#0f172a"}}>Unpaid Payables — {fmtM(total)} total</div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",minWidth:520}}>
                    <thead><tr style={{background:"#1e293b"}}>{["Vendor","Project","Invoice Ref","Due Date","Amount","Age"].map((h,i)=><th key={h} style={{padding:"8px 12px",color:"rgba(255,255,255,.7)",fontSize:".65rem",fontWeight:700,textTransform:"uppercase",textAlign:i>=4?"right":"left"}}>{h}</th>)}</tr></thead>
                    <tbody>
                      {unpaid.map((r,i)=>{
                        const bk=buckets.find(bk=>bk.filter(r))||buckets[0];
                        return(<tr key={r.id} style={{background:i%2?"#fafafa":"#fff"}}>
                          <td style={{padding:"9px 12px",fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{r.vendor||"—"}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",color:"#475569"}}>{r.projectName}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",color:"#64748b"}}>{r.invoiceRef||r.poNumber||"—"}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",color:"#64748b"}}>{r.dueDate||"—"}</td>
                          <td style={{padding:"9px 12px",fontSize:".82rem",fontWeight:700,color:bk.color,textAlign:"right"}}>{fmtM(r.amount)}</td>
                          <td style={{padding:"9px 12px",textAlign:"right"}}><span style={{background:bk.bg,color:bk.color,border:`1px solid ${bk.color}44`,borderRadius:20,padding:"2px 8px",fontSize:".72rem",fontWeight:700}}>{r.days!=null&&r.days>0?r.days+"d overdue":r.days===null?"No due date":"Current"}</span></td>
                        </tr>);
                      })}
                      {unpaid.length===0&&<tr><td colSpan={6} style={{textAlign:"center",padding:24,color:"#94a3b8",fontSize:".82rem"}}>No unpaid payables — all bills settled!</td></tr>}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          );
        })()}
      </Wrap>
    );
  }
  // ── Pipeline tab bar (shared) ───────────────────────────────────────────
  // BOQ lives here now (it left the sidebar): the BOQ tab opens the BOQ page,
  // which shows this same bar, for the roles that had BOQ in their nav.
  const boqInPipeline=["Manager","Sales","Finance","QS","SalesOpsAdmin"].includes(role);
  // CE Requests: a small tracker standing in for the hidden CE/QS Queue.
  const ceInPipeline=["Manager","Sales","QS","SalesOpsAdmin"].includes(role);
  // Five tabs are wider than a phone: the bar scrolls sideways instead of
  // cutting off the last ones (CE Requests, BOQ).
  const PipeTabBar=()=>(
    <div style={{display:"flex",gap:0,borderBottom:"2px solid #e2e8f0",marginBottom:20,overflowX:"auto",maxWidth:"calc(100vw - 32px)",WebkitOverflowScrolling:"touch"}}>
      {[["pipeline","📊 Pipeline"],["awarded","💰 Commissions"],["updates","📝 AE Updates"],...(ceInPipeline?[["ce","📐 CE Requests"]]:[]),...(boqInPipeline?[["boq","🧮 BOQ"]]:[])].filter(([t])=>!HIDDEN_PIPE_TABS.has(t)).map(([t,l])=>{
        const on=t==="boq"?page==="boq":page==="pipeline"&&pipeTab===t;
        return(
        <button key={t} onClick={()=>{if(t==="boq"){setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(null);setPage("boq");}else{setPipeTab(t);setPage("pipeline");}}}
          style={{padding:isMobile?"9px 12px":"9px 20px",whiteSpace:"nowrap",flexShrink:0,border:"none",background:"none",cursor:"pointer",fontSize:isMobile?".82rem":".88rem",fontWeight:on?700:500,color:on?"#3b82f6":"#64748b",borderBottom:on?"2px solid #3b82f6":"2px solid transparent",marginBottom:-2,fontFamily:"inherit"}}>
          {l}{t==="updates"&&aeUpdates.length>0&&<span style={{marginLeft:5,background:"#3b82f6",color:"#fff",borderRadius:20,padding:"1px 6px",fontSize:".65rem",fontWeight:700}}>{aeUpdates.filter(u=>u.date===today).length||""}</span>}
        </button>
        );
      })}
    </div>
  );

  if(page==="pipeline"&&pipeTab==="ce"&&ceInPipeline) return(
    <Wrap>
      <PipeTabBar/>
      <CERequestTracker ceReqs={ceReqs} deals={deals} addCEReq={addCEReq} updateCEReq={updateCEReq} session={session} role={role} toastEmit={toastEmit} today={today}/>
    </Wrap>
  );
  if(page==="pipeline"&&pipeTab==="updates") return(
    <Wrap>
      <PipeTabBar/>
      {(()=>{
        const todayCount=aeUpdates.filter(u=>u.date===today).length;
        const allDeals=[...wonDeals,...deals.filter(d=>!WON_STAGES.includes(d.stage))];
        const AV_COLORS=["#3b82f6","#8b5cf6","#059669","#f59e0b","#ef4444","#06b6d4","#ec4899","#f97316"];
        const colorFor=name=>AV_COLORS[(name||"").split("").reduce((s,c)=>s+c.charCodeAt(0),0)%AV_COLORS.length];
        const closedIds=new Set(deals.filter(d=>d.stage==="12 · Close-Out"||d.stage==="14 · Completed").map(d=>d.id));
        const pipelineIds=new Set(deals.filter(d=>isActivePipeline(d.stage)).map(d=>d.id));
        const wonIds=new Set(wonDeals.map(d=>d.id));

        const filteredUpdates=aeUpdates.filter(u=>{
          if(aeFeedFilter==="active") return u.dealId&&wonIds.has(u.dealId)&&!closedIds.has(u.dealId);
          if(aeFeedFilter==="pipeline") return u.dealId&&pipelineIds.has(u.dealId);
          if(aeFeedFilter==="general") return !u.dealId;
          return true;
        });
        const byPerson={};aeUpdates.filter(u=>u.date===today).forEach(u=>{byPerson[u.by]=(byPerson[u.by]||0)+1;});

        // Group filteredUpdates by project (dealId), separate closed from active
        const projectGroups={};// dealId -> {deal, updates[], isClosed}
        const generalUpdates=[];
        filteredUpdates.forEach(u=>{
          if(!u.dealId){generalUpdates.push(u);return;}
          if(!projectGroups[u.dealId]){
            const d=allDeals.find(x=>x.id===u.dealId);
            projectGroups[u.dealId]={deal:d,updates:[],isClosed:closedIds.has(u.dealId)};
          }
          projectGroups[u.dealId].updates.push(u);
        });
        // Sort each group by most recent update first
        Object.values(projectGroups).forEach(g=>g.updates.sort((a,b)=>b.date.localeCompare(a.date)||b.time.localeCompare(a.time)));
        // Split into open vs closed project groups, sort by most recent update
        const activeGroups=Object.values(projectGroups).filter(g=>!g.isClosed).sort((a,b)=>b.updates[0]?.date.localeCompare(a.updates[0]?.date)||0);
        const closedGroups=Object.values(projectGroups).filter(g=>g.isClosed).sort((a,b)=>b.updates[0]?.date.localeCompare(a.updates[0]?.date)||0);
        generalUpdates.sort((a,b)=>b.date.localeCompare(a.date)||b.time.localeCompare(a.time));

        const UpdateCard=({u})=>{
          const taggedDeal=u.dealId?allDeals.find(d=>d.id===u.dealId):null;
          const isActive=u.dealId&&wonIds.has(u.dealId)&&!closedIds.has(u.dealId);
          const isPipeline=u.dealId&&pipelineIds.has(u.dealId);
          return(
            <div style={{background:"#fff",borderRadius:10,border:"1.5px solid #f1f5f9",padding:"10px 13px",marginBottom:7,display:"flex",gap:9,alignItems:"flex-start"}}>
              <div style={{width:32,height:32,borderRadius:"50%",background:colorFor(u.by),display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#fff",fontSize:".72rem",flexShrink:0}}>
                {u.by?.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase()||"?"}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:3,flexWrap:"wrap"}}>
                  <span style={{fontWeight:700,color:"#0f172a",fontSize:".83rem"}}>{u.by}</span>
                  <span style={{fontSize:".65rem",color:"#94a3b8",marginLeft:"auto",flexShrink:0}}>{u.date===today?"Today":u.date} {u.time}</span>
                </div>
                <div style={{fontSize:".82rem",color:"#1e293b",lineHeight:1.6}}>{u.text}</div>
              </div>
              {(u.by===session?.name||role==="Manager")&&(
                <button onClick={()=>delAeUpdate(u.id)} style={{background:"none",border:"none",color:"#cbd5e1",cursor:"pointer",fontSize:".72rem",padding:"2px 3px",flexShrink:0,lineHeight:1}} title="Delete">✕</button>
              )}
            </div>
          );
        };

        const ProjectGroup=({deal,updates,isClosed})=>(
          <div style={{marginBottom:14,borderRadius:12,border:`1.5px solid ${isClosed?"#e2e8f0":"#e2e8f0"}`,overflow:"hidden",opacity:isClosed?.75:1}}>
            <div style={{background:isClosed?"#f8fafc":"#f1f5f9",padding:"9px 14px",display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
              <span style={{fontWeight:700,color:isClosed?"#94a3b8":"#0f172a",fontSize:".84rem",flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                {isClosed?"✅ ":deal?.stage&&wonIds.has(deal?.id)?"🏗 ":"📊 "}{deal?(deal.contact||deal.client):"Unknown Project"}
              </span>
              {deal?.client&&deal.contact&&<span style={{fontSize:".68rem",color:"#94a3b8",flexShrink:0}}>{deal.client}</span>}
              {deal?.ceNo&&<span style={{fontSize:".68rem",color:"#64748b",background:"#fff",border:"1px solid #e2e8f0",borderRadius:4,padding:"1px 6px",flexShrink:0,fontWeight:600}}>{deal.ceNo}</span>}
              {isClosed&&<span style={{fontSize:".65rem",color:"#059669",background:"#dcfce7",border:"1px solid #bbf7d0",borderRadius:10,padding:"1px 7px",fontWeight:700,flexShrink:0}}>CLOSED</span>}
              <span style={{fontSize:".65rem",color:"#94a3b8",flexShrink:0}}>{updates.length} update{updates.length!==1?"s":""}</span>
            </div>
            <div style={{padding:"10px 12px 4px",background:"#fff"}}>
              {updates.map(u=><UpdateCard key={u.id} u={u}/>)}
            </div>
          </div>
        );

        const ComposeForm=(
          <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:"16px"}}>
            <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:12}}>
              <div style={{width:36,height:36,borderRadius:"50%",background:colorFor(session?.name),display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#fff",fontSize:".8rem",flexShrink:0}}>
                {session?.name?.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase()||"?"}
              </div>
              <div>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{session?.name||"You"}</div>
                <div style={{fontSize:".68rem",color:"#94a3b8"}}>{roleLabel(session?.role||role)}</div>
              </div>
            </div>
            <div style={{fontSize:".7rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>Tag a project (optional)</div>
            <div style={{display:"flex",gap:0,background:"#f1f5f9",borderRadius:7,padding:2,marginBottom:8}}>
              {[["active","🏗 Active",wonDeals.length],["pipeline","📊 Pipeline",deals.filter(d=>isActivePipeline(d.stage)).length]].map(([t,l,cnt])=>(
                <button key={t} onClick={()=>{setAeUpdateDealType(t);setAeUpdateDealId("");}}
                  style={{flex:1,padding:"5px 8px",border:"none",borderRadius:5,fontFamily:"inherit",fontSize:".75rem",fontWeight:aeUpdateDealType===t?700:500,cursor:"pointer",background:aeUpdateDealType===t?"#fff":"transparent",color:aeUpdateDealType===t?"#1d4ed8":"#64748b",boxShadow:aeUpdateDealType===t?"0 1px 3px rgba(0,0,0,.1)":"none",transition:"all .15s",textAlign:"center"}}>
                  {l} <span style={{fontSize:".62rem",opacity:.7}}>({cnt})</span>
                </button>
              ))}
            </div>
            <select value={aeUpdateDealId} onChange={e=>setAeUpdateDealId(e.target.value)}
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 9px",fontFamily:"inherit",fontSize:".8rem",background:"#f8fafc",color:aeUpdateDealId?"#1d4ed8":"#94a3b8",fontWeight:aeUpdateDealId?700:400,marginBottom:12,boxSizing:"border-box"}}>
              <option value="">— No project tag —</option>
              {aeUpdateDealType==="active"
                ? wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed").map(d=><option key={d.id} value={d.id}>{d.contact||d.client}{d.ceNo?" · "+d.ceNo:""}</option>)
                : deals.filter(d=>isActivePipeline(d.stage)).map(d=><option key={d.id} value={d.id}>{d.contact||d.client}{d.ceNo?" · "+d.ceNo:""}</option>)
              }
            </select>
            <textarea value={aeUpdateText} onChange={e=>setAeUpdateText(e.target.value)}
              onKeyDown={e=>{if(e.key==="Enter"&&(e.ctrlKey||e.metaKey)){e.preventDefault();if(aeUpdateText.trim())addAeUpdate(aeUpdateText,aeUpdateDealId);}}}
              rows={isMobile?3:4}
              placeholder="What did you work on? Site visits, follow-ups, client calls…"
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 11px",fontFamily:"inherit",fontSize:".84rem",resize:"vertical",boxSizing:"border-box",lineHeight:1.55,outline:"none",marginBottom:10}}
              onFocus={e=>e.target.style.borderColor="#3b82f6"}
              onBlur={e=>e.target.style.borderColor="#e2e8f0"}
            />
            <button onClick={()=>addAeUpdate(aeUpdateText,aeUpdateDealId)} disabled={!aeUpdateText.trim()}
              style={{width:"100%",background:aeUpdateText.trim()?"#3b82f6":"#e2e8f0",border:"none",borderRadius:8,padding:"10px",fontFamily:"inherit",fontSize:".85rem",color:aeUpdateText.trim()?"#fff":"#94a3b8",cursor:aeUpdateText.trim()?"pointer":"default",fontWeight:700}}>
              Post Update →
            </button>
            <div style={{fontSize:".65rem",color:"#94a3b8",marginTop:6,textAlign:"center"}}>Ctrl+Enter · Notifies Sales &amp; Ops on Telegram</div>
            {Object.keys(byPerson).length>0&&(
              <div style={{marginTop:12,paddingTop:10,borderTop:"1px solid #f1f5f9"}}>
                <div style={{fontSize:".67rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>📅 Today</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {Object.entries(byPerson).map(([name,cnt])=>(
                    <span key={name} style={{display:"inline-flex",alignItems:"center",gap:4,background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:20,padding:"2px 9px",fontSize:".71rem",color:"#475569",fontWeight:600}}>
                      <span style={{width:7,height:7,borderRadius:"50%",background:colorFor(name),display:"inline-block"}}/>
                      {name.split(" ")[0]} · {cnt}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        );

        const FeedSection=(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
              <div>
                <div style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>📋 Team Updates</div>
                <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:1}}>{aeUpdates.length} total · {todayCount} today</div>
              </div>
              <div style={{display:"flex",gap:0,background:"#f1f5f9",borderRadius:8,padding:2,flexWrap:"wrap"}}>
                {[["all","All",aeUpdates.length],["active","🏗",aeUpdates.filter(u=>u.dealId&&wonIds.has(u.dealId)&&!closedIds.has(u.dealId)).length],["pipeline","📊",aeUpdates.filter(u=>u.dealId&&pipelineIds.has(u.dealId)).length],["general","📝",aeUpdates.filter(u=>!u.dealId).length]].map(([t,l,cnt])=>(
                  <button key={t} onClick={()=>setAeFeedFilter(t)}
                    style={{padding:"5px 10px",border:"none",borderRadius:6,fontFamily:"inherit",fontSize:".73rem",fontWeight:aeFeedFilter===t?700:500,cursor:"pointer",background:aeFeedFilter===t?"#fff":"transparent",color:aeFeedFilter===t?"#1d4ed8":"#64748b",boxShadow:aeFeedFilter===t?"0 1px 3px rgba(0,0,0,.1)":"none",whiteSpace:"nowrap"}}>
                    {l} <span style={{opacity:.65}}>({cnt})</span>
                  </button>
                ))}
              </div>
            </div>

            {filteredUpdates.length===0&&(
              <div style={{textAlign:"center",padding:"40px 24px",color:"#94a3b8",fontSize:".84rem",background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0"}}>
                No {aeFeedFilter==="all"?"updates":aeFeedFilter+" updates"} yet.
              </div>
            )}

            {/* Active project groups */}
            {activeGroups.map(g=><ProjectGroup key={g.deal?.id||"unknown"} deal={g.deal} updates={g.updates} isClosed={false}/>)}

            {/* General (untagged) updates */}
            {generalUpdates.length>0&&(
              <div style={{marginBottom:14,borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{background:"#f1f5f9",padding:"9px 14px",display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontWeight:700,color:"#0f172a",fontSize:".84rem",flex:1}}>📝 General Updates</span>
                  <span style={{fontSize:".65rem",color:"#94a3b8"}}>{generalUpdates.length} update{generalUpdates.length!==1?"s":""}</span>
                </div>
                <div style={{padding:"10px 12px 4px",background:"#fff"}}>
                  {generalUpdates.map(u=><UpdateCard key={u.id} u={u}/>)}
                </div>
              </div>
            )}

            {/* Closed project groups — collapsed by default */}
            {closedGroups.length>0&&(
              <div style={{marginTop:8}}>
                <button onClick={()=>setAeShowClosed(v=>!v)}
                  style={{width:"100%",background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"9px 14px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,color:"#64748b",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:aeShowClosed?10:0}}>
                  <span>✅ Closed Projects ({closedGroups.length}) — {closedGroups.reduce((s,g)=>s+g.updates.length,0)} updates</span>
                  <span style={{fontSize:".7rem"}}>{aeShowClosed?"▲ Hide":"▼ Show"}</span>
                </button>
                {aeShowClosed&&closedGroups.map(g=><ProjectGroup key={g.deal?.id||"closed"} deal={g.deal} updates={g.updates} isClosed={true}/>)}
              </div>
            )}
          </div>
        );

        return isMobile?(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {ComposeForm}
            {FeedSection}
          </div>
        ):(
          <div style={{display:"grid",gridTemplateColumns:"320px 1fr",gap:18,alignItems:"start"}}>
            <div style={{position:"sticky",top:16}}>
              <div style={{fontWeight:800,color:"#0f172a",fontSize:".92rem",marginBottom:8}}>📝 Post an Update</div>
              {ComposeForm}
            </div>
            <div>{FeedSection}</div>
          </div>
        );
      })()}
    </Wrap>
  );

  // Sales Pipeline is restricted for the design team — only the Head Designer
  // keeps access. Other designers who somehow land here are bounced to their home.
  if(page==="pipeline"&&role==="Design"&&!isHeadDesigner(session?.name)) return(
    <Wrap>
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"40px 24px",textAlign:"center",maxWidth:520,margin:"40px auto"}}>
        <div style={{fontSize:"2rem",marginBottom:10}}>🔒</div>
        <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.05rem",marginBottom:6}}>Sales Pipeline is restricted</div>
        <div style={{fontSize:".82rem",color:"#64748b",lineHeight:1.5}}>Pipeline access is limited to the Head Designer. Head to your design queue and folder to see your assigned projects.</div>
        <button onClick={()=>setPage("home")} style={{marginTop:16,background:"#ec4899",border:"none",borderRadius:10,padding:"9px 20px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>Go to My Projects →</button>
      </div>
    </Wrap>
  );

  if(page==="pipeline"&&pipeTab==="awarded") return(
    <Wrap>
      <PipeTabBar/>
      {(()=>{
        const peso   =(v)=>"₱"+Math.round(Number(v)||0).toLocaleString("en-PH");
        const isMgr  =role==="Manager";
        // Team-wide commission visibility: Manager plus the finance/oversight roles
        // (Finance, FinanceAssistant, Accounting, SalesOpsAdmin) — the same roles the
        // DB already grants read access to commission_payouts — can flip to the whole
        // team. Approving a payout stays Manager-only (see the Approve button below).
        const canSeeTeam=["Manager","Finance","FinanceAssistant","Accounting","SalesOpsAdmin"].includes(ROLE_ALIASES[role]||role);
        // Awarded = deal in a WON stage (06→14). Exclude standby-PO umbrellas (0 value carriers).
        const awarded=wonDeals.filter(d=>!d.standbyPO);
        // Visibility: everyone sees their own; the roles above can flip to the whole team.
        // Credit follows the deal's Sales Owner only — the same person the team view
        // groups by and payouts are made to, so one deal never credits two people.
        const mine   =d=>!!session?.name&&d.salesOwner===session.name;
        const scope  =(canSeeTeam&&awardScope==="team")?"team":"mine";
        // VAT-ex collected (from the billing ledger) and the commission on it.
        const collX  =d=>collectedBase(d,dealCollected(d));
        const earnX  =d=>commissionEarned(d,dealCollected(d));
        const rows   =(scope==="team"?awarded:awarded.filter(mine))
                        .slice().sort((a,b)=>(earnX(b)-earnX(a)));
        const done   =s=>["12 · Close-Out","14 · Completed"].includes(s);
        // Totals
        const tVal   =rows.reduce((s,d)=>s+(Number(d.value)||0),0);
        const tColl  =rows.reduce((s,d)=>s+collX(d),0);
        const tEarn  =rows.reduce((s,d)=>s+earnX(d),0);
        const tProj  =rows.reduce((s,d)=>s+commissionProjected(d),0);
        const who    =scope==="team"?"the sales team":(session?.name||"you");

        // ── Payouts: what's actually been disbursed to the rep(s) in view ──────
        // Scope payouts the same way as the deal rows: "mine" = my own payouts,
        // "team" = everyone's. Only APPROVED payouts count as paid.
        const scopedPayouts=(payouts||[]).filter(p=>p.status!=="Void").filter(p=>scope==="team"?true:p.payee===session?.name);
        const paidByRep=(()=>{const m={};(payouts||[]).filter(isPayoutApproved).forEach(p=>{m[p.payee]=(m[p.payee]||0)+(Number(p.amount)||0);});return m;})();
        const tPaid    =payoutsPaid(scopedPayouts);
        const tPending =payoutsPending(scopedPayouts);
        const tPayable =commissionPayable(tEarn,tPaid);
        const canRecord=roleCanInsert("commission_payouts");
        const payeeOptions=[...new Set(awarded.map(d=>d.salesOwner).filter(Boolean))].sort();

        const kpi=(lbl,val,sub,accent)=>(
          <div style={{flex:"1 1 180px",background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"13px 15px",...(accent?{background:"linear-gradient(180deg,#ecfdf5,#fff)",borderColor:"#a7f3d0"}:{})}}>
            <div style={{fontSize:".68rem",fontWeight:700,letterSpacing:".5px",textTransform:"uppercase",color:accent?"#059669":"#94a3b8"}}>{lbl}</div>
            <div style={{fontSize:"1.4rem",fontWeight:800,marginTop:5,color:accent?"#047857":"#0f172a",fontVariantNumeric:"tabular-nums"}}>{val}</div>
            {sub&&<div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2}}>{sub}</div>}
          </div>
        );

        // Per-salesperson breakdown for the manager "Whole team" view.
        const groups=(()=>{
          const m=new Map();
          rows.forEach(d=>{const k=d.salesOwner||"— Unassigned —";(m.get(k)||m.set(k,[]).get(k)).push(d);});
          return [...m.entries()].map(([owner,ds])=>({
            owner, ds,
            val:ds.reduce((s,d)=>s+(Number(d.value)||0),0),
            coll:ds.reduce((s,d)=>s+collX(d),0),
            earned:ds.reduce((s,d)=>s+earnX(d),0),
            proj:ds.reduce((s,d)=>s+commissionProjected(d),0),
          })).sort((a,b)=>b.earned-a.earned);
        })();

        const renderRow=(d)=>{
          const collected=collX(d), contract=Number(d.value)||0;
          const pct=contract>0?Math.min(100,Math.round(collected/contract*100)):0;
          const earned=earnX(d), proj=commissionProjected(d);
          const pendLead=leadOriginPending(d);
          const payClr=PAY_CLR[d.paymentStatus]||"#94a3b8";
          const stgClr=STAGE_CLR[d.stage]||"#64748b";
          return(
            <tr key={d.id} onClick={()=>openEditDeal(d)} style={{borderBottom:"1px solid #f1f5f9",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"} onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
              <td style={{padding:"11px 13px",verticalAlign:"middle"}}>
                <div style={{fontFamily:"monospace",fontSize:".68rem",color:"#94a3b8"}}>{d.ceNo||"—"}</div>
                <div style={{fontWeight:700,color:"#0f172a"}}>{d.contact||d.client}</div>
                {d.contact&&d.client&&<div style={{fontSize:".72rem",color:"#64748b"}}>{d.client}</div>}
              </td>
              <td style={{padding:"11px 13px",whiteSpace:"nowrap",color:"#475569"}}>{d.salesOwner||"—"}</td>
              <td style={{padding:"11px 13px"}}>
                <span style={{fontSize:".68rem",fontWeight:700,padding:"3px 9px",borderRadius:20,whiteSpace:"nowrap",color:done(d.stage)?"#065f46":stgClr,background:done(d.stage)?"#dcfce7":stgClr+"1a"}}>{d.stage}</span>
              </td>
              <td style={{padding:"11px 13px",textAlign:"right",fontVariantNumeric:"tabular-nums",whiteSpace:"nowrap",color:"#0f172a"}}>{peso(contract)}</td>
              <td style={{padding:"11px 13px",textAlign:"right",minWidth:130}}>
                <div style={{fontVariantNumeric:"tabular-nums",color:"#0f172a"}}>{peso(collected)}</div>
                <div style={{height:5,borderRadius:20,background:"#e2e8f0",overflow:"hidden",marginTop:4}}><div style={{height:"100%",width:pct+"%",background:"#059669",borderRadius:20}}/></div>
                <div style={{fontSize:".66rem",color:"#94a3b8",marginTop:2}}>{pct}% collected</div>
              </td>
              <td style={{padding:"11px 13px"}}>
                <span style={{fontSize:".68rem",fontWeight:700,padding:"3px 9px",borderRadius:20,color:payClr,background:payClr+"1a",whiteSpace:"nowrap"}}>{d.paymentStatus||"Unpaid"}</span>
              </td>
              <td style={{padding:"11px 13px",textAlign:"right",whiteSpace:"nowrap"}}>
                <div style={{fontWeight:800,color:"#059669",fontVariantNumeric:"tabular-nums"}}>{peso(earned)}</div>
                <div style={{fontSize:".66rem",color:"#94a3b8",fontVariantNumeric:"tabular-nums"}}>of {peso(proj)} · {commissionRate(d)*100}%</div>
                {pendLead&&<div title="Self-sourced claim waiting for Manager approval — earns 0.5% until approved" style={{fontSize:".62rem",fontWeight:700,color:"#b45309",marginTop:2}}>⏳ 1.5% pending approval</div>}
              </td>
            </tr>
          );
        };

        return(
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,marginBottom:6}}>
              <div>
                <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>💰 Commissions</h2>
                <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{rows.length} awarded project{rows.length!==1?"s":""} · {scope==="team"?"whole team":"your projects"} · {todayL}</div>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                {canRecord&&(
                  <button onClick={()=>setPayoutDraft({payee:scope==="team"?"":(session?.name||""),periodLabel:`${MONTHS[new Date().getMonth()]} ${new Date().getFullYear()}`,amount:"",payBank:"",payMethod:"",payRef:"",notes:""})}
                    style={{border:"none",background:"#059669",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",padding:"8px 14px",borderRadius:8,cursor:"pointer"}}>+ Record payout</button>
                )}
                {canSeeTeam&&(
                  <div style={{display:"flex",background:"#f1f5f9",borderRadius:9,padding:3}}>
                    {[["mine","My projects"],["team","Whole team"]].map(([v,l])=>(
                      <button key={v} onClick={()=>setAwardScope(v)} style={{border:"none",background:awardScope===v?"#3b82f6":"transparent",color:awardScope===v?"#fff":"#475569",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",padding:"6px 14px",borderRadius:6,cursor:"pointer"}}>{l}</button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:12}}>
              {kpi("Commission · earned",peso(tEarn),`${peso(tProj)} projected at full collection`,true)}
              {kpi("Paid out",peso(tPaid),tEarn>0?`${Math.round(tPaid/tEarn*100)}% of earned disbursed`:"—")}
              {kpi("Payable",peso(tPayable),"earned but not yet paid")}
              {kpi("Pending approval",peso(tPending),tPending>0?"recorded, awaiting Manager":"none awaiting")}
            </div>

            <div style={{display:"flex",gap:10,alignItems:"flex-start",background:"#ecfdf5",border:"1.5px solid #a7f3d0",borderRadius:12,padding:"11px 15px",marginBottom:16,fontSize:".78rem",color:"#334155",lineHeight:1.55}}>
              <span style={{fontSize:"1rem",flexShrink:0}}>💡</span>
              <div>
                <b style={{color:"#065f46"}}>Commission accrues on what the client has paid, VAT-exclusive — not on award.</b> Each awarded deal earns
                its sales owner <b>{(COMMISSION_RATE["Self-sourced"]*100)}%</b> (self-sourced client, Manager-approved) or <b>{(COMMISSION_RATE["Given"]*100)}%</b> (client given to the team) of every peso collected, after taking out the 12% VAT (the client's 2% EWT counts as collected).
                <b style={{color:"#059669"}}> Earned</b> moves each time a payment is logged; <b>Projected</b> is the full commission once the contract is paid off.
                <b style={{color:"#059669"}}> Paid</b> is what Finance has disbursed (Manager-approved); <b>Payable</b> is earned minus paid — what you're still owed.
                <span style={{color:"#94a3b8"}}> Lead origin is set per deal — deals earn the {DEFAULT_LEAD_ORIGIN.toLowerCase()} rate until a Self-sourced claim is approved by a Manager.</span>
              </div>
            </div>

            <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,overflow:"hidden"}}>
              <div style={{overflowX:"auto"}}>
                <table style={{borderCollapse:"collapse",width:"100%",minWidth:820,fontSize:".82rem"}}>
                  <thead>
                    <tr style={{background:"#f8fafc",textAlign:"left"}}>
                      {["Project","Owner","Stage","Contract (VAT-ex)","Collected (VAT-ex)","Payment","Commission"].map((h,i)=>(
                        <th key={h} style={{padding:"10px 13px",fontSize:".65rem",fontWeight:700,letterSpacing:".5px",textTransform:"uppercase",color:"#94a3b8",borderBottom:"1.5px solid #e2e8f0",whiteSpace:"nowrap",textAlign:i>=3&&i!==5?"right":"left"}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {scope==="team"
                      ? groups.map(g=>(
                          <React.Fragment key={g.owner}>
                            <tr style={{background:"#eef2ff",borderBottom:"1px solid #e2e8f0"}}>
                              <td colSpan={3} style={{padding:"9px 13px",fontWeight:800,color:"#1e293b"}}>
                                {g.owner} <span style={{fontWeight:600,color:"#94a3b8",fontSize:".72rem"}}>· {g.ds.length} project{g.ds.length!==1?"s":""}</span>
                              </td>
                              <td style={{padding:"9px 13px",textAlign:"right",fontVariantNumeric:"tabular-nums",color:"#475569"}}>{peso(g.val)}</td>
                              <td style={{padding:"9px 13px",textAlign:"right",fontVariantNumeric:"tabular-nums",color:"#475569"}}>{peso(g.coll)}</td>
                              <td></td>
                              <td style={{padding:"9px 13px",textAlign:"right",whiteSpace:"nowrap"}}>
                                <div style={{fontWeight:800,color:"#059669",fontVariantNumeric:"tabular-nums"}}>{peso(g.earned)}</div>
                                <div style={{fontSize:".66rem",color:"#94a3b8",fontVariantNumeric:"tabular-nums"}}>of {peso(g.proj)}</div>
                              </td>
                            </tr>
                            {g.ds.map(renderRow)}
                          </React.Fragment>
                        ))
                      : rows.map(renderRow)}
                    {rows.length===0&&(
                      <tr><td colSpan={7} style={{padding:"36px 16px",textAlign:"center",color:"#94a3b8"}}>No awarded projects{scope==="mine"?" credited to you yet":" yet"}. Deals appear here once they reach stage 06 · Kickoff.</td></tr>
                    )}
                  </tbody>
                  {rows.length>0&&(
                    <tfoot>
                      <tr style={{background:"#f8fafc",fontWeight:800}}>
                        <td style={{padding:"12px 13px"}} colSpan={3}>{scope==="team"?"Team totals":"My totals"} · {rows.length} project{rows.length!==1?"s":""}</td>
                        <td style={{padding:"12px 13px",textAlign:"right",fontVariantNumeric:"tabular-nums"}}>{peso(tVal)}</td>
                        <td style={{padding:"12px 13px",textAlign:"right",fontVariantNumeric:"tabular-nums"}}>{peso(tColl)}</td>
                        <td></td>
                        <td style={{padding:"12px 13px",textAlign:"right",color:"#059669",fontVariantNumeric:"tabular-nums"}}>{peso(tEarn)}</td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>

            {/* ── Payout ledger: what's been disbursed to the rep(s) ─────────── */}
            <div style={{marginTop:22,background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,overflow:"hidden"}}>
              <div style={{padding:"12px 15px",borderBottom:"1.5px solid #f1f5f9",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
                <div>
                  <div style={{fontWeight:800,color:"#0f172a"}}>💸 Payout history</div>
                  <div style={{fontSize:".72rem",color:"#64748b",marginTop:2}}>{scopedPayouts.length} payout{scopedPayouts.length!==1?"s":""} · {scope==="team"?"whole team":(session?.name||"you")}</div>
                </div>
                {canRecord&&(
                  <button onClick={()=>setPayoutDraft({payee:scope==="team"?"":(session?.name||""),periodLabel:`${MONTHS[new Date().getMonth()]} ${new Date().getFullYear()}`,amount:"",payBank:"",payMethod:"",payRef:"",notes:""})}
                    style={{border:"none",background:"#059669",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".76rem",padding:"7px 13px",borderRadius:8,cursor:"pointer"}}>+ Record payout</button>
                )}
              </div>
              <div style={{overflowX:"auto"}}>
                <table style={{borderCollapse:"collapse",width:"100%",minWidth:720,fontSize:".82rem"}}>
                  <thead>
                    <tr style={{background:"#f8fafc",textAlign:"left"}}>
                      {["Rep","Period","Amount","Status","Recorded by","Ref","",""].map((h,i)=>(
                        <th key={i} style={{padding:"9px 13px",fontSize:".65rem",fontWeight:700,letterSpacing:".5px",textTransform:"uppercase",color:"#94a3b8",borderBottom:"1.5px solid #e2e8f0",whiteSpace:"nowrap",textAlign:i===2?"right":"left"}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {scopedPayouts.slice().sort((a,b)=>String(b.createdAt||"").localeCompare(String(a.createdAt||""))).map(p=>{
                      const sc=p.status==="Approved"?"#059669":p.status==="Void"?"#94a3b8":"#d97706";
                      return(
                        <tr key={p.id} style={{borderBottom:"1px solid #f1f5f9"}}>
                          <td style={{padding:"10px 13px",fontWeight:700,color:"#0f172a"}}>{p.payee||"—"}</td>
                          <td style={{padding:"10px 13px",color:"#475569"}}>{p.periodLabel||"—"}</td>
                          <td style={{padding:"10px 13px",textAlign:"right",fontVariantNumeric:"tabular-nums",fontWeight:700,color:p.status==="Void"?"#94a3b8":"#0f172a"}}>{peso(p.amount)}</td>
                          <td style={{padding:"10px 13px"}}><span style={{fontSize:".68rem",fontWeight:700,padding:"3px 9px",borderRadius:20,color:sc,background:sc+"1a",whiteSpace:"nowrap"}}>{p.status}</span></td>
                          <td style={{padding:"10px 13px",color:"#64748b",fontSize:".76rem"}}>{p.recordedBy||"—"}{p.approvedBy?<div style={{color:"#94a3b8"}}>✓ {p.approvedBy}</div>:null}</td>
                          <td style={{padding:"10px 13px",color:"#64748b",fontSize:".76rem"}}>{[p.payMethod,p.payRef].filter(Boolean).join(" · ")||"—"}</td>
                          <td style={{padding:"10px 13px",textAlign:"right"}}>{isMgr&&p.status==="Recorded"&&<button onClick={()=>approvePayout(p.id)} style={{border:"none",background:"#059669",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",padding:"5px 11px",borderRadius:7,cursor:"pointer"}}>Approve</button>}</td>
                          <td style={{padding:"10px 13px",textAlign:"right"}}>{canRecord&&p.status!=="Void"&&<button onClick={()=>voidPayout(p.id)} style={{border:"1px solid #e2e8f0",background:"#fff",color:"#94a3b8",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",padding:"5px 9px",borderRadius:7,cursor:"pointer"}}>Void</button>}</td>
                        </tr>
                      );
                    })}
                    {scopedPayouts.length===0&&(
                      <tr><td colSpan={8} style={{padding:"28px 16px",textAlign:"center",color:"#94a3b8"}}>No payouts recorded yet.{canRecord?" Use “Record payout” to log a disbursement.":" Finance records these as commissions are paid."}</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        );
      })()}

      {/* Record-payout form (Finance / Manager) */}
      {payoutDraft&&(
        <Modal open onClose={()=>setPayoutDraft(null)} title="Record commission payout">
          <div style={{display:"flex",flexDirection:"column",gap:12,minWidth:300}}>
            <Fld label="Rep (sales owner)">
              <Sel value={payoutDraft.payee} onChange={e=>setPayoutDraft(d=>({...d,payee:e.target.value}))}>
                <option value="">— Select rep —</option>
                {[...new Set([...wonDeals.filter(d=>!d.standbyPO).map(d=>d.salesOwner).filter(Boolean),...(payoutDraft.payee?[payoutDraft.payee]:[])])].sort().map(n=><option key={n} value={n}>{n}</option>)}
              </Sel>
            </Fld>
            <Fld label="Period" hint="e.g. the month the payout covers">
              <Inp value={payoutDraft.periodLabel} onChange={e=>setPayoutDraft(d=>({...d,periodLabel:e.target.value}))} placeholder="Aug 2026"/>
            </Fld>
            <Fld label="Amount (₱)">
              <Inp type="number" value={payoutDraft.amount} onChange={e=>setPayoutDraft(d=>({...d,amount:e.target.value}))} placeholder="0"/>
            </Fld>
            <div style={{display:"flex",gap:10}}>
              <Fld label="Method"><Inp value={payoutDraft.payMethod} onChange={e=>setPayoutDraft(d=>({...d,payMethod:e.target.value}))} placeholder="Bank transfer"/></Fld>
              <Fld label="Reference"><Inp value={payoutDraft.payRef} onChange={e=>setPayoutDraft(d=>({...d,payRef:e.target.value}))} placeholder="Ref #"/></Fld>
            </div>
            <Fld label="Notes"><Inp value={payoutDraft.notes} onChange={e=>setPayoutDraft(d=>({...d,notes:e.target.value}))} placeholder="Optional"/></Fld>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:4}}>
              <button onClick={()=>setPayoutDraft(null)} style={{border:"1px solid #e2e8f0",background:"#fff",color:"#475569",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",padding:"9px 16px",borderRadius:9,cursor:"pointer"}}>Cancel</button>
              <button onClick={async()=>{
                  if(!payoutDraft.payee){toastEmit("Please select a rep.","warning");return;}
                  if(!(Number(payoutDraft.amount)>0)){toastEmit("Enter a payout amount.","warning");return;}
                  await recordPayout(payoutDraft);
                  setPayoutDraft(null);
                }} style={{border:"none",background:"#059669",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",padding:"9px 18px",borderRadius:9,cursor:"pointer"}}>Record payout</button>
            </div>
          </div>
        </Modal>
      )}
    </Wrap>
  );

  if(page==="pipeline") return(
    <>
      <Wrap>
        {/* KPIs */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:10}}>
          <div>
            <PipeTabBar/>
            <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Sales Pipeline</h2>
            <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{deals.filter(d=>isActivePipeline(d.stage)).length} active deals · {todayL}</div>
            {/* Search bar */}
            <div style={{position:"relative",marginTop:8}}>
              <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#94a3b8",fontSize:".85rem"}}>🔍</span>
              <input
                type="text"
                value={pipeSearch}
                onChange={e=>setPipeSearch(e.target.value)}
                placeholder="Search by client, CE number, project name, AE..."
                style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"8px 12px 8px 32px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",outline:"none",background:"#fff"}}
                onFocus={e=>e.target.style.borderColor="#3b82f6"}
                onBlur={e=>e.target.style.borderColor="#e2e8f0"}
              />
              {pipeSearch&&<button onClick={()=>setPipeSearch("")} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:".85rem"}}>✕</button>}
            </div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
            <button onClick={()=>setShowActChat(v=>!v)} style={{background:showActChat?"#1e293b":"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"7px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:showActChat?"#4ade80":"#64748b",cursor:"pointer",position:"relative"}}>
              💬 Activity
              {actLog.length>0&&!showActChat&&<span style={{position:"absolute",top:-5,right:-5,background:"#ef4444",color:"#fff",borderRadius:"50%",width:16,height:16,fontSize:".6rem",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>{Math.min(actLog.length,9)}</span>}
            </button>
            <input ref={smartImportInputRef} type="file" accept=".xlsx,.xls,.csv,.pdf" style={{display:"none"}} onChange={async e=>{
                const file=e.target.files[0]; if(!file) return;
                e.target.value="";
                setImportLoading(true);
                try{
                  // Step 1: Parse the file
                  let rawRows=[], rawText="", fileType=file.name.split(".").pop().toLowerCase();
                  if(fileType==="csv"){
                    rawText=await file.text();
                    const lines=rawText.split("\n").filter(Boolean);
                    const parseCSVLine=l=>{const f=[];let c="",q=false;for(const ch of l){if(ch==='"')q=!q;else if(ch===','&&!q){f.push(c.trim());c="";}else c+=ch;}f.push(c.trim());return f;};
                    const headers=parseCSVLine(lines[0]).map(h=>h.replace(/^"|"$/g,""));
                    rawRows=lines.slice(1).map(line=>{
                      const vals=parseCSVLine(line).map(v=>v.replace(/^"|"$/g,""));
                      return Object.fromEntries(headers.map((h,i)=>[h,vals[i]||""]));
                    }).filter(r=>Object.values(r).some(v=>v));
                    rawText=lines.slice(0,6).join("\n");
                  } else if(["xlsx","xls"].includes(fileType)){
                    const {read,utils}=window.XLSX||{};
                    if(!read) throw new Error("Excel library not loaded. Please refresh the page and try again.");
                    const buf=await file.arrayBuffer();
                    const wb=read(buf,{type:"array"});
                    // Detect FabHub SmartImport Template by sheet names
                    const isFabHub=wb.SheetNames.some(s=>s.includes("Sales Import"));
                    if(isFabHub){
                      const parseSheet=(sheetName,defaultStage)=>{
                        if(!sheetName) return [];
                        const ws=wb.Sheets[sheetName];
                        const all2d=utils.sheet_to_json(ws,{header:1,defval:""});
                        const headerRow=(all2d[3]||[]).map(h=>String(h).replace(/\s*\*\s*/g,"").trim());
                        return all2d.slice(4)
                          .filter(row=>row[2]||row[3])
                          .map(row=>{
                            const obj={};
                            headerRow.forEach((h,i)=>{if(h) obj[h]=row[i]??""});
                            if(defaultStage) obj._defaultStage=defaultStage;
                            return obj;
                          });
                      };
                      const awardedSheet=wb.SheetNames.find(s=>s.includes("awarded"));
                      const regularSheet=wb.SheetNames.find(s=>s.includes("Sales Import")&&!s.includes("awarded"));
                      const awardedRows=parseSheet(awardedSheet,"09 · For Archiving");
                      const regularRows=parseSheet(regularSheet,null);
                      rawRows=[...awardedRows,...regularRows];
                      rawText=rawRows.slice(0,5).map(r=>Object.values(r).slice(0,6).join(" | ")).join("\n");
                    } else {
                      const ws=wb.Sheets[wb.SheetNames[0]];
                      rawRows=utils.sheet_to_json(ws,{defval:""});
                      rawText=utils.sheet_to_json(ws,{header:1}).slice(0,6).map(r=>r.join(" | ")).join("\n");
                    }
                  }

                  // Step 2: Analyze file structure locally
                  const allColumns=[...new Set(rawRows.flatMap(r=>Object.keys(r).filter(k=>k!=='_defaultStage')))];
                  const colsNorm=allColumns.map(c=>c.toLowerCase().replace(/[^a-z0-9]/g,""));
                  const isFabHubTemplate=colsNorm.some(c=>c.includes("ceno")||c.includes("clientname"))||
                    rawRows.some(r=>r._defaultStage);
                  const score=(terms)=>terms.filter(t=>colsNorm.some(c=>c.includes(t))).length;
                  const scores={
                    deals:   isFabHubTemplate?10:score(["client","stage","value","ceno","cenum","deal","pipeline","acquired","sales"]),
                    expenses:score(["expense","category","amount","vendor","cost","description","receipt"]),
                    inflows: score(["inflow","payment","received","collection","income","deposited"]),
                    clients: score(["company","contact","email","phone","address","industry"]),
                    payroll: score(["employee","salary","wage","payroll","rate","allowance","deduction"]),
                  };
                  const best=Object.entries(scores).sort((a,b)=>b[1]-a[1])[0];
                  const dataType=best[1]>0?best[0]:"unknown";
                  const confidence=isFabHubTemplate?98:Math.min(95,best[1]*20+5);
                  const issues=[];
                  if(rawRows.length===0) issues.push("File appears to be empty — no data rows found");
                  if(allColumns.length>30) issues.push("Wide file — showing first 20 columns");
                  const emptyCount=rawRows.filter(r=>Object.values(r).every(v=>!v||v==="")).length;
                  if(emptyCount>0) issues.push(`${emptyCount} rows with minimal data will be imported as bare leads`);
                  const awardedCount=rawRows.filter(r=>r._defaultStage==="09 · For Archiving").length;
                  if(awardedCount>0) issues.push(`${awardedCount} awarded/historical projects detected — will import as "Done / Collected"`);
                  const canImport=dataType==="deals"&&rawRows.length>0;
                  const analysis={
                    dataType,confidence,rowCount:rawRows.length,
                    fieldsFound:allColumns.slice(0,20),
                    isFabHubTemplate,
                    issues,
                    summary:isFabHubTemplate
                      ?`FabHub SmartImport Template detected. ${rawRows.length} deals ready to import (${awardedCount} historical awarded + ${rawRows.length-awardedCount} pipeline). Rows with missing stages will default to "01 · BizDev".`
                      :`File contains ${rawRows.length} row${rawRows.length!==1?"s":""} and ${allColumns.length} column${allColumns.length!==1?"s":""}. ${dataType!=="unknown"?`Detected as ${dataType} data based on column names.`:"Column names did not match a known data type — manual review needed."}`,
                    importAction:canImport?"Import as deals into the Sales Pipeline":`${dataType!=="unknown"?dataType.charAt(0).toUpperCase()+dataType.slice(1)+" data detected":"Unknown data type"} — use the matching module to import`,
                    canImport,
                    cantImportReason:canImport?"":dataType!=="deals"&&dataType!=="unknown"?`${dataType} data — import this using the ${dataType} module instead`:"Could not map columns to a known FabHub data type",
                  };
                  setSmartImport({rows:rawRows,analysis,fileName:file.name,fileType});
                }catch(err){
                  toastEmit("Error reading file: "+err.message,"error");
                }
                setImportLoading(false);
              }}/>
            <Btn onClick={openAddDeal}>+ Add Deal</Btn>
            <button onClick={()=>setQuickAddClientOpen(true)} style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:9,padding:"7px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:"#059669",cursor:"pointer"}}>
              + Add Client
            </button>
          </div>
        </div>
        {/* Addenda requiring Sales action */}
        {(()=>{
          const myAddenda=addenda.filter(a=>{
            const deal=deals.find(d=>d.id===a.projectId);
            return deal&&!a.salesNotified&&a.status!=="Rejected";
          });
          return myAddenda.length>0?(
            <div style={{background:"#fff7ed",border:"1.5px solid #fed7aa",borderRadius:12,padding:"12px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <div>
                <div style={{fontWeight:700,color:"#92400e",fontSize:".88rem"}}>⚠️ {myAddenda.length} scope change{myAddenda.length>1?"s":""} need your attention</div>
                <div style={{fontSize:".75rem",color:"#92400e",marginTop:3,opacity:.8}}>Operations logged scope changes — coordinate with clients before proceeding</div>
                <div style={{marginTop:6,display:"flex",flexDirection:"column",gap:3}}>
                  {myAddenda.slice(0,3).map(a=>(
                    <div key={a.id} style={{fontSize:".75rem",color:"#92400e"}}>
                      • <strong>{a.projectName||deals.find(d=>d.id===a.projectId)?.client}</strong>: {a.title}
                      {Number(a.value)>0&&<span style={{marginLeft:6,fontWeight:700}}>₱{Number(a.value).toLocaleString("en-PH")}</span>}
                    </div>
                  ))}
                  {myAddenda.length>3&&<div style={{fontSize:".72rem",color:"#92400e",opacity:.7}}>+{myAddenda.length-3} more</div>}
                </div>
              </div>
            </div>
          ):null;
        })()}
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:24}}>
          {[
            {l:"Total Pipeline",    v:fmt(Math.round(deals.filter(d=>isActivePipeline(d.stage)).reduce((s,d)=>s+Number(d.value||0),0))), c:"#3b82f6", sub:"Active stages"},
            {l:"Awarded Value",     v:fmt(Math.round(wonDeals.reduce((s,d)=>s+Number(d.value||0),0))),   c:"#059669", sub:"All-time · base contract"},
            {l:"Active Deals",      v:deals.filter(d=>isActivePipeline(d.stage)).length, c:"#f59e0b"},
            {l:"Awarded Projects",  v:wonDeals.length, c:"#8b5cf6"},
          ].map(({l,v,c,sub})=>(
            <div key={l} style={{background:"#fff",borderRadius:12,padding:"15px 16px",border:"1.5px solid #e2e8f0",boxShadow:"0 1px 4px rgba(0,0,0,.04)"}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c,lineHeight:1}}>{v}</div>
              {sub&&<div style={{fontSize:".68rem",color:c,opacity:.7,marginTop:2}}>{sub}</div>}
              <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:6}}>{l}</div>
            </div>
          ))}
        </div>

        {/* Activity Chat Pop-up Panel */}
        {showActChat&&(
          <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",marginBottom:20,overflow:"hidden",boxShadow:"0 8px 32px rgba(0,0,0,.1)"}}>
            <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontWeight:700,color:"#4ade80",fontSize:".88rem"}}>💬 Activity Feed — Sales Pipeline</span>
              <button onClick={()=>setShowActChat(false)} style={{background:"transparent",border:"none",color:"rgba(255,255,255,.5)",cursor:"pointer",fontSize:"1rem",lineHeight:1,padding:"0 4px"}}>✕</button>
            </div>
            <div style={{maxHeight:400,overflowY:"auto",padding:"12px 16px",display:"flex",flexDirection:"column",gap:8}}>
              {actLog.length===0&&<div style={{textAlign:"center",padding:"20px",color:"#94a3b8",fontSize:".82rem"}}>No activity yet — add a deal to get started.</div>}
              {actLog.slice(0,30).map((entry,i)=>{
                const actionClr={"New Deal":"#10b981","Project Awarded":"#f59e0b","Stage Change":"#3b82f6","Deal Updated":"#94a3b8","Deal Deleted":"#ef4444"}[entry.action]||"#64748b";
                const initials=(entry.by||"?").split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();
                return(
                  <div key={entry.id||i} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                    <div style={{width:32,height:32,borderRadius:"50%",background:actionClr+"22",border:`1.5px solid ${actionClr}44`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2}}>
                      <span style={{fontSize:".65rem",fontWeight:800,color:actionClr}}>{initials}</span>
                    </div>
                    <div style={{flex:1,background:"#f8fafc",borderRadius:"4px 12px 12px 12px",padding:"8px 12px",border:"1px solid #f1f5f9"}}>
                      <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:3,flexWrap:"wrap"}}>
                        <span style={{fontWeight:700,color:"#0f172a",fontSize:".78rem"}}>{entry.by||"System"}</span>
                        <span style={{fontSize:".62rem",color:actionClr,background:actionClr+"18",padding:"1px 7px",borderRadius:20,fontWeight:700}}>{entry.action}</span>
                        <span style={{fontSize:".65rem",color:"#94a3b8",marginLeft:"auto"}}>{entry.date} {entry.time}</span>
                      </div>
                      <div style={{fontSize:".8rem",color:"#475569",lineHeight:1.4}}>{entry.detail}</div>
                    </div>
                  </div>
                );
              })}
              {actLog.length>30&&<div style={{textAlign:"center",fontSize:".72rem",color:"#94a3b8",padding:"4px 0"}}>Showing last 30 of {actLog.length} activities</div>}
            </div>
          </div>
        )}

        {/* AE / Salesperson filter */}
        {(()=>{
          const aeList=[...new Set(deals.filter(d=>d.salesOwner).map(d=>d.salesOwner))].sort();
          if(aeList.length===0) return null;
          return(
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12,alignItems:"center"}}>
              <span style={{fontSize:".7rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginRight:2}}>AE:</span>
              {["all",...aeList].map(ae=>(
                <button key={ae} onClick={()=>setPipeAE(ae)}
                  style={{padding:"4px 11px",borderRadius:20,border:`1.5px solid ${pipeAE===ae?"#6366f1":"#e2e8f0"}`,background:pipeAE===ae?"#6366f1":"#fff",color:pipeAE===ae?"#fff":"#64748b",fontFamily:"inherit",fontWeight:pipeAE===ae?700:400,fontSize:".75rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                  {ae==="all"?`All (${deals.filter(d=>isActivePipeline(d.stage)).length})`:ae}
                </button>
              ))}
            </div>
          );
        })()}

        {/* Search results notice */}
        {pipeSearch&&(
          <div style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:10,padding:"8px 16px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:".82rem",color:"#1d4ed8"}}>
              🔍 Showing results for "<strong>{pipeSearch}</strong>" — {deals.filter(d=>isActivePipeline(d.stage)&&[d.client,d.contact,d.ceNo,d.salesOwner,d.product].join(" ").toLowerCase().includes(pipeSearch.toLowerCase())).length} deals found
            </span>
            <button onClick={()=>setPipeSearch("")} style={{background:"transparent",border:"none",color:"#3b82f6",cursor:"pointer",fontSize:".8rem",fontWeight:700}}>Clear ✕</button>
          </div>
        )}

        {/* ── ORPHANED DEALS — parentDealId set but parent doesn't exist ── */}
        {(()=>{
          const dealIds=new Set(deals.map(d=>d.id));
          const orphaned=deals.filter(d=>d.parentDealId&&!dealIds.has(d.parentDealId));
          if(!orphaned.length) return null;
          return(
            <div style={{background:"#fff7ed",border:"1.5px solid #fed7aa",borderRadius:12,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontWeight:700,color:"#c2410c",fontSize:".85rem",marginBottom:6}}>
                ⚠️ {orphaned.length} deal{orphaned.length>1?"s":""} with a broken parent link — hidden from pipeline
              </div>
              <div style={{fontSize:".75rem",color:"#92400e",marginBottom:10}}>
                These deals are linked to a project that no longer exists. Edit each deal, clear the "Link to Parent" field, and save to restore them to the pipeline.
              </div>
              {orphaned.map(d=>(
                <div key={d.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",background:"#fff",borderRadius:8,marginBottom:6,border:"1px solid #fed7aa",flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{d.contact||d.client||"—"}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2}}>{d.ceNo&&<span style={{fontWeight:600,color:"#6366f1",marginRight:6}}>{d.ceNo}</span>}{d.client}</div>
                  </div>
                  <Badge label={d.stage?.replace(/^\d+ · /,"")||"Unknown"} color={STAGE_CLR[d.stage]||"#94a3b8"}/>
                  {(role==="Manager"||role==="Sales")&&(
                    <button onClick={()=>openEditDeal(d)} style={{background:"#f97316",border:"none",borderRadius:7,padding:"6px 14px",fontSize:".78rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,flexShrink:0}}>✏ Fix Link</button>
                  )}
                </div>
              ))}
            </div>
          );
        })()}

        {/* ── 🧭 SELF-SOURCED CLAIMS AWAITING MANAGER APPROVAL ────────────────
            A Self-sourced lead origin pays 1.5% instead of 0.5%, so it only takes
            effect once a Manager approves it (migration 072). Everyone sees what's
            waiting; only a Manager can Approve (→ 1.5%) or Reject (→ back to Given). */}
        {(()=>{
          const q=(pipeSearch||"").toLowerCase();
          const pend=deals.filter(d=>leadOriginPending(d)&&!isLostStage(d.stage)
              &&(pipeAE==="all"||d.salesOwner===pipeAE)
              &&(!q||[d.client,d.contact,d.ceNo,d.salesOwner,d.product].join(" ").toLowerCase().includes(q)));
          if(!pend.length) return null;
          const decide=async(c,ok)=>{
            const name=c.contact||c.client;
            if(!(await uiConfirm(ok
              ?`Approve Self-sourced for ${name}?\n\nAE: ${c.salesOwner||"—"}\nCommission on this deal moves from 0.5% to 1.5% of collected (VAT-ex).`
              :`Reject the Self-sourced claim on ${name}?\n\nThe deal goes back to "Given" and earns 0.5%.`))) return;
            const now=new Date().toISOString();
            const patch=ok?{leadOriginStatus:"Approved",leadOriginApprovedBy:session?.name||"Manager",leadOriginApprovedAt:now}
                          :{leadOrigin:"Given",leadOriginStatus:"Approved",leadOriginApprovedBy:"",leadOriginApprovedAt:null};
            upDeals(ds=>ds.map(d=>d.id===c.id?{...d,...patch}:d));
            if(isSupabaseReady()) sbUpdate('deals',c.id,ok
              ?{lead_origin_status:"Approved",lead_origin_approved_by:patch.leadOriginApprovedBy,lead_origin_approved_at:now,updated_at:now}
              :{lead_origin:"Given",lead_origin_status:"Approved",lead_origin_approved_by:"",lead_origin_approved_at:null,updated_at:now}).catch(()=>{});
            logActivity(c.id,"Lead Origin",ok?`Self-sourced approved (1.5%)`:`Self-sourced claim rejected — set to Given (0.5%)`,session?.name);
            toastEmit&&toastEmit(ok?`✅ Self-sourced approved — ${name} now earns 1.5%`:`Claim rejected — ${name} stays at 0.5%`,ok?"success":"info",6000);
          };
          return(
            <div style={{background:"#eef2ff",border:"1.5px solid #c7d2fe",borderRadius:12,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontWeight:800,color:"#3730a3",fontSize:".9rem",marginBottom:4}}>🧭 {pend.length} Self-sourced claim{pend.length>1?"s":""} awaiting Manager approval</div>
              <div style={{fontSize:".72rem",color:"#4f46e5",marginBottom:10}}>These deals earn 0.5% until a Manager approves the 1.5% self-sourced rate.</div>
              {pend.map(c=>(
                <div key={c.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",background:"#fff",borderRadius:8,marginBottom:6,border:"1px solid #c7d2fe",flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:120,cursor:"pointer"}} onClick={()=>openEditDeal(c)}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.contact||c.client}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2}}>{c.ceNo&&<span style={{fontWeight:600,color:"#6366f1",marginRight:6}}>{c.ceNo}</span>}AE: {c.salesOwner||"—"}{c.bizDevSource?` · source: ${c.bizDevSource}`:""}</div>
                  </div>
                  {role==="Manager"&&<>
                    <button onClick={()=>decide(c,true)} style={{background:"#059669",border:"none",borderRadius:7,padding:"6px 14px",fontSize:".78rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,flexShrink:0}}>✅ Approve 1.5%</button>
                    <button onClick={()=>decide(c,false)} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"6px 12px",fontSize:".78rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit",fontWeight:700,flexShrink:0}}>Reject</button>
                  </>}
                </div>
              ))}
            </div>
          );
        })()}

        {/* ── ⏳ ADDENDUMS AWAITING CLIENT APPROVAL ──────────────────────────
            Pending addendums usually hang off an already-awarded parent, so they
            otherwise sit as an easy-to-miss sub-row. Surface them here as an
            action list: parent, value, days waiting (red "chase client" past 14
            days), and a one-click Approve. A pending addendum stays out of Total
            Contract, billing, and design until it's approved here. */}
        {(()=>{
          const q=(pipeSearch||"").toLowerCase();
          const STALE=14;
          const pend=deals.filter(d=>d.parentDealId&&d.addendumStatus==="Pending"&&!isLostStage(d.stage)
              &&(pipeAE==="all"||d.salesOwner===pipeAE)
              &&(!q||[d.client,d.contact,d.ceNo,d.salesOwner,d.product].join(" ").toLowerCase().includes(q)))
            .map(d=>({...d,_wait:d.dateAcquired?Math.floor((new Date(today)-new Date(d.dateAcquired))/864e5):0}))
            .sort((a,b)=>b._wait-a._wait);
          if(!pend.length) return null;
          const totalPend=pend.reduce((s,d)=>s+Math.abs(Number(d.value)||0),0);
          const canApprove=role==="Manager"||role==="Sales";
          const money=v=>"₱"+Math.abs(Number(v)||0).toLocaleString("en-PH");
          const approve=async(c)=>{
            const parent=deals.find(d=>d.id===c.parentDealId);
            const pname=parent?.contact||parent?.client||"the project";
            if(!(await uiConfirm(`Approve this addendum?\n\n${c.contact||c.client} — ${money(c.value)}\n\nThis marks it client-approved: it rolls into ${pname}'s Total Contract and unlocks billing & design. Reversible from the deal's edit screen.`))) return;
            const newStage=(parent&&!isLostStage(parent.stage))?parent.stage:c.stage;
            const prob=WON_STAGES.includes(newStage)?100:c.probability;
            upDeals(ds=>ds.map(d=>d.id===c.id?{...d,addendumStatus:"Approved",stage:newStage,probability:prob}:d));
            if(isSupabaseReady()) sbUpdate('deals',c.id,{addendum_status:"Approved",stage:newStage,probability:prob,updated_at:new Date().toISOString()}).catch(()=>{});
            logActivity(c.id,"Addendum approved",`${c.contact||c.client} — addendum approved by client (${money(c.value)}) → rolled into ${pname}`,session?.name);
            toastEmit&&toastEmit(`✅ Addendum approved — ${money(c.value)} now in ${pname}'s contract`,"success",6000);
          };
          return(
            <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"12px 16px",marginBottom:16}}>
              <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:6}}>
                <span style={{fontWeight:800,color:"#92400e",fontSize:".9rem"}}>⏳ {pend.length} addendum{pend.length>1?"s":""} awaiting client approval</span>
                {!BUDGET_ONLY.includes(role)&&<span style={{marginLeft:"auto",fontWeight:800,color:"#d97706",fontSize:".9rem",fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:".02em"}}>{fmt(totalPend)}</span>}
              </div>
              <div style={{fontSize:".72rem",color:"#a16207",marginBottom:10}}>Not yet in Total Contract, billing, or design — approve once the client signs off.</div>
              {pend.map(c=>{
                const parent=deals.find(d=>d.id===c.parentDealId);
                const stale=c._wait>STALE;
                return(
                  <div key={c.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",background:"#fff",borderRadius:8,marginBottom:6,border:`1px solid ${stale?"#fecaca":"#fde68a"}`,flexWrap:"wrap"}}>
                    <div style={{flex:1,minWidth:120,cursor:"pointer"}} onClick={()=>openEditDeal(c)}>
                      <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.contact||c.client}</div>
                      <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                        {c.ceNo&&<span style={{fontWeight:600,color:"#6366f1",marginRight:6}}>{c.ceNo}</span>}↳ {parent?(parent.contact||parent.client):"—"}
                      </div>
                    </div>
                    {!BUDGET_ONLY.includes(role)&&<div style={{fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,fontSize:".8rem",color:"#d97706",whiteSpace:"nowrap"}}>{money(c.value)}</div>}
                    <span title={`Waiting ${c._wait} day${c._wait!==1?"s":""} since acquired`} style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".64rem",fontWeight:700,padding:"2px 8px",borderRadius:20,whiteSpace:"nowrap",background:stale?"#fef2f2":"#f8fafc",color:stale?"#dc2626":"#64748b",border:`1px solid ${stale?"#fecaca":"#e2e8f0"}`}}>{stale?"⚠ ":""}{c._wait}d{stale?" · chase client":""}</span>
                    {canApprove&&<button onClick={()=>approve(c)} style={{background:"#059669",border:"none",borderRadius:7,padding:"6px 14px",fontSize:".78rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,flexShrink:0}}>✅ Approve</button>}
                  </div>
                );
              })}
            </div>
          );
        })()}

        {/* ── SEARCH ALL DEALS — shows hidden matches (won/closed/child) ── */}
        {pipeSearch&&pipeSearch.length>=2&&(()=>{
          const q=pipeSearch.toLowerCase();
          const matches=d=>[d.client,d.contact,d.ceNo,d.salesOwner,d.product].join(" ").toLowerCase().includes(q);
          const visibleInPipe=deals.filter(d=>isActivePipeline(d.stage)&&!d.parentDealId&&matches(d));
          const hidden=deals.filter(d=>matches(d)&&!visibleInPipe.find(v=>v.id===d.id));
          if(!hidden.length) return null;
          const locationOf=d=>{
            if(d.parentDealId){const par=deals.find(x=>x.id===d.parentDealId);return par?`Addendum of ${par.contact||par.client} (${par.ceNo||""})`:"Orphaned addendum";}
            if(d.stage==="12 · Close-Out") return "Closed Out";
            if(d.stage==="Cancelled") return "Cancelled";
            if(d.stage==="Did Not Win") return "Did Not Win";
            if(WON_STAGES.includes(d.stage)) return "Awarded Projects";
            return d.stage||"Unknown";
          };
          return(
            <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:12,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontWeight:700,color:"#059669",fontSize:".85rem",marginBottom:8}}>
                🔍 Also found in other sections ({hidden.length})
              </div>
              {hidden.map(d=>(
                <div key={d.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",background:"#fff",borderRadius:8,marginBottom:6,border:"1px solid #d1fae5",flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{d.contact||d.client||"—"}</div>
                    <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2}}>{d.ceNo&&<span style={{fontWeight:600,color:"#6366f1",marginRight:6}}>{d.ceNo}</span>}{d.client}</div>
                  </div>
                  <span style={{fontSize:".68rem",color:"#059669",background:"#dcfce7",borderRadius:20,padding:"2px 8px",fontWeight:600,whiteSpace:"nowrap"}}>{locationOf(d)}</span>
                  {(role==="Manager"||role==="Sales")&&(
                    <button onClick={()=>openEditDeal(d)} style={{background:"#1e293b",border:"none",borderRadius:7,padding:"6px 14px",fontSize:".78rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700,flexShrink:0}}>✏ Edit</button>
                  )}
                </div>
              ))}
            </div>
          );
        })()}

        {/* Active Pipeline — Hot / Cold split */}
        {(()=>{
          const daysSince=dt=>dt?Math.floor((new Date(today)-new Date(dt))/(864e5)):0;
          const allActive=deals.filter(d=>
            isActivePipeline(d.stage)&&
            (!pipeSearch||[d.client,d.contact,d.ceNo,d.salesOwner,d.product].join(" ").toLowerCase().includes(pipeSearch.toLowerCase()))&&
            (pipeAE==="all"||d.salesOwner===pipeAE)
          ).sort((a,b)=>new Date(b.dateAcquired||0)-new Date(a.dateAcquired||0));
          const childPipeDeals=allActive.filter(d=>d.parentDealId);
          const parentActive=allActive.filter(d=>!d.parentDealId);
          const overdueFollowUps=parentActive.filter(d=>d.followUp&&d.followUp<today).sort((a,b)=>new Date(a.followUp)-new Date(b.followUp));

          // ── Pipeline temperature board (Hot / Almost Awarded / Cold) ──────────
          // Buckets are MANUAL (deal.temperature), dragged between columns. When a
          // deal has no explicit temperature we derive one so the board is never
          // empty (see deriveTemp in core.js). tempOf resolves the effective bucket.
          const tempOf=d=>deriveTemp(d,daysSince(d.dateAcquired));
          const hotDeals   =parentActive.filter(d=>tempOf(d)==="Hot");
          const almostDeals=parentActive.filter(d=>tempOf(d)==="Almost Awarded");
          const coldDeals  =parentActive.filter(d=>tempOf(d)==="Cold");
          const canSetTemp=(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin");
          // Last time the deal was touched: newest of dateAcquired and any activity
          // log entry for it. Used for the stale-Cold review (NOT dateAcquired — an
          // old-but-active deal isn't dead). followUp is a plan, not activity.
          const lastActivityOf=d=>{
            let latest=d.dateAcquired||"";
            for(const e of actLog){ if(e.dealId===d.id && e.date && e.date>latest) latest=e.date; }
            return latest;
          };
          const daysIdle=d=>{const la=lastActivityOf(d);return la?Math.floor((new Date(today)-new Date(la))/(864e5)):0;};
          // setTemp — persist the manual bucket (partial column UPDATE, mirroring the
          // Did Not Win / Cancel pattern so RLS INSERT policies don't clobber it).
          const setTemp=(d,temp)=>{
            if(!canSetTemp||!DEAL_TEMPS.includes(temp)||(tempOf(d)===temp&&d.temperature===temp))return;
            upDeals(ds=>ds.map(x=>x.id===d.id?{...x,temperature:temp}:x));
            if(isSupabaseReady())sbUpdate('deals',d.id,{temperature:temp,updated_at:new Date().toISOString()}).catch(()=>{});
            logActivity(d.id,"Temperature",`${d.contact||d.client} → ${TEMP_META[temp].icon} ${temp}`,session?.name);
            toastEmit(`${TEMP_META[temp].icon} Moved to ${temp}`);
          };
          // Stale-Cold review: Cold parent deals idle ≥ COLD_STALE_DAYS. Surfaced for
          // one-click "Did Not Win" — never auto-written (a slow bid isn't a lost bid).
          const staleCold=coldDeals.filter(d=>daysIdle(d)>=COLD_STALE_DAYS).sort((a,b)=>daysIdle(b)-daysIdle(a));
          const sweepDidNotWin=(d)=>{
            const stamp=new Date().toISOString().slice(0,10);
            upDeals(ds=>ds.map(x=>{if(x.id!==d.id)return x;const notes=(x.notes||"")+`\n[DID NOT WIN ${stamp}]: auto-flagged — Cold ${daysIdle(d)}d with no activity, confirmed by ${session?.name||"Sales"}`;
              if(isSupabaseReady())sbUpdate('deals',x.id,{stage:"Did Not Win",probability:0,notes,updated_at:new Date().toISOString()}).catch(()=>{});
              return{...x,stage:"Did Not Win",probability:0,notes};}));
            logActivity(d.id,"Did Not Win",`${d.client} — stale Cold (${daysIdle(d)}d idle), marked Did Not Win`,session?.name);
            toastEmit("Moved to Did Not Win.");
          };

          // Helpers: hide contract value from Ops/Design/PM — show QS budget instead
          const qsBudgetTotal=id=>{const b=budgets[id]||{};return["Materials","Labor","Overhead","Subcon"].reduce((s,k)=>s+Number(b[k]||0),0);};
          const pipeAmt=d=>{if(BUDGET_ONLY.includes(role)){const t=qsBudgetTotal(d.id);return t>0?fmtK(t)+"📊":"Budget Pending";}return d.value?fmtK(Number(d.value)):"—";};

          // Compact row for Hot/Cold pipeline tables
          const PipeRow=({d,list,i})=>{
            const border=i<list.length-1?"1px solid #f1f5f9":"none";
            if(isMobile) return(
              <div style={{padding:"12px 14px",borderBottom:border,background:"#fff"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",gap:4,alignItems:"center",flexWrap:"wrap",marginBottom:3}}>
                      <span style={{fontWeight:700,color:"#0f172a",fontSize:".88rem"}}>{d.contact||d.client}</span>
                      {vvipClients?.has(d.client)&&<span style={{fontSize:".6rem",color:"#d97706",background:"#fef3c7",borderRadius:20,padding:"1px 5px",fontWeight:700}}>⭐</span>}
                      {!BUDGET_ONLY.includes(role)&&Number(d.value)>=3000000&&<span style={{fontSize:".6rem",color:"#dc2626",background:"#fef2f2",borderRadius:20,padding:"1px 5px",fontWeight:700}}>₱3M+</span>}
                      {d.awardRequestData&&<span style={{fontSize:".6rem",color:"#059669",background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:20,padding:"1px 5px",fontWeight:700}}>🏆 Pending</span>}
                      {!d.standbyPO&&(!Number(d.value)||Number(d.value)===0)&&<span style={{fontSize:".6rem",color:"#7c3aed",background:"#f5f3ff",border:"1px solid #ddd6fe",borderRadius:20,padding:"1px 5px",fontWeight:700}}>⏳ Awaiting QS Price</span>}
                    </div>
                    <div style={{fontSize:".72rem",color:"#64748b",display:"flex",gap:6,flexWrap:"wrap"}}>
                      {d.ceNo&&<span style={{fontWeight:600}}>{d.ceNo}</span>}
                      {d.client&&<span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:160}}>{d.client}</span>}
                    </div>
                    <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:3,display:"flex",gap:6,flexWrap:"wrap"}}>
                      {d.salesOwner&&<span>👤 {d.salesOwner.split(" ")[0]}</span>}
                      <span style={{color:d.followUp&&d.followUp<today?"#ef4444":daysSince(d.dateAcquired)>15?"#f59e0b":"#94a3b8"}}>
                        {d.followUp&&d.followUp<today?"⚠ "+d.followUp:daysSince(d.dateAcquired)+"d ago"}
                      </span>
                    </div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6,flexShrink:0}}>
                    <span style={{fontWeight:700,color:BUDGET_ONLY.includes(role)?"#8b5cf6":"#10b981",fontSize:".9rem"}}>{pipeAmt(d)}</span>
                    <div style={{display:"flex",gap:4,flexWrap:"wrap",justifyContent:"flex-end"}}>
                      {/* Temperature is set via the ⋯ menu (Move to Hot / Almost Awarded / Cold) — the card already sits in its temperature column, so an inline picker was redundant. */}
                      {(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={()=>openEditDeal(d)} style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"11px 13px",fontSize:".8rem",color:"#475569",cursor:"pointer",fontFamily:"inherit",minHeight:36}}>✏</button>}
                      {role==="QS"&&<button onClick={()=>setPriceModal(d)} style={{background:"#7c3aed",border:"none",borderRadius:6,padding:"11px 13px",fontSize:".8rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",minHeight:36}}>₱</button>}
                      {(role==="Manager"||role==="QS"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={()=>{setBoqCoId(null);setBoqStandaloneId(null);setBoqDealId(d.id);setPage("boq");}} style={{background:"#0ea5e9",border:"none",borderRadius:6,padding:"11px 13px",fontSize:".8rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",minHeight:36}} title="Open BOQ Builder">🧮</button>}
                      {(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")?<button onClick={()=>openAward(d)} style={{background:"#059669",border:"none",borderRadius:6,padding:"11px 13px",fontSize:".8rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",minHeight:36}}>🏆</button>:<button onClick={()=>setAwardReqModal(d)} style={{background:"#f59e0b",border:"none",borderRadius:6,padding:"11px 13px",fontSize:".8rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",minHeight:36}}>🏆</button>}
                      {(canDeleteDeal||role==="Manager"||role==="Sales")&&<button onClick={e=>{e.stopPropagation();const r=e.currentTarget.getBoundingClientRect();setRowMenu(rowMenu&&rowMenu.deal.id===d.id?null:{deal:d,top:r.bottom+4,right:Math.max(8,window.innerWidth-r.right)});}} style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:6,padding:"11px 13px",fontSize:".8rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit",minHeight:36,fontWeight:700}} title="More actions">⋯</button>}
                    </div>
                  </div>
                </div>
              </div>
            );
            return(
            <div
              style={{display:"flex",gap:8,padding:"7px 12px",borderBottom:i<list.length-1?"1px solid #f1f5f9":"none",alignItems:"center",background:"#fff",transition:"background .1s"}}
              onMouseEnter={e=>{e.currentTarget.style.background="#f8fafc";}}
              onMouseLeave={e=>{e.currentTarget.style.background="#fff";}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",gap:4,alignItems:"center",flexWrap:"wrap"}}>
                  <span style={{fontWeight:700,color:"#0f172a",fontSize:".8rem"}}>{d.contact||d.client}</span>
                  {vvipClients?.has(d.client)&&<span style={{fontSize:".58rem",color:"#d97706",background:"#fef3c7",borderRadius:20,padding:"1px 5px",fontWeight:700,flexShrink:0}}>⭐</span>}
                  {!BUDGET_ONLY.includes(role)&&Number(d.value)>=3000000&&<span style={{fontSize:".58rem",color:"#dc2626",background:"#fef2f2",borderRadius:20,padding:"1px 5px",fontWeight:700,flexShrink:0}}>₱3M+</span>}
                  {d.awardRequestData&&<span style={{fontSize:".58rem",color:"#059669",background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:20,padding:"1px 5px",fontWeight:700,flexShrink:0}}>🏆 Pending</span>}
                  {!d.standbyPO&&(!Number(d.value)||Number(d.value)===0)&&<span style={{fontSize:".58rem",color:"#7c3aed",background:"#f5f3ff",border:"1px solid #ddd6fe",borderRadius:20,padding:"1px 5px",fontWeight:700,flexShrink:0}}>⏳ Awaiting QS Price</span>}
                </div>
                <div style={{fontSize:".67rem",color:"#94a3b8",marginTop:1,display:"flex",gap:8,flexWrap:"wrap"}}>
                  {d.ceNo&&<span style={{color:"#475569",fontWeight:600}}>{d.ceNo}</span>}
                  {d.client&&<span style={{color:"#475569"}}>🏢 {d.client}</span>}
                  {d.salesOwner&&<span>👤 {d.salesOwner.split(" ")[0]}</span>}
                  {d.addedBy&&d.addedBy!==d.salesOwner&&<span style={{color:"#6366f1",background:"#eef2ff",borderRadius:4,padding:"0 4px",fontSize:".6rem",fontWeight:700}} title={`Added by ${d.addedBy}`}>+{d.addedBy.split(" ")[0]}</span>}
                  <span style={{color:d.followUp&&d.followUp<today?"#ef4444":daysSince(d.dateAcquired)>15?"#f59e0b":"#94a3b8"}}>
                    {d.followUp&&d.followUp<today?"⚠ "+d.followUp:daysSince(d.dateAcquired)+"d ago"}
                  </span>
                </div>
              </div>
              <div style={{fontWeight:700,color:BUDGET_ONLY.includes(role)?"#8b5cf6":"#10b981",fontSize:".8rem",flexShrink:0,minWidth:44,textAlign:"right"}}>{pipeAmt(d)}</div>
              <div style={{display:"flex",gap:3,flexShrink:0,alignItems:"center"}}>
                {/* Temperature is set via the ⋯ menu (Move to Hot / Almost Awarded / Cold) — the row already sits in its temperature column, so an inline picker was redundant. */}
                {(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={()=>openEditDeal(d)} style={{background:"#f1f5f9",border:"none",borderRadius:5,padding:"4px 7px",fontSize:".68rem",color:"#475569",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}} title="Edit">✏</button>}
                {role==="QS"&&!d.value&&<button onClick={()=>setPriceModal(d)} style={{background:"#7c3aed",border:"none",borderRadius:5,padding:"4px 7px",fontSize:".68rem",color:"#fff",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}} title="Set Client Price">₱</button>}
                {role==="QS"&&d.value&&<button onClick={()=>setPriceModal(d)} style={{background:"#ede9fe",border:"1px solid #c4b5fd",borderRadius:5,padding:"4px 7px",fontSize:".68rem",color:"#7c3aed",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}} title="Update Client Price">₱✏</button>}
                {(role==="Manager"||role==="QS"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={()=>{setBoqCoId(null);setBoqStandaloneId(null);setBoqDealId(d.id);setPage("boq");}} style={{background:"#0ea5e9",border:"none",borderRadius:5,padding:"4px 9px",fontSize:".68rem",color:"#fff",cursor:"pointer",fontWeight:700,fontFamily:"inherit",whiteSpace:"nowrap"}} title="Open BOQ Builder for this deal">🧮 BOQ</button>}
                {(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")
                  ?<button onClick={()=>openAward(d)} style={{background:"#059669",border:"none",borderRadius:5,padding:"4px 7px",fontSize:".68rem",color:"#fff",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}} title="Award Project">🏆</button>
                  :<button onClick={()=>setAwardReqModal(d)} style={{background:"#f59e0b",border:"none",borderRadius:5,padding:"4px 7px",fontSize:".68rem",color:"#fff",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}} title="Request Award">🏆</button>
                }
                {(canDeleteDeal||role==="Manager"||role==="Sales")&&<button onClick={e=>{e.stopPropagation();const r=e.currentTarget.getBoundingClientRect();setRowMenu(rowMenu&&rowMenu.deal.id===d.id?null:{deal:d,top:r.bottom+4,right:Math.max(8,window.innerWidth-r.right)});}} style={{background:rowMenu&&rowMenu.deal.id===d.id?"#e2e8f0":"#f8fafc",border:"1px solid #e2e8f0",borderRadius:5,padding:"4px 7px",fontSize:".68rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit",fontWeight:700}} title="More actions">⋯</button>}
              </div>
            </div>
            );
          };

          const PipeTableHeader=()=>isMobile?null:(
            <div style={{display:"flex",padding:"6px 12px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",fontSize:".62rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".4px"}}>
              <span style={{flex:1}}>Client / CE</span>
              <span style={{width:44,textAlign:"right"}}>Value</span>
              <span style={{width:90,textAlign:"right"}}>Actions</span>
            </div>
          );

          return(
            <div>
              {/* ⚠ Overdue follow-ups */}
              {overdueFollowUps.length>0&&(
                <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,padding:"11px 16px",marginBottom:14}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                    <span style={{fontWeight:700,color:"#b91c1c",fontSize:".85rem"}}>⚠️ {overdueFollowUps.length} follow-up{overdueFollowUps.length>1?"s":""} overdue</span>
                    <span style={{fontSize:".72rem",color:"#dc2626",opacity:.8}}>— reach out before these deals go cold</span>
                  </div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>
                    {overdueFollowUps.slice(0,6).map(d=>(
                      <button key={d.id} onClick={()=>openEditDeal(d)} title={`Follow-up due ${d.followUp}`} style={{display:"flex",alignItems:"center",gap:6,background:"#fff",border:"1px solid #fecaca",borderRadius:20,padding:"3px 10px",cursor:"pointer",fontFamily:"inherit"}}>
                        <span style={{fontSize:".75rem",fontWeight:700,color:"#0f172a"}}>{d.contact||d.client}</span>
                        <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:700,color:"#dc2626"}}>{d.followUp}</span>
                      </button>
                    ))}
                    {overdueFollowUps.length>6&&<span style={{fontSize:".72rem",color:"#dc2626",alignSelf:"center",fontWeight:600}}>+{overdueFollowUps.length-6} more</span>}
                  </div>
                </div>
              )}

              {/* ⚠ Stale-Cold review — Cold deals idle ≥45 days, one-click Did Not Win.
                  Never auto-written: a slow bid isn't a lost bid, so a human confirms. */}
              {canSetTemp&&!coldSweepDismissed&&staleCold.length>0&&(
                <div style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:12,padding:"12px 16px",marginBottom:14}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                    <div style={{minWidth:0}}>
                      <div style={{fontWeight:700,color:"#1d4ed8",fontSize:".85rem"}}>🧊 {staleCold.length} cold deal{staleCold.length>1?"s":""} look dead — mark Did Not Win?</div>
                      <div style={{fontSize:".73rem",color:"#2563eb",opacity:.85,marginTop:3}}>No activity for {COLD_STALE_DAYS}+ days. Confirm each individually — nothing changes until you click ✗.</div>
                    </div>
                    <button onClick={()=>setColdSweepDismissed(true)} style={{background:"transparent",border:"none",color:"#3b82f6",cursor:"pointer",fontSize:".76rem",fontWeight:700,flexShrink:0}}>Dismiss</button>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:10}}>
                    {staleCold.slice(0,8).map(d=>(
                      <div key={d.id} style={{display:"flex",alignItems:"center",gap:10,background:"#fff",border:"1px solid #dbeafe",borderRadius:8,padding:"7px 11px",flexWrap:"wrap"}}>
                        <div style={{flex:1,minWidth:0}}>
                          <span style={{fontWeight:700,color:"#0f172a",fontSize:".8rem"}}>{d.contact||d.client}</span>
                          {d.ceNo&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:600,color:"#6366f1",marginLeft:6}}>{d.ceNo}</span>}
                          <span style={{fontSize:".68rem",color:"#94a3b8",marginLeft:6}}>· {daysIdle(d)}d idle · {d.salesOwner?.split(" ")[0]||"—"}</span>
                        </div>
                        <button onClick={()=>openEditDeal(d)} style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"5px 10px",fontSize:".72rem",color:"#475569",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>Keep · Edit</button>
                        <button onClick={async()=>{if(await uiConfirm(`Mark "${d.contact||d.client}" as Did Not Win?\n\nCold for ${daysIdle(d)} days with no activity. This removes it from the active pipeline and its commission projection. Reversible from the deal's edit screen.`))sweepDidNotWin(d);}} style={{background:"#64748b",border:"none",borderRadius:6,padding:"5px 10px",fontSize:".72rem",color:"#fff",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✗ Did Not Win</button>
                      </div>
                    ))}
                    {staleCold.length>8&&<div style={{fontSize:".7rem",color:"#2563eb",opacity:.7}}>+{staleCold.length-8} more</div>}
                  </div>
                </div>
              )}

              {/* 🔥 Hot · 🏆 Almost Awarded · 🧊 Cold — set each deal's temperature with
                  the per-row picker. Buckets are manual (deal.temperature); unset deals
                  fall back to an age/stage-derived default. Three columns on desktop,
                  stacked on mobile. */}
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:14,marginBottom:20}}>
                {[["Hot",hotDeals],["Almost Awarded",almostDeals],["Cold",coldDeals]].map(([temp,list])=>{
                  const m=TEMP_META[temp];
                  // Column total = contract value of the parent deals in this column
                  // plus their nested children (addenda/linked deals carry value too).
                  // Hidden for BUDGET_ONLY roles (Design/Ops/PM) so contract value never leaks.
                  const colTotal=list.reduce((s,d)=>s+Number(d.value||0)+childPipeDeals.filter(c=>c.parentDealId===d.id).reduce((cs,c)=>cs+Number(c.value||0),0),0);
                  return(
                  <div key={temp}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".84rem",marginBottom:7,display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                      {m.icon} {temp}
                      <span style={{fontWeight:400,color:"#94a3b8",fontSize:".72rem"}}>({list.length})</span>
                      {!BUDGET_ONLY.includes(role)&&<span style={{marginLeft:"auto",fontWeight:800,color:m.clr,fontSize:".82rem",fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:".02em"}}>{fmt(colTotal)}</span>}
                    </div>
                    <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",transition:"background .1s,border-color .1s",opacity:list.length?1:.6}}>
                      <PipeTableHeader/>
                      <div style={{maxHeight:340,overflowY:"auto"}}>
                        {list.length===0&&<div style={{padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".78rem"}}>{pipeSearch?"No match.":`No deals. ${m.blurb}.`}</div>}
                        {list.map((d,i)=>{
                          const children=childPipeDeals.filter(c=>c.parentDealId===d.id);
                          return(<React.Fragment key={d.id}><PipeRow d={d} list={list} i={i}/>{children.map(c=><div key={c.id} style={{paddingLeft:24,borderLeft:"3px solid #f59e0b",marginLeft:12,background:"#fffbeb"}}><PipeRow d={c} list={children} i={0}/></div>)}</React.Fragment>);
                        })}
                      </div>
                    </div>
                  </div>
                  );
                })}
              </div>

              {/* Awarded Projects — active only (stages 06–11) */}
              {(()=>{
                const matchSearch=d=>!pipeSearch||[d.client,d.contact,d.ceNo,d.salesOwner,d.product].join(" ").toLowerCase().includes(pipeSearch.toLowerCase());
                // Project cards are the parent deals (no parentDealId); bucket them by their own stage.
                // Respect the AE chip filter (pipeAE) like the Hot/Cold pipeline does — addenda
                // still nest under their parent below, so they follow the parent's AE automatically.
                const wonParents=wonDeals.filter(d=>!d.parentDealId&&(pipeAE==="all"||d.salesOwner===pipeAE)&&(pipeType==="all"||(d.ceType||"Other")===pipeType)&&(!pipeNoAward||!pcards[d.id]?.awardDate));
                const activeWonBase=wonParents.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed"&&matchSearch(d));
                const doneWonBase  =wonParents.filter(d=>(d.stage==="12 · Close-Out"||d.stage==="14 · Completed")&&matchSearch(d));
                // Addenda nest under their parent's card, following the PARENT's bucket
                // regardless of the addendum's own WON stage. (Otherwise a won-stage addendum
                // whose parent is closed-out lands in the other bucket and disappears from both.)
                // Retired addenda (Did Not Win / Cancelled) are excluded here — they belong in
                // their own sections below, and were previously leaking back into the awarded
                // table so a linked deal "stayed" in the pipeline after being marked Did Not Win.
                const activeIds=new Set(activeWonBase.map(d=>d.id));
                const doneIds  =new Set(doneWonBase.map(d=>d.id));
                const addenda=deals.filter(d=>d.parentDealId&&!isLostStage(d.stage)&&(activeIds.has(d.parentDealId)||doneIds.has(d.parentDealId)));
                const activeWon=[...activeWonBase,...addenda.filter(d=>activeIds.has(d.parentDealId))];
                const doneWon  =[...doneWonBase, ...addenda.filter(d=>doneIds.has(d.parentDealId))];
                const STAGE_CLR_PIPE={"06 · Kickoff":"#8b5cf6","07 · Briefing":"#6366f1","08 · Fabrication":"#f59e0b","09 · Site & Billing":"#f97316","10 · Installation":"#3b82f6","11 · Punchlist":"#ef4444","12 · Close-Out":"#059669","14 · Completed":"#059669"};
                // Type chip colors — mirrors the CE_TYPES so each awarded deal carries its
                // project type inline (not just via its group header).
                const TYPE_CLR_PIPE={"Fabrication / General":"#0891b2","Construction":"#b45309","Retail Fit-Out":"#7c3aed","Kiosk":"#0d9488","Signage":"#db2777","Event / Activation":"#e11d48","Repair / Refurbishment":"#4f46e5","Other":"#64748b"};
                const AwardRow=({d,isChild=false})=>{
                  const jo=dealJo(jos,d.id);
                  const pc=pcards[d.id];
                  // Award date is editable inline (Manager/Sales/SalesOpsAdmin) so a
                  // mis-dated award can be corrected without a DB touch — it drives the
                  // month each deal lands in on the Awarded / Sales Value report
                  // (awardedMonth above). Sub-project (child) rows are editable too: an
                  // umbrella's standby-PO parent earns ₱0, so it is the sub-projects that
                  // carry sales value and must be datable into the correct month.
                  const canEditAward=(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin");
                  const setCardAwardDate=(date)=>{
                    if(!date) return;
                    upPcards(ps=>({...ps,[d.id]:{...(ps[d.id]||emptyProjectCard(d.id,d)),awardDate:date}}));
                    if(isSupabaseReady()) syncProjectCard(d.id,{award_date:date});
                    logActivity(d.id,"Award date set",`${d.contact||d.client} — award date set to ${date} by ${session?.name}`,session?.name);
                    toastEmit("Award date updated.");
                  };
                  const paid=dealCollected(d);
                  const inv=Number(d.invoiced)||0;
                  // Standby PO / Adhoc umbrella: the parent carries no contract
                  // revenue of its own (held at 0). Instead it shows a drawdown of
                  // its PO ceiling — used = Σ of its active child jobs, remaining
                  // counts down toward 0 as jobs are charged against the fund.
                  const isStandby=!isChild&&!!d.standbyPO;
                  const poBudget=Number(d.poBudget)||0;
                  const drawUsed=isStandby?deals.filter(c=>c.parentDealId===d.id&&!isLostStage(c.stage)).reduce((s,c)=>s+(Number(c.value)||0),0):0;
                  const drawLeft=Math.max(0,poBudget-drawUsed);
                  const drawPct=poBudget>0?Math.min(100,Math.round(drawUsed/poBudget*100)):0;
                  const contractVal=isStandby?0:Number(d.value)||0;
                  const outstanding=Math.max(0,contractVal-paid);
                  const pctPaid=contractVal>0?Math.min(100,Math.round(paid/contractVal*100)):0;
                  const sc=STAGE_CLR_PIPE[d.stage]||"#94a3b8";
                  const stageLabel=d.stage?.replace(/^\d+ · /,"")||"—";
                  const dLeftP=pc?.targetEndDate?Math.ceil((new Date(pc.targetEndDate)-new Date())/86400000):null;
                  const isOverP=dLeftP!==null&&dLeftP<0;
                  // Addendum (child) rows render in a compact style so the parent deal
                  // reads as the primary row and its addenda sit visually beneath it.
                  // Project card to open: an addendum rolls into its parent's card, but a
                  // Standby PO job IS the card (the umbrella itself is hidden in Projects).
                  const cardDealId=isChild&&d.parentDealId&&!deals.find(x=>x.id===d.parentDealId)?.standbyPO?d.parentDealId:d.id;
                  const cp=isChild?"2px 14px":"5px 14px";        // cell padding (compact)
                  const cpA=isChild?"2px 10px":"5px 10px";       // action-cell padding (compact)
                  const nameFs=isChild?".66rem":".82rem";        // project/client name
                  const moneyFs=isChild?".64rem":".78rem";       // contract
                  const moneyFs2=isChild?".62rem":".75rem";      // collected / outstanding
                  const metaFs=isChild?".64rem":".78rem";        // AE / PM
                  // Addendum rows carry a persistent amber tint (not just on hover) so
                  // they're immediately recognizable as addendums of the row above.
                  const childBg="#fef3c7";                       // amber-100
                  const childBgHover="#fde68a";                  // amber-200
                  return(
                    <tr style={{borderBottom:"1px solid #e2e8f0",cursor:"pointer",background:isChild?childBg:""}}
                      onClick={()=>{setJumpDeal(cardDealId);setPage("projects");}}
                      onMouseEnter={e=>e.currentTarget.style.background=isChild?childBgHover:"#f8fafc"}
                      onMouseLeave={e=>e.currentTarget.style.background=isChild?childBg:""}>
                      <td style={{width:4,padding:0,background:isChild?"#f59e0b":sc}}></td>
                      <td style={{padding:cp,verticalAlign:"middle",paddingLeft:isChild?16:14}}>
                        <div style={{fontWeight:isChild?600:700,fontSize:nameFs,color:isChild?"#374151":"#0d1117",lineHeight:1.3,overflowWrap:"break-word"}}>
                          {isChild&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".52rem",fontWeight:700,color:"#f59e0b",letterSpacing:".5px",marginRight:5,whiteSpace:"nowrap"}}>↳ ADDENDUM</span>}
                          {d.contact||d.client}
                        </div>
                        <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:isChild?2:4}}>
                          {!isChild&&(()=>{const t=d.ceType||"Other";const tc=TYPE_CLR_PIPE[t]||"#64748b";return(<span style={{fontSize:".56rem",fontWeight:700,letterSpacing:".02em",padding:"1px 6px",borderRadius:3,background:tc+"18",color:tc,border:`1px solid ${tc}55`}}>{t}</span>);})()}
                          {isStandby&&<span title="Standby PO — umbrella fund drawn down by its jobs" style={{fontSize:".56rem",fontWeight:700,letterSpacing:".02em",padding:"1px 6px",borderRadius:3,background:"#dbeafe",color:"#1d4ed8",border:"1px solid #93c5fd"}}>💳 STANDBY PO</span>}
                          {d.ceNo&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"1px 5px",borderRadius:3,background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe"}}>{d.ceNo}</span>}
                          {jo?.joNo&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"1px 5px",borderRadius:3,background:"#f0fdf4",color:"#166534",border:"1px solid #bbf7d0"}}>{jo.joNo}</span>}
                        </div>
                      </td>
                      <td style={{padding:cp,verticalAlign:"middle",whiteSpace:"nowrap"}}>
                        {isChild&&d.addendumStatus!=="Approved"?(
                          // Pending addendum: show approval status, not the raw
                          // workflow stage — it's awaiting client sign-off and is
                          // not yet in the project's Total Contract.
                          <span title="Awaiting client approval — not yet in Total Contract" style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:700,letterSpacing:".05em",textTransform:"uppercase",padding:"3px 8px",borderRadius:4,background:"#fffbeb",color:"#d97706",border:"1px solid #fde68a"}}>⏳ Pending</span>
                        ):isChild?(
                          <span title="Client-approved addendum — follows the parent project's stage" style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:700,letterSpacing:".05em",textTransform:"uppercase",padding:"3px 8px",borderRadius:4,background:"#ecfdf5",color:"#059669",border:"1px solid #a7f3d0"}}>✅ {stageLabel}</span>
                        ):(
                          <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:600,letterSpacing:".05em",textTransform:"uppercase",padding:"3px 8px",borderRadius:4,background:sc+"18",color:sc,border:`1px solid ${sc}44`}}>{stageLabel}</span>
                        )}
                      </td>
                      <td style={{padding:cp,fontSize:metaFs,fontWeight:500,color:"#0d1117",verticalAlign:"middle",whiteSpace:"nowrap"}}>{pc?.aeAssigned||jo?.aeAssigned||d.salesOwner||<span style={{color:"#cbd5e1"}}>—</span>}</td>
                      <td style={{padding:cp,fontSize:metaFs,fontWeight:500,color:"#0d1117",verticalAlign:"middle",whiteSpace:"nowrap"}}>{pc?.pm1||jo?.pm1||<span style={{color:"#cbd5e1"}}>—</span>}</td>
                      <td style={{padding:cp,verticalAlign:"middle",textAlign:"right",whiteSpace:"nowrap"}}>
                        {isStandby?(
                          <div style={{minWidth:120}}>
                            <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:moneyFs,fontWeight:700,color:drawLeft===0?"#64748b":"#2563eb"}} title={`Standby PO drawdown — ₱${drawUsed.toLocaleString("en-PH")} used of ₱${poBudget.toLocaleString("en-PH")}`}>₱{drawLeft.toLocaleString("en-PH")} <span style={{fontSize:".82em",fontWeight:600,color:"#94a3b8"}}>left</span></div>
                            <div style={{height:4,borderRadius:3,background:"#e2e8f0",marginTop:3,overflow:"hidden"}}><div style={{width:`${drawPct}%`,height:"100%",background:drawPct>=100?"#059669":"#3b82f6"}}/></div>
                            <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".54rem",fontWeight:700,color:"#94a3b8",marginTop:2}}>💳 PO ₱{poBudget.toLocaleString("en-PH")} · {drawPct}% used</div>
                          </div>
                        ):(
                          <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:moneyFs,fontWeight:700,color:"#10b981"}}>₱{contractVal.toLocaleString("en-PH")}</div>
                        )}
                      </td>
                      <td style={{padding:cp,verticalAlign:"middle",textAlign:"right",whiteSpace:"nowrap"}}>
                        <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:moneyFs2,fontWeight:700,color:pctPaid===100?"#059669":"#0d1117"}}>₱{paid.toLocaleString("en-PH")}</div>
                        {inv>0&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:700,padding:"1px 5px",borderRadius:3,marginTop:2,display:"inline-block",
                          color:pctPaid===100?"#065f46":pctPaid>50?"#1d4ed8":"#92400e",
                          background:pctPaid===100?"#ecfdf5":pctPaid>50?"#eff6ff":"#fffbeb",
                          border:`1px solid ${pctPaid===100?"#a7f3d0":pctPaid>50?"#bfdbfe":"#fde68a"}`}}>{pctPaid}%</span>}
                      </td>
                      <td style={{padding:cp,verticalAlign:"middle",textAlign:"right",whiteSpace:"nowrap"}}>
                        <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:moneyFs2,fontWeight:700,color:outstanding>0?"#ef4444":"#94a3b8"}}>
                          {outstanding>0?`₱${outstanding.toLocaleString("en-PH")}`:"—"}
                        </div>
                      </td>
                      <td style={{padding:cp,verticalAlign:"middle",whiteSpace:"nowrap"}} onClick={e=>e.stopPropagation()}>
                        {isStandby?(
                          <span title="Standby-PO umbrella earns ₱0 itself — set award dates on its sub-projects below, not here" style={{color:"#94a3b8",fontSize:".64rem",fontStyle:"italic"}}>on sub-projects ↓</span>
                        ):canEditAward?(
                          <input type="date" value={pc?.awardDate||""} max={new Date().toISOString().slice(0,10)}
                            onClick={e=>e.stopPropagation()}
                            onChange={e=>setCardAwardDate(e.target.value)}
                            title="Award date — sets the month this deal counts toward on the Sales Value report"
                            style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".66rem",fontWeight:700,color:pc?.awardDate?"#6366f1":"#94a3b8",border:"1px solid #e2e8f0",borderRadius:5,padding:"2px 5px",background:"#fff",cursor:"pointer",fontVariantNumeric:"tabular-nums"}}/>
                        ):(
                          pc?.awardDate
                            ?<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".68rem",fontWeight:700,color:"#6366f1"}}>{pc.awardDate}</span>
                            :<span style={{color:"#cbd5e1",fontSize:".72rem"}}>—</span>
                        )}
                      </td>
                      <td style={{padding:cp,verticalAlign:"middle",whiteSpace:"nowrap"}}>
                        {pc?.targetEndDate?(
                          <>
                            <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".68rem",fontWeight:700,color:isOverP?"#dc2626":dLeftP!==null&&dLeftP<=7?"#d97706":"#059669"}}>{pc.targetEndDate}</div>
                            {dLeftP!==null&&<span style={{display:"inline-block",marginTop:2,fontFamily:"'IBM Plex Mono',monospace",fontSize:".54rem",fontWeight:700,padding:"1px 5px",borderRadius:3,
                              color:isOverP?"#991b1b":dLeftP<=7?"#92400e":"#065f46",
                              background:isOverP?"#fef2f2":dLeftP<=7?"#fffbeb":"#ecfdf5",
                              border:`1px solid ${isOverP?"#fecaca":dLeftP<=7?"#fde68a":"#a7f3d0"}`}}>
                              {isOverP?`⚠ ${Math.abs(dLeftP)}d over`:`${dLeftP}d left`}
                            </span>}
                          </>
                        ):<span style={{color:"#cbd5e1",fontSize:".72rem"}}>—</span>}
                      </td>
                      <td style={{padding:cpA,verticalAlign:"middle",display:"flex",gap:4,alignItems:"center"}}>
                        <button onClick={e=>{e.stopPropagation();openEditDeal(d);}} style={{background:"#f1f5f9",border:"none",borderRadius:5,padding:"3px 8px",fontSize:".65rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏</button>
                        {(role==="Manager"||role==="QS"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={e=>{e.stopPropagation();setBoqCoId(null);setBoqStandaloneId(null);setBoqDealId(d.id);setPage("boq");}} title={isChild?"Open BOQ Builder for this addendum":"Open BOQ Builder for this project"} style={{background:"#0ea5e9",border:"none",borderRadius:5,padding:"3px 8px",fontSize:".65rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>🧮</button>}
                        <button onClick={e=>{e.stopPropagation();setJumpDeal(cardDealId);setPage("projects");}} title={cardDealId!==d.id?"Open the parent project card":"Open Project Card"} style={{background:"#eff6ff",border:"none",borderRadius:5,padding:"3px 8px",fontSize:".65rem",color:"#2563eb",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>📋</button>
                        {/* Row menu (Cancel Project / Delete Deal). Awarded deals never
                            render as PipeRow, so without this the menu was unreachable
                            for every awarded project. */}
                        {(canDeleteDeal||role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={e=>{e.stopPropagation();const r=e.currentTarget.getBoundingClientRect();setRowMenu(rowMenu&&rowMenu.deal.id===d.id?null:{deal:d,top:r.bottom+4,right:Math.max(8,window.innerWidth-r.right)});}} title="More actions" style={{background:rowMenu&&rowMenu.deal.id===d.id?"#e2e8f0":"#f8fafc",border:"1px solid #e2e8f0",borderRadius:5,padding:"2px 7px",fontSize:".65rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>⋯</button>}
                      </td>
                    </tr>
                  );
                };
                // Flat awarded-projects table (no per-type grouping). Parents render as
                // primary rows with their addenda nested directly beneath. Filtering by
                // project type is handled by the chip row above via `pipeType`.
                const AwardTable=({deals:list})=>{
                  const allChildren=list.filter(d=>d.parentDealId);
                  // Grouped by client (A→Z, normalized via shared clientKey so
                  // "COLLECTICONS INC" and "COLLECTICONS INC." group as one) so a
                  // client's projects sit together, then
                  // by value within each client. Type filtering still handled by the chips.
                  const parentList=list.filter(d=>!d.parentDealId)
                    .sort((a,b)=>clientKey(a.client).localeCompare(clientKey(b.client))||Number(b.value||0)-Number(a.value||0));
                  return(
                    <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                      <div style={{overflowX:"auto"}}>
                        <table style={{width:"100%",borderCollapse:"collapse",minWidth:920}}>
                          <thead>
                            <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                              <th style={{width:4,padding:0}}></th>
                              {["Project / Client","Stage","AE","PM","Contract","Collected","Outstanding","Awarded","Turnover",""].map(h=>(
                                <th key={h} style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".09em",color:"#94a3b8",padding:"9px 14px",textAlign:["Contract","Collected","Outstanding"].includes(h)?"right":"left",whiteSpace:"nowrap"}}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {parentList.map((d,i)=>{
                              const children=allChildren.filter(c=>c.parentDealId===d.id);
                              const newClient=i===0||clientKey(d.client)!==clientKey(parentList[i-1].client);
                              return(
                                <React.Fragment key={d.id}>
                                  {newClient&&(
                                    <tr>
                                      <td colSpan={11} style={{padding:"5px 14px",background:"#f1f5f9",borderTop:i===0?"none":"2px solid #e2e8f0",borderBottom:"1px solid #e2e8f0",fontFamily:"'IBM Plex Mono',monospace",fontSize:".6rem",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",color:"#475569"}}>{d.client||"—"}</td>
                                    </tr>
                                  )}
                                  <AwardRow d={d}/>
                                  {children.map(c=><AwardRow key={c.id} d={c} isChild={true}/>)}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                };
                // Type filter chips — counts come from the type-UNFILTERED won set (still
                // respecting the AE chip + search) so selecting one type never hides the
                // others. Each count reflects awarded parent projects of that type.
                const typeCounts={};
                wonDeals.filter(d=>!d.parentDealId&&(pipeAE==="all"||d.salesOwner===pipeAE)&&matchSearch(d))
                  .forEach(d=>{const t=d.ceType||"Other";typeCounts[t]=(typeCounts[t]||0)+1;});
                const typeList=Object.keys(typeCounts).sort();
                // Standby PO umbrellas contribute 0 (their value lives on the
                // drawdown jobs) so the total reflects charged work, never the PO
                // ceiling stacked on top of the jobs drawn against it.
                // A pending addendum still shows as a context row under its parent
                // (with a ⏳ chip) but is NOT awarded money yet, so its value is
                // excluded from the awarded grand total until the client approves.
                const grandTotal=activeWon.reduce((s,d)=>s+(((d.standbyPO&&!d.parentDealId)||(d.parentDealId&&d.addendumStatus==="Pending"))?0:Number(d.value||0)),0);
                return(<>
                  {/* Active Awarded — flat table with a project-type filter */}
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".84rem",marginBottom:10,display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                    🏆 Awarded Projects
                    <span style={{fontWeight:400,color:"#94a3b8",fontSize:".72rem"}}>({activeWon.filter(d=>!d.parentDealId).length} active)</span>
                    {(()=>{
                      // Count of active won parents still missing an award date — these are the
                      // deals excluded from the awarded/sales-value reports until dated. The chip
                      // toggles the awarded list down to exactly those, so they can be found and fixed.
                      const missing=wonDeals.filter(d=>!d.parentDealId&&(pipeAE==="all"||d.salesOwner===pipeAE)&&d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed"&&!pcards[d.id]?.awardDate).length;
                      if(!missing&&!pipeNoAward) return null;
                      return(
                        <button onClick={()=>setPipeNoAward(v=>!v)}
                          title="Show only awarded projects that have no award date set"
                          style={{padding:"3px 10px",borderRadius:20,border:`1.5px solid ${pipeNoAward?"#b45309":"#fbbf24"}`,background:pipeNoAward?"#b45309":"#fffbeb",color:pipeNoAward?"#fff":"#b45309",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                          ⚠️ No award date ({missing}){pipeNoAward?" ✕":""}
                        </button>
                      );
                    })()}
                    {grandTotal>0&&<span style={{marginLeft:"auto",fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,color:"#10b981",fontSize:".82rem"}}>₱{grandTotal.toLocaleString("en-PH")}</span>}
                  </div>
                  {typeList.length>1&&(
                    <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12,alignItems:"center"}}>
                      <span style={{fontSize:".7rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginRight:2}}>Type:</span>
                      {["all",...typeList].map(t=>{
                        const on=pipeType===t;
                        const tc=t==="all"?"#0f172a":(TYPE_CLR_PIPE[t]||"#64748b");
                        const cnt=t==="all"?Object.values(typeCounts).reduce((s,n)=>s+n,0):typeCounts[t];
                        return(
                          <button key={t} onClick={()=>setPipeType(t)}
                            style={{padding:"4px 11px",borderRadius:20,border:`1.5px solid ${on?tc:"#e2e8f0"}`,background:on?tc:"#fff",color:on?"#fff":"#64748b",fontFamily:"inherit",fontWeight:on?700:400,fontSize:".75rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                            {t==="all"?"All":t} <span style={{opacity:.7,fontWeight:600}}>({cnt})</span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                  {activeWon.length===0&&<div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"16px",textAlign:"center",color:"#94a3b8",fontSize:".78rem",marginBottom:16}}>{pipeType==="all"?"No active projects right now.":`No active ${pipeType} projects.`}</div>}
                  {activeWon.length>0&&<div style={{marginBottom:16}}><AwardTable deals={activeWon}/></div>}

                  {/* Closed Out / Done (12–13) */}
                  {doneWon.length>0&&(
                    <div style={{marginBottom:16}}>
                      <button onClick={()=>setDoneExpanded(p=>!p)} style={{width:"100%",display:"flex",alignItems:"center",gap:8,background:doneExpanded?"#059669":"#f0fdf4",border:`1.5px solid ${doneExpanded?"#059669":"#6ee7b7"}`,borderRadius:doneExpanded?"10px 10px 0 0":"10px",padding:"10px 14px",cursor:"pointer",fontFamily:"inherit",textAlign:"left",transition:"all .15s"}}>
                        <span style={{fontWeight:800,color:doneExpanded?"#fff":"#059669",fontSize:".85rem"}}>✅ Closed Out / Done</span>
                        <span style={{background:doneExpanded?"rgba(255,255,255,.2)":"#d1fae5",color:doneExpanded?"#fff":"#059669",borderRadius:20,padding:"1px 8px",fontSize:".68rem",fontWeight:700}}>{doneWon.length}</span>
                        <span style={{marginLeft:"auto",fontSize:".65rem",color:doneExpanded?"rgba(255,255,255,.6)":"#94a3b8"}}>{doneExpanded?"▲ Hide":"▼ Show"}</span>
                      </button>
                      {doneExpanded&&(
                        <div style={{background:"#fff",borderRadius:"0 0 10px 10px",border:"1.5px solid #d1fae5",borderTop:"none",overflow:"hidden",padding:10}}>
                          <AwardTable deals={doneWon}/>
                        </div>
                      )}
                    </div>
                  )}
                </>);
              })()}

              {/* Did Not Win — styled to match the awarded flat table */}
              {(()=>{
                const dnw=deals.filter(d=>d.stage==="Did Not Win");
                if(!dnw.length) return null;
                const TYPE_CLR_DNW={"Fabrication / General":"#0891b2","Construction":"#b45309","Retail Fit-Out":"#7c3aed","Kiosk":"#0d9488","Signage":"#db2777","Event / Activation":"#e11d48","Repair / Refurbishment":"#4f46e5","Other":"#64748b"};
                // The "did not win" reason is appended to notes as "[DID NOT WIN <date>]: <reason>".
                // Pull the most recent one for the Reason column (blank if only the marker exists).
                const lostReason=d=>{const m=[...String(d.notes||"").matchAll(/\[DID NOT WIN[^\]]*\]:?\s*(.*)/gi)];if(!m.length)return"";return(m[m.length-1][1]||"").trim();};
                return(
                  <div style={{marginTop:8,marginBottom:16}}>
                    {/* Collapsible, sits directly under Closed Out / Done */}
                    <button onClick={()=>setDnwExpanded(p=>!p)} style={{width:"100%",display:"flex",alignItems:"center",gap:8,background:dnwExpanded?"#64748b":"#f8fafc",border:`1.5px solid ${dnwExpanded?"#64748b":"#cbd5e1"}`,borderRadius:dnwExpanded?"10px 10px 0 0":"10px",padding:"10px 14px",cursor:"pointer",fontFamily:"inherit",textAlign:"left",transition:"all .15s"}}>
                      <span style={{fontWeight:800,color:dnwExpanded?"#fff":"#475569",fontSize:".85rem"}}>✗ Did Not Win</span>
                      <span style={{background:dnwExpanded?"rgba(255,255,255,.2)":"#e2e8f0",color:dnwExpanded?"#fff":"#475569",borderRadius:20,padding:"1px 8px",fontSize:".68rem",fontWeight:700}}>{dnw.length}</span>
                      <span style={{marginLeft:"auto",fontSize:".65rem",color:dnwExpanded?"rgba(255,255,255,.6)":"#94a3b8"}}>{dnwExpanded?"▲ Hide":"▼ Show"}</span>
                    </button>
                    {dnwExpanded&&(
                    <div style={{background:"#fff",borderRadius:"0 0 10px 10px",border:"1.5px solid #cbd5e1",borderTop:"none",overflow:"hidden"}}>
                      <div style={{overflowX:"auto"}}>
                        <table style={{width:"100%",borderCollapse:"collapse",minWidth:760}}>
                          <thead>
                            <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                              <th style={{width:4,padding:0}}></th>
                              {["Client / Project","Type","CE #","AE","Value","Reason",""].map(h=>(
                                <th key={h} style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".09em",color:"#94a3b8",padding:"9px 14px",textAlign:h==="Value"?"right":"left",whiteSpace:"nowrap"}}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {dnw.map(d=>{
                              const t=d.ceType||"Other";const tc=TYPE_CLR_DNW[t]||"#64748b";const reason=lostReason(d);
                              return(
                                <tr key={d.id} style={{borderBottom:"1px solid #e2e8f0",opacity:.85}}
                                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                                  onMouseLeave={e=>e.currentTarget.style.background=""}>
                                  <td style={{width:4,padding:0,background:"#cbd5e1"}}></td>
                                  <td style={{padding:"10px 14px",verticalAlign:"middle"}}>
                                    <div style={{fontWeight:700,fontSize:".82rem",color:"#475569",lineHeight:1.3}}>{d.contact||d.client}</div>
                                    {d.client!==d.contact&&d.contact&&<div style={{fontSize:".68rem",color:"#94a3b8",marginTop:1}}>{d.client}</div>}
                                  </td>
                                  <td style={{padding:"10px 14px",verticalAlign:"middle",whiteSpace:"nowrap"}}>
                                    <span style={{fontSize:".56rem",fontWeight:700,letterSpacing:".02em",padding:"1px 6px",borderRadius:3,background:tc+"18",color:tc,border:`1px solid ${tc}55`}}>{t}</span>
                                  </td>
                                  <td style={{padding:"10px 14px",verticalAlign:"middle",whiteSpace:"nowrap"}}>
                                    {d.ceNo?<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:600,padding:"1px 5px",borderRadius:3,background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe"}}>{d.ceNo}</span>:<span style={{color:"#cbd5e1"}}>—</span>}
                                  </td>
                                  <td style={{padding:"10px 14px",fontSize:".78rem",fontWeight:500,color:"#64748b",verticalAlign:"middle",whiteSpace:"nowrap"}}>{d.salesOwner||<span style={{color:"#cbd5e1"}}>—</span>}</td>
                                  <td style={{padding:"10px 14px",verticalAlign:"middle",textAlign:"right",whiteSpace:"nowrap"}}>
                                    <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".78rem",fontWeight:700,color:"#94a3b8"}}>{d.value?fmtK(Number(d.value)):"—"}</span>
                                  </td>
                                  <td style={{padding:"10px 14px",verticalAlign:"middle",fontSize:".74rem",color:"#64748b",maxWidth:220}}>
                                    {reason?<span title={reason} style={{display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{reason}</span>:<span style={{color:"#cbd5e1"}}>—</span>}
                                  </td>
                                  <td style={{padding:"6px 10px",verticalAlign:"middle",whiteSpace:"nowrap"}}>
                                    <div style={{display:"flex",gap:5}}>
                                      {(role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")&&<button onClick={()=>openEditDeal(d)} title="Edit deal" style={{background:"#f1f5f9",border:"none",borderRadius:5,padding:"3px 8px",fontSize:".65rem",color:"#94a3b8",cursor:"pointer",fontFamily:"inherit"}}>✏</button>}
                                      {(role==="Manager"||role==="Sales")&&<button onClick={()=>{upDeals(ds=>ds.map(x=>{if(x.id!==d.id)return x;const nd={...x,stage:"01 · BizDev"};if(isSupabaseReady())sbSyncOne("deals",nd,toSbDeal);return nd;}));toastEmit("Moved back to pipeline.");}} style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:5,padding:"3px 8px",fontSize:".65rem",color:"#059669",cursor:"pointer",fontFamily:"inherit",fontWeight:700}} title="Move back to pipeline">↩</button>}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    )}
                  </div>
                );
              })()}

              {/* Cancelled */}
              {deals.filter(d=>d.stage==="Cancelled").length>0&&(
                <details style={{marginTop:4}}>
                  <summary style={{cursor:"pointer",fontSize:".75rem",color:"#94a3b8",fontWeight:600,padding:"6px 0"}}>
                    Cancelled ({deals.filter(d=>d.stage==="Cancelled").length})
                  </summary>
                  <div style={{marginTop:6}}>
                  {deals.filter(d=>d.stage==="Cancelled").map(d=>{
                    // Surface the cancellation reason stamped into notes as "[CANCELLED <date>]: <reason>".
                    const cm=[...String(d.notes||"").matchAll(/\[CANCELLED[^\]]*\]:?\s*(.*)/gi)];
                    const cancelReason=cm.length?(cm[cm.length-1][1]||"").trim():"";
                    return(
                    <div key={d.id} style={{padding:"8px 12px",background:"#f8fafc",borderRadius:8,marginBottom:4,opacity:.65}}>
                      <div style={{display:"flex",justifyContent:"space-between"}}>
                        <span style={{fontSize:".8rem",color:"#64748b"}}>{d.client}{d.contact?" · "+d.contact:""}</span>
                        <span style={{fontSize:".8rem",color:"#94a3b8"}}>{d.value?fmtK(Number(d.value)):"—"}</span>
                      </div>
                      {cancelReason&&<div style={{fontSize:".7rem",color:"#b45309",marginTop:3,fontStyle:"italic"}}>⊘ {cancelReason}</div>}
                    </div>
                    );
                  })}
                  </div>
                </details>
              )}
            </div>
          );
        })()}
      </Wrap>
      {rowMenu&&(()=>{
        const d=rowMenu.deal;
        const items=[];
        const isWonDeal=WON_STAGES.includes(d.stage);
        // Move between temperature columns without dragging (mobile / quick action).
        // Only for active-pipeline parent deals — the board only buckets those.
        if((role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")&&isActivePipeline(d.stage)&&!d.parentDealId){
          const cur=deriveTemp(d,d.dateAcquired?Math.floor((new Date(today)-new Date(d.dateAcquired))/(864e5)):0);
          DEAL_TEMPS.filter(t=>t!==cur).forEach(t=>{const m=TEMP_META[t];items.push({icon:m.icon,label:`Move to ${t}`,color:m.clr,onClick:()=>{
            upDeals(ds=>ds.map(x=>x.id===d.id?{...x,temperature:t}:x));
            if(isSupabaseReady())sbUpdate('deals',d.id,{temperature:t,updated_at:new Date().toISOString()}).catch(()=>{});
            logActivity(d.id,"Temperature",`${d.contact||d.client} → ${m.icon} ${t}`,session?.name);
            toastEmit(`${m.icon} Moved to ${t}`);setRowMenu(null);
          }});});
        }
        if((role==="Manager"||role==="Sales")&&!isWonDeal) items.push({icon:"✗",label:"Mark Did Not Win",color:"#64748b",onClick:async ()=>{const reason=(await uiPrompt("Reason for not winning (optional):"));if(reason===null)return;const stamp=new Date().toISOString().slice(0,10);upDeals(ds=>ds.map(x=>{if(x.id!==d.id)return x;const notes=(x.notes||"")+(reason?"\n[DID NOT WIN "+stamp+"]: "+reason:"\n[DID NOT WIN "+stamp+"]");
          // Persist as a partial column UPDATE (like stageQ / payQ), NOT a full-row
          // upsert. An upsert routes through the RLS INSERT/WITH CHECK policy and was
          // failing silently for some roles, so the server kept the old stage and the
          // next sbLoadAll refresh (via mergeLocalOnly, server-wins) pulled the deal
          // right back into the pipeline after it had been marked Did Not Win.
          if(isSupabaseReady())sbUpdate('deals',x.id,{stage:"Did Not Win",probability:0,notes,updated_at:new Date().toISOString()}).catch(()=>{});return{...x,stage:"Did Not Win",probability:0,notes};}));logActivity(d.id,"Did Not Win",d.client+" — did not win");toastEmit("Moved to Did Not Win.");setRowMenu(null);}});
        // Cancel Project — for AWARDED projects the client backs out of. Unlike
        // Delete (which wipes the record) this retires the project to the Cancelled
        // stage: the CE record, award value, billing and history all stay intact and
        // it drops out of active Awarded totals. A reason is REQUIRED and the action
        // is logged, so cancelling an awarded project is a deliberate, auditable step.
        if((role==="Manager"||role==="Sales"||role==="SalesOpsAdmin")&&isWonDeal) items.push({icon:"⊘",label:"Cancel Project",color:"#b45309",onClick:async ()=>{
          const reason=(await uiPrompt("Cancelling an AWARDED project — this is logged and removes it from active projects.\n\nReason for cancellation (required):"));
          if(reason===null) return;                                                   // dialog dismissed
          if(!reason.trim()){ toastEmit("A reason is required to cancel a project.","error"); return; }
          // A Cancelled project drops out of Billing (it is no longer a won deal),
          // so any invoice left open would keep counting as receivable / overdue
          // with no screen left to clear it. Void the UNPAID ones here; invoices
          // with recorded payments stay for Finance to refund or forfeit.
          const collected=dealCollected(d);
          const activeMs=billings.filter(b=>b.dealId===d.id&&b.status!=='Cancelled');
          const msPaid=b=>(b.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+Number(p.amount||0),0);
          const toVoid=activeMs.filter(b=>msPaid(b)===0);
          const keep=activeMs.filter(b=>msPaid(b)>0);
          if(collected>0||activeMs.length>0){
            const warn=`⚠️ This project has billing on it:\n\n`
              +(toVoid.length?`• ${toVoid.length} unpaid invoice${toVoid.length===1?"":"s"} (${toVoid.map(b=>b.invoiceNo||b.name||"—").join(", ")}) will be marked Cancelled\n`:"")
              +(keep.length?`• ${keep.length} invoice${keep.length===1?"":"s"} with payments recorded will be left as is\n`:"")
              +(collected>0?`• ₱${Number(collected).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2})} already collected — handle refund/forfeiture in Finance\n`:"")
              +`\nOpen POs and payables are NOT touched — cancel those with Procurement/Finance.\n\nCancel this project?`;
            if(!(await uiConfirm(warn))) return;
          }
          const stamp=new Date().toISOString().slice(0,10);
          const voidIds=new Set(toVoid.map(b=>b.id));
          if(voidIds.size){
            upBillings(bs=>bs.map(b=>{
              if(!voidIds.has(b.id)) return b;
              const n={...b,status:"Cancelled",description:((b.description||"")+` [VOID ${stamp}: project cancelled — ${reason.trim()}]`).trim()};
              if(isSupabaseReady()) sbSyncOne("billing_milestones",n,toSbBilling);
              return n;
            }));
          }
          const invoiced=keep.reduce((s,b)=>s+Number(b.amount||0),0);
          upDeals(ds=>ds.map(x=>{
            if(x.id!==d.id) return x;
            const notes=(x.notes||"")+"\n[CANCELLED "+stamp+"]: "+reason.trim();
            // Partial column UPDATE (like Did Not Win), NOT a full-row upsert — an
            // upsert routes through the RLS INSERT/WITH CHECK policy and can silently
            // keep the old stage for some roles, pulling the deal back into pipeline.
            if(isSupabaseReady())sbUpdate('deals',x.id,{stage:"Cancelled",probability:0,notes,invoiced,updated_at:new Date().toISOString()}).catch(()=>{});
            return{...x,stage:"Cancelled",probability:0,notes,invoiced};
          }));
          logActivity(d.id,"Project Cancelled",`${d.client} — project cancelled: ${reason.trim()}${voidIds.size?` · voided ${toVoid.map(b=>b.invoiceNo||b.name).join(", ")}`:""}`,session?.name||role);
          const tg=`❌ <b>Project Cancelled</b>\nClient: <b>${d.client}</b>\n${d.contact?`Project: ${d.contact}\n`:""}${d.ceNo?`CE: ${d.ceNo}\n`:""}Reason: ${reason.trim()}\nBy: ${session?.name||role}`;
          sendTelegramNotification("management",tg);
          sendTelegramNotification("sales",tg);
          toastEmit(voidIds.size?`Project moved to Cancelled · ${voidIds.size} unpaid invoice${voidIds.size===1?"":"s"} voided.`:"Project moved to Cancelled.");
          setRowMenu(null);
        }});
        if(canDeleteDeal) items.push({icon:"🗑",label:"Delete Deal",color:"#dc2626",onClick:()=>{setConfirmDel(d.id);setRowMenu(null);}});
        return(
          <>
            <div onClick={()=>setRowMenu(null)} style={{position:"fixed",inset:0,zIndex:1300}}/>
            <div style={{position:"fixed",top:rowMenu.top,right:rowMenu.right,zIndex:1301,background:"#fff",borderRadius:10,border:"1.5px solid #e2e8f0",boxShadow:"0 12px 32px rgba(15,23,42,.18)",overflow:"hidden",minWidth:180}}>
              <div style={{padding:"8px 12px",borderBottom:"1px solid #f1f5f9",fontSize:".7rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".4px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:220}}>{d.contact||d.client}</div>
              {items.map((it,ix)=>(
                <button key={ix} onClick={it.onClick} style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:"#fff",border:"none",borderTop:ix>0?"1px solid #f8fafc":"none",cursor:"pointer",fontFamily:"inherit",fontSize:".82rem",fontWeight:600,color:it.color,textAlign:"left"}}
                  onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"} onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                  <span style={{fontSize:".9rem"}}>{it.icon}</span>{it.label}
                </button>
              ))}
            </div>
          </>
        );
      })()}
      {awardReqModal&&<AwardReqModal deal={awardReqModal} session={session} today={today} onClose={()=>setAwardReqModal(null)} onSubmit={formData=>{
          const d=awardReqModal;
          upDeals(ds=>ds.map(x=>x.id===d.id?{...x,
            awardRequestData:{...formData},
            notes:(x.notes||"")+`\n[AWARD REQUEST ${today}]: ${session?.name||"Sales"} flagged for award. Trigger: ${formData.awardTrigger}. AE: ${formData.aeAssigned||"—"}. Suggested PM: ${formData.pm1Suggestion||"—"}.`
          }:x));
          logActivity(d.id,"Award Requested",`${d.client} flagged by ${session?.name||"Sales"} — ${formData.awardTrigger}`);
          sendTelegramNotification("management",`🏆 <b>Award Request — Action Needed</b>\nClient: <b>${d.client}</b>\n${d.ceNo?`CE: ${d.ceNo} · `:""}${botSettings.hideValueInBots?"":` ₱${Number(d.value||0).toLocaleString("en-PH")}`}\nTrigger: ${formData.awardTrigger}\nRequested by: ${session?.name||"Sales"}\nScope: ${formData.scopeNotes||"—"}\n\nOpen FabHub → Pipeline to Review & Award.`);
          toastEmit("Award request submitted — Paulo will review and confirm.");
          setAwardReqModal(null);
        }}/>}
      {awardModal&&<AwardModal deal={awardModal} session={session} today={today} onClose={()=>setAwardModal(null)} onConfirm={confirmAward} drfs={drfs}/>}
      {priceModal&&<SetPriceModal deal={priceModal} today={today} onClose={()=>setPriceModal(null)} onSave={(val,note)=>{
        upDeals(ds=>ds.map(x=>{
          if(x.id!==priceModal.id) return x;
          const updated={...x,value:val,notes:(x.notes||"")+(note?`\n[QS PRICING ${today}]: ₱${val.toLocaleString("en-PH")} — ${note}`:`\n[QS PRICING ${today}]: ₱${val.toLocaleString("en-PH")}`)};
          if(isSupabaseReady()) sbUpdate('deals',x.id,{value:val,notes:updated.notes,updated_at:new Date().toISOString()}).catch(()=>{});
          return updated;
        }));
        logActivity(priceModal.id,"QS Pricing",`${priceModal.client} — price set to ₱${val.toLocaleString("en-PH")} by ${session?.name||"QS"}`);
        sendTelegramNotification("sales",`💰 <b>Price Set by QS</b>\nClient: <b>${priceModal.client}</b>${priceModal.ceNo?" · "+priceModal.ceNo:""}\nAmount: ₱${val.toLocaleString("en-PH",{maximumFractionDigits:0})}\nSet by: ${session?.name||"QS"}`);
        toastEmit("Price saved — Sales team notified.");
        setPriceModal(null);
      }}/>}
      {dupPrompt&&(
        <div onClick={()=>{setDupPrompt(null);setDupScopeTarget(null);setDupScopeForm({title:"",desc:"",value:"",});}} style={{position:"fixed",inset:0,background:"rgba(15,23,42,.65)",zIndex:1200,display:"flex",alignItems:isMobile?"flex-end":"center",justifyContent:"center",padding:isMobile?0:20}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:isMobile?"18px 18px 0 0":16,width:"100%",maxWidth:isMobile?undefined:500,padding:isMobile?"20px 18px 28px":"24px 28px",boxShadow:"0 24px 64px rgba(0,0,0,.25)",maxHeight:"92vh",overflowY:"auto"}}>
            {(
              <>
                <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.05rem",marginBottom:6}}>⚠️ Looks like a duplicate</div>
                <div style={{fontSize:".8rem",color:"#64748b",marginBottom:16}}>We found a similar project already in the pipeline for <strong>{dupPrompt.newData.client}</strong>. Is this a brand-new separate project, or a scope addition to an existing one?</div>
                {dupPrompt.matches.map(m=>(
                  <div key={m.id} style={{background:"#fffbeb",borderRadius:10,padding:"12px 14px",marginBottom:10,border:"1.5px solid #fbbf24"}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{m.client}{m.product?` — ${m.product}`:""}</div>
                    <div style={{fontSize:".74rem",color:"#64748b",marginTop:2}}>{[m.ceNo,m.stage].filter(Boolean).join(" · ")}</div>
                    <button onClick={()=>{
                      // A scope change is a linked child deal: save this new deal
                      // tagged to the existing project (parentDealId). It keeps its
                      // own billing and rolls into that project's Total Contract.
                      const d={...dupPrompt.newData,parentDealId:m.id};
                      setDupPrompt(null);setDupScopeTarget(null);
                      saveDeal(d,true);
                      toastEmit&&toastEmit(`Saved as a linked addendum of ${m.client} — it has its own billing and rolls into that project's Total Contract.`,"success",7000);
                    }} style={{marginTop:8,background:"#fef3c7",border:"1.5px solid #fbbf24",borderRadius:7,padding:"6px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",color:"#92400e",cursor:"pointer"}}>🔗 Add as a linked addendum of this project</button>
                  </div>
                ))}
                <div style={{display:"flex",gap:10,marginTop:16}}>
                  <button onClick={()=>{const d=dupPrompt.newData;setDupPrompt(null);saveDeal(d,true);}} style={{flex:1,background:"#1e293b",border:"none",borderRadius:9,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:"#fff",cursor:"pointer"}}>✅ Save as New Project</button>
                  <button onClick={()=>{setDupPrompt(null);setDupScopeTarget(null);}} style={{flex:1,background:"#f1f5f9",border:"none",borderRadius:9,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:"#64748b",cursor:"pointer"}}>↩ Cancel</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {quickAddClientOpen&&(
        <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,.5)",zIndex:1100,display:"flex",alignItems:isMobile?"flex-end":"center",justifyContent:"center",padding:isMobile?0:16}} onClick={()=>{setQuickAddClientOpen(false);resetQAC();}}>
          <div style={{background:"#fff",borderRadius:isMobile?"18px 18px 0 0":18,padding:isMobile?"20px 16px 28px":28,width:"100%",maxWidth:isMobile?undefined:580,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 24px 80px rgba(0,0,0,.2)"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div>
                <div style={{fontWeight:800,fontSize:"1.05rem",color:"#0f172a"}}>Add New Client</div>
                <div style={{fontSize:".78rem",color:"#64748b",marginTop:2}}>Fill in what you know — you can always update later</div>
              </div>
              <button onClick={()=>{setQuickAddClientOpen(false);resetQAC();}} style={{background:"#f1f5f9",border:"none",borderRadius:99,width:32,height:32,cursor:"pointer",fontSize:"1rem",color:"#64748b"}}>✕</button>
            </div>
            <div style={{background:"#f0fdf4",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1.5px solid #6ee7b7"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#059669",marginBottom:8}}>Company / Client Name <span style={{color:"#ef4444"}}>*</span></div>
              <Inp autoFocus value={quickAddClientForm.name} onChange={e=>fqac("name",e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){const n=quickAddClientForm.name.trim();if(!n)return;const allC=[...GMD_CLIENTS,...customClients];if(allC.find(c=>c.name.toLowerCase()===n.toLowerCase())){toastEmit("Client already exists.","warning");return;}const nc={name:n,id:"c"+Date.now(),addedBy:session?.name||"",addedAt:today};GMD_CLIENTS.push(nc);const prof={contactPerson:quickAddClientForm.contactPerson,email:quickAddClientForm.email,phone:quickAddClientForm.phone,mobile:quickAddClientForm.mobile,website:quickAddClientForm.website,billingAddress:quickAddClientForm.billingAddress,city:quickAddClientForm.city,province:quickAddClientForm.province,zipCode:quickAddClientForm.zipCode,country:quickAddClientForm.country,tin:quickAddClientForm.tin,paymentTerms:quickAddClientForm.paymentTerms,notes:quickAddClientForm.notes};const next=[...customClients,nc];setCustomClients(next);try{localStorage.setItem(KEYS.customclients,JSON.stringify(next));}catch{}if(isSupabaseReady()) sbUpsert('app_settings',{key:'customclients',value:next,updated_at:new Date().toISOString()},'key').catch(()=>{});if(Object.values(prof).some(v=>v)){saveClientProfileRemote(n,prof);}toastEmit(`Client "${n}" added to directory.`,"success");setQuickAddClientOpen(false);resetQAC();}}} placeholder="Full company or client name…"/>
            </div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>📇 Name & Contact</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <Fld label="Contact Person"><Inp value={quickAddClientForm.contactPerson} onChange={e=>fqac("contactPerson",e.target.value)} placeholder="e.g. Juan dela Cruz"/></Fld>
                <Fld label="Email"><Inp type="email" value={quickAddClientForm.email} onChange={e=>fqac("email",e.target.value)} placeholder="accounts@company.com"/></Fld>
                <Fld label="Phone"><Inp value={quickAddClientForm.phone} onChange={e=>fqac("phone",e.target.value)} placeholder="+63 2 8xxx xxxx"/></Fld>
                <Fld label="Mobile"><Inp value={quickAddClientForm.mobile} onChange={e=>fqac("mobile",e.target.value)} placeholder="+63 9xx xxx xxxx"/></Fld>
                <Fld label="Website"><Inp value={quickAddClientForm.website} onChange={e=>fqac("website",e.target.value)} placeholder="www.company.com"/></Fld>
              </div>
            </div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>📍 Billing Address</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <div style={{gridColumn:"1/-1"}}><Fld label="Street Address"><Inp value={quickAddClientForm.billingAddress} onChange={e=>fqac("billingAddress",e.target.value)} placeholder="Unit/Floor, Building, Street"/></Fld></div>
                <Fld label="City"><Inp value={quickAddClientForm.city} onChange={e=>fqac("city",e.target.value)} placeholder="Makati"/></Fld>
                <Fld label="Province / Region"><Inp value={quickAddClientForm.province} onChange={e=>fqac("province",e.target.value)} placeholder="Metro Manila"/></Fld>
                <Fld label="ZIP Code"><Inp value={quickAddClientForm.zipCode} onChange={e=>fqac("zipCode",e.target.value)} placeholder="1200"/></Fld>
                <Fld label="Country"><Inp value={quickAddClientForm.country} onChange={e=>fqac("country",e.target.value)} placeholder="Philippines"/></Fld>
              </div>
            </div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:16,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>🏢 Business Details</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <Fld label="Client TIN"><Inp value={quickAddClientForm.tin} onChange={e=>fqac("tin",e.target.value)} placeholder="000-000-000-000"/></Fld>
                <Fld label="Payment Terms"><Sel value={quickAddClientForm.paymentTerms} onChange={e=>fqac("paymentTerms",e.target.value)}><option>Due on receipt</option><option>Net 15</option><option>Net 30</option><option>Net 60</option><option>50% DP, Balance on completion</option></Sel></Fld>
                <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={quickAddClientForm.notes} onChange={e=>fqac("notes",e.target.value)} placeholder="Special billing instructions, key contacts…"/></Fld></div>
              </div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>{
                const n=quickAddClientForm.name.trim();
                if(!n) return;
                const allC=[...GMD_CLIENTS,...customClients];
                if(allC.find(c=>c.name.toLowerCase()===n.toLowerCase())){toastEmit("Client already exists.","warning");return;}
                const nc={name:n,id:"c"+Date.now(),addedBy:session?.name||"",addedAt:today};
                GMD_CLIENTS.push(nc);
                const prof={contactPerson:quickAddClientForm.contactPerson,email:quickAddClientForm.email,phone:quickAddClientForm.phone,mobile:quickAddClientForm.mobile,website:quickAddClientForm.website,billingAddress:quickAddClientForm.billingAddress,city:quickAddClientForm.city,province:quickAddClientForm.province,zipCode:quickAddClientForm.zipCode,country:quickAddClientForm.country,tin:quickAddClientForm.tin,paymentTerms:quickAddClientForm.paymentTerms,notes:quickAddClientForm.notes};
                const next=[...customClients,nc];
                setCustomClients(next);
                try{localStorage.setItem(KEYS.customclients,JSON.stringify(next));}catch{}
                if(isSupabaseReady()) sbUpsert('app_settings',{key:'customclients',value:next,updated_at:new Date().toISOString()},'key').catch(()=>{});
                if(Object.values(prof).some(v=>v)){
                  saveClientProfileRemote(n,prof);
                }
                toastEmit(`Client "${n}" added to directory.`,"success");
                setQuickAddClientOpen(false);
                resetQAC();
              }} style={{flex:1,background:"#059669",border:"none",borderRadius:9,padding:"11px",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>Add Client</button>
              <button onClick={()=>{setQuickAddClientOpen(false);resetQAC();}} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"11px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
    );

    // SalesOpsAdmin (Jessica) is scoped to ONLY the Weekly Dues board — she can
    // see when collections are due and when payments are scheduled, but not the
    // executive P&L, cash position, or AP ledger.
    if((page==="financecal"||page==="finance")&&role==="SalesOpsAdmin") return(
      <Wrap>
        <FinanceWeeklyDues billings={billings} payables={payables} wonDeals={wonDeals} deals={deals} completedDeals={completedDeals} today={today} setPage={setPage} setFinTab={setFinTab} role={role}/>
      </Wrap>
    );

    if(page==="finance"&&(role==="Finance"||role==="Manager"||role==="FinanceAssistant"||role==="Accounting")) return(
      <Wrap>
        {/* Aerwin's Purchase-to-Payment ERP header shows only on the ERP operational
            tabs (Accounts Payable, Payments). The owner/executive views — Executive
            dashboard (overview/P&L/Loans) and Cash Position — are their own pages. */}
        {["payables","payments"].includes(finTab)&&<FinanceErpBar active={finTab==="payables"?"ap":"payments"} go={financeErpGo} counts={financeErpCounts()}/>}
        {/* Weekly Dues board toggle — always reachable from anywhere in Finance
            (hidden with the AP while the new AP/AR system is built). */}
        {!AP_HIDDEN&&<div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
          <button onClick={()=>setFinTab(finTab==="duesboard"?"overview":"duesboard")} style={{whiteSpace:"nowrap",padding:"6px 14px",borderRadius:20,border:`1px solid ${finTab==="duesboard"?ERP.navy:ERP.line}`,background:finTab==="duesboard"?ERP.navy:"#fff",color:finTab==="duesboard"?"#fff":ERP.muted,cursor:"pointer",fontSize:".78rem",fontWeight:600,fontFamily:"inherit"}}>📅 Weekly Dues</button>
        </div>}
        {finTab==="duesboard"&&(
          <FinanceWeeklyDues billings={billings} payables={payables} wonDeals={wonDeals} deals={deals} completedDeals={completedDeals} today={today} setPage={setPage} setFinTab={setFinTab} role={role}/>
        )}
        {/* The old Finance sub-tab bar (Overview/Cash/Payables/Payments) was removed —
            those views are reached from the left nav (Finance, Cash Position,
            Accounts Payable) and the ERP bar (Accounts Payable, Payments). Only
            P&L and Loans have no other home, so they stay as two compact pills. */}
        {role!=="Accounting"&&["overview","pl","loans"].includes(finTab)&&(
          <div style={{display:"flex",justifyContent:"flex-end",gap:8,marginBottom:20,flexWrap:"wrap"}}>
            {[["pl","📈 P&L"],["loans","💳 Loans"]].filter(([t])=>!HIDDEN_FIN_TABS.has(t)).map(([t,l])=>{
              const on=finTab===t;
              return(
                <button key={t} onClick={()=>setFinTab(on?"overview":t)} style={{whiteSpace:"nowrap",padding:"6px 14px",borderRadius:20,border:`1px solid ${on?ERP.navy:ERP.line}`,background:on?ERP.navy:"#fff",color:on?"#fff":ERP.muted,cursor:"pointer",fontSize:".78rem",fontWeight:600,fontFamily:"inherit"}}>
                  {l}{t==="loans"&&loans.length>0&&<span style={{marginLeft:5,background:on?"rgba(255,255,255,.85)":"#7c3aed",color:on?ERP.navy:"#fff",borderRadius:20,padding:"1px 6px",fontSize:".62rem",fontWeight:700}}>{loans.length}</span>}
                </button>
              );
            })}
          </div>
        )}

        {/* ── OVERVIEW TAB ── */}
        {finTab==="overview"&&role!=="Accounting"&&(()=>{
          const now=new Date();
          const cy=now.getFullYear();
          // Billed stays VAT-ex (the invoice base); collected / outstanding / rate / DSO
          // are cash-basis from arSummary so they compare like with like.
          const totalBilled=arTot.billed;
          const totalCollected=arTot.collected;
          // Margin: billed revenue (VAT-ex) − AP-ledger costs (VAT-ex), same basis as
          // the Income Statement.
          const totalExpenses=costTot.net;
          const grossProfit=totalBilled-totalExpenses;
          const grossMargin=totalBilled>0?Math.round(grossProfit/totalBilled*100):0;
          const collectionRate=Math.round(arTot.collectionRate*100);
          const outstanding=arTot.outstanding;
          const dso=totalCollected>0?Math.round(outstanding/(totalCollected/365)):0;
          const backlog=wonDeals.reduce((s,d)=>{
            const billed=billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled").reduce((bs,b)=>bs+Number(b.amount||0),0);
            return s+Math.max(0,Number(d.value||0)-billed);
          },0);
          const pipelineVal=deals.filter(d=>ACTIVE_STAGES.includes(d.stage)).reduce((s,d)=>s+Number(d.value||0),0);
          const y12ago=new Date();y12ago.setFullYear(y12ago.getFullYear()-1);
          const recentDeals=deals.filter(d=>{const dt=new Date(d.createdAt||"2020-01-01");return dt>=y12ago;});
          const winRate=recentDeals.length>0?Math.round(recentDeals.filter(d=>!d.isCostCenter&&(WON_STAGES.includes(d.stage)||d.stage==="14 · Completed")).length/recentDeals.length*100):0;
          const avgDeal=wonDeals.length>0?Math.round(wonDeals.reduce((s,d)=>s+Number(d.value||0),0)/wonDeals.length):0;
          const months6=Array.from({length:6},(_,i)=>{const d=new Date(now.getFullYear(),now.getMonth()-5+i,1);return{y:d.getFullYear(),m:d.getMonth(),label:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()]};});
          const monthlyRev=months6.map(({y,m})=>billings.filter(b=>b.status!=="Cancelled").reduce((s,b)=>{const ds=b.invoiceDate||b.dueDate;if(!ds)return s;const d=new Date(ds);return(!isNaN(d)&&d.getFullYear()===y&&d.getMonth()===m)?s+Number(b.amount||0):s;},0));
          const monthlyExp=months6.map(({y,m})=>exps.reduce((s,e)=>{let ey,em;if(e.date){const d=new Date(e.date);ey=d.getFullYear();em=d.getMonth();}else{ey=e.year||cy;em=Number(e.month||0);}return(ey===y&&em===m)?s+Number(e.amount||0):s;},0));
          const maxBar=Math.max(...monthlyRev,...monthlyExp,1);
          const clientMap={};billings.forEach(b=>{const d=wonDeals.find(x=>x.id===b.dealId)||completedDeals.find(x=>x.id===b.dealId);if(!d)return;const k=d.client;if(!clientMap[k])clientMap[k]=0;clientMap[k]+=(b.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);});
          const topClients=Object.entries(clientMap).sort(([,a],[,b])=>b-a).slice(0,5);
          const totalPayables=payables.filter(p=>p.status==="Unpaid").reduce((s,p)=>s+Number(p.amount||0),0);
          const overduePayables=payables.filter(p=>p.status==="Unpaid"&&p.dueDate&&p.dueDate<today).length;

          // ── DAILY DIGEST ─────────────────────────────────────────────────
          const overdueBillings=billings.filter(m=>isBillingOverdue(m,today));
          const unsentLateBillings=billings.filter(m=>isBillingUnsentLate(m,today));
          const unbilledProjects=wonDeals.filter(d=>billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled").length===0);
          const fmtM=v=>"₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0});

          // ── CASH POSITION (today) ─────────────────────────────────────────
          const todayPos=cashPositions[today]||null;
          const BANK_LABELS={bpi:"BPI",metro:"Metrobank",china:"Chinabank",bdo:"BDO",security:"Security Bank",union:"UnionBank"};
          const cpBanks=todayPos?Object.entries(todayPos.banks||{}).map(([id,r])=>({id,label:BANK_LABELS[id]||id,beg:Number(r.beg||0),book:Number(r.book||0),end:Number(r.end||0)})).filter(b=>b.beg>0||b.book>0||b.end>0):[];
          const cpTotalBeg=cpBanks.reduce((s,b)=>s+b.beg,0);
          const cpTotalEnd=cpBanks.reduce((s,b)=>s+(b.end||b.book||b.beg),0);
          const cpTxns=todayPos?.transactions||[];
          const cpCollections=(todayPos?.collections?.manualCollections||[]).reduce((s,c)=>s+Number(c.amount||0),0);
          const cpExpenses=cpTxns.filter(t=>t.type==="expense"||t.amount<0).reduce((s,t)=>s+Math.abs(Number(t.amount||0)),0);
          const cpNetMove=cpTotalEnd-cpTotalBeg;

          // Build digest alerts list
          const digestAlerts=[];
          if(overdueBillings.length>0) digestAlerts.push({icon:"🚨",level:"danger",text:`${overdueBillings.length} overdue invoice${overdueBillings.length!==1?"s":""} — ₱${Number(overdueBillings.reduce((s,m)=>s+milestoneBalance(m,dealById.get(m.dealId)),0)).toLocaleString("en-PH",{maximumFractionDigits:0})} uncollected`});
          if(unsentLateBillings.length>0) digestAlerts.push({icon:"📤",level:"warning",text:`${unsentLateBillings.length} draft invoice${unsentLateBillings.length!==1?"s":""} past due and not yet sent — ${fmtM(unsentLateBillings.reduce((s,m)=>s+milestoneBalance(m,dealById.get(m.dealId)),0))}`});
          if(grossMargin<25) digestAlerts.push({icon:"📉",level:"warning",text:`Gross margin at ${grossMargin}% — below 25% target`});
          if(dso>90) digestAlerts.push({icon:"⏳",level:"warning",text:`DSO is ${dso} days — clients are paying very slowly`});
          if(outstanding>0) digestAlerts.push({icon:"💰",level:"info",text:`Outstanding AR: ${fmtM(outstanding)} across ${arTot.openMilestones} milestone${arTot.openMilestones!==1?"s":""}`});
          if(unbilledProjects.length>0) digestAlerts.push({icon:"📋",level:"warning",text:`${unbilledProjects.length} awarded project${unbilledProjects.length!==1?"s":""} with no milestones billed yet`});
          if(overduePayables>0) digestAlerts.push({icon:"📤",level:"warning",text:`${overduePayables} overdue payable${overduePayables!==1?"s":""} — ₱${Number(payables.filter(p=>p.status==="Unpaid"&&p.dueDate&&p.dueDate<today).reduce((s,p)=>s+Number(p.amount||0),0)).toLocaleString("en-PH",{maximumFractionDigits:0})}`});
          if(backlog>0) digestAlerts.push({icon:"🏗",level:"info",text:`Contract backlog: ${fmtM(backlog)} in awarded work not yet billed`});
          // Cash position alerts
          if(!todayPos) digestAlerts.push({icon:"⚠️",level:"warning",text:"No cash position entry for today — please update Daily Cash Position"});
          else{
            if(cpTotalEnd<500000) digestAlerts.push({icon:"🔴",level:"danger",text:`Total bank balance is low — ${fmtM(cpTotalEnd)} ending balance today`});
            if(cpNetMove<0) digestAlerts.push({icon:"📉",level:"warning",text:`Net cash movement today: ${fmtM(cpNetMove)} (outflows exceeded inflows)`});
            cpBanks.forEach(b=>{const end=b.end||b.book||b.beg;if(end<0) digestAlerts.push({icon:"🔴",level:"danger",text:`${b.label} is in negative balance: ${fmtM(end)}`});});
          }
          if(digestAlerts.length===0) digestAlerts.push({icon:"✅",level:"ok",text:"All financial indicators are on track — no alerts today."});

          // ── 4 REVIEW SECTIONS ────────────────────────────────────────────
          // 1. Collections / AR
          const arOverdueAmt=overdueBillings.reduce((s,m)=>s+milestoneBalance(m,dealById.get(m.dealId)),0);
          const arAge30 =overdueBillings.filter(m=>{const d=Math.floor((now-new Date(m.dueDate))/(864e5));return d<=30;}).length;
          const arAge60 =overdueBillings.filter(m=>{const d=Math.floor((now-new Date(m.dueDate))/(864e5));return d>30&&d<=60;}).length;
          const arAge90p=overdueBillings.filter(m=>{const d=Math.floor((now-new Date(m.dueDate))/(864e5));return d>60;}).length;
          const arStatus=overdueBillings.length===0?"ok":arAge90p>0?"danger":"warning";

          // 2. Cash Position
          const cpStatus=!todayPos?"warning":cpTotalEnd<500000?"danger":cpNetMove<0?"warning":"ok";

          // 3. Billing / Payables
          const overduePayablesAmt=payables.filter(p=>p.status==="Unpaid"&&p.dueDate&&p.dueDate<today).reduce((s,p)=>s+Number(p.amount||0),0);
          const billStatus=overduePayables>0?"danger":unbilledProjects.length>0?"warning":"ok";

          // 4. Profitability
          const profStatus=grossMargin<20?"danger":grossMargin<30?"warning":"ok";
          const prevMonthIdx=now.getMonth()===0?11:now.getMonth()-1;
          const prevMonthRev=monthlyRev[monthlyRev.length-2]||0;
          const thisMonthRev=monthlyRev[monthlyRev.length-1]||0;
          const revTrend=prevMonthRev>0?Math.round((thisMonthRev-prevMonthRev)/prevMonthRev*100):0;

          const statusColor={ok:"#059669",warning:"#d97706",danger:"#dc2626"};
          const statusBg={ok:"#f0fdf4",warning:"#fffbeb",danger:"#fef2f2"};
          const statusBorder={ok:"#bbf7d0",warning:"#fde68a",danger:"#fecaca"};
          const statusLabel={ok:"✅ Good",warning:"⚠️ Watch",danger:"🔴 Action Needed"};

          const sendDigest=async()=>{
            const dateStr=now.toLocaleDateString("en-PH",{weekday:"long",year:"numeric",month:"long",day:"numeric"});
            // Fetch AI analysis from Vercel function
            let aiAnalysis="";
            try{
              const payload={
                date:dateStr,
                totalBilled:totalBilled.toLocaleString("en-PH",{maximumFractionDigits:0}),
                totalCollected:totalCollected.toLocaleString("en-PH",{maximumFractionDigits:0}),
                collectionRate,outstanding:outstanding.toLocaleString("en-PH",{maximumFractionDigits:0}),
                dso,overdueCount:overdueBillings.length,
                overdueAmt:arOverdueAmt.toLocaleString("en-PH",{maximumFractionDigits:0}),
                age30:arAge30,age60:arAge60,age90p:arAge90p,
                cpTotalBeg:cpTotalBeg.toLocaleString("en-PH",{maximumFractionDigits:0}),
                cpTotalEnd:cpTotalEnd.toLocaleString("en-PH",{maximumFractionDigits:0}),
                cpCollections:cpCollections.toLocaleString("en-PH",{maximumFractionDigits:0}),
                cpNetMove:cpNetMove.toLocaleString("en-PH",{maximumFractionDigits:0}),
                bankSummary:cpBanks.map(b=>`${b.label}: ₱${(b.end||b.book||b.beg).toLocaleString("en-PH",{maximumFractionDigits:0})}`).join(", ")||"Not logged",
                noCashPos:!todayPos,
                totalPayables:totalPayables.toLocaleString("en-PH",{maximumFractionDigits:0}),
                overduePayables,overduePayablesAmt:overduePayablesAmt.toLocaleString("en-PH",{maximumFractionDigits:0}),
                unbilledCount:unbilledProjects.length,
                backlog:backlog.toLocaleString("en-PH",{maximumFractionDigits:0}),
                grossMargin,grossProfit:grossProfit.toLocaleString("en-PH",{maximumFractionDigits:0}),
                totalExpenses:totalExpenses.toLocaleString("en-PH",{maximumFractionDigits:0}),
                thisMonthRev:thisMonthRev.toLocaleString("en-PH",{maximumFractionDigits:0}),
                revTrend,winRate,avgDeal:avgDeal.toLocaleString("en-PH",{maximumFractionDigits:0}),
              };
              const r=await fetch("/api/digest-analysis",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
              const j=await r.json();
              if(j.analysis) aiAnalysis=j.analysis;
            }catch(e){console.warn("AI analysis unavailable:",e);}
            const lines=[
              `💼 <b>GMD Finance Daily Digest</b>`,
              `📅 ${dateStr}`,
              ``,
              ...(aiAnalysis?[`🤖 <b>AI ANALYSIS</b>`,aiAnalysis,``]:[]),
              `━━━━━━━━━━━━━━━━━━━━━━`,
              `🧾 <b>COLLECTIONS / AR</b>  ${arStatus==="ok"?"✅":arStatus==="danger"?"🔴":"⚠️"}`,
              `• Total Billed: ${fmtM(totalBilled)}`,
              `• Collected: ${fmtM(totalCollected)} (${collectionRate}% rate)`,
              `• Outstanding AR: ${fmtM(outstanding)}`,
              `• DSO: ${dso} days`,
              ...(overdueBillings.length>0?[
                `• Overdue Invoices: ${overdueBillings.length} — ${fmtM(arOverdueAmt)}`,
                `  1–30d: ${arAge30}  |  31–60d: ${arAge60}  |  60d+: ${arAge90p}`,
              ]:[`• No overdue invoices ✅`]),
              ...(unsentLateBillings.length>0?[`• Not yet sent (drafts past due): ${unsentLateBillings.length}`]:[]),
              ...(topClients.length>0?[`• Top Client: ${topClients[0][0]} (${fmtM(topClients[0][1])} collected)`]:[]),
              ``,
              `━━━━━━━━━━━━━━━━━━━━━━`,
              `💵 <b>DAILY CASH POSITION</b>  ${cpStatus==="ok"?"✅":cpStatus==="danger"?"🔴":"⚠️"}`,
              ...(todayPos?[
                `• Opening Balance: ${fmtM(cpTotalBeg)}`,
                `• Closing Balance: ${fmtM(cpTotalEnd)}`,
                `• Collections Today: ${fmtM(cpCollections)}`,
                `• Net Movement: ${cpNetMove>=0?"▲":"▼"} ${fmtM(Math.abs(cpNetMove))}`,
                ...cpBanks.map(b=>`  — ${b.label}: ${fmtM(b.end||b.book||b.beg)}`),
              ]:[`• ⚠️ No cash position logged for today`]),
              ``,
              `━━━━━━━━━━━━━━━━━━━━━━`,
              `📤 <b>BILLING / PAYABLES</b>  ${billStatus==="ok"?"✅":billStatus==="danger"?"🔴":"⚠️"}`,
              `• Unpaid Payables: ${fmtM(totalPayables)}`,
              ...(overduePayables>0?[`• Overdue Payables: ${overduePayables} items — ${fmtM(overduePayablesAmt)}`]:[`• No overdue payables ✅`]),
              ...(unbilledProjects.length>0?[`• Unbilled Projects: ${unbilledProjects.length} awarded with no invoice yet`]:[]),
              `• Contract Backlog: ${fmtM(backlog)}`,
              ``,
              `━━━━━━━━━━━━━━━━━━━━━━`,
              `📈 <b>PROFITABILITY</b>  ${profStatus==="ok"?"✅":profStatus==="danger"?"🔴":"⚠️"}`,
              `• Gross Margin: ${grossMargin}%${grossMargin>=30?" ✅":grossMargin>=20?" ⚠️":" 🔴"}`,
              `• Gross Profit: ${fmtM(grossProfit)}`,
              `• Total Expenses: ${fmtM(totalExpenses)}`,
              `• This Month Revenue: ${fmtM(thisMonthRev)}${revTrend!==0?` (${revTrend>0?"+":""}${revTrend}% vs last month)`:""}`,
              `• Win Rate: ${winRate}% | Avg Deal: ${fmtM(avgDeal)}`,
              ``,
              `━━━━━━━━━━━━━━━━━━━━━━`,
              `🚦 <b>ALERTS</b>`,
              ...digestAlerts.map(a=>`${a.icon} ${a.text}`),
              ``,
              `<i>Sent from FabHub Finance · ${dateStr}</i>`,
            ];
            await sendTelegramNotification("financialcontrol", lines.join("\n"));
            toastEmit("Daily digest sent to Financial Control ✅","success");
          };

          // Section card component (inline)
          const ReviewSection=({icon,title,status,children})=>(
            <div style={{background:statusBg[status],border:`1.5px solid ${statusBorder[status]}`,borderRadius:10,padding:"12px 14px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <span style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>{icon} {title}</span>
                <span style={{fontSize:".68rem",fontWeight:700,color:statusColor[status],background:"#fff",border:`1px solid ${statusBorder[status]}`,borderRadius:20,padding:"2px 8px"}}>{statusLabel[status]}</span>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:3}}>{children}</div>
            </div>
          );
          const Row=({label,value,color})=>(
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:".75rem",color:"#64748b"}}>{label}</span>
              <span style={{fontSize:".78rem",fontWeight:600,color:color||"#0f172a"}}>{value}</span>
            </div>
          );

          return(
            <div>
              {/* KPI Grid Row 1 — Revenue & Profitability */}
              <div style={{marginBottom:8,fontSize:".7rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:"1px"}}>Revenue &amp; Profitability</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:20}}>
                {[
                  {l:"Total Billed",v:fmtPHP(totalBilled),sub:wonDeals.length+" active projects",c:"#3b82f6"},
                  {l:"Gross Margin",v:grossMargin+"%",sub:grossMargin>=25?"✓ Healthy":"⚠ Below target",c:grossMargin>=25?"#059669":"#f59e0b"},
                  {l:"Collected YTD",v:fmtPHP(totalCollected),sub:`${collectionRate}% collection rate`,c:"#10b981"},
                  {l:"Outstanding AR",v:fmtPHP(outstanding),sub:`DSO: ${dso} days`,c:outstanding>0?"#ef4444":"#10b981"},
                ].map(({l,v,sub,c})=>(
                  <div key={l} style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 16px",borderTop:`3px solid ${c}`}}>
                    <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",marginBottom:4}}>{l}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                    <div style={{fontSize:".68rem",color:"#64748b",marginTop:3}}>{sub}</div>
                  </div>
                ))}
              </div>

              {/* KPI Grid Row 2 — Growth & Pipeline */}
              <div style={{marginBottom:8,fontSize:".7rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:"1px"}}>Growth &amp; Pipeline</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:24}}>
                {[
                  {l:"Contract Backlog",v:fmtPHP(backlog),sub:"Awarded, not yet billed",c:"#8b5cf6"},
                  {l:"Pipeline Value",  v:fmtPHP(pipelineVal),sub:"Active deals in progress",c:"#06b6d4"},
                  {l:"Win Rate",        v:winRate+"%",sub:"Last 12 months",c:winRate>=40?"#059669":"#f59e0b"},
                  {l:"Avg Deal Size",   v:fmtPHP(avgDeal),sub:wonDeals.length+" awarded projects",c:"#f97316"},
                ].map(({l,v,sub,c})=>(
                  <div key={l} style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 16px",borderTop:`3px solid ${c}`}}>
                    <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",marginBottom:4}}>{l}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                    <div style={{fontSize:".68rem",color:"#64748b",marginTop:3}}>{sub}</div>
                  </div>
                ))}
              </div>

              {/* Revenue vs Expenses — Last 6 Months */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:"16px 20px",marginBottom:20}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",marginBottom:14}}>📈 Revenue vs Expenses — Last 6 Months</div>
                <div style={{display:"flex",gap:6,alignItems:"flex-end",height:80}}>
                  {months6.map(({label},i)=>(
                    <div key={label} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                      <div style={{width:"100%",display:"flex",gap:2,alignItems:"flex-end",height:60}}>
                        <div style={{flex:1,background:"#3b82f6",borderRadius:"3px 3px 0 0",height:Math.max(2,monthlyRev[i]/maxBar*60)+"px",minHeight:2}} title={`Revenue ₱${Math.round(monthlyRev[i]/1000)}K`}/>
                        <div style={{flex:1,background:"#ef4444",borderRadius:"3px 3px 0 0",height:Math.max(2,monthlyExp[i]/maxBar*60)+"px",minHeight:2}} title={`Expenses ₱${Math.round(monthlyExp[i]/1000)}K`}/>
                      </div>
                      <div style={{fontSize:".6rem",color:"#94a3b8"}}>{label}</div>
                    </div>
                  ))}
                </div>
                <div style={{display:"flex",gap:16,marginTop:8,fontSize:".7rem",color:"#64748b"}}>
                  <span><span style={{display:"inline-block",width:10,height:10,background:"#3b82f6",borderRadius:2,marginRight:4}}/>Revenue Billed</span>
                  <span><span style={{display:"inline-block",width:10,height:10,background:"#ef4444",borderRadius:2,marginRight:4}}/>Expenses</span>
                </div>
              </div>

              {/* Bottom row: Top Clients + Payables Alert */}
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:16}}>
                <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:"16px 20px"}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",marginBottom:12}}>🏆 Top Clients by Collections</div>
                  {topClients.length===0&&<div style={{fontSize:".78rem",color:"#94a3b8"}}>No collection data yet.</div>}
                  {topClients.map(([client,collected],i)=>(
                    <div key={client} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:"1px solid #f1f5f9"}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{width:20,height:20,background:["#f59e0b","#94a3b8","#cd7f32","#64748b","#94a3b8"][i]||"#e2e8f0",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".62rem",fontWeight:800,color:"#fff",flexShrink:0}}>{i+1}</span>
                        <span style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{client}</span>
                      </div>
                      <span style={{fontSize:".82rem",fontWeight:700,color:"#059669"}}>₱{Math.round(collected/1000)}K</span>
                    </div>
                  ))}
                </div>
                <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:"16px 20px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>📤 Payables Summary</div>
                    <button onClick={()=>setFinTab("payables")} style={{fontSize:".72rem",color:"#3b82f6",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>View all →</button>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:8,marginBottom:10}}>
                    <div style={{background:"#fef2f2",borderRadius:8,padding:"10px 12px"}}>
                      <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>Unpaid</div>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:"#ef4444"}}>₱{Math.round(totalPayables/1000)}K</div>
                    </div>
                    <div style={{background:overduePayables>0?"#fff7ed":"#f0fdf4",borderRadius:8,padding:"10px 12px"}}>
                      <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>Overdue</div>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:overduePayables>0?"#f97316":"#059669"}}>{overduePayables>0?`${overduePayables} items`:"None"}</div>
                    </div>
                  </div>
                  {payables.filter(p=>p.status==="Unpaid").slice(0,3).map(p=>(
                    <div key={p.id} style={{display:"flex",justifyContent:"space-between",fontSize:".78rem",padding:"5px 0",borderBottom:"1px solid #f1f5f9"}}>
                      <span style={{color:"#0f172a",fontWeight:600}}>{p.vendor}</span>
                      <span style={{color:p.dueDate&&p.dueDate<today?"#ef4444":"#64748b",fontWeight:700}}>₱{Number(p.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})}</span>
                    </div>
                  ))}
                  {payables.filter(p=>p.status==="Unpaid").length===0&&<div style={{fontSize:".78rem",color:"#94a3b8"}}>No outstanding payables.</div>}
                </div>
              </div>
            </div>
          );
        })()}

        {/* ── CASH POSITION TAB ── */}
        {finTab==="cash"&&role!=="Accounting"&&(
          <>
            {/* Cash Position sub-tabs: Daily / Weekly / Monthly */}
            <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
              {[["daily","📅 Daily"],["weekly","🗓 Weekly"],["monthly","📆 Monthly"]].map(([k,lbl])=>(
                <button key={k} onClick={()=>setCashSub(k)} style={{padding:"8px 18px",border:"none",borderRadius:9,cursor:"pointer",fontFamily:"inherit",fontWeight:cashSub===k?800:600,fontSize:".82rem",background:cashSub===k?"#1f3864":"#eef2f8",color:cashSub===k?"#fff":"#475569"}}>{lbl}</button>
              ))}
            </div>
            {/* Supplier bills moved to their own nav item; this line keeps the
                reminder here, since marking a bill paid lowers Running Payables. */}
            {cashSub==="daily"&&AP_HIDDEN&&(()=>{
              const bal=p=>Math.round(((Number(String(p.amount??"").replace(/,/g,""))||0)-(Number(String(p.paidAmount??"").replace(/,/g,""))||0))*100)/100;
              const open=payables.filter(p=>!["Paid","Cancelled"].includes(p.status)&&bal(p)>0);
              if(!open.length) return null;
              const total=open.reduce((s,p)=>s+bal(p),0);
              return(
                <button onClick={()=>setFinTab("bills")} style={{display:"block",width:"100%",textAlign:"left",marginBottom:14,padding:"10px 14px",border:"1px solid #e2e8f0",borderRadius:10,background:"#fff",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem",color:"#475569"}}>
                  📦 <b style={{color:"#0f172a"}}>{open.length} open supplier bill{open.length>1?"s":""}</b> · ₱{total.toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2})} — mark paid ones before closing the day <span style={{color:"#3b82f6",fontWeight:700}}>→ Supplier Bills</span>
                </button>
              );
            })()}
            {cashSub==="daily"&&(
              <DailyCashPosition cashPositions={cashPositions} saveDayPos={saveDayPos} wonDeals={wonDeals} billings={billings} suppliers={suppliers} subcons={subcons} totRev={totRev} totExp={totExp} totColl={totColl} totOut={totOut} exps={exps} updateMilestone={updateMilestone} upExps={upExps} toSbExpense={toSbExpense} isSupabaseReady={isSupabaseReady} sbUpsert={sbUpsert} vouchers={vouchers} payables={payables} loans={loans} inventory={inventory} userName={session?.name||""} role={role} username={session?.username||""} cashStale={cashStale}/>
            )}
            {cashSub==="weekly"&&(
              <WeeklyCashFlow mode="weekly" cashPositions={cashPositions} billings={billings} exps={exps} chartOfAccounts={chartOfAccounts} setPage={setPage}/>
            )}
            {cashSub==="monthly"&&(
              <WeeklyCashFlow mode="monthly" cashPositions={cashPositions} billings={billings} exps={exps} chartOfAccounts={chartOfAccounts} setPage={setPage}/>
            )}
          </>
        )}

        {/* ── SUPPLIER BILLS TAB ── While the AP is hidden, Finance approves and
            marks PO / WO bills paid here (its own nav item, kept off Cash Position),
            so Running Payables on the Daily Cash Position stays true. */}
        {finTab==="bills"&&AP_HIDDEN&&role!=="Accounting"&&(
          <CashPositionPayables payables={payables} payPays={payPays} prs={prs} deals={deals} today={today}
            canApprove={canApprovePayables} canPay={roleCanInsert("payable_payments")}
            onApprove={approvePayable} onPay={(id,amt,o)=>recordPayablePayment(id,amt,o)} onPayMany={recordPayments} onCancelPay={cancelPayablePayment}/>
        )}

        {/* ── P&L TAB ── */}
        {finTab==="pl"&&role!=="Accounting"&&(
          <>
            <SecHead title="P&L / Income Statement" sub="Revenue, collections, expenses and gross profit"/>
            <PLStatement billings={billings} exps={exps} payables={payables} wonDeals={wonDeals}/>
          </>
        )}

        {/* ── PROJECTS P&L TAB ── */}
        {finTab==="projects"&&role!=="Accounting"&&(()=>{
          const allProj=wonDeals;
          const rows=allProj.map(d=>{
            const ms=billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled");
            const billed=ms.reduce((s,b)=>s+Number(b.amount||0),0);
            const _pa=arSummary(ms,()=>d);
            const collected=_pa.collected;
            // Direct cost on the AP-ledger basis, VAT-ex (costSummary); profit on
            // collections restated VAT-ex so both sides exclude VAT.
            const directExp=costTot.byProject.get(d.id)||0;
            const grossProfit=_pa.collectedBase-directExp;
            const margin=_pa.collectedBase>0?Math.round(grossProfit/_pa.collectedBase*100):null;
            const contractVal=Number(d.value||0);
            const balance=_pa.outstanding;
            return{d,contractVal,billed,collected,directExp,grossProfit,margin,balance};
          }).sort((a,b)=>b.contractVal-a.contractVal);
          const totContract=rows.reduce((s,r)=>s+r.contractVal,0);
          const totBilled=rows.reduce((s,r)=>s+r.billed,0);
          const totCollected=rows.reduce((s,r)=>s+r.collected,0);
          const totExp2=rows.reduce((s,r)=>s+r.directExp,0);
          const totGP=rows.reduce((s,r)=>s+r.grossProfit,0);
          const totMargin=totCollected>0?Math.round(totGP/totCollected*100):0;
          const fmtM=v=>"₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0});
          return(
            <div>
              {/* Summary strip */}
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:20}}>
                {[{l:"Contract Value",v:fmtM(totContract),c:"#3b82f6"},{l:"Total Billed",v:fmtM(totBilled),c:"#8b5cf6"},{l:"Collected",v:fmtM(totCollected),c:"#10b981"},{l:"Direct Costs",v:fmtM(totExp2),c:"#ef4444"},{l:"Gross Profit",v:fmtM(totGP),sub:totMargin+"%",c:totGP>=0?"#059669":"#ef4444"}].map(({l,v,sub,c})=>(
                  <div key={l} style={{background:"#fff",borderRadius:10,border:`1.5px solid ${c}33`,padding:"12px 14px",borderTop:`3px solid ${c}`}}>
                    <div style={{fontSize:".6rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".6px"}}>{l}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:c,marginTop:2}}>{v}</div>
                    {sub&&<div style={{fontSize:".7rem",color:c,fontWeight:700}}>{sub} margin</div>}
                  </div>
                ))}
              </div>
              {/* Table */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{overflowX:"auto"}}>
                <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 80px",background:"#1e293b",padding:"10px 16px",gap:8,minWidth:580}}>
                  {["Project","Contract","Billed","Collected","Direct Costs","Margin"].map(h=>(
                    <div key={h} style={{fontSize:".65rem",fontWeight:700,color:"rgba(255,255,255,.6)",textTransform:"uppercase",letterSpacing:".6px"}}>{h}</div>
                  ))}
                </div>
                {rows.length===0&&<div style={{padding:"24px",textAlign:"center",color:"#94a3b8"}}>No projects yet.</div>}
                {rows.map(({d,contractVal,billed,collected,directExp,grossProfit,margin,balance},i)=>(
                  <div key={d.id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 80px",padding:"11px 16px",gap:8,borderBottom:"1px solid #f1f5f9",background:i%2?"#fafafa":"#fff",alignItems:"center",minWidth:580}}>
                    <div>
                      <div style={{fontWeight:700,color:"#0f172a",fontSize:".84rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                      {d.contact&&<div style={{fontSize:".67rem",color:"#8b5cf6",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>📁 {d.client}</div>}
                      <div style={{fontSize:".65rem",color:"#94a3b8"}}>{d.ceNo||"—"} · {d.stage==="14 · Completed"?<span style={{color:"#059669",fontWeight:700}}>✅ Completed</span>:<span style={{color:"#3b82f6"}}>{d.stage?.replace(/^\d+ · /,"")}</span>}</div>
                    </div>
                    <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{contractVal?fmtM(contractVal):"—"}</div>
                    <div style={{fontSize:".82rem",color:"#8b5cf6"}}>{billed?fmtM(billed):"—"}</div>
                    <div style={{fontSize:".82rem",color:"#10b981",fontWeight:600}}>{collected?fmtM(collected):"—"}</div>
                    <div style={{fontSize:".82rem",color:"#ef4444"}}>{directExp?fmtM(directExp):"—"}</div>
                    <div style={{textAlign:"center"}}>
                      {margin!==null?(
                        <span style={{fontSize:".75rem",fontWeight:800,color:margin>=25?"#059669":margin>=10?"#f59e0b":"#ef4444",background:margin>=25?"#f0fdf4":margin>=10?"#fffbeb":"#fef2f2",borderRadius:20,padding:"3px 8px"}}>{margin}%</span>
                      ):<span style={{color:"#94a3b8",fontSize:".75rem"}}>—</span>}
                    </div>
                  </div>
                ))}
                </div>
              </div>
            </div>
          );
        })()}

        {/* ── PAYABLES TAB ── */}
        {finTab==="payables"&&(()=>{
          const n=v=>Number(v)||0;
          const fmtM=v=>"₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0});
          // PO-derived payables — group by supplier
          const openPOs=prs.filter(p=>["PO Issued","Partially Delivered"].includes(p.status));
          const supplierGroups={};
          openPOs.forEach(pr=>{
            const key=(pr.supplier||"Unknown").trim();
            if(!supplierGroups[key]) supplierGroups[key]={supplier:key,items:[],poNumbers:new Set(),earliestDelivery:null};
            supplierGroups[key].items.push(pr);
            if(pr.poNumber) supplierGroups[key].poNumbers.add(pr.poNumber);
            if(pr.deliveryDate){
              if(!supplierGroups[key].earliestDelivery||pr.deliveryDate<supplierGroups[key].earliestDelivery)
                supplierGroups[key].earliestDelivery=pr.deliveryDate;
            }
          });
          const poPayables=Object.values(supplierGroups).map(g=>({
            ...g,
            poCount:g.poNumbers.size,
            itemCount:g.items.length,
            total:g.items.reduce((s,pr)=>{
              const unitCost=n(pr.actUnitCost)||n(pr.estUnitCost)||n(pr.actualCost)||n(pr.estimatedCost);
              return s+unitCost*n(pr.qty);
            },0)
          })).filter(g=>g.total>0).sort((a,b)=>b.total-a.total);
          const totalPOPayables=poPayables.reduce((s,g)=>s+g.total,0);

          // Balance-aware buckets so a payable can be Partial (part-paid, part-owed),
          // matching the finance team's AP log. balance = amount − paidAmount.
          const bal=p=>Math.max(0,(Number(p.amount)||0)-(Number(p.paidAmount)||0));
          const isSettled=p=>p.status==="Paid";
          const openPay=payables.filter(p=>!isSettled(p));
          const paid=payables.filter(isSettled);
          const unpaid=openPay; // legacy alias used by summary/count below
          // A PO/WO payable is a real liability only once the goods/works are
          // RECEIVED & verified — before that it's a commitment (Awaiting Receipt),
          // not an outstanding balance owed. Manual Other Payables owe immediately.
          const receivedOpen=openPay.filter(p=>!payNeedsVerify(p)||p.verified);
          const awaitingOpen=openPay.filter(p=>payNeedsVerify(p)&&!p.verified);
          const outstandingReceived=receivedOpen.reduce((s,p)=>s+bal(p),0);
          const awaitingReceipt=awaitingOpen.reduce((s,p)=>s+bal(p),0);
          const totalOutstanding=outstandingReceived;
          const grandTotal=outstandingReceived; // owed now — excludes not-yet-received items
          const overdueCount=receivedOpen.filter(p=>p.dueDate&&p.dueDate<today).length;
          const paidThisMonth=paid.filter(p=>p.paidDate?.startsWith(today.slice(0,7))).reduce((s,p)=>s+Number(p.amount||0),0);
          // AP-log filter (All / Unpaid / Partial / Paid) — mirrors Aerwin's chips.
          const apRows=[...payables].sort((a,b)=>String(a.apNumber||"~").localeCompare(String(b.apNumber||"~"))||String(a.dueDate||"9999").localeCompare(String(b.dueDate||"9999")));
          const apFilter=payFilter||"All";
          const projName=id=>{const d=wonDeals.find(x=>x.id===id)||completedDeals.find(x=>x.id===id);return d?(d.contact||d.client):"";};
          const apQ=apLogSearch.trim().toLowerCase();
          const apVisible=apRows.filter(p=>(apFilter==="All"?true:apFilter==="Paid"?isSettled(p):apFilter==="Partial"?p.status==="Partial":(p.status==="Unpaid"||p.status==="Check Issued"))
            &&(!apQ||[p.apNumber,p.poNumber,p.vendor,p.invoiceNumber,p.invoiceRef,p.accountCode,projName(p.projectId)].some(v=>String(v||"").toLowerCase().includes(apQ))))
            // Float payables awaiting approval to the top so nothing sits forgotten in Pending.
            .sort((a,b)=>((a.approvalStatus==="Pending"&&!isSettled(a))?0:1)-((b.approvalStatus==="Pending"&&!isSettled(b))?0:1));
          const PAY_CATS=["Supplier","Subcontractor","Utility","Rent","Labor","Government","Other"];
          return(
            <div>
              {/* ERP bar is already rendered once at the top of the finance page — no duplicate here. */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
                <div>
                  <div style={{fontWeight:700,color:ERP.navy,fontSize:16}}>Accounts Payable</div>
                  <div style={{fontSize:12.5,color:ERP.muted,marginTop:2}}>Track what GMD owes to suppliers, subcontractors, and vendors.</div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                  {(()=>{const miss=payables.filter(p=>p.status!=="Paid"&&p.status!=="Cancelled"&&Number(p.amount)>0&&!p.dueDate).length;
                    return miss>0?<button onClick={()=>setDueDateFixOpen(true)} style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:7,padding:"9px 14px",fontFamily:"inherit",fontSize:13,color:"#b45309",cursor:"pointer",fontWeight:700}}>📅 Set due dates ({miss})</button>:null;})()}
                  <button onClick={()=>{setPayForm(emptyPayForm());setEditPayId(null);setPayModal(true);}}
                    style={{background:ERP.gold,border:"none",borderRadius:7,padding:"9px 16px",fontFamily:"inherit",fontSize:13,color:ERP.navy,cursor:"pointer",fontWeight:600}}>+ Other Payable</button>
                </div>
              </div>
              {/* Summary */}
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(auto-fit,minmax(190px,1fr))",gap:12,marginBottom:20}}>
                <ErpStat tone="warn" label="Outstanding Payables" value={fmtM(outstandingReceived)} foot={receivedOpen.length+" received · owed now"}/>
                <ErpStat tone="purple" label="Awaiting Receipt" value={fmtM(awaitingReceipt)} foot={awaitingOpen.length+" not yet received/verified"}/>
                <ErpStat tone={overdueCount>0?"danger":"ok"} label="Overdue" value={overdueCount+" items"} foot="received & past due"/>
                <ErpStat tone="ok" label="Paid This Month" value={fmtM(paidThisMonth)} foot="settled this month"/>
              </div>
              {/* PO-derived payables — by supplier */}
              {poPayables.length>0&&(
                <div style={{marginBottom:20}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,flexWrap:"wrap"}}>
                    <div style={{fontSize:12.5,fontWeight:700,color:ERP.navy}}>🛒 Supplier Payables — Open POs</div>
                    <ErpBadge kind="invoiced">{poPayables.length} supplier{poPayables.length!==1?"s":""} · {fmtM(totalPOPayables)}</ErpBadge>
                    <input value={supPaySearch} onChange={e=>setSupPaySearch(e.target.value)} placeholder="Search supplier…" style={{marginLeft:"auto",minWidth:180,flex:"0 1 240px",border:`1px solid ${ERP.line}`,borderRadius:7,padding:"6px 11px",fontFamily:"inherit",fontSize:12,outline:"none",color:ERP.ink}}/>
                  </div>
                  <div style={{background:ERP.paper,borderRadius:12,border:`1px solid ${ERP.line}`,overflow:"hidden"}}>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 80px 80px 120px",padding:"9px 10px",background:ERP.navyLight,borderBottom:`2px solid ${ERP.line}`,gap:8}}>
                      {["Supplier","POs","Items","Total Owed"].map((h,i)=>(
                        <div key={i} style={{fontSize:11,fontWeight:700,color:ERP.navy,textTransform:"uppercase",letterSpacing:".5px",textAlign:i===3?"right":i===0?"left":"center"}}>{h}</div>
                      ))}
                    </div>
                    {(()=>{
                      const sq=supPaySearch.trim().toLowerCase();
                      const supVisible=sq?poPayables.filter(g=>String(g.supplier||"").toLowerCase().includes(sq)):poPayables;
                      const supTotal=supVisible.reduce((s,g)=>s+g.total,0);
                      if(supVisible.length===0) return <div style={{padding:"18px 10px",textAlign:"center",color:ERP.muted,fontSize:12.5,fontStyle:"italic"}}>No suppliers match “{supPaySearch}”.</div>;
                      return(<>
                        {supVisible.map((g,idx)=>{
                          const isOverdue=g.earliestDelivery&&g.earliestDelivery<today;
                          return(
                            <div key={g.supplier} style={{display:"grid",gridTemplateColumns:"1fr 80px 80px 120px",padding:"9px 10px",gap:8,alignItems:"center",borderBottom:idx<supVisible.length-1?`1px solid ${ERP.line}`:"none",background:"#fff"}}
                              onMouseEnter={ev=>ev.currentTarget.style.background="#FAFBFD"} onMouseLeave={ev=>ev.currentTarget.style.background="#fff"}>
                              <div>
                                <div style={{fontSize:13,color:ERP.ink,fontWeight:700}}>{g.supplier}</div>
                                {g.earliestDelivery&&<div style={{fontSize:11,color:isOverdue?ERP.danger:ERP.muted,marginTop:1}}>{isOverdue?"⚠ Overdue: ":"Expected: "}{g.earliestDelivery}</div>}
                              </div>
                              <div style={{fontSize:13,color:ERP.muted,textAlign:"center",fontVariantNumeric:"tabular-nums"}}>{g.poCount||g.itemCount}</div>
                              <div style={{fontSize:13,color:ERP.muted,textAlign:"center",fontVariantNumeric:"tabular-nums"}}>{g.itemCount}</div>
                              <div style={{textAlign:"right",fontWeight:700,color:ERP.danger,fontSize:13,fontVariantNumeric:"tabular-nums"}}>{fmtM(g.total)}</div>
                            </div>
                          );
                        })}
                        <div style={{display:"grid",gridTemplateColumns:"1fr 80px 80px 120px",padding:"9px 10px",gap:8,alignItems:"center",background:ERP.navyLight,borderTop:`2px solid ${ERP.line}`}}>
                          <div style={{fontSize:12,fontWeight:700,color:ERP.navy}}>{sq?"Total (filtered)":"Total"}</div>
                          <div/><div/>
                          <div style={{textAlign:"right",fontWeight:800,color:ERP.danger,fontSize:14,fontVariantNumeric:"tabular-nums"}}>{fmtM(supTotal)}</div>
                        </div>
                      </>);
                    })()}
                  </div>
                </div>
              )}
              {/* ── Accounts Payable Log — vendor invoices with aging & balances ── */}
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,flexWrap:"wrap"}}>
                <div style={{fontSize:12.5,fontWeight:700,color:ERP.navy}}>📋 Accounts Payable Log</div>
                <span style={{fontSize:11.5,color:ERP.muted}}>Vendor invoices logged from POs, with aging & balances.</span>
                <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                  {roleCanInsert("payable_payments")&&<button onClick={()=>setMultiPay({vendor:"",sel:{},date:today,method:"Check",bank:"",ref:""})} title="One check or transfer that pays several bills of the same supplier" style={{background:ERP.navy,color:"#fff",border:"none",borderRadius:7,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>Pay several bills</button>}
                  <input value={apLogSearch} onChange={e=>setApLogSearch(e.target.value)} placeholder="Search AP/PO no., vendor, invoice, account…" style={{minWidth:200,flex:"0 1 280px",border:`1px solid ${ERP.line}`,borderRadius:7,padding:"6px 11px",fontFamily:"inherit",fontSize:12,outline:"none",color:ERP.ink}}/>
                  <div style={{display:"flex",gap:5}}>
                    {["All","Unpaid","Partial","Paid"].map(f=>(
                      <button key={f} onClick={()=>setPayFilter(f)} style={{background:apFilter===f?ERP.navy:"#fff",color:apFilter===f?"#fff":ERP.muted,border:`1px solid ${apFilter===f?ERP.navy:ERP.line}`,borderRadius:7,padding:"5px 12px",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>{f}</button>
                    ))}
                  </div>
                </div>
              </div>
              {apRows.length===0&&poPayables.length===0&&<div style={{textAlign:"center",padding:"32px",color:"#94a3b8",fontSize:".84rem"}}>No payables logged yet — issue a PO or add one manually. ✓</div>}
              {apRows.length>0&&(
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",marginBottom:16}}>
                  <div style={{overflowX:"auto"}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,minWidth:960}}>
                      <thead>
                        <tr>
                          {["AP No.","PO No.","Vendor","Account","Invoice No.","Invoice Date","Due Date","Aging","Amount","Paid","Balance","Status","Verification",""].map((h,i)=>(
                            <th key={h+i} style={i>=8&&i<=10?erpThNum:erpTh}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {apVisible.length===0&&<tr><td colSpan={14} style={{padding:"20px",textAlign:"center",color:"#94a3b8",fontSize:".8rem"}}>No {apFilter.toLowerCase()} payables.</td></tr>}
                        {apVisible.map((p,idx)=>{
                          const ag=payableAging(p);
                          const settled=isSettled(p);
                          const balance=bal(p);
                          const paidAmt=Number(p.paidAmount)||0;
                          const stTxt=settled?"Paid":p.status==="Partial"?"Partial":p.status==="Check Issued"?"Check Issued":"Unpaid";
                          const pn=projName(p.projectId);
                          const acct=chartOfAccounts.find(a=>String(a.code)===String(p.accountCode));
                          return(
                            <tr key={p.id}
                              onMouseEnter={ev=>ev.currentTarget.style.background="#FAFBFD"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                              <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{p.apNumber||<span style={{color:ERP.muted,fontWeight:500}} title="The server assigns the number when this syncs">pending</span>}{p.docType==="PRV"&&<div style={{fontSize:10.5,color:ERP.purple,fontWeight:700}}>Payment request</div>}</td>
                              <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{p.poNumber||"—"}</td>
                              <td style={{...erpTd,fontWeight:600,color:ERP.ink,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={p.vendor}>{p.vendor||"—"}{pn&&<div style={{fontSize:11,color:ERP.purple,fontWeight:500}}>📁 {pn}</div>}</td>
                              <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontSize:11.5,color:p.accountCode?ERP.ink:"#cbd5e1",whiteSpace:"nowrap"}} title={acct?`${acct.code} · ${acct.name}`:""}>{p.accountCode||"—"}</td>
                              <td style={{...erpTd,color:ERP.muted,whiteSpace:"nowrap"}}>{p.invoiceNumber||p.invoiceRef||"—"}</td>
                              <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{p.invoiceDate||"—"}</td>
                              <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{p.dueDate||"—"}</td>
                              <td style={{...erpTd,fontWeight:700,color:settled?ERP.muted:ag.clr,whiteSpace:"nowrap"}}>{settled?"—":ag.label}</td>
                              <td style={{...erpTdNum,fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{fmtM(p.amount)}</td>
                              <td style={{...erpTdNum,color:ERP.ok,whiteSpace:"nowrap"}}>{paidAmt>0?<button onClick={()=>setPayHistId(p.id)} title="Payment history" style={{background:"none",border:"none",padding:0,cursor:"pointer",color:"inherit",font:"inherit",textAlign:"right"}}>{fmtM(paidAmt)}{Number(p.amount)>0&&<div style={{fontSize:11,color:ERP.muted}}>{Math.round(paidAmt/Number(p.amount)*100)}%</div>}</button>:"—"}{(Number(p.retentionHeld)||0)>0&&<div style={{fontSize:10.5,color:"#b45309",fontWeight:700}} title="Retention held back from progress payments">Ret. {fmtM(Number(p.retentionHeld))}</div>}</td>
                              <td style={{...erpTdNum,fontWeight:700,color:balance>0?ERP.danger:ERP.muted,whiteSpace:"nowrap"}}>{fmtM(balance)}</td>
                              <td style={{...erpTd,whiteSpace:"nowrap"}}><ErpBadge kind={erpStatusKind(stTxt)}>{stTxt}</ErpBadge>{!settled&&p.approvalStatus==="Pending"&&<div style={{fontSize:10.5,fontWeight:800,color:"#b45309",marginTop:2}}>⏳ For approval</div>}{p.approvalStatus==="Rejected"&&<div style={{fontSize:10.5,fontWeight:800,color:ERP.danger,marginTop:2}}>✕ Rejected</div>}{p.approvalStatus==="Approved"&&p.approvedBy&&<div style={{fontSize:10,color:ERP.muted,marginTop:2}} title={`Approved by ${p.approvedBy}${p.approvedAt?" · "+p.approvedAt:""}`}>✓ {p.approvedBy}</div>}</td>
                              {(()=>{
                                const needV=payNeedsVerify(p),isSub=payIsSubcon(p);
                                return(
                                  <td style={{...erpTd,whiteSpace:"nowrap"}}>
                                    {!needV
                                      ? <span style={{fontSize:11,color:ERP.muted}}>—</span>
                                      : p.verified
                                        ? <ErpBadge kind="paid">{isSub?`${Number(p.verificationPct||0)}% Verified`:"Verified"}</ErpBadge>
                                        : <ErpBadge kind="unpaid">{isSub?"Pending (Operations)":"Pending (Warehouse)"}</ErpBadge>}
                                  </td>
                                );
                              })()}
                              <td style={{...erpTd,whiteSpace:"nowrap"}}>
                                <div style={{display:"flex",gap:4,justifyContent:"flex-end",alignItems:"center"}}>
                                  {!settled&&p.approvalStatus==="Pending"&&(canApprovePayables
                                    ? <><button onClick={()=>approvePayable(p.id)} title="Approve for payment (Manager / Finance)" style={{background:ERP.ok||"#16a34a",border:"none",borderRadius:6,padding:"4px 10px",fontSize:".7rem",color:"#fff",cursor:"pointer",fontWeight:800,fontFamily:"inherit"}}>✓ Approve</button>
                                        <button onClick={()=>rejectPayable(p.id)} title="Reject" style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#dc2626",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>Reject</button></>
                                    : <span title="Awaiting Manager / Finance approval" style={{fontSize:11,fontWeight:700,color:"#b45309",whiteSpace:"nowrap"}}>⏳ For approval</span>)}
                                  {!settled&&p.approvalStatus==="Rejected"&&<span title={p.notes||"Rejected"} style={{fontSize:11,fontWeight:700,color:ERP.danger,whiteSpace:"nowrap"}}>✕ Rejected</span>}
                                  {!settled&&payNeedsVerify(p)&&!p.verified&&<button onClick={()=>verifyPayable(p.id)} title={payIsSubcon(p)?"Operations: verify % complete":"Warehouse: verify receipt"} style={{background:ERP.gold,border:"none",borderRadius:6,padding:"4px 10px",fontSize:".7rem",color:ERP.navy,cursor:"pointer",fontWeight:800,fontFamily:"inherit"}}>✓ Verify</button>}
                                  {!settled&&balance>0&&payApproved(p)&&(!payNeedsVerify(p)||p.verified)&&(!payIsSubcon(p)||(Number(p.amount)||0)-payableClaimed(p)>0.005)&&<button onClick={()=>openPayModal(p)} style={{background:"#f59e0b",border:"none",borderRadius:6,padding:"4px 12px",fontSize:".7rem",color:"#fff",cursor:"pointer",fontWeight:800,fontFamily:"inherit"}}>Pay</button>}
                                  {(Number(p.retentionHeld)||0)>0&&payApproved(p)&&(!payNeedsVerify(p)||(Number(p.verificationPct)||0)>=100)&&<button onClick={()=>openRetentionRelease(p)} title="Release the retention held on this subcontractor bill" style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#b45309",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>Release ret.</button>}
                                  {(paysOf(p.id).length>0||paidAmt>0)&&<button onClick={()=>setPayHistId(p.id)} title="Payment history" style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>History</button>}
                                  {!settled&&payApproved(p)&&(!payNeedsVerify(p)||p.verified)&&!(p.cvId||p.status==="Check Issued")&&<button onClick={()=>payableToCheck(p.id)} title="Route to Check Voucher" style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#2563eb",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>🖊 CV</button>}
                                  <button onClick={()=>{setPayForm({...p});setEditPayId(p.id);setPayModal(true);}} style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏</button>
                                  <button onClick={()=>delPayable(p.id)} style={{background:"#fef2f2",border:"none",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>✕</button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {/* Add/Edit Payable Modal */}
              <Modal open={payModal} onClose={()=>{setPayModal(false);setEditPayId(null);}} title={editPayId?(payForm.docType==="PRV"?"Edit Payment Request":"Edit Other Payable"):(payForm.docType==="PRV"?"New Payment Request (PRV)":"New Other Payable")}>
                {editPayId&&payForm.apNumber&&<div style={{fontSize:".72rem",color:"#6366f1",fontWeight:700,fontFamily:"monospace",marginBottom:8}}>{payForm.apNumber}{payForm.poNumber?` · PO ${payForm.poNumber}`:""}</div>}
                <Fld label="Type">
                  <Sel value={payForm.docType==="PRV"?"PRV":"AP"} onChange={e=>setPayForm(p=>({...p,docType:e.target.value}))} disabled={!!(editPayId&&payForm.apNumber)}>
                    <option value="AP">Supplier bill (AP)</option>
                    <option value="PRV">Payment request, no PO (PRV)</option>
                  </Sel>
                  {!editPayId&&<div style={{fontSize:".72rem",color:"#64748b",marginTop:3}}>The {payForm.docType==="PRV"?"PRV":"AP"} number is assigned by the server when it saves, so two people can never get the same number.</div>}
                </Fld>
                <Fld label="Vendor / Payee"><Inp value={payForm.vendor||""} onChange={e=>setPayForm(p=>({...p,vendor:e.target.value}))} placeholder="e.g. ABC Steel Supply"/></Fld>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <Fld label="Invoice No."><Inp value={payForm.invoiceNumber||""} onChange={e=>setPayForm(p=>({...p,invoiceNumber:e.target.value}))} placeholder="Vendor invoice #"/></Fld>
                  <Fld label="Invoice Date"><Inp type="date" value={payForm.invoiceDate||""} onChange={e=>setPayForm(p=>({...p,invoiceDate:e.target.value}))}/></Fld>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <Fld label="Amount (₱)" required><Inp type="number" value={payForm.amount} onChange={e=>setPayForm(p=>({...p,amount:e.target.value}))} placeholder="0"/></Fld>
                  <Fld label="Already Paid (₱)"><Inp type="number" value={payForm.paidAmount} onChange={e=>setPayForm(p=>({...p,paidAmount:e.target.value}))} placeholder="0"/></Fld>
                </div>
                <Fld label="Due Date" required>
                  <Inp type="date" value={payForm.dueDate||""} onChange={e=>setPayForm(p=>({...p,dueDate:e.target.value}))}/>
                  {payForm.dueDate&&payForm.dueDate<today&&<div style={{fontSize:".72rem",color:"#ef4444",marginTop:3,fontWeight:600}}>⚠ Due date is in the past — this payable is already overdue.</div>}
                  {!payForm.dueDate&&<div style={{fontSize:".72rem",color:"#b45309",marginTop:3,fontWeight:600}}>Recommended — drives the cash-flow forecast.</div>}
                </Fld>
                <Fld label="Category"><Sel value={payForm.category} onChange={e=>setPayForm(p=>({...p,category:e.target.value}))}>{["Supplier","Subcontractor","Utility","Rent","Labor","Government","Other"].map(c=><option key={c}>{c}</option>)}</Sel></Fld>
                <Fld label="Account (Chart of Accounts)" required>
                  <Sel value={payForm.accountCode||""} onChange={e=>setPayForm(p=>({...p,accountCode:e.target.value}))}>
                    <option value="">— Select account —</option>
                    {[...chartOfAccounts].filter(a=>a.active!==false&&(a.type==="COGS"||a.type==="Expense"||a.type==="Asset")).sort((a,b)=>String(a.code).localeCompare(String(b.code))).map(a=><option key={a.id||a.code} value={a.code}>{a.code} · {a.name}</option>)}
                  </Sel>
                  {!payForm.accountCode&&<div style={{fontSize:".72rem",color:"#b45309",marginTop:3,fontWeight:600}}>Required — this drives the account-code financial statements.</div>}
                </Fld>
                {payForm.docType==="PRV"&&isSubconPayable(payForm)&&(
                  <Fld label="Work order">
                    <Sel value={payForm.poNumber||""} onChange={e=>setPayForm(p=>({...p,poNumber:e.target.value}))}>
                      <option value="">— None —</option>
                      {(swos||[]).filter(w=>w.woNumber&&w.status!=="Cancelled").slice().sort((a,b)=>String(b.woNumber).localeCompare(String(a.woNumber))).map(w=><option key={w.id||w.woNumber} value={w.woNumber}>{w.woNumber} · {w.subcontractor||"—"} · {fmtM(Number(w.contractAmount)||0)}</option>)}
                    </Sel>
                    {subconNeedsWo(payForm)&&<div style={{fontSize:".72rem",color:"#b91c1c",marginTop:3,fontWeight:600}}>Required: subcontractor payment requests of ₱{AP_RULES.subconNoWoLimit.toLocaleString("en-PH")} or more need a Work Order.</div>}
                    {payForm.poNumber&&<div style={{fontSize:".72rem",color:"#64748b",marginTop:3}}>Payment waits for Operations to verify % complete. Retention is held at payment.</div>}
                  </Fld>
                )}
                <Fld label="Link to Project"><Sel value={payForm.projectId||"none"} onChange={e=>setPayForm(p=>({...p,projectId:e.target.value==="none"?null:e.target.value}))}><option value="none">— No project</option>{wonDeals.map(d=><option key={d.id} value={d.id}>{d.client}{d.contact?" — "+d.contact:""}</option>)}{costCenterDeals.length>0&&<optgroup label="Cost centers">{costCenterDeals.map(d=><option key={d.id} value={d.id}>🏷 {d.contact||d.client}</option>)}</optgroup>}</Sel></Fld>
                {/* BIR: VAT + EWT capture (restored from the legacy expense flow) */}
                {(()=>{
                  const amt=Number(payForm.amount)||0;
                  const net=payForm.vatable?Math.round(amt/1.12*100)/100:amt;
                  const iv=payForm.vatable?Math.round((amt-net)*100)/100:0;
                  const er=Number(payForm.ewtRate)||0;
                  const ewt=er>0?Math.round(net*er/100*100)/100:0;
                  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
                  return(
                    <div style={{border:`1px solid ${ERP.line}`,borderRadius:8,padding:"10px 12px",marginBottom:12,background:"#FAFBFD"}}>
                      <div style={{fontSize:".7rem",fontWeight:800,color:ERP.navy,textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>BIR — VAT / Withholding</div>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                        <label style={{display:"flex",alignItems:"center",gap:8,fontSize:".8rem",color:"#334155",fontWeight:600,cursor:"pointer"}}>
                          <input type="checkbox" checked={!!payForm.vatable} onChange={e=>setPayForm(p=>({...p,vatable:e.target.checked}))} style={{width:16,height:16}}/>
                          VAT-inclusive (12%)
                        </label>
                        <Fld label="EWT Rate"><Sel value={String(payForm.ewtRate||0)} onChange={e=>setPayForm(p=>({...p,ewtRate:Number(e.target.value)}))}>{[["0","None"],["1","1%"],["2","2% (services/goods)"],["5","5%"],["10","10% (rental/pro.)"],["15","15%"]].map(([v,l])=><option key={v} value={v}>{l}</option>)}</Sel></Fld>
                      </div>
                      <Fld label="Supplier TIN"><Inp value={payForm.tin||""} onChange={e=>setPayForm(p=>({...p,tin:e.target.value}))} placeholder="000-000-000-000"/></Fld>
                      <div style={{display:"flex",gap:16,flexWrap:"wrap",fontSize:".74rem",color:ERP.muted,marginTop:4}}>
                        <span>Net: <strong style={{color:ERP.ink}}>{peso(net)}</strong></span>
                        {payForm.vatable&&<span>Input VAT: <strong style={{color:ERP.navy}}>{peso(iv)}</strong></span>}
                        {er>0&&<span>EWT ({er}%): <strong style={{color:ERP.danger}}>−{peso(ewt)}</strong></span>}
                        {er>0&&<span>Net of EWT: <strong style={{color:ERP.ink}}>{peso(amt-ewt)}</strong></span>}
                      </div>
                    </div>
                  );
                })()}
                <Fld label="Notes"><Inp value={payForm.notes||""} onChange={e=>setPayForm(p=>({...p,notes:e.target.value}))} placeholder="Optional details"/></Fld>
                <div style={{display:"flex",gap:10,marginTop:18}}>
                  <Btn full variant="green" onClick={()=>savePayable(payForm)}>Save Payable</Btn>
                  <Btn variant="ghost" onClick={()=>{setPayModal(false);setEditPayId(null);}}>Cancel</Btn>
                </div>
              </Modal>
              {/* Record-Payment modal: full / partial payment, subcontractor progress
                  claim with retention, or retention release. Every save is a row in
                  payable_payments (see recordPayments). */}
              {(()=>{
                const p=payables.find(x=>x.id===payPayId);
                if(!p) return null;
                const contract=Number(p.amount)||0;
                const paid=Number(p.paidAmount)||0;
                const balance=Math.max(0,Math.round((contract-paid)*100)/100);
                const held=Number(p.retentionHeld)||0;
                const sub=payIsSubcon(p);
                const release=payPayKind==="Retention release";
                const {pct:retPct,source:retSrc}=payableRetentionPct(p,swos);
                const claimed=payableClaimed(p);
                const leftToClaim=Math.max(0,Math.round((contract-claimed)*100)/100);
                const entered=Math.round((Number(payPayAmt)||0)*100)/100;
                // Subcontractor progress claim: the entered figure is the GROSS claim;
                // retention is held back from it and the rest is paid now.
                const retention=(sub&&!release&&!payPayDP)?Math.round(entered*retPct/100*100)/100:0;
                const cash=release?held:Math.round((entered-retention)*100)/100;
                const verifiedCap=(Number(p.verificationPct)||0)/100*contract;
                const overVerified=sub&&!release&&payNeedsVerify(p)&&claimed+entered>verifiedCap+0.005;
                const releaseBlocked=release&&payNeedsVerify(p)&&(Number(p.verificationPct)||0)<100;
                const overLimit=release?false:(sub?entered>leftToClaim+0.005:entered>balance+0.005);
                const noRef=payPayMethod==="Check"&&!String(payPayRef).trim();
                const invalid=!(cash>0)||overLimit||!payPayBank||!payPayDate||noRef||releaseBlocked||(release&&!(held>0));
                const pctPaidSoFar=contract>0?Math.round(paid/contract*100):0;
                const history=paysOf(p.id).slice().sort((a,b)=>String(b.payDate).localeCompare(String(a.payDate)));
                const close=()=>{setPayPayId(null);setPayPayAmt("");setPayPayMode("amount");setPayPayPct("");setPayPayBank("");setPayPayMethod("Online Transfer");setPayPayRef("");setPayPayDate("");setPayPayDP(false);setPayPayKind("Payment");};
                const base=sub?contract:contract; // % is always of the full contract
                const setFromPct=(v)=>{setPayPayPct(v);const q=Number(v)||0;setPayPayAmt(q>0?String(Math.round(base*q/100*100)/100):"");};
                const chip={border:"1px solid #bfdbfe",background:"#eff6ff",color:"#1d4ed8",borderRadius:6,padding:"4px 10px",fontSize:".72rem",cursor:"pointer",fontWeight:700,fontFamily:"inherit"};
                return(
                  <Modal open={!!payPayId} onClose={close} title={release?"Release Retention":"Record Payment"}>
                    <div style={{background:"#f8fafc",borderRadius:10,padding:"12px 14px",marginBottom:14,fontSize:".82rem"}}>
                      <div style={{fontWeight:700,color:"#0f172a"}}>{p.vendor||"Payable"}</div>
                      <div style={{color:"#64748b",marginTop:3}}>{p.apNumber||""}{p.poNumber?` · ${p.poNumber}`:""}{p.docType==="PRV"?" · Payment request":""}</div>
                      <div style={{marginTop:6,display:"flex",gap:16,flexWrap:"wrap"}}>
                        <span style={{color:"#64748b"}}>Contract <strong style={{color:"#0f172a"}}>{fmtM(contract)}</strong></span>
                        <span style={{color:"#64748b"}}>Paid <strong style={{color:"#059669"}}>{fmtM(paid)} ({pctPaidSoFar}%)</strong></span>
                        {held>0&&<span style={{color:"#64748b"}}>Retention held <strong style={{color:"#b45309"}}>{fmtM(held)}</strong></span>}
                        <span style={{color:"#64748b"}}>Balance <strong style={{color:"#b91c1c"}}>{fmtM(balance)}</strong></span>
                      </div>
                      {sub&&payNeedsVerify(p)&&<div style={{marginTop:6,color:"#64748b"}}>Operations verified <strong style={{color:"#0f172a"}}>{Number(p.verificationPct)||0}%</strong> complete</div>}
                    </div>
                    {release?(
                      <div style={{marginBottom:12,fontSize:".82rem",color:"#334155"}}>
                        Pays out the full retention held: <strong>{fmtM(held)}</strong>.
                        {releaseBlocked&&<div style={{marginTop:6,color:"#b91c1c",fontWeight:600}}>Operations must verify this work 100% complete before retention is released.</div>}
                      </div>
                    ):(
                      <>
                        <div style={{display:"flex",gap:6,marginBottom:12}}>
                          {[["amount","₱ Amount"],["pct","% of contract"]].map(([m,l])=>(
                            <button key={m} onClick={()=>{setPayPayMode(m);setPayPayPct("");if(m==="amount")setPayPayAmt(String(sub?leftToClaim:balance));else setPayPayAmt("");}} style={{flex:1,background:payPayMode===m?"#1e293b":"#fff",color:payPayMode===m?"#fff":"#475569",border:`1.5px solid ${payPayMode===m?"#1e293b":"#e2e8f0"}`,borderRadius:8,padding:"7px 10px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,cursor:"pointer"}}>{l}</button>
                          ))}
                        </div>
                        {payPayMode==="amount"?(
                          <>
                            <Fld label={sub?"Progress claim, gross (₱)":"Payment amount (₱)"} required>
                              <Inp type="number" value={payPayAmt} onChange={e=>setPayPayAmt(e.target.value)} placeholder="0"/>
                            </Fld>
                            <div style={{display:"flex",gap:6,marginBottom:6}}>
                              <button onClick={()=>setPayPayAmt(String(sub?leftToClaim:balance))} style={chip}>{sub?"Rest of contract":"Full balance"}</button>
                              <button onClick={()=>setPayPayAmt(String(Math.round((sub?leftToClaim:balance)/2*100)/100))} style={{...chip,background:"#f1f5f9",border:"1px solid #e2e8f0",color:"#475569"}}>Half</button>
                            </div>
                          </>
                        ):(
                          <>
                            <Fld label="Progress payment (% of contract)" required>
                              <Inp type="number" value={payPayPct} onChange={e=>setFromPct(e.target.value)} placeholder="e.g. 30"/>
                              {entered>0&&<div style={{fontSize:".78rem",color:"#0f172a",marginTop:4,fontWeight:600}}>= {fmtM(entered)} <span style={{color:"#94a3b8",fontWeight:400}}>of {fmtM(contract)} contract</span></div>}
                            </Fld>
                            <div style={{display:"flex",gap:6,marginBottom:6,flexWrap:"wrap"}}>
                              {[10,25,30,50].map(q=><button key={q} onClick={()=>setFromPct(String(q))} style={chip}>{q}%</button>)}
                            </div>
                          </>
                        )}
                        {sub&&retPct===0&&<div style={{fontSize:".74rem",color:"#64748b",margin:"6px 0"}}>No retention on this bill ({retSrc}).</div>}
                        {sub&&retPct>0&&(
                          <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"10px 12px",margin:"8px 0",fontSize:".8rem",color:"#78350f"}}>
                            <label style={{display:"flex",gap:8,alignItems:"center",cursor:"pointer",fontWeight:600}}>
                              <input type="checkbox" checked={payPayDP} onChange={e=>setPayPayDP(e.target.checked)}/> This is the downpayment (no retention)
                            </label>
                            <div style={{marginTop:6,display:"flex",gap:14,flexWrap:"wrap"}}>
                              <span>Retention {payPayDP?"0":retPct}% <span style={{color:"#a16207"}}>({payPayDP?"downpayment":retSrc})</span>: <strong>{fmtM(retention)}</strong></span>
                              <span>Pay now: <strong>{fmtM(cash)}</strong></span>
                            </div>
                          </div>
                        )}
                        {overLimit&&<div style={{fontSize:".72rem",color:"#ef4444",marginTop:3,fontWeight:600}}>⚠ {fmtM(entered)} is more than {sub?`the ${fmtM(leftToClaim)} left to claim on this contract`:`the outstanding balance of ${fmtM(balance)}`}.</div>}
                        {overVerified&&<div style={{fontSize:".72rem",color:"#b45309",marginTop:3,fontWeight:600}}>⚠ This brings claims to {contract>0?Math.round((claimed+entered)/contract*100):0}% of the contract, above the {Number(p.verificationPct)||0}% Operations has verified. Confirm the work is done before paying.</div>}
                      </>
                    )}
                    <div style={{borderTop:`1px solid ${ERP.line}`,marginTop:12,paddingTop:12}}>
                      <div style={{fontSize:".7rem",fontWeight:800,color:ERP.navy,textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Payment Details</div>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                        <Fld label="Payment date" required><Inp type="date" value={payPayDate} onChange={e=>setPayPayDate(e.target.value)}/></Fld>
                        <Fld label="Paid from (Bank / Account)" required>
                          <Sel value={payPayBank} onChange={e=>setPayPayBank(e.target.value)}>
                            <option value="">— Select —</option>
                            {(BANKS||[]).map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
                          </Sel>
                        </Fld>
                        <Fld label="Payment Method">
                          <Sel value={payPayMethod} onChange={e=>setPayPayMethod(e.target.value)}>
                            {["Online Transfer","Cash","Check"].map(m=><option key={m}>{m}</option>)}
                          </Sel>
                        </Fld>
                        <Fld label={payPayMethod==="Check"?"Check no.":"Reference No."} required={payPayMethod==="Check"}><Inp value={payPayRef} onChange={e=>setPayPayRef(e.target.value)} placeholder={payPayMethod==="Check"?"e.g. 087856":"Transfer / OR no."}/></Fld>
                      </div>
                      {(!payPayBank||!payPayDate||noRef)&&<div style={{fontSize:".72rem",color:"#b45309",fontWeight:600}}>{!payPayDate?"Enter the payment date. ":""}{!payPayBank?"Select the bank/account. ":""}{noRef?"Enter the check number.":""}</div>}
                    </div>
                    <div style={{display:"flex",gap:10,marginTop:14}}>
                      <Btn full variant="green" disabled={invalid} onClick={async()=>{if(invalid)return;
                        const ok=await recordPayments([{payableId:p.id,amount:cash,retentionAmount:retention,kind:release?"Retention release":"Payment"}],{date:payPayDate,method:payPayMethod,bank:payPayBank,ref:payPayRef,note:sub&&!release&&payPayDP?"Downpayment (no retention)":""});
                        if(ok) close();}}>{release?"Release Retention":"Record Payment"}</Btn>
                      <Btn variant="ghost" onClick={close}>Cancel</Btn>
                    </div>
                    {history.length>0&&(
                      <div style={{borderTop:`1px solid ${ERP.line}`,marginTop:14,paddingTop:10}}>
                        <div style={{fontSize:".7rem",fontWeight:800,color:ERP.navy,textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Payment history</div>
                        <PayHistoryList rows={history} onCancel={cancelPayablePayment} canCancel={roleCanInsert("payable_payments")}/>
                      </div>
                    )}
                  </Modal>
                );
              })()}
              {/* Payment history for one bill (read + cancel) */}
              {(()=>{
                const p=payables.find(x=>x.id===payHistId);
                if(!p) return null;
                const rows=paysOf(p.id).slice().sort((a,b)=>String(b.payDate).localeCompare(String(a.payDate)));
                return(
                  <Modal open={!!payHistId} onClose={()=>setPayHistId(null)} title="Payment history">
                    <div style={{fontSize:".82rem",marginBottom:10}}>
                      <div style={{fontWeight:700,color:"#0f172a"}}>{p.vendor||"Payable"}</div>
                      <div style={{color:"#64748b",marginTop:3}}>{p.apNumber||""}{p.poNumber?` · ${p.poNumber}`:""} · Contract {fmtM(Number(p.amount)||0)} · Paid {fmtM(Number(p.paidAmount)||0)}{(Number(p.retentionHeld)||0)>0?` · Retention held ${fmtM(Number(p.retentionHeld))}`:""}</div>
                    </div>
                    {rows.length?<PayHistoryList rows={rows} onCancel={cancelPayablePayment} canCancel={roleCanInsert("payable_payments")}/>:<div style={{fontSize:".82rem",color:"#64748b"}}>No payments recorded yet.</div>}
                    {(Number(p.retentionHeld)||0)>0&&payApproved(p)&&(!payNeedsVerify(p)||(Number(p.verificationPct)||0)>=100)&&<div style={{marginTop:12}}><Btn variant="ghost" onClick={()=>{setPayHistId(null);openRetentionRelease(p);}}>Release retention ({fmtM(Number(p.retentionHeld))})</Btn></div>}
                  </Modal>
                );
              })()}
              {/* One check / transfer paying several bills of the same vendor */}
              {multiPay&&(()=>{
                const norm=s=>String(s||"").trim().toLowerCase();
                const vendors=[...new Set(payables.filter(p=>p.status!=="Paid"&&payApproved(p)&&!payIsSubcon(p)).map(p=>p.vendor||"").filter(Boolean))].sort((a,b)=>a.localeCompare(b));
                const open=payables.filter(p=>norm(p.vendor)===norm(multiPay.vendor)&&p.vendor&&(Number(p.amount)||0)-(Number(p.paidAmount)||0)>0.005);
                const bal=p=>Math.round(((Number(p.amount)||0)-(Number(p.paidAmount)||0))*100)/100;
                const payableNow=p=>payApproved(p)&&(!payNeedsVerify(p)||p.verified)&&!payIsSubcon(p);
                const sel=multiPay.sel||{};
                const picked=open.filter(p=>sel[p.id]!=null&&payableNow(p));
                const total=picked.reduce((s,p)=>s+(Number(sel[p.id])||0),0);
                const bad=picked.some(p=>!(Number(sel[p.id])>0)||Number(sel[p.id])>bal(p)+0.005);
                const noRef=multiPay.method==="Check"&&!String(multiPay.ref||"").trim();
                const invalid=!picked.length||bad||!multiPay.bank||!multiPay.date||noRef;
                const set=patch=>setMultiPay(m=>({...m,...patch}));
                return(
                  <Modal open onClose={()=>setMultiPay(null)} title="Pay several bills at once">
                    <div style={{fontSize:".8rem",color:"#475569",marginBottom:10}}>One check or transfer that covers several bills of the same supplier. Each bill gets its own line in its payment history, linked to this one payment. Subcontractor bills are paid one at a time because of retention.</div>
                    <Fld label="Supplier" required>
                      <Sel value={multiPay.vendor||""} onChange={e=>set({vendor:e.target.value,sel:{}})}>
                        <option value="">— Select supplier —</option>
                        {vendors.map(v=><option key={v} value={v}>{v}</option>)}
                      </Sel>
                    </Fld>
                    {multiPay.vendor&&(
                      <div style={{border:`1px solid ${ERP.line}`,borderRadius:8,overflowX:"auto",margin:"6px 0 10px"}}>
                        <table style={{width:"100%",borderCollapse:"collapse",fontSize:".78rem"}}>
                          <thead><tr style={{background:"#f8fafc",color:"#64748b",textAlign:"left"}}><th style={{padding:"6px 8px"}}></th><th style={{padding:"6px 8px"}}>Bill</th><th style={{padding:"6px 8px",textAlign:"right"}}>Balance</th><th style={{padding:"6px 8px",textAlign:"right"}}>Pay</th></tr></thead>
                          <tbody>
                            {open.map(p=>{const ok=payableNow(p);const on=sel[p.id]!=null;return(
                              <tr key={p.id} style={{borderTop:`1px solid ${ERP.line}`,opacity:ok?1:.55}}>
                                <td style={{padding:"6px 8px"}}><input type="checkbox" disabled={!ok} checked={on} aria-label={`Include ${p.apNumber||p.invoiceNumber||"bill"}`} onChange={e=>{const n={...sel};if(e.target.checked)n[p.id]=String(bal(p));else delete n[p.id];set({sel:n});}}/></td>
                                <td style={{padding:"6px 8px"}}><div style={{fontWeight:600,color:"#0f172a"}}>{p.invoiceNumber||p.invoiceRef||p.poNumber||"—"}</div><div style={{color:"#94a3b8"}}>{p.apNumber||""}{!ok?(payIsSubcon(p)?" · subcontractor: pay singly":!payApproved(p)?" · not approved":" · not verified"):""}</div></td>
                                <td style={{padding:"6px 8px",textAlign:"right",fontVariantNumeric:"tabular-nums"}}>{fmtM(bal(p))}</td>
                                <td style={{padding:"6px 8px",textAlign:"right"}}>{on?<input type="number" value={sel[p.id]} aria-label="Amount to pay" onChange={e=>set({sel:{...sel,[p.id]:e.target.value}})} style={{width:110,textAlign:"right",border:`1px solid ${Number(sel[p.id])>bal(p)+0.005?"#ef4444":"#e2e8f0"}`,borderRadius:6,padding:"4px 6px",fontFamily:"inherit"}}/>:"—"}</td>
                              </tr>);})}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                      <Fld label="Payment date" required><Inp type="date" value={multiPay.date||""} onChange={e=>set({date:e.target.value})}/></Fld>
                      <Fld label="Paid from (Bank / Account)" required>
                        <Sel value={multiPay.bank||""} onChange={e=>set({bank:e.target.value})}>
                          <option value="">— Select —</option>
                          {(BANKS||[]).map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
                        </Sel>
                      </Fld>
                      <Fld label="Payment Method">
                        <Sel value={multiPay.method||"Check"} onChange={e=>set({method:e.target.value})}>
                          {["Check","Online Transfer","Cash"].map(m=><option key={m}>{m}</option>)}
                        </Sel>
                      </Fld>
                      <Fld label={(multiPay.method||"Check")==="Check"?"Check no.":"Reference No."} required={(multiPay.method||"Check")==="Check"}><Inp value={multiPay.ref||""} onChange={e=>set({ref:e.target.value})} placeholder="e.g. 087856"/></Fld>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"8px 0",fontSize:".85rem"}}>
                      <span style={{color:"#64748b"}}>{picked.length} bill{picked.length===1?"":"s"} selected</span>
                      <strong style={{color:"#0f172a"}}>Total {fmtM(total)}</strong>
                    </div>
                    {bad&&<div style={{fontSize:".72rem",color:"#ef4444",fontWeight:600}}>Each amount must be more than 0 and no more than that bill's balance.</div>}
                    <div style={{display:"flex",gap:10,marginTop:10}}>
                      <Btn full variant="green" disabled={invalid} onClick={async()=>{if(invalid)return;
                        const ok=await recordPayments(picked.map(p=>({payableId:p.id,amount:Number(sel[p.id])})),{date:multiPay.date,method:multiPay.method||"Check",bank:multiPay.bank,ref:multiPay.ref});
                        if(ok) setMultiPay(null);}}>Record payment for {picked.length||"—"} bill{picked.length===1?"":"s"}</Btn>
                      <Btn variant="ghost" onClick={()=>setMultiPay(null)}>Cancel</Btn>
                    </div>
                  </Modal>
                );
              })()}
            </div>
          );
        })()}
        {finTab==="payments"&&(()=>{
          // Payment History — every payment that coursed through Finance, unified
          // from released/cleared check vouchers (Check channel) and direct
          // payable settlements with no linked voucher (Online/Cash channel).
          const N=v=>Number(v)||0;
          const bankName=b=>{const x=(BANKS||[]).find(y=>y.id===b||y.short===b||y.name===b);return x?x.name:(b||"—");};
          const apOf=v=>v.apRef||(payables.find(p=>p.id===v.payableId)||{}).apNumber||"—";
          const cvPays=vouchers.filter(v=>v.status==="Released"||v.isCleared).map(v=>({
            id:"cv-"+v.id,date:v.releasedDate||v.date||"",apNo:apOf(v),vendor:v.payee||"—",
            channel:"Check",bank:bankName(v.bank),ref:v.checkNo?("Check #"+v.checkNo):"—",
            amount:N(v.amount),cvId:v.id,cleared:v.isCleared,
          }));
          const directPays=payables.filter(p=>!p.cvId&&p.status!=="Check Issued"&&N(p.paidAmount)>0).map(p=>({
            id:"ap-"+p.id,date:p.paidDate||"",apNo:p.apNumber||"—",vendor:p.vendor||"—",
            channel:p.payMethod==="Check"?"Check":p.payMethod==="Cash"?"Cash":"Online",bank:bankName(p.payBank)||"—",ref:p.payRef||p.invoiceNumber||p.invoiceRef||"—",
            amount:N(p.paidAmount),cvId:null,cleared:p.status==="Paid",
          }));
          const rows=[...cvPays,...directPays].sort((a,b)=>String(b.date).localeCompare(String(a.date)));
          const now=new Date();
          const thisMonth=rows.filter(r=>(r.date||"").slice(0,7)===today.slice(0,7));
          const totalMonth=thisMonth.reduce((s,r)=>s+r.amount,0);
          const checkMonth=thisMonth.filter(r=>r.channel==="Check").reduce((s,r)=>s+r.amount,0);
          const onlineMonth=totalMonth-checkMonth;
          const floatAmt=vouchers.filter(v=>v.status==="Released"&&!v.isCleared).reduce((s,v)=>s+N(v.amount),0);
          return(
            <div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(auto-fit,minmax(190px,1fr))",gap:12,marginBottom:20}}>
                <ErpStat label="Paid This Month" value={fmt(totalMonth)} foot={thisMonth.length+" payment(s)"}/>
                <ErpStat tone="purple" label="By Check" value={fmt(checkMonth)} foot="this month"/>
                <ErpStat tone="ok" label="By Online / Cash" value={fmt(onlineMonth)} foot="this month"/>
                <ErpStat tone="warn" label="Released — Float" value={fmt(floatAmt)} foot="checks not yet cleared"/>
              </div>
              <CheckRegister pays={payPays} payables={payables}/>
              <ErpCard title="Payment History" desc="All payments made against Accounts Payable, by Check or Online Transaction. Checks are released here; expenses originate in Procurement.">
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,minWidth:820}}>
                    <thead><tr>
                      {["Date","AP No.","Vendor","Channel","Bank","Reference","Amount",""].map((h,i)=>(
                        <th key={h+i} style={i===6?erpThNum:erpTh}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {rows.length===0&&<tr><td colSpan={8} style={{...erpTd,textAlign:"center",color:ERP.muted,fontStyle:"italic",padding:26}}>No payments recorded yet. Release a check voucher or settle a payable to see it here.</td></tr>}
                      {rows.map(r=>(
                        <tr key={r.id} onMouseEnter={ev=>ev.currentTarget.style.background="#FAFBFD"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                          <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{r.date||"—"}</td>
                          <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{r.apNo}</td>
                          <td style={{...erpTd,fontWeight:600,color:ERP.ink,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.vendor}>{r.vendor}</td>
                          <td style={{...erpTd,whiteSpace:"nowrap"}}><ErpBadge kind={r.channel==="Check"?"check":"online"}>{r.channel}</ErpBadge></td>
                          <td style={{...erpTd,color:ERP.muted,whiteSpace:"nowrap"}}>{r.bank}</td>
                          <td style={{...erpTd,color:ERP.muted,whiteSpace:"nowrap"}}>{r.ref}</td>
                          <td style={{...erpTdNum,fontWeight:800,color:ERP.navy,whiteSpace:"nowrap"}}>{fmt(r.amount)}</td>
                          <td style={{...erpTd,whiteSpace:"nowrap"}}>{r.cvId&&<button onClick={()=>{setPage("checkvouchers");setCvView(r.cvId);}} style={{background:"transparent",border:`1px solid ${ERP.line}`,borderRadius:6,padding:"5px 10px",fontSize:12,fontWeight:600,color:ERP.navy,cursor:"pointer",fontFamily:"inherit"}}>View CV</button>}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </ErpCard>
            </div>
          );
        })()}
        {finTab==="loans"&&role!=="Accounting"&&(()=>{
          const fmtM=v=>"₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0});
          const totalPrincipal=loans.reduce((s,l)=>s+l.principal,0);
          const totalPaid=loans.reduce((s,l)=>s+(l.payments||[]).reduce((a,p)=>a+p.amount,0),0);
          const totalOutstanding=Math.max(0,totalPrincipal-totalPaid);
          const totalMonthly=loans.reduce((s,l)=>s+l.monthlyPayment,0);
          const LOAN_TYPES=["Bank Loan","SSS Loan","Pag-IBIG Loan","GSIS Loan","Personal Loan","Credit Line","Investor Loan","Supplier Credit","Other"];
          return(
            <div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
                <div>
                  <div style={{fontWeight:800,color:"#0f172a",fontSize:"1rem"}}>💳 Loans & Financing</div>
                  <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Track borrowed funds, credit lines, and repayment schedules.</div>
                </div>
                <button onClick={()=>{setLoanForm({lender:"",type:"Bank Loan",principal:"",disbursedDate:"",termMonths:"",interestRate:"",monthlyPayment:"",notes:""});setEditLoanId(null);setLoanModal(true);}}
                  style={{background:"#1e293b",border:"none",borderRadius:8,padding:"8px 18px",fontFamily:"inherit",fontSize:".82rem",color:"#f59e0b",cursor:"pointer",fontWeight:700}}>+ Add Loan</button>
              </div>
              {/* KPI strip */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
                {[{l:"Total Borrowed",v:fmtM(totalPrincipal),c:"#7c3aed"},{l:"Outstanding Balance",v:fmtM(totalOutstanding),c:"#ef4444"},{l:"Monthly Obligations",v:fmtM(totalMonthly),c:"#f97316"}].map(({l,v,c})=>(
                  <div key={l} style={{background:"#fff",borderRadius:10,border:`1.5px solid ${c}33`,padding:"12px 14px",borderTop:`3px solid ${c}`}}>
                    <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".6px"}}>{l}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:c,marginTop:2}}>{v}</div>
                  </div>
                ))}
              </div>
              {loans.length===0&&<div style={{textAlign:"center",padding:"48px",color:"#94a3b8",fontSize:".84rem"}}>No loans recorded. Add a loan to track repayments and outstanding balance.</div>}
              {loans.map(loan=>{
                const paid=(loan.payments||[]).reduce((s,p)=>s+p.amount,0);
                const outstanding=Math.max(0,loan.principal-paid);
                const pct=loan.principal>0?Math.min(100,Math.round(paid/loan.principal*100)):0;
                const matDate=loan.disbursedDate&&loan.termMonths?new Date(new Date(loan.disbursedDate).setMonth(new Date(loan.disbursedDate).getMonth()+Number(loan.termMonths))).toISOString().slice(0,10):null;
                const isOverdue=matDate&&matDate<today&&outstanding>0;
                const lp=loanPay[loan.id]||{amount:"",date:today};
                return(
                  <div key={loan.id} style={{background:"#fff",borderRadius:14,border:`1.5px solid ${isOverdue?"#fecaca":"#e2e8f0"}`,borderLeft:`4px solid ${isOverdue?"#ef4444":"#7c3aed"}`,padding:"16px",marginBottom:12}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                          <span style={{fontWeight:800,color:"#0f172a",fontSize:".95rem"}}>{loan.lender}</span>
                          <span style={{fontSize:".65rem",background:"#ede9fe",color:"#7c3aed",borderRadius:20,padding:"2px 8px",fontWeight:700}}>{loan.type}</span>
                          {isOverdue&&<span style={{fontSize:".65rem",background:"#fef2f2",color:"#ef4444",borderRadius:20,padding:"2px 8px",fontWeight:700}}>OVERDUE</span>}
                          {outstanding===0&&<span style={{fontSize:".65rem",background:"#f0fdf4",color:"#059669",borderRadius:20,padding:"2px 8px",fontWeight:700}}>✓ SETTLED</span>}
                        </div>
                        <div style={{display:"flex",gap:16,marginTop:6,flexWrap:"wrap"}}>
                          {loan.disbursedDate&&<span style={{fontSize:".72rem",color:"#64748b"}}>Disbursed: {loan.disbursedDate}</span>}
                          {loan.termMonths&&<span style={{fontSize:".72rem",color:"#64748b"}}>{loan.termMonths} months</span>}
                          {loan.interestRate>0&&<span style={{fontSize:".72rem",color:"#64748b"}}>{loan.interestRate}% p.a.</span>}
                          {matDate&&<span style={{fontSize:".72rem",color:isOverdue?"#ef4444":"#64748b"}}>Matures: {matDate}</span>}
                        </div>
                        {loan.notes&&<div style={{fontSize:".75rem",color:"#64748b",marginTop:4}}>{loan.notes}</div>}
                        {/* Progress bar */}
                        <div style={{marginTop:10}}>
                          <div style={{display:"flex",justifyContent:"space-between",fontSize:".7rem",color:"#64748b",marginBottom:3}}>
                            <span>Paid: {fmtM(paid)} ({pct}%)</span>
                            <span>Outstanding: {fmtM(outstanding)}</span>
                          </div>
                          <div style={{height:6,background:"#f1f5f9",borderRadius:10,overflow:"hidden"}}>
                            <div style={{height:"100%",width:`${pct}%`,background:outstanding===0?"#059669":"#7c3aed",borderRadius:10,transition:"width .3s"}}/>
                          </div>
                        </div>
                        {/* Log payment inline */}
                        {outstanding>0&&(
                          <div style={{display:"flex",gap:8,marginTop:10,alignItems:"center",flexWrap:"wrap"}}>
                            <input type="number" placeholder="Payment amount" value={lp.amount} onChange={e=>setLoanPay(p=>({...p,[loan.id]:{...lp,amount:e.target.value}}))} style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 10px",fontSize:".78rem",fontFamily:"inherit",width:140}}/>
                            <input type="date" value={lp.date} onChange={e=>setLoanPay(p=>({...p,[loan.id]:{...lp,date:e.target.value}}))} style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 8px",fontSize:".78rem",fontFamily:"inherit"}}/>
                            <button onClick={()=>addLoanPayment(loan.id,lp.amount,lp.date)} style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:7,padding:"5px 12px",fontSize:".75rem",color:"#059669",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✓ Log Payment</button>
                          </div>
                        )}
                        {/* Payment history with principal/interest breakdown */}
                        {(loan.payments||[]).length>0&&(()=>{
                          const r=loan.interestRate>0?loan.interestRate/100/12:0;
                          let bal=loan.principal;
                          const sorted=[...(loan.payments||[])].sort((a,b)=>a.date.localeCompare(b.date));
                          return(
                            <div style={{marginTop:10}}>
                              <div style={{fontSize:".7rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".6px",marginBottom:4}}>Payment History</div>
                              <div style={{display:"grid",gridTemplateColumns:"80px 1fr 1fr 1fr 28px",gap:4,fontSize:".68rem",color:"#94a3b8",padding:"2px 0",borderBottom:"1px solid #f1f5f9"}}>
                                <span>Date</span><span>Payment</span><span style={{color:"#dc2626"}}>Interest</span><span style={{color:"#7c3aed"}}>Principal</span><span/>
                              </div>
                              {sorted.map(pm=>{
                                const interest=r>0?Math.round(bal*r*100)/100:0;
                                const principal=Math.min(bal,Math.max(0,Number(pm.amount)-interest));
                                bal=Math.max(0,bal-principal);
                                return(
                                  <div key={pm.id} style={{display:"grid",gridTemplateColumns:"80px 1fr 1fr 1fr 28px",gap:4,padding:"4px 0",borderBottom:"1px solid #f1f5f9",fontSize:".72rem",alignItems:"center"}}>
                                    <span style={{color:"#64748b"}}>{pm.date}</span>
                                    <span style={{fontWeight:700,color:"#059669"}}>{fmtM(pm.amount)}</span>
                                    <span style={{color:"#dc2626"}}>{r>0?fmtM(interest):"—"}</span>
                                    <span style={{color:"#7c3aed"}}>{r>0?fmtM(principal):fmtM(pm.amount)}</span>
                                    <button onClick={()=>delLoanPayment(loan.id,pm.id)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".7rem",fontFamily:"inherit"}}>x</button>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })()}
                      </div>
                      {/* Right side: principal + actions */}
                      <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6,minWidth:120}}>
                        <div>
                          <div style={{fontSize:".65rem",color:"#94a3b8",textAlign:"right"}}>Original</div>
                          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:"#0f172a"}}>{fmtM(loan.principal)}</div>
                        </div>
                        {loan.monthlyPayment>0&&(
                          <div>
                            <div style={{fontSize:".65rem",color:"#94a3b8",textAlign:"right"}}>Monthly</div>
                            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,fontSize:"1rem",color:"#f97316"}}>{fmtM(loan.monthlyPayment)}</div>
                          </div>
                        )}
                        <div style={{display:"flex",gap:6}}>
                          <button onClick={()=>{setLoanForm({...loan});setEditLoanId(loan.id);setLoanModal(true);}} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏</button>
                          <button onClick={()=>delLoan(loan.id)} style={{background:"#fef2f2",border:"none",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>✕</button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* Add/Edit Loan Modal */}
              <Modal open={loanModal} onClose={()=>{setLoanModal(false);setEditLoanId(null);}} title={editLoanId?"Edit Loan":"Add Loan / Financing"}>
                <Fld label="Lender / Source" required><Inp value={loanForm.lender} onChange={e=>setLoanForm(p=>({...p,lender:e.target.value}))} placeholder="e.g. BDO, SSS, Investor name"/></Fld>
                <Fld label="Type"><Sel value={loanForm.type} onChange={e=>setLoanForm(p=>({...p,type:e.target.value}))}>{["Bank Loan","SSS Loan","Pag-IBIG Loan","GSIS Loan","Personal Loan","Credit Line","Investor Loan","Supplier Credit","Other"].map(t=><option key={t}>{t}</option>)}</Sel></Fld>
                <Fld label="Principal Amount (₱)" required><Inp type="number" value={loanForm.principal} onChange={e=>setLoanForm(p=>({...p,principal:e.target.value}))} placeholder="0"/></Fld>
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10}}>
                  <Fld label="Disbursed Date"><Inp type="date" value={loanForm.disbursedDate} onChange={e=>setLoanForm(p=>({...p,disbursedDate:e.target.value}))}/></Fld>
                  <Fld label="Term (months)"><Inp type="number" value={loanForm.termMonths} onChange={e=>setLoanForm(p=>({...p,termMonths:e.target.value}))} placeholder="e.g. 24"/></Fld>
                </div>
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10}}>
                  <Fld label="Interest Rate (% p.a.)"><Inp type="number" value={loanForm.interestRate} onChange={e=>setLoanForm(p=>({...p,interestRate:e.target.value}))} placeholder="e.g. 8"/></Fld>
                  <Fld label="Monthly Payment (₱)">
                    <Inp type="number" value={loanForm.monthlyPayment} onChange={e=>setLoanForm(p=>({...p,monthlyPayment:e.target.value}))} placeholder="0"/>
                    {(()=>{
                      const P=Number(loanForm.principal);const n=Number(loanForm.termMonths);const r=Number(loanForm.interestRate)/100/12;
                      if(P>0&&n>0&&r>0){
                        const computed=P*r*Math.pow(1+r,n)/(Math.pow(1+r,n)-1);
                        const entered=Number(loanForm.monthlyPayment);
                        if(entered>0&&Math.abs(entered-computed)>computed*0.05)
                          return<div style={{fontSize:".7rem",color:"#f59e0b",marginTop:3}}>⚠ Computed monthly payment: ₱{computed.toLocaleString("en-PH",{maximumFractionDigits:0})} — entered differs by more than 5%.</div>;
                        if(!entered)
                          return<div style={{fontSize:".7rem",color:"#94a3b8",marginTop:3}}>Suggested: ₱{computed.toLocaleString("en-PH",{maximumFractionDigits:0})}/mo</div>;
                      }
                      return null;
                    })()}
                  </Fld>
                </div>
                <Fld label="Notes"><Inp value={loanForm.notes} onChange={e=>setLoanForm(p=>({...p,notes:e.target.value}))} placeholder="Purpose, collateral, terms, etc."/></Fld>
                <div style={{display:"flex",gap:10,marginTop:18}}>
                  <Btn full variant="green" onClick={()=>saveLoan(loanForm)}>Save Loan</Btn>
                  <Btn variant="ghost" onClick={()=>{setLoanModal(false);setEditLoanId(null);}}>Cancel</Btn>
                </div>
              </Modal>
            </div>
          );
        })()}
      </Wrap>
    );
    if(page==="procurement") return(<Wrap><ProcurementView2 costCenterDeals={costCenterDeals} onCreateCostCenter={createCostCenter} onWaiveDp={waiveDp} prs={prs} addPR={addPR} updatePR={updatePR} deletePR={deletePR} upPrs={upPrs} wonDeals={wonDeals} deals={deals} budgets={budgets} exps={exps} swos={swos} session={session} role={role} toastEmit={toastEmit} suppliers={suppliers} addSupplier={addSupplier} upPayables={upPayables} payables={payables} sendTelegramNotification={sendTelegramNotification} isSupabaseReady={isSupabaseReady} sbUpsert={sbUpsert} payableToSb={payableToSb} syncPoPayable={syncPoPayable} approvePOs={approvePOs} chartOfAccounts={chartOfAccounts}/></Wrap>);
    if(page==="subconwo") return(<Wrap><SubconWOView deals={deals} onWaiveDp={waiveDp} swos={swos} addSWO={addSWO} addSWOBatch={addSWOBatch} updateSWO={updateSWO} deleteSWO={deleteSWO} wonDeals={wonDeals} subcons={subcons} session={session} role={role} toastEmit={toastEmit} sendTelegramNotification={sendTelegramNotification} chartOfAccounts={chartOfAccounts}/></Wrap>);
    if(page==="budget") return(<Wrap><BudgetView wonDeals={wonDeals} budgets={budgets} saveBudget={saveBudget} prs={prs} exps={exps} role={role}/></Wrap>);
    if(page==="costing") return(<Wrap><CostingStudy wonDeals={wonDeals} budgets={budgets} prs={prs} exps={exps} projs={projs} role={role}/></Wrap>);
    if(page==="budgetreq") return(<Wrap><BudgetRequestView sendTelegramNotification={sendTelegramNotification} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR} wonDeals={wonDeals} session={session} role={role} toastEmit={toastEmit}/></Wrap>);
    if(page==="requests") return(<Wrap><RequestsView sendTelegramNotification={sendTelegramNotification} mreqs={mreqs} addMR={addMR} updateMR={updateMR} prs={prs} addPR={addPR} wonDeals={wonDeals} session={session} role={role} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR} toastEmit={toastEmit} suppliers={suppliers}/></Wrap>);
    if(page==="suppliers") return(<Wrap><SupplierMasterView suppliers={suppliers} addSupplier={addSupplier} updateSupplier={updateSupplier} deleteSupplier={deleteSupplier} session={session} role={role}/></Wrap>);
    if(page==="subcontractors") return(<Wrap><SubconMasterView subcons={subcons} addSubcon={addSubcon} updateSubcon={updateSubcon} deleteSubcon={deleteSubcon} session={session} role={role}/></Wrap>);
    if(page==="ceqs") return(<Wrap><CEQSView ceReqs={ceReqs} addCEReq={addCEReq} updateCEReq={updateCEReq} session={session} role={role} toastEmit={toastEmit} deals={deals}/></Wrap>);
    if(page==="masters") return(<Wrap><MasterListsView suppliers={suppliers} addSupplier={addSupplier} updateSupplier={updateSupplier} deleteSupplier={deleteSupplier} subcons={subcons} addSubcon={addSubcon} updateSubcon={updateSubcon} deleteSubcon={deleteSubcon} session={session} role={role} isMobile={isMobile}/></Wrap>);
    if(page==="swatchboard") return(<Wrap><ProcurementView swatches={swatches} projList={projList} clientName={clientName} openAddSwatch={openAddSwatch} openEditSwatch={openEditSwatch} delSwatch={id=>upSwatches(ss=>ss.filter(s=>s.id!==id))} swQ={swQ} Wrap={Wrap} addMR={addMR} wonDeals={wonDeals} session={session}/></Wrap>);
    if(page==="clients") return(
      <Wrap>
        <ClientDirectory deals={deals} session={session} role={role} vvipClients={vvipClients} toggleVvip={toggleVvip} customClients={customClients} isMobile={isMobile}
          clientProfiles={clientProfiles}
          saveClientProfile={saveClientProfileRemote}
          addNewClient={(name)=>{
            if(!name.trim()) return;
            if(GMD_CLIENTS.find(c=>c.name.toLowerCase()===name.trim().toLowerCase())||customClients.find(c=>c.name.toLowerCase()===name.trim().toLowerCase())) return;
            const nc={name:name.trim(),id:"c"+Date.now(),addedBy:session?.name||"",addedAt:today};
            GMD_CLIENTS.push(nc);
            const next=[...customClients,nc];
            setCustomClients(next);
            try{localStorage.setItem(KEYS.customclients,JSON.stringify(next));}catch{}
            if(isSupabaseReady()) sbUpsert('app_settings',{key:'customclients',value:next,updated_at:new Date().toISOString()},'key').catch(()=>{});
          }}
        />
      </Wrap>
    );
    const ROLES=['Manager', 'Sales', 'Finance', 'Procurement', 'ProcurementManager', 'QS', 'Operations', 'Design', 'ProjectMover', 'Coordinator', 'Warehouse', 'SalesOpsAdmin', 'FinanceAssistant'];
    if(page==="accounts"&&role==="Manager") return(
      <Wrap>
        <AccountsManager users={users} session={session} onApprove={approveUser} onReject={rejectUser} onDeactivate={deactivateUser} onDelete={deleteUser} onResetPw={resetPw} onCreateUser={createUser} ROLES={ROLES}/>
        {/* Role Permissions reference (Manager only) — who can view/create/edit/
            delete each record type, right where you set a person's role. */}
        {role==="Manager"&&(
          <div style={{maxWidth:1180,margin:"18px auto 0",padding:isMobile?"0 10px":"0 20px"}}>
            <button onClick={()=>setAccountsPermOpen(o=>!o)}
              style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
              <span>
                <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.1rem",color:"#0f172a"}}>🔐 Role Permissions</span>
                <span style={{display:"block",fontSize:".76rem",color:"#64748b",marginTop:2}}>Who can view, create, edit or delete each record type — mirrors the database security rules.</span>
              </span>
              <span style={{fontSize:".9rem",color:"#64748b",transform:accountsPermOpen?"rotate(180deg)":"none",transition:"transform .15s"}}>▾</span>
            </button>
            {accountsPermOpen&&<div style={{marginTop:10}}><PermissionsMatrix Wrap={Wrap} isMobile={isMobile} embedded/></div>}
          </div>
        )}
      </Wrap>
    );
  
  


  // ─── SALES ────────────────────────────────────────────────────────────────
  if(role==="Sales"){
    if(page==="home") return(
      <Wrap>
        <SecHead title="My Pipeline" action={<Btn onClick={openAddDeal}>+ Add Deal</Btn>}/>
        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:12,marginBottom:20}}>
          <KPI label="Active Deals"    value={deals.filter(d=>isActivePipeline(d.stage)).length} color="#3b82f6"/>
          <KPI label="Won Revenue"     value={fmtK(wonDeals.reduce((s,d)=>s+d.value,0))}     color="#10b981"/>
          <KPI label="Follow-ups Due"  value={deals.filter(d=>d.followUp&&d.followUp<=today&&isActivePipeline(d.stage)).length} color="#ef4444"/>
        </div>
        {deals.map(d=>(
          <Card key={d.id} accent={d.stage==="Did Not Win"||d.stage==="Cancelled"?"#fca5a5":WON_STAGES.includes(d.stage)?"#6ee7b7":d.followUp&&d.followUp<today?"#fed7aa":undefined}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
              <div style={{flex:1}}>
                <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:5}}>
                  <span style={{fontWeight:700,fontSize:"1rem",color:"#0f172a"}}>{d.client}</span>
                  {WON_STAGES.includes(d.stage)&&<Badge label="Awarded" color="#059669"/>}
                  {WON_STAGES.includes(d.stage)&&<Badge label={d.paymentStatus} color={PAY_CLR[d.paymentStatus]}/>}
                  {d.salesOwner&&d.salesOwner!==session?.name&&<span style={{fontSize:".62rem",background:"#eef2ff",color:"#6366f1",borderRadius:20,padding:"1px 6px",fontWeight:700}}>👤 {d.salesOwner.split(" ")[0]}</span>}
                </div>
                <div style={{fontSize:".78rem",color:"#64748b"}}>{d.product} · {d.contact}</div>
                {d.followUp&&<div style={{fontSize:".73rem",color:d.followUp<today&&isActivePipeline(d.stage)?"#ef4444":"#94a3b8",marginTop:5}}>📅 Follow-up: {d.followUp}{d.followUp<today&&!WON_STAGES.includes(d.stage)?" — OVERDUE":""}</div>}
                {d.notes&&<div style={{fontSize:".73rem",color:"#94a3b8",marginTop:4,fontStyle:"italic"}}>{d.notes}</div>}
                {WON_STAGES.includes(d.stage)&&d.invoiced>0&&(()=>{
                  const paid=dealCollected(d);
                  return(
                  <div style={{marginTop:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:".7rem",color:"#94a3b8",marginBottom:4}}>
                      <span>{fmt(paid)} of {fmt(d.invoiced)} collected</span>
                      <span>{d.invoiced>0?Math.round(paid/d.invoiced*100):0}%</span>
                    </div>
                    <ProgBar pct={d.invoiced>0?paid/d.invoiced*100:0} color={paid>=d.invoiced?"#059669":"#10b981"}/>
                  </div>
                  );
                })()}
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{fontWeight:800,color:"#10b981",fontSize:"1.15rem"}}>{fmt(d.value)}</div>
                <div style={{display:"flex",gap:6,marginTop:8,justifyContent:"flex-end",flexWrap:"wrap"}}>
                  <Btn small variant="ghost" onClick={()=>openEditDeal(d)}>✏ Edit</Btn>
                  {isActivePipeline(d.stage)&&<Btn small onClick={()=>openAward(d)} style={{background:"#059669",color:"#fff",border:"none"}}>🏆 Award</Btn>}
                  {canDeleteDeal&&<Btn small variant="danger" onClick={()=>setConfirmDel(d.id)}>✕</Btn>}
                </div>
              </div>
            </div>
          </Card>
        ))}
      </Wrap>
    );
  }

  // ─── FINANCE ──────────────────────────────────────────────────────────────
  if(["Finance","Cost Control","Procurement","QS"].includes(role)){
    const grossPro=arTot.billed-totExp;
    const grossMar=arTot.billed>0?Math.round(grossPro/arTot.billed*100):0;
    if(page==="home"&&role==="QS") return(
      <Wrap>
        <DeptHeader
          name={session?.name?.split(" ")[0]||"Team"}
          subtitle={`QS / Cost Control · ${todayL}`}
          buttons={[
            {label:"BOQ",   icon:"🧮", bg:"#8b5cf6", action:()=>{setBoqDealId(null);setBoqStandaloneId(null);setBoqCoId(null);setPage("boq");}},
            {label:"CE Request",    icon:"📐", bg:"#06b6d4", action:()=>setPage("ceqs")},
            {label:"Cost Analysis", icon:"💹", bg:"#059669", action:()=>setPage("costanalysis")},
            {label:"Budget",        icon:"📊", bg:"#1e293b", action:()=>setPage("budget")},
          ]}
        />
        {/* QS action items */}
        {(()=>{
          const pendingBudget=jos.filter(j=>j.budgetStatus==="QS Budget Pending");
          return pendingBudget.length>0?(
            <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"14px 18px",marginBottom:20}}>
              <div style={{fontWeight:700,color:"#92400e",marginBottom:8}}>⚠️ {pendingBudget.length} project{pendingBudget.length>1?"s":""} need{pendingBudget.length===1?"s":""} your budget target</div>
              {pendingBudget.map(j=>(
                <div key={j.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",background:"rgba(255,255,255,.7)",borderRadius:8,marginBottom:6,flexWrap:"wrap",gap:8}}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".88rem"}}>{j.client}</div>
                    <div style={{fontSize:".73rem",color:"#64748b"}}>{j.ceNo||"No CE"} · {j.joNo} · Start: {j.startDate||"TBA"}</div>
                  </div>
                  <button onClick={()=>setPage("costanalysis")}
                    style={{background:"#d97706",border:"none",borderRadius:8,padding:"6px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",color:"#fff",cursor:"pointer"}}>
                    Set Budget →
                  </button>
                </div>
              ))}
            </div>
          ):null;
        })()}
        <BudgetView wonDeals={wonDeals} budgets={budgets} saveBudget={saveBudget} prs={prs} exps={exps} role={role}/>
      </Wrap>
    );
    if(page==="home"&&isProcurementRole(role)) return(
      <Wrap>
        <DeptHeader
          name={session?.name?.split(" ")[0]||"Team"}
          subtitle={`Procurement · ${todayL}`}
          buttons={[
            {label:"+ New PO",      icon:"📦", bg:"#06b6d4", action:()=>setPage("procurement")},
            {label:"+ Work Order",  icon:"🔧", bg:"#8b5cf6", action:()=>setPage("subconwo")},
            ...(pageOn("requests")?[{label:"Requests",      icon:"📋", bg:"#f59e0b", action:()=>setPage("requests")}]:[]),
            ...(pageOn("inventory")?[{label:"Inventory",     icon:"🗃️", bg:"#1e293b", action:()=>setPage("inventory")}]:[]),
            {label:"Suppliers",     icon:"🏢", bg:"#1e293b", action:()=>setPage("masters")},
          ]}
        />
        <SecHead title="Procurement Overview"/>
        {(()=>{
          const lowInv=inventory.filter(i=>Number(i.qtyOnHand)<=Number(i.reorderPoint)&&Number(i.reorderPoint)>0);
          const invVal=inventory.reduce((s,i)=>s+Number(i.qtyOnHand||0)*Number(i.avgCost||0),0);
          const activePOItems=new Set(prs.filter(p=>p.status==="PO Issued").map(p=>p.itemName||""));
          const needsPR=lowInv.filter(i=>![...activePOItems].some(n=>n.toLowerCase().includes(i.name.toLowerCase().slice(0,8))));
          return(<>
            {/* KPI tiles */}
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(5,1fr)",gap:12,marginBottom:20}}>
              {[
                ...(pageOn("requests")?[{l:"Pending Material Requests",v:mreqs.filter(m=>m.status==="Submitted").length,c:"#f59e0b",action:()=>setPage("requests")},
                {l:"Pending Budget Requests",  v:breqs.filter(b=>b.status==="Submitted").length,c:"#ef4444",action:()=>setPage("requests")}]:[]),
                {l:"Active POs",              v:prs.filter(p=>p.status==="PO Issued").length,   c:"#3b82f6",action:()=>setPage("procurement")},
                ...(pageOn("inventory")?[{l:"Low Stock — Need PR",     v:needsPR.length,c:needsPR.length>0?"#f97316":"#94a3b8",action:()=>setPage("inventory")}]:[]),
                ...(pageOn("inventory")?[{l:"Inventory Value",         v:"₱"+Math.round(invVal).toLocaleString("en-PH"),c:"#059669",action:()=>setPage("inventory")}]:[]),
              ].map(({l,v,c,action})=>(
                <div key={l} onClick={action} style={{background:"#fff",borderRadius:12,padding:"18px",border:"1.5px solid #e2e8f0",cursor:"pointer",transition:"all .15s"}}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor=c;e.currentTarget.style.boxShadow=`0 4px 16px ${c}22`;}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor="#e2e8f0";e.currentTarget.style.boxShadow="none";}}>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.9rem",color:c}}>{v}</div>
                  <div style={{fontSize:".7rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
                  <div style={{fontSize:".72rem",color:c,marginTop:8,fontWeight:600}}>View →</div>
                </div>
              ))}
            </div>
            {/* Low stock → raise PR action list */}
            {pageOn("inventory")&&needsPR.length>0&&(
              <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fed7aa",padding:"14px 18px",marginBottom:16}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
                  <div style={{fontWeight:700,color:"#c2410c",fontSize:".9rem"}}>📦 {needsPR.length} item{needsPR.length!==1?"s":""} need restocking — no active PO</div>
                  <button onClick={()=>setPage("procurement")} style={{background:"#f97316",border:"none",borderRadius:8,padding:"7px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",color:"#fff",cursor:"pointer"}}>+ Raise stock PO</button>
                </div>
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:8}}>
                  {needsPR.slice(0,9).map(i=>(
                    <div key={i.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",borderRadius:8,background:"#fff7ed",border:"1px solid #fed7aa"}}>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:600,fontSize:".8rem",color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.name}</div>
                        <div style={{fontSize:".7rem",color:"#f97316",fontFamily:"monospace"}}>{Number(i.qtyOnHand)} {i.unit} left · reorder at {Number(i.reorderPoint)}</div>
                      </div>
                    </div>
                  ))}
                  {needsPR.length>9&&<div style={{fontSize:".75rem",color:"#94a3b8",padding:"8px 12px",display:"flex",alignItems:"center"}}>+{needsPR.length-9} more items</div>}
                </div>
              </div>
            )}
          </>);
        })()}
      </Wrap>
    );
    if(page==="home") return(
      <Wrap>
        {/* Finance: pending MR/BR approvals banner */}
        {(()=>{
          const pendingMR=mreqs.filter(m=>m.status==="Submitted"||m.status==="Reviewed");
          const pendingBR=breqs.filter(b=>b.status==="Submitted"||b.status==="Under Review");
          const total=pendingMR.length+pendingBR.length;
          if(!total) return null;
          return(
            <div style={{background:"#fff",border:"1.5px solid #fde68a",borderRadius:12,padding:"14px 18px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{fontWeight:700,color:"#92400e",fontSize:".9rem"}}>⏳ {total} Pending Approval{total!==1?"s":""}</div>
                <div style={{fontSize:".75rem",color:"#b45309",marginTop:2}}>
                  {pendingMR.length>0&&<span style={{marginRight:10}}>📋 {pendingMR.length} Material Request{pendingMR.length!==1?"s":""}</span>}
                  {pendingBR.length>0&&<span>💳 {pendingBR.length} Budget Request{pendingBR.length!==1?"s":""}</span>}
                </div>
              </div>
              {pageOn("requests")&&<button onClick={()=>setPage("requests")} style={{background:"#f59e0b",border:"none",borderRadius:8,padding:"7px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#fff",cursor:"pointer",whiteSpace:"nowrap"}}>Review Now →</button>}
            </div>
          );
        })()}
        {/* Finance: new awarded projects needing billing milestones */}
        {(()=>{
          const needsBilling=wonDeals.filter(d=>{
            const ms=billings.filter(b=>b.dealId===d.id);
            return ms.length===0;
          });
          return needsBilling.length>0?(
            <div style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:12,padding:"12px 18px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{fontWeight:700,color:"#1d4ed8",fontSize:".88rem"}}>📋 {needsBilling.length} project{needsBilling.length>1?"s":""} need{needsBilling.length===1?"s":""} billing milestones set up</div>
                <div style={{fontSize:".73rem",color:"#1d4ed8",marginTop:3,opacity:.8}}>{needsBilling.slice(0,3).map(d=>d.client).join(", ")}{needsBilling.length>3?` +${needsBilling.length-3} more`:""}</div>
              </div>
              <button onClick={()=>setPage("billing")}
                style={{background:"#1d4ed8",border:"none",borderRadius:8,padding:"7px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#fff",cursor:"pointer"}}>
                Set Up Billing →
              </button>
            </div>
          ):null;
        })()}
        {/* ── Inventory snapshot for Finance/Manager ── */}
        {(()=>{
          const invVal=inventory.reduce((s,i)=>s+Number(i.qtyOnHand||0)*Number(i.avgCost||0),0);
          const lowInv=inventory.filter(i=>Number(i.qtyOnHand)<=Number(i.reorderPoint)&&Number(i.reorderPoint)>0);
          const outInv=inventory.filter(i=>Number(i.qtyOnHand)===0);
          const activePOCount=prs.filter(p=>p.status==="PO Issued").length;
          if(invVal===0&&inventory.length===0) return null;
          return(
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 18px",marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem"}}>📦 Warehouse Inventory</div>
                <button onClick={()=>setPage("inventory")} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"5px 14px",fontFamily:"inherit",fontWeight:600,fontSize:".75rem",color:"#475569",cursor:"pointer"}}>View Full Inventory →</button>
              </div>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10}}>
                {[
                  {l:"Asset Value",     v:"₱"+Math.round(invVal).toLocaleString("en-PH"),c:"#059669"},
                  {l:"Items on Hand",   v:inventory.length,c:"#3b82f6"},
                  {l:"Low Stock",       v:lowInv.length, c:lowInv.length>0?"#f59e0b":"#94a3b8"},
                  {l:"Active POs",      v:activePOCount,  c:activePOCount>0?"#8b5cf6":"#94a3b8"},
                ].map(({l,v,c})=>(
                  <div key={l} style={{textAlign:"center",padding:"10px 8px",borderRadius:8,background:"#f8fafc",border:`1px solid #e2e8f0`}}>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
                    <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginTop:3}}>{l}</div>
                  </div>
                ))}
              </div>
              {(lowInv.length>0||outInv.length>0)&&(
                <div style={{marginTop:10,fontSize:".75rem",color:"#92400e",background:"#fffbeb",borderRadius:7,padding:"7px 12px",border:"1px solid #fde68a"}}>
                  ⚠️ {outInv.length>0&&<span style={{marginRight:8}}><strong>{outInv.length} item{outInv.length!==1?"s":""} depleted</strong></span>}{lowInv.length>0&&<span><strong>{lowInv.length} item{lowInv.length!==1?"s":""} below reorder point</strong> — {lowInv.slice(0,3).map(i=>i.name).join(", ")}{lowInv.length>3?` +${lowInv.length-3} more`:""}</span>}
                </div>
              )}
            </div>
          );
        })()}
        {/* ── Materials issued per project (from stocklog) ── */}
        {(()=>{
          const outMoves=stocklog.filter(m=>m.moveType.startsWith("OUT")&&m.projectId);
          if(!outMoves.length) return null;
          const projMap={};
          for(const m of outMoves){
            if(!projMap[m.projectId])projMap[m.projectId]={qty:0,cost:0,moves:0};
            projMap[m.projectId].qty+=Number(m.qty||0);
            projMap[m.projectId].cost+=Number(m.qty||0)*Number(m.unitCost||0);
            projMap[m.projectId].moves++;
          }
          const projRows=Object.entries(projMap).map(([pid,v])=>{
            const d=wonDeals.find(x=>x.id===pid)||completedDeals.find(x=>x.id===pid);
            return{pid,name:d?((d.client||"")+(d.ceNo?` (${d.ceNo})`:"")):"Other",qty:v.qty,cost:v.cost,moves:v.moves};
          }).sort((a,b)=>b.cost-a.cost).slice(0,6);
          return(
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 18px",marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem"}}>🏗 Materials Issued to Projects</div>
                <button onClick={()=>setPage("stockmove")} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"5px 14px",fontFamily:"inherit",fontWeight:600,fontSize:".75rem",color:"#475569",cursor:"pointer"}}>View Stock Log →</button>
              </div>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:8}}>
                {projRows.map(r=>(
                  <div key={r.pid} style={{padding:"9px 12px",borderRadius:8,background:"#f8fafc",border:"1px solid #e2e8f0"}}>
                    <div style={{fontWeight:600,fontSize:".8rem",color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name}</div>
                    <div style={{display:"flex",gap:12,marginTop:4}}>
                      <span style={{fontSize:".72rem",color:"#f97316",fontWeight:700}}>{r.qty.toLocaleString()} units out</span>
                      {r.cost>0&&<span style={{fontSize:".72rem",color:"#059669",fontWeight:700}}>₱{Math.round(r.cost).toLocaleString("en-PH")}</span>}
                    </div>
                    <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>{r.moves} movement{r.moves!==1?"s":""}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}
        <DailyCashPosition
          cashPositions={cashPositions}
          saveDayPos={saveDayPos}
          wonDeals={wonDeals}
          billings={billings}
          totRev={totRev}
          totExp={totExp}
          totColl={totColl}
          totOut={totOut}
          exps={exps}
          payables={payables}
          vouchers={vouchers}
          loans={loans}
          suppliers={suppliers}
          subcons={subcons}
          inventory={inventory}
          userName={session?.name||""}
          cashStale={cashStale}
        />
      </Wrap>
    );
    if(page==="budget") return(<Wrap><BudgetView wonDeals={wonDeals} budgets={budgets} saveBudget={saveBudget} prs={prs} exps={exps} role={role}/></Wrap>);
    if(page==="procurement") return(<Wrap><ProcurementView2 costCenterDeals={costCenterDeals} onCreateCostCenter={createCostCenter} onWaiveDp={waiveDp} prs={prs} addPR={addPR} updatePR={updatePR} deletePR={deletePR} upPrs={upPrs} wonDeals={wonDeals} deals={deals} budgets={budgets} exps={exps} swos={swos} session={session} role={role} toastEmit={toastEmit} suppliers={suppliers} addSupplier={addSupplier} upPayables={upPayables} payables={payables} sendTelegramNotification={sendTelegramNotification} isSupabaseReady={isSupabaseReady} sbUpsert={sbUpsert} payableToSb={payableToSb} syncPoPayable={syncPoPayable} approvePOs={approvePOs} chartOfAccounts={chartOfAccounts}/></Wrap>);
    if(page==="subconwo") return(<Wrap><SubconWOView deals={deals} onWaiveDp={waiveDp} swos={swos} addSWO={addSWO} addSWOBatch={addSWOBatch} updateSWO={updateSWO} deleteSWO={deleteSWO} wonDeals={wonDeals} subcons={subcons} session={session} role={role} toastEmit={toastEmit} sendTelegramNotification={sendTelegramNotification} chartOfAccounts={chartOfAccounts}/></Wrap>);
    if(page==="swatchboard") return(<Wrap><ProcurementView swatches={swatches} projList={projList} clientName={clientName} openAddSwatch={openAddSwatch} openEditSwatch={openEditSwatch} delSwatch={id=>upSwatches(ss=>ss.filter(s=>s.id!==id))} swQ={swQ} Wrap={Wrap} addMR={addMR} wonDeals={wonDeals} session={session}/></Wrap>);
    if(page==="budgetreq") return(<Wrap><BudgetRequestView sendTelegramNotification={sendTelegramNotification} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR} wonDeals={wonDeals} session={session} role={role} toastEmit={toastEmit}/></Wrap>);
    if(page==="requests") return(<Wrap><RequestsView sendTelegramNotification={sendTelegramNotification} mreqs={mreqs} addMR={addMR} updateMR={updateMR} prs={prs} addPR={addPR} wonDeals={wonDeals} session={session} role={role} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR} toastEmit={toastEmit} suppliers={suppliers}/></Wrap>);
    if(page==="masters") return(<Wrap><MasterListsView suppliers={suppliers} addSupplier={addSupplier} updateSupplier={updateSupplier} deleteSupplier={deleteSupplier} subcons={subcons} addSubcon={addSubcon} updateSubcon={updateSubcon} deleteSubcon={deleteSubcon} session={session} role={role} isMobile={isMobile}/></Wrap>);
    if(page==="expenses") return(
      <Wrap>
        <SecHead title="Expense Ledger" action={<Btn onClick={()=>openAddExp()}>+ Other Payable</Btn>} sub="Historical log of costs — company-wide and per project"/>
        <div style={{display:"flex",gap:8,alignItems:"flex-start",background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:".8rem",color:"#1e40af",lineHeight:1.45}}>
          <span style={{fontSize:"1rem",lineHeight:1}}>💡</span>
          <span>This is the historical expense ledger. To <strong>record a new cost</strong>, use <strong>+ Other Payable</strong> — it enters the AP ledger where it can be approved, verified and paid. Materials &amp; subcon costs come in through their PO / Work Order instead.</span>
        </div>
        {["all",...projList.map(d=>d.id)].map(filter=>{
          const label=filter==="all"?"All Expenses":clientName(filter);
          const filtered=filter==="all"?exps:exps.filter(e=>e.projectId===filter);
          if(filter!=="all"&&filtered.length===0) return null;
          return(
            <div key={filter} style={{marginBottom:20}}>
              {filter!=="all"&&<div style={{fontWeight:700,color:"#0f172a",marginBottom:8,fontSize:".92rem"}}>{label}</div>}
              {filtered.map(e=>(
                <Card key={e.id}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
                        <Badge label={e.category} color="#64748b"/>
                        {e.projectId?<Badge label={clientName(e.projectId)} color="#8b5cf6"/>:<Badge label="Company-wide" color="#94a3b8"/>}
                        <span style={{fontSize:".72rem",color:"#94a3b8"}}>{MONTHS[e.month]}</span>
                      </div>
                      <div style={{fontWeight:600,color:"#0f172a"}}>{e.note}</div>
                      {e.receipt&&<a href={e.receipt} target="_blank" rel="noreferrer" style={{fontSize:".72rem",color:"#3b82f6",marginTop:4,display:"block"}}>📎 View Receipt</a>}
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontWeight:800,color:"#ef4444",fontSize:"1.05rem"}}>{fmt(e.amount)}</div>
                      <div style={{display:"flex",gap:6,marginTop:8}}><Btn small variant="ghost" onClick={()=>openEditExp(e)}>✏ Edit</Btn><Btn small variant="danger" onClick={()=>delExp(e.id)}>Delete</Btn></div>
                    </div>
                  </div>
                </Card>
              ))}
              {filter==="all"&&exps.length===0&&<EmptyState icon="📋" msg="No legacy expenses here. New costs are recorded as Other Payables in the AP ledger."/>}
            </div>
          );
        })}
      </Wrap>
    );
  }

  // ─── OPERATIONS ───────────────────────────────────────────────────────────
  // ── WAREHOUSE ───────────────────────────────────────────────────────────────
  // Warehousing is hidden (shared.jsx): the Warehouse role's whole workspace
  // was Deliveries / Inventory / Stock Movements, so it gets a notice instead.
  if(role==="Warehouse"&&WAREHOUSE_HIDDEN) return(<Wrap><EmptyState icon="🏭" msg="Warehousing is offline while FabHub's modules are being rebuilt. Please coordinate deliveries and stock with Procurement for now."/></Wrap>);
  if(role==="Warehouse"||(["Manager","Finance"].includes(role)&&page==="deliveries")){
    if(role==="Warehouse"&&page==="stockmove") return(<Wrap><StockMovementView inventory={inventory} stocklog={stocklog} wonDeals={wonDeals} logStockMove={logStockMove} session={session} role={role}/></Wrap>);
    if(role==="Warehouse"&&page==="inventory") return(<Wrap><InventoryView inventory={inventory} stocklog={stocklog} wonDeals={wonDeals} prs={prs} updatePR={updatePR} addPR={addPR} addInventoryItem={addInventoryItem} updateInventoryItem={updateInventoryItem} deleteInventoryItem={deleteInventoryItem} clearAllInventory={clearAllInventory} logStockMove={logStockMove} mergeInventoryItems={mergeInventoryItems} suppliers={suppliers} addSupplier={addSupplier} printDR={printDR} tools={tools} upTools={upTools} saveTool={saveTool} deleteTool={deleteTool} drs={drs} saveDr={saveDr} deleteDr={deleteDr} projs={projs} upProjs={upProjs} deals={wonDeals} session={session} role={role}/></Wrap>);
    if(page==="deliveries"||page==="home") return(
      <Wrap>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>Good {greeting}, {session?.name?.split(" ")[0]||"Warehouse"} 👋</div>
            <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>Warehouse · {todayL}</div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button onClick={()=>{setIssueForm({itemId:"",qty:"",projectId:"",requestedBy:"",deliveryLink:"",date:today});setIssueModal(true);}} style={{background:"#f97316",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📤 Issue to Site</button>
            <button onClick={()=>{setFabForm({itemId:"",qty:"",projectId:"",requestedBy:"",notes:"",date:today});setFabModal(true);}} style={{background:"#8b5cf6",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>🔨 Fab Release</button>
            <button onClick={()=>setPage("inventory")} style={{background:"#64748b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📦 Inventory</button>
            <button onClick={()=>setPage("stockmove")} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer"}}>📋 Stock Log</button>
          </div>
        </div>
        {(()=>{
          const now=new Date();
          const weekEnd=new Date(now); weekEnd.setDate(now.getDate()+7);
          const toReceive=prs.filter(p=>!["Delivered","Cancelled","Draft"].includes(p.status)&&p.poDate);
          const arrivedToday=prs.filter(p=>p.deliveryDate===today&&p.status!=="Delivered"&&p.status!=="Cancelled");
          const overdueDeliveries=prs.filter(p=>p.deliveryDate&&p.deliveryDate<today&&!["Delivered","Cancelled"].includes(p.status));
          const thisWeek=prs.filter(p=>p.deliveryDate&&new Date(p.deliveryDate)>=now&&new Date(p.deliveryDate)<=weekEnd&&!["Delivered","Cancelled"].includes(p.status));
          const recentlyReceived=prs.filter(p=>p.status==="Delivered"&&p.deliveryDate&&Math.abs(Math.ceil((now-new Date(p.deliveryDate))/(1000*60*60*24)))<=3);
          const lowStockItems=inventory.filter(i=>i.status!=="Inactive"&&Number(i.reorderPoint)>0&&Number(i.qtyOnHand)<=Number(i.reorderPoint));
          return(
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              {/* KPI strip — delivery health + inventory health, all click-through */}
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"repeat(2,1fr)":"repeat(5,1fr)",gap:12}}>
                {[
                  {l:"Arriving Today",    v:arrivedToday.length,        c:"#dc2626", icon:"🚨", pg:"deliveries"},
                  {l:"Overdue",           v:overdueDeliveries.length,   c:"#f97316", icon:"⏰", pg:"deliveries"},
                  {l:"This Week",         v:thisWeek.length,            c:"#3b82f6", icon:"🚚", pg:"deliveries"},
                  {l:"Received (3d)",     v:recentlyReceived.length,    c:"#059669", icon:"✅", pg:"stockmove"},
                  {l:"Low Stock",        v:lowStockItems.length,       c:lowStockItems.length>0?"#f59e0b":"#94a3b8", icon:"📉", pg:"inventory"},
                ].map(({l,v,c,icon,pg})=>(
                  <div key={l} onClick={()=>setPage(pg)} style={{background:"#fff",borderRadius:12,padding:"14px",border:`1.5px solid ${c}33`,textAlign:"center",cursor:"pointer"}}>
                    <div style={{fontSize:"1.2rem",marginBottom:4}}>{icon}</div>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
                    <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
                  </div>
                ))}
              </div>

              {/* Low stock banner */}
              {(()=>{const lowStock=lowStockItems;return lowStock.length>0?(
                <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"10px 16px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                  <span style={{fontSize:"1rem"}}>⚠️</span>
                  <div style={{flex:1}}>
                    <strong style={{fontSize:".84rem",color:"#92400e"}}>{lowStock.length} item{lowStock.length>1?"s":""} at or below reorder point</strong>
                    <div style={{fontSize:".75rem",color:"#b45309",marginTop:2}}>{lowStock.slice(0,5).map(i=>`${i.name} (${i.qtyOnHand} ${i.unit||""} left)`).join(" · ")}{lowStock.length>5&&` +${lowStock.length-5} more`}</div>
                  </div>
                  <button onClick={()=>setPage("inventory")} style={{background:"#f59e0b",border:"none",borderRadius:8,padding:"6px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",cursor:"pointer",whiteSpace:"nowrap"}}>View Inventory</button>
                </div>
              ):null;})()}

              {/* Arriving today — most urgent */}
              {arrivedToday.length>0&&(
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fecaca",overflow:"hidden"}}>
                  <div style={{background:"#dc2626",padding:"10px 16px"}}><span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>🚨 Due Today — Receive and Inspect ({arrivedToday.length})</span></div>
                  {arrivedToday.map((pr,i)=>{
                    const d=wonDeals.find(x=>x.id===pr.projectId);
                    const joW=dealJo(jos,pr.projectId);
                    const pmW=pcards[pr.projectId]?.pm1||joW?.pm1;
                    return(
                      <div key={pr.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",borderBottom:i<arrivedToday.length-1?"1px solid #fee2e2":"",background:"#fff"}}>
                        <div>
                          <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem"}}>{pr.itemName}</div>
                          <div style={{fontSize:".72rem",color:"#64748b"}}>{d?.contact||d?.client||"?"} <span style={{color:"#94a3b8"}}>({d?.client||""})</span></div>
                          <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:1}}>{pr.qty} {pr.unit} · {pr.supplier||"No supplier"}{pmW?` · PM: ${pmW}`:""}</div>
                          {pr.poNumber&&<div style={{fontSize:".65rem",color:"#64748b"}}>PO: {pr.poNumber}</div>}
                        </div>
                        <button onClick={()=>{setReceivingPr({...pr,_deal:d});setRxQty(String(pr.qty||""));setRxDrNo("");}}
                          style={{background:"#059669",border:"none",borderRadius:8,padding:"7px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                          ✓ Receive
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Overdue deliveries */}
              {overdueDeliveries.length>0&&(
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #fed7aa",overflow:"hidden"}}>
                  <div style={{background:"#d97706",padding:"10px 16px"}}><span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>⏰ Overdue — Follow Up with Procurement ({overdueDeliveries.length})</span></div>
                  {overdueDeliveries.map((pr,i)=>{
                    const d=wonDeals.find(x=>x.id===pr.projectId);
                    const joW=dealJo(jos,pr.projectId);
                    const pmW=pcards[pr.projectId]?.pm1||joW?.pm1;
                    const daysLate=Math.ceil((now-new Date(pr.deliveryDate))/(1000*60*60*24));
                    return(
                      <div key={pr.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<overdueDeliveries.length-1?"1px solid #fef3c7":"",background:"#fff"}}>
                        <div>
                          <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{pr.itemName}</div>
                          <div style={{fontSize:".72rem",color:"#64748b"}}>{d?.contact||d?.client||"?"}</div>
                          <div style={{fontSize:".68rem",color:"#94a3b8"}}>Expected {pr.deliveryDate} · {pr.supplier||"No supplier"}{pmW?` · PM: ${pmW}`:""}</div>
                        </div>
                        <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"flex-end"}}>
                          <span style={{fontSize:".72rem",background:"#fff7ed",color:"#d97706",border:"1px solid #fed7aa",borderRadius:20,padding:"2px 9px",fontWeight:700,whiteSpace:"nowrap"}}>{daysLate}d late</span>
                          <button onClick={()=>{setReceivingPr({...pr,_deal:d});setRxQty(String(pr.qty||""));setRxDrNo("");}}
                            style={{background:"#059669",border:"none",borderRadius:8,padding:"5px 12px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer",whiteSpace:"nowrap"}}>
                            ✓ Receive
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* This week's expected deliveries */}
              {thisWeek.length>0&&(
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  <div style={{background:"#1e293b",padding:"10px 16px"}}><span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>🚚 Expected This Week ({thisWeek.length})</span></div>
                  {thisWeek.map((pr,i)=>{
                    const d=wonDeals.find(x=>x.id===pr.projectId);
                    const daysUntil=Math.ceil((new Date(pr.deliveryDate)-now)/(1000*60*60*24));
                    return(
                      <div key={pr.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:i<thisWeek.length-1?"1px solid #f8fafc":"",background:"#fff"}}>
                        <div>
                          <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>{pr.itemName}</div>
                          <div style={{fontSize:".72rem",color:"#94a3b8"}}>{d?.client||"?"} · {pr.qty} {pr.unit} · {pr.supplier||"—"} · {pr.deliveryDate}</div>
                        </div>
                        <span style={{fontSize:".72rem",background:"#eff6ff",color:"#3b82f6",border:"1px solid #bfdbfe",borderRadius:20,padding:"2px 9px",fontWeight:700,whiteSpace:"nowrap"}}>{daysUntil===0?"Today":daysUntil===1?"Tomorrow":`in ${daysUntil}d`}</span>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Quick links */}
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10}}>
                <div onClick={()=>{setIssueForm({itemId:"",qty:"",projectId:"",requestedBy:"",deliveryLink:"",date:today});setIssueModal(true);}} style={{background:"#fff7ed",borderRadius:10,padding:"16px",border:"1.5px solid #fed7aa",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:"1.4rem"}}>📤</div>
                  <div style={{fontWeight:700,color:"#c2410c",marginTop:6,fontSize:".88rem"}}>Issue to Site</div>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>Send items to project site</div>
                </div>
                <div onClick={()=>{setFabForm({itemId:"",qty:"",projectId:"",requestedBy:"",notes:"",date:today});setFabModal(true);}} style={{background:"#f5f3ff",borderRadius:10,padding:"16px",border:"1.5px solid #ddd6fe",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:"1.4rem"}}>🔨</div>
                  <div style={{fontWeight:700,color:"#6d28d9",marginTop:6,fontSize:".88rem"}}>Fab Release</div>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>Release materials to fab floor</div>
                </div>
                <div onClick={()=>setPage("inventory")} style={{background:"#fff",borderRadius:10,padding:"16px",border:"1.5px solid #e2e8f0",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:"1.4rem"}}>📦</div>
                  <div style={{fontWeight:700,color:"#0f172a",marginTop:6,fontSize:".88rem"}}>Inventory</div>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>{inventory.length} items tracked</div>
                </div>
                <div onClick={()=>setPage("stockmove")} style={{background:"#fff",borderRadius:10,padding:"16px",border:"1.5px solid #e2e8f0",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:"1.4rem"}}>📋</div>
                  <div style={{fontWeight:700,color:"#0f172a",marginTop:6,fontSize:".88rem"}}>Stock Log</div>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>Full history · IN / OUT / Adjust</div>
                </div>
              </div>
            </div>
          );
        })()}

        {/* ── Partial Receiving Modal ─────────────────────────── */}
        {receivingPr&&(
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)setReceivingPr(null);}}>
            <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:440,boxShadow:"0 20px 60px rgba(0,0,0,.25)"}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.25rem",color:"#0f172a",marginBottom:4}}>📦 Receive Delivery</div>
              <div style={{fontSize:".8rem",color:"#64748b",marginBottom:18,paddingBottom:14,borderBottom:"1px solid #f1f5f9"}}>Confirm receipt and log into inventory</div>

              <div style={{background:"#f8fafc",borderRadius:10,padding:"12px 14px",marginBottom:16,fontSize:".83rem"}}>
                <div style={{fontWeight:700,color:"#0f172a",marginBottom:4}}>{receivingPr.itemName}</div>
                <div style={{color:"#64748b"}}>Supplier: <strong>{receivingPr.supplier||"—"}</strong></div>
                <div style={{color:"#64748b"}}>PO: <strong>{receivingPr.poNumber||"—"}</strong> · Expected: <strong>{receivingPr.qty} {receivingPr.unit||""}</strong></div>
                {receivingPr._deal&&<div style={{color:"#64748b",marginTop:2}}>Project: <strong>{projDisplayName(receivingPr._deal)}</strong></div>}
              </div>

              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
                <div>
                  <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Qty Received *</label>
                  <input type="number" value={rxQty} onChange={e=>setRxQty(e.target.value)} min={0.01} step="any"
                    style={{width:"100%",border:"1.5px solid #3b82f6",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".92rem",fontWeight:700,color:"#0f172a",textAlign:"center"}}/>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:3}}>PO qty: {receivingPr.qty} {receivingPr.unit||""}</div>
                </div>
                <div>
                  <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>DR / Reference No.</label>
                  <input type="text" value={rxDrNo} onChange={e=>setRxDrNo(e.target.value)} placeholder="e.g. DR-2024-001"
                    style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a"}}/>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:3}}>Supplier's delivery note #</div>
                </div>
              </div>

              {rxQty&&Number(rxQty)<Number(receivingPr.qty)&&(
                <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:8,padding:"8px 12px",marginBottom:14,fontSize:".78rem",color:"#92400e"}}>
                  ⚠️ Partial receipt — balance of <strong>{Number(receivingPr.qty)-Number(rxQty)} {receivingPr.unit||""}</strong> remains outstanding
                </div>
              )}

              <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                <button disabled={!rxQty||Number(rxQty)<=0} onClick={()=>{
                  const isPartial=Number(rxQty)<Number(receivingPr.qty);
                  const newStatus=isPartial?"Partially Delivered":"Delivered";
                  const noteStr=`${rxDrNo?`DR: ${rxDrNo} · `:""}Received ${rxQty} ${receivingPr.unit||""} by ${session?.name||"Warehouse"} on ${today}`;
                  const unitCost=Number(receivingPr.actUnitCost||receivingPr.estUnitCost)||0;
                  const recvAmt=Math.round(Number(rxQty)*unitCost*100)/100;
                  const poNote=`${rxDrNo?`DR ${rxDrNo} · `:""}PO ${receivingPr.poNumber||receivingPr.id.slice(-6)} · ${receivingPr.supplier||""}`;
                  // GMD-stock POs aren't tied to a real project (projectId="__gmd_stocks__").
                  const isStock=receivingPr.projectId==="__gmd_stocks__"||receivingPr.projectName==="GMD Stocks";
                  const sProjId=isStock?null:(receivingPr.projectId||null);
                  // ── ACCOUNTING: a PROJECT-DIRECT delivery records the cost as a logged EXPENSE on receipt
                  // (acctStatus "Logged" — recognized now, NOT pushed into the pay-now queue, since suppliers
                  // are on terms; payment is handled separately when due). The expense is tagged to the project.
                  // GMD-stock deliveries are NOT expensed here — stock is a cash-valued asset, expensed only when
                  // it's released to a project (handled in logStockMove). This avoids double-counting stock cost.
                  const alreadyLogged=recvAmt>0&&exps.some(e=>e.fromPrId===receivingPr.id&&e.expDate===today&&Number(e.amount)===recvAmt);
                  let paymentStatus="Pending Payment";
                  if(recvAmt>0&&!isStock&&!alreadyLogged){
                    const expId=uid();
                    const supTerms=(suppliers.find(s=>(s.companyName||"").toLowerCase()===(receivingPr.supplier||"").toLowerCase())||{}).paymentTerms||"";
                    // PO-level terms (warehouse policy) win over the supplier default — a
                    // per-PO negotiation (e.g. COD rush from a Net-60 supplier) is honoured.
                    const effTerms=receivingPr.paymentTerms||supTerms;
                    const due=dueDateFromTerms(effTerms,today);
                    // Reconcile the PO's existing payable (created when the PO was issued) instead of
                    // creating a duplicate: stamp its due date from the supplier's terms on first
                    // receipt and link this receipt's expense to it. Only fall back to a fresh
                    // per-line payable when the PO has none yet — legacy POs issued before the
                    // auto-payable, or solo requests with no PO number.
                    const existingPoPay=receivingPr.poNumber?payables.find(p=>p.poId===receivingPr.poNumber):null;
                    let payId;
                    if(existingPoPay){
                      payId=existingPoPay.id;
                      if(!existingPoPay.dueDate&&existingPoPay.status!=="Paid"){
                        const upd={...existingPoPay,dueDate:due};
                        upPayables(ps=>ps.map(p=>p.id===existingPoPay.id?upd:p));
                        if(isSupabaseReady()&&isUUID(existingPoPay.id)) sbUpsert("payables",payableToSb(upd),"id").catch(()=>{});
                      }
                    } else {
                      payId=uid();
                      // Payment-due tracker: float a payable with a due date computed from the supplier's terms,
                      // so finance can see when it's due. It gets settled later via Check Payable / BizLink.
                      const payRec={id:payId,vendor:receivingPr.supplier||"—",amount:recvAmt,dueDate:due,projectId:sProjId,category:"Supplier",accountCode:receivingPr.accountCode||"5020",invoiceRef:rxDrNo?`DR ${rxDrNo}`:"",notes:`${receivingPr.itemName||""} · PO ${receivingPr.poNumber||receivingPr.id.slice(-6)}${effTerms?` · Terms: ${effTerms}${receivingPr.paymentTerms?" (PO)":""}`:" · No terms on file"}`,status:"Unpaid",poNumber:receivingPr.poNumber||"",poId:receivingPr.id,expenseId:expId,createdAt:today,createdBy:session?.name||""};
                      upPayables(ps=>[payRec,...ps]);
                      if(isSupabaseReady()) sbUpsert("payables",payableToSb(payRec),"id").catch(()=>{});
                    }
                    // payableId links the expense to its payable so it isn't offered for re-routing
                    // (which would create a duplicate payable/CV for the same PO).
                    const expRec={id:expId,expDate:today,month:new Date().getMonth(),year:new Date().getFullYear(),category:receivingPr.category||"Materials",note:`${receivingPr.itemName||""}${receivingPr.poNumber?" — "+receivingPr.poNumber:""}`,payee:receivingPr.supplier||"",supplier:receivingPr.supplier||"",qty:Number(rxQty),pricePerQty:unitCost,amount:recvAmt,projectId:sProjId,dealId:sProjId,bankAccount:"",poRef:receivingPr.poNumber||"",receipt:rxDrNo?`DR ${rxDrNo}`:"",acctStatus:"Logged",payableId:payId,createdBy:session?.name||"",createdAt:today,fromPrId:receivingPr.id};
                    upExps(es=>[...es,expRec]);
                    if(isSupabaseReady()) sbUpsert("expenses",toSbExpense(expRec),"id").catch(()=>{});
                    paymentStatus="Expense Logged";
                  }
                  updatePR(receivingPr.id,{status:newStatus,qtyDelivered:Number(rxQty),deliveryDate:today,deliveryNote:noteStr,paymentStatus});
                  sendTelegramNotification("procurement",`📦 <b>Delivery ${isPartial?"Partial ":""} Confirmed</b>\n${receivingPr.itemName}\nQty: ${rxQty}/${receivingPr.qty} ${receivingPr.unit||""}\n${rxDrNo?`DR: ${rxDrNo}\n`:""}Received by: ${session?.name||"Warehouse"} · ${today}`);
                  sendTelegramNotification("warehouse",`📦 <b>Delivery ${isPartial?"Partial ":""} Confirmed</b>\n${receivingPr.itemName}\nQty: ${rxQty}/${receivingPr.qty} ${receivingPr.unit||""}\n${rxDrNo?`DR: ${rxDrNo}\n`:""}Received by: ${session?.name||"Warehouse"} · ${today}`);
                  // ── INVENTORY: log stock-in. If the item isn't an inventory SKU yet, auto-create it so
                  // the warehouse can always track what was received (no more silent, untracked deliveries).
                  const invMatch=inventory.find(i=>i.name?.toLowerCase()===receivingPr.itemName?.toLowerCase()||i.name?.toLowerCase().includes(receivingPr.itemName?.toLowerCase()));
                  if(invMatch){
                    logStockMove({itemId:invMatch.id,moveType:"IN — Delivery",qty:Number(rxQty),unitCost,projectId:sProjId,notes:poNote,date:today});
                  } else {
                    const newInvId=uid();
                    addInventoryItem({id:newInvId,name:receivingPr.itemName||"Unnamed item",category:receivingPr.category||"Materials",unit:receivingPr.unit||"pcs",supplier:receivingPr.supplier||"",qtyOnHand:0,reorderPoint:0,avgCost:0,lastPurchasePrice:0,location:"Main Warehouse",status:"Active",notes:`Auto-created from ${receivingPr.poNumber||"PO"}`});
                    logStockMove({itemId:newInvId,moveType:"IN — Delivery",qty:Number(rxQty),unitCost,projectId:sProjId,notes:poNote,date:today});
                  }
                  toastEmit(`✓ Delivery recorded${isPartial?" (partial)":""}${recvAmt>0&&!isStock&&!alreadyLogged?` · ₱${recvAmt.toLocaleString("en-PH")} expense logged`:isStock?" · added to GMD Stock (asset)":""} · stock updated`,"success");
                  setReceivingPr(null);
                }}
                  style={{flex:1,background:rxQty&&Number(rxQty)>0?"#059669":"#e2e8f0",border:"none",borderRadius:9,padding:"11px 0",color:rxQty&&Number(rxQty)>0?"#fff":"#94a3b8",fontFamily:"inherit",fontWeight:800,fontSize:".88rem",cursor:rxQty&&Number(rxQty)>0?"pointer":"not-allowed"}}>
                  ✓ Confirm Receipt
                </button>
                <button onClick={()=>printDR(receivingPr,rxQty||receivingPr.qty,rxDrNo,receivingPr._deal)}
                  style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:9,padding:"11px 14px",color:"#1d4ed8",fontFamily:"inherit",fontWeight:700,fontSize:".83rem",cursor:"pointer"}}>
                  🖨 Print DR
                </button>
                <button onClick={()=>setReceivingPr(null)}
                  style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"11px 14px",color:"#64748b",fontFamily:"inherit",fontWeight:600,fontSize:".83rem",cursor:"pointer"}}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Issue to Site Modal ─────────────────────────── */}
        {issueModal&&(()=>{
          const canConfirm=issueForm.itemId&&issueForm.qty&&Number(issueForm.qty)>0&&issueForm.projectId;
          const item=inventory.find(i=>i.id===issueForm.itemId);
          const remaining=item?(item.qtyOnHand-Number(issueForm.qty)):null;
          return(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)setIssueModal(false);}}>
              <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:460,boxShadow:"0 20px 60px rgba(0,0,0,.25)",maxHeight:"90vh",overflowY:"auto"}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.3rem",color:"#0f172a",marginBottom:2}}>📤 Issue to Site</div>
                <div style={{fontSize:".78rem",color:"#64748b",marginBottom:18,paddingBottom:14,borderBottom:"1px solid #f1f5f9"}}>Items leaving the warehouse going to a project site. The project PM will be notified to confirm receipt.</div>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Project / Site <span style={{color:"#ef4444"}}>*</span></label>
                    <select value={issueForm.projectId} onChange={e=>setIssueForm(f=>({...f,projectId:e.target.value}))}
                      style={{width:"100%",border:`1.5px solid ${issueForm.projectId?"#f97316":"#e2e8f0"}`,borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a"}}>
                      <option value="">— Select project —</option>
                      {wonDeals.filter(d=>d.stage!=="14 · Completed").map(d=>(
                        <option key={d.id} value={d.id}>{d.client}{d.ceNo?` (${d.ceNo})`:""}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Item <span style={{color:"#ef4444"}}>*</span></label>
                    <select value={issueForm.itemId} onChange={e=>setIssueForm(f=>({...f,itemId:e.target.value}))}
                      style={{width:"100%",border:`1.5px solid ${issueForm.itemId?"#f97316":"#e2e8f0"}`,borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a"}}>
                      <option value="">— Select item —</option>
                      {[...inventory].filter(i=>i.status!=="Inactive").sort((a,b)=>a.name.localeCompare(b.name)).map(i=>(
                        <option key={i.id} value={i.id}>{i.name} — {i.qtyOnHand} {i.unit} on hand</option>
                      ))}
                    </select>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                    <div>
                      <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Qty Issued <span style={{color:"#ef4444"}}>*</span></label>
                      <input type="number" min="0.01" step="any" value={issueForm.qty} onChange={e=>setIssueForm(f=>({...f,qty:e.target.value}))} placeholder="0"
                        style={{width:"100%",border:`1.5px solid ${issueForm.qty?"#f97316":"#e2e8f0"}`,borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".92rem",fontWeight:700,color:"#0f172a",textAlign:"center",boxSizing:"border-box"}}/>
                      {item&&issueForm.qty&&<div style={{fontSize:".68rem",marginTop:3,fontWeight:700,color:remaining<0?"#ef4444":"#94a3b8"}}>{remaining<0?`⚠ Only ${item.qtyOnHand} ${item.unit} on hand`:`Remaining after: ${remaining} ${item.unit}`}</div>}
                    </div>
                    <div>
                      <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Date</label>
                      <input type="date" value={issueForm.date} onChange={e=>setIssueForm(f=>({...f,date:e.target.value}))}
                        style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a",boxSizing:"border-box"}}/>
                    </div>
                  </div>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Requested by</label>
                    <input value={issueForm.requestedBy} onChange={e=>setIssueForm(f=>({...f,requestedBy:e.target.value}))} placeholder="PM or site engineer name"
                      style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a",boxSizing:"border-box"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Delivery Photo / Link <span style={{fontSize:".65rem",color:"#94a3b8",fontWeight:400}}>(Google Drive, photo URL, etc.)</span></label>
                    <input value={issueForm.deliveryLink} onChange={e=>setIssueForm(f=>({...f,deliveryLink:e.target.value}))} placeholder="https://drive.google.com/…"
                      style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a",boxSizing:"border-box"}}/>
                  </div>
                  <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"9px 12px",fontSize:".74rem",color:"#92400e"}}>
                    ℹ️ After confirming, a task will be added to the project checklist for the PM to acknowledge receipt on site.
                  </div>
                </div>
                <div style={{display:"flex",gap:10,marginTop:20}}>
                  <button disabled={!canConfirm} onClick={async ()=>{
                    if(!item) return;
                    if(remaining<0){if(!(await uiConfirm(`Only ${item.qtyOnHand} ${item.unit} on hand. Issue ${issueForm.qty} anyway?`))) return;}
                    const notesStr=[issueForm.requestedBy?`Requested by: ${issueForm.requestedBy}`:"",issueForm.deliveryLink?`Delivery link: ${issueForm.deliveryLink}`:""].filter(Boolean).join(" · ");
                    const ok=logStockMove({itemId:issueForm.itemId,moveType:"OUT — Issued to Site",qty:Number(issueForm.qty),unitCost:0,projectId:issueForm.projectId,notes:notesStr,date:issueForm.date||today});
                    if(!ok) return;
                    // Create PM confirmation checklist task
                    const deal=wonDeals.find(d=>d.id===issueForm.projectId);
                    const task={id:uid(),projectId:issueForm.projectId,title:`Confirm receipt: ${Number(issueForm.qty)} ${item.unit} of ${item.name} from Warehouse`,dept:"Operations",priority:"Normal",status:"To Do",dueDate:issueForm.date||today,createdBy:session?.name||"Warehouse",createdDate:today,notes:`Issued by: ${session?.name||"Warehouse"}${issueForm.requestedBy?` | Requested by: ${issueForm.requestedBy}`:""}${issueForm.deliveryLink?` | ${issueForm.deliveryLink}`:""}`};
                    upChecklist(cs=>[...cs,task]);
                    if(isSupabaseReady()) sbInsert('checklists',toSbChecklist(task)).catch(()=>{});
                    sendTelegramNotification("ops",`📦 <b>Materials Issued to Site</b>\nItem: <b>${item.name}</b> — ${Number(issueForm.qty)} ${item.unit}\nProject: ${deal?.client||"?"}${deal?.ceNo?` (${deal.ceNo})`:""}\nIssued by: ${session?.name||"Warehouse"}${issueForm.requestedBy?`\nRequested by: ${issueForm.requestedBy}`:""}\n\n⚠️ Please confirm receipt in the project checklist.`);
                    toastEmit(`📤 Issued ${issueForm.qty} ${item.unit} of ${item.name} → ${deal?.client||"site"}. PM notified to confirm.`,"success");
                    setIssueModal(false);
                  }}
                    style={{flex:1,background:canConfirm?"#f97316":"#e2e8f0",border:"none",borderRadius:9,padding:"12px 0",color:canConfirm?"#fff":"#94a3b8",fontFamily:"inherit",fontWeight:800,fontSize:".88rem",cursor:canConfirm?"pointer":"not-allowed"}}>
                    📤 Confirm Issue to Site
                  </button>
                  <button onClick={()=>setIssueModal(false)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"12px 16px",color:"#64748b",fontFamily:"inherit",fontWeight:600,fontSize:".83rem",cursor:"pointer"}}>Cancel</button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* ── Fab Release Modal ─────────────────────────── */}
        {fabModal&&(()=>{
          const canConfirm=fabForm.itemId&&fabForm.qty&&Number(fabForm.qty)>0;
          const item=inventory.find(i=>i.id===fabForm.itemId);
          const remaining=item?(item.qtyOnHand-Number(fabForm.qty)):null;
          return(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)setFabModal(false);}}>
              <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:440,boxShadow:"0 20px 60px rgba(0,0,0,.25)"}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.3rem",color:"#0f172a",marginBottom:2}}>🔨 Release for Fabrication</div>
                <div style={{fontSize:".78rem",color:"#64748b",marginBottom:18,paddingBottom:14,borderBottom:"1px solid #f1f5f9"}}>Materials going to the fabrication floor inside the warehouse. Logged as one-way — no site confirmation needed.</div>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Item <span style={{color:"#ef4444"}}>*</span></label>
                    <select value={fabForm.itemId} onChange={e=>setFabForm(f=>({...f,itemId:e.target.value}))}
                      style={{width:"100%",border:`1.5px solid ${fabForm.itemId?"#8b5cf6":"#e2e8f0"}`,borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a"}}>
                      <option value="">— Select item —</option>
                      {[...inventory].filter(i=>i.status!=="Inactive").sort((a,b)=>a.name.localeCompare(b.name)).map(i=>(
                        <option key={i.id} value={i.id}>{i.name} — {i.qtyOnHand} {i.unit} on hand</option>
                      ))}
                    </select>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                    <div>
                      <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Qty Released <span style={{color:"#ef4444"}}>*</span></label>
                      <input type="number" min="0.01" step="any" value={fabForm.qty} onChange={e=>setFabForm(f=>({...f,qty:e.target.value}))} placeholder="0"
                        style={{width:"100%",border:`1.5px solid ${fabForm.qty?"#8b5cf6":"#e2e8f0"}`,borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".92rem",fontWeight:700,color:"#0f172a",textAlign:"center",boxSizing:"border-box"}}/>
                      {item&&fabForm.qty&&<div style={{fontSize:".68rem",marginTop:3,fontWeight:700,color:remaining<0?"#ef4444":"#94a3b8"}}>{remaining<0?`⚠ Only ${item.qtyOnHand} ${item.unit} on hand`:`After: ${remaining} ${item.unit} left`}</div>}
                    </div>
                    <div>
                      <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Date</label>
                      <input type="date" value={fabForm.date} onChange={e=>setFabForm(f=>({...f,date:e.target.value}))}
                        style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a",boxSizing:"border-box"}}/>
                    </div>
                  </div>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Project</label>
                    <select value={fabForm.projectId} onChange={e=>setFabForm(f=>({...f,projectId:e.target.value}))}
                      style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a"}}>
                      <option value="">— Optional —</option>
                      {wonDeals.filter(d=>d.stage!=="14 · Completed").map(d=>(
                        <option key={d.id} value={d.id}>{d.client}{d.ceNo?` (${d.ceNo})`:""}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Requested by</label>
                    <input value={fabForm.requestedBy} onChange={e=>setFabForm(f=>({...f,requestedBy:e.target.value}))} placeholder="Fabrication supervisor name"
                      style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a",boxSizing:"border-box"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:".75rem",fontWeight:700,color:"#475569",display:"block",marginBottom:5}}>Notes</label>
                    <input value={fabForm.notes} onChange={e=>setFabForm(f=>({...f,notes:e.target.value}))} placeholder="Work order, batch reference, reason…"
                      style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#0f172a",boxSizing:"border-box"}}/>
                  </div>
                </div>
                <div style={{display:"flex",gap:10,marginTop:20}}>
                  <button disabled={!canConfirm} onClick={async ()=>{
                    if(!item) return;
                    if(remaining<0){if(!(await uiConfirm(`Only ${item.qtyOnHand} ${item.unit} on hand. Release ${fabForm.qty} anyway?`))) return;}
                    const notesStr=[fabForm.requestedBy?`Requested by: ${fabForm.requestedBy}`:"",fabForm.notes].filter(Boolean).join(" · ");
                    if(!logStockMove({itemId:fabForm.itemId,moveType:"OUT — Released for Fabrication",qty:Number(fabForm.qty),unitCost:0,projectId:fabForm.projectId||"",notes:notesStr,date:fabForm.date||today})) return;
                    const deal=fabForm.projectId?wonDeals.find(d=>d.id===fabForm.projectId):null;
                    toastEmit(`🔨 Released ${fabForm.qty} ${item.unit} of ${item.name} to fab floor${deal?` — ${deal.client}`:""}`,"success");
                    setFabModal(false);
                  }}
                    style={{flex:1,background:canConfirm?"#8b5cf6":"#e2e8f0",border:"none",borderRadius:9,padding:"12px 0",color:canConfirm?"#fff":"#94a3b8",fontFamily:"inherit",fontWeight:800,fontSize:".88rem",cursor:canConfirm?"pointer":"not-allowed"}}>
                    🔨 Confirm Fab Release
                  </button>
                  <button onClick={()=>setFabModal(false)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"12px 16px",color:"#64748b",fontFamily:"inherit",fontWeight:600,fontSize:".83rem",cursor:"pointer"}}>Cancel</button>
                </div>
              </div>
            </div>
          );
        })()}
      </Wrap>
    );
  }

  if(role==="Operations"){
    if(page==="home") return <OpsView sendTelegramNotification={sendTelegramNotification} projs={projs} projList={projList} deals={deals} selProj={selProj} setSelProj={setSelProj} opsTab={opsTab} setOpsTab={setOpsTab} proj={proj} projDeal={projDeal} upProj={upProj} overallProg={overallProg} costOf={costOf} marginOf={marginOf} openDesignEdit={openDesignEdit} swatches={swatches} swQ={swQ} openAddSwatch={(pid,by)=>{setSwForm({projectId:pid,name:"",category:"Fabric",qty:"",unit:"pcs",supplier:"",estCost:"",swatchLink:"",addedBy:by||"Ops",status:"To Buy",notes:""});setEditSw(null);setSwModal(true);}} openEditSwatch={sw=>{setSwForm({...sw});setEditSw(sw.id);setSwModal(true);}} delSwatch={id=>upSwatches(ss=>ss.filter(s=>s.id!==id))} exps={exps} openAddExp={openAddExp} openEditExp={openEditExp} delExp={delExp} clientName={clientName} matModal={matModal} setMatModal={setMatModal} matForm={matForm} setMatForm={setMatForm} editMat={editMat} setEditMat={setEditMat} saveMat={()=>{if(!matForm.name||!matForm.qty||!matForm.cost)return;const rec={...matForm,qty:Number(matForm.qty),cost:Number(matForm.cost),id:editMat||uid()};upProj(selProj,p=>({...p,materials:editMat?p.materials.map(m=>m.id===editMat?rec:m):[...p.materials,rec]}));setMatModal(false);setEditMat(null);setMatForm({name:"",qty:"",unit:"pcs",cost:"",received:false});}} addPmUpdate={addPmUpdate} addAddendum={addAddendum} updateAddendumStatus={updateAddendumStatus} session={session} Wrap={Wrap} addenda={addenda} addAddendum2={addAddendum2} updateAddendum={updateAddendum} deleteAddendum={deleteAddendum} pcards={pcards} logActivity={logActivity} drfs={drfs} jos={jos} budgets={budgets} role={role} openPmModal={d=>setPmUpdateModal(d)} onCloseProject={(dealId,stage)=>{upDeals(ds=>ds.map(d=>d.id===dealId?{...d,stage}:d));if(isSupabaseReady())sbUpdate('deals',dealId,{stage}).catch(()=>{});logActivity(dealId,"Stage Change",`Pipeline stage → ${stage}`,session?.name);["sales","ops","management"].forEach(ch=>sendTelegramNotification(ch,`📌 <b>Project Stage Updated</b>\nClient: <b>${projDeal?.client||"?"}</b>${projDeal?.ceNo?`\nCE: ${projDeal.ceNo}`:""}\nNew Stage: ${stage}\nBy: ${session?.name||"Ops"}`));}}/>;
    if(page==="procurement") return(<Wrap><ProcurementView2 costCenterDeals={costCenterDeals} onCreateCostCenter={createCostCenter} onWaiveDp={waiveDp} prs={prs} addPR={addPR} updatePR={updatePR} deletePR={deletePR} upPrs={upPrs} wonDeals={wonDeals} deals={deals} budgets={budgets} exps={exps} swos={swos} session={session} role={role} toastEmit={toastEmit} suppliers={suppliers} addSupplier={addSupplier} upPayables={upPayables} payables={payables} sendTelegramNotification={sendTelegramNotification} isSupabaseReady={isSupabaseReady} sbUpsert={sbUpsert} payableToSb={payableToSb} syncPoPayable={syncPoPayable} approvePOs={approvePOs} chartOfAccounts={chartOfAccounts}/></Wrap>);
    if(page==="subconwo") return(<Wrap><SubconWOView deals={deals} onWaiveDp={waiveDp} swos={swos} addSWO={addSWO} addSWOBatch={addSWOBatch} updateSWO={updateSWO} deleteSWO={deleteSWO} wonDeals={wonDeals} subcons={subcons} session={session} role={role} toastEmit={toastEmit} sendTelegramNotification={sendTelegramNotification} chartOfAccounts={chartOfAccounts}/></Wrap>);
    if(page==="budget") return(<Wrap><BudgetView wonDeals={wonDeals} budgets={budgets} saveBudget={saveBudget} prs={prs} exps={exps} role={role}/></Wrap>);
    if(page==="budgetreq") return(<Wrap><BudgetRequestView sendTelegramNotification={sendTelegramNotification} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR} wonDeals={wonDeals} session={session} role={role} toastEmit={toastEmit}/></Wrap>);
    if(page==="requests") return(<Wrap><RequestsView sendTelegramNotification={sendTelegramNotification} mreqs={mreqs} addMR={addMR} updateMR={updateMR} prs={prs} addPR={addPR} wonDeals={wonDeals} session={session} role={role} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR} toastEmit={toastEmit} suppliers={suppliers}/></Wrap>);
    if(page==="calendar") return(<ConstructionCalendar wonDeals={wonDeals} completedDeals={completedDeals} deals={deals} pcards={pcards} jos={jos} prs={prs} billings={billings} drfs={drfs} ceReqs={ceReqs} setPage={setPage} setJumpDeal={setJumpDeal} today={today} Wrap={Wrap} checklists={checklist} session={session} addOpsEvent={data=>{const rec={...data,id:uid(),dept:"Operations",createdDate:today,createdBy:session?.name||role};upChecklist(cs=>[...cs,rec]);if(isSupabaseReady())sbInsert('checklists',toSbChecklist(rec)).catch(err=>{console.error("Calendar item sync:",err);toastEmit&&toastEmit("Calendar item saved locally only — tap 🔄 sync to push it to the server.","warning",8000);});const proj=wonDeals.find(d=>d.id===rec.projectId);const msg=`📅 <b>Calendar Item Added</b>\n<b>${rec.type||"Event"}</b>: ${rec.title||""}\nDate: ${rec.dueDate||"—"}${proj?`\nProject: ${proj.client}${proj.ceNo?" ("+proj.ceNo+")":""}`:""}\nBy: ${rec.createdBy||"—"}`;const _t=(rec.type||"").toLowerCase();if(["installation","backjob","turnover","site visit","repair"].some(t=>_t.includes(t))){sendTelegramNotification("ops",msg);sendTelegramNotification("sales",msg);}else if(_t.includes("drf")||_t.includes("design")){sendTelegramNotification("design",msg);}else if(_t.includes("billing")){sendTelegramNotification("finance",msg);}else{sendTelegramNotification("ops",msg);}}} updateOpsEvent={(id,ch)=>{upChecklist(cs=>cs.map(c=>c.id===id?{...c,...ch}:c));if(isSupabaseReady())sbUpdate('checklists',id,toSbChecklist({...checklist.find(c=>c.id===id),...ch})).catch(()=>{});}} deleteOpsEvent={delOpsEvent}/>);
  }

  // ─── DESIGN ───────────────────────────────────────────────────────────────
  if(role==="Design"){
    // ── MY FOLDER — each designer's own folder of assigned projects ─────────
    // After the design lead distributes projects per designer, every designer
    // gets a dedicated folder listing the projects + DRFs assigned to them.
    // The Head Designer sees every designer's folder; others see only their own.
    if(page==="myfolder") return(
      <Wrap>
        <MyFolderView session={session} projList={projList} projs={projs} drfs={drfs} updateDRF={updateDRF} deleteDRF={deleteDRF} upProj={upProj} setSelProj={setSelProj} setOpsTab={setOpsTab}/>
      </Wrap>
    );
    if(page==="home") return(
      <Wrap>
        <DeptHeader
          name={session?.name?.split(" ")[0]||"Team"}
          subtitle={`Design · ${todayL}`}
          buttons={[
            {label:"+ New DRF",    icon:"🎨", bg:"#ec4899", action:()=>setPage("drf")},
            {label:"My Requests",  icon:"📋", bg:"#1e293b", action:()=>setPage("drf")},
            ...(pageOn("swatchboard")?[{label:"Swatchboard",  icon:"🎨", bg:"#8b5cf6", action:()=>setPage("swatchboard")}]:[]),
          ]}
        />
        <SecHead title="Design Board — most-due first"/>
        {projList.length===0
          ? <EmptyState icon="🎨" msg="No active projects assigned yet."/>
          : <DesignBoard projList={projList} projs={projs} drfs={drfs} upProj={upProj} session={session} role={role} today={today} setSelProj={setSelProj} setOpsTab={setOpsTab} sendTelegramNotification={sendTelegramNotification} toastEmit={toastEmit}/>}
        {selProj&&proj&&(
          <DesignDetailModal selProj={selProj} proj={proj} deal={projDeal} linkedDrf={drfs.find(r=>r.dealId===selProj)} drfs={drfs} projList={projList} projs={projs} upProj={upProj} session={session} role={role} sendTelegramNotification={sendTelegramNotification} toastEmit={toastEmit} today={today} setSelProj={setSelProj} setOpsTab={setOpsTab}/>
        )}
      </Wrap>
    );
    if(page==="procurement") return <ProcurementView swatches={swatches} projList={projList} clientName={clientName} openAddSwatch={(pid,by)=>{setSwForm({projectId:pid,name:"",category:"Fabric",qty:"",unit:"pcs",supplier:"",estCost:"",swatchLink:"",addedBy:by||"Design",status:"To Buy",notes:""});setEditSw(null);setSwModal(true);}} openEditSwatch={sw=>{setSwForm({...sw});setEditSw(sw.id);setSwModal(true);}} delSwatch={id=>upSwatches(ss=>ss.filter(s=>s.id!==id))} swQ={swQ} Wrap={Wrap} addMR={addMR} wonDeals={wonDeals} session={session}/>;
    if(page==="swatchboard") return(<Wrap><ProcurementView swatches={swatches} projList={projList} clientName={clientName} openAddSwatch={openAddSwatch} openEditSwatch={openEditSwatch} delSwatch={id=>upSwatches(ss=>ss.filter(s=>s.id!==id))} swQ={swQ} Wrap={Wrap} addMR={addMR} wonDeals={wonDeals} session={session}/></Wrap>);
    if(page==="drf") return(<Wrap><DRFView drfs={drfs} addDRF={addDRF} updateDRF={updateDRF} deleteDRF={deleteDRF} wonDeals={wonDeals} session={session} role={role}/></Wrap>);
  }

  // ── GLOBAL DRF PAGE (Sales / Manager) ───────────────────────────────────
  if(page==="drf") return(<Wrap><DRFView drfs={drfs} addDRF={addDRF} updateDRF={updateDRF} deleteDRF={deleteDRF} wonDeals={wonDeals} session={session} role={role}/></Wrap>);

  // ── DESIGN BOARD (Manager side panel — same board Design sees) ───────────
  if(page==="designboard") return(
    <Wrap>
      <SecHead title="Design Board — most-due first"/>
      {projList.length===0
        ? <EmptyState icon="🎨" msg="No active design projects yet."/>
        : <DesignBoard projList={projList} projs={projs} drfs={drfs} upProj={upProj} session={session} role={role} today={today} setSelProj={setSelProj} setOpsTab={setOpsTab} sendTelegramNotification={sendTelegramNotification} toastEmit={toastEmit}/>}
      {selProj&&proj&&(
        <DesignDetailModal selProj={selProj} proj={proj} deal={projDeal} linkedDrf={drfs.find(r=>r.dealId===selProj)} drfs={drfs} projList={projList} projs={projs} upProj={upProj} session={session} role={role} sendTelegramNotification={sendTelegramNotification} toastEmit={toastEmit} today={today} setSelProj={setSelProj} setOpsTab={setOpsTab}/>
      )}
    </Wrap>
  );

  // ── DESIGN STATUS (Sales — read-only, own deals only) ────────────────────
  // Answers the three things Sales asks Design: promised date, briefed yet, and
  // which projects carry artwork / signage. No editing — Sales watches, not drives.
  if(page==="designstatus"){
    const mine=projList.filter(d=>d.salesOwner===session?.name||d.assignedAE===session?.name);
    return(
      <Wrap>
        <SecHead title="Design Status — my projects"/>
        {mine.length===0
          ? <EmptyState icon="🎨" msg="None of your projects are in design yet."/>
          : mine.map(d=>{
            const dz=projs[d.id]?.design||{};const drf=drfs.find(r=>r.dealId===d.id);
            const u=designUrgency(dz,drf,today);const promised=designPromisedDate(dz,drf);
            const openB=openBlockers(dz).length;const briefed=isProductionBriefed(dz);
            return(
              <Card key={d.id} accent={u.color}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                  <div>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:"1rem"}}>{d.client}</div>
                    <div style={{fontSize:".76rem",color:"#64748b",marginTop:2}}>{d.product}</div>
                  </div>
                  <Badge label={dz.status||"Briefing"} color={DS_CLR[dz.status]||"#94a3b8"}/>
                </div>
                <div style={{display:"flex",gap:14,flexWrap:"wrap",marginTop:10,fontSize:".76rem"}}>
                  <span><span style={{color:"#94a3b8"}}>Promised: </span><b style={{color:promised?u.color:"#cbd5e1"}}>{promised||"not committed"}</b></span>
                  <span><span style={{color:"#94a3b8"}}>Briefed to production: </span><b style={{color:briefed?"#15803d":"#b45309"}}>{briefed?"Yes":"Not yet"}</b></span>
                  {designNeedsArtwork(dz)&&<span style={{color:"#7c3aed",fontWeight:700}}>🎨 {(dz.deliverables||[]).filter(t=>ARTWORK_DELIVERABLES.includes(t)).join(" · ")}</span>}
                </div>
                {openB>0&&<div style={{marginTop:8,fontSize:".74rem",color:"#dc2626",fontWeight:600}}>🚧 {openB} open blocker{openB!==1?"s":""}: {openBlockers(dz).map(b=>b.text).join("; ")}</div>}
              </Card>
            );
          })}
      </Wrap>
    );
  }

  // ── PROJECT CARDS ────────────────────────────────────────────────────────────
  // ── TEAM ACTIVITY DASHBOARD ──────────────────────────────────────────────
  if(page==="activity") return(
    <Wrap>
      <ActivityDashboard actLog={actLog} users={users} session={session} isMobile={isMobile}/>
    </Wrap>
  );
  // ── MY ACCOUNT PAGE ─────────────────────────────────────────────────────
  if(page==="myaccount") return(
    <Wrap>
      <div style={{maxWidth:520,margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:28}}>
          <button onClick={()=>setPage("home")} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>← Back</button>
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.5rem",color:"#0f172a"}}>⚙️ My Account</div>
            <div style={{fontSize:".78rem",color:"#94a3b8",marginTop:1}}>Logged in as <strong>{session?.username}</strong> · {role}</div>
          </div>
        </div>
        {isSupabaseReady()&&(
          <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",marginBottom:20}}>
            <div style={{fontWeight:700,color:"#0f172a",fontSize:".9rem",marginBottom:2}}>🔄 Data Sync</div>
            <div style={{fontSize:".75rem",color:"#64748b",marginBottom:10}}>If this device is missing data that shows on another device, reconnect to the server and reload everything.</div>
            <button onClick={async()=>{
              // Expired role token → reload lands on login (boot clears the session).
              if(!restoreAppToken()){ appLogout(); }
              window.location.reload();
            }} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"10px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>🔄 Reload from Cloud</button>
          </div>
        )}
        <MyAccountPage session={session} users={users} setUsers={setUsers} upUsers={upUsers} setSession={setSession} logActivity={logActivity} checkPw={checkPw} hashPw={hashPw} actLog={actLog} verifyCurrentPassword={verifyCurrentPassword} onSetServerPw={setPasswordServer}/>
      </div>
    </Wrap>
  );
  // ── PM UPDATES PAGE ──────────────────────────────────────────────────────
  if(page==="pmupdates") return(
    <Wrap>
      <SecHead title="📝 PM Updates" sub="Log progress updates on your active projects"/>
      {(()=>{
        const myName=session?.name||"";
        const myProjects=wonDeals.filter(d=>{
          const jo=dealJo(jos,d.id);
          return jo&&[jo.pm1,jo.pm2,jo.pm3,jo.coordinator].filter(Boolean).some(p=>
            p===myName||p.toLowerCase().includes((myName||"").split(" ")[0]?.toLowerCase()||""));
        });
        return myProjects.length===0
          ? <div style={{textAlign:"center",padding:"40px",color:"#94a3b8"}}>No projects assigned to you yet. Contact Arrius or Paulo to get assigned.</div>
          : (
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {myProjects.map(d=>{
                const jo=dealJo(jos,d.id);
                const pc=pcards[d.id];
                const pct=pc?Math.round(Object.values(pc.departments||{}).filter(dept=>dept.done).length/6*100):0;
                const myUpdates=actLog.filter(a=>a.dealId===d.id&&a.action==="PM Update").slice(0,3);
                return(
                  <div key={d.id} style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                    <div style={{background:"#0ea5e9",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{fontWeight:700,color:"#fff",fontSize:".92rem"}}>{d.client}</div>
                        <div style={{fontSize:".72rem",color:"rgba(255,255,255,.7)",marginTop:1}}>{d.ceNo} · PM: {pc?.pm1||jo?.pm1||"—"} · {pct}% complete</div>
                      </div>
                      <button onClick={()=>setPmUpdateModal({dealId:d.id,dealName:d.client,ceNo:d.ceNo,ae:jo?.aeAssigned||d.salesOwner})}
                        style={{background:"rgba(255,255,255,.2)",border:"1px solid rgba(255,255,255,.3)",borderRadius:8,padding:"7px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>
                        + Log Update
                      </button>
                    </div>
                    <div style={{padding:"12px 16px"}}>
                      {myUpdates.length===0
                        ? <div style={{color:"#94a3b8",fontSize:".8rem",fontStyle:"italic"}}>No updates logged yet for this project.</div>
                        : myUpdates.map((u,i)=>(
                          <div key={i} style={{fontSize:".82rem",color:"#475569",padding:"6px 0",borderBottom:i<myUpdates.length-1?"1px solid #f8fafc":"",display:"flex",gap:10}}>
                            <span style={{color:"#94a3b8",whiteSpace:"nowrap",fontSize:".75rem"}}>{u.date} {u.time||""}</span>
                            <span>{u.detail}</span>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          );
      })()}

      {/* PM Update Modal */}
      {/* PM Update Modal */}
      {pmUpdateModal&&<PmUpdateModal {...pmModalExtra} pmUpdateModal={pmUpdateModal} setPmUpdateModal={setPmUpdateModal} session={session} logActivity={logActivity} addPmUpdate={addPmUpdate} updateProjectTurnover={(dealId,date)=>{upPcards(ps=>({...ps,[dealId]:{...ps[dealId],targetEndDate:date}}));if(isSupabaseReady())syncProjectCard(dealId,{target_end_date:date});}}/>}
    </Wrap>
  );

  // ── ADDENDA PAGE ───────────────────────────────────────────────────────────
  if(page==="addenda") return(
    <Wrap>
      <SecHead title="⚠️ Scope Changes" sub={["Sales","Finance"].includes(role)?"View all scope changes across active projects":"Flag addenda discovered on site — AE and Paolo will be notified"}/>
      <AddendaPageContent role={role} wonDeals={wonDeals} deals={deals} jos={jos} session={session} addenda={addenda} upAddenda={upAddenda} updateAddendum={updateAddendum} logActivity={logActivity} onOpenCoBoq={(id,readOnly=false)=>{setBoqDealId(null);setBoqStandaloneId(null);setBoqCoReadOnly(!!readOnly);setBoqCoId(id);setPage("boq");}}/>
    </Wrap>
  );

  if(page==="projects") return(
    <Wrap>
      <ProjectCards changeDealStage={changeDealStage} setProjectProgress={setProjectProgress} syncProjectCard={syncProjectCard}
        pcards={pcards} wonDeals={wonDeals} completedDeals={completedDeals} deals={deals}
        toggleDeptTask={toggleDeptTask} markDeptDone={markDeptDone}
        setProjectTAT={setProjectTAT} jos={jos}
        delDeal={delDeal} delPcard={delPcard} setConfirmDel={setConfirmDel}
        session={session} role={role} budgets={budgets}
        blockers={blockers} addBlocker={addBlocker} resolveBlocker={resolveBlocker}
        logActivity={logActivity} actLog={actLog}
        addenda={addenda} billings={billings} mreqs={mreqs} breqs={breqs}
        prs={prs} exps={exps}
        isMobile={isMobile} createCard={createProjectCard}
        swos={swos}
        updateJO={updateJO} upPcards={upPcards}
        addAddendum2={addAddendum2}
        addPmUpdate={addPmUpdate}
        initialDeal={jumpDeal} clearJump={()=>setJumpDeal(null)}
        initialFilter={jumpFilter} clearJumpFilter={()=>setJumpFilter(null)}
        checklist={checklist}
        loadChecklistTemplate={loadChecklistTemplate}
        openAddCl={openAddCl}
        openEditCl={openEditCl}
        delCl={delCl}
        clStatusQ={clStatusQ}
        clModal={clModal}
        setClModal={setClModal}
        clForm={clForm}
        setClForm={setClForm}
        editCl={editCl}
        saveCl={saveCl}
        upDeals={upDeals}
        ceReqs={ceReqs}
        toastEmit={toastEmit}
        customMembers={customMembers} setCustomMembers={setCustomMembers}
        setPage={setPage} setJumpDeal={setJumpDeal}
        sendTelegramNotification={sendTelegramNotification}/>
      {/* ── SMART IMPORT PREVIEW MODAL ──────────────────────────────── */}
      {smartImport&&(
        <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,.7)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:760,maxHeight:"90vh",overflow:"auto",boxShadow:"0 24px 64px rgba(0,0,0,.3)"}}>
            {/* Header */}
            <div style={{background:"#1e293b",borderRadius:"16px 16px 0 0",padding:"18px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontWeight:800,color:"#fff",fontSize:"1rem"}}>🤔 Smart Import — AI Analysis</div>
                <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:2}}>{smartImport.fileName}</div>
              </div>
              <button onClick={()=>setSmartImport(null)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:8,padding:"6px 12px",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem"}}>✕ Cancel</button>
            </div>
            <div style={{padding:24}}>
              {/* AI Summary */}
              <div style={{background:smartImport.analysis.canImport?"#f0fdf4":"#fef2f2",border:`1.5px solid ${smartImport.analysis.canImport?"#6ee7b7":"#fecaca"}`,borderRadius:10,padding:"14px 18px",marginBottom:20}}>
                <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                  <span style={{fontSize:"1.4rem"}}>{smartImport.analysis.canImport?"✅":"⚠️"}</span>
                  <div>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".9rem",marginBottom:4}}>
                      {smartImport.analysis.dataType?.toUpperCase()||"UNKNOWN"} DATA
                      <span style={{marginLeft:8,fontSize:".72rem",background:smartImport.analysis.confidence>70?"#059669":"#f59e0b",color:"#fff",borderRadius:20,padding:"2px 8px",fontWeight:600}}>
                        {smartImport.analysis.confidence}% confidence
                      </span>
                    </div>
                    <div style={{fontSize:".85rem",color:"#475569",lineHeight:1.6}}>{smartImport.analysis.summary}</div>
                    {!smartImport.analysis.canImport&&(
                      <div style={{marginTop:8,fontSize:".82rem",color:"#dc2626",fontWeight:600}}>⛔ {smartImport.analysis.cantImportReason}</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Stats row */}
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:10,marginBottom:20}}>
                {[
                  {l:"Total Rows",     v:smartImport.analysis.rowCount||smartImport.rows.length, c:"#3b82f6"},
                  {l:"Columns Found",  v:smartImport.analysis.fieldsFound?.length||0,            c:"#8b5cf6"},
                  {l:"Import Action",  v:smartImport.analysis.importAction||"Manual review",     c:"#0f172a"},
                ].map(({l,v,c})=>(
                  <div key={l} style={{background:"#f8fafc",borderRadius:10,padding:"12px 14px"}}>
                    <div style={{fontWeight:800,fontSize:".9rem",color:c}}>{v}</div>
                    <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:3}}>{l}</div>
                  </div>
                ))}
              </div>

              {/* Fields detected */}
              {smartImport.analysis.fieldsFound?.length>0&&(
                <div style={{marginBottom:16}}>
                  <div style={{fontWeight:700,fontSize:".82rem",color:"#0f172a",marginBottom:8}}>Fields Detected</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                    {smartImport.analysis.fieldsFound.map(f=>(
                      <span key={f} style={{background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe",borderRadius:20,padding:"3px 10px",fontSize:".75rem",fontWeight:600}}>{f}</span>
                    ))}
                  </div>
                </div>
              )}

              {/* Issues/warnings */}
              {smartImport.analysis.issues?.length>0&&(
                <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"12px 14px",marginBottom:16}}>
                  <div style={{fontWeight:700,fontSize:".8rem",color:"#92400e",marginBottom:6}}>⚠️ Data Quality Notes</div>
                  {smartImport.analysis.issues.map((iss,i)=>(
                    <div key={i} style={{fontSize:".8rem",color:"#78350f",marginBottom:3}}>• {iss}</div>
                  ))}
                </div>
              )}

              {/* Data preview table */}
              <div style={{marginBottom:20}}>
                <div style={{fontWeight:700,fontSize:".82rem",color:"#0f172a",marginBottom:8}}>Data Preview (first 5 rows)</div>
                <div style={{overflowX:"auto",border:"1px solid #e2e8f0",borderRadius:8}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:".78rem"}}>
                    <thead>
                      <tr style={{background:"#1e293b"}}>
                        {["#","Client","CE No","Stage","CE Type","Value"].map(k=>(
                          <th key={k} style={{padding:"8px 10px",textAlign:"left",color:"#fff",fontWeight:700,whiteSpace:"nowrap"}}>{k}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(()=>{
                        const normType=(t)=>{const u=String(t||"").toUpperCase().trim();if(u.includes("INTERIOR"))return"Interior Design";if(u.includes("SIGNAGE"))return"Signage";if(u.includes("FIT"))return"Fit-Out";if(u.includes("RENOVATI"))return"Renovation";return"Fabrication / General";};
                        const parseVal=(v)=>Number(String(v||"").replace(/[₱,\s]/g,""))||0;
                        return smartImport.rows.slice(0,5).map((r,i)=>{
                          const client=String(r["Client Name"]||r.client||r.Client||"").trim();
                          const ceNo=String(r["CE No"]||r["CE No."]||"").trim();
                          const rawStage=r.Stage||r.stage||r._defaultStage||"";
                          const ceType=normType(r["CE Type"]||r.ceType||"");
                          const value=parseVal(r["Contract Value (VAT EX)"]||r["Contract Value"]||r.value||0);
                          return(
                            <tr key={i} style={{background:i%2?"#f8fafc":"#fff"}}>
                              <td style={{padding:"7px 10px",color:"#94a3b8",fontSize:".72rem"}}>{i+1}</td>
                              <td style={{padding:"7px 10px",color:"#0f172a",fontWeight:600}}>{client||"—"}</td>
                              <td style={{padding:"7px 10px",color:"#475569"}}>{ceNo||"—"}</td>
                              <td style={{padding:"7px 10px",color:"#475569",maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{normalizeStage(rawStage||"01 · BizDev")}</td>
                              <td style={{padding:"7px 10px",color:"#8b5cf6"}}>{ceType}</td>
                              <td style={{padding:"7px 10px",color:"#059669",fontWeight:600}}>{value>0?"₱"+value.toLocaleString("en-PH"):"—"}</td>
                            </tr>
                          );
                        });
                      })()}
                    </tbody>
                  </table>
                </div>
                <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:5}}>Showing 5 of {smartImport.rows.length} rows · Step 1 of 2: Analysis</div>
              </div>

              {/* Action buttons */}
              <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                <button onClick={()=>setSmartImport(null)}
                  style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"10px 20px",fontFamily:"inherit",fontSize:".85rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>
                  Cancel
                </button>
                {smartImport.analysis.canImport&&smartImport.analysis.dataType==="deals"&&(
                  <button onClick={()=>{
                    const normType=(t)=>{const u=String(t||"").toUpperCase().trim();if(u.includes("INTERIOR"))return"Interior Design";if(u.includes("SIGNAGE"))return"Signage";if(u.includes("FIT"))return"Fit-Out";if(u.includes("RENOVATI"))return"Renovation";return"Fabrication / General";};
                    const parseVal=(v)=>Number(String(v||"").replace(/[₱,\s]/g,""))||0;
                    const mapped=smartImport.rows.map((r,idx)=>{
                      const client=String(r["Client Name"]||r.client||r.Client||r["client_name"]||r.company||"").trim();
                      const ceNo=String(r["CE No"]||r.ceNo||r["CE Number"]||r.ce_no||r["CE No."]||"").trim();
                      const product=String(r["Project / Product"]||r.product||r.Product||r["Project Name"]||r.project||"").trim();
                      const rawStage=r.Stage||r.stage||r.status||r._defaultStage||"";
                      // Match an existing deal by CE number; when the row has NO CE
                      // number, fall back to an exact client + product match against
                      // a non-lost deal — otherwise every re-import of a CE-less row
                      // spawns a fresh duplicate (root cause of the empty Kareila /
                      // Archives / Diageo stub duplicates).
                      const exists=deals.find(d=>{
                        if(ceNo&&d.ceNo&&(d.ceNo===ceNo||d.ceNo==="#"+ceNo.replace(/^#/,""))) return true;
                        if(!ceNo&&!isLostStage(d.stage)&&client&&d.client&&d.client.toLowerCase()===client.toLowerCase()){
                          const dprod=String(d.product||d.contact||"").trim().toLowerCase();
                          if(product&&dprod&&dprod===product.toLowerCase()) return true;
                        }
                        return false;
                      });
                      return{
                        _idx:idx,_exists:!!exists,_existingId:exists?.id,
                        id:exists?.id||uid(),client,
                        product,
                        contact:String(r["Contact Person"]||r.contact||r.Contact||"").trim(),
                        ceNo:ceNo||("CE-IMPORT-"+Date.now()+"-"+idx),
                        ceType:normType(r["CE Type"]||r.ceType||r.type||""),
                        stage:normalizeStage(rawStage||"01 · BizDev"),
                        value:parseVal(r["Contract Value (VAT EX)"]||r["Contract Value"]||r.value||r.Value||r.amount||0),
                        invoiced:parseVal(r.invoiced||r.Invoiced||0),
                        // Only a Manager may set amount paid (it drives commission on deals
                        // without milestones); the DB zeroes it for anyone else
                        // (migration 20261026040000). Keep them in sync.
                        amountPaid:canonRole(role)==="Manager"?parseVal(r.amountPaid||r["Amount Paid"]||r.paid||0):0,
                        paymentStatus:String(r["Payment Status"]||r.paymentStatus||"Unpaid").trim()||"Unpaid",
                        receiptType:String(r.receiptType||r["Receipt Type"]||"OR").trim(),
                        salesOwner:String(r["Sales Owner"]||r.salesOwner||r.ae||r.AE||r.Owner||"").trim(),
                        assignedAE:String(r["Assigned AE"]||r["AE Assigned (JO)"]||r.assignedAE||"").trim(),
                        dateAcquired:String(r["Date Acquired"]||r.dateAcquired||r.date||today).trim()||today,
                        dueDate:String(r["Due Date"]||r.dueDate||"").trim()||"",
                        notes:String(r.Notes||r.notes||"").trim(),
                        commsGroup:String(r["Comms Group"]||r.commsGroup||"").trim(),
                        bizDevSource:String(r["BizDev Source"]||r.bizDevSource||r["Biz Dev Source"]||r.source||"").trim(),
                        priority:"Normal",
                        probability:WON_STAGES.includes(normalizeStage(rawStage||"01 · BizDev"))?100:50,
                      };
                    }).filter(r=>r.client);
                    setImportReview(mapped);
                  }}
                  style={{background:"#3b82f6",border:"none",borderRadius:8,padding:"10px 22px",fontFamily:"inherit",fontSize:".85rem",color:"#fff",cursor:"pointer",fontWeight:700}}>
                    👁 Review {smartImport.rows.length} Deals →
                  </button>
                )}
                {smartImport.analysis.canImport&&smartImport.analysis.dataType!=="deals"&&(
                  <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:8,padding:"10px 16px",fontSize:".82rem",color:"#1d4ed8"}}>
                    ℹ️ {smartImport.analysis.dataType} data detected — use the matching module to import this data type.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── SMART IMPORT REVIEW MODAL (Step 2) ───────────────────────────── */}
      {importReview&&(
        <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,.75)",zIndex:1100,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:900,maxHeight:"92vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,.35)"}}>
            {/* Header */}
            <div style={{background:"#1e293b",padding:"16px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
              <div>
                <div style={{fontWeight:800,color:"#fff",fontSize:"1rem"}}>✅ Step 2 of 2 — Review & Confirm Import</div>
                <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:2}}>{importReview.length} deals · edit Stage or CE Type before confirming</div>
              </div>
              <button onClick={()=>setImportReview(null)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:8,padding:"6px 12px",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem"}}>✕ Back</button>
            </div>
            {/* Review table */}
            <div style={{overflowY:"auto",flex:1}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:".8rem"}}>
                <thead style={{position:"sticky",top:0,zIndex:1}}>
                  <tr style={{background:"#f8fafc"}}>
                    {["#","Status","Client","CE No","Project","Stage","CE Type","Value"].map(h=>(
                      <th key={h} style={{padding:"10px 10px",textAlign:"left",fontWeight:700,color:"#475569",fontSize:".72rem",borderBottom:"2px solid #e2e8f0",whiteSpace:"nowrap"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {importReview.map((row,i)=>(
                    <tr key={i} style={{borderBottom:"1px solid #f1f5f9",background:row._exists?"#fffbeb":"#fff"}}>
                      <td style={{padding:"8px 10px",color:"#94a3b8",fontSize:".72rem"}}>{i+1}</td>
                      <td style={{padding:"8px 10px"}}>
                        <span style={{fontSize:".68rem",fontWeight:700,padding:"2px 7px",borderRadius:20,background:row._exists?"#fef3c7":"#dcfce7",color:row._exists?"#92400e":"#15803d"}}>
                          {row._exists?"UPDATE":"NEW"}
                        </span>
                      </td>
                      <td style={{padding:"8px 10px",fontWeight:600,color:"#0f172a",maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.client}</td>
                      <td style={{padding:"8px 10px",color:"#64748b",fontSize:".75rem"}}>{row.ceNo}</td>
                      <td style={{padding:"8px 10px",color:"#64748b",maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontSize:".75rem"}}>{row.product||"—"}</td>
                      <td style={{padding:"4px 6px"}}>
                        <select value={row.stage} onChange={e=>setImportReview(rv=>rv.map((r,j)=>j===i?{...r,stage:e.target.value}:r))}
                          style={{fontSize:".72rem",padding:"4px 6px",borderRadius:6,border:"1px solid #e2e8f0",background:"#fff",color:"#0f172a",width:"100%",fontFamily:"inherit"}}>
                          {[...DEAL_STAGES,...WON_STAGES].map(s=><option key={s} value={s}>{s}</option>)}
                        </select>
                      </td>
                      <td style={{padding:"4px 6px"}}>
                        <select value={row.ceType} onChange={e=>setImportReview(rv=>rv.map((r,j)=>j===i?{...r,ceType:e.target.value}:r))}
                          style={{fontSize:".72rem",padding:"4px 6px",borderRadius:6,border:"1px solid #e2e8f0",background:"#fff",color:"#0f172a",width:"100%",fontFamily:"inherit"}}>
                          {CE_TYPES.map(t=><option key={t} value={t}>{t}</option>)}
                        </select>
                      </td>
                      <td style={{padding:"8px 10px",color:"#059669",fontWeight:600,whiteSpace:"nowrap"}}>{row.value>0?"₱"+row.value.toLocaleString("en-PH"):"—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Footer */}
            <div style={{padding:"14px 20px",borderTop:"1px solid #e2e8f0",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0,background:"#f8fafc"}}>
              <div style={{fontSize:".78rem",color:"#64748b"}}>
                <strong style={{color:"#0f172a"}}>{importReview.filter(r=>!r._exists).length}</strong> new · <strong style={{color:"#f59e0b"}}>{importReview.filter(r=>r._exists).length}</strong> updates · {importReview.length} total
              </div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setImportReview(null)} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"9px 18px",fontFamily:"inherit",fontSize:".84rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>← Back</button>
                <button onClick={()=>{
                  let imported=0,skipped=0;
                  importReview.forEach(rec=>{
                    if(rec._exists){
                      upDeals(ds=>ds.map(d=>d.id===rec._existingId?rec:d));
                      if(isSupabaseReady()) sbSyncOne("deals",rec,toSbDeal);
                      if(WON_STAGES.includes(rec.stage)&&!rec.parentDealId){
                        upProjs(ps=>({...ps,[rec.id]:ps[rec.id]||emptyProject()}));
                        upPcards(ps=>({...ps,[rec.id]:ps[rec.id]||emptyProjectCard(rec.id,rec)}));
                      }
                      skipped++;
                    } else {
                      upDeals(ds=>[...ds,rec]);
                      if(isSupabaseReady()) sbSyncOne("deals",rec,toSbDeal);
                      if(WON_STAGES.includes(rec.stage)&&!rec.parentDealId){
                        upProjs(ps=>({...ps,[rec.id]:emptyProject()}));
                        upPcards(ps=>({...ps,[rec.id]:emptyProjectCard(rec.id,rec)}));
                        const newJo={
                          id:"jo"+rec.id,dealId:rec.id,
                          joNo:`JO-${new Date().getFullYear()}-${String(jos.length+imported+1).padStart(3,"0")}`,
                          client:rec.client,ceNo:rec.ceNo,projectName:rec.product||rec.client,
                          value:rec.value,awardTrigger:"Imported",triggerDate:rec.dateAcquired||today,
                          pm1:"",pm2:"",pm3:"",coordinator:"",aeAssigned:rec.salesOwner||"",
                          startDate:rec.dateAcquired||today,commsLink:"",
                          scopeNotes:rec.notes||"",specialInstructions:"",
                          budgetStatus:"QS Budget Pending",status:"Active",issuedDate:today,
                        };
                        upJos(js=>js.find(j=>j.dealId===rec.id)?js:[...js,newJo]);
                        if(isSupabaseReady()) sbSyncOne("job_orders",newJo,toSbJO);
                      }
                      imported++;
                    }
                  });
                  logActivity(null,"Excel Import",`${imported} new + ${skipped} updated via Smart Import`);
                  setImportReview(null);setSmartImport(null);
                  toastEmit(`Import complete! ${imported} new deals · ${skipped} updated.`,"success");
                }} style={{background:"#059669",border:"none",borderRadius:8,padding:"9px 22px",fontFamily:"inherit",fontSize:".84rem",color:"#fff",cursor:"pointer",fontWeight:700}}>
                  ✅ Confirm Import ({importReview.length})
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Wrap>
  );

  // ── INVENTORY ────────────────────────────────────────────────────────────────
  if(page==="inventory"||(role==="Warehouse"&&page==="home")) return(
    <Wrap>
      <InventoryView
        inventory={inventory} stocklog={stocklog} wonDeals={wonDeals} prs={prs} updatePR={updatePR} addPR={addPR}
        addInventoryItem={addInventoryItem} updateInventoryItem={updateInventoryItem}
        deleteInventoryItem={deleteInventoryItem} clearAllInventory={clearAllInventory} logStockMove={logStockMove} mergeInventoryItems={mergeInventoryItems}
        suppliers={suppliers} addSupplier={addSupplier} printDR={printDR} tools={tools} upTools={upTools} saveTool={saveTool} deleteTool={deleteTool} drs={drs} saveDr={saveDr} deleteDr={deleteDr}
        projs={projs} upProjs={upProjs} deals={wonDeals}
        session={session} role={role}/>
    </Wrap>
  );

  if(page==="stockmove") return(
    <Wrap>
      <StockMovementView
        inventory={inventory} stocklog={stocklog} wonDeals={wonDeals}
        logStockMove={logStockMove} session={session} role={role}/>
    </Wrap>
  );

  if(page==="suppliers") return(<Wrap><SupplierMasterView suppliers={suppliers} addSupplier={addSupplier} updateSupplier={updateSupplier} deleteSupplier={deleteSupplier} session={session} role={role}/></Wrap>);
  if(page==="subcontractors") return(<Wrap><SubconMasterView subcons={subcons} addSubcon={addSubcon} updateSubcon={updateSubcon} deleteSubcon={deleteSubcon} session={session} role={role}/></Wrap>);
  if(page==="ceqs") return(<Wrap><CEQSView ceReqs={ceReqs} addCEReq={addCEReq} updateCEReq={updateCEReq} session={session} role={role} toastEmit={toastEmit} deals={deals}/></Wrap>);
  if(page==="boq"){
    // Put a BOQ onto a deal (Duplicate or Link from the BOQ builder's dialog).
    // The server write is awaited FIRST: if it fails nothing else happens, so a
    // standalone BOQ is never deleted and the user never lands on a deal whose
    // BOQ didn't save. setValue (an explicit tick in the dialog) also pegs the
    // deal value to the BOQ net in the same write. Linking is final: a deal that
    // already has a BOQ is refused (re-checked on the server right before the
    // write), and a mother PO never takes a BOQ — it earns ₱0 itself.
    const attachBoqToDeal=async(dealId,boqData,{setValue}={})=>{
      const tgt=deals.find(d=>d.id===dealId);
      if(!tgt||isMotherPO(tgt)){toastEmit&&toastEmit("⛔ A mother PO can't carry a BOQ or a price — put the BOQ on its sub-project instead.","error",8000);return false;}
      const hasContent=b=>!!(b&&((b.items?.length)||(b.sections?.length)));
      let existing=tgt.boqData;
      if(isSupabaseReady()&&supabase){
        const {data,error}=await supabase.from('deals').select('boq_data').eq('id',dealId).maybeSingle();
        if(error){toastEmit&&toastEmit("❌ Couldn't check that deal on the server — nothing was changed. Try again.","error",8000);return false;}
        existing=data?.boq_data||null;
      }
      if(hasContent(existing)){toastEmit&&toastEmit("⛔ That deal already has a BOQ. A linked BOQ is final — edit it on the deal instead.","error",8000);return false;}
      const bi=Array.isArray(boqData.items)?boqData.items:[];
      const grand=bi.reduce((s,it)=>s+(Number(it.total)||0),0);
      const net=Math.round((grand-Math.min(Math.max(Number(boqData.discount)||0,0),grand))*100)/100;
      const pegValue=!!setValue&&bi.length>0;
      if(isSupabaseReady()){
        const ok=await sbUpdate('deals',dealId,pegValue?{boq_data:boqData,value:net}:{boq_data:boqData});
        if(!ok){toastEmit&&toastEmit("❌ Couldn't confirm the BOQ saved to that deal. FabHub will retry when the connection is back — this BOQ was left as it is. Check the deal before trying again.","error",10000);return false;}
      }
      try{const drafts=JSON.parse(localStorage.getItem(KEYS.boqDrafts)||"{}");drafts[dealId]=boqData;localStorage.setItem(KEYS.boqDrafts,JSON.stringify(drafts));}catch{}
      upDeals(ds=>ds.map(d=>d.id===dealId?{...d,boqData,...(pegValue?{value:net}:{})}:d));
      // The linked BOQ's decided VAT choice sets the deal's receipt type (BOQ is
      // the VAT authority — see onBoqVat below).
      if(typeof boqData.vatEnabled==="boolean"){const rt=boqData.vatEnabled?"OR":"AR";const cur=deals.find(d=>d.id===dealId);if(cur&&cur.receiptType!==rt){if(["OR","AR"].includes(cur.receiptType))toastEmit&&toastEmit(`Project receipt type changed ${cur.receiptType} → ${rt} to match the BOQ (${boqData.vatEnabled?"VAT 12%":"No VAT"})${billings.some(b=>b.dealId===dealId)?" — existing invoices keep their tax; adjust one in the billing modal if needed":""}`,"info",8000);upDeals(ds=>ds.map(d=>d.id===dealId?{...d,receiptType:rt,withholding:rt==="AR"?false:d.withholding}:d));if(isSupabaseReady())sbUpdate('deals',dealId,{receipt_type:rt,...(rt==="AR"?{withholding:false}:{})}).catch(()=>{});}}
      return true;
    };
    const duplicateBoqToDeal=async(dealId,boqData,opts)=>{
      if(!(await attachBoqToDeal(dealId,boqData,opts)))return false;
      const d=deals.find(x=>x.id===dealId);
      setBoqCoId(null);setBoqStandaloneId(null);setBoqDealId(dealId);
      toastEmit&&toastEmit(`✅ BOQ copied to ${d?.client||"the deal"}${d?.ceNo?" ("+d.ceNo+")":""} — now editing the copy`,"success");
      return true;
    };
    if(boqCoId){
      const co=addenda.find(a=>a.id===boqCoId);
      if(!co){setBoqCoId(null);return null;}
      // A change order builds its own BOQ. On save we derive the flat scope line
      // items + a value from the built BOQ, so the existing approval → contract →
      // BOQ merge → billing pipeline (syncCoBoq / syncCoBilling) keeps working.
      const saveCoBoq=(coId,bd)=>{
        const items=Array.isArray(bd.items)?bd.items:[];
        const scopeItems=items.filter(it=>(it.description||"").trim()).map(it=>({
          description:(it.description||"").trim(),
          qty:Number(it.qty)||0,
          unit:it.unit||"lot",
          rate:Number(it.unitCost!=null?it.unitCost:it.baseCost)||0,
          section:it.section||"CO",
          subsection:it.subsection||"",
        }));
        const magnitude=Math.round(scopeItems.reduce((s,it)=>s+it.qty*it.rate,0)*100)/100;
        updateAddendum(coId,{coBoqData:bd,scopeItems,value:magnitude});
      };
      return(<Wrap><BOQBuilder key={"co:"+boqCoId} wonDeals={wonDeals} deals={deals} jos={jos} session={session} role={role} toastEmit={toastEmit} boqLibrary={boqLibrary} setBoqLibrary={setBoqLibrary} initialCoId={boqCoId} coRecord={co} saveCoBoq={boqCoReadOnly?undefined:saveCoBoq} readOnly={boqCoReadOnly} onBack={()=>{setBoqCoReadOnly(false);setBoqCoId(null);}}/></Wrap>);
    }
    if(boqDealId) return(<Wrap><BOQBuilder key={"deal:"+boqDealId} onDuplicateToDeal={duplicateBoqToDeal} wonDeals={wonDeals} deals={deals} jos={jos} session={session} role={role} toastEmit={toastEmit} boqLibrary={boqLibrary} setBoqLibrary={setBoqLibrary} initialDealId={boqDealId} clearBoqDeal={()=>setBoqDealId(null)} onBack={()=>setBoqDealId(null)} onBoqValue={(dealId,netTotal)=>{const v=Math.round((Number(netTotal)||0)*100)/100;const cur=deals.find(d=>d.id===dealId);if(isMotherPO(cur))return;if(cur&&Math.round((Number(cur.value)||0)*100)/100===v)return;upDeals(ds=>ds.map(d=>d.id===dealId?{...d,value:v}:d));if(isSupabaseReady())sbUpdate('deals',dealId,{value:v}).catch(()=>{});}} onBoqData={(dealId,bd)=>upDeals(ds=>ds.map(d=>d.id===dealId?{...d,boqData:bd}:d))} onBoqVat={(dealId,vatEnabled)=>{
      // The BOQ is the authority on VAT: its decided VAT choice sets the deal's
      // receipt type (VAT 12% → OR, No VAT → AR), overriding whatever the sales
      // form had — the form defaults to OR, so an "explicit" OR there is usually
      // just the default and must not silently win over the costing decision.
      // vatEnabled must be a decided boolean (not the unset null).
      if(typeof vatEnabled!=="boolean")return;
      const rt=vatEnabled?"OR":"AR";
      const cur=deals.find(d=>d.id===dealId);
      if(!cur||cur.receiptType===rt)return;
      // Billed projects flip too (owner decision 2026-10-01: the BOQ is final;
      // a single invoice is adjusted in the billing modal). Existing invoices keep
      // the tax they were billed with: the DB trigger trg_deal_receipt_type_freeze
      // (migration 20261001010000) stamps the old receipt type onto milestones
      // that had none of their own before the deal changes.
      if(["OR","AR"].includes(cur.receiptType))toastEmit&&toastEmit(`Project receipt type changed ${cur.receiptType} → ${rt} to match the BOQ (${vatEnabled?"VAT 12%":"No VAT"})${billings.some(b=>b.dealId===dealId)?" — existing invoices keep their tax; adjust one in the billing modal if needed":""}`,"info");
      upDeals(ds=>ds.map(d=>d.id===dealId?{...d,receiptType:rt,withholding:rt==="AR"?false:d.withholding}:d));
      if(isSupabaseReady())sbUpdate('deals',dealId,{receipt_type:rt,...(rt==="AR"?{withholding:false}:{})}).catch(()=>{});
    }}/></Wrap>);
    if(boqStandaloneId) return(<Wrap><BOQBuilder key={"sa:"+boqStandaloneId} onDuplicateToDeal={duplicateBoqToDeal} wonDeals={wonDeals} deals={deals} jos={jos} session={session} role={role} toastEmit={toastEmit} boqLibrary={boqLibrary} setBoqLibrary={setBoqLibrary} standaloneBoqs={standaloneBoqs} saveStandaloneBoq={saveStandaloneBoq} initialStandaloneId={boqStandaloneId} clearBoqStandalone={()=>setBoqStandaloneId(null)} onBack={()=>setBoqStandaloneId(null)} onLinkToDeal={async(dealId,boqData,opts)=>{const sid=boqStandaloneId;if(!(await attachBoqToDeal(dealId,boqData,opts)))return false;deleteStandaloneBoq(sid);setBoqStandaloneId(null);setBoqDealId(dealId);toastEmit&&toastEmit(opts?.setValue?"✅ BOQ linked to project — deal value set from BOQ":"✅ BOQ linked to project","success");return true;}}/></Wrap>);
    return(<Wrap>{boqInPipeline&&<PipeTabBar/>}<BOQHomeView standaloneBoqs={standaloneBoqs} deals={deals} session={session} role={role} today={today} onOpenStandalone={id=>{setBoqCoId(null);setBoqDealId(null);setBoqStandaloneId(id);}} onOpenDeal={id=>{setBoqCoId(null);setBoqStandaloneId(null);setBoqDealId(id);}} onNewStandalone={()=>{const id=uid();saveStandaloneBoq({id,title:"",location:"",quotationNo:"",boqDate:today,items:[],sections:[],vatEnabled:true,discount:"",createdBy:session?.name||"",createdAt:new Date().toISOString(),updatedAt:new Date().toISOString()});setBoqCoId(null);setBoqDealId(null);setBoqStandaloneId(id);}} onDeleteStandalone={deleteStandaloneBoq}/></Wrap>);
  }

  if(page==="tvboard"&&role==="Manager") return(<Wrap><TVBoardAdmin announcements={announcements} upAnnouncements={upAnnouncements} session={session} today={today}/></Wrap>);
  if(page==="coa") return(<Wrap><ChartOfAccountsView chartOfAccounts={chartOfAccounts} saveChartOfAccounts={saveChartOfAccounts} session={session} role={role}/></Wrap>);
  if(page==="acctreport") return(<Wrap><AccountReportView chartOfAccounts={chartOfAccounts} exps={exps} role={role}/></Wrap>);

  // ── COST ANALYSIS (Budget + Costing Study combined) ─────────────────────────
  if(page==="costanalysis") return(
    <Wrap>
      <div style={{display:"flex",gap:10,marginBottom:20,borderBottom:"2px solid #e2e8f0",paddingBottom:12,flexWrap:"wrap"}}>
        {[["budget","💰 Budget"],["costing","📊 Costing Study"],["profitability","🏗 Profitability"]].map(([tab,label])=>(
          <button key={tab} onClick={()=>setCostTab(tab)}
            style={{padding:"8px 20px",borderRadius:20,border:`2px solid ${costTab===tab?"#1e293b":"#e2e8f0"}`,background:costTab===tab?"#1e293b":"#fff",color:costTab===tab?"#fff":"#64748b",fontFamily:"inherit",fontWeight:costTab===tab?700:400,fontSize:".84rem",cursor:"pointer"}}>
            {label}
          </button>
        ))}
      </div>
      {costTab==="budget"&&<BudgetView wonDeals={wonDeals} budgets={budgets} saveBudget={saveBudget} prs={prs} exps={exps} role={role}/>}
      {costTab==="costing"&&<CostingStudy wonDeals={wonDeals} budgets={budgets} prs={prs} exps={exps} projs={projs} role={role}/>}
      {costTab==="profitability"&&(()=>{
        // Project Profitability — Revenue (billings) − Cost (Accounts Payable) per
        // project, Aerwin's formula. Cost is AP by project (where costs now live)
        // plus any legacy expense not already routed into a payable, so nothing is
        // double-counted or lost.
        const fmtM=v=>"₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0});
        const rows=wonDeals.map(d=>{
          const ms=billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled");
          const billed=ms.reduce((s,b)=>s+Number(b.amount||0),0);
          const collected=ms.reduce((s,b)=>s+(b.payments||[]).reduce((ss,p)=>ss+Number(p.amount||0),0),0);
          const apCost=payables.filter(p=>p.projectId===d.id).reduce((s,p)=>s+Number(p.amount||0),0);
          const expCost=exps.filter(e=>(e.projectId||e.dealId)===d.id&&!e.payableId&&!e.cvId).reduce((s,e)=>s+Number(e.amount||0),0);
          const cost=apCost+expCost;
          const grossProfit=billed-cost;
          const margin=billed>0?Math.round(grossProfit/billed*100):null;
          const contractVal=Number(d.value||0);
          return{d,contractVal,billed,collected,cost,grossProfit,margin};
        }).sort((a,b)=>b.contractVal-a.contractVal);
        const totContract=rows.reduce((s,r)=>s+r.contractVal,0);
        const totBilled=rows.reduce((s,r)=>s+r.billed,0);
        const totCollected=rows.reduce((s,r)=>s+r.collected,0);
        const totCost=rows.reduce((s,r)=>s+r.cost,0);
        const totGP=totBilled-totCost;
        const totMargin=totBilled>0?Math.round(totGP/totBilled*100):0;
        return(
          <div>
            <div style={{fontSize:".8rem",color:"#64748b",marginBottom:14}}>Revenue is billed value; cost is Accounts Payable (POs, Work Orders &amp; Other Payables) tagged to each project.</div>
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:20}}>
              {[{l:"Contract Value",v:fmtM(totContract),c:"#3b82f6"},{l:"Total Billed",v:fmtM(totBilled),c:"#8b5cf6"},{l:"Collected",v:fmtM(totCollected),c:"#10b981"},{l:"AP Cost",v:fmtM(totCost),c:"#ef4444"},{l:"Gross Profit",v:fmtM(totGP),sub:totMargin+"%",c:totGP>=0?"#059669":"#ef4444"}].map(({l,v,sub,c})=>(
                <div key={l} style={{background:"#fff",borderRadius:10,border:`1.5px solid ${c}33`,padding:"12px 14px",borderTop:`3px solid ${c}`}}>
                  <div style={{fontSize:".6rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".6px"}}>{l}</div>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:c,marginTop:2}}>{v}</div>
                  {sub&&<div style={{fontSize:".7rem",color:c,fontWeight:700}}>{sub} margin</div>}
                </div>
              ))}
            </div>
            <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <div style={{overflowX:"auto"}}>
                <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 80px",background:"#1e293b",padding:"10px 16px",gap:8,minWidth:580}}>
                  {["Project","Contract","Billed","Collected","AP Cost","Margin"].map(h=>(
                    <div key={h} style={{fontSize:".65rem",fontWeight:700,color:"rgba(255,255,255,.6)",textTransform:"uppercase",letterSpacing:".6px"}}>{h}</div>
                  ))}
                </div>
                {rows.length===0&&<div style={{padding:"24px",textAlign:"center",color:"#94a3b8"}}>No projects yet.</div>}
                {rows.map(({d,contractVal,billed,collected,cost,margin},i)=>(
                  <div key={d.id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 80px",padding:"11px 16px",gap:8,borderBottom:"1px solid #f1f5f9",background:i%2?"#fafafa":"#fff",alignItems:"center",minWidth:580}}>
                    <div>
                      <div style={{fontWeight:700,color:"#0f172a",fontSize:".84rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                      {d.contact&&<div style={{fontSize:".67rem",color:"#8b5cf6",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>📁 {d.client}</div>}
                      <div style={{fontSize:".65rem",color:"#94a3b8"}}>{d.ceNo||"—"} · {d.stage==="14 · Completed"?<span style={{color:"#059669",fontWeight:700}}>✅ Completed</span>:<span style={{color:"#3b82f6"}}>{d.stage?.replace(/^\d+ · /,"")}</span>}</div>
                    </div>
                    <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{contractVal?fmtM(contractVal):"—"}</div>
                    <div style={{fontSize:".82rem",color:"#8b5cf6"}}>{billed?fmtM(billed):"—"}</div>
                    <div style={{fontSize:".82rem",color:"#10b981",fontWeight:600}}>{collected?fmtM(collected):"—"}</div>
                    <div style={{fontSize:".82rem",color:"#ef4444"}}>{cost?fmtM(cost):"—"}</div>
                    <div style={{textAlign:"center"}}>
                      {margin!==null?(
                        <span style={{fontSize:".75rem",fontWeight:800,color:margin>=25?"#059669":margin>=10?"#f59e0b":"#ef4444",background:margin>=25?"#f0fdf4":margin>=10?"#fffbeb":"#fef2f2",borderRadius:20,padding:"3px 8px"}}>{margin}%</span>
                      ):<span style={{color:"#94a3b8",fontSize:".75rem"}}>—</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })()}
    </Wrap>
  );

  // ── AUDIT (Policy §5) ────────────────────────────────────────────────────────
  if(page==="audit") return(
    <Wrap>
      <AuditView findings={auditFindings} addFinding={addFinding} updateFinding={updateFinding} session={session} role={role}/>
    </Wrap>
  );

  if(page==="projectmargins"&&(session?.username==="paulo"||session?.username==="mar")) return(
    <ProjectMarginsView wonDeals={wonDeals} exps={exps} billings={billings} payables={payables} prs={prs} swos={swos} today={today} setPage={setPage} onOpenProject={id=>{setJumpDeal(id);setPage("projects");}} Wrap={Wrap} isMobile={isMobile}/>
  );

  if(page==="syshealth"&&role==="Manager") return(
    <Wrap>
      <SystemHealthView session={session}/>
    </Wrap>
  );

  // ── BILLING ─────────────────────────────────────────────────────────────────
  if(page==="billing") return(
    <>
    <Wrap>
      {/* Missing due-date nudge — keeps the cash-flow forecast accurate */}
      {(()=>{const miss=billings.filter(b=>{if(b.status==="Cancelled"||b.status==="Fully Paid")return false;return milestoneBalance(b,dealById.get(b.dealId))>0.5&&!b.dueDate;}).length;
        return miss>0?(
          <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"10px 14px",marginBottom:14,display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <span style={{flex:1,minWidth:200,fontSize:".82rem",color:"#92400e",fontWeight:600}}>⚠️ {miss} unpaid billing{miss===1?"":"s"} missing a due date — the cash-flow forecast can't schedule {miss===1?"it":"them"}.</span>
            <button onClick={()=>setDueDateFixOpen(true)} style={{background:"#b45309",border:"none",borderRadius:8,padding:"8px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:"pointer",whiteSpace:"nowrap"}}>📅 Set due dates</button>
          </div>
        ):null;})()}
      {/* Aging Summary */}
      {(()=>{
        const now=new Date();
        // Each bucket holds the open balance split into VAT-exclusive base, VAT and
        // EWT (milestoneBalanceParts): base + VAT − EWT = what the client still owes.
        const z=()=>({base:0,vat:0,ewt:0,bal:0});
        const aging={current:z(),d30:z(),d60:z(),d90:z(),over90:z()};
        billings.forEach(b=>{
          // Same basis as the Outstanding figure (arSummary): any milestone with a
          // balance counts, even one marked Fully Paid — a short payment shouldn't
          // drop out of the aging just because of its status.
          const p=milestoneBalanceParts(b,dealById.get(b.dealId));
          if(p.bal<=0.005) return;
          const days=b.dueDate?Math.floor((now-new Date(b.dueDate))/(1000*60*60*24)):0;
          const k=days<=0?"current":days<=30?"d30":days<=60?"d60":days<=90?"d90":"over90";
          ["base","vat","ewt","bal"].forEach(f=>{aging[k][f]+=p[f];});
        });
        const tot=Object.values(aging).reduce((a,v)=>({base:a.base+v.base,vat:a.vat+v.vat,ewt:a.ewt+v.ewt,bal:a.bal+v.bal}),z());
        if(tot.bal===0) return null;
        const peso2=v=>"₱"+v.toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
        return(
          <div style={{marginBottom:16}}>
            <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",marginBottom:10}}>📊 AR Aging <span style={{fontWeight:500,color:"#94a3b8",fontSize:".72rem"}}>· VAT-exclusive · tap a card for the list</span></div>
            {/* Mobile: Total across the top, buckets two per row. Desktop: Total + five buckets in one row. */}
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(6,1fr)",gap:8}}>
              {[["Total",tot,"#0f172a","all"],["Current",aging.current,"#10b981","current"],["1–30 days",aging.d30,"#f59e0b","d30"],
                ["31–60 days",aging.d60,"#f97316","d60"],["61–90 days",aging.d90,"#ef4444","d90"],["90+ days",aging.over90,"#dc2626","over90"]
              ].map(([l,a,c,key])=>{const isTot=l==="Total";return(
                <div key={l} role="button" tabIndex={0} title="Show the projects to collect" onClick={()=>a.bal>0.005&&setArDrill(key)} onKeyDown={e=>{if((e.key==="Enter"||e.key===" ")&&a.bal>0.005){e.preventDefault();setArDrill(key);}}} style={{cursor:a.bal>0.005?"pointer":"default",background:isTot?"#1e293b":"#fff",border:`1.5px solid ${isTot?"#1e293b":c+"33"}`,borderRadius:10,padding:isMobile?"10px 8px":"12px 14px",textAlign:"center",minWidth:0,gridColumn:isMobile&&isTot?"1 / -1":undefined}}>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:isMobile&&!isTot?"1rem":"1.1rem",color:isTot?"#f59e0b":c,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                    ₱{a.base.toLocaleString("en-PH",{minimumFractionDigits:0,maximumFractionDigits:2})}
                  </div>
                  <div style={{fontSize:".68rem",color:isTot?"rgba(255,255,255,.6)":"#94a3b8",marginTop:3,textTransform:"uppercase",letterSpacing:".8px"}}>{isTot?"Total outstanding · VAT-ex":l}</div>
                  {isTot
                    ?<div style={{display:"flex",justifyContent:"center",flexWrap:"wrap",gap:"2px 14px",marginTop:8,fontSize:".74rem",color:"rgba(255,255,255,.8)"}}>
                      <span>VAT <b style={{color:"#fff"}}>{peso2(a.vat)}</b></span>
                      {a.ewt>0.005&&<span>EWT <b style={{color:"#fff"}}>−{peso2(a.ewt)}</b></span>}
                      <span>Collectible <b style={{color:"#f59e0b"}}>{peso2(a.bal)}</b></span>
                    </div>
                    :a.vat>0.005&&<div style={{fontSize:".66rem",color:"#64748b",marginTop:2}}>+ VAT {peso2(a.vat)}</div>}
                </div>);})}
            </div>
          </div>
        );
      })()}
      {arDrill&&<ARDrill bucket={arDrill} billings={billings} dealOf={id=>dealById.get(id)}
        canPay={["Manager","Finance","FinanceAssistant","SalesOpsAdmin"].includes(role)}
        onReceive={(dealId,msId)=>{setArDrill(null);setBillingJumpPay(msId);setBillingJumpDeal(dealId);}}
        onClose={()=>setArDrill(null)}/>}
      {/* Priority call list */}
      {(()=>{
        const today2=new Date();
        const callList=wonDeals.map(d=>{
          const ms=billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled"&&b.status!=="Fully Paid");
          const totalDue=ms.reduce((s,m)=>s+milestoneBalance(m,d),0);
          const mostOverdue=ms.filter(m=>m.dueDate&&m.dueDate<today).sort((a,b)=>new Date(a.dueDate)-new Date(b.dueDate))[0];
          const daysOverdue=mostOverdue?Math.floor((today2-new Date(mostOverdue.dueDate))/(1000*60*60*24)):null;
          return{d,totalDue,daysOverdue,msCount:ms.length};
        }).filter(x=>x.totalDue>0).sort((a,b)=>((b.daysOverdue||0)-(a.daysOverdue||0))||(b.totalDue-a.totalDue));
        if(!callList.length) return null;
        return(
          <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",marginBottom:16,overflow:"hidden"}}>
            <div style={{background:"#1e293b",padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"4px 12px"}}>
              <span style={{fontWeight:700,color:"#f59e0b",fontSize:".88rem"}}>📞 Priority Call List — ₱{callList.reduce((s,x)=>s+x.totalDue,0).toLocaleString("en-PH",{minimumFractionDigits:0})} outstanding</span>
              <span style={{fontSize:".72rem",color:"rgba(255,255,255,.5)"}}>{callList.length} clients to follow up</span>
            </div>
            {callList.slice(0,8).map(({d,totalDue,daysOverdue,msCount})=>(
              <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 18px",borderBottom:"1px solid #f8fafc",flexWrap:"wrap",gap:8}}>
                <div>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem"}}>{d.client}</div>
                  <div style={{fontSize:".72rem",color:"#64748b",marginTop:1}}>{d.ceNo||"No CE"} · {msCount} milestone{msCount!==1?"s":""}</div>
                </div>
                <div style={{display:"flex",gap:12,alignItems:"center"}}>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontWeight:800,color:"#ef4444",fontSize:".92rem"}}>₱{totalDue.toLocaleString("en-PH",{minimumFractionDigits:0})}</div>
                    <div style={{fontSize:".68rem",color:"#94a3b8"}}>outstanding</div>
                  </div>
                  {daysOverdue!==null&&(
                    <span style={{background:daysOverdue>60?"#fef2f2":daysOverdue>30?"#fff7ed":"#fffbeb",color:daysOverdue>60?"#dc2626":daysOverdue>30?"#c2410c":"#d97706",border:`1px solid ${daysOverdue>60?"#fecaca":daysOverdue>30?"#fed7aa":"#fde68a"}`,borderRadius:20,padding:"2px 9px",fontSize:".72rem",fontWeight:700}}>
                      {daysOverdue}d overdue
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        );
      })()}
      <BillingView
        billings={billings} wonDeals={wonDeals} completedDeals={completedDeals} deals={deals} addenda={addenda}
        addMilestone={addMilestone} updateMilestone={updateMilestone} applyDeduction={applyDeduction}
        deleteMilestone={deleteMilestone} deleteProjectBilling={deleteProjectBilling} createMilestoneSchedule={createMilestoneSchedule} logBillingPayment={logBillingPayment}
        deleteBillingPayment={deleteBillingPayment}
        setConfirmDel={setConfirmDel} canDeleteDeal={canDeleteDeal}
        session={session} role={role}
        clientProfiles={clientProfiles}
        upDeals={upDeals}
        onSaveOnboarding={async(dealId,fields)=>{
          upDeals(ds=>ds.map(d=>d.id===dealId?{...d,...fields}:d));
          if(isSupabaseReady()){
            // Through the set_deal_onboarding RPC, not sbUpdate: Finance and
            // FinanceAssistant edit this panel but deals_upd doesn't admit
            // them, so a direct update matched 0 rows and was silently lost.
            const snake={};
            if('bir2303Url' in fields) snake.bir_2303_url=fields.bir2303Url||"";
            if('bir2303OnFile' in fields) snake.bir_2303_on_file=!!fields.bir2303OnFile;
            if('signedCeUrl' in fields) snake.signed_ce_url=fields.signedCeUrl||null;
            if('signedCeOnFile' in fields) snake.signed_ce_on_file=!!fields.signedCeOnFile;
            if('vatTreatment' in fields) snake.vat_treatment=fields.vatTreatment||null;
            if('downpaymentPct' in fields) snake.downpayment_pct=fields.downpaymentPct!==""&&fields.downpaymentPct!=null?Number(fields.downpaymentPct):null;
            if('paymentTermsText' in fields) snake.payment_terms_text=fields.paymentTermsText||null;
            if('clientSatisfied' in fields) snake.client_satisfied=!!fields.clientSatisfied;
            if('satisfactionNote' in fields) snake.satisfaction_note=fields.satisfactionNote||null;
            supabase.rpc('set_deal_onboarding',{p_deal_id:dealId,p_fields:snake}).then(({error})=>{
              if(error){console.error('set_deal_onboarding:',error.message);toastEmit("⚠ Onboarding details not saved: "+error.message,"error");}
            },e=>toastEmit("⚠ Onboarding details not saved: "+(e?.message||e),"error"));
          }
        }}
        onOpenPayTerms={id=>setPayTermsModal(id)}
        initialDeal={billingJumpDeal} clearInitialDeal={()=>setBillingJumpDeal(null)}
        initialPayMs={billingJumpPay} clearInitialPayMs={()=>setBillingJumpPay(null)}
        cocDeals={Object.entries(projs).filter(([id,p])=>p?.cocCreated).map(([id])=>id)}
        projs={projs} overallProg={overallProg}
        toastEmit={toastEmit} sendTelegramNotification={sendTelegramNotification}/>
    </Wrap>
    {payTermsModal&&(()=>{const _d=deals.find(d=>d.id===payTermsModal);const _src=_d&&_d.parentDealId?(deals.find(x=>x.id===_d.parentDealId)||_d):_d;return _d?<MilestoneBuilder deal={_d} contractVal={_d.originalValue!=null?_d.originalValue:_d.value} schedCtx={{awardDate:pcards?.[_d.id]?.awardDate||_d.dateAcquired||pcards?.[_src.id]?.awardDate||"",stageDates:projs?.[_src.id]?.stageDates||projs?.[_d.id]?.stageDates||{}}} onClose={()=>setPayTermsModal(null)} onCreate={async(active,netDays,notes)=>{if(await createMilestoneSchedule(payTermsModal,active,netDays,notes))setPayTermsModal(null);}}/>:null;})()}
    </>
  );

  // ── DATA MANAGEMENT (Manager only) ──────────────────────────────────────────
    if(page==="datamanagement"&&session?.username!=="paulo"){
      return(<Wrap><div style={{textAlign:"center",padding:"60px",color:"#94a3b8"}}>
        <div style={{fontSize:"3rem",marginBottom:12}}>🔒</div>
        <div style={{fontWeight:700,color:"#0f172a",fontSize:"1.1rem"}}>CEO Only</div>
        <div style={{fontSize:".85rem",marginTop:6,color:"#64748b"}}>Data management is restricted to Paulo Garcia.</div>
      </div></Wrap>);
    }
  if(page==="datamanagement"&&role==="Manager") return(
    <Wrap>
      <DataManagement
        deals={deals} exps={exps} inflows={infs} jos={jos} prs={prs}
        mreqs={mreqs} breqs={breqs} addenda={addenda} billings={billings}
        pcards={pcards} checklist={checklist} cashPositions={cashPositions}
        actLog={actLog} budgets={budgets} payables={payables} vouchers={vouchers}
        upDeals={upDeals} upExps={upExps} upInflows={upInflows} upJos={upJos}
        upPrs={upPrs} upMreqs={upMreqs} upBreqs={upBreqs} upAddenda={upAddenda}
        upBillings={upBillings} upPcards={upPcards} upChecklist={upChecklist}
        upCashPos={upCashPos} setActLog={setActLog} upBudgets={upBudgets}
        upPayables={upPayables} upVouchers={upVouchers}
        persist={persist}/>
    </Wrap>
  );

  // ── DAILY PAYABLES (Accounting-logged Expenses) ───────────────────────────

  // ── CHECK PAYABLES ────────────────────────────────────────────────────────────
  if(page==="checkvouchers"&&(role==="Accounting"||role==="Finance"||role==="Manager"||role==="FinanceAssistant")) return(
    <Wrap>
      <FinanceErpBar active="cv" go={financeErpGo} counts={financeErpCounts()}/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.1rem"}}>✅ Check Payables</div>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Checks issued to suppliers — must be linked to a PO or Payable</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {(role==="Accounting"||role==="Finance"||role==="Manager")&&(
            <Btn onClick={openAddCv}>+ New Voucher</Btn>
          )}
          <button onClick={()=>{
            const rows=[["CV No","Date","Payee","Description","Amount","Bank","Project","Status","Released By","Released Date"]];
            [...vouchers].sort((a,b)=>(b.date||"").localeCompare(a.date||"")).forEach(v=>{
              const proj=wonDeals.find(d=>d.id===v.projectId)||completedDeals.find(d=>d.id===v.projectId);
              rows.push([v.cvNo||"",v.date||"",v.payee||"",v.description||"",Number(v.amount||0).toFixed(2),v.bank||"",proj?projDisplayName(proj):"",v.status||"Draft",v.releasedBy||"",v.releasedDate||""]);
            });
            const csv=rows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
            const a=document.createElement("a");a.href="data:text/csv;charset=utf-8,"+encodeURIComponent("﻿"+csv);a.download=`GMD_CheckVouchers_${today}.csv`;a.click();
          }} style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer"}}>⬇ Export CSV</button>
        </div>
      </div>

      {/* Accounts Payable Voucher (APV) Log — the approval/support document raised
          when a payable is logged, before payment. Mirrors Aerwin's Vouchers tab. */}
      {(()=>{
        const apvRows=[...payables].sort((a,b)=>String(b.apNumber||"").localeCompare(String(a.apNumber||"")));
        return(
          <ErpCard title="Accounts Payable Voucher (APV) Log" desc="Automatically raised whenever a vendor invoice or other payable is logged to Accounts Payable — the approval/support document, before payment is made. Click View / Print for the voucher.">
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,minWidth:820}}>
                <thead><tr>
                  {["APV No.","Date","Vendor","Project","Account","PO No.","AP No.","Amount",""].map((h,i)=>(
                    <th key={h+i} style={i===7?erpThNum:erpTh}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {apvRows.length===0&&<tr><td colSpan={9} style={{...erpTd,textAlign:"center",color:ERP.muted,fontStyle:"italic",padding:26}}>No APVs yet — they're created automatically when a payable is logged to Accounts Payable.</td></tr>}
                  {apvRows.map(p=>{
                    const proj=(wonDeals.find(d=>d.id===p.projectId)||completedDeals.find(d=>d.id===p.projectId));
                    return(
                      <tr key={p.id} onMouseEnter={ev=>ev.currentTarget.style.background="#FAFBFD"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{apvNoFor(p)}</td>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{p.invoiceDate||p.createdAt||"—"}</td>
                        <td style={{...erpTd,fontWeight:600,color:ERP.ink,maxWidth:170,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={p.vendor}>{p.vendor||"—"}</td>
                        <td style={{...erpTd,color:ERP.muted,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{proj?projDisplayName(proj):"—"}</td>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontSize:11.5,color:p.accountCode?ERP.ink:"#cbd5e1",whiteSpace:"nowrap"}}>{p.accountCode||"—"}</td>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{p.poNumber||"—"}</td>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{p.apNumber||"—"}</td>
                        <td style={{...erpTdNum,fontWeight:800,color:ERP.navy,whiteSpace:"nowrap"}}>{fmt(p.amount)}</td>
                        <td style={{...erpTd,whiteSpace:"nowrap"}}><button onClick={()=>printAPV(p)} style={{background:"transparent",border:`1px solid ${ERP.line}`,borderRadius:6,padding:"5px 10px",fontSize:12,fontWeight:600,color:ERP.navy,cursor:"pointer",fontFamily:"inherit"}}>View / Print</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </ErpCard>
        );
      })()}

      {/* Workflow status bar */}
      {(()=>{
        const wfSteps=[
          {label:"Draft",icon:"📝",status:"Draft",clr:"#64748b",bg:"#f1f5f9"},
          {label:"For Release",icon:"📤",status:"For Release",clr:"#d97706",bg:"#fffbeb"},
          {label:"Released",icon:"📮",status:"Released",clr:"#ea580c",bg:"#fff7ed"},
          {label:"Cleared",icon:"✅",status:"cleared",clr:"#059669",bg:"#f0fdf4"},
          {label:"Void",icon:"🚫",status:"Void",clr:"#dc2626",bg:"#fef2f2"},
        ];
        const counts={Draft:0,"For Release":0,Released:0,cleared:0,Void:0};
        const amts={"For Release":0,Released:0};
        vouchers.forEach(v=>{
          if(v.isCleared) counts.cleared++;
          else if(v.status==="Draft") counts.Draft++;
          else if(v.status==="For Release"){counts["For Release"]++;amts["For Release"]+=Number(v.amount||0);}
          else if(v.status==="Released"){counts.Released++;amts.Released+=Number(v.amount||0);}
          else if(v.status==="Void") counts.Void++;
        });
        return(
          <div style={{display:"flex",alignItems:"center",background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"12px 20px",marginBottom:14,gap:4,overflowX:"auto"}}>
            {wfSteps.map((s,i)=>(
              <React.Fragment key={s.status}>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,flex:1,minWidth:80,cursor:"pointer"}} onClick={()=>setCvStatus(s.status==="cleared"?"Cleared":s.status)}>
                  <div style={{width:36,height:36,borderRadius:"50%",background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1rem",border:`2px solid ${s.clr}22`}}>{s.icon}</div>
                  <div style={{fontSize:".67rem",fontWeight:700,color:s.clr,textAlign:"center"}}>{s.label}</div>
                  <div style={{fontSize:".75rem",fontWeight:900,color:s.clr}}>{counts[s.status]}</div>
                  {amts[s.status]>0&&<div style={{fontSize:".63rem",color:"#94a3b8"}}>₱{(amts[s.status]/1000).toFixed(0)}K</div>}
                </div>
                {i<wfSteps.length-1&&<div style={{color:"#cbd5e1",fontSize:"1rem",flexShrink:0,paddingBottom:20}}>→</div>}
              </React.Fragment>
            ))}
          </div>
        );
      })()}
      {/* Filter bar */}
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <input value={cvSearch} onChange={e=>setCvSearch(e.target.value)} placeholder="Search payee, description or CV no..." style={{flex:1,minWidth:160,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontSize:".82rem"}}/>
      </div>

      {/* KPI row */}
      {(()=>{
        const pending=vouchers.filter(v=>v.status==="For Release");
        const released=vouchers.filter(v=>v.status==="Released"&&!v.isCleared);
        const totalPending=pending.reduce((s,v)=>s+Number(v.amount||0),0);
        const totalReleased=released.reduce((s,v)=>s+Number(v.amount||0),0);
        return(
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(auto-fit,minmax(190px,1fr))",gap:12,marginBottom:16}}>
            <ErpStat label="Total Vouchers" value={vouchers.length+" CVs"} foot="all check vouchers"/>
            <ErpStat tone="warn" label="For Release" value={pending.length+" vouchers"} foot="awaiting release"/>
            <ErpStat tone="danger" label="Amount Pending" value={fmt(totalPending)} foot="for release"/>
            <ErpStat tone="ok" label="Released (Float)" value={fmt(totalReleased)} foot="not yet cleared"/>
          </div>
        );
      })()}

      {/* Kanban groups */}
      {(()=>{
        const CV_GROUPS=[
          {key:"Draft",      label:"Draft",               dot:"#64748b", clr:"#475569", items:vouchers.filter(v=>v.status==="Draft"&&!v.isCleared)},
          {key:"ForRelease", label:"For Release",          dot:"#f59e0b", clr:"#b45309", items:vouchers.filter(v=>v.status==="For Release"&&!v.isCleared)},
          {key:"Released",   label:"Released (Floating)",  dot:"#ea580c", clr:"#c2410c", items:vouchers.filter(v=>v.status==="Released"&&!v.isCleared)},
          {key:"Cleared",    label:"Cleared",              dot:"#059669", clr:"#059669", items:vouchers.filter(v=>v.isCleared)},
          {key:"Void",       label:"Void",                 dot:"#dc2626", clr:"#dc2626", items:vouchers.filter(v=>v.status==="Void")},
        ];
        const searchQ=cvSearch.toLowerCase();
        const filtered=CV_GROUPS.map(g=>({...g,items:g.items.filter(v=>!searchQ||(v.payee||"").toLowerCase().includes(searchQ)||(v.description||"").toLowerCase().includes(searchQ)||(v.cvNo||"").toLowerCase().includes(searchQ))}));
        const toggleCv=key=>setCvCollapsed(s=>{const n=new Set(s);n.has(key)?n.delete(key):n.add(key);return n;});
        return filtered.map(g=>{
          const isOpen=!cvCollapsed.has(g.key);
          const total=g.items.reduce((s,v)=>s+Number(v.amount||0),0);
          return(
            <div key={g.key} style={{marginBottom:10,border:"1.5px solid #e2e8f0",borderRadius:12,overflow:"hidden",background:"#fff"}}>
              <div onClick={()=>toggleCv(g.key)} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 16px",cursor:"pointer",borderBottom:isOpen?"1px solid #f1f5f9":"none"}}>
                <div style={{width:10,height:10,borderRadius:"50%",background:g.dot,flexShrink:0}}/>
                <div style={{fontWeight:700,fontSize:".82rem",color:g.clr}}>{g.label}</div>
                <div style={{background:"#f1f5f9",borderRadius:20,padding:"1px 8px",fontSize:".72rem",fontWeight:700,color:"#64748b"}}>{g.items.length}</div>
                {total>0&&<div style={{marginLeft:"auto",fontWeight:700,fontSize:".8rem",color:"#0f172a"}}>{fmt(total)}</div>}
                <div style={{color:"#cbd5e1",fontSize:".75rem",marginLeft:total>0?6:"auto"}}>{isOpen?"▲":"▼"}</div>
              </div>
              {isOpen&&g.items.length>0&&(
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                    <thead>
                      <tr>
                        {["CV No","Date","Payee","Description","Amount","Bank",""].map((h,i)=>(
                          <th key={i} style={i===4?erpThNum:erpTh}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {g.items.map((v,idx)=>{
                        const canEdit=(role==="Accounting"||role==="Manager")&&v.status==="Draft";
                        const canSubmit=(role==="Accounting"||role==="Manager")&&v.status==="Draft";
                        const canRelease=(role==="Finance"||role==="Manager")&&v.status==="For Release";
                        const canClear=v.status==="Released"&&!v.isCleared&&(role==="Finance"||role==="Manager"||role==="Accounting");
                        const canVoid=(role==="Manager"||role==="Accounting")&&v.status!=="Released"&&v.status!=="Void"&&!v.isCleared;
                        return(
                          <tr key={v.id}
                            onMouseEnter={ev=>ev.currentTarget.style.background="#FAFBFD"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                            <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{v.cvNo||"—"}</td>
                            <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{v.date||"—"}</td>
                            <td style={{...erpTd,fontWeight:600,color:ERP.ink,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                              <div style={{fontWeight:600,color:ERP.ink}}>{v.payee||"—"}</div>
                              {v.sourceExpenseId&&<div style={{fontSize:11,fontWeight:700,color:ERP.ok,marginTop:1}}>✓ From Accounting</div>}
                              {v.status==="Released"&&!v.isCleared&&v.releasedDate&&<div style={{fontSize:11,fontWeight:700,color:"#ea580c",marginTop:1}}>🏦 Expect clearance by {addDaysISO(v.releasedDate,3)}</div>}
                            </td>
                            <td style={{...erpTd,color:ERP.muted,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.description||"—"}</td>
                            <td style={{...erpTdNum,fontWeight:800,color:ERP.navy,whiteSpace:"nowrap"}}>{fmt(v.amount)}</td>
                            <td style={{...erpTd,color:ERP.navy,whiteSpace:"nowrap"}}>{v.bank||"—"}</td>
                            <td style={{...erpTd}}>
                              <div style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap"}}>
                                <button onClick={()=>setCvView(v.id)} title="View Check Voucher" style={{background:"#fef9c3",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#a16207",cursor:"pointer",fontFamily:"inherit",fontWeight:700,whiteSpace:"nowrap"}}>👁 View</button>
                                <button onClick={()=>printCheckVoucher(v)} title="Print Check Voucher" style={{background:"#eef2ff",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#4338ca",cursor:"pointer",fontFamily:"inherit",fontWeight:700,whiteSpace:"nowrap"}}>🖨 Print</button>
                                {canEdit&&<button onClick={()=>openEditCv(v)} style={{background:"#f1f5f9",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏ Edit</button>}
                                {canSubmit&&<button onClick={()=>submitCvForRelease(v.id)} style={{background:"#fef9c3",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#ca8a04",cursor:"pointer",fontFamily:"inherit",fontWeight:700,whiteSpace:"nowrap"}}>→ Submit</button>}
                                {canRelease&&<button onClick={async ()=>{if((await uiConfirm(`Release CV ${v.cvNo||""} to ${v.payee||"payee"} for ${fmt(v.amount)}?\n\nThis marks the linked payable as Paid.`)))releaseCv(v.id);}} style={{background:"#dcfce7",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#16a34a",cursor:"pointer",fontFamily:"inherit",fontWeight:700,whiteSpace:"nowrap"}}>✓ Release</button>}
                                {canClear&&<button onClick={async ()=>{if((await uiConfirm(`Mark CV ${v.cvNo||""} to ${v.payee||"payee"} for ${fmt(v.amount)} as cleared by the bank?`)))clearCv(v.id);}} style={{background:"#eff6ff",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#2563eb",cursor:"pointer",fontFamily:"inherit",fontWeight:700,whiteSpace:"nowrap"}}>🏦 Cleared</button>}
                                {canVoid&&<button onClick={async ()=>{if((await uiConfirm("Void this voucher?")))voidCv(v.id);}} style={{background:"#fef2f2",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".65rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>Void</button>}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
              {isOpen&&g.items.length===0&&(
                <div style={{padding:"20px",textAlign:"center",color:"#94a3b8",fontSize:".8rem"}}>No {g.label.toLowerCase()} vouchers.</div>
              )}
            </div>
          );
        });
      })()}

      {/* Notes panel for released vouchers */}
      {cvStatus==="Released"&&vouchers.filter(v=>v.status==="Released").length>0&&(
        <div style={{marginTop:12,padding:"10px 14px",background:"#f0fdf4",borderRadius:10,border:"1px solid #86efac",fontSize:".78rem",color:"#166534"}}>
          ✅ Released vouchers have been authorized by Finance. These represent actual cash disbursements.
        </div>
      )}

      {/* CV Modal */}
      {cvModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.45)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:520,maxHeight:"90vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,.3)"}}>
            <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.05rem",marginBottom:18}}>{editCvId?"Edit Check Voucher":"New Check Voucher"}</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              <div>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>CV Number</label>
                <input value={cvForm.cvNo} onChange={e=>setCvForm(f=>({...f,cvNo:e.target.value}))} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
              </div>
              <div>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Date</label>
                <input type="date" value={cvForm.date} onChange={e=>setCvForm(f=>({...f,date:e.target.value}))} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
              </div>
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Payee *</label>
              <input value={cvForm.payee} onChange={e=>setCvForm(f=>({...f,payee:e.target.value}))} placeholder="Supplier / vendor name" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Description</label>
              <input value={cvForm.description} onChange={e=>setCvForm(f=>({...f,description:e.target.value}))} placeholder="What is this payment for?" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              <div>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Amount *</label>
                <input type="number" value={cvForm.amount} onChange={e=>setCvForm(f=>({...f,amount:e.target.value}))} placeholder="0.00" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
              </div>
              <div>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Bank Account</label>
                <select value={cvForm.bank||""} onChange={e=>setCvForm(f=>({...f,bank:e.target.value}))} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",background:"#fff",boxSizing:"border-box"}}>
                  <option value="">— Select Bank —</option>
                  {BANKS.map(b=><option key={b.id} value={b.id}>{b.short}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              <div>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Check No.</label>
                <input value={cvForm.checkNo||""} onChange={e=>setCvForm(f=>({...f,checkNo:e.target.value}))} placeholder="e.g. 0012345" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
              </div>
              <div>
                <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>PO Reference</label>
                <input value={cvForm.poRef||""} onChange={e=>setCvForm(f=>({...f,poRef:e.target.value}))} placeholder="e.g. PO-0042" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",boxSizing:"border-box"}}/>
              </div>
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Link to Payable (optional)</label>
              <select value={cvForm.payableId||""} onChange={e=>setCvForm(f=>({...f,payableId:e.target.value||null}))} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",background:"#fff",boxSizing:"border-box"}}>
                <option value="">— Not linked to a payable —</option>
                {payables.filter(p=>p.status==="Unpaid").map(p=><option key={p.id} value={p.id}>{p.vendor} — ₱{Number(p.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})}{p.invoiceRef?" · "+p.invoiceRef:""}</option>)}
              </select>
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Project (optional)</label>
              <select value={cvForm.projectId||""} onChange={e=>setCvForm(f=>({...f,projectId:e.target.value||null}))} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",background:"#fff",boxSizing:"border-box"}}>
                <option value="">— Company-wide / No project —</option>
                {wonDeals.map(d=><option key={d.id} value={d.id}>{projDisplayName(d)}</option>)}
                {costCenterDeals.length>0&&<optgroup label="Cost centers">{costCenterDeals.map(d=><option key={d.id} value={d.id}>🏷 {d.contact||d.client}</option>)}</optgroup>}
              </select>
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:4}}>Notes</label>
              <textarea value={cvForm.notes} onChange={e=>setCvForm(f=>({...f,notes:e.target.value}))} rows={2} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",resize:"vertical",boxSizing:"border-box"}}/>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button onClick={()=>setCvModal(false)} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer",color:"#475569"}}>Cancel</button>
              <button onClick={saveCv} disabled={!cvForm.payee||!cvForm.amount} style={{background:cvForm.payee&&cvForm.amount?"#6366f1":"#e2e8f0",border:"none",borderRadius:8,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:cvForm.payee&&cvForm.amount?"pointer":"not-allowed",color:cvForm.payee&&cvForm.amount?"#fff":"#94a3b8"}}>Save Voucher</button>
            </div>
          </div>
        </div>
      )}
      {/* ── On-screen Check Voucher document (Aerwin's format) ── */}
      {cvView&&(()=>{
        const v=vouchers.find(x=>x.id===cvView);
        if(!v) return null;
        const bankName=(()=>{const b=(BANKS||[]).find(x=>x.id===v.bank||x.short===v.bank||x.name===v.bank);return b?b.name:(v.bank||"—");})();
        const apRef=v.apRef||(payables.find(p=>p.id===v.payableId)||{}).apNumber||"—";
        const pesos=n=>"PHP "+Number(n||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
        const DocRow=({label,value})=>(
          <div style={{display:"flex",gap:14,marginBottom:9,fontSize:13}}>
            <div style={{width:140,color:"#5B6472",fontWeight:600,flexShrink:0}}>{label}</div>
            <div style={{fontWeight:600,color:"#1B2430"}}>{value||"—"}</div>
          </div>
        );
        return(
          <div onClick={()=>setCvView(null)} style={{position:"fixed",inset:0,background:"rgba(11,20,37,.55)",zIndex:9999,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"40px 16px",overflowY:"auto"}}>
            <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:12,width:"100%",maxWidth:620,boxShadow:"0 20px 50px rgba(0,0,0,.3)",overflow:"hidden"}}>
              <div style={{padding:"18px 20px"}}>
                {/* cv-doc: navy border + diagonal watermark, matching Aerwin's ERP */}
                <div style={{border:"1.5px solid #0B2545",borderRadius:8,padding:"22px 26px",background:"#fff",position:"relative",overflow:"hidden"}}>
                  <div style={{position:"absolute",top:"44%",left:"50%",transform:"translate(-50%,-50%) rotate(-18deg)",fontSize:38,fontWeight:800,color:"rgba(11,37,69,0.05)",whiteSpace:"nowrap",pointerEvents:"none"}}>GMD PRODUCTION INC.</div>
                  <div style={{position:"relative"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",borderBottom:"2px solid #C9A24B",paddingBottom:10,marginBottom:14}}>
                      <div>
                        <div style={{fontSize:15,fontWeight:800,color:"#0B2545"}}>GMD PRODUCTION INC.</div>
                        <div style={{fontSize:11,color:"#5B6472",marginTop:2}}>Marikina City, Metro Manila, Philippines · TIN 010-063-229-00000</div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontSize:10,letterSpacing:".05em",color:"#5B6472",textTransform:"uppercase"}}>Check Voucher No.</div>
                        <div style={{fontSize:16,fontWeight:800,color:"#A8822F"}}>{v.cvNo||"—"}</div>
                      </div>
                    </div>
                    <DocRow label="Date" value={v.date}/>
                    <DocRow label="Payee" value={v.payee}/>
                    <DocRow label="Particulars" value={v.description}/>
                    <DocRow label="PO Reference" value={v.poRef}/>
                    <DocRow label="AP Reference" value={apRef}/>
                    <DocRow label="Bank" value={bankName}/>
                    <DocRow label="Check Number" value={v.checkNo}/>
                    <div style={{margin:"14px 0",border:"1px solid #DCE2EC",borderRadius:8,padding:"12px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",background:"#EEF2F8"}}>
                      <span style={{fontSize:12,color:"#5B6472",fontWeight:600}}>Amount</span>
                      <span style={{fontSize:20,fontWeight:800,color:"#0B2545"}}>{pesos(v.amount)}</span>
                    </div>
                    <div style={{background:"#fff",border:"1px solid #DCE2EC",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:12.5}}>
                      <div style={{fontWeight:700,color:"#0B2545",fontSize:11,textTransform:"uppercase",letterSpacing:".04em",marginBottom:5}}>Accounting Entry</div>
                      <div style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}><span style={{color:"#1B2430"}}>Dr &nbsp;2000 — Accounts Payable - Trade</span><span>{pesos(v.amount)}</span></div>
                      <div style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}><span style={{paddingLeft:18,color:"#5B6472"}}>Cr &nbsp;{bankName}</span><span style={{color:"#5B6472"}}>{pesos(v.amount)}</span></div>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginTop:26}}>
                      <div style={{borderTop:"1px solid #1B2430",paddingTop:5,fontSize:11,color:"#5B6472",textAlign:"center"}}>Prepared by — Finance</div>
                      <div style={{borderTop:"1px solid #1B2430",paddingTop:5,fontSize:11,color:"#5B6472",textAlign:"center"}}>Approved by — Management</div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{display:"flex",justifyContent:"flex-end",gap:8,padding:"14px 20px",borderTop:"1px solid #DCE2EC"}}>
                <button onClick={()=>printCheckVoucher(v)} style={{background:"transparent",border:"1px solid #DCE2EC",borderRadius:7,padding:"9px 16px",fontFamily:"inherit",fontSize:13,fontWeight:600,color:"#0B2545",cursor:"pointer"}}>🖨 Print</button>
                <button onClick={()=>setCvView(null)} style={{background:"#0B2545",border:"none",borderRadius:7,padding:"9px 18px",fontFamily:"inherit",fontSize:13,fontWeight:600,color:"#fff",cursor:"pointer"}}>Close</button>
              </div>
            </div>
          </div>
        );
      })()}
    </Wrap>
  );

  // ── ACCOUNTING DASHBOARD (accessible from Finance & Manager navs) ────────────
  if(page==="audittrail"&&(role==="Finance"||role==="Manager"||role==="Accounting")) return(
    <AuditTrailView isMobile={isMobile} fmt={fmt} setPage={setPage} restoreFinancial={restoreFinancial} labelFor={t=>(FIN_AUDIT[t]||{}).label||t} Wrap={Wrap}/>
  );
  if(page==="wip"&&(role==="Finance"||role==="Manager"||role==="Accounting")) return(
    <WIPView wonDeals={wonDeals} projs={projs} billings={billings} exps={exps} prs={prs} overallProg={overallProg} setPage={setPage} Wrap={Wrap} isMobile={isMobile}/>
  );
  if(page==="cashflow"&&(role==="Finance"||role==="Manager"||role==="Accounting"||role==="FinanceAssistant")) return(
    <CashFlowView deals={deals} billings={billings} payables={payables} vouchers={vouchers} loans={loans} cashPositions={cashPositions} setPage={setPage} Wrap={Wrap} isMobile={isMobile} onFixDueDates={()=>setDueDateFixOpen(true)}/>
  );
  if(page==="weeklycashflow"&&(role==="Finance"||role==="Manager"||role==="Accounting")) return(
    <Wrap><WeeklyCashFlow cashPositions={cashPositions} billings={billings} exps={exps} chartOfAccounts={chartOfAccounts} setPage={setPage}/></Wrap>
  );
  if(page==="dailylog") return(
    <DailySiteLogView dailyLogs={dailyLogs} wonDeals={wonDeals} addDailyLog={addDailyLog} delDailyLog={delDailyLog} session={session} role={role} Wrap={Wrap} isMobile={isMobile} setPage={setPage}/>
  );
  if(page==="acctdash"&&(role==="Finance"||role==="Manager"||role==="Accounting"||role==="FinanceAssistant")) return(
    <Wrap>
      <FinanceErpBar active="dashboard" go={financeErpGo} counts={financeErpCounts()}/>
      <FinanceDigestPanel billings={billings} exps={exps} wonDeals={wonDeals} completedDeals={completedDeals} deals={deals} payables={payables} prs={prs} swos={swos} cashPositions={cashPositions} today={today} isMobile={isMobile} sendTelegramNotification={sendTelegramNotification} toastEmit={toastEmit}/>
      {(()=>{
        const bpiPos=Object.values(cashPositions).filter(p=>(p?.date||"")<=today).sort((a,b)=>(b.date||"").localeCompare(a.date||""))[0];
        const bpiBal=bpiPos?Number(bpiPos.banks?.bpi?.book||bpiPos.banks?.bpi?.end||bpiPos.banks?.bpi?.beg||0):0;
        const pendingPay=exps.filter(e=>e.acctStatus==="For Payment"||(!e.acctStatus&&e.bankAccount));
        const overduePay=exps.filter(e=>(e.acctStatus==="For Payment"||(!e.acctStatus))&&e.expDate&&e.expDate<today);
        const paidThisMonth=exps.filter(e=>e.acctStatus==="Paid"&&(e.expDate||"").slice(0,7)===today.slice(0,7));
        // BIR tax this month: creditable input VAT + EWT withheld from suppliers
        const monthExps=exps.filter(e=>(e.expDate||"").slice(0,7)===today.slice(0,7));
        const inputVatMonth=monthExps.reduce((s,e)=>s+(Number(e.inputVat)||0),0);
        const ewtPayableMonth=monthExps.reduce((s,e)=>s+(Number(e.ewtAmount)||0),0);
        const pendingEvs=evouchers.filter(e=>e.status==="For Payment");
        const evItems=pendingEvs.reduce((s,e)=>(s+(e.items||[]).length),0);
        const pendingEvsAmt=pendingEvs.reduce((s,e)=>(s+(e.items||[]).reduce((ss,i)=>ss+Number(i.amount||0),0)),0);
        const cvDraft=vouchers.filter(v=>v.status==="Draft").length;
        const cvForRel=vouchers.filter(v=>v.status==="For Release");
        const cvReleased=vouchers.filter(v=>v.status==="Released"&&!v.isCleared);
        const cvCleared=vouchers.filter(v=>v.isCleared);
        const cvForRelAmt=cvForRel.reduce((s,v)=>s+Number(v.amount||0),0);
        const cvRelAmt=cvReleased.reduce((s,v)=>s+Number(v.amount||0),0);
        const loggedExps=exps.filter(e=>!e.acctStatus||e.acctStatus==="Logged").sort((a,b)=>(b.expDate||"").localeCompare(a.expDate||""));
        const recentActivity=[
          ...exps.filter(e=>e.acctStatus==="For Payment"||e.acctStatus==="Logged").map(e=>({type:"daily",label:(e.note||e.category||"Expense"),sub:e.expDate+" · "+(e.bankAccount||"No bank"),status:e.acctStatus||"Logged",amt:Number(e.amount||0),date:e.expDate||""})),
          ...vouchers.filter(v=>["For Release","Released"].includes(v.status)).map(v=>({type:"cv",label:v.cvNo+" · "+(v.payee||""),sub:v.date,status:v.status,amt:Number(v.amount||0),date:v.date||""})),
          ...evouchers.filter(e=>["For Payment","Draft"].includes(e.status)).map(e=>({type:"ev",label:e.evNo+" · "+(e.payee||e.department||"Liquidation"),sub:(e.items||[]).length+" line items · "+e.date,status:e.status,amt:(e.items||[]).reduce((s,i)=>s+Number(i.amount||0),0),date:e.date||""})),
        ].sort((a,b)=>b.date.localeCompare(a.date)).slice(0,8);
        // ── Purchase-to-Payment KPIs (Procurement → Finance) — driven by POs + the AP ledger ──
        const _pN=v=>Number(v)||0;
        const _payBal=p=>Math.max(0,_pN(p.amount)-_pN(p.paidAmount));
        const openPOset=new Set(prs.filter(p=>["PO Issued","Partially Delivered"].includes(p.status)&&p.poNumber).map(p=>p.poNumber));
        // Only received/verified payables are truly owed; not-yet-received PO/WO
        // payables are commitments awaiting receipt (see the AP ledger).
        const _received=p=>!payNeedsVerify(p)||p.verified;
        const outstandingPayables=payables.filter(p=>p.status!=="Paid"&&_received(p)).reduce((s,p)=>s+_payBal(p),0);
        const awaitingReceiptAmt=payables.filter(p=>p.status!=="Paid"&&!_received(p)).reduce((s,p)=>s+_payBal(p),0);
        const overduePayList=payables.filter(p=>p.status!=="Paid"&&_received(p)&&p.dueDate&&p.dueDate<today&&_payBal(p)>0);
        const overduePayAmt=overduePayList.reduce((s,p)=>s+_payBal(p),0);
        const paidPayMonth=payables.filter(p=>p.status==="Paid"&&(p.paidDate||"").slice(0,7)===today.slice(0,7));
        const paidByCheck=paidPayMonth.filter(p=>p.cvId||p.status==="Check Issued").reduce((s,p)=>s+_pN(p.amount),0);
        const paidByOnline=paidPayMonth.reduce((s,p)=>s+_pN(p.amount),0)-paidByCheck;
        const paidPayTotal=paidByCheck+paidByOnline;
        const statusClr={Logged:"#64748b","For Payment":"#d97706",Paid:"#059669",Draft:"#64748b","For Release":"#d97706",Released:"#ea580c",Cleared:"#059669",Cancelled:"#dc2626"};
        const statusBg={Logged:"#f8fafc","For Payment":"#fffbeb",Paid:"#f0fdf4",Draft:"#f8fafc","For Release":"#fffbeb",Released:"#fff7ed",Cleared:"#f0fdf4",Cancelled:"#fef2f2"};
        return(<>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
            <div>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a"}}>📒 Accounting</div>
              <div style={{color:"#64748b",fontSize:".85rem",marginTop:2}}>{session?.name||role} · {todayL}</div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button onClick={()=>openAddExp()} style={{background:"#0f172a",border:"none",borderRadius:9,padding:"8px 18px",color:"#facc15",fontFamily:"inherit",fontWeight:800,fontSize:".82rem",cursor:"pointer",letterSpacing:".3px"}}>+ OTHER PAYABLE</button>
              <button onClick={()=>setPage("wip")} style={{background:"#0e7490",border:"none",borderRadius:9,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>📐 WIP Report</button>
              <button onClick={()=>setPage("weeklycashflow")} style={{background:"#1f3864",border:"none",borderRadius:9,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>📅 Weekly Summary</button>
              <button onClick={()=>setPage("audittrail")} style={{background:"#475569",border:"none",borderRadius:9,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>🕵️ Audit Trail</button>
            </div>
          </div>
          {/* Purchase-to-Payment — the finance cockpit's KPI row (Aerwin's ERP dashboard) */}
          <div style={{display:"flex",alignItems:"center",gap:8,margin:"4px 2px 10px"}}>
            <span style={{fontSize:".7rem",fontWeight:800,color:"#64748b",textTransform:"uppercase",letterSpacing:".9px"}}>🔗 Purchase-to-Payment</span>
            <span style={{fontSize:".68rem",color:"#94a3b8"}}>from Procurement's POs & the AP ledger</span>
            {(role==="Finance"||role==="Manager"||role==="FinanceAssistant")
              ?<button onClick={()=>{setFinTab("payables");setPage("finance");}} style={{marginLeft:"auto",background:"transparent",border:"1px solid #e2e8f0",borderRadius:6,padding:"3px 10px",color:"#475569",fontSize:".7rem",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>Open AP Ledger →</button>
              :<button onClick={()=>setPage("checkvouchers")} style={{marginLeft:"auto",background:"transparent",border:"1px solid #e2e8f0",borderRadius:6,padding:"3px 10px",color:"#475569",fontSize:".7rem",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>Check Payables →</button>}
          </div>
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(auto-fit,minmax(190px,1fr))",gap:12,marginBottom:20}}>
            <ErpStat label="Open Purchase Orders" value={String(openPOset.size)} foot={openPOset.size===1?"PO awaiting invoice":"POs awaiting invoice"}/>
            <ErpStat tone="warn" label="Outstanding Payables" value={fmt(outstandingPayables)} foot="received & owed now"/>
            <ErpStat tone="purple" label="Awaiting Receipt" value={fmt(awaitingReceiptAmt)} foot="not yet received/verified"/>
            <ErpStat tone={overduePayList.length>0?"danger":"ok"} label="Overdue Payables" value={fmt(overduePayAmt)} foot={overduePayList.length+" invoice(s) past due date"}/>
            <ErpStat tone="ok" label="Paid This Month" value={fmt(paidPayTotal)} foot={"Check "+fmt(paidByCheck)+" · Online "+fmt(paidByOnline)}/>
          </div>
          {/* POs Pending Payment */}
          {(()=>{
            const pendingPOs=prs.filter(p=>p.paymentStatus==="Pending Payment");
            if(!pendingPOs.length) return null;
            return(
              <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #f59e0b",overflow:"hidden",marginBottom:16}}>
                <div style={{background:"#78350f",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontWeight:700,color:"#fcd34d",fontSize:".84rem"}}>📦 POs Pending Payment — {pendingPOs.length} received item{pendingPOs.length!==1?"s":""}</span>
                  <span style={{fontSize:".7rem",color:"rgba(255,255,255,.6)"}}>Click to create a payable entry</span>
                </div>
                {pendingPOs.map((pr,idx)=>{
                  const deal=wonDeals.find(d=>d.id===pr.projectId);
                  const amt=Number(pr.qtyDelivered||pr.qty||0)*Number(pr.actUnitCost||pr.estUnitCost||0);
                  return(
                    <div key={pr.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",borderBottom:idx<pendingPOs.length-1?"1px solid #fef3c7":"none",flexWrap:"wrap",background:idx%2===0?"#fffbeb":"#fff"}}>
                      <div style={{flex:1,minWidth:160}}>
                        <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>{pr.itemName}</div>
                        <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:2}}>
                          {pr.supplier||"No supplier"} · {pr.poNumber||"No PO#"}{deal?" · "+projDisplayName(deal):""}
                        </div>
                        <div style={{fontSize:".7rem",color:"#b45309",marginTop:1}}>
                          Received: {pr.qtyDelivered||pr.qty} {pr.unit||""} on {pr.deliveryDate||today}
                        </div>
                      </div>
                      <div style={{fontWeight:800,color:"#92400e",fontSize:".9rem",minWidth:80,textAlign:"right"}}>{amt>0?fmt(amt):"—"}</div>
                      <div style={{flexShrink:0}}>
                        <button onClick={()=>{setPoPayPr(pr);setPoPayStep(1);setPoPayType(null);setPoPayModal(true);}} style={{background:"#b45309",border:"none",borderRadius:7,padding:"7px 15px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer",whiteSpace:"nowrap"}}>Create Payable →</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
          {/* Recent Activity */}
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
            <div style={{background:"#1e293b",padding:"11px 16px"}}>
              <span style={{fontWeight:700,color:"#f59e0b",fontSize:".84rem"}}>🕐 Recent Activity</span>
            </div>
            {recentActivity.length===0?(
              <div style={{padding:"20px",color:"#94a3b8",fontSize:".82rem",textAlign:"center"}}>No recent activity.</div>
            ):recentActivity.map((a,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",borderBottom:"1px solid #f1f5f9",fontSize:".8rem"}}>
                <div style={{width:32,height:32,borderRadius:8,background:a.type==="cv"?"#f0fdf4":a.type==="ev"?"#f5f3ff":"#eff6ff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".9rem",flexShrink:0}}>
                  {a.type==="cv"?"✅":a.type==="ev"?"🧾":"📄"}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,color:"#0f172a"}}>{a.label}</div>
                  <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:1}}>{a.sub}</div>
                </div>
                <span style={{display:"inline-flex",alignItems:"center",gap:4,padding:"2px 9px",borderRadius:20,fontSize:".68rem",fontWeight:700,background:statusBg[a.status]||"#f8fafc",color:statusClr[a.status]||"#64748b"}}>
                  <span style={{width:5,height:5,borderRadius:"50%",background:statusClr[a.status]||"#64748b"}}/>
                  {a.status}
                </span>
                <div style={{fontWeight:700,color:"#0f172a",minWidth:90,textAlign:"right"}}>{fmt(a.amt)}</div>
              </div>
            ))}
          </div>
        </>);
      })()}
      {/* PO → Payable 2-step decision modal */}
      {poPayModal&&poPayPr&&(()=>{
        const pr=poPayPr;
        const amt=Number(pr.qtyDelivered||pr.qty||0)*Number(pr.actUnitCost||pr.estUnitCost||0);
        const autoSuggest=amt>=10000&&pr.poNumber?"check":"daily";
        const handleConfirm=async()=>{
          if(poPayType==="daily"){
            // "Other Payable" — an AP-ledger entry (was the retired Daily Payables expense).
            setPayForm({...emptyPayForm(),vendor:pr.supplier||"",amount:amt||"",dueDate:today,category:"Supplier",projectId:pr.projectId||null,notes:`${pr.itemName}${pr.poNumber?" — "+pr.poNumber:""}`,poNumber:pr.poNumber||"",invoiceNumber:pr.deliveryNote||""});
            setEditPayId(null);setPayModal(true);
            setPage("finance");setFinTab("payables");
          } else {
            const nextNo=await claimDocNumber("CV",vouchers.map(v=>v.cvNo),4,true);
            setCvForm({date:today,cvNo:nextNo,payee:pr.supplier||"",description:`${pr.itemName}${pr.poNumber?" — "+pr.poNumber:""}`,amount:amt||"",bank:"",notes:"",status:"Draft",poRef:pr.poNumber||"",payableId:null,checkNo:"",clearedDate:"",isCleared:false,projectId:pr.projectId||null});
            setEditCvId(null);setCvModal(true);
          }
          updatePR(pr.id,{paymentStatus:"Payable Created"});
          setPoPayModal(false);setPoPayPr(null);
        };
        const close=()=>{setPoPayModal(false);setPoPayPr(null);};
        return(
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.48)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1200,padding:"16px"}}>
            <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:460,boxShadow:"0 20px 60px rgba(0,0,0,.22)",overflow:"hidden"}}>
              <div style={{background:"#78350f",padding:"15px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,color:"#fcd34d",fontSize:".9rem"}}>📦 Create Payable</span>
                <button onClick={close} style={{background:"none",border:"none",color:"rgba(255,255,255,.7)",cursor:"pointer",fontSize:"1.1rem",lineHeight:1,padding:0}}>✕</button>
              </div>
              <div style={{padding:"13px 20px",borderBottom:"1px solid #f1f5f9",background:"#fffbeb"}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{pr.itemName}</div>
                <div style={{fontSize:".73rem",color:"#92400e",marginTop:2}}>{pr.supplier||"No supplier"} · {pr.poNumber||"No PO#"} · Received: {pr.qtyDelivered||pr.qty} {pr.unit||""} on {pr.deliveryDate||today}</div>
                <div style={{fontWeight:800,color:"#b45309",fontSize:"1rem",marginTop:5}}>{amt>0?fmt(amt):"Amount TBD"}</div>
              </div>
              {poPayStep===1?(
                <>
                  <div style={{padding:"16px 20px 10px"}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",marginBottom:6}}>How will this be paid?</div>
                    <div style={{fontSize:".75rem",color:"#64748b",lineHeight:1.55}}>Use <strong>Check Payable</strong> for formal supplier invoices to be paid by check (typically ₱10,000+). Use <strong>Other Payable</strong> to log it in the AP ledger for payment by online transfer or cash.</div>
                    <div style={{marginTop:10,padding:"7px 11px",borderRadius:8,background:autoSuggest==="check"?"#f0fdf4":"#eff6ff",fontSize:".72rem",fontWeight:600,color:autoSuggest==="check"?"#059669":"#6366f1"}}>
                      💡 Suggested: {autoSuggest==="check"?"Check Payable — formal invoice, ≥ ₱10,000":"Other Payable — small amount or no PO number"}
                    </div>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,padding:"10px 20px 20px"}}>
                    <button onClick={()=>{setPoPayType("daily");setPoPayStep(2);}} style={{background:autoSuggest==="daily"?"#6366f1":"#f8fafc",border:autoSuggest==="daily"?"2px solid #6366f1":"2px solid #e2e8f0",borderRadius:12,padding:"18px 12px",cursor:"pointer",fontFamily:"inherit",textAlign:"center",color:autoSuggest==="daily"?"#fff":"#1e293b",transition:"all .15s"}}>
                      <div style={{fontSize:"1.5rem",marginBottom:7}}>📄</div>
                      <div style={{fontWeight:700,fontSize:".83rem"}}>Other Payable</div>
                      <div style={{fontSize:".68rem",color:autoSuggest==="daily"?"rgba(255,255,255,.8)":"#94a3b8",marginTop:4,lineHeight:1.4}}>AP ledger entry<br/>Online / cash</div>
                    </button>
                    <button onClick={()=>{setPoPayType("check");setPoPayStep(2);}} style={{background:autoSuggest==="check"?"#059669":"#f8fafc",border:autoSuggest==="check"?"2px solid #059669":"2px solid #e2e8f0",borderRadius:12,padding:"18px 12px",cursor:"pointer",fontFamily:"inherit",textAlign:"center",color:autoSuggest==="check"?"#fff":"#1e293b",transition:"all .15s"}}>
                      <div style={{fontSize:"1.5rem",marginBottom:7}}>✅</div>
                      <div style={{fontWeight:700,fontSize:".83rem"}}>Check Payable</div>
                      <div style={{fontSize:".68rem",color:autoSuggest==="check"?"rgba(255,255,255,.8)":"#94a3b8",marginTop:4,lineHeight:1.4}}>Formal invoice<br/>Larger amounts</div>
                    </button>
                  </div>
                </>
              ):(
                <>
                  <div style={{padding:"16px 20px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                      <span style={{background:poPayType==="check"?"#f0fdf4":"#eff6ff",color:poPayType==="check"?"#059669":"#6366f1",padding:"4px 12px",borderRadius:20,fontWeight:700,fontSize:".78rem"}}>{poPayType==="check"?"✅ Check Payable":"📄 Other Payable"}</span>
                      <button onClick={()=>setPoPayStep(1)} style={{background:"none",border:"none",color:"#6366f1",cursor:"pointer",fontSize:".74rem",fontWeight:600,textDecoration:"underline",fontFamily:"inherit",padding:0}}>Change</button>
                    </div>
                    <div style={{fontSize:".8rem",color:"#475569",lineHeight:1.55}}>
                      {poPayType==="check"?"A Check Voucher will be pre-filled with this PO's details. You can review and finalize amounts before saving.":"An Other Payable entry will be pre-filled with this PO's details in the Finance AP ledger. You can review and adjust before saving."}
                    </div>
                    <div style={{marginTop:12,background:"#f8fafc",borderRadius:10,padding:"12px 14px",fontSize:".78rem",color:"#334155",lineHeight:1.7}}>
                      <div><strong>Supplier:</strong> {pr.supplier||"—"}</div>
                      <div><strong>PO Reference:</strong> {pr.poNumber||"—"}</div>
                      <div><strong>Amount:</strong> {amt>0?fmt(amt):"TBD"}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:10,padding:"0 20px 20px"}}>
                    <button onClick={()=>setPoPayStep(1)} style={{flex:1,background:"#f1f5f9",border:"none",borderRadius:8,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer",color:"#475569"}}>← Back</button>
                    <button onClick={handleConfirm} style={{flex:2,background:poPayType==="check"?"#059669":"#6366f1",border:"none",borderRadius:8,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer",color:"#fff"}}>Open {poPayType==="check"?"Check Payable":"Other Payable"} Form →</button>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })()}
      <ExpenseModal open={expModal} onClose={()=>setExpModal(false)} form={expForm} setForm={setExpForm} onSave={saveExp} onSaveAll={batchSaveExps} editId={editExpId} projList={spendWonDeals} clientName={clientName} chartOfAccounts={chartOfAccounts} suppliers={suppliers} exps={exps}/>
    </Wrap>
  );

  // ── LIQUIDATION REPORTS ───────────────────────────────────────────────────────
  if(page==="evouchers"&&(role==="Accounting"||role==="Finance"||role==="Manager"||role==="FinanceAssistant")) return(
    <Wrap>
      <LiquidationView evouchers={evouchers} addEV={addEV} updateEV={updateEV} deleteEV={deleteEV}
        addEVItem={addEVItem} updateEVItem={updateEVItem} deleteEVItem={deleteEVItem}
        submitEV={submitEV} markEVPaid={markEVPaid}
        wonDeals={wonDeals} session={session} role={role} today={today} fmt={fmt}
        BANKS={BANKS} isMobile={isMobile}/>
    </Wrap>
  );


  // ── BUDGET REQUESTS ───────────────────────────────────────────────────────
  if(page==="budgetreq") return(
    <Wrap>
      <BudgetRequestView
        breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={delBR}
        wonDeals={wonDeals} session={session} role={role}/>
    </Wrap>
  );

  // ── SWATCHBOARD (Design + Cost Control + Procurement) ────────────────────
  if(page==="swatchboard") return(
    <Wrap>
      <ProcurementView swatches={swatches} projList={projList} clientName={clientName}
        openAddSwatch={openAddSwatch} openEditSwatch={openEditSwatch} delSwatch={delSwatch} swQ={swQ} Wrap={Wrap} addMR={addMR} wonDeals={wonDeals} session={session}/>
    </Wrap>
  );

  // ── BUDGET PAGE ──────────────────────────────────────────────────────────────
  if(page==="budget") return(
    <Wrap>
      <BudgetView
        wonDeals={wonDeals} budgets={budgets} saveBudget={saveBudget}
        prs={prs} exps={exps} role={role}/>
    </Wrap>
  );

  // ── COSTING STUDY PAGE ────────────────────────────────────────────────────
  if(page==="costing") return(
    <Wrap>
      <CostingStudy
        wonDeals={wonDeals} budgets={budgets} prs={prs}
        exps={exps} projs={projs} role={role}/>
    </Wrap>
  );

  // ── PROCUREMENT PAGE (Cost Control) ───────────────────────────────────────
  // ── Unified Purchase Orders view (Aerwin-style) — Materials POs + Subcontractor
  // WOs in one clean list. Read/launch only: creation stays in the Procurement
  // and Work Order modules so each keeps its own form + features. ──────────────
  if(page==="purchaseorders"&&(role==="Finance"||role==="Manager"||role==="FinanceAssistant"||role==="Accounting")) return(
    <Wrap>
      <FinanceErpBar active="po" go={financeErpGo} counts={financeErpCounts()}/>
      {(()=>{
        const N=v=>Number(v)||0;
        const projName=(id,fallback)=>{const d=wonDeals.find(x=>x.id===id)||completedDeals.find(x=>x.id===id);return d?projDisplayName(d):(fallback||"—");};
        // Materials POs — group purchase_requests line items by PO number.
        const poGroups={};
        prs.forEach(p=>{
          if(!p.poNumber) return;
          const k=p.poNumber;
          if(!poGroups[k]) poGroups[k]={kind:"po",type:"Materials",no:k,vendor:p.supplier||"—",projectId:p.projectId,date:p.poDate||p.createdDate||"",account:p.accountCode||"",statuses:[],amount:0};
          const g=poGroups[k];
          g.amount+=(N(p.actUnitCost)||N(p.estUnitCost)||N(p.actualCost)||N(p.estimatedCost))*N(p.qty);
          g.statuses.push(p.status);
          if(!g.account&&p.accountCode) g.account=p.accountCode;
          if(p.poDate&&(!g.date||p.poDate<g.date)) g.date=p.poDate;
        });
        const poRows=Object.values(poGroups).filter(g=>!(g.statuses.length&&g.statuses.every(s=>s==="Cancelled"))).map(g=>{
          let status=g.statuses[0]||"Draft";
          if(g.statuses.some(s=>s==="Partially Delivered")) status="Partially Delivered";
          else if(g.statuses.length&&g.statuses.every(s=>s==="Delivered")) status="Delivered";
          else if(g.statuses.some(s=>s==="PO Issued")) status="PO Issued";
          return {...g,status};
        });
        // Subcontractor WOs — one row each.
        const woRows=swos.map(w=>({kind:"wo",type:"Subcontractor",no:w.woNumber||"—",vendor:w.subcontractor||"—",projectId:w.dealId||w.projectId,projectName:w.projectName,date:w.woDate||w.createdDate||"",account:w.accountCode||"",amount:N(w.contractAmount),status:w.status||"Issued"}));
        const rows=[...poRows,...woRows].sort((a,b)=>String(b.date).localeCompare(String(a.date)));
        const totalValue=rows.reduce((s,r)=>s+r.amount,0);
        const openCount=rows.filter(r=>!["Delivered","Cancelled","Completed"].includes(r.status)).length;
        const q=poViewSearch.trim().toLowerCase();
        const visibleRows=rows.filter(r=>(poViewFilter==="all"||(poViewFilter==="po"&&r.kind==="po")||(poViewFilter==="wo"&&r.kind==="wo"))
          &&(!q||String(r.no).toLowerCase().includes(q)||String(r.vendor).toLowerCase().includes(q)||String(projName(r.projectId,r.projectName)).toLowerCase().includes(q)));
        return(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16,flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{fontWeight:700,color:ERP.navy,fontSize:16}}>Purchase Orders</div>
                <div style={{fontSize:12.5,color:ERP.muted,marginTop:2,maxWidth:620}}><strong>Materials POs</strong> are verified by Warehouse and billed in full. <strong>Subcontractor Work Orders</strong> are verified by Operations based on % of project completion — only the verified % reaches Accounts Payable.</div>
              </div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <button onClick={()=>setPage("procurement")} style={{background:ERP.navy,border:"none",borderRadius:7,padding:"9px 16px",fontFamily:"inherit",fontSize:13,color:"#fff",cursor:"pointer",fontWeight:600}}>+ Material PO</button>
                <button onClick={()=>setPage("subconwo")} style={{background:ERP.gold,border:"none",borderRadius:7,padding:"9px 16px",fontFamily:"inherit",fontSize:13,color:ERP.navy,cursor:"pointer",fontWeight:600}}>+ Work Order</button>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(auto-fit,minmax(190px,1fr))",gap:12,marginBottom:20}}>
              <ErpStat label="Total Orders" value={String(rows.length)} foot={poRows.length+" POs · "+woRows.length+" WOs"}/>
              <ErpStat tone="warn" label="Open Orders" value={String(openCount)} foot="awaiting delivery / completion"/>
              <ErpStat label="Purchase Orders" value={fmt(poRows.reduce((s,r)=>s+r.amount,0))} foot="materials value"/>
              <ErpStat tone="purple" label="Work Orders" value={fmt(woRows.reduce((s,r)=>s+r.amount,0))} foot="subcontractor contracts"/>
            </div>
            <ErpCard title="All Orders" desc="Materials Purchase Orders and Subcontractor Work Orders in one list. Click Open to view or edit in its module.">
              <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
                {[["all","All",rows.length],["po","Purchase Orders",poRows.length],["wo","Work Orders",woRows.length]].map(([k,l,n])=>{
                  const on=poViewFilter===k;
                  return(
                    <button key={k} onClick={()=>setPoViewFilter(k)} style={{display:"flex",alignItems:"center",gap:6,background:on?ERP.navy:"#fff",color:on?"#fff":ERP.muted,border:`1px solid ${on?ERP.navy:ERP.line}`,borderRadius:20,padding:"5px 12px",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                      {l}<span style={{background:on?"rgba(255,255,255,.85)":ERP.navyLight,color:ERP.navy,borderRadius:10,padding:"0 7px",fontSize:11,fontWeight:700}}>{n}</span>
                    </button>
                  );
                })}
                <input value={poViewSearch} onChange={e=>setPoViewSearch(e.target.value)} placeholder="Search no., vendor, or project…" style={{marginLeft:"auto",minWidth:180,flex:"0 1 260px",border:`1px solid ${ERP.line}`,borderRadius:7,padding:"7px 12px",fontFamily:"inherit",fontSize:12.5,outline:"none",color:ERP.ink}}/>
              </div>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,minWidth:860}}>
                  <thead><tr>
                    {["No.","Type","Date","Vendor / Subcontractor","Project","Account","Amount","Status","Verification",""].map((h,i)=>(
                      <th key={h+i} style={i===6?erpThNum:erpTh}>{h}</th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {visibleRows.length===0&&<tr><td colSpan={10} style={{...erpTd,textAlign:"center",color:ERP.muted,fontStyle:"italic",padding:26}}>{rows.length===0?"No purchase orders or work orders yet.":"No orders match this filter."}</td></tr>}
                    {visibleRows.map((r,idx)=>{
                      const pay=payables.find(x=>x.poId===r.no||x.poNumber===r.no);
                      const payBal=pay?Math.max(0,(Number(pay.amount)||0)-(Number(pay.paidAmount)||0)):0;
                      const settled=pay&&pay.status==="Paid";
                      const isSub=r.type==="Subcontractor";
                      return(
                      <tr key={r.kind+r.no+idx} onMouseEnter={ev=>ev.currentTarget.style.background="#FAFBFD"} onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{r.no}</td>
                        <td style={{...erpTd,whiteSpace:"nowrap"}}><ErpBadge kind={r.type==="Subcontractor"?"approved":"open"}>{r.type}</ErpBadge></td>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",color:ERP.muted,whiteSpace:"nowrap"}}>{r.date||"—"}</td>
                        <td style={{...erpTd,fontWeight:600,color:ERP.ink,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.vendor}>{r.vendor}</td>
                        <td style={{...erpTd,color:ERP.muted,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{projName(r.projectId,r.projectName)}</td>
                        <td style={{...erpTd,fontVariantNumeric:"tabular-nums",fontSize:11.5,color:r.account?ERP.ink:"#cbd5e1",whiteSpace:"nowrap"}}>{r.account||"—"}</td>
                        <td style={{...erpTdNum,fontWeight:700,color:ERP.navy,whiteSpace:"nowrap"}}>{fmt(r.amount)}</td>
                        <td style={{...erpTd,whiteSpace:"nowrap"}}><ErpBadge kind={erpStatusKind(r.status)}>{r.status}</ErpBadge></td>
                        <td style={{...erpTd,whiteSpace:"nowrap"}}>
                          {!pay
                            ? <span style={{fontSize:11,color:ERP.muted}} title="No payable in the AP ledger yet — issue/deliver the order first">Not in AP</span>
                            : pay.verified
                              ? <ErpBadge kind="paid">{isSub?`${Number(pay.verificationPct||0)}% Verified`:"Verified"}</ErpBadge>
                              : <ErpBadge kind="unpaid">{isSub?"Pending (Ops)":"Pending (WH)"}</ErpBadge>}
                        </td>
                        <td style={{...erpTd,whiteSpace:"nowrap"}}>
                          <div style={{display:"flex",gap:4,justifyContent:"flex-end",alignItems:"center"}}>
                            {pay&&!settled&&!pay.verified&&<button onClick={()=>verifyPayable(pay.id)} title={isSub?"Operations: verify % complete":"Warehouse: verify receipt"} style={{background:ERP.gold,border:"none",borderRadius:6,padding:"5px 10px",fontSize:12,color:ERP.navy,cursor:"pointer",fontWeight:800,fontFamily:"inherit"}}>✓ Verify</button>}
                            {pay&&!settled&&pay.verified&&payBal>0&&!payApproved(pay)&&<span style={{fontSize:11,color:ERP.muted,fontWeight:600}} title="Awaiting Manager / Finance approval before payment">Pending approval</span>}
                            {pay&&!settled&&pay.verified&&payBal>0&&payApproved(pay)&&<button onClick={()=>{setFinTab("payables");setPage("finance");openPayModal(pay);}} style={{background:"#f59e0b",border:"none",borderRadius:6,padding:"5px 12px",fontSize:12,color:"#fff",cursor:"pointer",fontWeight:800,fontFamily:"inherit"}}>Pay</button>}
                            {pay&&settled&&<span style={{fontSize:11,color:ERP.ok,fontWeight:700}}>Paid</span>}
                            <button onClick={()=>setPage(r.kind==="wo"?"subconwo":"procurement")} style={{background:"transparent",border:`1px solid ${ERP.line}`,borderRadius:6,padding:"5px 10px",fontSize:12,fontWeight:600,color:ERP.navy,cursor:"pointer",fontFamily:"inherit"}}>Open</button>
                          </div>
                        </td>
                      </tr>
                      );})}
                    ))}
                  </tbody>
                </table>
              </div>
            </ErpCard>
          </div>
        );
      })()}
    </Wrap>
  );

  if((["Cost Control","Finance","Manager","Operations"].includes(role))&&page==="procurement") return(
    <Wrap>
      <ProcurementView2 costCenterDeals={costCenterDeals} onCreateCostCenter={createCostCenter} onWaiveDp={waiveDp}
        prs={prs} addPR={addPR} updatePR={updatePR} deletePR={deletePR}
        wonDeals={wonDeals} deals={deals} budgets={budgets} session={session} role={role} toastEmit={toastEmit} suppliers={suppliers}
        upPayables={upPayables} payables={payables} sendTelegramNotification={sendTelegramNotification} isSupabaseReady={isSupabaseReady} sbUpsert={sbUpsert} payableToSb={payableToSb} syncPoPayable={syncPoPayable} approvePOs={approvePOs} chartOfAccounts={chartOfAccounts}/>
    </Wrap>
  );

  // Clients directory (Manager, Sales, Finance)
  if(page==="clients") return(
    <Wrap>
      <ClientDirectory deals={deals} session={session} role={role} vvipClients={vvipClients} toggleVvip={toggleVvip} customClients={customClients} isMobile={isMobile}
        clientProfiles={clientProfiles}
        saveClientProfile={saveClientProfileRemote}
        addNewClient={(name)=>{
          if(!name.trim()) return;
          if(GMD_CLIENTS.find(c=>c.name.toLowerCase()===name.trim().toLowerCase())||customClients.find(c=>c.name.toLowerCase()===name.trim().toLowerCase())) return;
          const nc={name:name.trim(),id:"c"+Date.now(),addedBy:session?.name||"",addedAt:today};
          GMD_CLIENTS.push(nc);
          const next=[...customClients,nc];
          setCustomClients(next);
          try{localStorage.setItem(KEYS.customclients,JSON.stringify(next));}catch{}
          if(isSupabaseReady()) sbUpsert('app_settings',{key:'customclients',value:next,updated_at:new Date().toISOString()},'key').catch(()=>{});
        }}
      />
    </Wrap>
  );

  // Accounts management (Manager only)
  if(role==="Manager"&&page==="accounts") return(
    <Wrap>
      <AccountsManager users={users} session={session} onApprove={approveUser} onReject={rejectUser} onDeactivate={deactivateUser} onDelete={deleteUser} onResetPw={resetPw} onCreateUser={createUser} ROLES={ROLES}/>
      {/* Permissions reference — who each role can view/create/edit/delete.
          Lives alongside account management so it's one place to answer
          "what can this person do?" right where you set their role. */}
      {(()=>{
        const open=accountsPermOpen;
        return(
          <div style={{maxWidth:1180,margin:"18px auto 0",padding:isMobile?"0 10px":"0 20px"}}>
            <button onClick={()=>setAccountsPermOpen(o=>!o)}
              style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
              <span>
                <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.1rem",color:"#0f172a"}}>🔐 Role Permissions</span>
                <span style={{display:"block",fontSize:".76rem",color:"#64748b",marginTop:2}}>Who can view, create, edit or delete each record type — mirrors the database security rules.</span>
              </span>
              <span style={{fontSize:".9rem",color:"#64748b",transform:open?"rotate(180deg)":"none",transition:"transform .15s"}}>▾</span>
            </button>
            {open&&<div style={{marginTop:10}}><PermissionsMatrix Wrap={Wrap} isMobile={isMobile} embedded/></div>}
          </div>
        );
      })()}
      {/* Demo Data Loader */}
      {(()=>{
        const demoDealsExist=deals.some(d=>d.id?.startsWith("demo-"));
        const loadDemo=async ()=>{
          if(!(await uiConfirm("Load demo data? This will add sample deals, projects, inventory, checklist tasks, and financials alongside any existing data."))) return;
          // Deals
          upDeals(ds=>{const ids=new Set(ds.map(d=>d.id));return[...ds,...SEED_DEALS.filter(d=>!ids.has(d.id))];});
          // Projects
          Object.entries(SEED_PROJECTS).forEach(([id,p])=>{setProjs(ps=>{const n={...ps,[id]:{...emptyProject(),...ps[id],...p}};persist(KEYS.projects,n);return n;});});
          // Expenses
          upExps(es=>{const ids=new Set(es.map(e=>e.id));return[...es,...SEED_EXP.filter(e=>!ids.has(e.id))];});
          // Inflows
          upInfs(is=>{const ids=new Set(is.map(i=>i.id));return[...is,...SEED_INF.filter(i=>!ids.has(i.id))];});
          // Checklist
          upChecklist(cs=>{const ids=new Set(cs.map(c=>c.id));return[...cs,...SEED_CHECKLIST.filter(c=>!ids.has(c.id))];});
          // Inventory
          upInventory(iv=>{const ids=new Set(iv.map(i=>i.id));return[...iv,...SEED_INVENTORY.filter(i=>!ids.has(i.id))];});
          // DRFs
          upDrfs(ds=>{const ids=new Set(ds.map(d=>d.id));return[...ds,...SEED_DRF.filter(d=>!ids.has(d.id))];});
          toastEmit("✅ Demo data loaded — 10 deals, 4 active projects, 8 inventory items, 10 tasks, 2 DRFs, and sample financials.","success");
        };
        const clearDemo=async ()=>{
          if(!(await uiConfirm("Remove all demo data? This cannot be undone."))) return;
          upDeals(ds=>ds.filter(d=>!d.id?.startsWith("demo-")));
          setProjs(ps=>{const n=Object.fromEntries(Object.entries(ps).filter(([k])=>!k.startsWith("demo-")));persist(KEYS.projects,n);return n;});
          upExps(es=>es.filter(e=>!e.id?.startsWith("demo-")));
          upInfs(is=>is.filter(i=>!i.id?.startsWith("demo-")));
          upChecklist(cs=>cs.filter(c=>!c.id?.startsWith("demo-")));
          upInventory(iv=>iv.filter(i=>!i.id?.startsWith("demo-")));
          upDrfs(ds=>ds.filter(d=>!d.id?.startsWith("demo-")));
          toastEmit("🗑 Demo data removed.","info");
        };
        return(
          <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:14,padding:20,marginTop:24}}>
            <div style={{fontWeight:800,color:"#92400e",fontSize:".95rem",marginBottom:6}}>🧪 Demo Data</div>
            <div style={{fontSize:".78rem",color:"#78350f",marginBottom:14}}>Load realistic sample data across all departments — deals, projects, inventory, financials, checklist tasks, and design requests — to explore the system without affecting real records.</div>
            {demoDealsExist?(
              <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                <span style={{background:"#d1fae5",color:"#065f46",fontSize:".75rem",fontWeight:700,padding:"4px 12px",borderRadius:20}}>✅ Demo data is loaded</span>
                <button onClick={clearDemo} style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:8,padding:"8px 16px",fontFamily:"inherit",fontSize:".8rem",color:"#dc2626",cursor:"pointer",fontWeight:700}}>🗑 Remove Demo Data</button>
              </div>
            ):(
              <button onClick={loadDemo} style={{background:"#f59e0b",border:"none",borderRadius:9,padding:"10px 22px",fontFamily:"inherit",fontWeight:800,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>🧪 Load Demo Data</button>
            )}
          </div>
        );
      })()}
    </Wrap>
  );
  return <Wrap><EmptyState icon="🔍" msg={`No view for ${role}/${page}`}/></Wrap>;
}

// ─── P&L STATEMENT ────────────────────────────────────────────────────────────
function PLStatement({billings,exps,payables=[],wonDeals}){
  const curYear=new Date().getFullYear();
  const[year,setYear]=useState(curYear);
  const[view,setView]=useState("monthly");
  const fmt=v=>"₱"+Math.round(Math.abs(v)).toLocaleString("en-PH");
  const fmtSigned=v=>v===0?"—":(v<0?"-":"")+fmt(v);
  const gpColor=v=>v>0?"#059669":v<0?"#ef4444":"#94a3b8";

  const revByMonth=useMemo(()=>{
    const arr=Array(12).fill(0);
    billings.forEach(b=>{
      if(b.status==="Cancelled") return;
      const d=b.invoiceDate||b.dueDate;
      if(!d) return;
      const dt=new Date(d);
      if(dt.getFullYear()!==year) return;
      arr[dt.getMonth()]+=Number(b.amount||0);
    });
    return arr;
  },[billings,year]);

  const collByMonth=useMemo(()=>{
    const arr=Array(12).fill(0);
    billings.forEach(b=>{
      (b.payments||[]).forEach(p=>{
        if(!p.date||!isCashPayment(p)) return;
        const dt=new Date(p.date);
        if(dt.getFullYear()!==year) return;
        arr[dt.getMonth()]+=Number(p.amount||0);
      });
    });
    return arr;
  },[billings,year]);

  const expByMonth=useMemo(()=>{
    const arr=Array(12).fill(0);
    // AP-ledger basis: legacy expenses not routed to a payable + all payables,
    // so the P&L tab matches the account-code Income Statement.
    exps.forEach(e=>{
      if(e.payableId||e.cvId) return;
      if((e.year||curYear)!==year) return;
      arr[Number(e.month||0)]+=costNet(e);
    });
    (payables||[]).forEach(p=>{
      if(["Cancelled","Void"].includes(p.status)) return;
      const d=new Date(p.invoiceDate||p.createdAt||"");
      if(isNaN(d)||d.getFullYear()!==year) return;
      arr[d.getMonth()]+=costNet(p);
    });
    return arr;
  },[exps,payables,year,curYear]);

  const gpByMonth=revByMonth.map((r,i)=>r-expByMonth[i]);
  const ytdRev=revByMonth.reduce((s,v)=>s+v,0);
  const ytdColl=collByMonth.reduce((s,v)=>s+v,0);
  const ytdExp=expByMonth.reduce((s,v)=>s+v,0);
  const ytdGP=ytdRev-ytdExp;
  const ytdGPPct=ytdRev>0?Math.round(ytdGP/ytdRev*100):0;
  const visMonths=year<curYear?12:new Date().getMonth()+1;

  const deptData=useMemo(()=>{
    const map={};
    billings.forEach(b=>{
      if(b.status==="Cancelled") return;
      const deal=wonDeals.find(d=>d.id===b.dealId);
      const dept=deal?.ceType||"Other";
      if(!map[dept]) map[dept]={dept,rev:0,coll:0,exp:0};
      const d=b.invoiceDate||b.dueDate;
      if(d&&new Date(d).getFullYear()===year) map[dept].rev+=Number(b.amount||0);
      (b.payments||[]).forEach(p=>{
        if(p.date&&isCashPayment(p)&&new Date(p.date).getFullYear()===year) map[dept].coll+=Number(p.amount||0);
      });
    });
    exps.forEach(e=>{
      if((e.year||curYear)!==year) return;
      const deal=wonDeals.find(d=>d.id===(e.projectId||e.dealId));
      const dept=deal?.ceType||"Company-wide";
      if(!map[dept]) map[dept]={dept,rev:0,coll:0,exp:0};
      map[dept].exp+=Number(e.amount||0);
    });
    return Object.values(map)
      .map(r=>({...r,gp:r.rev-r.exp,gpPct:r.rev>0?Math.round((r.rev-r.exp)/r.rev*100):0}))
      .sort((a,b)=>b.rev-a.rev);
  },[billings,exps,wonDeals,year,curYear]);

  const th={padding:"10px 10px",fontWeight:700,color:"#475569",fontSize:".78rem",borderBottom:"2px solid #e2e8f0",background:"#f8fafc",whiteSpace:"nowrap"};
  const td=(right=true)=>({padding:"9px 10px",textAlign:right?"right":"left",fontSize:".82rem",whiteSpace:"nowrap"});

  const rows=[
    {label:"Revenue Billed", data:revByMonth, ytd:ytdRev, color:"#3b82f6", bold:false, isGP:false},
    {label:"Collected",      data:collByMonth,ytd:ytdColl,color:"#10b981", bold:false, isGP:false},
    {label:"Expenses",       data:expByMonth, ytd:ytdExp, color:"#ef4444", bold:false, isGP:false},
    {label:"Gross Profit",   data:gpByMonth,  ytd:ytdGP,  color:gpColor(ytdGP), bold:true, isGP:true},
  ];

  return(
    <div>
      {/* Controls row */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20,flexWrap:"wrap"}}>
        <div style={{display:"flex",gap:0,background:"#f1f5f9",borderRadius:8,padding:2}}>
          {[["monthly","📅 Monthly"],["dept","🏷 By Project Type"]].map(([v,l])=>(
            <button key={v} onClick={()=>setView(v)} style={{padding:"6px 14px",borderRadius:6,border:"none",cursor:"pointer",fontSize:".8rem",fontWeight:600,background:view===v?"#fff":"transparent",color:view===v?"#0f172a":"#64748b",boxShadow:view===v?"0 1px 3px rgba(0,0,0,.1)":"none",transition:"all .15s"}}>{l}</button>
          ))}
        </div>
        <select value={year} onChange={e=>setYear(Number(e.target.value))} style={{padding:"6px 12px",borderRadius:8,border:"1px solid #e2e8f0",fontSize:".85rem",color:"#0f172a",background:"#fff"}}>
          {[curYear-2,curYear-1,curYear].map(y=><option key={y} value={y}>{y}</option>)}
        </select>
        <div style={{marginLeft:window.innerWidth<768?undefined:"auto",width:"100%",display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10}}>
          <KPI label="YTD Revenue"   value={fmtPHP(ytdRev)}  color="#3b82f6"/>
          <KPI label="YTD Collected" value={fmtPHP(ytdColl)} color="#10b981"/>
          <KPI label="YTD Expenses"  value={fmtPHP(ytdExp)}  color="#ef4444"/>
          <KPI label="Gross Profit"  value={fmtPHP(ytdGP)}   color={gpColor(ytdGP)} sub={ytdRev>0?ytdGPPct+"%":"-"}/>
        </div>
      </div>

      {/* Monthly Table */}
      {view==="monthly"&&(
        <div style={{overflowX:"auto",borderRadius:12,border:"1px solid #e2e8f0"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr>
                <th style={{...th,textAlign:"left",minWidth:130}}>Metric</th>
                {["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].slice(0,visMonths).map(m=>(
                  <th key={m} style={{...th,textAlign:"right",minWidth:90}}>{m}</th>
                ))}
                <th style={{...th,textAlign:"right",background:"#e2e8f0",minWidth:100}}>YTD</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row,ri)=>(
                <tr key={row.label} style={{borderBottom:"1px solid #f1f5f9",background:row.bold?"#f0fdf4":"#fff"}}>
                  <td style={{...td(false),fontWeight:row.bold?700:500,color:row.bold?"#0f172a":"#374151"}}>{row.label}</td>
                  {row.data.slice(0,visMonths).map((v,i)=>(
                    <td key={i} style={{...td(),fontWeight:row.bold?700:400,color:row.isGP?gpColor(v):(v>0?row.color:"#cbd5e1")}}>
                      {v===0?"—":fmt(v)}
                    </td>
                  ))}
                  <td style={{...td(),fontWeight:800,color:row.isGP?gpColor(row.ytd):row.color,background:"#f1f5f9"}}>
                    {row.ytd===0?"—":fmtSigned(row.ytd)}
                  </td>
                </tr>
              ))}
              <tr style={{borderTop:"2px solid #e2e8f0",background:"#f8fafc"}}>
                <td style={{...td(false),fontWeight:600,color:"#64748b",fontSize:".76rem"}}>GP Margin %</td>
                {revByMonth.slice(0,visMonths).map((r,i)=>{
                  const g=gpByMonth[i];const p=r>0?Math.round(g/r*100):null;
                  return <td key={i} style={{...td(),fontSize:".76rem",color:p==null?"#cbd5e1":gpColor(g)}}>{p==null?"—":p+"%"}</td>;
                })}
                <td style={{...td(),fontWeight:700,fontSize:".76rem",color:gpColor(ytdGP),background:"#f1f5f9"}}>{ytdRev>0?ytdGPPct+"%":"—"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Department Table */}
      {view==="dept"&&(
        <div style={{borderRadius:12,border:"1px solid #e2e8f0",overflow:"hidden"}}>
          {deptData.length===0
            ?<div style={{padding:40,textAlign:"center",color:"#94a3b8"}}>No financial data for {year}. Revenue populates from billing milestones; expenses from logged costs.</div>
            :(
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead>
                <tr>
                  {["Project Type","Revenue","Collected","Expenses","Gross Profit","GP %"].map((h,i)=>(
                    <th key={h} style={{...th,textAlign:i===0?"left":"right"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {deptData.map(row=>(
                  <tr key={row.dept} style={{borderBottom:"1px solid #f1f5f9"}}>
                    <td style={{...td(false),fontWeight:600,color:"#0f172a"}}>{row.dept}</td>
                    <td style={{...td(),color:"#3b82f6",fontWeight:500}}>{row.rev>0?fmt(row.rev):"—"}</td>
                    <td style={{...td(),color:"#10b981",fontWeight:500}}>{row.coll>0?fmt(row.coll):"—"}</td>
                    <td style={{...td(),color:"#ef4444",fontWeight:500}}>{row.exp>0?fmt(row.exp):"—"}</td>
                    <td style={{...td(),fontWeight:700,color:gpColor(row.gp)}}>{fmtSigned(row.gp)}</td>
                    <td style={{...td(),fontWeight:700,color:gpColor(row.gp)}}>{row.rev>0?row.gpPct+"%":"—"}</td>
                  </tr>
                ))}
                <tr style={{borderTop:"2px solid #e2e8f0",background:"#f1f5f9"}}>
                  <td style={{...td(false),fontWeight:800,color:"#0f172a"}}>TOTAL</td>
                  <td style={{...td(),fontWeight:800,color:"#3b82f6"}}>{ytdRev>0?fmt(ytdRev):"—"}</td>
                  <td style={{...td(),fontWeight:800,color:"#10b981"}}>{ytdColl>0?fmt(ytdColl):"—"}</td>
                  <td style={{...td(),fontWeight:800,color:"#ef4444"}}>{ytdExp>0?fmt(ytdExp):"—"}</td>
                  <td style={{...td(),fontWeight:800,color:gpColor(ytdGP)}}>{fmtSigned(ytdGP)}</td>
                  <td style={{...td(),fontWeight:800,color:gpColor(ytdGP)}}>{ytdRev>0?ytdGPPct+"%":"—"}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

// ─── OPS VIEW ─────────────────────────────────────────────────────────────────
const PM_STAGES=["Design Ongoing","Fabrication Started","Fabrication Ongoing","Fabrication Complete","Mobilization","Installation Started","Installation Ongoing","Installation Complete","Punchlist","Project Closed"];
function OpsUpdateForm({selProj,selProjName,session,addPmUpdate,logActivity,openPmModal}){
  return(
    <div style={{marginBottom:14,display:"flex",gap:8,flexWrap:"wrap"}}>
      {[{type:"General Progress",icon:"📋",color:"#0ea5e9"},{type:"Blocker",icon:"🚨",color:"#ef4444"},{type:"Materials Needed",icon:"📦",color:"#f59e0b"},{type:"Design Request",icon:"🎨",color:"#8b5cf6"}].map(({type,icon,color})=>(
        <button key={type} onClick={()=>openPmModal&&openPmModal({dealId:selProj,dealName:selProjName||selProj,initialType:type})} style={{background:color,border:"none",borderRadius:9,padding:"8px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#fff",cursor:"pointer"}}>
          {icon} {type}
        </button>
      ))}
    </div>
  );
}

// Contract breakdown — original contract + each scope-change addendum, with the
// current (revised) contract total. Approved/Billed/Collected addenda are already
// rolled into deal.value (rollDealContract) and original_value isn't persisted,
// so the original base is derived as (current value − rolled addenda) — correct
// even after a reload, and never double-counting. Reused across Project Cards,
// Billing, Sales, and Pipeline so every team sees the same numbers.
function ContractBreakdown({deal,addenda,deals,compact}){
  if(!deal) return null;
  const ROLLED=s=>["Approved","Billed","Collected"].includes(s);
  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:0});
  // Two kinds of addendum feed the breakdown:
  //  1. Legacy CO records (addenda) — value was folded into deal.value via
  //     rollDealContract, so the original base is (value − rolled COs).
  //  2. Child deals (parentDealId set) — the current model. These are their OWN
  //     deals and are NEVER rolled into the parent's value; they add on top.
  //     A child in a won stage is an approved addendum; otherwise it's pending.
  const coItems=(addenda||[]).filter(a=>(a.dealId||a.projectId)===deal.id&&a.status!=="Rejected");
  const childItems=(deals||[]).filter(d=>d.parentDealId===deal.id&&!isLostStage(d.stage)).map(d=>{
    // Approval is driven by the explicit addendumStatus flag (the single source
    // of truth), NOT by the workflow stage: an approved addendum inherits its
    // parent project's stage — which may not be a "won" stage — so keying the
    // roll-up off the stage alone would under-count. Legacy children saved
    // before this flag existed (addendumStatus null) fall back to the old
    // stage-based rule so nothing changes for them.
    const approved = d.addendumStatus==="Approved" || (d.addendumStatus==null && WON_STAGES.includes(d.stage));
    return {
      id:d.id,title:d.contact||d.client||"Addendum",ceNo:d.ceNo||"",
      value:Math.abs(Number(d.value)||0),
      status:approved?"Approved":(d.addendumStatus==="Pending"?"Pending client approval":d.stage),
      _child:true,_won:approved,
    };
  });
  const items=[...coItems,...childItems];
  if(compact&&!items.length) return null;
  // Legacy COs are already inside deal.value; child deals are additive on top.
  const rolledCoSum=coItems.filter(a=>ROLLED(a.status)).reduce((s,a)=>s+(Number(a.value)||0),0);
  const childApprovedSum=childItems.filter(a=>a._won).reduce((s,a)=>s+(Number(a.value)||0),0);
  const dealVal=Number(deal.value)||0;
  const original=Math.round((dealVal-rolledCoSum)*100)/100;
  const current=Math.round((dealVal+childApprovedSum)*100)/100;
  const isRolled=a=>a._child?a._won:ROLLED(a.status);
  const pendingSum=items.filter(a=>!isRolled(a)).reduce((s,a)=>s+(Number(a.value)||0),0);
  const approvedCount=items.filter(a=>isRolled(a)).length;
  const row=(key,label,sub,amt,clr,strong)=>(
    <div key={key} style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",gap:10,padding:"5px 0",borderTop:strong?"1.5px solid #e2e8f0":"1px solid #f1f5f9"}}>
      <div style={{minWidth:0}}>
        <div style={{fontSize:strong?".82rem":".78rem",fontWeight:strong?800:600,color:"#0f172a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{label}</div>
        {sub&&<div style={{fontSize:".65rem",color:"#94a3b8"}}>{sub}</div>}
      </div>
      <div style={{fontFamily:"'IBM Plex Mono',monospace",fontWeight:strong?800:700,fontSize:strong?".85rem":".8rem",color:clr||"#0f172a",whiteSpace:"nowrap"}}>{amt}</div>
    </div>
  );
  return(
    <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"10px 14px"}}>
      <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",fontWeight:700,marginBottom:2}}>Contract Breakdown</div>
      {row("orig","Initial Contract"+(deal.ceNo?" · "+deal.ceNo:""),null,peso(original),"#0f172a",false)}
      {items.map(a=>row(a.id,(isRolled(a)?"":"⏳ ")+(a._child?"Addendum · ":"")+(a.title||"Addendum"),(a.ceNo?a.ceNo+" · ":"")+(a.status||"")+(isRolled(a)?"":" — not yet in contract"),peso(Number(a.value)||0),isRolled(a)?"#059669":"#d97706",false))}
      {row("cur","Total Contract",approvedCount>0?`initial + ${approvedCount} approved addend${approvedCount===1?"um":"a"}`:null,peso(current),"#10b981",true)}
      {pendingSum>0&&row("pot","If pending approved","+"+peso(pendingSum)+" awaiting client approval",peso(current+pendingSum),"#d97706",false)}
    </div>
  );
}
function OpsView({sendTelegramNotification,projs,projList,deals,selProj,setSelProj,opsTab,setOpsTab,proj,projDeal,upProj,overallProg,costOf,marginOf,openDesignEdit,swatches,swQ,openAddSwatch,openEditSwatch,delSwatch,exps,openAddExp,openEditExp,delExp,clientName,matModal,setMatModal,matForm,setMatForm,editMat,setEditMat,saveMat,addPmUpdate,addAddendum,updateAddendumStatus,session,Wrap,addenda,addAddendum2,updateAddendum,deleteAddendum,pcards,setPage,logActivity,drfs,jos,budgets,role,onCloseProject,openPmModal}){
  const BUDGET_ONLY_OPS=["Operations","ProjectMover"];
  const qsBudgetTotalOps=id=>{const b=(budgets||{})[id]||{};return["Materials","Labor","Overhead","Subcon"].reduce((s,k)=>s+Number(b[k]||0),0);};
  const opsAmt=(d)=>{if(BUDGET_ONLY_OPS.includes(role)){const t=qsBudgetTotalOps(d?.id);return t>0?fmt(t)+" (budget)":"Budget Pending";}return fmt(d?.value);};
  const uid2=()=>String(Date.now());
  // Hoisted to component top (not inside the closeout tab's IIFE) so the hook
  // order is stable across opsTab switches — a conditional hook would change
  // OpsView's hook count and crash on tab change.
  const[rptForm,setRptForm]=useState(emptyProjectReport("progress"));
  if(!selProj) return(
    <Wrap>
      <SecHead title="Active Projects" sub="Click any project to update stages, materials, and team"/>
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(2,1fr)",gap:12}}>
        {projList.map(d=>{
          const p=projs[d.id]; if(!p) return null; const prog=overallProg(p);
          const pending=swatches.filter(s=>s.projectId===d.id&&s.status==="To Buy").length;
          const m=marginOf(p,d);
          const pc=pcards[d.id];
          const projDone=pc?DEPT_ORDER.every(dept=>pc.departments?.[dept]?.done):false;
          if(projDone) return null; // Completed projects filtered out below
          return(
            <Card key={d.id} onClick={()=>{setSelProj(d.id);setOpsTab("progress");}} accent={p?.currentStage==="Delivery"?"#6ee7b7":undefined}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div><div style={{fontWeight:700,color:"#0f172a"}}>{d.client}</div><div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{d.product}</div></div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap",justifyContent:"flex-end"}}><Badge label={p?.currentStage||"Active"} color={PROD_CLR[p?.currentStage]||"#94a3b8"}/>{p?.currentStage==="Design"&&<Badge label={p.design?.status||"Briefing"} color={DS_CLR[p.design?.status||"Briefing"]}/>}</div>
              </div>
              <div style={{display:"flex",gap:2,marginBottom:8}}>
                {["Design","Fabrication","QC","Delivery"].map((s,i)=>{const done=["Design","Fabrication","QC","Delivery"].indexOf(p.currentStage)>i,cur=p.currentStage===s;return <div key={s} style={{flex:1,height:4,borderRadius:2,background:done||cur?PROD_CLR[s]:"#e2e8f0",opacity:cur?.6:1}}/>;  })}
              </div>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}><ProgBar pct={prog} color={PROD_CLR[p.currentStage]} h={6}/><span style={{fontWeight:700,color:PROD_CLR[p.currentStage],minWidth:36,fontSize:".85rem"}}>{prog}%</span></div>
              <div style={{display:"flex",gap:12,fontSize:".73rem",color:"#64748b",flexWrap:"wrap"}}>
                <span style={{color:BUDGET_ONLY_OPS.includes(role)?"#8b5cf6":"#10b981",fontWeight:600}}>{opsAmt(d)}</span>
                {!BUDGET_ONLY_OPS.includes(role)&&<span>Margin: <strong style={{color:m>=20?"#059669":"#f59e0b"}}>{m}%</strong></span>}
                <span>Team: {p.team.length}</span>
                {pending>0&&<span style={{color:"#ef4444"}}>🛒 {pending} to buy</span>}
                {(()=>{const ps=p?.stageDates?.Punchlist?.s;if(!ps)return null;const el=bizDaysElapsed(ps);const left=5-el;const over=left<0;return<span style={{color:over?"#ef4444":left<=1?"#f59e0b":"#f97316",fontWeight:700}}>📋 Punchlist {over?`${Math.abs(left)}d OVERDUE`:`${left}d left`}</span>})()}
              </div>
              {(()=>{
                const tgt=pc?.targetEndDate;if(!tgt) return null;
                const dLeft=Math.ceil((new Date(tgt)-new Date())/(1000*60*60*24));
                const over=dLeft<0;const warn=dLeft<=7&&!over;
                return(
                  <div style={{marginTop:6,display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:".7rem",color:"#94a3b8"}}>Due {tgt}</span>
                    <span style={{fontSize:".7rem",fontWeight:700,padding:"2px 8px",borderRadius:20,
                      background:over?"#fef2f2":warn?"#fffbeb":"#f0fdf4",
                      color:over?"#dc2626":warn?"#d97706":"#059669",
                      border:`1px solid ${over?"#fecaca":warn?"#fde68a":"#6ee7b7"}`}}>
                      {over?`⚠ ${Math.abs(dLeft)}d OVERDUE`:warn?`⏰ ${dLeft}d left`:`✓ ${dLeft}d left`}
                    </span>
                  </div>
                );
              })()}
            </Card>
          );
        })}
        {/* ── Completed Projects ── */}
        {(()=>{
          const completed=projList.filter(d=>{
            const pc=pcards[d.id];
            return pc&&DEPT_ORDER.every(dept=>pc.departments?.[dept]?.done);
          });
          if(!completed.length) return null;
          return(
            <div style={{gridColumn:"1/-1",marginTop:12}}>
              <div style={{fontWeight:700,color:"#94a3b8",fontSize:".78rem",textTransform:"uppercase",letterSpacing:"1px",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                <span style={{width:8,height:8,borderRadius:"50%",background:"#10b981",display:"inline-block"}}/>
                Completed Projects ({completed.length})
              </div>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(2,1fr)",gap:8}}>
                {completed.map(d=>(
                  <div key={d.id} style={{background:"#f0fdf4",borderRadius:10,border:"1.5px solid #6ee7b7",padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",opacity:.8}}>
                    <div>
                      <div style={{fontWeight:700,color:"#059669",fontSize:".85rem"}}>{d.client}</div>
                      <div style={{fontSize:".7rem",color:"#64748b",marginTop:1}}>{d.contact||d.ceNo} · {opsAmt(d)}</div>
                    </div>
                    <span style={{background:"#059669",color:"#fff",fontSize:".68rem",fontWeight:800,padding:"3px 10px",borderRadius:20}}>✅ DONE</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}
        {projList.length===0&&<div style={{gridColumn:"1/-1"}}><EmptyState icon="⚙" msg="No active projects. Mark a deal as Won in the Pipeline to create a project."/></div>}
      </div>
    </Wrap>
  );

  // Scope changes / addenda are owned by Sales (a linked child deal via
  // "+ Add New Deal -> Link to Parent Deal"), not Operations — so Ops has no
  // Addenda tab. The single parent project card carries the added scope.
  const tabs=[["progress","📊 Progress"],["team","👥 Team"],["materials","📦 Materials"],["swatches","🛒 Swatchboard"],["costs","💰 Costs"],["updates","📝 PM Updates"],["closeout","✅ Close-Out"]];
  return(
    <Wrap>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
        <Btn variant="ghost" small onClick={()=>setSelProj(null)}>← Back</Btn>
        <div style={{flex:1}}>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.05rem"}}>{projDeal?.client} — {projDeal?.product}</div>
          <div style={{fontSize:".74rem",color:"#64748b",marginTop:2}}>{projDeal?.contact} · Delivery: {proj?.stageDates?.Delivery?.e||"TBD"} · <span style={{color:PAY_CLR[projDeal?.paymentStatus]}}>{projDeal?.paymentStatus}</span></div>
        </div>
        <Badge label={proj?.currentStage} color={PROD_CLR[proj?.currentStage||"Design"]}/>
        <span style={{fontWeight:800,color:BUDGET_ONLY_OPS.includes(role)?"#8b5cf6":"#10b981"}}>{opsAmt(projDeal)}</span>
        {projDeal?.salesRepoLink&&<a href={projDeal.salesRepoLink} target="_blank" rel="noreferrer" style={{display:"flex",alignItems:"center",gap:5,padding:"6px 12px",background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:8,color:"#3b82f6",textDecoration:"none",fontWeight:700,fontSize:".78rem",whiteSpace:"nowrap"}}>📁 Sales Repo</a>}
      </div>
      <div style={{display:"flex",gap:2,borderBottom:"1.5px solid #e2e8f0",marginBottom:18}}>
        {tabs.map(([k,l])=>(
          <button key={k} onClick={()=>setOpsTab(k)} style={{background:"transparent",border:"none",borderBottom:`2.5px solid ${opsTab===k?"#f97316":"transparent"}`,padding:"8px 14px",fontFamily:"inherit",fontWeight:opsTab===k?700:400,fontSize:".82rem",color:opsTab===k?"#f97316":"#64748b",cursor:"pointer",marginBottom:-1.5,whiteSpace:"nowrap"}}>{l}</button>
        ))}
      </div>

      {opsTab==="progress"&&(
        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:12}}>
          {(()=>{
            const drf=(drfs||[]).find(d=>d.dealId===selProj);
            const jo=(jos||[]).find(j=>j.dealId===selProj);
            const pcard=pcards?.[selProj];
            const hasBrief=drf||jo?.scopeNotes||jo?.specialInstructions||jo?.location||projDeal?.salesRepoLink||pcard?.scopeNotes||pcard?.specialInstructions||pcard?.commsLink;
            if(!hasBrief) return null;
            return(
              <div style={{gridColumn:"1/-1",background:"#fff",borderRadius:12,border:"1.5px solid #a5b4fc",padding:"16px 18px",marginBottom:4}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
                  <span style={{fontWeight:800,color:"#4f46e5",fontSize:".9rem"}}>📋 Project Brief & Handoff</span>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    {projDeal?.salesRepoLink&&<a href={projDeal.salesRepoLink} target="_blank" rel="noreferrer" style={{display:"inline-flex",alignItems:"center",gap:4,padding:"5px 11px",background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:7,color:"#3b82f6",textDecoration:"none",fontWeight:700,fontSize:".74rem"}}>📁 Sales Repo</a>}
                    {drf?.approvedLink&&<a href={drf.approvedLink} target="_blank" rel="noreferrer" style={{display:"inline-flex",alignItems:"center",gap:4,padding:"5px 11px",background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:7,color:"#059669",textDecoration:"none",fontWeight:700,fontSize:".74rem"}}>✅ Approved Files</a>}
                  </div>
                </div>
                {drf&&(
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10,marginBottom:10}}>
                    {drf.size&&(<div><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Size / Dimensions</div><div style={{fontWeight:600,color:"#0f172a",fontSize:".84rem"}}>{drf.size}</div></div>)}
                    {drf.designer&&(<div><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Assigned Designer</div><div style={{fontWeight:600,color:"#0f172a",fontSize:".84rem"}}>{drf.designer}</div></div>)}
                    {drf.designDeadline&&(<div><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Design Deadline</div><div style={{fontWeight:600,color:"#dc2626",fontSize:".84rem"}}>{drf.designDeadline}</div></div>)}
                    {drf.description&&(<div style={{gridColumn:"1/-1"}}><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Description / Scope</div><div style={{color:"#334155",fontSize:".83rem",whiteSpace:"pre-wrap",lineHeight:1.5}}><Linkify text={drf.description}/></div></div>)}
                    {(drf.accessories||[]).filter(Boolean).length>0&&(<div style={{gridColumn:"1/-1"}}><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>Accessories / Components</div><div style={{display:"flex",flexWrap:"wrap",gap:5}}>{drf.accessories.filter(Boolean).map((a,i)=><span key={i} style={{background:"#e0e7ff",color:"#4338ca",borderRadius:5,padding:"2px 9px",fontSize:".74rem",fontWeight:600}}>{a}</span>)}</div></div>)}
                    {(drf.refLinks||[]).filter(Boolean).length>0&&(<div style={{gridColumn:"1/-1"}}><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>Reference Links</div><div style={{display:"flex",flexWrap:"wrap",gap:8}}>{drf.refLinks.filter(Boolean).map((r,i)=><a key={i} href={r} target="_blank" rel="noreferrer" style={{color:"#6366f1",fontSize:".76rem",fontWeight:600,textDecoration:"none"}}>🔗 Ref {i+1}</a>)}</div></div>)}
                  </div>
                )}
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10,borderTop:drf?"1px solid #e2e8f0":"none",paddingTop:drf?10:0}}>
                  {(pcards?.[selProj]?.scopeNotes||jo?.scopeNotes)&&(<div style={{gridColumn:"1/-1"}}><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Scope of Work</div><div style={{color:"#334155",fontSize:".83rem",whiteSpace:"pre-wrap",lineHeight:1.5}}>{pcards?.[selProj]?.scopeNotes||jo?.scopeNotes}</div></div>)}
                  {(pcards?.[selProj]?.specialInstructions||jo?.specialInstructions)&&(<div style={{gridColumn:"1/-1"}}><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Special Instructions</div><div style={{color:"#dc2626",fontSize:".83rem",fontWeight:600,whiteSpace:"pre-wrap"}}>{pcards?.[selProj]?.specialInstructions||jo?.specialInstructions}</div></div>)}
                  {jo?.location&&(<div><div style={{fontSize:".68rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Site Location</div><div style={{color:"#334155",fontSize:".83rem"}}>{jo.location}</div></div>)}
                </div>
              </div>
            );
          })()}
          {["Design","Fabrication","QC","Delivery"].map((s,i)=>{
            const done=["Design","Fabrication","QC","Delivery"].indexOf(proj.currentStage)>i;
            const cur=proj.currentStage===s; const locked=["Design","Fabrication","QC","Delivery"].indexOf(proj.currentStage)<i;
            const c=PROD_CLR[s]; const pct=proj.progress[s]||0;
            return(
              <Card key={s} accent={cur?c:undefined}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <span style={{fontWeight:700,color:cur?c:done?"#94a3b8":"#cbd5e1",fontSize:".92rem"}}>{s}</span>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:".72rem",color:done?"#059669":cur?c:"#94a3b8"}}>{done?"✓ Done":cur?"In progress":"Pending"}</span>
                    {cur&&pct===100&&i<3&&<Btn small onClick={()=>{const nextStage=["Design","Fabrication","QC","Delivery"][i+1];upProj(selProj,p=>({...p,currentStage:nextStage,stageDates:{...p.stageDates,[nextStage]:{...p.stageDates?.[nextStage],s:p.stageDates?.[nextStage]?.s||today},[s]:{...p.stageDates?.[s],e:p.stageDates?.[s]?.e||today}}}));}}>→ Next Stage</Btn>}
                  </div>
                </div>
                <input type="range" min={0} max={100} value={pct} disabled={locked||done} onChange={e=>upProj(selProj,p=>({...p,progress:{...p.progress,[s]:Number(e.target.value)}}))} style={{width:"100%",accentColor:c,marginBottom:6,cursor:locked||done?"not-allowed":"pointer"}}/>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:".72rem",color:"#94a3b8"}}>
                  <span>{proj.stageDates?.[s]?.s||"—"} → {proj.stageDates?.[s]?.e||"—"}</span>
                  <span style={{color:c,fontWeight:700}}>{pct}%</span>
                </div>
              </Card>
            );
          })}
          <div style={{gridColumn:"1/-1"}}>
            <Fld label="Project Notes">
              <Inp rows={3} value={proj.notes||""} onChange={e=>upProj(selProj,p=>({...p,notes:e.target.value}))} placeholder="Add notes for the team…"/>
            </Fld>
          </div>
          {projDeal?.stage==='11 · Punchlist'&&(()=>{
            const punchStart = proj?.stageDates?.Punchlist?.s;
            const elapsed = bizDaysElapsed(punchStart);
            const remaining = bizDaysRemaining(punchStart);
            const breached = remaining < 0;
            const urgent = remaining <= 1 && remaining >= 0;
            return(
              <div style={{gridColumn:"1/-1"}}>
                <Card accent={breached?"#ef4444":urgent?"#f59e0b":"#f97316"}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <span style={{fontWeight:800,color:breached?"#ef4444":urgent?"#f59e0b":"#f97316",fontSize:".9rem"}}>
                      {breached?"⚠️ PUNCHLIST SLA BREACHED":"🔔 Punchlist SLA Timer"}
                    </span>
                    <span style={{fontSize:".75rem",background:breached?"#fef2f2":urgent?"#fffbeb":"#fff7ed",color:breached?"#ef4444":urgent?"#f59e0b":"#f97316",padding:"3px 8px",borderRadius:20,fontWeight:700}}>
                      {breached?`${Math.abs(remaining)} day${Math.abs(remaining)!==1?"s":""} OVERDUE`:remaining===0?"Due today":`${remaining} day${remaining!==1?"s":""} left`}
                    </span>
                  </div>
                  <div style={{fontSize:".78rem",color:"#475569",marginBottom:8}}>5 business-day resolution SLA · PM owns sign-off</div>
                  {punchStart?(
                    <div style={{fontSize:".75rem",color:"#64748b"}}>Started: {punchStart} · Elapsed: {elapsed} business day{elapsed!==1?"s":""}</div>
                  ):(
                    <div style={{fontSize:".78rem",color:"#f59e0b",fontWeight:600}}>⚠️ Set punchlist start date in stage dates to activate SLA timer</div>
                  )}
                </Card>
              </div>
            );
          })()}
        </div>
      )}

      {opsTab==="team"&&(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:20}}>
          <Fld label={`Production Team (${proj.team.length} assigned)`}>
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:16}}>
              {proj.team.map(m=>(
                <div key={m} style={{background:"#fff7ed",border:"1.5px solid #fed7aa",borderRadius:8,padding:"6px 12px",display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:24,height:24,borderRadius:"50%",background:`hsl(${m.charCodeAt(0)*17%360},45%,55%)`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:".72rem",color:"#fff",flexShrink:0}}>{m[0]}</div>
                  <span style={{fontSize:".82rem",fontWeight:600}}>{m}</span>
                  <button onClick={()=>upProj(selProj,p=>({...p,team:p.team.filter(x=>x!==m)}))} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".8rem",padding:0}}>✕</button>
                </div>
              ))}
              {proj.team.length===0&&<span style={{fontSize:".8rem",color:"#94a3b8"}}>No team assigned yet.</span>}
            </div>
          </Fld>
          <Fld label="Add / Remove Members">
            <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
              {PROD_MEMBERS.map(m=>(
                <button key={m} onClick={()=>upProj(selProj,p=>({...p,team:p.team.includes(m)?p.team.filter(x=>x!==m):[...p.team,m]}))} style={{padding:"6px 13px",border:`1.5px solid ${proj.team.includes(m)?"#f97316":"#e2e8f0"}`,borderRadius:20,background:proj.team.includes(m)?"#fff7ed":"#fff",color:proj.team.includes(m)?"#f97316":"#64748b",fontWeight:proj.team.includes(m)?700:400,cursor:"pointer",fontSize:".8rem",fontFamily:"inherit"}}>
                  {proj.team.includes(m)?"✓ ":""}{m}
                </button>
              ))}
            </div>
          </Fld>
        </div>
      )}

      {opsTab==="materials"&&(<>
        <SecHead title={`Materials (${proj.materials.filter(m=>!m.received).length} pending)`} action={<Btn onClick={()=>{setMatForm({name:"",qty:"",unit:"pcs",cost:"",received:false});setEditMat(null);setMatModal(true);}}>+ Add Material</Btn>}/>
        {proj.materials.map(m=>(
          <Card key={m.id} accent={m.received?"#6ee7b7":undefined}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
              <div style={{display:"flex",alignItems:"center",gap:12,flex:1}}>
                <div onClick={()=>upProj(selProj,p=>({...p,materials:p.materials.map(x=>x.id===m.id?{...x,received:!x.received}:x)}))} style={{width:22,height:22,borderRadius:5,border:`2px solid ${m.received?"#10b981":"#cbd5e1"}`,background:m.received?"#10b981":"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {m.received&&<span style={{color:"#fff",fontSize:".7rem",fontWeight:900}}>✓</span>}
                </div>
                <div>
                  <div style={{fontWeight:600,color:m.received?"#94a3b8":"#0f172a",textDecoration:m.received?"line-through":"none"}}>{m.name}</div>
                  <div style={{fontSize:".73rem",color:"#94a3b8",marginTop:2}}>{m.qty} {m.unit}</div>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
                <span style={{fontWeight:700,color:"#f59e0b",fontSize:".95rem"}}>{fmt(m.cost)}</span>
                <Badge label={m.received?"Received":"Pending"} color={m.received?"#10b981":"#ef4444"}/>
                <Btn small variant="ghost" onClick={()=>{setMatForm({...m});setEditMat(m.id);setMatModal(true);}}>✏ Edit</Btn>
                <Btn small variant="danger" onClick={()=>upProj(selProj,p=>({...p,materials:p.materials.filter(x=>x.id!==m.id)}))}>Delete</Btn>
              </div>
            </div>
          </Card>
        ))}
        {proj.materials.length===0&&<EmptyState icon="📦" msg="No materials added yet. Add the first one above."/>}
        <Modal open={matModal} onClose={()=>setMatModal(false)} title={editMat?"Edit Material":"Add Material"}>
          <Fld label="Material Name" required><Inp value={matForm.name} onChange={e=>setMatForm(p=>({...p,name:e.target.value}))} placeholder="e.g. Steel angle bars"/></Fld>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:12}}>
            <Fld label="Quantity"><Inp type="number" value={matForm.qty} onChange={e=>setMatForm(p=>({...p,qty:e.target.value}))}/></Fld>
            <Fld label="Unit"><Sel value={matForm.unit} onChange={e=>setMatForm(p=>({...p,unit:e.target.value}))}>{MAT_UNITS.map(u=><option key={u}>{u}</option>)}</Sel></Fld>
          </div>
          <Fld label="Total Cost (₱)"><Inp type="number" value={matForm.cost} onChange={e=>setMatForm(p=>({...p,cost:e.target.value}))}/></Fld>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
            <div onClick={()=>setMatForm(p=>({...p,received:!p.received}))} style={{width:20,height:20,borderRadius:5,border:`2px solid ${matForm.received?"#10b981":"#cbd5e1"}`,background:matForm.received?"#10b981":"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {matForm.received&&<span style={{color:"#fff",fontSize:".65rem",fontWeight:900}}>✓</span>}
            </div>
            <span style={{fontSize:".84rem",color:"#64748b"}}>Already received</span>
          </div>
          <div style={{display:"flex",gap:10}}><Btn full onClick={saveMat}>{editMat?"Save Changes":"Add Material"}</Btn><Btn variant="ghost" onClick={()=>setMatModal(false)}>Cancel</Btn></div>
        </Modal>
      </>)}

      {opsTab==="swatches"&&(()=>{
        const ps=swatches.filter(s=>s.projectId===selProj);
        return(
          <>
            <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:".82rem",color:"#64748b"}}>{ps.filter(s=>s.status==="To Buy").length} to buy · {ps.filter(s=>s.status==="Ordered").length} ordered · {ps.filter(s=>s.status==="Received").length} received</div>
              <div style={{display:"flex",gap:8}}>
                <Btn small variant="accent" onClick={()=>openAddSwatch(selProj,"Design")}>+ Design adds</Btn>
                <Btn small onClick={()=>openAddSwatch(selProj,"Ops")}>+ Ops adds</Btn>
              </div>
            </div>
            {ps.map(sw=>(
              <Card key={sw.id} accent={SW_CLR[sw.status]}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
                      <Badge label={sw.status} color={SW_CLR[sw.status]}/>
                      <Badge label={sw.category} color="#64748b"/>
                      <Badge label={`Added by ${sw.addedBy}`} color={sw.addedBy==="Design"?"#8b5cf6":"#f97316"}/>
                    </div>
                    <div style={{fontWeight:700,color:"#0f172a",textDecoration:sw.status==="Received"?"line-through":"none"}}>{sw.name}</div>
                    <div style={{fontSize:".75rem",color:"#64748b",marginTop:3}}>{sw.qty} {sw.unit} · {sw.supplier||"No supplier"}</div>
                    {sw.notes&&<div style={{fontSize:".73rem",color:"#94a3b8",marginTop:3,fontStyle:"italic"}}>{sw.notes}</div>}
                    {sw.swatchLink&&<a href={sw.swatchLink} target="_blank" rel="noreferrer" style={{fontSize:".72rem",color:"#3b82f6",marginTop:3,display:"block"}}>🔗 Reference</a>}
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{fontWeight:700,color:"#f59e0b"}}>{sw.estCost?fmt(sw.estCost):"—"}</div>
                    <div style={{marginTop:8}}>
                      <select value={sw.status} onChange={e=>swQ(sw.id,e.target.value)} style={{border:`1.5px solid ${SW_CLR[sw.status]}`,borderRadius:8,padding:"5px 9px",fontFamily:"inherit",fontSize:".78rem",color:SW_CLR[sw.status],fontWeight:700,background:SW_CLR[sw.status]+"12",cursor:"pointer",marginBottom:6,width:"100%"}}>
                        {SWATCH_STATUS.map(s=><option key={s} style={{color:"#0f172a",background:"#fff",fontWeight:400}}>{s}</option>)}
                      </select>
                    </div>
                    <div style={{display:"flex",gap:6,justifyContent:"flex-end"}}>
                      <Btn small variant="ghost" onClick={()=>openEditSwatch(sw)}>✏ Edit</Btn>
                      <Btn small variant="danger" onClick={()=>delSwatch(sw.id)}>Delete</Btn>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
            {ps.length===0&&<EmptyState icon="🛒" msg="No swatch items yet. Design and Ops can both add items."/>}
          </>
        );
      })()}

      {opsTab==="costs"&&(()=>{
        const p=proj; const d=projDeal;
        const projExpList=exps.filter(e=>e.projectId===selProj);
        const totalOps=costOf(p);
        const profit=d.value-totalOps;
        const margin=d.value>0?Math.round(profit/d.value*100):0;
        return(
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <div>
              <Card>
                <div style={{fontWeight:700,color:"#0f172a",marginBottom:14}}>Cost Breakdown</div>
                {[["Materials",(p.materials||[]).reduce((s,m)=>s+m.cost,0),"#f59e0b"],["Labor",p.laborCost||0,"#8b5cf6"],["Overhead",p.overhead||0,"#3b82f6"],["Total",totalOps,"#ef4444"]].map(([l,v,c],i)=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:i<3?"1px solid #f1f5f9":"none",fontSize:".87rem"}}>
                    <span style={{color:"#64748b",fontWeight:i===3?700:400}}>{l}</span>
                    <span style={{fontWeight:700,color:c}}>{fmt(v)}</span>
                  </div>
                ))}
                <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginTop:14}}>
                  {!BUDGET_ONLY_OPS.includes(role)&&<div style={{display:"flex",justifyContent:"space-between",marginBottom:6,fontSize:".85rem"}}><span style={{color:"#64748b"}}>Contract Value</span><span style={{color:"#10b981",fontWeight:700}}>{fmt(d.value)}</span></div>}
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontWeight:700}}>Gross Margin</span>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.5rem",color:margin>=20?"#059669":"#f59e0b"}}>{margin}%</div>
                      <div style={{fontSize:".7rem",color:"#94a3b8"}}>{fmt(profit)} profit</div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div>
              <SecHead title="Project Expenses" action={<Btn small onClick={()=>openAddExp(selProj)}>+ Add</Btn>}/>
              {projExpList.map(e=>(
                <Card key={e.id}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div><Badge label={e.category} color="#64748b"/><div style={{fontWeight:600,color:"#0f172a",marginTop:4,fontSize:".85rem"}}>{e.note}</div><div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2}}>{MONTHS[e.month]}</div>{e.receipt&&<a href={e.receipt} target="_blank" rel="noreferrer" style={{fontSize:".7rem",color:"#3b82f6",display:"block",marginTop:2}}>📎 Receipt</a>}</div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontWeight:700,color:"#ef4444"}}>{fmt(e.amount)}</div>
                      <div style={{display:"flex",gap:5,marginTop:6}}><Btn small variant="ghost" onClick={()=>openEditExp(e)}>✏ Edit</Btn><Btn small variant="danger" onClick={()=>delExp(e.id)}>Del</Btn></div>
                    </div>
                  </div>
                </Card>
              ))}
              {projExpList.length===0&&<EmptyState icon="📋" msg="No expenses tagged to this project yet."/>}
            </div>
          </div>
        );
      })()}

      {/* PM UPDATES TAB */}
      {opsTab==="updates"&&(
        <div>
          <OpsUpdateForm selProj={selProj} selProjName={projDeal?.client||selProj} session={session} addPmUpdate={addPmUpdate} logActivity={logActivity} openPmModal={openPmModal}/>
          {(proj.pmUpdates||[]).length===0&&<EmptyState icon="📝" msg="No PM updates yet. Use the buttons above to log progress, blockers, or requests."/>}
          {(proj.pmUpdates||[]).map(u=>{
            const uType=u.type||"General Progress";
            const uColor=PM_TYPE_COLOR[uType]||"#0ea5e9";
            const uIcon=PM_TYPE_ICON[uType]||"📋";
            const isBlocker=uType==="Blocker";
            const cleared=u.blockerStatus==="Cleared";
            const canClear=!["Sales","Finance"].includes(role);
            return(
              <Card key={u.id||u.date}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6,flexWrap:"wrap"}}>
                  <span style={{background:uColor,color:"#fff",borderRadius:20,padding:"2px 10px",fontSize:".68rem",fontWeight:700,fontFamily:"'IBM Plex Mono',monospace"}}>{uIcon} {uType}</span>
                  {isBlocker&&<span style={{background:cleared?"#dcfce7":"#fef2f2",color:cleared?"#15803d":"#dc2626",border:`1px solid ${cleared?"#86efac":"#fca5a5"}`,borderRadius:20,padding:"2px 10px",fontSize:".65rem",fontWeight:700,fontFamily:"'IBM Plex Mono',monospace"}}>{cleared?"✓ Cleared":"⚠ Open"}</span>}
                  {u.stage&&<span style={{fontSize:".65rem",color:"#64748b",background:"#f1f5f9",borderRadius:12,padding:"2px 8px"}}>{u.stage}{u.pct?" · "+u.pct+"%":""}</span>}
                </div>
                <div style={{fontSize:".88rem",color:"#0f172a",lineHeight:1.6,marginBottom:isBlocker?8:0}}>{u.note||u.text||""}</div>
                {isBlocker&&(u.blockerDesc||u.decisionMaker||u.actionPlan)&&(
                  <div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"8px 10px",marginBottom:6,fontSize:".78rem"}}>
                    {u.blockerDesc&&<div style={{marginBottom:4}}><b>Blocker:</b> {u.blockerDesc}</div>}
                    {u.decisionMaker&&<div style={{marginBottom:4,color:"#dc2626"}}><b>Decision from:</b> {u.decisionMaker}</div>}
                    {u.actionPlan&&<div><b>Action plan:</b> {u.actionPlan}</div>}
                  </div>
                )}
                {u.nextSteps&&<div style={{fontSize:".78rem",color:"#475569",marginTop:4}}><b>Next:</b> {u.nextSteps}</div>}
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:6,flexWrap:"wrap",gap:6}}>
                  <div style={{fontSize:".72rem",color:"#94a3b8"}}>{u.by} · {u.date}{u.time&&` at ${u.time}`}</div>
                  {isBlocker&&!cleared&&canClear&&(
                    <button onClick={()=>upProj(selProj,p=>({...p,pmUpdates:(p.pmUpdates||[]).map(x=>x.id===u.id?{...x,blockerStatus:"Cleared",clearedBy:session?.name,clearedOn:today}:x)}))} style={{background:"#dcfce7",border:"1px solid #86efac",borderRadius:6,padding:"3px 10px",fontSize:".68rem",color:"#15803d",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✓ Clear Blocker</button>
                  )}
                </div>
              </Card>
            );
          })}
        </div>
      )}

      {opsTab==="closeout"&&(()=>{
        const warranty=proj?.warranty||{active:false,type:"30",startDate:"",endDate:"",notes:""};
        const reports=proj?.reports||[];
        const progRpt=latestReport(proj,"progress");
        const instRpt=latestReport(proj,"installation");
        const hasProgress=progressReportOnFile(proj);
        const hasInstall=installationReportOnFile(proj);
        const satisfied=!!proj?.clientSatisfied;
        const submitReport=(kind)=>{
          const f=rptForm.kind===kind?rptForm:emptyProjectReport(kind);
          if(kind==="progress"&&(Number(f.pctComplete)||0)<90){toastEmit("Progress Report must be at least 90% completion","warning");return;}
          const rec={...emptyProjectReport(kind),...f,kind,id:uid(),submittedBy:session?.name||"",submittedAt:new Date().toISOString(),status:"Submitted"};
          upProj(selProj,p=>({...p,reports:[...(p.reports||[]),rec]}));
          logActivity&&logActivity(selProj,"Report Submitted",`${kind==="progress"?"Progress":"Installation"} Report (${rec.pctComplete}%) for ${projDeal?.client}`,session?.name);
          const rmsg=`📄 <b>${kind==="progress"?"Progress":"Installation"} Report Filed</b>\nProject: <b>${projDeal?.contact||projDeal?.client||"?"}</b>${projDeal?.ceNo?`\nCE: ${projDeal.ceNo}`:""}\nCompletion: ${rec.pctComplete}%\nBy: ${session?.name||"PM"}\n\n${kind==="progress"?"💰 Finance: progress billing may proceed.":"💰 Finance: forwarded to Sales for client-satisfaction check before final billing."}`;
          sendTelegramNotification("management",rmsg);sendTelegramNotification(kind==="progress"?"finance":"sales",rmsg);
          setRptForm(emptyProjectReport(kind==="progress"?"installation":"progress"));
          toastEmit(`${kind==="progress"?"Progress":"Installation"} Report filed`,"success");
        };
        const verifyReport=(id)=>{
          upProj(selProj,p=>({...p,reports:(p.reports||[]).map(r=>r.id===id?{...r,status:"Verified",verifiedBy:session?.name||"",verifiedAt:new Date().toISOString()}:r)}));
          toastEmit("Report verified","success");
        };
        const wEnd=warranty.startDate?(()=>{const d=new Date(warranty.startDate);d.setDate(d.getDate()+Number(warranty.type||30));return d.toISOString().slice(0,10);})():"";
        const wExpired=wEnd&&wEnd<today;
        const wActive=warranty.active&&wEnd&&wEnd>=today;
        const dealStage=projDeal?.stage||"";
        const isClosedOut=dealStage==="12 · Close-Out";
        const stageIdx=WON_STAGES.indexOf(dealStage);
        return(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* ── Pipeline Stage ── */}
            <Card accent={isClosedOut?"#059669":"#f59e0b"}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:isClosedOut?0:12}}>
                <div>
                  <div style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>📌 Pipeline Stage</div>
                  <div style={{fontSize:".78rem",color:"#64748b",marginTop:2}}>Current: <strong style={{color:isClosedOut?"#059669":"#f59e0b"}}>{dealStage||"—"}</strong></div>
                </div>
                {isClosedOut&&<span style={{background:"#dcfce7",color:"#059669",borderRadius:20,padding:"3px 14px",fontSize:".78rem",fontWeight:800}}>✅ CLOSED</span>}
              </div>
              {!isClosedOut&&onCloseProject&&(
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  <button onClick={()=>{
                    onCloseProject(selProj,"12 · Close-Out");
                    toastEmit("Project moved to Close-Out","success");
                  }} style={{flex:1,background:"#059669",border:"none",borderRadius:9,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>
                    🔒 Mark as Project Close-Out (Stage 12)
                  </button>
                </div>
              )}
            </Card>
            {/* ── Billing Documents (Progress + Installation Reports) — Policy §2.2/§2.3 ── */}
            <Card accent={hasInstall?"#059669":"#3b82f6"}>
              <div style={{fontWeight:800,color:"#0f172a",fontSize:".92rem",marginBottom:4}}>📄 Billing Documents</div>
              <div style={{fontSize:".75rem",color:"#64748b",marginBottom:12}}>A Progress Report (≥90%) unlocks progress billing; an Installation Report triggers final billing.</div>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10,marginBottom:12}}>
                {[{k:"progress",label:"Progress Report (≥90%)",rpt:progRpt,ok:hasProgress},{k:"installation",label:"Installation Report",rpt:instRpt,ok:hasInstall}].map(({k,label,rpt,ok})=>(
                  <div key={k} style={{border:"1px solid #e2e8f0",borderRadius:10,padding:"10px 12px",background:"#f8fafc"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                      <span style={{fontSize:".8rem",fontWeight:700,color:"#334155"}}>{label}</span>
                      {rpt?<span style={{fontSize:".68rem",fontWeight:700,padding:"2px 8px",borderRadius:20,background:REPORT_STATUS_CLR[rpt.status]+"22",color:REPORT_STATUS_CLR[rpt.status]}}>{rpt.status} · {rpt.pctComplete}%</span>:<span style={{fontSize:".68rem",color:"#94a3b8"}}>Not filed</span>}
                    </div>
                    {rpt?(
                      <div style={{fontSize:".72rem",color:"#64748b"}}>
                        <div>By {rpt.submittedBy||"—"}{rpt.submittedAt?` · ${String(rpt.submittedAt).slice(0,10)}`:""}</div>
                        {rpt.scopeNote&&<div style={{marginTop:2}}>{rpt.scopeNote}</div>}
                        {rpt.photosLink&&<a href={rpt.photosLink} target="_blank" rel="noopener noreferrer" style={{color:"#3b82f6"}}>Photos ↗</a>}
                        {rpt.status!=="Verified"&&(role==="Sales"||role==="Manager")&&<button onClick={()=>verifyReport(rpt.id)} style={{marginLeft:8,background:"none",border:"none",color:"#059669",cursor:"pointer",fontSize:".72rem",fontWeight:700,padding:0}}>✓ Verify</button>}
                      </div>
                    ):(
                      <div style={{fontSize:".7rem",color:ok?"#059669":"#94a3b8"}}>{ok?"On file":"Awaiting submission"}</div>
                    )}
                  </div>
                ))}
              </div>
              <div style={{background:"#fff",border:"1px dashed #cbd5e1",borderRadius:10,padding:"10px 12px"}}>
                <div style={{display:"flex",gap:8,marginBottom:8,flexWrap:"wrap"}}>
                  {REPORT_KINDS.map(rk=>(
                    <button key={rk.k} onClick={()=>setRptForm(f=>({...emptyProjectReport(rk.k),...(f.kind===rk.k?f:{}),kind:rk.k}))} style={{background:rptForm.kind===rk.k?"#1e293b":"#fff",color:rptForm.kind===rk.k?"#fff":"#475569",border:"1px solid #cbd5e1",borderRadius:7,padding:"4px 12px",fontFamily:"inherit",fontSize:".74rem",fontWeight:700,cursor:"pointer"}}>{rk.icon} {rk.label}</button>
                  ))}
                </div>
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"90px 1fr",gap:8,marginBottom:8}}>
                  <Fld label="% Complete"><Inp type="number" value={rptForm.pctComplete} onChange={e=>setRptForm(f=>({...f,pctComplete:e.target.value}))}/></Fld>
                  <Fld label="Photos Link"><Inp type="url" value={rptForm.photosLink} onChange={e=>setRptForm(f=>({...f,photosLink:e.target.value}))} placeholder="Drive link to photos"/></Fld>
                </div>
                <Fld label="Scope / Notes"><Inp value={rptForm.scopeNote} onChange={e=>setRptForm(f=>({...f,scopeNote:e.target.value}))} placeholder="% of scope completed, remarks"/></Fld>
                <div style={{marginTop:8}}><Btn onClick={()=>submitReport(rptForm.kind)}>📤 File {rptForm.kind==="progress"?"Progress":"Installation"} Report</Btn></div>
              </div>
            </Card>

            {/* ── Client Satisfaction (Sales verifies before COC) — Policy §2.3 ── */}
            <Card accent={satisfied?"#059669":"#94a3b8"}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <span style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>🤝 Client Satisfaction (Sales)</span>
                {satisfied&&<span style={{background:"#dcfce7",color:"#059669",borderRadius:20,padding:"3px 10px",fontSize:".72rem",fontWeight:700}}>✓ VERIFIED</span>}
              </div>
              {!hasInstall&&!satisfied&&<div style={{fontSize:".74rem",color:"#94a3b8",marginBottom:8}}>Awaiting Installation Report before Sales verifies satisfaction.</div>}
              {satisfied?(
                <div style={{fontSize:".8rem",color:"#475569"}}>{proj?.satisfactionNote||"Client satisfaction confirmed."}</div>
              ):(
                <div>
                  <Fld label="Verification Note"><Inp value={proj?.satisfactionNote||""} onChange={e=>upProj(selProj,p=>({...p,satisfactionNote:e.target.value}))} placeholder="Client confirmed satisfaction / no outstanding issues"/></Fld>
                  <div style={{marginTop:8}}>
                    <Btn disabled={!hasInstall||!(role==="Sales"||role==="Manager")} onClick={()=>{
                      if(!hasInstall){toastEmit("Installation Report required first","warning");return;}
                      upProj(selProj,p=>({...p,clientSatisfied:true}));
                      logActivity&&logActivity(selProj,"Satisfaction Verified",`Sales verified client satisfaction for ${projDeal?.client}`,session?.name);
                      toastEmit("Client satisfaction verified — Sales may prepare the COC","success");
                    }}>✓ Verify Client Satisfaction</Btn>
                  </div>
                  {!(role==="Sales"||role==="Manager")&&<div style={{fontSize:".7rem",color:"#94a3b8",marginTop:6}}>Only Sales verifies client satisfaction.</div>}
                </div>
              )}
            </Card>

            <Card accent={proj?.cocCreated?"#059669":"#f59e0b"}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <span style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>📋 Certificate of Completion (COC)</span>
                {proj?.cocCreated&&<span style={{background:"#dcfce7",color:"#059669",borderRadius:20,padding:"3px 10px",fontSize:".72rem",fontWeight:700}}>✓ ISSUED</span>}
              </div>
              {proj?.cocCreated?(
                <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10,fontSize:".82rem"}}>
                  <div><span style={{color:"#94a3b8"}}>Date Issued: </span><strong>{proj.cocDate||"—"}</strong></div>
                  <div><span style={{color:"#94a3b8"}}>Link: </span>{proj.cocLink?<a href={proj.cocLink} target="_blank" rel="noopener noreferrer" style={{color:"#3b82f6"}}>Open COC ↗</a>:<span style={{color:"#94a3b8"}}>—</span>}</div>
                </div>
              ):(
                <div>
                  <div style={{fontSize:".78rem",color:"#f59e0b",fontWeight:600,marginBottom:10}}>⚠️ COC not yet issued. Finance cannot finalize billing until COC is confirmed.</div>
                  {(!hasInstall||!satisfied)&&(
                    <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
                      <span style={{fontSize:".7rem",fontWeight:600,padding:"3px 9px",borderRadius:20,border:"1px solid",borderColor:hasInstall?"#6ee7b7":"#fecaca",background:hasInstall?"#f0fdf4":"#fef2f2",color:hasInstall?"#059669":"#b91c1c"}}>{hasInstall?"✓":"○"} Installation Report</span>
                      <span style={{fontSize:".7rem",fontWeight:600,padding:"3px 9px",borderRadius:20,border:"1px solid",borderColor:satisfied?"#6ee7b7":"#fecaca",background:satisfied?"#f0fdf4":"#fef2f2",color:satisfied?"#059669":"#b91c1c"}}>{satisfied?"✓":"○"} Client Satisfaction</span>
                    </div>
                  )}
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:8,marginBottom:10}}>
                    <Fld label="COC Date"><Inp type="date" value={proj?.cocDate||""} onChange={e=>upProj(selProj,p=>({...p,cocDate:e.target.value}))}/></Fld>
                    <Fld label="COC Link (optional)"><Inp type="url" value={proj?.cocLink||""} onChange={e=>upProj(selProj,p=>({...p,cocLink:e.target.value}))} placeholder="Google Drive link"/></Fld>
                  </div>
                  <Btn disabled={!hasInstall||!satisfied} onClick={()=>{
                    if(!proj?.cocDate){toastEmit("Set a COC date first","warning");return;}
                    if(!hasInstall){toastEmit("An Installation Report must be on file first (§2.3)","warning");return;}
                    if(!satisfied){toastEmit("Sales must verify client satisfaction first (§2.3)","warning");return;}
                    upProj(selProj,p=>({...p,cocCreated:true}));
                    logActivity&&logActivity(selProj,"COC Issued",`COC issued for ${projDeal?.client}. Finance notified for final billing.`,session?.name);
                    const cocMsg=`📋 <b>Certificate of Completion Issued</b>\nClient: <b>${projDeal?.client||"?"}</b>${projDeal?.ceNo?`\nCE: ${projDeal.ceNo}`:""}\nCOC Date: ${proj?.cocDate||today}\nIssued by: ${session?.name||"Ops"}\n\n💰 Finance: please finalize billing.`;
                    sendTelegramNotification("sales",cocMsg);
                    sendTelegramNotification("ops",cocMsg);
                    sendTelegramNotification("management",cocMsg);
                    toastEmit("COC issued — Finance notified to finalize billing","success");
                  }}>✅ Mark COC as Issued → Notify Finance</Btn>
                </div>
              )}
            </Card>
            <Card accent={wActive?"#059669":wExpired?"#ef4444":"#94a3b8"}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <span style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>🛡 Warranty Period</span>
                {wActive&&<span style={{background:"#dcfce7",color:"#059669",borderRadius:20,padding:"3px 10px",fontSize:".72rem",fontWeight:700}}>ACTIVE · Expires {wEnd}</span>}
                {wExpired&&<span style={{background:"#fef2f2",color:"#ef4444",borderRadius:20,padding:"3px 10px",fontSize:".72rem",fontWeight:700}}>EXPIRED {wEnd}</span>}
                {!warranty.active&&<span style={{background:"#f1f5f9",color:"#94a3b8",borderRadius:20,padding:"3px 10px",fontSize:".72rem",fontWeight:700}}>Not activated</span>}
              </div>
              {!warranty.active?(
                <div>
                  <div style={{fontSize:".78rem",color:"#64748b",marginBottom:10}}>Activate after COC is issued. Period starts from COC date.</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:10}}>
                    <Fld label="Type">
                      <Sel value={warranty.type||"30"} onChange={e=>upProj(selProj,p=>({...p,warranty:{...p.warranty||{},type:e.target.value}}))}>
                        <option value="30">30 days</option><option value="60">60 days</option><option value="90">90 days</option>
                      </Sel>
                    </Fld>
                    <Fld label="Start Date"><Inp type="date" value={warranty.startDate||proj?.cocDate||""} onChange={e=>upProj(selProj,p=>({...p,warranty:{...p.warranty||{},startDate:e.target.value}}))}/></Fld>
                    <Fld label="Notes"><Inp value={warranty.notes||""} onChange={e=>upProj(selProj,p=>({...p,warranty:{...p.warranty||{},notes:e.target.value}}))}/></Fld>
                  </div>
                  <Btn onClick={()=>{
                    const wStart=warranty.startDate||proj?.cocDate||today;
                    const newEnd=(()=>{const d=new Date(wStart);d.setDate(d.getDate()+Number(warranty.type||30));return d.toISOString().slice(0,10);})();
                    upProj(selProj,p=>({...p,warranty:{...p.warranty||{},active:true,startDate:wStart,endDate:newEnd}}));
                    logActivity&&logActivity(selProj,"Warranty Activated",`${warranty.type||"30"}-day warranty for ${projDeal?.client}. Expires ${newEnd}.`,session?.name);
                    toastEmit(`Warranty activated — expires ${newEnd}`,"success");
                  }}>🛡 Activate Warranty</Btn>
                </div>
              ):(
                <div style={{fontSize:".82rem",color:"#475569"}}>
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:8}}>
                    <div><span style={{color:"#94a3b8"}}>Period: </span><strong>{warranty.type||"30"} days</strong></div>
                    <div><span style={{color:"#94a3b8"}}>Started: </span><strong>{warranty.startDate}</strong></div>
                    <div><span style={{color:"#94a3b8"}}>Expires: </span><strong>{wEnd}</strong></div>
                    {warranty.notes&&<div style={{gridColumn:"1/-1"}}><span style={{color:"#94a3b8"}}>Notes: </span>{warranty.notes}</div>}
                  </div>
                  {wExpired&&<div style={{marginTop:10,fontSize:".78rem",color:"#ef4444",fontWeight:600}}>⚠️ Warranty expired. Ensure all defect claims are resolved.</div>}
                </div>
              )}
            </Card>
          </div>
        );
      })()}

    </Wrap>
  );
}

// ─── DESIGN REQUEST FORM (DRF) VIEW ──────────────────────────────────────────
// ─── DESIGN — MY FOLDER (year folders + inline editable dropdowns) ────────────
// Each designer gets a folder of the projects + DRFs assigned to them, split into
// year sub-folders (2026, 2027, …) and sortable by client or due date. Clicking a
// project/DRF opens an inline editable dropdown (status · details · timeline)
// instead of redirecting to the Design Request tab.
function MyFolderView({session,projList,projs,drfs,updateDRF,deleteDRF,upProj,setSelProj,setOpsTab}){
  const me=session?.name||"";
  const head=isHeadDesigner(me);
  // Delete an item from the board. DRFs are removed outright; a project's
  // design card is cleared (its design entry reset) so it drops off every
  // designer's folder — the underlying deal/project itself is untouched.
  const deleteItem=async(it)=>{
    if(it.kind==="drf"){
      if(await uiConfirm(`Delete the design request for “${it.title||it.client}”? This can't be undone.`)) deleteDRF(it.id);
    }else{
      if(await uiConfirm(`Remove the design card for “${it.title||it.client}”? The project stays, but its design tracking is cleared.`)) upProj(it.id,p=>({...p,design:{}}));
    }
  };
  const[sortBy,setSortBy]=useState("client");
  const[openItem,setOpenItem]=useState(null); // `${kind}:${id}`
  const[openCat,setOpenCat]=useState({});     // `${member}:${status}` -> expanded
  // Done / Cancelled are "closed" design statuses. They get their own collapsed
  // sub-folders so they stop inflating the live project count. Works for both
  // project cards (DESIGN_STATUSES) and DRFs (DRF_STATUSES) — both share the
  // Done/Cancelled tokens.
  const isClosedItem=it=>it.status==="Done"||it.status==="Cancelled";
  const mob=window.innerWidth<768;
  const yearOf=(...cands)=>{for(const c of cands){const m=/(\d{4})/.exec(c||"");if(m)return m[1];}return "Undated";};

  const folderFor=(member)=>{
    const projItems=projList.filter(d=>(projs[d.id]?.design?.designer||"")===member).map(d=>({
      kind:"project",id:d.id,client:d.client,
      title:projs[d.id]?.design?.projectTitle||d.product||d.client,
      status:projs[d.id]?.design?.status||"Briefing",
      due:projs[d.id]?.design?.dueDate||"",deal:d,
    }));
    const drfItems=(drfs||[]).filter(x=>(x.designer||"")===member).map(x=>({
      kind:"drf",id:x.id,client:x.client,title:x.projectTitle,status:x.status,due:x.designDeadline||"",drf:x,
    }));
    return {member,items:[...projItems,...drfItems]};
  };
  const members=head?[me,...DESIGN_MEMBERS.filter(m=>m!==me)]:[me];
  const folders=members.map(folderFor);

  const sortItems=(items)=>[...items].sort((a,b)=>{
    if(sortBy==="due"){
      const av=a.due||"9999",bv=b.due||"9999";
      return av.localeCompare(bv);
    }
    return (a.client||"").localeCompare(b.client||"");
  });

  // One collapsible row for a single project/DRF. Reused by the live year
  // sub-folders and by the Done / Cancelled category sub-folders below.
  const ItemRow=(it)=>{
    const isDrf=it.kind==="drf";
    const c=(isDrf?DRF_CLR[it.status]:DS_CLR[it.status])||"#94a3b8";
    const key=`${it.kind}:${it.id}`;
    const open=openItem===key;
    return(
      <div key={key} style={{borderBottom:"1px solid #f8fafc"}}>
        <div onClick={()=>setOpenItem(open?null:key)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",cursor:"pointer",background:open?"#fdf4ff":"#fff"}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{isDrf?"🖌️ ":""}{it.title||it.client}</div>
            <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:1}}>{it.client}{it.due?` · due ${it.due}`:""}</div>
          </div>
          <span style={{marginLeft:12,fontSize:".68rem",fontWeight:700,color:c,background:c+"18",border:`1px solid ${c}44`,borderRadius:20,padding:"2px 9px",whiteSpace:"nowrap"}}>{it.status}</span>
          <span style={{marginLeft:10,color:"#94a3b8",fontSize:".7rem"}}>{open?"▲":"▼"}</span>
        </div>
        {open&&(
          <div style={{background:"#faf5ff",borderTop:"1px solid #e9d5ff",padding:"14px 18px"}}>
            {/* Standardized data card — same Category · Client ·
                Location · Size block as the DRF list, so a project
                reads consistently wherever it appears. For a project
                card the values come from its linked DRF, falling back
                to the deal's brief. */}
            {(()=>{
              const ld=isDrf?it.drf:(drfs||[]).find(r=>r.dealId===it.id);
              const cat=ld?.category||"";
              const client=it.client||it.deal?.client||"";
              const loc=ld?.location||it.deal?.location||"";
              const size=ld?.size||it.deal?.drfSize||"";
              return(
                <div style={{background:"#fff",border:"1px solid #e9d5ff",borderRadius:10,padding:"12px 14px",marginBottom:14}}>
                  <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:"10px 16px"}}>
                    {[["Category",cat],["Client",client],["Location",loc],["Size",size]].map(([l,v])=>(
                      <div key={l}>
                        <div style={{fontSize:".62rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".6px",marginBottom:3}}>{l}</div>
                        <div style={{fontSize:".82rem",color:v?"#0f172a":"#cbd5e1",fontWeight:600}}>{v||"—"}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })()}
            <div style={{display:"grid",gridTemplateColumns:mob?"1fr":"1fr 1fr",gap:14}}>
              {/* Project Status */}
              <div>
                <div style={{fontSize:".65rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>Project Status</div>
                {isDrf
                  ?<select value={it.status} onChange={e=>updateDRF(it.id,{status:e.target.value})}
                     style={{width:"100%",boxSizing:"border-box",border:`1.5px solid ${c}`,borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",color:c,background:c+"12",fontWeight:700,cursor:"pointer"}}>
                     {DRF_STATUSES.map(s=><option key={s} value={s} style={{color:"#0f172a",background:"#fff",fontWeight:400}}>{s}</option>)}
                   </select>
                  :<select value={it.status} onChange={e=>upProj(it.id,p=>({...p,design:{...p.design,status:e.target.value,statusHistory:[...(p.design?.statusHistory||[]),{status:e.target.value,date:todayL,by:session?.name||"Design"}]}}))}
                     style={{width:"100%",boxSizing:"border-box",border:`1.5px solid ${c}`,borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",color:c,background:c+"12",fontWeight:700,cursor:"pointer"}}>
                     {DESIGN_STATUSES.map(s=><option key={s} value={s} style={{color:"#0f172a",background:"#fff",fontWeight:400}}>{s}</option>)}
                   </select>
                }
              </div>
              {/* Timeline / Due Date */}
              <div>
                <div style={{fontSize:".65rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>Timeline / Due Date</div>
                <input type="date" value={it.due||""}
                  onChange={e=>{const v=e.target.value;if(isDrf)updateDRF(it.id,{designDeadline:v});else upProj(it.id,p=>({...p,design:{...p.design,dueDate:v}}));}}
                  style={{width:"100%",boxSizing:"border-box",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a"}}/>
              </div>
              {/* Project Details — editable */}
              <div style={{gridColumn:mob?"auto":"1/-1"}}>
                <div style={{fontSize:".65rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>Project Details</div>
                {isDrf?(
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    <input value={it.drf.projectTitle||""} onChange={e=>updateDRF(it.id,{projectTitle:e.target.value})} placeholder="Project title"
                      style={{width:"100%",boxSizing:"border-box",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a"}}/>
                    <textarea value={it.drf.notes||""} onChange={e=>updateDRF(it.id,{notes:e.target.value})} placeholder="Notes / details" rows={2}
                      style={{width:"100%",boxSizing:"border-box",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",resize:"vertical"}}/>
                  </div>
                ):(
                  <textarea value={projs[it.id]?.design?.notes||""} onChange={e=>upProj(it.id,p=>({...p,design:{...p.design,notes:e.target.value}}))} placeholder="Design notes / details" rows={2}
                    style={{width:"100%",boxSizing:"border-box",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",resize:"vertical"}}/>
                )}
              </div>
            </div>
            <div style={{display:"flex",gap:8,marginTop:12,alignItems:"center"}}>
              {!isDrf&&(
                <button onClick={e=>{e.stopPropagation();setSelProj(it.id);setOpsTab("design");}}
                  style={{background:"#7c3aed",border:"none",borderRadius:8,padding:"7px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".76rem",cursor:"pointer"}}>Open full design →</button>
              )}
              <button onClick={e=>{e.stopPropagation();deleteItem(it);}}
                style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"7px 14px",color:"#dc2626",fontFamily:"inherit",fontWeight:700,fontSize:".76rem",cursor:"pointer"}}>✕ Delete</button>
              <span style={{fontSize:".7rem",color:"#94a3b8"}}>Changes save automatically.</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  // A collapsible category sub-folder (Done / Cancelled), one per member.
  const ClosedCategory=(member,label,emoji,color,catItems)=>{
    if(catItems.length===0) return null;
    const ck=`${member}:${label}`;
    const expanded=!!openCat[ck];
    return(
      <div key={ck}>
        <div onClick={()=>setOpenCat(p=>({...p,[ck]:!expanded}))}
          style={{background:"#f8fafc",borderTop:"1px solid #eef2f7",padding:"7px 16px",display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
          <span style={{fontWeight:800,color,fontSize:".82rem",letterSpacing:".3px"}}>{emoji} {label}</span>
          <span style={{fontSize:".68rem",color:"#94a3b8",fontWeight:600}}>{catItems.length} project{catItems.length!==1?"s":""}</span>
          <span style={{marginLeft:"auto",color:"#94a3b8",fontSize:".7rem"}}>{expanded?"▲ Hide":"▼ Show"}</span>
        </div>
        {expanded&&sortItems(catItems).map(ItemRow)}
      </div>
    );
  };

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:18,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>📁 My Projects</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{head?"Every designer's projects, filed by year — yours first.":"Your assigned projects and design requests, filed by year."}</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:".72rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>Sort</span>
          <select value={sortBy} onChange={e=>setSortBy(e.target.value)}
            style={{border:"1.5px solid #e2e8f0",borderRadius:10,padding:"7px 11px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
            <option value="client">Client (A–Z)</option>
            <option value="due">Due Date</option>
          </select>
        </div>
      </div>

      {folders.map(({member,items})=>{
        const mine=member===me;
        // Live vs closed. Done / Cancelled drop out of the year sub-folders and
        // the header count, and get their own collapsed category sub-folders so
        // "My Projects" reflects active work only.
        const active=items.filter(it=>!isClosedItem(it));
        const doneItems=items.filter(it=>it.status==="Done");
        const cancelledItems=items.filter(it=>it.status==="Cancelled");
        // Split live items into year sub-folders, newest year first (Undated last).
        const years={};
        active.forEach(it=>{const y=yearOf(it.due);(years[y]=years[y]||[]).push(it);});
        const yearKeys=Object.keys(years).sort((a,b)=>{
          if(a==="Undated") return 1; if(b==="Undated") return -1; return b.localeCompare(a);
        });
        return(
          <div key={member} style={{background:"#fff",borderRadius:12,border:`1.5px solid ${mine?"#ec489966":"#e2e8f0"}`,overflow:"hidden",marginBottom:14}}>
            <div style={{background:mine?"#be185d":"#1e293b",padding:"11px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontWeight:700,color:"#fff",fontSize:".9rem"}}>📁 {member}{mine?" (You)":""}</span>
              <span style={{fontSize:".72rem",color:"rgba(255,255,255,.7)",fontWeight:600}}>{active.length} active{(doneItems.length||cancelledItems.length)?` · ${doneItems.length+cancelledItems.length} closed`:""}</span>
            </div>
            {items.length===0
              ? <div style={{padding:"18px 16px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No projects assigned yet.</div>
              : <>
                {active.length===0&&<div style={{padding:"14px 16px",textAlign:"center",color:"#94a3b8",fontSize:".8rem"}}>No active projects — see closed below.</div>}
                {yearKeys.map(yr=>(
                  <div key={yr}>
                    <div style={{background:"#f8fafc",borderBottom:"1px solid #eef2f7",borderTop:"1px solid #eef2f7",padding:"7px 16px",display:"flex",alignItems:"center",gap:8}}>
                      <span style={{fontWeight:800,color:"#475569",fontSize:".82rem",letterSpacing:".3px"}}>🗂 {yr}</span>
                      <span style={{fontSize:".68rem",color:"#94a3b8",fontWeight:600}}>{years[yr].length} project{years[yr].length!==1?"s":""}</span>
                    </div>
                    {sortItems(years[yr]).map(ItemRow)}
                  </div>
                ))}
                {ClosedCategory(member,"Done","✅","#059669",doneItems)}
                {ClosedCategory(member,"Cancelled","🚫","#dc2626",cancelledItems)}
              </>
            }
          </div>
        );
      })}
    </div>
  );
}

function DRFView({drfs,addDRF,updateDRF,deleteDRF,wonDeals,session,role}){
  const[showForm,setShowForm]=useState(false);
  const[editId,setEditId]=useState(null);
  const[form,setForm]=useState(emptyDRF());
  const[filterSt,setFilterSt]=useState("All");
  const[filterDesigner,setFilterDesigner]=useState("All");
  const[query,setQuery]=useState("");
  const mob=window.innerWidth<768;
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));

  const openNew=()=>{setForm({...emptyDRF(),createdBy:session?.name||""});setEditId(null);setShowForm(true);};
  const openEdit=(d)=>{setForm({...d});setEditId(d.id);setShowForm(true);};
  const save=()=>{
    if(!form.projectTitle||!form.client) return;
    if(editId) updateDRF(editId,form); else addDRF({...form,createdBy:session?.name||""});
    setShowForm(false);setEditId(null);
  };
  const setAccessory=(i,v)=>f("accessories",form.accessories.map((a,ai)=>ai===i?v:a));
  const addAccessory=()=>f("accessories",[...form.accessories,""]);
  const removeAccessory=(i)=>f("accessories",form.accessories.filter((_,ai)=>ai!==i));
  const setRef=(i,v)=>f("refLinks",form.refLinks.map((r,ri)=>ri===i?v:r));

  const[expandedId,setExpandedId]=useState(null);
  const q=query.trim().toLowerCase();
  const shown=(drfs||[]).filter(d=>{
    if(filterSt!=="All"&&d.status!==filterSt) return false;
    if(filterDesigner!=="All"){
      if(filterDesigner==="Unassigned"){if(d.designer) return false;}
      else if(d.designer!==filterDesigner) return false;
    }
    if(q){
      const hay=[d.projectTitle,d.client,d.designer,d.drfNo,d.location,d.type,d.category].filter(Boolean).join(" ").toLowerCase();
      if(!hay.includes(q)) return false;
    }
    return true;
  });
  // Head designer (Design Manager) can raise a DRF too — server RLS already
  // permits the Design role to insert design_requests, so this only unhides the
  // button for the design lead rather than granting any new server access.
  const canCreate=["Manager","Sales","Operations","SalesOpsAdmin"].includes(role)||isHeadDesigner(session?.name);
  const canAcknowledge=["Manager","Design"].includes(role);

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Design Request Forms</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>AE submits → Design receives brief → Approved files stored</div>
        </div>
        {canCreate&&<button onClick={openNew} style={{background:"#ec4899",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>+ New DRF</button>}
      </div>

      {/* Search + Designer filter */}
      <div style={{display:"flex",gap:10,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{position:"relative",flex:mob?"1 1 100%":"1 1 260px",minWidth:200}}>
          <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:"#94a3b8",fontSize:".9rem",pointerEvents:"none"}}>🔍</span>
          <input value={query} onChange={e=>setQuery(e.target.value)} placeholder="Search project, client, designer…"
            style={{width:"100%",boxSizing:"border-box",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"9px 12px 9px 34px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a"}}/>
          {query&&<button onClick={()=>setQuery("")} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:".9rem",fontFamily:"inherit"}}>✕</button>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:".72rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>Designer</span>
          <select value={filterDesigner} onChange={e=>setFilterDesigner(e.target.value)}
            style={{border:"1.5px solid #e2e8f0",borderRadius:10,padding:"9px 12px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
            <option value="All">All Designers</option>
            <option value="Unassigned">Unassigned</option>
            {DESIGN_MEMBERS.map(m=><option key={m} value={m}>{m}</option>)}
          </select>
        </div>
      </div>

      {/* Status filter */}
      <div style={{display:"flex",gap:7,marginBottom:16,flexWrap:"wrap"}}>
        {["All",...DRF_STATUSES].map(s=>(
          <button key={s} onClick={()=>setFilterSt(s)} style={{padding:"5px 13px",borderRadius:20,border:`1.5px solid ${filterSt===s?DRF_CLR[s]||"#ec4899":"#e2e8f0"}`,background:filterSt===s?(DRF_CLR[s]||"#ec4899")+"18":"#fff",color:filterSt===s?DRF_CLR[s]||"#ec4899":"#64748b",fontWeight:filterSt===s?700:400,cursor:"pointer",fontFamily:"inherit",fontSize:".78rem"}}>{s}</button>
        ))}
      </div>

      {/* Form */}
      {showForm&&(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:20,marginBottom:18,boxShadow:"0 4px 16px rgba(0,0,0,.08)"}}>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span>{editId?"Edit DRF":"New Design Request Form"}</span>
            {editId&&<span style={{fontSize:".75rem",color:"#94a3b8",fontWeight:400}}>{drfs.find(d=>d.id===editId)?.drfNo}</span>}
          </div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <Fld label="Client" required><Inp value={form.client} onChange={e=>f("client",e.target.value)} placeholder="Client name"/></Fld>
            <Fld label="Location"><Inp value={form.location} onChange={e=>f("location",e.target.value)} placeholder="e.g. SM Megamall Unit 3B"/></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Project Title" required><Inp value={form.projectTitle} onChange={e=>f("projectTitle",e.target.value)} placeholder="e.g. Golf Bag Organizer Rack / Shirts Display"/></Fld></div>
            <Fld label="Type"><Sel value={form.type} onChange={e=>f("type",e.target.value)}>{DRF_TYPES.map(t=><option key={t}>{t}</option>)}</Sel></Fld>
            <Fld label="Project Type" hint="Kiosk / In-line / Event / Other"><Sel value={form.category||""} onChange={e=>f("category",e.target.value)}><option value="">— Select —</option>{DRF_CATEGORIES.map(t=><option key={t}>{t}</option>)}</Sel></Fld>
            <Fld label="Size / Dimensions"><Inp value={form.size} onChange={e=>f("size",e.target.value)} placeholder="e.g. W1200 x H1800 x D600mm"/></Fld>
            <Fld label="Maximum Height"><Inp value={form.maxHeight||""} onChange={e=>f("maxHeight",e.target.value)} placeholder="e.g. 2400mm"/></Fld>
            <Fld label="Platform"><Sel value={form.platform||""} onChange={e=>f("platform",e.target.value)}><option value="">— Select —</option><option>With Platform</option><option>Without Platform</option></Sel></Fld>
            <Fld label="Ideal Finishes"><Inp value={form.finishes||""} onChange={e=>f("finishes",e.target.value)} placeholder="e.g. Matte laminate, powder-coated steel"/></Fld>
            <Fld label="Brand Guideline Link"><Inp type="url" value={form.brandGuideLink||""} onChange={e=>f("brandGuideLink",e.target.value)} placeholder="https://…"/></Fld>
            <Fld label="Budget (optional)"><Inp value={form.budget||""} onChange={e=>f("budget",e.target.value)} placeholder="e.g. ₱150,000"/></Fld>
            {/* Only the Design lead (Manager/Design) assigns who works the brief —
                Sales/Ops requesting it don't pick the designer. */}
            {canAcknowledge
              ?<Fld label="Assigned Designer"><Sel value={form.designer} onChange={e=>f("designer",e.target.value)}><option value="">— Unassigned —</option>{DESIGN_MEMBERS.map(m=><option key={m}>{m}</option>)}</Sel></Fld>
              :<Fld label="Assigned Designer"><div style={{padding:"8px 12px",borderRadius:8,background:"#f1f5f9",fontSize:".85rem",color:"#94a3b8"}}>{form.designer||"— Design lead will assign —"}</div></Fld>
            }
            <Fld label="Design Deadline"><Inp type="date" value={form.designDeadline} onChange={e=>f("designDeadline",e.target.value)}/></Fld>
            <Fld label="Linked Deal / Project"><Sel value={form.dealId} onChange={e=>{const d=wonDeals.find(x=>x.id===e.target.value);f("dealId",e.target.value);if(d&&!form.client)f("client",d.client);}}><option value="">— Link to deal (optional) —</option>{[...wonDeals].sort((a,b)=>(a.client||"").localeCompare(b.client||"")).map(d=><option key={d.id} value={d.id}>{d.client}{d.contact?` — ${d.contact}`:""} ({d.stage?.replace(/^\d+ · /,"")||d.stage})</option>)}</Sel></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Description / Details" hint="What needs to be designed? Include dimensions, function, and key specs."><Inp rows={5} value={form.description} onChange={e=>f("description",e.target.value)} placeholder="RE-CREATE: Golf bag organizer rack with shelving&#10;SIZE: Must fit two large golf bags&#10;FUNCTION: Store 2 bags + shoe shelf (3-4 pairs) + drawer cabinet"/></Fld></div>
            {/* Accessories / Components */}
            <div style={{gridColumn:"1/-1"}}>
              <div style={{fontSize:".8rem",fontWeight:700,color:"#64748b",marginBottom:6}}>Accessories / Components</div>
              {form.accessories.map((a,i)=>(
                <div key={i} style={{display:"flex",gap:8,marginBottom:6}}>
                  <Inp value={a} onChange={e=>setAccessory(i,e.target.value)} placeholder={`e.g. Shelving for shoes (3-4 pairs)`}/>
                  <button onClick={()=>removeAccessory(i)} style={{background:"#fef2f2",border:"none",borderRadius:7,padding:"6px 10px",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,flexShrink:0}}>✕</button>
                </div>
              ))}
              <button onClick={addAccessory} style={{background:"#f8fafc",border:"1.5px dashed #e2e8f0",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>+ Add Component</button>
            </div>
            {/* Reference image links */}
            <div style={{gridColumn:"1/-1"}}>
              <div style={{fontSize:".8rem",fontWeight:700,color:"#64748b",marginBottom:6}}>Reference Images (links)</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
                {form.refLinks.map((r,i)=>(
                  <Fld key={i} label={`Ref ${i+1}`}><Inp type="url" value={r} onChange={e=>setRef(i,e.target.value)} placeholder="https://…"/></Fld>
                ))}
              </div>
            </div>
            {/* Approved files link — shown when status is Approved or Done */}
            {(editId&&["Approved","Done"].includes(form.status))&&(
              <div style={{gridColumn:"1/-1"}}><Fld label="✅ Approved Files Link" hint="Google Drive / Dropbox link to final approved drawings"><Inp type="url" value={form.approvedLink} onChange={e=>f("approvedLink",e.target.value)} placeholder="https://drive.google.com/…"/></Fld></div>
            )}
            {editId&&canAcknowledge&&(
              <Fld label="Status"><Sel value={form.status} onChange={e=>f("status",e.target.value)}>{DRF_STATUSES.filter(s=>s!=="Approved"||role==="Manager"||isHeadDesigner(session?.name)).map(s=><option key={s}>{s}</option>)}</Sel></Fld>
            )}
            <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={form.notes} onChange={e=>f("notes",e.target.value)} placeholder="Any additional notes, brand guidelines, restrictions…"/></Fld></div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:14}}>
            <button onClick={save} disabled={!form.projectTitle||!form.client}
              style={{background:form.projectTitle&&form.client?"#ec4899":"#e2e8f0",border:"none",borderRadius:10,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:form.projectTitle&&form.client?"#fff":"#94a3b8",cursor:form.projectTitle&&form.client?"pointer":"not-allowed"}}>
              {editId?"Update DRF":"Submit DRF"}
            </button>
            <button onClick={()=>{setShowForm(false);setEditId(null);}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"10px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {/* DRF Table */}
      {shown.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8",fontSize:".84rem"}}>{(q||filterSt!=="All"||filterDesigner!=="All")?"No design requests match your search / filters.":"No design requests yet."}</div>}
      {shown.length>0&&(
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
          <div style={{overflowX:mob?"visible":"auto"}}>
          {/* Table header — hidden on mobile (cards carry their own labels) */}
          {!mob&&(
          <div style={{display:"grid",gridTemplateColumns:"72px 110px 1fr 140px 130px 96px 36px",gap:0,background:"#f8fafc",borderBottom:"1.5px solid #e2e8f0",padding:"8px 16px",alignItems:"center",minWidth:640}}>
            {["DRF #","Status","Project","Client","Designer","Due",""].map((h,i)=>(
              <div key={i} style={{fontSize:".6rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".7px",color:"#94a3b8",paddingRight:8}}>{h}</div>
            ))}
          </div>
          )}
          {/* Rows */}
          {shown.map((drf,idx)=>{
            const isExpanded=expandedId===drf.id;
            const isNew=drf.status==="New";
            const statusClr=DRF_CLR[drf.status]||"#94a3b8";
            return(
              <div key={drf.id} style={{borderBottom:idx<shown.length-1?"1px solid #f1f5f9":"none"}}>
                {/* Summary row — click to expand. Mobile uses a wrapping card
                    layout; desktop keeps the fixed-width scrolling grid. */}
                {mob?(
                <div onClick={()=>setExpandedId(isExpanded?null:drf.id)}
                  style={{display:"flex",flexDirection:"column",gap:6,padding:"12px 16px",cursor:"pointer",background:isNew?"#fff5f5":isExpanded?"#fdf4ff":"#fff",transition:"background .12s"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                    <span style={{fontWeight:700,color:"#ec4899",fontSize:".74rem"}}>{drf.drfNo}</span>
                    <span style={{fontSize:".65rem",fontWeight:700,color:statusClr,background:statusClr+"18",border:`1px solid ${statusClr}33`,borderRadius:20,padding:"2px 8px",whiteSpace:"nowrap"}}>{drf.status}</span>
                    <span style={{marginLeft:"auto",color:"#94a3b8",fontSize:".7rem"}}>{isExpanded?"▲":"▼"}</span>
                  </div>
                  <div style={{fontWeight:600,color:"#0f172a",fontSize:".9rem",lineHeight:1.3,wordBreak:"break-word"}}>
                    {drf.projectTitle}
                    {drf.type&&<span style={{marginLeft:6,fontSize:".68rem",color:"#94a3b8",fontWeight:400}}>{drf.type}</span>}
                  </div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:"2px 14px",fontSize:".76rem",color:"#475569"}}>
                    <span><span style={{color:"#94a3b8"}}>Client: </span>{drf.client||"—"}</span>
                    <span><span style={{color:"#94a3b8"}}>Designer: </span>{drf.designer||<span style={{color:"#cbd5e1"}}>Unassigned</span>}</span>
                    <span style={{color:drf.designDeadline&&new Date(drf.designDeadline)<new Date()?"#ef4444":"#475569",fontWeight:drf.designDeadline&&new Date(drf.designDeadline)<new Date()?700:400}}><span style={{color:"#94a3b8",fontWeight:400}}>Due: </span>{drf.designDeadline||"—"}</span>
                  </div>
                </div>
                ):(
                <div onClick={()=>setExpandedId(isExpanded?null:drf.id)}
                  style={{display:"grid",gridTemplateColumns:"72px 110px 1fr 140px 130px 96px 36px",gap:0,padding:"10px 16px",alignItems:"center",cursor:"pointer",background:isNew?"#fff5f5":isExpanded?"#fdf4ff":"#fff",transition:"background .12s",minWidth:640}}
                  onMouseEnter={e=>{if(!isNew&&!isExpanded)e.currentTarget.style.background="#f8fafc";}}
                  onMouseLeave={e=>{e.currentTarget.style.background=isNew?"#fff5f5":isExpanded?"#fdf4ff":"#fff";}}>
                  <div style={{fontWeight:700,color:"#ec4899",fontSize:".72rem"}}>{drf.drfNo}</div>
                  <div>
                    <span style={{fontSize:".65rem",fontWeight:700,color:statusClr,background:statusClr+"18",border:`1px solid ${statusClr}33`,borderRadius:20,padding:"2px 8px",whiteSpace:"nowrap"}}>{drf.status}</span>
                  </div>
                  <div style={{fontWeight:600,color:"#0f172a",fontSize:".83rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:12}}>
                    {drf.projectTitle}
                    {drf.type&&<span style={{marginLeft:6,fontSize:".65rem",color:"#94a3b8",fontWeight:400}}>{drf.type}</span>}
                  </div>
                  <div style={{fontSize:".78rem",color:"#475569",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{drf.client||"—"}</div>
                  <div style={{fontSize:".78rem",color:"#475569",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{drf.designer||<span style={{color:"#cbd5e1"}}>Unassigned</span>}</div>
                  <div style={{fontSize:".75rem",color:drf.designDeadline&&new Date(drf.designDeadline)<new Date()?"#ef4444":"#64748b",fontWeight:drf.designDeadline&&new Date(drf.designDeadline)<new Date()?700:400}}>{drf.designDeadline||"—"}</div>
                  <div style={{textAlign:"center",color:"#94a3b8",fontSize:".7rem"}}>{isExpanded?"▲":"▼"}</div>
                </div>
                )}

                {/* Expanded detail panel */}
                {isExpanded&&(
                  <div style={{background:"#faf5ff",borderTop:"1px solid #e9d5ff",padding:"14px 18px"}}>
                    {/* Standardized brief summary — the answered Sales form.
                        Always shows the same four fields in the same order so
                        every DRF reads consistently. */}
                    <div style={{background:"#fff",border:"1px solid #e9d5ff",borderRadius:10,padding:"12px 14px",marginBottom:12}}>
                      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:"10px 16px"}}>
                        {[["Category",drf.category],["Client",drf.client],["Location",drf.location],["Size",drf.size]].map(([l,v])=>(
                          <div key={l}>
                            <div style={{fontSize:".62rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".6px",marginBottom:3}}>{l}</div>
                            <div style={{fontSize:".82rem",color:v?"#0f172a":"#cbd5e1",fontWeight:600}}>{v||"—"}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14,marginBottom:12}}>
                      {/* Left: brief details */}
                      <div>
                        {(drf.maxHeight||drf.platform)&&(
                          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                            {drf.maxHeight&&<span style={{fontSize:".72rem",color:"#64748b"}}>↕ Max {drf.maxHeight}</span>}
                            {drf.platform&&<span style={{fontSize:".72rem",color:"#64748b"}}>🧱 {drf.platform}</span>}
                          </div>
                        )}
                        {(drf.finishes||drf.budget)&&(
                          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8,fontSize:".72rem",color:"#64748b"}}>
                            {drf.finishes&&<span>🎨 Finishes: {drf.finishes}</span>}
                            {drf.budget&&<span>💰 Budget: {drf.budget}</span>}
                          </div>
                        )}
                        {drf.brandGuideLink&&<div style={{marginBottom:8}}><a href={drf.brandGuideLink} target="_blank" rel="noreferrer" style={{fontSize:".74rem",color:"#6366f1",fontWeight:600,textDecoration:"none"}}>📘 Brand Guideline →</a></div>}
                        {drf.description&&(
                          <div style={{fontSize:".78rem",color:"#475569",background:"#fff",borderRadius:8,padding:"10px 12px",whiteSpace:"pre-wrap",lineHeight:1.6,border:"1px solid #e9d5ff"}}><Linkify text={drf.description}/></div>
                        )}
                        {drf.accessories?.filter(Boolean).length>0&&(
                          <div style={{marginTop:8}}>
                            <div style={{fontSize:".65rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:4}}>Components</div>
                            {drf.accessories.filter(Boolean).map((a,i)=>(
                              <div key={i} style={{fontSize:".76rem",color:"#475569",display:"flex",gap:6,alignItems:"center",marginBottom:2}}>
                                <span style={{color:"#ec4899",fontWeight:700}}>·</span>{a}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {/* Right: links + meta */}
                      <div>
                        {drf.refLinks?.filter(Boolean).length>0&&(
                          <div style={{marginBottom:8}}>
                            <div style={{fontSize:".65rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:4}}>References</div>
                            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                              {drf.refLinks.filter(Boolean).map((r,i)=>(
                                <a key={i} href={r} target="_blank" rel="noreferrer" style={{fontSize:".74rem",color:"#6366f1",fontWeight:600,textDecoration:"none"}}>🖼 Ref {i+1}</a>
                              ))}
                            </div>
                          </div>
                        )}
                        {drf.approvedLink&&(
                          <div style={{marginBottom:8}}>
                            <a href={drf.approvedLink} target="_blank" rel="noreferrer" style={{fontSize:".78rem",color:"#059669",fontWeight:700}}>✅ View Approved Files →</a>
                          </div>
                        )}
                        {drf.notes&&<div style={{fontSize:".75rem",color:"#92400e",background:"#fffbeb",borderRadius:6,padding:"6px 10px",marginBottom:8,whiteSpace:"pre-wrap"}}>📝 <Linkify text={drf.notes} color="#b45309"/></div>}
                        <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:4}}>Submitted by {drf.createdBy||"—"} · {drf.createdAt}</div>
                      </div>
                    </div>
                    {/* Action buttons */}
                    <div style={{display:"flex",gap:7,flexWrap:"wrap",alignItems:"center"}}>
                      {/* Inline status editing — available at any point after a DRF
                          exists (incl. after acknowledgement), so the design lead can
                          push it to In Progress / For Review / Revision / Approved etc.
                          without opening the full edit form. */}
                      {canAcknowledge&&(
                        <select value={drf.status} onClick={e=>e.stopPropagation()}
                          onChange={e=>{const status=e.target.value;updateDRF(drf.id,{status});}}
                          title="Update status"
                          style={{border:`1.5px solid ${statusClr}`,borderRadius:8,padding:"6px 10px",fontFamily:"inherit",fontSize:".75rem",color:statusClr,background:statusClr+"12",cursor:"pointer",fontWeight:700}}>
                          {DRF_STATUSES.filter(s=>s!=="Approved"||role==="Manager"||isHeadDesigner(session?.name)).map(s=><option key={s} value={s} style={{color:"#0f172a",background:"#fff",fontWeight:400}}>{s}</option>)}
                        </select>
                      )}
                      {canAcknowledge&&(
                        <select value={drf.designer||""} onClick={e=>e.stopPropagation()}
                          onChange={e=>{const designer=e.target.value;updateDRF(drf.id,{designer,status:drf.status==="New"?"Acknowledged":drf.status});}}
                          style={{border:"1.5px solid #ddd6fe",borderRadius:8,padding:"6px 10px",fontFamily:"inherit",fontSize:".75rem",color:"#6d28d9",background:"#faf5ff",cursor:"pointer",fontWeight:700}}>
                          <option value="">— Assign designer —</option>
                          {DESIGN_MEMBERS.map(m=><option key={m} value={m}>{m}</option>)}
                        </select>
                      )}
                      {isNew&&canAcknowledge&&(
                        <button onClick={e=>{e.stopPropagation();updateDRF(drf.id,{status:"Acknowledged"});setExpandedId(null);}}
                          style={{background:"#3b82f6",border:"none",borderRadius:8,padding:"6px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",cursor:"pointer"}}>
                          ✓ Acknowledge
                        </button>
                      )}
                      <button onClick={e=>{e.stopPropagation();openEdit(drf);}} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"6px 14px",fontSize:".75rem",color:"#475569",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>✏ Edit</button>
                      {(role==="Manager"||drf.createdBy===session?.name)&&(
                        <button onClick={async e=>{e.stopPropagation();if((await uiConfirm("Delete this DRF?")))deleteDRF(drf.id);}} style={{background:"#fef2f2",border:"none",borderRadius:8,padding:"6px 14px",fontSize:".75rem",color:"#dc2626",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>✕ Delete</button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── PROCUREMENT VIEW ─────────────────────────────────────────────────────────
function ProcurementView({swatches,projList,clientName,openAddSwatch,openEditSwatch,delSwatch,swQ,Wrap,addMR,wonDeals,session}){
  const sw=swatches||[];
  const toBuy=sw.filter(s=>s.status==="To Buy");
  const ordered=sw.filter(s=>s.status==="Ordered");
  const received=sw.filter(s=>s.status==="Received");
  const approved=sw.filter(s=>s.status==="Client Approved");
  const[filter,setFilter]=useState("All");
  const shown=filter==="All"?sw:sw.filter(s=>s.status===filter);
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:18,flexWrap:"wrap",gap:10}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>🎨 Procurement Swatchboard</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Shared checklist — Design & Ops add, Procurement fulfills</div>
        </div>
        <Btn onClick={()=>openAddSwatch(null,"Design")}>+ Add Item</Btn>
      </div>

      {/* Stats bar */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 20px",marginBottom:16,display:"flex",gap:0,flexWrap:"wrap"}}>
        {[
          {l:"Total Items",     v:sw.length,       c:"#3b82f6"},
          {l:"To Buy",          v:toBuy.length,    c:"#ef4444"},
          {l:"Ordered",         v:ordered.length,  c:"#f59e0b"},
          {l:"Received",        v:received.length, c:"#10b981"},
          {l:"Client Approved", v:approved.length, c:"#059669"},
        ].map(({l,v,c},i)=>(
          <div key={l} style={{flex:1,minWidth:100,paddingLeft:i>0?20:0,borderLeft:i>0?"1px solid #f1f5f9":"none",paddingRight:16}}>
            <div style={{fontWeight:800,fontSize:"1.25rem",color:c,lineHeight:1,marginBottom:3}}>{v}</div>
            <div style={{fontSize:".6rem",textTransform:"uppercase",letterSpacing:".7px",color:"#94a3b8"}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Filter pills */}
      <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
        {["All","To Buy","Ordered","Received","Client Approved"].map(f=>(
          <button key={f} onClick={()=>setFilter(f)} style={{padding:"6px 14px",borderRadius:20,border:`1.5px solid ${filter===f?SW_CLR[f]||"#3b82f6":"#e2e8f0"}`,background:filter===f?(SW_CLR[f]||"#3b82f6")+"18":"#fff",color:filter===f?SW_CLR[f]||"#3b82f6":"#64748b",fontWeight:filter===f?700:400,cursor:"pointer",fontFamily:"inherit",fontSize:".8rem"}}>{f}</button>
        ))}
      </div>
      {shown.map(sw=>(
        <Card key={sw.id} accent={SW_CLR[sw.status]}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
            <div style={{flex:1}}>
              <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",marginBottom:5}}>
                <Badge label={sw.status} color={SW_CLR[sw.status]}/>
                <Badge label={sw.category} color="#64748b"/>
                <Badge label={sw.addedBy==="Design"?"🎨 Design":"⚙ Ops"} color={sw.addedBy==="Design"?"#8b5cf6":"#f97316"}/>
                {sw.projectId&&<Badge label={clientName(sw.projectId)} color="#3b82f6"/>}
              </div>
              <div style={{fontWeight:700,color:"#0f172a",fontSize:".98rem",textDecoration:sw.status==="Client Approved"?"line-through":"none"}}>{sw.name}</div>
              <div style={{fontSize:".75rem",color:"#64748b",marginTop:3}}>{sw.qty} {sw.unit} · {sw.supplier||"No supplier specified"}</div>
              {sw.notes&&<div style={{fontSize:".73rem",color:"#94a3b8",marginTop:3,fontStyle:"italic"}}>{sw.notes}</div>}
              {sw.swatchLink&&<a href={sw.swatchLink} target="_blank" rel="noreferrer" style={{fontSize:".72rem",color:"#3b82f6",display:"block",marginTop:4}}>🔗 View reference</a>}
              {sw.status==="Client Approved"&&sw.clientApprovedBy&&(
                <div style={{fontSize:".72rem",color:"#059669",marginTop:4,fontWeight:600}}>✅ Approved by {sw.clientApprovedBy} · {sw.clientApprovedAt}</div>
              )}
            </div>
            <div style={{flexShrink:0,textAlign:"right"}}>
              <div style={{fontWeight:700,color:"#f59e0b",fontSize:"1rem",marginBottom:8}}>{sw.estCost?fmt(sw.estCost):"—"}</div>
              <select value={sw.status} onChange={e=>swQ(sw.id,e.target.value)} style={{border:`1.5px solid ${SW_CLR[sw.status]}`,borderRadius:8,padding:"6px 10px",fontFamily:"inherit",fontSize:".8rem",color:SW_CLR[sw.status],fontWeight:700,background:SW_CLR[sw.status]+"12",cursor:"pointer",display:"block",marginBottom:8,width:"100%"}}>
                {SWATCH_STATUS.map(s=><option key={s} style={{color:"#0f172a",background:"#fff",fontWeight:400}}>{s}</option>)}
              </select>
              <div style={{display:"flex",gap:6,justifyContent:"flex-end"}}>
                {sw.status==="Client Approved"&&addMR&&(
                  <button onClick={()=>{
                    addMR({
                      projectId: sw.projectId || "",
                      projectName: wonDeals?.find(d=>d.id===sw.projectId)?.client || "",
                      itemName: sw.name,
                      category: sw.category || "Materials",
                      qty: sw.qty || 1,
                      unit: sw.unit || "pcs",
                      estUnitCost: sw.estCost || 0,
                      urgency: "Normal",
                      purpose: `From approved swatch: ${sw.name}`,
                      requestedBy: session?.name || "",
                      notes: sw.notes || "",
                      status: "Submitted",
                    });
                    swQ(sw.id, "MR Submitted");
                  }} style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>
                    → Create MR
                  </button>
                )}
                <Btn small variant="ghost" onClick={()=>openEditSwatch(sw)}>✏ Edit</Btn>
                <Btn small variant="danger" onClick={()=>delSwatch(sw.id)}>Delete</Btn>
              </div>
            </div>
          </div>
        </Card>
      ))}
      {shown.length===0&&<EmptyState icon="🛒" msg={`No ${filter==="All"?"items":filter.toLowerCase()} in the swatchboard yet.`}/>}
    </div>
  );
}



// ─── CHECKLIST VIEW ───────────────────────────────────────────────────────────
function ChecklistView({checklist,projList,deals,clientName,openAddCl,openEditCl,delCl,clStatusQ,clModal,setClModal,clForm,setClForm,editCl,saveCl,clProjF,setClProjF,clTypeF,setClTypeF,clStatF,setClStatF,clDeptF,setClDeptF,role,wonDeals,loadChecklistTemplate,Wrap,users}){
  const f=(k,v)=>setClForm(p=>({...p,[k]:v}));
  const allTypes=["All",...CL_TYPES,"Custom"];
  const isCustom=!CL_TYPES.includes(clForm.type)||clForm.type==="Custom";

  const filtered=checklist
    .filter(c=>clProjF==="all"||c.projectId===clProjF)
    .filter(c=>clTypeF==="All"||(clTypeF==="Custom"?!CL_TYPES.includes(c.type):c.type===clTypeF))
    .filter(c=>clStatF==="All"||c.status===clStatF)
    .filter(c=>clDeptF==="All"||c.dept===clDeptF)
    .sort((a,b)=>{
      const pri={Urgent:0,High:1,Normal:2}; const sta={"To Do":0,"In Progress":1,Done:2};
      return (sta[a.status]-sta[b.status])||( pri[a.priority]-pri[b.priority]);
    });

  const toDo=checklist.filter(c=>c.status==="To Do").length;
  const inProg=checklist.filter(c=>c.status==="In Progress").length;
  const done=checklist.filter(c=>c.status==="Done").length;
  const overdue=checklist.filter(c=>c.dueDate&&c.dueDate<today&&c.status!=="Done").length;

  // group by project for display
  const byProject={};
  filtered.forEach(c=>{
    const key=c.projectId||"__none__";
    if(!byProject[key]) byProject[key]=[];
    byProject[key].push(c);
  });

  const allMembers=(users||[]).filter(u=>u.status==="active").map(u=>u.name).sort();

  return(
    <Wrap>
      <SecHead title="Project Checklist" sub="All departments — Operations, Design, Procurement — add tasks here"/>

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:12,marginBottom:20}}>
        <KPI label="To Do"       value={toDo}   color="#94a3b8"/>
        <KPI label="In Progress" value={inProg}  color="#f59e0b"/>
        <KPI label="Done"        value={done}    color="#10b981"/>
        <KPI label="Overdue"     value={overdue} color={overdue>0?"#ef4444":"#94a3b8"}/>
      </div>

      {/* Overdue alert */}
      {overdue>0&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fca5a5",borderRadius:12,padding:"12px 18px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:"1.2rem"}}>⚠️</span>
          <div style={{fontSize:".85rem",color:"#dc2626",fontWeight:600}}>{overdue} task{overdue>1?"s":""} past due date — check filters to find them</div>
        </div>
      )}

      {/* Filters */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 18px",marginBottom:16}}>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"flex-end"}}>
          <div style={{minWidth:160}}>
            <div style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".8px",marginBottom:5}}>Project</div>
            <select value={clProjF} onChange={e=>setClProjF(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",background:"#fff",cursor:"pointer",width:"100%"}}>
              <option value="all">All Projects</option>
              {[...wonDeals,...deals.filter(d=>!WON_STAGES.includes(d.stage)&&checklist.some(c=>c.projectId===d.id))].map(d=>(
                <option key={d.id} value={d.id}>{d.client}</option>
              ))}
            </select>
          </div>
          <div style={{minWidth:130}}>
            <div style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".8px",marginBottom:5}}>Status</div>
            <select value={clStatF} onChange={e=>setClStatF(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",background:"#fff",cursor:"pointer",width:"100%"}}>
              {["All",...CL_STATUS].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div style={{minWidth:130}}>
            <div style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".8px",marginBottom:5}}>Department</div>
            <select value={clDeptF} onChange={e=>setClDeptF(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",background:"#fff",cursor:"pointer",width:"100%"}}>
              {["All",...CL_DEPT].map(d=><option key={d}>{d}</option>)}
            </select>
          </div>
          <div style={{flex:1}}/>
          <Btn onClick={()=>openAddCl(null,role==="Design"?"Design":role==="Finance"?"Finance":"Operations")}>+ Add Task</Btn>
        </div>
        {/* Type quick filter pills */}
        <div style={{display:"flex",gap:7,marginTop:12,flexWrap:"wrap"}}>
          {["All",...CL_TYPES].map(t=>{
            const ic=TYPE_ICON[t]||"";
            const cl=TYPE_CLR[t]||"#64748b";
            return(
              <button key={t} onClick={()=>setClTypeF(t)} style={{padding:"4px 12px",borderRadius:20,border:`1.5px solid ${clTypeF===t?cl:"#e2e8f0"}`,background:clTypeF===t?cl+"18":"#fff",color:clTypeF===t?cl:"#64748b",fontFamily:"inherit",fontWeight:clTypeF===t?700:400,fontSize:".78rem",cursor:"pointer"}}>
                {ic} {t}
              </button>
            );
          })}
        </div>
      </div>

      {/* Grouped by project */}
      {Object.keys(byProject).length===0&&(
        <div>
          <EmptyState icon="✅" msg="No tasks match the current filters. Hit + Add Task to get started."/>
          {clProjF!=="all"&&checklist.filter(c=>c.projectId===clProjF).length===0&&(
            <div style={{textAlign:"center",marginTop:8}}>
              <div style={{fontSize:".8rem",color:"#64748b",marginBottom:10}}>Or start with the GMD standard template for this project:</div>
              <button onClick={()=>loadChecklistTemplate(clProjF,"this project")}
                style={{background:"#1e293b",border:"none",borderRadius:10,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>
                📋 Load GMD Standard Checklist Template
              </button>
            </div>
          )}
        </div>
      )}

      {Object.entries(byProject).map(([projId,items])=>{
        const deal=deals.find(d=>d.id===projId);
        return(
          <div key={projId} style={{marginBottom:24}}>
            {clProjF==="all"&&(
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                <div style={{fontWeight:800,color:"#0f172a",fontSize:"1rem"}}>{deal?deal.client:"No Project"}</div>
                {deal&&<Badge label={deal.stage} color={STAGE_CLR[deal.stage]||"#94a3b8"}/>}
                <div style={{flex:1,height:1,background:"#e2e8f0"}}/>
                <Btn small onClick={()=>openAddCl(projId===("__none__")?null:projId,role==="Design"?"Design":"Operations")}>+ Add to {deal?.client||"project"}</Btn>
              </div>
            )}
            {items.map(item=>{
              const typeColor=TYPE_CLR[item.type]||"#8b5cf6";
              const stColor=CS_CLR[item.status]||"#94a3b8";
              const isOD=item.dueDate&&item.dueDate<today&&item.status!=="Done";
              return(
                <Card key={item.id} accent={item.status==="Done"?"#d1fae5":isOD?"#fca5a5":item.priority==="Urgent"?"#fef3c7":undefined}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
                    {/* Left: checkbox + content */}
                    <div style={{display:"flex",gap:12,alignItems:"flex-start",flex:1}}>
                      {/* Status toggle circle */}
                      <div onClick={()=>{const next=item.status==="Done"?"To Do":item.status==="To Do"?"In Progress":"Done";clStatusQ(item.id,next);}} style={{width:24,height:24,borderRadius:"50%",border:`2.5px solid ${stColor}`,background:item.status==="Done"?stColor:"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2,transition:"all .15s"}}>
                        {item.status==="Done"&&<span style={{color:"#fff",fontSize:".72rem",fontWeight:900}}>✓</span>}
                        {item.status==="In Progress"&&<span style={{width:8,height:8,borderRadius:"50%",background:stColor,display:"block"}}/>}
                      </div>
                      <div style={{flex:1}}>
                        <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
                          <span style={{fontSize:".82rem",fontWeight:700,color:"#0f172a",textDecoration:item.status==="Done"?"line-through":"none",opacity:item.status==="Done"?.6:1}}>
                            {TYPE_ICON[item.type]||"📌"} {item.title}
                          </span>
                          {item.priority!=="Normal"&&<Badge label={item.priority} color={PRI_CLR[item.priority]}/>}
                        </div>
                        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:5}}>
                          <Badge label={item.type} color={typeColor}/>
                          <Badge label={item.dept} color="#64748b"/>
                          {item.assignedTo&&<span style={{fontSize:".72rem",color:"#64748b"}}>👤 {item.assignedTo}</span>}
                          {item.supplier&&<span style={{fontSize:".72rem",color:"#64748b"}}>🏭 {item.supplier}</span>}
                        </div>
                        {item.notes&&<div style={{fontSize:".75rem",color:"#94a3b8",fontStyle:"italic"}}>{item.notes}</div>}
                    {item.qty&&<div style={{fontSize:".72rem",color:"#0ea5e9",marginTop:2}}>Qty: {item.qty} {item.unit}</div>}
                    {item.whatCouldGoWrong&&(
                      <div style={{marginTop:6,background:"#fef9c3",border:"1px solid #fde047",borderRadius:6,padding:"5px 9px",fontSize:".72rem",color:"#854d0e"}}>
                        ⚠️ <strong>Risk:</strong> {item.whatCouldGoWrong}
                      </div>
                    )}
                        <div style={{display:"flex",gap:12,marginTop:5,fontSize:".7rem",color:isOD?"#ef4444":"#94a3b8"}}>
                          {item.dueDate&&<span>{isOD?"⚠ Overdue: ":"Due: "}{item.dueDate}</span>}
                          <span>Added by {item.createdBy} · {item.createdDate}</span>
                        </div>
                      </div>
                    </div>
                    {/* Right: status selector + actions */}
                    <div style={{flexShrink:0,textAlign:"right"}}>
                      <select value={item.status} onChange={e=>clStatusQ(item.id,e.target.value)} style={{border:`1.5px solid ${stColor}44`,borderRadius:8,padding:"5px 10px",fontFamily:"inherit",fontSize:".78rem",color:stColor,fontWeight:700,background:stColor+"12",cursor:"pointer",display:"block",marginBottom:8}}>
                        {CL_STATUS.map(s=><option key={s} style={{color:"#0f172a",background:"#fff",fontWeight:400}}>{s}</option>)}
                      </select>
                      <div style={{display:"flex",gap:6,justifyContent:"flex-end"}}>
                        <Btn small variant="ghost" onClick={()=>openEditCl(item)}>✏ Edit</Btn>
                        <Btn small variant="danger" onClick={()=>delCl(item.id)}>Delete</Btn>
                      </div>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        );
      })}

      {/* Add Task Modal */}
      <Modal open={clModal} onClose={()=>setClModal(false)} title={editCl?"Edit Task":"Add Task"} wide>
        {/* Project */}
        <Fld label="Project" hint="Which project is this task for?">
          <select value={clForm.projectId||"none"} onChange={e=>f("projectId",e.target.value==="none"?null:e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",cursor:"pointer"}}>
            <option value="none">— No specific project —</option>
            {deals.map(d=><option key={d.id} value={d.id}>{d.client} — {d.product}</option>)}
          </select>
        </Fld>

        {/* Task Type — standard presets + custom */}
        <Fld label="Task Type" hint="Pick a standard type or choose Custom to type your own">
          <div style={{display:"flex",gap:7,flexWrap:"wrap",marginBottom:10}}>
            {[...CL_TYPES,"Custom"].map(t=>{
              const c=TYPE_CLR[t]||"#8b5cf6";
              const selected=clForm.type===t||(t==="Custom"&&!CL_TYPES.includes(clForm.type));
              return(
                <button key={t} onClick={()=>f("type",t)} style={{padding:"6px 14px",borderRadius:20,border:`1.5px solid ${selected?c:"#e2e8f0"}`,background:selected?c+"18":"#fff",color:selected?c:"#64748b",fontFamily:"inherit",fontWeight:selected?700:400,fontSize:".8rem",cursor:"pointer"}}>
                  {TYPE_ICON[t]||"📌"} {t}
                </button>
              );
            })}
          </div>
          {(!CL_TYPES.includes(clForm.type)||clForm.type==="Custom")&&(
            <Inp value={clForm.customType||""} onChange={e=>{f("customType",e.target.value);f("type","Custom");}} placeholder="Describe your task type (e.g. Site Measurement, Client Meeting)"/>
          )}
        </Fld>

        <Fld label="Task Title / Description" required>
          <Inp value={clForm.title} onChange={e=>f("title",e.target.value)} placeholder="What needs to be done?"/>
        </Fld>

        {/* Qty + Unit for Module and Swatch types */}
        {(clForm.type==="Module"||clForm.type==="Swatch"||clForm.type==="Purchase") && (
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14,marginBottom:4}}>
            <Fld label="Quantity"><Inp type="number" value={clForm.qty||""} onChange={e=>f("qty",e.target.value)} placeholder="e.g. 12"/></Fld>
            <Fld label="Unit"><select value={clForm.unit||"pcs"} onChange={e=>f("unit",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",cursor:"pointer",outline:"none"}}>
              {["pcs","sheets","meters","sqm","kg","sets","rolls","liters","lots"].map(u=><option key={u}>{u}</option>)}
            </select></Fld>
          </div>
        )}

        {/* Proactive mindset field — from Action Planning Workshop */}
        <div style={{background:"#fef9c3",border:"1.5px solid #fde047",borderRadius:10,padding:"12px 14px",marginBottom:14}}>
          <div style={{fontSize:".72rem",fontWeight:700,color:"#854d0e",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>⚠️ What Could Go Wrong? <span style={{fontWeight:400,color:"#92400e"}}>(Think ahead — from Action Planning Workshop)</span></div>
          <Inp value={clForm.whatCouldGoWrong||""} onChange={e=>f("whatCouldGoWrong",e.target.value)} placeholder="e.g. Material arrives late, wrong specs ordered, client unavailable for approval…" rows={2}/>
        </div>

        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
          <Fld label="Department">
            <select value={clForm.dept} onChange={e=>f("dept",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",cursor:"pointer"}}>
              {CL_DEPT.map(d=><option key={d}>{d}</option>)}
            </select>
          </Fld>
          <Fld label="Assigned To">
            <select value={clForm.assignedTo||""} onChange={e=>f("assignedTo",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",cursor:"pointer"}}>
              <option value="">— Unassigned —</option>
              {allMembers.map(m=><option key={m}>{m}</option>)}
            </select>
          </Fld>
          <Fld label="Priority">
            <select value={clForm.priority} onChange={e=>f("priority",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",cursor:"pointer"}}>
              {PRIORITIES.map(p=><option key={p}>{p}</option>)}
            </select>
          </Fld>
          <Fld label="Status">
            <select value={clForm.status} onChange={e=>f("status",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",cursor:"pointer"}}>
              {CL_STATUS.map(s=><option key={s}>{s}</option>)}
            </select>
          </Fld>
          <Fld label="Due Date">
            <Inp type="date" value={clForm.dueDate||""} onChange={e=>f("dueDate",e.target.value)}/>
          </Fld>
          <Fld label="Supplier / Vendor" hint="For Purchase or Supplier Job tasks">
            <Inp value={clForm.supplier||""} onChange={e=>f("supplier",e.target.value)} placeholder="e.g. Casa Hardware, MetalWorks PH"/>
          </Fld>
        </div>

        <Fld label="Notes">
          <Inp rows={3} value={clForm.notes||""} onChange={e=>f("notes",e.target.value)} placeholder="Any additional details, specs, or instructions…"/>
        </Fld>

        <div style={{display:"flex",gap:10,marginTop:4}}>
          <Btn full onClick={saveCl}>{editCl?"Save Changes":"Add Task"}</Btn>
          <Btn variant="ghost" onClick={()=>setClModal(false)}>Cancel</Btn>
        </div>
      </Modal>
    </Wrap>
  );
}

// ─── AUTH SCREEN ──────────────────────────────────────────────────────────────
function AuthScreen({authView,setAuthView,onLogin,onRegister,sbReady}){
  const[uname,  setUname]  = useState("");
  const[pw,     setPw]     = useState("");
  const[name,   setName]   = useState("");
  const[pw2,    setPw2]    = useState("");
  const[reqRole,setReqRole]= useState("Sales");
  const[err,    setErr]    = useState("");
  const[ok,     setOk]     = useState("");
  const[showPw, setShowPw] = useState(false);

  const doLogin = async () => {
    setErr("");
    const e = await onLogin(uname, pw);
    if(e) setErr(e);
  };
  const doRegister = async () => {
    setErr(""); setOk("");
    if(pw !== pw2){ setErr("Passwords do not match."); return; }
    const e = await onRegister(name, uname, pw, reqRole);
    if(e){ setErr(e); return; }
    setOk("✅ Account created! A Manager will approve your access shortly.");
    setName(""); setUname(""); setPw(""); setPw2("");
    setTimeout(()=>{ setAuthView("login"); setOk(""); }, 2500);
  };
  const isLogin = authView==="login";

  return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0f172a 0%,#1e1b4b 50%,#0f172a 100%)",display:"flex",alignItems:"center",justifyContent:"center",padding:16,fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800&display=swap'); *{box-sizing:border-box;} input:focus{border-color:#f59e0b!important;outline:none;box-shadow:0 0 0 3px rgba(245,158,11,.15);} input,select,textarea{font-size:16px;} button:focus-visible,a:focus-visible{outline:2px solid #f59e0b;outline-offset:2px;border-radius:6px;}`}</style>
      <div style={{width:"100%",maxWidth:400}}>
        {/* Logo */}
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"2.2rem",color:"#fff",letterSpacing:-1}}>
            GMD <span style={{color:"#f59e0b"}}>PROD</span>
          </div>
          <div style={{color:"rgba(255,255,255,.4)",fontSize:".8rem",marginTop:4}}>Internal Operations Platform</div>
          {!sbReady&&<div style={{marginTop:12,background:"rgba(245,158,11,.15)",border:"1px solid rgba(245,158,11,.4)",borderRadius:8,padding:"8px 14px",fontSize:".78rem",color:"#fcd34d",display:"flex",alignItems:"center",gap:8}}>
            <span style={{display:"inline-block",width:8,height:8,borderRadius:"50%",background:"#f59e0b",animation:"pulse 1s infinite"}}/>
            Connecting to server… please wait before logging in.
          </div>}
        </div>

        {/* Card */}
        <div style={{background:"rgba(255,255,255,.05)",backdropFilter:"blur(20px)",borderRadius:18,border:"1px solid rgba(255,255,255,.1)",padding:"28px 28px 24px",boxShadow:"0 24px 60px rgba(0,0,0,.4)"}}>
          {/* Tabs */}
          <div style={{display:"flex",background:"rgba(0,0,0,.3)",borderRadius:10,padding:4,marginBottom:24}}>
            {["login","register"].map(v=>(
              <button key={v} onClick={()=>{setAuthView(v);setErr("");setOk("");}} style={{flex:1,padding:"8px",border:"none",borderRadius:8,background:authView===v?"#fff":"transparent",color:authView===v?"#0f172a":"rgba(255,255,255,.5)",fontWeight:authView===v?700:400,fontSize:".82rem",cursor:"pointer",fontFamily:"inherit",transition:"all .2s",textTransform:"capitalize"}}>
                {v==="login"?"Log In":"Register"}
              </button>
            ))}
          </div>

          {/* Error / Success */}
          {err&&<div style={{background:"rgba(239,68,68,.15)",border:"1px solid rgba(239,68,68,.3)",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:".8rem",color:"#fca5a5"}}>{err}</div>}
          {ok &&<div style={{background:"rgba(16,185,129,.15)",border:"1px solid rgba(16,185,129,.3)",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:".8rem",color:"#6ee7b7"}}>{ok}</div>}

          {/* Register fields */}
          {!isLogin&&(
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.5)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>Full Name *</label>
              <FInp value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. Juan dela Cruz" style={{width:"100%",background:"rgba(255,255,255,.08)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 13px",color:"#fff",fontFamily:"inherit",fontSize:".88rem"}}/>
            </div>
          )}

          {/* Username */}
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.5)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>Username *</label>
            <FInp value={uname} onChange={e=>setUname(e.target.value)} placeholder="e.g. juan" onKeyDown={e=>isLogin&&e.key==="Enter"&&doLogin()} style={{width:"100%",background:"rgba(255,255,255,.08)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 13px",color:"#fff",fontFamily:"inherit",fontSize:".88rem"}}/>
          </div>

          {/* Password */}
          <div style={{marginBottom:14,position:"relative"}}>
            <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.5)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>Password *</label>
            <div style={{position:"relative"}}>
              <FInp type={showPw?"text":"password"} value={pw} onChange={e=>setPw(e.target.value)} placeholder="Min 6 characters" onKeyDown={e=>isLogin&&e.key==="Enter"&&doLogin()} style={{width:"100%",background:"rgba(255,255,255,.08)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 40px 10px 13px",color:"#fff",fontFamily:"inherit",fontSize:".88rem"}}/>
              <button onClick={()=>setShowPw(s=>!s)} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"rgba(255,255,255,.4)",cursor:"pointer",fontSize:".78rem"}}>{showPw?"Hide":"Show"}</button>
            </div>
          </div>

          {/* Confirm password + role (register only) */}
          {!isLogin&&(<>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.5)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>Confirm Password *</label>
              <FInp type="password" value={pw2} onChange={e=>setPw2(e.target.value)} style={{width:"100%",background:"rgba(255,255,255,.08)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 13px",color:"#fff",fontFamily:"inherit",fontSize:".88rem"}}/>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.5)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:6}}>Request Role</label>
              <select value={reqRole} onChange={e=>setReqRole(e.target.value)} style={{width:"100%",background:"rgba(255,255,255,.08)",border:"1.5px solid rgba(255,255,255,.15)",borderRadius:9,padding:"10px 13px",color:"#fff",fontFamily:"inherit",fontSize:".88rem",cursor:"pointer"}}>
                {["Sales","Finance","Procurement","QS","Operations","Design","Warehouse"].map(r=><option key={r} style={{background:"#1e293b"}}>{r}</option>)}
              </select>
              <div style={{fontSize:".7rem",color:"rgba(255,255,255,.3)",marginTop:5}}>A Manager will assign your final role upon approval.</div>
            </div>
          </>)}

          {/* Submit */}
          <button onClick={isLogin?doLogin:doRegister} disabled={isLogin&&!sbReady} style={{width:"100%",background:isLogin&&!sbReady?"#475569":"#f59e0b",border:"none",borderRadius:10,padding:"12px",fontFamily:"inherit",fontWeight:700,fontSize:".92rem",color:isLogin&&!sbReady?"#94a3b8":"#0f172a",cursor:isLogin&&!sbReady?"not-allowed":"pointer",marginTop:6,transition:"all .15s"}}
            onMouseEnter={e=>{if(!(isLogin&&!sbReady))e.currentTarget.style.background="#fbbf24";}}
            onMouseLeave={e=>{if(!(isLogin&&!sbReady))e.currentTarget.style.background="#f59e0b";}}>
            {isLogin&&!sbReady?"⏳ Connecting…":isLogin?"Log In →":"Create Account →"}
          </button>

          {isLogin&&(
            <div style={{textAlign:"center",marginTop:16,fontSize:".75rem",color:"rgba(255,255,255,.3)"}}>
              No account yet?{" "}
              <button onClick={()=>setAuthView("register")} style={{background:"none",border:"none",color:"#f59e0b",cursor:"pointer",fontFamily:"inherit",fontSize:".75rem",fontWeight:600}}>Register here</button>
            </div>
          )}
          {!isLogin&&(
            <div style={{textAlign:"center",marginTop:16,fontSize:".75rem",color:"rgba(255,255,255,.5)"}}>
              Already have an account?{" "}
              <button onClick={()=>{setAuthView("login");setErr("");setOk("");}}
                style={{background:"none",border:"none",color:"#f59e0b",cursor:"pointer",fontFamily:"inherit",fontSize:".75rem",fontWeight:600}}>
                Back to Login
              </button>
            </div>
          )}
        </div>

        <div style={{textAlign:"center",marginTop:20,fontSize:".7rem",color:"rgba(255,255,255,.2)"}}>
          GMD Productions Inc. · Internal use only
        </div>
      </div>
    </div>
  );
}

// ─── ACCOUNTS MANAGER ─────────────────────────────────────────────────────────
function AccountsManager({users,session,onApprove,onReject,onDeactivate,onDelete,onResetPw,onCreateUser,ROLES}){
  const[resetId,  setResetId]  = useState(null);
  const[newPw,    setNewPw]    = useState("");
  const[resetMsg, setResetMsg] = useState("");
  const[editRole, setEditRole] = useState({});
  const[showCreate,setShowCreate]=useState(false);
  const[cf,setCf]=useState({name:"",username:"",password:"",role:"Sales",title:""});
  const[createErr,setCreateErr]=useState("");
  const STATUS_CLR = {active:"#10b981",pending:"#f59e0b",inactive:"#94a3b8",rejected:"#ef4444"};
  const ALL_ROLES=["Sales","Finance","Accounting","Procurement","ProcurementManager","QS","Operations","Design","Warehouse","ProjectMover","SalesOpsAdmin","Audit","HRAdmin","Manager"];

  const pending  = users.filter(u=>u.status==="pending");
  const active   = users.filter(u=>u.status==="active");
  const inactive = users.filter(u=>u.status==="inactive"||u.status==="rejected");

  const submitCreate=async()=>{
    if(!cf.name.trim()||!cf.username.trim()||cf.password.length<6){setCreateErr("Name, username, and password (min 6 chars) are required.");return;}
    if(users.some(u=>u.username===cf.username.toLowerCase().trim())){setCreateErr("Username already taken.");return;}
    const res=await onCreateUser(cf.name,cf.username,cf.password,cf.role,cf.title);
    if(res&&res.ok===false){setCreateErr(res.error||"Couldn't create the account. Try again.");return;}
    setCf({name:"",username:"",password:"",role:"Sales",title:""});
    setCreateErr("");setShowCreate(false);
  };
  const inp={border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",width:"100%",boxSizing:"border-box"};

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4,flexWrap:"wrap",gap:10}}>
        <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.2rem"}}>Account Management</div>
        <button onClick={()=>{setShowCreate(s=>!s);setCreateErr("");}} style={{background:"#0f172a",border:"none",borderRadius:8,padding:"8px 18px",fontFamily:"inherit",fontSize:".82rem",color:"#f59e0b",cursor:"pointer",fontWeight:700}}>
          {showCreate?"✕ Cancel":"+ Create Account"}
        </button>
      </div>
      <div style={{fontSize:".78rem",color:"#64748b",marginBottom:16}}>Approve registrations, manage roles, reset passwords.</div>

      {/* Create Account Form */}
      {showCreate&&(
        <div style={{background:"#f8fafc",border:"1.5px solid #1e293b",borderRadius:12,padding:"18px 20px",marginBottom:20}}>
          <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem",marginBottom:14}}>✨ New Account</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10,marginBottom:10}}>
            <div><div style={{fontSize:".7rem",color:"#64748b",marginBottom:4,fontWeight:600}}>Full Name *</div><input style={inp} value={cf.name} onChange={e=>setCf(p=>({...p,name:e.target.value}))} placeholder="e.g. Juan dela Cruz"/></div>
            <div><div style={{fontSize:".7rem",color:"#64748b",marginBottom:4,fontWeight:600}}>Username *</div><input style={inp} value={cf.username} onChange={e=>setCf(p=>({...p,username:e.target.value.toLowerCase()}))} placeholder="e.g. juan"/></div>
            <div><div style={{fontSize:".7rem",color:"#64748b",marginBottom:4,fontWeight:600}}>Password * (min 6 chars)</div><input type="password" style={inp} value={cf.password} onChange={e=>setCf(p=>({...p,password:e.target.value}))} placeholder="Temporary password"/></div>
            <div><div style={{fontSize:".7rem",color:"#64748b",marginBottom:4,fontWeight:600}}>Role *</div>
              <select style={{...inp,cursor:"pointer"}} value={cf.role} onChange={e=>setCf(p=>({...p,role:e.target.value}))}>
                {ALL_ROLES.map(r=><option key={r} value={r}>{roleLabel(r)}</option>)}
              </select>
            </div>
            <div style={{gridColumn:"1/-1"}}><div style={{fontSize:".7rem",color:"#64748b",marginBottom:4,fontWeight:600}}>Job Title (optional)</div><input style={inp} value={cf.title} onChange={e=>setCf(p=>({...p,title:e.target.value}))} placeholder="e.g. Account Executive"/></div>
          </div>
          {createErr&&<div style={{fontSize:".78rem",color:"#ef4444",marginBottom:8,fontWeight:600}}>{createErr}</div>}
          <button onClick={submitCreate} style={{background:"#059669",border:"none",borderRadius:8,padding:"9px 22px",fontFamily:"inherit",fontSize:".84rem",color:"#fff",cursor:"pointer",fontWeight:700}}>Create Account →</button>
        </div>
      )}

      {/* Pending approvals */}
      {pending.length>0&&(
        <div style={{marginBottom:24}}>
          <div style={{fontWeight:700,color:"#dc2626",fontSize:".88rem",marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
            <span style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:20,padding:"1px 10px",fontSize:".72rem"}}>{pending.length} pending</span>
            Pending Approvals
          </div>
          {pending.map(u=>(
            <div key={u.id} style={{background:"#fff",border:"1.5px solid #fde68a",borderRadius:12,padding:"16px 18px",marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
                <div>
                  <div style={{fontWeight:700,color:"#0f172a"}}>{u.name}</div>
                  <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>@{u.username} · Requested: <strong>{roleLabel(u.role)}</strong> · Registered {u.createdAt}</div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                  <select value={editRole[u.id]||u.role} onChange={e=>setEditRole(r=>({...r,[u.id]:e.target.value}))} style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 10px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
                    {["Sales","Finance","Procurement","QS","Operations","Design","Warehouse","SalesOpsAdmin","Manager"].map(r=><option key={r} value={r}>{roleLabel(r)}</option>)}
                  </select>
                  <button onClick={()=>onApprove(u.id,editRole[u.id]||u.role)} style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:8,padding:"6px 14px",fontWeight:700,fontSize:".78rem",color:"#059669",cursor:"pointer",fontFamily:"inherit"}}>✓ Approve</button>
                  <button onClick={async ()=>{if((await uiConfirm(`Reject ${u.name}'s account request?`)))onReject(u.id);}} style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:8,padding:"6px 14px",fontWeight:700,fontSize:".78rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>✕ Reject</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {pending.length===0&&<div style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:".82rem",color:"#059669"}}>✓ No pending approvals</div>}

      {/* Active accounts */}
      <div style={{marginBottom:20}}>
        <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem",marginBottom:10}}>Active Accounts ({active.length})</div>
        {active.map(u=>(
          <div key={u.id} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 18px",marginBottom:8}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontWeight:700,color:"#0f172a"}}>{u.name}</span>
                  {u.id===session?.userId&&<span style={{fontSize:".65rem",background:"#eff6ff",color:"#3b82f6",border:"1px solid #93c5fd",padding:"1px 7px",borderRadius:10,fontWeight:700}}>You</span>}
                </div>
                <div style={{fontSize:".73rem",color:"#64748b",marginTop:2}}>@{u.username} · {roleLabel(u.role)}</div>
              </div>
              <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                <button onClick={()=>{setResetId(u.id);setNewPw("");setResetMsg("");}} style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:7,padding:"5px 11px",fontSize:".75rem",color:"#3b82f6",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>Reset PW</button>
                {u.id!==session?.userId&&(
                  <button onClick={()=>onDeactivate(u.id)} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 11px",fontSize:".75rem",color:"#64748b",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>Deactivate</button>
                )}
              </div>
            </div>
            {resetId===u.id&&(
              <div style={{marginTop:12,padding:"12px 14px",background:"#f8fafc",borderRadius:8,border:"1px solid #e2e8f0",display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                <FInp type="password" value={newPw} onChange={e=>setNewPw(e.target.value)} placeholder="New password (min 6 chars)" style={{flex:1,minWidth:180,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 11px",fontFamily:"inherit",fontSize:".83rem",color:"#0f172a"}}/>
                <button onClick={async()=>{if(newPw.length>=6){const ok=await onResetPw(u.id,newPw);if(ok){setResetId(null);setResetMsg("Password reset!");}else setResetMsg("⚠️ Couldn't reach the server — password not reset. Try again.");}else setResetMsg("Min 6 characters.");}} style={{background:"#1e293b",border:"none",borderRadius:7,padding:"7px 14px",fontWeight:700,fontSize:".78rem",color:"#fff",cursor:"pointer",fontFamily:"inherit"}}>Save</button>
                <button onClick={()=>setResetId(null)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 12px",fontSize:".75rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit"}}>Cancel</button>
                {resetMsg&&<span style={{fontSize:".75rem",color:"#059669",fontWeight:600}}>{resetMsg}</span>}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Inactive/rejected */}
      {inactive.length>0&&(
        <div>
          <div style={{fontWeight:700,color:"#94a3b8",fontSize:".88rem",marginBottom:10}}>Inactive / Rejected ({inactive.length})</div>
          {inactive.map(u=>(
            <div key={u.id} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 16px",marginBottom:6,display:"flex",justifyContent:"space-between",alignItems:"center",opacity:.7}}>
              <div>
                <span style={{fontWeight:600,color:"#64748b"}}>{u.name}</span>
                <span style={{fontSize:".73rem",color:"#94a3b8",marginLeft:8}}>@{u.username} · {u.status}</span>
              </div>
              <div style={{display:"flex",gap:7}}>
                <button onClick={()=>onApprove(u.id,u.role)} style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:7,padding:"4px 11px",fontSize:".73rem",color:"#059669",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>Reactivate</button>
                <button onClick={async ()=>{if((await uiConfirm(`Permanently delete ${u.name}'s account? This cannot be undone.`)))onDelete(u.id);}} style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:7,padding:"4px 11px",fontSize:".73rem",color:"#dc2626",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── SALES CALENDAR VIEW ─────────────────────────────────────────────────────
function SalesCalendarView({deals, session, role, pcards, jos, billings}){
  const todayStr=new Date().toISOString().slice(0,10);
  const[calDate,setCalDate]=useState(()=>{const n=new Date();return{y:n.getFullYear(),m:n.getMonth()};});
  const[selectedDay,setSelectedDay]=useState(null);
  const AE_COLORS={"Paulo Garcia":"#3b82f6","Paolo Gomez":"#8b5cf6","April Gail De Ello":"#ec4899","Jena De Asis":"#f59e0b","Don Wyn Celmar":"#10b981"};
  const aeColor=ae=>AE_COLORS[ae]||"#94a3b8";

  const prevMonth=()=>{setCalDate(({y,m})=>m===0?{y:y-1,m:11}:{y,m:m-1});setSelectedDay(null);};
  const nextMonth=()=>{setCalDate(({y,m})=>m===11?{y:y+1,m:0}:{y,m:m+1});setSelectedDay(null);};

  const{y,m}=calDate;
  const firstDay=new Date(y,m,1).getDay();
  const daysInMonth=new Date(y,m+1,0).getDate();
  const monthStr=`${y}-${String(m+1).padStart(2,"0")}`;
  const MONTHS_PH=["January","February","March","April","May","June","July","August","September","October","November","December"];

  // Build full event list for this month
  const allEvents=useMemo(()=>{
    const list=[];
    deals.forEach(d=>{
      if(d.followUp) list.push({date:d.followUp,label:d.client,type:"followup",ae:d.salesOwner,ceNo:d.ceNo,color:aeColor(d.salesOwner),icon:"📅"});
      if(d.dateAcquired) list.push({date:d.dateAcquired,label:d.client,type:"acquired",ae:d.salesOwner,color:aeColor(d.salesOwner),icon:"🆕"});
      const pc=pcards?.[d.id];
      if(pc?.targetEndDate){
        const jo=(jos||[]).find(j=>j.dealId===d.id);
        list.push({date:pc.targetEndDate,label:d.client,type:"turnover",ceNo:d.ceNo,color:"#3b82f6",icon:"🏗",detail:"PM: "+(jo?.pm1||pc?.pm1||"—")});
      }
    });
    (billings||[]).filter(b=>b.dueDate&&b.status!=="Fully Paid"&&b.status!=="Cancelled").forEach(b=>{
      const deal=deals.find(d=>d.id===b.dealId);
      if(!deal) return;
      list.push({date:b.dueDate,label:deal.client,type:"billing",ceNo:deal.ceNo||"",color:"#10b981",icon:"💵",sub:b.name||"Invoice",detail:"₱"+Number(b.amount||0).toLocaleString("en-PH",{maximumFractionDigits:0})});
    });
    return list;
  },[deals,pcards,jos,billings]);

  // Events keyed by 2-digit day string for this month only
  const events=useMemo(()=>{
    const map={};
    allEvents.filter(e=>e.date?.startsWith(monthStr)).forEach(e=>{
      const day=e.date.slice(8,10);
      if(!map[day]) map[day]=[];
      map[day].push(e);
    });
    return map;
  },[allEvents,monthStr]);

  // Upcoming 14 days across all months
  const todayD=new Date(todayStr+"T00:00:00");
  const in14=new Date(todayD);in14.setDate(in14.getDate()+14);
  const upcoming=useMemo(()=>
    allEvents.filter(e=>{const d=new Date(e.date+"T00:00:00");return d>=todayD&&d<=in14;})
      .sort((a,b)=>a.date.localeCompare(b.date))
  ,[allEvents,todayStr]);

  const cells=[];
  for(let i=0;i<firstDay;i++) cells.push(null);
  for(let d=1;d<=daysInMonth;d++) cells.push(d);

  // Summary: follow-ups this month by AE
  const followUps=deals.filter(d=>d.followUp?.startsWith(monthStr));
  const byAE=[...new Set(followUps.map(d=>d.salesOwner||"Unassigned"))].map(ae=>({ae,count:followUps.filter(d=>(d.salesOwner||"Unassigned")===ae).length})).sort((a,b)=>b.count-a.count);

  const TYPE_LABEL={followup:"Follow-up",acquired:"Date Acquired",turnover:"Turnover",billing:"Collection Due"};

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>📅 Project Calendar</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Follow-ups · turnover dates · collection due dates</div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button onClick={prevMonth} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontWeight:700,fontFamily:"inherit",fontSize:".85rem",color:"#475569"}}>←</button>
          <span style={{fontWeight:800,fontSize:"1rem",color:"#0f172a",minWidth:160,textAlign:"center"}}>{MONTHS_PH[m]} {y}</span>
          <button onClick={nextMonth} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontWeight:700,fontFamily:"inherit",fontSize:".85rem",color:"#475569"}}>→</button>
          <button onClick={()=>{const n=new Date();setCalDate({y:n.getFullYear(),m:n.getMonth()});setSelectedDay(null);}} style={{background:"#1e293b",border:"none",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontWeight:700,fontFamily:"inherit",fontSize:".82rem",color:"#fff"}}>Today</button>
        </div>
      </div>

      {/* Legend strip */}
      <div style={{background:"#fff",borderRadius:10,border:"1.5px solid #e2e8f0",padding:"8px 14px",marginBottom:12,display:"flex",gap:14,flexWrap:"wrap",alignItems:"center"}}>
        {[{c:"#94a3b8",l:"Follow-up 📅"},{c:"#94a3b8",l:"Acquired 🆕"},{c:"#3b82f6",l:"Turnover 🏗"},{c:"#10b981",l:"Collection Due 💵"}].map(({c,l})=>(
          <div key={l} style={{display:"flex",alignItems:"center",gap:5,fontSize:".72rem",color:"#475569"}}>
            <div style={{width:9,height:9,borderRadius:"50%",background:c,flexShrink:0}}/>{l}
          </div>
        ))}
        {byAE.length>0&&<>
          <div style={{width:1,height:16,background:"#e2e8f0",flexShrink:0}}/>
          {Object.entries(AE_COLORS).map(([ae,clr])=>(
            <span key={ae} style={{display:"flex",alignItems:"center",gap:4,fontSize:".72rem",color:"#64748b"}}>
              <span style={{width:9,height:9,borderRadius:2,background:clr,display:"inline-block"}}/>{ae.split(" ")[0]}
            </span>
          ))}
        </>}
      </div>

      {/* Calendar grid */}
      <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",background:"#1e293b"}}>
          {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d=>(
            <div key={d} style={{padding:"8px 4px",textAlign:"center",fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.6)",textTransform:"uppercase",letterSpacing:".5px"}}>{d}</div>
          ))}
        </div>
        {Array.from({length:Math.ceil(cells.length/7)},(_,wi)=>(
          <div key={wi} style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",borderBottom:wi<Math.ceil(cells.length/7)-1?"1px solid #f1f5f9":""}}>
            {cells.slice(wi*7,(wi+1)*7).map((day,di)=>{
              if(!day) return <div key={di} style={{minHeight:72,background:"#fafafa",borderRight:"1px solid #f1f5f9"}}/>;
              const dayStr=String(day).padStart(2,"0");
              const fullDate=`${monthStr}-${dayStr}`;
              const isToday=fullDate===todayStr;
              const isSel=selectedDay===fullDate;
              const evts=events[dayStr]||[];
              const isPast=fullDate<todayStr;
              return(
                <div key={day} {...clickable(()=>setSelectedDay(isSel?null:fullDate))} aria-label={`Select day ${fullDate}`}
                  style={{minHeight:72,padding:"4px 6px",borderRight:"1px solid #f1f5f9",background:isSel?"#eff6ff":isToday?"#fefce8":isPast?"#fafafa":"#fff",cursor:"pointer"}}>
                  <div style={{fontWeight:isToday?800:500,fontSize:".75rem",marginBottom:2,width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",borderRadius:"50%",background:isToday?"#fef9c3":undefined,color:isToday?"#92400e":"#0f172a"}}>{day}</div>
                  {evts.slice(0,3).map((ev,i)=>{
                    const clr=ev.color||aeColor(ev.ae);
                    return(
                      <div key={i} title={ev.label+(ev.ceNo?" · "+ev.ceNo:"")+(ev.detail?" · "+ev.detail:"")}
                        style={{background:clr+"22",border:`1px solid ${clr}44`,borderRadius:4,padding:"2px 4px",marginBottom:1,fontSize:".6rem",color:clr,fontWeight:600,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                        {ev.icon} {ev.label}
                      </div>
                    );
                  })}
                  {evts.length>3&&<div style={{fontSize:".58rem",color:"#94a3b8",paddingLeft:2}}>+{evts.length-3}</div>}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Day detail panel */}
      {selectedDay&&(events[selectedDay.slice(8,10)]||[]).length>0&&(
        <div style={{marginTop:12,background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
          <div style={{background:"#1e293b",padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,color:"#fff",fontSize:".88rem"}}>
              {new Date(selectedDay+"T00:00:00").toLocaleDateString("en-PH",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}
            </span>
            <button onClick={()=>setSelectedDay(null)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:6,padding:"3px 10px",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem"}}>✕</button>
          </div>
          {(events[selectedDay.slice(8,10)]||[]).map((ev,i,arr)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 16px",borderBottom:i<arr.length-1?"1px solid #f8fafc":""}}>
              <div style={{width:32,height:32,borderRadius:8,background:(ev.color||aeColor(ev.ae))+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1rem",flexShrink:0}}>{ev.icon}</div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{ev.label}{ev.ceNo?<span style={{fontWeight:400,color:"#94a3b8",fontSize:".75rem"}}> · {ev.ceNo}</span>:""}</div>
                <div style={{fontSize:".72rem",color:"#64748b",marginTop:1}}>{ev.sub||""}{ev.detail?" · "+ev.detail:""}</div>
              </div>
              <span style={{fontSize:".68rem",fontWeight:700,color:ev.color||aeColor(ev.ae),background:(ev.color||aeColor(ev.ae))+"18",border:`1px solid ${(ev.color||aeColor(ev.ae))}44`,borderRadius:20,padding:"2px 8px",flexShrink:0}}>
                {TYPE_LABEL[ev.type]||ev.type}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Upcoming 14 days */}
      {upcoming.length>0&&(
        <div style={{marginTop:16}}>
          <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem",marginBottom:8}}>⚡ Next 14 Days</div>
          {upcoming.map((ev,i)=>{
            const daysUntil=Math.ceil((new Date(ev.date+"T00:00:00")-todayD)/(1000*60*60*24));
            return(
              <div key={i} style={{background:"#fff",borderRadius:10,border:`1.5px solid ${(ev.color||"#94a3b8")}33`,padding:"10px 14px",marginBottom:7,display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:34,height:34,borderRadius:8,background:(ev.color||"#94a3b8")+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".95rem",flexShrink:0}}>{ev.icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{ev.label}{ev.ceNo?<span style={{fontWeight:400,color:"#94a3b8",fontSize:".75rem"}}> · {ev.ceNo}</span>:""}</div>
                  <div style={{fontSize:".7rem",color:"#64748b",marginTop:1}}>{TYPE_LABEL[ev.type]||ev.type}{ev.detail?" · "+ev.detail:""}</div>
                  <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:1}}>{new Date(ev.date+"T00:00:00").toLocaleDateString("en-PH",{weekday:"short",month:"short",day:"numeric"})}</div>
                </div>
                <div style={{fontSize:".72rem",fontWeight:700,flexShrink:0,color:daysUntil===0?"#dc2626":daysUntil<=3?"#f59e0b":"#059669",background:daysUntil===0?"#fef2f2":daysUntil<=3?"#fffbeb":"#f0fdf4",border:`1px solid ${daysUntil===0?"#fecaca":daysUntil<=3?"#fde68a":"#6ee7b7"}`,borderRadius:20,padding:"3px 10px"}}>
                  {daysUntil===0?"TODAY":daysUntil===1?"Tomorrow":daysUntil+"d away"}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// Roles that may edit a client profile — same as set_client_profile
// (migration 20261026053903_set_client_profile_rpc.sql): keep them in sync.
const CLIENT_PROFILE_EDITORS=["Manager","Finance","FinanceAssistant","Accounting","Sales","SalesOpsAdmin"];
// ─── CLIENT AUTOCOMPLETE ──────────────────────────────────────────────────────
function ClientDirectory({deals, session, role, vvipClients, toggleVvip, customClients, clientProfiles, saveClientProfile, addNewClient, isMobile}){
  const[selClient,  setSelClient]  = useState(null);
  const[search,     setSearch]     = useState("");
  const[filter,     setFilter]     = useState("all");
  const[editClient, setEditClient] = useState(null);
  const[editName,   setEditName]   = useState("");
  const[addOpen,    setAddOpen]    = useState(false);
  const EMPTY_ADD={name:"",parentGroup:"",contactPerson:"",email:"",phone:"",mobile:"",website:"",billingAddress:"",city:"",province:"",zipCode:"",country:"Philippines",tin:"",paymentTerms:"Due on receipt",notes:""};
  // Existing parent groups already in use — offered as suggestions so people
  // pick a consistent spelling instead of inventing "Diageo" / "Diageo PH" / etc.
  const knownGroups=useMemo(()=>[...new Set(Object.values(clientProfiles||{}).map(p=>p?.parentGroup).filter(Boolean))].sort(),[clientProfiles]);
  const[addForm,    setAddForm]    = useState(EMPTY_ADD);
  const fa=(k,v)=>setAddForm(p=>({...p,[k]:v}));
  const doAddClient=()=>{
    const name=addForm.name.trim();
    if(!name) return;
    const allC=[...GMD_CLIENTS,...(customClients||[])];
    if(allC.find(c=>c.name.toLowerCase()===name.toLowerCase())){alert("Client already exists.");return;}
    if(addNewClient) addNewClient(name); else GMD_CLIENTS.push({name,id:"c"+Date.now(),addedBy:session?.name||"",addedAt:today});
    const prof={parentGroup:(addForm.parentGroup||"").trim(),contactPerson:addForm.contactPerson,email:addForm.email,phone:addForm.phone,mobile:addForm.mobile,website:addForm.website,billingAddress:addForm.billingAddress,city:addForm.city,province:addForm.province,zipCode:addForm.zipCode,country:addForm.country,tin:addForm.tin,paymentTerms:addForm.paymentTerms,notes:addForm.notes};
    if(saveClientProfile&&Object.values(prof).some(v=>v)) saveClientProfile(name,prof);
    setAddForm(EMPTY_ADD);
    setAddOpen(false);
    forceUpdate(n=>n+1);
  };
  const[profileModal,setProfileModal]=useState(null); // client name being profiled
  const[profileForm, setProfileForm]=useState({});
  const[,forceUpdate]              = useState(0);
  const fp2=(k,v)=>setProfileForm(p=>({...p,[k]:v}));
  const openProfile=(name)=>{
    setProfileForm({...({parentGroup:"",contactPerson:"",email:"",phone:"",mobile:"",website:"",billingAddress:"",city:"",province:"",zipCode:"",country:"Philippines",tin:"",paymentTerms:"Due on receipt",notes:""}),...((clientProfiles||{})[name]||{})});
    setProfileModal(name);
  };
  const saveProfile=()=>{
    if(!profileModal) return;
    saveClientProfile(profileModal,profileForm);
    setProfileModal(null);
  };

  const saveClientEdit=()=>{
    if(!editName.trim()) return;
    const idx = GMD_CLIENTS.findIndex(c=>c.name===editClient);
    if(idx > -1) GMD_CLIENTS[idx].name = editName.trim();
    setEditClient(null); setEditName("");
  };

  const allClients=useMemo(()=>{
    const map=new Map();
    GMD_CLIENTS.forEach(c=>map.set(clientKey(c.name),{...c}));
    (customClients||[]).forEach(c=>{
      const key=clientKey(c.name);
      map.set(key,map.has(key)?{...map.get(key),...c}:{...c});
    });
    return [...map.values()];
  },[customClients]);
  const filtered = useMemo(()=>{
    let list = allClients;
    if(search) list = list.filter(c=>
      c.name.toLowerCase().includes(search.toLowerCase())||
      (c.city||"").toLowerCase().includes(search.toLowerCase())||
      (c.email||"").toLowerCase().includes(search.toLowerCase())
    );
    if(filter==="with-balance") list = list.filter(c=>c.balance>0);
    if(filter==="with-projects") list = list.filter(c=>deals.some(d=>clientKey(d.client)===clientKey(c.name)));
    if(filter==="vvip") list = list.filter(c=>vvipClients?.has(c.name));
    // VVIP always on top
    list=[...list].sort((a,b)=>{
      const av=vvipClients?.has(a.name)?0:1;
      const bv=vvipClients?.has(b.name)?0:1;
      return av-bv||a.name.localeCompare(b.name);
    });
    return list;
  },[search,filter,deals,vvipClients,customClients]);

  const totalBalance = allClients.reduce((s,c)=>s+(Number(c.balance)||0),0);

  return(
    <div>
      {/* Header */}
      <div style={{marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Client Directory</h2>
          <p style={{margin:"4px 0 0",color:"#64748b",fontSize:".78rem"}}>{allClients.length} clients on record</p>
        </div>
        <button onClick={()=>setAddOpen(true)} style={{background:"#059669",border:"none",borderRadius:9,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:"#fff",cursor:"pointer"}}>+ Add Client</button>
      </div>

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:12,marginBottom:20}}>
        {[
          {l:"Total Clients",    v:allClients.length,                                      c:"#3b82f6"},
          {l:"With Active Deals",v:allClients.filter(c=>deals.some(d=>clientKey(d.client)===clientKey(c.name))).length, c:"#10b981"},
          {l:"Open Balances",    v:allClients.filter(c=>c.balance>0).length,               c:"#ef4444"},
          {l:"Total Outstanding",v:"₱"+totalBalance.toLocaleString(),                       c:"#f59e0b"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"15px 18px",border:"1.5px solid #e2e8f0"}}>
            <div style={{fontWeight:800,fontSize:"1.4rem",color:c,fontFamily:"'Barlow Condensed',sans-serif"}}>{v}</div>
            <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Consolidated rollup by parent group (e.g. all Diageo departments) */}
      {(()=>{
        const g={};
        deals.forEach(d=>{
          const grp=(clientProfiles||{})[d.client]?.parentGroup;
          if(!grp) return;
          g[grp]=g[grp]||{group:grp,clients:new Set(),value:0,collected:0};
          g[grp].clients.add(d.client);
          if(WON_STAGES.includes(d.stage)) g[grp].value+=Number(d.value||0);
          g[grp].collected+=Number(d.amountPaid||0);
        });
        const rows=Object.values(g).sort((a,b)=>b.value-a.value);
        if(!rows.length) return null;
        return(
          <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
            <div style={{fontSize:".65rem",fontWeight:700,textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginBottom:10}}>Consolidated by Group</div>
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(auto-fill,minmax(220px,1fr))",gap:10}}>
              {rows.map(r=>(
                <div key={r.group} style={{background:"#f8fafc",borderRadius:10,padding:"11px 14px",border:"1px solid #eef2f7"}}>
                  <div style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>{r.group}</div>
                  <div style={{fontSize:".7rem",color:"#94a3b8",margin:"1px 0 6px"}}>{r.clients.size} account{r.clients.size>1?"s":""}</div>
                  <div style={{fontSize:".74rem",color:"#64748b"}}>Awarded: <strong style={{color:"#0f172a"}}>₱{r.value.toLocaleString("en-PH",{maximumFractionDigits:0})}</strong></div>
                  <div style={{fontSize:".74rem",color:"#64748b"}}>Collected: <strong style={{color:"#059669"}}>₱{r.collected.toLocaleString("en-PH",{maximumFractionDigits:0})}</strong></div>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {/* Open balances alert */}
      {allClients.filter(c=>c.balance>0).length>0&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,padding:"12px 18px",marginBottom:16,display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
          <span style={{fontSize:"1.2rem"}}>⚠️</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,color:"#dc2626",fontSize:".88rem"}}>Clients with outstanding balances</div>
            <div style={{display:"flex",gap:16,marginTop:4,flexWrap:"wrap"}}>
              {allClients.filter(c=>c.balance>0).map(c=>(
                <span key={c.name} style={{fontSize:".78rem",color:"#ef4444"}}>
                  <strong>{c.name}</strong> — ₱{c.balance.toLocaleString()}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Search + filters */}
      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        <FInp
          value={search} onChange={e=>setSearch(e.target.value)}
          placeholder="Search by name, city, or email…"
          style={{flex:1,minWidth:200,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 13px",fontFamily:"inherit",fontSize:".86rem",color:"#1e293b",outline:"none"}}
        />
        {[
          {id:"all",           l:`All (${allClients.length})`},
          {id:"with-balance",  l:`Open Balance (${allClients.filter(c=>c.balance>0).length})`},
          {id:"with-projects", l:`Has Deals (${allClients.filter(c=>deals.some(d=>clientKey(d.client)===clientKey(c.name))).length})`},
          {id:"vvip",          l:`⭐ VVIP (${vvipClients?.size||0})`},
        ].map(({id,l})=>(
          <button key={id} onClick={()=>setFilter(id)}
            style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${filter===id?"#1e293b":"#e2e8f0"}`,background:filter===id?"#1e293b":"#fff",color:filter===id?"#fff":"#64748b",fontFamily:"inherit",fontWeight:filter===id?700:400,fontSize:".78rem",cursor:"pointer",whiteSpace:"nowrap"}}>
            {l}
          </button>
        ))}
      </div>

      {/* Client list */}
      <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:0,padding:"8px 18px",background:"#f8fafc",borderBottom:"1.5px solid #e2e8f0",fontSize:".65rem",fontWeight:700,textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8"}}>
          {["Client Name","Awarded Deals","Contact","Status"].map(h=><div key={h}>{h}</div>)}
        </div>
        {filtered.map((c,i)=>{
          const clientDeals = deals.filter(d=>clientKey(d.client)===clientKey(c.name));
          const hasBalance  = c.balance>0;
          const hasDeals    = clientDeals.length>0;
          return(
            <div key={i} {...clickable(()=>setSelClient(c.name))} aria-label={`Open client ${c.name}`} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:0,padding:"12px 18px",cursor:"pointer",borderBottom:"1px solid #f1f5f9",background:hasBalance?"#fef9f9":i%2===0?"#fff":"#fafafa",alignItems:"center",transition:"background .1s"}}
              onMouseEnter={e=>e.currentTarget.style.background="#f0f9ff"}
              onMouseLeave={e=>e.currentTarget.style.background=hasBalance?"#fef9f9":i%2===0?"#fff":"#fafafa"}>
              <div style={{display:"flex",alignItems:"flex-start",gap:8}}>
                {(role==="Manager"||role==="Sales")&&(
                  <button onClick={()=>toggleVvip(c.name)} title={vvipClients?.has(c.name)?"Remove VVIP":"Mark as VVIP"}
                    style={{background:"none",border:"none",cursor:"pointer",fontSize:"1rem",padding:"0 2px",color:vvipClients?.has(c.name)?"#f59e0b":"#cbd5e1",flexShrink:0,marginTop:1}}>
                    {vvipClients?.has(c.name)?"⭐":"☆"}
                  </button>
                )}
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    {editClient===c.name ? (
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <input value={editName} onChange={e=>setEditName(e.target.value)}
                          onKeyDown={e=>{if(e.key==="Enter")saveClientEdit();if(e.key==="Escape"){setEditClient(null);}}}
                          autoFocus style={{border:"1.5px solid #3b82f6",borderRadius:6,padding:"3px 8px",fontFamily:"inherit",fontSize:".85rem",width:200}}/>
                        <button onClick={saveClientEdit} style={{background:"#3b82f6",border:"none",borderRadius:5,padding:"3px 10px",color:"#fff",cursor:"pointer",fontSize:".75rem",fontWeight:700}}>Save</button>
                        <button onClick={()=>setEditClient(null)} style={{background:"#f1f5f9",border:"none",borderRadius:5,padding:"3px 8px",color:"#64748b",cursor:"pointer",fontSize:".75rem"}}>✕</button>
                      </div>
                    ):(
                      <>
                        <span style={{fontWeight:600,color:"#0f172a",fontSize:".88rem"}}>{c.name}</span>
                        {(clientProfiles||{})[c.name]?.parentGroup&&<span style={{fontSize:".62rem",background:"#eef2ff",color:"#4338ca",border:"1px solid #c7d2fe",borderRadius:20,padding:"1px 7px",fontWeight:700}} title="Parent group">🏛 {(clientProfiles||{})[c.name].parentGroup}</span>}
                        {vvipClients?.has(c.name)&&<span style={{fontSize:".65rem",background:"#fef3c7",color:"#d97706",border:"1px solid #fde68a",borderRadius:20,padding:"1px 7px",fontWeight:700}}>VVIP</span>}
                        {(role==="Manager")&&<button onClick={e=>{e.stopPropagation();setEditClient(c.name);setEditName(c.name);}} style={{background:"none",border:"none",cursor:"pointer",fontSize:".75rem",color:"#94a3b8",padding:"0 2px"}} title="Edit client name">✏️</button>}
                        {saveClientProfile&&<button onClick={e=>{e.stopPropagation();openProfile(c.name);}} style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:5,padding:"1px 7px",cursor:"pointer",fontSize:".65rem",color:"#3b82f6",fontWeight:700}} title="Edit client profile">👤 Profile</button>}
                      </>
                    )}
                  </div>
                  {c.email&&<div style={{fontSize:".72rem",color:"#94a3b8",marginTop:2}}>{c.email}</div>}
                  {hasBalance&&<div style={{fontSize:".72rem",color:"#ef4444",fontWeight:700,marginTop:2}}>⚠ ₱{c.balance.toLocaleString()} outstanding</div>}
                </div>
              </div>
              <div>{(()=>{
                const wonC=clientDeals.filter(d=>!d.isCostCenter&&WON_STAGES.includes(d.stage));
                const wonVal=wonC.reduce((s,d)=>s+Number(d.value||0),0);
                return wonC.length>0?(
                  <div>
                    <div style={{fontWeight:700,color:"#059669",fontSize:".82rem"}}>{wonC.length} project{wonC.length>1?"s":""}</div>
                    <div style={{fontSize:".72rem",color:"#10b981",marginTop:1}}>₱{wonVal.toLocaleString("en-PH")}</div>
                  </div>
                ):<span style={{fontSize:".72rem",color:"#cbd5e1"}}>None yet</span>;
              })()}</div>
              <div>{(()=>{
                const cp=(clientProfiles||{})[c.name]||{};
                const contact=cp.contactPerson||"";
                const phone=cp.phone||cp.mobile||c.phone||"";
                return(
                  <div style={{fontSize:".78rem",color:"#64748b"}}>
                    {contact&&<div style={{fontWeight:600,color:"#0f172a",marginBottom:1}}>{contact}</div>}
                    {phone?<div>{phone}</div>:<span style={{color:"#cbd5e1"}}>—</span>}
                  </div>
                );
              })()}</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {hasDeals?(
                  <span style={{fontSize:".68rem",background:"#f0fdf4",color:"#059669",border:"1px solid #6ee7b7",borderRadius:20,padding:"2px 8px",fontWeight:700}}>
                    {clientDeals.length} deal{clientDeals.length>1?"s":""}
                  </span>
                ):(
                  <span style={{fontSize:".68rem",color:"#cbd5e1"}}>No deals</span>
                )}
                {hasBalance&&(
                  <span style={{fontSize:".68rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:20,padding:"2px 8px",fontWeight:700}}>
                    Balance due
                  </span>
                )}
              </div>
            </div>
          );
        })}
        {filtered.length===0&&(
          <div style={{padding:"32px 0",textAlign:"center",color:"#94a3b8",fontSize:".84rem"}}>
            No clients match your search.
          </div>
        )}
      </div>
      <div style={{marginTop:10,fontSize:".72rem",color:"#94a3b8",textAlign:"right"}}>
        Showing {filtered.length} of {allClients.length} clients
      </div>
      {/* Client History Modal */}
      {selClient&&(()=>{
        const clientDeals=deals.filter(d=>clientKey(d.client)===clientKey(selClient));
        const totalValue=clientDeals.reduce((s,d)=>s+Number(d.value||0),0);
        const totalCollected=clientDeals.reduce((s,d)=>s+Number(d.amountPaid||0),0);
        const isVvip=vvipClients?.has(selClient);
        return(
          <Modal open title={`${isVvip?"⭐ ":""}${selClient}`} onClose={()=>setSelClient(null)} wide>
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:10,marginBottom:16}}>
              {[
                {l:"Total Projects",  v:clientDeals.length,                           c:"#3b82f6"},
                {l:"Total Value",     v:"₱"+totalValue.toLocaleString("en-PH",{minimumFractionDigits:0}), c:"#0f172a"},
                {l:"Total Collected", v:"₱"+totalCollected.toLocaleString("en-PH",{minimumFractionDigits:0}), c:"#059669"},
              ].map(({l,v,c})=>(
                <div key={l} style={{background:"#f8fafc",borderRadius:10,padding:"12px 14px",textAlign:"center"}}>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.2rem",color:c}}>{v}</div>
                  <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:4}}>{l}</div>
                </div>
              ))}
            </div>
            {clientDeals.length===0&&<div style={{textAlign:"center",padding:"24px",color:"#94a3b8"}}>No projects on record.</div>}
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {clientDeals.sort((a,b)=>new Date(b.dateAcquired||0)-new Date(a.dateAcquired||0)).map(d=>(
                <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:"#f8fafc",borderRadius:9,border:"1px solid #e2e8f0",flexWrap:"wrap",gap:8}}>
                  <div>
                    <div style={{fontWeight:600,color:"#0f172a",fontSize:".88rem"}}>{d.contact||d.ceNo||"No project name"}</div>
                    <div style={{fontSize:".72rem",color:"#64748b",marginTop:1}}>{d.ceNo||"CE pending"} · {d.ceType} · {d.dateAcquired||""}</div>
                  </div>
                  <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>₱{Number(d.value||0).toLocaleString("en-PH",{minimumFractionDigits:0})}</span>
                    <span style={{fontSize:".72rem",background:d.paymentStatus==="Paid"?"#f0fdf4":"#f8fafc",color:d.paymentStatus==="Paid"?"#059669":"#94a3b8",border:"1px solid #e2e8f0",borderRadius:20,padding:"2px 9px",fontWeight:600}}>{d.paymentStatus||"—"}</span>
                    <span style={{fontSize:".72rem",color:"#64748b",background:"#f1f5f9",borderRadius:20,padding:"2px 9px"}}>{(d.stage||"").replace(/^[0-9]+ · /,"")}</span>
                  </div>
                </div>
              ))}
            </div>
          </Modal>
        );
      })()}

      {/* ── ADD CLIENT MODAL ─────────────────────────────────────────── */}
      {addOpen&&(
        <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,.5)",zIndex:1100,display:"flex",alignItems:isMobile?"flex-end":"center",justifyContent:"center",padding:isMobile?0:16}} onClick={()=>{setAddOpen(false);setAddForm(EMPTY_ADD);}}>
          <div style={{background:"#fff",borderRadius:isMobile?"18px 18px 0 0":18,padding:isMobile?"20px 16px 28px":28,width:"100%",maxWidth:isMobile?undefined:580,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 24px 80px rgba(0,0,0,.2)"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div>
                <div style={{fontWeight:800,fontSize:"1.05rem",color:"#0f172a"}}>Add New Client</div>
                <div style={{fontSize:".78rem",color:"#64748b",marginTop:2}}>Fill in what you know — you can always update later</div>
              </div>
              <button onClick={()=>{setAddOpen(false);setAddForm(EMPTY_ADD);}} style={{background:"#f1f5f9",border:"none",borderRadius:99,width:32,height:32,cursor:"pointer",fontSize:"1rem",color:"#64748b"}}>✕</button>
            </div>
            <div style={{background:"#f0fdf4",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1.5px solid #6ee7b7"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#059669",marginBottom:8}}>Company / Client Name <span style={{color:"#ef4444"}}>*</span></div>
              <Inp autoFocus value={addForm.name} onChange={e=>fa("name",e.target.value)} onKeyDown={e=>e.key==="Enter"&&doAddClient()} placeholder="Full company or client name…"/>
              <div style={{marginTop:10}}>
                <div style={{fontWeight:700,fontSize:".75rem",color:"#475569",marginBottom:4}}>Parent Group <span style={{fontWeight:400,color:"#94a3b8"}}>(optional — e.g. “Diageo” for a department/subsidiary)</span></div>
                <input list="clientGroupOpts" value={addForm.parentGroup} onChange={e=>fa("parentGroup",e.target.value)} placeholder="Leave blank for a standalone client…" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".85rem",color:"#1e293b",outline:"none",boxSizing:"border-box"}}/>
                <datalist id="clientGroupOpts">{knownGroups.map(g=><option key={g} value={g}/>)}</datalist>
              </div>
            </div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>📇 Name & Contact</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <Fld label="Contact Person"><Inp value={addForm.contactPerson} onChange={e=>fa("contactPerson",e.target.value)} placeholder="e.g. Juan dela Cruz"/></Fld>
                <Fld label="Email"><Inp type="email" value={addForm.email} onChange={e=>fa("email",e.target.value)} placeholder="accounts@company.com"/></Fld>
                <Fld label="Phone"><Inp value={addForm.phone} onChange={e=>fa("phone",e.target.value)} placeholder="+63 2 8xxx xxxx"/></Fld>
                <Fld label="Mobile"><Inp value={addForm.mobile} onChange={e=>fa("mobile",e.target.value)} placeholder="+63 9xx xxx xxxx"/></Fld>
                <Fld label="Website"><Inp value={addForm.website} onChange={e=>fa("website",e.target.value)} placeholder="www.company.com"/></Fld>
              </div>
            </div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>📍 Billing Address</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <div style={{gridColumn:"1/-1"}}><Fld label="Street Address"><Inp value={addForm.billingAddress} onChange={e=>fa("billingAddress",e.target.value)} placeholder="Unit/Floor, Building, Street"/></Fld></div>
                <Fld label="City"><Inp value={addForm.city} onChange={e=>fa("city",e.target.value)} placeholder="Makati"/></Fld>
                <Fld label="Province / Region"><Inp value={addForm.province} onChange={e=>fa("province",e.target.value)} placeholder="Metro Manila"/></Fld>
                <Fld label="ZIP Code"><Inp value={addForm.zipCode} onChange={e=>fa("zipCode",e.target.value)} placeholder="1200"/></Fld>
                <Fld label="Country"><Inp value={addForm.country} onChange={e=>fa("country",e.target.value)} placeholder="Philippines"/></Fld>
              </div>
            </div>
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:16,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>🏢 Business Details</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <Fld label="Client TIN"><Inp value={addForm.tin} onChange={e=>fa("tin",e.target.value)} placeholder="000-000-000-000"/></Fld>
                <Fld label="Payment Terms"><Sel value={addForm.paymentTerms} onChange={e=>fa("paymentTerms",e.target.value)}><option>Due on receipt</option><option>Net 15</option><option>Net 30</option><option>Net 60</option><option>50% DP, Balance on completion</option></Sel></Fld>
                <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={addForm.notes} onChange={e=>fa("notes",e.target.value)} placeholder="Special billing instructions, key contacts…"/></Fld></div>
              </div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={doAddClient} style={{flex:1,background:"#059669",border:"none",borderRadius:9,padding:"11px",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>Add Client</button>
              <button onClick={()=>{setAddOpen(false);setAddForm(EMPTY_ADD);}} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"11px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* ── CLIENT PROFILE MODAL ─────────────────────────────────────── */}
      {profileModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(15,23,42,.5)",zIndex:1100,display:"flex",alignItems:isMobile?"flex-end":"center",justifyContent:"center",padding:isMobile?0:16}} onClick={()=>setProfileModal(null)}>
          <div style={{background:"#fff",borderRadius:isMobile?"18px 18px 0 0":18,padding:isMobile?"20px 16px 28px":28,width:"100%",maxWidth:isMobile?undefined:580,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 24px 80px rgba(0,0,0,.2)"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div>
                <div style={{fontWeight:800,fontSize:"1.05rem",color:"#0f172a"}}>👤 Client Profile</div>
                <div style={{fontSize:".78rem",color:"#64748b",marginTop:2}}>{profileModal}</div>
              </div>
              <button onClick={()=>setProfileModal(null)} style={{background:"#f1f5f9",border:"none",borderRadius:99,width:32,height:32,cursor:"pointer",fontSize:"1rem",color:"#64748b"}}>✕</button>
            </div>

            {/* Name & Contact */}
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>📇 Name & Contact</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <Fld label="Parent Group" hint="e.g. “Diageo” — groups departments/subsidiaries for consolidated reporting">
                  <input list="clientGroupOpts" value={profileForm.parentGroup||""} onChange={e=>fp2("parentGroup",e.target.value)} placeholder="Blank = standalone client" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".85rem",color:"#1e293b",outline:"none",boxSizing:"border-box"}}/>
                  <datalist id="clientGroupOpts">{knownGroups.map(g=><option key={g} value={g}/>)}</datalist>
                </Fld>
                <Fld label="Contact Person"><Inp value={profileForm.contactPerson||""} onChange={e=>fp2("contactPerson",e.target.value)} placeholder="e.g. Juan dela Cruz"/></Fld>
                <Fld label="Email"><Inp type="email" value={profileForm.email||""} onChange={e=>fp2("email",e.target.value)} placeholder="accounts@company.com"/></Fld>
                <Fld label="Phone"><Inp value={profileForm.phone||""} onChange={e=>fp2("phone",e.target.value)} placeholder="+63 2 8xxx xxxx"/></Fld>
                <Fld label="Mobile"><Inp value={profileForm.mobile||""} onChange={e=>fp2("mobile",e.target.value)} placeholder="+63 9xx xxx xxxx"/></Fld>
                <Fld label="Website"><Inp value={profileForm.website||""} onChange={e=>fp2("website",e.target.value)} placeholder="www.company.com"/></Fld>
              </div>
            </div>

            {/* Billing Address */}
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:12,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>📍 Billing Address</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <div style={{gridColumn:"1/-1"}}><Fld label="Street Address"><Inp value={profileForm.billingAddress||""} onChange={e=>fp2("billingAddress",e.target.value)} placeholder="Unit/Floor, Building, Street"/></Fld></div>
                <Fld label="City"><Inp value={profileForm.city||""} onChange={e=>fp2("city",e.target.value)} placeholder="Makati"/></Fld>
                <Fld label="Province / Region"><Inp value={profileForm.province||""} onChange={e=>fp2("province",e.target.value)} placeholder="Metro Manila"/></Fld>
                <Fld label="ZIP Code"><Inp value={profileForm.zipCode||""} onChange={e=>fp2("zipCode",e.target.value)} placeholder="1200"/></Fld>
                <Fld label="Country"><Inp value={profileForm.country||""} onChange={e=>fp2("country",e.target.value)} placeholder="Philippines"/></Fld>
              </div>
            </div>

            {/* Business Details */}
            <div style={{background:"#f8fafc",borderRadius:10,padding:"14px 16px",marginBottom:16,border:"1px solid #e2e8f0"}}>
              <div style={{fontWeight:700,fontSize:".8rem",color:"#475569",marginBottom:10}}>🏢 Business Details</div>
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
                <Fld label="Client TIN"><Inp value={profileForm.tin||""} onChange={e=>fp2("tin",e.target.value)} placeholder="000-000-000-000"/></Fld>
                <Fld label="Payment Terms">
                  <Sel value={profileForm.paymentTerms||"Due on receipt"} onChange={e=>fp2("paymentTerms",e.target.value)}>
                    <option>Due on receipt</option>
                    <option>Net 15</option>
                    <option>Net 30</option>
                    <option>Net 60</option>
                    <option>50% DP, Balance on completion</option>
                  </Sel>
                </Fld>
                <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={profileForm.notes||""} onChange={e=>fp2("notes",e.target.value)} placeholder="Special billing instructions, key contacts…"/></Fld></div>
              </div>
            </div>

            <div style={{display:"flex",gap:10}}>
              {CLIENT_PROFILE_EDITORS.includes(role)?(
                <button onClick={saveProfile} style={{flex:1,background:"#1e293b",border:"none",borderRadius:9,padding:"11px",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",color:"#fff",cursor:"pointer"}}>Save Profile</button>
              ):(
                <div style={{flex:1,alignSelf:"center",fontSize:".78rem",color:"#94a3b8"}}>View only: Sales, Finance or a Manager can edit client profiles.</div>
              )}
              <button onClick={()=>setProfileModal(null)} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"11px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



// ─── EXPORT / IMPORT PANEL ────────────────────────────────────────────────────
function ExportImportPanel({KEYS, onClose}){
  const[importing,  setImporting]  = useState(false);
  const[importMsg,  setImportMsg]  = useState("");
  const[importErr,  setImportErr]  = useState("");

  const ALL_KEYS = [
    {key:KEYS.deals,    label:"Deals / Pipeline"},
    {key:KEYS.projects, label:"Projects & Operations"},
    {key:KEYS.expenses, label:"Expenses"},
    {key:KEYS.inflows,  label:"Inflows / Payments"},
    {key:KEYS.checklist,label:"Checklists"},
    {key:KEYS.swatches, label:"Swatchboard"},
    {key:KEYS.jos,      label:"Job Orders"},
    {key:KEYS.cashPos,  label:"Daily Cash Positions"},
    {key:KEYS.users,    label:"User Accounts"},
  ];

  // Export all data as JSON file
  const handleExport = () => {
    const backup = {
      exportedAt: new Date().toISOString(),
      exportedBy: "FabHub GMD",
      version: "v1",
      data: {}
    };
    ALL_KEYS.forEach(({key, label}) => {
      try {
        const raw = localStorage.getItem(key);
        backup.data[key] = raw ? JSON.parse(raw) : null;
      } catch { backup.data[key] = null; }
    });
    const blob = new Blob([JSON.stringify(backup, null, 2)], {type:"application/json"});
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `GMD_FabHub_Backup_${new Date().toISOString().split("T")[0]}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Import from JSON file
  const handleImport = (e) => {
    const file = e.target.files[0];
    if(!file) return;
    setImporting(true);
    setImportMsg(""); setImportErr("");
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const backup = JSON.parse(ev.target.result);
        if(!backup.data) throw new Error("Invalid backup file — missing data section.");
        let restored = 0;
        ALL_KEYS.forEach(({key}) => {
          if(backup.data[key] !== undefined && backup.data[key] !== null) {
            localStorage.setItem(key, JSON.stringify(backup.data[key]));
            restored++;
          }
        });
        setImportMsg(`✓ ${restored} data sets restored from backup dated ${backup.exportedAt?.split("T")[0]||"unknown"}. Refresh the page to see your data.`);
      } catch(err) {
        setImportErr(`Import failed: ${err.message}`);
      }
      setImporting(false);
    };
    reader.readAsText(file);
    e.target.value = ""; // reset input
  };

  // Show data summary
  const summary = ALL_KEYS.map(({key,label})=>{
    try {
      const raw = localStorage.getItem(key);
      if(!raw) return {label, count:"Empty", hasData:false};
      const parsed = JSON.parse(raw);
      const count = Array.isArray(parsed) ? parsed.length
        : typeof parsed === "object" && parsed !== null ? Object.keys(parsed).length
        : 1;
      return {label, count:`${count} record${count!==1?"s":""}`, hasData:count>0};
    } catch { return {label, count:"Error", hasData:false}; }
  });

  return(
    <div>
      {/* Data summary */}
      <div style={{background:"#f8fafc",borderRadius:10,padding:12,marginBottom:16}}>
        <div style={{fontSize:".68rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:8}}>Current Data in Browser</div>
        {summary.map(({label,count,hasData})=>(
          <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid #e2e8f0",fontSize:".76rem"}}>
            <span style={{color:"#475569"}}>{label}</span>
            <span style={{fontWeight:600,color:hasData?"#059669":"#94a3b8"}}>{count}</span>
          </div>
        ))}
      </div>

      {/* Export */}
      <button onClick={handleExport}
        style={{width:"100%",background:"#1e293b",border:"none",borderRadius:10,padding:"11px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:"#fff",cursor:"pointer",marginBottom:10,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
        ⬇ Download Backup (.json)
      </button>

      {/* Import */}
      <label style={{display:"block",width:"100%",background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:10,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#059669",cursor:"pointer",textAlign:"center",marginBottom:10}}>
        ⬆ Restore from Backup
        <input type="file" accept=".json" onChange={handleImport} style={{display:"none"}}/>
      </label>

      {importing&&<div style={{fontSize:".78rem",color:"#64748b",textAlign:"center",marginBottom:8}}>Restoring…</div>}
      {importMsg&&(
        <div style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:8,padding:"10px 12px",fontSize:".78rem",color:"#059669",marginBottom:8,lineHeight:1.5}}>
          {importMsg}
          <button onClick={()=>window.location.reload()} style={{display:"block",marginTop:8,background:"#059669",border:"none",borderRadius:6,padding:"6px 14px",color:"#fff",fontWeight:700,cursor:"pointer",fontFamily:"inherit",fontSize:".78rem"}}>
            Refresh Now →
          </button>
        </div>
      )}
      {importErr&&<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"10px 12px",fontSize:".78rem",color:"#dc2626",marginBottom:8}}>{importErr}</div>}

      <div style={{fontSize:".68rem",color:"#94a3b8",textAlign:"center",lineHeight:1.5}}>
        Backup is a .json file saved to your computer.<br/>
        Keep it somewhere safe — Google Drive recommended.
      </div>
    </div>
  );
}

// ─── BUDGET VIEW ──────────────────────────────────────────────────────────────
function BudgetView({wonDeals,budgets,saveBudget,prs,exps,role}){
  const[selDeal,setSelDeal]=useState(null);
  const deal = wonDeals.find(d=>d.id===selDeal);
  const budget = budgets[selDeal]||emptyBudget();
  const[form,setForm]=useState(budget);
  const[saved,setSaved]=useState(false);

  useEffect(()=>{
    const b=budgets[selDeal]||emptyBudget();
    setForm(b); setSaved(!!budgets[selDeal]?.savedAt);
  },[selDeal,budgets]);

  const f=(k,v)=>{setSaved(false);setForm(p=>({...p,[k]:v}));};
  const n=v=>Number(String(v).replace(/,/g,""))||0;

  const costFor=useCallback((dealId)=>projectCostBreakdown(dealId,prs,exps),[prs,exps]);

  // Compute per-project budget data for card grid (exclude closed stages)
  const allProjectData=useMemo(()=>{
    return wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed").map(d=>{
      const b=budgets[d.id]||emptyBudget();
      const {committed,actual}=costFor(d.id);
      const totalBudget=BUDGET_CATS.reduce((s,c)=>s+n(b[c]),0);
      const totalActual=BUDGET_CATS.reduce((s,c)=>s+actual[c],0);
      const totalCommitted=BUDGET_CATS.reduce((s,c)=>s+committed[c],0);
      const totalProjected=totalActual+totalCommitted;
      const contractVal=n(d.value)||0;
      const pctUsed=totalBudget>0?Math.round(totalProjected/totalBudget*100):0;
      const grossMargin=contractVal>0?Math.round((contractVal-totalProjected)/contractVal*100):null;
      const isOver=totalBudget>0&&totalProjected>totalBudget;
      const hasBudget=totalBudget>0;
      return{d,b,actuals:actual,committed,totalBudget,totalActual,totalCommitted,totalProjected,contractVal,pctUsed,grossMargin,isOver,hasBudget};
    });
  },[wonDeals,budgets,costFor]);

  // Committed / actual for the selected deal (detail view)
  const {committed,actual:actuals} = useMemo(()=>costFor(selDeal),[costFor,selDeal]);

  const totalBudget = BUDGET_CATS.reduce((s,c)=>s+n(form[c]),0);
  const totalActual = BUDGET_CATS.reduce((s,c)=>s+actuals[c],0);
  const totalCommitted = BUDGET_CATS.reduce((s,c)=>s+committed[c],0);
  const totalProjected = totalActual+totalCommitted;
  const contractVal = n(deal?.value)||0;
  const grossMargin = contractVal>0?Math.round((contractVal-totalProjected)/contractVal*100):0;
  const budgetUsed  = totalBudget>0?Math.round(totalProjected/totalBudget*100):0;
  const linkedPRs   = prs.filter(p=>p.projectId===selDeal&&p.status!=="Cancelled").length;
  const linkedExps  = exps.filter(e=>e.projectId===selDeal).length;

  // Summary KPIs across all projects
  const overBudgetCount=allProjectData.filter(p=>p.isOver).length;
  const noBudgetCount=allProjectData.filter(p=>!p.hasBudget).length;
  const totalAllBudget=allProjectData.reduce((s,p)=>s+p.totalBudget,0);
  const totalAllActual=allProjectData.reduce((s,p)=>s+p.totalActual,0);
  const totalAllCommitted=allProjectData.reduce((s,p)=>s+p.totalCommitted,0);

  // ── CARD GRID VIEW ───────────────────────────────────────────────────────────
  if(!selDeal) return(
    <div>
      <div style={{marginBottom:20}}>
        <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Project Budget</h2>
        <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Click a project to set or update its budget — track actual spend vs plan</div>
      </div>

      {/* Summary KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:20}}>
        {[
          {l:"Total Budget Set", v:fmtPHP(totalAllBudget),                 c:"#3b82f6"},
          {l:"Committed (open POs)",v:fmtPHP(totalAllCommitted),          c:"#a16207"},
          {l:"Actual Spend",     v:fmtPHP(totalAllActual),                c:totalAllActual>totalAllBudget&&totalAllBudget>0?"#ef4444":"#10b981"},
          {l:"Budget Remaining", v:fmtPHP(Math.max(0,totalAllBudget-totalAllActual-totalAllCommitted)), c:(totalAllBudget-totalAllActual-totalAllCommitted)<0?"#ef4444":"#059669"},
          {l:"Over Budget",      v:overBudgetCount,                        c:overBudgetCount>0?"#ef4444":"#059669"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
            <div style={{fontWeight:800,fontSize:typeof v==="number"&&v<1000?"1.5rem":"1rem",color:c,lineHeight:1.2,wordBreak:"break-all"}}>{v}</div>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
          </div>
        ))}
      </div>

      {noBudgetCount>0&&(
        <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"12px 16px",marginBottom:16,fontSize:".8rem",color:"#92400e"}}>
          <div style={{fontWeight:700,marginBottom:6}}>⚠️ {noBudgetCount} project{noBudgetCount!==1?"s":""} have no budget set — click to set:</div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {allProjectData.filter(p=>!p.hasBudget).map(({d})=>(
              <button key={d.id} onClick={()=>setSelDeal(d.id)}
                style={{background:"#fff",border:"1.5px solid #fde68a",borderRadius:8,padding:"4px 12px",fontFamily:"inherit",fontSize:".78rem",fontWeight:600,color:"#92400e",cursor:"pointer"}}>
                {d.contact||d.client}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Project Cards Grid */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:14}}>
        {allProjectData.map(({d,actuals:acts,committed:cmt,totalBudget:tb,totalActual:ta,totalCommitted:tcm,contractVal:cv,pctUsed,grossMargin:gm,isOver,hasBudget})=>{
          const healthClr=isOver?"#ef4444":!hasBudget?"#94a3b8":pctUsed>80?"#f59e0b":"#059669";
          const healthLabel=isOver?"Over Budget":!hasBudget?"No Budget":pctUsed>80?"At Risk":"On Track";
          return(
            <div key={d.id} {...clickable(()=>setSelDeal(d.id))} aria-label={`Open ${d.client||d.contact||"deal"}`}
              style={{background:"#fff",borderRadius:14,border:`1.5px solid ${isOver?"#fecaca":"#e2e8f0"}`,borderLeft:`4px solid ${healthClr}`,padding:"16px 18px",cursor:"pointer",transition:"box-shadow .15s",boxShadow:"0 1px 4px rgba(0,0,0,.04)"}}
              onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(59,130,246,.12)"}
              onMouseLeave={e=>e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.04)"}>

              {/* Header */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".92rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                  {d.contact&&<div style={{fontSize:".68rem",color:"#8b5cf6",marginTop:1}}>📁 {d.client}</div>}
                  <div style={{fontSize:".7rem",color:"#64748b",marginTop:2}}>{d.ceNo||"No CE"}</div>
                </div>
                <span style={{fontSize:".65rem",fontWeight:700,color:healthClr,background:healthClr+"18",border:`1px solid ${healthClr}33`,borderRadius:20,padding:"2px 9px",flexShrink:0,marginLeft:8}}>{healthLabel}</span>
              </div>

              {/* Budget bars */}
              {hasBudget?(
                <>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginBottom:10}}>
                    <div style={{background:"#f8fafc",borderRadius:8,padding:"7px 9px"}}>
                      <div style={{fontSize:".55rem",textTransform:"uppercase",color:"#94a3b8",marginBottom:2,letterSpacing:".3px"}}>Budget</div>
                      <div style={{fontWeight:700,color:"#3b82f6",fontSize:".78rem",lineHeight:1.2}}>{fmtPHP(tb)}</div>
                    </div>
                    <div style={{background:"#fffbeb",borderRadius:8,padding:"7px 9px"}}>
                      <div style={{fontSize:".55rem",textTransform:"uppercase",color:"#a16207",marginBottom:2,letterSpacing:".3px"}}>Committed</div>
                      <div style={{fontWeight:700,color:"#a16207",fontSize:".78rem",lineHeight:1.2}}>{fmtPHP(tcm)}</div>
                    </div>
                    <div style={{background:"#f8fafc",borderRadius:8,padding:"7px 9px"}}>
                      <div style={{fontSize:".55rem",textTransform:"uppercase",color:"#94a3b8",marginBottom:2,letterSpacing:".3px"}}>Actual</div>
                      <div style={{fontWeight:700,color:isOver?"#ef4444":"#10b981",fontSize:".78rem",lineHeight:1.2}}>{fmtPHP(ta)}</div>
                    </div>
                  </div>
                  {/* Progress bar */}
                  <div style={{marginBottom:8}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:".65rem",color:"#94a3b8",marginBottom:3}}>
                      <span>{pctUsed}% committed+spent</span>
                      {gm!==null&&<span style={{color:gm>=20?"#059669":gm>=10?"#f59e0b":"#ef4444",fontWeight:700}}>{gm}% margin</span>}
                    </div>
                    <div style={{height:6,background:"#f1f5f9",borderRadius:3,overflow:"hidden"}}>
                      <div style={{height:"100%",width:Math.min(100,pctUsed)+"%",background:healthClr,borderRadius:3,transition:"width .5s"}}/>
                    </div>
                  </div>
                  {/* Category dots */}
                  <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                    {BUDGET_CATS.map(cat=>{
                      const bcat=Number((budgets[d.id]||{})[cat]||0);
                      const acat=acts[cat]+(cmt[cat]||0);
                      const cpct=bcat>0?Math.round(acat/bcat*100):0;
                      const cc=acat>bcat&&bcat>0?"#ef4444":cpct>80?"#f59e0b":BUDGET_CAT_CLR[cat];
                      return bcat>0?(
                        <span key={cat} style={{fontSize:".65rem",background:cc+"18",color:cc,border:`1px solid ${cc}33`,borderRadius:20,padding:"1px 7px",fontWeight:600}}>
                          {cat} {cpct}%
                        </span>
                      ):null;
                    })}
                  </div>
                </>
              ):(
                <div style={{textAlign:"center",padding:"14px 0",color:"#94a3b8",fontSize:".8rem"}}>
                  No budget set — <span style={{color:"#3b82f6",fontWeight:600}}>click to add</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  // ── DETAIL / EDIT VIEW ───────────────────────────────────────────────────────
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <button onClick={()=>setSelDeal(null)} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"6px 14px",fontFamily:"inherit",fontSize:".82rem",color:"#475569",cursor:"pointer",fontWeight:600,marginBottom:8}}>← All Projects</button>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>{deal?.contact||deal?.client}</h2>
          {deal?.contact&&<div style={{fontSize:".72rem",color:"#8b5cf6",marginTop:1}}>📁 {deal?.client}</div>}
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{deal?.ceNo||"No CE"} · Set budget per category, save to track vs actual spend</div>
        </div>
      </div>

      {/* Data source status */}
      {totalActual===0&&totalBudget>0&&(
        <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"12px 16px",marginBottom:16,fontSize:".82rem",color:"#92400e"}}>
          ⚠️ <strong>Actual Spend shows ₱0</strong> — to populate it, link your expenses and PRs to this project:<br/>
          <span style={{fontWeight:600}}>1.</span> In <em>Expenses</em>, set "Link to Project" to this project.<br/>
          <span style={{fontWeight:600}}>2.</span> In <em>Purchase Orders</em>, set the project and budget category (Materials / Labor / Overhead / Subcon).<br/>
          Currently: <strong>{linkedPRs} PO{linkedPRs!==1?"s":""}</strong> · <strong>{linkedExps} expense{linkedExps!==1?"s":""}</strong> linked to this project.
        </div>
      )}
      {(totalActual>0||totalCommitted>0)&&(
        <div style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:10,padding:"8px 14px",marginBottom:14,fontSize:".78rem",color:"#065f46"}}>
          📊 From <strong>{linkedPRs} PO{linkedPRs!==1?"s":""}</strong> + <strong>{linkedExps} expense{linkedExps!==1?"s":""}</strong> linked to this project. <strong>Committed</strong> = open POs not yet delivered; <strong>Actual</strong> = delivered POs + logged expenses.
        </div>
      )}

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:20}}>
        {[
          {l:"Total Budget",    v:totalBudget>0?fmtPHP(totalBudget):"Not set", c:"#3b82f6"},
          {l:"Committed (open POs)",v:fmtPHP(totalCommitted), c:"#a16207"},
          {l:"Actual Spend",    v:fmtPHP(totalActual),       c:totalActual>totalBudget&&totalBudget>0?"#ef4444":"#10b981"},
          {l:"Budget Remaining",v:totalBudget>0?fmtPHP(totalBudget-totalProjected):"—", c:(totalBudget-totalProjected)<0?"#ef4444":"#059669"},
          {l:"Projected Margin",v:contractVal>0?grossMargin+"%":"—", c:grossMargin>=20?"#059669":grossMargin>=10?"#f59e0b":"#ef4444"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
            <div style={{fontWeight:800,fontSize:"1rem",color:c,lineHeight:1.3,wordBreak:"break-all"}}>{v}</div>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Budget table */}
      <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden",marginBottom:16}}>
        <div style={{display:"grid",gridTemplateColumns:"120px 1fr 1fr 1fr 1fr 70px",background:"#1e293b",padding:"10px 16px",gap:10}}>
          {["Category","Budget (₱)","Committed","Actual","Remaining","% Used"].map(h=>(
            <div key={h} style={{fontSize:".66rem",fontWeight:700,color:"rgba(255,255,255,.6)",textTransform:"uppercase",letterSpacing:".6px"}}>{h}</div>
          ))}
        </div>
        {BUDGET_CATS.map((cat,i)=>{
          const bgt=n(form[cat]);
          const act=actuals[cat];
          const com=committed[cat]||0;
          const projected=act+com;
          const variance=bgt-projected;
          const pct=bgt>0?Math.round(projected/bgt*100):projected>0?999:0;
          return(
            <div key={cat} style={{display:"grid",gridTemplateColumns:"120px 1fr 1fr 1fr 1fr 70px",padding:"12px 16px",gap:10,borderBottom:"1px solid #f1f5f9",background:i%2?"#fafafa":"#fff",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{width:10,height:10,borderRadius:"50%",background:BUDGET_CAT_CLR[cat],flexShrink:0,display:"inline-block"}}/>
                <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{cat}</span>
              </div>
              <div>
                <input
                  value={form[cat]||""}
                  onChange={e=>f(cat,e.target.value)}
                  placeholder="0.00"
                  style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 10px",fontFamily:"inherit",fontSize:".85rem",width:"100%",boxSizing:"border-box",textAlign:"right",outline:"none"}}/>
              </div>
              <div style={{fontWeight:600,color:"#a16207",fontSize:".82rem",textAlign:"right"}}>{com>0?fmtPHP(com):"—"}</div>
              <div style={{fontWeight:600,color:projected>bgt&&bgt>0?"#ef4444":"#10b981",fontSize:".82rem",textAlign:"right"}}>{fmtPHP(act)}</div>
              <div style={{fontWeight:600,color:variance<0?"#ef4444":"#059669",fontSize:".82rem",textAlign:"right"}}>
                {bgt>0?(variance<0?"▼ ":"▲ ")+fmtPHP(Math.abs(variance)):"—"}
              </div>
              <div style={{textAlign:"center"}}>
                <span style={{fontSize:".78rem",fontWeight:700,color:pct>100?"#ef4444":pct>80?"#f59e0b":"#059669"}}>
                  {pct===999?"N/A":pct+"%"}
                </span>
                {bgt>0&&(
                  <div style={{height:4,background:"#f1f5f9",borderRadius:2,marginTop:4,overflow:"hidden"}}>
                    <div style={{height:"100%",width:Math.min(pct,100)+"%",background:pct>100?"#ef4444":pct>80?"#f59e0b":"#10b981",borderRadius:2}}/>
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {/* Totals row */}
        <div style={{display:"grid",gridTemplateColumns:"120px 1fr 1fr 1fr 1fr 70px",padding:"12px 16px",gap:10,background:"#1e293b",alignItems:"center"}}>
          <div style={{fontWeight:700,color:"#f59e0b",fontSize:".85rem"}}>TOTAL</div>
          <div style={{fontWeight:800,color:"#fff",fontSize:".82rem",textAlign:"right"}}>{fmtPHP(totalBudget)}</div>
          <div style={{fontWeight:800,color:"#fcd34d",fontSize:".82rem",textAlign:"right"}}>{fmtPHP(totalCommitted)}</div>
          <div style={{fontWeight:800,color:totalProjected>totalBudget?"#f87171":"#4ade80",fontSize:".82rem",textAlign:"right"}}>{fmtPHP(totalActual)}</div>
          <div style={{fontWeight:800,color:totalBudget-totalProjected<0?"#f87171":"#4ade80",fontSize:".82rem",textAlign:"right"}}>
            {totalBudget>0?(totalBudget-totalProjected<0?"▼ ":"▲ ")+fmtPHP(Math.abs(totalBudget-totalProjected)):"—"}
          </div>
          <div style={{textAlign:"center",fontWeight:800,color:budgetUsed>100?"#f87171":"#4ade80",fontSize:".85rem"}}>{budgetUsed}%</div>
        </div>
      </div>

      {/* Notes + Save */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:16,marginBottom:12}}>
        <div style={{fontWeight:700,color:"#475569",fontSize:".78rem",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>Budget Notes</div>
        <textarea value={form.notes||""} onChange={e=>f("notes",e.target.value)}
          placeholder="e.g. Includes mobilization, based on approved CE dated…"
          rows={2} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".85rem",color:"#1e293b",resize:"vertical",outline:"none",boxSizing:"border-box"}}/>
      </div>
      <div style={{display:"flex",gap:10,alignItems:"center"}}>
        <button onClick={()=>{saveBudget(selDeal,form);setSaved(true);}}
          style={{background:"#1e293b",border:"none",borderRadius:10,padding:"10px 24px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:"#fff",cursor:"pointer"}}>
          {saved?"✓ Saved":"Save Budget"}
        </button>
        {budget.savedAt&&<span style={{fontSize:".72rem",color:"#94a3b8"}}>Last saved {new Date(budget.savedAt).toLocaleDateString("en-PH")}</span>}
        {totalProjected>totalBudget&&totalBudget>0&&(
          <span style={{fontSize:".78rem",color:"#ef4444",fontWeight:700}}>⚠️ Committed + actual exceeds budget by {fmtPHP(totalProjected-totalBudget)}</span>
        )}
      </div>
    </div>
  );
}

// ─── CE/QS QUEUE VIEW ─────────────────────────────────────────────────────────
function CEQSView({ceReqs,addCEReq,updateCEReq,session,role,toastEmit,deals}){
  const n=v=>Number(String(v||0).replace(/,/g,""))||0;
  const fmtPHP2=v=>v?("₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0})):"—";
  const[tab,setTab]=React.useState("queue");
  const[showForm,setShowForm]=React.useState(false);
  const[editId,setEditId]=React.useState(null);
  const[detailId,setDetailId]=React.useState(null);
  const[trackQ,setTrackQ]=React.useState("");
  const[trackStatus,setTrackStatus]=React.useState("All");
  const[trackPriority,setTrackPriority]=React.useState("All");
  const isQS=["Manager","QS"].includes(role);
  const isSales=["Manager","Sales","SalesOpsAdmin"].includes(role);
  const TYPES={kiosk:"Kiosk",retail:"Retail Fit-out",office:"Office",fnb:"F&B / Restaurant",signage:"Signage",event:"Event / Activation",repair:"Repair / Refurb",other:"Other"};
  const PRI_CLR={High:"#ef4444",Normal:"#3b82f6",Low:"#94a3b8"};
  const STATUS_CLR={Pending:"#f59e0b",Ongoing:"#3b82f6",Done:"#10b981"};
  const AWARDED_CLR={Won:"#10b981",Lost:"#ef4444",Pending:"#94a3b8"};
  const emptyForm=()=>({clientName:"",projectName:"",location:"",projectType:"retail",priority:"Normal",targetDeadline:"",submissionDeadline:"",targetBudget:"",targetMargin:"",plansLink:"",skpLink:"",scheduleOfFinish:"",notes:"",ceNotes:"",bidAmount:"",bidMarginPct:"",awarded:"Pending",awardDate:""});
  const[form,setForm]=React.useState(emptyForm());
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const openNew=()=>{setForm(emptyForm());setEditId(null);setShowForm(true);};
  const openEdit=r=>{setForm({clientName:r.clientName||"",projectName:r.projectName||"",location:r.location||"",projectType:r.projectType||"retail",priority:r.priority||"Normal",targetDeadline:r.targetDeadline||"",submissionDeadline:r.submissionDeadline||"",targetBudget:r.targetBudget||"",targetMargin:r.targetMargin||"",plansLink:r.plansLink||"",skpLink:r.skpLink||"",scheduleOfFinish:r.scheduleOfFinish||"",notes:r.notes||"",ceNotes:r.ceNotes||"",bidAmount:r.bidAmount||"",bidMarginPct:r.bidMarginPct||"",awarded:r.awarded||"Pending",awardDate:r.awardDate||""});setEditId(r.id);setShowForm(true);};
  const handleSave=async()=>{
    if(!form.clientName.trim()){alert("Client name is required.");return;}
    const rec={client_name:form.clientName.trim(),project_name:form.projectName,location:form.location,project_type:form.projectType,priority:form.priority,submitted_by:session?.name||role||"",target_deadline:form.targetDeadline||null,submission_deadline:form.submissionDeadline||null,target_budget:n(form.targetBudget)||null,target_margin:n(form.targetMargin)||null,plans_link:form.plansLink,skp_link:form.skpLink,schedule_of_finish:form.scheduleOfFinish,notes:form.notes,ce_notes:form.ceNotes,bid_amount:n(form.bidAmount)||null,bid_margin_pct:n(form.bidMarginPct)||null,awarded:form.awarded,award_date:form.awardDate||null,updated_at:new Date().toISOString()};
    if(editId){await updateCEReq(editId,rec);}else{await addCEReq({...rec,status:"Pending"});}
    setShowForm(false);toastEmit?.("Saved","success");
  };
  const setStatus=(id,status)=>updateCEReq(id,{status,updated_at:new Date().toISOString()});
  const setAwarded=(id,awarded)=>updateCEReq(id,{awarded,award_date:awarded!=="Pending"?new Date().toISOString().split("T")[0]:null,updated_at:new Date().toISOString()});
  const daysDiff=d=>{if(!d)return null;const diff=Math.round((new Date(d)-new Date())/(864e5));return diff;};
  const daysLabel=d=>{const diff=daysDiff(d);if(diff===null)return null;if(diff<0)return{txt:`${Math.abs(diff)}d overdue`,clr:"#ef4444"};if(diff===0)return{txt:"Due today",clr:"#f59e0b"};return{txt:`${diff}d left`,clr:diff<=3?"#f59e0b":"#64748b"};};

  const pending=ceReqs.filter(r=>r.status==="Pending");
  const ongoing=ceReqs.filter(r=>r.status==="Ongoing");
  const done=ceReqs.filter(r=>r.status==="Done");
  const submitted=done.filter(r=>r.bidAmount>0||r.awarded!=="Pending");
  const won=submitted.filter(r=>r.awarded==="Won");
  const lost=submitted.filter(r=>r.awarded==="Lost");
  const winRate=submitted.length?Math.round(won.length/submitted.length*100):0;
  const avgMarginWon=won.length?Math.round(won.reduce((s,r)=>s+Number(r.bidMarginPct||0),0)/won.length):0;
  const byType=Object.entries(TYPES).map(([k,label])=>{const sub=submitted.filter(r=>r.projectType===k);const w=sub.filter(r=>r.awarded==="Won");return{key:k,label,total:sub.length,won:w.length,rate:sub.length?Math.round(w.length/sub.length*100):0};}).filter(x=>x.total>0);

  // ── Tracking hub: deal linking, master list, SLA ──
  const dealById=id=>id?(deals||[]).find(d=>String(d.id)===String(id)):null;
  const nowMs=Date.now();
  const trackRows=React.useMemo(()=>{
    const qq=trackQ.trim().toLowerCase();
    return [...ceReqs]
      .filter(r=>trackStatus==="All"||r.status===trackStatus)
      .filter(r=>trackPriority==="All"||r.priority===trackPriority)
      .filter(r=>!qq||[r.clientName,r.projectName,r.submittedBy,r.location].some(v=>String(v||"").toLowerCase().includes(qq)))
      .sort((a,b)=>new Date(b.createdAt||0)-new Date(a.createdAt||0));
  },[ceReqs,trackQ,trackStatus,trackPriority]);
  const openReqs=ceReqs.filter(r=>r.status!=="Done");
  const overdueCount=openReqs.filter(r=>r.targetDeadline&&new Date(r.targetDeadline).getTime()<nowMs).length;
  const dueSoonCount=openReqs.filter(r=>{const dd=daysDiff(r.targetDeadline);return dd!==null&&dd>=0&&dd<=3;}).length;
  const agingCount=openReqs.filter(r=>r.createdAt&&(nowMs-new Date(r.createdAt).getTime())/864e5>14).length;
  const exportTracking=()=>{
    if(!window.XLSX){toastEmit?.("Excel library still loading — please try again in a moment","error");return;}
    const wb=window.XLSX.utils.book_new();
    const header=["Client","Project","Location","Type","Priority","Status","Submitted By","Submitted","Days Pending","Target Deadline","Deadline Status","Submission Deadline","Linked Deal","Deal Stage","CE Outcome","Bid Amount","Margin %","Notes"];
    const body=trackRows.map(r=>{
      const d=dealById(r.dealId);
      const dp=r.createdAt?Math.round((nowMs-new Date(r.createdAt).getTime())/864e5):"";
      const dl=daysLabel(r.targetDeadline);
      return [r.clientName||"",r.projectName||"",r.location||"",TYPES[r.projectType]||r.projectType||"",r.priority||"",r.status||"",r.submittedBy||"",r.createdAt?String(r.createdAt).slice(0,10):"",dp,r.targetDeadline||"",dl?dl.txt:"",r.submissionDeadline||"",d?(projDisplayName(d)||d.client||""):"",d?d.stage:"",r.awarded||"",r.bidAmount||"",r.bidMarginPct||"",r.notes||""];
    });
    window.XLSX.utils.book_append_sheet(wb,window.XLSX.utils.aoa_to_sheet([header,...body]),"CE Tracking");
    window.XLSX.writeFile(wb,`CE-Tracking-${new Date().toISOString().slice(0,10)}.xlsx`);
    toastEmit?.(`Exported ${trackRows.length} request${trackRows.length!==1?"s":""}`,"success");
  };

  const Card=({r})=>{
    const dl=daysLabel(r.targetDeadline);
    const daysPending=r.createdAt?Math.round((new Date()-new Date(r.createdAt))/(864e5)):null;
    return(
      <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 14px",marginBottom:8,cursor:"pointer"}} onClick={()=>setDetailId(r.id===detailId?null:r.id)}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.clientName}</div>
            {r.projectName&&<div style={{fontSize:".72rem",color:"#64748b",marginTop:2}}>{r.projectName}</div>}
          </div>
          <span style={{background:PRI_CLR[r.priority]+"22",color:PRI_CLR[r.priority],borderRadius:5,padding:"2px 7px",fontSize:".65rem",fontWeight:700,flexShrink:0}}>{r.priority}</span>
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>
          <span style={{background:"#f1f5f9",color:"#475569",borderRadius:5,padding:"2px 7px",fontSize:".67rem",fontWeight:600}}>{TYPES[r.projectType]||r.projectType}</span>
          {r.targetBudget>0&&<span style={{background:"#f0fdf4",color:"#059669",borderRadius:5,padding:"2px 7px",fontSize:".67rem",fontWeight:600}}>{fmtPHP2(r.targetBudget)}</span>}
          {r.targetMargin>0&&<span style={{background:"#eff6ff",color:"#3b82f6",borderRadius:5,padding:"2px 7px",fontSize:".67rem",fontWeight:600}}>{r.targetMargin}% margin</span>}
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8,gap:8}}>
          <div style={{fontSize:".67rem",color:"#94a3b8"}}>{r.submittedBy}{daysPending!==null?` · ${daysPending}d ago`:""}</div>
          {dl&&<span style={{fontSize:".67rem",fontWeight:700,color:dl.clr}}>{dl.txt}</span>}
        </div>
        {detailId===r.id&&(
          <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid #f1f5f9",display:"flex",flexDirection:"column",gap:6}}>
            {r.location&&<div style={{fontSize:".72rem",color:"#475569"}}>📍 {r.location}</div>}
            {r.submissionDeadline&&<div style={{fontSize:".72rem",color:"#475569"}}>📅 Submit by: {r.submissionDeadline}</div>}
            {r.plansLink&&<div style={{fontSize:".72rem"}}><a href={r.plansLink.startsWith("http")?r.plansLink:"#"} target="_blank" rel="noreferrer" style={{color:"#3b82f6"}}>🗺 Plans link</a></div>}
            {r.skpLink&&<div style={{fontSize:".72rem"}}><a href={r.skpLink.startsWith("http")?r.skpLink:"#"} target="_blank" rel="noreferrer" style={{color:"#3b82f6"}}>📐 SKP file link</a></div>}
            {r.scheduleOfFinish&&<div style={{fontSize:".72rem",color:"#475569"}}>📋 {r.scheduleOfFinish}</div>}
            {r.notes&&<div style={{fontSize:".72rem",color:"#475569",background:"#f8fafc",borderRadius:6,padding:"6px 8px"}}>{r.notes}</div>}
            {r.ceNotes&&isQS&&<div style={{fontSize:".72rem",color:"#7c3aed",background:"#f5f3ff",borderRadius:6,padding:"6px 8px",fontStyle:"italic"}}>📐 CE Notes: {r.ceNotes}</div>}
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:4}}>
              {isQS&&r.status==="Pending"&&<button onClick={e=>{e.stopPropagation();setStatus(r.id,"Ongoing");}} style={{background:"#3b82f6",border:"none",borderRadius:6,padding:"5px 10px",color:"#fff",fontFamily:"inherit",fontSize:".72rem",fontWeight:700,cursor:"pointer"}}>→ Start</button>}
              {isQS&&r.status==="Ongoing"&&<button onClick={e=>{e.stopPropagation();setStatus(r.id,"Done");}} style={{background:"#10b981",border:"none",borderRadius:6,padding:"5px 10px",color:"#fff",fontFamily:"inherit",fontSize:".72rem",fontWeight:700,cursor:"pointer"}}>✓ Mark Done</button>}
              {isQS&&r.status==="Ongoing"&&<button onClick={e=>{e.stopPropagation();setStatus(r.id,"Pending");}} style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",color:"#64748b",fontFamily:"inherit",fontSize:".72rem",cursor:"pointer"}}>← Back to Pending</button>}
              {(isQS||isSales)&&<button onClick={e=>{e.stopPropagation();openEdit(r);}} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:6,padding:"5px 10px",color:"#475569",fontFamily:"inherit",fontSize:".72rem",cursor:"pointer"}}>✏ Edit</button>}
            </div>
          </div>
        )}
      </div>
    );
  };

  return(
    <div style={{padding:"0 0 40px"}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,gap:12,flexWrap:"wrap"}}>
        <div>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>📐 CE / QS Queue</div>
          <div style={{fontSize:".78rem",color:"#64748b",marginTop:2}}>Cost estimation requests — {pending.length} pending · {ongoing.length} ongoing · {done.length} done</div>
        </div>
        {(isQS||isSales)&&<button onClick={openNew} style={{background:"#7c3aed",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>+ Submit CE Request</button>}
      </div>
      {/* Summary strip */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:10,marginBottom:20}}>
        {[["Pending",pending.length,"#f59e0b"],["Ongoing",ongoing.length,"#3b82f6"],["Done",done.length,"#10b981"],["Win Rate",submitted.length?winRate+"%":"—","#8b5cf6"]].map(([l,v,c])=>(
          <div key={l} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 14px"}}>
            <div style={{fontSize:".65rem",color:"#64748b",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px"}}>{l}</div>
            <div style={{fontSize:"1.4rem",fontWeight:800,color:c,marginTop:4}}>{v}</div>
          </div>
        ))}
      </div>
      {/* Tabs */}
      <div style={{display:"flex",gap:4,marginBottom:16,borderBottom:"1.5px solid #e2e8f0",paddingBottom:8}}>
        {[["queue","📋 Queue"],["tracking","🗂 Tracking"],["winloss","🏆 Win/Loss"],["analysis","📊 Analysis"]].map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t)} style={{background:tab===t?"#1e293b":"transparent",border:"none",borderRadius:7,padding:"6px 16px",fontFamily:"inherit",fontSize:".78rem",fontWeight:tab===t?700:500,color:tab===t?"#fff":"#64748b",cursor:"pointer"}}>{l}</button>
        ))}
      </div>

      {/* ── QUEUE TAB ── */}
      {tab==="queue"&&(
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16,alignItems:"start"}}>
          {[["Pending",pending,"#f59e0b"],["Ongoing",ongoing,"#3b82f6"],["Done",done,"#10b981"]].map(([label,list,clr])=>(
            <div key={label}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                <span style={{width:10,height:10,borderRadius:"50%",background:clr,display:"inline-block"}}/>
                <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{label}</span>
                <span style={{background:clr+"22",color:clr,borderRadius:20,padding:"1px 8px",fontSize:".7rem",fontWeight:700}}>{list.length}</span>
              </div>
              {list.length===0&&<div style={{fontSize:".78rem",color:"#94a3b8",padding:"20px 0",textAlign:"center"}}>No {label.toLowerCase()} requests</div>}
              {[...list].sort((a,b)=>{
                const pa={High:0,Normal:1,Low:2};
                const pdiff=(pa[a.priority]||1)-(pa[b.priority]||1);
                if(pdiff!==0) return pdiff;
                // secondary: overdue deadline first, then oldest submission
                const aDL=a.targetDeadline?new Date(a.targetDeadline):null;
                const bDL=b.targetDeadline?new Date(b.targetDeadline):null;
                const now=new Date();
                const aOver=aDL&&aDL<now;const bOver=bDL&&bDL<now;
                if(aOver&&!bOver) return -1;
                if(!aOver&&bOver) return 1;
                if(aDL&&bDL) return aDL-bDL;
                const aAge=a.createdAt?new Date(a.createdAt):new Date(0);
                const bAge=b.createdAt?new Date(b.createdAt):new Date(0);
                return aAge-bAge; // older first
              }).map(r=><Card key={r.id} r={r}/>)}
            </div>
          ))}
        </div>
      )}

      {/* ── TRACKING TAB ── master list, deal linking, SLA/deadline tracking */}
      {tab==="tracking"&&(
        <div>
          {/* SLA summary */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:10,marginBottom:16}}>
            {[["Overdue",overdueCount,"#ef4444"],["Due ≤ 3 days",dueSoonCount,"#f59e0b"],["Aging > 14 days",agingCount,"#64748b"],["Total Requests",ceReqs.length,"#8b5cf6"]].map(([l,v,c])=>(
              <div key={l} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 14px"}}>
                <div style={{fontSize:".62rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px"}}>{l}</div>
                <div style={{fontSize:"1.3rem",fontWeight:800,color:c,marginTop:4}}>{v}</div>
              </div>
            ))}
          </div>
          {/* Toolbar */}
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:10}}>
            <input value={trackQ} onChange={e=>setTrackQ(e.target.value)} placeholder="Search client, project, submitter…" style={{flex:"1 1 220px",minWidth:0,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".82rem",outline:"none"}}/>
            <select value={trackStatus} onChange={e=>setTrackStatus(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".8rem",background:"#fff",outline:"none"}}>
              {["All","Pending","Ongoing","Done"].map(s=><option key={s} value={s}>{s==="All"?"All statuses":s}</option>)}
            </select>
            <select value={trackPriority} onChange={e=>setTrackPriority(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".8rem",background:"#fff",outline:"none"}}>
              {["All","High","Normal","Low"].map(s=><option key={s} value={s}>{s==="All"?"All priorities":s}</option>)}
            </select>
            <button onClick={exportTracking} style={{background:"#059669",border:"none",borderRadius:8,padding:"8px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>⬇ Export Excel</button>
          </div>
          <div style={{fontSize:".72rem",color:"#94a3b8",marginBottom:8}}>{trackRows.length} of {ceReqs.length} shown</div>
          {/* Master table */}
          <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",minWidth:900}}>
              <thead><tr style={{background:"#f8fafc"}}>{["Client / Project","Type","Priority","Status","Submitted","Aging","Target Deadline","Linked Deal","Outcome",""].map(h=><th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:".66rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1.5px solid #e2e8f0",whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
              <tbody>
                {trackRows.length===0&&<tr><td colSpan={10} style={{padding:"40px",textAlign:"center",color:"#94a3b8",fontSize:".85rem"}}>No requests match your filters.</td></tr>}
                {trackRows.map(r=>{
                  const d=dealById(r.dealId);
                  const dl=daysLabel(r.targetDeadline);
                  const isOpen=r.status!=="Done";
                  const dp=r.createdAt?Math.round((nowMs-new Date(r.createdAt).getTime())/864e5):null;
                  return(
                    <tr key={r.id} style={{borderBottom:"1px solid #f1f5f9"}}>
                      <td style={{padding:"9px 12px"}}>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{r.clientName}</div>
                        {r.projectName&&<div style={{fontSize:".7rem",color:"#94a3b8"}}>{r.projectName}</div>}
                      </td>
                      <td style={{padding:"9px 12px",fontSize:".76rem",color:"#475569",whiteSpace:"nowrap"}}>{TYPES[r.projectType]||r.projectType}</td>
                      <td style={{padding:"9px 12px"}}><span style={{background:PRI_CLR[r.priority]+"22",color:PRI_CLR[r.priority],borderRadius:5,padding:"2px 7px",fontSize:".66rem",fontWeight:700}}>{r.priority}</span></td>
                      <td style={{padding:"9px 12px"}}><span style={{background:STATUS_CLR[r.status]+"22",color:STATUS_CLR[r.status],borderRadius:5,padding:"2px 7px",fontSize:".66rem",fontWeight:700}}>{r.status}</span></td>
                      <td style={{padding:"9px 12px",fontSize:".74rem",color:"#64748b",whiteSpace:"nowrap"}}>
                        <div>{r.createdAt?String(r.createdAt).slice(0,10):"—"}</div>
                        {r.submittedBy&&<div style={{fontSize:".68rem",color:"#94a3b8"}}>{r.submittedBy}</div>}
                      </td>
                      <td style={{padding:"9px 12px",fontSize:".74rem",color:(isOpen&&dp>14)?"#ef4444":"#64748b",fontWeight:(isOpen&&dp>14)?700:400,whiteSpace:"nowrap"}}>{dp!==null?`${dp}d`:"—"}</td>
                      <td style={{padding:"9px 12px",fontSize:".74rem",whiteSpace:"nowrap"}}>
                        {r.targetDeadline?(<><span style={{color:"#475569"}}>{r.targetDeadline}</span>{isOpen&&dl&&<div style={{fontSize:".68rem",fontWeight:700,color:dl.clr}}>{dl.txt}</div>}</>):<span style={{color:"#cbd5e1"}}>—</span>}
                      </td>
                      <td style={{padding:"9px 12px",fontSize:".74rem"}}>
                        {d?(<><div style={{color:"#0f172a",fontWeight:600}}>{projDisplayName(d)||d.client}</div><div style={{fontSize:".66rem",color:"#94a3b8"}}>{d.stage}</div></>):<span style={{color:"#cbd5e1"}}>—</span>}
                      </td>
                      <td style={{padding:"9px 12px",fontSize:".74rem",whiteSpace:"nowrap"}}>
                        <span style={{background:AWARDED_CLR[r.awarded||"Pending"]+"22",color:AWARDED_CLR[r.awarded||"Pending"],borderRadius:5,padding:"2px 7px",fontSize:".66rem",fontWeight:700}}>{r.awarded||"Pending"}</span>
                        {r.bidAmount>0&&<div style={{fontSize:".68rem",color:"#059669",fontWeight:700,marginTop:2}}>{fmtPHP2(r.bidAmount)}</div>}
                      </td>
                      <td style={{padding:"9px 12px",whiteSpace:"nowrap"}}>
                        {(isQS||isSales)&&<button onClick={()=>openEdit(r)} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:6,padding:"4px 9px",color:"#475569",fontFamily:"inherit",fontSize:".7rem",cursor:"pointer"}}>✏</button>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── WIN/LOSS TAB ── */}
      {tab==="winloss"&&(
        <div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10,marginBottom:20}}>
            {[["Submitted",submitted.length,"#475569"],["Won",won.length,"#10b981"],["Lost",lost.length,"#ef4444"],["Win Rate",submitted.length?winRate+"%":"—","#8b5cf6"],["Avg Margin (Won)",won.length?avgMarginWon+"%":"—","#059669"]].map(([l,v,c])=>(
              <div key={l} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 14px"}}>
                <div style={{fontSize:".62rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px"}}>{l}</div>
                <div style={{fontSize:"1.3rem",fontWeight:800,color:c,marginTop:4}}>{v}</div>
              </div>
            ))}
          </div>
          {submitted.length===0?(
            <div style={{textAlign:"center",padding:"60px 0",color:"#94a3b8",fontSize:".88rem"}}>No completed CEs with bid data yet.<br/>Mark a request as Done and add bid details to track win/loss.</div>
          ):(
            <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{background:"#f8fafc"}}>{["Client","Type","Bid Amount","Margin","Status","Outcome"].map(h=><th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1.5px solid #e2e8f0"}}>{h}</th>)}</tr></thead>
                <tbody>
                  {submitted.sort((a,b)=>new Date(b.createdAt||0)-new Date(a.createdAt||0)).map(r=>(
                    <tr key={r.id} style={{borderBottom:"1px solid #f1f5f9"}}>
                      <td style={{padding:"10px 14px"}}>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{r.clientName}</div>
                        {r.projectName&&<div style={{fontSize:".7rem",color:"#94a3b8"}}>{r.projectName}</div>}
                      </td>
                      <td style={{padding:"10px 14px",fontSize:".78rem",color:"#475569"}}>{TYPES[r.projectType]||r.projectType}</td>
                      <td style={{padding:"10px 14px",fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>{fmtPHP2(r.bidAmount)}</td>
                      <td style={{padding:"10px 14px",fontSize:".82rem",color:r.bidMarginPct>=20?"#059669":r.bidMarginPct>=10?"#f59e0b":"#ef4444",fontWeight:700}}>{r.bidMarginPct?r.bidMarginPct+"%":"—"}</td>
                      <td style={{padding:"10px 14px"}}>
                        <span style={{background:STATUS_CLR[r.status]+"22",color:STATUS_CLR[r.status],borderRadius:5,padding:"2px 8px",fontSize:".7rem",fontWeight:700}}>{r.status}</span>
                      </td>
                      <td style={{padding:"10px 14px"}}>
                        {isSales?(
                          <select value={r.awarded} onChange={e=>setAwarded(r.id,e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:6,padding:"4px 8px",fontFamily:"inherit",fontSize:".75rem",outline:"none",background:"#fff",color:AWARDED_CLR[r.awarded],fontWeight:700}}>
                            <option value="Pending">Pending</option>
                            <option value="Won">Won</option>
                            <option value="Lost">Lost</option>
                          </select>
                        ):(
                          <span style={{background:AWARDED_CLR[r.awarded]+"22",color:AWARDED_CLR[r.awarded],borderRadius:5,padding:"2px 8px",fontSize:".7rem",fontWeight:700}}>{r.awarded}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── ANALYSIS TAB ── */}
      {tab==="analysis"&&(
        <div>
          {byType.length===0?(
            <div style={{textAlign:"center",padding:"60px 0",color:"#94a3b8",fontSize:".88rem"}}>No data yet — win/loss outcomes will appear here once CEs are submitted and marked Won or Lost.</div>
          ):(
            <div>
              <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".88rem"}}>Win Rate by Project Type</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:12,marginBottom:24}}>
                {byType.sort((a,b)=>b.rate-a.rate).map(x=>(
                  <div key={x.key} style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"14px 16px"}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",marginBottom:6}}>{x.label}</div>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                      <div style={{flex:1,height:8,borderRadius:4,background:"#f1f5f9",overflow:"hidden"}}>
                        <div style={{width:x.rate+"%",height:"100%",background:x.rate>=60?"#10b981":x.rate>=40?"#f59e0b":"#ef4444",borderRadius:4,transition:"width .4s"}}/>
                      </div>
                      <span style={{fontWeight:800,color:x.rate>=60?"#10b981":x.rate>=40?"#f59e0b":"#ef4444",fontSize:".88rem",flexShrink:0}}>{x.rate}%</span>
                    </div>
                    <div style={{fontSize:".7rem",color:"#94a3b8"}}>{x.won} won · {x.total-x.won} lost · {x.total} total</div>
                  </div>
                ))}
              </div>
              <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".88rem"}}>All Submitted CEs ({submitted.length})</div>
              <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:8,fontSize:".72rem",color:"#64748b"}}>
                <span>Total bid value: <b style={{color:"#0f172a"}}>₱{submitted.reduce((s,r)=>s+Number(r.bidAmount||0),0).toLocaleString("en-PH",{maximumFractionDigits:0})}</b></span>
                <span>Won value: <b style={{color:"#10b981"}}>₱{won.reduce((s,r)=>s+Number(r.bidAmount||0),0).toLocaleString("en-PH",{maximumFractionDigits:0})}</b></span>
                <span>Avg margin (won): <b style={{color:"#059669"}}>{avgMarginWon}%</b></span>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── FORM MODAL ── */}
      {showForm&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:10020,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:16,overflowY:"auto"}}>
          <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:640,boxShadow:"0 24px 64px rgba(0,0,0,.3)",marginBottom:24}}>
            <div style={{background:"#1e293b",borderRadius:"16px 16px 0 0",padding:"14px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontWeight:800,color:"#fff",fontSize:".95rem"}}>{editId?"Edit CE Request":"New CE Request"}</div>
              <button onClick={()=>setShowForm(false)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:8,padding:"5px 12px",color:"rgba(255,255,255,.7)",cursor:"pointer",fontSize:".82rem",fontWeight:600}}>✕</button>
            </div>
            <div style={{padding:"18px 20px 20px",display:"flex",flexDirection:"column",gap:12}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Client Name *</label>
                  <input value={form.clientName} onChange={e=>f("clientName",e.target.value)} placeholder="e.g. BINI — SM Seaside Cebu" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Project Name</label>
                  <input value={form.projectName} onChange={e=>f("projectName",e.target.value)} placeholder="e.g. Phase 2 Fit-out" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Location</label>
                  <input value={form.location} onChange={e=>f("location",e.target.value)} placeholder="e.g. SM Seaside, Cebu" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Project Type</label>
                  <select value={form.projectType} onChange={e=>f("projectType",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",background:"#fff",boxSizing:"border-box"}}>
                    {Object.entries(TYPES).map(([k,v])=><option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Priority</label>
                  <select value={form.priority} onChange={e=>f("priority",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",background:"#fff",boxSizing:"border-box"}}>
                    <option>High</option><option>Normal</option><option>Low</option>
                  </select>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>CE Deadline</label>
                  <input type="date" value={form.targetDeadline} onChange={e=>f("targetDeadline",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Proposal Submission Deadline</label>
                  <input type="date" value={form.submissionDeadline} onChange={e=>f("submissionDeadline",e.target.value)} style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Target Budget (₱)</label>
                  <input type="number" value={form.targetBudget} onChange={e=>f("targetBudget",e.target.value)} placeholder="0" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Target Margin (%)</label>
                  <input type="number" value={form.targetMargin} onChange={e=>f("targetMargin",e.target.value)} placeholder="e.g. 25" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Plans Link (Google Drive, etc.)</label>
                  <input value={form.plansLink} onChange={e=>f("plansLink",e.target.value)} placeholder="https://drive.google.com/..." style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>SKP File Link</label>
                  <input value={form.skpLink} onChange={e=>f("skpLink",e.target.value)} placeholder="https://..." style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Schedule of Finish</label>
                  <input value={form.scheduleOfFinish} onChange={e=>f("scheduleOfFinish",e.target.value)} placeholder="e.g. Standard finish, no special cladding" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={{fontSize:".68rem",fontWeight:700,color:"#64748b",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Notes for CE/QS (from Sales)</label>
                  <textarea value={form.notes} onChange={e=>f("notes",e.target.value)} rows={3} placeholder="Scope clarifications, special requirements, client preferences..." style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>
                </div>
                {isQS&&<>
                  <div style={{gridColumn:"1/-1",borderTop:"1.5px solid #e2e8f0",paddingTop:10,marginTop:2}}>
                    <div style={{fontSize:".72rem",fontWeight:700,color:"#7c3aed",marginBottom:8}}>📐 CE/QS Fields</div>
                  </div>
                  <div style={{gridColumn:"1/-1"}}>
                    <label style={{fontSize:".68rem",fontWeight:700,color:"#7c3aed",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>CE Notes (internal)</label>
                    <textarea value={form.ceNotes} onChange={e=>f("ceNotes",e.target.value)} rows={2} placeholder="Internal notes, assumptions, scope concerns..." style={{width:"100%",border:"1.5px solid #c4b5fd",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:".68rem",fontWeight:700,color:"#7c3aed",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Bid Amount (₱)</label>
                    <input type="number" value={form.bidAmount} onChange={e=>f("bidAmount",e.target.value)} placeholder="Final bid" style={{width:"100%",border:"1.5px solid #c4b5fd",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:".68rem",fontWeight:700,color:"#7c3aed",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Bid Margin (%)</label>
                    <input type="number" value={form.bidMarginPct} onChange={e=>f("bidMarginPct",e.target.value)} placeholder="e.g. 22" style={{width:"100%",border:"1.5px solid #c4b5fd",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",boxSizing:"border-box"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:".68rem",fontWeight:700,color:"#7c3aed",textTransform:"uppercase",letterSpacing:".5px",display:"block",marginBottom:4}}>Outcome</label>
                    <select value={form.awarded} onChange={e=>f("awarded",e.target.value)} style={{width:"100%",border:"1.5px solid #c4b5fd",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".85rem",outline:"none",background:"#fff",boxSizing:"border-box"}}>
                      <option value="Pending">Pending</option><option value="Won">Won</option><option value="Lost">Lost</option>
                    </select>
                  </div>
                </>}
              </div>
              <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:6}}>
                <button onClick={()=>setShowForm(false)} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 20px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>Cancel</button>
                <button onClick={handleSave} style={{background:"#7c3aed",border:"none",borderRadius:9,padding:"9px 24px",fontFamily:"inherit",fontSize:".82rem",color:"#fff",cursor:"pointer",fontWeight:700}}>Save Request</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── BOQ MODAL (opened from pipeline 📋 button) ──────────────────────────────

// ─── SUBCON WORK ORDERS VIEW ───────────────────────────────────────────────────
function SubconWOView({swos,addSWO,addSWOBatch,updateSWO,deleteSWO,wonDeals,deals,subcons,session,role,toastEmit,sendTelegramNotification,chartOfAccounts=[],onWaiveDp}){
  const today=new Date().toISOString().split("T")[0];
  const[mode,setMode]=useState("list");
  const[editingId,setEditingId]=useState(null);
  const[form,setForm]=useState(emptySWO());
  const[suggestedNo,setSuggestedNo]=useState("");
  const[submitting,setSubmitting]=useState(false);
  const[filterProj,setFilterProj]=useState("all");
  const[filterStat,setFilterStat]=useState("all");
  const[expanded,setExpanded]=useState({});
  const[delivModal,setDelivModal]=useState(null); // {woId, wo}
  const[delivForm,setDelivForm]=useState(emptyDelivery());
  const df=(k,v)=>setDelivForm(p=>({...p,[k]:v}));
  const openDelivery=w=>{setDelivModal({woId:w.id,wo:w});setDelivForm(w.delivery?{...w.delivery}:emptyDelivery());};
  const saveDelivery=()=>{
    const d={...delivForm,inspectedBy:delivForm.inspectedBy||session?.name||"",inspectedOn:delivForm.inspectedOn||today,status:"Inspected"};
    updateSWO(delivModal.woId,{delivery:d,...(delivModal.wo.status==="Issued"?{status:"In Progress"}:{})});
    toastEmit&&toastEmit("Delivery inspection recorded","success");
    setDelivModal(null);
  };
  const signOffDelivery=w=>{
    const d={...(w.delivery||{}),signedOffBy:session?.name||"",signedOffOn:today,status:"Accepted"};
    updateSWO(w.id,{delivery:d,status:"Completed"});
    sendTelegramNotification("ops",`✅ <b>Subcon Delivery Accepted — ${w.woNumber}</b>\nSubcontractor: ${w.subcontractor||"—"}\nProject: ${w.projectName||"—"}\nSigned off by: ${session?.name||"?"} · ${today}\n${w.retentionPct>0?"Retention "+w.retentionPct+"% held until project close":""}`);
    toastEmit&&toastEmit(`${w.woNumber} signed off — marked Completed`,"success");
  };
  const releaseRetention=w=>{
    const d={...(w.delivery||{}),retentionReleased:true,retentionReleasedBy:session?.name||"",retentionReleasedOn:today};
    updateSWO(w.id,{delivery:d});
    sendTelegramNotification("financialcontrol",`💰 <b>Retention Release Approved — ${w.woNumber}</b>\nSubcontractor: ${w.subcontractor||"—"}\nRetention: ₱${woRetentionAmt(w).toLocaleString("en-PH")}\nAuthorized by: ${session?.name||"?"} · ${today}`);
    toastEmit&&toastEmit("Retention release recorded — Finance notified","success");
  };
  const canSignOff=role==="Manager"||role==="Ops";

  const n=v=>Number(String(v).replace(/,/g,""))||0;
  const fmt=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:0});
  const ACCT_CLR={"For Accounting":"#d97706","Checked":"#2563eb","Payment Ordered":"#059669"};
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const canManage=role==="Manager"||isProcurementRole(role);
  const woDirect=canApprovePO(role,session?.name||"",session?.name||"");
  // Down payment gate (same rule as POs): no work order is issued on a deal the
  // client hasn't paid on, unless a Manager waived the down payment.
  const WO_ISSUED=["Issued","In Progress","Completed"];
  const allD=deals||wonDeals||[];
  const dpBlockedDeal=pid=>{const d=allD.find(x=>x.id===pid);return d&&!dealDpClear(d,allD)?d:null;};
  const dpMsg=d=>`No down payment received on ${d.ceNo||d.client||"this project"}. A Manager must waive it before a work order can be issued.`;
  // Where a WO sits in the engage → complete → pay chain (Policy v2.0). Derived
  // from the WO's own workflow + accounting fields: a subcontractor is only
  // payable once the work is issued, and paid via the Accounting board
  // (acctStatus: For Accounting → Checked → Payment Ordered → Paid).
  const swoLifecycle=(w)=>{
    const st=w.status||"", acct=w.acctStatus||"";
    const issued=["Issued","In Progress","Completed"].includes(st);
    const completed=st==="Completed";
    const inAccounting=["For Accounting","Checked","Payment Ordered","Paid"].includes(acct);
    const paymentOrdered=["Payment Ordered","Paid"].includes(acct);
    const paid=acct==="Paid"||(Number(w.paidAmt)||0)>0;
    return {issued,completed,inAccounting,paymentOrdered,paid,acct};
  };
  const swoLifecycleStrip=(lc)=>{
    const nodes=[
      {label:"Issued",                                          done:lc.issued,       color:SWO_STATUS_CLR["Issued"]},
      {label:lc.completed?"Completed":"Complete work",          done:lc.completed,    color:SWO_STATUS_CLR["Completed"]},
      {label:lc.acct?`Accounting · ${lc.acct}`:"To Accounting", done:lc.inAccounting, half:lc.inAccounting&&!lc.paymentOrdered, color:"#8b5cf6"},
      {label:"Paid",                                            done:lc.paid,         half:lc.paymentOrdered&&!lc.paid, color:T.success},
    ];
    return <LifecycleStrip nodes={nodes}/>;
  };

  const openNew=()=>{
    const sug=computeNextWoNo(swos);
    setForm({...emptySWO(),woNumber:sug,woDate:today});
    setSuggestedNo(sug); setEditingId(null); setMode("form");
  };
  const openEdit=w=>{setForm({...w});setSuggestedNo(w.woNumber||"");setEditingId(w.id);setMode("form");};

  // Picking a master-list subcon auto-fills their commercial terms
  const pickSubcon=name=>setForm(p=>{
    const m=(subcons||[]).find(s=>(s.company_name||s.companyName||"").trim().toLowerCase()===name.trim().toLowerCase());
    if(!m) return {...p,subcontractor:name};
    return {...p,subcontractor:name,
      specialty:m.specialty||p.specialty||"",
      paymentStructure:m.payment_structure||m.paymentStructure||p.paymentStructure||"",
      paymentTerms:m.payment_terms||m.paymentTerms||p.paymentTerms||""};
  });

  // ── Batch upload ────────────────────────────────────────────────────────────
  const batchInputRef=useRef(null);
  const[batchRows,setBatchRows]=useState(null); // null=closed; [] or [{...mapped, _errors}]=review
  const[batchBusy,setBatchBusy]=useState(false);
  const[batchFileName,setBatchFileName]=useState("");

  // Column aliases → canonical WO field. Header comparison is case/punctuation-insensitive.
  const BATCH_COLS=[
    {key:"woNumber",        aliases:["wonumber","wono","won","wonum","workorderno","workordernumber","wonumberno"]},
    {key:"subcontractor",   aliases:["subcontractor","subcontractorname","subcon","subconname","subconnesname","vendor","supplier","company"]},
    {key:"project",         aliases:["project","projectname","client","deal","ceno","cenumber","ce"]},
    {key:"specialty",       aliases:["specialty","worktype","trade","scopecategory","category"]},
    {key:"scopeOfWork",     aliases:["scopeofwork","scope","workdescription","description","works"]},
    {key:"contractAmount",  aliases:["contractamount","amount","contractvalue","value","total","cost"]},
    {key:"retentionPct",    aliases:["retentionpct","retention","retentionpercent","retention%"]},
    {key:"paymentStructure",aliases:["paymentstructure","payment","paymentmilestones","milestones"]},
    {key:"paymentTerms",    aliases:["paymentterms","terms","credit","creditterms"]},
    {key:"startDate",       aliases:["startdate","start","commencement","begindate","schedule"]},
    {key:"targetEndDate",   aliases:["targetenddate","enddate","end","completion","targetdate","deadline"]},
    {key:"woDate",          aliases:["wodate","date","dateissued","issuedate","orderdate"]},
    {key:"notes",           aliases:["notes","remarks","comment","comments"]},
  ];
  const normHdr=h=>String(h||"").toLowerCase().replace(/[^a-z0-9%]/g,"");
  // "NONE"/"N/A"/"10%"/"1,000" → number; blanks and non-numeric text → 0.
  const numCell=v=>{const m=String(v==null?"":v).replace(/,/g,"").match(/-?\d+(\.\d+)?/);return m?Number(m[0]):0;};
  // Excel serial dates → ISO; also handles m/d/yy, m/d/yyyy and yyyy-mm-dd text.
  const toISODate=v=>{
    if(v===""||v==null) return "";
    if(typeof v==="number"&&v>0&&v<80000){ // Excel serial
      const d=new Date(Date.UTC(1899,11,30+Math.round(v)));
      return isNaN(d)?"":d.toISOString().split("T")[0];
    }
    const s=String(v).trim();
    const m=s.match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})/);
    if(m) return `${m[1]}-${String(m[2]).padStart(2,"0")}-${String(m[3]).padStart(2,"0")}`;
    // m/d/yyyy or m/d/yy (2-digit year → 20xx). Day/month order assumes US m/d.
    const m2=s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2}(?:\d{2})?)/);
    if(m2){const yr=m2[3].length===2?`20${m2[3]}`:m2[3];return `${yr}-${String(m2[1]).padStart(2,"0")}-${String(m2[2]).padStart(2,"0")}`;}
    return s;
  };
  // Best-guess match of a free-text project cell to a won deal. Only a
  // suggestion — the review screen lets the user confirm/override every row,
  // because short spreadsheet names ("MIZUNO", "I'M IN SHANG") are inherently
  // ambiguous against the real CE list. Punctuation-insensitive, token-aware,
  // and biased toward base projects over addenda/change orders.
  const normName=s=>String(s||"").toLowerCase().replace(/[^a-z0-9]+/g," ").trim();
  const matchProject=cell=>{
    const q=normName(cell);
    if(!q) return null;
    const qt=q.split(" ").filter(t=>t.length>2);
    let best=null,bestScore=0;
    (wonDeals||[]).forEach(d=>{
      const name=normName(projDisplayName(d));
      const client=normName(d.contact||d.client||"");
      const ce=normName(d.ceNo||"");
      let score=0;
      if(name===q||client===q||ce===q) score=100;
      else if(name.startsWith(q)||q.startsWith(name)||client.startsWith(q)) score=80;
      else if(name.includes(q)||q.includes(name)) score=60;
      else{
        const nt=new Set(name.split(" "));
        const hit=qt.filter(t=>nt.has(t)).length;
        if(hit) score=25+hit*8;
      }
      if(score>0){
        if(/addendum|change order|added works|movement|relocation|pull out|demolition|board up|reuse/.test(name)) score-=18; // prefer the base project
        score-=Math.min(name.length/60,4); // prefer the tighter (plainer) name
        if(score>bestScore){bestScore=score;best=d;}
      }
    });
    return bestScore>=30?best:null;
  };
  // User picks/overrides a row's project in the review table; re-validate the row.
  const setBatchProject=(idx,dealId)=>setBatchRows(rows=>(rows||[]).map((r,i)=>{
    if(i!==idx) return r;
    const deal=(wonDeals||[]).find(d=>d.id===dealId);
    const nr={...r,projectId:dealId||"",projectName:deal?projDisplayName(deal):""};
    const errors=[];
    if(!nr.subcontractor) errors.push("Missing subcontractor");
    if(!nr.projectId) errors.push(nr.projectCell?`No match for "${nr.projectCell}" — pick a project`:"Missing project");
    if(!nr.scopeOfWork) errors.push("Missing scope of work");
    if(nr.contractAmount<=0) errors.push("Contract amount must be > 0");
    return {...nr,_errors:errors};
  }));

  const parseBatchFile=async file=>{
    const ext=file.name.split(".").pop().toLowerCase();
    let rows=[];
    if(ext==="csv"){
      const text=await file.text();
      const lines=text.split(/\r?\n/).filter(l=>l.trim());
      const parseLine=l=>{const out=[];let c="",q=false;for(const ch of l){if(ch==='"')q=!q;else if(ch===","&&!q){out.push(c);c="";}else c+=ch;}out.push(c);return out.map(x=>x.trim().replace(/^"|"$/g,""));};
      const headers=parseLine(lines[0]);
      rows=lines.slice(1).map(l=>{const v=parseLine(l);return Object.fromEntries(headers.map((h,i)=>[h,v[i]??""]));});
    } else if(["xlsx","xls"].includes(ext)){
      const XLSX=window.XLSX;
      if(!XLSX||!XLSX.read) throw new Error("Excel library still loading — please try again in a moment.");
      const buf=await file.arrayBuffer();
      const wb=XLSX.read(buf,{type:"array"});
      const ws=wb.Sheets[wb.SheetNames[0]];
      rows=XLSX.utils.sheet_to_json(ws,{defval:""});
    } else {
      throw new Error("Unsupported file type. Upload a .csv, .xlsx or .xls file.");
    }
    // Build header→field map from the first row's keys
    const keys=rows.length?Object.keys(rows[0]):[];
    const colMap={};
    keys.forEach(k=>{
      const nk=normHdr(k);
      const hit=BATCH_COLS.find(c=>c.aliases.includes(nk));
      if(hit&&!colMap[hit.key]) colMap[hit.key]=k;
    });
    const mapped=rows.map((r,i)=>{
      const g=field=>colMap[field]!==undefined?r[colMap[field]]:"";
      const projCell=g("project");
      const deal=matchProject(projCell);
      const rec={
        woNumber:String(g("woNumber")||"").trim(),
        subcontractor:String(g("subcontractor")||"").trim(),
        projectCell:String(projCell||"").trim(),
        projectId:deal?deal.id:"",
        projectName:deal?projDisplayName(deal):"",
        specialty:String(g("specialty")||"").trim(),
        scopeOfWork:String(g("scopeOfWork")||"").trim(),
        contractAmount:numCell(g("contractAmount")),
        // New WOs carry the company retention rate unless the sheet says otherwise (a typed 0 stays 0).
        retentionPct:String(g("retentionPct")??"").trim()===""?AP_RULES.subconRetentionPct:numCell(g("retentionPct")),
        paymentStructure:String(g("paymentStructure")||"").trim(),
        paymentTerms:String(g("paymentTerms")||"").trim(),
        startDate:toISODate(g("startDate")),
        targetEndDate:toISODate(g("targetEndDate")),
        woDate:toISODate(g("woDate"))||today,
        notes:String(g("notes")||"").trim(),
      };
      const errors=[];
      if(!rec.subcontractor) errors.push("Missing subcontractor");
      if(!rec.projectCell) errors.push("Missing project");
      else if(!rec.projectId) errors.push(`No matching won project for "${rec.projectCell}"`);
      if(!rec.scopeOfWork) errors.push("Missing scope of work");
      if(rec.contractAmount<=0) errors.push("Contract amount must be > 0");
      // auto-fill subcon terms from the master list when the row leaves them blank
      const m=(subcons||[]).find(s=>(s.company_name||s.companyName||"").trim().toLowerCase()===rec.subcontractor.toLowerCase());
      if(m){
        if(!rec.specialty) rec.specialty=m.specialty||"";
        if(!rec.paymentStructure) rec.paymentStructure=m.payment_structure||m.paymentStructure||"";
        if(!rec.paymentTerms) rec.paymentTerms=m.payment_terms||m.paymentTerms||"";
      }
      return {...rec,_row:i+2,_errors:errors};
    });
    return mapped;
  };

  const onBatchFile=async e=>{
    const file=e.target.files[0]; if(!file) return;
    e.target.value="";
    setBatchBusy(true); setBatchFileName(file.name);
    try{
      const mapped=await parseBatchFile(file);
      if(!mapped.length) toastEmit&&toastEmit("No data rows found in the file.","error");
      setBatchRows(mapped);
    }catch(err){
      toastEmit&&toastEmit(err.message||"Could not read the file.","error");
      setBatchRows(null); setBatchFileName("");
    }
    setBatchBusy(false);
  };

  const confirmBatch=()=>{
    const valid=(batchRows||[]).filter(r=>!r._errors.length);
    if(!valid.length){toastEmit&&toastEmit("No valid rows to import — fix the flagged rows first.","error");return;}
    const recs=valid.map(r=>({
      subcontractor:r.subcontractor,projectId:r.projectId,projectName:r.projectName,
      specialty:r.specialty,scopeOfWork:r.scopeOfWork,contractAmount:r.contractAmount,
      retentionPct:r.retentionPct,paymentStructure:r.paymentStructure,paymentTerms:r.paymentTerms,
      startDate:r.startDate,targetEndDate:r.targetEndDate,woDate:r.woDate,notes:r.notes,
      delivery:null,
      status:woDirect?"Issued":"Pending Approval",
      requestedBy:session?.name||"",
      approvedBy:woDirect?session?.name||"":"",
      acctStatus:woDirect?"For Accounting":"",
      woNumber:r.woNumber||"", // preserve the file's WO number; addSWOBatch reallocates on collision
    }));
    const count=addSWOBatch(recs);
    const skipped=(batchRows||[]).length-valid.length;
    toastEmit&&toastEmit(`${count} work order${count>1?"s":""} imported${woDirect?" and issued":" for approval"}${skipped?` · ${skipped} row${skipped>1?"s":""} skipped`:""}`,"success");
    setBatchRows(null); setBatchFileName("");
  };

  const downloadBatchTemplate=()=>{
    const headers=["Subcontractor","Project","Specialty","Scope of Work","Contract Amount","Retention %","Payment Structure","Payment Terms","Start Date","Target End Date","WO Date","Notes"];
    const sample=wonDeals[0]?projDisplayName(wonDeals[0]):"Client Name or CE No";
    const example=["ABC Steel Works",sample,"Structural Steel","Fabricate and install steel trusses per approved drawings","250000","10","50% down, 50% on completion","30 days","2026-08-15","2026-09-30","2026-08-07","Include shop drawings"];
    const esc=v=>{const s=String(v);return /[",\n]/.test(s)?`"${s.replace(/"/g,'""')}"`:s;};
    const csv=[headers.map(esc).join(","),example.map(esc).join(",")].join("\n");
    const blob=new Blob([csv],{type:"text/csv;charset=utf-8;"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download="FabHub_WorkOrder_Batch_Template.csv";
    document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
  };

  const submit=async()=>{
    if(submitting) return;
    if(!form.subcontractor.trim()){toastEmit&&toastEmit("Please enter the subcontractor name.","error");return;}
    if(!form.projectId){toastEmit&&toastEmit("Please select a project.","error");return;}
    if(!form.scopeOfWork.trim()){toastEmit&&toastEmit("Please describe the scope of work.","error");return;}
    if(n(form.contractAmount)<=0){toastEmit&&toastEmit("Contract amount must be greater than 0.","error");return;}
    const deal=wonDeals.find(d=>d.id===form.projectId);
    const base={...form,projectName:projDisplayName(deal)||form.projectName||"",contractAmount:n(form.contractAmount),retentionPct:n(form.retentionPct)};
    if(editingId){
      const orig=swos.find(w=>w.id===editingId);
      const dpBlk=orig&&WO_ISSUED.includes(base.status)&&!WO_ISSUED.includes(orig.status)&&dpBlockedDeal(base.projectId);
      if(dpBlk){toastEmit&&toastEmit(dpMsg(dpBlk),"error",9000);return;}
      if(base.status==="Issued"&&orig&&(orig.status==="Pending Approval"||orig.status==="Draft")&&!canApprovePO(role,session?.name||"",orig.requestedBy)){toastEmit&&toastEmit("Needs a Manager or the Procurement Manager to approve.","error");return;}
      if(base.status==="Issued"&&orig&&orig.status!=="Issued") Object.assign(base,{approvedBy:session?.name||"",acctStatus:base.acctStatus||"For Accounting"});
      updateSWO(editingId,base);
      toastEmit&&toastEmit(`${form.woNumber||"Work order"} updated`,"success");
      setMode("list");setEditingId(null);
      return;
    }
    setSubmitting(true);
    let woNo;
    try{ woNo=await claimWoNumber({typed:form.woNumber,suggested:suggestedNo,swos}); }
    finally{ setSubmitting(false); }
    const dpBlkNew=woDirect&&dpBlockedDeal(base.projectId);
    if(dpBlkNew) toastEmit&&toastEmit(`Saved as Pending Approval. ${dpMsg(dpBlkNew)}`,"error",9000);
    const issueNow=woDirect&&!dpBlkNew;
    addSWO({...base,woNumber:woNo,status:issueNow?"Issued":"Pending Approval",
      requestedBy:session?.name||"",approvedBy:issueNow?session?.name||"":"",
      acctStatus:issueNow?"For Accounting":""});
    toastEmit&&toastEmit(woNo!==(form.woNumber||"").trim()
      ?`Saved as ${woNo} — ${(form.woNumber||"").trim()} was already taken`
      :woDirect?`Work Order ${woNo} issued to ${form.subcontractor.trim()}`
      :`Work Order ${woNo} submitted for approval`,"success");
    setMode("list");
  };

  // Standard Subcontractor Service Agreement Contract — auto-filled from the
  // awarded Work Order. Mirrors GMD's EYESPORTS-NUVALI template plus the added
  // liability clauses (indemnification, independent-contractor, insurance,
  // safety, property damage, termination, taxes, lien waiver, PCAB, force majeure).
  const printSubconContract=w=>{
    if(!w) return;
    const esc=s=>String(s==null?"":s).replace(/[&<>]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;"}[c]));
    const N=v=>Number(v)||0;
    const amount=N(w.contractAmount);
    const peso=n=>"₱"+N(n).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
    // number → words (integer pesos)
    const ones=["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
    const tens=["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
    const below1000=n=>{let s="";if(n>=100){s+=ones[Math.floor(n/100)]+" Hundred";n%=100;if(n)s+=" ";}if(n>=20){s+=tens[Math.floor(n/10)];n%=10;if(n)s+="-"+ones[n];}else if(n>0){s+=ones[n];}return s;};
    const toWords=num=>{num=Math.floor(N(num));if(num<=0)return "Zero";const g=["","Thousand","Million","Billion"];let gi=0,parts=[];while(num>0){const chunk=num%1000;if(chunk)parts.unshift(below1000(chunk)+(g[gi]?" "+g[gi]:""));num=Math.floor(num/1000);gi++;}return parts.join(" ");};
    const cents=Math.round((amount-Math.floor(amount))*100);
    const amountWords=`${toWords(amount)} Pesos${cents?` and ${cents}/100`:""} Only`;
    // milestone split: Downpayment 30 · 1st 25 · 2nd 25 · Final (rest) · Retention = WO retention%
    const ret=N(w.retentionPct)||10;
    const dp=30,p1=25,p2=25,fin=Math.max(0,100-dp-p1-p2-ret);
    const mrow=(stage,pct,desc)=>`<tr><td><b>${stage}</b></td><td class="c">${pct}%</td><td>${desc}</td><td class="r">${peso(amount*pct/100)}</td></tr>`;
    const proj=(wonDeals.find(d=>d.id===w.dealId)||wonDeals.find(d=>d.id===w.projectId));
    const projName=w.projectName||(proj?(proj.contact||proj.client):"")||"—";
    const scopeItems=String(w.scopeOfWork||"").split(/\r?\n|;|•/).map(s=>s.trim()).filter(Boolean);
    const dur=(w.startDate&&w.targetEndDate)?(()=>{const d=Math.round((new Date(w.targetEndDate)-new Date(w.startDate))/864e5);return d>0?`${d}`:"thirty (30) to forty-five (45)";})():"thirty (30) to forty-five (45)";
    const dateStr=(w.woDate||today);
    const CL=(no,title,body)=>`<div class="cl"><div class="cl-h">${no}. ${esc(title)}</div><div class="cl-b">${body}</div></div>`;
    const html=`<!doctype html><html><head><meta charset="utf-8"><title>Subcontractor Contract — ${esc(w.woNumber||"")}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Inter',-apple-system,Segoe UI,Arial,sans-serif;color:#1B2430;padding:44px 54px;font-size:12px;line-height:1.6}
  .lh{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #C9A24B;padding-bottom:12px;margin-bottom:8px}
  .co{font-size:19px;font-weight:800;color:#0B2545}
  .co small{display:block;font-size:10.5px;color:#5B6472;font-weight:400;margin-top:2px}
  .doct{text-align:right}
  .doct .t{font-size:13px;font-weight:800;color:#A8822F;text-transform:uppercase;letter-spacing:.6px}
  .doct .p{font-size:10.5px;color:#5B6472;margin-top:2px}
  h1{font-size:15px;color:#0B2545;text-align:center;margin:18px 0 4px;letter-spacing:.5px}
  .intro{font-size:11.5px;color:#334155;margin:10px 0 6px;text-align:justify}
  .cl{margin:9px 0}
  .cl-h{font-weight:800;color:#0B2545;font-size:11.5px;text-transform:uppercase;letter-spacing:.3px;margin-bottom:2px}
  .cl-b{text-align:justify;color:#243040}
  .cl-b ul{margin:3px 0 3px 18px}
  table{width:100%;border-collapse:collapse;margin:6px 0;font-size:11px}
  th{background:#EEF2F8;color:#0B2545;text-align:left;padding:6px 8px;border:1px solid #DCE2EC;text-transform:uppercase;font-size:10px;letter-spacing:.4px}
  td{padding:6px 8px;border:1px solid #DCE2EC;vertical-align:top}
  td.c{text-align:center}td.r{text-align:right;font-variant-numeric:tabular-nums;white-space:nowrap}
  tfoot td{font-weight:800;background:#F5F7FA}
  .amtbox{background:#EEF2F8;border:1px solid #DCE2EC;border-radius:6px;padding:10px 14px;margin:8px 0}
  .sig{display:grid;grid-template-columns:1fr 1fr;gap:26px 40px;margin-top:34px}
  .sig .b{border-top:1px solid #1B2430;padding-top:4px;font-size:11px}
  .sig .b .nm{font-weight:800;color:#0B2545}
  .sig .b .ps{color:#5B6472;font-size:10.5px}
  .ack{margin-top:26px;border-top:1px dashed #94A3B8;padding-top:12px;font-size:11px;color:#334155}
  .fields div{margin:3px 0}
  @media print{body{padding:24px 32px}}
</style></head><body>
  <div class="lh">
    <div class="co">GMD PRODUCTION INC.<small>32 Santan, Brgy. Fortune, Marikina City, Philippines · TIN 010-063-229-00000</small></div>
    <div class="doct"><div class="t">Subcontractor Agreement</div><div class="p">${esc(w.woNumber||"")}${w.woNumber?" · ":""}${esc(dateStr)}</div></div>
  </div>
  <h1>SERVICE AGREEMENT CONTRACT</h1>
  <div class="intro">This Service Agreement Contract is entered into this <b>${esc(dateStr)}</b> at 32 Santan, Brgy. Fortune, Marikina City, Philippines, by and between <b>GMD PRODUCTION INC.</b>, a corporation duly organized and existing under Philippine laws, herein represented by its authorized representative <b>Ar. Arrius Jerome A. Catubay</b> (the <b>General Contractor</b>); and <b>${esc(w.subcontractor||"____________________")}</b>${w.specialty?` (${esc(w.specialty)})`:""}, of legal age, herein referred to as the <b>Subcontractor</b>. Collectively, the <b>Parties</b>.${projName?` This Agreement covers the project: <b>${esc(projName)}</b>.`:""}</div>
  ${CL(1,"Documents","The following documents form integral parts of this Agreement: (1.1) Scope of Works / Bill of Quantities; (1.2) Approved Plans, Drawings, and Specifications; (1.3) Project Schedule and Work Program; (1.4) Approved Quotation / Proposal; (1.5) Purchase Orders and Variation Orders; (1.6) Any written correspondence mutually agreed upon. In case of discrepancies, the order of precedence shall follow the sequence above.")}
  ${CL(2,"Scope of Works",`The Subcontractor shall perform the following works in accordance with approved plans, specifications, and instructions of the General Contractor${projName?` for <b>${esc(projName)}</b>`:""}:${scopeItems.length?`<ul>${scopeItems.map(s=>`<li>${esc(s)}</li>`).join("")}</ul>`:" as detailed in the attached Bill of Quantities (BOQ)."} All works shall be executed with workmanship of the highest standard, using quality materials and in accordance with project timelines and specifications.`)}
  ${CL(3,"Inspection of Work / Reporting","The General Contractor reserves the right to inspect the works at any time. The Subcontractor shall provide daily or weekly progress updates as required. Any defects or deviations noted during inspection shall be corrected immediately at the Subcontractor's expense. Failure to submit reports may be considered a breach of this Agreement.")}
  ${CL(4,"Procurement","All materials and tools shall be supplied by the Subcontractor unless otherwise specified. If the General Contractor provides materials, proper acknowledgment receipts and inventory tracking shall be maintained. Any material wastage, loss, or damage due to negligence shall be charged to the Subcontractor.")}
  ${CL(5,"Contract Price",`The agreed contract price for the full and satisfactory completion of the works is <b>${esc(amountWords)}</b> (<b>${peso(amount)}</b>), inclusive of all labor, supervision, tools, mobilization, and applicable taxes unless otherwise stated. <i>The contract price indicated herein is a non-VAT amount and is exclusive of any Value Added Tax (VAT).</i>`)}
  ${CL(6,"Changes and Additions","Any change, addition, or omission to the scope of work shall be covered by a written Variation Order approved by the General Contractor. No verbal instruction shall be binding unless confirmed in writing. Approved additional works shall be compensated based on mutually agreed unit rates or lump-sum amounts.")}
  ${CL(7,"Terms of Payment",`Payment shall be made upon completion of agreed milestones, as follows:
    <table><thead><tr><th>Stage</th><th class="c">%</th><th>Description</th><th class="r">Amount</th></tr></thead><tbody>
    ${mrow("Downpayment",dp,"Upon signing of the contract and issuance of Notice to Proceed")}
    ${mrow("1st Progress Billing",p1,"Upon completion of at least 30%–50% of the agreed scope, subject to inspection and approval")}
    ${mrow("2nd Progress Billing",p2,"Upon completion of at least 75%–80% of the agreed scope, subject to inspection and approval")}
    ${fin>0?mrow("Final Payment",fin,"Upon full completion of all works and acceptance by the General Contractor"):""}
    ${mrow("Retention",ret,`To be released sixty (60) days after project completion and acceptance, provided no defects or pending corrections exist`)}
    </tbody><tfoot><tr><td colspan="3">TOTAL</td><td class="r">${peso(amount)}</td></tr></tfoot></table>
    All billings must be supported by a progress report, photos, and inspection approval. Retention of ${ret}% shall be deducted from every billing and released only after the liability period of sixty (60) days.`)}
  ${CL(8,"Penalty","For delay in completion, a penalty of one-tenth of one percent (0.1%) of the contract price per calendar day of delay shall be imposed, unless such delay is excused due to force majeure or written extension approval by the General Contractor.")}
  ${CL(9,"Contract Time / Completion / Time Extension",`The total contract duration shall be <b>${esc(String(dur))}${/\d/.test(String(dur))&&!/thirty/.test(String(dur))?" calendar days":""}</b>${w.startDate?`, commencing on <b>${esc(w.startDate)}</b>`:", commencing on the first day of mobilization"}${w.targetEndDate?` and targeted for completion on <b>${esc(w.targetEndDate)}</b>`:""}. Time extension may be granted only upon written request and approval due to justifiable causes (e.g., weather, design changes, force majeure).`)}
  ${CL(10,"Default by General Contractor","If the General Contractor fails to make due payment as stipulated or causes unreasonable delay in site access, the Subcontractor may suspend work after written notice and resume only upon resolution of the issue, without prejudice to any claim for damages or extension of time.")}
  ${CL(11,"Warranties and Responsibilities","The Subcontractor warrants that all work performed shall be free from defects in materials and workmanship for a period of SIX (6) MONTHS from project acceptance. Any defects within the warranty period shall be repaired or replaced at no cost to the General Contractor. The Subcontractor shall also ensure compliance with all safety, labor, and environmental regulations.")}
  ${CL(12,"Title of Work","All materials and works completed under this Agreement shall become the property of the General Contractor upon delivery or installation, regardless of whether full payment has been made.")}
  ${CL(13,"Assignment","The Subcontractor shall not assign, transfer, or subcontract the whole or any part of this Agreement without the prior written consent of the General Contractor.")}
  ${CL(14,"Indemnification / Hold Harmless","The Subcontractor shall indemnify, defend, and hold free and harmless the General Contractor, its officers, employees, and clients from and against any and all claims, suits, losses, damages, liabilities, and expenses (including attorney's fees) arising out of or in connection with the Subcontractor's performance of the works, or any act, omission, or negligence of the Subcontractor, its workers, or agents.")}
  ${CL(15,"Independent Contractor / No Employer-Employee Relationship","The Subcontractor is an independent contractor. Nothing in this Agreement shall be construed to create an employer-employee relationship between the General Contractor and the Subcontractor or any of its workers. The Subcontractor shall be solely responsible for the wages, statutory benefits, SSS, PhilHealth, Pag-IBIG contributions, taxes, and all obligations to its personnel, and shall hold the General Contractor free from any liability arising therefrom.")}
  ${CL(16,"Insurance","The Subcontractor shall, at its own expense, secure and maintain adequate insurance covering its works and personnel, including Comprehensive General Liability (CGL) and Workmen's Compensation / Contractor's All Risk Insurance (CARI) where applicable, and shall furnish proof of such coverage upon request. The Subcontractor assumes all risk not covered by such insurance.")}
  ${CL(17,"Safety and Liability for Accidents","The Subcontractor shall observe and comply with DOLE Department Order No. 13 (Construction Safety and Health) and all applicable safety regulations, provide the necessary safety officer, personal protective equipment, and safety measures, and shall be solely liable for any accident, injury, illness, or death of its workers or third parties occurring in connection with its works.")}
  ${CL(18,"Liability for Damage to Property and Works","The Subcontractor shall be liable for and shall repair or replace, at its own cost, any damage to existing works, the General Contractor's or client's property, adjacent property, or materials caused by the Subcontractor's works, acts, or negligence.")}
  ${CL(19,"Termination for Default","The General Contractor may terminate this Agreement, in whole or in part, upon written notice if the Subcontractor abandons the works, fails to prosecute the works diligently, incurs unreasonable delay, or breaches any provision of this Agreement. Upon such termination, the General Contractor may take over and complete the works and charge any additional cost to the Subcontractor, without prejudice to other remedies.")}
  ${CL(20,"Taxes and Withholding","The Subcontractor shall be responsible for its own taxes arising from this Agreement. The General Contractor shall have the right to withhold and remit the applicable Expanded Withholding Tax (EWT) and other taxes required by law from any payment due to the Subcontractor.")}
  ${CL(21,"Waiver of Lien / Claims","Acceptance of final payment by the Subcontractor shall constitute a waiver and release of any and all liens, claims, or demands against the General Contractor in connection with this Agreement, except for retention money and any claim expressly reserved in writing.")}
  ${CL(22,"License and Permits","The Subcontractor warrants that it holds a valid PCAB license (where applicable) and shall secure and maintain all permits, clearances, and licenses required for the performance of its works, and shall comply with all applicable laws, ordinances, and regulations.")}
  ${CL(23,"Force Majeure","Neither Party shall be liable for delay or failure to perform its obligations due to causes beyond its reasonable control, including acts of God, natural calamities, fire, war, civil disturbance, epidemic, or government action (force majeure). The affected Party shall promptly notify the other and resume performance as soon as reasonably practicable.")}
  ${CL(24,"Arbitration","Any dispute arising out of or in connection with this Agreement shall first be settled amicably. If unresolved within thirty (30) days, it shall be referred to arbitration under the Construction Industry Arbitration Commission (CIAC), in accordance with the laws of the Republic of the Philippines.")}
  ${CL(25,"Miscellaneous","This Agreement constitutes the entire understanding between both Parties. Any amendment shall be in writing and signed by both Parties. Both Parties shall comply with all applicable laws, taxes, and permits related to the execution of the work. The Parties hereby affirm that they have read, understood, and voluntarily agreed to all terms and conditions herein.")}
  <div class="sig">
    <div>
      <div style="font-weight:800;color:#0B2545;margin-bottom:14px;">GMD PRODUCTION INC.<div style="font-weight:400;color:#5B6472;font-size:10.5px;">General Contractor</div></div>
      <div class="b" style="margin-bottom:22px;"><div class="nm">Ar. Arrius Jerome A. Catubay</div><div class="ps">Authorized Representative</div></div>
      <div class="b" style="margin-bottom:22px;"><div class="nm">Maria Nell Pril</div><div class="ps">Operations Manager</div></div>
      <div class="b"><div class="nm">&nbsp;</div><div class="ps">Procurement Manager</div></div>
    </div>
    <div>
      <div style="font-weight:800;color:#0B2545;margin-bottom:14px;">SUBCONTRACTOR<div style="font-weight:400;color:#5B6472;font-size:10.5px;">${esc(w.subcontractor||"")}</div></div>
      <div class="fields" style="margin-top:6px;">
        <div>Name: ____________________________</div>
        <div>Position: _________________________</div>
        <div>CTC No.: _________________________</div>
        <div>Issued on: ________________________</div>
        <div>Issued at: ________________________</div>
      </div>
      <div class="b" style="margin-top:26px;"><div class="nm">&nbsp;</div><div class="ps">Signature over Printed Name</div></div>
    </div>
  </div>
  <div class="ack">
    <b>SIGNED IN THE PRESENCE OF:</b>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:40px;margin-top:20px;">
      <div class="b" style="border-top:1px solid #1B2430;padding-top:4px;">Witness — Signature over Printed Name</div>
      <div class="b" style="border-top:1px solid #1B2430;padding-top:4px;">Witness — Signature over Printed Name</div>
    </div>
    <div style="margin-top:18px;"><b>ACKNOWLEDGMENT</b><br/>REPUBLIC OF THE PHILIPPINES ) S.S.<br/><br/>BEFORE ME, a Notary Public for and in the __________, Philippines, personally appeared the above-named persons, known to me through competent identification, who acknowledged that the foregoing instrument is their free and voluntary act and deed.<br/><br/>WITNESS MY HAND AND SEAL this ______ day of ____________, at __________, Philippines.<br/><br/>Doc. No. ____; Page No. ____; Book No. ____; Series of ______.</div>
  </div>
</body></html>`;
    const win=window.open("","_blank","width=820,height=900");
    if(win){win.document.write(html);win.document.close();addPrintClose(win);setTimeout(()=>win.print(),600);}
  };
  const printWO=w=>{
    const fmt2=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2});
    const retAmt=woRetentionAmt(w);
    const esc=s=>String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Work Order — ${esc(w.woNumber)}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:Arial,sans-serif;padding:32px;color:#0f172a;font-size:12px}
  .hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;border-bottom:2px solid #1e293b;padding-bottom:16px}
  .co{font-size:22px;font-weight:800;letter-spacing:-0.5px}
  .co-sub{font-size:11px;color:#64748b;margin-top:2px}
  .doc-title{font-size:20px;font-weight:800;color:#1e293b}
  .doc-sub{font-size:11px;color:#64748b;margin-top:3px}
  .meta{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px 16px;margin-bottom:20px;background:#f8fafc;padding:14px 16px;border-radius:8px;border:1px solid #e2e8f0}
  .meta-item label{display:block;font-size:9px;text-transform:uppercase;letter-spacing:.8px;color:#94a3b8;margin-bottom:3px}
  .meta-item span{font-weight:700;font-size:13px}
  .sec-title{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:#1e293b;border-bottom:1.5px solid #1e293b;padding-bottom:4px;margin:18px 0 8px}
  .scope{white-space:pre-wrap;font-size:12px;line-height:1.6;background:#fff;border:1px solid #e2e8f0;border-radius:8px;padding:12px 14px;min-height:90px}
  table{width:100%;border-collapse:collapse;margin-top:8px}
  td{padding:8px 10px;border-bottom:1px solid #f1f5f9;vertical-align:top;font-size:12px}
  td.lbl{color:#64748b;width:220px}
  td.val{font-weight:700}
  .total-row td{font-weight:800;background:#eff6ff;color:#1e40af;border-top:2px solid #1e293b;font-size:13px}
  .sig{display:grid;grid-template-columns:1fr 1fr 1fr;gap:24px;margin-top:44px}
  .sig-box{border-top:1px solid #cbd5e1;padding-top:8px;font-size:10px;color:#64748b}
  @media print{body{padding:20px}}
</style></head><body>
<div class="hdr">
  <div><div class="co">GMD PRODUCTIONS INC</div><div class="co-sub">Fabrication &amp; Project Management</div></div>
  <div style="text-align:right"><div class="doc-title">SUBCON WORK ORDER</div><div class="doc-sub">${esc(w.woNumber)} · ${esc(w.woDate)||""}</div></div>
</div>
<div class="meta">
  <div class="meta-item"><label>Subcontractor</label><span>${esc(w.subcontractor)||"—"}</span></div>
  <div class="meta-item"><label>WO Number</label><span>${esc(w.woNumber)||"—"}</span></div>
  <div class="meta-item"><label>Date Issued</label><span>${esc(w.woDate)||"—"}</span></div>
  <div class="meta-item"><label>Project</label><span>${esc(w.projectName)||"—"}</span></div>
  <div class="meta-item"><label>Work Type</label><span>${esc(w.specialty)||"—"}</span></div>
  <div class="meta-item"><label>Schedule</label><span>${esc(w.startDate)||"—"} → ${esc(w.targetEndDate)||"—"}</span></div>
</div>
<div class="sec-title">Scope of Work</div>
<div class="scope">${esc(w.scopeOfWork)||"—"}</div>
${w.notes?`<div class="sec-title">Notes</div><div class="scope" style="min-height:0">${esc(w.notes)}</div>`:""}
<div class="sec-title">Commercial Terms</div>
<table>
  <tr><td class="lbl">Payment Structure</td><td class="val">${esc(w.paymentStructure)||"—"}</td></tr>
  <tr><td class="lbl">Payment Terms</td><td class="val">${esc(w.paymentTerms)||"—"}</td></tr>
  <tr><td class="lbl">Retention${n(w.retentionPct)>0?` (${n(w.retentionPct)}%)`:""}</td><td class="val">${n(w.retentionPct)>0?"−"+fmt2(retAmt)+" held until acceptance":"None"}</td></tr>
  <tr class="total-row"><td>CONTRACT AMOUNT</td><td>${fmt2(w.contractAmount)}</td></tr>
</table>
<div class="sig">
  <div class="sig-box">Prepared by<br><br><br>_______________________<br>${esc(w.requestedBy)||""}</div>
  <div class="sig-box">Approved by<br><br><br>_______________________<br>${esc(w.approvedBy)||""}</div>
  <div class="sig-box">Conforme — Subcontractor<br><br><br>_______________________<br>${esc(w.subcontractor)||""}</div>
</div>
</body></html>`;
    const win=window.open("","_blank","width=900,height=700");
    if(win){win.document.write(html);win.document.close();addPrintClose(win);setTimeout(()=>win.print(),600);}
  };

  const filtered=swos.filter(w=>{
    if(role==="Accounting"&&w.acctStatus!=="For Accounting") return false;
    if(filterProj!=="all"&&w.projectId!==filterProj) return false;
    if(filterStat!=="all"&&w.status!==filterStat) return false;
    return true;
  }).sort((a,b)=>String(b.woDate||b.createdDate||"").localeCompare(String(a.woDate||a.createdDate||"")));
  const totalValue=filtered.filter(w=>w.status!=="Cancelled").reduce((s,w)=>s+n(w.contractAmount),0);

  // ── Form (new / edit) ──────────────────────────────────────────────────────
  if(mode==="form"){
    const canSubmit=form.subcontractor.trim()&&form.projectId&&form.scopeOfWork.trim()&&n(form.contractAmount)>0&&!submitting;
    const retAmt=woRetentionAmt({retentionPct:form.retentionPct,contractAmount:n(form.contractAmount)});
    return(
      <div>
        <button onClick={()=>{setMode("list");setEditingId(null);}} style={{background:"none",border:"none",color:"#3b82f6",cursor:"pointer",fontFamily:"inherit",fontSize:".84rem",fontWeight:700,marginBottom:14,padding:0}}>← Back to Work Orders</button>
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:20}}>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem",marginBottom:16}}>🛠️ {editingId?"Edit Work Order":"New Subcon Work Order"}</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <Fld label="Subcontractor" required hint="From the Subcontractor Master — terms auto-fill">
              <datalist id="wo-subcon-dl">
                {[...new Map((subcons||[]).map(s=>{const n=(s.company_name||s.companyName||"").trim();return[n,n];})).values()].filter(Boolean).sort().map(n=><option key={n} value={n}/>)}
              </datalist>
              <input list="wo-subcon-dl" value={form.subcontractor||""} onChange={e=>pickSubcon(e.target.value)} placeholder="Type or select subcontractor…"
                style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box"}}/>
            </Fld>
            <Fld label="Project" required>
              <SearchSelect
                value={form.projectId||null}
                onChange={v=>{const d=wonDeals.find(x=>x.id===v);setForm(p=>({...p,projectId:v||"",projectName:projDisplayName(d)}));}}
                options={projOptions(wonDeals)}
                placeholder="Search project name or CE…"
                noneLabel="— Select Project —"
                noneValue=""
              />
              {(()=>{const d=allD.find(x=>x.id===form.projectId);return d&&(d.dpWaivedAt||!dealDpClear(d,allD))?<div style={{marginTop:6}}><DpGate deal={d} deals={allD} role={role} onWaiveDp={onWaiveDp} what="Work orders"/></div>:null;})()}
            </Fld>
            <Fld label="WO Number" required hint={editingId?undefined:"Suggested — confirmed on submit to avoid duplicates"}>
              <Inp value={form.woNumber} onChange={e=>f("woNumber",e.target.value)} placeholder="WO-0001"/>
            </Fld>
            <Fld label="WO Date"><Inp type="date" value={form.woDate} onChange={e=>f("woDate",e.target.value)}/></Fld>
            <Fld label="Work Type / Specialty"><Inp value={form.specialty} onChange={e=>f("specialty",e.target.value)} placeholder="e.g. General Works, Stone Works"/></Fld>
            {editingId
              ?<Fld label="Status"><Sel value={form.status} onChange={e=>f("status",e.target.value)}>{SWO_STATUSES.map(s=><option key={s}>{s}</option>)}</Sel></Fld>
              :<Fld label="Approval">
                <div style={{padding:"9px 13px",border:"1.5px dashed "+(woDirect?"#6ee7b7":"#fde68a"),borderRadius:8,fontSize:".76rem",fontWeight:700,color:woDirect?"#059669":"#b45309",background:woDirect?"#f0fdf4":"#fffbeb",boxSizing:"border-box"}}>
                  {woDirect?"✓ Issues immediately":"⏳ Goes to Pending Approval"}
                </div>
              </Fld>}
            <Fld label="Start Date"><Inp type="date" value={form.startDate} onChange={e=>f("startDate",e.target.value)}/></Fld>
            <Fld label="Target Completion"><Inp type="date" value={form.targetEndDate} onChange={e=>f("targetEndDate",e.target.value)}/></Fld>
            <div style={{gridColumn:"1/-1"}}>
              <Fld label="Scope of Work" required hint="What exactly the subcontractor will deliver — printed on the WO">
                <textarea value={form.scopeOfWork} onChange={e=>f("scopeOfWork",e.target.value)} rows={5}
                  placeholder={"e.g.\n• Supply and install kitchen modular cabinets per approved drawings rev.3\n• Includes hardware, site measurement, hauling and 2 site visits\n• Excludes countertops and electrical"}
                  style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",resize:"vertical",outline:"none",boxSizing:"border-box"}}/>
              </Fld>
            </div>
            <Fld label="Contract Amount (₱)" required><Inp type="number" value={form.contractAmount} onChange={e=>f("contractAmount",e.target.value)} placeholder="0.00"/></Fld>
            <Fld label="Retention %" hint={retAmt>0?`${fmt(retAmt)} held until acceptance`:"0 = no retention"}>
              <Inp type="number" value={form.retentionPct} onChange={e=>f("retentionPct",e.target.value)} placeholder="e.g. 10" min={0} max={100}/>
            </Fld>
            <Fld label="Payment Structure"><Inp value={form.paymentStructure} onChange={e=>f("paymentStructure",e.target.value)} placeholder="e.g. 50% Start / 50% Completion"/></Fld>
            <Fld label="Payment Terms"><Inp value={form.paymentTerms} onChange={e=>f("paymentTerms",e.target.value)} placeholder="e.g. 30 Days, Cash Basis"/></Fld>
            <Fld label="Account (Chart of Accounts)" hint="Defaults to 5200 · Subcontractor Costs">
              <Sel value={form.accountCode||""} onChange={e=>f("accountCode",e.target.value)}>
                <option value="">5200 · Subcontractor Costs (default)</option>
                {[...chartOfAccounts].filter(a=>a.active!==false&&(a.type==="COGS"||a.type==="Expense"||a.type==="Asset")).sort((a,b)=>String(a.code).localeCompare(String(b.code))).map(a=><option key={a.id||a.code} value={a.code}>{a.code} · {a.name}</option>)}
              </Sel>
            </Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp value={form.notes} onChange={e=>f("notes",e.target.value)} placeholder="Internal notes (optional)"/></Fld></div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:16}}>
            <button onClick={submit} disabled={!canSubmit} style={{background:canSubmit?"#1e293b":"#e2e8f0",border:"none",borderRadius:10,padding:"11px 24px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:canSubmit?"#fff":"#94a3b8",cursor:canSubmit?"pointer":"not-allowed"}}>
              {submitting?"⏳ Saving…":editingId?"Save Changes":"🛠️ Issue Work Order"}
            </button>
            <button onClick={()=>{setMode("list");setEditingId(null);}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"11px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  // ── List ──────────────────────────────────────────────────────────────────
  const WO_GRID="86px 1.1fr 1fr 86px 110px 110px 28px";
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>🛠️ Subcon Work Orders</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Scope-of-work engagements with subcontractors — separate from Purchase Orders, counted in the Subcon budget line</div>
        </div>
        {canManage&&(
          <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
            <input ref={batchInputRef} type="file" accept=".csv,.xlsx,.xls" style={{display:"none"}} onChange={onBatchFile}/>
            <button onClick={downloadBatchTemplate} title="Download a CSV template with the expected columns" style={{background:"none",border:"none",color:"#3b82f6",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer",alignSelf:"center",padding:0}}>⬇ Template</button>
            <button onClick={()=>{if(!window.XLSX){toastEmit&&toastEmit("Excel library still loading — try again in a second.","warning");return;}batchInputRef.current&&batchInputRef.current.click();}} disabled={batchBusy} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"9px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#475569",cursor:batchBusy?"wait":"pointer"}}>{batchBusy?"Reading…":"⬆️ Batch Upload"}</button>
            <button onClick={openNew} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>+ New Work Order</button>
          </div>
        )}
      </div>

      {batchRows&&(()=>{
        const valid=batchRows.filter(r=>!r._errors.length);
        const projOpts=[...(wonDeals||[]).map(d=>({id:d.id,label:projDisplayName(d)}))].sort((a,b)=>a.label.localeCompare(b.label));
        return(
          <Modal open onClose={()=>{setBatchRows(null);setBatchFileName("");}} maxWidth={920} title={`Batch Upload — Review (${batchFileName})`}>
            <div style={{fontSize:".82rem",color:"#475569",marginBottom:12}}>
              <b style={{color:"#059669"}}>{valid.length} ready</b>{batchRows.length-valid.length>0&&<> · <b style={{color:"#dc2626"}}>{batchRows.length-valid.length} need attention</b></>} · {woDirect?"will be Issued":"will be submitted for Approval"}. Confirm each row's <b>Project</b> against the app's list below — best guesses are pre-selected; ⚠ rows had no confident match.
            </div>
            <div style={{maxHeight:"52vh",overflow:"auto",border:"1px solid #e2e8f0",borderRadius:10}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:".76rem"}}>
                <thead><tr style={{background:"#f8fafc",textAlign:"left",position:"sticky",top:0}}>
                  {["#","WO No","Subcontractor","Project","Scope","Amount","Ret%","Status"].map(h=><th key={h} style={{padding:"7px 9px",fontWeight:800,color:"#64748b",borderBottom:"1.5px solid #e2e8f0",whiteSpace:"nowrap"}}>{h}</th>)}
                </tr></thead>
                <tbody>
                  {batchRows.map((r,i)=>{
                    const ok=!r._errors.length;
                    return(
                      <tr key={i} style={{background:ok?"#fff":"#fef2f2",borderBottom:"1px solid #f1f5f9"}}>
                        <td style={{padding:"6px 9px",color:"#94a3b8"}}>{r._row}</td>
                        <td style={{padding:"6px 9px",color:"#64748b",whiteSpace:"nowrap"}}>{r.woNumber||"auto"}</td>
                        <td style={{padding:"6px 9px",fontWeight:600,color:"#1e293b"}}>{r.subcontractor||"—"}</td>
                        <td style={{padding:"6px 9px",minWidth:200}}>
                          <select value={r.projectId||""} onChange={e=>setBatchProject(i,e.target.value)} title={r.projectCell?`File said: ${r.projectCell}`:""}
                            style={{width:"100%",maxWidth:230,border:`1.5px solid ${r.projectId?"#e2e8f0":"#fca5a5"}`,borderRadius:7,padding:"5px 7px",fontFamily:"inherit",fontSize:".74rem",color:r.projectId?"#1e293b":"#dc2626",background:"#fff"}}>
                            <option value="">{r.projectCell?`⚠ "${r.projectCell}" — pick…`:"— pick project —"}</option>
                            {projOpts.map(o=><option key={o.id} value={o.id}>{o.label}</option>)}
                          </select>
                        </td>
                        <td style={{padding:"6px 9px",color:"#64748b",maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.scopeOfWork}>{r.scopeOfWork||"—"}</td>
                        <td style={{padding:"6px 9px",fontWeight:700,color:"#1e293b",whiteSpace:"nowrap"}}>{fmt(r.contractAmount)}</td>
                        <td style={{padding:"6px 9px",color:"#64748b"}}>{r.retentionPct||0}%</td>
                        <td style={{padding:"6px 9px",whiteSpace:"nowrap"}}>{ok?<span style={{color:"#059669",fontWeight:700}}>✓ Ready</span>:<span style={{color:"#dc2626",fontWeight:600}} title={r._errors.join("; ")}>⚠ {r._errors[0]}</span>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:16}}>
              <button onClick={()=>{setBatchRows(null);setBatchFileName("");}} style={{background:"#f1f5f9",border:"none",borderRadius:9,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#475569",cursor:"pointer"}}>Cancel</button>
              <button onClick={confirmBatch} disabled={!valid.length} style={{background:valid.length?"#1e293b":"#cbd5e1",border:"none",borderRadius:9,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:valid.length?"pointer":"not-allowed"}}>Import {valid.length} Work Order{valid.length!==1?"s":""}</button>
            </div>
          </Modal>
        );
      })()}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12,marginBottom:18}}>
        <ErpStat label="Total WOs" value={String(filtered.length)} foot="work orders"/>
        <ErpStat tone="warn" label="In Progress" value={String(filtered.filter(w=>w.status==="In Progress").length)} foot="ongoing"/>
        <ErpStat tone="ok" label="Completed" value={String(filtered.filter(w=>w.status==="Completed").length)} foot="finished"/>
        <ErpStat tone="purple" label="Total Value" value={"Php "+totalValue.toLocaleString("en-PH",{maximumFractionDigits:0})} foot="subcontractor contracts"/>
      </div>

      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap"}}>
        <div style={{minWidth:240,flex:"0 1 300px"}}>
          <SearchSelect
            value={filterProj==="all"?null:filterProj}
            onChange={v=>setFilterProj(v||"all")}
            options={projOptions(wonDeals)}
            placeholder="Search project name or CE…"
            noneLabel="All Projects"
            noneValue={null}
          />
        </div>
        <select value={filterStat} onChange={e=>setFilterStat(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Statuses</option>
          {SWO_STATUSES.map(s=><option key={s}>{s}</option>)}
        </select>
      </div>

      {/* Delivery Inspection Modal */}
      {delivModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.45)",zIndex:1100,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:520,maxHeight:"90vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,.25)"}}>
            <div style={{fontWeight:800,color:"#0f172a",fontSize:"1rem",marginBottom:4}}>📦 Record Delivery & Inspection</div>
            <div style={{fontSize:".74rem",color:"#64748b",marginBottom:16}}>{delivModal.wo.woNumber} · {delivModal.wo.subcontractor}</div>
            <div style={{display:"grid",gap:14}}>
              <Fld label="Delivery Method" required>
                <div style={{display:"flex",gap:10}}>
                  {[["warehouse","🏭 Delivered to Warehouse"],["site","📍 Installed on Site"]].map(([v,lbl])=>(
                    <button key={v} onClick={()=>df("mode",v)} style={{flex:1,padding:"10px 0",borderRadius:9,border:`2px solid ${delivForm.mode===v?"#4f46e5":"#e2e8f0"}`,background:delivForm.mode===v?"#ede9fe":"#fff",color:delivForm.mode===v?"#4f46e5":"#64748b",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,cursor:"pointer"}}>
                      {lbl}
                    </button>
                  ))}
                </div>
              </Fld>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                <Fld label="Date Delivered / Installed"><Inp type="date" value={delivForm.deliveredDate} onChange={e=>df("deliveredDate",e.target.value)}/></Fld>
                <Fld label="Inspection Date"><Inp type="date" value={delivForm.inspectedOn} onChange={e=>df("inspectedOn",e.target.value)}/></Fld>
              </div>
              <Fld label="Inspected By"><Inp value={delivForm.inspectedBy||session?.name||""} onChange={e=>df("inspectedBy",e.target.value)} placeholder="Name of inspector"/></Fld>
              <Fld label="Inspection Checklist">
                <div style={{display:"flex",flexDirection:"column",gap:8,padding:"10px 14px",border:"1.5px solid #e0e7ff",borderRadius:9,background:"#f5f3ff"}}>
                  {[["checkQty","Quantity / Count matches WO"],["checkDimensions","Dimensions / Specs correct"],["checkFinish","Finish / Workmanship acceptable"]].map(([k,lbl])=>(
                    <label key={k} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:".8rem",fontWeight:600,color:"#1e293b"}}>
                      <input type="checkbox" checked={!!delivForm[k]} onChange={e=>df(k,e.target.checked)} style={{width:16,height:16,accentColor:"#4f46e5"}}/>
                      {lbl}
                    </label>
                  ))}
                </div>
              </Fld>
              <Fld label="Defects / Issues (if any)">
                <textarea value={delivForm.defectNotes} onChange={e=>df("defectNotes",e.target.value)} rows={2} placeholder="Describe any defects, missing items, or punch-list items…" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".82rem",resize:"vertical",outline:"none",boxSizing:"border-box"}}/>
              </Fld>
              <Fld label="Inspector Notes (optional)">
                <textarea value={delivForm.inspectionNotes} onChange={e=>df("inspectionNotes",e.target.value)} rows={2} placeholder="Additional remarks…" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".82rem",resize:"vertical",outline:"none",boxSizing:"border-box"}}/>
              </Fld>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:18}}>
              <button onClick={()=>setDelivModal(null)} style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 18px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>Cancel</button>
              <button onClick={saveDelivery} disabled={!delivForm.mode} style={{background:delivForm.mode?"#4f46e5":"#e2e8f0",border:"none",borderRadius:9,padding:"9px 22px",fontFamily:"inherit",fontSize:".82rem",color:delivForm.mode?"#fff":"#94a3b8",cursor:delivForm.mode?"pointer":"not-allowed",fontWeight:700}}>✓ Save Inspection</button>
            </div>
          </div>
        </div>
      )}

      {filtered.length===0?(
        <div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8",fontSize:".84rem"}}>No work orders yet. Hit + New Work Order to engage a subcontractor.</div>
      ):(
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,.04)"}}>
          <div style={{overflowX:"auto"}}>
            <div style={{display:"grid",gridTemplateColumns:WO_GRID,gap:0,background:ERP.navyLight,borderBottom:`2px solid ${ERP.line}`,padding:"9px 16px",alignItems:"center",minWidth:660}}>
              {["WO #","Subcontractor","Project","Date","Status","Amount",""].map((h,i)=>(
                <div key={i} style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",color:ERP.navy,paddingRight:8,textAlign:i===5?"right":"left"}}>{h}</div>
              ))}
            </div>
            {filtered.map((w,wi)=>{
              const isOpen=!!expanded[w.id];
              const retAmt=woRetentionAmt(w);
              const lc=swoLifecycle(w);
              return(
                <div key={w.id} style={{borderBottom:wi<filtered.length-1?"1px solid #f1f5f9":"none"}}>
                  <div {...clickable(()=>setExpanded(p=>({...p,[w.id]:!p[w.id]})))} aria-expanded={isOpen} aria-label={`Work order ${w.woNumber||""}, ${w.status||""} — expand details`}
                    style={{display:"grid",gridTemplateColumns:WO_GRID,gap:0,padding:"9px 16px",alignItems:"center",cursor:"pointer",background:isOpen?"#f8fafc":"#fff",transition:"background .12s",minWidth:660}}
                    onMouseEnter={e=>{if(!isOpen)e.currentTarget.style.background="#f8fafc";}}
                    onMouseLeave={e=>{e.currentTarget.style.background=isOpen?"#f8fafc":"#fff";}}>
                    <div style={{fontWeight:700,color:"#6366f1",fontSize:".74rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:6}}>{w.woNumber||"—"}</div>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{w.subcontractor||"—"}{w.specialty&&<span style={{fontWeight:400,color:"#94a3b8",fontSize:".7rem"}}> · {w.specialty}</span>}</div>
                    <div style={{fontSize:".74rem",color:"#64748b",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{w.projectName||"—"}</div>
                    <div style={{fontSize:".7rem",color:"#64748b",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:6}}>{w.woDate||"—"}</div>
                    <div style={{paddingRight:6,overflow:"hidden"}}>
                      <span style={{fontSize:".62rem",background:SWO_STATUS_CLR[w.status]+"22",color:SWO_STATUS_CLR[w.status],border:`1px solid ${SWO_STATUS_CLR[w.status]}44`,borderRadius:20,padding:"1px 8px",fontWeight:700,whiteSpace:"nowrap"}}>{w.status}</span>
                    </div>
                    <div style={{textAlign:"right",paddingRight:4}}>
                      <span style={{fontWeight:700,color:"#10b981",fontSize:".78rem"}}>{fmt(w.contractAmount)}</span>
                      {retAmt>0&&<div style={{fontSize:".6rem",color:"#94a3b8",fontWeight:600}}>{n(w.retentionPct)}% ret.</div>}
                    </div>
                    <div style={{textAlign:"center",color:"#94a3b8",fontSize:".65rem",userSelect:"none"}}>{isOpen?"▲":"▼"}</div>
                  </div>
                  {/* Lifecycle: where this WO sits in the engage → complete → pay chain */}
                  <div style={{padding:"0 16px 7px",background:isOpen?"#f8fafc":"#fff",overflowX:"auto"}}>{swoLifecycleStrip(lc)}</div>
                  {isOpen&&(
                    <div style={{background:"#fafafa",borderTop:"1px solid #f1f5f9",padding:"10px 16px"}}>
                      <div style={{fontSize:".72rem",color:"#475569",whiteSpace:"pre-wrap",background:"#fff",border:"1px solid #f1f5f9",borderRadius:8,padding:"8px 12px",marginBottom:8}}>{w.scopeOfWork||"No scope recorded."}</div>
                      <div style={{display:"flex",gap:12,flexWrap:"wrap",fontSize:".7rem",color:"#64748b",marginBottom:8}}>
                        {(w.startDate||w.targetEndDate)&&<span>📅 {w.startDate||"—"} → {w.targetEndDate||"—"}</span>}
                        {w.paymentStructure&&<span>💸 {w.paymentStructure}</span>}
                        {w.paymentTerms&&<span>🗓 {w.paymentTerms}</span>}
                        {retAmt>0&&<span style={{color:"#c2410c",fontWeight:600}}>Retention {n(w.retentionPct)}% = {fmt(retAmt)}</span>}
                        <span>By: {w.requestedBy||"—"}</span>
                        {w.approvedBy&&<span style={{color:"#10b981",fontWeight:600}}>✓ {w.approvedBy}</span>}
                        {w.notes&&<span style={{fontStyle:"italic"}}>{w.notes}</span>}
                      </div>
                      {/* ── Delivery & Inspection ── */}
                      {(w.status==="Issued"||w.status==="In Progress"||w.status==="Completed")&&(()=>{
                        const d=w.delivery;
                        const retAmt2=woRetentionAmt(w);
                        return(
                          <div style={{marginBottom:10,border:"1.5px solid #e0e7ff",borderRadius:10,padding:"10px 14px",background:"#f5f3ff"}}>
                            <div style={{fontWeight:700,fontSize:".72rem",color:"#4f46e5",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                              📦 Delivery & Acceptance
                              {!d&&<span style={{fontSize:".62rem",background:"#fef9c3",color:"#a16207",border:"1px solid #fde68a",borderRadius:20,padding:"1px 8px",fontWeight:700}}>⏳ Awaiting Delivery</span>}
                              {d?.status==="Inspected"&&<span style={{fontSize:".62rem",background:"#dbeafe",color:"#1d4ed8",border:"1px solid #93c5fd",borderRadius:20,padding:"1px 8px",fontWeight:700}}>🔍 Inspected — Pending Sign-off</span>}
                              {d?.status==="Accepted"&&<span style={{fontSize:".62rem",background:"#dcfce7",color:"#15803d",border:"1px solid #86efac",borderRadius:20,padding:"1px 8px",fontWeight:700}}>✅ Accepted by {d.signedOffBy}</span>}
                              {d?.status==="Rejected"&&<span style={{fontSize:".62rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fca5a5",borderRadius:20,padding:"1px 8px",fontWeight:700}}>❌ Rejected</span>}
                            </div>
                            {d&&(
                              <div style={{display:"flex",gap:16,flexWrap:"wrap",fontSize:".7rem",color:"#374151",marginBottom:8}}>
                                <span>📍 {d.mode==="warehouse"?"Delivered to Warehouse":"Installed on Site"}</span>
                                <span>📅 {d.deliveredDate||"—"}</span>
                                <span>🔍 Inspected by {d.inspectedBy||"—"} on {d.inspectedOn||"—"}</span>
                                {d.signedOffBy&&<span style={{color:"#059669",fontWeight:700}}>✅ Signed off by {d.signedOffBy} · {d.signedOffOn}</span>}
                              </div>
                            )}
                            {d&&(
                              <div style={{display:"flex",gap:8,flexWrap:"wrap",fontSize:".69rem",marginBottom:8}}>
                                {[["Qty / Count",d.checkQty],["Dimensions",d.checkDimensions],["Finish / Quality",d.checkFinish]].map(([lbl,ok])=>(
                                  <span key={lbl} style={{padding:"2px 9px",borderRadius:20,fontWeight:600,background:ok?"#dcfce7":"#fee2e2",color:ok?"#15803d":"#dc2626",border:`1px solid ${ok?"#86efac":"#fca5a5"}`}}>{ok?"✓":"✗"} {lbl}</span>
                                ))}
                                {d.defectNotes&&<span style={{color:"#b45309",fontStyle:"italic"}}>⚠ {d.defectNotes}</span>}
                              </div>
                            )}
                            {/* Retention release status */}
                            {d?.status==="Accepted"&&retAmt2>0&&(
                              <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 10px",background:d.retentionReleased?"#dcfce7":"#fffbeb",borderRadius:8,border:`1px solid ${d.retentionReleased?"#86efac":"#fde68a"}`,marginBottom:8}}>
                                <span style={{fontSize:".69rem",fontWeight:700,color:d.retentionReleased?"#15803d":"#b45309"}}>
                                  {d.retentionReleased?`✅ Retention ₱${retAmt2.toLocaleString("en-PH")} released · ${d.retentionReleasedOn}`:`🔒 Retention ₱${retAmt2.toLocaleString("en-PH")} held`}
                                </span>
                                {!d.retentionReleased&&canSignOff&&(
                                  <button onClick={()=>releaseRetention(w)} style={{background:"#059669",border:"none",borderRadius:6,padding:"3px 10px",fontSize:".68rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>Release Retention</button>
                                )}
                              </div>
                            )}
                            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                              {(role==="PM"||role==="Warehouse"||role==="Ops"||role==="Manager")&&(
                                <button onClick={()=>openDelivery(w)} style={{background:"#4f46e5",border:"none",borderRadius:7,padding:"4px 12px",fontSize:".7rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>
                                  {d?"📝 Update Inspection":"📦 Record Delivery"}
                                </button>
                              )}
                              {d?.status==="Inspected"&&canSignOff&&(
                                <button onClick={()=>signOffDelivery(w)} style={{background:"#059669",border:"none",borderRadius:7,padding:"4px 12px",fontSize:".7rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>
                                  ✅ Sign Off (Ops Director)
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })()}
                      <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                        <select value={w.status} onChange={e=>{const st=e.target.value;
                          const dpBlk=WO_ISSUED.includes(st)&&!WO_ISSUED.includes(w.status)&&dpBlockedDeal(w.projectId);
                          if(dpBlk){toastEmit&&toastEmit(dpMsg(dpBlk),"error",9000);return;}
                          if(st==="Issued"&&(w.status==="Pending Approval"||w.status==="Draft")&&!canApprovePO(role,session?.name||"",w.requestedBy)){toastEmit&&toastEmit("Needs a Manager or the Procurement Manager to approve.","error");return;}
                          updateSWO(w.id,{status:st,...(st==="Issued"&&w.status!=="Issued"?{approvedBy:session?.name||"",acctStatus:w.acctStatus||"For Accounting"}:{})});}} style={{border:"1.5px solid #e2e8f0",borderRadius:6,padding:"3px 6px",fontFamily:"inherit",fontSize:".7rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
                          {SWO_STATUSES.map(s=><option key={s}>{s}</option>)}
                        </select>
                        {w.acctStatus&&<span style={{fontSize:".62rem",background:(ACCT_CLR[w.acctStatus]||"#94a3b8")+"22",color:ACCT_CLR[w.acctStatus]||"#94a3b8",border:`1px solid ${(ACCT_CLR[w.acctStatus]||"#94a3b8")}44`,borderRadius:20,padding:"1px 8px",fontWeight:700}}>🧾 {w.acctStatus}{w.acctStatus==="Payment Ordered"&&w.paymentBank?` · ${(BANKS.find(b=>b.id===w.paymentBank)||{}).short||w.paymentBank}`:""}</span>}
                        <div style={{marginLeft:"auto",display:"flex",gap:6}}>
                          {(w.status==="Pending Approval"||w.status==="Draft")&&canApprovePO(role,session?.name||"",w.requestedBy)&&(
                            <button onClick={()=>{
                              const dpBlk=dpBlockedDeal(w.projectId);
                              if(dpBlk){toastEmit&&toastEmit(dpMsg(dpBlk),"error",9000);return;}
                              updateSWO(w.id,{status:"Issued",approvedBy:session?.name||"",acctStatus:"For Accounting"});
                              const aMsg=`✅ <b>Work Order Approved — ${w.woNumber}</b>\nSubcontractor: ${w.subcontractor||"—"}\nAmount: ${fmt(w.contractAmount)}\nRequested by: ${w.requestedBy||"—"}\nApproved by: ${session?.name||"?"} · ${today}\n→ Sent to Accounting for documentation`;
                              sendTelegramNotification("procurement",aMsg);
                              sendTelegramNotification("financialcontrol",aMsg);
                              toastEmit&&toastEmit(`${w.woNumber} approved — sent to Accounting`,"success");
                            }} style={{background:"#059669",border:"none",borderRadius:7,padding:"4px 12px",fontSize:".72rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>✓ Approve & Issue</button>
                          )}
                          {(w.status==="Pending Approval"||w.status==="Draft")&&!canApprovePO(role,session?.name||"",w.requestedBy)&&(
                            <span style={{fontSize:".68rem",color:"#b45309",fontWeight:600,alignSelf:"center"}}>⏳ Awaiting approval</span>
                          )}
                          <button aria-label={`Print work order ${w.woNumber||""}`.trim()} title="Print work order" onClick={()=>printWO(w)} style={{background:"#eff6ff",border:"none",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#1e40af",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>🖨 Print</button>
                          <button aria-label="Generate subcontractor contract" onClick={()=>printSubconContract(w)} title="Generate the Standard Subcontractor Contract" style={{background:"#0B2545",border:"none",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>📄 Contract</button>
                          <button aria-label={`Edit work order ${w.woNumber||""}`.trim()} title="Edit work order" onClick={()=>openEdit(w)} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏ Edit</button>
                          {canManage&&<button aria-label={`Delete work order ${w.woNumber||""}`.trim()} title="Delete work order" onClick={async ()=>{
                            // Policy v2.0: a WO already in Accounting (or paid) can't be
                            // deleted silently — it breaks the finance/document trail.
                            const inFinance=["For Accounting","Checked","Payment Ordered","Paid"].includes(w.acctStatus||"")||(Number(w.paidAmt)||0)>0;
                            const note=inFinance?`\n\n⚠️ This WO is already with Accounting${w.acctStatus?` (status: ${w.acctStatus})`:""}${(Number(w.paidAmt)||0)>0?` and has a recorded payment`:""}. Deleting it breaks the finance trail — handle it in the Accounting board instead if this is a mistake.`:"";
                            if((await uiConfirm({title:"Delete work order",tone:"danger",confirmLabel:"Delete WO",message:`Delete ${w.woNumber||"this work order"}?${note}\n\nThis cannot be undone.`})))deleteSWO(w.id);
                          }} style={{background:"#fef2f2",border:"none",borderRadius:7,padding:"4px 10px",fontSize:".72rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>✕</button>}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── ACCOUNTING / FINANCE — PO DOCUMENTATION & PAYMENT ORDERS ────────────────
// Pipeline: Procurement issues → Accounting checks & takes notes → Finance
// creates the bank-tagged Payment Order. Lives on the Accounting page.

// ─── PO DOCUMENTATION QUEUE ─────────────────────────────────────────────────────
function PoDocumentationQueue({prs,swos,updatePR,updateSWO,wonDeals,session,role,toastEmit,sendTelegramNotification,settleDocPayable}){
  const today=new Date().toISOString().split("T")[0];
  const n=v=>Number(String(v).replace(/,/g,""))||0;
  const fmt=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:0});
  const ACCT_CLR={"For Accounting":"#d97706","Checked":"#2563eb","Payment Ordered":"#059669"};
  const[stageFilter,setStageFilter]=useState("For Accounting");
  const[open,setOpen]=useState({});
  const[notesDraft,setNotesDraft]=useState({});
  const[bankPick,setBankPick]=useState({});
  const[refPick,setRefPick]=useState({});
  const[paidRef,setPaidRef]=useState({});
  const[paidDate,setPaidDate]=useState({});
  const[paidAmt,setPaidAmt]=useState({});
  const canAct=role==="Manager"||role==="Finance";

  const docs=[];
  const byPO={};
  prs.forEach(p=>{ if(p.acctStatus){const key=p.poNumber||p.id;(byPO[key]=byPO[key]||[]).push(p);} });
  Object.entries(byPO).forEach(([key,items])=>{
    const gross=items.reduce((s,p)=>(n(p.actUnitCost)||n(p.estUnitCost))*n(p.qty)+s,0);
    const d=items.find(i=>n(i.poDiscValue)>0);
    const poDisc=(()=>{if(!d)return 0;if(d.poDiscType==="pct")return gross*(n(d.poDiscValue)/100);if(d.poDiscType==="fixed")return Math.min(n(d.poDiscValue),gross);return 0;})();
    const afterPo=gross-poDisc;
    const amount=Math.round((afterPo+(items[0]?.withVat?afterPo*0.12:0))*100)/100;
    const a=items.find(i=>i.acctStatus)||items[0];
    docs.push({kind:"PO",key:"po:"+key,number:items[0].poNumber||"(no PO #)",payee:items[0].supplier||"—",
      projects:[...new Set(items.map(i=>i.projectName).filter(Boolean))].join(", ")||"—",
      amount,acct:a,lines:items,
      apply:changes=>items.forEach(i=>updatePR(i.id,changes,{silent:true}))});
  });
  (swos||[]).forEach(w=>{
    if(!w.acctStatus) return;
    docs.push({kind:"WO",key:"wo:"+w.id,number:w.woNumber||"(no WO #)",payee:w.subcontractor||"—",
      projects:w.projectName||"—",amount:n(w.contractAmount),acct:w,lines:null,retentionPct:n(w.retentionPct),
      apply:changes=>updateSWO(w.id,changes)});
  });
  const STAGES=["For Accounting","Checked","Payment Ordered","Paid"];
  const STAGE_CLR={"For Accounting":"#f59e0b","Checked":"#3b82f6","Payment Ordered":"#8b5cf6","Paid":"#059669"};
  docs.sort((a,b)=>STAGES.indexOf(a.acct.acctStatus)-STAGES.indexOf(b.acct.acctStatus)||String(b.number).localeCompare(String(a.number)));
  const shown=stageFilter==="All"?docs:docs.filter(d=>d.acct.acctStatus===stageFilter);
  const counts=Object.fromEntries(STAGES.map(s=>[s,docs.filter(d=>d.acct.acctStatus===s).length]));

  // AP Aging totals
  const agingTotals=STAGES.map(s=>({stage:s,total:docs.filter(d=>d.acct.acctStatus===s).reduce((sum,d)=>sum+d.amount,0),count:counts[s]}));
  const totalOutstanding=agingTotals.filter(a=>a.stage!=="Paid").reduce((s,a)=>s+a.total,0);

  const printPaymentOrder=d=>{
    const a=d.acct;
    const bank=BANKS.find(b=>b.id===a.paymentBank);
    const esc=s=>String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    const fmt2=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2});
    const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Payment Order — ${esc(d.number)}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:Arial,sans-serif;padding:32px;color:#0f172a;font-size:12px}
  .hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;border-bottom:2px solid #1e293b;padding-bottom:16px}
  .co{font-size:22px;font-weight:800;letter-spacing:-0.5px}
  .co-sub{font-size:11px;color:#64748b;margin-top:2px}
  .doc-title{font-size:20px;font-weight:800;color:#1e293b}
  .doc-sub{font-size:11px;color:#64748b;margin-top:3px}
  table{width:100%;border-collapse:collapse;margin-top:8px}
  td{padding:9px 10px;border-bottom:1px solid #f1f5f9;vertical-align:top;font-size:12px}
  td.lbl{color:#64748b;width:200px}
  td.val{font-weight:700}
  .amount-row td{font-weight:800;background:#eff6ff;color:#1e40af;border-top:2px solid #1e293b;font-size:15px}
  .paid-row td{font-weight:800;background:#f0fdf4;color:#059669;border-top:2px solid #059669;font-size:13px}
  .trail{margin-top:16px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:12px 14px;font-size:11px;color:#475569;line-height:1.8}
  .sig{display:grid;grid-template-columns:1fr 1fr 1fr;gap:24px;margin-top:44px}
  .sig-box{border-top:1px solid #cbd5e1;padding-top:8px;font-size:10px;color:#64748b}
  @media print{body{padding:20px}}
</style></head><body>
<div class="hdr">
  <div><div class="co">GMD PRODUCTIONS INC</div><div class="co-sub">Fabrication &amp; Project Management</div></div>
  <div style="text-align:right"><div class="doc-title">PAYMENT ORDER</div><div class="doc-sub">${esc(d.number)} · ${esc(a.paymentOrderedAt)||today}</div></div>
</div>
<table>
  <tr><td class="lbl">Pay To</td><td class="val">${esc(d.payee)}</td></tr>
  <tr><td class="lbl">For</td><td class="val">${d.kind} ${esc(d.number)} — ${esc(d.projects)}</td></tr>
  <tr><td class="lbl">Pay From (Bank)</td><td class="val">${esc(bank?bank.name+" ("+bank.short+")":a.paymentBank||"—")}</td></tr>
  <tr><td class="lbl">Reference / Cheque</td><td class="val">${esc(a.paymentRef)||"—"}</td></tr>
  ${d.kind==="WO"&&d.retentionPct>0?`<tr><td class="lbl">Retention (${d.retentionPct}%)</td><td class="val">−${fmt2(d.amount*d.retentionPct/100)} held until acceptance</td></tr>`:""}
  <tr class="amount-row"><td>AMOUNT</td><td>${fmt2(d.amount)}</td></tr>
  ${a.acctStatus==="Paid"?`<tr class="paid-row"><td>✅ PAID</td><td>${esc(a.paidRef||"—")} · ${esc(a.paidDate||"—")}${a.paidAmt?` · ${fmt2(a.paidAmt)} confirmed`:""}<br><span style="font-size:11px;font-weight:400">Confirmed by: ${esc(a.paidBy||"—")}</span></td></tr>`:""}
</table>
${a.acctNotes?`<div class="trail"><b>Accounting notes:</b><br>${esc(a.acctNotes)}</div>`:""}
<div class="trail">
  Requested by: <b>${esc(a.requestedBy)||"—"}</b><br>
  Approved by: <b>${esc(a.approvedBy)||"—"}</b><br>
  Checked by Accounting: <b>${esc(a.acctCheckedBy)||"—"}</b>${a.acctCheckedAt?` · ${esc(a.acctCheckedAt)}`:""}<br>
  Payment ordered by: <b>${esc(a.paymentOrderedBy)||"—"}</b>${a.paymentOrderedAt?` · ${esc(a.paymentOrderedAt)}`:""}${a.acctStatus==="Paid"?`<br>Payment confirmed by: <b>${esc(a.paidBy||"—")}</b> · ${esc(a.paidDate||"—")}`:""}</div>
<div class="sig">
  <div class="sig-box">Prepared by — Finance<br><br><br>_______________________<br>${esc(a.paymentOrderedBy)||""}</div>
  <div class="sig-box">Approved by<br><br><br>_______________________</div>
  <div class="sig-box">Received by — Payee<br><br><br>_______________________</div>
</div>
</body></html>`;
    const win=window.open("","_blank","width=900,height=700");
    if(win){win.document.write(html);win.document.close();addPrintClose(win);setTimeout(()=>win.print(),600);}
  };

  if(docs.length===0) return null;
  return(
    <div style={{marginBottom:22}}>
      {/* AP Aging Summary */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:14}}>
        {agingTotals.map(a=>(
          <div key={a.stage} {...clickable(()=>setStageFilter(a.stage))} aria-label={`Filter by stage ${a.stage}`} style={{background:T.surface,border:`1.5px solid ${STAGE_CLR[a.stage]}44`,borderRadius:10,padding:"10px 14px",cursor:"pointer",transition:"box-shadow .15s",boxShadow:stageFilter===a.stage?"0 0 0 2px "+STAGE_CLR[a.stage]:"0 1px 3px rgba(0,0,0,.05)"}}>
            <div style={{fontSize:".68rem",color:STAGE_CLR[a.stage],fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:2}}>{a.stage}</div>
            <div style={{fontWeight:800,fontSize:"1rem",color:"#0f172a"}}>{fmt(a.total)}</div>
            <div style={{fontSize:".68rem",color:"#94a3b8"}}>{a.count} doc{a.count!==1?"s":""}</div>
          </div>
        ))}
        <div style={{background:"#1e293b",borderRadius:10,padding:"10px 14px"}}>
          <div style={{fontSize:".68rem",color:"#94a3b8",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",marginBottom:2}}>Outstanding</div>
          <div style={{fontWeight:800,fontSize:"1rem",color:"#f97316"}}>{fmt(totalOutstanding)}</div>
          <div style={{fontSize:".68rem",color:"#64748b"}}>unpaid total</div>
        </div>
      </div>

      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10,flexWrap:"wrap"}}>
        <div style={{fontWeight:800,color:"#0f172a",fontSize:"1rem"}}>🧾 PO Documentation & Payment Orders</div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {["All",...STAGES].map(s=>(
            <button key={s} onClick={()=>setStageFilter(s)} style={{padding:"4px 12px",borderRadius:20,border:`1.5px solid ${stageFilter===s?(STAGE_CLR[s]||"#3b82f6"):"#e2e8f0"}`,background:stageFilter===s?(STAGE_CLR[s]||"#3b82f6")+"18":"#fff",color:stageFilter===s?(STAGE_CLR[s]||"#3b82f6"):"#64748b",fontWeight:stageFilter===s?700:400,cursor:"pointer",fontFamily:"inherit",fontSize:".74rem"}}>
              {s}{s!=="All"&&counts[s]>0?` (${counts[s]})`:""}
            </button>
          ))}
        </div>
      </div>
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,.04)"}}>
        {shown.length===0&&<div style={{textAlign:"center",padding:"20px 0",color:"#94a3b8",fontSize:".8rem"}}>Nothing in "{stageFilter}".</div>}
        {shown.map((d,di)=>{
          const a=d.acct;
          const isOpen=!!open[d.key];
          const draft=notesDraft[d.key]!==undefined?notesDraft[d.key]:(a.acctNotes||"");
          const bank=bankPick[d.key]!==undefined?bankPick[d.key]:(a.paymentBank||"");
          const ref=refPick[d.key]!==undefined?refPick[d.key]:(a.paymentRef||"");
          const pRef=paidRef[d.key]!==undefined?paidRef[d.key]:(a.paidRef||"");
          const pDate=paidDate[d.key]!==undefined?paidDate[d.key]:(a.paidDate||today);
          const pAmt=paidAmt[d.key]!==undefined?paidAmt[d.key]:(a.paidAmt!=null?String(a.paidAmt):"");
          const stageColor=STAGE_CLR[a.acctStatus]||"#94a3b8";
          return(
            <div key={d.key} style={{borderBottom:di<shown.length-1?"1px solid #f1f5f9":"none"}}>
              <div onClick={()=>setOpen(p=>({...p,[d.key]:!p[d.key]}))}
                style={{display:"grid",gridTemplateColumns:"40px 86px 1.2fr 1fr 130px 110px 28px",gap:0,padding:"9px 16px",alignItems:"center",cursor:"pointer",background:isOpen?"#f8fafc":"#fff"}}
                onMouseEnter={e=>{if(!isOpen)e.currentTarget.style.background="#f8fafc";}}
                onMouseLeave={e=>{e.currentTarget.style.background=isOpen?"#f8fafc":"#fff";}}>
                <div style={{fontSize:".82rem"}}>{d.kind==="PO"?"📦":"🛠"}</div>
                <div style={{fontWeight:700,color:"#6366f1",fontSize:".74rem"}}>{d.number}</div>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{d.payee}</div>
                <div style={{fontSize:".72rem",color:"#64748b",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{d.projects}</div>
                <div style={{paddingRight:6}}>
                  <span style={{fontSize:".62rem",background:stageColor+"22",color:stageColor,border:`1px solid ${stageColor}44`,borderRadius:20,padding:"1px 8px",fontWeight:700,whiteSpace:"nowrap"}}>{a.acctStatus}</span>
                </div>
                <div style={{textAlign:"right",fontWeight:700,color:a.acctStatus==="Paid"?"#059669":"#10b981",fontSize:".78rem",paddingRight:4,textDecoration:a.acctStatus==="Paid"?"line-through":"none",opacity:a.acctStatus==="Paid"?0.6:1}}>{fmt(d.amount)}</div>
                <div style={{textAlign:"center",color:"#94a3b8",fontSize:".65rem"}}>{isOpen?"▲":"▼"}</div>
              </div>
              {isOpen&&(
                <div style={{background:"#fafafa",borderTop:"1px solid #f1f5f9",padding:"10px 16px"}}>
                  {d.lines&&(
                    <div style={{fontSize:".7rem",color:"#64748b",marginBottom:8}}>
                      {d.lines.map(l=><div key={l.id}>• {l.itemName} — {l.qty} {l.unit} × {fmt(n(l.actUnitCost)||n(l.estUnitCost))}</div>)}
                    </div>
                  )}
                  <div style={{display:"flex",gap:12,flexWrap:"wrap",fontSize:".7rem",color:"#64748b",marginBottom:8}}>
                    <span>Requested: {a.requestedBy||"—"}</span>
                    <span>Approved: {a.approvedBy||"—"}</span>
                    {a.acctCheckedBy&&<span style={{color:"#3b82f6",fontWeight:600}}>✓ Checked: {a.acctCheckedBy} · {a.acctCheckedAt}</span>}
                    {a.paymentOrderedBy&&<span style={{color:"#8b5cf6",fontWeight:600}}>💳 Payment Order: {(BANKS.find(b=>b.id===a.paymentBank)||{}).short||a.paymentBank||"—"} · {a.paymentRef||"no ref"} · {a.paymentOrderedBy} · {a.paymentOrderedAt}</span>}
                    {a.acctStatus==="Paid"&&<span style={{color:"#059669",fontWeight:700}}>✅ Paid: {a.paidRef||"—"} · {a.paidDate||"—"}{a.paidAmt?` · ₱${Number(a.paidAmt).toLocaleString("en-PH")}`:""} · {a.paidBy||"—"}</span>}
                  </div>
                  <textarea value={draft} onChange={e=>setNotesDraft(p=>({...p,[d.key]:e.target.value}))} rows={2}
                    placeholder="Accounting notes — receipts checked, OR/SI numbers, discrepancies…"
                    disabled={!canAct}
                    style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 11px",fontFamily:"inherit",fontSize:".78rem",color:"#1e293b",resize:"vertical",outline:"none",boxSizing:"border-box",background:canAct?"#fff":"#f8fafc"}}/>
                  <div style={{display:"flex",gap:6,alignItems:"center",marginTop:8,flexWrap:"wrap"}}>
                    {canAct&&draft!==(a.acctNotes||"")&&(
                      <button onClick={()=>{d.apply({acctNotes:draft});toastEmit&&toastEmit("Notes saved","success");}}
                        style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"5px 12px",fontSize:".72rem",color:"#475569",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>💾 Save Notes</button>
                    )}
                    <div style={{marginLeft:"auto",display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                      {canAct&&a.acctStatus==="For Accounting"&&(
                        <button onClick={()=>{
                          d.apply({acctStatus:"Checked",acctNotes:draft,acctCheckedBy:session?.name||"",acctCheckedAt:today});
                          sendTelegramNotification&&sendTelegramNotification("financialcontrol",`🧾 <b>${d.kind} ${d.number} checked by Accounting</b>\nPayee: ${d.payee}\nAmount: ${fmt(d.amount)}\nChecked by: ${session?.name||"?"}\n→ Ready for Payment Order`);
                          toastEmit&&toastEmit(`${d.number} checked — ready for payment order`,"success");
                        }} style={{background:"#3b82f6",border:"none",borderRadius:7,padding:"5px 14px",fontSize:".72rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>✓ Mark Checked</button>
                      )}
                      {canAct&&a.acctStatus==="Checked"&&(<>
                        <select value={bank} onChange={e=>setBankPick(p=>({...p,[d.key]:e.target.value}))} style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 8px",fontFamily:"inherit",fontSize:".72rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
                          <option value="">— Pay from bank… —</option>
                          {BANKS.map(b=><option key={b.id} value={b.id}>{b.short}</option>)}
                        </select>
                        <input value={ref} onChange={e=>setRefPick(p=>({...p,[d.key]:e.target.value}))} placeholder="Cheque / ref no. (optional)"
                          style={{width:160,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 9px",fontFamily:"inherit",fontSize:".72rem",color:"#1e293b",boxSizing:"border-box"}}/>
                        <button disabled={!bank} onClick={()=>{
                          if(!bank) return;
                          d.apply({acctStatus:"Payment Ordered",paymentBank:bank,paymentRef:ref,paymentOrderedBy:session?.name||"",paymentOrderedAt:today});
                          const bk=(BANKS.find(b=>b.id===bank)||{}).short||bank;
                          const pMsg=`💳 <b>Payment Order — ${d.kind} ${d.number}</b>\nPay to: ${d.payee}\nAmount: ${fmt(d.amount)}\nBank: ${bk}${ref?`\nRef: ${ref}`:""}\nBy: ${session?.name||"?"} · ${today}`;
                          sendTelegramNotification&&sendTelegramNotification("financialcontrol",pMsg);
                          toastEmit&&toastEmit(`Payment order created for ${d.number} (${bk})`,"success");
                        }} style={{background:bank?"#059669":"#e2e8f0",border:"none",borderRadius:7,padding:"5px 14px",fontSize:".72rem",color:bank?"#fff":"#94a3b8",cursor:bank?"pointer":"not-allowed",fontFamily:"inherit",fontWeight:700}}>💳 Create Payment Order</button>
                      </>)}
                      {canAct&&a.acctStatus==="Payment Ordered"&&(<>
                        <input value={pRef} onChange={e=>setPaidRef(p=>({...p,[d.key]:e.target.value}))} placeholder="OR / Cheque / ref no."
                          style={{width:150,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 9px",fontFamily:"inherit",fontSize:".72rem",color:"#1e293b",boxSizing:"border-box"}}/>
                        <input type="date" value={pDate} onChange={e=>setPaidDate(p=>({...p,[d.key]:e.target.value}))}
                          style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 8px",fontFamily:"inherit",fontSize:".72rem",color:"#1e293b"}}/>
                        <input type="number" value={pAmt} onChange={e=>setPaidAmt(p=>({...p,[d.key]:e.target.value}))} placeholder={`Amt paid (${fmt(d.amount)})`}
                          style={{width:130,border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 9px",fontFamily:"inherit",fontSize:".72rem",color:"#1e293b",boxSizing:"border-box"}}/>
                        <button onClick={()=>{
                          const confirmedAmt=pAmt?Number(pAmt):d.amount;
                          d.apply({acctStatus:"Paid",paidRef:pRef||a.paymentRef||"",paidDate:pDate||today,paidAmt:confirmedAmt,paidBy:session?.name||""});
                          settleDocPayable&&settleDocPayable(d.number,confirmedAmt,a.paymentBank,pRef||a.paymentRef||"");
                          const bk=(BANKS.find(b=>b.id===a.paymentBank)||{}).short||a.paymentBank||"—";
                          sendTelegramNotification&&sendTelegramNotification("financialcontrol",`✅ <b>Payment Confirmed — ${d.kind} ${d.number}</b>\nPaid to: ${d.payee}\nAmount: ₱${confirmedAmt.toLocaleString("en-PH")}\nBank: ${bk}\nRef: ${pRef||a.paymentRef||"—"}\nDate: ${pDate||today}\nBy: ${session?.name||"?"}`);
                          toastEmit&&toastEmit(`${d.number} marked as Paid ✅`,"success");
                        }} style={{background:"#059669",border:"none",borderRadius:7,padding:"5px 14px",fontSize:".72rem",color:"#fff",cursor:"pointer",fontFamily:"inherit",fontWeight:700}}>✅ Mark as Paid</button>
                        <button onClick={()=>printPaymentOrder(d)} style={{background:"#eff6ff",border:"none",borderRadius:7,padding:"5px 12px",fontSize:".72rem",color:"#1e40af",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>🖨 Print</button>
                      </>)}
                      {a.acctStatus==="Paid"&&(
                        <button onClick={()=>printPaymentOrder(d)} style={{background:"#f0fdf4",border:"none",borderRadius:7,padding:"5px 12px",fontSize:".72rem",color:"#059669",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>🖨 Print Receipt</button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── COSTING STUDY ────────────────────────────────────────────────────────────

// ─── DOWN PAYMENT GATE (POs / subcon WOs) ────────────────────────────────────
// Shown wherever a PO or work order is about to be issued on a deal that has no
// payment yet ("NO DP = NO production"). Managers can waive the down payment
// for the deal right here, with a reason; everyone else is told who can.
// Rule: dealDpClear (core.js) + migration 20261020110000.
function DpGate({deal,deals,role,onWaiveDp,what="POs"}){
  const[reason,setReason]=useState("");
  const[busy,setBusy]=useState(false);
  if(!deal) return null;
  const mgr=canonRole(role)==="Manager";
  const label=`${deal.client||"This deal"}${deal.ceNo?" ("+deal.ceNo+")":""}`;
  const waive=async(r)=>{if(busy||!onWaiveDp)return;setBusy(true);const ok=await onWaiveDp(deal.id,r);setBusy(false);if(ok)setReason("");};
  if(deal.dpWaivedAt) return(
    <div style={{fontSize:".72rem",color:"#92400e",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"7px 10px",marginBottom:8,lineHeight:1.5}}>
      Down payment waived on {label} by {deal.dpWaivedBy||"a Manager"}{deal.dpWaivedAt?" on "+String(deal.dpWaivedAt).slice(0,10):""}: {deal.dpWaivedReason||"—"}
      {mgr&&onWaiveDp&&<button type="button" disabled={busy} onClick={()=>waive(null)} style={{marginLeft:8,background:"none",border:"none",color:"#b45309",fontWeight:700,cursor:"pointer",fontFamily:"inherit",fontSize:".72rem",textDecoration:"underline",padding:0}}>Remove waiver</button>}
    </div>);
  if(dealDpClear(deal,deals)) return null;
  return(
    <div role="alert" style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"10px 12px",marginBottom:10,fontSize:".76rem",color:"#991b1b",lineHeight:1.5}}>
      <b>No down payment received on {label}.</b> {what} can't be issued until the client pays, or a Manager waives the down payment for this deal (for example, a client on credit terms).
      {mgr&&onWaiveDp
        ?<div style={{display:"flex",gap:6,marginTop:8,flexWrap:"wrap"}}>
            <input value={reason} onChange={e=>setReason(e.target.value)} placeholder="Reason, e.g. SM credit terms, pays 30 days after delivery" aria-label="Reason for waiving the down payment"
              style={{flex:"1 1 220px",minWidth:0,border:"1.5px solid #fecaca",borderRadius:7,padding:"6px 9px",fontFamily:"inherit",fontSize:".76rem",background:"#fff",boxSizing:"border-box"}}/>
            <button type="button" disabled={busy||reason.trim().length<5} onClick={()=>waive(reason)} style={{background:reason.trim().length<5?"#fca5a5":"#b91c1c",border:"none",borderRadius:7,padding:"6px 12px",fontFamily:"inherit",fontSize:".74rem",fontWeight:700,color:"#fff",cursor:reason.trim().length<5?"not-allowed":"pointer"}}>{busy?"Saving…":"Waive down payment"}</button>
          </div>
        :<div style={{marginTop:4,color:"#7f1d1d"}}>Ask a Manager to waive it, or wait for Finance to record the client's payment.</div>}
    </div>);
}

// ─── PROCUREMENT VIEW 2 (Full PO → Multi-item → Delivery) ───────────────────
function ProcurementView2({prs,addPR,updatePR,deletePR,upPrs,wonDeals,deals:allDeals,budgets,exps,swos,session,role,toastEmit,suppliers,addSupplier,upPayables,payables,sendTelegramNotification,isSupabaseReady,sbUpsert,payableToSb,syncPoPayable,approvePOs,chartOfAccounts=[],onWaiveDp,costCenterDeals=[],onCreateCostCenter}){
  // Internal cost centers (HR, GMD Tools, warehouse stock…): deals flagged
  // is_cost_center, bought against like a project but kept out of project
  // lists. Only a Manager adds one (create_cost_center RPC).
  const[showCostCenters,setShowCostCenters]=useState(false);
  const[newCostCenter,setNewCostCenter]=useState("");
  const[ccBusy,setCcBusy]=useState(false);
  const addCostCenter=async()=>{
    if(ccBusy||!newCostCenter.trim()||!onCreateCostCenter) return;
    setCcBusy(true);
    try{if(await onCreateCostCenter(newCostCenter)) setNewCostCenter("");}
    finally{setCcBusy(false);}
  };
  const activeDeals=React.useMemo(()=>(allDeals||wonDeals||[]).filter(d=>!isLostStage(d.stage)),[allDeals,wonDeals]);
  const today=new Date().toISOString().split("T")[0];
  // ── PO approval gate ────────────────────────────────────────────────────────
  // Segregation of duties: a PO may only be moved to "PO Issued" by a Manager or
  // by the Procurement Manager (canApprovePO; the database checks it too).
  // The person who prepared/created the PO cannot self-approve it. Anyone without
  // authority who selects "PO Issued" is held at "Pending Approval" with no
  // approver stamp, so the printed PO never shows the preparer as the approver.
  // Same helper (canApprovePO) already gates Subcon Work Orders.
  const canApproveFor=requestedBy=>canApprovePO(role,session?.name||"",requestedBy);
  // Down payment gate: the deal a PO line is for, when that deal still needs a
  // down payment (or a Manager's waiver) before anything can be issued on it.
  const ISSUED_ST=["PO Issued","Partially Delivered","Delivered"];
  const dpBlockedDeal=projectId=>{const d=(allDeals||wonDeals||[]).find(x=>x.id===projectId);return d&&!dealDpClear(d,allDeals||wonDeals||[])?d:null;};
  const dpMsg=d=>`No down payment received on ${d.ceNo||d.client||"this project"}. A Manager must waive it before a PO can be issued.`;
  // Apply a status change to one PR, enforcing the issue gate. onDone(patch)
  // runs after the update with the patch that was actually written.
  const changePoStatus=(pr,st,onDone)=>{
    let patch={status:st};
    const blocked=ISSUED_ST.includes(st)&&!ISSUED_ST.includes(pr.status)&&dpBlockedDeal(pr.projectId||pr.dealId);
    if(blocked){toastEmit&&toastEmit(dpMsg(blocked),"error",9000);return;}
    if(st==="PO Issued"&&pr.status!=="PO Issued"){
      if(!canApproveFor(pr.requestedBy)){
        toastEmit&&toastEmit("Needs a Manager or the Procurement Manager — held at Pending Approval.","error");
        patch={status:"Pending Approval"};
      }else{
        patch={status:st,approvedBy:session?.name||"",approvedAt:today};
      }
    }
    updatePR(pr.id,patch);
    onDone&&onDone(patch);
  };
  const[mode,setMode]=useState("list");
  const[editingId,setEditingId]=useState(null);
  const[editForm,setEditForm]=useState(emptyPR());
  const[filterProj,setFilterProj]=useState("all");
  const[filterStat,setFilterStat]=useState("all");
  const[expandedPo,setExpandedPo]=useState(null);
  const[poListTab,setPoListTab]=useState("list");
  const[poImportModal,setPoImportModal]=useState(false);
  const[poImportRows,setPoImportRows]=useState([]);
  const[poImportStatus,setPoImportStatus]=useState("");
  const[poSupplier,setPoSupplier]=useState("");
  const[poNumber,setPoNumber]=useState("");
  const[poNumberAuto,setPoNumberAuto]=useState(false); // true = auto-filled preview, claim real no. at save
  const[poDate,setPoDate]=useState(new Date().toISOString().split("T")[0]);
  const[poStatus,setPoStatus]=useState("Draft");
  const[poExpectedDelivery,setPoExpectedDelivery]=useState("");
  const[poItems,setPoItems]=useState([emptyPoItem()]);
  const[poLevelDiscType,setPoLevelDiscType]=useState("none");
  const[poLevelDiscValue,setPoLevelDiscValue]=useState("");
  const[poWithVat,setPoWithVat]=useState(false);
  const[poAccountCode,setPoAccountCode]=useState(""); // Chart-of-Accounts code for the PO (flows to the payable)
  const[poTerms,setPoTerms]=useState(""); // Warehouse payment terms — COD / N days; drives the payable due date on receipt
  const[poTermsText,setPoTermsText]=useState(""); // Free-text Terms & Conditions printed on the PO PDF (blank = standard boilerplate)
  const[editingPrIds,setEditingPrIds]=useState(null);
  const[selectedPOs,setSelectedPOs]=useState(()=>new Set()); // groupKeys picked for bulk delete

  const n=v=>Number(String(v).replace(/,/g,""))||0;
  const fmt=v=>"₱"+Number(v).toLocaleString("en-PH",{minimumFractionDigits:0});
  // Canonical PO total — gross − PO-level discount (+ VAT), the same formula the
  // printed PO and the auto-created payable use (syncPoPayable). The PO list row
  // must show THIS, not a bare qty×cost gross, so the amount doesn't appear to
  // "change" when the PO is opened/printed.
  const poTotalOf=(its)=>poTotals(its).total;

  function emptyPoItem(){
    return {_id:Math.random().toString(36).slice(2),_existingId:null,projectId:"",projectName:"",itemName:"",category:"Materials",budgetCategory:"Materials",qty:1,unit:"pcs",estUnitCost:0};
  }

  const nextPoNo=()=>claimDocNumber("PO",prs.map(p=>p.poNumber));
  // Preview only — a local next-number guess for the form. It does NOT advance
  // the server counter, so opening the form (and cancelling) never burns a PO
  // number. The real, collision-free number is claimed via nextPoNo() at save.
  const previewPoNo=()=>{const mx=prs.reduce((m,p)=>{const t=/^PO-(\d+)$/.exec(String(p.poNumber||""));return t?Math.max(m,Number(t[1])):m;},0);return `PO-${String(mx+1).padStart(4,"0")}`;};

  const openNewPO=()=>{
    setPoSupplier(""); setPoNumber(previewPoNo()); setPoNumberAuto(true); setPoDate(new Date().toISOString().split("T")[0]);
    setPoStatus("PO Issued"); setPoExpectedDelivery(""); setPoItems([emptyPoItem()]);
    setPoLevelDiscType("none"); setPoLevelDiscValue(""); setPoWithVat(false); setPoAccountCode(""); setPoTerms("");
    setPoTermsText(PO_TERMS_DEFAULT);
    setEditingPrIds(null); setMode("newpo");
  };

  const openEditPO=(poNo,items)=>{
    const first=items[0]||{};
    setPoSupplier(first.supplier||"");
    setPoNumber(poNo); setPoNumberAuto(false);
    setPoDate(first.poDate||today);
    setPoStatus(first.status||"Draft");
    setPoExpectedDelivery(first.deliveryDate||"");
    setPoLevelDiscType(first.poDiscType||"none");
    setPoLevelDiscValue(String(first.poDiscValue||""));
    setPoWithVat(first.withVat||false);
    setPoAccountCode(first.accountCode||"");
    setPoTerms(first.paymentTerms||"");
    setPoTermsText(first.termsText||PO_TERMS_DEFAULT);
    setPoItems(items.map(pr=>({
      _id:Math.random().toString(36).slice(2),
      _existingId:pr.id,
      projectId:pr.projectId||"",
      projectName:pr.projectName||"",
      itemName:pr.itemName||"",
      category:pr.category||"Materials",
      budgetCategory:pr.budgetCategory||"Materials",
      qty:pr.qty||1,
      unit:pr.unit||"pcs",
      estUnitCost:pr.estUnitCost||0,
    })));
    setEditingPrIds(items.map(i=>i.id));
    setMode("newpo");
  };

  const printPO=(poNo,supplierName,poD,items,poDiscType,poDiscVal,withVat)=>{
    const fmt=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2});
    const subtotal=items.reduce((s,i)=>{const cost=(Number(i.actUnitCost)||Number(i.estUnitCost)||0)*Number(i.qty||1);return s+cost;},0);
    const poDisc=poDiscType==="pct"?subtotal*(Number(poDiscVal||0)/100):poDiscType==="fixed"?Math.min(Number(poDiscVal||0),subtotal):0;
    const grandTotal=subtotal-poDisc;
    const vatAmt=withVat?grandTotal*0.12:0;
    const totalWithVat=grandTotal+vatAmt;
    // Effective terms for the printed PO: the PO's own term wins; if left on
    // "supplier default" (blank), fall back to the supplier's terms so the
    // supplier reads the terms that actually apply, not a dash.
    const supTermsPrint=(suppliers||[]).find(s=>(s.companyName||s.company_name||"").toLowerCase()===(supplierName||"").toLowerCase())?.paymentTerms||"";
    const effTermsPrint=items[0]?.paymentTerms||supTermsPrint;
    const termsSrc=(items[0]?.termsText||"").trim()||PO_TERMS_DEFAULT;
    const esc=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    const termsItems=termsSrc.split("\n").map(t=>t.trim()).filter(Boolean).map(t=>`<li>${esc(t)}</li>`).join("");
    const preparedBy=items[0]?.requestedBy||items[0]?.createdBy||"";
    const approvedBy=items[0]?.approvedBy||"";
    const receivedBy=supplierName||"";
    const allProjDeals=[...activeDeals,...(wonDeals||[])];
    const projectList=[...new Set(items.map(i=>{if(i.projectId==="__gmd_stocks__"||i.projectName==="GMD Stocks")return"GMD Stocks";const d=allProjDeals.find(x=>x.id===i.projectId);return d?projDisplayName(d):(i.projectName||"");}).filter(Boolean))].join(" / ")||"—";
    const rows=items.map((i,idx)=>{
      const deal=i.projectId==="__gmd_stocks__"?null:allProjDeals.find(d=>d.id===i.projectId);
      const unitCost=Number(i.actUnitCost)||Number(i.estUnitCost)||0;
      const lineGross=unitCost*Number(i.qty||1);
      return `<tr><td>${idx+1}</td><td>${i.itemName||""}</td><td>${deal?projDisplayName(deal):(i.projectName||"—")}</td><td>${i.category||""}</td><td style="text-align:center">${i.qty} ${i.unit||""}</td><td style="text-align:right">${fmt(unitCost)}</td><td style="text-align:right;font-weight:700">${fmt(lineGross)}</td></tr>`;
    }).join("");
    const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>PO — ${poNo}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:Arial,sans-serif;padding:32px;color:#0f172a;font-size:12px}
  .hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;border-bottom:2px solid #1e293b;padding-bottom:16px}
  .co{font-size:22px;font-weight:800;letter-spacing:-0.5px}
  .co-sub{font-size:11px;color:#64748b;margin-top:2px}
  .po-title{font-size:20px;font-weight:800;color:#1e293b}
  .po-sub{font-size:11px;color:#64748b;margin-top:3px}
  .meta{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-bottom:8px;background:#f8fafc;padding:14px 16px;border-radius:8px 8px 0 0;border:1px solid #e2e8f0;border-bottom:none}
  .meta-item label{display:block;font-size:9px;text-transform:uppercase;letter-spacing:.8px;color:#94a3b8;margin-bottom:3px}
  .meta-item span{font-weight:700;font-size:13px}
  .meta-proj{background:#f8fafc;padding:10px 16px 14px;border-radius:0 0 8px 8px;border:1px solid #e2e8f0;margin-bottom:20px;border-top:1px dashed #e2e8f0}
  .meta-proj label{display:block;font-size:9px;text-transform:uppercase;letter-spacing:.8px;color:#94a3b8;margin-bottom:3px}
  .meta-proj span{font-weight:700;font-size:12px;color:#1e293b}
  table{width:100%;border-collapse:collapse;margin-top:8px}
  th{background:#1e293b;color:#fff;padding:8px 10px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.5px}
  td{padding:8px 10px;border-bottom:1px solid #f1f5f9;vertical-align:top}
  tr:nth-child(even) td{background:#f8fafc}
  .total-row td{font-weight:800;background:#eff6ff;color:#1e40af;border-top:2px solid #1e293b}
  .terms{margin-top:28px;border:1px solid #e2e8f0;border-radius:8px;padding:14px 16px;background:#fafafa}
  .terms h4{font-size:10px;text-transform:uppercase;letter-spacing:.8px;color:#64748b;margin-bottom:8px}
  .terms ol{margin:0;padding-left:18px}
  .terms li{font-size:10px;color:#334155;margin-bottom:5px;line-height:1.5}
  .sig{display:grid;grid-template-columns:1fr 1fr 1fr;gap:24px;margin-top:48px}
  .sig-box{font-size:10px;color:#64748b;text-transform:uppercase;letter-spacing:.5px;font-weight:600}
  @media print{body{padding:20px}}
</style></head><body>
<div class="hdr">
  <div><div class="co">GMD PRODUCTIONS INC</div><div class="co-sub">Fabrication & Project Management</div></div>
  <div style="text-align:right"><div class="po-title">PURCHASE ORDER</div><div class="po-sub">${poNo} · ${poD||""}</div></div>
</div>
<div class="meta">
  <div class="meta-item"><label>Supplier</label><span>${supplierName||"—"}</span></div>
  <div class="meta-item"><label>PO Number</label><span>${poNo}</span></div>
  <div class="meta-item"><label>Date Issued</label><span>${poD||"—"}</span></div>
  <div class="meta-item"><label>Payment Terms</label><span>${effTermsPrint||"—"}</span></div>
</div>
<div class="meta-proj"><label>Project(s)</label><span>${projectList}</span></div>
<table>
  <thead><tr><th>#</th><th>Description</th><th>Project</th><th>Category</th><th style="text-align:center">Qty</th><th style="text-align:right">Unit Cost</th><th style="text-align:right">Amount</th></tr></thead>
  <tbody>${rows}</tbody>
  ${poDisc>0?`<tr style="background:#f0fdf4"><td colspan="6" style="text-align:right;font-size:11px;color:#059669">PO-Level Discount (${poDiscType==="pct"?poDiscVal+"%":"Fixed"})</td><td style="text-align:right;color:#059669;font-weight:700">−${fmt(poDisc)}</td></tr>`:""}
  ${withVat?`<tr style="background:#f8fafc"><td colspan="6" style="text-align:right;font-size:11px;color:#64748b">Ex-VAT Amount</td><td style="text-align:right;color:#64748b">${fmt(grandTotal)}</td></tr><tr style="background:#fffbeb"><td colspan="6" style="text-align:right;font-size:11px;color:#b45309;font-weight:700">VAT 12% (OR)</td><td style="text-align:right;color:#b45309;font-weight:700">+${fmt(vatAmt)}</td></tr>`:""}
  <tr class="total-row"><td colspan="6" style="text-align:right">${withVat?"TOTAL (VAT Inclusive)":"Grand Total"}</td><td style="text-align:right">${fmt(totalWithVat)}</td></tr>
  ${withVat?`<tr><td colspan="7" style="font-size:9px;color:#94a3b8;text-align:right;padding-top:4px">Official Receipt (OR) — VAT Registered Supplier · TIN of GMD PRODUCTIONS INC applies</td></tr>`:""}
</table>
${termsItems?`<div class="terms"><h4>Terms &amp; Conditions</h4><ol>${termsItems}</ol></div>`:""}
<div class="sig">
  <div class="sig-box">Prepared by<br><br><br><div style="border-top:1px solid #94a3b8;padding-top:6px;margin-top:4px"><strong style="font-size:11px;color:#0f172a">${preparedBy||"&nbsp;"}</strong><br>Procurement</div></div>
  <div class="sig-box">Approved by<br><br><br><div style="border-top:1px solid #94a3b8;padding-top:6px;margin-top:4px"><strong style="font-size:11px;color:#0f172a">${approvedBy||"&nbsp;"}</strong><br>Manager / Authorized</div></div>
  <div class="sig-box">Received by<br><br><br><div style="border-top:1px solid #94a3b8;padding-top:6px;margin-top:4px"><strong style="font-size:11px;color:#0f172a">${receivedBy||"&nbsp;"}</strong><br>Supplier / Vendor</div></div>
</div>
</body></html>`;
    const w=window.open("","_blank","width=900,height=700");
    if(w){w.document.write(html);w.document.close();addPrintClose(w);setTimeout(()=>w.print(),600);}
  };

  const addPoItem=()=>setPoItems(p=>[...p,emptyPoItem()]);
  const removePoItem=(id)=>setPoItems(p=>p.filter(i=>i._id!==id));
  const updatePoItem=(id,k,v)=>setPoItems(p=>p.map(i=>i._id===id?{...i,[k]:v}:i));
  const calcPoLevelDisc=(subtotal)=>{
    if(poLevelDiscType==="pct") return subtotal*(n(poLevelDiscValue)/100);
    if(poLevelDiscType==="fixed") return Math.min(n(poLevelDiscValue),subtotal);
    return 0;
  };

  const submitPO=async()=>{
    if(!poSupplier){toastEmit&&toastEmit("Please enter a supplier name.","error");return;}
    if(!poNumber){toastEmit&&toastEmit("Please enter a PO number.","error");return;}
    if(poItems.some(i=>!i.itemName)){toastEmit&&toastEmit("Every item must have a description.","error");return;}
    if(poItems.some(i=>!(Number(i.qty)>0))){toastEmit&&toastEmit("Every item must have a quantity greater than 0.","error");return;}
    // Claim the real, collision-free PO number now (at save), not when the form
    // opened — so opening + cancelling never burns a number and the sequence
    // doesn't skip. Only for a brand-new PO whose number is still the auto
    // preview; a manually-typed or edited number is kept as-is.
    let poNo=poNumber.trim();
    if(!editingPrIds&&poNumberAuto){const claimed=await nextPoNo();if(claimed)poNo=claimed;}
    // PO issue gate on save: only a Manager or the Procurement Manager may
    // create/save a PO already in "PO Issued". Everyone else (the preparer) is
    // held at "Pending Approval" so they can't self-approve their own PO.
    const canIssueNow=canApproveFor(session?.name||"");
    const dpBlocked=ISSUED_ST.includes(poStatus)&&poItems.map(i=>dpBlockedDeal(i.projectId)).find(Boolean);
    const effStatus=dpBlocked?"Pending Approval":(poStatus==="PO Issued"&&!canIssueNow)?"Pending Approval":poStatus;
    if(dpBlocked) toastEmit&&toastEmit(`Saved as Pending Approval. ${dpMsg(dpBlocked)}`,"error",9000);
    else if(poStatus==="PO Issued"&&!canIssueNow) toastEmit&&toastEmit("Saved as Pending Approval — a Manager or the Procurement Manager must issue it.","info");
    const buildUpdate=(item)=>{
      // Resolve against all active deals, not just awarded ones — procurement
      // often buys swatches/materials for deals that haven't been won yet, and
      // those costs still need to be tracked against the project.
      const deal=activeDeals.find(d=>d.id===item.projectId);
      return{itemName:item.itemName,category:item.category,budgetCategory:item.budgetCategory,
        qty:Number(item.qty)||1,unit:item.unit,estUnitCost:Number(item.estUnitCost)||0,
        discType:"none",discValue:0,
        poDiscType:poLevelDiscType,poDiscValue:poLevelDiscValue,withVat:poWithVat,
        accountCode:poAccountCode,paymentTerms:poTerms,termsText:poTermsText,
        projectId:item.projectId,projectName:deal?.client||item.projectName||"",
        supplier:poSupplier,poNumber:poNo,poDate:poDate,
        status:effStatus,deliveryDate:poExpectedDelivery||""};
    };
    if(editingPrIds){
      const updatedIds=poItems.filter(i=>i._existingId).map(i=>i._existingId);
      editingPrIds.filter(id=>!updatedIds.includes(id)).forEach(id=>deletePR(id));
      poItems.forEach(item=>{
        if(item._existingId) updatePR(item._existingId,buildUpdate(item));
        else addPR({...emptyPR(),...buildUpdate(item),requestedBy:session?.name||""},{silent:true});
      });
      setEditingPrIds(null);
      toastEmit&&toastEmit(`PO ${poNo} updated`,"success");
    }else{
      poItems.forEach(item=>{
        addPR({...emptyPR(),...buildUpdate(item),
          requestedBy:session?.name||"",
          approvedBy:effStatus==="PO Issued"?session?.name||"":""
        },{silent:true});
      });
      const itemLines=poItems.map(item=>`  • ${item.itemName||"?"} — ${item.qty||"?"} ${item.unit||""} @ ₱${Number(item.estUnitCost||0).toLocaleString("en-PH")}`).join("\n");
      const projects=[...new Set(poItems.map(item=>{const d=activeDeals.find(x=>x.id===item.projectId);return d?.client||item.projectName||item.projectId||"?";}).filter(Boolean))].join(", ");
      const poMsg=`🛒 <b>New Purchase Order ${poNo}</b>\nSupplier: ${poSupplier}\nProject: ${projects}\n\n${itemLines}\n\nBy: ${session?.name||"?"}`;
      sendTelegramNotification("procurement",poMsg);
      sendTelegramNotification("management",poMsg);
      toastEmit&&toastEmit(`PO ${poNo} saved — ${poItems.length} item${poItems.length>1?"s":""}`,"success");
    }
    // Create-or-update the single payable for this PO (only once it's issued).
    // syncPoPayable computes the true total (line + PO discounts + VAT) and keeps
    // one payable per PO number; the delivery/receive flow later reconciles the
    // same payable instead of creating a duplicate.
    syncPoPayable&&syncPoPayable(poNo,poItems.map(buildUpdate));
    setMode("list");
  };

  const filteredAll=prs.filter(p=>{
    if(filterProj!=="all"&&p.projectId!==filterProj) return false;
    if(filterStat!=="all"&&p.status!==filterStat) return false;
    return true;
  });

  const grouped=(()=>{
    const byPO={};
    const solo=[];
    filteredAll.forEach(p=>{
      if(p.poNumber){
        const key=`${p.poNumber}|||${(p.supplier||"").toLowerCase().trim()}`;
        if(!byPO[key]) byPO[key]=[];
        byPO[key].push(p);
      } else {
        solo.push(p);
      }
    });
    const poGroups=Object.entries(byPO).map(([key,items])=>{const poNo=key.split("|||")[0];return{type:"po",poNo,groupKey:key,items,supplier:items[0]?.supplier||"",status:items[0]?.status||"Draft",poDate:items[0]?.poDate||"",total:poTotalOf(items)};});
    const soloItems=solo.map(p=>({type:"solo",pr:p}));
    return [...poGroups,...soloItems].sort((a,b)=>{
      const aDate=a.type==="po"?a.poDate:a.pr.createdDate||"";
      const bDate=b.type==="po"?b.poDate:b.pr.createdDate||"";
      return bDate.localeCompare(aDate);
    });
  })();

  const STATUS_CLR={"Draft":"#94a3b8","Pending Approval":"#f59e0b","PO Issued":"#3b82f6","Partially Delivered":"#8b5cf6","Delivered":"#10b981","Cancelled":"#ef4444"};
  // Where a PO sits in the receive → pay chain (Policy v2.0: nothing is payable
  // until goods are received and a payable is raised). Derived from the PR line
  // items (delivery) and the linked Accounts Payable rows (poId/poNumber).
  const poLifecycle=(items,poNo)=>{
    const totQty=items.reduce((s,i)=>s+n(i.qty),0);
    const delQty=items.reduce((s,i)=>s+n(i.qtyDelivered),0);
    const anyDelivered=delQty>0||items.some(i=>["Delivered","Partially Delivered"].includes(i.status));
    const fullyDelivered=(totQty>0&&delQty>=totQty)||(items.length>0&&items.every(i=>i.status==="Delivered"));
    const linkedAP=(payables||[]).filter(p=>p.poId===poNo||p.poNumber===poNo);
    const apNos=[...new Set(linkedAP.map(p=>p.apNumber).filter(Boolean))];
    const isPaid=v=>v.status==="Paid"||v.acctStatus==="Paid"||(n(v.amount)>0&&n(v.paidAmount)>=n(v.amount));
    const paid=linkedAP.length>0&&linkedAP.every(isPaid);
    const partiallyPaid=linkedAP.some(p=>n(p.paidAmount)>0);
    return {anyDelivered,fullyDelivered,hasPayable:linkedAP.length>0,linkedAP,apNos,paid,partiallyPaid};
  };
  // Slim 4-stage strip: Issued → Received → Payable → Paid. Answers "why can't
  // Finance pay this yet?" at a glance, without opening the row. While the AP
  // is hidden (shared.jsx) POs stand on their own: Issued → Received only.
  const lifecycleStrip=(lc)=>{
    const nodes=[
      {label:"Issued", done:true, color:STATUS_CLR["PO Issued"]},
      {label:lc.fullyDelivered?"Received":lc.anyDelivered?"Part. recv":"Received", done:lc.anyDelivered, half:lc.anyDelivered&&!lc.fullyDelivered, color:STATUS_CLR["Delivered"]},
      ...(AP_HIDDEN?[]:[
        {label:lc.apNos[0]||"Payable", done:lc.hasPayable, color:"#6366f1"},
        {label:lc.paid?"Paid":lc.partiallyPaid?"Part. paid":"Paid", done:lc.paid, half:lc.partiallyPaid&&!lc.paid, color:T.success},
      ]),
    ];
    return <LifecycleStrip nodes={nodes}/>;
  };
  const totalValue=filteredAll.reduce((s,p)=>(n(p.actUnitCost)||n(p.estUnitCost))*n(p.qty)+s,0);
  // Assign a distinct color to each PO number that appears more than once in the list
  const DUP_PALETTE=["#dc2626","#d97706","#059669","#7c3aed","#db2777","#0891b2","#65a30d","#ea580c"];
  const dupPoColors=(()=>{
    const counts={};
    grouped.forEach(g=>{if(g.type==="po")counts[g.poNo]=(counts[g.poNo]||0)+1;});
    const dupNos=Object.keys(counts).filter(k=>counts[k]>1).sort();
    const map={};
    dupNos.forEach((no,i)=>{map[no]=DUP_PALETTE[i%DUP_PALETTE.length];});
    return map;
  })();

  // ── Multi-select bulk delete (PO groups only) ──────────────────────────────
  const poGroupList=grouped.filter(g=>g.type==="po");
  const selectedVisibleCount=poGroupList.filter(g=>selectedPOs.has(g.groupKey)).length;
  const allPosSelected=poGroupList.length>0&&selectedVisibleCount===poGroupList.length;
  const toggleSelectPO=(k)=>setSelectedPOs(prev=>{const s=new Set(prev);s.has(k)?s.delete(k):s.add(k);return s;});
  const toggleSelectAllPOs=()=>setSelectedPOs(prev=>poGroupList.every(g=>prev.has(g.groupKey))?new Set():new Set(poGroupList.map(g=>g.groupKey)));
  const bulkDeletePOs=async ()=>{
    const groups=poGroupList.filter(g=>selectedPOs.has(g.groupKey));
    if(!groups.length) return;
    const poCount=groups.length;
    const itemCount=groups.reduce((s,g)=>s+g.items.length,0);
    const poNos=new Set(groups.map(g=>g.poNo));
    // Auto-created PO payables are keyed by poId=PO number (and carry poNumber);
    // deletePR doesn't touch payables, so warn how many will be left behind.
    const linked=(payables||[]).filter(p=>poNos.has(p.poId)||poNos.has(p.poNumber));
    const note=!linked.length?"":AP_HIDDEN?`\n\nℹ️ ${linked.length} linked payable record${linked.length>1?"s":""} will stay on file for the new AP system.`:`\n\n⚠️ ${linked.length} linked Accounts Payable ${linked.length>1?"entries":"entry"} will remain — remove ${linked.length>1?"them":"it"} in Accounts Payable if needed.`;
    if(!(await uiConfirm(`Delete ${poCount} purchase order${poCount>1?"s":""} (${itemCount} line item${itemCount>1?"s":""})? This cannot be undone.${note}`))) return;
    groups.forEach(g=>g.items.forEach(i=>deletePR(i.id)));
    setSelectedPOs(new Set());
    toastEmit&&toastEmit(`Deleted ${poCount} purchase order${poCount>1?"s":""}.`,"success");
  };

  // Edit single PR inline
  if(mode==="editpr"&&editingId){
    const ef=(k,v)=>setEditForm(p=>({...p,[k]:v}));
    return(
      <div>
        <button onClick={()=>{setMode("list");setEditingId(null);}} style={{background:"none",border:"none",color:"#3b82f6",cursor:"pointer",fontFamily:"inherit",fontSize:".84rem",fontWeight:700,marginBottom:14,padding:0}}>← Back to Purchase Orders</button>
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:20}}>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem",marginBottom:16}}>Edit Purchase Request</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <Fld label="Project" required>
              <Sel value={editForm.projectId} onChange={e=>{const v=e.target.value;if(v==="__gmd_stocks__"){ef("projectId","__gmd_stocks__");ef("projectName","GMD Stocks");return;}const d=activeDeals.find(x=>x.id===v);ef("projectId",v);ef("projectName",projDisplayName(d));}}>
                <option value="">— Select Project —</option>
                <option value="__gmd_stocks__">GMD Stocks</option>
                {activeDeals.map(d=><option key={d.id} value={d.id}>{projDisplayName(d)}</option>)}
              </Sel>
            </Fld>
            <Fld label="Budget Category">
              <Sel value={editForm.budgetCategory||"Materials"} onChange={e=>ef("budgetCategory",e.target.value)}>
                {BUDGET_CATS.map(c=><option key={c}>{c}</option>)}
              </Sel>
            </Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Item Name" required><Inp value={editForm.itemName} onChange={e=>ef("itemName",e.target.value)}/></Fld></div>
            <Fld label="Category"><Sel value={editForm.category} onChange={e=>ef("category",e.target.value)}>{PR_CATS.map(c=><option key={c}>{c}</option>)}</Sel></Fld>
            <Fld label="Supplier"><Inp value={editForm.supplier} onChange={e=>ef("supplier",e.target.value)}/></Fld>
            <Fld label="Qty"><Inp type="number" value={editForm.qty} onChange={e=>ef("qty",e.target.value)}/></Fld>
            <Fld label="Unit"><input list="po-units-dl" value={editForm.unit} onChange={e=>ef("unit",e.target.value)} placeholder="pcs, meters, sqm…" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",outline:"none"}}/><datalist id="po-units-dl">{PO_UNITS.map(u=><option key={u} value={u}/>)}</datalist></Fld>
            <Fld label="Est Unit Cost (₱)"><Inp type="number" value={editForm.estUnitCost} onChange={e=>ef("estUnitCost",e.target.value)}/></Fld>
            <Fld label="Actual Unit Cost (₱)">
              <Inp type="number" value={editForm.actUnitCost} onChange={e=>ef("actUnitCost",e.target.value)}
                style={{borderColor:["Partially Delivered","Delivered"].includes(editForm.status)?"#f97316":undefined}}/>
              {["Partially Delivered","Delivered"].includes(editForm.status)&&<div style={{fontSize:".67rem",color:"#c2410c",marginTop:3}}>⚠ P14: Item already delivered — changing this will affect inventory avg cost. Ensure it matches the actual DR/SI.</div>}
            </Fld>
            <Fld label="Status"><Sel value={editForm.status} onChange={e=>ef("status",e.target.value)}>{PROC_STATUSES.map(s=><option key={s}>{s}</option>)}</Sel></Fld>
            <Fld label="PO Number"><Inp value={editForm.poNumber} onChange={e=>ef("poNumber",e.target.value)}/></Fld>
            <Fld label="PO Date"><Inp type="date" value={editForm.poDate} onChange={e=>ef("poDate",e.target.value)}/></Fld>
            <Fld label="Terms">
              <Sel value={editForm.paymentTerms||""} onChange={e=>ef("paymentTerms",e.target.value)}>
                <option value="">— Supplier default —</option>
                {PO_TERMS.map(t=><option key={t} value={t}>{t}</option>)}
              </Sel>
            </Fld>
            <Fld label="Requested By"><Inp value={editForm.requestedBy} onChange={e=>ef("requestedBy",e.target.value)}/></Fld>
            {["PO Issued","Approved"].includes(editForm.status)&&(
              <Fld label="Expected Delivery Date"><Inp type="date" value={editForm.deliveryDate} onChange={e=>ef("deliveryDate",e.target.value)}/></Fld>
            )}
            {(editForm.status==="Partially Delivered"||editForm.status==="Delivered")&&(<>
              <Fld label="Qty Delivered">
                <Inp type="number" value={editForm.qtyDelivered}
                  onChange={e=>{const v=e.target.value;if(Number(v)>Number(editForm.qty||0)){toastEmit&&toastEmit(`⚠️ Qty delivered (${v}) exceeds PO qty (${editForm.qty}) — over-receive must be approved by Manager.`,"warn");}ef("qtyDelivered",v);}}
                  style={{borderColor:Number(editForm.qtyDelivered||0)>Number(editForm.qty||0)?"#f97316":undefined}}/>
                {Number(editForm.qtyDelivered||0)>Number(editForm.qty||0)&&<div style={{fontSize:".68rem",color:"#c2410c",marginTop:3}}>⚠ Over PO qty — ensure Manager approved</div>}
              </Fld>
              <Fld label="Delivery Date"><Inp type="date" value={editForm.deliveryDate} onChange={e=>ef("deliveryDate",e.target.value)}/></Fld>
              <div style={{gridColumn:"1/-1"}}><Fld label="DR / Delivery Note"><Inp value={editForm.deliveryNote} onChange={e=>ef("deliveryNote",e.target.value)}/></Fld></div>
            </>)}
            <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp value={editForm.notes} onChange={e=>ef("notes",e.target.value)}/></Fld></div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:16}}>
            <button onClick={()=>{
              const orig=prs.find(p=>p.id===editingId);
              let patch={...editForm};
              const dpBlk=orig&&ISSUED_ST.includes(editForm.status)&&!ISSUED_ST.includes(orig.status)&&dpBlockedDeal(editForm.projectId||orig.projectId||orig.dealId);
              if(dpBlk){toastEmit&&toastEmit(dpMsg(dpBlk),"error",9000);patch={...patch,status:orig.status,approvedBy:orig.approvedBy||"",approvedAt:orig.approvedAt||""};}
              // Enforce the PO issue gate on edits too — a non-approver cannot
              // flip an existing PO to "PO Issued" via the edit form.
              else if(editForm.status==="PO Issued"&&orig&&orig.status!=="PO Issued"){
                if(!canApproveFor(editForm.requestedBy||orig.requestedBy)){
                  toastEmit&&toastEmit("Needs a Manager or the Procurement Manager — held at Pending Approval.","error");
                  patch={...patch,status:"Pending Approval",approvedBy:"",approvedAt:""};
                }else{
                  patch={...patch,approvedBy:session?.name||"",approvedAt:today};
                }
              }
              updatePR(editingId,patch);if(patch.poNumber&&syncPoPayable)syncPoPayable(patch.poNumber,prs.map(p=>p.id===editingId?{...p,...patch}:p));toastEmit&&toastEmit("PR updated","success");setMode("list");setEditingId(null);}} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:"#fff",cursor:"pointer"}}>Save Changes</button>
            <button onClick={()=>{setMode("list");setEditingId(null);}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"10px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  // New PO form
  if(mode==="newpo"){
    const canSubmit=poSupplier.trim()&&poNumber.trim()&&poItems.every(i=>i.projectName?.trim()&&i.itemName.trim());
    const subtotalGross=poItems.reduce((s,i)=>s+n(i.estUnitCost)*n(i.qty),0);
    const poLevelDiscAmt=calcPoLevelDisc(subtotalGross);
    const grandTotal=subtotalGross-poLevelDiscAmt;
    return(
      <div>
        <button onClick={()=>setMode("list")} style={{background:"none",border:"none",color:"#3b82f6",cursor:"pointer",fontFamily:"inherit",fontSize:".84rem",fontWeight:700,marginBottom:14,padding:0}}>← Back to Purchase Orders</button>
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:20}}>
          <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem",marginBottom:16}}>{editingPrIds?"✏ Edit Purchase Order":"📦 New Purchase Order"}</div>
          <datalist id="po-units-dl">{PO_UNITS.map(u=><option key={u} value={u}/>)}</datalist>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(5,1fr)",gap:12,marginBottom:20,paddingBottom:16,borderBottom:"1.5px solid #f1f5f9"}}>
            <Fld label="Supplier" required>
              <input list="po-supplier-list" value={poSupplier} onChange={e=>setPoSupplier(e.target.value)} placeholder="Type or select supplier…"
                style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box"}}/>
              <datalist id="po-supplier-list">
                {[...new Map((suppliers||[]).map(s=>{const n=(s.company_name||s.companyName||"").trim();return[n,n];})).values()].filter(Boolean).sort().map(n=><option key={n} value={n}/>)}
              </datalist>
              {poSupplier.trim()&&!(suppliers||[]).some(s=>(s.company_name||s.companyName||"").toLowerCase()===poSupplier.trim().toLowerCase())&&(
                <button type="button" onClick={()=>{
                  if(addSupplier) addSupplier({companyName:poSupplier.trim(),company_name:poSupplier.trim(),contactPerson:"",contactNos:"",email:"",address:"",tinNo:"",paymentTerms:"",notes:""});
                  toastEmit&&toastEmit(`✅ "${poSupplier.trim()}" added to suppliers`,"success");
                }} style={{marginTop:5,background:"none",border:"none",color:"#1d4ed8",fontSize:".72rem",fontWeight:700,cursor:"pointer",padding:0,textAlign:"left",fontFamily:"inherit"}}>
                  + Add "{poSupplier.trim()}" as new supplier
                </button>
              )}
            </Fld>
            <Fld label="PO Number" required><Inp value={poNumber} onChange={e=>{setPoNumber(e.target.value);setPoNumberAuto(false);}} placeholder="PO-0001"/></Fld>
            <Fld label="PO Date"><Inp type="date" value={poDate} onChange={e=>setPoDate(e.target.value)}/></Fld>
            <Fld label="Status"><Sel value={poStatus} onChange={e=>setPoStatus(e.target.value)}>{PROC_STATUSES.map(s=><option key={s}>{s}</option>)}</Sel></Fld>
            <Fld label="Expected Delivery"><Inp type="date" value={poExpectedDelivery} onChange={e=>setPoExpectedDelivery(e.target.value)}/></Fld>
            <Fld label="Account (Chart of Accounts)">
              <Sel value={poAccountCode} onChange={e=>setPoAccountCode(e.target.value)}>
                <option value="">— Select account —</option>
                {[...chartOfAccounts].filter(a=>a.active!==false&&(a.type==="COGS"||a.type==="Expense"||a.type==="Asset")).sort((a,b)=>String(a.code).localeCompare(String(b.code))).map(a=><option key={a.id||a.code} value={a.code}>{a.code} · {a.name}</option>)}
              </Sel>
            </Fld>
            <Fld label="Terms">
              <Sel value={poTerms} onChange={e=>setPoTerms(e.target.value)}>
                <option value="">— Supplier default —</option>
                {PO_TERMS.map(t=><option key={t} value={t}>{t}</option>)}
              </Sel>
            </Fld>
          </div>
          <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem",marginBottom:10}}>Line Items</div>
          <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:12}}>
            {poItems.map((item,idx)=>{
              const lineTotal=n(item.estUnitCost)*n(item.qty);
              return(
                <div key={item._id} style={{background:"#f8fafc",borderRadius:10,border:"1.5px solid #e2e8f0",padding:"12px 14px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <span style={{fontSize:".72rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>Item #{idx+1}</span>
                    {poItems.length>1&&<button onClick={()=>removePoItem(item._id)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".8rem",fontFamily:"inherit"}}>✕ Remove</button>}
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(2,1fr) 1fr 1fr",gap:10}}>
                    <Fld label="Project" required>
                      <input
                        list={`proj-list-${item._id}`}
                        value={item.projectName}
                        onChange={e=>{
                          const name=e.target.value;
                          if(name==="GMD Stocks"){updatePoItem(item._id,"projectName","GMD Stocks");updatePoItem(item._id,"projectId","__gmd_stocks__");return;}
                          const deal=activeDeals.find(d=>projDisplayName(d)===name);
                          updatePoItem(item._id,"projectName",name);
                          updatePoItem(item._id,"projectId",deal?deal.id:name||"");
                        }}
                        placeholder="Search or type project name…"
                        style={{width:"100%",border:`1.5px solid ${item.projectName&&item.projectId&&!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(item.projectId)&&item.projectId!=="__gmd_stocks__"?"#f97316":"#e2e8f0"}`,borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box"}}
                      />
                      {item.projectName&&item.projectId&&!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(item.projectId)&&item.projectId!=="__gmd_stocks__"&&(
                        <div style={{fontSize:".67rem",color:"#c2410c",marginTop:3}}>⚠ Project not found in FabHub — PO will save without project link. Select from the list to link properly.</div>
                      )}
                      <datalist id={`proj-list-${item._id}`}>
                        <option value="GMD Stocks"/>
                        {activeDeals.map(d=><option key={d.id} value={projDisplayName(d)}/>)}
                      </datalist>
                    </Fld>
                    <Fld label="Item Name / Description" required><Inp value={item.itemName} onChange={e=>updatePoItem(item._id,"itemName",e.target.value)} placeholder="e.g. 18mm Melamine Board White"/></Fld>
                    <Fld label="Category"><Sel value={item.category} onChange={e=>updatePoItem(item._id,"category",e.target.value)}>{PR_CATS.map(c=><option key={c}>{c}</option>)}</Sel></Fld>
                    <Fld label="Budget Line"><Sel value={item.budgetCategory} onChange={e=>updatePoItem(item._id,"budgetCategory",e.target.value)}>{BUDGET_CATS.map(c=><option key={c}>{c}</option>)}</Sel></Fld>
                    <Fld label="Qty"><Inp type="number" value={item.qty} onChange={e=>updatePoItem(item._id,"qty",e.target.value)} min={1} style={{borderColor:!(Number(item.qty)>0)?"#ef4444":undefined}}/>{!(Number(item.qty)>0)&&<div style={{fontSize:".66rem",color:"#ef4444",marginTop:2}}>Required</div>}</Fld>
                    <Fld label="Unit"><input list="po-units-dl" value={item.unit} onChange={e=>updatePoItem(item._id,"unit",e.target.value)} placeholder="pcs, sqm…" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".87rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",outline:"none"}}/></Fld>
                    <Fld label="Est Unit Cost (₱)"><Inp type="number" value={item.estUnitCost} onChange={e=>updatePoItem(item._id,"estUnitCost",e.target.value)} placeholder="0"/></Fld>
                    <div style={{display:"flex",alignItems:"flex-end",paddingBottom:2}}>
                      <div style={{background:"#eff6ff",borderRadius:8,padding:"8px 12px",width:"100%"}}>
                        <div style={{fontSize:".63rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:2}}>Line Total</div>
                        <div style={{fontWeight:700,color:"#3b82f6",fontSize:".9rem"}}>{fmt(lineTotal)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {[...new Set(poItems.map(i=>i.projectId))].map(pid=>{const d=(allDeals||wonDeals||[]).find(x=>x.id===pid);return d&&(d.dpWaivedAt||!dealDpClear(d,allDeals||wonDeals||[]))?<DpGate key={pid} deal={d} deals={allDeals||wonDeals||[]} role={role} onWaiveDp={onWaiveDp}/>:null;})}
          <button onClick={addPoItem} style={{background:"#f8fafc",border:"1.5px dashed #cbd5e1",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer",fontWeight:700,width:"100%",marginBottom:16}}>+ Add Item</button>
          {/* PO-level discount */}
          <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:10,padding:"12px 16px",marginBottom:12}}>
            <div style={{fontWeight:700,color:"#065f46",fontSize:".8rem",marginBottom:8}}>PO-Level Discount (applied to entire order)</div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <Sel value={poLevelDiscType} onChange={e=>{setPoLevelDiscType(e.target.value);setPoLevelDiscValue("");}} style={{flex:"0 0 120px"}}>
                <option value="none">No discount</option>
                <option value="pct">Percentage (%)</option>
                <option value="fixed">Fixed Amount (₱)</option>
              </Sel>
              {poLevelDiscType!=="none"&&(
                <Inp type="number" value={poLevelDiscValue} onChange={e=>setPoLevelDiscValue(e.target.value)} placeholder={poLevelDiscType==="pct"?"e.g. 5":"e.g. 2000"} style={{flex:1,maxWidth:160}}/>
              )}
              {poLevelDiscAmt>0&&<span style={{fontSize:".82rem",color:"#059669",fontWeight:700}}>= −{fmt(poLevelDiscAmt)}</span>}
            </div>
          </div>
          {/* VAT toggle */}
          <div style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 16px",marginBottom:12,display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",userSelect:"none"}}>
              <input type="checkbox" checked={poWithVat} onChange={e=>setPoWithVat(e.target.checked)}
                style={{width:16,height:16,accentColor:"#1e293b",cursor:"pointer"}}/>
              <span style={{fontWeight:700,color:"#0f172a",fontSize:".84rem"}}>With VAT (Official Receipt)</span>
            </label>
            {poWithVat
              ?<span style={{fontSize:".78rem",color:"#059669",fontWeight:600}}>🧾 OR — 12% VAT will be added on top of ex-VAT prices</span>
              :<span style={{fontSize:".78rem",color:"#94a3b8"}}>📄 No OR — cash / no receipt, amount is as quoted</span>}
          </div>

          {/* Terms & Conditions (free text, printed on the PO PDF) */}
          <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 16px",marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,flexWrap:"wrap",gap:8}}>
              <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>Terms &amp; Conditions <span style={{fontWeight:500,color:"#94a3b8"}}>(printed on the PO)</span></div>
              <button type="button" onClick={()=>setPoTermsText(PO_TERMS_DEFAULT)} style={{background:"none",border:"none",color:"#1d4ed8",fontSize:".72rem",fontWeight:700,cursor:"pointer",padding:0,fontFamily:"inherit"}}>↺ Reset to standard terms</button>
            </div>
            <textarea value={poTermsText} onChange={e=>setPoTermsText(e.target.value)} rows={6}
              placeholder="Terms & conditions for this supplier — one per line…"
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"10px 13px",fontFamily:"inherit",fontSize:".82rem",color:"#1e293b",background:"#fff",boxSizing:"border-box",outline:"none",resize:"vertical",lineHeight:1.5}}/>
            <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:4}}>💡 Leave blank to fall back to GMD's standard terms on the printed PO. One line per term.</div>
          </div>

          {/* Totals summary */}
          {(()=>{const vat=poWithVat?grandTotal*0.12:0;const totalWithVat=grandTotal+vat;return(
          <div style={{background:"#eff6ff",borderRadius:10,padding:"12px 16px",marginBottom:16}}>
            {poLevelDiscAmt>0&&(
              <>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:".82rem",color:"#64748b",marginBottom:4}}>
                  <span>Subtotal (gross)</span><span>{fmt(subtotalGross)}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:".82rem",color:"#059669",marginBottom:4}}>
                  <span>PO-level discount</span><span>−{fmt(poLevelDiscAmt)}</span>
                </div>
                <div style={{borderTop:"1.5px solid #bfdbfe",marginTop:6,paddingTop:6}}/>
              </>
            )}
            {poWithVat&&(
              <>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:".82rem",color:"#64748b",marginBottom:4}}>
                  <span>Ex-VAT Amount</span><span>{fmt(grandTotal)}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:".82rem",color:"#f59e0b",marginBottom:4}}>
                  <span>VAT 12%</span><span>+{fmt(vat)}</span>
                </div>
                <div style={{borderTop:"1.5px solid #bfdbfe",marginTop:6,paddingTop:6}}/>
              </>
            )}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontWeight:700,color:"#1e40af",fontSize:".88rem"}}>{poWithVat?"Total (VAT Inclusive)":"Grand Total (est.)"}</span>
              <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:"#1e40af"}}>{fmt(totalWithVat)}</span>
            </div>
          </div>
          );})()}
          <div style={{display:"flex",gap:10}}>
            <button onClick={submitPO} disabled={!canSubmit} style={{background:canSubmit?"#1e293b":"#e2e8f0",border:"none",borderRadius:10,padding:"11px 24px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:canSubmit?"#fff":"#94a3b8",cursor:canSubmit?"pointer":"not-allowed"}}>
              📦 Submit Purchase Order ({poItems.length} item{poItems.length>1?"s":""})
            </button>
            <button onClick={()=>setMode("list")} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"11px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  // List view
  return(
    <div>
      {showCostCenters&&(
        <div onClick={()=>setShowCostCenters(false)} style={{position:"fixed",inset:0,background:"#0f172acc",zIndex:1500,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"36px 16px",overflowY:"auto"}}>
          <div onClick={e=>e.stopPropagation()} role="dialog" aria-label="Cost centers" style={{background:"#fff",borderRadius:16,border:"1.5px solid #e2e8f0",padding:22,maxWidth:480,width:"100%",boxShadow:"0 24px 60px #0006"}}>
            <div style={{fontWeight:800,color:"#0f172a",fontSize:"1rem",marginBottom:4}}>🏷 Internal cost centers</div>
            <div style={{fontSize:".75rem",color:"#64748b",marginBottom:14}}>GMD's own spending (tools, stock, HR, operations). Pick one as the project on a PO, payable, expense or voucher. Cost centers never show up as client projects. GMD Stocks (no project) still works as before.</div>
            {costCenterDeals.length===0
              ?<div style={{fontSize:".8rem",color:"#94a3b8",padding:"10px 0"}}>No cost centers yet.</div>
              :<div style={{border:"1.5px solid #e2e8f0",borderRadius:10,overflow:"hidden",marginBottom:14}}>
                {costCenterDeals.map((d,i)=>(
                  <div key={d.id} style={{display:"flex",justifyContent:"space-between",gap:10,padding:"9px 12px",borderTop:i?"1px solid #f1f5f9":"none",fontSize:".82rem"}}>
                    <span style={{fontWeight:700,color:"#0f172a"}}>{d.contact||d.client}</span>
                    <span style={{color:"#64748b",fontFamily:"monospace",fontSize:".74rem"}}>{d.ceNo||"—"}</span>
                  </div>
                ))}
              </div>}
            {canonRole(role)==="Manager"
              ?<div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <input value={newCostCenter} onChange={e=>setNewCostCenter(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")addCostCenter();}} maxLength={80} placeholder="New cost center, e.g. HR Cost Center" style={{flex:"1 1 200px",border:"1.5px solid #cbd5e1",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".82rem"}}/>
                <button onClick={addCostCenter} disabled={ccBusy||!newCostCenter.trim()} style={{background:"#1e293b",color:"#fff",border:"none",borderRadius:8,padding:"8px 14px",fontFamily:"inherit",fontSize:".8rem",fontWeight:800,cursor:ccBusy||!newCostCenter.trim()?"not-allowed":"pointer",opacity:ccBusy||!newCostCenter.trim()?.6:1}}>{ccBusy?"Adding…":"+ Add"}</button>
              </div>
              :<div style={{fontSize:".74rem",color:"#64748b"}}>Need a new cost center? Ask a Manager to add it.</div>}
            <div style={{textAlign:"right",marginTop:14}}>
              <button onClick={()=>setShowCostCenters(false)} style={{background:"none",border:"none",color:"#64748b",fontFamily:"inherit",fontSize:".8rem",fontWeight:700,cursor:"pointer"}}>Close</button>
            </div>
          </div>
        </div>
      )}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>📦 Purchase Orders</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Issue POs to suppliers — each with multiple project-tagged line items</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
            <div style={{display:"flex",gap:0,borderRadius:8,overflow:"hidden",border:"1.5px solid #e2e8f0",marginRight:4}}>
              {[["list","📋 PO List"],["summary","📊 Summary"]].map(([t,l])=>(
                <button key={t} onClick={()=>setPoListTab(t)} style={{padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,border:"none",background:poListTab===t?"#1e293b":"#fff",color:poListTab===t?"#fff":"#64748b",cursor:"pointer"}}>{l}</button>
              ))}
            </div>
          <button onClick={()=>setShowCostCenters(true)} title="Internal cost centers you can buy against" style={{background:"#fff",color:"#0f172a",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,cursor:"pointer"}}>🏷 Cost centers</button>
          <button onClick={()=>{
            const rows=[["PO Number","Date","Supplier","Project","Item Description","Category","Qty","Unit","Est Unit Cost","Act Unit Cost","Line Total","Status","Notes"]];
            const allProjDeals=[...wonDeals,...(allDeals||[])];
            grouped.forEach(g=>{
              if(g.type==="po"){
                g.items.forEach(pr=>{
                  const proj=allProjDeals.find(d=>d.id===pr.projectId);
                  const projName=proj?projDisplayName(proj):(pr.projectName||pr.projectId==="__gmd_stocks__"?"GMD Stocks":pr.projectId||"—");
                  const unitCostAct=n(pr.actUnitCost)||n(pr.estUnitCost);
                  rows.push([g.poNo,g.poDate||"",g.supplier,projName,pr.itemName||"",pr.category||"",n(pr.qty),pr.unit||"",n(pr.estUnitCost),n(pr.actUnitCost)||"",+(unitCostAct*n(pr.qty)).toFixed(2),pr.status||"",pr.notes||""]);
                });
              } else {
                const pr=g.pr;
                const proj=allProjDeals.find(d=>d.id===pr.projectId);
                const projName=proj?projDisplayName(proj):(pr.projectName||pr.projectId==="__gmd_stocks__"?"GMD Stocks":pr.projectId||"—");
                const unitCostAct=n(pr.actUnitCost)||n(pr.estUnitCost);
                rows.push(["(No PO)",pr.createdDate||"",pr.supplier||"",projName,pr.itemName||"",pr.category||"",n(pr.qty),pr.unit||"",n(pr.estUnitCost),n(pr.actUnitCost)||"",+(unitCostAct*n(pr.qty)).toFixed(2),pr.status||"",pr.notes||""]);
              }
            });
            const csv=rows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
            const a=document.createElement("a");a.href="data:text/csv;charset=utf-8,"+encodeURIComponent("﻿"+csv);a.download=`GMD_PurchaseOrders_${today}.csv`;a.click();
          }} style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#1d4ed8",cursor:"pointer"}}>⬇ Export CSV</button>
          <label style={{background:"#f0fdf4",border:"1.5px solid #bbf7d0",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#16a34a",cursor:"pointer",whiteSpace:"nowrap"}}>
            ⬆ Import CSV
            <input type="file" accept=".csv" style={{display:"none"}} onChange={e=>{
              const file=e.target.files[0]; if(!file) return;
              const reader=new FileReader();
              reader.onload=ev=>{
                const text=ev.target.result;
                const lines=text.split(/\r?\n/).filter(l=>l.trim());
                if(lines.length<2){setPoImportStatus("CSV appears empty.");setPoImportModal(true);return;}
                const parseRow=line=>{const cols=[];let cur="",inQ=false;for(let i=0;i<line.length;i++){const c=line[i];if(c==='"'){if(inQ&&line[i+1]==='"'){cur+='"';i++;}else inQ=!inQ;}else if(c===','&&!inQ){cols.push(cur.trim());cur="";}else cur+=c;}cols.push(cur.trim());return cols;};
                const headers=parseRow(lines[0]).map(h=>h.replace(/^"|"$/g,"").toLowerCase().replace(/\s+/g,"_"));
                const col=(row,names)=>{for(const nm of names){const i=headers.indexOf(nm);if(i>=0)return row[i]||"";}return "";};
                const rows=lines.slice(1).map(l=>parseRow(l).map(v=>v.replace(/^"|"$/g,""))).filter(r=>r.some(v=>v));
                const parsed=rows.map((r,i)=>({
                  _row:i+2,
                  poNumber:col(r,["po_number","po_#","po#"])||"",
                  poDate:col(r,["date","po_date"])||"",
                  supplier:col(r,["supplier"])||"",
                  projectName:col(r,["project"])||"",
                  itemName:col(r,["item_description","item","description"])||"",
                  category:col(r,["category"])||"Materials",
                  qty:Number(col(r,["qty","quantity"]))||1,
                  unit:col(r,["unit"])||"pcs",
                  estUnitCost:Number(col(r,["est_unit_cost","estimated_unit_cost","est._unit_cost"]))||0,
                  actUnitCost:Number(col(r,["act_unit_cost","actual_unit_cost","act._unit_cost"]))||0,
                  status:col(r,["status"])||"PO Issued",
                  notes:col(r,["notes"])||"",
                }));
                setPoImportRows(parsed);
                setPoImportStatus("");
                setPoImportModal(true);
              };
              reader.readAsText(file);
              e.target.value="";
            }}/>
          </label>
          <button onClick={openNewPO} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>+ New Purchase Order</button>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12,marginBottom:18}}>
        <ErpStat label="Total POs" value={String([...new Set(prs.map(p=>p.poNumber).filter(Boolean))].length+prs.filter(p=>!p.poNumber).length)} foot="purchase orders"/>
        <ErpStat tone="warn" label="Pending Approval" value={String(prs.filter(p=>p.status==="Pending Approval").length)} foot="awaiting approval"/>
        <ErpStat label="PO Issued" value={String([...new Set(prs.filter(p=>p.status==="PO Issued").map(p=>p.poNumber||p.id))].length)} foot="issued to suppliers"/>
        <ErpStat tone="ok" label="Total Value" value={"Php "+totalValue.toLocaleString("en-PH",{minimumFractionDigits:0,maximumFractionDigits:0})} foot="materials value"/>
      </div>
      {/* Pending POs the viewer may approve, approved in bulk (hidden when none). */}
      {approvePOs&&<POApprovals prs={prs} deals={allDeals||wonDeals} role={role} session={session} approvePOs={approvePOs}/>}

      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap"}}>
        <select value={filterProj} onChange={e=>setFilterProj(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Projects</option>
          {activeDeals.map(d=><option key={d.id} value={d.id}>{d.client}{d.contact?` — ${d.contact}`:""}</option>)}
        </select>
        <select value={filterStat} onChange={e=>setFilterStat(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Statuses</option>
          {PR_STATUSES.map(s=><option key={s}>{s}</option>)}
        </select>
      </div>

      {grouped.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8",fontSize:".84rem"}}>No purchase orders yet. Hit + New Purchase Order to start.</div>}
      {(role==="Manager"||isProcurementRole(role))&&poListTab==="list"&&poGroupList.length>0&&(
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10,flexWrap:"wrap"}}>
          <label style={{display:"flex",alignItems:"center",gap:6,fontSize:".78rem",color:"#475569",cursor:"pointer",fontWeight:600}}>
            <input type="checkbox" checked={allPosSelected} onChange={toggleSelectAllPOs} style={{width:16,height:16,cursor:"pointer",accentColor:"#dc2626"}}/>
            Select all POs ({poGroupList.length})
          </label>
          {selectedVisibleCount>0&&(<>
            <span style={{fontSize:".78rem",color:"#64748b"}}>{selectedVisibleCount} selected</span>
            <button onClick={bulkDeletePOs} style={{background:"#dc2626",border:"none",borderRadius:8,padding:"6px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",color:"#fff",cursor:"pointer"}}>🗑 Delete selected ({selectedVisibleCount})</button>
            <button onClick={()=>setSelectedPOs(new Set())} style={{background:"none",border:"none",color:"#64748b",cursor:"pointer",fontFamily:"inherit",fontSize:".78rem",textDecoration:"underline"}}>Clear</button>
          </>)}
        </div>
      )}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
        {/* Table header */}
        {grouped.length>0&&<div style={{display:"grid",gridTemplateColumns:"90px 1fr 1fr 110px 100px 90px",padding:"9px 14px",background:ERP.navyLight,borderBottom:`2px solid ${ERP.line}`,gap:8,alignItems:"center"}}>
          {["PO #","Supplier","Project","Amount","Status",""].map((h,i)=>(
            <div key={i} style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",color:ERP.navy,textAlign:i===3?"right":"left"}}>{h}</div>
          ))}
        </div>}
          {poListTab==="summary"&&(()=>{
            const allPoNos=[...new Set(prs.filter(p=>p.poNumber).map(p=>p.poNumber))];
            const bySupplier={};
            const byProject={};
            const byStatus={};
            filteredAll.forEach(p=>{
              const sup=p.supplier||"(No supplier)";
              if(!bySupplier[sup])bySupplier[sup]={count:0,total:0,items:[]};
              bySupplier[sup].count++;bySupplier[sup].total+=(n(p.actUnitCost)||n(p.estUnitCost))*n(p.qty);bySupplier[sup].items.push(p);
              const proj=p.projectName||p.projectId||"GMD Stocks";
              if(!byProject[proj])byProject[proj]={count:0,total:0};
              byProject[proj].count++;byProject[proj].total+=(n(p.actUnitCost)||n(p.estUnitCost))*n(p.qty);
              const st=p.status||"Draft";
              if(!byStatus[st])byStatus[st]={count:0,total:0};
              byStatus[st].count++;byStatus[st].total+=(n(p.actUnitCost)||n(p.estUnitCost))*n(p.qty);
            });
            const supRows=Object.entries(bySupplier).sort((a,b)=>b[1].total-a[1].total);
            const projRows=Object.entries(byProject).sort((a,b)=>b[1].total-a[1].total);
            const stRows=Object.entries(byStatus).sort((a,b)=>b[1].total-a[1].total);
            return(
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
                {/* By Supplier */}
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  <div style={{background:"#1e293b",padding:"10px 16px",fontWeight:700,color:"#f59e0b",fontSize:".82rem"}}>By Supplier</div>
                  {supRows.map(([sup,{count,total}])=>(
                    <div key={sup} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 16px",borderBottom:"1px solid #f1f5f9",gap:8}}>
                      <div style={{minWidth:0}}>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{sup}</div>
                        <div style={{fontSize:".65rem",color:"#94a3b8"}}>{count} item{count!==1?"s":""}</div>
                      </div>
                      <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem",flexShrink:0}}>{fmt(total)}</div>
                    </div>
                  ))}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"9px 16px",background:"#f8fafc",fontWeight:800,fontSize:".82rem"}}>
                    <span>TOTAL</span><span style={{color:"#1d4ed8"}}>{fmt(supRows.reduce((s,[,{total}])=>s+total,0))}</span>
                  </div>
                </div>
                {/* By Project */}
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  <div style={{background:"#1e293b",padding:"10px 16px",fontWeight:700,color:"#4ade80",fontSize:".82rem"}}>By Project</div>
                  {projRows.map(([proj,{count,total}])=>(
                    <div key={proj} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 16px",borderBottom:"1px solid #f1f5f9",gap:8}}>
                      <div style={{minWidth:0}}>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{proj}</div>
                        <div style={{fontSize:".65rem",color:"#94a3b8"}}>{count} item{count!==1?"s":""}</div>
                      </div>
                      <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem",flexShrink:0}}>{fmt(total)}</div>
                    </div>
                  ))}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"9px 16px",background:"#f8fafc",fontWeight:800,fontSize:".82rem"}}>
                    <span>TOTAL</span><span style={{color:"#059669"}}>{fmt(projRows.reduce((s,[,{total}])=>s+total,0))}</span>
                  </div>
                </div>
                {/* By Status */}
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden",gridColumn:"1/-1"}}>
                  <div style={{background:"#1e293b",padding:"10px 16px",fontWeight:700,color:"#a78bfa",fontSize:".82rem"}}>By Status</div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:1,background:"#f1f5f9"}}>
                    {stRows.map(([st,{count,total}])=>(
                      <div key={st} style={{background:"#fff",padding:"12px 16px"}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}>
                          <span style={{width:8,height:8,borderRadius:"50%",background:STATUS_CLR[st]||"#94a3b8",flexShrink:0,display:"inline-block"}}/>
                          <span style={{fontWeight:700,color:"#0f172a",fontSize:".78rem"}}>{st}</span>
                        </div>
                        <div style={{fontWeight:800,color:STATUS_CLR[st]||"#64748b",fontSize:"1rem"}}>{fmt(total)}</div>
                        <div style={{fontSize:".65rem",color:"#94a3b8",marginTop:2}}>{count} item{count!==1?"s":""}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })()}
          {poListTab==="list"&&grouped.map((g,gi)=>{
          if(g.type==="po"){
            const {poNo,groupKey,items,supplier,status,poDate:poD,total}=g;
            const lc=poLifecycle(items,poNo);
            const projects=[...new Set(items.map(i=>i.projectName||"").filter(Boolean))].join(", ")||"—";
            // Keyed by groupKey (poNumber+supplier), not bare poNo — two different
            // suppliers can share the same PO number (dupPoColors below exists
            // specifically to flag that), and keying by poNo alone made both
            // groups' accordions open/close together.
            const open=expandedPo===groupKey;
            return(
              <div key={groupKey} style={{borderBottom:gi<grouped.length-1?"1px solid #f1f5f9":"none"}}>
                {/* Compact row */}
                <div {...clickable(()=>setExpandedPo(o=>o===groupKey?null:groupKey))} aria-expanded={open} aria-label={`PO ${poNo}, ${status} — expand line items`} style={{display:"grid",gridTemplateColumns:"90px 1fr 1fr 110px 100px 90px",padding:"9px 14px",gap:8,alignItems:"center",cursor:"pointer",background:open?"#f8fafc":"#fff"}}
                  onMouseEnter={e=>{if(!open)e.currentTarget.style.background="#f8fafc";}} onMouseLeave={e=>{e.currentTarget.style.background=open?"#f8fafc":"#fff";}}>
                  <div style={{fontWeight:700,color:dupPoColors[poNo]||"#6366f1",fontSize:".75rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:4}}>
                    {(role==="Manager"||isProcurementRole(role))&&<input type="checkbox" checked={selectedPOs.has(groupKey)} onClick={e=>e.stopPropagation()} onChange={()=>toggleSelectPO(groupKey)} title="Select for bulk delete" style={{width:14,height:14,cursor:"pointer",accentColor:"#dc2626",flexShrink:0,margin:0}}/>}
                    {dupPoColors[poNo]&&<span title="Duplicate PO number" style={{width:7,height:7,borderRadius:"50%",background:dupPoColors[poNo],flexShrink:0,display:"inline-block"}}/>}
                    {poNo}
                  </div>
                  <div style={{fontWeight:600,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{supplier||"—"}</div>
                  <div style={{fontSize:".75rem",color:"#64748b",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{projects}</div>
                  <div style={{textAlign:"right",fontWeight:800,color:"#10b981",fontSize:".85rem"}}>{fmt(total)}</div>
                  <div><span style={{fontSize:".62rem",background:STATUS_CLR[status]+"22",color:STATUS_CLR[status],border:`1px solid ${STATUS_CLR[status]}44`,borderRadius:20,padding:"2px 8px",fontWeight:700,whiteSpace:"nowrap"}}>{status}</span></div>
                  <div style={{display:"flex",gap:5,justifyContent:"flex-end"}}>
                    <button aria-label={`Print PO ${poNo}`} title="Print PO" onClick={e=>{e.stopPropagation();printPO(poNo,supplier,poD,items,items[0]?.poDiscType,items[0]?.poDiscValue,items[0]?.withVat);}} style={{background:"#eff6ff",border:"none",borderRadius:6,padding:"3px 8px",fontSize:".68rem",color:"#1e40af",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>🖨</button>
                    {(role==="Manager"||isProcurementRole(role))&&<button aria-label={`Edit PO ${poNo}`} title="Edit PO" onClick={e=>{e.stopPropagation();openEditPO(poNo,items);}} style={{background:"#f0fdf4",border:"none",borderRadius:6,padding:"3px 8px",fontSize:".68rem",color:"#059669",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>✏</button>}
                    {(role==="Manager"||isProcurementRole(role))&&<button aria-label={`Delete PO ${poNo}`} title="Delete PO" onClick={async e=>{e.stopPropagation();
                      // Policy v2.0: a PO that has already raised an Accounts Payable
                      // entry can't be deleted silently — deleting the PR leaves the
                      // payable (and any expense) orphaned and breaks the document
                      // trail. Warn, name the AP, and let Finance clean up there.
                      const apNote=!lc.hasPayable?"":AP_HIDDEN?`\n\nℹ️ This PO's payable record${lc.linkedAP.length>1?"s":""}${lc.apNos.length?` (${lc.apNos.join(", ")})`:""} will stay on file for the new AP system.`:`\n\n⚠️ This PO has ${lc.linkedAP.length} linked Accounts Payable ${lc.linkedAP.length>1?"entries":"entry"}${lc.apNos.length?` (${lc.apNos.join(", ")})`:""} that will remain. Remove ${lc.linkedAP.length>1?"them":"it"} in Accounts Payable if this is a mistake.`;
                      if((await uiConfirm({title:"Delete purchase order",tone:"danger",confirmLabel:"Delete PO",message:`Delete PO ${poNo}?${apNote}\n\nThis cannot be undone.`})))items.forEach(i=>deletePR(i.id));
                    }} style={{background:"#fef2f2",border:"none",borderRadius:6,padding:"3px 7px",fontSize:".68rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>✕</button>}
                  </div>
                </div>
                {/* Lifecycle: where this PO sits in the receive → pay chain */}
                <div style={{padding:"0 14px 7px 14px",background:open?"#f8fafc":"#fff"}}>{lifecycleStrip(lc)}</div>
                {/* Expanded line items */}
                {open&&(
                  <div style={{background:"#fafafa",borderTop:"1px solid #f1f5f9",padding:"8px 14px 10px"}}>
                    {items.map((pr,ii)=>{
                      const actTotal=(n(pr.actUnitCost)||n(pr.estUnitCost))*n(pr.qty);
                      const delivPct=n(pr.qty)>0?Math.round(n(pr.qtyDelivered)/n(pr.qty)*100):0;
                      return(
                        <div key={pr.id} style={{display:"flex",alignItems:"center",gap:10,padding:"5px 0",borderBottom:ii<items.length-1?"1px solid #f1f5f9":"none",flexWrap:"wrap"}}>
                          <div style={{flex:1,minWidth:0}}>
                            <span style={{fontWeight:600,color:"#0f172a",fontSize:".8rem"}}>{pr.itemName}</span>
                            <span style={{fontSize:".7rem",color:"#94a3b8",marginLeft:8}}>{pr.qty} {pr.unit}</span>
                            {delivPct>0&&delivPct<100&&<span style={{fontSize:".68rem",color:"#f59e0b",fontWeight:600,marginLeft:8}}>{delivPct}% delivered</span>}
                          </div>
                          <span style={{fontWeight:700,color:"#0f172a",fontSize:".8rem",flexShrink:0}}>{fmt(actTotal)}</span>
                          <select value={pr.status} onClick={e=>e.stopPropagation()} onChange={e=>changePoStatus(pr,e.target.value,patch=>syncPoPayable&&syncPoPayable(pr.poNumber,items.map(x=>x.id===pr.id?{...x,...patch}:x)))} style={{border:"1.5px solid #e2e8f0",borderRadius:6,padding:"3px 6px",fontFamily:"inherit",fontSize:".7rem",color:"#0f172a",background:"#fff",cursor:"pointer",flexShrink:0}}>
                            {PROC_STATUSES.map(s=><option key={s}>{s}</option>)}
                          </select>
                          <button onClick={e=>{e.stopPropagation();setEditForm({...pr});setEditingId(pr.id);setMode("editpr");}} style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"3px 8px",fontSize:".7rem",color:"#475569",cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>✏</button>
                          {(role==="Manager"||isProcurementRole(role))&&<button onClick={async e=>{e.stopPropagation();if((await uiConfirm("Delete this item?")))deletePR(pr.id);}} style={{background:"#fef2f2",border:"none",borderRadius:6,padding:"3px 8px",fontSize:".7rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit",flexShrink:0}}>✕</button>}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          } else {
            const {pr}=g;
            const actTotal=(n(pr.actUnitCost)||n(pr.estUnitCost))*n(pr.qty);
            const projName=pr.projectName||activeDeals.find(d=>d.id===pr.projectId)?.contact||activeDeals.find(d=>d.id===pr.projectId)?.client||"—";
            return(
              <div key={pr.id} style={{display:"grid",gridTemplateColumns:"90px 1fr 1fr 110px 100px 90px",padding:"9px 14px",gap:8,alignItems:"center",borderBottom:gi<grouped.length-1?"1px solid #f1f5f9":"none",background:"#fff"}}
                onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"} onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                <div style={{fontWeight:600,color:"#94a3b8",fontSize:".72rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>—</div>
                <div style={{fontWeight:600,color:"#0f172a",fontSize:".8rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{pr.supplier||pr.itemName||"—"}</div>
                <div style={{fontSize:".75rem",color:"#64748b",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{projName}</div>
                <div style={{textAlign:"right",fontWeight:800,color:"#10b981",fontSize:".85rem"}}>{fmt(actTotal)}</div>
                <div><span style={{fontSize:".62rem",background:STATUS_CLR[pr.status]+"22",color:STATUS_CLR[pr.status],border:`1px solid ${STATUS_CLR[pr.status]}44`,borderRadius:20,padding:"2px 8px",fontWeight:700,whiteSpace:"nowrap"}}>{pr.status}</span></div>
                <div style={{display:"flex",gap:4,justifyContent:"flex-end"}}>
                  <select value={pr.status} onChange={e=>changePoStatus(pr,e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:5,padding:"2px 4px",fontFamily:"inherit",fontSize:".65rem",color:"#0f172a",background:"#fff",cursor:"pointer",maxWidth:40}}>
                    {PROC_STATUSES.map(s=><option key={s}>{s}</option>)}
                  </select>
                  <button onClick={()=>{setEditForm({...pr});setEditingId(pr.id);setMode("editpr");}} style={{background:"#f1f5f9",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".68rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏</button>
                  {(role==="Manager"||isProcurementRole(role))&&<button onClick={async ()=>{if((await uiConfirm(`Delete "${pr.itemName||pr.item||"this request"}"${pr.supplier?` from ${pr.supplier}`:""}?`)))deletePR(pr.id);}} style={{background:"#fef2f2",border:"none",borderRadius:5,padding:"3px 7px",fontSize:".68rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>✕</button>}
                </div>
              </div>
            );
          }
        })}
      </div>

      {/* ── CSV Import Modal ── */}
      {poImportModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:860,maxHeight:"85vh",overflow:"auto",boxShadow:"0 24px 60px rgba(0,0,0,.25)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div>
                <div style={{fontWeight:800,fontSize:"1.1rem",color:"#0f172a"}}>⬆ Import Purchase Orders from CSV</div>
                <div style={{fontSize:".74rem",color:"#64748b",marginTop:2}}>Review the rows below before saving. Each row becomes one PO line item.</div>
              </div>
              <button onClick={()=>{setPoImportModal(false);setPoImportRows([]);setPoImportStatus("");}} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"6px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#475569",cursor:"pointer"}}>✕ Close</button>
            </div>
            {poImportStatus&&<div style={{background:poImportStatus.startsWith("✅")?"#f0fdf4":"#fef2f2",border:`1px solid ${poImportStatus.startsWith("✅")?"#bbf7d0":"#fecaca"}`,borderRadius:8,padding:"10px 14px",marginBottom:14,color:poImportStatus.startsWith("✅")?"#16a34a":"#dc2626",fontSize:".82rem"}}>{poImportStatus}</div>}
            {poImportRows.length===0&&!poImportStatus&&(
              <div style={{textAlign:"center",padding:40,color:"#94a3b8",fontSize:".88rem"}}>No rows parsed. Make sure the CSV has a header row matching the export format.</div>
            )}
            {poImportRows.length>0&&(
              <>
                <div style={{fontSize:".75rem",color:"#64748b",marginBottom:10,fontWeight:600}}>{poImportRows.length} row{poImportRows.length>1?"s":""} found</div>
                <div style={{overflowX:"auto",marginBottom:18}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:".74rem"}}>
                    <thead>
                      <tr style={{background:"#f8fafc"}}>
                        {["Row","PO #","Date","Supplier","Project","Item","Cat","Qty","Unit","Est Cost","Act Cost","Status","Notes"].map(h=>(
                          <th key={h} style={{padding:"7px 10px",textAlign:"left",color:"#64748b",fontWeight:700,borderBottom:"2px solid #e2e8f0",whiteSpace:"nowrap"}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {poImportRows.map((r,i)=>(
                        <tr key={i} style={{borderBottom:"1px solid #f1f5f9",background:i%2?"#fafafa":"#fff"}}>
                          <td style={{padding:"6px 10px",color:"#94a3b8"}}>{r._row}</td>
                          <td style={{padding:"6px 10px",fontWeight:700,color:"#1d4ed8"}}>{r.poNumber||"—"}</td>
                          <td style={{padding:"6px 10px"}}>{r.poDate||"—"}</td>
                          <td style={{padding:"6px 10px",fontWeight:600}}>{r.supplier||"—"}</td>
                          <td style={{padding:"6px 10px",color:"#64748b"}}>{r.projectName||"—"}</td>
                          <td style={{padding:"6px 10px"}}>{r.itemName||"—"}</td>
                          <td style={{padding:"6px 10px",color:"#64748b"}}>{r.category}</td>
                          <td style={{padding:"6px 10px",textAlign:"right"}}>{r.qty}</td>
                          <td style={{padding:"6px 10px",color:"#64748b"}}>{r.unit}</td>
                          <td style={{padding:"6px 10px",textAlign:"right",color:"#0f172a",fontWeight:600}}>{"₱"+Number(r.estUnitCost).toLocaleString()}</td>
                          <td style={{padding:"6px 10px",textAlign:"right",color:"#10b981",fontWeight:600}}>{r.actUnitCost?"₱"+Number(r.actUnitCost).toLocaleString():"—"}</td>
                          <td style={{padding:"6px 10px"}}><span style={{background:"#eff6ff",color:"#1d4ed8",borderRadius:20,padding:"2px 8px",fontSize:".68rem",fontWeight:700}}>{r.status}</span></td>
                          <td style={{padding:"6px 10px",color:"#94a3b8",maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.notes||"—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                  <button onClick={()=>{setPoImportModal(false);setPoImportRows([]);setPoImportStatus("");}} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"9px 20px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#475569",cursor:"pointer"}}>Cancel</button>
                  <button onClick={async()=>{
                    setPoImportStatus("Saving…");
                    let saved=0,failed=0;const dpSkipped=new Set();
                    for(const r of poImportRows){
                      const allDealsAll=[...wonDeals,...(allDeals||[])];
                      const matchDeal=allDealsAll.find(d=>(d.client||"").toLowerCase()===r.projectName.toLowerCase()||(d.contact||"").toLowerCase()===r.projectName.toLowerCase())||(r.projectName==="GMD Stocks"?{id:"__gmd_stocks__"}:null);
                      const rec={
                        deal_id:matchDeal?.id||null,
                        project_name:r.projectName||"",
                        po_number:r.poNumber||null,
                        po_date:r.poDate||null,
                        supplier:r.supplier||"",
                        item:r.itemName||"",
                        category:r.category||"Materials",
                        budget_category:r.category||"Materials",
                        qty:r.qty||1,
                        unit:r.unit||"pcs",
                        estimated_cost:r.estUnitCost||0,
                        actual_cost:r.actUnitCost||null,
                        status:r.status||"PO Issued",
                        notes:r.notes||"",
                        created_by:session?.name||"Import",
                        requested_by:session?.name||"Import",
                      };
                      // The database refuses an issued PO on a deal with no down payment
                      // (migration 20261020110000); skip it here and say why.
                      if(ISSUED_ST.includes(rec.status)&&dpBlockedDeal(rec.deal_id)){failed++;dpSkipped.add(matchDeal?.ceNo||matchDeal?.client||r.projectName);continue;}
                      const res=await sbInsert("purchase_requests",rec);
                      if(res){
                        saved++;
                        // Update local state only — sbInsert already saved to Supabase
                        const localRec={...rec,id:res.id,dealId:rec.deal_id,projectId:rec.deal_id,itemName:rec.item,estUnitCost:rec.estimated_cost,actUnitCost:rec.actual_cost,poNumber:rec.po_number,poDate:rec.po_date,budgetCategory:rec.budget_category,createdBy:rec.created_by,requestedBy:rec.requested_by,createdDate:today};
                        upPrs(ps=>[localRec,...ps]);
                      } else failed++;
                    }
                    if(failed===0){
                      setPoImportStatus(`✅ ${saved} row${saved>1?"s":""} imported successfully!`);
                      setPoImportRows([]);
                      const suppliers=[...new Set(poImportRows.map(r=>r.supplier).filter(Boolean))].join(", ");
                      const importMsg=`📥 <b>PO Bulk Import — ${saved} item${saved>1?"s":""}</b>\nSupplier${suppliers.includes(",")?'s':''}: ${suppliers||"—"}\nImported by: ${session?.name||"?"}`;
                      sendTelegramNotification("procurement",importMsg);
                      sendTelegramNotification("management",importMsg);
                    } else {
                      setPoImportStatus(`⚠️ ${saved} saved, ${failed} failed.${dpSkipped.size?` No down payment yet on ${[...dpSkipped].join(", ")}: a Manager must waive it first.`:" Check console for details."}`);
                    }
                  }} style={{background:"#16a34a",border:"none",borderRadius:8,padding:"9px 24px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>
                    ✅ Import {poImportRows.length} Row{poImportRows.length>1?"s":""}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── COSTING STUDY ────────────────────────────────────────────────────────────
function CostingStudy({wonDeals,budgets,prs,exps,projs,role}){
  const[view,setView]=useState("list"); // list | project | company
  const[selCostProject,setSelCostProject]=useState(null); // selected project dealId

  const n=v=>Number(String(v).replace(/,/g,""))||0;
  const fmt=v=>"₱"+Number(v).toLocaleString("en-PH",{minimumFractionDigits:0});
  const pct=(a,b)=>b>0?Math.round(a/b*100):0;

  // Build per-project costing data
  const projectData = useMemo(()=>{
    return wonDeals.map(deal=>{
      const budget = budgets[deal.id]||emptyBudget();
      const dealPRs = prs.filter(p=>p.projectId===deal.id&&p.status!=="Cancelled");
      const dealExps= exps.filter(e=>e.projectId===deal.id);

      const actuals={Materials:0,Labor:0,Overhead:0,Subcon:0};
      dealPRs.forEach(p=>{
        const cost=(n(p.actUnitCost)||n(p.estUnitCost))*n(p.qty);
        const cat=p.budgetCategory||"Materials";
        if(actuals[cat]!==undefined) actuals[cat]+=cost;
      });
      dealExps.forEach(e=>{
        const cat=e.category==="Labor"?"Labor":e.category==="Subcon"?"Subcon":e.category==="Overhead"?"Overhead":"Materials";
        actuals[cat]+=n(e.amount);
      });

      const totalBudget=BUDGET_CATS.reduce((s,c)=>s+n(budget[c]),0);
      const totalActual=BUDGET_CATS.reduce((s,c)=>s+actuals[c],0);
      const contractVal=n(deal.value)||0;
      const grossMargin=contractVal>0?Math.round((contractVal-totalActual)/contractVal*100):null;
      const budgetVariance=totalBudget-totalActual;
      const isOverBudget=totalBudget>0&&totalActual>totalBudget;

      return{deal,budget,actuals,totalBudget,totalActual,contractVal,grossMargin,budgetVariance,isOverBudget,prCount:dealPRs.length};
    });
  },[wonDeals,budgets,prs,exps]);

  // Company-wide totals
  const companyTotals=useMemo(()=>{
    const totals={Materials:0,Labor:0,Overhead:0,Subcon:0};
    const budgetTotals={Materials:0,Labor:0,Overhead:0,Subcon:0};
    let totalContract=0,totalActual=0,totalBudget=0;
    projectData.forEach(pd=>{
      BUDGET_CATS.forEach(c=>{totals[c]+=pd.actuals[c];budgetTotals[c]+=n(pd.budget[c]);});
      totalContract+=pd.contractVal;
      totalActual+=pd.totalActual;
      totalBudget+=pd.totalBudget;
    });
    return{totals,budgetTotals,totalContract,totalActual,totalBudget};
  },[projectData]);

  const overBudget=projectData.filter(p=>p.isOverBudget);
  const lowMargin=projectData.filter(p=>p.grossMargin!==null&&p.grossMargin<20);

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Costing Study</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Budget vs actual · {projectData.length} projects · {overBudget.length>0?`${overBudget.length} over budget`:""} {lowMargin.length>0?`· ${lowMargin.length} low margin`:""}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {[["list","📋 List"],["project","Per Project"],["company","Company-Wide"]].map(([v,l])=>(
            <button key={v} onClick={()=>setView(v)} style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${view===v?"#1e293b":"#e2e8f0"}`,background:view===v?"#1e293b":"#fff",color:view===v?"#fff":"#64748b",fontFamily:"inherit",fontWeight:view===v?700:400,fontSize:".8rem",cursor:"pointer"}}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {/* Alert banners */}
      {overBudget.length>0&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,padding:"12px 16px",marginBottom:14,fontSize:".82rem",color:"#dc2626"}}>
          🚨 <strong>{overBudget.length} project{overBudget.length>1?"s":""} over budget:</strong> {overBudget.map(p=>p.deal.client).join(", ")}
        </div>
      )}
      {lowMargin.length>0&&(
        <div style={{background:"#fff7ed",border:"1.5px solid #fed7aa",borderRadius:12,padding:"12px 16px",marginBottom:14,fontSize:".82rem",color:"#c2410c"}}>
          ⚠️ <strong>{lowMargin.length} project{lowMargin.length>1?"s":""} below 20% margin:</strong> {lowMargin.map(p=>`${p.deal.client} (${p.grossMargin}%)`).join(", ")}
        </div>
      )}

      {view==="company"&&(
        <>
          {/* Company-wide KPIs */}
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:20}}>
            {[
              {l:"Total Contract Value", v:fmt(companyTotals.totalContract), c:"#0f172a"},
              {l:"Total Budgeted",       v:fmt(companyTotals.totalBudget),   c:"#3b82f6"},
              {l:"Total Actual Spend",   v:fmt(companyTotals.totalActual),   c:companyTotals.totalActual>companyTotals.totalBudget?"#ef4444":"#10b981"},
              {l:"Overall Margin",       v:companyTotals.totalContract>0?Math.round((companyTotals.totalContract-companyTotals.totalActual)/companyTotals.totalContract*100)+"%":"—", c:"#8b5cf6"},
            ].map(({l,v,c})=>(
              <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
                <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
              </div>
            ))}
          </div>

          {/* Company-wide by category */}
          <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden",marginBottom:16}}>
            <div style={{padding:"12px 18px",background:"#1e293b",fontWeight:700,color:"#f59e0b",fontSize:".85rem"}}>Cost Breakdown by Category — All Projects</div>
            {BUDGET_CATS.map((cat,i)=>{
              const bgt=companyTotals.budgetTotals[cat];
              const act=companyTotals.totals[cat];
              const share=companyTotals.totalActual>0?Math.round(act/companyTotals.totalActual*100):0;
              return(
                <div key={cat} style={{display:"grid",gridTemplateColumns:"140px 1fr 1fr 1fr 80px",padding:"12px 18px",gap:12,borderBottom:"1px solid #f1f5f9",background:i%2?"#fafafa":"#fff",alignItems:"center"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{width:10,height:10,borderRadius:"50%",background:BUDGET_CAT_CLR[cat],flexShrink:0,display:"inline-block"}}/>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{cat}</span>
                  </div>
                  <div style={{textAlign:"right",color:"#3b82f6",fontWeight:600}}>{fmt(bgt)}</div>
                  <div style={{textAlign:"right",fontWeight:700,color:act>bgt&&bgt>0?"#ef4444":"#10b981"}}>{fmt(act)}</div>
                  <div style={{textAlign:"right",color:bgt-act<0?"#ef4444":"#059669",fontWeight:600}}>{bgt>0?(bgt-act<0?"▼":"▲")+" "+fmt(Math.abs(bgt-act)):"—"}</div>
                  <div style={{textAlign:"center",fontSize:".78rem",fontWeight:700,color:"#8b5cf6"}}>{share}% of total</div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {view==="list"&&(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
          <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 80px",background:"#1e293b",padding:"10px 16px",gap:12}}>
            {["Project","Contract","Budget","Actual Spend","Margin","Status"].map(h=>(
              <div key={h} style={{fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.6)",textTransform:"uppercase",letterSpacing:".8px"}}>{h}</div>
            ))}
          </div>
          {projectData.length===0&&<div style={{padding:"32px",textAlign:"center",color:"#94a3b8"}}>No awarded projects yet.</div>}
          {projectData.map((pd,i)=>{
            const isOver=pd.isOverBudget;
            const isLow=pd.grossMargin!==null&&pd.grossMargin<20;
            return(
              <div key={pd.deal.id} {...clickable(()=>{setSelCostProject(pd.deal.id);setView("project");})} aria-label="Open project cost detail" style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 80px",padding:"11px 16px",gap:12,borderBottom:"1px solid #f1f5f9",background:i%2?"#fafafa":"#fff",cursor:"pointer",alignItems:"center",transition:"background .1s"}}
                onMouseEnter={e=>e.currentTarget.style.background="#eff6ff"}
                onMouseLeave={e=>e.currentTarget.style.background=i%2?"#fafafa":"#fff"}>
                <div>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{pd.deal.client}</div>
                  <div style={{fontSize:".7rem",color:"#64748b",marginTop:1}}>{pd.deal.ceNo||"No CE"} · {pd.deal.contact||pd.deal.product}</div>
                </div>
                <div style={{fontWeight:600,color:"#0f172a",fontSize:".85rem"}}>₱{pd.contractVal.toLocaleString("en-PH",{minimumFractionDigits:0})}</div>
                <div style={{fontWeight:600,color:"#3b82f6",fontSize:".85rem"}}>{pd.totalBudget>0?"₱"+pd.totalBudget.toLocaleString("en-PH",{minimumFractionDigits:0}):<span style={{color:"#cbd5e1"}}>Not set</span>}</div>
                <div style={{fontWeight:700,color:isOver?"#ef4444":"#10b981",fontSize:".85rem"}}>₱{pd.totalActual.toLocaleString("en-PH",{minimumFractionDigits:0})}</div>
                <div style={{fontWeight:800,fontSize:".9rem",color:pd.grossMargin===null?"#94a3b8":isLow?"#ef4444":"#059669"}}>
                  {pd.grossMargin!==null?pd.grossMargin+"%":"—"}
                </div>
                <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                  {isOver&&<span style={{fontSize:".62rem",background:"#fef2f2",color:"#dc2626",padding:"1px 6px",borderRadius:20,fontWeight:700}}>Over</span>}
                  {isLow&&<span style={{fontSize:".62rem",background:"#fff7ed",color:"#c2410c",padding:"1px 6px",borderRadius:20,fontWeight:700}}>Low</span>}
                  {!isOver&&!isLow&&pd.totalBudget>0&&<span style={{fontSize:".62rem",background:"#f0fdf4",color:"#059669",padding:"1px 6px",borderRadius:20,fontWeight:700}}>OK</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {view==="project"&&(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <button onClick={()=>{setView("list");setSelCostProject(null);}}
              style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"5px 12px",cursor:"pointer",fontFamily:"inherit",fontSize:".8rem",fontWeight:600,color:"#64748b"}}>
              ← Back to All Projects
            </button>
          </div>
          {projectData.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8"}}>No awarded projects yet.</div>}
          {(selCostProject?projectData.filter(pd=>pd.deal.id===selCostProject):projectData).map(pd=>(
            <div key={pd.deal.id} style={{background:"#fff",borderRadius:14,border:`1.5px solid ${pd.isOverBudget?"#fecaca":"#e2e8f0"}`,overflow:"hidden"}}>
              {/* Project header */}
              <div style={{display:"flex",justifyContent:"space-between",padding:"14px 18px",background:pd.isOverBudget?"#fef9f9":"#f8fafc",borderBottom:"1px solid #e2e8f0",flexWrap:"wrap",gap:10}}>
                <div>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".9rem"}}>{pd.deal.client}</div>
                  {pd.deal.contact&&<div style={{fontSize:".73rem",color:"#64748b",marginTop:1}}>{pd.deal.contact}</div>}
                  <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:3}}>{pd.prCount} PRs logged · {pd.deal.stage.replace(/^\d+ · /,"")}</div>
                </div>
                <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
                  {[
                    {l:"Contract",v:fmt(pd.contractVal),c:"#0f172a"},
                    {l:"Budget",  v:pd.totalBudget>0?fmt(pd.totalBudget):"Not set",c:"#3b82f6"},
                    {l:"Actual",  v:fmt(pd.totalActual),c:pd.isOverBudget?"#ef4444":"#10b981"},
                    {l:"Margin",  v:pd.grossMargin!==null?pd.grossMargin+"%":"—",c:pd.grossMargin===null?"#94a3b8":pd.grossMargin<20?"#ef4444":"#059669"},
                  ].map(({l,v,c})=>(
                    <div key={l} style={{textAlign:"right"}}>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1rem",color:c}}>{v}</div>
                      <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px"}}>{l}</div>
                    </div>
                  ))}
                </div>
              </div>
              {/* Category breakdown */}
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:0}}>
                {BUDGET_CATS.map((cat,i)=>{
                  const bgt=n(pd.budget[cat]);
                  const act=pd.actuals[cat];
                  const p=bgt>0?Math.round(act/bgt*100):act>0?999:0;
                  return(
                    <div key={cat} style={{padding:"12px 16px",borderRight:i<3?"1px solid #f1f5f9":"none",borderTop:"1px solid #f1f5f9"}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                        <span style={{width:8,height:8,borderRadius:"50%",background:BUDGET_CAT_CLR[cat],display:"inline-block"}}/>
                        <span style={{fontSize:".72rem",fontWeight:700,color:"#475569"}}>{cat}</span>
                      </div>
                      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".95rem",color:act>bgt&&bgt>0?"#ef4444":"#0f172a"}}>{fmt(act)}</div>
                      <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:2}}>Budget: {bgt>0?fmt(bgt):"—"}</div>
                      {bgt>0&&(
                        <div style={{marginTop:5}}>
                          <div style={{height:4,background:"#f1f5f9",borderRadius:2,overflow:"hidden"}}>
                            <div style={{height:"100%",width:Math.min(p,100)+"%",background:p>100?"#ef4444":p>80?"#f59e0b":"#10b981",borderRadius:2}}/>
                          </div>
                          <div style={{fontSize:".65rem",color:p>100?"#ef4444":"#94a3b8",marginTop:2,fontWeight:p>100?700:400}}>{p===999?"No budget":p+"%"}</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              {/* Variance note */}
              {pd.totalBudget>0&&(
                <div style={{padding:"8px 18px",background:pd.isOverBudget?"#fef2f2":"#f0fdf4",fontSize:".75rem",fontWeight:600,color:pd.isOverBudget?"#dc2626":"#059669",borderTop:"1px solid #e2e8f0"}}>
                  {pd.isOverBudget
                    ?`🚨 Over budget by ${fmt(Math.abs(pd.budgetVariance))} — review spend immediately`
                    :`✓ ${fmt(pd.budgetVariance)} remaining of budget`}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── BUDGET REQUEST VIEW ──────────────────────────────────────────────────────
function BudgetRequestView({sendTelegramNotification,breqs,addBR,updateBR,deleteBR,wonDeals,session,role,toastEmit}){
  const[showForm,setShowForm]=useState(false);
  const[form,setForm]=useState({projectId:"",purpose:"Installation",amount:"",urgency:"Normal",description:"",requestedBy:session?.name||"",dateNeeded:"",notes:""});
  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const n=v=>Number(String(v).replace(/,/g,""))||0;
  const fmt=v=>"₱"+n(v).toLocaleString("en-PH",{minimumFractionDigits:0});
  const STATUS_CLR={"Submitted":"#f59e0b","Under Review":"#3b82f6","Approved":"#10b981","Released":"#059669","Rejected":"#ef4444"};
  const canApprove=role==="Cost Control"||role==="Manager";

  const submit=()=>{
    if(!form.amount||!form.projectId||!form.purpose) return;
    if(!(n(form.amount)>0)){toastEmit&&toastEmit("Amount must be a positive number.","error");return;}
    addBR({...form,status:"Submitted"});
    setForm({projectId:"",purpose:"Installation",amount:"",urgency:"Normal",description:"",requestedBy:session?.name||"",dateNeeded:"",notes:""});
    setShowForm(false);
  };

  const printBR = (br) => {
    const deal = wonDeals.find(d=>d.id===br.projectId);
    const projName = deal?.contact||deal?.client||"—";
    const fmtP = v=>"₱"+Number(String(v).replace(/,/g,"")).toLocaleString("en-PH",{minimumFractionDigits:2});
    const printDate = new Date().toLocaleDateString("en-PH",{year:"numeric",month:"long",day:"numeric"});
    const win = window.open("","_blank","width=860,height=980");
    if(!win){alert("Please allow pop-ups.");return;}
    win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
<title>Budget Request — ${projName}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0;}
  body{font-family:Arial,Helvetica,sans-serif;font-size:11.5px;color:#1a1a1a;background:#fff;line-height:1.5;}
  .page{max-width:760px;margin:0 auto;padding:36px 48px;}
  .letterhead{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:14px;border-bottom:3px solid #f97316;margin-bottom:20px;}
  .co-name{font-weight:900;font-size:13px;color:#1a1a1a;letter-spacing:.3px;}
  .co-info{font-size:10px;color:#666;line-height:1.7;margin-top:3px;}
  .doc-title{font-size:20px;font-weight:900;color:#f97316;letter-spacing:.5px;margin-bottom:3px;}
  .doc-no{font-size:11px;color:#666;}
  .section{margin-bottom:18px;}
  .section-title{font-size:9.5px;font-weight:900;text-transform:uppercase;letter-spacing:1px;color:#f97316;border-bottom:1.5px solid #f97316;padding-bottom:3px;margin-bottom:10px;}
  .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:6px 24px;}
  .info-row{font-size:11px;display:flex;gap:6px;}
  .info-label{font-weight:700;color:#555;min-width:100px;flex-shrink:0;}
  .info-val{color:#1a1a1a;}
  .amount-box{background:#f0fdf4;border:2px solid #6ee7b7;border-radius:8px;padding:14px 20px;margin-bottom:18px;display:flex;justify-content:space-between;align-items:center;}
  .amount-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#059669;}
  .amount-value{font-size:24px;font-weight:900;color:#059669;letter-spacing:.5px;}
  .desc-box{background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:10px 14px;font-size:11px;color:#1a1a1a;margin-bottom:18px;white-space:pre-wrap;}
  .desc-label{font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px;}
  .urgency-badge{display:inline-block;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:700;}
  .urgency-Urgent{background:#fef2f2;color:#dc2626;border:1px solid #fecaca;}
  .urgency-High{background:#fffbeb;color:#d97706;border:1px solid #fde68a;}
  .urgency-Normal{background:#f0fdf4;color:#059669;border:1px solid #6ee7b7;}
  .sig-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;margin-top:32px;}
  .sig-box{border-top:1.5px solid #1a1a1a;padding-top:8px;}
  .sig-role{font-size:9.5px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#666;margin-bottom:4px;}
  .sig-name{font-size:11.5px;font-weight:700;color:#1a1a1a;min-height:18px;}
  .sig-date{font-size:10px;color:#666;margin-top:2px;min-height:14px;}
  .sig-line{height:28px;border-bottom:1px solid #ccc;margin-bottom:4px;}
  .no-print{margin-top:24px;text-align:center;}
  @media print{.no-print{display:none;}}
</style></head><body><div class="page">

  <div class="letterhead">
    <div>
      <div class="co-name">GMD Productions Inc.</div>
      <div class="co-info">Interior Design &amp; Fabrication<br>Marikina City, Metro Manila<br>gmdproductionsinc@gmail.com</div>
    </div>
    <div style="text-align:right">
      <div class="doc-title">BUDGET REQUEST</div>
      <div class="doc-no">Date: ${printDate}</div>
      <div class="doc-no">Status: <strong>${br.status||"Submitted"}</strong></div>
    </div>
  </div>

  <div class="amount-box">
    <div>
      <div class="amount-label">Amount Requested</div>
      <div style="font-size:11px;color:#059669;margin-top:2px;">${br.purpose||"—"}</div>
    </div>
    <div class="amount-value">${fmtP(br.amount||0)}</div>
  </div>

  <div class="section">
    <div class="section-title">Project Information</div>
    <div class="info-grid">
      <div class="info-row"><span class="info-label">Project:</span><span class="info-val">${projName}</span></div>
      <div class="info-row"><span class="info-label">CE No.:</span><span class="info-val">${deal?.ceNo||"—"}</span></div>
      <div class="info-row"><span class="info-label">Location:</span><span class="info-val">${deal?.location||"—"}</span></div>
      <div class="info-row"><span class="info-label">Date Submitted:</span><span class="info-val">${br.createdDate||"—"}</span></div>
      <div class="info-row"><span class="info-label">Date Needed By:</span><span class="info-val">${br.dateNeeded||"—"}</span></div>
      <div class="info-row"><span class="info-label">Urgency:</span><span class="info-val"><span class="urgency-badge urgency-${br.urgency||"Normal"}">${br.urgency||"Normal"}</span></span></div>
    </div>
  </div>

  ${br.description?`
  <div class="section">
    <div class="section-title">Description / Justification</div>
    <div class="desc-box">${br.description}</div>
  </div>`:""}

  ${br.notes?`
  <div class="section">
    <div class="section-title">Additional Notes</div>
    <div class="desc-box">${br.notes}</div>
  </div>`:""}

  ${(br.status==="Approved"||br.status==="Released")?`
  <div class="section">
    <div class="section-title">Approval Details</div>
    <div class="info-grid">
      ${br.approvedBy?`<div class="info-row"><span class="info-label">Approved by:</span><span class="info-val">${br.approvedBy}</span></div>`:""}
      ${br.approvedDate?`<div class="info-row"><span class="info-label">Approval Date:</span><span class="info-val">${br.approvedDate}</span></div>`:""}
      ${br.releasedBy?`<div class="info-row"><span class="info-label">Released by:</span><span class="info-val">${br.releasedBy}</span></div>`:""}
      ${br.releasedDate?`<div class="info-row"><span class="info-label">Release Date:</span><span class="info-val">${br.releasedDate}</span></div>`:""}
    </div>
  </div>`:""}

  <div class="sig-grid">
    <div class="sig-box">
      <div class="sig-role">Requested By</div>
      <div class="sig-name">${br.requestedBy||"_______________"}</div>
      <div class="sig-date">${br.createdDate||"_______________"}</div>
    </div>
    <div class="sig-box">
      <div class="sig-role">Checked By</div>
      <div class="sig-line"></div>
      <div class="sig-date">Date: _______________</div>
    </div>
    <div class="sig-box">
      <div class="sig-role">Approved By</div>
      ${(br.status==="Approved"||br.status==="Released")&&br.approvedBy?`<div class="sig-name">${br.approvedBy}</div><div class="sig-date">${br.approvedDate||"_______________"}</div>`:`<div class="sig-line"></div><div class="sig-date">Date: _______________</div>`}
    </div>
  </div>

  <div style="margin-top:40px;font-size:9.5px;color:#aaa;text-align:center;border-top:1px solid #e5e5e5;padding-top:10px;">
    GMD Productions Inc. · Budget Request · Internal Document · Generated ${printDate}
  </div>

  <div class="no-print">
    <button onclick="window.print()" style="background:#f97316;color:#fff;border:none;border-radius:8px;padding:11px 28px;font-size:13px;font-weight:700;cursor:pointer;font-family:Arial,sans-serif;">🖨️ Print / Save as PDF</button>
    <p style="margin-top:8px;font-size:11px;color:#999;">Select <strong>Save as PDF</strong> in the print dialog</p>
  </div>

</div></body></html>`);
    win.document.close();addPrintClose(win); win.focus();
  };

  const pending=breqs.filter(b=>b.status==="Submitted"||b.status==="Under Review");

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Budget Requests</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Operations requests cash for installation, mobilization, permits · Cost Control approves and releases</div>
        </div>
        <button onClick={()=>setShowForm(s=>!s)} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>
          + Request Budget
        </button>
      </div>

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:16}}>
        {[
          {l:"Total Requests", v:breqs.length,                                        c:"#0f172a"},
          {l:"Pending",        v:pending.length,                                      c:"#f59e0b"},
          {l:"Approved",       v:breqs.filter(b=>b.status==="Approved").length,       c:"#10b981"},
          {l:"Total Released", v:fmt(breqs.filter(b=>b.status==="Released").reduce((s,b)=>s+n(b.amount),0)), c:"#059669"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
          </div>
        ))}
      </div>

      {canApprove&&pending.length>0&&(
        <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"10px 16px",marginBottom:14,fontSize:".82rem",color:"#92400e"}}>
          ⚠️ <strong>{pending.length} budget request{pending.length>1?"s":""} need your action</strong>
        </div>
      )}

      {/* Form */}
      {showForm&&(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:20,marginBottom:18}}>
          <div style={{fontWeight:800,color:"#0f172a",marginBottom:16}}>New Budget Request</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <Fld label="Project" required>
              <Sel value={form.projectId} onChange={e=>f("projectId",e.target.value)}>
                <option value="">— Select Project —</option>
                {wonDeals.map(d=><option key={d.id} value={d.id}>{d.client}{d.contact?` — ${d.contact}`:""}</option>)}
              </Sel>
            </Fld>
            <Fld label="Purpose" required>
              <Sel value={form.purpose} onChange={e=>f("purpose",e.target.value)}>
                {BR_PURPOSES.map(p=><option key={p}>{p}</option>)}
              </Sel>
            </Fld>
            <Fld label="Amount Needed (₱)" required>
              <Inp type="number" value={form.amount} onChange={e=>f("amount",e.target.value)} placeholder="0.00"/>
            </Fld>
            <Fld label="Date Needed By">
              <Inp type="date" value={form.dateNeeded} onChange={e=>f("dateNeeded",e.target.value)}/>
            </Fld>
            <Fld label="Urgency">
              <Sel value={form.urgency} onChange={e=>f("urgency",e.target.value)}>
                {["Normal","High","Urgent"].map(u=><option key={u}>{u}</option>)}
              </Sel>
            </Fld>
            <Fld label="Requested By">
              <Inp value={form.requestedBy} onChange={e=>f("requestedBy",e.target.value)} placeholder={session?.name||""}/>
            </Fld>
            <div style={{gridColumn:"1/-1"}}>
              <Fld label="Description — what is this budget for?">
                <Inp rows={3} value={form.description} onChange={e=>f("description",e.target.value)} placeholder="e.g. Mobilization for SM Megamall installation starting May 20 — truck rental, labor allowance, permits"/>
              </Fld>
            </div>
            <div style={{gridColumn:"1/-1"}}>
              <Fld label="Notes">
                <Inp rows={2} value={form.notes} onChange={e=>f("notes",e.target.value)} placeholder="Any supporting details…"/>
              </Fld>
            </div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:14}}>
            <button onClick={submit} disabled={!form.amount||!form.projectId}
              style={{background:form.amount&&form.projectId?"#1e293b":"#e2e8f0",border:"none",borderRadius:10,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:form.amount&&form.projectId?"#fff":"#94a3b8",cursor:form.amount&&form.projectId?"pointer":"not-allowed"}}>
              Submit Request
            </button>
            <button onClick={()=>setShowForm(false)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"10px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {/* BR List */}
      {breqs.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8",fontSize:".84rem"}}>No budget requests yet.</div>}
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {breqs.map(br=>{
          const deal=wonDeals.find(d=>d.id===br.projectId);
          return(
            <div key={br.id} style={{background:"#fff",borderRadius:12,border:`1.5px solid ${br.urgency==="Urgent"?"#fecaca":br.status==="Released"?"#6ee7b7":"#e2e8f0"}`,padding:"14px 18px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".9rem"}}>{br.purpose}</span>
                    <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1rem",color:br.status==="Released"?"#059669":"#0f172a"}}>₱{n(br.amount).toLocaleString("en-PH")}</span>
                    <span style={{fontSize:".68rem",background:STATUS_CLR[br.status]+"22",color:STATUS_CLR[br.status],border:`1px solid ${STATUS_CLR[br.status]}44`,borderRadius:20,padding:"1px 9px",fontWeight:700}}>{br.status}</span>
                    {br.urgency!=="Normal"&&<span style={{fontSize:".68rem",color:br.urgency==="Urgent"?"#ef4444":"#f59e0b",background:br.urgency==="Urgent"?"#fef2f2":"#fffbeb",border:`1px solid ${br.urgency==="Urgent"?"#fecaca":"#fde68a"}`,borderRadius:20,padding:"1px 9px",fontWeight:600}}>{br.urgency}</span>}
                  </div>
                  <div style={{fontSize:".75rem",color:"#64748b",display:"flex",gap:12,flexWrap:"wrap",alignItems:"center"}}>
                    {deal&&<span>📁 {deal.client}{deal.contact?` — ${deal.contact}`:""}</span>}
                    {br.dateNeeded&&<span>📅 Needed by {br.dateNeeded}</span>}
                    <span>By: {br.requestedBy||"—"}</span>
                    <span>{br.createdDate}</span>
                    {br.statusChangedAt&&br.status!=="Submitted"&&(()=>{const d=Math.ceil((new Date()-new Date(br.statusChangedAt))/86400000);const clr={Approved:"#059669",Released:"#1d4ed8",Rejected:"#ef4444"}[br.status]||"#64748b";return<span style={{color:clr,fontWeight:600}}>{br.status==="Approved"?"✓ ":br.status==="Released"?"💵 ":"❌ "}{d===0?"Today":d+"d ago"}</span>})()}
                  </div>
                  {br.description&&<div style={{fontSize:".75rem",color:"#475569",marginTop:5,fontStyle:"italic"}}>"{br.description}"</div>}
                </div>
                <div style={{display:"flex",gap:7,flexShrink:0,flexWrap:"wrap",alignItems:"flex-start"}}>
                  <button onClick={()=>printBR(br)} style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:7,padding:"5px 10px",fontSize:".72rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>🖨️</button>
                  {canApprove&&(br.status==="Submitted"||br.status==="Under Review")&&(<>
                    <button onClick={()=>{
                      if(br.requestedBy===session?.name){toastEmit&&toastEmit("You cannot approve your own budget request.","error");return;}
                      updateBR(br.id,{status:"Approved",approvedBy:session?.name,approvedDate:today,statusChangedAt:today});
                      const deal=wonDeals.find(d=>d.id===br.projectId);
                      sendTelegramNotification("operations",`✅ <b>Budget Request Approved</b>\n${br.purpose}\n₱${n(br.amount).toLocaleString("en-PH",{maximumFractionDigits:0})}\nProject: ${deal?.client||"?"}${deal?.contact?" — "+deal.contact:""}\nApproved by: ${session?.name}`);
                    }} style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:8,padding:"6px 12px",fontWeight:700,fontSize:".76rem",color:"#059669",cursor:"pointer",fontFamily:"inherit"}}>
                      ✓ Approve
                    </button>
                    <button onClick={()=>{
                      updateBR(br.id,{status:"Rejected",statusChangedAt:today});
                      const deal=wonDeals.find(d=>d.id===br.projectId);
                      sendTelegramNotification("operations",`❌ <b>Budget Request Rejected</b>\n${br.purpose}\n₱${n(br.amount).toLocaleString("en-PH",{maximumFractionDigits:0})}\nProject: ${deal?.client||"?"}${deal?.contact?" — "+deal.contact:""}\nRejected by: ${session?.name}`);
                    }} style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:8,padding:"6px 12px",fontWeight:700,fontSize:".76rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>
                      ✕ Reject
                    </button>
                    {role==="Manager"&&<button onClick={async ()=>{if((await uiConfirm("Delete this budget request?")))deleteBR(br.id);}} style={{background:"#fee2e2",border:"1.5px solid #fecaca",borderRadius:8,padding:"6px 10px",fontWeight:700,fontSize:".73rem",color:"#991b1b",cursor:"pointer",fontFamily:"inherit"}}>🗑</button>}
                  </>)}
                  {br.status==="Approved"&&canApprove&&(
                    <button onClick={()=>{
                      updateBR(br.id,{status:"Released",releasedBy:session?.name,releasedDate:today,statusChangedAt:today});
                      const deal=wonDeals.find(d=>d.id===br.projectId);
                      const relMsg=`💵 <b>Budget Released</b>\n${br.purpose}\n₱${n(br.amount).toLocaleString("en-PH",{maximumFractionDigits:0})}\nProject: ${deal?.client||"?"}${deal?.contact?" — "+deal.contact:""}\nReleased by: ${session?.name}`;sendTelegramNotification("ops",relMsg);sendTelegramNotification("financialcontrol",relMsg);
                    }} style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:8,padding:"6px 12px",fontWeight:700,fontSize:".76rem",color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit"}}>
                      💵 Mark Released
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── BILLING VIEW ─────────────────────────────────────────────────────────────
function DeptHeader({greeting,name,subtitle,buttons=[]}){
  return(
    <div style={{background:"#0f172a",borderRadius:12,padding:"16px 20px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center",gap:14,flexWrap:"wrap"}}>
      <div>
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.4rem",color:"#f8fafc",letterSpacing:"-.3px"}}>
          Good {new Date().getHours()<12?"morning":new Date().getHours()<17?"afternoon":"evening"}, {name||"Team"} 👋
        </div>
        <div style={{fontSize:".72rem",color:"rgba(255,255,255,.4)",marginTop:2}}>{subtitle}</div>
      </div>
      {buttons.length>0&&(
        <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
          {buttons.map(({label,icon,bg,fg,action})=>(
            <button key={label} onClick={action}
              style={{background:bg||"#1e293b",color:fg||"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".76rem",cursor:"pointer",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:5}}>
              {icon} {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function RecentActivityFeed({projs,wonDeals,limit=10}){
  const all=[];
  wonDeals.forEach(d=>{
    const p=projs[d.id];
    if(!p?.pmUpdates?.length) return;
    p.pmUpdates.forEach(u=>all.push({...u,dealId:d.id,dealName:d.client||d.contact||d.id}));
  });
  all.sort((a,b)=>(b.date||"")>(a.date||"")?1:(b.date||"")<(a.date||"")?-1:(b.time||"")>(a.time||"")?1:-1);
  const recent=all.slice(0,limit);
  if(!recent.length) return(<div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No project updates yet — team will post updates from the Projects page.</div>);
  return(
    <div>
      {recent.map((u,i)=>{
        const uType=u.type||"General Progress";
        const uColor=PM_TYPE_COLOR[uType]||"#0ea5e9";
        const uIcon=PM_TYPE_ICON[uType]||"📋";
        const isBlocker=uType==="Blocker"&&u.blockerStatus==="Open";
        return(
          <div key={u.id||i} style={{padding:"11px 16px",borderBottom:i<recent.length-1?"1px solid #f1f5f9":"",display:"flex",gap:10,alignItems:"flex-start",background:isBlocker?"#fff5f5":"#fff"}}>
            <span style={{fontSize:"1.1rem",lineHeight:1.2,flexShrink:0,marginTop:1}}>{uIcon}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{u.dealName}</span>
                <span style={{fontSize:".65rem",color:"#94a3b8",flexShrink:0}}>{u.date||""}{u.time?" · "+u.time:""}</span>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,marginTop:3,flexWrap:"wrap"}}>
                <span style={{fontSize:".68rem",background:uColor+"18",color:uColor,border:`1px solid ${uColor}44`,borderRadius:20,padding:"1px 9px",fontWeight:700}}>{uIcon} {uType}</span>
                {u.by&&<span style={{fontSize:".68rem",color:"#94a3b8"}}>by {u.by}</span>}
                {isBlocker&&<span style={{fontSize:".66rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:20,padding:"1px 8px",fontWeight:700}}>🚨 OPEN BLOCKER</span>}
              </div>
              {(u.note||u.text)&&<div style={{fontSize:".79rem",color:"#475569",marginTop:4,lineHeight:1.4}}>{(u.note||u.text).length>120?(u.note||u.text).slice(0,120)+"…":(u.note||u.text)}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
function PMFeedView({projs,wonDeals,deals,session,role,upProj}){
  const[typeFilter,setTypeFilter]=useState("All");
  const[projFilter,setProjFilter]=useState("");
  const[search,setSearch]=useState("");
  const today2=new Date().toISOString().slice(0,10);
  const canClear=!["Sales","Finance"].includes(role);

  const allUpdates=React.useMemo(()=>{
    const out=[];
    for(const deal of wonDeals){
      const proj=projs[deal.id];
      for(const u of (proj?.pmUpdates||[])){
        out.push({...u,dealId:deal.id,client:deal.client,ceNo:deal.ceNo||""});
      }
    }
    return out.sort((a,b)=>{
      const da=(a.date||"")+(a.time||"");
      const db=(b.date||"")+(b.time||"");
      return db.localeCompare(da);
    });
  },[projs,wonDeals]);

  const openBlockers=allUpdates.filter(u=>u.type==="Blocker"&&u.blockerStatus!=="Cleared");

  const filtered=allUpdates.filter(u=>{
    if(typeFilter!=="All"&&u.type!==typeFilter) return false;
    if(projFilter&&u.dealId!==projFilter) return false;
    if(search&&!(u.note||u.text||"").toLowerCase().includes(search.toLowerCase())&&!u.client.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return(
    <div style={{maxWidth:900,margin:"0 auto",padding:"0 0 40px"}}>
      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.6rem",color:"#0f172a",marginBottom:4}}>📋 PM Activity Feed</div>
      <div style={{fontSize:".82rem",color:"#64748b",marginBottom:18}}>All project updates across active jobs — visible to the whole team.</div>

      {openBlockers.length>0&&(
        <div style={{background:"#fef2f2",border:"1.5px solid #fca5a5",borderRadius:12,padding:"12px 16px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:"1.2rem"}}>🚨</span>
          <div>
            <div style={{fontWeight:700,color:"#dc2626",fontSize:".9rem"}}>{openBlockers.length} Open Blocker{openBlockers.length!==1?"s":""}</div>
            <div style={{fontSize:".78rem",color:"#991b1b"}}>{openBlockers.map(b=>b.client).join(" · ")}</div>
          </div>
        </div>
      )}

      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14,alignItems:"center"}}>
        {["All",...PM_UPDATE_TYPES].map(t=>(
          <button key={t} onClick={()=>setTypeFilter(t)} style={{border:`2px solid ${t==="All"?"#64748b":PM_TYPE_COLOR[t]||"#64748b"}`,borderRadius:20,padding:"4px 14px",fontSize:".75rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",background:typeFilter===t?(t==="All"?"#64748b":PM_TYPE_COLOR[t]||"#64748b"):"#fff",color:typeFilter===t?"#fff":(t==="All"?"#64748b":PM_TYPE_COLOR[t]||"#64748b")}}>
            {t!=="All"&&PM_TYPE_ICON[t]+" "}{t}
          </button>
        ))}
        <select value={projFilter} onChange={e=>setProjFilter(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"5px 10px",fontFamily:"inherit",fontSize:".78rem",marginLeft:"auto"}}>
          <option value="">All Projects</option>
          {wonDeals.map(d=><option key={d.id} value={d.id}>{d.client}{d.ceNo?" · "+d.ceNo:""}</option>)}
        </select>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search updates…" style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"5px 10px",fontFamily:"inherit",fontSize:".78rem",minWidth:160}}/>
      </div>

      {filtered.length===0&&<div style={{textAlign:"center",padding:"40px 0",color:"#94a3b8",fontSize:".9rem"}}>No updates found.</div>}

      {filtered.map(u=>{
        const uType=u.type||"General Progress";
        const uColor=PM_TYPE_COLOR[uType]||"#0ea5e9";
        const uIcon=PM_TYPE_ICON[uType]||"📋";
        const isBlocker=uType==="Blocker";
        const cleared=u.blockerStatus==="Cleared";
        return(
          <div key={u.id||u.date+u.client} style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"14px 16px",marginBottom:10,borderLeft:`4px solid ${uColor}`}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6,flexWrap:"wrap"}}>
              <span style={{background:uColor,color:"#fff",borderRadius:20,padding:"2px 10px",fontSize:".68rem",fontWeight:700,fontFamily:"'IBM Plex Mono',monospace"}}>{uIcon} {uType}</span>
              <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{u.client}</span>
              {u.ceNo&&<span style={{fontSize:".68rem",color:"#94a3b8",fontFamily:"'IBM Plex Mono',monospace"}}>{u.ceNo}</span>}
              {isBlocker&&<span style={{background:cleared?"#dcfce7":"#fef2f2",color:cleared?"#15803d":"#dc2626",border:`1px solid ${cleared?"#86efac":"#fca5a5"}`,borderRadius:20,padding:"2px 8px",fontSize:".65rem",fontWeight:700}}>{cleared?"✓ Cleared":"⚠ Open"}</span>}
              {u.stage&&<span style={{fontSize:".65rem",color:"#64748b",background:"#f1f5f9",borderRadius:12,padding:"2px 8px"}}>{u.stage}{u.pct?" · "+u.pct+"%":""}</span>}
            </div>
            <div style={{fontSize:".87rem",color:"#1e293b",lineHeight:1.6,marginBottom:isBlocker?8:4}}>{u.note||u.text||""}</div>
            {isBlocker&&(u.blockerDesc||u.decisionMaker||u.actionPlan)&&(
              <div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"8px 10px",marginBottom:6,fontSize:".78rem"}}>
                {u.blockerDesc&&<div style={{marginBottom:3}}><b>Blocker:</b> {u.blockerDesc}</div>}
                {u.decisionMaker&&<div style={{marginBottom:3,color:"#dc2626"}}><b>Decision from:</b> {u.decisionMaker}</div>}
                {u.actionPlan&&<div><b>Action plan:</b> {u.actionPlan}</div>}
                {u.clearedBy&&<div style={{color:"#15803d",marginTop:4}}>✓ Cleared by {u.clearedBy} · {u.clearedOn}</div>}
              </div>
            )}
            {u.nextSteps&&<div style={{fontSize:".78rem",color:"#475569",marginBottom:4}}><b>Next:</b> {u.nextSteps}</div>}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:6}}>
              <div style={{fontSize:".72rem",color:"#94a3b8"}}>{u.by} · {u.date}{u.time&&` at ${u.time}`}</div>
              {isBlocker&&!cleared&&canClear&&(
                <button onClick={()=>upProj(u.dealId,p=>({...p,pmUpdates:(p.pmUpdates||[]).map(x=>x.id===u.id?{...x,blockerStatus:"Cleared",clearedBy:session?.name,clearedOn:today2}:x)}))} style={{background:"#dcfce7",border:"1px solid #86efac",borderRadius:6,padding:"3px 10px",fontSize:".68rem",color:"#15803d",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✓ Clear Blocker</button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function DeductionForm({ms,applyDeduction,session,today,toastEmit,sendTelegramNotification,deal}){
  const[showDed,setShowDed]=useState(false);
  const[dedForm,setDedForm]=useState({reason:"",amount:""});
  const[saving,setSaving]=useState(false);
  if(!showDed) return(
    <button onClick={()=>setShowDed(true)} style={{background:"none",border:"1px dashed #f97316",borderRadius:6,padding:"3px 10px",fontSize:".68rem",color:"#c2410c",cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>+ Record Deduction</button>
  );
  // The database lowers the amount and keeps the record in one step
  // (record_billing_deduction, migration 20261020060000): Manager only, reason
  // required, never more than the invoice or below what has been paid.
  const save=async()=>{
    const amt=Number(dedForm.amount);
    if(!String(dedForm.reason).trim()){toastEmit&&toastEmit("Give the reason for the deduction.","warning");return;}
    if(!isFinite(amt)||amt<=0){toastEmit&&toastEmit("Enter a deduction amount greater than zero.","warning");return;}
    if(amt>Number(ms.amount||0)+0.005){toastEmit&&toastEmit(`Deduction is more than the milestone amount (₱${Number(ms.amount||0).toLocaleString("en-PH")}).`,"warning");return;}
    if(!isSupabaseReady()){toastEmit&&toastEmit("No server connection — a deduction can only be recorded online.","error",8000);return;}
    setSaving(true);
    const{data,error}=await _rpcWithTimeout(supabase.rpc('record_billing_deduction',{p_milestone_id:ms.id,p_amount:amt,p_reason:String(dedForm.reason).trim()}));
    setSaving(false);
    if(error){toastEmit&&toastEmit("Deduction not recorded: "+error.message,"error",9000);return;}
    applyDeduction(ms.id,data);
    sendTelegramNotification&&sendTelegramNotification("financialcontrol",`📉 <b>Billing Deduction Approved — ${deal?.client||""}</b>\nMilestone: ${ms.name}${ms.invoiceNo?` (${ms.invoiceNo})`:""}\nDeduction: ₱${amt.toLocaleString("en-PH")}\nAmount: ₱${Number(data.amount_before).toLocaleString("en-PH")} → ₱${Number(data.amount_after).toLocaleString("en-PH")}\nReason: ${data.reason}\nApproved by: ${session?.name||data.recorded_by} · ${today}`);
    toastEmit&&toastEmit("Deduction recorded — Finance notified","success");
    setShowDed(false);setDedForm({reason:"",amount:""});
  };
  return(
    <div style={{background:"#fff7ed",border:"1.5px solid #fed7aa",borderRadius:8,padding:"10px 12px"}}>
      <div style={{fontWeight:700,color:"#c2410c",fontSize:".76rem",marginBottom:8}}>📉 Record Deduction</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
        <Fld label="Reason" required><Inp value={dedForm.reason} onChange={e=>setDedForm(p=>({...p,reason:e.target.value}))} placeholder="e.g. Penalty, Incomplete works"/></Fld>
        <Fld label="Amount (₱, VAT-ex)" required><Inp type="number" value={dedForm.amount} onChange={e=>setDedForm(p=>({...p,amount:e.target.value}))} placeholder="0.00"/></Fld>
      </div>
      <div style={{display:"flex",gap:6}}>
        <button onClick={save} disabled={saving} style={{background:"#c2410c",border:"none",borderRadius:6,padding:"5px 14px",fontSize:".74rem",color:"#fff",cursor:saving?"wait":"pointer",fontFamily:"inherit",fontWeight:700,opacity:saving?.6:1}}>{saving?"Saving…":"Approve & Record"}</button>
        <button onClick={()=>setShowDed(false)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:6,padding:"5px 10px",fontSize:".74rem",color:"#64748b",cursor:"pointer",fontFamily:"inherit"}}>Cancel</button>
      </div>
    </div>
  );
}

// ─── AUDIT VIEW (Policy §5) ──────────────────────────────────────────────────
function AuditView({findings,addFinding,updateFinding,session,role}){
  const[showForm,setShowForm]=useState(false);
  const[form,setForm]=useState(emptyFinding());
  const[replyFor,setReplyFor]=useState(null);
  const[replyText,setReplyText]=useState("");
  const ff=(k,v)=>setForm(f=>({...f,[k]:v}));
  const canIssue=role==="Audit"||role==="Manager";
  const canManage=role==="Audit"||role==="Manager"||role==="HRAdmin";
  const open=findings.filter(f=>f.status==="Open");
  const overdue=open.filter(f=>findingOverdue(f,today));
  const submit=()=>{
    if(!form.finding.trim()){toastEmit("Describe the finding first","warning");return;}
    addFinding(form);setForm(emptyFinding());setShowForm(false);
  };
  const sendReply=(id)=>{
    if(!replyText.trim())return;
    updateFinding(id,{response:replyText.trim(),respondedAt:today,status:"Responded"});
    setReplyFor(null);setReplyText("");toastEmit("Response recorded","success");
  };
  const KPI2=({l,v,c})=>(
    <div style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
      <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:c}}>{v}</div>
      <div style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:4}}>{l}</div>
    </div>
  );
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:18,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.2rem"}}>🔎 Audit</h2>
          <div style={{fontSize:".76rem",color:"#64748b",marginTop:2}}>Findings carry a 3-day reply window (§5.2); unanswered findings are referred to HR &amp; Admin.</div>
        </div>
        {canIssue&&<button onClick={()=>setShowForm(s=>!s)} style={{background:"#dc2626",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>+ Issue Finding</button>}
      </div>

      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:16}}>
        <KPI2 l="Open" v={open.length} c="#f59e0b"/>
        <KPI2 l="Overdue (>3d)" v={overdue.length} c="#ef4444"/>
        <KPI2 l="Referred to HR" v={findings.filter(f=>f.status==="Referred to HR").length} c="#dc2626"/>
        <KPI2 l="Closed" v={findings.filter(f=>f.status==="Closed").length} c="#059669"/>
      </div>

      {showForm&&canIssue&&(
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:18,marginBottom:16}}>
          <div style={{fontWeight:800,color:"#0f172a",marginBottom:12}}>New Audit Finding</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:12}}>
            <Fld label="Area"><Sel value={form.area} onChange={e=>ff("area",e.target.value)}>{AUDIT_AREAS.map(a=><option key={a}>{a}</option>)}</Sel></Fld>
            <Fld label="Respondent"><Inp value={form.respondent} onChange={e=>ff("respondent",e.target.value)} placeholder="Person / department concerned"/></Fld>
            <Fld label="Severity"><Sel value={form.severity} onChange={e=>ff("severity",e.target.value)}>{AUDIT_SEVERITY.map(s=><option key={s}>{s}</option>)}</Sel></Fld>
            <Fld label="Date Issued"><Inp type="date" value={form.issuedAt||today} onChange={e=>ff("issuedAt",e.target.value)}/></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Finding" required><Inp value={form.finding} onChange={e=>ff("finding",e.target.value)} placeholder="What was observed, with specifics"/></Fld></div>
          </div>
          <div style={{fontSize:".72rem",color:"#64748b",margin:"8px 0"}}>Reply due: <strong>{addDaysISO(form.issuedAt||today,AUDIT_REPLY_DAYS)}</strong> (3 days from issue).</div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={submit} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:"#fff",cursor:"pointer"}}>Issue Finding</button>
            <button onClick={()=>setShowForm(false)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {/* Recurring audit calendar (§7) */}
      <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:16,marginBottom:16}}>
        <div style={{fontWeight:800,color:"#0f172a",fontSize:".92rem",marginBottom:4}}>🗓 Recurring Audit Calendar (§7)</div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:".78rem",minWidth:520}}>
            <thead><tr style={{textAlign:"left",color:"#94a3b8",fontSize:".68rem",textTransform:"uppercase",letterSpacing:".05em"}}>
              <th style={{padding:"6px 8px"}}>Area</th><th style={{padding:"6px 8px"}}>Frequency</th><th style={{padding:"6px 8px"}}>Schedule</th><th style={{padding:"6px 8px"}}>Responsible</th>
            </tr></thead>
            <tbody>
              {RECURRING_AUDITS.map((r,i)=>(
                <tr key={i} style={{borderTop:"1px solid #f1f5f9"}}>
                  <td style={{padding:"6px 8px",fontWeight:600,color:"#334155"}}>{r.area}</td>
                  <td style={{padding:"6px 8px",color:"#64748b"}}>{r.freq}</td>
                  <td style={{padding:"6px 8px",color:"#64748b"}}>{r.schedule}</td>
                  <td style={{padding:"6px 8px",color:"#64748b"}}>{r.responsible}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Findings list */}
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {findings.length===0&&<div style={{textAlign:"center",color:"#94a3b8",padding:"30px 0",fontSize:".85rem"}}>No audit findings on record.</div>}
        {findings.map(f=>{
          const od=findingOverdue(f,today);
          return(
            <div key={f.id} style={{background:"#fff",borderRadius:12,border:`1.5px solid ${od?"#fecaca":"#e2e8f0"}`,padding:"14px 16px",borderLeft:`4px solid ${AUDIT_STATUS_CLR[f.status]||"#94a3b8"}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                <div style={{flex:1,minWidth:220}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
                    <span style={{fontSize:".68rem",fontWeight:700,padding:"2px 8px",borderRadius:20,background:AUDIT_STATUS_CLR[f.status]+"22",color:AUDIT_STATUS_CLR[f.status]}}>{f.status}</span>
                    <span style={{fontSize:".68rem",fontWeight:700,padding:"2px 8px",borderRadius:20,background:AUDIT_SEVERITY_CLR[f.severity]+"22",color:AUDIT_SEVERITY_CLR[f.severity]}}>{f.severity}</span>
                    <span style={{fontSize:".72rem",color:"#64748b",fontWeight:600}}>{f.area}</span>
                    {od&&<span style={{fontSize:".68rem",fontWeight:800,color:"#dc2626"}}>⚠ OVERDUE</span>}
                  </div>
                  <div style={{fontSize:".88rem",color:"#0f172a",fontWeight:600}}>{f.finding}</div>
                  <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:3}}>Respondent: {f.respondent||"—"} · Issued {f.issuedAt||"—"} by {f.issuedBy||"—"} · Reply due {f.replyDue||"—"}</div>
                  {f.response&&<div style={{fontSize:".8rem",color:"#334155",marginTop:6,padding:"6px 10px",background:"#f8fafc",borderRadius:8}}>💬 {f.response} <span style={{color:"#94a3b8"}}>· {f.respondedAt}</span></div>}
                  {f.hrReferral&&<div style={{fontSize:".72rem",color:"#dc2626",fontWeight:700,marginTop:4}}>Referred to HR &amp; Admin{f.kpiImpact?` · KPI: ${f.kpiImpact}`:""}</div>}
                </div>
              </div>
              <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
                {f.status==="Open"&&replyFor!==f.id&&<button onClick={()=>{setReplyFor(f.id);setReplyText(f.response||"");}} style={{background:"#3b82f6",border:"none",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".74rem",color:"#fff",cursor:"pointer"}}>Respond</button>}
                {canManage&&f.status!=="Closed"&&!f.hrReferral&&<button onClick={()=>updateFinding(f.id,{status:"Referred to HR",hrReferral:true})} style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".74rem",color:"#dc2626",cursor:"pointer"}}>Refer to HR</button>}
                {canManage&&f.status!=="Closed"&&<button onClick={()=>updateFinding(f.id,{status:"Closed",resolvedAt:today})} style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".74rem",color:"#059669",cursor:"pointer"}}>Close</button>}
              </div>
              {replyFor===f.id&&(
                <div style={{marginTop:10,display:"flex",gap:8,flexWrap:"wrap"}}>
                  <input value={replyText} onChange={e=>setReplyText(e.target.value)} placeholder="Respondent's reply…" style={{flex:1,minWidth:200,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".82rem",outline:"none"}}/>
                  <button onClick={()=>sendReply(f.id)} style={{background:"#1e293b",border:"none",borderRadius:8,padding:"8px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:"#fff",cursor:"pointer"}}>Save</button>
                  <button onClick={()=>{setReplyFor(null);setReplyText("");}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// The client's PO number for a deal. A sub-project billed under a mother PO
// (parentDealId) shows its parent's number unless it has its own.
const dealClientPo=(d,deals)=>{
  if(!d) return "";
  if((d.clientPoNo||"").trim()) return d.clientPoNo.trim();
  const p=d.parentDealId&&(deals||[]).find(x=>x.id===d.parentDealId);
  return (p?.clientPoNo||"").trim();
};
// Client PO # on the Billing page. Keeps its own draft so typing is never
// trimmed or reformatted mid-word; it saves on blur / Enter only.
function ClientPoField({deal,inherited,canEdit,onSave}){
  const[draft,setDraft]=useState(deal?.clientPoNo||"");
  const[busy,setBusy]=useState(false);
  useEffect(()=>{setDraft(deal?.clientPoNo||"");},[deal?.id,deal?.clientPoNo]);
  const commit=async()=>{
    if(busy||draft.trim()===(deal?.clientPoNo||"").trim()) return;
    setBusy(true);
    const ok=await onSave(deal.id,draft);
    setBusy(false);
    if(!ok) setDraft(deal?.clientPoNo||"");
  };
  return(
    <div style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"10px 16px",marginBottom:14,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
      <span style={{fontSize:".8rem",fontWeight:800,color:"#475569"}}>📄 Client PO #</span>
      {canEdit?(
        <input value={draft} disabled={busy} maxLength={100} onChange={e=>setDraft(e.target.value)} onBlur={commit}
          onKeyDown={e=>{if(e.key==="Enter")e.currentTarget.blur();}}
          placeholder={inherited?`From mother PO: ${inherited}`:"Optional: the client's PO number, if they issued one"}
          style={{flex:"1 1 220px",minWidth:0,fontFamily:"inherit",fontSize:".82rem",padding:"6px 10px",border:"1.5px solid #cbd5e1",borderRadius:8,outline:"none",background:"#fff"}}/>
      ):(
        <span style={{fontSize:".82rem",color:(deal?.clientPoNo||inherited)?"#0f172a":"#94a3b8",fontWeight:600}}>{deal?.clientPoNo||(inherited?`${inherited} (mother PO)`:"None")}</span>
      )}
      <span style={{fontSize:".7rem",color:"#94a3b8"}}>Prints on the SOA and invoice{busy?" · saving…":""}</span>
    </div>
  );
}
function BillingView({billings,wonDeals,completedDeals,deals,addenda,addMilestone,updateMilestone,applyDeduction,deleteMilestone,deleteProjectBilling,createMilestoneSchedule,logBillingPayment,deleteBillingPayment,setConfirmDel,canDeleteDeal,session,role,cocDeals,clientProfiles,initialDeal,clearInitialDeal,initialPayMs,clearInitialPayMs,upDeals,onSaveOnboarding,onOpenPayTerms,projs,overallProg,toastEmit,sendTelegramNotification}){
  const mob=window.innerWidth<768;
  const[selDeal,  setSelDeal]  =useState(initialDeal||null);
  // A jump from elsewhere (dashboard, AR Aging list) opens that project; with
  // initialPayMs it also opens the usual Log Payment form on that invoice,
  // pre-filled with its open balance. Runs on every jump, not only on mount,
  // because the AR Aging list sits on this same page.
  React.useEffect(()=>{
    if(!initialDeal) return;
    setSelDeal(initialDeal);clearInitialDeal&&clearInitialDeal();
    if(initialPayMs){
      const ms=billings.find(b=>b.id===initialPayMs);
      if(ms&&canPayDeal(deals.find(d=>d.id===ms.dealId))&&ms.status!=="Cancelled"){
        const bal=Math.round(milestoneBalance(ms,deals.find(d=>d.id===ms.dealId))*100)/100;
        setShowPay(ms.id);setPayForm(p=>({...p,amount:bal>0?bal:""}));
      }
      clearInitialPayMs&&clearInitialPayMs();
    }
  // eslint-disable-next-line
  },[initialDeal]);
  const[showForm, setShowForm] =useState(false);
  // Tracks which deals had their schedule set up this session so the "Set Up
  // Billing Milestones" call-to-action collapses immediately after Jessica (or
  // Finance) confirms the dialogue, without waiting for the billings store to
  // round-trip. Billing schedules are NEVER auto-generated — the old useEffect
  // that silently created them for every awarded deal was removed; Jessica is
  // notified on award and sets them up deliberately via the dialogue below.
  const[showPay,  setShowPay]  =useState(null);
  const[editPay,  setEditPay]  =useState(null);     // {msId, payId} being edited
  const[editMs,   setEditMs]   =useState(null);     // milestone id being edited
  const[editMsForm,setEditMsForm]=useState({});
  const[msForm,   setMsForm]   =useState({name:"",description:"",amount:"",invoiceNo:"",invoiceDate:today,dueDate:"",status:"Draft",receiptType:null,withholding:null});
  // Gross-entry helper for the milestone amount — staff can type the VAT-inclusive
  // figure and the stored net Amount fills (amount stays net, as the SOA expects).
  const[msGrossStr,setMsGrossStr]=useState("");
  const msNetToGross=(v)=>{const x=Number(v)||0;return x?String(Math.round(x*1.12*100)/100):"";};
  const[payForm,  setPayForm]  =useState({amount:"",date:today,refNo:"",note:"",valueDate:"",bank:"",method:"Bank Transfer"});
  const[editPayForm,setEditPayForm]=useState({});
  const[billingSearch,setBillingSearch]=useState("");
  const[billingFilter,setBillingFilter]=useState("all"); // all | outstanding | overdue | collected | uncollected | paid
  // Billing Check: double-billing / integrity scan over every project (see
  // billingIntegrityIssues in core.js). Recomputed whenever billing data changes.
  const[showCheck,setShowCheck]=useState(false);
  const checkIssues=useMemo(()=>billingIntegrityIssues({deals,billings,addenda,today}),[deals,billings,addenda]);
  const[showNotBilled,setShowNotBilled]=useState(false);  // hide 0-milestone "Not billed" projects by default
  const[billRowMenu,setBillRowMenu]=useState(null);       // ⋯ row-actions menu {id,client,canDeleteSchedule,canRemoveProject,top,right}
  const[forecastRange,setForecastRange]=useState("week"); // today | week | month — collection forecast horizon

  const n =v=>Number(String(v||0).replace(/,/g,""))||0;
  const fmt=v=>"₱"+Number(v).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
  const fm =(k,v)=>setMsForm(p=>({...p,[k]:v}));
  const fp =(k,v)=>setPayForm(p=>({...p,[k]:v}));
  const fme=(k,v)=>setEditMsForm(p=>({...p,[k]:v}));
  const canEdit=role==="Manager"||role==="Finance"||role==="FinanceAssistant"||role==="SalesOpsAdmin";
  // Payments on a deal the user owns as Sales Owner are recorded by someone else
  // (their commission rides on them). Mirrors migration 20261026063330.
  const canPayDeal=d=>canEdit&&!ownsDealCommission(d,session?.name,role);
  // Client PO # — same roles as set_deal_client_po (migration
  // 20261026010000_deals_client_po_no.sql): keep them in sync.
  const canEditClientPo=["Manager","Finance","FinanceAssistant","Sales","SalesOpsAdmin"].includes(role);
  const saveClientPo=async(dealId,value)=>{
    if(!isSupabaseReady()){toastEmit&&toastEmit("Offline: the PO # can't be saved right now.","error");return false;}
    const{data,error}=await _rpcWithTimeout(supabase.rpc('set_deal_client_po',{p_deal_id:dealId,p_po:value}));
    if(error){toastEmit&&toastEmit(`PO # not saved: ${error.message}`,"error",9000);return false;}
    upDeals&&upDeals(ds=>ds.map(d=>d.id===dealId?{...d,clientPoNo:data||""}:d));
    toastEmit&&toastEmit(data?`Client PO # saved: ${data}`:"Client PO # cleared","success");
    return true;
  };
  // Share PDF for invoices and SOAs (SharePdf.jsx / billingPdf.js). Anyone on
  // this page can make one; only Finance's and Managers' copies are clean,
  // everyone else's is watermarked DRAFT (same rule as the BOQ quotation).
  const billingPdf=useSharePdf(toastEmit);
  const billingPdfDraft=!["Manager","Finance","FinanceAssistant","Accounting"].includes(role);
  const shareInvoicePdf=(ms)=>{
    const{d,tx,totalPaid,balance,cp,clientAddr}=invoiceData(ms);
    const model={
      draft:billingPdfDraft,
      docTitle:"Billing Statement",
      invoiceNo:ms.invoiceNo||"",invoiceDate:ms.invoiceDate||today,
      dueDate:ms.dueDate||ms.invoiceDate||today,overdue:!!(ms.dueDate&&ms.dueDate<today),
      terms:cp.paymentTerms||"Due on receipt",poNo:dealClientPo(d,deals),
      billTo:{name:d?.client||"—",contact:cp.contactPerson||"",address:clientAddr,email:cp.email||"",tin:cp.tin||""},
      line:{date:ms.invoiceDate||today,service:ms.name||"",tax:tx.vat>0?"12% S":"—",
        description:[d?.contact||"",d?.location?`Location: ${d.location}`:"",ms.description||""].filter(Boolean)},
      subtotal:Number(ms.amount)||0,vat:tx.vat,gross:tx.gross,ewt:tx.ewt,paid:totalPaid,balance,
    };
    billingPdf.make(async()=>{const {buildInvoicePdf}=await import("./views/billingPdf");return buildInvoicePdf(model);},
      [ms.invoiceNo,d?.client,"Billing Statement"].filter(Boolean).join(" - "),
      {draft:billingPdfDraft,draftNote:"Only Finance's or a Manager's copy is clean to send."});
  };
  const shareSoaPdf=(clientName)=>{
    const sd=soaData(clientName);
    if(!sd){toastEmit&&toastEmit("No billing data found for "+clientName,"warning");return;}
    const model={
      draft:billingPdfDraft,clientName,address:sd.soaAddr,dateStr:sd.dateStr,refNos:sd.invoiceNos,amtLbl:sd.amtLbl,
      preparedBy:sd.preparedBy,
      rows:sd.rows.map(r=>{
        const po=dealClientPo(r.d,deals);
        return{client:r.d.client||"",project:r.d.contact||r.d.product||r.d.ceNo||"—",
          ref:[r.d.ceNo&&(r.d.contact||r.d.product)?r.d.ceNo:"",po?"PO# "+po:""].filter(Boolean).join(" · "),
          vatable:r.vatable,vat:r.vat,gross:r.gross,payments:r.payments,ewt:r.ewt,due:r.due,balance:r.balance};
      }),
      totals:{vatable:sd.tV,vat:sd.tVat,gross:sd.tG,payments:sd.tP,ewt:sd.tE,due:sd.tD,balance:sd.tB},
    };
    billingPdf.make(async()=>{const {buildSoaPdf}=await import("./views/billingPdf");return buildSoaPdf(model);},
      [clientName,"Statement of Account",today].join(" - "),
      {draft:billingPdfDraft,draftNote:"Only Finance's or a Manager's copy is clean to send."});
  };
  // Look up across ALL deals, not just wonDeals — addendum child-deals live in
  // their own (often non-won) stage, so a wonDeals-only lookup returned undefined
  // and every tax calc below fell back to "OR", applying 12% VAT to AR/VAT-exempt
  // addendums. Resolving the real deal makes billing follow the deal form.
  const deal=deals.find(d=>d.id===selDeal);

  // Company-wide stats — memoized on [billings] only. These re-scan the FULL
  // billings list (every milestone × every payment) and previously recomputed
  // on every keystroke into any form on this page (msForm/payForm/search/etc
  // are all local state here, so any edit re-rendered the whole component)
  // even though the underlying billing data hadn't changed.
  const allBilled=useMemo(()=>billings.filter(m=>m.status!=="Cancelled").reduce((s,m)=>s+n(m.amount),0),[billings]);
  const allCollected=useMemo(()=>billings.reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+n(p.amount),0),0),[billings]);
  // Part of Collected that was settled without cash (offset / credit note).
  const allOffset=useMemo(()=>billings.reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced&&isOffsetPayment(p)).reduce((ps,p)=>ps+n(p.amount),0),0),[billings]);
  // Outstanding = cash receivable (VAT-incl, less EWT) minus good payments, via the
  // shared arSummary — the same figure as Daily Cash Position's Running A/R and the
  // per-project balances below. The old `amount − payments` mixed the VAT-ex base
  // with cash payments and read ~₱4.3M low.
  const allOutstanding=useMemo(()=>{
    const byId=new Map(deals.map(d=>[d.id,d]));
    return arSummary(billings,id=>byId.get(id)).outstanding;
  },[billings,deals]);
  const overdue=useMemo(()=>billings.filter(m=>isBillingOverdue(m,today)),[billings]);
  // Drafts past their due date: never sent to the client, so not "overdue" — but
  // the money is late all the same. Shown apart so Finance sends them or re-dates them.
  const unsentLate=useMemo(()=>billings.filter(m=>isBillingUnsentLate(m,today)),[billings]);

  // ── Collection Forecast — how much net cash we can expect to collect within a
  // horizon (today / next 7 days / next 30 days), driven entirely off billing
  // inputs. Each outstanding milestone contributes its NET receivable (after
  // VAT/EWT, via calcTax, using the milestone's own receipt-type/withholding or
  // the deal default) minus what's already been collected. Bucketed by dueDate;
  // overdue items are still collectible so they're included in every horizon and
  // called out separately. Milestones with no due date can't be scheduled and
  // are surfaced in a dedicated "unscheduled" figure so they aren't lost.
  const collectionForecast=useMemo(()=>{
    const now=new Date(); now.setHours(0,0,0,0);
    const t0=now.getTime(), DAY=86400000;
    const ends={today:t0, week:t0+6*DAY, month:t0+29*DAY};
    const rows=[]; let unscheduledAmt=0, unscheduledCount=0;
    billings.forEach(m=>{
      if(m.status==="Cancelled"||m.status==="Fully Paid") return;
      const dl=wonDeals.find(x=>x.id===m.dealId)||deals.find(x=>x.id===m.dealId);
      const tx=calcTax(n(m.amount),m.receiptType??dl?.receiptType??"OR",m.withholding??dl?.withholding??false);
      const paid=(m.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+n(p.amount),0);
      const out=Math.round((tx.netReceivable-paid)*100)/100;
      if(out<=0.5) return;
      const dd=m.dueDate?new Date(m.dueDate):null;
      if(!m.dueDate||isNaN(dd)){unscheduledAmt+=out;unscheduledCount++;return;}
      dd.setHours(0,0,0,0);
      rows.push({id:m.id,client:dl?.client||"Unknown",name:m.name||"Milestone",dueDate:m.dueDate,t:dd.getTime(),amount:out});
    });
    const build=end=>{
      const items=rows.filter(r=>r.t<=end).sort((a,b)=>a.t-b.t);
      const total=items.reduce((s,r)=>s+r.amount,0);
      const overdueAmt=items.filter(r=>r.t<t0).reduce((s,r)=>s+r.amount,0);
      return {total,count:items.length,overdue:overdueAmt,items};
    };
    return {today:build(ends.today),week:build(ends.week),month:build(ends.month),unscheduledAmt,unscheduledCount};
  },[billings,wonDeals,deals]);

  // Collision-free invoice number from the shared server counter (falls back to
  // local allocation offline / before the migration). Used at save time.
  const claimInv=()=>claimDocNumber("INV",billings.map(b=>b.invoiceNo||""));
  // A typed invoice number must not already be on another milestone — duplicate
  // numbers (INV-1535 on 7 projects) are what the Billing Check flags.
  const invTaken=(no,exceptId)=>{const k=String(no||"").trim().toUpperCase();return !!k&&billings.some(b=>b.id!==exceptId&&b.status!=="Cancelled"&&String(b.invoiceNo||"").trim().toUpperCase()===k);};
  const submitMS=async()=>{
    if(!msForm.name||!msForm.amount) return;
    if(!(Number(msForm.amount)>0)){toastEmit&&toastEmit("Amount must be a positive number.","error");return;}
    if(!String(msForm.dueDate||"").trim()){
      const ok=await uiConfirm({title:"No due date set",tone:"warning",confirmLabel:"Save without due date",cancelLabel:"Go back & set it",
        message:"This billing milestone has no due date, so the Cash-Flow Forecast will treat its expected collection as due now instead of scheduling it. Set a due date for an accurate projection.\n\nSave anyway?"});
      if(!ok) return;
    }
    if(invTaken(msForm.invoiceNo)){toastEmit&&toastEmit(`${String(msForm.invoiceNo).trim()} is already used on another milestone. Leave Invoice No. blank to get the next free number.`,"error",8000);return;}
    // Mother PO (standby PO umbrella): its sub-projects carry the billing, so a
    // milestone here usually re-bills one of them (Diageo CE-2026-1216).
    const msDeal=deals.find(d=>d.id===selDeal);
    if(isMotherPO(msDeal)){
      const kids=deals.filter(d=>d.parentDealId===selDeal).map(d=>d.ceNo).filter(Boolean);
      // Hard stop for non-Managers — the database refuses it too
      // (migration 20260930010000_mother_po_billing_manager_only.sql).
      if(canonRole(role)!=="Manager"){toastEmit&&toastEmit(`${msDeal.ceNo||"This project"} is a mother PO. Only a Manager can bill it — bill the sub-project instead${kids.length?` (${kids.join(", ")})`:""}.`,"error",9000);return;}
      const ok=await uiConfirm({title:"This is a mother PO",tone:"warning",confirmLabel:"Bill the mother PO anyway",cancelLabel:"Go back",
        message:`${msDeal.ceNo||"This project"} is a standby PO / Adhoc umbrella. It carries ₱0 of its own; billing belongs on its sub-projects${kids.length?` (${kids.join(", ")})`:""}.\n\nA milestone here is billed on top of those and double-counts billing and collections. Bill the sub-project instead.\n\nAdd it to the mother PO anyway?`});
      if(!ok) return;
    }
    // VAT comes from the BOQ via the deal's receipt type; a per-invoice Receipt
    // Type is the only other source. With neither, the invoice would default to OR.
    if(!["OR","AR"].includes(msForm.receiptType||msDeal?.receiptType)&&!msDeal?.standbyPO){toastEmit&&toastEmit("VAT isn't decided for this project yet — choose it in the BOQ, set Project VAT above (no BOQ), or set Receipt Type on this invoice.","error",9000);return;}
    addMilestone({...msForm,dealId:selDeal,invoiceNo:String(msForm.invoiceNo||"").trim()||await claimInv(),createdBy:session?.name||role});
    setMsForm({name:"",description:"",amount:"",invoiceNo:"",invoiceDate:today,dueDate:"",status:"Draft",receiptType:null,withholding:null});
    setMsGrossStr("");
    setShowForm(false);
  };
  // Turn the WIP under-billed figure into an invoice: bill the work completed
  // (contract × % complete) that hasn't been billed yet. Prefills the milestone
  // form so finance can review receipt type / retention before submitting.
  const progressClaim=()=>{
    if(!deal) return;
    const p=projs?.[selDeal];
    const pct=p&&overallProg?Math.max(0,Math.min(100,overallProg(p))):0;
    const contract=n(deal.value);
    if(!contract){toastEmit&&toastEmit("Set a contract value for this project first.","error");return;}
    const earned=Math.round(contract*pct/100);
    // Revenue recognised so far = invoiced amount + retention withheld (retention
    // is earned, just not yet invoiced) so a claim is never double-counted.
    const dealMs=billings.filter(b=>b.dealId===selDeal&&b.status!=="Cancelled"&&!b.isRetentionRelease);
    const recognized=dealMs.reduce((s,m)=>s+n(m.amount)+(Number(m.retentionHeld)||0),0);
    const claimable=Math.round((earned-recognized)*100)/100;
    if(claimable<=0){toastEmit&&toastEmit(`Nothing to claim — ${pct}% complete = ₱${earned.toLocaleString("en-PH")} earned, already recognised ₱${recognized.toLocaleString("en-PH")}.`,"info",7000);return;}
    const ret=Number(deal.paymentTerms?.retention)||0;
    const retHeld=Math.round(claimable*ret/100);
    const netInvoice=Math.round((claimable-retHeld)*100)/100;
    const claimNo=billings.filter(b=>b.dealId===selDeal&&/progress claim/i.test(b.name||"")).length+1;
    setMsForm({
      name:`Progress Claim #${claimNo} — ${pct}% complete`,
      description:`Work completed to ${pct}%: ₱${claimable.toLocaleString("en-PH")} earned this claim.${ret?` Retention ${ret}% (₱${retHeld.toLocaleString("en-PH")}) withheld — net invoice ₱${netInvoice.toLocaleString("en-PH")}.`:""}`,
      amount:String(netInvoice),
      retentionHeld:ret?retHeld:undefined,
      invoiceNo:"",invoiceDate:today,dueDate:"",status:"Draft",
      receiptType:deal.receiptType||null,withholding:deal.withholding??null,
    });
    setMsGrossStr((deal.receiptType||"OR")==="OR"?msNetToGross(netInvoice):"");
    setShowForm(true);
    toastEmit&&toastEmit(ret?`Claim drafted: ₱${netInvoice.toLocaleString("en-PH")} net (₱${retHeld.toLocaleString("en-PH")} retention held).`:`Claim drafted: ₱${netInvoice.toLocaleString("en-PH")} (review & save).`,"success",6500);
  };
  // Retention receivable for the selected project: withheld across claims, less
  // any already released.
  const retentionState=(()=>{
    const ms=billings.filter(b=>b.dealId===selDeal&&b.status!=="Cancelled");
    const held=ms.reduce((s,m)=>s+(Number(m.retentionHeld)||0),0);
    const released=ms.filter(m=>m.isRetentionRelease).reduce((s,m)=>s+n(m.amount),0);
    return {held,released,outstanding:Math.round((held-released)*100)/100};
  })();
  const releaseRetention=async()=>{
    if(!deal) return;
    const out=retentionState.outstanding;
    if(out<=0){toastEmit&&toastEmit("No retention outstanding to release.","info");return;}
    // Policy §3: retention is released on client satisfaction — gated on the COC.
    const cocOk=(cocDeals&&cocDeals.includes(selDeal))||projs?.[selDeal]?.cocCreated;
    if(!cocOk){toastEmit&&toastEmit("Retention can only be released after the COC is issued (§3). Complete Close-Out first.","warning",6000);return;}
    if(!(await uiConfirm(`Release retention of ₱${out.toLocaleString("en-PH")} for ${deal.client||"this project"}? This creates a Draft retention-release invoice.`))) return;
    addMilestone({name:"Retention Release",description:`Release of retention withheld across progress billings (${deal.paymentTerms?.retentionRelease||"on completion"}).`,amount:out,dealId:selDeal,isRetentionRelease:true,invoiceNo:await claimInv(),invoiceDate:today,dueDate:"",status:"Draft",receiptType:deal.receiptType||null,withholding:deal.withholding??null,createdBy:session?.name||role});
    toastEmit&&toastEmit(`Retention release drafted: ₱${out.toLocaleString("en-PH")}.`,"success",6000);
  };
  const submitPay=async()=>{
    if(!payForm.amount||!showPay) return;
    const amt=Number(payForm.amount);
    if(!isFinite(amt)||amt<=0){toastEmit("Enter a payment amount greater than zero.","warning");return;}
    // Offset / credit note: settles the invoice without cash. Manager only, with a
    // reference and a reason (trg_offset_guard enforces the same in the database).
    const isOffset=isOffsetPayment(payForm);
    if(isOffset){
      if(canonRole(role)!=="Manager"){toastEmit("Only a Manager can record an offset / credit note.","error",8000);return;}
      if(!String(payForm.refNo||"").trim()){toastEmit("Enter the credit note or agreement no. for this offset.","warning",8000);return;}
      if(!String(payForm.note||"").trim()){toastEmit("Say what was offset (e.g. which debt to the client this cancels).","warning",8000);return;}
      if(!(await uiConfirm({title:"Settle by offset — no cash",tone:"warning",confirmLabel:"Record offset",cancelLabel:"Go back",
        message:`₱${amt.toLocaleString("en-PH",{minimumFractionDigits:2})} will mark this invoice as settled without any money received. It will not count as cash or collections in Cash Flow or the collection charts.\n\nRecord it?`})))return;
    }
    const ms=billings.find(b=>b.id===showPay);
    if(ms){
      const alreadyPaid=(ms.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+Number(p.amount||0),0);
      const tx=calcTax(ms.amount, ms.receiptType??deal?.receiptType??"OR", ms.withholding??deal?.withholding??false);
      const msBalance=Math.max(0, tx.netReceivable - alreadyPaid);
      if(Number(payForm.amount)>msBalance+0.01){
        toastEmit(`Payment ₱${Number(payForm.amount).toLocaleString("en-PH")} exceeds balance of ₱${msBalance.toLocaleString("en-PH")}. Please check the amount.`,"warning");
        return;
      }
    }
    // #4 Date sanity — warn (not block) on illogical dates.
    if(payForm.date&&payForm.date>today&&!(await uiConfirm("The Date Received is in the future. Save anyway?")))return;
    if(payForm.date&&payForm.valueDate&&payForm.valueDate<payForm.date&&!(await uiConfirm("The Value Date is before the Date Received (funds credited before payment received?). Save anyway?")))return;
    // A collection on a mother PO milestone, or the same money already logged in
    // the PO family, double-counts Collected (₱842,319.50 on CE-2026-1216 + -091).
    const payDeal=ms?deals.find(d=>d.id===ms.dealId):null;
    if(isMotherPO(payDeal)&&canonRole(role)!=="Manager"){toastEmit(`${payDeal.ceNo||"This project"} is a mother PO. Only a Manager can record payments on it — record it on the sub-project that was billed.`,"error",9000);return;}
    if(isMotherPO(payDeal)&&!(await uiConfirm({title:"Payment on a mother PO",tone:"warning",confirmLabel:"Record on mother PO anyway",cancelLabel:"Go back",
      message:`${payDeal.ceNo||"This project"} is a standby PO / Adhoc umbrella. Collections belong on the sub-project that was billed, not on the mother PO.\n\nRecord this payment on the mother PO anyway?`})))return;
    const dupPays=ms?findDuplicatePayments({dealId:ms.dealId,payment:{amount:amt,date:payForm.date,refNo:payForm.refNo},billings,deals}):[];
    if(dupPays.length){
      const lines=dupPays.map(x=>`• ${x.deal?.ceNo||"No CE"} ${x.deal?.contact||x.deal?.client||""} — ${x.milestone.invoiceNo||x.milestone.name}: ₱${Number(x.payment.amount||0).toLocaleString("en-PH",{minimumFractionDigits:2})} on ${x.payment.date||"—"}${x.payment.refNo?` (Ref ${x.payment.refNo})`:""}`).join("\n");
      const ok=await uiConfirm({title:"This payment may already be recorded",tone:"warning",confirmLabel:"Record it anyway",cancelLabel:"Go back",
        message:`A payment with the same amount and date (or the same reference no.) is already logged on this PO family:\n\n${lines}\n\nRecording it again double-counts Collected. Only continue if the client really paid twice.`});
      if(!ok) return;
    }
    logBillingPayment(showPay,{...payForm,...(isOffset?{bank:"",valueDate:""}:{}),recordedBy:session?.name||role});
    setPayForm({amount:"",date:today,refNo:"",note:"",valueDate:"",bank:"",method:"Bank Transfer"});
    setShowPay(null);
  };
  const saveEditMs=async()=>{
    if(!editMs) return;
    if(invTaken(editMsForm.invoiceNo,editMs)){toastEmit&&toastEmit(`${String(editMsForm.invoiceNo).trim()} is already used on another milestone. Use a different invoice number.`,"error",8000);return;}
    // A Draft with a "Bill on" date gets its due date when it's sent — don't
    // push staff to set one now (that is what made unsent Drafts show overdue).
    if(!String(editMsForm.dueDate||"").trim()&&!(editMsForm.isDraft&&editMsForm.plannedDate)){
      const ok=await uiConfirm({title:"No due date set",tone:"warning",confirmLabel:"Save without due date",cancelLabel:"Go back & set it",
        message:"This billing milestone has no due date, so the Cash-Flow Forecast will treat its expected collection as due now instead of scheduling it. Set a due date for an accurate projection.\n\nSave anyway?"});
      if(!ok) return;
    }
    updateMilestone(editMs,{
      name:editMsForm.name,description:editMsForm.description,
      amount:Number(editMsForm.amount)||0,
      invoiceNo:editMsForm.invoiceNo,invoiceDate:editMsForm.invoiceDate,
      ...(editMsForm.isDraft?{plannedDate:editMsForm.plannedDate||""}:{}),
      dueDate:editMsForm.dueDate,
      receiptType:editMsForm.receiptType??null,
      withholding:editMsForm.withholding??null,
    });
    setEditMs(null);setEditMsForm({});
  };
  // One milestone's invoice figures — used by the print page AND the Share PDF
  // copy (billingPdf.js), so the two can't disagree.
  const invoiceData=(ms)=>{
    const d=deals.find(x=>x.id===ms.dealId);
    const tx=calcTax(ms.amount,ms.receiptType??d?.receiptType??"OR",ms.withholding??d?.withholding??false);
    const totalPaid=(ms.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+n(p.amount),0);
    const balance=Math.max(0,tx.netReceivable-totalPaid);
    const cp=(clientProfiles||{})[d?.client||""]||{};
    const clientAddr=[cp.billingAddress,cp.city,cp.province,cp.zipCode].filter(Boolean).join(", ");
    return{d,tx,totalPaid,balance,cp,clientAddr};
  };
  const printInvoice=(ms)=>{
    const{d,tx,totalPaid,balance,cp,clientAddr}=invoiceData(ms);
    const win=window.open("","_blank");
    win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Billing Statement ${ms.invoiceNo}</title>
<style>
  @page{size:A4;margin:12mm 14mm}
  *{box-sizing:border-box;margin:0;padding:0;}
  body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;font-size:11px;background:#fff;}
  /* Print button */
  .print-btn{text-align:center;padding:12px;background:#f8fafc;border-bottom:1px solid #e2e8f0;}
  .print-btn button{background:#1e293b;color:#fff;border:none;border-radius:6px;padding:8px 24px;font-size:13px;cursor:pointer;font-family:inherit;font-weight:700;}
  /* Header — matches Statement of Account template */
  .header{background:#1e293b;padding:12px 20px;display:flex;justify-content:space-between;align-items:center;}
  .co-name{font-size:22px;font-weight:900;color:#fff;letter-spacing:-.5px;}
  .sub-bar{background:#1e293b;padding:2px 20px 10px;display:flex;justify-content:space-between;border-bottom:3px solid #ea580c;}
  .tagline{color:rgba(255,255,255,.45);font-size:9.5px;}
  .wrap{padding:16px 20px 8px;}
  /* Doc title */
  .doc-title{font-size:16px;font-weight:900;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:14px;}
  /* Bill-to + meta grid */
  .meta-row{display:grid;grid-template-columns:1fr auto;gap:40px;margin-bottom:16px;border-top:1px solid #e2e8f0;border-bottom:1px solid #e2e8f0;padding:12px 0;}
  .bill-label{font-size:9px;font-weight:700;text-transform:uppercase;color:#64748b;margin-bottom:4px;letter-spacing:.5px;}
  .bill-name{font-weight:700;font-size:13px;color:#0f172a;}
  .bill-addr{font-size:11px;color:#475569;margin-top:3px;line-height:1.6;}
  .meta-table td{font-size:11px;padding:2px 0 2px 24px;vertical-align:top;}
  .meta-table .label{color:#64748b;padding-left:0;white-space:nowrap;text-transform:uppercase;font-size:9px;font-weight:700;letter-spacing:.5px;}
  .meta-table .val{font-weight:600;}
  /* Items table — navy header like SOA */
  table.items{width:100%;border-collapse:collapse;margin-bottom:0;}
  table.items thead tr{background:#1e293b;}
  table.items th{padding:8px 10px;font-size:8px;font-weight:700;text-transform:uppercase;color:rgba(255,255,255,.8);text-align:left;letter-spacing:.5px;}
  table.items th.r{text-align:right;}
  table.items td{padding:9px 10px;font-size:11px;border-bottom:1px solid #f1f5f9;vertical-align:top;}
  table.items tbody tr:nth-child(even){background:#f9fafb;}
  table.items td.r{text-align:right;white-space:nowrap;}
  table.items td.bold{font-weight:700;}
  /* Footer row: terms left, totals right */
  .footer-row{display:grid;grid-template-columns:1fr auto;gap:24px;margin-top:0;border-top:1px dashed #cbd5e1;padding-top:14px;}
  .terms{font-size:11px;color:#475569;line-height:1.7;}
  .terms strong{display:block;margin-bottom:4px;font-size:11px;color:#0f172a;}
  .totals-tbl{width:270px;}
  .totals-tbl td{font-size:11px;padding:3px 0 3px 16px;}
  .totals-tbl .label{color:#64748b;padding-left:0;}
  .totals-tbl .sep{border-top:1px dashed #cbd5e1;}
  .totals-tbl .grand-sep td{border-top:2px solid #1e293b;font-weight:900;font-size:13px;padding-top:8px;}
  .totals-tbl .grand-sep .label{color:#0f172a;text-transform:uppercase;letter-spacing:.5px;}
  /* Tax summary — navy header like SOA */
  .tax-summary{margin-top:20px;}
  .tax-summary .ts-title{font-weight:700;font-size:11px;margin-bottom:5px;text-transform:uppercase;letter-spacing:.8px;color:#0f172a;}
  table.ts{width:100%;border-collapse:collapse;}
  table.ts thead tr{background:#1e293b;}
  table.ts th{padding:6px 10px;font-size:8px;font-weight:700;text-transform:uppercase;color:rgba(255,255,255,.8);text-align:right;letter-spacing:.5px;}
  table.ts th:first-child{text-align:center;}
  table.ts td{padding:6px 10px;font-size:11px;text-align:right;border-bottom:1px solid #f1f5f9;}
  table.ts td:first-child{text-align:center;}
  /* Signature */
  .sig-row{display:grid;grid-template-columns:1fr 1fr;gap:40px;margin-top:32px;padding-top:16px;}
  .sig-block{font-size:11px;color:#64748b;}
  .sig-line{border-top:1px solid #94a3b8;margin-top:28px;padding-top:4px;}
  /* Company footer */
  .co-footer{text-align:center;margin-top:22px;padding-top:10px;border-top:1px solid #e2e8f0;font-size:9px;color:#94a3b8;line-height:1.7;}
  @media print{
    .print-btn{display:none;}
    .header,.sub-bar,table.items thead tr,table.ts thead tr{print-color-adjust:exact;-webkit-print-color-adjust:exact;}
  }
</style>
</head><body>
<div class="print-btn"><button onclick="window.print()">🖨 Print / Save as PDF</button></div>

<!-- Header -->
<div class="header">
  <div class="co-name">GMD PRODUCTIONS INC.</div>
  <div style="text-align:right">
    <span style="color:rgba(255,255,255,.6);font-size:10px">DATE: </span>
    <span style="color:#f97316;font-weight:700;font-size:12px">${ms.invoiceDate||today}</span>
  </div>
</div>
<div class="sub-bar">
  <span class="tagline">Retail Design &amp; Build | Construction | Modular Fit-outs | Signage | POP Displays</span>
  <span class="tagline">BILLING NO.: ${ms.invoiceNo||"—"}</span>
</div>

<div class="wrap">
  <!-- Document title -->
  <!-- Never "Tax Invoice": GMD issues its official BIR invoice / receipt
       separately, so this document is a billing statement only (Paulo,
       2026-10-26). Same title and note on the Share PDF (billingPdf.js). -->
  <div class="doc-title">Billing Statement</div>

  <!-- Bill-to + Invoice meta -->
  <div class="meta-row">
    <div>
      <div class="bill-label">Bill To</div>
      <div class="bill-name">${d?.client||"—"}</div>
      ${cp.contactPerson?`<div class="bill-addr">${cp.contactPerson}</div>`:""}
      ${clientAddr?`<div class="bill-addr">${clientAddr}</div>`:""}
      ${cp.email?`<div class="bill-addr">${cp.email}</div>`:""}
      ${cp.tin?`<div class="bill-addr">TIN: ${cp.tin}</div>`:""}
    </div>
    <table class="meta-table">
      <tr><td class="label">BILLING NO.</td><td class="val">${ms.invoiceNo||"—"}</td></tr>
      ${dealClientPo(d,deals)?`<tr><td class="label">PO #</td><td class="val">${String(dealClientPo(d,deals)).replace(/&/g,"&amp;").replace(/</g,"&lt;")}</td></tr>`:""}
      <tr><td class="label">DATE</td><td class="val">${ms.invoiceDate||today}</td></tr>
      <tr><td class="label">TERMS</td><td class="val">${cp.paymentTerms||"Due on receipt"}</td></tr>
      <tr><td class="label">DUE DATE</td><td class="val" style="color:${ms.dueDate&&ms.dueDate<today?"#dc2626":"inherit"}">${ms.dueDate||ms.invoiceDate||today}</td></tr>
    </table>
  </div>

  <!-- Line items -->
  <table class="items">
    <thead>
      <tr>
        <th style="width:80px">DATE</th>
        <th style="width:130px">SERVICE</th>
        <th>DESCRIPTION</th>
        <th class="r" style="width:60px">TAX</th>
        <th class="r" style="width:40px">QTY</th>
        <th class="r" style="width:100px">RATE</th>
        <th class="r" style="width:100px">AMOUNT</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>${ms.invoiceDate||today}</td>
        <td class="bold">${ms.name}</td>
        <td>${[d?.contact?`${d.contact}`:"",d?.location?`Location: ${d.location}`:"",ms.description||""].filter(Boolean).join("<br/>")}</td>
        <td class="r">${tx.vat>0?"12% S":"—"}</td>
        <td class="r">1</td>
        <td class="r">${fmt(ms.amount)}</td>
        <td class="r">${fmt(ms.amount)}</td>
      </tr>
    </tbody>
  </table>

  <!-- Footer: payment terms + totals -->
  <div class="footer-row">
    <div class="terms">
      <strong>We require the ff payment terms:</strong>
      1) 50% DP to start project<br/>
      2) Billing of 40% up until installation<br/>
      3) Retention of 10% upon certificate of completion<br/><br/>
      <strong>Account Name: GMD PRODUCTIONS INC</strong>
      BDO CHECKING — 012758000370<br/>
      BPI CHECKING — 6011 04 82 03<br/>
      METROBANK — 382-7-38202059-2
    </div>
    <table class="totals-tbl">
      <tr><td class="label">SUBTOTAL</td><td style="text-align:right">${fmt(ms.amount)}</td></tr>
      <tr><td class="label sep">TAX</td><td style="text-align:right" class="sep">${fmt(tx.vat)}</td></tr>
      <tr><td class="label">TOTAL</td><td style="text-align:right">${fmt(tx.gross)}</td></tr>
      ${tx.ewt>0?`<tr><td class="label" style="color:#dc2626">Less: EWT</td><td style="text-align:right;color:#dc2626">(${fmt(tx.ewt)})</td></tr>`:""}
      ${totalPaid>0?`<tr><td class="label" style="color:#2563eb">AMOUNT PAID</td><td style="text-align:right;color:#2563eb">(${fmt(totalPaid)})</td></tr>`:""}
      <tr class="grand-sep">
        <td class="label">BALANCE DUE</td>
        <td style="text-align:right;color:${balance>0?"#ea580c":"#059669"}">PHP ${balance>0?Number(balance).toLocaleString("en-PH",{minimumFractionDigits:2}):"0.00"}</td>
      </tr>
    </table>
  </div>

  <!-- Tax summary -->
  ${tx.vat>0?`
  <div class="tax-summary">
    <div class="ts-title">Tax Summary</div>
    <table class="ts">
      <thead><tr><th>RATE</th><th>TAX</th><th>NET</th></tr></thead>
      <tbody><tr><td>VAT @ 12%</td><td>${fmt(tx.vat)}</td><td>${fmt(ms.amount)}</td></tr></tbody>
    </table>
  </div>`:""}

  <!-- Signature -->
  <div class="sig-row">
    <div class="sig-block">
      <div class="sig-line">Accepted By</div>
    </div>
    <div class="sig-block">
      <div class="sig-line">Accepted Date</div>
    </div>
  </div>

  <!-- Company footer -->
  <div style="text-align:center;margin-top:18px;font-size:10px;font-weight:700;color:#475569">This is a billing statement, not an official receipt or BIR invoice. The official invoice is issued separately.</div>
  <div class="co-footer">
    GMD PRODUCTIONS INC &nbsp;·&nbsp; 32 Santan Unit H Brgy Fortune, Marikina, NCR 1802 PH &nbsp;·&nbsp; TIN 010-063-229-000<br/>
    +63 9189338436 &nbsp;·&nbsp; sales@gmd.ph &nbsp;·&nbsp; www.gmd.ph
  </div>

  <div style="text-align:center;margin-top:10px;font-size:9px;color:#cbd5e1">Page 1 of 1</div>
</div>
</body></html>`);
    win.document.close();addPrintClose(win);
  };

  // One client's SOA figures — used by the print page AND the Share PDF copy
  // (billingPdf.js), so the two can't disagree. null = nothing billed yet.
  const soaData=(clientName)=>{
    const clientDeals=[...wonDeals,...(completedDeals||[]),...deals.filter(d=>d.parentDealId&&new Set([...wonDeals,...(completedDeals||[])].map(x=>x.id)).has(d.parentDealId))].filter((d,i,a)=>a.findIndex(x=>x.id===d.id)===i).filter(d=>clientKey(d.client)===clientKey(clientName));
    const rows=clientDeals.map(d=>{
      const ms=billings.filter(b=>b.dealId===d.id);
      const rt=d.receiptType||"OR",wh=d.withholding||false;
      const active=ms.filter(m=>m.status!=="Cancelled");
      const vatable=active.reduce((s,m)=>s+calcTax(m.amount,m.receiptType??rt,m.withholding??wh).base,0);
      const vat=active.reduce((s,m)=>s+calcTax(m.amount,m.receiptType??rt,m.withholding??wh).vat,0);
      const gross=vatable+vat;
      // Bounced payments never reached GMD: leave them out, like the invoice
      // and every other paid total do. Counting them understated the balance.
      const payments=ms.reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+Number(p.amount||0),0),0);
      const ewt=active.reduce((s,m)=>s+calcTax(m.amount,m.receiptType??rt,m.withholding??wh).ewt,0);
      const due=Math.max(0,gross-payments-ewt);
      const balance=Math.max(0,gross-payments);
      return{d,vatable,vat,gross,payments,ewt,due,balance};
    }).filter(r=>r.vatable>0||r.payments>0);
    if(!rows.length) return null;
    const tV=rows.reduce((s,r)=>s+r.vatable,0),tVat=rows.reduce((s,r)=>s+r.vat,0);
    const tG=rows.reduce((s,r)=>s+r.gross,0),tP=rows.reduce((s,r)=>s+r.payments,0);
    const tE=rows.reduce((s,r)=>s+r.ewt,0),tD=rows.reduce((s,r)=>s+r.due,0);
    const tB=rows.reduce((s,r)=>s+r.balance,0);
    const dateStr=new Date().toLocaleDateString("en-US",{month:"numeric",day:"numeric",year:"numeric"});
    const preparedBy=session?.name||"";
    // Billing address from the client's profile (Clients → Profile), the same
    // source the invoice uses. It used to print blank for every client.
    const cpSoa=(clientProfiles||{})[clientName]||(clientProfiles||{})[clientDeals[0]?.client||""]||{};
    const soaAddr=[cpSoa.billingAddress,cpSoa.city,cpSoa.province,cpSoa.zipCode].filter(Boolean).join(", ");
    // AR (no VAT) projects have no "vatable" amount; don't label them as such.
    const amtLbl=tVat>0?"VATABLE AMOUNT":"AMOUNT (NO VAT)";
    const invoiceNos=[...new Set(billings.filter(b=>clientDeals.some(d=>d.id===b.dealId)&&b.invoiceNo&&b.status!=="Cancelled").map(b=>b.invoiceNo))].join(", ");
    return{clientDeals,rows,tV,tVat,tG,tP,tE,tD,tB,dateStr,preparedBy,cpSoa,soaAddr,amtLbl,invoiceNos};
  };
  const printSOA=(clientName)=>{
    const esc=(s)=>String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    const f=(v)=>Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
    const sd=soaData(clientName);
    if(!sd){alert("No billing data found for "+clientName);return;}
    const{rows,tV,tVat,tG,tP,tE,tD,tB,dateStr,preparedBy,soaAddr,amtLbl,invoiceNos}=sd;
    const rowsHtml=rows.map((r,i)=>`<tr>
      <td style="text-align:center;color:#64748b">${i+1}</td>
      <td style="color:#2563eb;font-weight:600">${esc(r.d.client)}</td>
      <td style="text-align:left"><div style="color:#2563eb;font-weight:600">${esc(r.d.contact||r.d.product||r.d.ceNo||"—")}</div>${(()=>{const po=dealClientPo(r.d,deals);const ref=[r.d.ceNo&&(r.d.contact||r.d.product)?r.d.ceNo:"",po?"PO# "+po:""].filter(Boolean).join(" · ");return ref?`<div style="color:#64748b;font-size:8.5px;margin-top:1px">${esc(ref)}</div>`:"";})()}</td>
      <td style="text-align:right">${f(r.vatable)}</td>
      <td style="text-align:right">${f(r.vat)}</td>
      <td style="text-align:right">${f(r.gross)}</td>
      <td style="text-align:right;color:#2563eb">${f(r.payments)}</td>
      <td style="text-align:right">${f(r.ewt)}</td>
      <td style="text-align:right;color:#ea580c;font-weight:700">${f(r.due)}</td>
      <td style="text-align:right;font-weight:700">${f(r.balance)}</td>
    </tr>`).join("");
    const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>SOA — ${esc(clientName)}</title><style>
      @page{size:A4 landscape;margin:12mm 15mm}
      *{box-sizing:border-box;margin:0;padding:0;print-color-adjust:exact;-webkit-print-color-adjust:exact}
      body{font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#0f172a;background:#fff;padding:0}
      .print-btn{text-align:center;padding:12px;background:#f8fafc;border-bottom:1px solid #e2e8f0}
      .print-btn button{background:#1e293b;color:#fff;border:none;border-radius:6px;padding:8px 24px;font-size:13px;cursor:pointer;font-family:inherit}
      @media print{.print-btn{display:none}}
      .header{background:#1e293b;padding:12px 20px;display:flex;justify-content:space-between;align-items:center}
      .co-name{font-size:22px;font-weight:900;color:#fff;letter-spacing:-.5px}
      .sub-bar{background:#1e293b;padding:2px 20px 10px;display:flex;justify-content:space-between;border-bottom:3px solid #ea580c}
      .tagline{color:rgba(255,255,255,.45);font-size:9.5px}
      .soa-wrap{padding:12px 20px 8px}
      .soa-title{font-size:15px;font-weight:900;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:14px}
      .client-grid{display:grid;grid-template-columns:auto 1fr 40px auto 1fr;gap:6px 10px;align-items:end;margin-bottom:16px}
      .cl{font-size:9px;font-weight:700;color:#64748b;text-transform:uppercase;white-space:nowrap}
      .cv{border-bottom:1.5px solid #0f172a;padding-bottom:2px;font-weight:600;font-size:11px;color:#1e40af}
      .summary{display:grid;grid-template-columns:repeat(5,1fr);border:1.5px solid #e2e8f0;margin-bottom:16px}
      .sb{padding:10px 14px;background:#f8fafc;border-right:1px solid #e2e8f0;text-align:center}
      .sb:last-child{border-right:none;background:#fff7ed}
      .sl{font-size:8px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.7px;margin-bottom:5px}
      .sv{font-size:16px;font-weight:800;color:#0f172a}
      .sb:last-child .sv{color:#ea580c}
      table{width:100%;border-collapse:collapse;margin:0 0 14px;font-size:10px}
      thead tr{background:#1e293b}
      thead th{color:rgba(255,255,255,.8);font-size:8px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;padding:8px 10px;text-align:left}
      thead th:nth-child(n+4){text-align:right}
      tbody tr:nth-child(even){background:#f9fafb}
      tbody td{padding:8px 10px;border-bottom:1px solid #f1f5f9}
      tbody td:nth-child(n+4){text-align:right}
      tfoot tr{background:#1e293b}
      tfoot td{color:#fff;font-weight:700;padding:9px 10px;font-size:10px;text-align:right}
      tfoot td:nth-child(1),tfoot td:nth-child(2){text-align:center;color:rgba(255,255,255,.7);font-size:9px;font-weight:400}
      .total-due{color:#f97316!important;font-size:13px!important;font-weight:900!important}
      .notes{border:1px solid #e2e8f0;border-radius:6px;padding:10px 14px;margin-bottom:14px;font-size:9px;color:#475569}
      .notes b{color:#0f172a;font-size:9px}
      .notes .nt{font-weight:700;font-size:10px;color:#0f172a;margin-bottom:6px}
      .sig{display:grid;grid-template-columns:1fr 1fr;gap:40px;padding:10px 0}
      .sl2{font-size:9px;color:#64748b;margin-bottom:18px}
      .sn{font-size:11px;font-weight:700}
      .sc{font-size:9px;color:#64748b}
    </style></head><body>
    <div class="print-btn"><button onclick="window.print()">🖨 Print / Save as PDF</button></div>
    <div class="header">
      <div class="co-name">GMD PRODUCTIONS INC.</div>
      <div style="text-align:right">
        <span style="color:rgba(255,255,255,.6);font-size:10px">DATE: </span>
        <span style="color:#f97316;font-weight:700;font-size:12px">${dateStr}</span>
      </div>
    </div>
    <div class="sub-bar">
      <span class="tagline">Retail Design &amp; Build | Construction | Modular Fit-outs | Signage | POP Displays</span>
      <span class="tagline">REF NO.: ${esc(invoiceNos)||"—"}</span>
    </div>
    <div class="soa-wrap">
      <div class="soa-title">Statement of Account</div>
      <div class="client-grid">
        <span class="cl">CLIENT NAME:</span>
        <span class="cv">${esc(clientName)}</span>
        <span></span>
        <span class="cl">BILLING ADDRESS:</span>
        <span class="cv">${soaAddr?esc(soaAddr):"&nbsp;"}</span>
      </div>
      <div class="summary">
        <div class="sb"><div class="sl">TOTAL ${amtLbl}</div><div class="sv">${f(tV)}</div></div>
        <div class="sb"><div class="sl">TOTAL VAT</div><div class="sv">${f(tVat)}</div></div>
        <div class="sb"><div class="sl">TOTAL PAYMENTS MADE</div><div class="sv">${f(tP)}</div></div>
        <div class="sb"><div class="sl">TOTAL BALANCE</div><div class="sv">${f(tB)}</div></div>
        <div class="sb"><div class="sl">TOTAL AMOUNT DUE</div><div class="sv">${f(tD)}</div></div>
      </div>
      <table>
        <thead><tr>
          <th style="width:30px;text-align:center">#</th>
          <th>CLIENT NAME</th><th>PROJECT NAME</th>
          <th>${amtLbl}</th><th>VAT</th><th>SALES AMOUNT</th>
          <th>PAYMENT MADE</th><th>WHT</th><th>TOTAL AMOUNT DUE</th><th>BALANCE</th>
        </tr></thead>
        <tbody>${rowsHtml}</tbody>
        <tfoot><tr>
          <td></td><td colspan="2">TOTAL AMOUNT DUE</td>
          <td>${f(tV)}</td><td>${f(tVat)}</td><td>${f(tG)}</td>
          <td>${f(tP)}</td><td>${f(tE)}</td>
          <td class="total-due">${f(tD)}</td><td>${f(tB)}</td>
        </tr></tfoot>
      </table>
      <div class="notes">
        <div class="nt">NOTES</div>
        <p style="margin-bottom:6px">Thank you for your business! Please send or email (<b>finance@gmd.ph</b>) us a copy of the payment for proper recording.</p>
        <p style="margin-top:8px;font-weight:700">Payment Details:</p>
        <p style="margin-top:4px"><b>Account Name:</b>&nbsp; GMD PRODUCTIONS INC</p>
        <p style="margin-top:3px"><b>BDO CHECKING</b>&nbsp;—&nbsp;012758000370</p>
        <p style="margin-top:3px"><b>BPI CHECKING</b>&nbsp;—&nbsp;6011 04 82 03</p>
        <p style="margin-top:3px"><b>METROBANK</b>&nbsp;—&nbsp;382-7-38202059-2</p>
      </div>
      <div class="sig">
        <div><div class="sl2">Prepared by:</div><div class="sn">${esc(preparedBy)||"&nbsp;"}</div><div class="sc">GMD Productions Inc.</div></div>
        <div><div class="sl2">Approved by:</div><div class="sn">Paulo Garcia</div><div class="sc">GMD Productions Inc.</div></div>
      </div>
    </div>
    </body></html>`;
    const w=window.open("","_blank","width=1100,height=780");
    if(!w){toastEmit&&toastEmit("Popup blocked — please allow popups for this site","warning");return;}
    w.document.write(html);
    w.document.close();addPrintClose(w);
    setTimeout(()=>w.print(),600);
  };

  // Per-project summary for list — includes addendum child deals
  const _baseDeals=wonDeals;
  const _baseIds=new Set(_baseDeals.map(d=>d.id));
  // Pending addendums are awaiting client approval — they must NOT surface as
  // billable line items (nothing to bill until the client signs off). Only
  // approved addendums appear in billing; on approval they flow in automatically.
  const _addendumDeals=deals.filter(d=>d.parentDealId&&_baseIds.has(d.parentDealId)&&!_baseIds.has(d.id)&&d.addendumStatus!=="Pending");
  const _allSummaries=[..._baseDeals,..._addendumDeals].map(d=>{
    const ms=billings.filter(b=>b.dealId===d.id);
    const active=ms.filter(m=>m.status!=="Cancelled");
    // Per-milestone VAT breakdown via calcTax: `amount` is the VAT-exclusive base
    // (Gross), 12% output VAT is added on top (OR only), Total is the VAT-inclusive
    // amount billed to the client, and netReceivable is the cash owed after any EWT
    // withheld. Balance is measured against netReceivable so it reaches zero when a
    // milestone is fully paid (mirrors the Fully Paid rule in logBillingPayment).
    const tot=active.reduce((a,m)=>{
      const tx=calcTax(n(m.amount),m.receiptType??m.receipt_type??d.receiptType??"OR",m.withholding??d.withholding??false);
      a.gross+=tx.base; a.vat+=tx.vat; a.total+=tx.gross; a.collectible+=tx.netReceivable;
      return a;
    },{gross:0,vat:0,total:0,collectible:0});
    const grossBase=tot.gross, vat=tot.vat, total=tot.total, collectible=tot.collectible;
    const collected=ms.reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+n(p.amount),0),0);
    const balance  =Math.max(0,collectible-collected);
    const hasOverdue=ms.some(m=>isBillingOverdue(m,today));
    const hasUnsent=ms.some(m=>isBillingUnsentLate(m,today));
    const fullyPaid=total>0&&balance===0;
    const toBill=ms.filter(m=>m.status==="Draft"&&m.plannedDate&&m.plannedDate<today).length;
    return{d,ms,grossBase,vat,total,collected,collectible,balance,hasOverdue,hasUnsent,fullyPaid,toBill,milestoneCount:ms.length};
  });
  // Count of awarded projects with no billing set up yet — hidden by default.
  const notBilledCount=_allSummaries.filter(s=>s.milestoneCount===0).length;
  const projectSummaries=_allSummaries.filter(({d,total,collected,balance,hasOverdue,hasUnsent,fullyPaid,milestoneCount})=>{
    const q=billingSearch.toLowerCase();
    const matchSearch=!q||(d.client||"").toLowerCase().includes(q)||(d.ceNo||"").toLowerCase().includes(q)||(d.contact||"").toLowerCase().includes(q);
    const matchFilter=billingFilter==="all"||(billingFilter==="outstanding"&&balance>0&&!fullyPaid)||(billingFilter==="paid"&&fullyPaid)||(billingFilter==="overdue"&&hasOverdue)||(billingFilter==="unsent"&&hasUnsent)||(billingFilter==="collected"&&collected>0)||(billingFilter==="uncollected"&&total>0&&collected===0);
    // Hide "Not billed" (0-milestone) projects unless the toggle is on or the user is searching.
    const matchNotBilled=milestoneCount>0||showNotBilled||!!q;
    return matchSearch&&matchFilter&&matchNotBilled;
  });
  // Group each approved addendum directly under its main project, followed by a
  // subtotal for the whole contract. A group shows when the main project OR any
  // of its addenda matches the search/filter, and then always shows complete,
  // so an addendum never appears on its own at the bottom of the list.
  const _matchIds=new Set(projectSummaries.map(x=>x.d.id));
  const _kidsOf=new Map();
  _allSummaries.forEach(x=>{if(x.d.parentDealId&&_baseIds.has(x.d.parentDealId)){if(!_kidsOf.has(x.d.parentDealId))_kidsOf.set(x.d.parentDealId,[]);_kidsOf.get(x.d.parentDealId).push(x);}});
  const billingRows=[];
  _allSummaries.filter(x=>!(x.d.parentDealId&&_baseIds.has(x.d.parentDealId))).forEach(parent=>{
    const kids=(_kidsOf.get(parent.d.id)||[]).filter(k=>k.milestoneCount>0||showNotBilled||_matchIds.has(k.d.id));
    if(!_matchIds.has(parent.d.id)&&!kids.some(k=>_matchIds.has(k.d.id))) return;
    const groupOverdue=parent.hasOverdue||kids.some(k=>k.hasOverdue);
    billingRows.push({...parent,groupOverdue,addendumCount:kids.length});
    kids.forEach(k=>billingRows.push({...k,groupOverdue:k.hasOverdue,childOf:parent.d}));
    if(kids.length){
      const all=[parent,...kids];
      const sum=f=>Math.round(all.reduce((t,x)=>t+(Number(x[f])||0),0)*100)/100;
      billingRows.push({subtotalOf:parent.d,addendumCount:kids.length,grossBase:sum("grossBase"),vat:sum("vat"),total:sum("total"),collected:sum("collected"),balance:sum("balance"),contract:Math.round((Number(parent.d.value)||0)+kids.filter(k=>isApprovedAddendumDeal(k.d)).reduce((t,x)=>t+(Number(x.d.value)||0),0)*100)/100});
    }
  });
  // Shared grid template for the billing list header + rows:
  // Project | Gross | VAT | Total | Paid | Balance | Status | Actions
  const BILL_COLS="2fr 1fr 0.85fr 1.05fr 1fr 1fr 90px 170px";
  const BILL_MINW=940;

  // CSV Export function
  const exportBillingCSV=()=>{
    const rows=[["Project","CE No","Milestone","Amount","Status","Due Date","Invoice No","Receipt Type","Payments Made","Total Paid","Outstanding","Bank"]];
    billings.forEach(b=>{
      const d=wonDeals.find(x=>x.id===b.dealId)||deals.find(x=>x.id===b.dealId);
      const totalPaid=(b.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);
      const outstanding=milestoneBalance(b,d);
      const paymentsSummary=(b.payments||[]).map(p=>`${p.date||""}:₱${Number(p.amount||0).toLocaleString()}`).join(" | ");
      const banks=[...new Set((b.payments||[]).map(p=>p.bank).filter(Boolean))].join("/");
      rows.push([
        d?.client||"",d?.ceNo||"",b.name||"",
        Number(b.amount||0).toFixed(2),b.status||"Unpaid",
        b.dueDate||"",b.invoiceNo||"",b.receiptType||"",
        paymentsSummary,totalPaid.toFixed(2),outstanding.toFixed(2),banks
      ]);
    });
    const csv=rows.map(r=>r.map(v=>(`"${String(v).replace(/"/g,'""')}"`)).join(",")).join("\n");
    const a=document.createElement("a");
    a.href="data:text/csv;charset=utf-8,"+encodeURIComponent("\uFEFF"+csv);
    a.download=`GMD_Billing_${today}.csv`;
    a.click();
  };


  return(
    <div>
      {billingPdf.dialog}
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>Billing</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Click any project to manage milestones and log payments</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {(()=>{const hi=checkIssues.filter(x=>x.severity==="high").length;const clr=hi?{bg:"#fef2f2",bd:"#fecaca",tx:"#b91c1c"}:checkIssues.length?{bg:"#fffbeb",bd:"#fde68a",tx:"#92400e"}:{bg:"#ecfdf5",bd:"#a7f3d0",tx:"#047857"};return(
            <button onClick={()=>setShowCheck(v=>!v)} aria-expanded={showCheck}
              style={{background:clr.bg,border:`1.5px solid ${clr.bd}`,borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,color:clr.tx,cursor:"pointer"}}>
              🔍 Billing Check{checkIssues.length?` · ${checkIssues.length} issue${checkIssues.length===1?"":"s"}`:" · all clear"}
            </button>
          );})()}
          <button onClick={exportBillingCSV}
            style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".78rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer"}}>
            ⬇ Export Billing CSV
          </button>
        </div>
      </div>

      {/* Billing Check panel */}
      {showCheck&&(
        <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",gap:10,flexWrap:"wrap",alignItems:"baseline",marginBottom:10}}>
            <div style={{fontWeight:800,fontSize:".9rem",color:"#0f172a"}}>Billing Check</div>
            <div style={{fontSize:".7rem",color:"#94a3b8"}}>Billed over contract · no contract value · Drafts past their bill-on date · duplicate invoice numbers · duplicate milestones · change orders billed twice · sub-centavo amounts</div>
          </div>
          {checkIssues.length===0?(
            <div style={{fontSize:".8rem",color:"#047857",fontWeight:600}}>✓ No double billing or numbering problems found across {new Set(billings.map(b=>b.dealId)).size} projects.</div>
          ):(
            <div style={{display:"grid",gap:6,maxHeight:360,overflowY:"auto"}}>
              {checkIssues.map((x,k)=>{
                const KIND={tobill:"Not yet billed",over:"Over contract",novalue:"No contract value",dupinv:"Duplicate invoice no.",dupms:"Duplicate milestone",coDouble:"Change order",centavo:"Centavo rounding"};
                const hi=x.severity==="high";
                return(
                  <div key={k} style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",border:`1px solid ${hi?"#fecaca":"#e2e8f0"}`,background:hi?"#fef2f2":"#f8fafc",borderRadius:9,padding:"8px 12px"}}>
                    <span style={{fontSize:".62rem",fontWeight:800,textTransform:"uppercase",letterSpacing:".05em",color:hi?"#b91c1c":"#64748b",minWidth:130}}>{KIND[x.kind]||x.kind}</span>
                    <span style={{flex:1,minWidth:220,fontSize:".78rem",color:"#0f172a"}}>
                      {x.deal&&x.kind!=="dupinv"&&<b>{x.deal.ceNo||"No CE"} · {x.deal.client}{x.deal.contact?` — ${x.deal.contact}`:""}: </b>}
                      {x.msg}
                    </span>
                    {x.kind==="dupinv"?(
                      <span style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                        {[...new Set(x.milestones.map(m=>m.dealId))].map(id=>{const dd=deals.find(z=>z.id===id);return <button key={id} onClick={()=>{setSelDeal(id);setShowCheck(false);}} style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:6,padding:"3px 8px",fontFamily:"inherit",fontSize:".7rem",fontWeight:700,color:"#1d4ed8",cursor:"pointer"}}>{dd?.ceNo||"Open"}</button>;})}
                      </span>
                    ):x.deal&&(
                      <button onClick={()=>{setSelDeal(x.deal.id);setShowCheck(false);}} style={{background:"#1e293b",border:"none",borderRadius:6,padding:"4px 10px",fontFamily:"inherit",fontSize:".72rem",fontWeight:700,color:"#fff",cursor:"pointer"}}>Open →</button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
          <div style={{fontSize:".68rem",color:"#94a3b8",marginTop:10}}>Nothing here is changed automatically. Check what the client actually received before cancelling or re-numbering an invoice.</div>
        </div>
      )}

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:16}}>
        {[
          {l:"Total Billed (VAT-ex)",v:fmt(allBilled),             c:"#3b82f6"},
          {l:"Total Collected",   v:fmt(allCollected),             c:"#059669", note:allOffset>0?`incl. ${fmt(allOffset)} by offset (no cash)`:""},
          {l:"Outstanding",       v:fmt(allOutstanding), c:allOutstanding>0?"#ef4444":"#059669", filter:"outstanding", hint:"View all clients with a balance →"},
          {l:"Overdue Invoices",  v:overdue.length,                c:overdue.length>0?"#ef4444":"#94a3b8", filter:"overdue", hint:"View overdue invoices →"},
          {l:"Not Yet Sent",      v:unsentLate.length,             c:unsentLate.length>0?"#d97706":"#94a3b8", filter:"unsent", hint:unsentLate.length>0?"Drafts past due — send or re-date →":"No late drafts"},
        ].map(({l,v,c,filter,hint,note})=>{
          const isLink=!!filter;
          return(
          <div key={l}
            {...(isLink?clickable(()=>{setBillingFilter(filter);const el=document.getElementById("billing-list-top");if(el)el.scrollIntoView({behavior:"smooth",block:"start"});}):{})}
            aria-label={isLink?hint:undefined}
            title={isLink?hint:undefined}
            style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:`1.5px solid ${isLink&&billingFilter===filter?c:"#e2e8f0"}`,cursor:isLink?"pointer":"default",transition:"border-color .1s,box-shadow .1s"}}
            onMouseEnter={isLink?e=>{e.currentTarget.style.borderColor=c;e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,.06)";}:undefined}
            onMouseLeave={isLink?e=>{e.currentTarget.style.borderColor=billingFilter===filter?c:"#e2e8f0";e.currentTarget.style.boxShadow="none";}:undefined}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
            {isLink&&<div style={{fontSize:".6rem",color:c,marginTop:4,fontWeight:600,opacity:.85}}>{hint}</div>}
            {note&&<div style={{fontSize:".6rem",color:"#7c3aed",marginTop:4,fontWeight:600}}>{note}</div>}
          </div>
          );
        })}
      </div>

      {/* ── Collection Forecast — expected net collections by due date ──── */}
      {(allOutstanding>0||collectionForecast.unscheduledCount>0)&&(()=>{
        const cur=collectionForecast[forecastRange];
        const tabs=[["today","Due Today"],["week","This Week"],["month","This Month"]];
        const rangeNote={today:"due on or before today",week:"due within the next 7 days",month:"due within the next 30 days"}[forecastRange];
        const shown=cur.items.slice(0,5);
        return(
          <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:"16px 18px",marginBottom:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,marginBottom:12}}>
              <div>
                <div style={{fontWeight:800,color:"#0f172a",fontSize:".95rem"}}>📥 Collection Forecast</div>
                <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:2}}>Expected net cash (after VAT/EWT) from outstanding invoices, by due date</div>
              </div>
              <div style={{display:"flex",gap:6}}>
                {tabs.map(([v,l])=>(
                  <button key={v} onClick={()=>setForecastRange(v)}
                    style={{padding:"7px 13px",borderRadius:20,border:`1.5px solid ${forecastRange===v?"#f97316":"#e2e8f0"}`,background:forecastRange===v?"#fff7ed":"#fff",color:forecastRange===v?"#c2410c":"#64748b",fontFamily:"inherit",fontSize:".75rem",fontWeight:forecastRange===v?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>
                    {l}
                  </button>
                ))}
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"minmax(0,240px) 1fr",gap:16,alignItems:"start"}}>
              <div style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:12,padding:"14px 16px"}}>
                <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:"1.9rem",color:"#059669",lineHeight:1.1}}>{fmt(cur.total)}</div>
                <div style={{fontSize:".68rem",color:"#059669",fontWeight:700,marginTop:3}}>{cur.count} invoice{cur.count!==1?"s":""} {rangeNote}</div>
                {cur.overdue>0&&<div style={{fontSize:".7rem",color:"#dc2626",fontWeight:600,marginTop:6}}>Includes {fmt(cur.overdue)} already overdue</div>}
                {collectionForecast.unscheduledCount>0&&<div style={{fontSize:".68rem",color:"#b45309",fontWeight:600,marginTop:6}}>⚠ {fmt(collectionForecast.unscheduledAmt)} on {collectionForecast.unscheduledCount} invoice{collectionForecast.unscheduledCount!==1?"s":""} with no due date — set one to forecast it</div>}
              </div>
              <div>
                {shown.length===0?(
                  <div style={{color:"#94a3b8",fontSize:".82rem",padding:"8px 0"}}>Nothing due in this window.</div>
                ):shown.map((r,i)=>{
                  const od=r.dueDate<today;
                  return(
                    <div key={r.id} style={{display:"grid",gridTemplateColumns:"1fr auto auto",gap:10,padding:"6px 0",borderBottom:i<shown.length-1?"1px solid #f1f5f9":"none",alignItems:"center"}}>
                      <div style={{minWidth:0}}>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.client}</div>
                        <div style={{fontSize:".7rem",color:"#94a3b8",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.name}</div>
                      </div>
                      <div style={{fontSize:".7rem",color:od?"#dc2626":"#64748b",fontWeight:od?700:500,whiteSpace:"nowrap"}}>{od?"⚠ ":""}{r.dueDate}</div>
                      <div style={{fontWeight:700,color:"#059669",fontSize:".82rem",whiteSpace:"nowrap",fontVariantNumeric:"tabular-nums"}}>{fmt(r.amount)}</div>
                    </div>
                  );
                })}
                {cur.items.length>5&&<div style={{fontSize:".7rem",color:"#94a3b8",marginTop:6}}>+{cur.items.length-5} more invoice{cur.items.length-5!==1?"s":""}</div>}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Overdue alert + Aging Summary */}
      {overdue.length>0&&(()=>{
        const today2=new Date();
        const age=ms=>{const d=new Date(ms.dueDate);return Math.floor((today2-d)/(1000*60*60*24));};
        const d30 =overdue.filter(m=>age(m)<=30);
        const d60 =overdue.filter(m=>age(m)>30&&age(m)<=60);
        const d90 =overdue.filter(m=>age(m)>60&&age(m)<=90);
        const d90p=overdue.filter(m=>age(m)>90);
        return(
          <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:12,padding:"14px 18px",marginBottom:12}}>
            <div style={{fontWeight:700,color:"#dc2626",marginBottom:10,fontSize:".88rem"}}>🚨 Overdue Invoice Aging Summary</div>
            <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:10}}>
              {[[d30,"1–30 days","#f59e0b","#fffbeb"],[d60,"31–60 days","#f97316","#fff7ed"],[d90,"61–90 days","#ef4444","#fef2f2"],[d90p,"90+ days","#dc2626","#fef2f2"]].map(([grp,lbl,clr,bg])=>(
                <div key={lbl} style={{background:bg,borderRadius:8,padding:"10px 12px",textAlign:"center",border:`1px solid ${clr}33`}}>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.4rem",color:clr}}>{grp.length}</div>
                  <div style={{fontSize:".65rem",textTransform:"uppercase",letterSpacing:"1px",color:clr,marginTop:3}}>{lbl}</div>
                  <div style={{fontSize:".72rem",color:clr,fontWeight:600,marginTop:2}}>
                    ₱{grp.reduce((s,m)=>{const p=(m.payments||[]).reduce((ps,p)=>ps+n(p.amount),0);const md=deals.find(x=>x.id===m.dealId);return s+Math.max(0,calcTax(m.amount,m.receiptType??md?.receiptType??"OR",m.withholding??md?.withholding??false).netReceivable-p);},0).toLocaleString("en-PH",{minimumFractionDigits:0})}
                  </div>
                </div>
              ))}
            </div>
            <div style={{fontSize:".78rem",color:"#dc2626"}}>
              {overdue.slice(0,4).map(m=>{const d=deals.find(x=>x.id===m.dealId);return`${d?.client||"?"} (${m.invoiceNo}, ${age(m)}d overdue)`;}).join(" · ")}
              {overdue.length>4&&` +${overdue.length-4} more`}
            </div>
          </div>
        );
      })()}

      {/* ── SEARCH + FILTER ────────────────────────────────────────────── */}
      <div id="billing-list-top" style={{display:"flex",gap:10,marginBottom:12,flexWrap:"wrap",alignItems:"center",scrollMarginTop:12}}>
        <div style={{flex:1,minWidth:200,position:"relative"}}>
          <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:"#94a3b8",fontSize:".85rem",pointerEvents:"none"}}>🔍</span>
          <input value={billingSearch} onChange={e=>setBillingSearch(e.target.value)} placeholder="Search project, CE no, or contact…"
            style={{width:"100%",paddingLeft:32,paddingRight:10,paddingTop:8,paddingBottom:8,border:"1.5px solid #e2e8f0",borderRadius:8,fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div style={{display:"flex",gap:6}}>
          {[["all","All"],["outstanding","Outstanding"],["overdue","Overdue"],["unsent","Not Yet Sent"],["collected","Has Collections"],["uncollected","Uncollected"],["paid","Fully Paid"]].map(([v,l])=>(
            <button key={v} onClick={()=>setBillingFilter(v)}
              style={{padding:"7px 13px",borderRadius:20,border:`1.5px solid ${billingFilter===v?"#1e293b":"#e2e8f0"}`,background:billingFilter===v?"#1e293b":"#fff",color:billingFilter===v?"#fff":"#64748b",fontFamily:"inherit",fontSize:".75rem",fontWeight:billingFilter===v?700:400,cursor:"pointer",whiteSpace:"nowrap"}}>
              {l}
            </button>
          ))}
        </div>
        {notBilledCount>0&&(
          <button onClick={()=>setShowNotBilled(v=>!v)}
            title={showNotBilled?"Hide projects with no billing set up":"Show projects with no billing set up"}
            style={{padding:"7px 13px",borderRadius:20,border:`1.5px dashed ${showNotBilled?"#1e293b":"#cbd5e1"}`,background:showNotBilled?"#1e293b":"#fff",color:showNotBilled?"#fff":"#94a3b8",fontFamily:"inherit",fontSize:".75rem",fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>
            {showNotBilled?"Hide":"Show"} not billed ({notBilledCount})
          </button>
        )}
      </div>

      {/* ── PROJECT LIST TABLE ──────────────────────────────────────────── */}
      <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:mob?"hidden":"auto"}}>
        {/* Table header — desktop only; mobile uses self-labeling cards */}
        {!mob&&(
        <div style={{display:"grid",gridTemplateColumns:BILL_COLS,background:"#1e293b",padding:"10px 18px",gap:12,minWidth:BILL_MINW}}>
          {[["Project","left"],["VATEx","right"],["VAT","right"],["Total","right"],["Paid","right"],["Balance","right"],["Status","left"],["Actions","left"]].map(([h,al])=>(
            <div key={h} style={{fontSize:".68rem",fontWeight:700,color:"rgba(255,255,255,.6)",textTransform:"uppercase",letterSpacing:".8px",textAlign:al}}>{h}</div>
          ))}
        </div>
        )}
        {wonDeals.length===0&&<div style={{padding:"32px",textAlign:"center",color:"#94a3b8"}}>No awarded projects. Award a deal to start billing.</div>}
        {billingRows.map((row,i)=>{
          if(row.subtotalOf){
            const {subtotalOf:pd,addendumCount:ac}=row;
            const label=`Total contract · main + ${ac} addend${ac===1?"um":"a"}`;
            const cells=[["VATEx",fmt(row.grossBase),"#3b82f6"],["VAT",fmt(row.vat),"#f59e0b"],["Total",fmt(row.total),"#0f172a"],["Paid",row.collected>0?fmt(row.collected):"—","#059669"],["Balance",row.balance>0?fmt(row.balance):"✓ Clear",row.balance>0?"#ef4444":"#059669"]];
            if(mob) return(
              <div key={"sub-"+pd.id} style={{padding:"10px 16px",borderBottom:"1px solid #e2e8f0",background:"#f8fafc",borderTop:"1.5px solid #e2e8f0"}}>
                <div style={{fontSize:".66rem",fontWeight:800,color:"#475569",textTransform:"uppercase",letterSpacing:".06em",marginBottom:6}}>{label} · contract {fmt(row.contract)}</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                  {cells.map(([l,v,c])=><div key={l}><div style={{fontSize:".58rem",color:"#94a3b8",textTransform:"uppercase",fontWeight:700}}>{l}</div><div style={{fontWeight:800,color:c,fontSize:".8rem"}}>{v}</div></div>)}
                </div>
              </div>
            );
            return(
              <div key={"sub-"+pd.id} style={{display:"grid",gridTemplateColumns:BILL_COLS,minWidth:BILL_MINW,padding:"9px 18px",gap:12,borderBottom:"1px solid #e2e8f0",borderTop:"1.5px solid #e2e8f0",background:"#f8fafc",alignItems:"center"}}>
                <div style={{fontSize:".7rem",fontWeight:800,color:"#475569",textTransform:"uppercase",letterSpacing:".06em"}}>{label}<div style={{fontSize:".66rem",fontWeight:600,color:"#94a3b8",textTransform:"none",letterSpacing:0}}>Contract {fmt(row.contract)}</div></div>
                {cells.map(([l,v,c])=><div key={l} style={{fontWeight:800,color:c,fontSize:".86rem",textAlign:"right",fontVariantNumeric:"tabular-nums"}}>{v}</div>)}
                <div/><div/>
              </div>
            );
          }
          const {d,ms,grossBase,vat,total,collected,collectible,balance,hasOverdue,hasUnsent,fullyPaid,toBill,milestoneCount,groupOverdue,childOf,addendumCount}=row;
          const statusBadge=(
            <>
              {hasOverdue&&<span style={{fontSize:".68rem",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:20,padding:"2px 8px",fontWeight:700}}>Overdue</span>}
              {hasUnsent&&<span title="A Draft milestone is past its due date and hasn't been sent" style={{fontSize:".68rem",background:"#fffbeb",color:"#b45309",border:"1px solid #fcd34d",borderRadius:20,padding:"2px 8px",fontWeight:700}}>Not sent</span>}
              {fullyPaid&&<span style={{fontSize:".68rem",background:"#f0fdf4",color:"#059669",border:"1px solid #6ee7b7",borderRadius:20,padding:"2px 8px",fontWeight:700}}>Paid</span>}
              {!hasOverdue&&!hasUnsent&&!fullyPaid&&milestoneCount>0&&<span style={{fontSize:".68rem",background:"#eff6ff",color:"#3b82f6",border:"1px solid #93c5fd",borderRadius:20,padding:"2px 8px",fontWeight:700}}>Active</span>}
              {milestoneCount===0&&<span style={{fontSize:".68rem",color:"#e2e8f0"}}>—</span>}
            </>
          );
          // Row-menu delete options adapt to the row: a billed project (milestones
          // present) offers "Delete billing schedule" (archived, reversible); a
          // "Not billed" 0-milestone project has no schedule to delete, so it
          // offers "Remove project" instead — the full deal delete, Manager-gated
          // and routed through the global confirmation modal.
          const canDeleteSchedule=canEdit&&milestoneCount>0;
          const canRemoveProject=canDeleteDeal&&milestoneCount===0;
          const hasRowMenu=canDeleteSchedule||canRemoveProject;
          const actionButtons=(
            <>
              <button onClick={e=>{e.stopPropagation();setSelDeal(d.id);}}
                style={{background:"#1e293b",border:"none",borderRadius:7,padding:mob?"8px 14px":"5px 12px",fontFamily:"inherit",fontSize:".75rem",color:"#fff",cursor:"pointer",fontWeight:600,flex:mob?1:undefined}}>
                Open →
              </button>
              <button onClick={e=>{e.stopPropagation();printSOA(d.client);}}
                style={{background:"#f97316",border:"none",borderRadius:7,padding:mob?"8px 14px":"5px 10px",fontFamily:"inherit",fontSize:".72rem",color:"#fff",cursor:"pointer",fontWeight:700,flex:mob?1:undefined}}>
                📄 SOA
              </button>
              <button onClick={e=>{e.stopPropagation();shareSoaPdf(d.client);}} disabled={billingPdf.busy} title="SOA as a PDF to share (Viber, Mail, Files) or download"
                style={{background:"#ecfeff",border:"1.5px solid #67e8f9",borderRadius:7,padding:mob?"8px 14px":"5px 10px",fontFamily:"inherit",fontSize:".72rem",color:"#155e75",cursor:billingPdf.busy?"wait":"pointer",fontWeight:700,flex:mob?1:undefined}}>
                {billingPdf.busy?"…":"📤 SOA PDF"}
              </button>
              {hasRowMenu&&(
                <button onClick={e=>{e.stopPropagation();const r=e.currentTarget.getBoundingClientRect();setBillRowMenu(billRowMenu?.id===d.id?null:{id:d.id,client:d.client,canDeleteSchedule,canRemoveProject,top:r.bottom+4,right:Math.max(8,window.innerWidth-r.right)});}}
                  title="More actions"
                  style={{background:billRowMenu?.id===d.id?"#e2e8f0":"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:7,padding:mob?"8px 13px":"5px 10px",fontFamily:"inherit",fontSize:".9rem",lineHeight:1,color:"#64748b",cursor:"pointer",fontWeight:700,flex:mob?0:undefined}}>
                  ⋯
                </button>
              )}
            </>
          );
          // The 🔴 on a main project also lights when one of its addenda is
          // overdue, so the client's late invoice shows where people look first.
          const projectCell=(
            <div style={childOf?{position:"relative",paddingLeft:24}:undefined}>
              {childOf&&<span aria-hidden="true" style={{position:"absolute",left:6,top:-10,height:22,width:11,borderLeft:"2px solid #67e8f9",borderBottom:"2px solid #67e8f9",borderBottomLeftRadius:6}}/>}
              <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                {groupOverdue&&<span style={{color:"#ef4444",fontSize:".8rem"}} title={hasOverdue?"Overdue invoice":"An addendum of this project has an overdue invoice"}>🔴</span>}
                {childOf?(
                  <>
                    <span style={{fontSize:".6rem",fontWeight:700,letterSpacing:".04em",color:"#0e7490",background:"#ecfeff",border:"1px solid #a5f3fc",borderRadius:5,padding:"1px 6px",whiteSpace:"nowrap"}}>ADDENDUM OF {childOf.ceNo||childOf.contact||"MAIN PROJECT"}</span>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".86rem"}}>{d.contact||d.client}</span>
                  </>
                ):(
                  <>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".88rem"}}>{d.client}</span>
                    {d.contact&&<span style={{fontSize:".72rem",color:"#94a3b8"}}>— {d.contact}</span>}
                  </>
                )}
              </div>
              <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:1}}>
                {d.ceNo||"No CE"} · {milestoneCount} milestone{milestoneCount!==1?"s":""}
                {addendumCount>0&&!childOf&&` · ${addendumCount} addend${addendumCount===1?"um":"a"}`}
                {toBill>0&&<span title="Draft milestones past their Bill-on date" style={{color:"#d97706",fontWeight:700,marginLeft:6}}>⏰ {toBill} to bill</span>}
                {fullyPaid&&<span style={{color:"#059669",fontWeight:700,marginLeft:6}}>✓ Fully Paid</span>}
              </div>
            </div>
          );
          const dash=<span style={{color:"#e2e8f0",fontSize:".78rem"}}>—</span>;
          // Gross = VAT-exclusive base; VAT = 12% output VAT; Total = VAT-inclusive
          // amount billed to the client; Paid = cash collected; Balance = amount
          // still owed (net of any EWT withheld).
          const grossCell=grossBase>0?fmt(grossBase):<span style={{color:"#e2e8f0",fontSize:".78rem"}}>Not billed</span>;
          const vatCell=vat>0?fmt(vat):dash;
          const totalCell=total>0?fmt(total):dash;
          const paidCell=collected>0?fmt(collected):dash;
          const balanceCell=balance>0?fmt(balance):"✓ Clear";
          const money=(node,color,al="right")=>(<div style={{fontWeight:600,color,fontSize:".86rem",textAlign:al,fontVariantNumeric:"tabular-nums"}}>{node}</div>);

          if(mob){
            // Stacked card — no horizontal scroll, everything visible incl. SOA button
            return(
              <div key={d.id} {...clickable(()=>setSelDeal(d.id))} aria-label={`Open billing for ${d.client||d.contact||"project"}`}
                style={{padding:"14px 16px",borderBottom:"1px solid #f1f5f9",background:hasOverdue?"#fffafa":"#fff",cursor:"pointer"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                  {projectCell}
                  <div style={{flexShrink:0}}>{statusBadge}</div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,margin:"12px 0",padding:"10px 0",borderTop:"1px solid #f1f5f9",borderBottom:"1px solid #f1f5f9"}}>
                  {[["VATEx",grossCell,"#3b82f6"],["VAT",vatCell,"#f59e0b"],["Total",totalCell,"#0f172a"],["Paid",paidCell,"#059669"],["Balance",balanceCell,balance>0?"#ef4444":"#059669"]].map(([lbl,val,clr])=>(
                    <div key={lbl}>
                      <div style={{fontSize:".6rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".6px",fontWeight:700}}>{lbl}</div>
                      <div style={{fontWeight:lbl==="Total"||lbl==="Balance"?700:600,color:clr,fontSize:".82rem",marginTop:2}}>{val}</div>
                    </div>
                  ))}
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>{actionButtons}</div>
              </div>
            );
          }

          return(
            <div key={d.id}
              {...clickable(()=>setSelDeal(d.id))} aria-label={`Open billing for ${d.client||d.contact||"project"}`}
              style={{display:"grid",gridTemplateColumns:BILL_COLS,minWidth:BILL_MINW,padding:"12px 18px",gap:12,borderBottom:"1px solid #f1f5f9",background:hasOverdue?"#fffafa":i%2?"#fafafa":"#fff",cursor:"pointer",alignItems:"center",transition:"background .1s"}}
              onMouseEnter={e=>e.currentTarget.style.background="#eff6ff"}
              onMouseLeave={e=>e.currentTarget.style.background=hasOverdue?"#fffafa":i%2?"#fafafa":"#fff"}>
              {projectCell}
              {money(grossCell,"#3b82f6")}
              {money(vatCell,"#f59e0b")}
              {money(totalCell,"#0f172a")}
              {money(paidCell,"#059669")}
              {money(balanceCell,balance>0?"#ef4444":"#059669")}
              <div>{statusBadge}</div>
              <div style={{display:"flex",gap:5,alignItems:"center"}}>{actionButtons}</div>
            </div>
          );
        })}
      </div>

      {/* ── Row-actions menu (⋯) — fixed-position so the overflow:auto list
             doesn't clip it. Anchored to the button that opened it. ─────────── */}
      {billRowMenu&&(()=>{
        const menuItem={display:"block",width:"100%",textAlign:"left",background:"#fff",border:"none",borderBottom:"1px solid #f1f5f9",padding:"11px 15px",fontFamily:"inherit",fontSize:".8rem",color:"#dc2626",cursor:"pointer",fontWeight:600,whiteSpace:"nowrap"};
        return(
        <>
          <div onClick={()=>setBillRowMenu(null)} style={{position:"fixed",inset:0,zIndex:60}}/>
          <div style={{position:"fixed",top:billRowMenu.top,right:billRowMenu.right,zIndex:61,background:"#fff",border:"1px solid #e2e8f0",borderRadius:9,boxShadow:"0 8px 24px rgba(0,0,0,.14)",minWidth:210,overflow:"hidden"}}>
            {billRowMenu.canDeleteSchedule&&(
              <button onClick={()=>{const id=billRowMenu.id;setBillRowMenu(null);deleteProjectBilling(id);}}
                title="Archive this project's billing schedule to the Audit Trail (reversible)" style={menuItem}>
                🗑 Delete billing schedule
              </button>
            )}
            {billRowMenu.canRemoveProject&&(
              <button onClick={()=>{const id=billRowMenu.id;setBillRowMenu(null);setConfirmDel(id);}}
                title="This project has no billing set up. Removing it permanently deletes the whole project and all its records." style={{...menuItem,borderBottom:"none"}}>
                🗑 Remove project…
              </button>
            )}
          </div>
        </>
        );
      })()}

      {/* ── POPUP: Project Billing Detail ──────────────────────────────── */}
      {selDeal&&(
        <Modal open title={`${deal?.client||""}${deal?.contact?" — "+deal?.contact:""}`} onClose={()=>{setSelDeal(null);setShowForm(false);setShowPay(null);}} wide>
          {/* Project billing summary */}
          {(()=>{
            const ms=billings.filter(b=>b.dealId===selDeal);
            const rt=deal?.receiptType||"OR", wh=deal?.withholding||false;
            // Net receivable per milestone — use milestone's own tax settings, fall back to deal
            const billedNet=ms.filter(m=>m.status!=="Cancelled").reduce((s,m)=>s+calcTax(m.amount,m.receiptType??rt,m.withholding??wh).netReceivable,0);
            const collected=ms.reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+n(p.amount),0),0);
            const tx=calcTax(deal?.value||0,rt,wh);
            // ── Guardrail: milestone bases must reconcile to the contract value ──
            // Milestone amounts are entered VAT-exclusive (base), same basis as the
            // contract value, so their sum should equal the contract. A sum over the
            // contract means the project is over-billed (e.g. retention added on top
            // of a 100% DP+Progress split → 110%); a sum under it means the schedule
            // isn't fully set up yet. Cancelled milestones don't count.
            const billedBase=ms.filter(m=>m.status!=="Cancelled").reduce((s,m)=>s+n(m.amount),0);
            const contractBase=n(deal?.value);
            const diff=Math.round((billedBase-contractBase)*100)/100;
            const pctOfContract=contractBase>0?Math.round(billedBase/contractBase*100):0;
            const overBilled=diff>0.5;                 // sums to more than the contract
            const underBilled=diff<-0.5&&ms.some(m=>m.status!=="Cancelled"); // short, but has milestones
            // Change-order milestones on this project that duplicate an addendum
            // billed on its own project, or whose change order no longer exists.
            const coIssues=findAddendumDoubleBilling({dealId:selDeal,billings,deals,addenda});
            return(
              <>
              <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:overBilled||underBilled?10:16}}>
                {[
                  {l:"Contract Value",v:fmt(deal?.value||0),    c:"#0f172a"},
                  {l:"Total Billed (net)",v:fmt(billedNet),     c:"#3b82f6"},
                  {l:"Collected",     v:fmt(collected),          c:"#059669"},
                  {l:"Outstanding",   v:fmt(Math.max(0,billedNet-collected)), c:billedNet>collected?"#ef4444":"#059669"},
                ].map(({l,v,c})=>(
                  <div key={l} style={{textAlign:"center",padding:"10px",background:"#f8fafc",borderRadius:8}}>
                    <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.1rem",color:c}}>{v}</div>
                    <div style={{fontSize:".62rem",color:"#94a3b8",textTransform:"uppercase",letterSpacing:".8px",marginTop:3}}>{l}</div>
                  </div>
                ))}
              </div>
              {coIssues.map(({milestone:m,child,reason})=>(
                <div key={m.id} style={{background:"#fef2f2",border:"1.5px solid #fca5a5",borderRadius:10,padding:"10px 14px",marginBottom:10,display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:"1rem"}}>🚫</span>
                  <span style={{fontSize:".8rem",color:"#b91c1c"}}>
                    {reason==="duplicate"
                      ?<><strong>Double-billed addendum: {m.invoiceNo||m.name} ({fmt(n(m.amount))}).</strong> This change order is already billed on its own addendum project {child.ceNo||child.contact||""}. Addenda bill on their own project only — {m.status==="Draft"?"delete":"cancel"} {m.invoiceNo||"this milestone"} here.</>
                      :<><strong>Orphaned change-order milestone: {m.invoiceNo||m.name} ({fmt(n(m.amount))}).</strong> No change order on this project backs it any more. Confirm whether it was billed elsewhere before sending, then {m.status==="Draft"?"delete":"cancel"} it.</>}
                  </span>
                </div>
              ))}
              {overBilled&&(
                <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:"1rem"}}>⚠️</span>
                  <span style={{fontSize:".8rem",color:"#b91c1c"}}>
                    <strong>Over-billed: milestones total {pctOfContract}% of the contract.</strong>{" "}
                    Milestone bases sum to {fmt(billedBase)} vs contract {fmt(contractBase)} — {fmt(diff)} too high. Check the milestone amounts (they should be VAT-exclusive and sum to the contract value).
                  </span>
                </div>
              )}
              {underBilled&&(
                <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:10,padding:"10px 14px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:"1rem"}}>ℹ️</span>
                  <span style={{fontSize:".8rem",color:"#92400e"}}>
                    Milestones cover {pctOfContract}% of the contract ({fmt(billedBase)} of {fmt(contractBase)}). {fmt(-diff)} not yet scheduled — expected if the billing schedule is still being set up.
                  </span>
                </div>
              )}
              </>
            );
          })()}

          {/* Receipt-type consistency guard — a milestone whose receipt type disagrees with
              its deal prints VAT differently than the app shows (OR adds 12% VAT, AR does not),
              which silently produces a phantom balance-due on the printed invoice. Surface it so
              Finance reconciles the deal header instead of letting it drift. */}
          {(()=>{
            const bad=billings.filter(m=>m.dealId===selDeal&&m.status!=="Cancelled"
              &&m.receiptType&&deal?.receiptType&&m.receiptType!==deal.receiptType);
            if(!bad.length)return null;
            return(
              <div style={{marginBottom:12,padding:"10px 14px",background:"#fffbeb",border:"1.5px solid #fcd34d",borderRadius:8,fontSize:".78rem",color:"#92400e"}}>
                <div style={{fontWeight:700,marginBottom:3}}>⚠️ Receipt-type mismatch</div>
                {bad.length} milestone{bad.length>1?"s":""} ({bad.map(m=>m.invoiceNo||m.name).join(", ")}) {bad.length>1?"are":"is"} set to <strong>{[...new Set(bad.map(m=>m.receiptType))].join("/")}</strong> but this deal is <strong>{deal.receiptType}</strong>. Printed invoices use the milestone's type, so the invoice and the deal summary can show different tax. Align the deal's receipt type (Edit terms) so new milestones inherit the correct VAT treatment.
              </div>
            );
          })()}

          {/* Contract breakdown (original + addenda) — shown when this project has change orders */}
          {((addenda||[]).some(a=>a.dealId===selDeal&&a.status!=="Rejected")||(deals||[]).some(d=>d.parentDealId===selDeal&&!isLostStage(d.stage)))&&<div style={{marginBottom:12}}><ContractBreakdown deal={deal} addenda={addenda} deals={deals}/></div>}

          {/* COC-to-Finance notification banner */}
          {(()=>{
            const ms=billings.filter(b=>b.dealId===selDeal);
            const rt=deal?.receiptType||"OR", wh=deal?.withholding||false;
            const billed   =ms.filter(m=>m.status!=="Cancelled").reduce((s,m)=>s+calcTax(m.amount,m.receiptType??rt,m.withholding??wh).netReceivable,0);
            const collected=ms.reduce((s,m)=>s+(m.payments||[]).filter(p=>!p.bounced).reduce((ps,p)=>ps+n(p.amount),0),0);
            const outstanding=Math.max(0,billed-collected);
            if(cocDeals&&cocDeals.includes(selDeal)&&outstanding>0){
              return(
                <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:10,padding:"10px 16px",marginBottom:12,display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:"1rem"}}>📋</span>
                  <span style={{fontSize:".82rem",fontWeight:700,color:"#059669"}}>COC Issued — Final billing ready to collect</span>
                  <span style={{fontSize:".75rem",color:"#065f46",marginLeft:4}}>Outstanding: {fmt(outstanding)}</span>
                </div>
              );
            }
            return null;
          })()}

          {deal&&<ClientPoField deal={deal} canEdit={canEditClientPo} onSave={saveClientPo}
            inherited={deal.clientPoNo?"":dealClientPo(deal,deals)}/>}

          {/* Project VAT when the BOQ hasn't decided it. The BOQ's VAT choice sets
             receipt type (see onBoqVat); with no BOQ decision, Finance or a Manager
             sets it here so the project can be billed. Server-side the
             set_deal_receipt_type RPC enforces the same rule
             (migration 20261006010000) — keep the two in sync. */}
          {deal&&!deal.standbyPO&&typeof (deal.boqData||deal.boq_data)?.vatEnabled!=="boolean"&&(()=>{
            const canSetVat=["Manager","Finance","FinanceAssistant"].includes(role);
            const cur=deal.receiptType;
            const setVat=async(rt)=>{
              if(rt===cur)return;
              if(cur&&!(await uiConfirm({title:"Change project VAT?",tone:"warning",confirmLabel:`Change to ${rt}`,cancelLabel:"Cancel",
                message:`${deal.ceNo||"This project"} is ${cur}. Change it to ${rt==="OR"?"OR (VAT 12%)":"AR (No VAT)"}?\n\nInvoices already created keep the tax they were billed with; new invoices follow ${rt}.`})))return;
              if(!isSupabaseReady()){toastEmit&&toastEmit("No server connection — VAT not changed.","error");return;}
              const{error}=await _rpcWithTimeout(supabase.rpc('set_deal_receipt_type',{p_deal_id:deal.id,p_receipt_type:rt}));
              if(error){toastEmit&&toastEmit(`VAT not changed: ${error.message}`,"error",9000);return;}
              upDeals&&upDeals(ds=>ds.map(d=>d.id===deal.id?{...d,receiptType:rt,withholding:rt==="AR"?false:d.withholding}:d));
              toastEmit&&toastEmit(`${deal.ceNo||"Project"} set to ${rt==="OR"?"OR (VAT 12%)":"AR (No VAT)"}`,"success");
            };
            return(
              <div style={{background:cur?"#f8fafc":"#fef2f2",border:`1.5px solid ${cur?"#e2e8f0":"#fecaca"}`,borderRadius:12,padding:"10px 16px",marginBottom:14,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                <span style={{fontSize:".8rem",fontWeight:800,color:cur?"#475569":"#b91c1c"}}>🧾 Project VAT{cur?"":" — not decided"}</span>
                <span style={{fontSize:".72rem",color:"#64748b"}}>No BOQ VAT decision for this project.{canSetVat?" Finance sets it here:":" Finance or a Manager sets it."}</span>
                <div style={{display:"flex",gap:6,marginLeft:"auto"}}>
                  {[["OR","OR · VAT 12%"],["AR","AR · No VAT"]].map(([rt,label])=>(
                    <button key={rt} type="button" disabled={!canSetVat} onClick={()=>setVat(rt)}
                      style={{padding:"4px 12px",border:`2px solid ${cur===rt?"#d97706":"#e2e8f0"}`,borderRadius:8,background:cur===rt?"#fef3c7":"#fff",color:cur===rt?"#92400e":"#64748b",fontWeight:cur===rt?700:500,cursor:canSetVat?"pointer":"not-allowed",opacity:!canSetVat&&cur!==rt?.5:1,fontFamily:"inherit",fontSize:".74rem"}}>
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            );
          })()}

          {/* Onboarding readiness gate (Policy §2.1) — Finance holds the first
             invoice until the client's engagement facts are on file. */}
          {(()=>{
            // Payment terms and the down payment are entered in the Milestone
            // Builder, so the gate here only asks for the client documents.
            const gate=dealOnboardingGate(deal,{scheduleInBuilder:true});
            const existingMs=billings.filter(b=>b.dealId===selDeal);
            if(!deal||gate.ready||existingMs.length>0) return null; // satisfied, or already billing
            const save=(fields)=>onSaveOnboarding&&onSaveOnboarding(selDeal,fields);
            return(
              <div style={{background:"#fff7ed",border:"1.5px solid #fed7aa",borderRadius:12,padding:"12px 16px",marginBottom:14}}>
                <div style={{fontSize:".82rem",fontWeight:800,color:"#c2410c",marginBottom:8}}>🧾 Client onboarding incomplete — invoicing on hold (Policy §2.1)</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:12}}>
                  {gate.checks.map(c=>(
                    <span key={c.label} style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:".72rem",fontWeight:600,padding:"3px 10px",borderRadius:20,border:"1px solid",borderColor:c.ok?"#6ee7b7":"#fecaca",background:c.ok?"#f0fdf4":"#fef2f2",color:c.ok?"#059669":"#b91c1c"}}>
                      {c.ok?"✓":"○"} {c.label}
                    </span>
                  ))}
                </div>
                {canEdit?(
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:10}}>
                    <Fld label="Signed C.E. / client PO">
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <Inp type="url" value={deal.signedCeUrl||""} placeholder="Drive link to signed C.E. or PO" onChange={e=>save({signedCeUrl:e.target.value})} style={{flex:1}}/>
                        <label style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",color:"#475569",whiteSpace:"nowrap"}}>
                          <input type="checkbox" checked={!!deal.signedCeOnFile} onChange={e=>save({signedCeOnFile:e.target.checked})}/> On file
                        </label>
                      </div>
                    </Fld>
                    <Fld label="BIR Form 2303">
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <Inp type="url" value={deal.bir2303Url||""} placeholder="Drive link to 2303" onChange={e=>save({bir2303Url:e.target.value})} style={{flex:1}}/>
                        <label style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",color:"#475569",whiteSpace:"nowrap"}}>
                          <input type="checkbox" checked={!!deal.bir2303OnFile} onChange={e=>save({bir2303OnFile:e.target.checked})}/> On file
                        </label>
                      </div>
                    </Fld>
                    <Fld label="VAT Treatment">
                      <Sel value={deal.vatTreatment||""} onChange={e=>save({vatTreatment:e.target.value})}>
                        <option value="">— Select —</option>
                        {VAT_TREATMENTS.map(v=><option key={v} value={v}>{v}</option>)}
                      </Sel>
                    </Fld>
                  </div>
                ):(
                  <div style={{fontSize:".72rem",color:"#9a3412"}}>Finance must complete these before the downpayment invoice can be generated.</div>
                )}
              </div>
            );
          })()}

          {/* Billing schedule — set up once with the Milestone Builder (no
             preset terms). After that, staff edit the milestones themselves. */}
          {(()=>{
            const terms=deal?.paymentTerms;
            const existingMs=billings.filter(b=>b.dealId===selDeal);
            const val=Number(deal?.originalValue!=null?deal.originalValue:deal?.value||0);
            const gate=dealOnboardingGate(deal,{scheduleInBuilder:true});
            if(existingMs.length>0||deal?.billingGenerated){
              if(!terms) return null;
              return(
                <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center",marginBottom:14}}>
                  <span style={{fontSize:".62rem",textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",fontWeight:700}}>Schedule</span>
                  <span style={{fontSize:".7rem",background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe",borderRadius:20,padding:"2px 10px",fontWeight:600,fontFamily:"'IBM Plex Mono',monospace"}}>{scheduleSummary(terms)}</span>
                  {terms.retentionRelease&&<span style={{fontSize:".65rem",color:"#64748b"}}>Retention released: {terms.retentionRelease}</span>}
                </div>
              );
            }
            if(!canEdit) return(
              <div style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:".78rem",color:"#64748b"}}>No billing milestones set up yet. Finance sets them up here.</div>
            );
            const blocked=val<=0||!gate.ready;
            return(
              <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:10,padding:"10px 14px",marginBottom:14}}>
                <span style={{fontSize:".78rem",color:"#1d4ed8",fontWeight:600}}>
                  {val<=0?"💳 Set the contract value before setting up billing.":!gate.ready?`💳 Complete client onboarding first: ${gate.missing.join(", ")}.`:"💳 No billing milestones yet. Enter each milestone and its % of the contract."}
                </span>
                {onOpenPayTerms&&<button onClick={()=>!blocked&&onOpenPayTerms(selDeal)} disabled={blocked} style={{marginLeft:"auto",background:blocked?"#cbd5e1":"#1d4ed8",border:"none",borderRadius:8,padding:"6px 14px",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",color:"#fff",cursor:blocked?"not-allowed":"pointer",whiteSpace:"nowrap"}}>📋 Set Up Billing Milestones</button>}
              </div>
            );
          })()}

          {/* Retention receivable */}
          {(retentionState.held>0)&&(
            <div style={{display:"flex",flexWrap:"wrap",alignItems:"center",gap:16,marginBottom:12,padding:"12px 16px",background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12}}>
              <span style={{fontWeight:800,color:"#92400e",fontSize:".82rem"}}>🔒 Retention</span>
              <span style={{fontSize:".82rem",color:"#92400e"}}>Withheld: <strong>₱{retentionState.held.toLocaleString("en-PH")}</strong></span>
              {retentionState.released>0&&<span style={{fontSize:".82rem",color:"#92400e"}}>Released: <strong>₱{retentionState.released.toLocaleString("en-PH")}</strong></span>}
              <span style={{fontSize:".82rem",color:"#92400e"}}>Outstanding: <strong>₱{retentionState.outstanding.toLocaleString("en-PH")}</strong></span>
              {(()=>{const cocOk=(cocDeals&&cocDeals.includes(selDeal))||projs?.[selDeal]?.cocCreated;return canEdit&&retentionState.outstanding>0&&(
                <button onClick={releaseRetention} title={cocOk?"":"Retention releases after the COC is issued (§3)"} style={{marginLeft:"auto",background:cocOk?"#b45309":"#d6b68a",border:"none",borderRadius:8,padding:"6px 14px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".78rem",cursor:cocOk?"pointer":"not-allowed"}}>{cocOk?"Release Retention →":"🔒 Locked until COC"}</button>
              );})()}
            </div>
          )}

          {/* Add milestone form */}
          {canEdit&&(
            <div style={{marginBottom:12}}>
              {!showForm?(
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  <button onClick={()=>setShowForm(true)}
                    style={{background:"#1e293b",border:"none",borderRadius:9,padding:"8px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>
                    + Add Milestone
                  </button>
                  <button onClick={progressClaim} title="Bill the work completed (contract × % complete) that hasn't been billed yet"
                    style={{background:"#0e7490",border:"none",borderRadius:9,padding:"8px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>
                    📐 Progress Claim
                  </button>
                </div>
              ):(
                <div style={{background:"#f8fafc",borderRadius:12,border:"1.5px solid #e2e8f0",padding:16,marginBottom:8}}>
                  <div style={{fontWeight:700,color:"#0f172a",marginBottom:12,fontSize:".88rem"}}>New Billing Milestone</div>
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:12}}>
                    <Fld label="Milestone Name" required hint="e.g. 50% Downpayment, Progress Billing, Final Billing">
                      <Inp value={msForm.name} onChange={e=>fm("name",e.target.value)} placeholder="e.g. 50% Downpayment upon PO"/>
                    </Fld>
                    <Fld label="Amount (₱, Net / VAT-exclusive)" hint={(msForm.receiptType??deal?.receiptType??"OR")==="OR"?"Net (ex-VAT). Prefer entering gross? Use the box below — this fills for you.":undefined} required>
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <Inp type="number" value={msForm.amount} onChange={e=>{fm("amount",e.target.value);setMsGrossStr(msNetToGross(e.target.value));}} placeholder="0.00" style={{flex:1}}/>
                        {selDeal&&(()=>{
                          const d=wonDeals.find(x=>x.id===selDeal)||deals.find(x=>x.id===selDeal);
                          const existingMs=billings.filter(b=>b.dealId===selDeal);
                          const totalMs=existingMs.reduce((s,b)=>s+Number(b.amount||0),0);
                          const remaining=Math.max(0,(Number(d?.value||0)-totalMs));
                          return remaining>0?(
                            <button type="button" onClick={()=>{fm("amount",String(remaining));setMsGrossStr(msNetToGross(remaining));}}
                              style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:6,padding:"5px 10px",color:"#1d4ed8",cursor:"pointer",fontFamily:"inherit",fontSize:".75rem",fontWeight:700,whiteSpace:"nowrap"}}>
                              Bill Remaining ₱{remaining.toLocaleString()}
                            </button>
                          ):null;
                        })()}
                      </div>
                    </Fld>
                    {(msForm.receiptType??deal?.receiptType??"OR")==="OR"&&(
                      <Fld label="Or enter Gross (VAT-inclusive)" hint="Type the gross figure — the net Amount fills automatically.">
                        <Inp type="number" min={0} value={msGrossStr} onChange={e=>{const g=e.target.value;setMsGrossStr(g);fm("amount",g===""?"":String(Math.round(Math.max(0,Number(g)||0)/1.12*100)/100));}} placeholder="e.g. 560,000 incl. VAT"/>
                      </Fld>
                    )}
                    <Fld label="Invoice No." hint="Auto-generated if blank"><Inp value={msForm.invoiceNo} onChange={e=>fm("invoiceNo",e.target.value)} placeholder="Leave blank for the next free number"/></Fld>
                    <Fld label="Invoice Date"><Inp type="date" value={msForm.invoiceDate} onChange={e=>fm("invoiceDate",e.target.value)}/></Fld>
                    <Fld label="Due Date" required hint={!msForm.dueDate?"Recommended — drives the cash-flow forecast.":undefined}><Inp type="date" value={msForm.dueDate} onChange={e=>fm("dueDate",e.target.value)}/></Fld>
                    <Fld label="Status"><Sel value={msForm.status} onChange={e=>fm("status",e.target.value)}>{BILLING_STATUSES.map(s=><option key={s}>{s}</option>)}</Sel></Fld>
                    <Fld label="Receipt Type" hint={deal?.receiptType?`Defaults to project setting (${deal.receiptType})`:"Project VAT not decided in the BOQ yet — choose one here or set VAT in the BOQ"}>
                      <Sel value={msForm.receiptType||""} onChange={e=>{const v=e.target.value||null;fm("receiptType",v);if((v??deal?.receiptType??"OR")==="OR")setMsGrossStr(msNetToGross(msForm.amount));}}>
                        <option value="">{deal?.receiptType?`— Use Project Default (${deal.receiptType}) —`:"— Not set (decide in BOQ) —"}</option>
                        <option value="OR">OR (Official Receipt)</option>
                        <option value="AR">AR (Acknowledgement Receipt)</option>
                      </Sel>
                    </Fld>
                    <Fld label="Withholding Tax (EWT 2%)" hint={`Defaults to deal setting (${deal?.withholding?"Yes":"No"})`}>
                      <Sel value={msForm.withholding==null?"":String(msForm.withholding)} onChange={e=>fm("withholding",e.target.value===""?null:e.target.value==="true")}>
                        <option value="">— Use Deal Default ({deal?.withholding?"Yes":"No"}) —</option>
                        <option value="true">Yes — apply 2% EWT deduction</option>
                        <option value="false">No — no withholding</option>
                      </Sel>
                    </Fld>
                    <div style={{gridColumn:"1/-1"}}><Fld label="Description"><Inp value={msForm.description} onChange={e=>fm("description",e.target.value)} placeholder="What this billing covers…"/></Fld></div>
                    {/* Tax preview — reads like the SOA: net sale → +VAT → =gross
                        billed to client → −EWT withheld → =cash you collect. */}
                    {n(msForm.amount)>0&&deal&&(()=>{
                      const tx=calcTax(msForm.amount,msForm.receiptType??deal.receiptType??"OR",msForm.withholding??deal.withholding??false);
                      const f2=v=>Math.abs(Number(v)).toLocaleString("en-PH",{minimumFractionDigits:2,maximumFractionDigits:2});
                      const rows=(msForm.receiptType??deal.receiptType??"OR")==="OR"
                        ?[["Net Sale (VAT-exclusive)",tx.base,"#0f172a"],["VAT 12%",tx.vat,"#f59e0b"],["Gross — billed to client",tx.gross,"#2563eb"],...(tx.ewt>0?[["EWT 2% (client withholds)",-tx.ewt,"#ef4444"]]:[]),["Net Collectible (cash in)",tx.netReceivable,"#059669"]]
                        :[["Amount (AR — no VAT)",tx.base,"#0f172a"],["Net Collectible (cash in)",tx.netReceivable,"#059669"]];
                      return<div style={{gridColumn:"1/-1",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,padding:"4px 12px"}}>
                        {rows.map(([l,v,c],i)=>(
                          <div key={l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderTop:i===0?"none":"1px dashed #fde68a"}}>
                            <span style={{fontSize:".74rem",color:"#78716c",fontWeight:i===rows.length-1?700:500}}>{l}</span>
                            <span style={{fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,fontSize:".82rem",color:c}}>{v<0?"−":""}₱{f2(v)}</span>
                          </div>
                        ))}
                      </div>;
                    })()}
                  </div>
                  <div style={{display:"flex",gap:8,marginTop:12}}>
                    <button onClick={submitMS} disabled={!msForm.name||!msForm.amount}
                      style={{background:msForm.name&&msForm.amount?"#1e293b":"#e2e8f0",border:"none",borderRadius:9,padding:"8px 20px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:msForm.name&&msForm.amount?"#fff":"#94a3b8",cursor:msForm.name&&msForm.amount?"pointer":"not-allowed"}}>
                      Add Milestone
                    </button>
                    <button onClick={()=>setShowForm(false)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"8px 16px",fontFamily:"inherit",fontWeight:600,fontSize:".82rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Milestone list */}
          {billings.filter(b=>b.dealId===selDeal).length===0&&!showForm&&(
            <div style={{textAlign:"center",padding:"24px",color:"#94a3b8",fontSize:".84rem"}}>No milestones yet. Hit + Add Milestone to create the first billing.</div>
          )}
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {billings.filter(b=>b.dealId===selDeal).map(ms=>{
              const paidTotal=(ms.payments||[]).filter(p=>!p.bounced).reduce((s,p)=>s+n(p.amount),0);
              const tx=calcTax(ms.amount,ms.receiptType??deal?.receiptType??"OR",ms.withholding??deal?.withholding??false);
              const balance=Math.max(0,tx.netReceivable-paidTotal);
              const pct=tx.netReceivable>0?Math.round(paidTotal/tx.netReceivable*100):0;
              const sClr=BILLING_STATUS_CLR[ms.status]||"#94a3b8";
              const isOverdue=isBillingOverdue(ms,today);
              const isUnsentLate=isBillingUnsentLate(ms,today);
              // Receivables lifecycle: Drafted → Sent → Paid (half = partially paid).
              const msSent=["Sent to Client","Partially Paid","Fully Paid","Overdue"].includes(ms.status);
              const msFullyPaid=ms.status==="Fully Paid"||(tx.netReceivable>0&&paidTotal>=tx.netReceivable);
              const msPartlyPaid=paidTotal>0&&!msFullyPaid;
              const msNodes=[
                {label:"Drafted", done:true, color:BILLING_STATUS_CLR["Draft"]||T.inkFaint},
                {label:"Sent", done:msSent, color:BILLING_STATUS_CLR["Sent to Client"]||T.info},
                {label:msFullyPaid?"Paid":msPartlyPaid?"Part. paid":"Paid", done:msFullyPaid, half:msPartlyPaid, color:T.success},
              ];
              return(
                <div key={ms.id} style={{background:"#f8fafc",borderRadius:10,border:`1.5px solid ${isOverdue?"#fecaca":isUnsentLate?"#fcd34d":sClr+"33"}`,padding:"12px 16px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,flexWrap:"wrap"}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",marginBottom:5}}>
                        <span style={{fontWeight:700,color:"#0f172a"}}>{ms.name}</span>
                        <span style={{fontSize:".68rem",background:sClr+"22",color:sClr,border:`1px solid ${sClr}44`,borderRadius:20,padding:"1px 8px",fontWeight:700}}>{ms.status}</span>
                        {isOverdue&&<span style={{fontSize:".68rem",color:T.danger,background:T.dangerBg,border:`1px solid ${T.dangerLine}`,borderRadius:20,padding:"1px 8px",fontWeight:700}}>🚨 Overdue</span>}
                        {isUnsentLate&&<span title="Still a Draft after its due date. Send it to the client and mark it Sent, or change the due date." style={{fontSize:".68rem",color:"#b45309",background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:20,padding:"1px 8px",fontWeight:700}}>📤 Not sent — was due {ms.dueDate}</span>}
                        <span style={{fontSize:".68rem",color:T.inkFaint}}>{ms.invoiceNo}</span>
                      </div>
                      {!ms.isRetentionRelease&&<div style={{marginBottom:8}}><LifecycleStrip nodes={msNodes}/></div>}
                      <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:".78rem",marginBottom:8}}>
                        <span><span style={{color:"#94a3b8"}}>Net Sale: </span>₱{n(ms.amount).toLocaleString("en-PH")}</span>
                        {tx.vat>0&&<span><span style={{color:"#94a3b8"}}>VAT 12%: </span><strong style={{color:"#f59e0b"}}>+₱{tx.vat.toLocaleString("en-PH",{minimumFractionDigits:0})}</strong></span>}
                        {tx.vat>0&&<span><span style={{color:"#94a3b8"}}>Gross billed: </span><strong style={{color:"#2563eb"}}>₱{tx.gross.toLocaleString("en-PH",{minimumFractionDigits:0})}</strong></span>}
                        {tx.ewt>0&&<span><span style={{color:"#94a3b8"}}>EWT 2%: </span><strong style={{color:"#ef4444"}}>−₱{tx.ewt.toLocaleString("en-PH",{minimumFractionDigits:0})}</strong></span>}
                        <span><span style={{color:"#94a3b8"}}>Net Collectible: </span><strong style={{color:"#3b82f6"}}>₱{tx.netReceivable.toLocaleString("en-PH",{minimumFractionDigits:0})}</strong></span>
                        <span><span style={{color:"#94a3b8"}}>Paid: </span><strong style={{color:"#059669"}}>₱{paidTotal.toLocaleString("en-PH",{minimumFractionDigits:0})}</strong></span>
                        {balance>0&&<span><span style={{color:"#94a3b8"}}>Balance: </span><strong style={{color:"#ef4444"}}>₱{balance.toLocaleString("en-PH",{minimumFractionDigits:0})}</strong></span>}
                        {ms.dueDate&&<span style={{color:isOverdue?"#ef4444":isUnsentLate?"#b45309":"#64748b",fontWeight:isOverdue||isUnsentLate?700:400}}>Due: {ms.dueDate}</span>}
                        {ms.status==="Draft"&&ms.plannedDate&&<span style={{color:ms.plannedDate<today?"#d97706":"#64748b",fontWeight:ms.plannedDate<today?700:400}}>{ms.plannedDate<today?"⏰ ":""}Bill on: {ms.plannedDate}</span>}
                        <span title="Month this revenue is counted in the chart. Click Edit to change.">
                          <span style={{color:"#94a3b8"}}>Rev. Period: </span>
                          <strong style={{color:"#8b5cf6"}}>{(()=>{const d=new Date(ms.invoiceDate||ms.dueDate||"");return isNaN(d.getTime())?"Not set":d.toLocaleDateString("en-PH",{month:"short",year:"numeric"});})()}</strong>
                        </span>
                      </div>
                      {/* Progress */}
                      <div style={{height:5,background:"#e2e8f0",borderRadius:3,overflow:"hidden",marginBottom:6}}>
                        <div style={{height:"100%",width:pct+"%",background:pct>=100?"#10b981":"#3b82f6",borderRadius:3,transition:"width .5s"}}/>
                      </div>
                      {/* Payment history */}
                      {(ms.payments||[]).length>0&&(
                        <div style={{background:"#f0fdf4",borderRadius:7,padding:"7px 10px",marginTop:4}}>
                          <div style={{fontSize:".67rem",fontWeight:700,color:"#059669",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>Payments</div>
                          {(ms.payments||[]).map(p=>(
                            <div key={p.id}>
                              {editPay?.msId===ms.id&&editPay?.payId===p.id&&canPayDeal(deal)?(
                                <div style={{background:"#fff",borderRadius:7,padding:"8px",border:"1.5px solid #93c5fd",marginBottom:4}}>
                                  <div style={{fontWeight:700,color:"#1d4ed8",marginBottom:6,fontSize:".78rem"}}>Edit Payment</div>
                                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:6}}>
                                    <Fld label="Amount (₱)"><Inp type="number" value={editPayForm.amount??p.amount} onChange={e=>setEditPayForm(f=>({...f,amount:e.target.value}))}/></Fld>
                                    <Fld label="Date"><Inp type="date" value={editPayForm.date??p.date??today} onChange={e=>setEditPayForm(f=>({...f,date:e.target.value}))}/></Fld>
                                    <Fld label="Bank"><Sel value={editPayForm.bank??p.bank??""} onChange={e=>setEditPayForm(f=>({...f,bank:e.target.value}))}><option value="">— Select bank</option>{BANKS.map(b=><option key={b.id} value={b.id}>{b.short}</option>)}<option value="cash">Cash</option></Sel></Fld>
                                    <Fld label="Method"><Sel value={editPayForm.method??p.method??"Bank Transfer"} onChange={e=>setEditPayForm(f=>({...f,method:e.target.value}))}>{PAYMENT_METHODS.map(m=><option key={m} value={m}>{m}</option>)}{(canonRole(role)==="Manager"||isOffsetPayment(p))&&<option value={OFFSET_METHOD}>{OFFSET_METHOD} (no cash)</option>}</Sel></Fld>
                                    <Fld label="Value Date"><Inp type="date" value={editPayForm.valueDate??p.valueDate??""} onChange={e=>setEditPayForm(f=>({...f,valueDate:e.target.value}))}/></Fld>
                                    <Fld label="Reference No."><Inp value={editPayForm.refNo??p.refNo??""} onChange={e=>setEditPayForm(f=>({...f,refNo:e.target.value}))} placeholder="Ref…"/></Fld>
                                    <Fld label="Note"><Inp value={editPayForm.note??p.note??""} onChange={e=>setEditPayForm(f=>({...f,note:e.target.value}))} placeholder="Note…"/></Fld>
                                  </div>
                                  <div style={{display:"flex",gap:6,marginTop:6}}>
                                    <button onClick={async()=>{
                                      const amt=Number(editPayForm.amount??p.amount);
                                      if(!isFinite(amt)||amt<=0){toastEmit("Enter a payment amount greater than zero.","warning");return;}
                                      // #3 Overpayment cap on edit (Add already enforces this).
                                      const eTx=calcTax(ms.amount,ms.receiptType??deal?.receiptType??"OR",ms.withholding??deal?.withholding??false);
                                      const otherPaid=(ms.payments||[]).filter(px=>px.id!==p.id&&!px.bounced).reduce((s,px)=>s+Number(px.amount||0),0);
                                      const eBalance=Math.max(0,eTx.netReceivable-otherPaid);
                                      if(amt>eBalance+0.01){toastEmit(`Payment ₱${amt.toLocaleString("en-PH")} exceeds the milestone balance of ₱${eBalance.toLocaleString("en-PH")}.`,"warning");return;}
                                      // #4 Date sanity — warn (not block) on illogical dates.
                                      const nDate=editPayForm.date??p.date;
                                      const nVal=editPayForm.valueDate??p.valueDate;
                                      if(nDate&&nDate>today&&!(await uiConfirm("The Date Received is in the future. Save anyway?")))return;
                                      if(nDate&&nVal&&nVal<nDate&&!(await uiConfirm("The Value Date is before the Date Received (funds credited before payment received?). Save anyway?")))return;
                                      const updated={...p,...editPayForm,amount:amt};
                                      if(isOffsetPayment(updated)||isOffsetPayment(p)){
                                        if(canonRole(role)!=="Manager"){toastEmit("Only a Manager can record or change an offset / credit note.","error",8000);return;}
                                        if(isOffsetPayment(updated)&&!String(updated.refNo||"").trim()){toastEmit("An offset needs the credit note or agreement no. in Reference No.","warning",8000);return;}
                                      }
                                      updateMilestone(ms.id,{payments:(ms.payments||[]).map(px=>px.id===p.id?updated:px)},{action:"Payment Edited",detail:`${ms.name||"Milestone"}: ₱${Number(p.amount||0).toLocaleString("en-PH")} → ₱${amt.toLocaleString("en-PH")}`});
                                      setEditPay(null);setEditPayForm({});
                                    }} style={{background:"#1d4ed8",border:"none",borderRadius:6,padding:"5px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",color:"#fff",cursor:"pointer"}}>Save</button>
                                    <button onClick={()=>{setEditPay(null);setEditPayForm({});}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:6,padding:"5px 10px",fontFamily:"inherit",fontSize:".75rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
                                  </div>
                                </div>
                              ):(
                                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:2,gap:4}}>
                                  <div style={{display:"flex",gap:8,fontSize:".73rem",color:"#475569",flexWrap:"wrap",flex:1,alignItems:"center"}}>
                                    <span>{p.date}</span>
                                    <span style={{fontWeight:700,color:"#059669"}}>₱{n(p.amount).toLocaleString("en-PH")}</span>
                                    {p.method&&<span style={{color:"#64748b"}}>{p.method}</span>}
                                    {p.bank&&<span style={{color:"#64748b"}}>🏦 {p.bank==="cash"?"Cash":(BANKS.find(x=>x.id===p.bank)?.short||p.bank)}</span>}
                                    {(()=>{
                                      if(isOffsetPayment(p)) return <span style={{fontSize:".65rem",fontWeight:700,padding:"1px 7px",borderRadius:20,background:"#f5f3ff",color:"#7c3aed"}}>🔁 Offset — no cash</span>;
                                      const cd=paymentClearDate(p);
                                      if(p.bounced) return <span style={{fontSize:".65rem",fontWeight:700,padding:"1px 7px",borderRadius:20,background:"#fef2f2",color:"#dc2626"}}>✕ Bounced</span>;
                                      if(isPaymentCleared(p,today)) return <span style={{fontSize:".65rem",fontWeight:700,padding:"1px 7px",borderRadius:20,background:"#f0fdf4",color:"#059669"}}>✓ Cleared{cd&&cd!==p.date?` ${cd}`:""}</span>;
                                      return <span style={{fontSize:".65rem",fontWeight:700,padding:"1px 7px",borderRadius:20,background:"#fffbeb",color:"#b45309"}}>⏳ Clears {cd||"—"}</span>;
                                    })()}
                                    {p.refNo&&<span style={{color:"#64748b"}}>Ref: {p.refNo}</span>}
                                    {p.note&&<span style={{color:"#94a3b8",fontStyle:"italic"}}>{p.note}</span>}
                                  </div>
                                  {canPayDeal(deal)&&(!isOffsetPayment(p)||canonRole(role)==="Manager")&&(
                                    <div style={{display:"flex",gap:4,flexShrink:0}}>
                                      {!p.bounced&&!isOffsetPayment(p)&&!isPaymentCleared(p,today)&&(
                                        <button onClick={()=>updateMilestone(ms.id,{payments:(ms.payments||[]).map(px=>px.id===p.id?{...px,valueDate:today,bounced:false}:px)},{action:"Payment Cleared",detail:`${ms.name||"Milestone"}: ₱${Number(p.amount||0).toLocaleString("en-PH")} marked cleared`})}
                                          title="Mark funds cleared today"
                                          style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:5,padding:"2px 7px",fontFamily:"inherit",fontSize:".65rem",color:"#059669",cursor:"pointer",fontWeight:600}}>✓ Clear</button>
                                      )}
                                      {!p.bounced&&!isOffsetPayment(p)&&(
                                        <button onClick={async ()=>{if((await uiConfirm("Mark this collection as bounced? It will stop counting as cleared cash.")))updateMilestone(ms.id,{payments:(ms.payments||[]).map(px=>px.id===p.id?{...px,bounced:true}:px)},{action:"Payment Bounced",detail:`${ms.name||"Milestone"}: ₱${Number(p.amount||0).toLocaleString("en-PH")} marked bounced`});}}
                                          title="Mark cheque bounced"
                                          style={{background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:5,padding:"2px 7px",fontFamily:"inherit",fontSize:".65rem",color:"#c2410c",cursor:"pointer",fontWeight:600}}>⤺</button>
                                      )}
                                      {p.bounced&&(
                                        <button onClick={()=>updateMilestone(ms.id,{payments:(ms.payments||[]).map(px=>px.id===p.id?{...px,bounced:false}:px)},{action:"Payment Restored",detail:`${ms.name||"Milestone"}: ₱${Number(p.amount||0).toLocaleString("en-PH")} un-bounced`})}
                                          title="Un-bounce"
                                          style={{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:5,padding:"2px 7px",fontFamily:"inherit",fontSize:".65rem",color:"#059669",cursor:"pointer",fontWeight:600}}>↺</button>
                                      )}
                                      <button onClick={()=>{setEditPay({msId:ms.id,payId:p.id});setEditPayForm({});}}
                                        style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:5,padding:"2px 7px",fontFamily:"inherit",fontSize:".65rem",color:"#1d4ed8",cursor:"pointer",fontWeight:600}}>✏</button>
                                      <button onClick={async ()=>{if((await uiConfirm("Remove this payment? This will reverse the collected amount.")))deleteBillingPayment(ms.id,p.id);}}
                                        style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:5,padding:"2px 7px",fontFamily:"inherit",fontSize:".65rem",color:"#dc2626",cursor:"pointer",fontWeight:600}}>×</button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                      {/* Edit milestone inline */}
                      {editMs===ms.id&&canEdit&&(
                        <div style={{background:"#eff6ff",borderRadius:8,padding:"10px 12px",border:"1.5px solid #93c5fd",marginTop:8}}>
                          <div style={{fontWeight:700,color:"#1d4ed8",marginBottom:8,fontSize:".82rem"}}>Edit Milestone</div>
                          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:8}}>
                            <Fld label="Milestone Name"><Inp value={editMsForm.name||""} onChange={e=>fme("name",e.target.value)} placeholder="e.g. 30% Down Payment"/></Fld>
                            <Fld label="Amount (₱)"><Inp type="number" value={editMsForm.amount||""} onChange={e=>fme("amount",e.target.value)} placeholder="0.00"/></Fld>
                            <Fld label="Invoice No"><Inp value={editMsForm.invoiceNo||""} onChange={e=>fme("invoiceNo",e.target.value)} placeholder="INV-0001"/></Fld>
                            <Fld label="Invoice Date"><Inp type="date" value={editMsForm.invoiceDate||""} onChange={e=>fme("invoiceDate",e.target.value)}/></Fld>
                            {editMsForm.isDraft&&<Fld label="Bill on" hint="When this invoice should go out. Billing Check flags it 3 days after."><Inp type="date" value={editMsForm.plannedDate||""} onChange={e=>fme("plannedDate",e.target.value)}/></Fld>}
                            <Fld label="Due Date" required hint={!editMsForm.dueDate?"Recommended — drives the cash-flow forecast.":undefined}><Inp type="date" value={editMsForm.dueDate||""} onChange={e=>fme("dueDate",e.target.value)}/></Fld>
                            <Fld label="Description"><Inp value={editMsForm.description||""} onChange={e=>fme("description",e.target.value)} placeholder="Optional details…"/></Fld>
                            <Fld label="Receipt Type" hint={`Deal default: ${deal?.receiptType||"OR"}`}>
                              <Sel value={editMsForm.receiptType||""} onChange={e=>fme("receiptType",e.target.value||null)}>
                                <option value="">{deal?.receiptType?`— Use Project Default (${deal.receiptType}) —`:"— Not set (decide in BOQ) —"}</option>
                                <option value="OR">OR (Official Receipt)</option>
                                <option value="AR">AR (Acknowledgement Receipt)</option>
                              </Sel>
                            </Fld>
                            <Fld label="Withholding Tax (EWT 2%)" hint={`Deal default: ${deal?.withholding?"Yes":"No"}`}>
                              <Sel value={editMsForm.withholding==null?"":String(editMsForm.withholding)} onChange={e=>fme("withholding",e.target.value===""?null:e.target.value==="true")}>
                                <option value="">— Use Deal Default ({deal?.withholding?"Yes":"No"}) —</option>
                                <option value="true">Yes — apply 2% EWT deduction</option>
                                <option value="false">No — no withholding</option>
                              </Sel>
                            </Fld>
                          </div>
                          <div style={{display:"flex",gap:8,marginTop:8}}>
                            <button onClick={saveEditMs} style={{background:"#1d4ed8",border:"none",borderRadius:7,padding:"7px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:"#fff",cursor:"pointer"}}>Save Changes</button>
                            <button onClick={()=>{setEditMs(null);setEditMsForm({});}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 12px",fontFamily:"inherit",fontWeight:600,fontSize:".78rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
                          </div>
                        </div>
                      )}
                      {/* Log payment inline */}
                      {showPay===ms.id&&canPayDeal(deal)&&(
                        <div style={{background:"#eff6ff",borderRadius:8,padding:"10px 12px",border:"1.5px solid #93c5fd",marginTop:8}}>
                          <div style={{fontWeight:700,color:"#1d4ed8",marginBottom:8,fontSize:".82rem"}}>Log Payment</div>
                          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:8}}>
                            <Fld label="Amount (₱)"><Inp type="number" value={payForm.amount} onChange={e=>fp("amount",e.target.value)} placeholder="0.00"/></Fld>
                            {!isOffsetPayment(payForm)&&<Fld label="Bank Deposited To">
                              <Sel value={payForm.bank||""} onChange={e=>fp("bank",e.target.value)}>
                                <option value="">— Select Bank —</option>
                                {[...BANKS.map(b=>({v:b.id,l:b.short})),{v:"cash",l:"Cash"}].map(b=><option key={b.v} value={b.v}>{b.l}</option>)}
                              </Sel>
                            </Fld>}
                            <Fld label="Payment Method">
                              <Sel value={payForm.method||"Bank Transfer"} onChange={e=>fp("method",e.target.value)}>
                                {PAYMENT_METHODS.map(m=><option key={m} value={m}>{m}</option>)}
                                {canonRole(role)==="Manager"&&<option value={OFFSET_METHOD}>{OFFSET_METHOD} (no cash)</option>}
                              </Sel>
                            </Fld>
                            <Fld label={isOffsetPayment(payForm)?"Date Settled":"Date Received"}><Inp type="date" value={payForm.date} onChange={e=>fp("date",e.target.value)}/></Fld>
                            {!isOffsetPayment(payForm)&&<Fld label="Value Date" hint={payForm.method==="Cheque"?"When the cheque clears — blank = auto ~3 banking days":"When funds are available — blank = same day"}><Inp type="date" value={payForm.valueDate||""} onChange={e=>fp("valueDate",e.target.value)}/></Fld>}
                            <Fld label={isOffsetPayment(payForm)?"Credit Note / Agreement No.":"Reference No."} required={isOffsetPayment(payForm)}><Inp value={payForm.refNo} onChange={e=>fp("refNo",e.target.value)} placeholder={isOffsetPayment(payForm)?"e.g. CN-0001":"Cheque / transfer ref…"}/></Fld>
                            <Fld label={isOffsetPayment(payForm)?"What was offset":"Note"} required={isOffsetPayment(payForm)}><Inp value={payForm.note} onChange={e=>fp("note",e.target.value)} placeholder={isOffsetPayment(payForm)?"e.g. Cancels GMD's debt to Makerlab":"e.g. BPI online transfer"}/></Fld>
                          </div>
                          {payForm.amount&&payForm.date&&(
                            <div style={{fontSize:".72rem",color:isOffsetPayment(payForm)?"#7c3aed":"#64748b",marginTop:6}}>
                              {isOffsetPayment(payForm)?"🔁 Settles the invoice without cash — not counted in Cash Flow or collection charts.":(()=>{const cd=paymentClearDate({...payForm,method:payForm.method});const cleared=isPaymentCleared({...payForm,method:payForm.method},today);return cleared?`✅ Clears immediately — counts as available cash on ${cd}.`:`⏳ Pending clearance — funds count as available cash on ${cd}.`;})()}
                            </div>
                          )}
                          <div style={{display:"flex",gap:8,marginTop:8}}>
                            <button onClick={submitPay} disabled={!payForm.amount}
                              style={{background:payForm.amount?"#1d4ed8":"#e2e8f0",border:"none",borderRadius:7,padding:"7px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:payForm.amount?"#fff":"#94a3b8",cursor:payForm.amount?"pointer":"not-allowed"}}>
                              {isOffsetPayment(payForm)?"Record Offset":"Save Payment"}
                            </button>
                            <button onClick={()=>setShowPay(null)} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 12px",fontFamily:"inherit",fontWeight:600,fontSize:".78rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
                          </div>
                        </div>
                      )}
                    {/* Deductions (Manager-only; kept in billing_deductions, reversed rows stay listed) */}
                    {(()=>{
                      const deds=(ms.deductions||[]);
                      const totalDed=deds.filter(d=>!d.reversedAt).reduce((s,d)=>s+Number(d.amount||0),0);
                      const isMgrB=canonRole(role)==="Manager";
                      const reverseDed=async(d)=>{
                        const why=await uiPrompt(`Reverse the ₱${Number(d.amount).toLocaleString("en-PH")} deduction ("${d.reason}")?\n\nThe amount goes back on ${ms.name||"this milestone"}. The deduction stays on record, marked reversed.\nReason (required):`,"");
                        if(why==null) return;
                        if(!String(why).trim()){toastEmit&&toastEmit("A reason is required to reverse a deduction.","warning");return;}
                        const{data,error}=await _rpcWithTimeout(supabase.rpc('reverse_billing_deduction',{p_id:d.id,p_reason:String(why).trim()}));
                        if(error){toastEmit&&toastEmit("Deduction not reversed: "+error.message,"error",9000);return;}
                        applyDeduction(ms.id,data);
                        sendTelegramNotification&&sendTelegramNotification("financialcontrol",`↺ <b>Billing Deduction Reversed — ${deal?.client||""}</b>\nMilestone: ${ms.name}${ms.invoiceNo?` (${ms.invoiceNo})`:""}\nRestored: ₱${Number(d.amount).toLocaleString("en-PH")}\nOriginal reason: ${d.reason}\nWhy reversed: ${data.reverse_reason}\nBy: ${session?.name||data.reversed_by} · ${today}`);
                        toastEmit&&toastEmit("Deduction reversed — amount restored","success");
                      };
                      return(
                        <div style={{marginTop:8}}>
                          {deds.length>0&&(
                            <div style={{background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:8,padding:"8px 12px",marginBottom:6}}>
                              <div style={{fontSize:".67rem",fontWeight:700,color:"#c2410c",marginBottom:5,textTransform:"uppercase",letterSpacing:".5px"}}>Deductions — ₱{totalDed.toLocaleString("en-PH")} in effect</div>
                              {deds.map((d,di)=>(
                                <div key={d.id||di} style={{display:"flex",justifyContent:"space-between",fontSize:".72rem",color:d.reversedAt?"#94a3b8":"#78350f",marginBottom:3,gap:8,alignItems:"center"}}>
                                  <div>
                                    <span style={{fontWeight:700,textDecoration:d.reversedAt?"line-through":"none"}}>₱{Number(d.amount).toLocaleString("en-PH")}</span>
                                    <span style={{margin:"0 5px",color:"#c2410c"}}>·</span>
                                    <span style={{textDecoration:d.reversedAt?"line-through":"none"}}>{d.reason}</span>
                                    {d.approvedBy&&<span style={{color:"#059669",fontWeight:600,marginLeft:6}}>✓ {d.approvedBy} · {d.approvedOn}</span>}
                                    {d.reversedAt&&<span style={{color:"#64748b",fontWeight:600,marginLeft:6}}>↺ Reversed by {d.reversedBy} · {String(d.reversedAt).slice(0,10)} — {d.reverseReason}</span>}
                                  </div>
                                  {isMgrB&&!d.reversedAt&&<button onClick={()=>reverseDed(d)} title="Put the amount back (the record is kept)" style={{background:"none",border:"1px solid #fed7aa",borderRadius:5,color:"#c2410c",cursor:"pointer",fontSize:".65rem",padding:"1px 7px",fontFamily:"inherit",fontWeight:600}}>↺ Reverse</button>}
                                </div>
                              ))}
                            </div>
                          )}
                          {isMgrB&&ms.status!=="Cancelled"&&<DeductionForm ms={ms} applyDeduction={applyDeduction} session={session} today={today} toastEmit={toastEmit} sendTelegramNotification={sendTelegramNotification} deal={deal}/>}
                        </div>
                      );
                    })()}
                    </div>
                    {/* Action buttons */}
                    <div style={{display:"flex",flexDirection:"column",gap:5,flexShrink:0}}>
                      <button onClick={()=>printInvoice(ms)} style={{background:"#1e293b",border:"none",borderRadius:7,padding:"6px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",color:"#fff",cursor:"pointer"}}>🖨 Billing Statement</button>
                      <button onClick={()=>shareInvoicePdf(ms)} disabled={billingPdf.busy} title="Billing statement as a PDF to share (Viber, Mail, Files) or download" style={{background:"#ecfeff",border:"1.5px solid #67e8f9",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",color:"#155e75",cursor:billingPdf.busy?"wait":"pointer"}}>{billingPdf.busy?"Making PDF…":"📤 Billing PDF"}</button>
                      {canPayDeal(deal)&&ms.status!=="Fully Paid"&&ms.status!=="Cancelled"&&(
                        <button onClick={()=>{const opening=showPay!==ms.id;setShowPay(showPay===ms.id?null:ms.id);if(opening){const totalPaid=(ms.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);const bal=tx.netReceivable-totalPaid;setPayForm(p=>({...p,amount:bal>0?bal:tx.netReceivable}));}}} style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:7,padding:"6px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",color:"#059669",cursor:"pointer"}}>+ Payment</button>
                      )}
                      {canEdit&&!canPayDeal(deal)&&ms.status!=="Fully Paid"&&ms.status!=="Cancelled"&&(
                        <div title="Your commission rides on this deal's collections, so Finance or a Manager records them." style={{fontSize:".65rem",color:"#94a3b8",maxWidth:120,lineHeight:1.3}}>Your deal: Finance logs its payments</div>
                      )}
                      {canEdit&&<button onClick={()=>{setEditMs(editMs===ms.id?null:ms.id);setEditMsForm({name:ms.name,description:ms.description||"",amount:String(ms.amount||""),invoiceNo:ms.invoiceNo||"",invoiceDate:ms.invoiceDate||today,dueDate:ms.dueDate||"",plannedDate:ms.plannedDate||"",isDraft:ms.status==="Draft",receiptType:ms.receiptType??null,withholding:ms.withholding??null});setShowPay(null);}} style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:7,padding:"6px 12px",fontFamily:"inherit",fontWeight:700,fontSize:".75rem",color:"#1d4ed8",cursor:"pointer"}}>✏ Edit</button>}
                      {canEdit&&<select value={ms.status} onChange={e=>updateMilestone(ms.id,{status:e.target.value})} style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 8px",fontFamily:"inherit",fontSize:".72rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>{BILLING_STATUSES.map(s=><option key={s}>{s}</option>)}</select>}
                      {canEdit&&<button onClick={()=>deleteMilestone(ms.id)} title="Delete this milestone (archived to Audit Trail)" style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:7,padding:"5px",fontFamily:"inherit",fontWeight:600,fontSize:".7rem",color:"#dc2626",cursor:"pointer"}}>Delete</button>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── PROJECT CARDS ────────────────────────────────────────────────────────────
function TATSetter({deal,card,onSet,refTable,ceType}){
  const[open,setOpen]    =useState(!card?.targetDays);
  const[date,setDate]    =useState(card?.targetEndDate||"");
  const[category,setCategory]=useState(card?.tatCategory||"");

  const refEntries=Object.entries(refTable||{});

  const awardPlusDays=days=>{
    const base=card?.awardDate||new Date().toISOString().split("T")[0];
    const d=new Date(base); d.setDate(d.getDate()+Number(days));
    return d.toISOString().split("T")[0];
  };

  const computedDays=date&&card?.awardDate
    ?Math.ceil((new Date(date)-new Date(card.awardDate))/86400000)
    :null;

  if(!open) return(
    <button onClick={()=>setOpen(true)}
      style={{background:"transparent",border:"1.5px solid #6ee7b7",borderRadius:8,padding:"6px 14px",fontFamily:"inherit",fontWeight:600,fontSize:".78rem",color:"#059669",cursor:"pointer"}}>
      ✏ Edit TAT
    </button>
  );

  const canSave=date&&(computedDays===null||computedDays>=0);

  return(
    <div style={{background:"#fff",borderRadius:10,border:"1.5px solid #e2e8f0",padding:"12px 14px",minWidth:280}}>
      <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem",marginBottom:10}}>Set Turnover Date</div>

      {/* Reference table — click to pre-fill date */}
      <div style={{marginBottom:10}}>
        <div style={{fontSize:".68rem",fontWeight:700,color:"#94a3b8",textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>
          {ceType} — Reference (click to apply)
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:160,overflowY:"auto"}}>
          {refEntries.map(([cat,ref])=>(
            <div key={cat} {...clickable(()=>{setCategory(cat);setDate(awardPlusDays(ref.days));})} aria-label={`Select category ${cat}`}
              style={{display:"flex",justifyContent:"space-between",padding:"5px 8px",borderRadius:6,cursor:"pointer",background:category===cat?"#eff6ff":"#f8fafc",border:`1px solid ${category===cat?"#93c5fd":"#f1f5f9"}`,transition:"all .1s"}}
              onMouseEnter={e=>e.currentTarget.style.background="#eff6ff"}
              onMouseLeave={e=>e.currentTarget.style.background=category===cat?"#eff6ff":"#f8fafc"}>
              <span style={{fontSize:".75rem",color:"#0f172a",fontWeight:category===cat?700:400}}>{cat}</span>
              <span style={{fontSize:".75rem",color:"#3b82f6",fontWeight:700,flexShrink:0,marginLeft:8}}>{ref.days}d</span>
            </div>
          ))}
        </div>
      </div>

      {/* Date picker */}
      <div style={{display:"flex",flexDirection:"column",gap:4,marginTop:8}}>
        <span style={{fontSize:".72rem",color:"#64748b"}}>Turnover date</span>
        <input type="date" value={date} onChange={e=>{setDate(e.target.value);setCategory("");}}
          style={{border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 10px",fontFamily:"inherit",fontSize:".88rem",color:"#0f172a",outline:"none"}}/>
      </div>

      {computedDays!==null&&(
        <div style={{fontSize:".73rem",color:computedDays<0?"#ef4444":"#059669",marginTop:6,fontWeight:600}}>
          {computedDays<0?"⚠ Date is before award date":`→ ${computedDays} days from award date`}
        </div>
      )}

      <div style={{display:"flex",gap:8,marginTop:10}}>
        <button onClick={()=>{if(canSave)onSet(card.dealId,date,category);setOpen(false);}}
          disabled={!canSave}
          style={{background:canSave?"#1e293b":"#e2e8f0",border:"none",borderRadius:8,padding:"8px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",color:canSave?"#fff":"#94a3b8",cursor:canSave?"pointer":"not-allowed"}}>
          Set Target
        </button>
        <button onClick={()=>setOpen(false)}
          style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 12px",fontFamily:"inherit",fontWeight:600,fontSize:".78rem",color:"#64748b",cursor:"pointer"}}>
          Cancel
        </button>
      </div>
    </div>
  );
}

// ─── INVENTORY VIEW ───────────────────────────────────────────────────────────
function ProjectCards({changeDealStage,setProjectProgress,syncProjectCard,pcards,wonDeals,completedDeals,deals,toggleDeptTask,markDeptDone,setProjectTAT,jos,delDeal,delPcard,session,role,budgets,blockers,addBlocker,resolveBlocker,logActivity,actLog,addenda,billings,mreqs,breqs,prs=[],exps=[],isMobile,createCard,updateJO,upPcards,addAddendum2,checklist,openAddCl,openEditCl,delCl,clStatusQ,clModal,setClModal,clForm,setClForm,editCl,saveCl,upDeals,ceReqs,toastEmit,sendTelegramNotification,initialDeal,clearJump,initialFilter,clearJumpFilter,loadChecklistTemplate,swos=[],addPmUpdate,setConfirmDel,customMembers=[],setCustomMembers=()=>{},setPage=()=>{},setJumpDeal=()=>{}}){
  const todayStr=new Date().toISOString().split("T")[0];
  const[selDealRaw,setSelDeal]=useState(initialDeal||null);
  // A selection whose deal isn't loaded/won (deleted, moved to a lost stage, or a
  // jump-link opened before data arrived) counts as no selection. Derived during
  // render, because the clean-up effect below only runs AFTER a render — and that
  // one render against deal===undefined crashed the Projects page on deal.id.
  const deal=wonDeals.find(d=>d.id===selDealRaw)||completedDeals.find(d=>d.id===selDealRaw);
  const selDeal=deal?selDealRaw:null;
  // An addendum (child deal) has no project card of its own — it rolls into its
  // parent's card — so a jump-link carrying the child's id opens the parent.
  // Standby PO jobs are the exception: they ARE the cards (umbrella is hidden).
  useEffect(()=>{if(initialDeal){const all=[...wonDeals,...completedDeals];const jd=all.find(d=>d.id===initialDeal);const par=jd?.parentDealId?all.find(d=>d.id===jd.parentDealId):null;const pid=par&&!par.standbyPO?par.id:initialDeal;setSelDeal(pid);clearJump&&clearJump();}},[]);
  useEffect(()=>{if(initialFilter){setPcFilter(initialFilter);clearJumpFilter&&clearJumpFilter();}},[]);
  // If the open project was deleted (e.g. via the delete button below → the
  // global confirm modal → delDeal), it vanishes from wonDeals/completedDeals;
  // fall back to the grid (selDeal above already renders it as unselected).
  useEffect(()=>{if(selDealRaw&&!deal)setSelDeal(null);},[selDealRaw,deal]);
  const[viewMode,setViewMode]=useState("card");
  const[showTeamLoad,setShowTeamLoad]=useState(false);
  const[teamLoadTab,setTeamLoadTab]=useState("pm");
  const[pcOwner,setPcOwner]=useState(null); // {tab:"pm"|"coor"|"subcon",name}
  const[pcFilter,setPcFilter]=useState(null);
  const[pcDeptFilter,setPcDeptFilter]=useState("All");
  const[pcSort,setPcSort]=useState("tat");
  const[pcShowClosed,setPcShowClosed]=useState(false);
  const[pcSearch,setPcSearch]=useState("");
  const[showBForm,setShowBForm]=useState(false);
  const[bfTitle,setBfTitle]=useState(""); const[bfDept,setBfDept]=useState("Operations"); const[bfDetail,setBfDetail]=useState("");
  const[showUForm,setShowUForm]=useState(false); const[uText,setUText]=useState("");
  const[tatOpen,setTatOpen]=useState(false);
  const[showTeamEdit,setShowTeamEdit]=useState(false);
  const[teamForm,setTeamForm]=useState({ae:"",pm1:"",pm2:"",pm3:"",designer:"",coordinator:"",warehouseOnly:false});
  const[showScopeForm,setShowScopeForm]=useState(false);
  const[scopeForm,setScopeForm]=useState({title:"",desc:"",value:"",ceNo:""});
  const fsc=(k,v)=>setScopeForm(p=>({...p,[k]:v}));
  const[showDateEdit,setShowDateEdit]=useState(false);
  const[dateForm,setDateForm]=useState({awardDate:"",targetEndDate:""});
  const fdt=(k,v)=>setDateForm(p=>({...p,[k]:v}));
  const[pmUpdateModal,setPmUpdateModal]=useState(null);

  // useMemo — projectCostBreakdown scans the FULL company-wide prs/exps arrays,
  // and the blockers/actLog/addenda/billings filters scan full company-wide
  // lists too. Without this, opening a project card recomputed all of it on
  // every keystroke into any of this component's own local forms (blocker
  // flag, PM update, team edit, scope/date edit — all local state that
  // re-renders this whole component).
  const projStats=useMemo(()=>{
    const projBlockers=(blockers||[]).filter(b=>b.dealId===selDeal);
    const openProjB=projBlockers.filter(b=>b.status==="Open");
    const projUpdates=(actLog||[]).filter(a=>a.dealId===selDeal&&a.action==="PM Update").sort((a,b)=>b.date.localeCompare(a.date)).slice(0,3);
    const projAddenda=(addenda||[]).filter(a=>a.dealId===selDeal);
    const projBillings=(billings||[]).filter(b=>b.dealId===selDeal);
    const totalBilled=projBillings.filter(b=>b.status!=='Cancelled').reduce((s,b)=>s+Number(b.amount||0),0);
    const totalColl=projBillings.reduce((s,b)=>s+(b.payments||[]).reduce((ps,p)=>ps+Number(p.amount||0),0),0);
    const {committed:projCommitted,actual:projActual}=projectCostBreakdown(selDeal,prs,exps);
    const totalCommitted=BUDGET_CATS.reduce((s,c)=>s+projCommitted[c],0);
    const totalActualCost=BUDGET_CATS.reduce((s,c)=>s+projActual[c],0);
    const totalExposure=totalCommitted+totalActualCost;
    const pendingMRs=(mreqs||[]).filter(m=>m.projectId===selDeal&&(m.status==="Submitted"||m.status==="Reviewed")).length;
    const pendingBRs=(breqs||[]).filter(b=>(b.projectId===selDeal||b.dealId===selDeal)&&(b.status==="Pending"||b.status==="Under Review")).length;
    return{projBlockers,openProjB,projUpdates,projAddenda,projBillings,totalBilled,totalColl,projCommitted,projActual,totalCommitted,totalActualCost,totalExposure,pendingMRs,pendingBRs};
  },[selDeal,blockers,actLog,addenda,billings,prs,exps,mreqs,breqs]);

  const today2=new Date();
  const card=selDeal?pcards[selDeal]:null;
  const jo=dealJo(jos,selDeal);

  const PHASES=[
    {id:"design",    label:"Design",     icon:"🎨", stgs:["06 · Kickoff","07 · Briefing"]},
    {id:"fab",       label:"Fabrication",icon:"🔨", stgs:["08 · Fabrication"]},
    {id:"site",      label:"Site",       icon:"🏗",  stgs:["09 · Site & Billing","10 · Installation"]},
    {id:"punchlist", label:"Punchlist",  icon:"📋", stgs:["11 · Punchlist"]},
    {id:"closeout",  label:"Close-Out",  icon:"✅", stgs:["12 · Close-Out","14 · Completed"]},
  ];
  const phaseIdx=stg=>PHASES.findIndex(p=>p.stgs.includes(stg));

  const fmt=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:0});
  const BUDGET_ONLY_PC=["Design","Operations","ProjectMover"];
  const pcAmt=d=>{
    if(!BUDGET_ONLY_PC.includes(role))return fmt(d?.value);
    const b=(budgets||{})[d?.id]||{};
    const t=["Materials","Labor","Overhead","Subcon"].reduce((s,k)=>s+Number(b[k]||0),0);
    return t>0?fmt(t)+" 📊":"Budget Pending";
  };
  const editableDepts={Manager:DEPT_ORDER,Sales:["Sales"],Design:["Design"],QS:["QS"],Procurement:["Procurement"],Operations:["Operations"],Finance:["Finance"],SalesOpsAdmin:DEPT_ORDER}[role]||[];
  const projPct=(pc,deal=null)=>{if(deal?.stage==="12 · Close-Out"||deal?.stage==="14 · Completed")return 100;return pc?(pc.manualProgress!=null?pc.manualProgress:Math.round(Object.values(pc.departments||{}).filter(d=>d.done).length/6*100)):0;};
  const getHealth=(d,pc)=>{
    if(!pc||!d)return "none";
    const end=pc.targetEndDate?new Date(pc.targetEndDate):null;
    const ob=(blockers||[]).some(b=>b.status==="Open"&&b.dealId===d.id);
    if(end&&today2>end)return "red";
    if(ob)return "yellow";
    if(end){const dl=Math.ceil((end-today2)/86400000);if(dl/(pc.targetDays||30)<0.25)return "yellow";}
    return "green";
  };
  const HC={green:["#10b981","On Track"],yellow:["#f59e0b","At Risk"],red:["#ef4444","Overdue"],none:["#94a3b8","No TAT"]};

  const calcCardGrade=(deal,pc)=>{
    if(!pc||!deal) return{score:0,grade:"F",color:"#ef4444",gcolor:"#fef2f2",breakdown:{completeness:{earned:0,max:40,items:{hasPM:false,hasDate:false,hasBudget:false,hasDesigner:false,hasCE:false}},recency:{earned:0,max:30,label:"No updates yet",count:0},timeline:{earned:0,max:30,label:"—"}}};
    let score=0;
    // ─ Completeness (40pts) ────────────────────────────────────────────────
    const joR=dealJo(jos,deal.id);
    const hasPM=!!(pc.pm1||joR?.pm1);
    const hasDate=!!pc.targetEndDate;
    const b=budgets[deal.id];
    const hasBudget=b&&["Materials","Labor","Overhead","Subcon"].some(k=>Number(b[k]||0)>0);
    const hasDesigner=!!(pc.designer||joR?.designer);
    const hasCE=!!deal.ceNo;
    const completeness=(hasPM?10:0)+(hasDate?12:0)+(hasBudget?10:0)+(hasDesigner?5:0)+(hasCE?3:0);
    score+=completeness;
    // ─ Update recency (30pts) ─────────────────────────────────────────────
    const updates=(actLog||[]).filter(a=>a.dealId===deal.id&&a.action==="PM Update");
    const lastUpd=updates[0];
    let recency=0,recencyLabel="No updates yet";
    if(lastUpd){
      const ds=Math.ceil((today2-new Date(lastUpd.date))/86400000);
      if(ds<=2){recency=30;recencyLabel=ds===0?"Today":ds===1?"Yesterday":`${ds}d ago`;}
      else if(ds<=7){recency=22;recencyLabel=`${ds}d ago`;}
      else if(ds<=14){recency=12;recencyLabel=`${ds}d ago`;}
      else if(ds<=30){recency=5;recencyLabel=`${ds}d ago`;}
      else{recency=0;recencyLabel=`${ds}d ago (stale)`;}
    }
    score+=recency;
    // ─ Timeline health (30pts) ────────────────────────────────────────────
    let timeline=10,timelineLabel="No target date";
    const end=pc.targetEndDate?new Date(pc.targetEndDate):null;
    if(end){
      const dl=Math.ceil((end-today2)/86400000);
      if(dl<0){timeline=0;timelineLabel=`${Math.abs(dl)}d overdue`;}
      else if(dl===0){timeline=5;timelineLabel="Due today";}
      else if(dl<=7){timeline=10;timelineLabel=`${dl}d left`;}
      else if(dl<=14){timeline=18;timelineLabel=`${dl}d left`;}
      else if(dl<=30){timeline=24;timelineLabel=`${dl}d left`;}
      else{timeline=30;timelineLabel=`${dl}d left`;}
    }
    score+=timeline;
    // ─ Grade ─────────────────────────────────────────────────────────────
    let grade,color,gcolor;
    if(score>=85){grade="A+";color="#059669";gcolor="#dcfce7";}
    else if(score>=75){grade="A";color="#10b981";gcolor="#d1fae5";}
    else if(score>=65){grade="B";color="#3b82f6";gcolor="#dbeafe";}
    else if(score>=50){grade="C";color="#f59e0b";gcolor="#fef3c7";}
    else if(score>=30){grade="D";color="#f97316";gcolor="#ffedd5";}
    else{grade="F";color="#ef4444";gcolor="#fef2f2";}
    return{score,grade,color,gcolor,breakdown:{completeness:{earned:completeness,max:40,items:{hasPM,hasDate,hasBudget,hasDesigner,hasCE}},recency:{earned:recency,max:30,label:recencyLabel,count:updates.length},timeline:{earned:timeline,max:30,label:timelineLabel}}};
  };

  const totalCards=Object.keys(pcards).length;
  const fullyDone=Object.values(pcards).filter(p=>DEPT_ORDER.every(d=>p.departments?.[d]?.done)).length;
  const needsAttn=wonDeals.filter(d=>{const h=getHealth(d,pcards[d.id]);return h==="yellow"||h==="red";}).length;
  const openBCount=(blockers||[]).filter(b=>b.status==="Open").length;

  // ── Team-load rollups (by PM / Coordinator / Subcon) ──────────────────────
  const dealStatus=(d)=>{
    const pc=pcards[d.id];
    if(d.stage==="12 · Close-Out"||d.stage==="14 · Completed")return "done";
    if(pc&&DEPT_ORDER.every(dep=>pc.departments?.[dep]?.done))return "done";
    return getHealth(d,pc); // green | yellow | red | none
  };
  // Shared owner-key resolver — used by both the rollup and the grid filter
  const ownerKeys=(d,tab)=>{
    const pc=pcards[d.id],jo=dealJo(jos,d.id);
    if(tab==="pm")return[pc?.pm1||jo?.pm1||"Unassigned"];
    if(tab==="coor")return[pc?.coordinator||jo?.coordinator||"Unassigned"];
    const ws=(swos||[]).filter(w=>w.projectId===d.id||w.dealId===d.id);
    return ws.length?[...new Set(ws.map(w=>w.subcontractor).filter(Boolean))]:["Unassigned"];
  };
  const buildRollup=(tab)=>{
    const map={};
    wonDeals.forEach(d=>{
      if(d.standbyPO&&!d.parentDealId) return;   // umbrella has no production — don't count it in team load
      const st=dealStatus(d);
      ownerKeys(d,tab).forEach(k=>{
        if(!k)return;
        if(!map[k])map[k]={name:k,total:0,red:0,yellow:0,green:0,done:0,none:0,active:0,value:0};
        const row=map[k];row.total++;row[st]=(row[st]||0)+1;row.value+=Number(d.value||0);
        if(st!=="done")row.active++;
      });
    });
    return Object.values(map).sort((a,b)=>b.active-a.active||b.total-a.total);
  };
  const teamRollups={pm:buildRollup("pm"),coor:buildRollup("coor"),subcon:buildRollup("subcon")};
  const fmtPeso=(n)=>{n=Number(n||0);if(n>=1e6)return"₱"+(n/1e6).toFixed(n>=1e7?0:1)+"M";if(n>=1e3)return"₱"+Math.round(n/1e3)+"K";return n>0?"₱"+n:"—";};
  const teamTabMeta={pm:["👷","Project Manager"],coor:["📋","Coordinator"],subcon:["🔧","Subcontractor"]};
  const SC_CLR={red:["#ef4444","Urgent"],yellow:["#f59e0b","At Risk"],green:["#10b981","On Track"],done:["#059669","Done"],none:["#94a3b8","No Date"]};

  return(
    <>
    <div>
      {/* Page header */}
      <div style={{marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>📋 Project Cards</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{wonDeals.length} awarded · {totalCards} cards · all departments in one view</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          {!selDeal&&(
            <div style={{display:"flex",background:"#fff",border:"1px solid #e2e8f0",borderRadius:8,padding:3,gap:2}}>
              {[["list","☰ List"],["card","⊞ Cards"]].map(([v,l])=>(
                <button key={v} onClick={()=>setViewMode(v)}
                  style={{padding:"4px 12px",borderRadius:5,border:"none",fontFamily:"inherit",fontSize:".72rem",fontWeight:600,cursor:"pointer",
                    background:viewMode===v?"#0f172a":"transparent",color:viewMode===v?"#fff":"#64748b",transition:"all .12s"}}>
                  {l}
                </button>
              ))}
            </div>
          )}
          {selDeal&&<button onClick={()=>{setSelDeal(null);setShowBForm(false);setShowUForm(false);setTatOpen(false);setShowTeamEdit(false);setShowScopeForm(false);setScopeForm({title:"",desc:"",value:"",ceNo:""});setPcSearch("");}} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"7px 14px",fontFamily:"inherit",fontSize:".82rem",color:"#475569",cursor:"pointer",fontWeight:600}}>← All Projects</button>}
        </div>
      </div>

      {/* KPI bar — only on list view */}
      {!selDeal&&(
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(5,1fr)",gap:10,marginBottom:16}}>
          {[
            {l:"Active",       v:wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed").length, c:"#0f172a",    f:null},
            {l:"Completed",    v:wonDeals.filter(d=>d.stage==="12 · Close-Out"||d.stage==="14 · Completed").length, c:"#059669", f:"completed"},
            {l:"Needs Attention",v:needsAttn,c:"#f59e0b",f:"attention"},
            {l:"Open Blockers",v:openBCount,c:openBCount>0?"#ef4444":"#94a3b8",f:"blockers"},
            {l:"Past Deadline",v:wonDeals.filter(d=>pcards[d.id]?.targetEndDate&&pcards[d.id].targetEndDate<today&&!DEPT_ORDER.every(dept=>pcards[d.id]?.departments?.[dept]?.done)).length,c:"#c2410c",f:"overdue"},
            {l:"All Projects", v:wonDeals.length,c:"#64748b",f:"all"},
          ].map(({l,v,c,f})=>(
            <div key={l} {...clickable(()=>setPcFilter(x=>x===f?null:f))} aria-label={`Filter ${l}`}
              style={{background:pcFilter===f?"#1e293b":"#fff",borderRadius:12,padding:"14px 16px",border:`1.5px solid ${pcFilter===f?c:"#e2e8f0"}`,cursor:"pointer",transition:"all .15s"}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:pcFilter===f?"#fff":c}}>{v}</div>
              <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:pcFilter===f?"rgba(255,255,255,.6)":"#94a3b8",marginTop:5}}>{l}</div>
            </div>
          ))}
        </div>
      )}

      {/* Team Load — rollups by PM / Coordinator / Subcon */}
      {!selDeal&&(
        <div style={{background:"#fff",borderRadius:12,border:"1px solid #e2e8f0",marginBottom:16,overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,.05)"}}>
          <div onClick={()=>setShowTeamLoad(v=>!v)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",cursor:"pointer",background:showTeamLoad?"#f8fafc":"#fff",borderBottom:showTeamLoad?"1px solid #e2e8f0":"none"}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:".95rem"}}>👥</span>
              <span style={{fontWeight:800,fontSize:".9rem",color:"#0f172a"}}>Team Load</span>
              <span style={{fontSize:".68rem",color:"#94a3b8"}}>workload &amp; risk by owner</span>
            </div>
            <span style={{fontSize:".7rem",color:"#64748b",fontWeight:600}}>{showTeamLoad?"▲ Hide":"▼ Show"}</span>
          </div>
          {showTeamLoad&&(
            <div style={{padding:"12px 16px 16px"}}>
              {/* status legend */}
              <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:12}}>
                {["red","yellow","green","done","none"].map(k=>(
                  <span key={k} style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:".62rem",fontWeight:600,color:"#64748b"}}>
                    <span style={{width:9,height:9,borderRadius:2,background:SC_CLR[k][0]}}/>{SC_CLR[k][1]}
                  </span>
                ))}
              </div>
              {/* tabs */}
              <div style={{display:"flex",gap:6,marginBottom:12,flexWrap:"wrap"}}>
                {Object.entries(teamTabMeta).map(([k,[ic,lbl]])=>(
                  <button key={k} onClick={()=>setTeamLoadTab(k)}
                    style={{padding:"5px 12px",borderRadius:8,border:`1.5px solid ${teamLoadTab===k?"#0f172a":"#e2e8f0"}`,background:teamLoadTab===k?"#0f172a":"#fff",color:teamLoadTab===k?"#fff":"#64748b",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer"}}>
                    {ic} By {lbl}
                  </button>
                ))}
              </div>
              {/* rollup table */}
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",minWidth:520}}>
                  <thead>
                    <tr style={{borderBottom:"2px solid #e2e8f0"}}>
                      {[teamTabMeta[teamLoadTab][1],"Total","Active","Urgent","At Risk","On Track","Done","No Date","Value"].map((h,i)=>(
                        <th key={h} style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",padding:"8px 10px",textAlign:i===0?"left":i===8?"right":"center",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {teamRollups[teamLoadTab].length===0&&(
                      <tr><td colSpan={9} style={{textAlign:"center",padding:"20px",color:"#94a3b8",fontSize:".8rem"}}>No projects yet.</td></tr>
                    )}
                    {teamRollups[teamLoadTab].map(r=>{
                      const cells=[["red",r.red],["yellow",r.yellow],["green",r.green],["done",r.done],["none",r.none]];
                      const isSel=pcOwner&&pcOwner.tab===teamLoadTab&&pcOwner.name===r.name;
                      return(
                        <tr key={r.name} title={`Filter projects → ${r.name}`}
                          onClick={()=>setPcOwner(isSel?null:{tab:teamLoadTab,name:r.name})}
                          style={{borderBottom:"1px solid #f1f5f9",cursor:"pointer",background:isSel?"#eef2ff":"transparent",transition:"background .1s"}}
                          onMouseEnter={e=>{if(!isSel)e.currentTarget.style.background="#f8fafc";}}
                          onMouseLeave={e=>{if(!isSel)e.currentTarget.style.background="transparent";}}>
                          <td style={{padding:"9px 10px",fontSize:".8rem",fontWeight:700,color:r.name==="Unassigned"?"#cbd5e1":isSel?"#4338ca":"#0f172a",fontStyle:r.name==="Unassigned"?"italic":"normal",whiteSpace:"nowrap"}}>{isSel?"▸ ":""}{r.name}</td>
                          <td style={{padding:"9px 10px",textAlign:"center",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1rem",color:"#0f172a"}}>{r.total}</td>
                          <td style={{padding:"9px 10px",textAlign:"center",fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1rem",color:r.active>0?"#0f172a":"#cbd5e1"}}>{r.active}</td>
                          {cells.map(([k,v])=>(
                            <td key={k} style={{padding:"9px 10px",textAlign:"center"}}>
                              {v>0?<span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",minWidth:22,height:22,borderRadius:6,fontSize:".72rem",fontWeight:700,background:SC_CLR[k][0]+"1a",color:SC_CLR[k][0],border:`1px solid ${SC_CLR[k][0]}40`,padding:"0 5px"}}>{v}</span>:<span style={{color:"#e2e8f0",fontSize:".8rem"}}>·</span>}
                            </td>
                          ))}
                          <td style={{padding:"9px 10px",textAlign:"right",fontFamily:"'IBM Plex Mono',monospace",fontSize:".72rem",fontWeight:700,color:r.value>0?"#0f172a":"#cbd5e1",whiteSpace:"nowrap"}}>{fmtPeso(r.value)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {!selDeal?(
        // ── PROJECT GRID ────────────────────────────────────────────────────
        <div>
          <div style={{marginBottom:8,position:"relative"}}>
            <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:".85rem",pointerEvents:"none"}}>🔍</span>
            <input value={pcSearch} onChange={e=>setPcSearch(e.target.value)} placeholder="Search projects, clients, CE#…"
              style={{width:"100%",boxSizing:"border-box",padding:"7px 10px 7px 30px",borderRadius:8,border:"1.5px solid #e2e8f0",fontFamily:"inherit",fontSize:".82rem",outline:"none",background:"#f8fafc"}}/>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:12,flexWrap:"wrap"}}>
            {["All",...DEPT_ORDER].map(dept=>(
              <button key={dept} onClick={()=>setPcDeptFilter(f=>f===dept?"All":dept)}
                style={{padding:"3px 10px",borderRadius:20,border:`1.5px solid ${pcDeptFilter===dept&&dept!=="All"?(DEPT_CLR[dept]||"#1e293b"):"#e2e8f0"}`,background:pcDeptFilter===dept&&dept!=="All"?(DEPT_CLR[dept]||"#1e293b"):"#fff",color:pcDeptFilter===dept&&dept!=="All"?"#fff":"#64748b",fontFamily:"inherit",fontWeight:pcDeptFilter===dept?700:400,fontSize:".72rem",cursor:"pointer"}}>
                {dept}
              </button>
            ))}
            {[["tat","⏰ Urgent"],["pct","📊 Least done"],["project","🔤 Project"],["client","📁 Client"]].map(([v,l])=>(
              <button key={v} onClick={()=>setPcSort(s=>s===v?null:v)}
                style={{padding:"3px 10px",borderRadius:20,border:`1.5px solid ${pcSort===v?"#1e293b":"#e2e8f0"}`,background:pcSort===v?"#1e293b":"#fff",color:pcSort===v?"#fff":"#64748b",fontFamily:"inherit",fontWeight:pcSort===v?700:400,fontSize:".72rem",cursor:"pointer"}}>
                {l}
              </button>
            ))}
            {pcOwner&&<button onClick={()=>setPcOwner(null)} style={{padding:"3px 10px",borderRadius:20,border:`1.5px solid ${teamTabMeta[pcOwner.tab]?SC_CLR.green[0]:"#c7d2fe"}`,background:"#eef2ff",color:"#4338ca",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer",whiteSpace:"nowrap"}}>{teamTabMeta[pcOwner.tab][0]} {pcOwner.name} ✕</button>}
            {(pcFilter||pcDeptFilter!=="All"||pcSearch||pcOwner)&&<button onClick={()=>{setPcFilter(null);setPcDeptFilter("All");setPcSearch("");setPcOwner(null);}} style={{padding:"3px 10px",borderRadius:20,border:"1.5px solid #fecaca",background:"#fef2f2",color:"#dc2626",fontFamily:"inherit",fontWeight:700,fontSize:".72rem",cursor:"pointer"}}>✕ Clear</button>}
          </div>
          {(()=>{
            // shared filter logic
            let list=pcFilter==="overdue"
              ?wonDeals
              :pcFilter==="completed"
              ?wonDeals.filter(d=>d.stage==="12 · Close-Out"||d.stage==="14 · Completed")
              :pcFilter==="all"
                ?wonDeals
                :wonDeals.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed");
            if(pcSearch){const q=pcSearch.toLowerCase();list=list.filter(d=>[d.contact,d.client,d.ceNo,d.salesOwner].join(" ").toLowerCase().includes(q));}
            if(pcFilter==="attention") list=list.filter(d=>{const h=getHealth(d,pcards[d.id]);return h==="yellow"||h==="red";});
            if(pcFilter==="blockers") list=list.filter(d=>(blockers||[]).some(b=>b.dealId===d.id&&b.status==="Open"));
            if(pcFilter==="overdue") list=list.filter(d=>d.stage!=="12 · Close-Out"&&d.stage!=="14 · Completed"&&pcards[d.id]?.targetEndDate&&pcards[d.id].targetEndDate<today&&!DEPT_ORDER.every(dept=>pcards[d.id]?.departments?.[dept]?.done));
            if(pcDeptFilter!=="All") list=list.filter(d=>pcards[d.id]&&!pcards[d.id]?.departments?.[pcDeptFilter]?.done);
            if(pcOwner) list=list.filter(d=>ownerKeys(d,pcOwner.tab).includes(pcOwner.name));
            list=[...list].sort((a,b)=>{
              if(pcSort==="client")return a.client.localeCompare(b.client);
              if(pcSort==="project")return (a.contact||a.client).localeCompare(b.contact||b.client);
              if(pcSort==="pct")return projPct(pcards[a.id])-projPct(pcards[b.id]);
              if(pcSort==="tat"){
                const da=pcards[a.id]?.targetEndDate?Math.ceil((new Date(pcards[a.id].targetEndDate)-today2)/86400000):999;
                const db=pcards[b.id]?.targetEndDate?Math.ceil((new Date(pcards[b.id].targetEndDate)-today2)/86400000):999;
                return da-db;
              }
              return 0;
            });
            // Separate parent deals from child deals for nested display
            const childDeals=list.filter(d=>d.parentDealId);
            // Standby PO umbrellas carry no production of their own — their
            // drawdown jobs are independent fabrications. So in Project HQ we
            // hide the ₱0 umbrella card and promote its jobs to top-level
            // project cards. Normal addendum children stay nested as before.
            const standbyParentIds=new Set(deals.filter(x=>x.standbyPO).map(x=>x.id));
            const parentList=list.filter(d=>{
              if(d.standbyPO&&!d.parentDealId) return false;              // hide the umbrella itself
              if(!d.parentDealId) return true;                            // normal top-level project
              return standbyParentIds.has(d.parentDealId);                // promote standby-PO jobs
            });
            const renderPCRow=(d,idx,total,isChild=false)=>{
              const pc=pcards[d.id];
              const g=calcCardGrade(d,pc);
              const h=getHealth(d,pc);const[hc]=HC[h];
              const joR=dealJo(jos,d.id);
              const projB=(blockers||[]).filter(b=>b.dealId===d.id&&b.status==="Open").length;
              const pct=projPct(pc,d);
              const pm=[pc?.pm1||joR?.pm1,pc?.pm2||joR?.pm2,pc?.pm3||joR?.pm3].filter(Boolean)[0]||"—";
              const ae=pc?.aeAssigned||joR?.aeAssigned||d.salesOwner||"—";
              const dLeft=pc?.targetEndDate?Math.ceil((new Date(pc.targetEndDate)-today2)/86400000):null;
              return(
                <div key={d.id} {...clickable(()=>{setSelDeal(d.id);setShowTeamEdit(false);})} aria-label={`Open ${d.client||d.contact||"deal"}`}
                  style={{display:"grid",gridTemplateColumns:"minmax(160px,1fr) 140px 120px 140px 80px 80px",gap:0,padding:isChild?"7px 14px 7px 28px":"10px 14px",alignItems:"center",cursor:"pointer",borderBottom:idx<total-1?"1px solid #f1f5f9":"none",borderLeft:`3px solid ${isChild?"#f59e0b":g.color}`,background:isChild?"#fffbeb":"#fff",transition:"background .1s",minWidth:720}}
                  onMouseEnter={e=>e.currentTarget.style.background=isChild?"#fef3c7":"#f8fafc"}
                  onMouseLeave={e=>e.currentTarget.style.background=isChild?"#fffbeb":"#fff"}>
                  <div style={{paddingRight:10,minWidth:0}}>
                    {isChild&&<div style={{fontSize:".55rem",color:"#f59e0b",fontWeight:700,marginBottom:1}}>↳ ADDENDUM</div>}
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".83rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                    <div style={{fontSize:".65rem",color:"#94a3b8",marginTop:1}}>{d.ceNo||"No CE"}{projB>0&&<span style={{marginLeft:6,color:"#ef4444",fontWeight:700}}>⛔ {projB}</span>}{!pc&&<span style={{marginLeft:6,color:"#f59e0b",fontWeight:700}}>⚠ No card</span>}</div>
                  </div>
                  <div style={{fontSize:".76rem",color:"#475569",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{d.client}</div>
                  <div style={{fontSize:".76rem",color:"#475569",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{ae==="—"?<span style={{color:"#cbd5e1"}}>—</span>:ae}</div>
                  <div style={{fontSize:".76rem",color:"#475569",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:8}}>{pm==="—"?<span style={{color:"#cbd5e1"}}>Unassigned</span>:pm}</div>
                  <div style={{lineHeight:1.2}}>
                    <span style={{fontSize:".72rem",fontWeight:800,color:g.color,background:g.gcolor,borderRadius:20,padding:"2px 8px",whiteSpace:"nowrap",letterSpacing:".3px",display:"inline-block"}}>{pct===100?"✅":g.grade}</span>
                    <div style={{fontSize:".55rem",color:g.color,marginTop:2,paddingLeft:2,fontWeight:600}}>{g.score}pts</div>
                  </div>
                  <div style={{fontSize:".74rem",fontWeight:dLeft!==null&&dLeft<0?700:400,color:dLeft===null?"#cbd5e1":dLeft<0?"#ef4444":dLeft<=7?"#f59e0b":"#64748b"}}>
                    {dLeft===null?"—":dLeft<0?`${Math.abs(dLeft)}d over`:`${dLeft}d left`}
                  </div>
                </div>
              );
            };
            if(parentList.length===0&&childDeals.length===0) return <div style={{textAlign:"center",padding:"32px",color:"#94a3b8",fontSize:".84rem"}}>No projects match this filter.</div>;

            // ── CARD VIEW ────────────────────────────────────────────────────
            if(viewMode==="card") return(
              <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(auto-fill,minmax(340px,1fr))",gap:14}}>
                {parentList.map(d=>{
                  const pc=pcards[d.id];
                  const h=getHealth(d,pc);const[hc]=HC[h];
                  const joC=dealJo(jos,d.id);
                  const dLeftC=pc?.targetEndDate?Math.ceil((new Date(pc.targetEndDate)-today2)/86400000):null;
                  const isOverC=dLeftC!==null&&dLeftC<0;
                  const projSwos=(swos||[]).filter(w=>w.projectId===d.id||w.dealId===d.id);
                  const pms=[pc?.pm1||joC?.pm1,pc?.pm2||joC?.pm2,pc?.pm3||joC?.pm3].filter(Boolean).join(", ")||"—";
                  const aeC=pc?.aeAssigned||joC?.aeAssigned||d.salesOwner||"—";
                  const designerC=pc?.designer||joC?.designer||"—";
                  const projTypeC=pc?.tatCategory||d.projType||joC?.projType||"";
                  const pctC=projPct(pc,d);
                  const gradeC=calcCardGrade(d,pc);
                  const deptStateC=DEPT_ORDER.map(dep=>({dep,done:!!pc?.departments?.[dep]?.done}));
                  const doneCountC=deptStateC.filter(x=>x.done).length;
                  const lastNoteC=(pc?.pmUpdates||[])[0];
                  const lastNoteTxtC=lastNoteC?(lastNoteC.note||lastNoteC.text||""):"";
                  const[,hLabelC]=HC[h];
                  return(
                    <div key={d.id} {...clickable(()=>{setSelDeal(d.id);setShowTeamEdit(false);})} aria-label={`Open ${d.client||d.contact||"deal"}`}
                      style={{background:"#fff",border:"1px solid #e2e8f0",borderLeft:`4px solid ${hc}`,borderRadius:"2px 10px 10px 2px",overflow:"hidden",
                        boxShadow:"0 1px 4px rgba(0,0,0,.05)",cursor:"pointer",transition:"box-shadow .15s,transform .15s"}}
                      onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,.09)";e.currentTarget.style.transform="translateY(-1px)";}}
                      onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.05)";e.currentTarget.style.transform="translateY(0)";}}>
                      {/* Card head */}
                      <div style={{padding:"13px 15px 10px",borderBottom:"1px solid #e2e8f0",display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                        <div style={{minWidth:0}}>
                          <div style={{fontWeight:800,fontSize:".9rem",color:"#0f172a",letterSpacing:"-.02em",lineHeight:1.25,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.contact||d.client}</div>
                          <div style={{fontSize:".68rem",color:"#7c3aed",marginTop:2}}>{d.client!==d.contact?`📁 ${d.client}`:""}</div>
                          <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:5}}>
                            {projTypeC&&<span style={{fontSize:".56rem",fontWeight:700,letterSpacing:".04em",textTransform:"uppercase",padding:"2px 6px",borderRadius:3,background:"#faf5ff",color:"#7c3aed",border:"1px solid #e9d5ff"}}>{projTypeC}</span>}
                            {d.ceNo&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"2px 6px",borderRadius:3,background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe"}}>{d.ceNo}</span>}
                            {joC&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"2px 6px",borderRadius:3,background:"#f0fdf4",color:"#166534",border:"1px solid #bbf7d0"}}>{joC.joNo}</span>}
                            {pc?.warehouseOnly&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"2px 6px",borderRadius:3,background:"#fffbeb",color:"#92400e",border:"1px solid #fde68a"}}>📦 WH Only</span>}
                          </div>
                        </div>
                        <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:5,flexShrink:0}}>
                          <div style={{display:"flex",alignItems:"center",gap:6}}>
                            <span title={`Card health: ${hLabelC}`} style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".92rem",lineHeight:1,minWidth:26,height:26,display:"inline-flex",alignItems:"center",justifyContent:"center",borderRadius:6,background:gradeC.gcolor,color:gradeC.color,border:`1px solid ${gradeC.color}55`,padding:"0 5px"}}>{gradeC.grade}</span>
                            {role==="Manager"&&setConfirmDel&&<button onClick={e=>{e.stopPropagation();setConfirmDel(d.id);}} title="Delete project" style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:5,padding:"3px 6px",fontSize:".72rem",lineHeight:1,color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>🗑</button>}
                          </div>
                          <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:600,letterSpacing:".06em",textTransform:"uppercase",padding:"3px 8px",borderRadius:4,background:hc+"18",color:hc,border:`1px solid ${hc}44`,whiteSpace:"nowrap"}}>{d.stage?.replace(/^\d+ · /,"")||"—"}</span>
                        </div>
                      </div>
                      {/* Progress + department strip */}
                      <div style={{padding:"10px 15px",borderBottom:"1px solid #e2e8f0",background:"#fbfcfe"}}>
                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
                          <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8"}}>Progress · {doneCountC}/6 depts</span>
                          <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".95rem",color:pctC>=100?"#059669":pctC>=50?"#0f172a":"#64748b"}}>{pctC}%</span>
                        </div>
                        <div style={{height:6,borderRadius:20,background:"#e2e8f0",overflow:"hidden",marginBottom:8}}>
                          <div style={{height:"100%",width:`${pctC}%`,borderRadius:20,background:pctC>=100?"#10b981":isOverC?"#ef4444":"#3b82f6",transition:"width .3s"}}/>
                        </div>
                        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                          {deptStateC.map(({dep,done})=>(
                            <span key={dep} title={`${dep}: ${done?"done":"pending"}`}
                              style={{fontSize:".55rem",fontWeight:700,padding:"2px 7px",borderRadius:20,whiteSpace:"nowrap",
                                background:done?(DEPT_CLR[dep]||"#10b981"):"#fff",color:done?"#fff":"#94a3b8",
                                border:`1px solid ${done?(DEPT_CLR[dep]||"#10b981"):"#e2e8f0"}`}}>
                              {done?"✓ ":""}{dep.slice(0,4)}
                            </span>
                          ))}
                        </div>
                      </div>
                      {/* Spec table */}
                      <table style={{width:"100%",borderCollapse:"collapse"}}>
                        {[["📍 Location",d.location||joC?.location||"—"],["🤝 AE",aeC],["👷 PM",pms],["📋 Coordinator",pc?.coordinator||joC?.coordinator||"—"],["🎨 Designer",designerC]].map(([lbl,val])=>(
                          <tr key={lbl} style={{borderBottom:"1px solid #e2e8f0"}}>
                            <td style={{width:110,fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",padding:"7px 14px",background:"#f8fafc",borderRight:"1px solid #e2e8f0",whiteSpace:"nowrap",verticalAlign:"middle"}}>{lbl}</td>
                            <td style={{padding:"7px 14px",fontSize:".78rem",fontWeight:500,color:val==="—"?"#cbd5e1":"#0f172a",fontStyle:val==="—"?"italic":"normal"}}>{val}</td>
                          </tr>
                        ))}
                        {projSwos.length>0&&(
                          <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                            <td style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",padding:"7px 14px",background:"#f8fafc",borderRight:"1px solid #e2e8f0",whiteSpace:"nowrap",verticalAlign:"top"}}>🔧 Subcons</td>
                            <td style={{padding:"7px 14px"}}>
                              <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                                {projSwos.map(w=><span key={w.id} style={{fontSize:".68rem",fontWeight:600,padding:"1px 8px",borderRadius:20,background:"#eff6ff",border:"1px solid #bfdbfe",color:"#1d4ed8"}}>{w.subcontractor||"?"}</span>)}
                              </div>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".55rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",padding:"7px 14px",background:"#f8fafc",borderRight:"1px solid #e2e8f0",whiteSpace:"nowrap",verticalAlign:"middle"}}>📅 Timeline</td>
                          <td style={{padding:"7px 14px"}}>
                            <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                              <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".68rem",color:"#94a3b8"}}>{joC?.startDate||d.awardDate||"—"}</span>
                              <span style={{color:"#cbd5e1",fontSize:".6rem"}}>→</span>
                              <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".68rem",fontWeight:700,color:isOverC?"#dc2626":dLeftC!==null&&dLeftC<=7?"#d97706":"#059669"}}>{pc?.targetEndDate||"No date"}</span>
                              {dLeftC!==null&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:700,padding:"1px 7px",borderRadius:3,
                                color:isOverC?"#991b1b":dLeftC<=7?"#92400e":"#065f46",
                                background:isOverC?"#fef2f2":dLeftC<=7?"#fffbeb":"#ecfdf5",
                                border:`1px solid ${isOverC?"#fecaca":dLeftC<=7?"#fde68a":"#a7f3d0"}`}}>
                                {isOverC?`⚠ ${Math.abs(dLeftC)}d over`:`${dLeftC}d left`}
                              </span>}
                            </div>
                          </td>
                        </tr>
                      </table>
                      {/* Latest update note */}
                      {lastNoteTxtC&&(
                        <div style={{padding:"9px 15px",borderTop:"1px solid #e2e8f0",background:"#fffdf7",display:"flex",gap:7,alignItems:"flex-start"}}>
                          <span style={{fontSize:".7rem",lineHeight:1.3,flexShrink:0}}>📝</span>
                          <div style={{minWidth:0}}>
                            <div style={{fontSize:".72rem",color:"#475569",lineHeight:1.35,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{lastNoteTxtC}</div>
                            <div style={{fontSize:".58rem",color:"#94a3b8",marginTop:2}}>{lastNoteC.by||"Team"}{lastNoteC.date?` · ${lastNoteC.date}`:""}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );

            // ── LIST VIEW ────────────────────────────────────────────────────
            return(
              <div style={{background:"#fff",borderRadius:10,border:"1px solid #e2e8f0",overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,.05)"}}>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",minWidth:820}}>
                    <thead>
                      <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                        <th style={{width:4,padding:0}}></th>
                        {["Project / Client","Stage","Location","AE","PM","Coordinator","Subcons","Turnover"].map(h=>(
                          <th key={h} style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".1em",color:"#94a3b8",padding:"10px 14px",textAlign:"left",whiteSpace:"nowrap"}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {parentList.map(d=>{
                        const pcL=pcards[d.id];
                        const hL=getHealth(d,pcL);const[hcL]=HC[hL];
                        const joL=dealJo(jos,d.id);
                        const dLeftL=pcL?.targetEndDate?Math.ceil((new Date(pcL.targetEndDate)-today2)/86400000):null;
                        const isOverL=dLeftL!==null&&dLeftL<0;
                        const aeL=pcL?.aeAssigned||joL?.aeAssigned||d.salesOwner||"—";
                        const pm1L=pcL?.pm1||joL?.pm1||"";
                        const pm2L=pcL?.pm2||joL?.pm2||"";
                        const coordL=pcL?.coordinator||joL?.coordinator||"—";
                        const projSwosL=(swos||[]).filter(w=>w.projectId===d.id||w.dealId===d.id);
                        const stageLabel=d.stage?.replace(/^\d+ · /,"")||"—";
                        return(
                          <tr key={d.id} style={{borderBottom:"1px solid #e2e8f0",cursor:"pointer"}}
                            onClick={()=>{setSelDeal(d.id);setShowTeamEdit(false);}}
                            onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                            onMouseLeave={e=>e.currentTarget.style.background=""}>
                            {/* Stage color bar */}
                            <td style={{width:4,padding:0,background:hcL}}></td>
                            {/* Project / Client */}
                            <td style={{padding:"10px 14px",verticalAlign:"middle"}}>
                              <div style={{fontWeight:700,fontSize:".82rem",color:"#0d1117",lineHeight:1.25}}>{d.contact||d.client}</div>
                              {d.client!==d.contact&&<div style={{fontSize:".68rem",color:"#7c3aed",marginTop:1}}>{d.client}</div>}
                              <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:4}}>
                                {d.ceNo&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"1px 5px",borderRadius:3,background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe"}}>{d.ceNo}</span>}
                                {joL&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"1px 5px",borderRadius:3,background:"#f0fdf4",color:"#166534",border:"1px solid #bbf7d0"}}>{joL.joNo}</span>}
                                {pcL?.warehouseOnly&&<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:600,padding:"1px 5px",borderRadius:3,background:"#fffbeb",color:"#92400e",border:"1px solid #fde68a"}}>📦 WH</span>}
                              </div>
                            </td>
                            {/* Stage pill */}
                            <td style={{padding:"10px 14px",verticalAlign:"middle",whiteSpace:"nowrap"}}>
                              <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:600,letterSpacing:".05em",textTransform:"uppercase",padding:"3px 8px",borderRadius:4,background:hcL+"18",color:hcL,border:`1px solid ${hcL}44`,whiteSpace:"nowrap"}}>{stageLabel}</span>
                            </td>
                            {/* Location */}
                            <td style={{padding:"10px 14px",fontSize:".78rem",color:"#475569",verticalAlign:"middle",maxWidth:130,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.location||joL?.location||<span style={{color:"#cbd5e1"}}>—</span>}</td>
                            {/* AE */}
                            <td style={{padding:"10px 14px",fontSize:".78rem",fontWeight:500,color:"#0d1117",verticalAlign:"middle",whiteSpace:"nowrap"}}>{aeL==="—"?<span style={{color:"#cbd5e1"}}>—</span>:aeL}</td>
                            {/* PM */}
                            <td style={{padding:"10px 14px",verticalAlign:"middle"}}>
                              {pm1L?<><div style={{fontSize:".78rem",fontWeight:500,color:"#0d1117"}}>{pm1L}</div>{pm2L&&<div style={{fontSize:".68rem",color:"#94a3b8",marginTop:1}}>+ {pm2L}</div>}</>:<span style={{fontSize:".78rem",color:"#cbd5e1",fontStyle:"italic"}}>—</span>}
                            </td>
                            {/* Coordinator */}
                            <td style={{padding:"10px 14px",fontSize:".78rem",fontWeight:500,color:"#0d1117",verticalAlign:"middle",whiteSpace:"nowrap"}}>{coordL==="—"?<span style={{color:"#cbd5e1"}}>—</span>:coordL}</td>
                            {/* Subcons */}
                            <td style={{padding:"10px 14px",verticalAlign:"middle"}}>
                              {projSwosL.length>0?(
                                <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
                                  {projSwosL.slice(0,2).map(w=><span key={w.id} style={{fontSize:".68rem",fontWeight:600,padding:"1px 7px",borderRadius:20,background:"#eff6ff",border:"1px solid #bfdbfe",color:"#1d4ed8",whiteSpace:"nowrap"}}>{w.subcontractor||"?"}</span>)}
                                  {projSwosL.length>2&&<span style={{fontSize:".65rem",color:"#94a3b8"}}>+{projSwosL.length-2}</span>}
                                </div>
                              ):<span style={{color:"#cbd5e1",fontSize:".72rem",fontStyle:"italic"}}>—</span>}
                            </td>
                            {/* Turnover */}
                            <td style={{padding:"10px 14px",verticalAlign:"middle",whiteSpace:"nowrap"}}>
                              {pcL?.targetEndDate?(
                                <>
                                  <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".72rem",fontWeight:700,color:isOverL?"#dc2626":dLeftL!==null&&dLeftL<=7?"#d97706":"#059669"}}>{pcL.targetEndDate}</div>
                                  {dLeftL!==null&&<span style={{display:"inline-block",marginTop:2,fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:700,padding:"1px 6px",borderRadius:3,
                                    color:isOverL?"#991b1b":dLeftL<=7?"#92400e":"#065f46",
                                    background:isOverL?"#fef2f2":dLeftL<=7?"#fffbeb":"#ecfdf5",
                                    border:`1px solid ${isOverL?"#fecaca":dLeftL<=7?"#fde68a":"#a7f3d0"}`}}>
                                    {isOverL?`⚠ ${Math.abs(dLeftL)}d over`:`${dLeftL}d left`}
                                  </span>}
                                </>
                              ):<span style={{color:"#cbd5e1",fontSize:".72rem"}}>—</span>}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })()}

        </div>
      ):(
        // ── PROJECT HQ ─────────────────────────────────────────────────────
        (()=>{
          const pct=projPct(card,deal);
          const h=getHealth(deal,card);const[hc,hl]=HC[h];
          const pi=phaseIdx(deal?.stage);
          const elapsed=card?.awardDate?Math.ceil((today2-new Date(card.awardDate))/86400000):0;
          const end=card?.targetEndDate?new Date(card.targetEndDate):null;
          const dLeft=end?Math.ceil((end-today2)/86400000):null;
          const isOver=dLeft!==null&&dLeft<0;
          const {projBlockers,openProjB,projUpdates,projAddenda,projBillings,totalBilled,totalColl,totalCommitted,totalActualCost,totalExposure,pendingMRs,pendingBRs}=projStats;
          const contractVal=Number(deal?.value||0);
          const profitMargin=contractVal>0?Math.round((contractVal-totalExposure)/contractVal*100):null;
          const canFlagBlocker=["Manager","Operations","ProjectMover","Sales","Design","QS","Procurement","Finance","SalesOpsAdmin"].includes(role);
          const ceType=deal?.ceType||"Fabrication / General";
          const refTable=TAT_REFERENCE[ceType]||TAT_REFERENCE["Fabrication / General"];
          const canSetTAT=role==="Manager"||role==="QS"||role==="Operations"||role==="SalesOpsAdmin";


          const projCl=(checklist||[]).filter(c=>c.projectId===selDeal).sort((a,b)=>{
            const pri={Urgent:0,High:1,Normal:2};
            const sta={"To Do":0,"In Progress":1,"Done":2};
            return (sta[a.status]-sta[b.status])||(pri[a.priority]-pri[b.priority]);
          });

          return(
            <div style={{display:"flex",flexDirection:"column",gap:12}}>

              {/* ── Header card ── */}
              <div style={{background:"#fff",borderRadius:14,border:`1.5px solid ${hc}44`,padding:isMobile?"14px":"18px 22px"}}>
                {/* Top row: project name + stage badge */}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10,marginBottom:10}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:800,color:"#0f172a",fontSize:isMobile?"1rem":"1.15rem"}}>{deal?.contact||deal?.client}</div>
                    {deal?.contact&&<div style={{fontSize:".72rem",color:"#8b5cf6",marginTop:1}}>📁 {deal?.client}</div>}
                    <div style={{fontSize:".75rem",color:"#64748b",marginTop:2,display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                      {deal?.ceNo&&<span>{deal.ceNo}</span>}
                      {jo&&<span style={{color:"#3b82f6"}}>📋 {jo.joNo}</span>}
                      {card?.warehouseOnly&&<span style={{background:"#fef3c7",color:"#92400e",border:"1px solid #fbbf24",borderRadius:20,padding:"1px 8px",fontSize:".65rem",fontWeight:700}}>📦 Warehouse / Procurement Only</span>}
                    </div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4,flexShrink:0}}>
                    <span style={{fontSize:".72rem",fontWeight:700,color:hc,background:hc+"18",borderRadius:20,padding:"4px 12px",border:`1px solid ${hc}44`}}>{deal?.stage?.replace(/^\d+ · /,"")||"—"}</span>
                    {pct===100&&<span style={{fontSize:".68rem",fontWeight:700,color:"#059669",background:"#f0fdf4",borderRadius:20,padding:"2px 9px"}}>✅ Done</span>}
                    {/* PRFs for this project — same roles that can read prfs (prf_can_read). */}
                    {deal&&["Manager","ProjectMover","Operations","Coordinator","Warehouse","QS","Procurement","ProcurementManager","Finance","FinanceAssistant","Accounting","SalesOpsAdmin"].includes(role)&&(
                      <button onClick={()=>{setJumpDeal(deal.id);setPage("materialreq");}} title="Purchase requests for this project"
                        style={{background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:6,padding:"4px 10px",fontSize:".72rem",fontWeight:700,color:"#c2410c",cursor:"pointer",fontFamily:"inherit"}}>📦 PRFs</button>
                    )}
                    {role==="Manager"&&setConfirmDel&&deal&&<button onClick={()=>setConfirmDel(deal.id)} title="Delete this project and all its records" style={{marginTop:2,background:"#fef2f2",border:"1px solid #fecaca",borderRadius:6,padding:"4px 10px",fontSize:".7rem",fontWeight:700,color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>🗑 Delete Project</button>}
                  </div>
                </div>

                {/* Info grid: location, team, subcons, timeline */}
                <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:8,marginBottom:10}}>
                  {/* Location */}
                  <div style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px"}}>
                    <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>📍 Location</div>
                    <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{deal?.location||jo?.location||"—"}</div>
                  </div>
                  {/* AE */}
                  <div style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px"}}>
                    <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>🤝 AE</div>
                    <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{card?.aeAssigned||jo?.aeAssigned||deal?.salesOwner||"—"}</div>
                  </div>
                  {/* PM */}
                  <div style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px"}}>
                    <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>👷 PM</div>
                    <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{[card?.pm1||jo?.pm1,card?.pm2||jo?.pm2,card?.pm3||jo?.pm3].filter(Boolean).join(", ")||"Unassigned"}</div>
                  </div>
                  {/* Coordinator */}
                  <div style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px"}}>
                    <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>📋 Coordinator</div>
                    <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{card?.coordinator||jo?.coordinator||"—"}</div>
                  </div>
                  {/* Subcontractors */}
                  {(()=>{
                    const projSwos=(swos||[]).filter(w=>w.projectId===selDeal||w.dealId===selDeal);
                    return projSwos.length>0?(
                      <div style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px",gridColumn:"1/-1"}}>
                        <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:4}}>🔧 Subcontractors</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                          {projSwos.map(w=>(
                            <span key={w.id} style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:20,padding:"2px 10px",fontSize:".75rem",fontWeight:600,color:"#1d4ed8"}}>
                              {w.subcontractor||"?"}{w.specialty?` · ${w.specialty}`:""}
                            </span>
                          ))}
                        </div>
                      </div>
                    ):null;
                  })()}
                  {/* Timeline */}
                  <div style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px",gridColumn:"1/-1"}}>
                    <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:4}}>📅 Timeline</div>
                    <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                      <span style={{fontSize:".78rem",color:"#64748b"}}>{jo?.startDate||deal?.awardDate||"—"}</span>
                      <span style={{color:"#94a3b8",fontSize:".7rem"}}>→</span>
                      <span style={{fontSize:".78rem",fontWeight:700,color:isOver?"#ef4444":dLeft<=7?"#f59e0b":"#059669"}}>
                        {card?.targetEndDate||"No turnover date set"}
                      </span>
                      {card?.targetDays&&(
                        <span style={{fontSize:".7rem",fontWeight:700,color:isOver?"#ef4444":dLeft<=7?"#f59e0b":"#64748b",background:isOver?"#fef2f2":dLeft<=7?"#fffbeb":"#f1f5f9",borderRadius:20,padding:"2px 8px"}}>
                          {isOver?`⚠ ${Math.abs(dLeft)}d overdue`:`${dLeft}d left`}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* Stage selector */}
                {["Manager","Sales","Operations","ProjectMover","SalesOpsAdmin"].includes(role)&&deal&&changeDealStage&&canSetDealStage(role,deal.stage)&&(()=>{
                  const changeStage=async st=>{
                    if(!(await changeDealStage(selDeal,st))) return;
                    if(st==="14 · Completed"){
                      setPcFilter("completed");
                      setSelDeal(null);
                      toastEmit(`✅ ${deal.client} marked Completed — showing Completed tab`,"success");
                    } else {
                      toastEmit(`Stage → ${st}`,"success");
                    }
                  };
                  const ACTIVE_STAGES=["06 · Kickoff","07 · Briefing","08 · Fabrication","09 · Site & Billing","10 · Installation","11 · Punchlist"];
                  const isAlreadyDone=deal.stage==="12 · Close-Out"||deal.stage==="14 · Completed";
                  return(
                    <div style={{marginTop:12,borderTop:"1px solid #f1f5f9",paddingTop:12}}>
                      <div style={{fontSize:".6rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".08em",color:"#94a3b8",marginBottom:8}}>Stage — tap to change</div>
                      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                        {ACTIVE_STAGES.map(s=>{
                          const isActive=deal.stage===s;
                          const stageColors={"06 · Kickoff":"#8b5cf6","07 · Briefing":"#6366f1","08 · Fabrication":"#f59e0b","09 · Site & Billing":"#f97316","10 · Installation":"#3b82f6","11 · Punchlist":"#ef4444"};
                          const sc=stageColors[s]||"#64748b";
                          const label=s.replace(/^\d+ · /,"");
                          return(
                            <button key={s} onClick={()=>changeStage(s)}
                              style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:600,letterSpacing:".04em",padding:"4px 11px",borderRadius:20,cursor:"pointer",transition:"all .12s",
                                background:isActive?sc:"transparent",
                                color:isActive?"#fff":sc,
                                border:`1.5px solid ${isActive?sc:sc+"55"}`}}>
                              {label}
                            </button>
                          );
                        })}
                      </div>
                      {/* Complete project button — shown when stage is 06-11 */}
                      {!isAlreadyDone&&(
                        <div style={{marginTop:10,display:"flex",gap:8,flexWrap:"wrap"}}>
                          <button onClick={async ()=>{if((await uiConfirm(`Move "${deal.contact||deal.client}" to Close-Out?\n\nUse this when the project is finishing up (final billing, punch items, handover).`))) changeStage("12 · Close-Out");}}
                            style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:700,letterSpacing:".04em",padding:"5px 14px",borderRadius:20,cursor:"pointer",background:"transparent",color:"#059669",border:"1.5px solid #059669"}}>
                            🔒 Move to Close-Out
                          </button>
                          {canSetDealStage(role,deal.stage,"14 · Completed")&&(
                          <button onClick={async ()=>{if((await uiConfirm(`Mark "${deal.contact||deal.client}" as Completed?\n\nUse this only when all work is done and the project is fully closed.`))) changeStage("14 · Completed");}}
                            style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:700,letterSpacing:".04em",padding:"5px 14px",borderRadius:20,cursor:"pointer",background:"#059669",color:"#fff",border:"1.5px solid #059669"}}>
                            ✅ Mark as Completed
                          </button>
                          )}
                        </div>
                      )}
                      {/* If already done, show badge + reopen option */}
                      {isAlreadyDone&&(
                        <div style={{marginTop:10,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                          <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".62rem",fontWeight:700,padding:"4px 12px",borderRadius:20,background:"#ecfdf5",color:"#059669",border:"1px solid #a7f3d0"}}>
                            {deal.stage==="14 · Completed"?"✅ Completed":"🔒 Close-Out"}
                          </span>
                          <button onClick={async ()=>{if((await uiConfirm("Reopen this project? It will be moved back to 11 · Punchlist."))) changeStage("11 · Punchlist");}}
                            style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".58rem",fontWeight:600,padding:"3px 10px",borderRadius:20,cursor:"pointer",background:"transparent",color:"#94a3b8",border:"1px solid #e2e8f0"}}>
                            ↩ Reopen
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })()}
                {/* All-depts-done celebration banner */}
                {pct===100&&deal&&deal.stage!=="12 · Close-Out"&&deal.stage!=="14 · Completed"&&(
                  <div style={{marginTop:10,background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:10,padding:"10px 14px"}}>
                    <span style={{fontSize:".8rem",fontWeight:700,color:"#059669"}}>🎉 All departments complete! Use the buttons above to close out or complete this project.</span>
                  </div>
                )}
                {/* Scope changes are logged by Sales as a linked deal
                    (+ Add New Deal -> Link to Parent Deal), not from the project
                    card, so there is no "Log Scope Change" form here. */}
              </div>

              {/* ── Project Team ── */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:isMobile?"12px 14px":"14px 20px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>👥 Project Team</div>
                  {(role==="Manager"||role==="Operations"||role==="SalesOpsAdmin")&&!showTeamEdit&&selDeal&&(
                    <button onClick={()=>{
                      setTeamForm({ae:card?.aeAssigned||jo?.aeAssigned||deal?.salesOwner||"",pm1:card?.pm1||jo?.pm1||"",pm2:card?.pm2||jo?.pm2||"",pm3:card?.pm3||jo?.pm3||"",designer:card?.designer||jo?.designer||"",coordinator:card?.coordinator||jo?.coordinator||"",warehouseOnly:card?.warehouseOnly||false});
                      setShowTeamEdit(true);
                    }} style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"4px 10px",fontFamily:"inherit",fontSize:".72rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>✏️ Edit</button>
                  )}
                </div>
                {showTeamEdit?(
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    {[["ae","AE (Account Executive)",SALES_TEAM],["pm1","PM 1",OPS_TEAM],["pm2","PM 2",OPS_TEAM],["pm3","PM 3",OPS_TEAM],["designer","Designer",DESIGN_MEMBERS],["coordinator","Coordinator",OPS_TEAM]].map(([k,l,opts])=>{
                      const sugg=[...new Set([...opts,...customMembers])];
                      return(
                      <div key={k}>
                        <label style={{fontSize:".72rem",fontWeight:700,color:"#64748b",display:"block",marginBottom:2}}>{l}</label>
                        <input list={`teamopts_${k}`} value={teamForm[k]} onChange={e=>setTeamForm(f=>({...f,[k]:e.target.value}))} placeholder="— Not assigned — (type to add a new name)"
                          style={{width:"100%",padding:"7px 8px",borderRadius:6,border:"1.5px solid #e2e8f0",fontFamily:"inherit",fontSize:".82rem",background:"#fff",boxSizing:"border-box"}}/>
                        <datalist id={`teamopts_${k}`}>{sugg.map(m=><option key={m} value={m}/>)}</datalist>
                      </div>
                      );
                    })}
                    <div>
                      <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"8px 10px",background:"#fffbeb",borderRadius:8,border:"1.5px solid #fbbf24"}}>
                        <input type="checkbox" checked={!!teamForm.warehouseOnly} onChange={e=>setTeamForm(f=>({...f,warehouseOnly:e.target.checked}))} style={{width:16,height:16,cursor:"pointer"}}/>
                        <div>
                          <div style={{fontSize:".82rem",fontWeight:700,color:"#92400e"}}>📦 Warehouse / Procurement Only</div>
                          <div style={{fontSize:".7rem",color:"#b45309"}}>This project does not require full operations (e.g. client purchase assistance)</div>
                        </div>
                      </label>
                    </div>
                    <div style={{display:"flex",gap:8,marginTop:4}}>
                      <button onClick={()=>{
                        const tf=teamForm;
                        // Remember any names typed in that aren't in the built-in roster, so they become reusable suggestions everywhere.
                        const known=new Set([...SALES_TEAM,...OPS_TEAM,...DESIGN_MEMBERS,...customMembers]);
                        const fresh=[...new Set([tf.ae,tf.pm1,tf.pm2,tf.pm3,tf.designer,tf.coordinator].map(s=>(s||"").trim()).filter(s=>s&&!known.has(s)))];
                        if(fresh.length){const nm=[...customMembers,...fresh];setCustomMembers(nm);try{localStorage.setItem("gmdv5:customMembers",JSON.stringify(nm));}catch{}if(isSupabaseReady())sbUpsert('app_settings',{key:'custom_members',value:nm,updated_at:new Date().toISOString()},'key').catch(()=>{});}
                        // Create the card locally if this project never had one (the ~70 projects
                        // that reached a project stage without going through the Award flow). The
                        // sbUpsert below writes/creates the row in Supabase (id auto-generates); on
                        // next load sbLoadAll fills in the default department structure.
                        if(upPcards) upPcards(ps=>({...ps,[selDeal]:{...(ps[selDeal]||{deal_id:selDeal,dealId:selDeal}),aeAssigned:tf.ae,pm1:tf.pm1,pm2:tf.pm2,pm3:tf.pm3,designer:tf.designer,coordinator:tf.coordinator,warehouseOnly:tf.warehouseOnly||false}}));
                        if(isSupabaseReady()){
                          syncProjectCard(selDeal,{ae_assigned:tf.ae,pm1:tf.pm1,pm2:tf.pm2,pm3:tf.pm3,designer:tf.designer,coordinator:tf.coordinator,warehouse_only:tf.warehouseOnly||false});
                        }
                        if(jo&&updateJO) updateJO(jo.id,{aeAssigned:tf.ae,pm1:tf.pm1,pm2:tf.pm2,pm3:tf.pm3,designer:tf.designer,coordinator:tf.coordinator});
                        logActivity(selDeal,"Team Updated",`AE: ${tf.ae||"—"}, PM: ${[tf.pm1,tf.pm2,tf.pm3].filter(Boolean).join(", ")||"—"}, Designer: ${tf.designer||"—"}`,session?.name);
                        const pmStr=[tf.pm1,tf.pm2,tf.pm3].filter(Boolean).join(", ")||"—";
                        const tgMsg=`👥 <b>Project Team Assigned</b>\n${deal?.client||""}${deal?.ceNo?` · ${deal.ceNo}`:""}\n👷 PM: ${pmStr}\n🤝 AE: ${tf.ae||"—"}${tf.coordinator?`\n📋 Coordinator: ${tf.coordinator}`:""}${tf.designer?`\n🎨 Designer: ${tf.designer}`:""}\nAssigned by: ${session?.name}`;
                        sendTelegramNotification("ops",tgMsg);
                        sendTelegramNotification("management",tgMsg);
                        toastEmit&&toastEmit("Team saved","success");
                        setShowTeamEdit(false);
                      }} style={{flex:1,background:"#1e293b",border:"none",borderRadius:8,padding:"8px",fontFamily:"inherit",fontSize:".82rem",color:"#fff",cursor:"pointer",fontWeight:700}}>✓ Save Team</button>
                      <button onClick={()=>setShowTeamEdit(false)} style={{flex:1,background:"#f1f5f9",border:"none",borderRadius:8,padding:"8px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>Cancel</button>
                    </div>
                  </div>
                ):(
                  <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:6}}>
                    {[
                      {l:"AE",v:card?.aeAssigned||jo?.aeAssigned||deal?.salesOwner||"—"},
                      {l:"Designer",v:card?.designer||jo?.designer||"—"},
                      {l:"PM",v:[card?.pm1||jo?.pm1,card?.pm2||jo?.pm2,card?.pm3||jo?.pm3].filter(Boolean).join(", ")||"—"},
                      {l:"Coordinator",v:card?.coordinator||jo?.coordinator||"—"},
                    ].map(({l,v})=>(
                      <div key={l} style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px"}}>
                        <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>{l}</div>
                        <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{v}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* ── Vitals ── */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:isMobile?"12px 14px":"14px 20px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>📌 Project Vitals</div>
                  {(role==="Manager"||role==="Operations"||role==="QS"||role==="SalesOpsAdmin")&&selDeal&&!showDateEdit&&(
                    <button onClick={()=>{setDateForm({awardDate:card?.awardDate||"",targetEndDate:card?.targetEndDate||"",location:deal?.location||"",ceType:deal?.ceType||"Fabrication / General"});setShowDateEdit(true);}}
                      style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"4px 10px",fontFamily:"inherit",fontSize:".72rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>✏️ Edit</button>
                  )}
                </div>
                {showDateEdit?(
                  <div style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"14px",marginBottom:10}}>
                    <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10,marginBottom:12}}>
                      <div>
                        <div style={{fontSize:".72rem",fontWeight:700,color:"#64748b",marginBottom:4}}>Award / Start Date</div>
                        <input type="date" value={dateForm.awardDate} onChange={e=>fdt("awardDate",e.target.value)}
                          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"8px 10px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}/>
                      </div>
                      <div>
                        <div style={{fontSize:".72rem",fontWeight:700,color:"#64748b",marginBottom:4}}>Turnover / Target Due</div>
                        <input type="date" value={dateForm.targetEndDate} onChange={e=>fdt("targetEndDate",e.target.value)}
                          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"8px 10px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}/>
                        {dateForm.awardDate&&dateForm.targetEndDate&&(()=>{
                          const days=Math.ceil((new Date(dateForm.targetEndDate)-new Date(dateForm.awardDate))/86400000);
                          return days<0
                            ?<div style={{fontSize:".71rem",color:"#ef4444",marginTop:3,fontWeight:600}}>⚠ Turnover date is before award date</div>
                            :<div style={{fontSize:".71rem",color:"#059669",marginTop:3,fontWeight:600}}>→ {days} days from award date</div>;
                        })()}
                      </div>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10,marginBottom:12}}>
                      <div>
                        <div style={{fontSize:".72rem",fontWeight:700,color:"#64748b",marginBottom:4}}>📍 Location</div>
                        <input type="text" value={dateForm.location||""} onChange={e=>fdt("location",e.target.value)} placeholder="Site / delivery address"
                          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"8px 10px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",outline:"none",boxSizing:"border-box"}}/>
                      </div>
                      <div>
                        <div style={{fontSize:".72rem",fontWeight:700,color:"#64748b",marginBottom:4}}>CE Type</div>
                        <select value={dateForm.ceType||"Fabrication / General"} onChange={e=>fdt("ceType",e.target.value)}
                          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"8px 10px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a",outline:"none",boxSizing:"border-box",background:"#fff"}}>
                          {CE_TYPES.map(t=><option key={t} value={t}>{t}</option>)}
                        </select>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>{
                        if(!dateForm.awardDate) return;
                        const newDays=dateForm.targetEndDate?Math.max(1,Math.ceil((new Date(dateForm.targetEndDate)-new Date(dateForm.awardDate))/86400000)):card?.targetDays;
                        upPcards(ps=>({...ps,[selDeal]:{...(ps[selDeal]||{deal_id:selDeal,dealId:selDeal}),awardDate:dateForm.awardDate,targetEndDate:dateForm.targetEndDate||ps[selDeal]?.targetEndDate,targetDays:newDays||ps[selDeal]?.targetDays}}));
                        if(isSupabaseReady()){
                          syncProjectCard(selDeal,{award_date:dateForm.awardDate,...(dateForm.targetEndDate?{target_end_date:dateForm.targetEndDate,target_days:newDays}:{})});
                        }
                        // Location & CE Type live on the deal, not the card
                        if(upDeals&&(dateForm.location!==(deal?.location||"")||dateForm.ceType!==(deal?.ceType||""))){
                          upDeals(ds=>ds.map(d=>d.id===selDeal?{...d,location:dateForm.location||"",ceType:dateForm.ceType||d.ceType}:d));
                          if(isSupabaseReady()) sbUpdate('deals',selDeal,{location:dateForm.location||"",ce_type:dateForm.ceType||deal?.ceType||""}).catch(()=>{});
                        }
                        logActivity(selDeal,"Dates Updated",`Award: ${dateForm.awardDate}${dateForm.targetEndDate?` → Turnover: ${dateForm.targetEndDate}`:""}`,session?.name);
                        toastEmit&&toastEmit("Dates saved ✓","success");
                        setShowDateEdit(false);
                      }} disabled={!dateForm.awardDate||(dateForm.targetEndDate&&dateForm.awardDate>dateForm.targetEndDate)}
                        style={{flex:1,background:(dateForm.awardDate&&(!dateForm.targetEndDate||dateForm.awardDate<=dateForm.targetEndDate))?"#1e293b":"#e2e8f0",border:"none",borderRadius:8,padding:"8px",fontFamily:"inherit",fontSize:".82rem",color:(dateForm.awardDate&&(!dateForm.targetEndDate||dateForm.awardDate<=dateForm.targetEndDate))?"#fff":"#94a3b8",cursor:(dateForm.awardDate&&(!dateForm.targetEndDate||dateForm.awardDate<=dateForm.targetEndDate))?"pointer":"not-allowed",fontWeight:700}}>✓ Save Dates</button>
                      <button onClick={()=>setShowDateEdit(false)}
                        style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"8px 14px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>Cancel</button>
                    </div>
                  </div>
                ):(
                  <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(3,1fr)",gap:8,marginBottom:10}}>
                    {[{l:"Location",v:deal?.location||"—"},{l:"Award Date",v:card?.awardDate||"—"},{l:"Target Due",v:card?.targetEndDate||"Not set"},{l:"CE Type",v:deal?.ceType||"—"},{l:"Elapsed",v:card?.awardDate?elapsed+"d":"—"},{l:"TAT",v:card?.targetDays?card.targetDays+"d target":"Not set"}].map(({l,v})=>(
                      <div key={l} style={{background:"#f8fafc",borderRadius:8,padding:"8px 10px"}}>
                        <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>{l}</div>
                        <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{v}</div>
                      </div>
                    ))}
                  </div>
                )}
                {!showDateEdit&&<div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {deal?.salesRepoLink&&<a href={deal.salesRepoLink} target="_blank" rel="noreferrer" style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",color:"#3b82f6",textDecoration:"none",fontWeight:700,background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:6,padding:"4px 10px"}}>📁 Sales Repo</a>}
                  {(card?.commsLink||jo?.commsLink)&&<a href={card?.commsLink||jo?.commsLink} target="_blank" rel="noreferrer" style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:".72rem",color:"#059669",textDecoration:"none",fontWeight:700,background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:6,padding:"4px 10px"}}>📱 Comms Group</a>}
                </div>}
              </div>

              {/* ── Phase Timeline ── */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:isMobile?"12px 14px":"14px 20px"}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem",marginBottom:12}}>🗺 Project Phases</div>
                <div style={{display:"flex",alignItems:"center",overflowX:"auto",paddingBottom:4}}>
                  {PHASES.map((phase,i)=>{
                    const isActive=i===pi; const isPast=i<pi;
                    return(
                      <React.Fragment key={phase.id}>
                        <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,minWidth:64}}>
                          <div style={{width:38,height:38,borderRadius:"50%",background:isActive?"#1e293b":isPast?"#10b981":"#f1f5f9",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1rem",border:isActive?"2.5px solid #f59e0b":"2.5px solid transparent",boxShadow:isActive?"0 0 0 3px rgba(245,158,11,.2)":undefined}}>
                            {isPast?"✓":phase.icon}
                          </div>
                          <div style={{fontSize:".58rem",fontWeight:isActive?800:500,color:isActive?"#f59e0b":isPast?"#10b981":"#94a3b8",textAlign:"center",whiteSpace:"nowrap"}}>{phase.label}</div>
                        </div>
                        {i<PHASES.length-1&&<div style={{flex:1,height:2,background:i<pi?"#10b981":"#e2e8f0",minWidth:8}}/>}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>

              {/* ── Department Progress (click to toggle done / expand tasks) ── */}
              {card&&(()=>{
                const doneDepts=DEPT_ORDER.filter(d=>card.departments?.[d]?.done).length;
                const autoPct=Math.round(doneDepts/6*100);
                const canEditManual=role==="Manager"||role==="Operations"||role==="SalesOpsAdmin";
                const setManual=(val)=>{
                  upPcards(ps=>({...ps,[selDeal]:{...ps[selDeal],manualProgress:val}}));
                  if(isSupabaseReady()) syncProjectCard(selDeal,{manual_progress:val});
                };
                return(
                <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:isMobile?"12px 14px":"14px 20px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>🏗 Department Progress</div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <span style={{fontSize:".72rem",fontWeight:700,color:pct>=100?"#059669":"#64748b"}}>{pct}%{card.manualProgress!=null&&<span style={{color:"#8b5cf6",fontWeight:600}}> (manual)</span>}</span>
                      <span style={{fontSize:".66rem",color:"#94a3b8"}}>{doneDepts}/6 done</span>
                    </div>
                  </div>
                  {/* progress bar */}
                  <div style={{height:7,background:"#f1f5f9",borderRadius:4,overflow:"hidden",marginBottom:12}}>
                    <div style={{height:"100%",width:pct+"%",background:pct>=100?"#059669":pct>=50?"#10b981":"#f59e0b",borderRadius:4,transition:"width .2s"}}/>
                  </div>
                  {/* department rows */}
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {DEPT_ORDER.map(dept=>{
                      const dd=card.departments?.[dept]||{done:false,tasks:[]};
                      const canEditDept=editableDepts.includes(dept);
                      const clr=DEPT_CLR[dept]||"#64748b";
                      const tasks=dd.tasks||[];
                      const doneTasks=tasks.filter(t=>t.done).length;
                      return(
                        <details key={dept} style={{background:dd.done?"#f0fdf4":"#f8fafc",border:`1px solid ${dd.done?"#a7f3d0":"#e2e8f0"}`,borderRadius:10,padding:"8px 12px"}}>
                          <summary style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",listStyle:"none"}}>
                            <input type="checkbox" checked={!!dd.done} disabled={!canEditDept}
                              onChange={e=>{e.stopPropagation();markDeptDone(selDeal,dept,e.target.checked);}}
                              onClick={e=>e.stopPropagation()}
                              style={{width:17,height:17,accentColor:clr,cursor:canEditDept?"pointer":"not-allowed",flexShrink:0}}/>
                            <span style={{width:8,height:8,borderRadius:"50%",background:clr,flexShrink:0}}/>
                            <span style={{fontWeight:700,fontSize:".8rem",color:dd.done?"#059669":"#0f172a",flex:1}}>{dept}</span>
                            {tasks.length>0&&<span style={{fontSize:".66rem",color:"#94a3b8"}}>{doneTasks}/{tasks.length} tasks</span>}
                            {dd.done&&dd.doneBy&&<span style={{fontSize:".62rem",color:"#059669"}}>✓ {dd.doneBy}</span>}
                            {tasks.length>0&&<span style={{fontSize:".7rem",color:"#94a3b8"}}>▾</span>}
                          </summary>
                          {tasks.length>0&&(
                            <div style={{marginTop:8,paddingLeft:27,display:"flex",flexDirection:"column",gap:5}}>
                              {tasks.map(t=>(
                                <label key={t.id} style={{display:"flex",alignItems:"center",gap:8,cursor:canEditDept?"pointer":"default"}}>
                                  <input type="checkbox" checked={!!t.done} disabled={!canEditDept}
                                    onChange={()=>toggleDeptTask(selDeal,dept,t.id)}
                                    style={{width:14,height:14,accentColor:clr,cursor:canEditDept?"pointer":"not-allowed",flexShrink:0}}/>
                                  <span style={{fontSize:".76rem",color:t.done?"#94a3b8":"#334155",textDecoration:t.done?"line-through":"none"}}>{t.text}</span>
                                </label>
                              ))}
                            </div>
                          )}
                          {tasks.length===0&&<div style={{marginTop:6,paddingLeft:27,fontSize:".72rem",color:"#94a3b8"}}>No sub-tasks — use the checkbox to mark this department done.</div>}
                        </details>
                      );
                    })}
                  </div>
                  {/* manual progress override */}
                  {canEditManual&&(
                    <div style={{marginTop:12,paddingTop:10,borderTop:"1px solid #f1f5f9",display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                      <span style={{fontSize:".68rem",color:"#94a3b8",fontWeight:600}}>Manual override:</span>
                      <input type="number" min={0} max={100} value={card.manualProgress!=null?card.manualProgress:""}
                        placeholder={`auto ${autoPct}`}
                        onChange={e=>{const v=e.target.value===""?null:Math.max(0,Math.min(100,Number(e.target.value)));setManual(v);}}
                        style={{width:72,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"5px 8px",fontFamily:"inherit",fontSize:".8rem"}}/>
                      <span style={{fontSize:".72rem",color:"#64748b"}}>%</span>
                      {card.manualProgress!=null&&<button onClick={()=>setManual(null)} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"5px 10px",fontFamily:"inherit",fontSize:".72rem",color:"#64748b",cursor:"pointer",fontWeight:600}}>↺ Use auto ({autoPct}%)</button>}
                    </div>
                  )}
                </div>
                );
              })()}

              {/* ── Blockers ── */}
              <div style={{background:openProjB.length>0?"#fef2f2":"#fff",borderRadius:14,border:`1.5px solid ${openProjB.length>0?"#fecaca":"#e2e8f0"}`,padding:isMobile?"12px 14px":"14px 20px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:openProjB.length>0||showBForm?10:0}}>
                  <div style={{fontWeight:700,color:openProjB.length>0?"#dc2626":"#0f172a",fontSize:".82rem"}}>
                    ⛔ Blockers{openProjB.length>0&&<span style={{background:"#ef4444",color:"#fff",borderRadius:20,fontSize:".6rem",padding:"1px 7px",marginLeft:5}}>{openProjB.length}</span>}
                    {openProjB.length===0&&projBlockers.filter(b=>b.status==="Resolved").length>0&&<span style={{fontSize:".68rem",color:"#94a3b8",fontWeight:400,marginLeft:6}}>({projBlockers.filter(b=>b.status==="Resolved").length} resolved)</span>}
                  </div>
                  {canFlagBlocker&&!showBForm&&<button onClick={()=>{setShowBForm(true);setBfTitle("");setBfDept("Operations");setBfDetail("");}} style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"5px 12px",fontFamily:"inherit",fontSize:".75rem",color:"#dc2626",cursor:"pointer",fontWeight:700}}>+ Flag Blocker</button>}
                </div>
                {openProjB.map(b=>(
                  <div key={b.id} style={{background:"#fff",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{b.title}</div>
                      {b.detail&&<div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>{b.detail}</div>}
                      <div style={{fontSize:".67rem",color:"#94a3b8",marginTop:3}}>By {b.flaggedBy} · {b.createdAt?.split("T")[0]} · <span style={{color:DEPT_CLR[b.dept]||"#64748b",fontWeight:700}}>{b.dept}</span> to act</div>
                    </div>
                    {(role==="Manager"||editableDepts.includes(b.dept))&&<button onClick={()=>resolveBlocker(b.id)} style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontSize:".72rem",color:"#059669",cursor:"pointer",fontWeight:700,flexShrink:0}}>✓ Resolve</button>}
                  </div>
                ))}
                {openProjB.length===0&&!showBForm&&<div style={{fontSize:".78rem",color:"#94a3b8",textAlign:"center",padding:"2px 0"}}>No open blockers ✓</div>}
                {showBForm&&(
                  <div style={{background:"#fff",border:"1px solid #fecaca",borderRadius:10,padding:"14px",marginTop:8}}>
                    <input value={bfTitle} onChange={e=>setBfTitle(e.target.value)} placeholder="What's blocking? (required)" style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 10px",fontFamily:"inherit",fontSize:".84rem",marginBottom:8,boxSizing:"border-box"}}/>
                    <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:8,marginBottom:8}}>
                      <select value={bfDept} onChange={e=>setBfDept(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 10px",fontFamily:"inherit",fontSize:".82rem"}}>
                        {DEPT_ORDER.map(d=><option key={d} value={d}>{d}</option>)}
                      </select>
                      <input value={bfDetail} onChange={e=>setBfDetail(e.target.value)} placeholder="Context / details (optional)" style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"7px 10px",fontFamily:"inherit",fontSize:".82rem"}}/>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>{if(!bfTitle.trim())return;addBlocker(selDeal,bfTitle.trim(),bfDept||"Operations",bfDetail.trim());setShowBForm(false);}} style={{background:"#ef4444",border:"none",borderRadius:8,padding:"8px 18px",fontFamily:"inherit",fontSize:".82rem",color:"#fff",cursor:"pointer",fontWeight:700}}>⛔ Submit</button>
                      <button onClick={()=>setShowBForm(false)} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"8px 14px",fontFamily:"inherit",fontSize:".82rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
                    </div>
                  </div>
                )}
              </div>

              {/* ── TAT (collapsible) ── */}
              {card&&(
                <div style={{background:isOver?"#fef2f2":"#f0fdf4",borderRadius:14,border:`1.5px solid ${isOver?"#fecaca":"#6ee7b7"}`,overflow:"hidden"}}>
                  <div onClick={()=>setTatOpen(o=>!o)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:isMobile?"12px 14px":"14px 20px",cursor:"pointer"}}>
                    <div style={{fontWeight:700,color:isOver?"#dc2626":"#059669",fontSize:".82rem"}}>⏱ Turnaround Time{card.targetDays&&<span style={{fontWeight:400,color:isOver?"#ef4444":dLeft<=7?"#f59e0b":"#059669",marginLeft:6}}>{isOver?`— ⚠ ${Math.abs(dLeft)}d overdue`:`— ${dLeft}d remaining`}</span>}</div>
                    <span style={{color:"#94a3b8",fontSize:".8rem"}}>{tatOpen?"▲":"▼"}</span>
                  </div>
                  {tatOpen&&(
                    <div style={{padding:isMobile?"0 14px 14px":"0 20px 16px"}}>
                      {card.targetDays&&(
                        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:8,marginBottom:10}}>
                          {[{l:"Award Date",v:card.awardDate||"—"},{l:"Target",v:card.targetDays+" days"},{l:"Due Date",v:card.targetEndDate||"—"},{l:"Elapsed",v:elapsed+" days"}].map(({l,v})=>(
                            <div key={l} style={{background:"rgba(255,255,255,.7)",borderRadius:8,padding:"8px 10px"}}>
                              <div style={{fontSize:".58rem",textTransform:"uppercase",color:"#94a3b8",marginBottom:1}}>{l}</div>
                              <div style={{fontSize:".82rem",fontWeight:600,color:"#0f172a"}}>{v}</div>
                            </div>
                          ))}
                        </div>
                      )}
                      {!card.targetDays&&<div style={{fontSize:".8rem",color:"#94a3b8",marginBottom:10}}>Turnover date not set — QS or Operations should set the target date.</div>}
                      {card.targetDays&&(
                        <div style={{marginBottom:12}}>
                          <div style={{display:"flex",justifyContent:"space-between",fontSize:".68rem",color:"#94a3b8",marginBottom:3}}>
                            <span>Day {elapsed} of {card.targetDays}</span>
                            <span>{Math.min(100,Math.round(elapsed/card.targetDays*100))}% of time used</span>
                          </div>
                          <div style={{height:6,background:"rgba(0,0,0,.1)",borderRadius:3,overflow:"hidden"}}>
                            <div style={{height:"100%",width:Math.min(100,elapsed/card.targetDays*100)+"%",background:isOver?"#ef4444":elapsed/card.targetDays>0.8?"#f59e0b":"#10b981",borderRadius:3}}/>
                          </div>
                        </div>
                      )}
                      {canSetTAT&&<TATSetter deal={deal} card={card} onSet={setProjectTAT} refTable={refTable} ceType={ceType}/>}
                      {card.tatSetBy&&<div style={{fontSize:".68rem",color:"#94a3b8",marginTop:8}}>Set by {card.tatSetBy} · {card.tatSetAt?.split("T")[0]}</div>}
                    </div>
                  )}
                </div>
              )}

              {/* ── Team Updates (single unified feed — posts via the canonical Log Update modal) ── */}
              {(()=>{
                const allProjUpdates=(actLog||[]).filter(a=>a.dealId===selDeal&&a.action==="PM Update").sort((a,b)=>b.date.localeCompare(a.date)||b.time?.localeCompare(a.time||""));
                const isPM=card&&[card.pm1,card.pm2,card.pm3].filter(Boolean).some(pm=>pm===session?.name);
                const canPost=role==="Manager"||role==="Operations"||role==="ProjectMover"||role==="SalesOpsAdmin"||role==="Coordinator"||isPM;
                return(
                <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  <div style={{background:"#1e293b",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{fontWeight:700,color:"#4ade80",fontSize:".82rem"}}>💬 Team Updates ({allProjUpdates.length})</div>
                    {canPost&&<button onClick={()=>setPmUpdateModal({dealId:selDeal,dealName:deal?.client||"",stage:deal?.stage||"",pct})} style={{background:"rgba(255,255,255,.1)",border:"1px solid rgba(255,255,255,.2)",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontSize:".75rem",color:"#4ade80",cursor:"pointer",fontWeight:700}}>+ Post Update</button>}
                  </div>
                  {/* Chat messages */}
                  <div style={{padding:"12px 16px",display:"flex",flexDirection:"column",gap:10,maxHeight:400,overflowY:"auto"}}>
                    {allProjUpdates.length===0&&(
                      <div style={{textAlign:"center",padding:"16px 0",color:"#94a3b8",fontSize:".8rem"}}>No updates yet.{canPost&&" Tap + Post Update to add the first one."}</div>
                    )}
                    {allProjUpdates.map((u,i)=>{
                      const isMe=u.by===session?.name;
                      const initials=(u.by||"?").split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();
                      const hasTag=u.detail?.includes("@");
                      return(
                        <div key={u.id||i} style={{display:"flex",gap:8,alignItems:"flex-start",flexDirection:isMe?"row-reverse":"row"}}>
                          <div style={{width:32,height:32,borderRadius:"50%",background:isMe?"#059669":"#1e293b",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2}}>
                            <span style={{fontSize:".65rem",fontWeight:800,color:"#fff"}}>{initials}</span>
                          </div>
                          <div style={{maxWidth:"75%"}}>
                            <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:3,flexDirection:isMe?"row-reverse":"row"}}>
                              <span style={{fontWeight:700,color:"#0f172a",fontSize:".75rem"}}>{u.by}</span>
                              <span style={{fontSize:".65rem",color:"#94a3b8"}}>{u.date} {u.time}</span>
                            </div>
                            <div style={{
                              background:isMe?"#dcfce7":hasTag?"#fef3c7":"#f8fafc",
                              border:`1px solid ${isMe?"#6ee7b7":hasTag?"#fde68a":"#e2e8f0"}`,
                              borderRadius:isMe?"12px 4px 12px 12px":"4px 12px 12px 12px",
                              padding:"9px 12px",fontSize:".82rem",color:"#0f172a",lineHeight:1.5,
                              wordBreak:"break-word"
                            }}>
                              {(u.detail||"").split(/(@\w+)/g).map((part,j)=>
                                part.startsWith("@")
                                  ?<strong key={j} style={{color:"#2563eb"}}>{part}</strong>
                                  :<span key={j}>{part}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                );
              })()}

              {/* ── Project Checklist ── */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                <div style={{padding:isMobile?"12px 14px":"14px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>
                    ✅ Checklist
                    {projCl.filter(c=>c.status!=="Done").length>0&&<span style={{background:"#f59e0b",color:"#fff",borderRadius:20,fontSize:".6rem",padding:"1px 7px",marginLeft:5}}>{projCl.filter(c=>c.status!=="Done").length}</span>}
                  </div>
                  {role!=="Coordinator"&&<div style={{display:"flex",gap:6}}>
                    {projCl.length===0&&loadChecklistTemplate&&<button onClick={()=>{const d=deal;if(d)loadChecklistTemplate(d.id,d.client);}} style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:8,padding:"5px 12px",fontFamily:"inherit",fontSize:".75rem",color:"#1d4ed8",cursor:"pointer",fontWeight:700}}>📋 Load Template</button>}
                    <button onClick={()=>openAddCl&&openAddCl(selDeal,"Design","Task")} style={{background:"#ede9fe",border:"none",borderRadius:8,padding:"5px 12px",fontFamily:"inherit",fontSize:".75rem",color:"#7c3aed",cursor:"pointer",fontWeight:700}}>🎨 Request from Design</button>
                    <button onClick={()=>openAddCl&&openAddCl(selDeal,role==="Design"?"Design":"Operations")} style={{background:"#f1f5f9",border:"none",borderRadius:8,padding:"5px 12px",fontFamily:"inherit",fontSize:".75rem",color:"#475569",cursor:"pointer",fontWeight:700}}>+ Add Task</button>
                  </div>}
                </div>
                {projCl.length===0?(
                  <div style={{padding:"14px 20px",color:"#94a3b8",fontSize:".78rem",textAlign:"center"}}>No checklist tasks yet for this project.</div>
                ):(
                  <div style={{display:"flex",flexDirection:"column",gap:0}}>
                    {projCl.map((c,i)=>(
                      <div key={c.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 16px",borderBottom:i<projCl.length-1?"1px solid #f8fafc":"none",background:"#fff"}}>
                        <select value={c.status} onChange={e=>clStatusQ&&clStatusQ(c.id,e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:6,padding:"3px 6px",fontFamily:"inherit",fontSize:".68rem",color:"#0f172a",background:"#fff",cursor:"pointer",flexShrink:0}}>
                          {["To Do","In Progress","Done"].map(s=><option key={s}>{s}</option>)}
                        </select>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:".82rem",color:c.status==="Done"?"#94a3b8":"#0f172a",textDecoration:c.status==="Done"?"line-through":"none",fontWeight:c.status==="Done"?400:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.title}</div>
                          <div style={{fontSize:".65rem",color:"#94a3b8",marginTop:1,display:"flex",gap:6,flexWrap:"wrap"}}>
                            <span style={{background:"#f1f5f9",borderRadius:4,padding:"0 5px"}}>{c.dept||"Ops"}</span>
                            {c.priority&&c.priority!=="Normal"&&<span style={{color:c.priority==="Urgent"?"#ef4444":"#f59e0b",fontWeight:700}}>{c.priority}</span>}
                            {c.dueDate&&<span style={{color:c.dueDate<todayStr?"#ef4444":"#94a3b8"}}>Due {c.dueDate}</span>}
                            {c.assignedTo&&<span>👤 {c.assignedTo.split(" ")[0]}</span>}
                          </div>
                        </div>
                        <div style={{display:"flex",gap:4,flexShrink:0}}>
                          {openEditCl&&role!=="Coordinator"&&<button onClick={()=>openEditCl(c)} style={{background:"#f1f5f9",border:"none",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#475569",cursor:"pointer",fontFamily:"inherit"}}>✏</button>}
                          {(role==="Manager"||role==="Operations"||role==="SalesOpsAdmin")&&delCl&&<button onClick={()=>delCl(c.id)} style={{background:"#fef2f2",border:"none",borderRadius:6,padding:"4px 8px",fontSize:".68rem",color:"#dc2626",cursor:"pointer",fontFamily:"inherit"}}>✕</button>}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* ── Scope Changes (Total Contract roll-up) ──
                  Finance-facing: shows Initial + Addendums = Total. Hidden from
                  Operations/PM/Design — they maintain the single project card and
                  don't need the contract total; scope changes are Sales-owned. */}
              {!["Operations","ProjectMover","Design"].includes(role)&&(
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:isMobile?"12px 14px":"14px 20px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:projAddenda.length>0?10:0}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>⚠️ Scope Changes{projAddenda.length>0&&<span style={{fontSize:".68rem",color:"#94a3b8",fontWeight:400,marginLeft:5}}>({projAddenda.length})</span>}</div>
                </div>
                {(projAddenda.length>0||(deals||[]).some(d=>d.parentDealId===deal.id&&!isLostStage(d.stage)))&&<div style={{marginBottom:10}}><ContractBreakdown deal={deal} addenda={addenda} deals={deals}/></div>}
                {projAddenda.length===0&&!(deals||[]).some(d=>d.parentDealId===deal.id&&!isLostStage(d.stage))&&<div style={{fontSize:".78rem",color:"#94a3b8"}}>No scope changes for this project.</div>}
                {projAddenda.slice(0,3).map(a=>{
                  const sc={"Discovered":"#94a3b8","Sales Notified":"#f59e0b","Client Coordinating":"#3b82f6","Approved":"#059669","Billed":"#8b5cf6","Collected":"#10b981","Rejected":"#ef4444"}[a.status]||"#94a3b8";
                  return(
                    <div key={a.id} style={{padding:"9px 12px",borderRadius:8,background:"#fffbeb",border:"1px solid #fde68a",marginBottom:6,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                      <div>
                        <div style={{fontWeight:600,color:"#0f172a",fontSize:".82rem"}}>{a.title}</div>
                        {Number(a.value)>0&&<div style={{fontSize:".72rem",color:"#92400e",marginTop:1}}>₱{Number(a.value).toLocaleString("en-PH")} additional</div>}
                      </div>
                      <span style={{fontSize:".63rem",background:sc+"22",color:sc,border:`1px solid ${sc}44`,borderRadius:20,padding:"2px 8px",fontWeight:700,flexShrink:0}}>{a.status}</span>
                    </div>
                  );
                })}
                {projAddenda.length>3&&<div style={{fontSize:".72rem",color:"#94a3b8",marginTop:4}}>+{projAddenda.length-3} more — see Scope Changes page</div>}
              </div>
              )}


              {/* ── Finance Snapshot ── */}
              <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:isMobile?"12px 14px":"14px 20px",marginBottom:8}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,gap:8,flexWrap:"wrap"}}>
                  <div style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>💰 Finance Snapshot</div>
                  {["Manager","Finance","FinanceAssistant","Accounting","Operations","Sales"].includes(role)&&(
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <button onClick={()=>{setJumpDeal(selDeal);setPage("budget");}}
                        style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:7,padding:"4px 11px",fontFamily:"inherit",fontSize:".72rem",color:"#2563eb",cursor:"pointer",fontWeight:700}}>📊 Budget →</button>
                      <button onClick={()=>{setJumpDeal(selDeal);setPage("billing");}}
                        style={{background:"#f0fdf4",border:"1px solid #6ee7b7",borderRadius:7,padding:"4px 11px",fontFamily:"inherit",fontSize:".72rem",color:"#059669",cursor:"pointer",fontWeight:700}}>🧾 Billing →</button>
                    </div>
                  )}
                </div>
                <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:8}}>
                  {[
                    {l:"Contract",v:fmtPHP(deal?.value||0),c:"#0f172a"},
                    {l:"Billed",v:totalBilled>0?fmtPHP(totalBilled):"Not yet billed",c:totalBilled>0?"#3b82f6":"#94a3b8"},
                    {l:"Collected",v:fmtPHP(totalColl),c:totalColl>0?"#059669":"#94a3b8"},
                    {l:"Outstanding",v:totalBilled>totalColl?fmtPHP(totalBilled-totalColl):"—",c:totalBilled>totalColl?"#f59e0b":"#94a3b8"},
                  ].map(({l,v,c})=>(
                    <div key={l} style={{background:"#f8fafc",borderRadius:8,padding:"10px 12px"}}>
                      <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>{l}</div>
                      <div style={{fontWeight:800,fontSize:".88rem",color:c,lineHeight:1.3,wordBreak:"break-all"}}>{v}</div>
                    </div>
                  ))}
                </div>
                <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:8,marginTop:8}}>
                  {[
                    {l:"Committed (open POs)",v:totalCommitted>0?fmtPHP(totalCommitted):"—",c:totalCommitted>0?"#a16207":"#94a3b8"},
                    {l:"Actual Spend",v:totalActualCost>0?fmtPHP(totalActualCost):"—",c:totalActualCost>0?"#0f172a":"#94a3b8"},
                    {l:"Total Exposure",v:totalExposure>0?fmtPHP(totalExposure):"—",c:totalExposure>0?"#dc2626":"#94a3b8"},
                    {l:"Profit Margin",v:profitMargin!==null?profitMargin+"%":"—",c:profitMargin===null?"#94a3b8":profitMargin>=20?"#059669":profitMargin>=10?"#f59e0b":"#ef4444"},
                  ].map(({l,v,c})=>(
                    <div key={l} style={{background:"#f8fafc",borderRadius:8,padding:"10px 12px"}}>
                      <div style={{fontSize:".58rem",textTransform:"uppercase",letterSpacing:".8px",color:"#94a3b8",marginBottom:2}}>{l}</div>
                      <div style={{fontWeight:800,fontSize:".88rem",color:c,lineHeight:1.3,wordBreak:"break-all"}}>{v}</div>
                    </div>
                  ))}
                </div>
                {(pendingMRs>0||pendingBRs>0)&&(
                  <div style={{marginTop:10,display:"flex",gap:6,flexWrap:"wrap"}}>
                    {pendingMRs>0&&<span style={{fontSize:".72rem",background:"#fff3ed",color:"#f97316",border:"1px solid #fed7aa",borderRadius:6,padding:"3px 10px",fontWeight:700}}>🔧 {pendingMRs} MR{pendingMRs>1?"s":""} pending</span>}
                    {pendingBRs>0&&<span style={{fontSize:".72rem",background:"#f5f3ff",color:"#8b5cf6",border:"1px solid #ddd6fe",borderRadius:6,padding:"3px 10px",fontWeight:700}}>💳 {pendingBRs} BR{pendingBRs>1?"s":""} pending</span>}
                  </div>
                )}
              </div>

            </div>
          );
        })()
      )}
    </div>
    {pmUpdateModal&&<PmUpdateModal deals={deals} role={role} changeDealStage={changeDealStage} setProjectProgress={setProjectProgress} sendTelegramNotification={sendTelegramNotification} pmUpdateModal={pmUpdateModal} setPmUpdateModal={setPmUpdateModal} session={session} logActivity={logActivity} addPmUpdate={addPmUpdate} updateProjectTurnover={(dealId,date)=>{upPcards(ps=>({...ps,[dealId]:{...ps[dealId],targetEndDate:date}}));if(isSupabaseReady())syncProjectCard(dealId,{target_end_date:date});}}/>}
    </>
  );
}


// ─── BOT SETTINGS VIEW ────────────────────────────────────────────────────────
function BotSettingsView({botSettings,saveBotSettings,role,Wrap}){
  // The token is write-only here: it is kept in app_secrets on the server and
  // never sent back to any browser. Only a Manager can replace it.
  const[form,setForm]=React.useState({token:"",chatIds:{...{general:"",ops:"",design:"",procurement:"",sales:"",management:""},...(botSettings.chatIds||{})},hideValueInBots:botSettings.hideValueInBots||false});
  const[testing,setTesting]=React.useState(null);
  const[testResult,setTestResult]=React.useState({});
  const[saved,setSaved]=React.useState(false);

  // Chat IDs and privacy save only for a Manager (migration 20261026123914):
  // whoever sets the chat IDs decides where management alerts go.
  const canEdit=role==="Manager";
  const[tokenStatus,setTokenStatus]=React.useState(null);
  const loadTokenStatus=React.useCallback(()=>{
    if(!isSupabaseReady()) return;
    supabase.rpc('telegram_token_status').then(({data})=>setTokenStatus(data||null),()=>{});
  },[]);
  React.useEffect(()=>{loadTokenStatus();},[loadTokenStatus]);

  const CHANNELS=[
    {id:"general",         label:"🌐 General",          hint:"All-team announcements"},
    {id:"ops",             label:"🏗 Operations",        hint:"PM updates, project alerts"},
    {id:"design",          label:"🎨 Design",             hint:"DRF submissions, design deadlines"},
    {id:"procurement",     label:"📦 Procurement",       hint:"MRs, deliveries, swatch approvals"},
    {id:"warehouse",       label:"🏭 Warehouse",         hint:"Deliveries, stock movements"},
    {id:"sales",           label:"💼 Sales",              hint:"Swatch approvals, deal updates"},
    {id:"management",      label:"👔 Management",        hint:"High-level overdue alerts only"},
    {id:"financialcontrol",label:"💰 Cost Control",      hint:"Final billing, payment releases, billing due, collections"},
  ];

  // Sends through the server with the saved token to the chat ID typed here,
  // then reads Telegram's reply (send_telegram / telegram_send_result).
  const testChannel=async(chId)=>{
    setTesting(chId);
    const chatId=String(form.chatIds?.[chId]||"").trim();
    const done=r=>{setTestResult(x=>({...x,[chId]:r}));setTesting(null);};
    if(!tokenStatus?.set) return done({ok:false,msg:"No bot token saved yet"});
    if(!chatId) return done({ok:false,msg:"Chat ID missing"});
    const{data:id,error}=await supabase.rpc('send_telegram',{p_dept:chId,p_message:`🤖 <b>FabHub Test</b>\nChannel: <b>${chId}</b>\nBot is live! ✅`,p_chat_id:chatId});
    if(error) return done({ok:false,msg:"❌ "+(error.message||"Could not send")});
    for(let i=0;i<8;i++){
      await new Promise(r=>setTimeout(r,1000));
      const{data:res}=await supabase.rpc('telegram_send_result',{p_id:id});
      if(res?.done) return done(res.ok?{ok:true,msg:"✅ Message sent!"}:{ok:false,msg:"❌ "+(res.description||"Telegram refused it")});
    }
    done({ok:false,msg:"⏳ Sent, but no reply from Telegram yet: check the group"});
  };

  const doSave=async()=>{
    const ok=await saveBotSettings(form);
    if(!ok) return;
    if(form.token){setForm(f=>({...f,token:""}));loadTokenStatus();}
    setSaved(true);setTimeout(()=>setSaved(false),2500);
  };

  return(
    <Wrap>
      <div style={{maxWidth:660,margin:"0 auto"}}>
        <h2 style={{margin:"0 0 4px",fontWeight:900,fontSize:"1.4rem",color:"#0f172a",fontFamily:"'Barlow Condensed',sans-serif"}}>🤖 Telegram Bot Settings</h2>
        <p style={{margin:"0 0 20px",fontSize:".8rem",color:"#64748b"}}>Connect FabHub to your Telegram groups for instant notifications on key events.</p>

        <div style={{background:"#eff6ff",border:"1.5px solid #93c5fd",borderRadius:12,padding:"14px 18px",marginBottom:20}}>
          <div style={{fontWeight:700,color:"#1d4ed8",marginBottom:6,fontSize:".85rem"}}>⚡ 4-Step Setup</div>
          <ol style={{margin:0,paddingLeft:18,fontSize:".78rem",color:"#1e40af",lineHeight:1.75}}>
            <li>Message <strong>@BotFather</strong> on Telegram → /newbot → copy the API token</li>
            <li>Create a Telegram group for each department and add the bot as <strong>admin</strong></li>
            <li>Send any message in each group, then open: <code style={{background:"#dbeafe",padding:"1px 5px",borderRadius:3}}>api.telegram.org/bot[TOKEN]/getUpdates</code></li>
            <li>Find the <code>chat.id</code> (negative number) and paste it below</li>
          </ol>
        </div>

        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"18px",marginBottom:16}}>
          <div style={{fontWeight:700,color:"#0f172a",marginBottom:8}}>🔑 Bot Token</div>
          <div style={{fontSize:".78rem",color:tokenStatus?.set?"#059669":"#b45309",fontWeight:600,marginBottom:8}}>
            {tokenStatus==null?"Checking…":tokenStatus.set?`✓ Token saved on the server${tokenStatus.updated_by?` · last set by ${tokenStatus.updated_by}`:""}${tokenStatus.updated_at?` · ${String(tokenStatus.updated_at).slice(0,10)}`:""}`:"No token saved yet"}
          </div>
          {role==="Manager"?<>
            <input type="password" autoComplete="off" value={form.token||""} onChange={e=>setForm(f=>({...f,token:e.target.value}))} placeholder={tokenStatus?.set?"Paste a new token to replace it (leave blank to keep)":"7123456789:AAH9g3kXXX..."}
              style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"9px 12px",fontFamily:"inherit",fontSize:".85rem",color:"#0f172a",boxSizing:"border-box"}}/>
            <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:4}}>Kept on the server only: FabHub never shows it again or stores it on any device.</div>
          </>:<div style={{fontSize:".7rem",color:"#94a3b8"}}>Only a Manager can change the bot token.</div>}
        </div>

        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"18px",marginBottom:16}}>
          <div style={{fontWeight:700,color:"#0f172a",marginBottom:14}}>📢 Department Group Chat IDs</div>
          {CHANNELS.map(ch=>(
            <div key={ch.id} style={{marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
                <div>
                  <div style={{fontWeight:600,color:"#475569",fontSize:".82rem"}}>{ch.label}</div>
                  <div style={{fontSize:".68rem",color:"#94a3b8"}}>{ch.hint}</div>
                </div>
                <button onClick={()=>testChannel(ch.id)} disabled={testing===ch.id}
                  style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:7,padding:"5px 12px",fontFamily:"inherit",fontWeight:600,fontSize:".72rem",color:"#475569",cursor:"pointer",opacity:testing===ch.id?.5:1}}>
                  {testing===ch.id?"Testing...":"Test →"}
                </button>
              </div>
              <input value={form.chatIds?.[ch.id]||""} readOnly={!canEdit} onChange={e=>setForm(f=>({...f,chatIds:{...(f.chatIds||{}),[ch.id]:e.target.value}}))} placeholder="-100123456789"
                style={{width:"100%",border:`1.5px solid ${testResult[ch.id]?.ok?"#6ee7b7":testResult[ch.id]?.ok===false?"#fecaca":"#e2e8f0"}`,borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",boxSizing:"border-box"}}/>
              {testResult[ch.id]&&<div style={{fontSize:".72rem",marginTop:4,color:testResult[ch.id].ok?"#059669":"#dc2626",fontWeight:600}}>{testResult[ch.id].msg}</div>}
            </div>
          ))}
        </div>

        <div style={{background:"#f8fafc",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"16px",marginBottom:20}}>
          <div style={{fontWeight:700,color:"#0f172a",marginBottom:10}}>🔔 What Gets Notified</div>
          {[
            {icon:"🏆",label:"Project awarded / JO issued",ch:"ALL departments"},
            {icon:"📝",label:"PM Update logged",ch:"Operations"},
            {icon:"📋",label:"New Design Request (DRF) submitted",ch:"Design"},
            {icon:"📦",label:"Delivery received by Warehouse",ch:"Procurement"},
            {icon:"🔧",label:"New Material Request submitted",ch:"Procurement"},
            {icon:"✅",label:"PO approved (status → PO Issued)",ch:"Procurement"},
            {icon:"✅",label:"Swatch client-approved",ch:"Procurement + Sales"},
            {icon:"⚠️",label:"Scope change / addendum logged",ch:"Sales + Management"},
            {icon:"💰",label:"Budget request submitted",ch:"Management"},
          ].map((t,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0",borderBottom:i<4?"1px solid #e2e8f0":""}}>
              <span style={{fontSize:".9rem"}}>{t.icon}</span>
              <div style={{flex:1}}>
                <div style={{fontSize:".78rem",color:"#0f172a",fontWeight:500}}>{t.label}</div>
                <div style={{fontSize:".68rem",color:"#94a3b8"}}>→ {t.ch}</div>
              </div>
              <span style={{fontSize:".62rem",background:"#dcfce7",color:"#059669",border:"1px solid #6ee7b7",borderRadius:20,padding:"2px 7px",fontWeight:700}}>ACTIVE</span>
            </div>
          ))}
        </div>

        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"16px",marginBottom:16}}>
          <div style={{fontWeight:700,color:"#0f172a",marginBottom:10}}>🔒 Privacy Settings</div>
          <label style={{display:"flex",alignItems:"center",gap:12,cursor:"pointer"}}>
            <div onClick={()=>canEdit&&setForm(f=>({...f,hideValueInBots:!f.hideValueInBots}))}
              style={{width:42,height:24,borderRadius:12,background:form.hideValueInBots?"#1e293b":"#e2e8f0",position:"relative",transition:"background .2s",cursor:"pointer",flexShrink:0}}>
              <div style={{position:"absolute",top:3,left:form.hideValueInBots?19:3,width:18,height:18,borderRadius:9,background:"#fff",transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,.2)"}}/>
            </div>
            <div>
              <div style={{fontWeight:600,fontSize:".82rem",color:"#0f172a"}}>Hide contract/project values in notifications</div>
              <div style={{fontSize:".7rem",color:"#94a3b8",marginTop:2}}>When on, ₱ amounts are omitted from all bot messages (deal added, award request, project awarded, addendum, budget request)</div>
            </div>
          </label>
        </div>

        {canEdit?<button onClick={doSave}
          style={{background:saved?"#059669":"#1e293b",border:"none",borderRadius:10,padding:"12px 28px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".88rem",cursor:"pointer",width:"100%",transition:"background .3s"}}>
          {saved?"✅ Settings Saved!":"💾 Save Bot Settings"}
        </button>:<div style={{textAlign:"center",fontSize:".78rem",color:"#64748b",padding:"10px 0"}}>View only: a Manager changes the bot token, chat IDs and privacy settings.</div>}
      </div>
    </Wrap>
  );
}

// ─── DATA MANAGEMENT (Manager Only) ──────────────────────────────────────────
function DataManagement({
  deals,exps,inflows,jos,prs,mreqs,breqs,addenda,billings,pcards,checklist,
  cashPositions,actLog,budgets,payables,vouchers,
  upDeals,upExps,upInflows,upJos,upPrs,upMreqs,upBreqs,upAddenda,
  upBillings,upPcards,upChecklist,upCashPos,setActLog,upBudgets,
  upPayables,upVouchers,persist
}){
  const[confirmPurge,setConfirmPurge]=useState(null); // holds purge config
  const[purgeWord,setPurgeWord]=useState("");
  const[purgeResult,setPurgeResult]=useState(null);

  const PURGE_WORD = "PURGE";

  // Data counts for summary
  const counts = {
    "Deals / Pipeline":    deals.length,
    "Expenses":            exps.length,
    "Inflows":             inflows.length,
    "Job Orders":          jos.length,
    "Purchase Requests":   prs.length,
    "Material Requests":   mreqs.length,
    "Budget Requests":     breqs.length,
    "Addenda":             addenda.length,
    "Billing Milestones":  billings.length,
    "Project Cards":       Object.keys(pcards).length,
    "Checklist Items":     checklist.length,
    "Cash Position Days":  Object.keys(cashPositions).length,
    "Activity Log":        actLog.length,
    "Payables":            payables.length,
    "Check Vouchers":      vouchers.length,
  };

  const totalRecords = Object.values(counts).reduce((s,v)=>s+v,0);

  // Purge options
  const PURGE_OPTIONS = [
    {
      key:"all_transactions",
      label:"🧹 Full Purge — Go Live Clean",
      desc:"Removes ALL transaction data. Keeps users, clients, and system settings. Use this when you're ready to start for real.",
      color:"#dc2626",
      bgColor:"#fef2f2",
      borderColor:"#fecaca",
      items:["Deals / Pipeline","Expenses","Inflows","Job Orders","Purchase Requests","Material Requests","Budget Requests","Addenda","Billing Milestones","Project Cards","Checklist Items","Cash Position Days","Activity Log","Payables","Check Vouchers"],
      action:()=>{
        upDeals(()=>[]);upExps(()=>[]);upInflows(()=>[]);upJos(()=>[]);
        upPrs(()=>[]);upMreqs(()=>[]);upBreqs(()=>[]);upAddenda(()=>[]);
        upBillings(()=>[]);upPcards(()=>({}));upChecklist(()=>[]);
        upCashPos(()=>({}));upBudgets(()=>({}));upPayables(()=>[]);upVouchers(()=>[]);
        setActLog([]);persist("gmdv5:actlog",[]);
        if(isSupabaseReady()){
          ["deals","expenses","inflows","job_orders","purchase_requests","material_requests","budget_requests","addenda","billing_payments","billing_milestones","project_card_dept_tasks","project_card_dept_status","project_cards","checklists","activity_log","payables","check_vouchers"].forEach(t=>sbClear(t).catch(()=>{}));
          sbDeleteWhere('cash_positions','date','1900-01-01','gte');
          sbDeleteWhere('project_budgets','deal_id',null,'not_null');
          sbDeleteWhere('projects','deal_id',null,'not_null');
        }
        return "Full purge complete. FabHub is clean and ready for real data.";
      }
    },
    {
      key:"deals_only",
      label:"🗑 Clear Pipeline Only",
      desc:"Removes all deals, project cards, JOs, checklists, addenda. Keeps expenses, billing, and cash position.",
      color:"#f59e0b",
      bgColor:"#fffbeb",
      borderColor:"#fde68a",
      items:["Deals / Pipeline","Job Orders","Project Cards","Checklist Items","Addenda"],
      action:()=>{
        upDeals(()=>[]);upJos(()=>[]);upPcards(()=>({}));
        upChecklist(()=>[]);upAddenda(()=>[]);
        if(isSupabaseReady()){
          ["deals","job_orders","project_card_dept_tasks","project_card_dept_status","project_cards","checklists","addenda"].forEach(t=>sbClear(t).catch(()=>{}));
          sbDeleteWhere('projects','deal_id',null,'not_null');
        }
        return "Pipeline cleared. Expenses, billing, and cash position preserved.";
      }
    },
    {
      key:"finance_only",
      label:"🗑 Clear Finance Data Only",
      desc:"Removes expenses, inflows, billing milestones, cash position history, payables, and check vouchers. Pipeline and project cards untouched.",
      color:"#3b82f6",
      bgColor:"#eff6ff",
      borderColor:"#93c5fd",
      items:["Expenses","Inflows","Billing Milestones","Cash Position Days","Payables","Check Vouchers"],
      action:()=>{
        upExps(()=>[]);upInflows(()=>[]);upBillings(()=>[]);upCashPos(()=>({}));upPayables(()=>[]);upVouchers(()=>[]);
        if(isSupabaseReady()){
          ["expenses","inflows","billing_payments","billing_milestones","payables","check_vouchers"].forEach(t=>sbClear(t).catch(()=>{}));
          sbDeleteWhere('cash_positions','date','1900-01-01','gte');
        }
        return "Finance data cleared. Pipeline and projects untouched.";
      }
    },
    {
      key:"procurement_only",
      label:"🗑 Clear Procurement Only",
      desc:"Removes all PRs, MRs, and Budget Requests. Deals and billing untouched.",
      color:"#06b6d4",
      bgColor:"#ecfeff",
      borderColor:"#a5f3fc",
      items:["Purchase Requests","Material Requests","Budget Requests"],
      action:()=>{
        upPrs(()=>[]);upMreqs(()=>[]);upBreqs(()=>[]);
        if(isSupabaseReady()) ["purchase_requests","material_requests","budget_requests"].forEach(t=>sbClear(t).catch(()=>{}));
        return "Procurement data cleared.";
      }
    },
    {
      key:"log_only",
      label:"🗑 Clear Activity Log Only",
      desc:"Clears the activity feed. No other data affected.",
      color:"#6b7280",
      bgColor:"#f9fafb",
      borderColor:"#e5e7eb",
      items:["Activity Log"],
      action:()=>{
        setActLog([]);persist("gmdv5:actlog",[]);
        if(isSupabaseReady()) sbClear("activity_log").catch(()=>{});
        return "Activity log cleared.";
      }
    },
  ];

  const executePurge=()=>{
    if(purgeWord!==PURGE_WORD) return;
    const opt=PURGE_OPTIONS.find(o=>o.key===confirmPurge);
    if(!opt) return;
    const msg=opt.action();
    setPurgeResult(msg);
    setConfirmPurge(null);
    setPurgeWord("");
  };

  return(
    <div>
      {/* Header */}
      <div style={{marginBottom:24}}>
        <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>⚙ Data Management</h2>
        <div style={{fontSize:".75rem",color:"#94a3b8",marginTop:3}}>Manager only — surgical delete and purge controls</div>
      </div>

      {/* Success banner */}
      {purgeResult&&(
        <div style={{background:"#f0fdf4",border:"1.5px solid #6ee7b7",borderRadius:12,padding:"12px 18px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#059669"}}> ✅ {purgeResult}</span>
          <button onClick={()=>setPurgeResult(null)} style={{background:"none",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:"1rem"}}>✕</button>
        </div>
      )}

      {/* Current data summary */}
      <div style={{background:"#fff",borderRadius:14,border:"1.5px solid #e2e8f0",padding:"18px 20px",marginBottom:20}}>
        <div style={{fontWeight:700,color:"#0f172a",marginBottom:14,fontSize:".9rem"}}>Current Data Summary</div>
        <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:8,marginBottom:14}}>
          {Object.entries(counts).map(([label,count])=>(
            <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"7px 12px",background:count>0?"#f8fafc":"#fff",borderRadius:8,border:"1px solid #f1f5f9"}}>
              <span style={{fontSize:".78rem",color:"#475569"}}>{label}</span>
              <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:".95rem",color:count>0?"#0f172a":"#cbd5e1"}}>{count}</span>
            </div>
          ))}
        </div>
        <div style={{borderTop:"1px solid #f1f5f9",paddingTop:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontSize:".82rem",color:"#64748b"}}>Total records in system</span>
          <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.1rem",color:"#0f172a"}}>{totalRecords.toLocaleString()}</span>
        </div>
        <div style={{marginTop:8,fontSize:".72rem",color:"#94a3b8",fontStyle:"italic"}}>
          🔒 Protected (never deleted): {22} team members · 207 GMD clients · System configuration
        </div>
      </div>

      {/* Purge options */}
      <div style={{marginBottom:12,fontWeight:700,color:"#dc2626",fontSize:".88rem"}}>⚠️ Purge Controls — These actions are permanent and cannot be undone</div>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {PURGE_OPTIONS.map(opt=>(
          <div key={opt.key} style={{background:opt.bgColor,border:`1.5px solid ${opt.borderColor}`,borderRadius:12,padding:"16px 20px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,color:opt.color,fontSize:".9rem",marginBottom:4}}>{opt.label}</div>
                <div style={{fontSize:".78rem",color:"#475569",marginBottom:8}}>{opt.desc}</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {opt.items.map(item=>(
                    <span key={item} style={{fontSize:".68rem",background:"rgba(0,0,0,.06)",color:"#475569",padding:"1px 9px",borderRadius:20}}>
                      {item} ({counts[item]||0})
                    </span>
                  ))}
                </div>
              </div>
              <button onClick={()=>{setConfirmPurge(opt.key);setPurgeWord("");}}
                style={{background:opt.color,border:"none",borderRadius:9,padding:"8px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:"#fff",cursor:"pointer",flexShrink:0}}>
                Purge →
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Confirm purge modal */}
      {confirmPurge&&(()=>{
        const opt=PURGE_OPTIONS.find(o=>o.key===confirmPurge);
        return(
          <Modal open title="⚠️ Confirm Purge" onClose={()=>{setConfirmPurge(null);setPurgeWord("");}}>
            <div style={{background:"#fef2f2",border:"1.5px solid #fecaca",borderRadius:10,padding:"14px 16px",marginBottom:18}}>
              <div style={{fontWeight:700,color:"#dc2626",marginBottom:6}}>{opt.label}</div>
              <div style={{fontSize:".82rem",color:"#7f1d1d"}}>{opt.desc}</div>
            </div>
            <div style={{fontSize:".85rem",color:"#0f172a",marginBottom:12}}>
              This will permanently delete <strong>{opt.items.reduce((s,i)=>s+(counts[i]||0),0)} records</strong>. This cannot be undone.
            </div>
            <div style={{fontSize:".85rem",color:"#0f172a",marginBottom:8}}>
              Type <strong style={{color:"#dc2626",letterSpacing:"2px"}}>{PURGE_WORD}</strong> to confirm:
            </div>
            <input
              type="text"
              value={purgeWord}
              onChange={e=>setPurgeWord(e.target.value.toUpperCase())}
              placeholder={`Type ${PURGE_WORD} to confirm`}
              autoFocus
              style={{width:"100%",border:`2px solid ${purgeWord===PURGE_WORD?"#10b981":"#e2e8f0"}`,borderRadius:8,padding:"10px 14px",fontFamily:"inherit",fontSize:"1rem",fontWeight:700,letterSpacing:"3px",color:"#dc2626",boxSizing:"border-box",outline:"none",textTransform:"uppercase",marginBottom:16}}
            />
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>{setConfirmPurge(null);setPurgeWord("");}}
                style={{flex:1,background:"#f1f5f9",border:"none",borderRadius:9,padding:"10px",fontFamily:"inherit",fontWeight:600,fontSize:".85rem",color:"#475569",cursor:"pointer"}}>
                Cancel — Keep Data
              </button>
              <button onClick={executePurge} disabled={purgeWord!==PURGE_WORD}
                style={{flex:1,background:purgeWord===PURGE_WORD?"#dc2626":"#e2e8f0",border:"none",borderRadius:9,padding:"10px",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",color:purgeWord===PURGE_WORD?"#fff":"#94a3b8",cursor:purgeWord===PURGE_WORD?"pointer":"not-allowed"}}>
                ✓ Confirm Purge
              </button>
            </div>
          </Modal>
        );
      })()}
    </div>
  );
}
  const printJO=(jo,dealsList=[])=>{
    const d=(dealsList||[]).find(x=>x.id===jo.dealId)||{};
    const win=window.open("","_blank");
    win.document.write(`<!DOCTYPE html><html><head><title>Job Order ${jo.joNo||jo.joNum}</title>
    <style>
      body{font-family:Arial,sans-serif;margin:40px;color:#1e293b;font-size:13px;}
      .hdr{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:16px;border-bottom:3px solid #1e293b;margin-bottom:24px;}
      .logo{font-size:24px;font-weight:900;letter-spacing:-1px;}
      .logo span{color:#f59e0b;}
      .jo-no{font-size:20px;font-weight:900;color:#1e293b;}
      .section{margin-bottom:20px;}
      .section-title{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#94a3b8;margin-bottom:8px;border-bottom:1px solid #e2e8f0;padding-bottom:4px;}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
      .field label{font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.5px;display:block;margin-bottom:2px;}
      .field span{font-size:13px;color:#0f172a;font-weight:600;}
      .scope-box{background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:12px;font-size:13px;line-height:1.6;min-height:60px;}
      .pm-badge{display:inline-block;background:#eff6ff;color:#1d4ed8;border:1px solid #93c5fd;border-radius:20px;padding:3px 12px;font-weight:700;font-size:12px;margin:2px;}
      .status{display:inline-block;background:#f0fdf4;color:#059669;border:1px solid #6ee7b7;border-radius:20px;padding:4px 14px;font-weight:700;font-size:12px;}
      .footer{margin-top:40px;padding-top:16px;border-top:1px solid #e2e8f0;display:grid;grid-template-columns:1fr 1fr 1fr;gap:20px;}
      .sig-box{text-align:center;}
      .sig-line{border-top:1px solid #1e293b;margin-top:40px;padding-top:6px;font-size:11px;color:#64748b;}
      @media print{button{display:none;}}
    </style></head><body>
    <div class="hdr">
      <div>
        <div class="logo">GMD <span>PROD</span></div>
        <div style="color:#64748b;font-size:11px;margin-top:4px;">GMD Productions Inc. · TIN: 010-063-229-00000</div>
        <div style="color:#64748b;font-size:11px;">32 Unit-H Santan St., Fortune, Marikina City</div>
      </div>
      <div style="text-align:right">
        <div class="jo-no">JOB ORDER</div>
        <div style="font-size:18px;font-weight:800;color:#f59e0b;">${jo.joNo||jo.joNum||"JO-XXXX"}</div>
        <div style="font-size:12px;color:#64748b;margin-top:4px;">Issued: ${jo.issuedDate||jo.dateIssued||""}</div>
        <div class="status" style="margin-top:6px;">${jo.status||"Active"}</div>
      </div>
    </div>

    <div class="section">
      <div class="section-title">Project Details</div>
      <div class="grid">
        <div class="field"><label>Client</label><span>${jo.client||d.client||"—"}</span></div>
        <div class="field"><label>CE Number</label><span>${jo.ceNo||d.ceNo||"—"}</span></div>
        <div class="field"><label>Project Name</label><span>${jo.projectName||d.contact||"—"}</span></div>
        <div class="field"><label>CE Type</label><span>${jo.ceType||d.ceType||"—"} ${jo.product||d.product?("· "+(jo.product||d.product)):"" }</span></div>
        <div class="field"><label>Project Location</label><span>${jo.location||d.location||"—"}</span></div>
        <div class="field"><label>Contract Value</label><span>₱${(jo.value||d.value||0).toLocaleString("en-PH")}</span></div>
        <div class="field"><label>Award Trigger</label><span>${jo.awardTrigger||"—"} ${jo.triggerDate?("· "+jo.triggerDate):""}</span></div>
      </div>
    </div>

    <div class="section">
      <div class="section-title">Team Assignment</div>
      <div class="grid">
        <div class="field">
          <label>Project Manager(s)</label>
          <div>${[jo.pm1,jo.pm2,jo.pm3].filter(Boolean).map(pm=>'<span class="pm-badge">'+pm+'</span>').join("")||'<span style="color:#94a3b8">Not assigned</span>'}</div>
        </div>
        <div class="field">
          <label>Coordinator</label>
          <span>${jo.coordinator||"—"}</span>
        </div>
        <div class="field"><label>Account Executive</label><span>${jo.aeAssigned||d.salesOwner||"—"}</span></div>
        <div class="field"><label>Designer</label><span>${jo.designer||"—"}</span></div>
        <div class="field"><label>Target Turnover Date</label><span>${jo.startDate||"—"}</span></div>
      </div>
      ${jo.commsLink?('<div style="margin-top:10px"><div class="field"><label>Comms Group</label><a href="'+jo.commsLink+'" style="color:#3b82f6">'+jo.commsLink+'</a></div></div>'):""}
    </div>

    <div class="section">
      <div class="section-title">Scope of Work</div>
      <div class="scope-box">${(jo.scopeNotes||"").replace(/\n/g,"<br/>")}</div>\n'
    </div>

    ${jo.specialInstructions?'<div class="section"><div class="section-title">Special Instructions / Venue Requirements</div><div class="scope-box" style="background:#fffbeb;border-color:#fde68a;">'+(jo.specialInstructions||"").replace(/\\n/g,"<br/>")+'</div></div>':""}


    <div style="background:#eff6ff;border:1px solid #93c5fd;border-radius:8px;padding:12px;margin-bottom:20px;font-size:12px;color:#1d4ed8;">
      <strong>Budget Status:</strong> ${jo.budgetStatus||"QS Budget Pending"} &nbsp;·&nbsp;
      <strong>Issued by:</strong> ${jo.issuedBy||"Manager"} &nbsp;·&nbsp;
      <strong>Date:</strong> ${jo.issuedDate||jo.dateIssued||""}
    </div>

    <div class="footer">
      <div class="sig-box"><div class="sig-line">Prepared by / Account Executive</div></div>
      <div class="sig-box"><div class="sig-line">Project Manager</div></div>
      <div class="sig-box"><div class="sig-line">Approved by / Director</div></div>
    </div>

    <div style="text-align:center;margin-top:30px;">
      <button onclick="window.print()" style="padding:10px 24px;background:#1e293b;color:#fff;border:none;border-radius:8px;cursor:pointer;font-size:14px;font-weight:700;">🖨 Print / Save as PDF</button>
    </div>
    </body></html>`);
    win.document.close();addPrintClose(win);
  };

// ─── SUPPLIER MASTER VIEW ──────────────────────────────────────────────────────
const SUPPLIER_RATINGS = ["5 - EXCELLENT AND RELIABLE","4 - GOOD","3 - ACCEPTABLE","2 - MODERATE","1 - POOR"];
const PAYMENT_TERMS_OPTS = ["Cash Basis","7 Days","15 Days","30 Days","30-45 Days","45 Days","60 Days","90 Days","Terms"];

function SupplierMasterView({suppliers,addSupplier,updateSupplier,deleteSupplier,session,role}){
  const[showForm,setShowForm]=useState(false);
  const[editId,setEditId]=useState(null);
  // Duplicate rows (same company name) collapse into one display row — a
  // rating/terms edit made there should apply to every underlying duplicate,
  // not just the first one, or the others silently keep stale data.
  const[editIds,setEditIds]=useState([]);
  const emptySupplier=()=>({rating:"4 - GOOD",companyName:"",email:"",materials:"",contactNos:"",contactPerson:"",paymentTerms:"Cash Basis",address:"",tinNo:"",notes:"",status:"Active"});
  const[form,setForm]=useState(emptySupplier());
  const[search,setSearch]=useState("");
  const[filterRating,setFilterRating]=useState("all");
  const[filterMat,setFilterMat]=useState("all");

  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const canEdit=role==="Manager"||isProcurementRole(role);

  const filtered=useMemo(()=>{
    let list=suppliers;
    if(filterRating!=="all") list=list.filter(s=>s.rating===filterRating);
    if(filterMat!=="all") list=list.filter(s=>(s.materials||"").toLowerCase().includes(filterMat.toLowerCase()));
    if(search){const q=search.toLowerCase();list=list.filter(s=>(s.companyName||"").toLowerCase().includes(q)||(s.materials||"").toLowerCase().includes(q)||(s.contactPerson||"").toLowerCase().includes(q));}
    return list.slice().sort((a,b)=>{const ra=a.rating?parseInt(a.rating):0,rb=b.rating?parseInt(b.rating):0;return rb-ra;});
  },[suppliers,filterRating,filterMat,search]);

  const ratingClr={
    "5 - EXCELLENT AND RELIABLE":"#059669",
    "4 - GOOD":"#3b82f6",
    "3 - ACCEPTABLE":"#f59e0b",
    "2 - MODERATE":"#f97316",
    "1 - POOR":"#ef4444",
  };

  const openEdit=(s)=>{setForm({...s,companyName:s.companyName||s.company_name||""});setEditId(s.id);setEditIds(s._ids&&s._ids.length?s._ids:[s.id]);setShowForm(true);};
  const openNew=()=>{setForm(emptySupplier());setEditId(null);setEditIds([]);setShowForm(true);};
  const save=()=>{
    if(!form.companyName) return;
    if(editId) (editIds.length?editIds:[editId]).forEach(id=>updateSupplier(id,form));
    else addSupplier(form);
    setShowForm(false);setEditId(null);setEditIds([]);
  };

  const topMat=[...new Set(suppliers.map(s=>s.materials).filter(Boolean))].sort();

  // Group filtered suppliers by company name so duplicates collapse into one row
  const grouped=useMemo(()=>{
    const map=new Map();
    filtered.forEach(s=>{
      const key=(s.companyName||s.company_name||"").trim().toLowerCase();
      if(!map.has(key)){
        map.set(key,{...s,_ids:[s.id],_materials:[...(s.materials?[s.materials]:[])],_allItems:[s]});
      } else {
        const g=map.get(key);
        g._ids.push(s.id);
        g._allItems.push(s);
        if(s.materials&&!g._materials.includes(s.materials)) g._materials.push(s.materials);
      }
    });
    return [...map.values()];
  },[filtered]);

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>🏭 Supplier Master List</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Approved vendors — rated, categorized, and ready to quote</div>
        </div>
        {canEdit&&(
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <label style={{background:"#eff6ff",border:"1.5px solid #bfdbfe",borderRadius:10,padding:"8px 16px",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",color:"#1d4ed8",cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
              ⬆ Import CSV
              <input type="file" accept=".csv" style={{display:"none"}} onChange={e=>{
                const file=e.target.files?.[0];if(!file)return;
                const reader=new FileReader();
                reader.onload=ev=>{
                  const lines=ev.target.result.split("\n").map(l=>l.trim()).filter(Boolean);
                  if(!lines.length)return;
                  const isHeader=lines[0].toLowerCase().includes("company")||lines[0].toLowerCase().includes("name");
                  const dataLines=isHeader?lines.slice(1):lines;
                  let count=0;
                  dataLines.forEach(line=>{
                    const cols=line.split(",").map(c=>c.replace(/^"|"$/g,"").trim());
                    const [companyName="",contactPerson="",contactNos="",email="",address="",materials="",rating="",tinNo="",paymentTerms="",notes=""]=[...cols,...Array(10).fill("")];
                    if(!companyName)return;
                    addSupplier({companyName,contactPerson,contactNos,email,address,materials,rating:rating||"4 - GOOD",tinNo,paymentTerms:paymentTerms||"Cash Basis",notes,status:"Active"});
                    count++;
                  });
                  alert(`✓ Imported ${count} supplier${count!==1?"s":""}.`);
                };
                reader.readAsText(file);
                e.target.value="";
              }}/>
            </label>
            <button onClick={openNew} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>+ Add Supplier</button>
          </div>
        )}
      </div>

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr 1fr":"repeat(4,1fr)",gap:10,marginBottom:16}}>
        {[
          {l:"Total Suppliers",v:suppliers.length,c:"#3b82f6"},
          {l:"Excellent & Reliable",v:suppliers.filter(s=>s.rating&&s.rating.startsWith("5")).length,c:"#059669"},
          {l:"Good",v:suppliers.filter(s=>s.rating&&s.rating.startsWith("4")).length,c:"#3b82f6"},
          {l:"Acceptable or Below",v:suppliers.filter(s=>s.rating&&!s.rating.startsWith("5")&&!s.rating.startsWith("4")).length,c:"#f59e0b"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <FInp value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search supplier, material, contact…"
          style={{flex:1,minWidth:200,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 13px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a"}}/>
        <select value={filterRating} onChange={e=>setFilterRating(e.target.value)}
          style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Ratings</option>
          {SUPPLIER_RATINGS.map(r=><option key={r}>{r}</option>)}
        </select>
        <select value={filterMat} onChange={e=>setFilterMat(e.target.value)}
          style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Materials</option>
          {topMat.slice(0,20).map(m=><option key={m}>{m}</option>)}
        </select>
      </div>

      {/* Add/Edit Form */}
      {showForm&&canEdit&&(
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:18,marginBottom:16,boxShadow:"0 4px 16px rgba(0,0,0,.06)"}}>
          <div style={{fontWeight:800,color:"#0f172a",marginBottom:14}}>{editId?"Edit Supplier":"Add Supplier"}</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <div style={{gridColumn:"1/-1"}}><Fld label="Company Name" required><Inp value={form.companyName} onChange={e=>f("companyName",e.target.value)} placeholder="Company name"/></Fld></div>
            <Fld label="Rating"><Sel value={form.rating} onChange={e=>f("rating",e.target.value)}>{SUPPLIER_RATINGS.map(r=><option key={r}>{r}</option>)}</Sel></Fld>
            <Fld label="Materials Supplied"><Inp value={form.materials} onChange={e=>f("materials",e.target.value)} placeholder="e.g. Assorted Construction Supply"/></Fld>
            <Fld label="Email"><Inp type="email" value={form.email} onChange={e=>f("email",e.target.value)} placeholder="email@example.com"/></Fld>
            <Fld label="Contact Nos."><Inp value={form.contactNos} onChange={e=>f("contactNos",e.target.value)} placeholder="e.g. 941-0000 / 09XX-XXX-XXXX"/></Fld>
            <Fld label="Contact Person"><Inp value={form.contactPerson} onChange={e=>f("contactPerson",e.target.value)} placeholder="e.g. Ms. Maria"/></Fld>
            <Fld label="Payment Terms"><Sel value={form.paymentTerms} onChange={e=>f("paymentTerms",e.target.value)}>{PAYMENT_TERMS_OPTS.map(p=><option key={p}>{p}</option>)}</Sel></Fld>
            <Fld label="TIN No."><Inp value={form.tinNo} onChange={e=>f("tinNo",e.target.value)} placeholder="XXX-XXX-XXX-000"/></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Address"><Inp value={form.address} onChange={e=>f("address",e.target.value)} placeholder="Full address"/></Fld></div>
            <div style={{gridColumn:"1/-1"}}><Fld label="Notes"><Inp rows={2} value={form.notes} onChange={e=>f("notes",e.target.value)} placeholder="Payment method, special instructions…"/></Fld></div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:14}}>
            <button onClick={save} disabled={!form.companyName} style={{background:form.companyName?"#1e293b":"#e2e8f0",border:"none",borderRadius:9,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:form.companyName?"#fff":"#94a3b8",cursor:form.companyName?"pointer":"not-allowed"}}>{editId?"Save Changes":"Add Supplier"}</button>
            <button onClick={()=>{setShowForm(false);setEditId(null);}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {suppliers.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8",fontSize:".84rem"}}>No suppliers yet. Add your first supplier above.</div>}

      {/* List — grouped by company */}
      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {grouped.map(g=>{
          const clr=ratingClr[g.rating]||"#94a3b8";
          const name=g.companyName||g.company_name||"—";
          const contact=g.contactPerson||g.contact_person;
          const phone=g.contactNos||g.contact_nos;
          const terms=g.paymentTerms||g.payment_terms;
          return(
            <div key={name} style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:"12px 16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                <div style={{flex:1,minWidth:0}}>
                  {/* Company + rating */}
                  <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:5}}>
                    <span style={{fontSize:".65rem",fontWeight:700,color:clr,background:clr+"18",padding:"2px 8px",borderRadius:20,whiteSpace:"nowrap"}}>{g.rating||"—"}</span>
                    <span style={{fontWeight:800,color:"#0f172a",fontSize:".92rem"}}>{name}</span>
                    {g._ids.length>1&&<span style={{fontSize:".62rem",background:"#f1f5f9",color:"#64748b",borderRadius:20,padding:"1px 7px"}}>{g._ids.length} entries</span>}
                  </div>
                  {/* Materials as chips */}
                  {g._materials.length>0&&(
                    <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:6}}>
                      {g._materials.map((m,i)=>(
                        <span key={i} style={{fontSize:".71rem",background:"#eff6ff",color:"#1d4ed8",border:"1px solid #bfdbfe",borderRadius:20,padding:"2px 9px",fontWeight:600}}>📦 {m}</span>
                      ))}
                    </div>
                  )}
                  {/* Contact info row */}
                  <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:".76rem",color:"#64748b"}}>
                    {contact&&<span>👤 {contact}</span>}
                    {phone&&<span>📞 {phone}</span>}
                    {g.email&&<span>✉ {g.email}</span>}
                    {terms&&<span style={{background:"#f0fdf4",color:"#166534",padding:"1px 8px",borderRadius:10,fontWeight:600}}>💳 {terms}</span>}
                    {(g.tinNo||g.tin_no)&&<span style={{color:"#94a3b8"}}>TIN: {g.tinNo||g.tin_no}</span>}
                  </div>
                  {g.address&&<div style={{fontSize:".73rem",color:"#94a3b8",marginTop:3}}>📍 {g.address}</div>}
                  {g.notes&&<div style={{fontSize:".72rem",color:"#92400e",background:"#fffbeb",borderRadius:6,padding:"3px 8px",marginTop:4,display:"inline-block"}}>📝 {g.notes}</div>}
                </div>
                {canEdit&&(
                  <div style={{display:"flex",gap:5,flexShrink:0}}>
                    <button onClick={()=>openEdit(g)} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"5px 10px",fontSize:".72rem",color:"#475569",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>✏</button>
                    <button onClick={async ()=>{if((await uiConfirm(`Remove all ${g._ids.length} entr${g._ids.length===1?"y":"ies"} for ${name}?`)))g._ids.forEach(id=>deleteSupplier(id));}} style={{background:"#fef2f2",border:"none",borderRadius:7,padding:"5px 10px",fontSize:".72rem",color:"#dc2626",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>✕</button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── SUBCONTRACTOR MASTER VIEW ──────────────────────────────────────────────────
const SUBCON_RATINGS=["YES - ACCEPTABLE","NO","PROBATIONARY"];
const SUBCON_SPECIALTIES=["General Works","Electrical (Install only)","Stone Works (Supply & Install)","Metal Works (Supply & Install)","Tile Works","Glass Works","Painting","Plumbing","Carpentry","HVAC","Other"];

function SubconMasterView({subcons,addSubcon,updateSubcon,deleteSubcon,session,role}){
  const[showForm,setShowForm]=useState(false);
  const[editId,setEditId]=useState(null);
  // Duplicate rows (same company name) collapse into one display row — see
  // the identical fix/comment in SupplierMasterView.
  const[editIds,setEditIds]=useState([]);
  const emptySubcon=()=>({rating:"YES - ACCEPTABLE",specialty:"General Works",strengthsWeaknesses:"",contactNo:"",companyName:"",paymentTerms:"Cash Basis",address:"",remarks:"",rateStructure:"Project Rate",paymentStructure:"50% Start/50% Completion",locationNote:"",notes:"",status:"Active"});
  const[form,setForm]=useState(emptySubcon());
  const[search,setSearch]=useState("");
  const[filterSpecialty,setFilterSpecialty]=useState("all");
  const[filterRating,setFilterRating]=useState("all");

  const f=(k,v)=>setForm(p=>({...p,[k]:v}));
  const canEdit=role==="Manager"||isProcurementRole(role)||role==="Operations";

  const grouped=useMemo(()=>{
    const map=new Map();
    subcons.forEach(s=>{
      const key=(s.companyName||s.company_name||"").trim().toLowerCase();
      if(!map.has(key)){
        map.set(key,{...s,_ids:[s.id],_specialties:[...(s.specialty?[s.specialty]:[])],_allItems:[s]});
      } else {
        const g=map.get(key);
        g._ids.push(s.id);
        g._allItems.push(s);
        if(s.specialty&&!g._specialties.includes(s.specialty)) g._specialties.push(s.specialty);
      }
    });
    return [...map.values()];
  },[subcons]);

  const filtered=useMemo(()=>{
    let list=grouped;
    if(filterRating!=="all") list=list.filter(s=>s.rating===filterRating);
    if(filterSpecialty!=="all") list=list.filter(s=>s._specialties.includes(filterSpecialty));
    if(search){const q=search.toLowerCase();list=list.filter(s=>(s.companyName||"").toLowerCase().includes(q)||s._specialties.join(" ").toLowerCase().includes(q)||(s.contactNo||"").toLowerCase().includes(q));}
    return list;
  },[grouped,filterRating,filterSpecialty,search]);

  const openEdit=(s)=>{setForm({...s,companyName:s.companyName||s.company_name||"",strengthsWeaknesses:s.strengthsWeaknesses||s.strengths_weaknesses||"",contactNo:s.contactNo||s.contact_no||"",paymentTerms:s.paymentTerms||s.payment_terms||"Cash Basis",rateStructure:s.rateStructure||s.rate_structure||"Project Rate",paymentStructure:s.paymentStructure||s.payment_structure||"50% Start/50% Completion",locationNote:s.locationNote||s.location_note||""});setEditId(s.id);setEditIds(s._ids&&s._ids.length?s._ids:[s.id]);setShowForm(true);};
  const openNew=()=>{setForm(emptySubcon());setEditId(null);setEditIds([]);setShowForm(true);};
  const save=()=>{
    if(!form.companyName) return;
    if(editId) (editIds.length?editIds:[editId]).forEach(id=>updateSubcon(id,form));
    else addSubcon(form);
    setShowForm(false);setEditId(null);setEditIds([]);
  };

  const specialties=[...new Set(subcons.map(s=>s.specialty).filter(Boolean)),...SUBCON_SPECIALTIES].filter((v,i,a)=>a.indexOf(v)===i);

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,flexWrap:"wrap",gap:12}}>
        <div>
          <h2 style={{margin:0,fontWeight:800,color:"#0f172a",fontSize:"1.15rem"}}>👷 Subcontractor Master List</h2>
          <div style={{fontSize:".75rem",color:"#64748b",marginTop:2}}>Approved subcons — rated by specialty and performance</div>
        </div>
        {canEdit&&<button onClick={openNew} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"9px 18px",fontFamily:"inherit",fontWeight:700,fontSize:".84rem",color:"#fff",cursor:"pointer"}}>+ Add Subcon</button>}
      </div>

      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"repeat(3,1fr)",gap:10,marginBottom:16}}>
        {[
          {l:"Total Subcontractors",v:grouped.length,c:"#3b82f6"},
          {l:"Acceptable",v:grouped.filter(s=>s.rating==="YES - ACCEPTABLE").length,c:"#059669"},
          {l:"Not Approved",v:grouped.filter(s=>s.rating==="NO").length,c:"#ef4444"},
        ].map(({l,v,c})=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"14px 16px",border:"1.5px solid #e2e8f0"}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:800,fontSize:"1.3rem",color:c}}>{v}</div>
            <div style={{fontSize:".63rem",textTransform:"uppercase",letterSpacing:"1px",color:"#94a3b8",marginTop:5}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <FInp value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search subcon, specialty, contact…"
          style={{flex:1,minWidth:200,border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 13px",fontFamily:"inherit",fontSize:".84rem",color:"#0f172a"}}/>
        <select value={filterRating} onChange={e=>setFilterRating(e.target.value)}
          style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Ratings</option>
          {SUBCON_RATINGS.map(r=><option key={r}>{r}</option>)}
        </select>
        <select value={filterSpecialty} onChange={e=>setFilterSpecialty(e.target.value)}
          style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".8rem",color:"#0f172a",background:"#fff",cursor:"pointer"}}>
          <option value="all">All Specialties</option>
          {specialties.map(s=><option key={s}>{s}</option>)}
        </select>
      </div>

      {/* Add/Edit Form */}
      {showForm&&canEdit&&(
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",padding:18,marginBottom:16,boxShadow:"0 4px 16px rgba(0,0,0,.06)"}}>
          <div style={{fontWeight:800,color:"#0f172a",marginBottom:14}}>{editId?"Edit Subcontractor":"Add Subcontractor"}</div>
          <div style={{display:"grid",gridTemplateColumns:window.innerWidth<768?"1fr":"1fr 1fr",gap:14}}>
            <div style={{gridColumn:"1/-1"}}><Fld label="Company Name / Contact Person" required><Inp value={form.companyName} onChange={e=>f("companyName",e.target.value)} placeholder="e.g. Juan dela Cruz / ABC Construction"/></Fld></div>
            <Fld label="Rating"><Sel value={form.rating} onChange={e=>f("rating",e.target.value)}>{SUBCON_RATINGS.map(r=><option key={r}>{r}</option>)}</Sel></Fld>
            <Fld label="Specialty / Trade"><Inp value={form.specialty} onChange={e=>f("specialty",e.target.value)} placeholder="e.g. General Works"/></Fld>
            <Fld label="Contact No."><Inp value={form.contactNo} onChange={e=>f("contactNo",e.target.value)} placeholder="e.g. 0917-XXX-XXXX"/></Fld>
            <Fld label="Payment Terms"><Sel value={form.paymentTerms} onChange={e=>f("paymentTerms",e.target.value)}>{PAYMENT_TERMS_OPTS.map(p=><option key={p}>{p}</option>)}</Sel></Fld>
            <Fld label="Rate Structure"><Inp value={form.rateStructure} onChange={e=>f("rateStructure",e.target.value)} placeholder="e.g. Project Rate"/></Fld>
            <Fld label="Payment Structure"><Inp value={form.paymentStructure} onChange={e=>f("paymentStructure",e.target.value)} placeholder="e.g. 50% Start / 50% Completion"/></Fld>
            <Fld label="Location Note" hint="Leave blank for Metro Manila"><Inp value={form.locationNote} onChange={e=>f("locationNote",e.target.value)} placeholder="e.g. Davao, Cebu"/></Fld>
            <div style={{gridColumn:"1/-1"}}><Fld label="Address"><Inp value={form.address} onChange={e=>f("address",e.target.value)} placeholder="Full address"/></Fld></div>
            <div style={{gridColumn:"1/-1"}}><Fld label="Strengths / Weaknesses"><Inp rows={2} value={form.strengthsWeaknesses} onChange={e=>f("strengthsWeaknesses",e.target.value)} placeholder="W: Communication   S: Scope of Work"/></Fld></div>
            <div style={{gridColumn:"1/-1"}}><Fld label="Remarks / Notes"><Inp rows={2} value={form.remarks} onChange={e=>f("remarks",e.target.value)} placeholder="Special notes, last job, issues…"/></Fld></div>
          </div>
          <div style={{display:"flex",gap:10,marginTop:14}}>
            <button onClick={save} disabled={!form.companyName} style={{background:form.companyName?"#1e293b":"#e2e8f0",border:"none",borderRadius:9,padding:"10px 22px",fontFamily:"inherit",fontWeight:700,fontSize:".87rem",color:form.companyName?"#fff":"#94a3b8",cursor:form.companyName?"pointer":"not-allowed"}}>{editId?"Save Changes":"Add Subcon"}</button>
            <button onClick={()=>{setShowForm(false);setEditId(null);}} style={{background:"transparent",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"10px 18px",fontFamily:"inherit",fontWeight:600,fontSize:".84rem",color:"#64748b",cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}

      {grouped.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"#94a3b8",fontSize:".84rem"}}>No subcontractors yet. Add your first subcon above.</div>}

      {/* List */}
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {filtered.map(s=>{
          const isNo=s.rating==="NO";
          return(
            <div key={s._ids[0]} style={{background:"#fff",borderRadius:12,border:`1.5px solid ${isNo?"#fecaca":"#e2e8f0"}`,padding:"14px 18px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:6}}>
                    <span style={{fontSize:".68rem",fontWeight:700,color:isNo?"#ef4444":"#059669",background:isNo?"#fef2f2":"#f0fdf4",padding:"2px 8px",borderRadius:20}}>{s.rating||"—"}</span>
                    <span style={{fontWeight:700,color:"#0f172a",fontSize:".92rem"}}>{s.companyName||s.company_name}</span>
                    {(s.locationNote||s.location_note)&&<span style={{fontSize:".72rem",color:"#7c3aed",background:"#f5f3ff",padding:"1px 8px",borderRadius:20}}>📍 {s.locationNote||s.location_note}</span>}
                  </div>
                  {s._specialties.length>0&&(
                    <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:6}}>
                      {s._specialties.map(sp=><span key={sp} style={{fontSize:".7rem",color:"#3b82f6",background:"#eff6ff",border:"1px solid #bfdbfe",padding:"2px 8px",borderRadius:20}}>{sp}</span>)}
                    </div>
                  )}
                  <div style={{display:"flex",gap:16,flexWrap:"wrap",fontSize:".78rem",color:"#64748b"}}>
                    {(s.contactNo||s.contact_no)&&<span>📞 {s.contactNo||s.contact_no}</span>}
                    {(s.paymentTerms||s.payment_terms)&&<span style={{background:"#f0fdf4",color:"#166534",padding:"1px 8px",borderRadius:10,fontWeight:600}}>💳 {s.paymentTerms||s.payment_terms}</span>}
                    {(s.rateStructure||s.rate_structure)&&<span>💰 {s.rateStructure||s.rate_structure}</span>}
                    {(s.paymentStructure||s.payment_structure)&&<span>📋 {s.paymentStructure||s.payment_structure}</span>}
                  </div>
                  {(s.strengthsWeaknesses||s.strengths_weaknesses)&&<div style={{fontSize:".75rem",color:"#475569",marginTop:4}}>{s.strengthsWeaknesses||s.strengths_weaknesses}</div>}
                  {(s.address)&&<div style={{fontSize:".75rem",color:"#94a3b8",marginTop:2}}>📍 {s.address}</div>}
                  {(s.remarks)&&<div style={{fontSize:".75rem",color:"#92400e",background:"#fffbeb",borderRadius:6,padding:"3px 8px",marginTop:4,display:"inline-block"}}>📝 {s.remarks}</div>}
                </div>
                {canEdit&&(
                  <div style={{display:"flex",gap:6,flexShrink:0}}>
                    <button onClick={()=>openEdit(s)} style={{background:"#f1f5f9",border:"none",borderRadius:7,padding:"5px 11px",fontSize:".73rem",color:"#475569",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>✏</button>
                    <button onClick={async ()=>{if((await uiConfirm(`Remove all ${s._ids.length} entr${s._ids.length>1?"ies":"y"} for ${s.companyName}?`)))s._ids.forEach(id=>deleteSubcon(id));}} style={{background:"#fef2f2",border:"none",borderRadius:7,padding:"5px 11px",fontSize:".73rem",color:"#dc2626",cursor:"pointer",fontWeight:600,fontFamily:"inherit"}}>✕</button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function RequestsView({sendTelegramNotification,mreqs,addMR,updateMR,prs,addPR,wonDeals,session,role,breqs,addBR,updateBR,deleteBR,toastEmit,suppliers}){
  const[tab,setTab]=useState("Budget Request");
  const tabStyle=(active)=>({padding:"10px 24px",border:"none",borderBottom:`3px solid ${active?"#f59e0b":"transparent"}`,background:"transparent",color:active?"#f59e0b":"#64748b",fontWeight:active?700:400,cursor:"pointer",fontFamily:"inherit",fontSize:".9rem",transition:"all .15s",whiteSpace:"nowrap"});
  return(
    <div>
      <div style={{display:"flex",gap:0,borderBottom:"2px solid #e2e8f0",marginBottom:24,overflowX:"auto"}}>
        {["Budget Request"].map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={tabStyle(tab===t)}>{t}</button>
        ))}
      </div>
      {tab==="Budget Request"&&<BudgetRequestView sendTelegramNotification={sendTelegramNotification} breqs={breqs} addBR={addBR} updateBR={updateBR} deleteBR={deleteBR} wonDeals={wonDeals} session={session} role={role} toastEmit={toastEmit}/>}
    </div>
  );
}

function MasterListsView({suppliers,addSupplier,updateSupplier,deleteSupplier,subcons,addSubcon,updateSubcon,deleteSubcon,session,role}){
  const[tab,setTab]=useState("Suppliers");
  const tabStyle=(active)=>({padding:"10px 24px",border:"none",borderBottom:`3px solid ${active?"#f59e0b":"transparent"}`,background:"transparent",color:active?"#f59e0b":"#64748b",fontWeight:active?700:400,cursor:"pointer",fontFamily:"inherit",fontSize:".9rem",transition:"all .15s",whiteSpace:"nowrap"});
  return(
    <div>
      <div style={{display:"flex",gap:0,borderBottom:"2px solid #e2e8f0",marginBottom:24,overflowX:"auto"}}>
        {["Suppliers","Subcontractors"].map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={tabStyle(tab===t)}>{t}</button>
        ))}
      </div>
      {tab==="Suppliers"&&<SupplierMasterView suppliers={suppliers} addSupplier={addSupplier} updateSupplier={updateSupplier} deleteSupplier={deleteSupplier} session={session} role={role}/>}
      {tab==="Subcontractors"&&<SubconMasterView subcons={subcons} addSubcon={addSubcon} updateSubcon={updateSubcon} deleteSubcon={deleteSubcon} session={session} role={role}/>}
    </div>
  );
}

// ─── BOQ BUILDER ─────────────────────────────────────────────────────────────

const COA_TYPES=["Asset","Liability","Equity","Income","COGS","Expense"];
const COA_TYPE_CLR={Asset:"#0ea5e9",Liability:"#f97316",Equity:"#8b5cf6",Income:"#10b981",COGS:"#f59e0b",Expense:"#ef4444"};
// Default chart tailored to a PH fabrication / construction company (GMD Productions)
// GMD Production Inc. — actual chart of accounts, translated 1:1 from the
// company's own management FS (Income Statement / Balance Sheet / Source Data,
// Jan–Aug 2026 pack). Names mirror the finance team's real pivot categories so
// FabHub reproduces that exact statement; codes and types are added here.
// Mapping of the FS "Classification" tag → FabHub type:
//   COGS → COGS · OPEX → Expense · (revenue) → Income · balance-sheet → Asset/
//   Liability/Equity. Loan proceeds/repayment & dividends are financing/equity
//   movements, not P&L, so they are NOT expense/income accounts here.
// Obvious source typos are corrected (Ammortization→Amortization,
// Occular→Ocular); everything else is kept verbatim for clean reconciliation.
const DEFAULT_COA=[
  // ── 1xxx ASSETS (Balance Sheet) ──────────────────────────
  {code:"1000",name:"Cash on Hand",type:"Asset"},
  {code:"1100",name:"Accounts Receivable",type:"Asset"},
  {code:"1110",name:"Accounts Receivable - Credit",type:"Asset"},      // memo item per BS Note 1
  {code:"1200",name:"Advances to Employees",type:"Asset"},             // liquidated via "Return From Advances"
  {code:"1210",name:"Advances - Mobilization",type:"Asset"},           // recovered via "Return From Mobilization"
  {code:"1500",name:"Office Equipment (PPE)",type:"Asset"},
  {code:"1510",name:"Production Equipment (PPE)",type:"Asset"},
  {code:"1520",name:"Vehicle",type:"Asset"},
  {code:"1590",name:"Accumulated Depreciation",type:"Asset"},
  // ── 2xxx LIABILITIES (Balance Sheet) ─────────────────────
  {code:"2000",name:"Accounts Payable",type:"Liability"},
  {code:"2100",name:"Short-Term Loan",type:"Liability"},
  {code:"2110",name:"Short-Term Interest Payable",type:"Liability"},
  {code:"2200",name:"Long-Term Loan",type:"Liability"},
  {code:"2210",name:"Long-Term Interest Payable",type:"Liability"},
  {code:"2300",name:"Vehicle Loan",type:"Liability"},
  // ── 3xxx EQUITY ──────────────────────────────────────────
  {code:"3000",name:"Capital",type:"Equity"},
  {code:"3100",name:"Retained Earnings",type:"Equity"},
  // ── 4xxx INCOME ──────────────────────────────────────────
  {code:"4000",name:"Sales Revenue (Contract Price)",type:"Income"},
  {code:"4100",name:"Other Income",type:"Income"},                     // "Other Collection"
  {code:"4900",name:"Interest Income (Bank Interest)",type:"Income"},
  // ── 5xxx COST OF SALES (FS "COGS" — direct / project) ────
  {code:"5000",name:"Warehouse Rental",type:"COGS"},
  {code:"5010",name:"Warehouse Improvement",type:"COGS"},
  {code:"5020",name:"Production Supplies",type:"COGS"},
  {code:"5030",name:"Production Payroll",type:"COGS"},
  {code:"5040",name:"Production Payroll - Overtime",type:"COGS"},
  {code:"5050",name:"Production Equipment",type:"COGS"},
  {code:"5060",name:"Production - Tools",type:"COGS"},
  {code:"5070",name:"Production - Subcon",type:"COGS"},
  {code:"5080",name:"Production - Signage",type:"COGS"},
  {code:"5090",name:"Production - Printing",type:"COGS"},
  {code:"5100",name:"Sub-Con Prof Fee",type:"COGS"},
  {code:"5110",name:"Freight Charges",type:"COGS"},
  {code:"5120",name:"Mobilization - Repair",type:"COGS"},
  {code:"5130",name:"Mobilization - Pullout",type:"COGS"},
  {code:"5140",name:"Mobilization - Ocular",type:"COGS"},
  {code:"5150",name:"Mobilization - Installation",type:"COGS"},
  {code:"5160",name:"Repair And Maintenance",type:"COGS"},
  {code:"5170",name:"Logistic",type:"COGS"},
  {code:"5180",name:"Delivery Fee",type:"COGS"},
  {code:"5190",name:"OT Meal Allowance",type:"COGS"},
  {code:"5200",name:"Load Allowance",type:"COGS"},
  {code:"5210",name:"Insurance - Project",type:"COGS"},
  {code:"5220",name:"Toll Fee",type:"COGS"},
  // ── 6xxx OPERATING EXPENSES (FS "OPEX" — G&A) ────────────
  {code:"6000",name:"Office Salaries Expense",type:"Expense"},
  {code:"6010",name:"Sales Commission",type:"Expense"},
  {code:"6020",name:"Employee Benefit",type:"Expense"},
  {code:"6030",name:"Employee Benefit Expense (Other)",type:"Expense"},
  {code:"6040",name:"Insurance - Employee",type:"Expense"},
  {code:"6050",name:"Government Dues",type:"Expense"},
  {code:"6060",name:"Employees Seminars",type:"Expense"},
  {code:"6070",name:"Last Pay",type:"Expense"},
  {code:"6100",name:"Utilities",type:"Expense"},
  {code:"6110",name:"Other Rental",type:"Expense"},
  {code:"6120",name:"Office Supplies Expense",type:"Expense"},
  {code:"6130",name:"Office Services Expense",type:"Expense"},
  {code:"6140",name:"Office Event",type:"Expense"},
  {code:"6150",name:"Office-Improvement",type:"Expense"},
  {code:"6160",name:"Office Equipment",type:"Expense"},
  {code:"6170",name:"Courier Expense",type:"Expense"},
  {code:"6200",name:"Travel Expense",type:"Expense"},
  {code:"6210",name:"Transportation",type:"Expense"},
  {code:"6220",name:"Parking Fee",type:"Expense"},
  {code:"6230",name:"Gas - Expense",type:"Expense"},
  {code:"6250",name:"Meal Allowance",type:"Expense"},
  {code:"6300",name:"Taxes",type:"Expense"},
  {code:"6310",name:"Business And Lic Permit",type:"Expense"},
  {code:"6320",name:"Car Registration",type:"Expense"},
  {code:"6330",name:"Professional Fee",type:"Expense"},
  {code:"6400",name:"Marketing Collateral",type:"Expense"},
  {code:"6500",name:"Bank Services",type:"Expense"},
  {code:"6510",name:"Bank Charge",type:"Expense"},
  {code:"6520",name:"Amortization",type:"Expense"},
  {code:"6900",name:"Other Expense",type:"Expense"},
  {code:"6910",name:"Miscellaneous Expense",type:"Expense"},
  {code:"6950",name:"Interest Expense",type:"Expense"},                // shown under Other Income (Expense) on the FS
];

// Finance Daily Digest — self-contained snapshot (Collections/AR · Cash Position
// · Billing/Payables · Profitability) with a Send-to-Telegram action. Computes
// everything from the raw app data so it can be dropped on any finance screen.
// Mirrors the panel originally embedded in Finance → Overview.
function FinanceDigestPanel({billings=[],exps=[],wonDeals=[],completedDeals=[],deals=[],payables=[],prs=[],swos=[],cashPositions={},today,isMobile,sendTelegramNotification,toastEmit}){
  const now=new Date();
  const cy=now.getFullYear();
  // Same bases as Finance → Overview: AR in cash terms (arSummary), margin as
  // billed VAT-ex − AP-ledger costs VAT-ex (costSummary).
  const _ar=arSummary(billings,id=>(deals||[]).find(d=>d.id===id));
  const totalBilled=_ar.billed;
  const totalCollected=_ar.collected;
  const totalExpenses=costSummary(exps,payables,prs,swos).net;
  const grossProfit=totalBilled-totalExpenses;
  const grossMargin=totalBilled>0?Math.round(grossProfit/totalBilled*100):0;
  const collectionRate=Math.round(_ar.collectionRate*100);
  const outstanding=_ar.outstanding;
  const dso=totalCollected>0?Math.round(outstanding/(totalCollected/365)):0;
  const backlog=wonDeals.reduce((s,d)=>{const billed=billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled").reduce((bs,b)=>bs+Number(b.amount||0),0);return s+Math.max(0,Number(d.value||0)-billed);},0);
  const y12ago=new Date();y12ago.setFullYear(y12ago.getFullYear()-1);
  const recentDeals=deals.filter(d=>{const dt=new Date(d.createdAt||"2020-01-01");return dt>=y12ago;});
  const winRate=recentDeals.length>0?Math.round(recentDeals.filter(d=>!d.isCostCenter&&(WON_STAGES.includes(d.stage)||d.stage==="14 · Completed")).length/recentDeals.length*100):0;
  const avgDeal=wonDeals.length>0?Math.round(wonDeals.reduce((s,d)=>s+Number(d.value||0),0)/wonDeals.length):0;
  const months6=Array.from({length:6},(_,i)=>{const d=new Date(now.getFullYear(),now.getMonth()-5+i,1);return{y:d.getFullYear(),m:d.getMonth()};});
  const monthlyRev=months6.map(({y,m})=>billings.filter(b=>b.status!=="Cancelled").reduce((s,b)=>{const ds=b.invoiceDate||b.dueDate;if(!ds)return s;const d=new Date(ds);return(!isNaN(d)&&d.getFullYear()===y&&d.getMonth()===m)?s+Number(b.amount||0):s;},0));
  const clientMap={};billings.forEach(b=>{const d=wonDeals.find(x=>x.id===b.dealId)||completedDeals.find(x=>x.id===b.dealId);if(!d)return;const k=d.client;if(!clientMap[k])clientMap[k]=0;clientMap[k]+=(b.payments||[]).reduce((s,p)=>s+Number(p.amount||0),0);});
  const topClients=Object.entries(clientMap).sort(([,a],[,b])=>b-a).slice(0,5);
  const totalPayables=payables.filter(p=>p.status==="Unpaid").reduce((s,p)=>s+Number(p.amount||0),0);
  const overduePayables=payables.filter(p=>p.status==="Unpaid"&&p.dueDate&&p.dueDate<today).length;
  const overdueBillings=billings.filter(m=>isBillingOverdue(m,today));
  const unsentLateBillings=billings.filter(m=>isBillingUnsentLate(m,today));
  const unbilledProjects=wonDeals.filter(d=>billings.filter(b=>b.dealId===d.id&&b.status!=="Cancelled").length===0);
  const fmtM=v=>"₱"+Number(v).toLocaleString("en-PH",{maximumFractionDigits:0});
  const todayPos=cashPositions[today]||null;
  const BANK_LABELS={bpi:"BPI",metro:"Metrobank",china:"Chinabank",bdo:"BDO",security:"Security Bank",union:"UnionBank"};
  const cpBanks=todayPos?Object.entries(todayPos.banks||{}).map(([id,r])=>({id,label:BANK_LABELS[id]||id,beg:Number(r.beg||0),book:Number(r.book||0),end:Number(r.end||0)})).filter(b=>b.beg>0||b.book>0||b.end>0):[];
  const cpTotalBeg=cpBanks.reduce((s,b)=>s+b.beg,0);
  const cpTotalEnd=cpBanks.reduce((s,b)=>s+(b.end||b.book||b.beg),0);
  const cpCollections=(todayPos?.collections?.manualCollections||[]).reduce((s,c)=>s+Number(c.amount||0),0);
  const cpNetMove=cpTotalEnd-cpTotalBeg;
  const arOverdueAmt=overdueBillings.reduce((s,m)=>s+milestoneBalance(m,(deals||[]).find(d=>d.id===m.dealId)),0);
  const arAge30 =overdueBillings.filter(m=>{const d=Math.floor((now-new Date(m.dueDate))/(864e5));return d<=30;}).length;
  const arAge60 =overdueBillings.filter(m=>{const d=Math.floor((now-new Date(m.dueDate))/(864e5));return d>30&&d<=60;}).length;
  const arAge90p=overdueBillings.filter(m=>{const d=Math.floor((now-new Date(m.dueDate))/(864e5));return d>60;}).length;
  const arStatus=overdueBillings.length===0?"ok":arAge90p>0?"danger":"warning";
  const cpStatus=!todayPos?"warning":cpTotalEnd<500000?"danger":cpNetMove<0?"warning":"ok";
  const overduePayablesAmt=payables.filter(p=>p.status==="Unpaid"&&p.dueDate&&p.dueDate<today).reduce((s,p)=>s+Number(p.amount||0),0);
  const billStatus=overduePayables>0?"danger":unbilledProjects.length>0?"warning":"ok";
  const profStatus=grossMargin<20?"danger":grossMargin<30?"warning":"ok";
  const prevMonthRev=monthlyRev[monthlyRev.length-2]||0;
  const thisMonthRev=monthlyRev[monthlyRev.length-1]||0;
  const revTrend=prevMonthRev>0?Math.round((thisMonthRev-prevMonthRev)/prevMonthRev*100):0;
  const digestAlerts=[];
  if(overdueBillings.length>0) digestAlerts.push({icon:"🚨",text:`${overdueBillings.length} overdue invoice${overdueBillings.length!==1?"s":""} — ${fmtM(arOverdueAmt)} uncollected`});
  if(unsentLateBillings.length>0) digestAlerts.push({icon:"📤",text:`${unsentLateBillings.length} draft invoice${unsentLateBillings.length!==1?"s":""} past due and not yet sent — ${fmtM(unsentLateBillings.reduce((s,m)=>s+milestoneBalance(m,(deals||[]).find(d=>d.id===m.dealId)),0))}`});
  if(grossMargin<25) digestAlerts.push({icon:"📉",text:`Gross margin at ${grossMargin}% — below 25% target`});
  if(dso>90) digestAlerts.push({icon:"⏳",text:`DSO is ${dso} days — clients are paying very slowly`});
  if(unbilledProjects.length>0) digestAlerts.push({icon:"📋",text:`${unbilledProjects.length} awarded project${unbilledProjects.length!==1?"s":""} with no milestones billed yet`});
  if(overduePayables>0) digestAlerts.push({icon:"📤",text:`${overduePayables} overdue payable${overduePayables!==1?"s":""} — ${fmtM(overduePayablesAmt)}`});
  if(!todayPos) digestAlerts.push({icon:"⚠️",text:"No cash position entry for today — please update Daily Cash Position"});
  if(digestAlerts.length===0) digestAlerts.push({icon:"✅",text:"All financial indicators are on track — no alerts today."});
  const statusColor={ok:"#059669",warning:"#d97706",danger:"#dc2626"};
  const statusBg={ok:"#f0fdf4",warning:"#fffbeb",danger:"#fef2f2"};
  const statusBorder={ok:"#bbf7d0",warning:"#fde68a",danger:"#fecaca"};
  const statusLabel={ok:"✅ Good",warning:"⚠️ Watch",danger:"🔴 Action Needed"};
  const sendDigest=async()=>{
    const dateStr=now.toLocaleDateString("en-PH",{weekday:"long",year:"numeric",month:"long",day:"numeric"});
    const lines=[
      `💼 <b>GMD Finance Daily Digest</b>`,`📅 ${dateStr}`,``,
      `🧾 <b>COLLECTIONS / AR</b>  ${arStatus==="ok"?"✅":arStatus==="danger"?"🔴":"⚠️"}`,
      `• Total Billed: ${fmtM(totalBilled)}`,
      `• Collected: ${fmtM(totalCollected)} (${collectionRate}% rate)`,
      `• Outstanding AR: ${fmtM(outstanding)}`,
      `• DSO: ${dso} days`,
      ...(overdueBillings.length>0?[`• Overdue Invoices: ${overdueBillings.length} — ${fmtM(arOverdueAmt)}`]:[`• No overdue invoices ✅`]),
      ...(unsentLateBillings.length>0?[`• Not yet sent (drafts past due): ${unsentLateBillings.length}`]:[]),
      ``,
      `💵 <b>DAILY CASH POSITION</b>  ${cpStatus==="ok"?"✅":cpStatus==="danger"?"🔴":"⚠️"}`,
      ...(todayPos?[`• Opening: ${fmtM(cpTotalBeg)}`,`• Closing: ${fmtM(cpTotalEnd)}`,`• Collections Today: ${fmtM(cpCollections)}`,`• Net Movement: ${cpNetMove>=0?"▲":"▼"} ${fmtM(Math.abs(cpNetMove))}`]:[`• ⚠️ No cash position logged for today`]),
      ``,
      `📤 <b>BILLING / PAYABLES</b>  ${billStatus==="ok"?"✅":billStatus==="danger"?"🔴":"⚠️"}`,
      `• Unpaid Payables: ${fmtM(totalPayables)}`,
      ...(overduePayables>0?[`• Overdue Payables: ${overduePayables} items — ${fmtM(overduePayablesAmt)}`]:[`• No overdue payables ✅`]),
      ...(unbilledProjects.length>0?[`• Unbilled Projects: ${unbilledProjects.length}`]:[]),
      `• Contract Backlog: ${fmtM(backlog)}`,
      ``,
      `📈 <b>PROFITABILITY</b>  ${profStatus==="ok"?"✅":profStatus==="danger"?"🔴":"⚠️"}`,
      `• Gross Margin: ${grossMargin}%`,
      `• Gross Profit: ${fmtM(grossProfit)}`,
      `• Total Expenses: ${fmtM(totalExpenses)}`,
      `• This Month Revenue: ${fmtM(thisMonthRev)}${revTrend!==0?` (${revTrend>0?"+":""}${revTrend}% vs last month)`:""}`,
      `• Win Rate: ${winRate}% | Avg Deal: ${fmtM(avgDeal)}`,
      ``,
      `🚦 <b>ALERTS</b>`,...digestAlerts.map(a=>`${a.icon} ${a.text}`),
      ``,`<i>Sent from FabHub Finance · ${dateStr}</i>`,
    ];
    try{ await sendTelegramNotification&&sendTelegramNotification("financialcontrol",lines.join("\n")); toastEmit&&toastEmit("Daily digest sent to Financial Control ✅","success"); }
    catch(e){ toastEmit&&toastEmit("Could not send digest — check Telegram settings.","error"); }
  };
  const ReviewSection=({icon,title,status,children})=>(
    <div style={{background:statusBg[status],border:`1.5px solid ${statusBorder[status]}`,borderRadius:10,padding:"12px 14px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <span style={{fontWeight:700,color:"#0f172a",fontSize:".82rem"}}>{icon} {title}</span>
        <span style={{fontSize:".68rem",fontWeight:700,color:statusColor[status],background:"#fff",border:`1px solid ${statusBorder[status]}`,borderRadius:20,padding:"2px 8px"}}>{statusLabel[status]}</span>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:3}}>{children}</div>
    </div>
  );
  const Row=({label,value,color})=>(
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <span style={{fontSize:".75rem",color:"#64748b"}}>{label}</span>
      <span style={{fontSize:".78rem",fontWeight:600,color:color||"#0f172a"}}>{value}</span>
    </div>
  );
  return(
    <div style={{background:"#fff",border:"1.5px solid #e2e8f0",borderRadius:12,padding:"14px 16px",marginBottom:16}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:"1rem"}}>📡</span>
          <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>Finance Daily Digest</span>
          <span style={{fontSize:".68rem",color:"#94a3b8"}}>— {now.toLocaleDateString("en-PH",{weekday:"short",month:"short",day:"numeric"})}</span>
        </div>
        <button onClick={sendDigest} style={{background:"#0f172a",border:"none",borderRadius:8,padding:"7px 16px",fontFamily:"inherit",fontSize:".75rem",fontWeight:700,color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
          <span>📲</span> Send to Telegram
        </button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:10}}>
        <ReviewSection icon="🧾" title="Collections / AR" status={arStatus}>
          <Row label="Outstanding AR" value={fmtM(outstanding)} color={outstanding>0?"#ef4444":"#059669"}/>
          <Row label="Collection Rate" value={collectionRate+"%"} color={collectionRate>=50?"#059669":"#d97706"}/>
          <Row label="DSO" value={dso+" days"} color={dso>90?"#dc2626":dso>60?"#d97706":"#059669"}/>
          {overdueBillings.length>0&&<Row label="Overdue Invoices" value={`${overdueBillings.length} — ${fmtM(arOverdueAmt)}`} color="#dc2626"/>}
          {overdueBillings.length===0&&<Row label="Overdue" value="None ✅" color="#059669"/>}
          {unsentLateBillings.length>0&&<Row label="Not Yet Sent (past due)" value={`${unsentLateBillings.length} drafts`} color="#d97706"/>}
        </ReviewSection>
        <ReviewSection icon="💵" title="Daily Cash Position" status={cpStatus}>
          {todayPos?<>
            <Row label="Opening Balance" value={fmtM(cpTotalBeg)}/>
            <Row label="Closing Balance" value={fmtM(cpTotalEnd)} color={cpTotalEnd<500000?"#dc2626":"#059669"}/>
            <Row label="Collections Today" value={fmtM(cpCollections)} color="#059669"/>
            <Row label="Net Movement" value={(cpNetMove>=0?"+":"")+fmtM(cpNetMove)} color={cpNetMove>=0?"#059669":"#dc2626"}/>
          </> : <Row label="Status" value="⚠️ Not logged today" color="#d97706"/>}
        </ReviewSection>
        <ReviewSection icon="📤" title="Billing / Payables" status={billStatus}>
          <Row label="Unpaid Payables" value={fmtM(totalPayables)} color={totalPayables>0?"#ef4444":"#059669"}/>
          <Row label="Overdue Payables" value={overduePayables>0?`${overduePayables} — ${fmtM(overduePayablesAmt)}`:"None ✅"} color={overduePayables>0?"#dc2626":"#059669"}/>
          <Row label="Unbilled Projects" value={unbilledProjects.length>0?`${unbilledProjects.length} projects`:"None ✅"} color={unbilledProjects.length>0?"#d97706":"#059669"}/>
          <Row label="Contract Backlog" value={fmtM(backlog)} color="#8b5cf6"/>
        </ReviewSection>
        <ReviewSection icon="📈" title="Profitability" status={profStatus}>
          <Row label="Gross Margin" value={grossMargin+"%"} color={grossMargin>=30?"#059669":grossMargin>=20?"#d97706":"#dc2626"}/>
          <Row label="Gross Profit" value={fmtM(grossProfit)} color={grossProfit>=0?"#059669":"#dc2626"}/>
          <Row label="Total Expenses" value={fmtM(totalExpenses)} color="#ef4444"/>
          <Row label="This Month Rev." value={fmtM(thisMonthRev)} color="#3b82f6"/>
          {revTrend!==0&&<Row label="vs Last Month" value={(revTrend>0?"+":"")+revTrend+"%"} color={revTrend>0?"#059669":"#dc2626"}/>}
          <Row label="Win Rate" value={winRate+"%"} color={winRate>=40?"#059669":"#d97706"}/>
        </ReviewSection>
      </div>
    </div>
  );
}

// Aerwin-styled Finance module header + tab bar. Gives the finance/accounting
// screens the look of the finance team's standalone ERP (navy banner, gold
// wordmark, a Purchase-to-Payment tab strip with count badges) while staying
// inside FabHub. `active` is one of dashboard|po|ap|payments|cv; `go(key)` does
// the navigation; `counts` supplies the badge numbers.
// ── Aerwin ERP design tokens + shared finance primitives ────────────────────
// Exact palette lifted from the finance team's standalone Purchase-to-Payment
// ERP so FabHub's finance screens read as the same product.
const ERP={navy:"#0B2545",navy2:"#132F5C",navyLight:"#EEF2F8",gold:"#C9A24B",goldDark:"#A8822F",ink:"#1B2430",muted:"#5B6472",line:"#DCE2EC",paper:"#FFFFFF",bg:"#F5F7FA",danger:"#B3413A",ok:"#2E7D4F",warn:"#B8862C",purple:"#6A3FA0"};
const ERP_TONE={default:ERP.gold,warn:ERP.warn,danger:ERP.danger,ok:ERP.ok,purple:ERP.purple};

// .stat — value card with a colored left accent bar (tone: default|warn|danger|ok|purple)
function ErpStat({label,value,foot,tone="default"}){
  return(
    <div style={{background:ERP.paper,border:`1px solid ${ERP.line}`,borderRadius:12,padding:"16px 18px",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",left:0,top:0,bottom:0,width:4,background:ERP_TONE[tone]||ERP.gold}}/>
      <div style={{fontSize:11.5,color:ERP.muted,textTransform:"uppercase",letterSpacing:".6px",fontWeight:600}}>{label}</div>
      <div style={{fontSize:24,fontWeight:700,color:ERP.navy,marginTop:4}}>{value}</div>
      {foot!=null&&<div style={{fontSize:11.5,color:ERP.muted,marginTop:4}}>{foot}</div>}
    </div>
  );
}
// .card — titled white panel
function ErpCard({title,desc,right,children,style}){
  return(
    <div style={{background:ERP.paper,border:`1px solid ${ERP.line}`,borderRadius:12,padding:"18px 20px",marginBottom:16,...style}}>
      {(title||right)&&(
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,marginBottom:desc?4:14}}>
          {title&&<h2 style={{margin:0,fontSize:16,color:ERP.navy,fontWeight:700}}>{title}</h2>}
          {right}
        </div>
      )}
      {desc&&<p style={{margin:"0 0 14px",color:ERP.muted,fontSize:12.5}}>{desc}</p>}
      {children}
    </div>
  );
}
// Status badge, keyed to Aerwin's badge palette
const ERP_BADGE={open:{bg:"#E7EEFB",c:ERP.navy},invoiced:{bg:"#FDF1DC",c:ERP.warn},closed:{bg:"#E5F3EA",c:ERP.ok},unpaid:{bg:"#FBEAE8",c:ERP.danger},partial:{bg:"#FDF1DC",c:ERP.warn},paid:{bg:"#E5F3EA",c:ERP.ok},check:{bg:"#EEF2F8",c:ERP.navy},online:{bg:"#F0EAFB",c:ERP.purple},draft:{bg:"#EEF1F5",c:ERP.muted},approved:{bg:"#E7EEFB",c:ERP.navy},inactive:{bg:"#EEF1F5",c:ERP.muted}};
function ErpBadge({kind="open",children}){
  const s=ERP_BADGE[String(kind).toLowerCase()]||ERP_BADGE.open;
  return <span style={{display:"inline-block",padding:"3px 9px",borderRadius:20,fontSize:11,fontWeight:700,letterSpacing:".3px",background:s.bg,color:s.c}}>{children}</span>;
}
// Map a free-text status to a badge kind
function erpStatusKind(status){
  const s=String(status||"").toLowerCase();
  if(s.includes("paid")&&!s.includes("unpaid"))return"paid";
  if(s.includes("partial"))return"partial";
  if(s.includes("unpaid")||s.includes("overdue"))return"unpaid";
  if(s.includes("released")||s.includes("cleared"))return"closed";
  if(s.includes("for release")||s.includes("for payment")||s.includes("invoiced"))return"invoiced";
  if(s.includes("draft")||s.includes("logged"))return"draft";
  if(s.includes("cancel"))return"unpaid";
  if(s.includes("issued")||s.includes("open")||s.includes("approved"))return"open";
  return"open";
}
// Shared table styles (navy-light uppercase headers, hairline rows)
const erpTh={textAlign:"left",background:ERP.navyLight,color:ERP.navy,fontSize:11,textTransform:"uppercase",letterSpacing:".5px",padding:"9px 10px",borderBottom:`2px solid ${ERP.line}`,whiteSpace:"nowrap",fontWeight:700};
const erpTd={padding:"9px 10px",borderBottom:`1px solid ${ERP.line}`,verticalAlign:"top",fontSize:13,color:ERP.ink};
const erpThNum={...erpTh,textAlign:"right"};
const erpTdNum={...erpTd,textAlign:"right",fontVariantNumeric:"tabular-nums"};

function FinanceErpBar({active,go,counts={}}){
  const mob=window.innerWidth<768;
  const tabs=[
    {k:"dashboard",l:"Dashboard"},
    {k:"po",l:"Purchase Orders",n:counts.po},
    {k:"ap",l:"Accounts Payable",n:counts.ap},
    {k:"payments",l:"Payments",n:counts.payments},
    {k:"cv",l:"Check Vouchers",n:counts.cv},
  ];
  return(
    <div style={{marginBottom:mob?12:18}}>
      {/* The full GMD banner is desktop-only — on mobile it eats a whole screen
          of vertical space, so we drop it and let the tab strip lead. */}
      {!mob&&(
        <div style={{background:"linear-gradient(135deg,#0B2545 0%,#132F5C 100%)",borderRadius:12,padding:"18px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,boxShadow:"0 4px 14px rgba(11,37,69,0.18)"}}>
          <div>
            <div style={{fontSize:18,fontWeight:700,color:"#fff",letterSpacing:".3px"}}>GMD <span style={{color:"#C9A24B"}}>Production Inc.</span></div>
            <div style={{fontSize:12,color:"#C7D4E8",marginTop:2,fontWeight:500}}>Purchase-to-Payment · Accounts Payable · Check Voucher · Chart of Accounts</div>
          </div>
          <span style={{background:"rgba(201,162,75,0.18)",border:"1px solid #C9A24B",color:"#C9A24B",borderRadius:20,padding:"5px 10px",fontSize:11,fontWeight:600,letterSpacing:"1.2px",textTransform:"uppercase"}}>Finance Module</span>
        </div>
      )}
      {/* Mobile: a horizontal-scroll tab strip (no wrapping, no huge min-widths).
          Desktop: keep the even flex row. */}
      <div style={{background:"#fff",border:"1px solid #DCE2EC",borderRadius:10,padding:mob?4:6,marginTop:mob?0:18,display:"flex",gap:6,flexWrap:mob?"nowrap":"wrap",overflowX:mob?"auto":"visible",WebkitOverflowScrolling:"touch"}}>
        {tabs.map(t=>{
          const on=t.k===active;
          return(
            <button key={t.k} onClick={()=>!on&&go&&go(t.k)} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,flex:mob?"0 0 auto":1,minWidth:mob?"auto":108,whiteSpace:"nowrap",background:on?"#0B2545":"transparent",color:on?"#fff":"#5B6472",border:"none",borderRadius:8,padding:mob?"9px 14px":"10px 10px",fontFamily:"inherit",fontSize:13,fontWeight:600,cursor:on?"default":"pointer",transition:"all .15s ease"}}>
              {t.l}
              {t.n>0&&<span style={{background:on?"rgba(255,255,255,0.85)":"#C9A24B",color:"#0B2545",borderRadius:10,padding:"1px 7px",fontSize:11,fontWeight:700}}>{t.n}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

function ChartOfAccountsView({chartOfAccounts=[],saveChartOfAccounts,session,role}){
  const canEdit=["Manager","Finance","Accounting"].includes(role);
  const[form,setForm]=React.useState({code:"",name:"",type:"Expense"});
  const[editId,setEditId]=React.useState(null);
  const[q,setQ]=React.useState("");
  const sorted=[...chartOfAccounts].sort((a,b)=>String(a.code).localeCompare(String(b.code)));
  const ql=q.trim().toLowerCase();
  const filtered=ql?sorted.filter(a=>String(a.code).includes(ql)||(a.name||"").toLowerCase().includes(ql)):sorted;
  const seedDefaults=async ()=>{
    if(chartOfAccounts.length){if(!(await uiConfirm("Append the default chart to your existing accounts? Duplicates (same code) are skipped.")))return;}
    const have=new Set(chartOfAccounts.map(a=>String(a.code)));
    const add=DEFAULT_COA.filter(d=>!have.has(d.code)).map(d=>({id:uid(),code:d.code,name:d.name,type:d.type,active:true}));
    if(!add.length){uiAlert("All default accounts are already in your chart.");return;}
    saveChartOfAccounts([...chartOfAccounts,...add]);
  };
  const submit=()=>{
    const code=form.code.trim(),name=form.name.trim();
    if(!code||!name){uiAlert("Account code and name are required.");return;}
    if(chartOfAccounts.some(a=>String(a.code)===code&&a.id!==editId)){uiAlert(`Account code ${code} already exists.`);return;}
    if(editId) saveChartOfAccounts(chartOfAccounts.map(a=>a.id===editId?{...a,code,name,type:form.type}:a));
    else saveChartOfAccounts([...chartOfAccounts,{id:uid(),code,name,type:form.type,active:true}]);
    setForm({code:"",name:"",type:"Expense"});setEditId(null);
  };
  const startEdit=(a)=>{setEditId(a.id);setForm({code:String(a.code),name:a.name,type:a.type});};
  const del=async (a)=>{if((await uiConfirm(`Delete account ${a.code} — ${a.name}?`))) saveChartOfAccounts(chartOfAccounts.filter(x=>x.id!==a.id));};
  const inpSt={border:"1.5px solid #e2e8f0",borderRadius:7,padding:"7px 10px",fontFamily:"inherit",fontSize:".82rem",outline:"none",boxSizing:"border-box"};
  return(
    <div style={{maxWidth:860,margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:12,marginBottom:6,flexWrap:"wrap"}}>
        <div>
          <h2 style={{margin:"0 0 4px",fontWeight:900,fontSize:"1.4rem",color:"#0f172a",fontFamily:"'Barlow Condensed',sans-serif"}}>📒 Chart of Accounts</h2>
          <p style={{margin:0,fontSize:".8rem",color:"#64748b"}}>The accounts used to classify every transaction. {chartOfAccounts.length} account{chartOfAccounts.length!==1?"s":""}.</p>
        </div>
        {canEdit&&<button onClick={seedDefaults} style={{background:"#f1f5f9",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 16px",color:"#475569",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer",whiteSpace:"nowrap"}}>Load standard chart of accounts</button>}
      </div>
      {canEdit&&(
        <div style={{background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:10,padding:"12px 14px",margin:"14px 0",display:"flex",gap:8,alignItems:"flex-end",flexWrap:"wrap"}}>
          <div><div style={{fontSize:".65rem",fontWeight:700,color:"#64748b",marginBottom:3}}>Code</div><input value={form.code} onChange={e=>setForm(f=>({...f,code:e.target.value}))} placeholder="e.g. 6020" style={{...inpSt,width:90}}/></div>
          <div style={{flex:1,minWidth:160}}><div style={{fontSize:".65rem",fontWeight:700,color:"#64748b",marginBottom:3}}>Account Name</div><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="e.g. Rent" onKeyDown={e=>e.key==="Enter"&&submit()} style={{...inpSt,width:"100%"}}/></div>
          <div><div style={{fontSize:".65rem",fontWeight:700,color:"#64748b",marginBottom:3}}>Type</div><select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))} style={{...inpSt}}>{COA_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
          <button onClick={submit} style={{background:"#1e293b",border:"none",borderRadius:8,padding:"8px 16px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".8rem",cursor:"pointer"}}>{editId?"Save":"＋ Add"}</button>
          {editId&&<button onClick={()=>{setEditId(null);setForm({code:"",name:"",type:"Expense"});}} style={{background:"none",border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 14px",color:"#64748b",fontFamily:"inherit",fontWeight:600,fontSize:".8rem",cursor:"pointer"}}>Cancel</button>}
        </div>
      )}
      {chartOfAccounts.length===0?(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px dashed #cbd5e1",padding:"44px 24px",textAlign:"center"}}>
          <div style={{fontSize:"1.8rem",marginBottom:8}}>📒</div>
          <div style={{fontWeight:700,color:"#0f172a",fontSize:".95rem",marginBottom:4}}>No accounts yet</div>
          <div style={{fontSize:".8rem",color:"#64748b",marginBottom:16}}>Load the GMD default chart to get started, then customize it.</div>
          {canEdit&&<button onClick={seedDefaults} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>Load GMD default chart</button>}
        </div>
      ):(
        <>
          <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search by code or name…" style={{...inpSt,width:"100%",padding:"9px 13px",marginBottom:14}}/>
          {COA_TYPES.map(type=>{
            const rows=filtered.filter(a=>a.type===type);
            if(!rows.length) return null;
            return(
              <div key={type} style={{marginBottom:18}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                  <span style={{width:10,height:10,borderRadius:3,background:COA_TYPE_CLR[type]}}/>
                  <span style={{fontWeight:800,fontSize:".8rem",textTransform:"uppercase",letterSpacing:".5px",color:"#0f172a"}}>{type}</span>
                  <span style={{fontSize:".7rem",color:"#94a3b8"}}>{rows.length}</span>
                </div>
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  {rows.map((a,i)=>(
                    <div key={a.id} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 14px",borderBottom:i<rows.length-1?"1px solid #f1f5f9":"none"}}>
                      <span style={{fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,color:COA_TYPE_CLR[type],fontSize:".82rem",minWidth:52}}>{a.code}</span>
                      <span style={{flex:1,color:"#0f172a",fontSize:".85rem",fontWeight:500}}>{a.name}</span>
                      {canEdit&&<button onClick={()=>startEdit(a)} style={{background:"none",border:"none",color:"#64748b",cursor:"pointer",fontSize:".78rem",padding:2}} title="Edit">✏</button>}
                      {canEdit&&<button onClick={()=>del(a)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".78rem",padding:2,opacity:.6}} title="Delete">🗑</button>}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

function AccountReportView({chartOfAccounts=[],exps=[],role}){
  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2});
  const years=[...new Set(exps.map(e=>e.year||(e.expDate?Number(e.expDate.slice(0,4)):null)).filter(Boolean))].sort((a,b)=>b-a);
  const[year,setYear]=React.useState("all");
  const inYear=e=>year==="all"||String(e.year||(e.expDate?e.expDate.slice(0,4):""))===String(year);
  const scoped=exps.filter(inYear);
  const totalByCode={};
  let untagged=0;
  scoped.forEach(e=>{
    const amt=Number(e.amount)||0;
    if(e.accountCode){totalByCode[e.accountCode]=(totalByCode[e.accountCode]||0)+amt;}
    else untagged+=amt;
  });
  const codeMeta=Object.fromEntries(chartOfAccounts.map(a=>[String(a.code),a]));
  // Group tagged totals by account type
  const TYPES=["COGS","Expense","Asset","Liability","Equity","Income"];
  const byType={};
  Object.entries(totalByCode).forEach(([code,total])=>{
    const a=codeMeta[code]; const type=a?.type||"Unmapped";
    (byType[type]=byType[type]||[]).push({code,name:a?.name||"(deleted account)",total});
  });
  const grand=Object.values(totalByCode).reduce((s,v)=>s+v,0)+untagged;
  const orderedTypes=[...TYPES.filter(t=>byType[t]),...Object.keys(byType).filter(t=>!TYPES.includes(t))];
  return(
    <div style={{maxWidth:860,margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:12,marginBottom:14,flexWrap:"wrap"}}>
        <div>
          <h2 style={{margin:"0 0 4px",fontWeight:900,fontSize:"1.4rem",color:"#0f172a",fontFamily:"'Barlow Condensed',sans-serif"}}>📊 Account Report</h2>
          <p style={{margin:0,fontSize:".8rem",color:"#64748b"}}>Expenses totalled by chart-of-accounts code.</p>
        </div>
        <select value={year} onChange={e=>setYear(e.target.value)} style={{border:"1.5px solid #e2e8f0",borderRadius:8,padding:"8px 12px",fontFamily:"inherit",fontSize:".82rem",outline:"none"}}>
          <option value="all">All years</option>
          {years.map(y=><option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      {chartOfAccounts.length===0?(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px dashed #cbd5e1",padding:"40px 24px",textAlign:"center",color:"#64748b",fontSize:".85rem"}}>Load your Chart of Accounts first, then tag expenses to see this report.</div>
      ):(
        <>
          {orderedTypes.length===0&&untagged===0&&<div style={{background:"#fff",borderRadius:14,border:"1.5px dashed #cbd5e1",padding:"40px 24px",textAlign:"center",color:"#64748b",fontSize:".85rem"}}>No tagged expenses yet. Open an expense and pick an Account to populate this report.</div>}
          {orderedTypes.map(type=>{
            const rows=byType[type].sort((a,b)=>String(a.code).localeCompare(String(b.code)));
            const sub=rows.reduce((s,r)=>s+r.total,0);
            const clr=COA_TYPE_CLR[type]||"#64748b";
            return(
              <div key={type} style={{marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                  <span style={{width:10,height:10,borderRadius:3,background:clr}}/>
                  <span style={{fontWeight:800,fontSize:".8rem",textTransform:"uppercase",letterSpacing:".5px",color:"#0f172a"}}>{type}</span>
                </div>
                <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
                  {rows.map((r,i)=>(
                    <div key={r.code} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 14px",borderBottom:"1px solid #f1f5f9"}}>
                      <span style={{fontFamily:"'IBM Plex Mono',monospace",fontWeight:700,color:clr,fontSize:".82rem",minWidth:52}}>{r.code}</span>
                      <span style={{flex:1,color:"#0f172a",fontSize:".85rem"}}>{r.name}</span>
                      <span style={{fontWeight:700,color:"#0f172a",fontSize:".85rem",fontFamily:"'IBM Plex Mono',monospace"}}>{peso(r.total)}</span>
                    </div>
                  ))}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"8px 14px",background:clr+"0f",fontWeight:800,fontSize:".82rem",color:clr}}><span>Subtotal — {type}</span><span style={{fontFamily:"'IBM Plex Mono',monospace"}}>{peso(sub)}</span></div>
                </div>
              </div>
            );
          })}
          {untagged>0&&(
            <div style={{background:"#fffbeb",border:"1.5px solid #fde68a",borderRadius:12,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <span style={{fontWeight:700,color:"#92400e",fontSize:".82rem"}}>⚠️ Untagged expenses (no account)</span>
              <span style={{fontWeight:800,color:"#92400e",fontFamily:"'IBM Plex Mono',monospace"}}>{peso(untagged)}</span>
            </div>
          )}
          <div style={{display:"flex",justifyContent:"space-between",padding:"12px 16px",background:"#1e293b",borderRadius:12,alignItems:"center"}}>
            <span style={{fontWeight:800,color:"#f1f5f9",fontSize:".85rem",textTransform:"uppercase",letterSpacing:".5px"}}>Total Expenses</span>
            <span style={{fontWeight:900,color:"#f59e0b",fontSize:"1.1rem",fontFamily:"'Barlow Condensed',sans-serif"}}>{peso(grand)}</span>
          </div>
        </>
      )}
    </div>
  );
}

function BOQHomeView({standaloneBoqs=[],deals=[],session,role,today,onOpenStandalone,onOpenDeal,onNewStandalone,onDeleteStandalone}){
  const peso=v=>"₱"+Number(v||0).toLocaleString("en-PH",{minimumFractionDigits:2});
  const boqTotal=(items=[])=>items.reduce((s,it)=>s+(it.total||0),0);
  // Net of any peso discount (applied before VAT), matching the builder's math.
  const boqNet=(src={})=>{const sub=boqTotal(src.items);const disc=Math.min(Math.max(Number(src.discount)||0,0),sub);return sub-disc;};
  const fmtDate=d=>d?new Date(d+"T00:00:00").toLocaleDateString("en-PH",{year:"numeric",month:"short",day:"numeric"}):"—";
  const[q,setQ]=React.useState("");
  const[picking,setPicking]=React.useState(false);
  const[dq,setDq]=React.useState("");
  let drafts={};
  try{drafts=JSON.parse(localStorage.getItem(KEYS.boqDrafts)||"{}");}catch{}
  // Pipeline-linked BOQs: any deal whose BOQ (Supabase or local draft) actually has content
  const dealEntries=deals.map(d=>{
    const src=d.boqData||drafts[d.id];
    if(!src||!((src.items?.length)||(src.sections?.length))) return null;
    return{kind:"deal",id:d.id,title:src.boqTitle||d.client||"Untitled BOQ",sub:d.ceNo?`${d.client||""} · ${d.ceNo}`:(d.client||""),date:src.boqDate,total:boqNet(src),updatedAt:src.updatedAt||src.boqDate||""};
  }).filter(Boolean);
  const standaloneEntries=standaloneBoqs.map(b=>({kind:"standalone",id:b.id,title:b.title||"Untitled BOQ",sub:b.location||(b.quotationNo?`Quotation ${b.quotationNo}`:"Standalone"),date:b.boqDate,total:boqNet(b),updatedAt:b.updatedAt||b.createdAt||""}));
  const all=[...standaloneEntries,...dealEntries].sort((a,b)=>String(b.updatedAt||"").localeCompare(String(a.updatedAt||"")));
  const ql=q.trim().toLowerCase();
  const filtered=ql?all.filter(e=>e.title.toLowerCase().includes(ql)||(e.sub||"").toLowerCase().includes(ql)):all;
  const canDelete=["Manager","QS"].includes(role);
  return(
    <div style={{maxWidth:980,margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:12,marginBottom:6,flexWrap:"wrap"}}>
        <div>
          <h2 style={{margin:"0 0 4px",fontWeight:900,fontSize:"1.4rem",color:"#0f172a",fontFamily:"'Barlow Condensed',sans-serif"}}>🧮 Bills of Quantities</h2>
          <p style={{margin:0,fontSize:".8rem",color:"#64748b"}}>Every BOQ belongs to a pipeline deal. Pick a deal to start or edit its BOQ.</p>
        </div>
        <button onClick={()=>{setDq("");setPicking(true);}} style={{background:"#1e293b",border:"none",borderRadius:10,padding:"10px 20px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".85rem",cursor:"pointer",whiteSpace:"nowrap"}}>＋ New BOQ</button>
      </div>
      <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search BOQs by name, client, or quotation no…"
        style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 13px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",boxSizing:"border-box",margin:"14px 0 16px",outline:"none"}}/>
      {filtered.length===0?(
        <div style={{background:"#fff",borderRadius:14,border:"1.5px dashed #cbd5e1",padding:"48px 24px",textAlign:"center"}}>
          <div style={{fontSize:"1.8rem",marginBottom:8}}>🧮</div>
          <div style={{fontWeight:700,color:"#0f172a",fontSize:".95rem",marginBottom:4}}>{all.length===0?"No BOQs yet":"No matches"}</div>
          <div style={{fontSize:".8rem",color:"#64748b",marginBottom:16}}>{all.length===0?"Pick a pipeline deal to create its BOQ.":"Try a different search."}</div>
          {all.length===0&&<button onClick={()=>{setDq("");setPicking(true);}} style={{background:"#1e293b",border:"none",borderRadius:9,padding:"9px 18px",color:"#fff",fontFamily:"inherit",fontWeight:700,fontSize:".82rem",cursor:"pointer"}}>＋ New BOQ</button>}
        </div>
      ):(
        <div style={{background:"#fff",borderRadius:12,border:"1.5px solid #e2e8f0",overflow:"hidden"}}>
          {/* Column header — list view (replaces the old card grid) */}
          <div style={{display:"flex",alignItems:"center",gap:12,padding:"8px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",fontSize:".62rem",fontWeight:800,textTransform:"uppercase",letterSpacing:".5px",color:"#94a3b8"}}>
            <span style={{width:30,flexShrink:0}}>Type</span>
            <span style={{flex:1,minWidth:0}}>BOQ / Client</span>
            <span style={{width:96,textAlign:"right",flexShrink:0}}>Date</span>
            <span style={{width:120,textAlign:"right",flexShrink:0}}>Total</span>
            <span style={{width:22,flexShrink:0}}/>
          </div>
          {filtered.map((e,i)=>(
            <div key={e.kind+e.id} onClick={()=>e.kind==="standalone"?onOpenStandalone(e.id):onOpenDeal(e.id)}
              style={{display:"flex",alignItems:"center",gap:12,padding:"11px 14px",cursor:"pointer",borderTop:i===0?"none":"1px solid #f1f5f9",transition:"background .12s"}}
              onMouseEnter={ev=>ev.currentTarget.style.background="#f8fafc"}
              onMouseLeave={ev=>ev.currentTarget.style.background="#fff"}>
              <span title={e.kind==="standalone"?"Standalone":"Pipeline-linked"} style={{width:30,flexShrink:0,textAlign:"center",fontSize:".6rem",fontWeight:800,padding:"2px 0",borderRadius:20,background:e.kind==="standalone"?"#f5f3ff":"#eff6ff",color:e.kind==="standalone"?"#7c3aed":"#1d4ed8",border:`1px solid ${e.kind==="standalone"?"#ddd6fe":"#bfdbfe"}`}}>{e.kind==="standalone"?"📄":"🔗"}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,color:"#0f172a",fontSize:".88rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.title||"Untitled BOQ"}</div>
                <div style={{fontSize:".72rem",color:"#94a3b8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.sub||"—"}</div>
              </div>
              <span style={{width:96,textAlign:"right",flexShrink:0,fontSize:".68rem",color:"#94a3b8"}}>{fmtDate(e.date)}</span>
              <span style={{width:120,textAlign:"right",flexShrink:0,fontWeight:800,color:"#059669",fontSize:".95rem",fontFamily:"'Barlow Condensed',sans-serif"}}>{peso(e.total)}</span>
              {e.kind==="standalone"&&canDelete
                ? <button onClick={async ev=>{ev.stopPropagation();if((await uiConfirm("Delete this BOQ? This cannot be undone.")))onDeleteStandalone(e.id);}} title="Delete BOQ" style={{width:22,flexShrink:0,background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:".8rem",opacity:.5,padding:0}} onMouseEnter={ev=>ev.currentTarget.style.opacity=1} onMouseLeave={ev=>ev.currentTarget.style.opacity=.5}>🗑</button>
                : <span style={{width:22,flexShrink:0}}/>}
            </div>
          ))}
        </div>
      )}
      <Modal open={picking} onClose={()=>setPicking(false)} title="New BOQ — choose its deal">
        <p style={{margin:"0 0 10px",fontSize:".78rem",color:"#64748b"}}>Every BOQ belongs to a deal. Choose the deal this BOQ is for — if it isn't in the pipeline yet, add the deal there first.</p>
        <input value={dq} onChange={e=>setDq(e.target.value)} autoFocus placeholder="Search deals by client, contact, or CE no…"
          style={{width:"100%",border:"1.5px solid #e2e8f0",borderRadius:9,padding:"9px 13px",fontFamily:"inherit",fontSize:".82rem",color:"#0f172a",boxSizing:"border-box",marginBottom:12,outline:"none"}}/>
        {(()=>{
          const s=dq.trim().toLowerCase();
          const pickable=deals
            .filter(d=>!isLostStage(d.stage)&&!isMotherPO(d))
            .filter(d=>!s||(d.client||"").toLowerCase().includes(s)||(d.ceNo||"").toLowerCase().includes(s)||(d.contact||"").toLowerCase().includes(s))
            .sort((a,b)=>String(b.dateAcquired||b.addedAt||"").localeCompare(String(a.dateAcquired||a.addedAt||"")));
          if(!pickable.length) return <div style={{padding:"24px",textAlign:"center",color:"#94a3b8",fontSize:".82rem"}}>No matching deals. Create the deal in the Pipeline first, then come back to build its BOQ.</div>;
          return(
            <div style={{maxHeight:"46vh",overflowY:"auto",display:"flex",flexDirection:"column",gap:6}}>
              {pickable.map(d=>{
                const hasBoq=!!(d.boqData&&((d.boqData.items?.length)||(d.boqData.sections?.length)));
                const parent=d.parentDealId?deals.find(x=>x.id===d.parentDealId):null;
                return(
                  <button key={d.id} onClick={()=>{setPicking(false);onOpenDeal(d.id);}}
                    style={{textAlign:"left",background:d.parentDealId?"#fffbeb":"#f8fafc",border:`1.5px solid ${d.parentDealId?"#fde68a":"#e2e8f0"}`,borderRadius:10,padding:"10px 13px",cursor:"pointer",fontFamily:"inherit"}}
                    onMouseEnter={ev=>ev.currentTarget.style.borderColor="#94a3b8"} onMouseLeave={ev=>ev.currentTarget.style.borderColor=d.parentDealId?"#fde68a":"#e2e8f0"}>
                    {d.parentDealId&&<div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:".56rem",fontWeight:700,color:"#d97706",letterSpacing:".5px",marginBottom:2}}>↳ ADDENDUM{parent?` OF ${(parent.client||parent.contact||"").toUpperCase()}`:""}</div>}
                    <div style={{fontWeight:700,color:"#0f172a",fontSize:".85rem"}}>{d.client||d.contact||"Untitled deal"}{d.ceNo?` · ${d.ceNo}`:""}</div>
                    <div style={{fontSize:".72rem",color:"#94a3b8",marginTop:2}}>{d.stage||"—"}{hasBoq?" · already has a BOQ":""}</div>
                  </button>
                );
              })}
            </div>
          );
        })()}
      </Modal>
    </div>
  );
}


